webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(397);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactIntl = __webpack_require__(753);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactRedux = __webpack_require__(846);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	__webpack_require__(1358);
	
	__webpack_require__(1362);
	
	var _EventTypes = __webpack_require__(933);
	
	var _ApplicationUtil = __webpack_require__(1046);
	
	var _ApplicationUtil2 = _interopRequireDefault(_ApplicationUtil);
	
	var _index = __webpack_require__(1363);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ConfigStore = __webpack_require__(1268);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _NavigationServiceUtil = __webpack_require__(1874);
	
	var _NavigationServiceUtil2 = _interopRequireDefault(_NavigationServiceUtil);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _enUS = __webpack_require__(1875);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Load in our CSS.
	// TODO - DCOS-6452 - remove component @imports from index.less and
	// require them in the component.js
	
	/* eslint-enable no-unused-vars */
	var domElement = global.document.getElementById("application");
	
	// Translations
	
	/* eslint-disable no-unused-vars */
	
	var navigatorLanguage = "en-US";
	
	// TODO: Implement loader that can concat many sprites into a single one
	// We opt to load the sprite after the Javscript files are parsed because it
	// is quite expensive for the browser to parse a sprite file. This way we
	// don't block the JS execution.
	setTimeout(function () {
	  var ajax = new XMLHttpRequest();
	  ajax.open("GET", "sprite.svg", true);
	  ajax.send();
	  ajax.onload = function () {
	    var div = global.document.createElement("div");
	    div.innerHTML = ajax.responseText;
	    div.style.height = 0;
	    div.style.overflow = "hidden";
	    div.style.width = 0;
	    div.style.visibility = "hidden";
	    global.document.body.insertBefore(div, global.document.body.childNodes[0]);
	  };
	});
	
	// Patch json
	var oldJSON = _mesosphereSharedReactjs.RequestUtil.json;
	_mesosphereSharedReactjs.RequestUtil.json = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // Proxy error function so that we can trigger a plugin event
	  var oldHandler = options.error;
	  options.error = function () {
	    var _PluginSDK$Hooks;
	
	    if (typeof oldHandler === "function") {
	      oldHandler.apply(null, arguments);
	    }
	    (_PluginSDK$Hooks = _PluginSDK2.default.Hooks).doAction.apply(_PluginSDK$Hooks, ["AJAXRequestError"].concat(Array.prototype.slice.call(arguments)));
	  };
	
	  oldJSON(options);
	};
	
	(function () {
	  function renderApplication() {
	    function renderAppToDOM(content) {
	      _reactDom2.default.render(content, domElement, function () {
	        _PluginSDK2.default.Hooks.doAction("applicationRendered");
	      });
	    }
	
	    // Allow overriding of application contents
	    var contents = _PluginSDK2.default.Hooks.applyFilter("applicationContents", null);
	    if (contents) {
	      renderAppToDOM(contents);
	    } else {
	      var renderApplicationToDOM = function renderApplicationToDOM() {
	        var routes = _RouterUtil2.default.buildRoutes(_index2.default.getRoutes());
	        _NavigationServiceUtil2.default.registerRoutesInNavigation(routes[0].childRoutes);
	
	        renderAppToDOM(_react2.default.createElement(
	          _reactRedux.Provider,
	          { store: _PluginSDK2.default.Store },
	          _react2.default.createElement(
	            _reactIntl.IntlProvider,
	            { locale: navigatorLanguage, messages: _enUS2.default },
	            _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: routes })
	          )
	        ));
	
	        _PluginSDK2.default.Hooks.doAction("routes", routes);
	      };
	
	      if (_PluginSDK2.default.Hooks.applyFilter("delayApplicationLoad", true)) {
	        // Let's make sure we get Mesos Summary data before we render app
	        // Mesos may unreachable, so we will render even on request failure
	        _ApplicationUtil2.default.beginTemporaryPolling(function () {
	          _ApplicationUtil2.default.invokeAfterPageLoad(renderApplicationToDOM);
	        });
	      } else {
	        renderApplicationToDOM();
	      }
	    }
	  }
	
	  function onPluginsLoaded() {
	    _PluginSDK2.default.Hooks.removeAction("pluginsConfigured", onPluginsLoaded);
	    _ConfigStore2.default.removeChangeListener(_EventTypes.CONFIG_ERROR, onConfigurationError);
	    renderApplication();
	  }
	
	  function onConfigurationError() {
	    // Try to find appropriate DOM element or fallback
	    var element = global.document.querySelector("#canvas div") || domElement;
	    var columnClasses = {
	      "column-small-8": false,
	      "column-small-offset-2": false,
	      "column-medium-6": false,
	      "column-medium-offset-3": false
	    };
	
	    _reactDom2.default.render(_react2.default.createElement(_RequestErrorMsg2.default, {
	      columnClasses: columnClasses,
	      header: "Error requesting UI Configuration"
	    }), element);
	  }
	
	  function startApplication() {
	    // Plugins events
	    _PluginSDK2.default.Hooks.addAction("pluginsConfigured", onPluginsLoaded);
	    _ConfigStore2.default.addChangeListener(_EventTypes.CONFIG_ERROR, onConfigurationError);
	
	    // Load configuration
	    _ConfigStore2.default.fetchConfig();
	  }
	
	  if (!global.Intl) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      __webpack_require__(1876);
	      __webpack_require__(1879);
	
	      startApplication();
	    });
	  } else {
	    startApplication();
	  }
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(880);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _redux = __webpack_require__(853);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _PluginConstants = __webpack_require__(932);
	
	var _EventTypes = __webpack_require__(933);
	
	var _ActionsPubSub = __webpack_require__(934);
	
	var _ActionsPubSub2 = _interopRequireDefault(_ActionsPubSub);
	
	var _AppReducer = __webpack_require__(935);
	
	var _AppReducer2 = _interopRequireDefault(_AppReducer);
	
	var _AppHooks = __webpack_require__(954);
	
	var _AppHooks2 = _interopRequireDefault(_AppHooks);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Hooks = __webpack_require__(958);
	
	var _Hooks2 = _interopRequireDefault(_Hooks);
	
	var _PluginSDKStruct = __webpack_require__(963);
	
	var _PluginSDKStruct2 = _interopRequireDefault(_PluginSDKStruct);
	
	var _Loader = __webpack_require__(964);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hooks = new _Hooks2.default();
	var initialState = {};
	var middleware = [_ActionsPubSub2.default.pub];
	var PLUGIN_ENV_CACHE = [];
	var REGISTERED_ACTIONS = {};
	var existingFluxStores = {};
	
	var constants = {
	  APPLICATION: _PluginConstants.APPLICATION,
	  APP_STORE_CHANGE: _EventTypes.APP_STORE_CHANGE
	};
	
	var reducers = (0, _defineProperty3.default)({}, _PluginConstants.APPLICATION, _AppReducer2.default);
	
	// Default pass through function when devTools are not enabled
	var devToolIfEnabled = function devToolIfEnabled(f) {
	  return f;
	};
	
	// Inject middleware to observe actions and state
	if (_Config2.default.environment === "development" && _Config2.default.uiConfigurationFixture.uiConfiguration.enableDevTools && global.devToolsExtension) {
	  // Use Chrome extension if available
	  // https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
	  devToolIfEnabled = global.devToolsExtension();
	}
	
	// Create Redux Store
	var Store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers), initialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), devToolIfEnabled));
	
	/**
	 * Bootstraps plugins and adds new reducers to Store.
	 *
	 * @param {Object} pluginsConfig - Plugin configuration
	 */
	var initialize = function initialize(pluginsConfig) {
	  var _Loader$getAvailableP = _Loader2.default.getAvailablePlugins(),
	      pluginsList = _Loader$getAvailableP.pluginsList,
	      externalPluginsList = _Loader$getAvailableP.externalPluginsList;
	
	  (0, _keys2.default)(pluginsConfig).forEach(function (pluginID) {
	    // Make sure plugin is bundled
	    if (!(pluginID in pluginsList) && !(pluginID in externalPluginsList)) {
	      if (_Config2.default.environment === "development") {
	        console.warn("Plugin " + pluginID + " not available in bundle");
	      }
	
	      return;
	    }
	
	    var path = void 0;
	    // Default to always selecting internal plugin if same pluginID
	    // exists in external plugins. This makes mocking easier.
	    if (pluginID in pluginsList) {
	      path = pluginsList[pluginID];
	    } else {
	      path = externalPluginsList[pluginID];
	    }
	    // Bootstrap if plugin enabled
	    if (pluginsConfig[pluginID] && pluginsConfig[pluginID].enabled) {
	      bootstrapPlugin(pluginID, path, pluginsConfig[pluginID]);
	    }
	  });
	
	  replaceStoreReducers();
	
	  // Allows plugins to do things before the application ever renders
	  var promises = hooks.applyFilter("pluginsLoadedCheck", []);
	  var pluginsLoaded = false;
	
	  _promise2.default.all(promises).then(function () {
	    pluginsLoaded = true;
	    hooks.doAction("pluginsConfigured");
	  });
	
	  global.setTimeout(function () {
	    if (!pluginsLoaded) {
	      if (false) {
	        console.warn("Failed to load plugins.");
	      }
	    }
	  }, _PluginConstants.PLUGIN_LOAD_TIMEOUT);
	};
	
	/**
	 * Creates a personalized dispatch for each plugin
	 * @param  {String} pluginID Plugin pluginID
	 * @return {Function}    Dispatch method
	 */
	var createDispatcher = function createDispatcher(pluginID) {
	  return function (action) {
	    // Inject origin namespace if simple Object
	    if (action === Object(action)) {
	      action = (0, _assign2.default)({}, action, { __origin: pluginID });
	    }
	    Store.dispatch(action);
	  };
	};
	
	/**
	 * Builds Actions API for registerActions and getActions.
	 * Get Actions automatically instantiates actions module with
	 * the requesting Plugin's SDK so dispatch is bound to the requesting Plugin.
	 * @param  {PluginSDK} SDK - PluginSDK
	 * @return {Object}     - API for registering/requesting actions
	 */
	var getActionsAPI = function getActionsAPI(SDK) {
	  return {
	    registerActions: function registerActions(actions, name) {
	      if (SDK.pluginID in REGISTERED_ACTIONS) {
	        throw new Error(SDK.pluginID + " already has registered actions.");
	      }
	      // Allow Application to name it's actions. Plugins have actions
	      // registered under their pluginID
	      if (SDK.pluginID !== _PluginConstants.APPLICATION) {
	        name = SDK.pluginID;
	      }
	      REGISTERED_ACTIONS[name] = actions;
	    },
	    getActions: function getActions(name, defaultValue) {
	      if (!name || typeof name !== "string") {
	        throw new Error("Name not valid. Passed in " + name);
	      }
	      // Return Actions instantiated with SDK.
	      // Actions will now use Plugin's own dispatch
	      if (!REGISTERED_ACTIONS[name]) {
	        if (defaultValue !== undefined) {
	          return defaultValue;
	        }
	        throw Error("No registered actions for " + name + ". Make sure plugin is loaded or actions are registered");
	      }
	
	      return REGISTERED_ACTIONS[name];
	    }
	  };
	};
	
	/**
	 * Create a flux store that exposes events to components. This store
	 * does not support set methods. It provides an abstraction for handling
	 * state changes in the OmniStore.
	 * @param  {Object} definition - Store definition
	 * @return {Object}            - Created store
	 */
	var addStoreConfig = function addStoreConfig(definition) {
	  if (definition) {
	    if (!definition.storeID) {
	      throw new Error("Must define a valid storeID to expose events");
	    }
	    if (definition.storeID in existingFluxStores) {
	      throw new Error("Store with ID " + definition.storeID + " already exists.");
	    }
	    existingFluxStores[definition.storeID] = definition;
	    // Register events with StoreMixin. Only import this as needed
	    // because its presence will degrade test performance.
	    _mesosphereSharedReactjs.StoreMixin.store_configure(existingFluxStores);
	  }
	
	  return definition;
	};
	
	/**
	 * Return a slice of the State
	 * @param  {String} root - root of the slice to return
	 * @return {Function}      Returns state at root
	 */
	var getStateRootedAt = function getStateRootedAt(root) {
	  return function () {
	    return Store.getState()[root];
	  };
	};
	
	/**
	 * Extends the PluginSDK
	 * @param  {PluginSDK} SDK - SDK to extend
	 * @param  {Object} obj  - Key value pairs to be added to SDK
	 */
	var extendSDK = function extendSDK(SDK, obj) {
	  (0, _keys2.default)(obj).forEach(function (methodName) {
	    SDK[methodName] = obj[methodName].bind(SDK);
	  });
	};
	
	/**
	 * Builds SDK for pluginID
	 * @param  {String} pluginID - ID for plugin
	 * @param  {Object} config   - Config
	 * @return {PluginSDK}       - SDK for plugins
	 */
	var getSDK = function getSDK(pluginID, config) {
	  if (pluginID in PLUGIN_ENV_CACHE) {
	    return PLUGIN_ENV_CACHE[pluginID];
	  }
	
	  var StoreAPI = Store;
	
	  if (pluginID !== _PluginConstants.APPLICATION) {
	    // Limit access for Plugins
	    StoreAPI = {
	      subscribe: Store.subscribe.bind(Store),
	      getState: Store.getState.bind(Store),
	      getOwnState: getStateRootedAt(pluginID),
	      getAppState: getStateRootedAt(_PluginConstants.APPLICATION)
	    };
	  }
	
	  var SDK = new _PluginSDKStruct2.default({
	    addStoreConfig: addStoreConfig,
	    constants: constants,
	    onDispatch: onDispatch,
	    pluginID: pluginID,
	    config: config || {},
	    dispatch: createDispatcher(pluginID),
	    Hooks: hooks,
	    Store: StoreAPI
	  });
	
	  extendSDK(SDK, getActionsAPI(SDK));
	
	  PLUGIN_ENV_CACHE[pluginID] = SDK;
	
	  return SDK;
	};
	
	/**
	 * Bootstraps a plugin
	 *
	 * @param  {String} pluginID   Plugin's pluginID from config
	 * @param  {Module} plugin Plugin module or path to entry point within plugins directory
	 * @param  {Object} config Plugin configuration
	 */
	var bootstrapPlugin = function bootstrapPlugin(pluginID, plugin, config) {
	  // Inject Application key constant and configOptions if specified
	  var SDK = getSDK(pluginID, config);
	
	  var pluginReducer = plugin(SDK);
	
	  // If plugin exported a reducer, add it to the reducers object
	  if (pluginReducer) {
	    addPluginReducer(pluginReducer, pluginID);
	  }
	};
	
	/**
	 * Adds a plugin's reducer to the reducers Object
	 *
	 * @param {Function} reducer    Reducer function to manage plugins state in Store
	 * @param {String} pluginID     Plugin's ID
	 */
	var addPluginReducer = function addPluginReducer(reducer, pluginID) {
	  if (typeof reducer !== "function") {
	    throw new Error("Reducer for " + pluginID + " must be a function");
	  }
	  reducers[pluginID] = reducer;
	};
	
	/**
	 * Replace reducers in Store
	 */
	var replaceStoreReducers = function replaceStoreReducers() {
	  // Replace all store reducers now that we have all plugin reducers
	  Store.replaceReducer((0, _redux.combineReducers)(reducers));
	};
	
	/**
	 * Add reducer to Store (only available in test mode so we can test plugins
	 * that rely on State)
	 * @param {String} pluginID - Plugin ID
	 * @param  {Function} reducer - A reducer
	 */
	var __addReducer = function __addReducer(pluginID, reducer) {
	  addPluginReducer(reducer, pluginID);
	  replaceStoreReducers();
	};
	
	/**
	 * Register a callback to be invoked for every dispatched action
	 * @param  {Function} callback - Function invoked with action as argument for all dispatched Actions.
	 * @returns {Function} - unsubscribe
	 */
	var onDispatch = function onDispatch(callback) {
	  // Add ability to react to actions outside of a reducer.
	  // This will most likely be deprecated at some point but for now it gives
	  // us backwards compatibility with much of our existing dispatcher code
	  return _ActionsPubSub2.default.sub(callback);
	};
	
	// Subscribe to Store config change and call initialize with
	// new plugin configuration
	var unSubscribe = Store.subscribe(function () {
	  var configStore = Store.getState()[_PluginConstants.APPLICATION].config;
	  if (configStore && configStore.config && configStore.config.uiConfiguration) {
	    // unsubscribe once we have the config
	    unSubscribe();
	    initialize(configStore.config.uiConfiguration.plugins);
	  }
	});
	
	// Lets get an SDK for the Application
	var ApplicationSDK = getSDK(_PluginConstants.APPLICATION, _Config2.default);
	// Register our Actions
	_AppHooks2.default.initialize(ApplicationSDK);
	
	// Add helper for PluginTestUtils. This allows us to get SDKS for other plugins
	if (global.__DEV__) {
	  ApplicationSDK.__getSDK = getSDK;
	  ApplicationSDK.__addReducer = __addReducer;
	}
	
	// Add manual load method
	ApplicationSDK.initialize = initialize;
	
	module.exports = ApplicationSDK;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(881), __esModule: true };

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(899);
	__webpack_require__(904);
	module.exports = __webpack_require__(870).Promise;

/***/ },
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
[2095, 874, 887, 869, 871, 905, 868, 906, 907, 872, 908, 909, 914, 915, 896, 916, 917, 891, 922, 895, 923, 870, 924],
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */
535,
/* 909 */
[2096, 871, 910, 911, 907, 912, 913],
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */
441,
/* 916 */
[2097, 907, 872, 896],
/* 917 */
[2098, 869, 918, 878],
/* 918 */
[2099, 871, 919, 920, 921, 869, 878],
/* 919 */
417,
/* 920 */
[2054, 869],
/* 921 */
[2055, 906, 869],
/* 922 */
[2100, 888],
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(870)
	  , $           = __webpack_require__(874)
	  , DESCRIPTORS = __webpack_require__(891)
	  , SPECIES     = __webpack_require__(896)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  APPLICATION: "APPLICATION",
	  PLUGIN_LOAD_TIMEOUT: 5000
	};

/***/ },
/* 933 */
/***/ function(module, exports) {

	"use strict";
	
	var EventTypes = {};
	["APP_STORE_CHANGE", "AUTH_LOGIN_REDIRECT", "AUTH_USER_LOGIN_ERROR", "AUTH_USER_LOGIN_SUCCESS", "AUTH_USER_LOGOUT_ERROR", "AUTH_USER_LOGOUT_SUCCESS", "CLUSTER_CCID_SUCCESS", "CLUSTER_CCID_ERROR", "CONFIG_ERROR", "CONFIG_LOADED", "COSMOS_DESCRIBE_CHANGE", "COSMOS_DESCRIBE_ERROR", "COSMOS_LIST_VERSIONS_CHANGE", "COSMOS_LIST_VERSIONS_ERROR", "COSMOS_INSTALL_ERROR", "COSMOS_INSTALL_SUCCESS", "COSMOS_LIST_CHANGE", "COSMOS_LIST_ERROR", "COSMOS_REPOSITORIES_ERROR", "COSMOS_REPOSITORIES_SUCCESS", "COSMOS_REPOSITORY_ADD_ERROR", "COSMOS_REPOSITORY_ADD_SUCCESS", "COSMOS_REPOSITORY_DELETE_ERROR", "COSMOS_REPOSITORY_DELETE_SUCCESS", "COSMOS_SEARCH_CHANGE", "COSMOS_SEARCH_ERROR", "COSMOS_UNINSTALL_ERROR", "COSMOS_UNINSTALL_SUCCESS", "DCOS_CHANGE", "DCOS_METADATA_CHANGE", "DCOS_BUILD_INFO_CHANGE", "DCOS_BUILD_INFO_ERROR", "HEALTH_NODE_ERROR", "HEALTH_NODE_SUCCESS", "HEALTH_NODE_UNIT_ERROR", "HEALTH_NODE_UNIT_SUCCESS", "HEALTH_NODE_UNITS_ERROR", "HEALTH_NODE_UNITS_SUCCESS", "HEALTH_NODES_CHANGE", "HEALTH_NODES_ERROR", "HEALTH_UNIT_ERROR", "HEALTH_UNIT_NODE_ERROR", "HEALTH_UNIT_NODE_SUCCESS", "HEALTH_UNIT_NODES_ERROR", "HEALTH_UNIT_NODES_SUCCESS", "HEALTH_UNIT_SUCCESS", "HEALTH_UNITS_CHANGE", "HEALTH_UNITS_ERROR", "HISTORY_CHANGE", "METRONOME_JOB_CREATE_ERROR", "METRONOME_JOB_CREATE_SUCCESS", "METRONOME_JOB_DELETE_ERROR", "METRONOME_JOB_DELETE_SUCCESS", "METRONOME_JOB_DETAIL_CHANGE", "METRONOME_JOB_DETAIL_ERROR", "METRONOME_JOB_RUN_ERROR", "METRONOME_JOB_RUN_SUCCESS", "METRONOME_JOB_STOP_RUN_ERROR", "METRONOME_JOB_STOP_RUN_SUCCESS", "METRONOME_JOB_SCHEDULE_UPDATE_ERROR", "METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS", "METRONOME_JOB_UPDATE_ERROR", "METRONOME_JOB_UPDATE_SUCCESS", "METRONOME_JOBS_CHANGE", "METRONOME_JOBS_ERROR", "MESOS_STATE_CHANGE", "MESOS_STATE_REQUEST_ERROR", "MESOS_SUMMARY_CHANGE", "MESOS_SUMMARY_REQUEST_ERROR", "METADATA_CHANGE", "NOTIFICATION_CHANGE", "SHOW_CLI_INSTRUCTIONS", "SHOW_VERSIONS_ERROR", "SHOW_VERSIONS_SUCCESS", "SIDEBAR_CHANGE", "SIDEBAR_WIDTH_CHANGE", "SYSTEM_LOG_CHANGE", "SYSTEM_LOG_REQUEST_ERROR", "SYSTEM_LOG_STREAM_TYPES_SUCCESS", "SYSTEM_LOG_STREAM_TYPES_ERROR", "USER_CREATE_ERROR", "USER_CREATE_SUCCESS", "USER_DELETE_ERROR", "USER_DELETE_SUCCESS", "USERS_CHANGE", "USERS_REQUEST_ERROR", "VIRTUAL_NETWORKS_CHANGE", "VIRTUAL_NETWORKS_REQUEST_ERROR", "VISIBILITY_CHANGE"].forEach(function (eventType) {
	  EventTypes[eventType] = eventType;
	});
	
	module.exports = EventTypes;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listeners = {};
	var ID = 0;
	
	var pub = function pub() {
	  return function (next) {
	    return function (action) {
	      (0, _keys2.default)(listeners).forEach(function (id) {
	        listeners[id].call(null, action);
	      });
	
	      return next(action);
	    };
	  };
	};
	
	var unsubscribe = function unsubscribe(id) {
	  return function () {
	    delete listeners[id];
	  };
	};
	
	var sub = function sub(callback) {
	  listeners[++ID] = callback;
	
	  return unsubscribe(ID);
	};
	
	module.exports = {
	  pub: pub,
	  sub: sub
	};

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _EventTypes = __webpack_require__(933);
	
	var _PluginConstants = __webpack_require__(932);
	
	var _StructUtil = __webpack_require__(936);
	
	var _StructUtil2 = _interopRequireDefault(_StructUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	// List of plugins with permissions to alter this state
	var PERMISSIONS_LIST = [_PluginConstants.APPLICATION, "authentication", "organization"];
	
	// Compute new state based on action
	function updateState(prevState, action) {
	  // Peel away Structs and assign to State tree rooted at storeID
	  prevState[action.storeID] = _StructUtil2.default.copyRawObject(action.data);
	
	  return prevState;
	}
	
	function allowedToProceed(action) {
	  return PERMISSIONS_LIST.indexOf(action.__origin) > -1;
	}
	
	// Clones state from application stores and maps it into the OmniStore
	module.exports = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  // Return early if the action didn't come from Application
	  //  or plugins with permission
	  if (!allowedToProceed(action)) {
	    return state;
	  }
	
	  switch (action.type) {
	    case _EventTypes.APP_STORE_CHANGE:
	      return updateState(state, action);
	    default:
	      return state;
	  }
	};

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _List = __webpack_require__(947);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StructUtil = {
	  /**
	   * Recursively peels open Structs to get raw data and returns a clone
	   *
	   * @param  {Object} obj Item to be cloned where structs will be striped.
	   *                      One of Object, Array, Date, String, Number, or Boolean.
	   * @return {Object}     Cloned Object without Structs
	   */
	  copyRawObject: function copyRawObject(obj) {
	    var copy;
	
	    // Handle the 3 simple types, and null or undefined
	    if (obj == null || (typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) !== "object") {
	      return obj;
	    }
	    // Extract underlying array object
	    if (obj instanceof _List2.default) {
	      return copyRawObject(obj.getItems());
	    }
	    // Extract underlying storage Object
	    if (obj instanceof _Item2.default) {
	      return copyRawObject(obj._itemData);
	    }
	    // Handle Date
	    if (obj instanceof Date) {
	      copy = new Date();
	      copy.setTime(obj.getTime());
	
	      return copy;
	    }
	    // Handle Array
	    if (obj instanceof Array) {
	      return obj.map(copyRawObject);
	    }
	    // Handle Object
	    if (obj instanceof Object) {
	      copy = {};
	      for (var attr in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, attr)) {
	          copy[attr] = copyRawObject(obj[attr]);
	        }
	      }
	
	      return copy;
	    }
	  }
	};
	
	module.exports = StructUtil;

/***/ },
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _ObjectUtil = __webpack_require__(951);
	
	var _ObjectUtil2 = _interopRequireDefault(_ObjectUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Cast an item to the List's type, if specified.
	 *
	 * Note that cast must be bound to the List's context in order to access
	 * its `type` property.
	 *
	 * @param {Object} item
	 * @access private
	 * @memberOf List
	 * @return {Object} item, cast if list is typed.
	 */
	function cast(item) {
	  var Type = this.constructor.type;
	  if (Type != null && !(item instanceof Type)) {
	    return new Type(item);
	  }
	
	  return item;
	}
	
	module.exports = function () {
	  /**
	   * List
	   * @param {Object} options Options object
	   * @param {Array} options.items
	   * @param {{propertyName:(null|function)}} [options.filterProperties]
	   * @property {Class} type - the type of list items
	   * @constructor
	   * @struct
	   */
	  function List() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, List);
	
	    this.list = [];
	
	    if (options.items) {
	      if (!Array.isArray(options.items)) {
	        throw new Error("Expected an array.");
	      }
	      if (this.constructor.type != null) {
	        this.list = options.items.map(cast.bind(this));
	      } else {
	        this.list = options.items;
	      }
	    }
	
	    this.filterProperties = options.filterProperties || {};
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: "add",
	    value: function add(item) {
	      this.list.push(cast.call(this, item));
	    }
	  }, {
	    key: "getItems",
	    value: function getItems() {
	      return this.list;
	    }
	  }, {
	    key: "getFilterProperties",
	    value: function getFilterProperties() {
	      return this.filterProperties;
	    }
	  }, {
	    key: "last",
	    value: function last() {
	      return this.list[this.list.length - 1];
	    }
	
	    /**
	     * Return a new list with the items currently present in this list and
	     * the list on the first argument, without duplicates.
	     *
	     * @param {List} list - The list to combine with this list
	     * @returns {List} Returns a new list with the combined items
	     */
	
	  }, {
	    key: "combine",
	    value: function combine(list) {
	      var actualLength = 0;
	      var currentItems = this.getItems();
	      var newItems = list.getItems();
	
	      // We pre-allocate the result array with the worst possible scenario
	      var combinedItems = new Array(currentItems.length + newItems.length);
	
	      // Instead of using the O(n²) approach of iterating over `newItems` and
	      // checking if each item exist on `currentItems`, we use a trick that brings
	      // the complexity down to O(n) (well, O(2n) to be precise).
	
	      // We first generate a unique object for the current combine operation
	      // and we mark all the objects of `currentItems` with it, declaring them as
	      // used.
	      var comparisonTag = {};
	      for (var i = 0, length = currentItems.length; i < length; ++i) {
	        combinedItems[actualLength++] = _ObjectUtil2.default.markObject(currentItems[i], comparisonTag);
	      }
	
	      // We then iterate over the `newItems` and skip the objects that are already
	      // marked from the previous step.
	      for (var _i = 0, _length = newItems.length; _i < _length; ++_i) {
	        if (!_ObjectUtil2.default.objectHasMark(newItems[_i], comparisonTag)) {
	          combinedItems[actualLength++] = newItems[_i];
	        }
	      }
	
	      // Finally we trim-down the `combinedItems` array with the actual length
	      // of the end result and we create the new list
	      combinedItems.length = actualLength;
	
	      return new this.constructor({ items: combinedItems });
	    }
	
	    /**
	     * @param {function} callback Function to test each element of the array,
	     * taking three arguments: item, index, list. Return true to keep the item,
	     * false otherwise.
	     * @return {List} List (or child class) containing mapped items
	     */
	
	  }, {
	    key: "filterItems",
	    value: function filterItems(callback) {
	      var _this = this;
	
	      var items = this.getItems().filter(function (item, index) {
	        return callback(item, index, _this);
	      });
	
	      return new this.constructor({ items: items });
	    }
	
	    /**
	     * Filters items in list and returns a new instance of the list used.
	     * @param  {string} filterText string to search in properties of the list
	     * @param  {{propertyName:(null|function)}} [filterProperties] object
	     *     to configure filter properties as well as their getters
	     * @return {List} List (or child class) containing filtered items
	     */
	
	  }, {
	    key: "filterItemsByText",
	    value: function filterItemsByText(filterText) {
	      var filterProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFilterProperties();
	
	      var items = this.getItems();
	
	      if (filterText) {
	        items = _StringUtil2.default.filterByString(items, function (item) {
	          var searchFields = (0, _keys2.default)(filterProperties).map(function (prop) {
	            // We need different handlers for item getters since the property
	            // since there can be different ways of getting the value needed
	
	            // Use getter function if specified in filterProperties.
	            // This is used if property is nested or type is different than string
	            var valueGetter = filterProperties[prop];
	            if (typeof valueGetter === "function") {
	              return valueGetter(item, prop);
	            }
	
	            // Use default getter if item is an instanceof Item.
	            // This is the regular way of getting a property on an item
	            if (item instanceof _Item2.default) {
	              return item.get(prop) || "";
	            }
	
	            // Last resort is to get property on object.
	            // Some of the items in lists are not always of instance Item and
	            // therefore we might need to get it directly on the object
	            return item[prop] || "";
	          });
	
	          return searchFields.join(" ");
	        }, filterText);
	      }
	
	      return new this.constructor({ items: items });
	    }
	
	    /**
	     * @param {function} callback Function to execute on each value in the array,
	     * taking one argument: item
	     * @return {object} matching item
	     */
	
	  }, {
	    key: "findItem",
	    value: function findItem(callback) {
	      return this.getItems().find(callback);
	    }
	
	    /**
	     * @param {function} callback Function that produces an item of the new
	     * List, taking three arguments: item, index, list
	     * @return {List} List (or child class) containing mapped items
	     */
	
	  }, {
	    key: "mapItems",
	    value: function mapItems(callback) {
	      var _this2 = this;
	
	      var items = this.getItems().map(function (item, index) {
	        return callback(item, index, _this2);
	      });
	
	      return new this.constructor({ items: items });
	    }
	
	    /**
	     * @param {function} callback Function to execute on each value in the
	     * array, taking four arguments: previousValue, currentValue, index, list
	     * @param {*} initialValue
	     * @returns {*} returnValue
	     */
	
	  }, {
	    key: "reduceItems",
	    value: function reduceItems(callback, initialValue) {
	      var _this3 = this;
	
	      return this.getItems().reduce(function (previousValue, currentValue, index) {
	        return callback(previousValue, currentValue, index, _this3);
	      }, initialValue);
	    }
	  }]);
	  return List;
	}();

/***/ },
/* 948 */,
/* 949 */,
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function () {
	  function Item() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Item);
	
	    (0, _keys2.default)(item).forEach(function (key) {
	      this[key] = item[key];
	    }, this);
	
	    this._itemData = item;
	  }
	
	  (0, _createClass3.default)(Item, [{
	    key: "get",
	    value: function get(key) {
	      if (key == null) {
	        return this._itemData;
	      }
	
	      return this._itemData[key];
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.get();
	    }
	  }]);
	  return Item;
	}();

/***/ },
/* 951 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  /**
	   * This function adds the given mark to the provided object.
	   * Note that this will replace the value of a previous mark.
	   *
	   * @param {Object} obj - The object to mark
	   * @param {Any} mark - The mark to add
	   * @return {Object} Returns the passed object
	   */
	  markObject: function markObject(obj, mark) {
	    Object.defineProperty(obj, "___object_mark___", {
	      value: mark,
	      enumerable: false,
	      writable: true
	    });
	
	    return obj;
	  },
	
	
	  /**
	   * This function checks if the object is marked with the given mark.
	   *
	   * @param {Object} obj - The object to test
	   * @param {Any} mark - The mark to compare against
	   * @returns {Boolean} Returns true if the mark matches
	   */
	  objectHasMark: function objectHasMark(obj, mark) {
	    return obj.___object_mark___ === mark;
	  }
	};

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _marked = __webpack_require__(953);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var markdownRenderer = {
	  rendererReady: false,
	  prepareMarkdownRenderer: function prepareMarkdownRenderer() {
	    var renderer = new _marked2.default.Renderer();
	    renderer.link = function () {
	      var out = _marked2.default.Renderer.prototype.link.apply(this, arguments);
	
	      return out.replace(/^<a/, '<a target="_blank"');
	    };
	    _marked2.default.setOptions({ renderer: renderer });
	    this.rendererReady = true;
	  }
	};
	/* eslint-disable no-unused-vars */
	
	
	var StringUtil = {
	  arrayToJoinedString: function arrayToJoinedString() {
	    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ", ";
	
	    if (Array.isArray(array)) {
	      return array.join(separator);
	    }
	
	    return "";
	  },
	  getSearchTokens: function getSearchTokens(searchString) {
	    if (!searchString) {
	      return [];
	    }
	
	    return String(searchString).toLowerCase()
	    // split on non-word characters and slash
	    .split(/[^\w/]/).filter(Boolean);
	  },
	  filterByString: function filterByString(objects, getter, searchString) {
	    var _this = this;
	
	    var searchItems = this.getSearchTokens(searchString);
	
	    if (typeof getter === "function") {
	      return objects.filter(function (obj) {
	        return searchItems.some(function (item) {
	          return _this.getSearchTokens(getter(obj)).some(function (token) {
	            return token.startsWith(item);
	          });
	        });
	      });
	    }
	
	    return objects.filter(function (obj) {
	      return searchItems.some(function (item) {
	        return _this.getSearchTokens(obj[getter]).some(function (token) {
	          return token.startsWith(item);
	        });
	      });
	    });
	  },
	  escapeForRegExp: function escapeForRegExp(str) {
	    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
	  },
	  isUrl: function isUrl(str) {
	    return !!str && /^https?:\/\/.+/.test(str);
	  },
	  isEmail: function isEmail(str) {
	    // https://news.ycombinator.com/item?id=8360786
	    return !!str && str.length > 3 && str.indexOf("@") !== -1 && str.indexOf(".") !== -1;
	  },
	  pluralize: function pluralize(string, arity) {
	    if (arity == null) {
	      arity = 2;
	    }
	
	    if (string.length === 0) {
	      return "";
	    }
	
	    arity = parseInt(arity, 10);
	
	    if (arity !== 1) {
	      string = string.replace(/y$/, "ie") + "s";
	    }
	
	    return string;
	  },
	  capitalize: function capitalize(string) {
	    if (typeof string !== "string") {
	      return null;
	    }
	
	    return string.charAt(0).toUpperCase() + string.slice(1, string.length);
	  },
	  lowercase: function lowercase(string) {
	    if (typeof string !== "string") {
	      return null;
	    }
	
	    return string.charAt(0).toLowerCase() + string.slice(1, string.length);
	  },
	  humanizeArray: function humanizeArray(array, options) {
	    options = (0, _assign2.default)({
	      serialComma: true,
	      wrapValueFunction: false
	    }, options);
	
	    var length = array.length;
	    var conjunction = " and ";
	
	    if (length === 0) {
	      return "";
	    }
	
	    if (length === 1) {
	      if (options.wrapValueFunction) {
	        return options.wrapValueFunction(array[0], 0);
	      } else {
	        return array[0];
	      }
	    }
	
	    if (length === 2) {
	      if (options.wrapValueFunction) {
	        return [options.wrapValueFunction(array[0], 0), conjunction, options.wrapValueFunction(array[1], 1)];
	      } else {
	        return array.join(conjunction);
	      }
	    }
	
	    var head = array.slice(0, -1);
	    var tail = array.slice(-1)[0];
	    if (options.serialComma) {
	      conjunction = ", and ";
	    }
	
	    if (options.wrapValueFunction) {
	      var jsx = head.reduce(function (memo, value, index) {
	        memo.push(options.wrapValueFunction(value, index));
	
	        if (index !== head.length - 1) {
	          memo.push(", ");
	        }
	
	        return memo;
	      }, []);
	
	      jsx.push(conjunction);
	      jsx.push(options.wrapValueFunction(tail, "tail"));
	
	      return jsx;
	    } else {
	      return head.join(", ") + conjunction + tail;
	    }
	  },
	  parseMarkdown: function parseMarkdown(text) {
	    if (!text) {
	      return null;
	    }
	
	    if (!markdownRenderer.rendererReady) {
	      markdownRenderer.prepareMarkdownRenderer();
	    }
	
	    var __html = (0, _marked2.default)(
	    // Remove any tabs, that will create code blocks
	    text.replace("\t", " "), { gfm: true, tables: false, sanitize: true });
	
	    if (!__html) {
	      return null;
	    }
	
	    return { __html: __html };
	  },
	
	
	  /**
	   * @param {Array} id       - An array that, when concatenated, represents an ID.
	   * @param {Array} splitBy  - Tokens to split id by.
	   * @param {Object} replace - Keys are words to replace, with value of the word
	   *                           to replace with.
	   * @param {Boolean} removeConsecutive
	   *                         - Whether or not to remove consecutive duplicate
	   *                           word tokens.
	   * @return {String}        - Human-readable title.
	   */
	  idToTitle: function idToTitle(id) {
	    var splitBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var _this2 = this;
	
	    var replace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var removeConsecutive = arguments[3];
	
	    if (splitBy.length === 0) {
	      return id.reduce(function (title, word, i, words) {
	        if (removeConsecutive && i > 0 && word === words[i - 1]) {
	          return title;
	        }
	        word = replace[word] || _this2.capitalize(word.toLowerCase().trim());
	
	        return title + " " + word;
	      }, "").trim();
	    }
	
	    var splitID = id.reduce(function (accumulated, element) {
	      var splitWords = element.split(splitBy.shift());
	
	      splitWords.map(function (token) {
	        accumulated.push(token);
	      });
	
	      return accumulated;
	    }, []);
	
	    return this.idToTitle(splitID, splitBy, replace, removeConsecutive);
	  }
	};
	
	module.exports = StringUtil;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 */
	
	;(function() {
	'use strict';
	
	/**
	 * Block-Level Grammar
	 */
	
	var block = {
	  newline: /^\n+/,
	  code: /^( {4}[^\n]+\n*)+/,
	  fences: noop,
	  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
	  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
	  nptable: noop,
	  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
	  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
	  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
	  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
	  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
	  table: noop,
	  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
	  text: /^[^\n]+/
	};
	
	block.bullet = /(?:[*+-]|\d+\.)/;
	block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
	block.item = replace(block.item, 'gm')
	  (/bull/g, block.bullet)
	  ();
	
	block.list = replace(block.list)
	  (/bull/g, block.bullet)
	  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
	  ('def', '\\n+(?=' + block.def.source + ')')
	  ();
	
	block.blockquote = replace(block.blockquote)
	  ('def', block.def)
	  ();
	
	block._tag = '(?!(?:'
	  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
	  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
	  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';
	
	block.html = replace(block.html)
	  ('comment', /<!--[\s\S]*?-->/)
	  ('closed', /<(tag)[\s\S]+?<\/\1>/)
	  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
	  (/tag/g, block._tag)
	  ();
	
	block.paragraph = replace(block.paragraph)
	  ('hr', block.hr)
	  ('heading', block.heading)
	  ('lheading', block.lheading)
	  ('blockquote', block.blockquote)
	  ('tag', '<' + block._tag)
	  ('def', block.def)
	  ();
	
	/**
	 * Normal Block Grammar
	 */
	
	block.normal = merge({}, block);
	
	/**
	 * GFM Block Grammar
	 */
	
	block.gfm = merge({}, block.normal, {
	  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
	  paragraph: /^/,
	  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
	});
	
	block.gfm.paragraph = replace(block.paragraph)
	  ('(?!', '(?!'
	    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
	    + block.list.source.replace('\\1', '\\3') + '|')
	  ();
	
	/**
	 * GFM + Tables Block Grammar
	 */
	
	block.tables = merge({}, block.gfm, {
	  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
	  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
	});
	
	/**
	 * Block Lexer
	 */
	
	function Lexer(options) {
	  this.tokens = [];
	  this.tokens.links = {};
	  this.options = options || marked.defaults;
	  this.rules = block.normal;
	
	  if (this.options.gfm) {
	    if (this.options.tables) {
	      this.rules = block.tables;
	    } else {
	      this.rules = block.gfm;
	    }
	  }
	}
	
	/**
	 * Expose Block Rules
	 */
	
	Lexer.rules = block;
	
	/**
	 * Static Lex Method
	 */
	
	Lexer.lex = function(src, options) {
	  var lexer = new Lexer(options);
	  return lexer.lex(src);
	};
	
	/**
	 * Preprocessing
	 */
	
	Lexer.prototype.lex = function(src) {
	  src = src
	    .replace(/\r\n|\r/g, '\n')
	    .replace(/\t/g, '    ')
	    .replace(/\u00a0/g, ' ')
	    .replace(/\u2424/g, '\n');
	
	  return this.token(src, true);
	};
	
	/**
	 * Lexing
	 */
	
	Lexer.prototype.token = function(src, top, bq) {
	  var src = src.replace(/^ +$/gm, '')
	    , next
	    , loose
	    , cap
	    , bull
	    , b
	    , item
	    , space
	    , i
	    , l;
	
	  while (src) {
	    // newline
	    if (cap = this.rules.newline.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[0].length > 1) {
	        this.tokens.push({
	          type: 'space'
	        });
	      }
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      cap = cap[0].replace(/^ {4}/gm, '');
	      this.tokens.push({
	        type: 'code',
	        text: !this.options.pedantic
	          ? cap.replace(/\n+$/, '')
	          : cap
	      });
	      continue;
	    }
	
	    // fences (gfm)
	    if (cap = this.rules.fences.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'code',
	        lang: cap[2],
	        text: cap[3] || ''
	      });
	      continue;
	    }
	
	    // heading
	    if (cap = this.rules.heading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[1].length,
	        text: cap[2]
	      });
	      continue;
	    }
	
	    // table no leading pipe (gfm)
	    if (top && (cap = this.rules.nptable.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i].split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // lheading
	    if (cap = this.rules.lheading.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'heading',
	        depth: cap[2] === '=' ? 1 : 2,
	        text: cap[1]
	      });
	      continue;
	    }
	
	    // hr
	    if (cap = this.rules.hr.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'hr'
	      });
	      continue;
	    }
	
	    // blockquote
	    if (cap = this.rules.blockquote.exec(src)) {
	      src = src.substring(cap[0].length);
	
	      this.tokens.push({
	        type: 'blockquote_start'
	      });
	
	      cap = cap[0].replace(/^ *> ?/gm, '');
	
	      // Pass `top` to keep the current
	      // "toplevel" state. This is exactly
	      // how markdown.pl works.
	      this.token(cap, top, true);
	
	      this.tokens.push({
	        type: 'blockquote_end'
	      });
	
	      continue;
	    }
	
	    // list
	    if (cap = this.rules.list.exec(src)) {
	      src = src.substring(cap[0].length);
	      bull = cap[2];
	
	      this.tokens.push({
	        type: 'list_start',
	        ordered: bull.length > 1
	      });
	
	      // Get each top-level item.
	      cap = cap[0].match(this.rules.item);
	
	      next = false;
	      l = cap.length;
	      i = 0;
	
	      for (; i < l; i++) {
	        item = cap[i];
	
	        // Remove the list item's bullet
	        // so it is seen as the next token.
	        space = item.length;
	        item = item.replace(/^ *([*+-]|\d+\.) +/, '');
	
	        // Outdent whatever the
	        // list item contains. Hacky.
	        if (~item.indexOf('\n ')) {
	          space -= item.length;
	          item = !this.options.pedantic
	            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
	            : item.replace(/^ {1,4}/gm, '');
	        }
	
	        // Determine whether the next list item belongs here.
	        // Backpedal if it does not belong in this list.
	        if (this.options.smartLists && i !== l - 1) {
	          b = block.bullet.exec(cap[i + 1])[0];
	          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
	            src = cap.slice(i + 1).join('\n') + src;
	            i = l - 1;
	          }
	        }
	
	        // Determine whether item is loose or not.
	        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
	        // for discount behavior.
	        loose = next || /\n\n(?!\s*$)/.test(item);
	        if (i !== l - 1) {
	          next = item.charAt(item.length - 1) === '\n';
	          if (!loose) loose = next;
	        }
	
	        this.tokens.push({
	          type: loose
	            ? 'loose_item_start'
	            : 'list_item_start'
	        });
	
	        // Recurse.
	        this.token(item, false, bq);
	
	        this.tokens.push({
	          type: 'list_item_end'
	        });
	      }
	
	      this.tokens.push({
	        type: 'list_end'
	      });
	
	      continue;
	    }
	
	    // html
	    if (cap = this.rules.html.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: this.options.sanitize
	          ? 'paragraph'
	          : 'html',
	        pre: !this.options.sanitizer
	          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
	        text: cap[0]
	      });
	      continue;
	    }
	
	    // def
	    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.links[cap[1].toLowerCase()] = {
	        href: cap[2],
	        title: cap[3]
	      };
	      continue;
	    }
	
	    // table (gfm)
	    if (top && (cap = this.rules.table.exec(src))) {
	      src = src.substring(cap[0].length);
	
	      item = {
	        type: 'table',
	        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
	        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
	        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
	      };
	
	      for (i = 0; i < item.align.length; i++) {
	        if (/^ *-+: *$/.test(item.align[i])) {
	          item.align[i] = 'right';
	        } else if (/^ *:-+: *$/.test(item.align[i])) {
	          item.align[i] = 'center';
	        } else if (/^ *:-+ *$/.test(item.align[i])) {
	          item.align[i] = 'left';
	        } else {
	          item.align[i] = null;
	        }
	      }
	
	      for (i = 0; i < item.cells.length; i++) {
	        item.cells[i] = item.cells[i]
	          .replace(/^ *\| *| *\| *$/g, '')
	          .split(/ *\| */);
	      }
	
	      this.tokens.push(item);
	
	      continue;
	    }
	
	    // top-level paragraph
	    if (top && (cap = this.rules.paragraph.exec(src))) {
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'paragraph',
	        text: cap[1].charAt(cap[1].length - 1) === '\n'
	          ? cap[1].slice(0, -1)
	          : cap[1]
	      });
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      // Top-level should never reach here.
	      src = src.substring(cap[0].length);
	      this.tokens.push({
	        type: 'text',
	        text: cap[0]
	      });
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return this.tokens;
	};
	
	/**
	 * Inline-Level Grammar
	 */
	
	var inline = {
	  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
	  autolink: /^<([^ <>]+(@|:\/)[^ <>]+)>/,
	  url: noop,
	  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^<'">])*?>/,
	  link: /^!?\[(inside)\]\(href\)/,
	  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
	  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
	  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
	  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
	  code: /^(`+)([\s\S]*?[^`])\1(?!`)/,
	  br: /^ {2,}\n(?!\s*$)/,
	  del: noop,
	  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
	};
	
	inline._inside = /(?:\[[^\]]*\]|\\[\[\]]|[^\[\]]|\](?=[^\[]*\]))*/;
	inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;
	
	inline.link = replace(inline.link)
	  ('inside', inline._inside)
	  ('href', inline._href)
	  ();
	
	inline.reflink = replace(inline.reflink)
	  ('inside', inline._inside)
	  ();
	
	/**
	 * Normal Inline Grammar
	 */
	
	inline.normal = merge({}, inline);
	
	/**
	 * Pedantic Inline Grammar
	 */
	
	inline.pedantic = merge({}, inline.normal, {
	  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
	  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
	});
	
	/**
	 * GFM Inline Grammar
	 */
	
	inline.gfm = merge({}, inline.normal, {
	  escape: replace(inline.escape)('])', '~|])')(),
	  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
	  del: /^~~(?=\S)([\s\S]*?\S)~~/,
	  text: replace(inline.text)
	    (']|', '~]|')
	    ('|', '|https?://|')
	    ()
	});
	
	/**
	 * GFM + Line Breaks Inline Grammar
	 */
	
	inline.breaks = merge({}, inline.gfm, {
	  br: replace(inline.br)('{2,}', '*')(),
	  text: replace(inline.gfm.text)('{2,}', '*')()
	});
	
	/**
	 * Inline Lexer & Compiler
	 */
	
	function InlineLexer(links, options) {
	  this.options = options || marked.defaults;
	  this.links = links;
	  this.rules = inline.normal;
	  this.renderer = this.options.renderer || new Renderer;
	  this.renderer.options = this.options;
	
	  if (!this.links) {
	    throw new
	      Error('Tokens array requires a `links` property.');
	  }
	
	  if (this.options.gfm) {
	    if (this.options.breaks) {
	      this.rules = inline.breaks;
	    } else {
	      this.rules = inline.gfm;
	    }
	  } else if (this.options.pedantic) {
	    this.rules = inline.pedantic;
	  }
	}
	
	/**
	 * Expose Inline Rules
	 */
	
	InlineLexer.rules = inline;
	
	/**
	 * Static Lexing/Compiling Method
	 */
	
	InlineLexer.output = function(src, links, options) {
	  var inline = new InlineLexer(links, options);
	  return inline.output(src);
	};
	
	/**
	 * Lexing/Compiling
	 */
	
	InlineLexer.prototype.output = function(src) {
	  var out = ''
	    , link
	    , text
	    , href
	    , cap;
	
	  while (src) {
	    // escape
	    if (cap = this.rules.escape.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += cap[1];
	      continue;
	    }
	
	    // autolink
	    if (cap = this.rules.autolink.exec(src)) {
	      src = src.substring(cap[0].length);
	      if (cap[2] === '@') {
	        text = escape(
	          cap[1].charAt(6) === ':'
	          ? this.mangle(cap[1].substring(7))
	          : this.mangle(cap[1])
	        );
	        href = this.mangle('mailto:') + text;
	      } else {
	        text = escape(cap[1]);
	        href = text;
	      }
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // url (gfm)
	    if (!this.inLink && (cap = this.rules.url.exec(src))) {
	      src = src.substring(cap[0].length);
	      text = escape(cap[1]);
	      href = text;
	      out += this.renderer.link(href, null, text);
	      continue;
	    }
	
	    // tag
	    if (cap = this.rules.tag.exec(src)) {
	      if (!this.inLink && /^<a /i.test(cap[0])) {
	        this.inLink = true;
	      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
	        this.inLink = false;
	      }
	      src = src.substring(cap[0].length);
	      out += this.options.sanitize
	        ? this.options.sanitizer
	          ? this.options.sanitizer(cap[0])
	          : escape(cap[0])
	        : cap[0]
	      continue;
	    }
	
	    // link
	    if (cap = this.rules.link.exec(src)) {
	      src = src.substring(cap[0].length);
	      this.inLink = true;
	      out += this.outputLink(cap, {
	        href: cap[2],
	        title: cap[3]
	      });
	      this.inLink = false;
	      continue;
	    }
	
	    // reflink, nolink
	    if ((cap = this.rules.reflink.exec(src))
	        || (cap = this.rules.nolink.exec(src))) {
	      src = src.substring(cap[0].length);
	      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
	      link = this.links[link.toLowerCase()];
	      if (!link || !link.href) {
	        out += cap[0].charAt(0);
	        src = cap[0].substring(1) + src;
	        continue;
	      }
	      this.inLink = true;
	      out += this.outputLink(cap, link);
	      this.inLink = false;
	      continue;
	    }
	
	    // strong
	    if (cap = this.rules.strong.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.strong(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // em
	    if (cap = this.rules.em.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.em(this.output(cap[2] || cap[1]));
	      continue;
	    }
	
	    // code
	    if (cap = this.rules.code.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.codespan(escape(cap[2].trim(), true));
	      continue;
	    }
	
	    // br
	    if (cap = this.rules.br.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.br();
	      continue;
	    }
	
	    // del (gfm)
	    if (cap = this.rules.del.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.del(this.output(cap[1]));
	      continue;
	    }
	
	    // text
	    if (cap = this.rules.text.exec(src)) {
	      src = src.substring(cap[0].length);
	      out += this.renderer.text(escape(this.smartypants(cap[0])));
	      continue;
	    }
	
	    if (src) {
	      throw new
	        Error('Infinite loop on byte: ' + src.charCodeAt(0));
	    }
	  }
	
	  return out;
	};
	
	/**
	 * Compile Link
	 */
	
	InlineLexer.prototype.outputLink = function(cap, link) {
	  var href = escape(link.href)
	    , title = link.title ? escape(link.title) : null;
	
	  return cap[0].charAt(0) !== '!'
	    ? this.renderer.link(href, title, this.output(cap[1]))
	    : this.renderer.image(href, title, escape(cap[1]));
	};
	
	/**
	 * Smartypants Transformations
	 */
	
	InlineLexer.prototype.smartypants = function(text) {
	  if (!this.options.smartypants) return text;
	  return text
	    // em-dashes
	    .replace(/---/g, '\u2014')
	    // en-dashes
	    .replace(/--/g, '\u2013')
	    // opening singles
	    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
	    // closing singles & apostrophes
	    .replace(/'/g, '\u2019')
	    // opening doubles
	    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
	    // closing doubles
	    .replace(/"/g, '\u201d')
	    // ellipses
	    .replace(/\.{3}/g, '\u2026');
	};
	
	/**
	 * Mangle Links
	 */
	
	InlineLexer.prototype.mangle = function(text) {
	  if (!this.options.mangle) return text;
	  var out = ''
	    , l = text.length
	    , i = 0
	    , ch;
	
	  for (; i < l; i++) {
	    ch = text.charCodeAt(i);
	    if (Math.random() > 0.5) {
	      ch = 'x' + ch.toString(16);
	    }
	    out += '&#' + ch + ';';
	  }
	
	  return out;
	};
	
	/**
	 * Renderer
	 */
	
	function Renderer(options) {
	  this.options = options || {};
	}
	
	Renderer.prototype.code = function(code, lang, escaped) {
	  if (this.options.highlight) {
	    var out = this.options.highlight(code, lang);
	    if (out != null && out !== code) {
	      escaped = true;
	      code = out;
	    }
	  }
	
	  if (!lang) {
	    return '<pre><code>'
	      + (escaped ? code : escape(code, true))
	      + '\n</code></pre>';
	  }
	
	  return '<pre><code class="'
	    + this.options.langPrefix
	    + escape(lang, true)
	    + '">'
	    + (escaped ? code : escape(code, true))
	    + '\n</code></pre>\n';
	};
	
	Renderer.prototype.blockquote = function(quote) {
	  return '<blockquote>\n' + quote + '</blockquote>\n';
	};
	
	Renderer.prototype.html = function(html) {
	  return html;
	};
	
	Renderer.prototype.heading = function(text, level, raw) {
	  return '<h'
	    + level
	    + ' id="'
	    + this.options.headerPrefix
	    + raw.toLowerCase().replace(/[^\w]+/g, '-')
	    + '">'
	    + text
	    + '</h'
	    + level
	    + '>\n';
	};
	
	Renderer.prototype.hr = function() {
	  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
	};
	
	Renderer.prototype.list = function(body, ordered) {
	  var type = ordered ? 'ol' : 'ul';
	  return '<' + type + '>\n' + body + '</' + type + '>\n';
	};
	
	Renderer.prototype.listitem = function(text) {
	  return '<li>' + text + '</li>\n';
	};
	
	Renderer.prototype.paragraph = function(text) {
	  return '<p>' + text + '</p>\n';
	};
	
	Renderer.prototype.table = function(header, body) {
	  return '<table>\n'
	    + '<thead>\n'
	    + header
	    + '</thead>\n'
	    + '<tbody>\n'
	    + body
	    + '</tbody>\n'
	    + '</table>\n';
	};
	
	Renderer.prototype.tablerow = function(content) {
	  return '<tr>\n' + content + '</tr>\n';
	};
	
	Renderer.prototype.tablecell = function(content, flags) {
	  var type = flags.header ? 'th' : 'td';
	  var tag = flags.align
	    ? '<' + type + ' style="text-align:' + flags.align + '">'
	    : '<' + type + '>';
	  return tag + content + '</' + type + '>\n';
	};
	
	// span level renderer
	Renderer.prototype.strong = function(text) {
	  return '<strong>' + text + '</strong>';
	};
	
	Renderer.prototype.em = function(text) {
	  return '<em>' + text + '</em>';
	};
	
	Renderer.prototype.codespan = function(text) {
	  return '<code>' + text + '</code>';
	};
	
	Renderer.prototype.br = function() {
	  return this.options.xhtml ? '<br/>' : '<br>';
	};
	
	Renderer.prototype.del = function(text) {
	  return '<del>' + text + '</del>';
	};
	
	Renderer.prototype.link = function(href, title, text) {
	  if (this.options.sanitize) {
	    try {
	      var prot = decodeURIComponent(unescape(href))
	        .replace(/[^\w:]/g, '')
	        .toLowerCase();
	    } catch (e) {
	      return text;
	    }
	    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
	      return text;
	    }
	  }
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	Renderer.prototype.image = function(href, title, text) {
	  if (this.options.baseUrl && !originIndependentUrl.test(href)) {
	    href = resolveUrl(this.options.baseUrl, href);
	  }
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	Renderer.prototype.text = function(text) {
	  return text;
	};
	
	/**
	 * Parsing & Compiling
	 */
	
	function Parser(options) {
	  this.tokens = [];
	  this.token = null;
	  this.options = options || marked.defaults;
	  this.options.renderer = this.options.renderer || new Renderer;
	  this.renderer = this.options.renderer;
	  this.renderer.options = this.options;
	}
	
	/**
	 * Static Parse Method
	 */
	
	Parser.parse = function(src, options, renderer) {
	  var parser = new Parser(options, renderer);
	  return parser.parse(src);
	};
	
	/**
	 * Parse Loop
	 */
	
	Parser.prototype.parse = function(src) {
	  this.inline = new InlineLexer(src.links, this.options, this.renderer);
	  this.tokens = src.reverse();
	
	  var out = '';
	  while (this.next()) {
	    out += this.tok();
	  }
	
	  return out;
	};
	
	/**
	 * Next Token
	 */
	
	Parser.prototype.next = function() {
	  return this.token = this.tokens.pop();
	};
	
	/**
	 * Preview Next Token
	 */
	
	Parser.prototype.peek = function() {
	  return this.tokens[this.tokens.length - 1] || 0;
	};
	
	/**
	 * Parse Text Tokens
	 */
	
	Parser.prototype.parseText = function() {
	  var body = this.token.text;
	
	  while (this.peek().type === 'text') {
	    body += '\n' + this.next().text;
	  }
	
	  return this.inline.output(body);
	};
	
	/**
	 * Parse Current Token
	 */
	
	Parser.prototype.tok = function() {
	  switch (this.token.type) {
	    case 'space': {
	      return '';
	    }
	    case 'hr': {
	      return this.renderer.hr();
	    }
	    case 'heading': {
	      return this.renderer.heading(
	        this.inline.output(this.token.text),
	        this.token.depth,
	        this.token.text);
	    }
	    case 'code': {
	      return this.renderer.code(this.token.text,
	        this.token.lang,
	        this.token.escaped);
	    }
	    case 'table': {
	      var header = ''
	        , body = ''
	        , i
	        , row
	        , cell
	        , flags
	        , j;
	
	      // header
	      cell = '';
	      for (i = 0; i < this.token.header.length; i++) {
	        flags = { header: true, align: this.token.align[i] };
	        cell += this.renderer.tablecell(
	          this.inline.output(this.token.header[i]),
	          { header: true, align: this.token.align[i] }
	        );
	      }
	      header += this.renderer.tablerow(cell);
	
	      for (i = 0; i < this.token.cells.length; i++) {
	        row = this.token.cells[i];
	
	        cell = '';
	        for (j = 0; j < row.length; j++) {
	          cell += this.renderer.tablecell(
	            this.inline.output(row[j]),
	            { header: false, align: this.token.align[j] }
	          );
	        }
	
	        body += this.renderer.tablerow(cell);
	      }
	      return this.renderer.table(header, body);
	    }
	    case 'blockquote_start': {
	      var body = '';
	
	      while (this.next().type !== 'blockquote_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.blockquote(body);
	    }
	    case 'list_start': {
	      var body = ''
	        , ordered = this.token.ordered;
	
	      while (this.next().type !== 'list_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.list(body, ordered);
	    }
	    case 'list_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.token.type === 'text'
	          ? this.parseText()
	          : this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'loose_item_start': {
	      var body = '';
	
	      while (this.next().type !== 'list_item_end') {
	        body += this.tok();
	      }
	
	      return this.renderer.listitem(body);
	    }
	    case 'html': {
	      var html = !this.token.pre && !this.options.pedantic
	        ? this.inline.output(this.token.text)
	        : this.token.text;
	      return this.renderer.html(html);
	    }
	    case 'paragraph': {
	      return this.renderer.paragraph(this.inline.output(this.token.text));
	    }
	    case 'text': {
	      return this.renderer.paragraph(this.parseText());
	    }
	  }
	};
	
	/**
	 * Helpers
	 */
	
	function escape(html, encode) {
	  return html
	    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#39;');
	}
	
	function unescape(html) {
		// explicitly match decimal, hex, and named HTML entities
	  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
	    n = n.toLowerCase();
	    if (n === 'colon') return ':';
	    if (n.charAt(0) === '#') {
	      return n.charAt(1) === 'x'
	        ? String.fromCharCode(parseInt(n.substring(2), 16))
	        : String.fromCharCode(+n.substring(1));
	    }
	    return '';
	  });
	}
	
	function replace(regex, opt) {
	  regex = regex.source;
	  opt = opt || '';
	  return function self(name, val) {
	    if (!name) return new RegExp(regex, opt);
	    val = val.source || val;
	    val = val.replace(/(^|[^\[])\^/g, '$1');
	    regex = regex.replace(name, val);
	    return self;
	  };
	}
	
	function resolveUrl(base, href) {
	  if (!baseUrls[' ' + base]) {
	    // we can ignore everything in base after the last slash of its path component,
	    // but we might need to add _that_
	    // https://tools.ietf.org/html/rfc3986#section-3
	    if (/^[^:]+:\/*[^/]*$/.test(base)) {
	      baseUrls[' ' + base] = base + '/';
	    } else {
	      baseUrls[' ' + base] = base.replace(/[^/]*$/, '');
	    }
	  }
	  base = baseUrls[' ' + base];
	
	  if (href.slice(0, 2) === '//') {
	    return base.replace(/:[\s\S]*/, ':') + href;
	  } else if (href.charAt(0) === '/') {
	    return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
	  } else {
	    return base + href;
	  }
	}
	var baseUrls = {};
	var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
	
	function noop() {}
	noop.exec = noop;
	
	function merge(obj) {
	  var i = 1
	    , target
	    , key;
	
	  for (; i < arguments.length; i++) {
	    target = arguments[i];
	    for (key in target) {
	      if (Object.prototype.hasOwnProperty.call(target, key)) {
	        obj[key] = target[key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	
	/**
	 * Marked
	 */
	
	function marked(src, opt, callback) {
	  if (callback || typeof opt === 'function') {
	    if (!callback) {
	      callback = opt;
	      opt = null;
	    }
	
	    opt = merge({}, marked.defaults, opt || {});
	
	    var highlight = opt.highlight
	      , tokens
	      , pending
	      , i = 0;
	
	    try {
	      tokens = Lexer.lex(src, opt)
	    } catch (e) {
	      return callback(e);
	    }
	
	    pending = tokens.length;
	
	    var done = function(err) {
	      if (err) {
	        opt.highlight = highlight;
	        return callback(err);
	      }
	
	      var out;
	
	      try {
	        out = Parser.parse(tokens, opt);
	      } catch (e) {
	        err = e;
	      }
	
	      opt.highlight = highlight;
	
	      return err
	        ? callback(err)
	        : callback(null, out);
	    };
	
	    if (!highlight || highlight.length < 3) {
	      return done();
	    }
	
	    delete opt.highlight;
	
	    if (!pending) return done();
	
	    for (; i < tokens.length; i++) {
	      (function(token) {
	        if (token.type !== 'code') {
	          return --pending || done();
	        }
	        return highlight(token.text, token.lang, function(err, code) {
	          if (err) return done(err);
	          if (code == null || code === token.text) {
	            return --pending || done();
	          }
	          token.text = code;
	          token.escaped = true;
	          --pending || done();
	        });
	      })(tokens[i]);
	    }
	
	    return;
	  }
	  try {
	    if (opt) opt = merge({}, marked.defaults, opt);
	    return Parser.parse(Lexer.lex(src, opt), opt);
	  } catch (e) {
	    e.message += '\nPlease report this to https://github.com/chjj/marked.';
	    if ((opt || marked.defaults).silent) {
	      return '<p>An error occurred:</p><pre>'
	        + escape(e.message + '', true)
	        + '</pre>';
	    }
	    throw e;
	  }
	}
	
	/**
	 * Options
	 */
	
	marked.options =
	marked.setOptions = function(opt) {
	  merge(marked.defaults, opt);
	  return marked;
	};
	
	marked.defaults = {
	  gfm: true,
	  tables: true,
	  breaks: false,
	  pedantic: false,
	  sanitize: false,
	  sanitizer: null,
	  mangle: true,
	  smartLists: false,
	  silent: false,
	  highlight: null,
	  langPrefix: 'lang-',
	  smartypants: false,
	  headerPrefix: '',
	  renderer: new Renderer,
	  xhtml: false,
	  baseUrl: null
	};
	
	/**
	 * Expose
	 */
	
	marked.Parser = Parser;
	marked.parser = Parser.parse;
	
	marked.Renderer = Renderer;
	
	marked.Lexer = Lexer;
	marked.lexer = Lexer.lex;
	
	marked.InlineLexer = InlineLexer;
	marked.inlineLexer = InlineLexer.output;
	
	marked.parse = marked;
	
	if (true) {
	  module.exports = marked;
	} else if (typeof define === 'function' && define.amd) {
	  define(function() { return marked; });
	} else {
	  this.marked = marked;
	}
	
	}).call(function() {
	  return this || (typeof window !== 'undefined' ? window : global);
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 954 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  actions: ["pluginsConfigured"],
	
	  filters: ["hasCapability"],
	
	  initialize: function initialize(SDK) {
	    var _this = this;
	
	    this.actions.forEach(function (action) {
	      SDK.Hooks.addAction(action, _this[action].bind(_this));
	    });
	    this.filters.forEach(function (filter) {
	      SDK.Hooks.addFilter(filter, _this[filter].bind(_this));
	    });
	
	    this.SDK = SDK;
	  },
	  hasCapability: function hasCapability() {
	    // Users have access to everything by default
	    return true;
	  },
	  pluginsConfigured: function pluginsConfigured() {
	    // Filter the Application's configuration
	    this.SDK.Hooks.applyFilter("applicationConfiguration", this.SDK.config);
	  }
	};

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ConfigDev = __webpack_require__(956);
	
	var _ConfigDev2 = _interopRequireDefault(_ConfigDev);
	
	var _ConfigTest = __webpack_require__(957);
	
	var _ConfigTest2 = _interopRequireDefault(_ConfigTest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint no-redeclare: 0 */
	var Config = {
	  analyticsKey: "51ybGTeFEFU1xo6u10XMDrr6kATFyRyh",
	  acsAPIPrefix: "/acs/api/v1",
	  applicationRenderDelay: 1000,
	  networkingAPIPrefix: "/networking/api/v1",
	  cosmosAPIPrefix: "/package",
	  secretsAPIPrefix: "/secrets/v1",
	  delayAfterErrorCount: 5,
	  documentationURI: "https://dcos.io/docs",
	  marathonDocsURI: "https://mesosphere.github.io/marathon/docs/",
	  mesosDocsURI: "https://mesos.apache.org/documentation/latest/",
	  downloadsURI: "https://downloads.dcos.io",
	  environment: "production",
	  historyLength: 31,
	  historyServer: "",
	  fullProductName: "DC/OS",
	  marathonAPIPrefix: "/service/marathon/v2",
	  metronomeAPI: "/service/metronome",
	  productName: "DC/OS",
	  productHomepageURI: "https://dcos.io",
	  setInactiveAfter: 30000,
	  testHistoryInterval: 10000,
	  rootUrl: "",
	  slackChannel: "https://dcos-community.slack.com/messages/general/",
	  stateRefresh: 2000,
	  supportEmail: "help@dcos.io",
	  tailRefresh: 10000,
	  unitHealthAPIPrefix: "/system/health/v1",
	  logsAPIPrefix: "/system/v1/agent",
	  version: "1.1.14",
	  virtualNetworksApi: "/mesos/overlay-master"
	};
	
	Config.getRefreshRate = function () {
	  return this.stateRefresh;
	};
	
	// production gets replaced by Broccoli
	if (Config.environment === "development") {
	  Config.analyticsKey = ""; // Safeguard from developers logging to prod
	  Config = (0, _assign2.default)(Config, _ConfigDev2.default);
	} else if (Config.environment === "testing") {
	  Config.analyticsKey = ""; // Safeguard from developers logging to prod
	  Config = (0, _assign2.default)(Config, _ConfigTest2.default);
	} else if (Config.environment === "production") {
	  Config.useFixtures = false;
	}
	
	module.exports = Config;

/***/ },
/* 956 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {};

/***/ },
/* 957 */
/***/ function(module, exports) {

	"use strict";
	
	// put in your config overrides here
	var ConfigDev = {
	  applicationRenderDelay: 100,
	  rootUrl: "",
	  historyServer: "",
	  analyticsKey: "39uhSEOoRHMw6cMR6st9tYXDbAL3JSaP",
	  stateRefresh: 3000,
	  useFixtures: false,
	  useUIConfigFixtures: false
	};
	
	module.exports = ConfigDev;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addListener(store, hook, listener) {
	  var priority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
	
	  if (typeof priority !== "number") {
	    priority = 10;
	  }
	
	  if (store[hook] === undefined) {
	    store[hook] = {};
	  }
	
	  if (store[hook][priority] === undefined) {
	    store[hook][priority] = [];
	  }
	
	  store[hook][priority].push(listener);
	}
	
	function removeListener(store, hook, listener) {
	  if (store == null || (0, _typeof3.default)(store[hook]) !== "object") {
	    return;
	  }
	
	  // Find and remove listener in hook values
	  (0, _values2.default)(store[hook]).forEach(function (listeners) {
	    if (!Array.isArray(listeners)) {
	      return;
	    }
	
	    var index = listeners.indexOf(listener);
	    while (index > -1) {
	      listeners.splice(index, 1);
	      index = listeners.indexOf(listener, index);
	    }
	  });
	}
	/*
	 * Example usage:
	 *
	 * import Hooks from './Hooks';
	 * const hooks = new Hooks();
	 *
	 * // Register actions and filters;
	 * hooks.addAction('someAction', function actionHandler() {
	 *   // Do something on action fired
	 * });
	 * hooks.addFilter('someFilter', function filterHandler(value) {
	 *   // Change value on filter applied
	 *   return value.replace('some', 'someChanged');
	 * });
	 *
	 * // Call actions and filters
	 * hooks.doAction('someAction');
	 * hooks.applyFilter('someFilter', 'someValue');
	 */
	module.exports = function Hooks() {
	  return {
	    // Event store for actions
	    actions: {},
	
	    // Event store for filters
	    filters: {},
	
	    /**
	     * Attaches listener for filter
	     *
	     * @param  {String} hook The event id to listen for
	     * @param  {Function} listener Callback to fire when event executes
	     * @param  {Number} priority Priority for listener
	     */
	    addFilter: function addFilter(hook, listener, priority) {
	      addListener(this.filters, hook, listener, priority);
	    },
	
	
	    /**
	     * Removes listener for filter
	     *
	     * @param  {String} hook The event id to listen for
	     * @param  {Function} listener Callback to fire when event executes
	     */
	    removeFilter: function removeFilter(hook, listener) {
	      removeListener(this.filters, hook, listener);
	    },
	
	
	    /**
	     * Will apply all filters for a given hook
	     * If more arguments are passed to the function these arguments will
	     * be passed down to the listeners. But we only expect `value` to be
	     * modified.
	     *
	     * @param  {String} hook An event identifier
	     * @param  {Mixed} value The value that is being filtered
	     * @return {Mixed} The filtered value after all hooked functions are applied
	     */
	    applyFilter: function applyFilter(hook, value) {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      var listeners = this.filters[hook];
	
	      // If there's no listeners, then return early
	      if (listeners == null || listeners.length === 0) {
	        return value;
	      }
	
	      // Clone listeners, this will guarantee they all get called
	      listeners = (0, _assign2.default)({}, listeners);
	
	      // Sort the listeners by priority
	      var priorities = (0, _keys2.default)(listeners);
	      priorities.sort();
	
	      priorities.forEach(function (priority) {
	        // Clone and call all listeners
	        listeners[priority].slice(0).forEach(function (listener) {
	          // Creates new arguments array to call the listener with
	          var groupedArgs = args.slice();
	          groupedArgs.unshift(value);
	          value = listener.apply(null, groupedArgs);
	        });
	      });
	
	      return value;
	    },
	
	
	    /**
	     * Attaches listener for action
	     *
	     * @param  {String} hook The event id to listen for
	     * @param  {Function} listener Callback to fire when event executes
	     * @param  {Number} priority Priority for listener
	     */
	    addAction: function addAction(hook, listener, priority) {
	      addListener(this.actions, hook, listener, priority);
	    },
	
	
	    /**
	     * Removes listener for action
	     *
	     * @param  {String} hook The event id to listen for
	     * @param  {Function} listener Callback to fire when event executes
	     */
	    removeAction: function removeAction(hook, listener) {
	      removeListener(this.actions, hook, listener);
	    },
	
	
	    /**
	     * Will apply all filters for a given hook
	     * If more arguments are passed to the function these arguments will
	     * be passed down to the listeners. But we only expect `value` to be
	     * modified.
	     *
	     * @param  {String} hook An event identifier
	     */
	    doAction: function doAction(hook) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      var listeners = this.actions[hook];
	
	      // If there's no listeners, then return early
	      if (listeners == null || listeners.length === 0) {
	        return;
	      }
	
	      // Clone listeners, this will guarantee they all get called
	      listeners = (0, _assign2.default)({}, listeners);
	
	      // Sort the listeners by priority
	      var priorities = (0, _keys2.default)(listeners);
	      priorities.sort();
	
	      priorities.forEach(function (priority) {
	        // Clone and call all listeners
	        listeners[priority].slice(0).forEach(function (listener) {
	          listener.apply(null, args);
	        });
	      });
	    }
	  };
	};

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(960), __esModule: true };

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(961);
	module.exports = __webpack_require__(870).Object.values;

/***/ },
/* 961 */
[2105, 868, 962],
/* 962 */
[2106, 874, 903],
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Struct representing the PluginSDK
	 */
	var PluginSDK = function PluginSDK(item) {
	  (0, _classCallCheck3.default)(this, PluginSDK);
	
	  (0, _keys2.default)(item).forEach(function (key) {
	    this[key] = item[key];
	  }, this);
	};
	
	module.exports = PluginSDK;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var pluginsList = void 0;
	var externalPluginsList = void 0;
	
	// Try loading the list of plugins.
	try {
	  pluginsList = __webpack_require__(965);
	} catch (err) {
	  // No plugins
	  pluginsList = {};
	}
	
	// Try loading the list of plugins.
	try {
	  externalPluginsList = __webpack_require__(965);
	} catch (err) {
	  externalPluginsList = {};
	}
	
	// Return all available plugins
	function getAvailablePlugins() {
	  return {
	    pluginsList: pluginsList,
	    externalPluginsList: externalPluginsList
	  };
	}
	
	module.exports = {
	  getAvailablePlugins: getAvailablePlugins
	};

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(966);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(995);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(1021);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  banner: _index2.default,
	  tracking: _index4.default,
	  oauth: _index6.default
	};

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _SDK = __webpack_require__(967);
	
	var _SDK2 = _interopRequireDefault(_SDK);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (PluginSDK) {
	  _SDK2.default.setSDK(PluginSDK);
	
	  var PluginHooks = __webpack_require__(968);
	  // Set plugin's hooks
	  PluginHooks.initialize();
	};

/***/ },
/* 967 */
/***/ function(module, exports) {

	"use strict";
	
	var SDK = void 0;
	
	module.exports = {
	  getSDK: function getSDK() {
	    return SDK;
	  },
	  setSDK: function setSDK(pluginSDK) {
	    SDK = pluginSDK;
	  }
	};

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var SDK = __webpack_require__(967).getSDK(); /* eslint-disable no-unused-vars */
	
	
	module.exports = {
	  configuration: {
	    backgroundColor: "#1E232F",
	    foregroundColor: "#FFFFFF",
	    headerTitle: null,
	    headerContent: null,
	    footerContent: null,
	    imagePath: null,
	    dismissible: null
	  },
	
	  initialize: function initialize() {
	    SDK.Hooks.addAction("applicationRendered", this.applicationRendered.bind(this));
	    SDK.Hooks.addFilter("applicationContents", this.applicationContents.bind(this));
	    SDK.Hooks.addFilter("overlayNewWindowButton", this.overlayNewWindowButton.bind(this));
	    this.configure(SDK.config);
	  },
	  configure: function configure(configuration) {
	    var _this = this;
	
	    // Only merge keys that have a non-null value
	    (0, _keys2.default)(configuration).forEach(function (key) {
	      if (configuration[key] != null) {
	        _this.configuration[key] = configuration[key];
	      }
	    });
	  },
	  isEnabled: function isEnabled() {
	    var configuration = this.configuration;
	
	    return configuration.headerTitle != null || configuration.headerContent != null || configuration.footerContent != null;
	  },
	  toggleFullContent: function toggleFullContent() {
	    var banner = global.document.querySelector(".banner-plugin-wrapper");
	    banner.classList.toggle("display-full");
	  },
	  applicationRendered: function applicationRendered() {
	    if (this.isEnabled() === false || !_DOMUtils2.default.isTopFrame()) {
	      return;
	    }
	
	    var frame = global.document.getElementById("banner-plugin-iframe");
	
	    if (frame == null) {
	      return;
	    }
	
	    if (this.historyListenerAdded) {
	      return;
	    }
	
	    this.historyListenerAdded = true;
	
	    var frameWindow = frame.contentWindow;
	    var topWindow = global;
	
	    frameWindow.addEventListener("hashchange", function () {
	      topWindow.location.hash = frameWindow.location.hash;
	    });
	  },
	  applicationContents: function applicationContents() {
	    if (this.isEnabled() === false || !_DOMUtils2.default.isTopFrame()) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "banner-plugin-wrapper" },
	      this.getHeader(),
	      _react2.default.createElement("iframe", {
	        frameBorder: "0",
	        id: "banner-plugin-iframe",
	        src: "./index.html" + global.location.hash
	      }),
	      this.getFooter()
	    );
	  },
	  overlayNewWindowButton: function overlayNewWindowButton(button) {
	    if (this.isEnabled()) {
	      return null;
	    }
	
	    return button;
	  },
	  getColorStyles: function getColorStyles() {
	    return {
	      color: this.configuration.foregroundColor,
	      backgroundColor: this.configuration.backgroundColor
	    };
	  },
	  getIcon: function getIcon() {
	    var imagePath = this.configuration.imagePath;
	
	    if (imagePath == null || imagePath === "") {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "span",
	      { className: " icon icon-small icon-image-container icon-app-container" },
	      _react2.default.createElement("img", { src: imagePath })
	    );
	  },
	  getTitle: function getTitle() {
	    var title = this.configuration.headerTitle;
	
	    if (title == null || title === "") {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "h5",
	      {
	        className: "title flush-top flush-bottom",
	        style: { color: this.configuration.foregroundColor }
	      },
	      title
	    );
	  },
	  getHeaderContent: function getHeaderContent() {
	    var content = this.configuration.headerContent;
	
	    if (content == null || content === "") {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "span",
	      { className: "content hidden-small-down", title: content },
	      content
	    );
	  },
	  getHeader: function getHeader() {
	    var icon = this.getIcon();
	    var title = this.getTitle();
	    var content = this.getHeaderContent();
	
	    if (icon == null && title == null && content == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "header",
	      { className: "flex-container", style: this.getColorStyles() },
	      _react2.default.createElement(
	        "span",
	        { className: "flex-container" },
	        _react2.default.createElement(
	          "span",
	          null,
	          icon,
	          title
	        ),
	        _react2.default.createElement(
	          "span",
	          {
	            className: "banner-plugin-info-icon clickable hidden-medium-up",
	            onClick: this.toggleFullContent
	          },
	          _react2.default.createElement(_Icon2.default, {
	            fill: this.configuration.foregroundColor,
	            id: "circle-information",
	            size: "mini"
	          })
	        )
	      ),
	      content
	    );
	  },
	  getFooter: function getFooter() {
	    var content = this.configuration.footerContent;
	
	    if (content == null || content === "") {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "footer",
	      { style: this.getColorStyles() },
	      _react2.default.createElement(
	        "span",
	        { className: "content", title: content },
	        content
	      )
	    );
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function (_React$Component) {
	  (0, _inherits3.default)(Icon, _React$Component);
	
	  function Icon() {
	    (0, _classCallCheck3.default)(this, Icon);
	    return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, _getPrototypeOf2.default)(Icon)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Icon, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var props = this.props;
	
	
	      var additionalProps = _Util2.default.omit(props, ["className", "color", "family", "id", "size"]);
	      var classes = (0, _classnames2.default)("icon", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "icon-" + props.color, !!props.color), (0, _defineProperty3.default)(_classNames, "icon-" + props.size, !!props.size), _classNames), props.className);
	      var iconID = "#icon-" + props.family + "--" + props.id;
	
	      return _react2.default.createElement(
	        "svg",
	        (0, _extends3.default)({ className: classes }, additionalProps),
	        _react2.default.createElement("use", { xlinkHref: iconID })
	      );
	    }
	  }]);
	  return Icon;
	}(_react2.default.Component);
	
	Icon.defaultProps = {
	  family: "system",
	  size: "medium"
	};
	
	Icon.propTypes = {
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  color: _react2.default.PropTypes.string,
	  family: _react2.default.PropTypes.oneOf(["product", "system", "tiny"]),
	  id: _react2.default.PropTypes.string.isRequired,
	  size: _react2.default.PropTypes.oneOf(["tiny", "mini", "small", "medium", "large", "jumbo"])
	};
	
	module.exports = Icon;

/***/ },
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uniqueIDMap = {};
	
	var Util = {
	  /**
	   * Give a unique ID for this session.
	   * @param {string} id              Namespace for the unique ids.
	   * @return {Integer}               A unique id.
	   */
	  uniqueID: function uniqueID(id) {
	    if (!Object.prototype.hasOwnProperty.call(uniqueIDMap, id)) {
	      uniqueIDMap[id] = 0;
	    }
	
	    return uniqueIDMap[id]++;
	  },
	
	
	  /**
	   * Copies an object, omitting blacklisted keys.
	   * @param  {Object} object        Object to copy
	   * @param  {Array} blacklistKeys  Keys to not copy over
	   * @return {Object}               Copy of object without blacklisted keys
	   */
	  omit: function omit(object, blacklistKeys) {
	    return (0, _keys2.default)(object).reduce(function (newObject, key) {
	      if (blacklistKeys.indexOf(key) === -1) {
	        newObject[key] = object[key];
	      }
	
	      return newObject;
	    }, {});
	  },
	
	
	  /**
	   * Returns the last element
	   * @param  {Array} array        Array to act on
	   * @return {Anything}           Value in last position of Array
	   */
	  last: function last(array) {
	    if (array.length === 0) {
	      return null;
	    }
	
	    return array[array.length - 1];
	  },
	
	
	  /**
	   * Finds last index where condition returns true
	   * @param  {Array} array         Array to search
	   * @param  {Function} condition  Condition to find
	   * @return {Int}                 Index of last item or -1 if not found
	   */
	  findLastIndex: function findLastIndex(array, condition) {
	    var length = array.length;
	    var index = length - 1;
	    for (; index >= 0; index--) {
	      if (condition(array[index], index, array)) {
	        return index;
	      }
	    }
	
	    return -1;
	  },
	  getLocaleCompareSortFn: function getLocaleCompareSortFn(prop) {
	    return function (a, b) {
	      return a[prop].localeCompare(b[prop]);
	    };
	  },
	
	
	  /**
	   * Finds the property in a given object using a string of properties
	   * using dot-notation, e.g. 'hello.is.it.me.you.are.looking.for'
	   * @param  {Object} obj          Object to search in
	   * @param  {String} propertyPath Property path to search for
	   * @return {*}                   The value of the found property or null
	   */
	  findNestedPropertyInObject: function findNestedPropertyInObject(obj, propertyPath) {
	    if (propertyPath == null || obj == null) {
	      return null;
	    }
	
	    return propertyPath.split(".").reduce(function (current, nextProp) {
	      if (current == null) {
	        return current;
	      }
	
	      return current[nextProp];
	    }, obj);
	  },
	
	
	  /**
	   * Will wait until a certain amount of time has elapsed
	   * before calling the given function.
	   *
	   * @param  {Function} func A callback function to be called
	   * @param  {Number} wait How long to wait before callback is called
	   * @return {Function} A function
	   */
	  debounce: function debounce(func, wait) {
	    var timeoutID = null;
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (timeoutID) {
	        global.clearTimeout(timeoutID);
	      }
	
	      timeoutID = global.setTimeout(function () {
	        func.apply(null, args);
	      }, wait);
	    };
	  },
	
	
	  /**
	   * Check if item is an object.
	   *
	   * @param  {Object} obj Item to check if is an object.
	   * @return {Boolean} Whether the argument is an object.
	   */
	  isObject: function isObject(obj) {
	    return obj && obj.toString && obj.toString() === "[object Object]";
	  },
	
	
	  /**
	   * Deep copy an object.
	   *
	   * @param  {Object} obj Object to deep copy.
	   * @return {Object} Copy of obj.
	   */
	  deepCopy: function deepCopy(obj) {
	    var copy = void 0;
	    if (Array.isArray(obj)) {
	      copy = obj.slice(); // shallow copy
	    } else if (Util.isObject(obj)) {
	      copy = (0, _assign2.default)({}, obj);
	    }
	
	    if (copy != null) {
	      (0, _keys2.default)(copy).forEach(function (key) {
	        copy[key] = Util.deepCopy(copy[key]);
	      });
	    } else {
	      copy = obj;
	    }
	
	    return copy;
	  },
	
	
	  /**
	   * Removes keys with empty values from an Object
	   *
	   * @param {Object} obj Object to filter
	   * @return {Object} Copy of a filtered obj
	   */
	  filterEmptyValues: function filterEmptyValues(obj) {
	    return (0, _keys2.default)(obj).filter(function (key) {
	      return !_ValidatorUtil2.default.isEmpty(obj[key]);
	    }).reduce(function (memo, key) {
	      memo[key] = obj[key];
	
	      return memo;
	    }, {});
	  },
	  objectToGetParams: function objectToGetParams(obj) {
	    var queryString = (0, _keys2.default)(obj).filter(function (param) {
	      return obj[param] != null;
	    }).map(function (param) {
	      return encodeURIComponent(param) + "=" + encodeURIComponent(obj[param]);
	    }).join("&");
	
	    return queryString ? "?" + queryString : "";
	  },
	
	
	  /**
	   * Transform param to lower case
	   * if param is string otherwise
	   * return unchanged param
	   *
	   * @param {String} item
	   * @returns {String} item param lowercased
	   */
	  toLowerCaseIfString: function toLowerCaseIfString(item) {
	    if (typeof item === "string") {
	      return item.toLowerCase();
	    }
	
	    return item;
	  },
	
	
	  /**
	   * Transform param to upper case
	   * if param is string otherwise
	   * return unchanged param
	   *
	   * @param {String} item
	   * @returns {String} item param lowercased
	   */
	  toUpperCaseIfString: function toUpperCaseIfString(item) {
	    if (typeof item === "string") {
	      return item.toUpperCase();
	    }
	
	    return item;
	  },
	  isString: function isString(str) {
	    return typeof str === "string";
	  },
	
	
	  /**
	   * Parse url string
	   * and returns its object representation
	   *
	   * @param {String} url
	   * @returns {Object} url representation
	   */
	  parseUrl: function parseUrl(url) {
	    if (!Util.isString(url)) {
	      return null;
	    }
	
	    // Add http/s otherwise browser/engine think it's relative path
	    if (!/http|https/.test(url)) {
	      url = "https://" + url;
	    }
	
	    // TODO: replace below with browser native API <new URL()>
	    // when all browsers support are available
	    var aElement = document.createElement("a");
	    aElement.href = url;
	
	    return {
	      hash: aElement.hash,
	      host: aElement.host,
	      hostname: aElement.hostname,
	      href: aElement.href,
	      origin: aElement.origin,
	      password: aElement.password,
	      pathname: aElement.pathname,
	      port: aElement.port,
	      protocol: aElement.protocol,
	      search: aElement.search,
	      username: aElement.username
	    };
	  }
	};
	
	module.exports = Util;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _isFinite = __webpack_require__(984);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _isNan = __webpack_require__(987);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _isInteger = __webpack_require__(990);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValidatorUtil = {
	  isDefined: function isDefined(value) {
	    return value != null && value !== "" || typeof value === "number";
	  },
	  isEmail: function isEmail(email) {
	    return email != null && email.length > 0 && !/\s/.test(email) && /.+@.+\..+/.test(email);
	  },
	  isEmpty: function isEmpty(data) {
	    if (typeof data === "number" || typeof data === "boolean") {
	      return false;
	    }
	
	    if (typeof data === "undefined" || data === null) {
	      return true;
	    }
	
	    if (typeof data.length !== "undefined") {
	      return data.length === 0;
	    }
	
	    return (0, _keys2.default)(data).reduce(function (memo, key) {
	      if (Object.prototype.hasOwnProperty.call(data, key)) {
	        memo++;
	      }
	
	      return memo;
	    }, 0) === 0;
	  },
	  isInteger: function isInteger(value) {
	    return ValidatorUtil.isNumber(value) && (0, _isInteger2.default)(parseFloat(value));
	  },
	  isNumber: function isNumber(value) {
	    var number = parseFloat(value);
	
	    return (/^[0-9e+-.,]+$/.test(value) && !(0, _isNan2.default)(number) && (0, _isFinite2.default)(number)
	    );
	  },
	  isNumberInRange: function isNumberInRange(value) {
	    var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _range$min = range.min,
	        min = _range$min === undefined ? 0 : _range$min,
	        _range$max = range.max,
	        max = _range$max === undefined ? Number.POSITIVE_INFINITY : _range$max;
	
	    var number = parseFloat(value);
	
	    return ValidatorUtil.isNumber(value) && number >= min && number <= max;
	  },
	  isStringInteger: function isStringInteger(value) {
	    return typeof value === "string" && /^([0-9]+)$/.test(value);
	  }
	};
	
	module.exports = ValidatorUtil;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(985), __esModule: true };

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(986);
	module.exports = __webpack_require__(870).Number.isFinite;

/***/ },
/* 986 */
[2080, 868, 869],
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(988), __esModule: true };

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(989);
	module.exports = __webpack_require__(870).Number.isNaN;

/***/ },
/* 989 */
[2083, 868],
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(991), __esModule: true };

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(992);
	module.exports = __webpack_require__(870).Number.isInteger;

/***/ },
/* 992 */
[2081, 868, 993],
/* 993 */
[2082, 906],
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _isNan = __webpack_require__(987);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEIGHT_ATTRIBUTES = ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"];
	var WIDTH_ATTRIBUTES = ["paddingLeft", "paddingRight", "borderLeftWidth", "borderRightWidth"];
	
	var matchesFn = function () {
	  var el = global.document.querySelector("body");
	  var names = ["matches", "matchesSelector", "msMatchesSelector", "oMatchesSelector", "mozMatchesSelector", "webkitMatchesSelector"];
	
	  for (var i = 0; i < names.length; i++) {
	    if (el[names[i]]) {
	      return names[i];
	    }
	  }
	
	  return names[0];
	}();
	
	var DOMUtils = {
	  appendScript: function appendScript(el, code) {
	    var scriptNode = global.document.createElement("script");
	    scriptNode.type = "text/javascript";
	
	    try {
	      scriptNode.appendChild(global.document.createTextNode(code));
	    } catch (e) {
	      scriptNode.text = code;
	    }
	
	    el.appendChild(scriptNode);
	  },
	  closest: function closest(el, selector) {
	    var currentEl = el;
	
	    while (currentEl && currentEl.parentElement !== null) {
	      if (currentEl[matchesFn] && currentEl[matchesFn](selector)) {
	        return currentEl;
	      }
	
	      currentEl = currentEl.parentElement;
	    }
	
	    return null;
	  },
	  getComputedHeight: function getComputedHeight(obj) {
	    return DOMUtils.getComputedDimensions(obj).height;
	  },
	  getComputedWidth: function getComputedWidth(obj) {
	    return DOMUtils.getComputedDimensions(obj).width;
	  },
	  getComputedDimensions: function getComputedDimensions(obj) {
	    var compstyle;
	    if (typeof global.getComputedStyle === "undefined") {
	      compstyle = obj.currentStyle;
	    } else {
	      compstyle = global.getComputedStyle(obj);
	    }
	
	    var computeInnerBound = function computeInnerBound(acc, key) {
	      var val = parseInt(compstyle[key], 10);
	      if ((0, _isNan2.default)(val)) {
	        return acc;
	      } else {
	        return acc - val;
	      }
	    };
	
	    var width = WIDTH_ATTRIBUTES.reduce(computeInnerBound, obj.offsetWidth);
	
	    var height = HEIGHT_ATTRIBUTES.reduce(computeInnerBound, obj.offsetHeight);
	
	    return {
	      width: width,
	      height: height
	    };
	  },
	  getPageHeight: function getPageHeight() {
	    var body = global.document.body;
	    var html = global.document.documentElement;
	
	    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	  },
	  getDistanceFromTop: function getDistanceFromTop(element) {
	    return element.pageYOffset || element.scrollTop || 0;
	  },
	  isTopFrame: function isTopFrame() {
	    try {
	      return global.self === global.top;
	    } catch (e) {
	      return true;
	    }
	  },
	
	
	  // This will ease in and ease out of the transition.
	  // Code was modified from this answer:
	  // http://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
	  scrollTo: function scrollTo(container, scrollDuration, targetY, callback) {
	    var scrollHeight = container.scrollHeight;
	    var scrollStep = Math.PI / (scrollDuration / 15);
	    var cosParameter = scrollHeight / 2;
	    var scrollCount = 0;
	    var scrollMargin = void 0;
	
	    requestAnimationFrame(step);
	    var endTime = Date.now() + scrollDuration;
	
	    function step() {
	      setTimeout(function () {
	        var distanceFromTop = DOMUtils.getDistanceFromTop(container);
	        if (distanceFromTop !== targetY && endTime >= Date.now()) {
	          requestAnimationFrame(step);
	          scrollCount = scrollCount + 1;
	          scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
	          container.scrollTop = distanceFromTop + scrollMargin;
	        } else if (typeof callback === "function") {
	          callback();
	        }
	      }, 15);
	    }
	  },
	  whichTransitionEvent: function whichTransitionEvent(el) {
	    var transitions = {
	      transition: "transitionend",
	      OTransition: "oTransitionEnd",
	      MozTransition: "transitionend",
	      WebkitTransition: "webkitTransitionEnd"
	    };
	
	    for (var t in transitions) {
	      if (el.style[t] !== undefined) {
	        return transitions[t];
	      }
	    }
	  },
	  getDistanceFromTopOfParent: function getDistanceFromTopOfParent(el) {
	    var elTop = el.getBoundingClientRect().top;
	
	    var parentNode = el.parentNode;
	    if (!parentNode) {
	      return 0;
	    }
	
	    var parentTop = parentNode.getBoundingClientRect().top;
	
	    return elTop - parentTop;
	  },
	  getInputElement: function getInputElement(node) {
	    if (!node || !(node instanceof HTMLElement)) {
	      return null;
	    }
	    var inputTypes = ["input", "textarea"];
	    if (inputTypes.includes(node.nodeName.toLowerCase())) {
	      return node;
	    } else {
	      node = node.querySelector(inputTypes.join(", "));
	    }
	
	    return node;
	  }
	};
	
	module.exports = DOMUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _SDK = __webpack_require__(996);
	
	var _SDK2 = _interopRequireDefault(_SDK);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (PluginSDK) {
	  _SDK2.default.setSDK(PluginSDK);
	
	  var PluginHooks = __webpack_require__(997);
	  var TrackingActions = __webpack_require__(1011);
	  // Set plugin's hooks
	  PluginHooks.initialize(PluginSDK.config);
	
	  // Register Actions
	  PluginSDK.registerActions(TrackingActions);
	};

/***/ },
/* 996 */
967,
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _promise = __webpack_require__(880);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	var _PluginConstants = __webpack_require__(1010);
	
	var _Actions = __webpack_require__(1011);
	
	var _Actions2 = _interopRequireDefault(_Actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var SDK = __webpack_require__(996).getSDK();
	/* eslint-enable no-unused-vars */
	
	
	var segmentScript = "!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error('Segment snippet included twice.');else{analytics.invoked=!0;analytics.methods=['trackSubmit','trackClick','trackLink','trackForm','pageview','identify','group','track','ready','alias','page','once','off','on'];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement('script');e.type=\"text/javascript\";e.async=!0;e.src=('https:'===document.location.protocol?'https://':'http://')+'cdn.segment.com/analytics.js/v1/'+t+'/analytics.min.js';var n=document.getElementsByTagName('script')[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION=\"3.0.1\";analytics.load(\"" + _Config2.default.analyticsKey + "\");}}();";
	
	module.exports = {
	  filters: ["pluginsLoadedCheck", "userFormModalFooter", "userLoginPolicy", "userAddPolicy"],
	
	  actions: ["userLoginSuccess", "userLogoutSuccess", "routes"],
	
	  initialize: function initialize(configuration) {
	    var _this = this;
	
	    this.configuration = configuration;
	
	    this.filters.forEach(function (filter) {
	      SDK.Hooks.addFilter(filter, _this[filter].bind(_this));
	    });
	    this.actions.forEach(function (action) {
	      SDK.Hooks.addAction(action, _this[action].bind(_this));
	    });
	
	    _Actions2.default.initialize();
	
	    if (_AuthStore2.default.getUser()) {
	      _Actions2.default.identify(_AuthStore2.default.getUser().uid);
	    }
	
	    _DOMUtils2.default.appendScript(global.document.head, segmentScript);
	  },
	  pluginsLoadedCheck: function pluginsLoadedCheck(promiseArray) {
	    var promise = new _promise2.default(function (resolve) {
	      global.analytics.ready(function () {
	        resolve();
	      });
	
	      // Let's not block the application loading in case it takes a really
	      // long time to ready-up analytics or the integrations.
	      global.setTimeout(resolve, _PluginConstants.ANALYTICS_LOAD_TIMEOUT);
	    });
	
	    promiseArray.push(promise);
	
	    return promiseArray;
	  },
	  userLoginSuccess: function userLoginSuccess() {
	    _Actions2.default.identify(_AuthStore2.default.getUser().uid);
	  },
	  routes: function routes(_routes) {
	    _Actions2.default.setRoutes(_routes);
	  },
	  userLogoutSuccess: function userLogoutSuccess() {
	    _Actions2.default.log("dcos_logout");
	  },
	  userFormModalFooter: function userFormModalFooter() {
	    return null;
	  },
	  userLoginPolicy: function userLoginPolicy() {
	    return _react2.default.createElement(
	      "p",
	      null,
	      "By logging in to DC/OS you understand we will process personal information in accordance with our",
	      " ",
	      _react2.default.createElement(
	        "a",
	        { href: "https://mesosphere.com/privacy/", target: "_blank" },
	        "Privacy Policy"
	      ),
	      "."
	    );
	  },
	  userAddPolicy: function userAddPolicy() {
	    return _react2.default.createElement(
	      "p",
	      { className: "form-control-feedback" },
	      "By adding a user you understand we will process personal information in accordance with our",
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "reset-color",
	          href: "https://mesosphere.com/privacy/",
	          target: "_blank"
	        },
	        "Privacy Policy"
	      ),
	      "."
	    );
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _EventTypes = __webpack_require__(933);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _AuthActions = __webpack_require__(1003);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CookieUtils = __webpack_require__(1004);
	
	var _CookieUtils2 = _interopRequireDefault(_CookieUtils);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(AuthStore, _GetSetBaseStore);
	
	  function AuthStore() {
	    (0, _classCallCheck3.default)(this, AuthStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthStore.__proto__ || (0, _getPrototypeOf2.default)(AuthStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.AUTH_USER_LOGIN_CHANGED,
	        error: _EventTypes.AUTH_USER_LOGIN_ERROR,
	        logoutSuccess: _EventTypes.AUTH_USER_LOGOUT_SUCCESS,
	        logoutError: _EventTypes.AUTH_USER_LOGOUT_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        case _ActionTypes.REQUEST_LOGIN_SUCCESS:
	          _this.processLoginSuccess();
	          break;
	        case _ActionTypes.REQUEST_LOGIN_ERROR:
	          _this.emit(_EventTypes.AUTH_USER_LOGIN_ERROR, action.data, action.xhr);
	          break;
	        case _ActionTypes.REQUEST_LOGOUT_SUCCESS:
	          _this.processLogoutSuccess();
	          break;
	        case _ActionTypes.REQUEST_LOGOUT_ERROR:
	          _this.emit(_EventTypes.AUTH_USER_LOGOUT_ERROR, action.data);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AuthStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "login",
	    value: function login() {
	      _AuthActions2.default.login.apply(_AuthActions2.default, arguments);
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      _AuthActions2.default.logout.apply(_AuthActions2.default, arguments);
	    }
	  }, {
	    key: "isLoggedIn",
	    value: function isLoggedIn() {
	      return !!_CookieUtils2.default.getUserMetadata();
	    }
	  }, {
	    key: "getUser",
	    value: function getUser() {
	      var userCode = _CookieUtils2.default.getUserMetadata();
	
	      if (userCode == null) {
	        return null;
	      }
	
	      try {
	        return JSON.parse(atob(userCode));
	      } catch (err) {
	        return null;
	      }
	    }
	  }, {
	    key: "processLoginSuccess",
	    value: function processLoginSuccess() {
	      _PluginSDK.Hooks.doAction("userLoginSuccess");
	      this.emit(_EventTypes.AUTH_USER_LOGIN_CHANGED);
	    }
	  }, {
	    key: "processLogoutSuccess",
	    value: function processLogoutSuccess() {
	      global.document.cookie = _CookieUtils2.default.emptyCookieWithExpiry(new Date(1970));
	
	      this.emit(_EventTypes.AUTH_USER_LOGOUT_SUCCESS);
	
	      _PluginSDK.Hooks.doAction("userLogoutSuccess");
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "auth";
	    }
	  }]);
	  return AuthStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new AuthStore();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 999 */
/***/ function(module, exports) {

	"use strict";
	
	var ActionTypes = {};
	["REQUEST_CLI_INSTRUCTIONS", "REQUEST_CLUSTER_CCID_ERROR", "REQUEST_CLUSTER_CCID_SUCCESS", "REQUEST_CONFIG_ERROR", "REQUEST_CONFIG_SUCCESS", "REQUEST_COSMOS_PACKAGE_DESCRIBE_ERROR", "REQUEST_COSMOS_PACKAGE_DESCRIBE_SUCCESS", "REQUEST_COSMOS_PACKAGE_INSTALL_ERROR", "REQUEST_COSMOS_PACKAGE_INSTALL_SUCCESS", "REQUEST_COSMOS_PACKAGE_UNINSTALL_ERROR", "REQUEST_COSMOS_PACKAGE_UNINSTALL_SUCCESS", "REQUEST_COSMOS_PACKAGE_LIST_VERSIONS_SUCCESS", "REQUEST_COSMOS_PACKAGE_LIST_VERSIONS_ERROR", "REQUEST_COSMOS_PACKAGES_LIST_ERROR", "REQUEST_COSMOS_PACKAGES_LIST_SUCCESS", "REQUEST_COSMOS_PACKAGES_SEARCH_ERROR", "REQUEST_COSMOS_PACKAGES_SEARCH_SUCCESS", "REQUEST_COSMOS_REPOSITORIES_LIST_ERROR", "REQUEST_COSMOS_REPOSITORIES_LIST_SUCCESS", "REQUEST_COSMOS_REPOSITORY_ADD_ERROR", "REQUEST_COSMOS_REPOSITORY_ADD_SUCCESS", "REQUEST_COSMOS_REPOSITORY_DELETE_ERROR", "REQUEST_COSMOS_REPOSITORY_DELETE_SUCCESS", "REQUEST_DCOS_METADATA", "REQUEST_HEALTH_NODE_ERROR", "REQUEST_HEALTH_NODE_SUCCESS", "REQUEST_HEALTH_NODE_UNIT_ERROR", "REQUEST_HEALTH_NODE_UNIT_SUCCESS", "REQUEST_HEALTH_NODE_UNITS_ERROR", "REQUEST_HEALTH_NODE_UNITS_SUCCESS", "REQUEST_HEALTH_NODES_ERROR", "REQUEST_HEALTH_NODES_SUCCESS", "REQUEST_HEALTH_UNIT_ERROR", "REQUEST_HEALTH_UNIT_NODE_ERROR", "REQUEST_HEALTH_UNIT_NODE_SUCCESS", "REQUEST_HEALTH_UNIT_NODES_ERROR", "REQUEST_HEALTH_UNIT_NODES_SUCCESS", "REQUEST_HEALTH_UNIT_SUCCESS", "REQUEST_HEALTH_UNITS_ERROR", "REQUEST_HEALTH_UNITS_SUCCESS", "REQUEST_LOGIN_ERROR", "REQUEST_LOGIN_SUCCESS", "REQUEST_LOGOUT_ERROR", "REQUEST_LOGOUT_SUCCESS", "REQUEST_MESOS_STATE_ERROR", "REQUEST_MESOS_STATE_ONGOING", "REQUEST_MESOS_STATE_SUCCESS", "REQUEST_METADATA", "REQUEST_METRONOME_JOB_CREATE_ERROR", "REQUEST_METRONOME_JOB_CREATE_SUCCESS", "REQUEST_METRONOME_JOB_DELETE_ERROR", "REQUEST_METRONOME_JOB_DELETE_SUCCESS", "REQUEST_METRONOME_JOB_DETAIL_ERROR", "REQUEST_METRONOME_JOB_DETAIL_ONGOING", "REQUEST_METRONOME_JOB_DETAIL_SUCCESS", "REQUEST_METRONOME_JOB_RUN_ERROR", "REQUEST_METRONOME_JOB_RUN_SUCCESS", "REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_ERROR", "REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS", "REQUEST_METRONOME_JOB_STOP_RUN_ERROR", "REQUEST_METRONOME_JOB_STOP_RUN_SUCCESS", "REQUEST_METRONOME_JOB_UPDATE_ERROR", "REQUEST_METRONOME_JOB_UPDATE_SUCCESS", "REQUEST_METRONOME_JOBS_ERROR", "REQUEST_METRONOME_JOBS_ONGOING", "REQUEST_METRONOME_JOBS_SUCCESS", "REQUEST_PREVIOUS_SYSTEM_LOG_ERROR", "REQUEST_PREVIOUS_SYSTEM_LOG_SUCCESS", "REQUEST_SIDEBAR_CLOSE", "REQUEST_SIDEBAR_OPEN", "REQUEST_SIDEBAR_DOCK", "REQUEST_SIDEBAR_UNDOCK", "REQUEST_SIDEBAR_WIDTH_CHANGE", "REQUEST_SUMMARY_ERROR", "REQUEST_SUMMARY_HISTORY_ONGOING", "REQUEST_SUMMARY_HISTORY_SUCCESS", "REQUEST_SUMMARY_ONGOING", "REQUEST_SUMMARY_SUCCESS", "REQUEST_SYSTEM_LOG_ERROR", "REQUEST_SYSTEM_LOG_SUCCESS", "REQUEST_SYSTEM_LOG_STREAM_TYPES_ERROR", "REQUEST_SYSTEM_LOG_STREAM_TYPES_SUCCESS", "REQUEST_USER_CREATE_ERROR", "REQUEST_USER_CREATE_SUCCESS", "REQUEST_USER_DELETE_ERROR", "REQUEST_USER_DELETE_SUCCESS", "REQUEST_USERS_ERROR", "REQUEST_USERS_SUCCESS", "REQUEST_DCOS_BUILD_INFO_ERROR", "REQUEST_DCOS_BUILD_INFO_SUCCESS", "REQUEST_VIRTUAL_NETWORKS_ERROR", "REQUEST_VIRTUAL_NETWORKS_SUCCESS", "SERVER_ACTION", "SIDEBAR_ACTION"].forEach(function (actionType) {
	  ActionTypes[actionType] = actionType;
	});
	
	module.exports = ActionTypes;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _flux = __webpack_require__(1001);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppDispatcher = (0, _assign2.default)(new _flux.Dispatcher(), {
	  handleServerAction: function handleServerAction(action) {
	    if (!action.type) {
	      console.warn("Empty action.type: you likely mistyped the action.");
	    }
	
	    this.dispatch({
	      source: _ActionTypes2.default.SERVER_ACTION,
	      action: action
	    });
	  },
	  handleSidebarAction: function handleSidebarAction(action) {
	    if (!action.type) {
	      console.warn("Empty action.type: you likely mistyped the action.");
	    }
	
	    this.dispatch({
	      source: _ActionTypes2.default.SIDEBAR_ACTION,
	      action: action
	    });
	  }
	});
	
	module.exports = AppDispatcher;

/***/ },
/* 1001 */,
/* 1002 */,
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthActions = {
	  login: function login(credentials, target) {
	    var query = "";
	    if (target) {
	      query = "?target=" + encodeURIComponent(target);
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.acsAPIPrefix + "/auth/login" + query,
	      method: "POST",
	      data: credentials,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_LOGIN_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_LOGIN_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  logout: function logout() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.acsAPIPrefix + "/auth/logout",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_LOGOUT_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_LOGOUT_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  AuthActions.login = function () {
	    // base64 encoded - {is_remote: false, uid: "bootstrapuser", description: "Bootstrap superuser"}
	    global.document.cookie = "dcos-acs-info-cookie=" + "eyJ1aWQiOiJqb2UiLCJkZXNjcmlwdGlvbiI6IkpvZSBEb2UifQ==";
	    _AppDispatcher2.default.handleServerAction({
	      type: _ActionTypes.REQUEST_LOGIN_SUCCESS
	    });
	  };
	}
	
	module.exports = AuthActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _cookie = __webpack_require__(1005);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _AuthConstants = __webpack_require__(1006);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Utils = {
	  getUserMetadata: function getUserMetadata() {
	    return _cookie2.default.parse(global.document.cookie)[_AuthConstants.userCookieKey];
	  },
	  emptyCookieWithExpiry: function emptyCookieWithExpiry(date) {
	    return _cookie2.default.serialize(_AuthConstants.userCookieKey, "", { expires: date });
	  }
	};
	
	module.exports = Utils;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1005 */,
/* 1006 */
/***/ function(module, exports) {

	"use strict";
	
	var AuthConstants = {
	  userCookieKey: "dcos-acs-info-cookie"
	};
	
	module.exports = AuthConstants;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BaseStore2 = __webpack_require__(1008);
	
	var _BaseStore3 = _interopRequireDefault(_BaseStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: DCOS-6404, remove getters and setters from stores
	var GetSetBaseStore = function (_BaseStore) {
	  (0, _inherits3.default)(GetSetBaseStore, _BaseStore);
	
	  function GetSetBaseStore() {
	    (0, _classCallCheck3.default)(this, GetSetBaseStore);
	    return (0, _possibleConstructorReturn3.default)(this, (GetSetBaseStore.__proto__ || (0, _getPrototypeOf2.default)(GetSetBaseStore)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GetSetBaseStore, [{
	    key: "get",
	    value: function get(key) {
	      if (typeof this.getSet_data === "undefined") {
	        return null;
	      }
	
	      return this.getSet_data[key];
	    }
	  }, {
	    key: "set",
	    value: function set(data) {
	      // Throw error if data is an array or is not an object
	      if (!((typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data)) === "object" && !Array.isArray(data))) {
	        throw new Error("Can only update getSet_data with data of type Object.");
	      }
	
	      // Allows overriding `getSet_data` wherever this is implemented
	      if (typeof this.getSet_data === "undefined") {
	        this.getSet_data = {};
	      }
	
	      (0, _assign2.default)(this.getSet_data, data);
	    }
	  }]);
	  return GetSetBaseStore;
	}(_BaseStore3.default);
	
	module.exports = GetSetBaseStore;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseStore = function (_EventEmitter) {
	  (0, _inherits3.default)(BaseStore, _EventEmitter);
	
	  function BaseStore() {
	    (0, _classCallCheck3.default)(this, BaseStore);
	    return (0, _possibleConstructorReturn3.default)(this, (BaseStore.__proto__ || (0, _getPrototypeOf2.default)(BaseStore)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BaseStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }]);
	  return BaseStore;
	}(_events.EventEmitter);
	
	module.exports = BaseStore;

/***/ },
/* 1009 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1010 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  ANALYTICS_LOAD_TIMEOUT: 2000
	};

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _md = __webpack_require__(1012);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _reactRouter = __webpack_require__(785);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SDK = __webpack_require__(996).getSDK();
	
	var Actions = {
	  previousFakePageLog: "",
	
	  dcosMetadata: null,
	
	  routes: null,
	
	  logQueue: [],
	
	  pageQueue: [],
	
	  actions: ["log", "logFakePageView"],
	
	  initialize: function initialize() {
	    var _this = this;
	
	    this.actions.forEach(function (action) {
	      SDK.Hooks.addAction(action, _this[action].bind(_this));
	    });
	
	    this.listenForDcosMetadata();
	    this.start();
	  },
	  metadataLoaded: function metadataLoaded() {
	    var metadata = SDK.Store.getAppState().metadata;
	
	    return metadata && metadata.dcosMetadata && metadata.metadata && metadata.metadata.CLUSTER_ID;
	  },
	  listenForDcosMetadata: function listenForDcosMetadata() {
	    var _this2 = this;
	
	    if (!this.metadataLoaded()) {
	      var unSubscribe = SDK.Store.subscribe(function () {
	        if (_this2.metadataLoaded()) {
	          unSubscribe();
	          _this2.setDcosMetadata(_this2.mergeMetaData());
	        }
	      });
	    } else {
	      this.setDcosMetadata(this.mergeMetaData());
	    }
	  },
	  mergeMetaData: function mergeMetaData() {
	    return (0, _assign2.default)({}, SDK.Store.getAppState().metadata.dcosMetadata, {
	      clusterId: SDK.Store.getAppState().metadata.metadata.CLUSTER_ID
	    });
	  },
	  setDcosMetadata: function setDcosMetadata(metadata) {
	    this.dcosMetadata = metadata;
	
	    if (this.canLog()) {
	      this.drainQueue();
	    }
	  },
	  setRoutes: function setRoutes(routes) {
	    this.routes = routes;
	
	    if (this.canLog()) {
	      this.drainQueue();
	    }
	  },
	  start: function start() {
	    var _this3 = this;
	
	    this.createdAt = Date.now();
	    this.lastLogDate = this.createdAt;
	    this.stintID = (0, _md2.default)("session_" + this.createdAt);
	
	    _reactRouter.hashHistory.listen(_Util2.default.debounce(function (location) {
	      Actions.setActivePage(location.pathname + location.search);
	    }, 200));
	
	    // Poll to deplete queue
	    var checkAnalyticsReady = function checkAnalyticsReady() {
	      setTimeout(function () {
	        if (!_this3.canLog()) {
	          checkAnalyticsReady();
	        } else {
	          _this3.drainQueue();
	        }
	      }, 200);
	    };
	    checkAnalyticsReady();
	  },
	  canLog: function canLog() {
	    return global.analytics && global.analytics.initialized && this.dcosMetadata != null && this.routes != null;
	  },
	  drainQueue: function drainQueue() {
	    var _this4 = this;
	
	    this.logQueue.forEach(function (log) {
	      _this4.log(log);
	    });
	    this.logQueue = [];
	
	    this.pageQueue.forEach(function (path) {
	      _this4.logPage(path);
	    });
	    this.pageQueue = [];
	  },
	  logFakePageView: function logFakePageView(fakePageLog) {
	    if (!this.canLog()) {
	      this.logQueue.push(fakePageLog);
	
	      return;
	    }
	
	    if ((0, _deepEqual2.default)(this.previousFakePageLog, fakePageLog)) {
	      return;
	    }
	
	    this.logPage(fakePageLog);
	    this.previousFakePageLog = fakePageLog;
	  },
	  setActivePage: function setActivePage(path) {
	    if (path[path.length - 1] === "/") {
	      path = path.substring(0, path.length - 1);
	    }
	
	    if (!this.canLog()) {
	      this.pageQueue.push(path);
	
	      return;
	    }
	
	    this.logPage(path);
	  },
	  getStintID: function getStintID() {
	    return this.stintID;
	  },
	  getLogData: function getLogData() {
	    return (0, _assign2.default)({
	      appVersion: _Config2.default.version,
	      version: "1.1.14"
	    }, this.dcosMetadata);
	  },
	  identify: function identify(uid) {
	    var _this5 = this;
	
	    if (!this.canLog()) {
	      // Try again
	      setTimeout(function () {
	        _this5.identify(uid);
	      }, 500);
	
	      return;
	    }
	
	    if (!SDK.Hooks.applyFilter("shouldIdentifyLoggedInUser", true)) {
	      return;
	    }
	
	    var traits = (0, _assign2.default)(this.getLogData(), { email: uid });
	    global.analytics.identify(uid, traits, this.getAnonymizingKeys());
	
	    this.log("dcos_login");
	  },
	  logPage: function logPage(path) {
	    var _this6 = this;
	
	    if (!this.canLog()) {
	      this.pageQueue.push(path);
	
	      return;
	    }
	
	    if (typeof path === "string") {
	      (0, _reactRouter.match)({ history: _reactRouter.hashHistory, routes: this.routes }, function (error, redirectLocation, nextState) {
	        if (!error && nextState) {
	          var pathMatcher = _RouterUtil2.default.reconstructPathFromRoutes(nextState.routes);
	          if (nextState.params) {
	            (0, _keys2.default)(nextState.params).forEach(function (param) {
	              pathMatcher = pathMatcher.replace(":" + param + "?", "[" + param + "]");
	              pathMatcher = pathMatcher.replace(":" + param, "[" + param + "]");
	            });
	          }
	
	          // Replaces '/?/' and '/?' with '/'
	          path = pathMatcher.replace(/\/\?\/?/g, "/");
	        } else {
	          path = "/unknown";
	        }
	
	        _this6.submitToAnalytics(path);
	      });
	    }
	
	    this.submitToAnalytics(path);
	  },
	  submitToAnalytics: function submitToAnalytics(path) {
	    global.analytics.page((0, _assign2.default)(this.getLogData(), this.getAnonymizingKeys().page, { path: path }));
	  },
	
	
	  /**
	   * Logs arbitrary data
	   * @param  {String} eventID
	   */
	  log: function log(eventID) {
	    if (!this.canLog()) {
	      this.logQueue.push(eventID);
	
	      return;
	    }
	
	    // Populates with basic data that all logs need
	    var log = this.getLogData();
	
	    global.analytics.track(eventID, log, this.getAnonymizingKeys());
	  },
	  getAnonymizingKeys: function getAnonymizingKeys() {
	    return {
	      page: {
	        // Anonymize
	        referrer: "",
	        url: "",
	        path: "",
	        title: ""
	      }
	    };
	  }
	};
	
	module.exports = Actions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _queryString = __webpack_require__(810);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findRedirect(queryString) {
	  var redirectTo = false;
	
	  (0, _keys2.default)(queryString).forEach(function (key) {
	    if (/redirect/.test(key)) {
	      redirectTo = queryString[key];
	    }
	  });
	
	  return redirectTo;
	}
	
	var RouterUtil = {
	  /**
	   * Parse the url and find the query string (?)
	   * before or after the #
	   *
	   * @returns {Boolean|Object} false or query string object
	   */
	  getQueryStringInUrl: function getQueryStringInUrl() {
	    var queryString = false;
	    // This will match url instances like this:
	    // /?redirect=SOME_ADDRESS#/login
	    if (global.location.search) {
	      queryString = _queryString2.default.parse(global.location.search);
	    }
	
	    // This will match url instances like this:
	    // /#/login?redirect=SOME_ADDRESS
	    if (!queryString && global.location.hash) {
	      queryString = _queryString2.default.parse(global.location.hash);
	    }
	
	    return queryString;
	  },
	  isValidRedirect: function isValidRedirect(url) {
	    var parsedUrl = _Util2.default.parseUrl(url);
	
	    if (!parsedUrl) {
	      return false;
	    }
	
	    return parsedUrl.hostname === global.location.hostname;
	  },
	
	
	  /**
	   * Find relativePath query
	   * and keep it's original encoding
	   * the use of qs will decode the path
	   * making the path not found
	   *
	   * @returns {Boolean|String} False or path encodedURI
	   */
	  getRelativePath: function getRelativePath() {
	    var RELATIVE_PATH = "relativePath=";
	    var url = global.location.href;
	
	    if (!url.includes(RELATIVE_PATH)) {
	      return false;
	    }
	
	    var startPoint = url.indexOf(RELATIVE_PATH) + RELATIVE_PATH.length;
	    var endPoint = url.length;
	
	    return url.substring(startPoint, endPoint);
	  },
	  getRedirectTo: function getRedirectTo() {
	    return findRedirect(this.getQueryStringInUrl());
	  },
	
	
	  /**
	   * Creates a tree of React components for an array of route configurations
	   *
	   * @param  {Array} routes
	   * @return {Array} React tree of routes
	   */
	  createComponentsFromRoutes: function createComponentsFromRoutes(routes) {
	    return routes.map(function (route) {
	      var args = [route.type, _Util2.default.omit(route, ["type", "children"])];
	
	      if (route.component && route.component.willTransitionTo && !route.onEnter) {
	        route.onEnter = route.component.willTransitionTo;
	      }
	
	      if (route.children) {
	        var children = RouterUtil.createComponentsFromRoutes(route.children);
	        args = args.concat(children);
	      }
	
	      return _react2.default.createElement.apply(_react2.default, (0, _toConsumableArray3.default)(args));
	    });
	  },
	
	
	  /**
	   * Builds a route array that react router can use,
	   * with the correct configuration.
	   *
	   * @param  {Array} originalRoutes Original Route configuration
	   * @return {Array} Routes ready to use by react router
	   */
	  buildRoutes: function buildRoutes(originalRoutes) {
	    var elementRoutes = RouterUtil.createComponentsFromRoutes(originalRoutes);
	
	    return (0, _reactRouter.createRoutes)(elementRoutes);
	  },
	
	
	  /**
	   * Checks if a page should hide the header navigation tabs
	   * @param  {Array} routes instance of react-router
	   * @return {Bool} should hide Page Navigation
	   */
	  shouldHideNavigation: function shouldHideNavigation(routes) {
	    return !!routes[routes.length - 1].hideHeaderNavigation;
	  },
	
	
	  /**
	   * Builds absolute path from routes array
	   * React router v2.8.1 provides routes prop to a component that bound to a <Route />
	   * this.props.routes contains a plain list of all routes React router hits.
	   * So for for /foo/:id with the following set of routes
	   * <Route path="foo">
	   *   <Route path=":id">
	   *     <IndexRoute />
	   *     ...
	   *   </Route>
	   * </Route>
	   * React router will provide the following array
	   * [
	   *   {type: Route, path: 'foo'},
	   *   {type: Route, path: ':id'},
	   *   {type: IndexRoute}
	   * ]
	   * so we should filter all the routes that have `path` and join them to get the absolute path pattern
	   * @param {Array} routes - an array of current routes react-router gives you
	   * @returns {String} path - absolute path pattern
	   */
	  reconstructPathFromRoutes: function reconstructPathFromRoutes(routes) {
	    var path = routes.filter(function (route) {
	      return !!route.path;
	    }).map(function (route) {
	      return route.path;
	    }).join("/");
	
	    return "/" + path;
	  }
	};
	
	module.exports = RouterUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _SDK = __webpack_require__(1022);
	
	var _SDK2 = _interopRequireDefault(_SDK);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (PluginSDK) {
	  _SDK2.default.setSDK(PluginSDK);
	
	  var PluginHooks = __webpack_require__(1023);
	
	  // Set plugin's hooks
	  PluginHooks.initialize();
	};

/***/ },
/* 1022 */
967,
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AccessDeniedPage = __webpack_require__(1039);
	
	var _AccessDeniedPage2 = _interopRequireDefault(_AccessDeniedPage);
	
	var _ApplicationUtil = __webpack_require__(1046);
	
	var _ApplicationUtil2 = _interopRequireDefault(_ApplicationUtil);
	
	var _Authenticated = __webpack_require__(1267);
	
	var _Authenticated2 = _interopRequireDefault(_Authenticated);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _ConfigStore = __webpack_require__(1268);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _CookieUtils = __webpack_require__(1004);
	
	var _CookieUtils2 = _interopRequireDefault(_CookieUtils);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _UsersPage = __webpack_require__(1270);
	
	var _UsersPage2 = _interopRequireDefault(_UsersPage);
	
	var _AuthenticatedUserAccountDropdown = __webpack_require__(1354);
	
	var _AuthenticatedUserAccountDropdown2 = _interopRequireDefault(_AuthenticatedUserAccountDropdown);
	
	var _LoginPage = __webpack_require__(1357);
	
	var _LoginPage2 = _interopRequireDefault(_LoginPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var SDK = __webpack_require__(1022).getSDK();
	/* eslint-disable no-unused-vars */
	
	
	var configResponseCallback = null;
	var defaultOrganizationRoute = {
	  routes: []
	};
	
	module.exports = (0, _assign2.default)({}, _mesosphereSharedReactjs.StoreMixin, {
	  actions: ["AJAXRequestError", "userLoginSuccess", "userLogoutSuccess", "redirectToLogin"],
	
	  filters: ["applicationRoutes", "delayApplicationLoad", "organizationRoutes", "serverErrorModalListeners", "userAddPolicy"],
	
	  initialize: function initialize() {
	    var _this = this;
	
	    this.filters.forEach(function (filter) {
	      SDK.Hooks.addFilter(filter, _this[filter].bind(_this));
	    });
	    this.actions.forEach(function (action) {
	      SDK.Hooks.addAction(action, _this[action].bind(_this));
	    });
	    this.store_initializeListeners([{
	      name: "config",
	      events: ["success", "error"]
	    }]);
	    this.registerUserAccountDropdown();
	  },
	  redirectToLogin: function redirectToLogin(nextState, replace) {
	    var redirectTo = _RouterUtil2.default.getRedirectTo();
	    // Ignores relative path if redirect is present
	    if (redirectTo) {
	      replace("/login?redirect=" + redirectTo);
	    } else {
	      replace("/login?relativePath=" + nextState.location.pathname);
	    }
	  },
	  AJAXRequestError: function AJAXRequestError(xhr) {
	    if (xhr.status !== 401 && xhr.status !== 403) {
	      return;
	    }
	
	    var location = global.location.hash;
	    var onAccessDeniedPage = /access-denied/.test(location);
	    var onLoginPage = /login/.test(location);
	
	    // Unauthorized
	    if (xhr.status === 401 && !onLoginPage && !onAccessDeniedPage) {
	      global.document.cookie = _CookieUtils2.default.emptyCookieWithExpiry(new Date(1970));
	      global.location.href = "#/login";
	    }
	
	    // Forbidden
	    if (xhr.status === 403 && !onLoginPage && !onAccessDeniedPage) {
	      global.location.href = "#/access-denied";
	    }
	  },
	  serverErrorModalListeners: function serverErrorModalListeners(listeners) {
	    listeners.push({
	      name: "auth",
	      events: ["logoutError"]
	    });
	
	    return listeners;
	  },
	  applicationRoutes: function applicationRoutes(routes) {
	    // Override handler of index to be 'authenticated'
	    routes[0].children.forEach(function (child) {
	      if (child.id === "index") {
	        child.component = new _Authenticated2.default(child.component);
	        child.onEnter = child.component.willTransitionTo;
	      }
	    });
	
	    // Add access denied and login pages
	    routes[0].children.unshift({
	      component: _AccessDeniedPage2.default,
	      path: "/access-denied",
	      type: _reactRouter.Route
	    }, {
	      component: _LoginPage2.default,
	      path: "/login",
	      type: _reactRouter.Route
	    });
	
	    return routes;
	  },
	  onConfigStoreSuccess: function onConfigStoreSuccess() {
	    if (configResponseCallback) {
	      configResponseCallback();
	      configResponseCallback = null;
	    }
	  },
	  onConfigStoreError: function onConfigStoreError() {
	    if (configResponseCallback) {
	      configResponseCallback();
	      configResponseCallback = null;
	    }
	  },
	
	
	  // Ensure user route under organization
	  organizationRoutes: function organizationRoutes() {
	    var routeDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOrganizationRoute;
	
	    var userRoute = {
	      type: _reactRouter.Route,
	      path: "users",
	      component: _UsersPage2.default
	    };
	    var usersRouteIndex = routeDefinition.routes.findIndex(function (route) {
	      return route.name === userRoute.name;
	    });
	    // Replace by new definition
	    if (usersRouteIndex !== -1) {
	      routeDefinition.routes.splice(usersRouteIndex, 1, userRoute);
	    }
	
	    // Add user route if not already present
	    if (usersRouteIndex === -1) {
	      routeDefinition.routes.push(userRoute);
	    }
	
	    routeDefinition.redirect = {
	      type: _reactRouter.Redirect,
	      from: "/organization",
	      to: "/organization/users"
	    };
	
	    return routeDefinition;
	  },
	  registerUserAccountDropdown: function registerUserAccountDropdown() {
	    _foundationUi.MountService.MountService.registerComponent(_AuthenticatedUserAccountDropdown2.default, "Sidebar:UserAccountDropdown", 100);
	  },
	  userLoginSuccess: function userLoginSuccess() {
	    var redirectTo = _RouterUtil2.default.getRedirectTo();
	    var isValidRedirect = _RouterUtil2.default.isValidRedirect(redirectTo);
	
	    if (isValidRedirect) {
	      global.location.href = redirectTo;
	    } else {
	      _ApplicationUtil2.default.beginTemporaryPolling(function () {
	        var relativePath = _RouterUtil2.default.getRelativePath();
	        var loginRedirectRoute = _AuthStore2.default.get("loginRedirectRoute");
	
	        if (loginRedirectRoute && !relativePath) {
	          // Go to redirect route if it is present
	          _reactRouter.hashHistory.push(loginRedirectRoute);
	        } else if (relativePath) {
	          global.location.replace(global.location.origin + "/#" + relativePath);
	        } else {
	          // Go to home
	          _reactRouter.hashHistory.push("/");
	        }
	      });
	    }
	  },
	  userLogoutSuccess: function userLogoutSuccess() {
	    // Reload configuration because we need to get 'firstUser' which is
	    // dynamically set based on number of users
	    configResponseCallback = this.navigateToLoginPage;
	    _ConfigStore2.default.fetchConfig();
	  },
	  delayApplicationLoad: function delayApplicationLoad(value) {
	    var user = _AuthStore2.default.getUser();
	
	    // If user is logged in, then let's let the app do its thing
	    if (user) {
	      return value;
	    }
	
	    // Let's wait till login and then we'll request mesos summary before render
	    return false;
	  },
	  navigateToLoginPage: function navigateToLoginPage() {
	    global.location.href = "#/login";
	  },
	  userAddPolicy: function userAddPolicy() {
	    return _react2.default.createElement(
	      "p",
	      { className: "form-control-feedback" },
	      "By adding a user you understand we will process personal information in accordance with our",
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "reset-color",
	          href: "https://mesosphere.com/privacy/",
	          target: "_blank"
	        },
	        "Privacy Policy"
	      ),
	      "."
	    );
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Mount = __webpack_require__(1025);
	
	var _Mount2 = _interopRequireDefault(_Mount);
	
	var _navigation = __webpack_require__(1033);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _routing = __webpack_require__(1036);
	
	var _routing2 = _interopRequireDefault(_routing);
	
	var _mount = __webpack_require__(1029);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  MountService: {
	    Mount: _Mount2.default,
	    MountService: _mount.MountService
	  },
	  navigation: _navigation2.default,
	  routing: _routing2.default
	};

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _maxSafeInteger = __webpack_require__(1026);
	
	var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(1029);
	
	var _MountEvent = __webpack_require__(1031);
	
	var _ReactUtil = __webpack_require__(1032);
	
	var _ReactUtil2 = _interopRequireDefault(_ReactUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onMountServiceChange"];
	
	/**
	 * A component to use as a mount point to incorporate views/components provided
	 * by packages. It renders with a/components registered to the `MountService`
	 * with a matching `type`.
	 * It provides a property to configure the wrapping component (`wrapper`) as
	 * well as a property to `limit` the number of rendered elements.
	 *
	 * @example
	 *
	 * <Mount type="widget" limit={10} wrapper={MyWidgetsWrapper}>
	 *     <span className="help-text"></span>
	 * </Mount>
	 *
	 */
	
	var Mount = function (_React$Component) {
	  (0, _inherits3.default)(Mount, _React$Component);
	
	  function Mount() {
	    (0, _classCallCheck3.default)(this, Mount);
	
	    // Get components and init state
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Mount.__proto__ || (0, _getPrototypeOf2.default)(Mount)).apply(this, arguments));
	
	    _this.state = {
	      components: _index.MountService.findComponentsWithType(_this.props.type)
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(Mount, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _index.MountService.addListener(_MountEvent.CHANGE, this.onMountServiceChange);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type;
	
	
	      if (this.props.type === type) {
	        return;
	      }
	
	      this.setState({ components: _index.MountService.findComponentsWithType(type) });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _index.MountService.removeListener(_MountEvent.CHANGE, this.onMountServiceChange);
	    }
	  }, {
	    key: "onMountServiceChange",
	    value: function onMountServiceChange(type) {
	      if (this.props.type !== type) {
	        return;
	      }
	
	      this.setState({ components: _index.MountService.findComponentsWithType(type) });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          alwaysWrap = _props.alwaysWrap,
	          children = _props.children,
	          limit = _props.limit,
	          wrapper = _props.wrapper;
	      var components = this.state.components;
	
	      // Filter consumed props to only pass on a "clean" set of props
	
	      var filteredProps = (0, _keys2.default)(this.props).reduce(function (props, key) {
	        if (!Object.prototype.hasOwnProperty.call(Mount.propTypes, key)) {
	          props[key] = _this2.props[key];
	        }
	
	        return props;
	      }, {});
	
	      // Limit the number of components as configured and create elements
	      var elements = components.slice(0, limit).map(function (Component, index) {
	        return _react2.default.createElement(Component, (0, _extends3.default)({}, filteredProps, { key: index }));
	      });
	
	      // Don't render prop.children if elements is defined
	      if (elements.length > 0) {
	        // Wrap array of children in chosen wrapperComponent (default: div)
	        // e.g. for table row, this would be <tr/> and elements could be a
	        // set of  <td/>'s
	        return _ReactUtil2.default.wrapElements(elements, wrapper, alwaysWrap);
	      }
	
	      return _ReactUtil2.default.wrapElements(children, wrapper, alwaysWrap);
	    }
	  }]);
	  return Mount;
	}(_react2.default.Component);
	
	Mount.defaultProps = {
	  alwaysWrap: false,
	  limit: _maxSafeInteger2.default,
	  wrapper: "div"
	};
	
	Mount.propTypes = {
	  alwaysWrap: _react.PropTypes.bool,
	  limit: _react.PropTypes.number,
	  children: _react.PropTypes.element,
	  type: _react.PropTypes.string.isRequired,
	  wrapper: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func])
	};
	
	module.exports = Mount;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1027), __esModule: true };

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1028);
	module.exports = 0x1fffffffffffff;

/***/ },
/* 1028 */
[2084, 868],
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _MountService = __webpack_require__(1030);
	
	var _MountService2 = _interopRequireDefault(_MountService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  MountService: new _MountService2.default()
	};

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	var _MountEvent = __webpack_require__(1031);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * MountService
	 */
	var MountService = function (_EventEmitter) {
	  (0, _inherits3.default)(MountService, _EventEmitter);
	
	  function MountService() {
	    (0, _classCallCheck3.default)(this, MountService);
	
	    /**
	     * Private Context
	     *
	     * @typedef {Object} MountService~Context
	     * @property {MountService} instance - Current mount service instance
	     * @property {Array.<{component:function, priority:Number, type:String}>}
	     *     components -  List of component descriptors
	     * @property {number} rank - Consecutive number used to rank components
	     *     based on order of registration
	     */
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MountService.__proto__ || (0, _getPrototypeOf2.default)(MountService)).apply(this, arguments));
	
	    var context = {
	      components: [],
	      instance: _this,
	      rank: 0
	    };
	
	    _this.registerComponent = _this.registerComponent.bind(context);
	    _this.unregisterComponent = _this.unregisterComponent.bind(context);
	    _this.findComponentsWithType = _this.findComponentsWithType.bind(context);
	    return _this;
	  }
	
	  /**
	   * Register component with type and optional priority
	   *
	   * @this MountService~Context
	   * @param {function} component - React component which will be
	   * mounted based on the provided type
	   * @param {String} type - String which is used to match components with the
	   * respective mounts
	   * @param {Number} [priority] - Number which is used to sort the components
	   */
	
	
	  (0, _createClass3.default)(MountService, [{
	    key: "registerComponent",
	    value: function registerComponent(component, type) {
	      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var components = this.components,
	          instance = this.instance,
	          rank = this.rank;
	
	
	      if (typeof component !== "function") {
	        if (false) {
	          throw new TypeError("Provided component must be a " + "React.Component constructor or a stateless functional component");
	        }
	
	        return;
	      }
	
	      if (typeof type !== "string" || type === "") {
	        if (false) {
	          throw new TypeError("Provided type must be a none empty string");
	        }
	
	        return;
	      }
	
	      if (components.find(function (descriptor) {
	        return descriptor.component === component && descriptor.type === type;
	      })) {
	        if (false) {
	          throw new Error("Provided component/type " + component.name + "/" + type + "combination is already registered");
	        }
	
	        return;
	      }
	
	      // Add component descriptor and sort components list by priority and rank
	      components.push({ component: component, priority: priority, type: type, rank: rank++ });
	      components.sort(function (a, b) {
	        if (a.priority !== b.priority) {
	          return b.priority - a.priority;
	        }
	
	        return a.rank - b.rank;
	      });
	
	      instance.emit(_MountEvent.CHANGE, type);
	    }
	
	    /**
	     * Unregisters component by matching type and component
	     *
	     * @this MountService~Context
	     * @param  {function} component
	     * @param  {String} type
	     */
	
	  }, {
	    key: "unregisterComponent",
	    value: function unregisterComponent(component, type) {
	      var components = this.components,
	          instance = this.instance;
	
	
	      var i = components.length;
	      while (--i >= 0) {
	        if (components[i].component === component && components[i].type === type) {
	          components.splice(i, 1);
	          break;
	        }
	      }
	
	      instance.emit(_MountEvent.CHANGE, type);
	    }
	
	    /**
	     * Find components with matching type
	     *
	     * @this MountService~Context
	     * @param {String} type
	     * @returns {Array} list of matching components ordered by priority
	     */
	
	  }, {
	    key: "findComponentsWithType",
	    value: function findComponentsWithType(type) {
	      var components = this.components;
	
	
	      return components.filter(function (descriptor) {
	        return descriptor.type === type;
	      }).map(function (descriptor) {
	        return descriptor.component;
	      });
	    }
	  }]);
	  return MountService;
	}(_events.EventEmitter);
	
	module.exports = MountService;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _symbol = __webpack_require__(940);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  CHANGE: (0, _symbol2.default)("change")
	};

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUnwrappedElements(elements) {
	  if (Array.isArray(elements) && elements.length === 1 && _react2.default.isValidElement(elements[0])) {
	    return elements[0];
	  }
	
	  return elements;
	}
	
	function shouldWrapElements(elements, alwaysWrap) {
	  return alwaysWrap || Array.isArray(elements) && elements.length > 1;
	}
	
	var ReactUtil = {
	  /**
	   * Wrap React elements
	   *
	   * If elements is an array with a single element, it will not be wrapped
	   * unless alwaysWrap is true.
	   *
	   * @param {Array.<ReactElement>|ReactElement} elements
	   * @param  {function|String} wrapper component
	   * @param {boolean} [alwaysWrap]
	   *
	   * @returns {ReactElement} wrapped react elements
	   */
	  wrapElements: function wrapElements(elements) {
	    var wrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "div";
	    var alwaysWrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (elements == null && !alwaysWrap) {
	      return null;
	    }
	
	    if (shouldWrapElements(elements, alwaysWrap)) {
	      return _react2.default.createElement(wrapper, null, elements);
	    }
	
	    return getUnwrappedElements(elements, alwaysWrap);
	  }
	};
	
	module.exports = ReactUtil;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _NavigationService = __webpack_require__(1034);
	
	var _NavigationService2 = _interopRequireDefault(_NavigationService);
	
	var _EventTypes = __webpack_require__(1035);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var service = new _NavigationService2.default();
	
	module.exports = {
	  EventTypes: _EventTypes2.default,
	  NavigationService: service
	};

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	var _EventTypes = __webpack_require__(1035);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationService = function (_EventEmitter) {
	  (0, _inherits3.default)(NavigationService, _EventEmitter);
	
	  function NavigationService() {
	    (0, _classCallCheck3.default)(this, NavigationService);
	
	    /**
	     * @typedef NavigationService~Context
	     */
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NavigationService.__proto__ || (0, _getPrototypeOf2.default)(NavigationService)).call(this));
	
	    var privateContext = {
	      instance: _this,
	      deferredTasks: [],
	      definition: [
	      // The only default is root, so it goes first no matter what
	      { category: "root", children: [] }],
	      defer: function defer(method, args) {
	        this.deferredTasks.push({ method: method, args: args });
	      },
	      processDeferred: function processDeferred() {
	        var _this2 = this;
	
	        var tasks = this.deferredTasks.slice(0);
	        this.deferredTasks = [];
	
	        // If Task is unable to resolve at this point of time it will re-defer itself
	        tasks.forEach(function (_ref) {
	          var method = _ref.method,
	              args = _ref.args;
	
	          method.apply(_this2.instance, args);
	        });
	      }
	    };
	
	    _this.getDefinition = _this.getDefinition.bind(privateContext);
	    _this.registerCategory = _this.registerCategory.bind(privateContext);
	    _this.registerPrimary = _this.registerPrimary.bind(privateContext);
	    _this.registerSecondary = _this.registerSecondary.bind(privateContext);
	
	    _this.on(_EventTypes.NAVIGATION_CHANGE, privateContext.processDeferred.bind(privateContext));
	    return _this;
	  }
	
	  /**
	   * getDefinition - returns navigation definition
	   *
	   * @this {NavigationService~Context}
	   * @return {Array} definition items
	   */
	
	
	  (0, _createClass3.default)(NavigationService, [{
	    key: "getDefinition",
	    value: function getDefinition() {
	      return this.definition.slice(0);
	    }
	
	    /**
	     * registerCategory - register a Sidebar category
	     *
	     * @this {NavigationService~Context}
	     * @param  {String} category Category name
	     */
	
	  }, {
	    key: "registerCategory",
	    value: function registerCategory(category) {
	      if (!this.definition.find(function (element) {
	        return element.category === category;
	      })) {
	        this.definition.push({
	          category: category,
	          children: []
	        });
	
	        this.instance.emit(_EventTypes.NAVIGATION_CHANGE);
	      }
	    }
	
	    /**
	     * registerPrimary - register a primary navigation element
	     *
	     * @this {NavigationService~Context}
	     * @param  {String} path - an absolute path
	     * @param  {String|React.Component} link - link label or a custom component
	     * @param  {Object} options - additional data
	     * @return {undefined}
	     */
	
	  }, {
	    key: "registerPrimary",
	    value: function registerPrimary(path, link) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var _options$category = options.category,
	          category = _options$category === undefined ? "root" : _options$category;
	
	      var categoryElement = this.definition.find(function (element) {
	        return element.category === category;
	      });
	
	      if (!categoryElement) {
	        return this.defer(this.instance.registerPrimary, arguments);
	      }
	
	      var existingElement = categoryElement.children.find(function (element) {
	        return element.path === path;
	      });
	
	      if (existingElement) {
	        if (false) {
	          console.warn("Primary nav with the path " + path + " already exists!");
	        }
	
	        return;
	      }
	
	      categoryElement.children.push({
	        path: path,
	        link: link,
	        options: options,
	        children: []
	      });
	
	      this.instance.emit(_EventTypes.NAVIGATION_CHANGE);
	    }
	
	    /**
	     * registerSecondary - register a secondary navigation element
	     *
	     * @this {NavigationService~Context}
	     * @param  {String} parentPath - an absolute path of a parent element
	     * @param  {String} path - an absolute path of the secondary element
	     * @param  {String|React.Component} link - a string label or a custom link component
	     * @param  {Object} options - additional options
	     * @return {undefined}
	     */
	
	  }, {
	    key: "registerSecondary",
	    value: function registerSecondary(parentPath, path, link) {
	      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      // flatten categories
	      var primaryElements = this.definition.reduce(function (result, category) {
	        return result.concat(category.children);
	      }, []);
	
	      var parentElement = primaryElements.find(function (element) {
	        return element.path === parentPath;
	      });
	
	      if (!parentElement) {
	        return this.defer(this.instance.registerSecondary, arguments);
	      }
	
	      var existingElement = parentElement.children.find(function (element) {
	        return element.path === path;
	      });
	
	      if (existingElement) {
	        if (false) {
	          console.warn("\n          Secondary nav with the path " + parentPath + "/" + path + " already exists!\n        ");
	        }
	
	        return;
	      }
	
	      parentElement.children.push({
	        link: link,
	        options: options,
	        path: parentPath + "/" + path,
	        children: []
	      });
	
	      this.instance.emit(_EventTypes.NAVIGATION_CHANGE);
	    }
	  }]);
	  return NavigationService;
	}(_events.EventEmitter);
	
	module.exports = NavigationService;

/***/ },
/* 1035 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  NAVIGATION_CHANGE: "NAVIGATION_CHANGE"
	};

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _RoutingService = __webpack_require__(1037);
	
	var _RoutingService2 = _interopRequireDefault(_RoutingService);
	
	var _EventTypes = __webpack_require__(1038);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  EventTypes: _EventTypes2.default,
	  RoutingService: new _RoutingService2.default()
	};

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(785);
	
	var _events = __webpack_require__(1009);
	
	var _EventTypes = __webpack_require__(1038);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throwError(error) {
	  if (false) {
	    throw error;
	  }
	}
	
	var RoutingService = function (_EventEmitter) {
	  (0, _inherits3.default)(RoutingService, _EventEmitter);
	
	  function RoutingService() {
	    (0, _classCallCheck3.default)(this, RoutingService);
	
	    /**
	     * Private context
	     *
	     * @typedef {Object} RoutingService~Context
	     * @property {object} instance - reference to public instance
	     * @property {Array} definition - routing definition
	     * @property {Array} deferredTasks - tasks to perform once all dependencies have been resolved
	     */
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RoutingService.__proto__ || (0, _getPrototypeOf2.default)(RoutingService)).call(this));
	
	    var privateContext = {
	      instance: _this,
	      definition: [],
	      deferredTasks: [],
	
	      /**
	       * defer - add a task to deferredTasks
	       *
	       * @param  {Array} args arguments of a task
	       */
	      defer: function defer(args) {
	        this.deferredTasks.push(args);
	      },
	
	
	      /**
	       * processDeferred - process list of deferred tasks
	       */
	      processDeferred: function processDeferred() {
	        var _this2 = this;
	
	        var tasks = this.deferredTasks.slice(0);
	        this.deferredTasks = [];
	
	        // If Task is unable to resolve at this point of time it will re-defer itself
	        tasks.forEach(function (args) {
	          _this2.instance.registerTab.apply(_this2.instance, args);
	        });
	      }
	    };
	
	    _this.getDefinition = _this.getDefinition.bind(privateContext);
	    _this.registerPage = _this.registerPage.bind(privateContext);
	    _this.registerTab = _this.registerTab.bind(privateContext);
	    _this.registerRedirect = _this.registerRedirect.bind(privateContext);
	
	    _this.on(_EventTypes.ROUTING_CHANGE, privateContext.processDeferred.bind(privateContext));
	    return _this;
	  }
	
	  (0, _createClass3.default)(RoutingService, [{
	    key: "getDefinition",
	    value: function getDefinition() {
	      return this.definition.slice(0);
	    }
	
	    /**
	     * registerPage - adds a page route to the queue
	     *
	     * @this {RoutingService~Context}
	     * @param  {String} path a path to the page
	     * @param  {React.Component} component a React.js component of the page
	     * @return {undefined}
	     */
	
	  }, {
	    key: "registerPage",
	    value: function registerPage(path, component) {
	      if (!path || !component) {
	        return throwError(new Error("Please provide all required arguments"));
	      }
	
	      var existingPage = this.definition.find(function (route) {
	        return route.path === path;
	      });
	
	      if (existingPage && existingPage.component === component) {
	        return;
	      } else if (existingPage) {
	        return throwError(new Error("Attempt to override a page at " + path + "!"));
	      }
	
	      this.definition.push({
	        component: component,
	        path: path,
	        type: _reactRouter.Route
	      });
	
	      this.instance.emit(_EventTypes.ROUTING_CHANGE);
	    }
	
	    /**
	     * registerTab - adds a tab route to the queue
	     *
	     * @this {RoutingService~Context}
	     * @param  {String} pagePath a path to a parent page
	     * @param  {String} tabPath a path to the tab
	     * @param  {React.Component} component a React.js component of the tab
	     * @return {undefined}
	     */
	
	  }, {
	    key: "registerTab",
	    value: function registerTab(pagePath, tabPath, component) {
	      if (!pagePath || !tabPath || !component) {
	        return throwError(new Error("Please provide all required arguments"));
	      }
	
	      var page = this.definition.find(function (route) {
	        return route.path === pagePath;
	      });
	
	      if (!page) {
	        return this.defer(arguments);
	      }
	
	      if (!page.children) {
	        page.children = [];
	      }
	
	      var existingTab = page.children.find(function (route) {
	        return route.path === tabPath;
	      });
	
	      if (existingTab && existingTab.component === component) {
	        return;
	      } else if (existingTab) {
	        return throwError(new Error("Attempt to override a tab at " + pagePath + "/" + tabPath + "!"));
	      }
	
	      page.children.push({
	        component: component,
	        path: tabPath,
	        type: _reactRouter.Route
	      });
	
	      this.instance.emit(_EventTypes.ROUTING_CHANGE);
	    }
	
	    /**
	     * registerRedirect
	     *
	     * @this {RoutingService~Context}
	     * @param  {String} path a path to redirect from
	     * @param  {String} to   a path to redirect to
	     * @return {undefined}
	     */
	
	  }, {
	    key: "registerRedirect",
	    value: function registerRedirect(path, to) {
	      var existingRedirect = this.definition.find(function (route) {
	        return route.type === _reactRouter.Redirect && route.path === path;
	      });
	
	      if (existingRedirect && existingRedirect.to === to) {
	        return;
	      } else if (existingRedirect) {
	        return throwError(new Error("Attempt to override Redirect of " + path + " from " + existingRedirect.to + " to " + to + "!"));
	      }
	
	      this.definition.push({
	        path: path,
	        to: to,
	        type: _reactRouter.Redirect
	      });
	
	      this.instance.emit(_EventTypes.ROUTING_CHANGE);
	    }
	  }]);
	  return RoutingService;
	}(_events.EventEmitter);
	
	module.exports = RoutingService;

/***/ },
/* 1038 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  ROUTING_CHANGE: "ROUTING_CHANGE"
	};

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleUserLogout"];
	
	module.exports = function (_React$Component) {
	  (0, _inherits3.default)(AccessDeniedPage, _React$Component);
	
	  function AccessDeniedPage() {
	    (0, _classCallCheck3.default)(this, AccessDeniedPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AccessDeniedPage.__proto__ || (0, _getPrototypeOf2.default)(AccessDeniedPage)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AccessDeniedPage, [{
	    key: "handleUserLogout",
	    value: function handleUserLogout() {
	      _AuthStore2.default.logout();
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button-primary",
	            onClick: this.handleUserLogout
	          },
	          "Log out"
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "application-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "page" },
	          _react2.default.createElement(
	            "div",
	            { className: "page-body-content vertical-center flex-item-grow-1" },
	            _react2.default.createElement(
	              _AlertPanel2.default,
	              null,
	              _react2.default.createElement(
	                _AlertPanelHeader2.default,
	                null,
	                "Access denied"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "tall" },
	                "You do not have access to this service. Please contact your ",
	                _Config2.default.productName,
	                " administrator or see ",
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: _MetadataStore2.default.buildDocsURI("/administration/id-and-access-mgt/"),
	                    target: "_blank"
	                  },
	                  "security documentation"
	                ),
	                " for more information."
	              ),
	              this.getFooter()
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return AccessDeniedPage;
	}(_react2.default.Component);

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Panel = __webpack_require__(1042);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertPanel = _react2.default.createClass({
	  displayName: "AlertPanel",
	
	  defaultProps: {
	    icon: null
	  },
	
	  propTypes: {
	    icon: _react2.default.PropTypes.node,
	    iconClassName: _react2.default.PropTypes.string
	  },
	
	  // TODO: Use iconIDs instead of icon classes.
	  getIcon: function getIcon() {
	    var _props = this.props,
	        icon = _props.icon,
	        iconClassName = _props.iconClassName;
	
	
	    if (icon) {
	      return icon;
	    }
	
	    if (!iconClassName) {
	      return null;
	    }
	
	    return _react2.default.createElement("i", { className: iconClassName, key: "icon" });
	  },
	  render: function render() {
	    var classes = (0, _dedupe2.default)("panel alert-panel text-align-center flush-bottom", this.props.className);
	
	    return _react2.default.createElement(
	      _Panel2.default,
	      {
	        ref: "panel",
	        className: classes,
	        contentClass: ["panel-cell-borderless panel-cell-wider panel-cell-taller", {
	          "panel-cell-narrow": false,
	          "panel-cell-short": false
	        }],
	        footer: this.props.footer,
	        footerClass: ["panel-cell-wider panel-cell-taller", {
	          "panel-cell-narrow": false,
	          "panel-cell-short": false
	        }],
	        heading: this.getIcon(),
	        headingClass: ["panel-cell-borderless flush-bottom", {
	          "panel-cell-narrow": false,
	          "panel-cell-shorter": false,
	          "panel-cell-light": false
	        }]
	      },
	      this.props.children
	    );
	  }
	});
	
	module.exports = AlertPanel;

/***/ },
/* 1041 */,
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultClasses = {
	  panel: "panel",
	  content: "panel-content panel-cell panel-cell-narrow panel-cell-short panel-cell-borderless",
	  footer: "panel-footer panel-cell panel-cell-narrow panel-cell-short flush-top",
	  heading: "panel-header panel-cell panel-cell-light panel-cell-narrow panel-cell-shorter"
	};
	
	var Panel = _react2.default.createClass({
	  displayName: "Panel",
	
	  propTypes: {
	    heading: _react2.default.PropTypes.node,
	    footer: _react2.default.PropTypes.node,
	
	    // classes
	    contentClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	    headingClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	    footerClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	    onClick: _react2.default.PropTypes.func
	  },
	
	  getNode: function getNode(nodeName) {
	    var props = this.props;
	
	    var node = props[nodeName];
	
	    if (!node) {
	      return null;
	    }
	
	    var classes = (0, _dedupe2.default)(defaultClasses[nodeName], props[nodeName + "Class"]);
	
	    return _react2.default.createElement(
	      "div",
	      { className: classes },
	      node
	    );
	  },
	  render: function render() {
	    var props = this.props;
	
	    var contentClasses = (0, _dedupe2.default)(defaultClasses.content, props.contentClass);
	    var panelClasses = (0, _dedupe2.default)(defaultClasses.panel, props.className);
	
	    return _react2.default.createElement(
	      "div",
	      { className: panelClasses, onClick: this.props.onClick },
	      this.getNode("heading"),
	      _react2.default.createElement(
	        "div",
	        { className: contentClasses },
	        props.children
	      ),
	      this.getNode("footer")
	    );
	  }
	});
	
	module.exports = Panel;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertPanelHeader = function AlertPanelHeader(props) {
	  return _react2.default.createElement(
	    "h3",
	    { className: "flush-top" },
	    props.children
	  );
	};
	
	AlertPanelHeader.propTypes = {
	  children: _react2.default.PropTypes.node
	};
	
	module.exports = AlertPanelHeader;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _EventTypes = __webpack_require__(933);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _MetadataActions = __webpack_require__(1045);
	
	var _MetadataActions2 = _interopRequireDefault(_MetadataActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetadataStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(MetadataStore, _GetSetBaseStore);
	
	  function MetadataStore() {
	    (0, _classCallCheck3.default)(this, MetadataStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MetadataStore.__proto__ || (0, _getPrototypeOf2.default)(MetadataStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.METADATA_CHANGE,
	        dcosSuccess: _EventTypes.DCOS_METADATA_CHANGE,
	        dcosBuildInfoChange: _EventTypes.DCOS_BUILD_INFO_CHANGE,
	        dcosBuildInfoError: _EventTypes.DCOS_BUILD_INFO_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      var source = payload.source;
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_METADATA:
	          var oldMetadata = _this.get("metadata");
	          var metadata = action.data;
	
	          // only emitting on change
	          if (!(0, _deepEqual2.default)(oldMetadata, metadata)) {
	            _this.set({ metadata: metadata });
	            _this.emitChange(_EventTypes.METADATA_CHANGE);
	          }
	          break;
	        case _ActionTypes.REQUEST_DCOS_METADATA:
	          var oldDCOSMetadata = _this.get("dcosMetadata");
	          var dcosMetadata = action.data;
	
	          // only emitting on change
	          if (!(0, _deepEqual2.default)(oldDCOSMetadata, dcosMetadata)) {
	            _this.set({ dcosMetadata: dcosMetadata });
	            _this.emitChange(_EventTypes.DCOS_METADATA_CHANGE);
	          }
	          break;
	        case _ActionTypes.REQUEST_DCOS_BUILD_INFO_ERROR:
	          _this.emitChange(_EventTypes.DCOS_BUILD_INFO_ERROR);
	          break;
	        case _ActionTypes.REQUEST_DCOS_BUILD_INFO_SUCCESS:
	          var prevDCOSBuildInfo = _this.get("dcosBuildInfo");
	          var nextDCOSBuildInfo = action.data;
	
	          if (!(0, _deepEqual2.default)(prevDCOSBuildInfo, nextDCOSBuildInfo)) {
	            _this.set({ dcosBuildInfo: nextDCOSBuildInfo });
	            _this.emitChange(_EventTypes.DCOS_BUILD_INFO_CHANGE);
	          }
	
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(MetadataStore, [{
	    key: "init",
	    value: function init() {
	      this.set({
	        metadata: {},
	        dcosBuildInfo: null
	      });
	
	      _MetadataActions2.default.fetch();
	    }
	
	    // TODO: DCOS-7430 - Remove emitChange method
	
	  }, {
	    key: "emitChange",
	    value: function emitChange(eventName) {
	      this.emit(eventName);
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "buildDocsURI",
	    value: function buildDocsURI(path) {
	      return _Config2.default.documentationURI + "/" + this.parsedVersion + path;
	    }
	  }, {
	    key: "fetchDCOSBuildInfo",
	    value: function fetchDCOSBuildInfo() {
	      _MetadataActions2.default.fetchDCOSBuildInfo();
	    }
	  }, {
	    key: "version",
	    get: function get() {
	      var metadata = this.get("dcosMetadata");
	
	      return metadata && metadata.version;
	    }
	  }, {
	    key: "parsedVersion",
	    get: function get() {
	      var version = this.version || "latest";
	      version = version.split("-")[0];
	
	      return version.replace(/(.*?)\.(.*?)\..*/, "$1.$2");
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "metadata";
	    }
	  }]);
	  return MetadataStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new MetadataStore();

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetadataActions = {
	  fetchDCOSBuildInfo: function fetchDCOSBuildInfo() {
	    var host = _Config2.default.rootUrl.replace(/:[0-9]{0,4}$/, "");
	    var url = host + "/pkgpanda/active.buildinfo.full.json";
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_DCOS_BUILD_INFO_SUCCESS,
	          data: response
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_DCOS_BUILD_INFO_ERROR,
	          data: xhr.message,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetch: function fetch() {
	    // Checks capability to metadata API
	    if (!_PluginSDK.Hooks.applyFilter("hasCapability", false, "metadataAPI")) {
	      return;
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/metadata",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_METADATA,
	          data: response
	        });
	      }
	    });
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/dcos-metadata/dcos-version.json",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_DCOS_METADATA,
	          data: response
	        });
	      }
	    });
	  }
	};
	
	module.exports = MetadataActions;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _EventTypes = __webpack_require__(933);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  /**
	   * Checks that enough time has elapsed before rendering app
	   *
	   * @param  {Func} onDelayEndCallback Gets called after delay has elapsed
	   */
	  invokeAfterPageLoad: function invokeAfterPageLoad(onDelayEndCallback) {
	    var timeSpentLoading = Date.now() - global.getPageLoadedTime();
	    var msLeftOfDelay = _Config2.default.applicationRenderDelay - timeSpentLoading;
	
	    if (msLeftOfDelay <= 0) {
	      setTimeout(onDelayEndCallback);
	    } else {
	      setTimeout(onDelayEndCallback, msLeftOfDelay);
	    }
	  },
	
	
	  /**
	   * Polls mesos summary endpoint to ensure there's data before rendering
	   *
	   * @param  {Func} onSummaryReceivedCallback Called after summary request response
	   */
	  beginTemporaryPolling: function beginTemporaryPolling(onSummaryReceivedCallback) {
	    var mesosEvents = [_EventTypes.MESOS_SUMMARY_CHANGE, _EventTypes.MESOS_SUMMARY_REQUEST_ERROR];
	
	    _MesosSummaryStore2.default.init();
	
	    function onMesosSummaryChange() {
	      // Keep polling until the system attaches another listener to summary
	      function keepPollingAlive() {
	        if (_MesosSummaryStore2.default.listeners(_EventTypes.MESOS_SUMMARY_CHANGE).length > 1) {
	          _MesosSummaryStore2.default.removeChangeListener(_EventTypes.MESOS_SUMMARY_CHANGE, keepPollingAlive);
	        }
	      }
	
	      _MesosSummaryStore2.default.addChangeListener(_EventTypes.MESOS_SUMMARY_CHANGE, keepPollingAlive);
	
	      mesosEvents.forEach(function (event) {
	        _MesosSummaryStore2.default.removeChangeListener(event, onMesosSummaryChange);
	      });
	
	      onSummaryReceivedCallback();
	    }
	
	    mesosEvents.forEach(function (event) {
	      _MesosSummaryStore2.default.addChangeListener(event, onMesosSummaryChange);
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _EventTypes = __webpack_require__(933);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _MesosSummaryActions = __webpack_require__(1265);
	
	var _MesosSummaryActions2 = _interopRequireDefault(_MesosSummaryActions);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	var _StateSummary = __webpack_require__(1260);
	
	var _StateSummary2 = _interopRequireDefault(_StateSummary);
	
	var _SummaryList = __webpack_require__(1259);
	
	var _SummaryList2 = _interopRequireDefault(_SummaryList);
	
	var _TimeScales = __webpack_require__(1266);
	
	var _TimeScales2 = _interopRequireDefault(_TimeScales);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = null;
	var isInactive = false;
	
	/**
	 * @this {MesosSummaryStore}
	 */
	function startPolling() {
	  var _this = this;
	
	  if (requestInterval == null) {
	    // Should always retrieve bulk summary when polling starts
	    _MesosSummaryActions2.default.fetchSummary(_TimeScales2.default.MINUTE);
	
	    requestInterval = setInterval(function () {
	      var wasInactive = isInactive && !_VisibilityStore2.default.get("isInactive");
	      isInactive = _VisibilityStore2.default.get("isInactive");
	
	      if (!isInactive) {
	        if (wasInactive) {
	          // Flush history with new data set
	          _MesosSummaryActions2.default.fetchSummary(_TimeScales2.default.MINUTE);
	        } else {
	          _MesosSummaryActions2.default.fetchSummary();
	        }
	      } else {
	        // If not active, push null placeholder. This will ensure we maintain
	        // history when navigating back, for case where history server is down.
	
	        // Use {silent: true} Because we only want to push a summary on the stack without side
	        // effects (like re-rendering etc). The tab is out of focus so we
	        // don't want it to do any work. It only matters that there is
	        // appropriate history when we return focus to the tab.
	        _this.processSummaryError({ silent: true });
	      }
	    }, _Config2.default.getRefreshRate());
	  }
	}
	
	function stopPolling() {
	  if (requestInterval != null) {
	    clearInterval(requestInterval);
	    requestInterval = null;
	  }
	}
	
	var MesosSummaryStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(MesosSummaryStore, _GetSetBaseStore);
	
	  function MesosSummaryStore() {
	    (0, _classCallCheck3.default)(this, MesosSummaryStore);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MesosSummaryStore.__proto__ || (0, _getPrototypeOf2.default)(MesosSummaryStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this2,
	      storeID: _this2.storeID,
	      events: {
	        success: _EventTypes.MESOS_SUMMARY_CHANGE,
	        error: _EventTypes.MESOS_SUMMARY_REQUEST_ERROR
	      },
	
	      // When to remove listener
	      unmountWhen: function unmountWhen(store, event) {
	        if (event === "success") {
	          return store.get("statesProcessed");
	        }
	      },
	
	
	      // Set to true to keep listening until unmount
	      listenAlways: true
	    });
	
	    _this2.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        case _ActionTypes.REQUEST_SUMMARY_SUCCESS:
	          _this2.processSummary(action.data);
	          break;
	        case _ActionTypes.REQUEST_SUMMARY_HISTORY_SUCCESS:
	          _this2.processBulkState(action.data);
	          break;
	        case _ActionTypes.REQUEST_SUMMARY_ERROR:
	          _this2.processSummaryError();
	          break;
	        case _ActionTypes.REQUEST_SUMMARY_ONGOING:
	        case _ActionTypes.REQUEST_SUMMARY_HISTORY_ONGOING:
	          _this2.processSummaryError();
	          break;
	      }
	
	      return true;
	    });
	    return _this2;
	  }
	
	  (0, _createClass3.default)(MesosSummaryStore, [{
	    key: "init",
	    value: function init() {
	      this.set({
	        states: this.getInitialStates(),
	        prevMesosStatusesMap: {},
	        statesProcessed: false
	      });
	
	      startPolling.call(this);
	    }
	  }, {
	    key: "getInitialStates",
	    value: function getInitialStates() {
	      var initialStates = _MesosSummaryUtil2.default.getInitialStates().slice();
	      var states = new _SummaryList2.default({ maxLength: _Config2.default.historyLength });
	      initialStates.forEach(function (state) {
	        states.addSnapshot(state, state.date, false);
	      });
	
	      return states;
	    }
	  }, {
	    key: "unmount",
	    value: function unmount() {
	      this.set({
	        states: this.getInitialStates(),
	        prevMesosStatusesMap: {},
	        statesProcessed: false
	      });
	
	      stopPolling();
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        startPolling.call(this);
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return this.listeners(_EventTypes.MESOS_SUMMARY_CHANGE).length > 0;
	    }
	  }, {
	    key: "getActiveServices",
	    value: function getActiveServices() {
	      return this.get("states").lastSuccessful().getServiceList().getItems();
	    }
	  }, {
	    key: "getServiceFromName",
	    value: function getServiceFromName(name) {
	      var services = this.getActiveServices();
	
	      return services.find(function (service) {
	        return service.get("name") === name;
	      });
	    }
	  }, {
	    key: "hasServiceUrl",
	    value: function hasServiceUrl(serviceName) {
	      var service = this.getServiceFromName(serviceName);
	      var webuiUrl = service.get("webui_url");
	
	      return service && webuiUrl != null && webuiUrl.length > 0;
	    }
	  }, {
	    key: "getNextRequestTime",
	    value: function getNextRequestTime() {
	      var lastRequestTime = this.get("lastRequestTime");
	      if (!lastRequestTime) {
	        return Date.now();
	      }
	
	      // We want a consistent interval, this is how we're going to do it
	      return lastRequestTime + _Config2.default.getRefreshRate();
	    }
	  }, {
	    key: "processSummary",
	    value: function processSummary(data) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // If request to Mesos times out we get an empty Object
	      if (!(0, _keys2.default)(data).length) {
	        return this.processSummaryError();
	      }
	
	      var states = this.get("states");
	
	      if (typeof data.date !== "number") {
	        var lastRequestTime = this.getNextRequestTime();
	        this.set({ lastRequestTime: lastRequestTime });
	        data.date = lastRequestTime;
	      }
	
	      _CompositeState2.default.addSummary(data);
	
	      states.addSnapshot(data, data.date);
	
	      if (!options.silent) {
	        this.set({ statesProcessed: true });
	        this.emit(_EventTypes.MESOS_SUMMARY_CHANGE);
	      }
	    }
	  }, {
	    key: "processBulkState",
	    value: function processBulkState(data) {
	      var _this3 = this;
	
	      if (!Array.isArray(data)) {
	        return _MesosSummaryActions2.default.fetchSummary(_TimeScales2.default.MINUTE);
	      }
	
	      // If we get less data than the history length
	      // fill the front with the `n` copies of the earliest snapshot available
	      if (data.length < _Config2.default.historyLength) {
	        var diff = _Config2.default.historyLength - data.length;
	        for (var i = 0; i < diff; i++) {
	          data.unshift(_Util2.default.deepCopy(data[0]));
	        }
	      }
	
	      // Multiply Config.stateRefresh in order to use larger time slices
	      data = _MesosSummaryUtil2.default.addTimestampsToData(data, _Config2.default.getRefreshRate());
	      data.forEach(function (datum) {
	        _this3.processSummary(datum, { silent: true });
	      });
	      this.set({ lastRequestTime: Date.now() });
	      this.emit(_EventTypes.MESOS_SUMMARY_CHANGE);
	    }
	  }, {
	    key: "processSummaryError",
	    value: function processSummaryError() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var unsuccessfulSummary = new _StateSummary2.default({ successful: false });
	      var states = this.get("states");
	
	      this.set({ lastRequestTime: this.getNextRequestTime() });
	
	      states.add(unsuccessfulSummary);
	
	      if (!options.silent) {
	        this.emit(_EventTypes.MESOS_SUMMARY_REQUEST_ERROR);
	      }
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "summary";
	    }
	  }]);
	  return MesosSummaryStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new MesosSummaryStore();

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _NodesList = __webpack_require__(1049);
	
	var _NodesList2 = _interopRequireDefault(_NodesList);
	
	var _ServicesList = __webpack_require__(1059);
	
	var _ServicesList2 = _interopRequireDefault(_ServicesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BLANK_NODE = {
	  health: 3
	};
	
	var mergeData = function mergeData(newData, data) {
	  (0, _keys2.default)(newData).forEach(function (key) {
	    if (Array.isArray(newData[key])) {
	      data[key] = mergeMesosArrays(newData, data, key);
	    } else if ((0, _typeof3.default)(newData[key]) === "object" && data[key]) {
	      // We need to recurse over any nested objects.
	      data[key] = mergeData(newData[key], data[key]);
	    } else {
	      // Any other type of value can be replaced.
	      data[key] = newData[key];
	    }
	  });
	
	  return data;
	};
	
	var mergeMesosArrays = function mergeMesosArrays(newData, data, key) {
	  if (key === "frameworks" || key === "slaves") {
	    // We need to merge the objects within the frameworks and slaves arrays.
	    return mergeObjectsById(newData[key], data[key]);
	  } else {
	    // We can replace any other array.
	    return newData[key];
	  }
	};
	
	var mergeObjectsById = function mergeObjectsById(newData) {
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  // Merge the incoming data with the old data.
	  return newData.map(function (newDatum) {
	    var oldDatum = data.find(function (datum) {
	      return datum.id === newDatum.id;
	    });
	
	    // These objects don't need to be deeply merged.
	    return (0, _assign2.default)({}, oldDatum, newDatum);
	  });
	};
	
	var CompositeState = function () {
	  function CompositeState() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, CompositeState);
	
	    this.data = data;
	  }
	
	  (0, _createClass3.default)(CompositeState, [{
	    key: "addMarathonApps",
	    value: function addMarathonApps(data) {
	      if ((0, _keys2.default)(this.data).length === 0) {
	        return;
	      }
	
	      this.data.frameworks.forEach(function (service) {
	        // Marathon data merged by service name because Marathon doesn't know id.
	        // See MarathonStore.processMarathonGroups
	        if (data[service.name]) {
	          service._meta = (0, _assign2.default)({}, service._meta, {
	            marathon: data[service.name]
	          });
	        }
	      });
	    }
	  }, {
	    key: "addNodeHealth",
	    value: function addNodeHealth(data) {
	      if (data == null) {
	        return;
	      }
	
	      var oldData = this.data.slaves || [];
	      var dataByIP = {};
	
	      data.forEach(function (datum) {
	        dataByIP[datum.host_ip] = datum;
	      });
	
	      var newData = oldData.map(function (oldDatum) {
	        var matchedNode = dataByIP[oldDatum.hostname] || BLANK_NODE;
	
	        return (0, _assign2.default)({}, oldDatum, matchedNode);
	      });
	
	      this.data = (0, _extends3.default)({}, this.data, {
	        slaves: newData
	      });
	    }
	  }, {
	    key: "addState",
	    value: function addState(data) {
	      this.data = mergeData(data, this.data);
	    }
	  }, {
	    key: "addSummary",
	    value: function addSummary(data) {
	      this.data = mergeData(data, this.data);
	    }
	  }, {
	    key: "getServiceList",
	    value: function getServiceList() {
	      return new _ServicesList2.default({
	        items: this.data.frameworks
	      });
	    }
	  }, {
	    key: "getNodesList",
	    value: function getNodesList() {
	      if (this._nodesList === null) {
	        this._nodesList = new _NodesList2.default({ items: this.data.slaves });
	      }
	
	      return this._nodesList;
	    }
	  }, {
	    key: "data",
	    set: function set(newData) {
	      this._data = newData;
	      this._nodesList = null;
	    },
	    get: function get() {
	      return this._data;
	    }
	  }]);
	  return CompositeState;
	}();
	
	module.exports = new CompositeState({ frameworks: [], slaves: [] });

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodesList = function (_List) {
	  (0, _inherits3.default)(NodesList, _List);
	
	  function NodesList() {
	    (0, _classCallCheck3.default)(this, NodesList);
	    return (0, _possibleConstructorReturn3.default)(this, (NodesList.__proto__ || (0, _getPrototypeOf2.default)(NodesList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NodesList, [{
	    key: "filter",
	    value: function filter(filters) {
	      var hosts = this.getItems();
	
	      if (filters) {
	        // Marathon API
	        if (filters.ids) {
	          hosts = hosts.filter(function (host) {
	            return filters.ids.includes(host.id);
	          });
	        }
	
	        // Marathon API
	        if (filters.service != null) {
	          hosts = _MesosSummaryUtil2.default.filterHostsByService(hosts, filters.service);
	        }
	
	        // Marathon APIs
	        if (filters.name) {
	          hosts = _StringUtil2.default.filterByString(hosts, "hostname", filters.name);
	        }
	
	        // Component Health APIs
	        if (filters.ip) {
	          hosts = _StringUtil2.default.filterByString(hosts, "host_ip", filters.ip);
	        }
	
	        // Component Health API
	        if (filters.health) {
	          hosts = _UnitHealthUtil2.default.filterByHealth(hosts, filters.health);
	        }
	      }
	
	      return new NodesList({ items: hosts });
	    }
	  }, {
	    key: "sumUsedResources",
	    value: function sumUsedResources() {
	      var services = this.getItems();
	      var resourcesList = services.map(function (service) {
	        return service.used_resources;
	      });
	
	      return _MesosSummaryUtil2.default.sumResources(resourcesList);
	    }
	  }, {
	    key: "sumResources",
	    value: function sumResources() {
	      var services = this.getItems();
	      var resourcesList = services.map(function (service) {
	        return service.resources;
	      });
	
	      return _MesosSummaryUtil2.default.sumResources(resourcesList);
	    }
	  }]);
	  return NodesList;
	}(_List3.default);
	
	NodesList.type = _Node2.default;
	
	module.exports = NodesList;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Maths = __webpack_require__(1051);
	
	var _Maths2 = _interopRequireDefault(_Maths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MesosSummaryUtil = {
	  sumResources: function sumResources(resourceList) {
	    return resourceList.reduce(function (memo, resource) {
	      if (resource == null) {
	        return memo;
	      }
	
	      (0, _keys2.default)(memo).forEach(function (key) {
	        memo[key] = memo[key] + resource[key];
	      });
	
	      return memo;
	    }, { cpus: 0, mem: 0, disk: 0 });
	  },
	  stateResourcesToResourceStates: function stateResourcesToResourceStates(stateResources) {
	    // Transpose from [{date, resources, totalResources}, ...]
	    // to {resource: [{date, value, percentage}, ...], resource: ...}
	    var resources = { cpus: [], mem: [], disk: [] };
	    var resourceTypes = (0, _keys2.default)(resources);
	
	    stateResources.forEach(function (stateResource) {
	      resourceTypes.forEach(function (resourceType) {
	        var percentage = null,
	            value = null;
	
	        if (stateResource.resources != null) {
	          var max = Math.max(1, stateResource.totalResources[resourceType]);
	          value = stateResource.resources[resourceType];
	          percentage = _Maths2.default.round(100 * value / max);
	        }
	
	        resources[resourceType].push({
	          date: stateResource.date,
	          percentage: percentage,
	          value: value
	        });
	      });
	    });
	
	    return resources;
	  },
	  filterHostsByService: function filterHostsByService(hosts, frameworkId) {
	    return hosts.filter(function (host) {
	      return host.framework_ids.includes(frameworkId);
	    });
	  },
	  getInitialStates: function getInitialStates() {
	    var currentDate = Date.now();
	    // reverse date range!!!
	    var reverseRange = [];
	
	    for (var i = _Config2.default.historyLength; i > 0; i--) {
	      reverseRange.push(-i);
	    }
	
	    return reverseRange.map(function (i) {
	      return (0, _assign2.default)(MesosSummaryUtil.getEmptyState(), {
	        date: currentDate + i * _Config2.default.getRefreshRate()
	      });
	    });
	  },
	  getEmptyState: function getEmptyState() {
	    return {
	      frameworks: [],
	      slaves: [],
	      used_resources: { cpus: 0, mem: 0, disk: 0 },
	      total_resources: { cpus: 0, mem: 0, disk: 0 }
	    };
	  },
	  addTimestampsToData: function addTimestampsToData(data, timeStep) {
	    var length = data.length;
	    var timeNow = Date.now() + timeStep;
	
	    return data.map(function (datum, i) {
	      var timeDelta = (-length + i) * timeStep;
	      datum.date = timeNow + timeDelta;
	
	      return datum;
	    });
	  }
	};
	
	module.exports = MesosSummaryUtil;

/***/ },
/* 1051 */
/***/ function(module, exports) {

	"use strict";
	
	var Maths = {
	  round: function round(value, precision) {
	    precision = precision || 0;
	    var factor = Math.pow(10, precision);
	
	    return Math.round(value * factor) / factor;
	  },
	  sum: function sum(array) {
	    var sum = 0;
	
	    array.forEach(function (value) {
	      if (Array.isArray(value)) {
	        sum += this.sum(value);
	      } else {
	        sum += value;
	      }
	    }, this);
	
	    return sum;
	  },
	  mean: function mean(array) {
	    return Maths.sum(array) / array.length;
	  },
	
	
	  /**
	   * maps to domain (0,1)
	   *
	   * @param  {Number} value Number in range
	   * @param  {Object} stats
	   * @param  {Number} stats.min Minimum in range
	   * @param  {Number} stats.max Maximum in range
	   * @return {Number} A mapped number between (0,1)
	   **/
	  mapValue: function mapValue(value, stats) {
	    value = parseFloat(value);
	
	    var range = stats.max - stats.min;
	    var min = stats.min;
	
	    if (range === 0) {
	      return min;
	    }
	
	    var v = (value - min) / range;
	
	    if (isNaN(v)) {
	      return undefined;
	    } else {
	      return v;
	    }
	  },
	
	
	  /**
	   * pass in between 0 and 1
	   *
	   * @param  {Number} value Mapped number between (0,1)
	   * @param  {Object} stats
	   * @param  {Number} stats.min Minimum in range
	   * @param  {Number} stats.max Maximum in range
	   * @return {Number} An unmapped number between in the provided range
	   **/
	  unmapValue: function unmapValue(value, stats) {
	    value = stats.min + value * (stats.max - stats.min);
	
	    if (isNaN(value)) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	};
	
	module.exports = Maths;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Node = function (_Item) {
	  (0, _inherits3.default)(Node, _Item);
	
	  function Node() {
	    (0, _classCallCheck3.default)(this, Node);
	    return (0, _possibleConstructorReturn3.default)(this, (Node.__proto__ || (0, _getPrototypeOf2.default)(Node)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Node, [{
	    key: "getID",
	    value: function getID() {
	      return this.get("id");
	    }
	  }, {
	    key: "getServiceIDs",
	    value: function getServiceIDs() {
	      return this.get("framework_ids");
	    }
	  }, {
	    key: "isActive",
	    value: function isActive() {
	      return this.get("active");
	    }
	  }, {
	    key: "getUsageStats",
	    value: function getUsageStats(resource) {
	      var total = this.get("resources")[resource];
	      var value = this.get("used_resources")[resource];
	      var percentage = Math.round(100 * value / Math.max(1, total));
	
	      return { percentage: percentage, total: total, value: value };
	    }
	  }, {
	    key: "getHostName",
	    value: function getHostName() {
	      return this.get("hostname");
	    }
	
	    // Below is Component Health specific API
	    // http://schema.dcos/system/health/node
	
	  }, {
	    key: "getHealth",
	    value: function getHealth() {
	      return _UnitHealthUtil2.default.getHealth(this.get("health"));
	    }
	  }, {
	    key: "getOutput",
	    value: function getOutput() {
	      if ((0, _typeof3.default)(this.get("output")) === undefined) {
	        return "N/A";
	      }
	
	      return this.get("output") || "OK";
	    }
	  }, {
	    key: "sumTaskTypesByState",
	    value: function sumTaskTypesByState(state) {
	      var sum = 0;
	
	      (0, _keys2.default)(_TaskStates2.default).forEach(function (taskType) {
	        if (_TaskStates2.default[taskType].stateTypes.indexOf(state) !== -1) {
	          // Make sure there's a value
	          if (this[taskType]) {
	            sum += this[taskType];
	          }
	        }
	      }, this);
	
	      return sum;
	    }
	  }]);
	  return Node;
	}(_Item3.default);
	
	module.exports = Node;

/***/ },
/* 1053 */
/***/ function(module, exports) {

	"use strict";
	
	var TaskStates = {
	  TASK_CREATED: {
	    stateTypes: ["active", "success"],
	    displayName: "Created"
	  },
	
	  TASK_STAGING: {
	    stateTypes: ["active", "success"],
	    displayName: "Staging"
	  },
	
	  TASK_STARTING: {
	    stateTypes: ["active", "success"],
	    displayName: "Starting"
	  },
	
	  TASK_STARTED: {
	    stateTypes: ["active", "success"],
	    displayName: "Started"
	  },
	
	  TASK_RUNNING: {
	    stateTypes: ["active", "success"],
	    displayName: "Running"
	  },
	
	  TASK_KILLING: {
	    stateTypes: ["active", "failure"],
	    displayName: "Killing"
	  },
	
	  TASK_FINISHED: {
	    stateTypes: ["completed", "success"],
	    displayName: "Finished"
	  },
	
	  TASK_KILLED: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Killed"
	  },
	
	  TASK_FAILED: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Failed"
	  },
	
	  TASK_LOST: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Lost"
	  },
	
	  TASK_ERROR: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Error"
	  },
	
	  TASK_GONE: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Gone"
	  },
	
	  TASK_GONE_BY_OPERATOR: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Gone by operator"
	  },
	
	  TASK_DROPPED: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Dropped"
	  },
	
	  TASK_UNREACHABLE: {
	    stateTypes: ["active", "failure"],
	    displayName: "Unreachable"
	  },
	
	  TASK_UNKNOWN: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Unknown"
	  }
	};
	
	module.exports = TaskStates;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _UnitHealthStatus = __webpack_require__(1055);
	
	var _UnitHealthStatus2 = _interopRequireDefault(_UnitHealthStatus);
	
	var _UnitHealthTypes = __webpack_require__(1056);
	
	var _UnitHealthTypes2 = _interopRequireDefault(_UnitHealthTypes);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitHealthUtil = {
	  getHealthSortFunction: function getHealthSortFunction() {
	    return _TableUtil2.default.getSortFunction("id", function (item, prop) {
	      // TODO: Deprecate sorting conditions by prop
	      if (prop === "health") {
	        return UnitHealthUtil.getHealthSorting(item);
	      }
	
	      if (prop === "id" || prop === "name") {
	        return item.getTitle();
	      }
	
	      return item.get(prop);
	    }).apply(undefined, arguments);
	  },
	
	
	  // Gets the HealthSorting weight of a Node or HealthUnit
	  getHealthSorting: function getHealthSorting(item) {
	    return item.getHealth().value;
	  },
	
	
	  /**
	   * Get UnitHealthStatus object representing the health of an Item
	   * @param {Number} health - The health integer from Component Health API.
	   * @return {Object}       - UnitHealthStatus object.
	   */
	  getHealth: function getHealth(health) {
	    var healthKey = (0, _keys2.default)(_UnitHealthStatus2.default).find(function (key) {
	      return _UnitHealthStatus2.default[key].value === health;
	    });
	
	    return _UnitHealthStatus2.default[healthKey] || _UnitHealthStatus2.default[_UnitHealthTypes2.default.SERVER_NA];
	  },
	
	
	  /**
	   * Filter a List by UnitHealth.
	   * @param {Array}  items  - Array of Nodes or HealthUnits to be filtered.
	   * @param {String} health - Health title to filter by.
	   * @return {Array}        - Array of filtered objects.
	   */
	  filterByHealth: function filterByHealth(items, health) {
	    health = _Util2.default.toLowerCaseIfString(health);
	
	    if (health === "all") {
	      return items;
	    }
	
	    return items.filter(function (datum) {
	      if (health.length > 1) {
	        return _Util2.default.toLowerCaseIfString(datum.getHealth().title) === health;
	      }
	
	      return datum.getHealth().value === +health;
	    });
	  }
	};
	
	module.exports = UnitHealthUtil;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _UnitHealthStatus;
	
	var _UnitHealthTypes = __webpack_require__(1056);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * sortingValue = Order health types by it's label and number value
	 * This will depend on the sorting method/function
	 * suggested use is ascending 0 meaning ((top of the list)) more important
	 * visibility and 3 meaning least important (bottom of the order)
	 */
	var UnitHealthStatus = (_UnitHealthStatus = {}, (0, _defineProperty3.default)(_UnitHealthStatus, _UnitHealthTypes.SERVER_HEALTHY, {
	  title: "Healthy",
	  key: "HEALTHY",
	  classNames: "text-success",
	  sortingValue: 3,
	  value: _UnitHealthTypes.SERVER_HEALTHY
	}), (0, _defineProperty3.default)(_UnitHealthStatus, _UnitHealthTypes.SERVER_UNHEALTHY, {
	  title: "Unhealthy",
	  key: "UNHEALTHY",
	  classNames: "text-danger",
	  sortingValue: 0,
	  value: _UnitHealthTypes.SERVER_UNHEALTHY
	}), (0, _defineProperty3.default)(_UnitHealthStatus, _UnitHealthTypes.SERVER_WARN, {
	  title: "Warning",
	  key: "WAR",
	  classNames: "text-warning",
	  sortingValue: 2,
	  value: _UnitHealthTypes.SERVER_WARN
	}), (0, _defineProperty3.default)(_UnitHealthStatus, _UnitHealthTypes.SERVER_NA, {
	  title: "N/A",
	  key: "NA",
	  classNames: "text-mute",
	  sortingValue: 1,
	  value: _UnitHealthTypes.SERVER_NA
	}), _UnitHealthStatus);
	
	module.exports = UnitHealthStatus;

/***/ },
/* 1056 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Values for health value defined in the server
	 */
	module.exports = {
	  SERVER_HEALTHY: 0,
	  SERVER_UNHEALTHY: 1,
	  SERVER_WARN: 2,
	  SERVER_NA: 3
	};

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _HealthSorting = __webpack_require__(1058);
	
	var _HealthSorting2 = _interopRequireDefault(_HealthSorting);
	
	var _UnitHealthStatus = __webpack_require__(1055);
	
	var _UnitHealthStatus2 = _interopRequireDefault(_UnitHealthStatus);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableUtil = {
	  /**
	   * WARNING: When removing/modifying this function be aware of comments/sizes
	   * in variables-layout.less
	   * Returns an integer of what the expected height of a
	   * row will be given the current window dimensions.
	   *
	   * @return {Integer} Expected row height
	   */
	  getRowHeight: function getRowHeight() {
	    var defaultRowSize = 29;
	    var definitionList = {
	      mini: { screen: 480, rowHeight: 32 },
	      small: { screen: 768, rowHeight: 37 },
	      medium: { screen: 992, rowHeight: 45 },
	      large: { screen: 1270, rowHeight: 52 }
	    };
	
	    var rowHeight = null;
	    var windowWidth = global.innerWidth;
	    (0, _keys2.default)(definitionList).forEach(function (size) {
	      if (windowWidth >= definitionList[size].screen) {
	        rowHeight = definitionList[size].rowHeight;
	      }
	    });
	
	    return rowHeight || defaultRowSize;
	  },
	  compareValues: function compareValues(a, b, aTieBreaker, bTieBreaker) {
	    a = _Util2.default.toLowerCaseIfString(a);
	    b = _Util2.default.toLowerCaseIfString(b);
	    aTieBreaker = _Util2.default.toLowerCaseIfString(aTieBreaker);
	    bTieBreaker = _Util2.default.toLowerCaseIfString(bTieBreaker);
	    if (a === b || a == null || b == null) {
	      a = aTieBreaker;
	      b = bTieBreaker;
	    }
	
	    if (a > b) {
	      return 1;
	    }
	    if (a < b) {
	      return -1;
	    }
	
	    return 0;
	  },
	
	
	  /**
	   * High order function that will provide another high order function to get
	   * sort function for tables.
	   * @param  {String} tieBreakerProp property to break ties with
	   * @param  {Function} getProperty function that takes an item and a
	   * property string and returns a value
	   *
	   * @return {Function} A high order function that will, given a property
	   * string and a sort order ('asc' or 'desc'), return a comparator function
	   * between two items
	   */
	  getSortFunction: function getSortFunction(tieBreakerProp, getProperty) {
	    return function (prop, order) {
	      return function (a, b) {
	        return TableUtil.compareValues(getProperty(a, prop, order), getProperty(b, prop, order), getProperty(a, tieBreakerProp, order), getProperty(b, tieBreakerProp, order));
	      };
	    };
	  },
	
	
	  /**
	   * Normalize param received and try mapping to HealthSorting
	   * if not able to mapping default to HealthSorting.NA
	   *
	   * @param {String|Number} healthValue
	   * @returns {Number} HealthSorting value
	   */
	  getHealthSortingValue: function getHealthSortingValue(healthValue) {
	    var match = void 0;
	
	    if (typeof healthValue == "number") {
	      match = _UnitHealthStatus2.default[healthValue].sortingValue;
	    }
	
	    if (typeof healthValue == "string") {
	      healthValue = _Util2.default.toUpperCaseIfString(healthValue);
	      match = _HealthSorting2.default[healthValue];
	    }
	
	    // defaults to NA if can't map to a health sorting value
	    if (typeof match === "undefined") {
	      match = _HealthSorting2.default.NA;
	    }
	
	    return match;
	  },
	
	
	  /**
	   * Sort health status
	   * based on HealthSorting mapping value
	   * where lowest (0) (top of the list) is most important for visibility
	   * and highest (3) (bottom of the list) 3 is least important for visibility
	   *
	   * @param {Object} a
	   * @param {Object} b
	   * @returns {Number} item position
	   */
	  sortHealthValues: function sortHealthValues(a, b) {
	    var aTieBreaker = _Util2.default.toLowerCaseIfString(a.name);
	    var bTieBreaker = _Util2.default.toLowerCaseIfString(b.name);
	
	    a = TableUtil.getHealthSortingValue(a.health);
	    b = TableUtil.getHealthSortingValue(b.health);
	
	    if (a === b) {
	      a = aTieBreaker;
	      b = bTieBreaker;
	    }
	
	    if (a > b) {
	      return 1;
	    }
	    if (a < b) {
	      return -1;
	    }
	
	    return 0;
	  },
	
	
	  /**
	  *
	  * @returns {Function} sortHealthValues
	  */
	  getHealthSortingOrder: function getHealthSortingOrder() {
	    return TableUtil.sortHealthValues;
	  }
	};
	
	module.exports = TableUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1058 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Order health types by it's label and number value
	 * This will depend on the sorting method/function
	 * suggested use is ascending 0 meaning ((top of the list)) more important
	 * visibility and 3 meaning least important (bottom of the order)
	 */
	var HealthSorting = {
	  UNHEALTHY: 0,
	  HEALTHY: 3,
	  IDLE: 2,
	  NA: 1,
	  WARN: 2
	};
	
	module.exports = HealthSorting;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesList = function (_List) {
	  (0, _inherits3.default)(ServicesList, _List);
	
	  function ServicesList() {
	    (0, _classCallCheck3.default)(this, ServicesList);
	    return (0, _possibleConstructorReturn3.default)(this, (ServicesList.__proto__ || (0, _getPrototypeOf2.default)(ServicesList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServicesList, [{
	    key: "filter",
	    value: function filter(filters) {
	      var services = this.getItems();
	
	      if (filters) {
	        if (filters.ids) {
	          services = services.filter(function (service) {
	            return filters.ids.includes(service.id);
	          });
	        }
	
	        if (filters.name) {
	          services = _StringUtil2.default.filterByString(services, "name", filters.name);
	        }
	
	        if (filters.health != null && filters.health.length !== 0) {
	          services = services.filter(function (service) {
	            return filters.health.some(function (healthValue) {
	              return service.getHealth().value === parseInt(healthValue, 10);
	            });
	          });
	        }
	      }
	
	      return new ServicesList({ items: services });
	    }
	  }, {
	    key: "sumUsedResources",
	    value: function sumUsedResources() {
	      var services = this.getItems();
	      var resourcesList = services.map(function (service) {
	        return service.used_resources;
	      });
	
	      return _MesosSummaryUtil2.default.sumResources(resourcesList);
	    }
	  }, {
	    key: "sumTaskStates",
	    value: function sumTaskStates() {
	      var services = this.getItems();
	
	      var tasks = {
	        TASK_STAGING: 0,
	        TASK_STARTING: 0,
	        TASK_RUNNING: 0,
	        TASK_FINISHED: 0,
	        TASK_FAILED: 0,
	        TASK_LOST: 0,
	        TASK_ERROR: 0
	      };
	
	      if (services.length === 0) {
	        return tasks;
	      }
	
	      var taskTypes = (0, _keys2.default)(tasks);
	
	      services.forEach(function (service) {
	        taskTypes.forEach(function (taskType) {
	          if (service[taskType]) {
	            tasks[taskType] += service[taskType];
	          }
	        });
	      });
	
	      return tasks;
	    }
	  }]);
	  return ServicesList;
	}(_List3.default);
	
	ServicesList.type = _Framework2.default;
	
	module.exports = ServicesList;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _CleanJSONUtil = __webpack_require__(1065);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _FrameworkConstants = __webpack_require__(1069);
	
	var _Application2 = __webpack_require__(1070);
	
	var _Application3 = _interopRequireDefault(_Application2);
	
	var _FrameworkSpec = __webpack_require__(1099);
	
	var _FrameworkSpec2 = _interopRequireDefault(_FrameworkSpec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Application) {
	  (0, _inherits3.default)(Framework, _Application);
	
	  function Framework() {
	    (0, _classCallCheck3.default)(this, Framework);
	
	    // The variable is prefixed because `Item` will expose all the properties
	    // it gets as a properties of this object and we want to avoid any naming
	    // collisions.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Framework.__proto__ || (0, _getPrototypeOf2.default)(Framework)).apply(this, arguments));
	
	    _this._spec = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Framework, [{
	    key: "getPackageName",
	    value: function getPackageName() {
	      return this.getLabels().DCOS_PACKAGE_NAME;
	    }
	  }, {
	    key: "getFrameworkName",
	    value: function getFrameworkName() {
	      return this.getLabels().DCOS_PACKAGE_FRAMEWORK_NAME;
	    }
	  }, {
	    key: "getNodeIDs",
	    value: function getNodeIDs() {
	      return this.get("slave_ids");
	    }
	  }, {
	    key: "getResourceID",
	    value: function getResourceID() {
	      var regexp = new RegExp("[^" + _FrameworkConstants.FRAMEWORK_ID_VALID_CHARACTERS + "]", "g");
	
	      // Strip non-alphanumeric chars from name for safety
	      return _FrameworkConstants.ROUTE_ACCESS_PREFIX + (this.get("name") || "").replace(regexp, "");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getSpec",
	    value: function getSpec() {
	      if (this._spec == null) {
	        // State and other _useless_ information is removed to create a clean
	        // service spec.
	        this._spec = new _FrameworkSpec2.default((0, _CleanJSONUtil.cleanServiceJSON)(this.get()));
	      }
	
	      return this._spec;
	    }
	  }, {
	    key: "getTasksSummary",
	    value: function getTasksSummary() {
	      var isSDK = (0, _ServiceUtil.isSDKService)(this);
	      // TODO: Circular reference workaround DCOS_OSS-783
	      var MesosStateStore = __webpack_require__(1100);
	
	      var tasksSummary = (0, _assign2.default)({}, (0, _get3.default)(Framework.prototype.__proto__ || (0, _getPrototypeOf2.default)(Framework.prototype), "getTasksSummary", this).call(this));
	      var tasks = MesosStateStore.getTasksByService(this) || [];
	      var tasksRunning = this.get("TASK_RUNNING") || 0;
	      tasksSummary.tasksRunning += tasksRunning;
	      tasksSummary.tasksUnknown += tasksRunning;
	
	      tasks.reduce(function (memo, task) {
	        if (task.state !== "TASK_RUNNING" || task.isStartedByMarathon) {
	          return memo;
	        }
	        if (task.statuses != null) {
	          return task.statuses.reduce(function (memo, status) {
	            if (status.healthy || isSDK && status.healthy === undefined) {
	              memo.tasksHealthy++;
	              memo.tasksUnknown--;
	            }
	            if (status.healthy === false) {
	              memo.tasksUnhealthy++;
	              memo.tasksUnknown--;
	            }
	
	            return memo;
	          }, memo);
	        }
	
	        return memo;
	      }, tasksSummary);
	
	      return tasksSummary;
	    }
	  }, {
	    key: "getUsageStats",
	    value: function getUsageStats(resource) {
	      var value = this.get("used_resources")[resource];
	
	      return { value: value };
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      // There's an unfortunate naming issue in Mesos.
	      // used_resources is actually allocated resources
	      // the name can't be changed to keep backward compatibility.
	      // This is why `getResources` returns `used_resources`
	      var allocatedFrameworkResources = this.get("used_resources") || {
	        cpus: 0,
	        mem: 0,
	        gpus: 0,
	        disk: 0
	      };
	
	      // Framework doesn't know how many resources its scheduler consumes.
	      // Scheduler is launched by Marathon not the Framework itself.
	      // So we should get this information separately from the Marathon spec
	      var schedulerResources = this.getSpec().getResources();
	
	      return {
	        cpus: allocatedFrameworkResources.cpus + schedulerResources.cpus,
	        mem: allocatedFrameworkResources.mem + schedulerResources.mem,
	        gpus: allocatedFrameworkResources.gpus + schedulerResources.gpus,
	        disk: allocatedFrameworkResources.disk + schedulerResources.disk
	      };
	    }
	  }]);
	  return Framework;
	}(_Application3.default);

/***/ },
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.cleanJobJSON = cleanJobJSON;
	exports.cleanServiceJSON = cleanServiceJSON;
	
	var _JobConfig = __webpack_require__(1066);
	
	var _JobConfig2 = _interopRequireDefault(_JobConfig);
	
	var _ServiceSpecConstants = __webpack_require__(1067);
	
	var _ServiceSpecConstants2 = _interopRequireDefault(_ServiceSpecConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cleanJobJSON(jsonSpec) {
	  return cleanJSON(jsonSpec, _JobConfig2.default);
	}
	
	function cleanServiceJSON(jsonDefinition) {
	  return cleanJSON(jsonDefinition, _ServiceSpecConstants2.default);
	}
	
	function cleanJSON(json, config) {
	  return (0, _keys2.default)(json).filter(function (key) {
	    return !config.BLACKLIST.includes(key);
	  }).reduce(function (memo, key) {
	    memo[key] = json[key];
	
	    return memo;
	  }, {});
	}

/***/ },
/* 1066 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceConfig = {
	  BLACKLIST: ["activeRuns", "history", "historySummary"]
	};
	
	module.exports = ServiceConfig;

/***/ },
/* 1067 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceSpecConstants = {
	  /**
	   *  List of service `_itemData` keys that don't belong to a service spec
	   *  as the data is either describing the service state or from sources
	   *  other than Marathon.
	   *
	   * @type {array.<string>}
	   */
	  BLACKLIST: ["uris", "ports", "version", "versions", "versionInfo", "deployments", "queue", "lastTaskFailure", "tasks", "taskStats", "tasksHealthy", "tasksRunning", "tasksStaged", "tasksUnhealthy", "name", "pid", "used_resources", "offered_resources", "capabilities", "hostname", "webui_url", "active", "TASK_STAGING", "TASK_STARTING", "TASK_RUNNING", "TASK_KILLING", "TASK_FINISHED", "TASK_KILLED", "TASK_FAILED", "TASK_LOST", "TASK_ERROR", "slave_ids", "volumes"]
	};
	
	module.exports = ServiceSpecConstants;

/***/ },
/* 1068 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceUtil = {
	  isSDKService: function isSDKService() {
	    var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (typeof service.getLabels !== "function") {
	      return false;
	    }
	
	    var labels = service.getLabels();
	
	    return labels.DCOS_COMMONS_API_VERSION != null;
	  },
	  isPackage: function isPackage() {
	    var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (typeof service.getLabels !== "function") {
	      return false;
	    }
	
	    var labels = service.getLabels();
	
	    return labels.DCOS_PACKAGE_NAME != null;
	  }
	};
	
	module.exports = ServiceUtil;

/***/ },
/* 1069 */
/***/ function(module, exports) {

	"use strict";
	
	var constants = {
	  ROUTE_ACCESS_PREFIX: "dcos:adminrouter:service:",
	  FRAMEWORK_ID_VALID_CHARACTERS: "\\w-"
	};
	
	constants.FRAMEWORK_RESOURCE_ID_REGEXP = new RegExp("^" + constants.ROUTE_ACCESS_PREFIX + "[" + constants.FRAMEWORK_ID_VALID_CHARACTERS + "]+$");
	
	module.exports = constants;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _CleanJSONUtil = __webpack_require__(1065);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _FrameworkUtil = __webpack_require__(1080);
	
	var _FrameworkUtil2 = _interopRequireDefault(_FrameworkUtil);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _Service2 = __webpack_require__(1090);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	var _TaskStats = __webpack_require__(1097);
	
	var _TaskStats2 = _interopRequireDefault(_TaskStats);
	
	var _VolumeList = __webpack_require__(1094);
	
	var _VolumeList2 = _interopRequireDefault(_VolumeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Service) {
	  (0, _inherits3.default)(Application, _Service);
	
	  function Application() {
	    (0, _classCallCheck3.default)(this, Application);
	
	    // The variable is prefixed because `Item` will expose all the properties
	    // it gets as a properties of this object and we want to avoid any naming
	    // collisions.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).apply(this, arguments));
	
	    _this._spec = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Application, [{
	    key: "getDeployments",
	    value: function getDeployments() {
	      return this.get("deployments");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getSpec",
	    value: function getSpec() {
	      if (this._spec == null) {
	        // State and other _useless_ information is removed to create a clean
	        // service spec.
	        this._spec = new _ApplicationSpec2.default((0, _CleanJSONUtil.cleanServiceJSON)(this.get()));
	      }
	
	      return this._spec;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getHealth",
	    value: function getHealth() {
	      var _getTasksSummary = this.getTasksSummary(),
	          tasksHealthy = _getTasksSummary.tasksHealthy,
	          tasksUnhealthy = _getTasksSummary.tasksUnhealthy,
	          tasksRunning = _getTasksSummary.tasksRunning;
	
	      var healthChecks = this.getSpec().getHealthChecks();
	
	      if (tasksUnhealthy > 0) {
	        return _HealthStatus2.default.UNHEALTHY;
	      }
	
	      if (tasksRunning > 0 && tasksHealthy === tasksRunning) {
	        return _HealthStatus2.default.HEALTHY;
	      }
	
	      if (healthChecks && tasksRunning === 0) {
	        return _HealthStatus2.default.IDLE;
	      }
	
	      return _HealthStatus2.default.NA;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getImages",
	    value: function getImages() {
	      return _FrameworkUtil2.default.getServiceImages(this.getMetadata().images);
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getInstancesCount",
	    value: function getInstancesCount() {
	      return this.get("instances") || 0;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.getSpec().getLabels() || {};
	    }
	  }, {
	    key: "getLastConfigChange",
	    value: function getLastConfigChange() {
	      return this.getVersionInfo().lastConfigChangeAt;
	    }
	  }, {
	    key: "getLastScaled",
	    value: function getLastScaled() {
	      return this.getVersionInfo().lastScalingAt;
	    }
	  }, {
	    key: "getLastTaskFailure",
	    value: function getLastTaskFailure() {
	      return this.get("lastTaskFailure");
	    }
	  }, {
	    key: "getMetadata",
	    value: function getMetadata() {
	      return _FrameworkUtil2.default.getMetadataFromLabels(this.getLabels());
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId().split("/").pop();
	    }
	  }, {
	    key: "getPorts",
	    value: function getPorts() {
	      return this.get("ports");
	    }
	  }, {
	    key: "getResidency",
	    value: function getResidency() {
	      return this.get("residency");
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      var status = this.getServiceStatus();
	      if (status.displayName == null) {
	        return null;
	      }
	
	      return status.displayName;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getServiceStatus",
	    value: function getServiceStatus() {
	      var _getTasksSummary2 = this.getTasksSummary(),
	          tasksRunning = _getTasksSummary2.tasksRunning;
	
	      var deployments = this.getDeployments();
	      var queue = this.getQueue();
	
	      var instances = this.getInstancesCount();
	      if (instances === 0 && tasksRunning === 0) {
	        return _ServiceStatus2.default.SUSPENDED;
	      }
	
	      if (queue != null && queue.delay) {
	        if (queue.delay.overdue) {
	          return _ServiceStatus2.default.WAITING;
	        }
	
	        return _ServiceStatus2.default.DELAYED;
	      }
	
	      if (deployments != null && deployments.length > 0) {
	        return _ServiceStatus2.default.DEPLOYING;
	      }
	
	      if (tasksRunning > 0) {
	        return _ServiceStatus2.default.RUNNING;
	      }
	
	      return _ServiceStatus2.default.NA;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getTasksSummary",
	    value: function getTasksSummary() {
	      var healthData = {
	        tasksHealthy: this.get("tasksHealthy"),
	        tasksStaged: this.get("tasksStaged"),
	        tasksUnhealthy: this.get("tasksUnhealthy"),
	        tasksUnknown: Math.max(0, this.get("tasksRunning") - this.get("tasksHealthy") - this.get("tasksUnhealthy"))
	      };
	
	      var tasksSum = (0, _keys2.default)(healthData).reduce(function (sum, healthItem) {
	        return sum + healthData[healthItem];
	      }, 0);
	
	      healthData.tasksOverCapacity = Math.max(0, tasksSum - this.getInstancesCount());
	
	      healthData.tasksRunning = this.get("tasksRunning");
	
	      return healthData;
	    }
	  }, {
	    key: "getTaskStats",
	    value: function getTaskStats() {
	      return new _TaskStats2.default(this.get("taskStats"));
	    }
	  }, {
	    key: "getQueue",
	    value: function getQueue() {
	      return this.get("queue");
	    }
	  }, {
	    key: "getVersion",
	    value: function getVersion() {
	      return this.get("version");
	    }
	  }, {
	    key: "getVersions",
	    value: function getVersions() {
	      return this.get("versions") || new _map2.default();
	    }
	  }, {
	    key: "getVersionInfo",
	    value: function getVersionInfo() {
	      var currentVersionID = this.get("version");
	
	      var _get = this.get("versionInfo"),
	          lastConfigChangeAt = _get.lastConfigChangeAt,
	          lastScalingAt = _get.lastScalingAt;
	
	      return { lastConfigChangeAt: lastConfigChangeAt, lastScalingAt: lastScalingAt, currentVersionID: currentVersionID };
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getVolumes",
	    value: function getVolumes() {
	      return new _VolumeList2.default({ items: this.get("volumes") || [] });
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getWebURL",
	    value: function getWebURL() {
	      var _ref = this.getLabels() || {},
	          DCOS_SERVICE_NAME = _ref.DCOS_SERVICE_NAME,
	          DCOS_SERVICE_PORT_INDEX = _ref.DCOS_SERVICE_PORT_INDEX,
	          DCOS_SERVICE_SCHEME = _ref.DCOS_SERVICE_SCHEME;
	
	      var serviceName = encodeURIComponent(DCOS_SERVICE_NAME);
	
	      if (!serviceName || !DCOS_SERVICE_PORT_INDEX || !DCOS_SERVICE_SCHEME) {
	        return null;
	      }
	
	      return _Config2.default.rootUrl + "/service/" + serviceName + "/";
	    }
	  }]);
	  return Application;
	}(_Service3.default);

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1072), __esModule: true };

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(882);
	__webpack_require__(883);
	__webpack_require__(899);
	__webpack_require__(1073);
	__webpack_require__(1076);
	module.exports = __webpack_require__(870).Map;

/***/ },
/* 1073 */
[2101, 1074, 1075],
/* 1074 */
[2102, 874, 889, 922, 871, 908, 876, 909, 886, 902, 898, 892, 906, 923, 891],
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(874)
	  , global         = __webpack_require__(869)
	  , $export        = __webpack_require__(868)
	  , fails          = __webpack_require__(879)
	  , hide           = __webpack_require__(889)
	  , redefineAll    = __webpack_require__(922)
	  , forOf          = __webpack_require__(909)
	  , strictNew      = __webpack_require__(908)
	  , isObject       = __webpack_require__(906)
	  , setToStringTag = __webpack_require__(895)
	  , DESCRIPTORS    = __webpack_require__(891);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 1076 */
[2107, 868, 1077],
/* 1077 */
[2108, 909, 905],
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ServiceSpec2 = __webpack_require__(1079);
	
	var _ServiceSpec3 = _interopRequireDefault(_ServiceSpec2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_ServiceSpec) {
	  (0, _inherits3.default)(ApplicationSpec, _ServiceSpec);
	
	  function ApplicationSpec() {
	    (0, _classCallCheck3.default)(this, ApplicationSpec);
	    return (0, _possibleConstructorReturn3.default)(this, (ApplicationSpec.__proto__ || (0, _getPrototypeOf2.default)(ApplicationSpec)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ApplicationSpec, [{
	    key: "getAcceptedResourceRoles",
	    value: function getAcceptedResourceRoles() {
	      return this.get("acceptedResourceRoles");
	    }
	  }, {
	    key: "getArguments",
	    value: function getArguments() {
	      return this.get("args");
	    }
	  }, {
	    key: "getCommand",
	    value: function getCommand() {
	      return this.get("cmd");
	    }
	  }, {
	    key: "getContainerSettings",
	    value: function getContainerSettings() {
	      return this.get("container");
	    }
	  }, {
	    key: "getConstraints",
	    value: function getConstraints() {
	      return this.get("constraints");
	    }
	  }, {
	    key: "getCpus",
	    value: function getCpus() {
	      return this.get("cpus");
	    }
	  }, {
	    key: "getDisk",
	    value: function getDisk() {
	      return this.get("disk");
	    }
	  }, {
	    key: "getEnvironmentVariables",
	    value: function getEnvironmentVariables() {
	      return this.get("env");
	    }
	  }, {
	    key: "getExecutor",
	    value: function getExecutor() {
	      return this.get("executor");
	    }
	  }, {
	    key: "getFetch",
	    value: function getFetch() {
	      return this.get("fetch");
	    }
	  }, {
	    key: "getHealthChecks",
	    value: function getHealthChecks() {
	      var healthChecks = this.get("healthChecks") || [];
	
	      // "Clone" health checks to ensure that no one is accidentally altering the
	      // properties.
	      return healthChecks.map(function (healthCheck) {
	        return (0, _assign2.default)({}, healthCheck);
	      });
	    }
	  }, {
	    key: "getInstancesCount",
	    value: function getInstancesCount() {
	      return this.get("instances");
	    }
	  }, {
	    key: "getIpAddress",
	    value: function getIpAddress() {
	      return this.get("ipAddress");
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.get("labels");
	    }
	  }, {
	    key: "getMem",
	    value: function getMem() {
	      return this.get("mem");
	    }
	  }, {
	    key: "getPortDefinitions",
	    value: function getPortDefinitions() {
	      return this.get("portDefinitions");
	    }
	  }, {
	    key: "getResidency",
	    value: function getResidency() {
	      return this.get("residency");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      return {
	        cpus: this.get("cpus"),
	        mem: this.get("mem"),
	        gpus: this.get("gpus"),
	        disk: this.get("disk")
	      };
	    }
	  }, {
	    key: "getUpdateStrategy",
	    value: function getUpdateStrategy() {
	      return this.get("updateStrategy");
	    }
	  }, {
	    key: "getUser",
	    value: function getUser() {
	      return this.get("user");
	    }
	  }]);
	  return ApplicationSpec;
	}(_ServiceSpec3.default);

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(ServiceSpec, _Item);
	
	  function ServiceSpec() {
	    (0, _classCallCheck3.default)(this, ServiceSpec);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceSpec.__proto__ || (0, _getPrototypeOf2.default)(ServiceSpec)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceSpec, [{
	    key: "getId",
	    value: function getId() {
	      return this.get("id") || "";
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      return {
	        cpus: 0,
	        mem: 0,
	        gpus: 0,
	        disk: 0
	      };
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.get();
	    }
	  }]);
	  return ServiceSpec;
	}(_Item3.default);

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _ServiceImages = __webpack_require__(1081);
	
	var _ServiceImages2 = _interopRequireDefault(_ServiceImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// You might be tempted to merge FrameworkUtil into ServiceUtil, but that will
	// cause a circular dependency with ServiceUtil and struct/Service.
	var FrameworkUtil = {
	  getImageSizeFromImagesObject: function getImageSizeFromImagesObject(images, size) {
	    if (images == null || images["icon-" + size] == null || images["icon-" + size].length === 0) {
	      return null;
	    }
	
	    return images["icon-" + size];
	  },
	
	
	  /**
	   * Get meta data from framework labels
	   * @param {{DCOS_PACKAGE_METADATA:string}} labels
	   * @returns {object} metadata
	   */
	  getMetadataFromLabels: function getMetadataFromLabels(labels) {
	    if (_Util2.default.findNestedPropertyInObject(labels, "DCOS_PACKAGE_METADATA.length") == null) {
	      return {};
	    }
	
	    // Extract content of the DCOS_PACKAGE_METADATA label
	    try {
	      var dataAsJsonString = global.atob(labels.DCOS_PACKAGE_METADATA);
	
	      return JSON.parse(dataAsJsonString);
	    } catch (error) {
	      return {};
	    }
	  },
	
	
	  /**
	   * Get service icon images from images object
	   * @param  {Object} images containing urls for the different image sizes
	   * @return {Object}        containing urls for images. Returns default images
	   * if all is not available in given object.
	   */
	  getServiceImages: function getServiceImages(images) {
	    if (this.getImageSizeFromImagesObject(images, "small") == null || this.getImageSizeFromImagesObject(images, "medium") == null || this.getImageSizeFromImagesObject(images, "large") == null) {
	      return _ServiceImages2.default.NA_IMAGES;
	    }
	
	    return images;
	  }
	};
	
	module.exports = FrameworkUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var NA_IMAGES = {
	  "icon-small": __webpack_require__(1082),
	  "icon-medium": __webpack_require__(1083),
	  "icon-large": __webpack_require__(1084)
	};
	
	var MARATHON_IMAGES = {
	  "icon-small": __webpack_require__(1085),
	  "icon-medium": __webpack_require__(1086),
	  "icon-large": __webpack_require__(1087)
	};
	
	module.exports.NA_IMAGES = NA_IMAGES;
	module.exports.MARATHON_IMAGES = MARATHON_IMAGES;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./bd6fc6a8b80df8fdbe652a7d431e7ce4-icon-service-default-small@2x.png";

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./b8b555c448df5cb83f566edddfd4bb18-icon-service-default-medium@2x.png";

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./20e9eff56840a02f9c11374dba18d1ad-icon-service-default-large@2x.png";

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./b96f17a8f37bcc262c75e6eb3f1f5beb-icon-service-marathon-small@2x.png";

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./699753f70c29ffed1c1861002833adb4-icon-service-marathon-medium@2x.png";

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./c8c4be10c80d088db5a510aec528a2c6-icon-service-marathon-large@2x.png";

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _HealthTypes = __webpack_require__(1089);
	
	var _HealthTypes2 = _interopRequireDefault(_HealthTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HealthStatus = {
	  NA: {
	    key: "NA",
	    value: _HealthTypes2.default.NA,
	    classNames: "text-mute"
	  },
	  HEALTHY: {
	    key: "HEALTHY",
	    value: _HealthTypes2.default.HEALTHY,
	    classNames: "text-success"
	  },
	  UNHEALTHY: {
	    key: "UNHEALTHY",
	    value: _HealthTypes2.default.UNHEALTHY,
	    classNames: "text-danger"
	  },
	  IDLE: {
	    key: "IDLE",
	    value: _HealthTypes2.default.IDLE,
	    classNames: "text-warning"
	  }
	};
	
	module.exports = HealthStatus;

/***/ },
/* 1089 */
/***/ function(module, exports) {

	"use strict";
	
	var HealthTypes = {
	  UNHEALTHY: 0, // if tasksUnhealthy > 0
	  HEALTHY: 1, // if tasksUnhealthy === 0 && tasksHealthy > 0
	  IDLE: 2, // else tasksRunning === 0
	  NA: 3 // healthChecks === 0
	};
	
	module.exports = HealthTypes;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _ServiceImages = __webpack_require__(1081);
	
	var _ServiceImages2 = _interopRequireDefault(_ServiceImages);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	var _ServiceSpec = __webpack_require__(1079);
	
	var _ServiceSpec2 = _interopRequireDefault(_ServiceSpec);
	
	var _VolumeList = __webpack_require__(1094);
	
	var _VolumeList2 = _interopRequireDefault(_VolumeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(Service, _Item);
	
	  function Service() {
	    (0, _classCallCheck3.default)(this, Service);
	    return (0, _possibleConstructorReturn3.default)(this, (Service.__proto__ || (0, _getPrototypeOf2.default)(Service)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Service, [{
	    key: "getId",
	    value: function getId() {
	      return this.get("id") || "";
	    }
	  }, {
	    key: "getMesosId",
	    value: function getMesosId() {
	      return this.getId().split("/").slice(1).reverse().join(".");
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId().split("/").pop();
	    }
	  }, {
	    key: "getSpec",
	    value: function getSpec() {
	      return new _ServiceSpec2.default(this.get());
	    }
	  }, {
	    key: "getHealth",
	    value: function getHealth() {
	      return _HealthStatus2.default.NA;
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return {};
	    }
	  }, {
	    key: "getVolumes",
	    value: function getVolumes() {
	      return new _VolumeList2.default({ items: [] });
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      var status = this.getServiceStatus();
	      if (status.displayName == null) {
	        return null;
	      }
	
	      return status.displayName;
	    }
	  }, {
	    key: "getServiceStatus",
	    value: function getServiceStatus() {
	      return _ServiceStatus2.default.NA;
	    }
	  }, {
	    key: "getImages",
	    value: function getImages() {
	      return _ServiceImages2.default.NA_IMAGES;
	    }
	  }, {
	    key: "getQueue",
	    value: function getQueue() {
	      return null;
	    }
	  }, {
	    key: "getWebURL",
	    value: function getWebURL() {
	      return null;
	    }
	  }, {
	    key: "getInstancesCount",
	    value: function getInstancesCount() {
	      return 0;
	    }
	  }, {
	    key: "getRunningInstancesCount",
	    value: function getRunningInstancesCount() {
	      return (this.get("tasks") || []).length;
	    }
	  }, {
	    key: "getTasksSummary",
	    value: function getTasksSummary() {
	      return {
	        tasksHealthy: 0,
	        tasksStaged: 0,
	        tasksUnhealthy: 0,
	        tasksUnknown: 0,
	        tasksOverCapacity: 0,
	        tasksRunning: 0
	      };
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      var instances = this.getInstancesCount();
	
	      var _getSpec$getResources = this.getSpec().getResources(),
	          _getSpec$getResources2 = _getSpec$getResources.cpus,
	          cpus = _getSpec$getResources2 === undefined ? 0 : _getSpec$getResources2,
	          _getSpec$getResources3 = _getSpec$getResources.mem,
	          mem = _getSpec$getResources3 === undefined ? 0 : _getSpec$getResources3,
	          _getSpec$getResources4 = _getSpec$getResources.gpus,
	          gpus = _getSpec$getResources4 === undefined ? 0 : _getSpec$getResources4,
	          _getSpec$getResources5 = _getSpec$getResources.disk,
	          disk = _getSpec$getResources5 === undefined ? 0 : _getSpec$getResources5;
	
	      return {
	        cpus: cpus * instances,
	        mem: mem * instances,
	        gpus: gpus * instances,
	        disk: disk * instances
	      };
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return this.get();
	    }
	  }]);
	  return Service;
	}(_Item3.default);

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ServiceStatusLabels = __webpack_require__(1092);
	
	var _ServiceStatusLabels2 = _interopRequireDefault(_ServiceStatusLabels);
	
	var _ServiceStatusTypes = __webpack_require__(1093);
	
	var _ServiceStatusTypes2 = _interopRequireDefault(_ServiceStatusTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SERVICE_STATUS = {
	  RUNNING: {
	    key: _ServiceStatusTypes2.default.RUNNING,
	    displayName: _ServiceStatusLabels2.default.RUNNING
	  },
	  DEPLOYING: {
	    key: _ServiceStatusTypes2.default.DEPLOYING,
	    displayName: _ServiceStatusLabels2.default.DEPLOYING
	  },
	  SUSPENDED: {
	    key: _ServiceStatusTypes2.default.SUSPENDED,
	    displayName: _ServiceStatusLabels2.default.SUSPENDED
	  },
	  NA: {
	    key: _ServiceStatusTypes2.default.NA,
	    displayName: _ServiceStatusLabels2.default.NA
	  },
	  DELAYED: {
	    key: _ServiceStatusTypes2.default.DELAYED,
	    displayName: _ServiceStatusLabels2.default.DELAYED
	  },
	  WAITING: {
	    key: _ServiceStatusTypes2.default.WAITING,
	    displayName: _ServiceStatusLabels2.default.WAITING
	  }
	};
	
	module.exports = SERVICE_STATUS;

/***/ },
/* 1092 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceStatusLabels = {
	  RUNNING: "Running",
	  DEPLOYING: "Deploying",
	  SUSPENDED: "Suspended",
	  NA: "N/A",
	  DELAYED: "Delayed",
	  WAITING: "Waiting"
	};
	
	module.exports = ServiceStatusLabels;

/***/ },
/* 1093 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceStatusTypes = {
	  NA: 0,
	  SUSPENDED: 1,
	  RUNNING: 2,
	  DEPLOYING: 3,
	  WAITING: 4,
	  DELAYED: 5
	};
	
	module.exports = ServiceStatusTypes;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _Volume = __webpack_require__(1095);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VolumeList = function (_List) {
	  (0, _inherits3.default)(VolumeList, _List);
	
	  function VolumeList() {
	    (0, _classCallCheck3.default)(this, VolumeList);
	    return (0, _possibleConstructorReturn3.default)(this, (VolumeList.__proto__ || (0, _getPrototypeOf2.default)(VolumeList)).apply(this, arguments));
	  }
	
	  return VolumeList;
	}(_List3.default);
	
	VolumeList.type = _Volume2.default;
	
	module.exports = VolumeList;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _VolumeStatus = __webpack_require__(1096);
	
	var _VolumeStatus2 = _interopRequireDefault(_VolumeStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Volume = function (_Item) {
	  (0, _inherits3.default)(Volume, _Item);
	
	  function Volume() {
	    (0, _classCallCheck3.default)(this, Volume);
	    return (0, _possibleConstructorReturn3.default)(this, (Volume.__proto__ || (0, _getPrototypeOf2.default)(Volume)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Volume, [{
	    key: "getContainerPath",
	    value: function getContainerPath() {
	      return this.get("containerPath");
	    }
	  }, {
	    key: "getHost",
	    value: function getHost() {
	      return this.get("host");
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.get("id");
	    }
	  }, {
	    key: "getMode",
	    value: function getMode() {
	      return this.get("mode");
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      return this.get("status") || _VolumeStatus2.default.UNAVAILABLE;
	    }
	  }, {
	    key: "getSize",
	    value: function getSize() {
	      return this.get("size");
	    }
	  }, {
	    key: "getTaskID",
	    value: function getTaskID() {
	      return this.get("taskID");
	    }
	  }, {
	    key: "getType",
	    value: function getType() {
	      return this.get("type");
	    }
	  }]);
	  return Volume;
	}(_Item3.default);
	
	module.exports = Volume;

/***/ },
/* 1096 */
/***/ function(module, exports) {

	"use strict";
	
	var VolumeStatus = {
	  ATTACHED: "Attached",
	  DETACHED: "Detached",
	  UNAVAILABLE: "Unavailable"
	};
	
	module.exports = VolumeStatus;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _List = __webpack_require__(947);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _TaskStat = __webpack_require__(1098);
	
	var _TaskStat2 = _interopRequireDefault(_TaskStat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var functionMap = {
	  withLatestConfig: "getStatsForTasksWithLatestConfig",
	  startedAfterLastScaling: "getStatsForTasksStaredAfterLastScaling",
	  withOutdatedConfig: "getStatsForTasksWithOutdatedConfig",
	  totalSummary: "getStatsForAllTasks"
	};
	
	var TaskStats = function (_Item) {
	  (0, _inherits3.default)(TaskStats, _Item);
	
	  function TaskStats() {
	    (0, _classCallCheck3.default)(this, TaskStats);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskStats.__proto__ || (0, _getPrototypeOf2.default)(TaskStats)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskStats, [{
	    key: "getStatsForTasksWithLatestConfig",
	
	    /**
	     * @return {TaskStat} task statistic about all tasks that run with the same
	     * config as the latest app version.
	     */
	    value: function getStatsForTasksWithLatestConfig() {
	      var stat = this.get("withLatestConfig") || {};
	      stat.name = "withLatestConfig";
	
	      return new _TaskStat2.default(stat);
	    }
	
	    /**
	     * @return {TaskStat} task statistics about all tasks that were started after
	     * the last scaling or restart operation.
	     */
	
	  }, {
	    key: "getStatsForTasksStaredAfterLastScaling",
	    value: function getStatsForTasksStaredAfterLastScaling() {
	      var stat = this.get("startedAfterLastScaling") || {};
	      stat.name = "startedAfterLastScaling";
	
	      return new _TaskStat2.default(stat);
	    }
	
	    /**
	     * @return {TaskStat} task statistics about all tasks that were started
	     * before the last config change which was not simply a restart or scaling
	     * operation.
	     */
	
	  }, {
	    key: "getStatsForTasksWithOutdatedConfig",
	    value: function getStatsForTasksWithOutdatedConfig() {
	      var stat = this.get("withOutdatedConfig") || {};
	      stat.name = "withOutdatedConfig";
	
	      return new _TaskStat2.default(stat);
	    }
	
	    /**
	     * @return {TaskStat} task statistics about all tasks
	     */
	
	  }, {
	    key: "getStatsForAllTasks",
	    value: function getStatsForAllTasks() {
	      var stat = this.get("totalSummary") || {};
	      stat.name = "totalSummary";
	
	      return new _TaskStat2.default(stat);
	    }
	
	    /**
	     * @return {List} with each of the non-empty types of TaskStat available
	     */
	
	  }, {
	    key: "getList",
	    value: function getList() {
	      var _this2 = this;
	
	      var items = [];
	
	      (0, _keys2.default)(functionMap).forEach(function (key) {
	        var stat = _this2[functionMap[key]]();
	        if (!stat.isEmpty()) {
	          items.push(stat);
	        }
	      });
	
	      return new _List2.default({ items: items });
	    }
	  }]);
	  return TaskStats;
	}(_Item3.default);
	
	module.exports = TaskStats;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskStat = function (_Item) {
	  (0, _inherits3.default)(TaskStat, _Item);
	
	  function TaskStat() {
	    (0, _classCallCheck3.default)(this, TaskStat);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskStat.__proto__ || (0, _getPrototypeOf2.default)(TaskStat)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskStat, [{
	    key: "isEmpty",
	    value: function isEmpty() {
	      return (0, _typeof3.default)(this.get("stats")) !== "object" || !(0, _keys2.default)(this.get("stats")).length;
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.get("name");
	    }
	  }, {
	    key: "getHealthyTaskCount",
	    value: function getHealthyTaskCount() {
	      var stats = this.get("stats") || {};
	      if (stats.counts) {
	        return stats.counts.healthy || 0;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getRunningTaskCount",
	    value: function getRunningTaskCount() {
	      var stats = this.get("stats") || {};
	      if (stats.counts) {
	        return stats.counts.running || 0;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getStagedTaskCount",
	    value: function getStagedTaskCount() {
	      var stats = this.get("stats") || {};
	      if (stats.counts) {
	        return stats.counts.staged || 0;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getUnhealthyTaskCount",
	    value: function getUnhealthyTaskCount() {
	      var stats = this.get("stats") || {};
	      if (stats.counts) {
	        return stats.counts.unhealthy || 0;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getAverageLifeTime",
	    value: function getAverageLifeTime() {
	      var stats = this.get("stats") || {};
	      if (stats.lifeTime) {
	        return stats.lifeTime.averageSeconds || 0;
	      }
	
	      return 0;
	    }
	  }, {
	    key: "getMedianLifeTime",
	    value: function getMedianLifeTime() {
	      var stats = this.get("stats") || {};
	      if (stats.lifeTime) {
	        return stats.lifeTime.medianSeconds || 0;
	      }
	
	      return 0;
	    }
	  }]);
	  return TaskStat;
	}(_Item3.default);
	
	module.exports = TaskStat;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ApplicationSpec2 = __webpack_require__(1078);
	
	var _ApplicationSpec3 = _interopRequireDefault(_ApplicationSpec2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_ApplicationSpec) {
	  (0, _inherits3.default)(FrameworkSpec, _ApplicationSpec);
	
	  function FrameworkSpec() {
	    (0, _classCallCheck3.default)(this, FrameworkSpec);
	    return (0, _possibleConstructorReturn3.default)(this, (FrameworkSpec.__proto__ || (0, _getPrototypeOf2.default)(FrameworkSpec)).apply(this, arguments));
	  }
	
	  return FrameworkSpec;
	}(_ApplicationSpec3.default);

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _lodash = __webpack_require__(1101);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _EventTypes = __webpack_require__(933);
	
	var _MesosStateActions = __webpack_require__(1261);
	
	var _MesosStateActions2 = _interopRequireDefault(_MesosStateActions);
	
	var _MesosStateUtil = __webpack_require__(1262);
	
	var _MesosStateUtil2 = _interopRequireDefault(_MesosStateUtil);
	
	var _Task = __webpack_require__(1264);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPolling = false;
	
	var throttledFetchState = (0, _lodash2.default)(_MesosStateActions2.default.fetchState, _Config2.default.getRefreshRate());
	
	function poll() {
	  if (!isPolling) {
	    isPolling = true;
	  }
	  throttledFetchState();
	}
	
	function stopPolling() {
	  if (isPolling) {
	    throttledFetchState.cancel();
	    isPolling = false;
	  }
	}
	
	/**
	 * Assigns a property to task if it belongs to an SDK service.
	 * @param  {Object} task
	 * @param  {Array} service task belongs to
	 * @return {Object} task
	 */
	function flagSDKTask(task, service) {
	  if ((0, _ServiceUtil.isSDKService)(service) && task.sdkTask === undefined) {
	    task.sdkTask = true;
	  }
	
	  return task;
	}
	
	var MesosStateStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(MesosStateStore, _GetSetBaseStore);
	
	  function MesosStateStore() {
	    (0, _classCallCheck3.default)(this, MesosStateStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MesosStateStore.__proto__ || (0, _getPrototypeOf2.default)(MesosStateStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      lastMesosState: {},
	      taskCache: {}
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.MESOS_STATE_CHANGE,
	        error: _EventTypes.MESOS_STATE_REQUEST_ERROR
	      },
	      unmountWhen: function unmountWhen(store, event) {
	        if (event === "success") {
	          return (0, _keys2.default)(store.get("lastMesosState")).length;
	        }
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes2.default.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        case _ActionTypes2.default.REQUEST_MESOS_STATE_SUCCESS:
	          _this.processStateSuccess(action.data);
	          break;
	        case _ActionTypes2.default.REQUEST_MESOS_STATE_ERROR:
	          _this.processStateError(action.xhr);
	          break;
	        case _ActionTypes2.default.REQUEST_MESOS_STATE_ONGOING:
	          _this.processOngoingRequest();
	          break;
	      }
	
	      if (_this.shouldPoll() && (action.type === _ActionTypes2.default.REQUEST_MESOS_STATE_SUCCESS || action.type === _ActionTypes2.default.REQUEST_MESOS_STATE_ERROR || action.type === _ActionTypes2.default.REQUEST_MESOS_STATE_ONGOING)) {
	        poll();
	      }
	
	      return true;
	    });
	
	    _VisibilityStore2.default.addChangeListener(_EventTypes.VISIBILITY_CHANGE, _this.onVisibilityStoreChange.bind(_this));
	    return _this;
	  }
	
	  (0, _createClass3.default)(MesosStateStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	
	      if (this.shouldPoll()) {
	        poll();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "onVisibilityStoreChange",
	    value: function onVisibilityStoreChange() {
	      if (!_VisibilityStore2.default.isInactive() && this.shouldPoll()) {
	        poll();
	
	        return;
	      }
	
	      stopPolling();
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return this.listeners(_EventTypes.MESOS_STATE_CHANGE).length > 0;
	    }
	  }, {
	    key: "indexTasksByID",
	    value: function indexTasksByID(lastMesosState) {
	      var taskIndex = {};
	
	      lastMesosState.frameworks.forEach(function (service) {
	        var _service$tasks = service.tasks,
	            tasks = _service$tasks === undefined ? [] : _service$tasks,
	            _service$completed_ta = service.completed_tasks,
	            completed_tasks = _service$completed_ta === undefined ? [] : _service$completed_ta,
	            _service$unreachable_ = service.unreachable_tasks,
	            unreachable_tasks = _service$unreachable_ === undefined ? [] : _service$unreachable_;
	
	
	        tasks.concat(completed_tasks, unreachable_tasks).forEach(function (task) {
	          taskIndex[task.id] = task;
	        });
	      });
	
	      return taskIndex;
	    }
	  }, {
	    key: "getHostResourcesByFramework",
	    value: function getHostResourcesByFramework(filter) {
	      return _MesosStateUtil2.default.getHostResourcesByFramework(this.get("lastMesosState"), filter);
	    }
	  }, {
	    key: "getPodHistoricalInstances",
	    value: function getPodHistoricalInstances(pod) {
	      return _MesosStateUtil2.default.getPodHistoricalInstances(this.get("lastMesosState"), pod);
	    }
	  }, {
	    key: "getServiceFromName",
	    value: function getServiceFromName(name) {
	      var services = this.get("lastMesosState").frameworks;
	
	      if (services) {
	        return services.find(function (service) {
	          return service.name === name;
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNodeFromID",
	    value: function getNodeFromID(id) {
	      var nodes = this.get("lastMesosState").slaves;
	
	      if (nodes) {
	        return nodes.find(function (node) {
	          return node.id === id;
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNodeFromHostname",
	    value: function getNodeFromHostname(hostname) {
	      var nodes = this.get("lastMesosState").slaves;
	
	      if (nodes) {
	        return nodes.find(function (node) {
	          return node.hostname === hostname;
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "getTasksFromNodeID",
	    value: function getTasksFromNodeID(nodeID) {
	      var frameworks = this.get("lastMesosState").frameworks || [];
	      var memberTasks = {};
	
	      frameworks.forEach(function (framework) {
	        framework.tasks.forEach(function (task) {
	          if (task.slave_id === nodeID) {
	            // Need to get service from Marathon because we need the labels.
	            var service = _DCOSStore2.default.serviceTree.findItem(function (item) {
	              return item instanceof _Framework2.default && item.getFrameworkName() === framework.name;
	            });
	            task = flagSDKTask(task, service);
	            memberTasks[task.id] = task;
	          }
	        });
	        framework.completed_tasks.forEach(function (task) {
	          if (task.slave_id === nodeID) {
	            memberTasks[task.id] = task;
	          }
	        });
	      });
	
	      return (0, _values2.default)(memberTasks);
	    }
	  }, {
	    key: "getTaskFromTaskID",
	    value: function getTaskFromTaskID(taskID) {
	      var taskCache = this.get("taskCache");
	      var foundTask = taskCache[taskID];
	      if (foundTask == null) {
	        return null;
	      }
	
	      return new _Task2.default(foundTask);
	    }
	  }, {
	    key: "getTasksByService",
	    value: function getTasksByService(service) {
	      var frameworks = this.get("lastMesosState").frameworks;
	      var serviceName = service.getName();
	
	      // Convert serviceId to Mesos task name
	      var mesosTaskName = service.getMesosId();
	
	      if (!serviceName || !mesosTaskName || !frameworks) {
	        return [];
	      }
	
	      var serviceIsFramework = service && service instanceof _Framework2.default;
	      var serviceFrameworkName = serviceIsFramework ? service.getFrameworkName() : serviceName;
	
	      // Combine framework (if matching framework was found) and filtered
	      // Marathon tasks. This will give you a list of framework tasks including
	      // the scheduler tasks or a list of Marathon application tasks.
	      return frameworks.reduce(function (serviceTasks, framework) {
	        var _framework$tasks = framework.tasks,
	            tasks = _framework$tasks === undefined ? [] : _framework$tasks,
	            _framework$completed_ = framework.completed_tasks,
	            completed_tasks = _framework$completed_ === undefined ? [] : _framework$completed_,
	            _framework$unreachabl = framework.unreachable_tasks,
	            unreachable_tasks = _framework$unreachabl === undefined ? [] : _framework$unreachabl,
	            name = framework.name;
	        // Include tasks from framework match, if service is a Framework
	
	        if (serviceIsFramework && serviceFrameworkName === name) {
	          return serviceTasks.concat(tasks, completed_tasks).map(function (task) {
	            return flagSDKTask(task, service);
	          });
	        }
	
	        // Filter marathon tasks by service name
	        if (name === "marathon") {
	          return tasks.concat(completed_tasks, unreachable_tasks).filter(function (_ref) {
	            var name = _ref.name;
	            return name === mesosTaskName;
	          }).concat(serviceTasks).map(function (task) {
	            return flagSDKTask(task, service);
	          });
	        }
	
	        return serviceTasks;
	      }, []);
	    }
	  }, {
	    key: "getTasksFromVirtualNetworkName",
	    value: function getTasksFromVirtualNetworkName(overlayName) {
	      return _MesosStateUtil2.default.getTasksFromVirtualNetworkName(this.get("lastMesosState"), overlayName);
	    }
	  }, {
	    key: "processStateSuccess",
	    value: function processStateSuccess(lastMesosState) {
	      _CompositeState2.default.addState(lastMesosState);
	      var taskCache = this.indexTasksByID(lastMesosState);
	      this.set({ lastMesosState: lastMesosState, taskCache: taskCache });
	      this.emit(_EventTypes.MESOS_STATE_CHANGE);
	    }
	  }, {
	    key: "processStateError",
	    value: function processStateError(xhr) {
	      this.emit(_EventTypes.MESOS_STATE_REQUEST_ERROR, xhr);
	    }
	  }, {
	    key: "processOngoingRequest",
	    value: function processOngoingRequest() {
	      // Handle ongoing request here.
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "state";
	    }
	  }]);
	  return MesosStateStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new MesosStateStore();

/***/ },
/* 1101 */,
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get3 = __webpack_require__(1061);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = __webpack_require__(1103);
	
	var _DeclinedOffersUtil = __webpack_require__(1104);
	
	var _DeclinedOffersUtil2 = _interopRequireDefault(_DeclinedOffersUtil);
	
	var _DeploymentsList = __webpack_require__(1210);
	
	var _DeploymentsList2 = _interopRequireDefault(_DeploymentsList);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _JobTree = __webpack_require__(1212);
	
	var _JobTree2 = _interopRequireDefault(_JobTree);
	
	var _MarathonStore = __webpack_require__(1221);
	
	var _MarathonStore2 = _interopRequireDefault(_MarathonStore);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _MetronomeStore = __webpack_require__(1248);
	
	var _MetronomeStore2 = _interopRequireDefault(_MetronomeStore);
	
	var _NotificationStore = __webpack_require__(1258);
	
	var _NotificationStore2 = _interopRequireDefault(_NotificationStore);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _SummaryList = __webpack_require__(1259);
	
	var _SummaryList2 = _interopRequireDefault(_SummaryList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onMetronomeChange", "onMarathonGroupsChange", "onMarathonQueueChange", "onMarathonDeploymentsChange", "onMarathonServiceVersionChange", "onMarathonServiceVersionsChange", "onMesosSummaryChange"];
	
	var EVENT_DEBOUNCE_TIME = 250;
	
	var DCOSStore = function (_EventEmitter) {
	  (0, _inherits3.default)(DCOSStore, _EventEmitter);
	
	  function DCOSStore() {
	    (0, _classCallCheck3.default)(this, DCOSStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DCOSStore.__proto__ || (0, _getPrototypeOf2.default)(DCOSStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: _this.getEvents(),
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.data = {
	      marathon: {
	        serviceTree: new _ServiceTree2.default(),
	        queue: new _map2.default(),
	        deploymentsList: new _DeploymentsList2.default(),
	        versions: new _map2.default(),
	        dataReceived: false
	      },
	      metronome: {
	        jobTree: new _JobTree2.default(),
	        dataReceived: false
	      },
	      mesos: new _SummaryList2.default()
	    };
	
	    _this.debouncedEvents = new _map2.default();
	    return _this;
	  }
	
	  (0, _createClass3.default)(DCOSStore, [{
	    key: "getEvents",
	    value: function getEvents() {
	      return { change: _EventTypes.DCOS_CHANGE };
	    }
	  }, {
	    key: "getTotalListenerCount",
	    value: function getTotalListenerCount() {
	      var _this2 = this;
	
	      return (0, _values2.default)(this.getEvents()).reduce(function (memo, name) {
	        return memo + _this2.listeners(name).length;
	      }, 0);
	    }
	  }, {
	    key: "getProxyListeners",
	    value: function getProxyListeners() {
	      var proxyListeners = [];
	
	      if (_PluginSDK.Hooks.applyFilter("hasCapability", false, "metronomeAPI")) {
	        proxyListeners.push({
	          event: _EventTypes.METRONOME_JOBS_CHANGE,
	          handler: this.onMetronomeChange,
	          store: _MetronomeStore2.default
	        });
	      }
	
	      if (_PluginSDK.Hooks.applyFilter("hasCapability", false, "mesosAPI")) {
	        proxyListeners.push({
	          event: _EventTypes.MESOS_SUMMARY_CHANGE,
	          handler: this.onMesosSummaryChange,
	          store: _MesosSummaryStore2.default
	        });
	      }
	
	      if (_PluginSDK.Hooks.applyFilter("hasCapability", false, "marathonAPI")) {
	        proxyListeners = proxyListeners.concat([{
	          event: _EventTypes2.MARATHON_DEPLOYMENTS_CHANGE,
	          handler: this.onMarathonDeploymentsChange,
	          store: _MarathonStore2.default
	        }, {
	          event: _EventTypes2.MARATHON_GROUPS_CHANGE,
	          handler: this.onMarathonGroupsChange,
	          store: _MarathonStore2.default
	        }, {
	          event: _EventTypes2.MARATHON_QUEUE_CHANGE,
	          handler: this.onMarathonQueueChange,
	          store: _MarathonStore2.default
	        }, {
	          event: _EventTypes2.MARATHON_SERVICE_VERSION_CHANGE,
	          handler: this.onMarathonServiceVersionChange,
	          store: _MarathonStore2.default
	        }, {
	          event: _EventTypes2.MARATHON_SERVICE_VERSIONS_CHANGE,
	          handler: this.onMarathonServiceVersionsChange,
	          store: _MarathonStore2.default
	        }]);
	      }
	
	      return proxyListeners;
	    }
	
	    /**
	     * Fetch service version/configuration from Marathon
	     * @param {string} serviceID
	     * @param {string} versionID
	     */
	
	  }, {
	    key: "fetchServiceVersion",
	    value: function fetchServiceVersion(serviceID, versionID) {
	      _MarathonStore2.default.fetchServiceVersion(serviceID, versionID);
	    }
	
	    /**
	     * Fetch service versions/configurations from Marathon
	     * @param {string} serviceID
	     */
	
	  }, {
	    key: "fetchServiceVersions",
	    value: function fetchServiceVersions(serviceID) {
	      _MarathonStore2.default.fetchServiceVersions(serviceID);
	    }
	  }, {
	    key: "onMarathonDeploymentsChange",
	    value: function onMarathonDeploymentsChange() {
	      if (!this.data.marathon.dataReceived) {
	        return;
	      }
	      var deploymentsList = _MarathonStore2.default.get("deployments");
	      var serviceTree = _MarathonStore2.default.get("groups");
	
	      var deploymentListLength = deploymentsList.getItems().length;
	      var currentDeploymentCount = _NotificationStore2.default.getNotificationCount("services-deployments");
	
	      if (deploymentListLength !== currentDeploymentCount) {
	        _NotificationStore2.default.addNotification("services-deployments", "deployment-count", deploymentListLength);
	      }
	
	      // Populate deployments with affected services
	      this.data.marathon.deploymentsList = deploymentsList.mapItems(function (deployment) {
	        var ids = deployment.getAffectedServiceIds();
	        var services = ids.reduce(function (memo, id) {
	          var service = serviceTree.findItemById(id);
	          if (service != null) {
	            memo.affected.push(service);
	          } else {
	            memo.stale.push(id);
	          }
	
	          return memo;
	        }, { affected: [], stale: [] });
	
	        return (0, _assign2.default)({
	          affectedServices: services.affected,
	          staleServiceIds: services.stale
	        }, deployment);
	      });
	
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "emit",
	    value: function emit(eventType) {
	      // Debounce specified events
	      if ([_EventTypes.DCOS_CHANGE].includes(eventType)) {
	        var _get2;
	
	        clearTimeout(this.debouncedEvents.get(eventType));
	        this.debouncedEvents.set(eventType, setTimeout((_get2 = (0, _get4.default)(DCOSStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(DCOSStore.prototype), "emit", this)).bind.apply(_get2, [this].concat(Array.prototype.slice.call(arguments))), EVENT_DEBOUNCE_TIME));
	
	        return;
	      }
	
	      (0, _get4.default)(DCOSStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(DCOSStore.prototype), "emit", this).call(this, eventType);
	    }
	  }, {
	    key: "onMarathonGroupsChange",
	    value: function onMarathonGroupsChange() {
	      var serviceTree = _MarathonStore2.default.get("groups");
	      if (!(serviceTree instanceof _ServiceTree2.default)) {
	        return;
	      }
	
	      var marathon = this.data.marathon;
	
	      // Update service tree and data received flag
	
	      marathon.serviceTree = serviceTree;
	      marathon.dataReceived = true;
	
	      // Populate deployments with services data immediately
	      this.onMarathonDeploymentsChange();
	
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "onMarathonQueueChange",
	    value: function onMarathonQueueChange(nextQueue) {
	      var queue = this.data.marathon.queue;
	
	
	      var queuedAppIDs = [];
	      nextQueue.forEach(function (entry) {
	        if (entry.app == null && entry.pod == null) {
	          return;
	        }
	
	        var id = null;
	
	        if (entry.pod != null) {
	          id = entry.pod.id;
	        } else {
	          id = entry.app.id;
	        }
	
	        entry.declinedOffers = {
	          summary: _DeclinedOffersUtil2.default.getSummaryFromQueue(entry),
	          offers: _DeclinedOffersUtil2.default.getOffersFromQueue(entry)
	        };
	
	        queuedAppIDs.push(id);
	        queue.set(id, entry);
	      });
	
	      queue.forEach(function (entry) {
	        var id = null;
	
	        if (entry.pod != null) {
	          id = entry.pod.id;
	        } else {
	          id = entry.app.id;
	        }
	
	        if (queuedAppIDs.indexOf(id) === -1) {
	          queue.delete(id);
	        }
	      });
	
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "onMarathonServiceVersionChange",
	    value: function onMarathonServiceVersionChange(event) {
	      var serviceID = event.serviceID,
	          versionID = event.versionID,
	          version = event.version;
	      var versions = this.data.marathon.versions;
	
	      var currentVersions = versions.get(serviceID);
	
	      if (!currentVersions) {
	        currentVersions = new _map2.default();
	        versions.set(serviceID, currentVersions);
	      }
	
	      currentVersions.set(versionID, version);
	
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "onMarathonServiceVersionsChange",
	    value: function onMarathonServiceVersionsChange(event) {
	      var serviceID = event.serviceID,
	          nextVersions = event.versions;
	      var versions = this.data.marathon.versions;
	
	      var currentVersions = versions.get(serviceID);
	
	      if (currentVersions) {
	        nextVersions = new _map2.default([].concat((0, _toConsumableArray3.default)(nextVersions), (0, _toConsumableArray3.default)(currentVersions)));
	      }
	
	      versions.set(serviceID, nextVersions);
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "onMesosSummaryChange",
	    value: function onMesosSummaryChange() {
	      var states = _MesosSummaryStore2.default.get("states");
	      if (!(states instanceof _SummaryList2.default)) {
	        return;
	      }
	
	      this.data.mesos = states;
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "onMetronomeChange",
	    value: function onMetronomeChange() {
	      var metronome = this.data.metronome;
	
	      // Update job tree and data received flag
	
	      metronome.jobTree = _MetronomeStore2.default.jobTree;
	      metronome.dataReceived = true;
	
	      this.clearServiceTreeCache();
	      this.emit(_EventTypes.DCOS_CHANGE);
	    }
	  }, {
	    key: "addProxyListeners",
	    value: function addProxyListeners() {
	      this.getProxyListeners().forEach(function (item) {
	        item.store.addChangeListener(item.event, item.handler);
	      });
	    }
	  }, {
	    key: "removeProxyListeners",
	    value: function removeProxyListeners() {
	      this.getProxyListeners().forEach(function (item) {
	        item.store.removeChangeListener(item.event, item.handler);
	      });
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	
	    /**
	     * Adds the listener for the specified event
	     * @param {string} eventName
	     * @param {Function} callback
	     * @return {DCOSStore} DCOSStore instance
	     * @override
	     */
	
	  }, {
	    key: "on",
	    value: function on(eventName, callback) {
	      // Only add proxy listeners if not already listening
	      if (this.getTotalListenerCount() === 0) {
	        this.addProxyListeners();
	      }
	
	      return (0, _get4.default)(DCOSStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(DCOSStore.prototype), "on", this).call(this, eventName, callback);
	    }
	
	    /**
	     * Remove the specified listener for the specified event
	     * @param {string} eventName
	     * @param {Function} callback
	     * @return {DCOSStore} DCOSStore instance
	     * @override
	     */
	
	  }, {
	    key: "removeListener",
	    value: function removeListener(eventName, callback) {
	      (0, _get4.default)(DCOSStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(DCOSStore.prototype), "removeListener", this).call(this, eventName, callback);
	      // Remove proxy listeners if no one is listening
	      if (this.getTotalListenerCount() === 0) {
	        this.removeProxyListeners();
	      }
	
	      return this;
	    }
	
	    /**
	     * @type {JobTree}
	     */
	
	  }, {
	    key: "clearServiceTreeCache",
	    value: function clearServiceTreeCache() {
	      this.serviceTree = null;
	    }
	  }, {
	    key: "buildServiceTree",
	    value: function buildServiceTree() {
	      var _data = this.data,
	          _data$marathon = _data.marathon,
	          serviceTree = _data$marathon.serviceTree,
	          queue = _data$marathon.queue,
	          versions = _data$marathon.versions,
	          mesos = _data.mesos;
	
	      // Create framework dict from Mesos data
	
	      var frameworks = mesos.lastSuccessful().getServiceList().reduceItems(function (memo, framework) {
	        if (framework instanceof _Item2.default) {
	          memo["/" + framework.get("name")] = framework.get();
	        }
	
	        return memo;
	      }, {});
	
	      // Merge data by framework name, as  Marathon doesn't know framework ids.
	      return serviceTree.mapItems(function (item) {
	        if (item instanceof _ServiceTree2.default) {
	          return item;
	        }
	
	        var serviceId = item.getId();
	        var options = {
	          versions: versions.get(serviceId),
	          queue: queue.get(serviceId)
	        };
	
	        if (item instanceof _Framework2.default) {
	          options = (0, _assign2.default)(options, frameworks[item.getId()]);
	        }
	
	        if (item instanceof _Item2.default) {
	          return new item.constructor((0, _assign2.default)(options, item.get()));
	        }
	
	        return new item.constructor((0, _assign2.default)(options, item));
	      });
	    }
	  }, {
	    key: "buildFlatServiceTree",
	    value: function buildFlatServiceTree(serviceTree) {
	      return serviceTree.reduceItems(function (memo, item) {
	        if (item instanceof _ServiceTree2.default) {
	          return memo;
	        }
	
	        if (item.tasks) {
	          item.tasks.forEach(function (task) {
	            var taskData = {
	              version: task.version,
	              healthCheckResults: task.healthCheckResults
	            };
	
	            memo[task.id] = taskData;
	          });
	        }
	
	        return memo;
	      }, {});
	    }
	  }, {
	    key: "jobTree",
	    get: function get() {
	      return this.data.metronome.jobTree;
	    }
	
	    /**
	     * @type {DeploymentsList}
	     */
	
	  }, {
	    key: "deploymentsList",
	    get: function get() {
	      return this.data.marathon.deploymentsList;
	    }
	
	    /**
	     * @type {ServiceTree}
	     */
	
	  }, {
	    key: "serviceTree",
	    get: function get() {
	      if (!this._serviceTree) {
	        this.serviceTree = this.buildServiceTree();
	      }
	
	      return this._serviceTree;
	    },
	    set: function set(newValue) {
	      this._serviceTree = newValue;
	      this._flatServiceTree = null;
	    }
	  }, {
	    key: "taskLookupTable",
	    get: function get() {
	      if (!this._flatServiceTree) {
	        this._flatServiceTree = this.buildFlatServiceTree(this.serviceTree);
	      }
	
	      return this._flatServiceTree;
	    }
	  }, {
	    key: "jobDataReceived",
	    get: function get() {
	      return this.data.metronome.dataReceived;
	    }
	  }, {
	    key: "serviceDataReceived",
	    get: function get() {
	      return this.data.marathon.dataReceived;
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "dcos";
	    }
	  }]);
	  return DCOSStore;
	}(_events.EventEmitter);
	
	module.exports = new DCOSStore();

/***/ },
/* 1103 */
/***/ function(module, exports) {

	"use strict";
	
	var EventTypes = {};
	["MESOS_INITIALIZE_LOG_CHANGE", "MESOS_INITIALIZE_LOG_REQUEST_ERROR", "MESOS_LOG_CHANGE", "MESOS_LOG_REQUEST_ERROR", "MARATHON_APPS_CHANGE", "MARATHON_APPS_ERROR", "MARATHON_DEPLOYMENT_ROLLBACK_ERROR", "MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS", "MARATHON_DEPLOYMENTS_CHANGE", "MARATHON_DEPLOYMENTS_ERROR", "MARATHON_GROUP_CREATE_ERROR", "MARATHON_GROUP_CREATE_SUCCESS", "MARATHON_GROUP_DELETE_ERROR", "MARATHON_GROUP_DELETE_SUCCESS", "MARATHON_GROUP_EDIT_ERROR", "MARATHON_GROUP_EDIT_SUCCESS", "MARATHON_GROUPS_CHANGE", "MARATHON_GROUPS_ERROR", "MARATHON_INSTANCE_INFO_SUCCESS", "MARATHON_INSTANCE_INFO_ERROR", "MARATHON_POD_INSTANCE_KILL_SUCCESS", "MARATHON_POD_INSTANCE_KILL_ERROR", "MARATHON_QUEUE_CHANGE", "MARATHON_QUEUE_ERROR", "MARATHON_SERVICE_CREATE_ERROR", "MARATHON_SERVICE_CREATE_SUCCESS", "MARATHON_SERVICE_DELETE_ERROR", "MARATHON_SERVICE_DELETE_SUCCESS", "MARATHON_SERVICE_EDIT_ERROR", "MARATHON_SERVICE_EDIT_SUCCESS", "MARATHON_SERVICE_RESTART_ERROR", "MARATHON_SERVICE_RESTART_SUCCESS", "MARATHON_SERVICE_VERSION_CHANGE", "MARATHON_SERVICE_VERSION_ERROR", "MARATHON_SERVICE_VERSIONS_CHANGE", "MARATHON_SERVICE_VERSIONS_ERROR", "MARATHON_TASK_KILL_SUCCESS", "MARATHON_TASK_KILL_ERROR", "TASK_DIRECTORY_CHANGE", "TASK_DIRECTORY_ERROR", "NODE_STATE_ERROR", "NODE_STATE_SUCCESS"].forEach(function (eventType) {
	  EventTypes[eventType] = eventType;
	});
	
	module.exports = EventTypes;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _DeclinedOffersReasons = __webpack_require__(1209);
	
	var _DeclinedOffersReasons2 = _interopRequireDefault(_DeclinedOffersReasons);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEPLOYMENT_WARNING_DELAY_MS = 1000 * 60 * 5;
	var UNAVAILABLE_TEXT = "N/A";
	
	var rangeReducer = function rangeReducer(accumulator, range) {
	  accumulator.push(range.begin + " \u2013 " + range.end);
	
	  return accumulator;
	};
	
	var constraintsReducer = function constraintsReducer(accumulator, constraint) {
	  var name = constraint.name,
	      ranges = constraint.ranges,
	      set = constraint.set,
	      text = constraint.text,
	      scalar = constraint.scalar;
	
	  var value = null;
	
	  if (ranges) {
	    value = ranges.reduce(rangeReducer, []).join(", ");
	  } else if (set) {
	    value = set.join(", ");
	  } else if (text) {
	    value = text;
	  } else if (scalar) {
	    value = scalar;
	  }
	
	  if (!value) {
	    value = UNAVAILABLE_TEXT;
	  }
	
	  accumulator.push(name + ":" + value);
	
	  return accumulator;
	};
	
	var DeclinedOffersUtil = {
	  getSummaryFromQueue: function getSummaryFromQueue(queue) {
	    var app = queue.app,
	        pod = queue.pod,
	        _queue$processedOffer = queue.processedOffersSummary,
	        processedOffersSummary = _queue$processedOffer === undefined ? {} : _queue$processedOffer;
	
	
	    if (!processedOffersSummary.unusedOffersCount) {
	      return null;
	    }
	
	    var _processedOffersSumma = processedOffersSummary.rejectSummaryLastOffers,
	        rejectSummaryLastOffers = _processedOffersSumma === undefined ? [] : _processedOffersSumma;
	
	    var declinedOffersMap = {};
	
	    // Construct map of summary.
	    rejectSummaryLastOffers.forEach(function (_ref) {
	      var reason = _ref.reason,
	          declined = _ref.declined,
	          processed = _ref.processed;
	
	      declinedOffersMap[reason] = { declined: declined, processed: processed };
	    });
	
	    var roleOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.UNFULFILLED_ROLE];
	    var constraintOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.UNFULFILLED_CONSTRAINT];
	    var cpuOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.INSUFFICIENT_CPU];
	    var memOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.INSUFFICIENT_MEM];
	    var diskOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.INSUFFICIENT_DISK];
	    var portOfferSummary = declinedOffersMap[_DeclinedOffersReasons2.default.INSUFFICIENT_PORTS];
	
	    var requestedResources = null;
	
	    if (pod != null) {
	      var _pod$containers = pod.containers,
	          containers = _pod$containers === undefined ? [] : _pod$containers;
	
	
	      requestedResources = containers.reduce(function (accumulator, container) {
	        // Tally the total number of requested resources.
	        accumulator.cpus += _Util2.default.findNestedPropertyInObject(container, "resources.cpus") || 0;
	        accumulator.mem += _Util2.default.findNestedPropertyInObject(container, "resources.mem") || 0;
	        accumulator.disk += _Util2.default.findNestedPropertyInObject(container, "resources.disk") || 0;
	
	        // Push ports to the ports array if defined.
	        var ports = _Util2.default.findNestedPropertyInObject(container, "resources.ports");
	
	        if (ports) {
	          accumulator.ports.push(ports);
	        }
	
	        return accumulator;
	      }, {
	        roles: _Util2.default.findNestedPropertyInObject(pod, "scheduling.placement.acceptedResourceRoles") || ["*"],
	        constraints: _Util2.default.findNestedPropertyInObject(pod, "scheduling.placement.constraints") || [],
	        cpus: _Util2.default.findNestedPropertyInObject(pod, "executorResources.cpus") || 0,
	        mem: _Util2.default.findNestedPropertyInObject(pod, "executorResources.mem") || 0,
	        disk: _Util2.default.findNestedPropertyInObject(pod, "executorResources.disk") || 0,
	        ports: []
	      });
	    } else {
	      requestedResources = {
	        roles: _Util2.default.findNestedPropertyInObject(app, "acceptedResourceRoles") || ["*"],
	        constraints: _Util2.default.findNestedPropertyInObject(app, "constraints") || [],
	        cpus: app.cpus || 0,
	        mem: app.mem || 0,
	        disk: app.disk || 0,
	        ports: [app.ports] || [[]]
	      };
	    }
	
	    return {
	      roles: {
	        requested: requestedResources.roles.join(", ") || UNAVAILABLE_TEXT,
	        offers: roleOfferSummary.processed,
	        matched: roleOfferSummary.processed - roleOfferSummary.declined
	      },
	      constraints: {
	        requested: requestedResources.constraints.map(function () {
	          var constraint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	          if (Array.isArray(constraint)) {
	            return constraint.join(":");
	          }
	
	          // pod
	          var fieldName = constraint.fieldName,
	              operator = constraint.operator,
	              value = constraint.value;
	
	
	          return [fieldName, operator, value].filter(function (value) {
	            return value && value !== "";
	          }).join(":");
	        }).join(", ") || UNAVAILABLE_TEXT,
	        offers: constraintOfferSummary.processed,
	        matched: constraintOfferSummary.processed - constraintOfferSummary.declined
	      },
	      cpus: {
	        requested: requestedResources.cpus,
	        offers: cpuOfferSummary.processed,
	        matched: cpuOfferSummary.processed - cpuOfferSummary.declined
	      },
	      mem: {
	        requested: requestedResources.mem,
	        offers: memOfferSummary.processed,
	        matched: memOfferSummary.processed - memOfferSummary.declined
	      },
	      disk: {
	        requested: requestedResources.disk,
	        offers: diskOfferSummary.processed,
	        matched: diskOfferSummary.processed - diskOfferSummary.declined
	      },
	      ports: {
	        requested: requestedResources.ports.map(function () {
	          var resourceArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	          return resourceArr.join(", ");
	        }).join(", ") || UNAVAILABLE_TEXT,
	        offers: portOfferSummary.processed,
	        matched: portOfferSummary.processed - portOfferSummary.declined
	      }
	    };
	  },
	  getOffersFromQueue: function getOffersFromQueue(queue) {
	    var _queue$lastUnusedOffe = queue.lastUnusedOffers,
	        lastUnusedOffers = _queue$lastUnusedOffe === undefined ? [] : _queue$lastUnusedOffe;
	
	
	    if (!lastUnusedOffers.length) {
	      return null;
	    }
	
	    return lastUnusedOffers.map(function (declinedOffer) {
	      var _declinedOffer$offer = declinedOffer.offer,
	          _declinedOffer$offer$ = _declinedOffer$offer.attributes,
	          attributes = _declinedOffer$offer$ === undefined ? [] : _declinedOffer$offer$,
	          hostname = _declinedOffer$offer.hostname,
	          _declinedOffer$offer$2 = _declinedOffer$offer.resources,
	          resources = _declinedOffer$offer$2 === undefined ? [] : _declinedOffer$offer$2,
	          timestamp = declinedOffer.timestamp;
	
	
	      return {
	        hostname: hostname,
	        timestamp: timestamp,
	        unmatchedResource: declinedOffer.reason,
	        offered: resources.reduce(function (accumulator, resource) {
	          var name = resource.name,
	              role = resource.role,
	              scalar = resource.scalar;
	
	
	          if (scalar == null) {
	            scalar = 0;
	          }
	
	          if (name === "ports") {
	            var _resource$ranges = resource.ranges,
	                ranges = _resource$ranges === undefined ? [] : _resource$ranges;
	
	
	            accumulator[name] = ranges.reduce(rangeReducer, []);
	          } else {
	            accumulator[name] = scalar;
	          }
	
	          // Accumulate all roles.
	          if (!accumulator.roles.includes(role) && role) {
	            accumulator.roles.push(role);
	          }
	
	          return accumulator;
	        }, {
	          constraints: attributes.reduce(constraintsReducer, []).join(", "),
	          roles: []
	        })
	      };
	    });
	  },
	  getTimeWaiting: function getTimeWaiting(queue) {
	    return _Util2.default.findNestedPropertyInObject(queue, "processedOffersSummary.lastUsedOfferAt") || queue.since;
	  },
	  shouldDisplayDeclinedOffersWarning: function shouldDisplayDeclinedOffersWarning(item) {
	    var queue = item.getQueue();
	    var lastUsedOffer = _DateUtil2.default.strToMs(_Util2.default.findNestedPropertyInObject(queue, "processedOffersSummary.lastUsedOfferAt") || 0);
	    var lastUnusedOffer = _DateUtil2.default.strToMs(_Util2.default.findNestedPropertyInObject(queue, "processedOffersSummary.lastUnusedOfferAt") || 0);
	
	    // We don't display the declined offers debug info if the app is not in the
	    // deployment queue, or if the app's status is delayed, or if the app has
	    // matched an offer more recently than unmatched.
	    if (queue == null || item.getServiceStatus() === _ServiceStatus2.default.DELAYED || lastUsedOffer >= lastUnusedOffer) {
	      return false;
	    }
	
	    return Date.now() - _DateUtil2.default.strToMs(DeclinedOffersUtil.getTimeWaiting(queue)) >= DEPLOYMENT_WARNING_DELAY_MS;
	  }
	};
	
	module.exports = DeclinedOffersUtil;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1106);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MULTIPLICANTS = {
	  ms: 1,
	  sec: 1000,
	  min: 60000,
	  h: 3600000,
	  d: 86400000
	};
	
	var DateUtil = {
	  /*
	   * Composes a string expression by de-composing the given time in milliseconds
	   * into it's sub-multiplicants. For example:
	   *
	   * 11002 = 11002 ms (11 sec, 2 ms)
	   */
	  msToMultiplicants: function msToMultiplicants(ms) {
	    var multiplicants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_MULTIPLICANTS;
	
	    var expressionComponents = [];
	    var multiplicantKeys = (0, _keys2.default)(multiplicants);
	
	    // Start applying biggest to smallest fit
	    for (var i = multiplicantKeys.length - 1; i >= 0; --i) {
	      var unitName = multiplicantKeys[i];
	      var unitSize = multiplicants[unitName];
	      var fullFits = Math.floor(ms / unitSize);
	
	      if (fullFits > 0) {
	        expressionComponents.push(fullFits + " " + unitName);
	        ms = ms % unitSize;
	      }
	    }
	
	    return expressionComponents;
	  },
	
	
	  /**
	   * Creates a time string from time provided
	   * @param  {Date|Number} ms number to convert to time string
	   * @return {String} time string with the format 'MM-DD-YYYY [at] h:mma'
	   */
	  msToDateStr: function msToDateStr(ms) {
	    return (0, _moment2.default)(ms).format("MM-DD-YYYY [at] h:mma");
	  },
	
	
	  /**
	   * Creates a UTC time string from time provided
	   * @param  {Date|Number} ms number to convert to UTC time string
	   * @return {String} time string with the format 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	   */
	  msToUTCDate: function msToUTCDate(ms) {
	    return (0, _moment2.default)(ms).utc().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
	  },
	
	
	  /**
	   * Creates a log timestamp string from time provided
	   * @param  {Date|Number} ms number to convert to ANSI C time string
	   * @return {String} time string with the format 'YYYY-MM-DD hh:mm:ss'
	   */
	  msToLogTime: function msToLogTime(ms) {
	    return (0, _moment2.default)(ms).utc().format("YYYY-MM-DD hh:mm:ss");
	  },
	
	
	  /**
	  /**
	   * Creates relative time based on now and the time provided
	   * @param  {Date|Number} ms number to convert to relative time string
	   * @param  {Boolean} suppressRelativeTime whether to remove 'ago' from string
	   * @return {String} time string relative from now
	   */
	  msToRelativeTime: function msToRelativeTime(ms) {
	    var suppressRelativeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return (0, _moment2.default)(ms).fromNow(suppressRelativeTime);
	  },
	  strToMs: function strToMs(str) {
	    if (str == null) {
	      return null;
	    }
	
	    return (0, _moment2.default)(str).valueOf();
	  },
	  getDuration: function getDuration(time) {
	    var formatKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "seconds";
	
	    return _moment2.default.duration(time, formatKey).humanize();
	  }
	};
	
	module.exports = DateUtil;

/***/ },
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  INSUFFICIENT_MEM: "InsufficientMemory",
	  INSUFFICIENT_CPU: "InsufficientCpus",
	  INSUFFICIENT_DISK: "InsufficientDisk",
	  INSUFFICIENT_PORTS: "InsufficientPorts",
	  UNFULFILLED_CONSTRAINT: "UnfulfilledConstraint",
	  UNFULFILLED_ROLE: "UnfulfilledRole"
	};

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _Deployment = __webpack_require__(1211);
	
	var _Deployment2 = _interopRequireDefault(_Deployment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A typed {@link List} of {@link Deployment}s.
	 *
	 * @struct
	 */
	var DeploymentsList = function (_List) {
	  (0, _inherits3.default)(DeploymentsList, _List);
	
	  function DeploymentsList() {
	    (0, _classCallCheck3.default)(this, DeploymentsList);
	    return (0, _possibleConstructorReturn3.default)(this, (DeploymentsList.__proto__ || (0, _getPrototypeOf2.default)(DeploymentsList)).apply(this, arguments));
	  }
	
	  return DeploymentsList;
	}(_List3.default);
	
	DeploymentsList.type = _Deployment2.default;
	
	module.exports = DeploymentsList;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An application deployment.
	 *
	 * @struct
	 * @see the
	 *   {@link http://mesosphere.github.io/marathon/docs/deployments.html|Marathon
	 *   application deployment documentation}
	 */
	module.exports = function (_Item) {
	  (0, _inherits3.default)(Deployment, _Item);
	
	  function Deployment() {
	    (0, _classCallCheck3.default)(this, Deployment);
	    return (0, _possibleConstructorReturn3.default)(this, (Deployment.__proto__ || (0, _getPrototypeOf2.default)(Deployment)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Deployment, [{
	    key: "getId",
	
	    /**
	     * @return {string} the id of this deployment
	     */
	    value: function getId() {
	      return this.get("id");
	    }
	
	    /**
	     * @return {Array.<string>} an array of app IDs affected by this deployment.
	     */
	
	  }, {
	    key: "getAffectedServiceIds",
	    value: function getAffectedServiceIds() {
	      var affectedApps = this.get("affectedApps") || [];
	      var affectedPods = this.get("affectedPods") || [];
	
	      return affectedApps.concat(affectedPods);
	    }
	
	    /**
	     * @return {Array.<string>} an array of stale service IDs.
	     */
	
	  }, {
	    key: "getStaleServiceIds",
	    value: function getStaleServiceIds() {
	      return this.get("staleServiceIds");
	    }
	
	    /**
	     * @return {ServiceList} list of services affected by this deployment.
	     */
	
	  }, {
	    key: "getAffectedServices",
	    value: function getAffectedServices() {
	      var ids = this.getAffectedServiceIds();
	      var services = this.get("affectedServices");
	      if (ids == null || ids.length === 0) {
	        return [];
	      }
	      if (services == null) {
	        throw Error("Affected services list is stale.");
	      }
	
	      return services;
	    }
	
	    /**
	     * @return {Date} the date and time at which the deployment was started.
	     */
	
	  }, {
	    key: "getStartTime",
	    value: function getStartTime() {
	      return new Date(this.get("version"));
	    }
	
	    /**
	     * @return {number} the index of the deployment step currently underway.
	     * @see {@link getTotalSteps}
	     */
	
	  }, {
	    key: "getCurrentStep",
	    value: function getCurrentStep() {
	      return this.get("currentStep");
	    }
	
	    /**
	     * @return {number} the number of steps in this deployment.
	     * @see {@link getCurrentStep}
	     */
	
	  }, {
	    key: "getTotalSteps",
	    value: function getTotalSteps() {
	      return this.get("totalSteps");
	    }
	
	    /**
	     * @return {boolean} true if this deployment starts a new service.
	     */
	
	  }, {
	    key: "isStarting",
	    value: function isStarting() {
	      var steps = this.get("steps");
	      if (steps != null) {
	        return this.get("steps").some(function (step) {
	          return step.actions.some(function (action) {
	            return action.type === "StartApplication";
	          });
	        });
	      }
	    }
	  }]);
	  return Deployment;
	}(_Item3.default);

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _Tree2 = __webpack_require__(1220);
	
	var _Tree3 = _interopRequireDefault(_Tree2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Tree) {
	  (0, _inherits3.default)(JobTree, _Tree);
	
	  /**
	   * (Metronome) JobTree
	   * @param {{
	   *          id:string,
	   *          items:array<({id:string, items:array}|*)>,
	   *          filterProperties:{propertyName:(null|string|function)}
	   *        }} options
	   * TODO: DCOS-7369 - Add remove item method
	   * @constructor
	   * @struct
	   */
	  function JobTree() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        id = _ref.id;
	
	    (0, _classCallCheck3.default)(this, JobTree);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobTree.__proto__ || (0, _getPrototypeOf2.default)(JobTree)).apply(this, arguments));
	
	    _this.id = "";
	    if (typeof id == "string") {
	      _this.id = id;
	    }
	
	    // Converts items into instances of JobTree or Job
	    // based on their properties.
	    _this.list = _this.list.map(function (item) {
	      if (item instanceof _Job2.default || item instanceof JobTree) {
	        return item;
	      }
	
	      // Create instances of JobTree for tree like items
	      if (item.items != null && Array.isArray(item.items) && !(item instanceof JobTree)) {
	        return new _this.constructor((0, _assign2.default)({ filterProperties: _this.getFilterProperties() }, item));
	      }
	
	      // Convert items into instance of Job
	      return new _Job2.default(item);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobTree, [{
	    key: "getId",
	    value: function getId() {
	      return this.id;
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId().split(".").pop();
	    }
	  }]);
	  return JobTree;
	}(_Tree3.default);

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _CleanJSONUtil = __webpack_require__(1065);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _JobRunList = __webpack_require__(1214);
	
	var _JobRunList2 = _interopRequireDefault(_JobRunList);
	
	var _JobStatus = __webpack_require__(1218);
	
	var _JobStatus2 = _interopRequireDefault(_JobStatus);
	
	var _JobResources = __webpack_require__(1219);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(Job, _Item);
	
	  function Job() {
	    (0, _classCallCheck3.default)(this, Job);
	    return (0, _possibleConstructorReturn3.default)(this, (Job.__proto__ || (0, _getPrototypeOf2.default)(Job)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Job, [{
	    key: "getActiveRuns",
	    value: function getActiveRuns() {
	      return new _JobRunList2.default({ items: this.get("activeRuns") });
	    }
	  }, {
	    key: "getCommand",
	    value: function getCommand() {
	      var _ref = this.get("run") || {},
	          cmd = _ref.cmd;
	
	      return cmd;
	    }
	  }, {
	    key: "getCpus",
	    value: function getCpus() {
	      var _ref2 = this.get("run") || {},
	          _ref2$cpus = _ref2.cpus,
	          cpus = _ref2$cpus === undefined ? _JobResources.DEFAULT_CPUS : _ref2$cpus;
	
	      return cpus;
	    }
	  }, {
	    key: "getDescription",
	    value: function getDescription() {
	      return this.get("description");
	    }
	  }, {
	    key: "getDocker",
	    value: function getDocker() {
	      var _ref3 = this.get("run") || {},
	          _ref3$docker = _ref3.docker,
	          docker = _ref3$docker === undefined ? {} : _ref3$docker;
	
	      return docker;
	    }
	  }, {
	    key: "getDisk",
	    value: function getDisk() {
	      var _ref4 = this.get("run") || {},
	          _ref4$disk = _ref4.disk,
	          disk = _ref4$disk === undefined ? _JobResources.DEFAULT_DISK : _ref4$disk;
	
	      return disk;
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.get("id");
	    }
	  }, {
	    key: "getJobRuns",
	    value: function getJobRuns() {
	      var activeRuns = this.get("activeRuns") || [];
	
	      var _ref5 = this.get("history") || {},
	          _ref5$failedFinishedR = _ref5.failedFinishedRuns,
	          failedFinishedRuns = _ref5$failedFinishedR === undefined ? [] : _ref5$failedFinishedR,
	          _ref5$successfulFinis = _ref5.successfulFinishedRuns,
	          successfulFinishedRuns = _ref5$successfulFinis === undefined ? [] : _ref5$successfulFinis;
	
	      return new _JobRunList2.default({
	        items: [].concat(activeRuns, failedFinishedRuns, successfulFinishedRuns)
	      });
	    }
	  }, {
	    key: "getParameters",
	    value: function getParameters() {
	      return (0, _Util.findNestedPropertyInObject)(this.get("run"), "docker.parameters") || [];
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.get("labels") || {};
	    }
	  }, {
	    key: "getMem",
	    value: function getMem() {
	      var _ref6 = this.get("run") || {},
	          _ref6$mem = _ref6.mem,
	          mem = _ref6$mem === undefined ? _JobResources.DEFAULT_MEM : _ref6$mem;
	
	      return mem;
	    }
	  }, {
	    key: "getLastRunsSummary",
	    value: function getLastRunsSummary() {
	      return this.get("historySummary") || {};
	    }
	  }, {
	    key: "getLastRunStatus",
	    value: function getLastRunStatus() {
	      var _getLastRunsSummary = this.getLastRunsSummary(),
	          lastFailureAt = _getLastRunsSummary.lastFailureAt,
	          lastSuccessAt = _getLastRunsSummary.lastSuccessAt;
	
	      var status = _JobStatus2.default["N/A"].displayName;
	      var time = null;
	
	      if (lastFailureAt !== null) {
	        lastFailureAt = _DateUtil2.default.strToMs(lastFailureAt);
	      }
	
	      if (lastSuccessAt !== null) {
	        lastSuccessAt = _DateUtil2.default.strToMs(lastSuccessAt);
	      }
	
	      if (lastFailureAt !== null || lastSuccessAt !== null) {
	        if (lastFailureAt > lastSuccessAt) {
	          status = _JobStatus2.default["Failed"].displayName;
	          time = lastFailureAt;
	        } else {
	          status = _JobStatus2.default["Success"].displayName;
	          time = lastSuccessAt;
	        }
	      }
	
	      return { status: status, time: time };
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId().split(".").pop();
	    }
	  }, {
	    key: "getSchedules",
	    value: function getSchedules() {
	      var schedules = this.get("schedules");
	
	      if (!Array.isArray(schedules)) {
	        return [];
	      }
	
	      return schedules;
	    }
	  }, {
	    key: "getScheduleStatus",
	    value: function getScheduleStatus() {
	      var activeRuns = this.getActiveRuns();
	      var activeRunsLength = activeRuns.getItems().length;
	      var scheduleLength = this.getSchedules().length;
	
	      if (activeRunsLength > 0) {
	        var longestRunningActiveRun = activeRuns.getLongestRunningActiveRun();
	
	        return longestRunningActiveRun.getStatus();
	      }
	
	      if (scheduleLength > 0) {
	        var schedule = this.getSchedules()[0];
	
	        if (schedule != null && schedule.enabled) {
	          return "SCHEDULED";
	        }
	      }
	
	      if (scheduleLength === 0 && activeRunsLength === 0) {
	        return "UNSCHEDULED";
	      }
	
	      return "COMPLETED";
	    }
	  }, {
	    key: "toJSON",
	    value: function toJSON() {
	      return (0, _CleanJSONUtil.cleanJobJSON)(this.get());
	    }
	  }]);
	  return Job;
	}(_Item3.default);

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _JobRun = __webpack_require__(1215);
	
	var _JobRun2 = _interopRequireDefault(_JobRun);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobRunList = function (_List) {
	  (0, _inherits3.default)(JobRunList, _List);
	
	  function JobRunList() {
	    (0, _classCallCheck3.default)(this, JobRunList);
	    return (0, _possibleConstructorReturn3.default)(this, (JobRunList.__proto__ || (0, _getPrototypeOf2.default)(JobRunList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobRunList, [{
	    key: "getLongestRunningActiveRun",
	    value: function getLongestRunningActiveRun() {
	      var sortedRuns = this.getItems().sort(function (a, b) {
	        if (a.getDateCreated() == null && b.getDateCreated() == null) {
	          return 0;
	        }
	
	        if (a.getDateCreated() == null) {
	          return 1;
	        }
	
	        if (b.getDateCreated() == null) {
	          return -1;
	        }
	
	        return a.getDateCreated() - b.getDateCreated();
	      });
	
	      return sortedRuns[0];
	    }
	  }]);
	  return JobRunList;
	}(_List3.default);
	
	JobRunList.type = _JobRun2.default;
	
	module.exports = JobRunList;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _JobTaskList = __webpack_require__(1216);
	
	var _JobTaskList2 = _interopRequireDefault(_JobTaskList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobRun = function (_Item) {
	  (0, _inherits3.default)(JobRun, _Item);
	
	  function JobRun() {
	    (0, _classCallCheck3.default)(this, JobRun);
	    return (0, _possibleConstructorReturn3.default)(this, (JobRun.__proto__ || (0, _getPrototypeOf2.default)(JobRun)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobRun, [{
	    key: "getDateCreated",
	    value: function getDateCreated() {
	      return _DateUtil2.default.strToMs(this.get("createdAt"));
	    }
	  }, {
	    key: "getDateFinished",
	    value: function getDateFinished() {
	      return _DateUtil2.default.strToMs(this.get("finishedAt"));
	    }
	  }, {
	    key: "getJobID",
	    value: function getJobID() {
	      return this.get("jobId");
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      return this.get("status");
	    }
	  }, {
	    key: "getTasks",
	    value: function getTasks() {
	      return new _JobTaskList2.default({ items: this.get("tasks") });
	    }
	  }]);
	  return JobRun;
	}(_Item3.default);
	
	module.exports = JobRun;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _JobTask = __webpack_require__(1217);
	
	var _JobTask2 = _interopRequireDefault(_JobTask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobTaskList = function (_List) {
	  (0, _inherits3.default)(JobTaskList, _List);
	
	  function JobTaskList() {
	    (0, _classCallCheck3.default)(this, JobTaskList);
	    return (0, _possibleConstructorReturn3.default)(this, (JobTaskList.__proto__ || (0, _getPrototypeOf2.default)(JobTaskList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobTaskList, [{
	    key: "getLongestRunningTask",
	    value: function getLongestRunningTask() {
	      var sortedTasks = this.getItems().sort(function (a, b) {
	        if (a.getDateStarted() == null && b.getDateStarted() == null) {
	          return 0;
	        }
	
	        if (a.getDateStarted() == null) {
	          return 1;
	        }
	
	        if (b.getDateStarted() == null) {
	          return -1;
	        }
	
	        return a.getDateStarted() - b.getDateStarted();
	      });
	
	      return sortedTasks[0];
	    }
	  }]);
	  return JobTaskList;
	}(_List3.default);
	
	JobTaskList.type = _JobTask2.default;
	
	module.exports = JobTaskList;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(JobTask, _Item);
	
	  function JobTask() {
	    (0, _classCallCheck3.default)(this, JobTask);
	    return (0, _possibleConstructorReturn3.default)(this, (JobTask.__proto__ || (0, _getPrototypeOf2.default)(JobTask)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobTask, [{
	    key: "getDateStarted",
	    value: function getDateStarted() {
	      return _DateUtil2.default.strToMs(this.get("startedAt"));
	    }
	  }, {
	    key: "getDateCompleted",
	    value: function getDateCompleted() {
	      return _DateUtil2.default.strToMs(this.get("completedAt"));
	    }
	  }, {
	    key: "getTaskID",
	    value: function getTaskID() {
	      return this.get("id");
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      return this.get("status");
	    }
	  }]);
	  return JobTask;
	}(_Item3.default);

/***/ },
/* 1218 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	* Sort order is ordered by most important (lowest number, top of list)
	* to least important (largest number, bottom of list)
	*/
	var JobStatus = {
	  "N/A": {
	    displayName: "N/A",
	    sortOrder: 1
	  },
	  Success: {
	    displayName: "Success",
	    sortOrder: 2
	  },
	  Failed: {
	    displayName: "Failed",
	    sortOrder: 0
	  }
	};
	
	module.exports = JobStatus;

/***/ },
/* 1219 */
/***/ function(module, exports) {

	"use strict";
	
	var JobResources = {
	  DEFAULT_CPUS: 0.01,
	  DEFAULT_DISK: 0,
	  DEFAULT_MEM: 128
	};
	
	module.exports = JobResources;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_List) {
	  (0, _inherits3.default)(Tree, _List);
	
	  /**
	   * Tree
	   * @param {{
	   *          items:array<({items:array}|*)>,
	   *          filterProperties:{propertyName:(null|function)}
	   *        }} options
	   * @constructor
	   * @struct
	   */
	  function Tree() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Tree);
	
	    // Replace tree like items instances of Tree
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Tree.__proto__ || (0, _getPrototypeOf2.default)(Tree)).call(this, options));
	
	    _this.list = _this.list.map(function (item) {
	      if (item.items != null && Array.isArray(item.items) && !(item instanceof Tree)) {
	        return new _this.constructor((0, _assign2.default)({ filterProperties: _this.getFilterProperties() }, item));
	      }
	
	      return item;
	    });
	    return _this;
	  }
	
	  /**
	   * @return {List} flat List of all items
	   */
	
	
	  (0, _createClass3.default)(Tree, [{
	    key: "flattenItems",
	    value: function flattenItems() {
	      var items = this.getItems().reduce(function (current, item) {
	        current.push(item);
	        if (item instanceof Tree) {
	          return current.concat(item.flattenItems().getItems());
	        }
	
	        return current;
	      }, []);
	
	      return new _List3.default({ items: items });
	    }
	
	    /**
	     * @param {function} callback Function to test each element of the array,
	     * taking three arguments: item, index, list. Return true to keep the item,
	     * false otherwise.
	     * @return {Tree} List (or child class) containing mapped items
	     */
	
	  }, {
	    key: "filterItems",
	    value: function filterItems(callback) {
	      var _this2 = this;
	
	      var items = this.getItems().map(function (item) {
	        // Filter subtrees
	        if (item instanceof Tree) {
	          return item.filterItems(callback);
	        }
	
	        return item;
	      }).filter(function (item, index) {
	        // Don't filter subtrees with matching items
	        if (item instanceof Tree && item.getItems().length > 0) {
	          return true;
	        }
	
	        return callback(item, index, _this2);
	      });
	
	      return new this.constructor((0, _assign2.default)({}, this, { items: items }));
	    }
	
	    /**
	     * Filters items in tree and returns a new instance of the tree used.
	     * @param  {string} filterText string to search in properties of the list
	     * @param  {{propertyName:(null|function)}} [filterProperties] object to
	     *     configure filter properties as well as their getters
	     * @return {Tree} Tree (or child class) containing filtered items
	     */
	
	  }, {
	    key: "filterItemsByText",
	    value: function filterItemsByText(filterText) {
	      var filterProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFilterProperties();
	
	      if (filterText) {
	        var regex = _StringUtil2.default.escapeForRegExp(filterText);
	        var searchPattern = new RegExp(regex, "i");
	
	        return this.filterItems(function (item) {
	          // Filter items by property values
	          return (0, _keys2.default)(filterProperties).some(function (prop) {
	            // We need different handlers for item getters since the property
	            // there can be different ways of getting the value needed
	
	            // Use getter function if specified in filterProperties.
	            // This is used if property is nested or type is different than string
	            var valueGetter = filterProperties[prop];
	            if (typeof valueGetter === "function") {
	              return searchPattern.test(valueGetter(item, prop) || "");
	            }
	
	            // Use default getter if item is an instanceof Item.
	            // This is the regular way of getting a property on an item
	            if (item instanceof _Item2.default) {
	              return searchPattern.test(item.get(prop) || "");
	            }
	
	            // Last resort is to get property on object.
	            // Some of the items in lists are not always of instance Item and
	            // therefore we might need to get it directly on the object
	            return searchPattern.test(item[prop] || "");
	          });
	        });
	      }
	
	      return new this.constructor((0, _assign2.default)({}, this, { items: this.getItems() }));
	    }
	
	    /**
	     * @param {function} callback Function to execute on each value in the array,
	     * taking one argument: item
	     * @return {object} matching item
	     */
	
	  }, {
	    key: "findItem",
	    value: function findItem(callback) {
	      return this.flattenItems().findItem(callback);
	    }
	
	    /**
	     * @param {function} callback Function that produces an item of the new
	     * Tree, taking three arguments: item, index, tree
	     * @return {Tree} Tree (or child class) containing mapped items
	     */
	
	  }, {
	    key: "mapItems",
	    value: function mapItems(callback) {
	      var _this3 = this;
	
	      var items = this.getItems().map(function (item, index) {
	        if (item instanceof Tree) {
	          return callback(item.mapItems(callback), index, _this3);
	        }
	
	        return callback(item, index, _this3);
	      });
	
	      return new this.constructor((0, _assign2.default)({}, this, { items: items }));
	    }
	
	    /**
	     * @param {function} callback Function to execute on each value in the
	     * array, taking four arguments: previousValue, currentValue, index, list
	     * @param {*} initialValue
	     * @returns {*} returnValue
	     */
	
	  }, {
	    key: "reduceItems",
	    value: function reduceItems(callback, initialValue) {
	      var _this4 = this;
	
	      return this.getItems().reduce(function (previousValue, currentValue, index) {
	        var returnValue = callback(previousValue, currentValue, index, _this4);
	        if (currentValue instanceof Tree) {
	          returnValue = currentValue.reduceItems(callback, returnValue);
	        }
	
	        return returnValue;
	      }, initialValue);
	    }
	  }]);
	  return Tree;
	}(_List3.default);

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	var _ActionTypes2 = __webpack_require__(1223);
	
	var _DeploymentsList = __webpack_require__(1210);
	
	var _DeploymentsList2 = _interopRequireDefault(_DeploymentsList);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	var _EventTypes = __webpack_require__(1103);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _ServiceImages = __webpack_require__(1081);
	
	var _ServiceImages2 = _interopRequireDefault(_ServiceImages);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = null;
	var shouldEmbedLastUnusedOffers = false;
	
	function startPolling() {
	  if (requestInterval == null) {
	    poll();
	    requestInterval = global.setInterval(poll, _Config2.default.getRefreshRate());
	  }
	}
	
	function stopPolling() {
	  if (requestInterval != null) {
	    global.clearInterval(requestInterval);
	    requestInterval = null;
	  }
	}
	
	function poll() {
	  var options = {};
	
	  if (shouldEmbedLastUnusedOffers) {
	    options.params = "?embed=lastUnusedOffers";
	  }
	
	  _MarathonActions2.default.fetchGroups();
	  _MarathonActions2.default.fetchQueue(options);
	  _MarathonActions2.default.fetchDeployments();
	}
	
	var MarathonStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(MarathonStore, _GetSetBaseStore);
	
	  function MarathonStore() {
	    (0, _classCallCheck3.default)(this, MarathonStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MarathonStore.__proto__ || (0, _getPrototypeOf2.default)(MarathonStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      apps: {},
	      deployments: new _DeploymentsList2.default(),
	      groups: new _ServiceTree2.default(),
	      info: {}
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        appsSuccess: _EventTypes.MARATHON_APPS_CHANGE,
	        appsError: _EventTypes.MARATHON_APPS_ERROR,
	        deploymentsSuccess: _EventTypes.MARATHON_DEPLOYMENTS_CHANGE,
	        deploymentsError: _EventTypes.MARATHON_DEPLOYMENTS_ERROR,
	        deploymentRollbackSuccess: _EventTypes.MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS,
	        deploymentRollbackError: _EventTypes.MARATHON_DEPLOYMENT_ROLLBACK_ERROR,
	        instanceInfoSuccess: _EventTypes.MARATHON_INSTANCE_INFO_SUCCESS,
	        instanceInfoError: _EventTypes.MARATHON_INSTANCE_INFO_ERROR,
	        groupCreateSuccess: _EventTypes.MARATHON_GROUP_CREATE_SUCCESS,
	        groupCreateError: _EventTypes.MARATHON_GROUP_CREATE_ERROR,
	        groupDeleteSuccess: _EventTypes.MARATHON_GROUP_DELETE_SUCCESS,
	        groupDeleteError: _EventTypes.MARATHON_GROUP_DELETE_ERROR,
	        groupEditSuccess: _EventTypes.MARATHON_GROUP_EDIT_SUCCESS,
	        groupEditError: _EventTypes.MARATHON_GROUP_EDIT_ERROR,
	        groupsSuccess: _EventTypes.MARATHON_GROUPS_CHANGE,
	        groupsError: _EventTypes.MARATHON_GROUPS_ERROR,
	        podInstanceKillSuccess: _EventTypes.MARATHON_POD_INSTANCE_KILL_SUCCESS,
	        podInstanceKillError: _EventTypes.MARATHON_POD_INSTANCE_KILL_ERROR,
	        serviceCreateError: _EventTypes.MARATHON_SERVICE_CREATE_ERROR,
	        serviceCreateSuccess: _EventTypes.MARATHON_SERVICE_CREATE_SUCCESS,
	        serviceDeleteError: _EventTypes.MARATHON_SERVICE_DELETE_ERROR,
	        serviceDeleteSuccess: _EventTypes.MARATHON_SERVICE_DELETE_SUCCESS,
	        serviceEditError: _EventTypes.MARATHON_SERVICE_EDIT_ERROR,
	        serviceEditSuccess: _EventTypes.MARATHON_SERVICE_EDIT_SUCCESS,
	        serviceRestartError: _EventTypes.MARATHON_SERVICE_RESTART_ERROR,
	        serviceRestartSuccess: _EventTypes.MARATHON_SERVICE_RESTART_SUCCESS,
	        taskKillSuccess: _EventTypes.MARATHON_TASK_KILL_SUCCESS,
	        taskKillError: _EventTypes.MARATHON_TASK_KILL_ERROR
	      },
	      unmountWhen: function unmountWhen(store, event) {
	        if (event === "appsSuccess") {
	          return store.hasProcessedApps();
	        }
	
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	
	      switch (action.type) {
	        case _ActionTypes2.REQUEST_MARATHON_INSTANCE_INFO_ERROR:
	          _this.emit(_EventTypes.MARATHON_INSTANCE_INFO_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_INSTANCE_INFO_SUCCESS:
	          _this.processMarathonInfoRequest(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_CREATE_ERROR:
	          _this.emit(_EventTypes.MARATHON_GROUP_CREATE_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_CREATE_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_GROUP_CREATE_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_DELETE_ERROR:
	          _this.emit(_EventTypes.MARATHON_GROUP_DELETE_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_DELETE_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_GROUP_DELETE_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_EDIT_ERROR:
	          _this.emit(_EventTypes.MARATHON_GROUP_EDIT_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUP_EDIT_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_GROUP_EDIT_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_CREATE_ERROR:
	          _this.emit(_EventTypes.MARATHON_SERVICE_CREATE_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_CREATE_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_SERVICE_CREATE_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_DELETE_ERROR:
	          _this.emit(_EventTypes.MARATHON_SERVICE_DELETE_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_DELETE_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_SERVICE_DELETE_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_EDIT_ERROR:
	          _this.emit(_EventTypes.MARATHON_SERVICE_EDIT_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_EDIT_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_SERVICE_EDIT_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_RESTART_ERROR:
	          _this.emit(_EventTypes.MARATHON_SERVICE_RESTART_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_RESTART_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_SERVICE_RESTART_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUPS_SUCCESS:
	          _this.processMarathonGroups(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_DEPLOYMENTS_SUCCESS:
	          _this.processMarathonDeployments(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUPS_ERROR:
	          _this.processMarathonGroupsError();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_DEPLOYMENTS_ERROR:
	          _this.processMarathonDeploymentsError();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_GROUPS_ONGOING:
	          _this.processOngoingRequest();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_QUEUE_SUCCESS:
	          _this.processMarathonQueue(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_QUEUE_ERROR:
	          _this.processMarathonQueueError();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_VERSION_SUCCESS:
	          _this.processMarathonServiceVersion(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_VERSION_ERROR:
	          _this.processMarathonServiceVersionError();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_VERSIONS_SUCCESS:
	          _this.processMarathonServiceVersions(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_SERVICE_VERSIONS_ERROR:
	          _this.processMarathonServiceVersionsError();
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS:
	          _this.processMarathonDeploymentRollback(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_ERROR:
	          _this.processMarathonDeploymentRollbackError(action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_TASK_KILL_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_TASK_KILL_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_TASK_KILL_ERROR:
	          _this.emit(_EventTypes.MARATHON_TASK_KILL_ERROR, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_POD_INSTANCE_KILL_SUCCESS:
	          _this.emit(_EventTypes.MARATHON_POD_INSTANCE_KILL_SUCCESS);
	          break;
	        case _ActionTypes2.REQUEST_MARATHON_POD_INSTANCE_KILL_ERROR:
	          _this.emit(_EventTypes.MARATHON_POD_INSTANCE_KILL_ERROR, action.data);
	          break;
	      }
	
	      return true;
	    });
	
	    _VisibilityStore2.default.addChangeListener(_EventTypes.VISIBILITY_CHANGE, _this.onVisibilityStoreChange.bind(_this));
	    return _this;
	  }
	
	  (0, _createClass3.default)(MarathonStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	
	      if (this.shouldPoll()) {
	        startPolling();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "onVisibilityStoreChange",
	    value: function onVisibilityStoreChange() {
	      if (!_VisibilityStore2.default.isInactive() && this.shouldPoll()) {
	        startPolling();
	
	        return;
	      }
	
	      stopPolling();
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return this.listenerCount(_EventTypes.MARATHON_GROUPS_CHANGE) > 0 || this.listenerCount(_EventTypes.MARATHON_QUEUE_CHANGE) > 0 || this.listenerCount(_EventTypes.MARATHON_DEPLOYMENTS_CHANGE) > 0 || this.listenerCount(_EventTypes.MARATHON_APPS_CHANGE) > 0;
	    }
	  }, {
	    key: "changeService",
	    value: function changeService() {
	      return _MarathonActions2.default.changeService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "createGroup",
	    value: function createGroup() {
	      return _MarathonActions2.default.createGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "deleteGroup",
	    value: function deleteGroup() {
	      return _MarathonActions2.default.deleteGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "editGroup",
	    value: function editGroup() {
	      return _MarathonActions2.default.editGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "createService",
	    value: function createService() {
	      return _MarathonActions2.default.createService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "deleteService",
	    value: function deleteService() {
	      return _MarathonActions2.default.deleteService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "editService",
	    value: function editService() {
	      return _MarathonActions2.default.editService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "restartService",
	    value: function restartService() {
	      return _MarathonActions2.default.restartService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "fetchQueue",
	    value: function fetchQueue() {
	      return _MarathonActions2.default.fetchQueue.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "fetchServiceVersion",
	    value: function fetchServiceVersion() {
	      return _MarathonActions2.default.fetchServiceVersion.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "fetchServiceVersions",
	    value: function fetchServiceVersions() {
	      return _MarathonActions2.default.fetchServiceVersions.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "fetchMarathonInstanceInfo",
	    value: function fetchMarathonInstanceInfo() {
	      return _MarathonActions2.default.fetchMarathonInstanceInfo.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "killPodInstances",
	    value: function killPodInstances() {
	      return _MarathonActions2.default.killPodInstances.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "killTasks",
	    value: function killTasks() {
	      return _MarathonActions2.default.killTasks.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "hasProcessedApps",
	    value: function hasProcessedApps() {
	      return (0, _keys2.default)(this.get("apps")).length > 0;
	    }
	  }, {
	    key: "getFrameworkHealth",
	    value: function getFrameworkHealth(app) {
	      if (app.healthChecks == null || app.healthChecks.length === 0) {
	        return _HealthStatus2.default.NA;
	      }
	
	      var health = _HealthStatus2.default.IDLE;
	      if (app.tasksUnhealthy > 0) {
	        health = _HealthStatus2.default.UNHEALTHY;
	      } else if (app.tasksRunning > 0 && app.tasksHealthy === app.tasksRunning) {
	        health = _HealthStatus2.default.HEALTHY;
	      }
	
	      return health;
	    }
	  }, {
	    key: "getInstanceInfo",
	    value: function getInstanceInfo() {
	      return this.get("info");
	    }
	  }, {
	    key: "getServiceHealth",
	    value: function getServiceHealth(name) {
	      var appName = name.toLowerCase();
	      var marathonApps = this.get("apps");
	
	      if (!marathonApps[appName]) {
	        return _HealthStatus2.default.NA;
	      }
	
	      return marathonApps[appName].health;
	    }
	  }, {
	    key: "getServiceImages",
	    value: function getServiceImages(name) {
	      var appName = name.toLowerCase();
	      var appImages = null;
	      var marathonApps = this.get("apps");
	
	      if (marathonApps[appName]) {
	        appImages = marathonApps[appName].images;
	      }
	
	      return appImages;
	    }
	  }, {
	    key: "getServiceInstalledTime",
	    value: function getServiceInstalledTime(name) {
	      var appName = name.toLowerCase();
	      var appInstalledTime = null;
	      var marathonApps = this.get("apps");
	
	      if (marathonApps[appName]) {
	        appInstalledTime = marathonApps[appName].snapshot.version;
	      }
	
	      return appInstalledTime;
	    }
	  }, {
	    key: "getServiceVersion",
	    value: function getServiceVersion(name) {
	      var appName = name.toLowerCase();
	      var marathonApps = this.get("apps");
	
	      if (marathonApps[appName]) {
	        return this.getVersion(marathonApps[appName].snapshot);
	      }
	
	      return null;
	    }
	  }, {
	    key: "getVersion",
	    value: function getVersion(app) {
	      if (app == null || app.labels == null || app.labels.DCOS_PACKAGE_VERSION == null) {
	        return null;
	      }
	
	      return app.labels.DCOS_PACKAGE_VERSION;
	    }
	  }, {
	    key: "getServiceFromName",
	    value: function getServiceFromName(name) {
	      return this.get("apps")[name];
	    }
	  }, {
	    key: "processMarathonInfoRequest",
	    value: function processMarathonInfoRequest(info) {
	      this.set({ info: info });
	      this.emit(_EventTypes.MARATHON_INSTANCE_INFO_SUCCESS);
	    }
	  }, {
	    key: "processMarathonGroups",
	    value: function processMarathonGroups(data) {
	      var groups = new _ServiceTree2.default(data);
	
	      var apps = groups.reduceItems(function (map, item) {
	        if (item instanceof _Framework2.default) {
	          map[item.getFrameworkName().toLowerCase()] = {
	            health: item.getHealth(),
	            images: item.getImages(),
	            snapshot: item.get()
	          };
	        }
	
	        return map;
	      }, {});
	
	      var numberOfApps = (0, _keys2.default)(apps).length;
	      // Specific health check for Marathon
	      // We are setting the 'marathon' key here, since we can safely assume,
	      // it to be 'marathon' (we control it).
	      // This means that no other framework should be named 'marathon'.
	      apps.marathon = {
	        health: this.getFrameworkHealth({
	          // Make sure health check has a result
	          healthChecks: [{}],
	          // Marathon is healthy if this request returned apps
	          tasksHealthy: numberOfApps,
	          tasksRunning: numberOfApps
	        }),
	        images: _ServiceImages2.default.MARATHON_IMAGES
	      };
	
	      this.set({ apps: apps });
	      this.set({ groups: groups });
	
	      _CompositeState2.default.addMarathonApps(apps);
	
	      this.emit(_EventTypes.MARATHON_APPS_CHANGE, apps);
	      this.emit(_EventTypes.MARATHON_GROUPS_CHANGE, groups);
	    }
	  }, {
	    key: "processMarathonGroupsError",
	    value: function processMarathonGroupsError() {
	      this.emit(_EventTypes.MARATHON_APPS_ERROR);
	      this.emit(_EventTypes.MARATHON_GROUPS_ERROR);
	    }
	  }, {
	    key: "processMarathonDeployments",
	    value: function processMarathonDeployments(data) {
	      var deployments = new _DeploymentsList2.default({ items: data });
	      this.set({ deployments: deployments });
	      this.emit(_EventTypes.MARATHON_DEPLOYMENTS_CHANGE, deployments);
	    }
	  }, {
	    key: "processMarathonDeploymentsError",
	    value: function processMarathonDeploymentsError() {
	      this.emit(_EventTypes.MARATHON_DEPLOYMENTS_ERROR);
	    }
	  }, {
	    key: "processMarathonDeploymentRollback",
	    value: function processMarathonDeploymentRollback(data) {
	      var id = data.originalDeploymentID;
	      if (id != null) {
	        var deployments = this.get("deployments").filterItems(function (deployment) {
	          return deployment.getId() !== id;
	        });
	        this.set({ deployments: deployments });
	        this.emit(_EventTypes.MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS, data);
	        this.emit(_EventTypes.MARATHON_DEPLOYMENTS_CHANGE);
	      }
	    }
	  }, {
	    key: "processMarathonDeploymentRollbackError",
	    value: function processMarathonDeploymentRollbackError(data) {
	      this.emit(_EventTypes.MARATHON_DEPLOYMENT_ROLLBACK_ERROR, data);
	    }
	  }, {
	    key: "processMarathonQueue",
	    value: function processMarathonQueue(data) {
	      if (data.queue != null) {
	        this.emit(_EventTypes.MARATHON_QUEUE_CHANGE, data.queue);
	      }
	    }
	  }, {
	    key: "processMarathonQueueError",
	    value: function processMarathonQueueError() {
	      this.emit(_EventTypes.MARATHON_QUEUE_ERROR);
	    }
	  }, {
	    key: "processOngoingRequest",
	    value: function processOngoingRequest() {
	      // Handle ongoing request here.
	    }
	  }, {
	    key: "processMarathonServiceVersions",
	    value: function processMarathonServiceVersions(service) {
	      var serviceID = service.serviceID,
	          versions = service.versions;
	
	      versions = versions.reduce(function (map, version) {
	        return map.set(version);
	      }, new _map2.default());
	
	      this.emit(_EventTypes.MARATHON_SERVICE_VERSIONS_CHANGE, { serviceID: serviceID, versions: versions });
	    }
	  }, {
	    key: "processMarathonServiceVersionsError",
	    value: function processMarathonServiceVersionsError() {
	      this.emit(_EventTypes.MARATHON_SERVICE_VERSIONS_ERROR);
	    }
	  }, {
	    key: "processMarathonServiceVersion",
	    value: function processMarathonServiceVersion(service) {
	      var serviceID = service.serviceID,
	          version = service.version,
	          versionID = service.versionID;
	      // TODO (orlandohohmeier): Convert version into typed version struct
	
	      this.emit(_EventTypes.MARATHON_SERVICE_VERSION_CHANGE, {
	        serviceID: serviceID,
	        versionID: versionID,
	        version: version
	      });
	    }
	  }, {
	    key: "processMarathonServiceVersionError",
	    value: function processMarathonServiceVersionError() {
	      this.emit(_EventTypes.MARATHON_SERVICE_VERSION_ERROR);
	    }
	  }, {
	    key: "setShouldEmbedLastUnusedOffers",
	    value: function setShouldEmbedLastUnusedOffers(value) {
	      shouldEmbedLastUnusedOffers = value;
	
	      // Restart polling to immediately use the updated embed params.
	      stopPolling();
	      startPolling();
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "marathon";
	    }
	  }]);
	  return MarathonStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new MarathonStore();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _EventTypes = __webpack_require__(933);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Use visibility API to check if current tab is active or not
	var Visibility = function () {
	  var stateKey = void 0;
	  var keys = {
	    hidden: "visibilitychange",
	    webkitHidden: "webkitvisibilitychange",
	    mozHidden: "mozvisibilitychange",
	    msHidden: "msvisibilitychange"
	  };
	
	  // Find first key available on document
	  (0, _keys2.default)(keys).some(function (key) {
	    if (key in global.document) {
	      stateKey = key;
	
	      return true;
	    }
	
	    return false;
	  });
	
	  return {
	    addChangeListener: function addChangeListener(callback) {
	      global.document.addEventListener(keys[stateKey], callback);
	    },
	    getVisibility: function getVisibility() {
	      return !global.document[stateKey];
	    }
	  };
	}();
	
	var VisibilityStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(VisibilityStore, _GetSetBaseStore);
	
	  function VisibilityStore() {
	    (0, _classCallCheck3.default)(this, VisibilityStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VisibilityStore.__proto__ || (0, _getPrototypeOf2.default)(VisibilityStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      isTabVisible: true,
	      isInactive: false
	    };
	
	    _this.timeOut = null;
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        change: _EventTypes.VISIBILITY_CHANGE
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    // Listen for visibility change events
	    Visibility.addChangeListener(function () {
	      // We need setTimeout because browser hasn't yet given us the execution
	      // context.
	      setTimeout(_this.onVisibilityChange.bind(_this), 0);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VisibilityStore, [{
	    key: "isTabVisible",
	    value: function isTabVisible() {
	      return this.get("isTabVisible");
	    }
	  }, {
	    key: "isInactive",
	    value: function isInactive() {
	      return this.get("isInactive");
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      var _this2 = this;
	
	      var isTabVisible = Visibility.getVisibility();
	
	      this.set({ isTabVisible: isTabVisible });
	      this.emit(_EventTypes.VISIBILITY_CHANGE);
	
	      if (!this.get("isInactive") && !this.timeOut && !this.get("isTabVisible")) {
	        this.timeOut = setTimeout(function () {
	          _this2.set({ isInactive: true });
	          _this2.emit(_EventTypes.VISIBILITY_CHANGE);
	        }, _Config2.default.setInactiveAfter || 0);
	      }
	
	      if (isTabVisible) {
	        if (this.timeOut) {
	          clearTimeout(this.timeOut);
	          this.timeOut = null;
	        }
	
	        if (this.get("isInactive")) {
	          this.set({ isInactive: false });
	          this.emit(_EventTypes.VISIBILITY_CHANGE);
	        }
	      }
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "visibility";
	    }
	  }]);
	  return VisibilityStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new VisibilityStore();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1223 */
/***/ function(module, exports) {

	"use strict";
	
	var ActionTypes = {};
	["REQUEST_MESOS_LOG_ERROR", "REQUEST_MESOS_LOG_OFFSET_ERROR", "REQUEST_MESOS_LOG_OFFSET_SUCCESS", "REQUEST_MESOS_LOG_SUCCESS", "REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_ERROR", "REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS", "REQUEST_MARATHON_DEPLOYMENTS", "REQUEST_MARATHON_DEPLOYMENTS_ERROR", "REQUEST_MARATHON_DEPLOYMENTS_ONGOING", "REQUEST_MARATHON_DEPLOYMENTS_SUCCESS", "REQUEST_MARATHON_GROUP_CREATE_ERROR", "REQUEST_MARATHON_GROUP_CREATE_SUCCESS", "REQUEST_MARATHON_GROUP_DELETE_ERROR", "REQUEST_MARATHON_GROUP_DELETE_SUCCESS", "REQUEST_MARATHON_GROUP_EDIT_ERROR", "REQUEST_MARATHON_GROUP_EDIT_SUCCESS", "REQUEST_MARATHON_GROUPS", "REQUEST_MARATHON_GROUPS_ERROR", "REQUEST_MARATHON_GROUPS_ONGOING", "REQUEST_MARATHON_GROUPS_SUCCESS", "REQUEST_MARATHON_INSTANCE_INFO_ERROR", "REQUEST_MARATHON_INSTANCE_INFO_SUCCESS", "REQUEST_MARATHON_POD_INSTANCE_KILL_ERROR", "REQUEST_MARATHON_POD_INSTANCE_KILL_SUCCESS", "REQUEST_MARATHON_QUEUE_ERROR", "REQUEST_MARATHON_QUEUE_ONGOING", "REQUEST_MARATHON_QUEUE_SUCCESS", "REQUEST_MARATHON_SERVICE_CREATE_ERROR", "REQUEST_MARATHON_SERVICE_CREATE_SUCCESS", "REQUEST_MARATHON_SERVICE_DELETE_ERROR", "REQUEST_MARATHON_SERVICE_DELETE_SUCCESS", "REQUEST_MARATHON_SERVICE_EDIT_ERROR", "REQUEST_MARATHON_SERVICE_EDIT_SUCCESS", "REQUEST_MARATHON_SERVICE_RESTART_ERROR", "REQUEST_MARATHON_SERVICE_RESTART_SUCCESS", "REQUEST_MARATHON_SERVICE_VERSION_ERROR", "REQUEST_MARATHON_SERVICE_VERSION_SUCCESS", "REQUEST_MARATHON_SERVICE_VERSIONS_ERROR", "REQUEST_MARATHON_SERVICE_VERSIONS_SUCCESS", "REQUEST_MARATHON_TASK_KILL_ERROR", "REQUEST_MARATHON_TASK_KILL_SUCCESS", "REQUEST_NODE_STATE_ERROR", "REQUEST_NODE_STATE_SUCCESS", "REQUEST_PREVIOUS_MESOS_LOG_ERROR", "REQUEST_PREVIOUS_MESOS_LOG_SUCCESS", "REQUEST_TASK_DIRECTORY_ERROR", "REQUEST_TASK_DIRECTORY_SUCCESS"].forEach(function (actionType) {
	  ActionTypes[actionType] = actionType;
	});
	
	module.exports = ActionTypes;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _ActionTypes = __webpack_require__(1223);
	
	var _MarathonUtil = __webpack_require__(1225);
	
	var _MarathonUtil2 = _interopRequireDefault(_MarathonUtil);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function buildURI(path) {
	  return "" + _Config2.default.rootUrl + _Config2.default.marathonAPIPrefix + path;
	}
	
	var MarathonActions = {
	  createGroup: function createGroup(data) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/groups"),
	      method: "POST",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_CREATE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_CREATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  deleteGroup: function deleteGroup(groupId, force) {
	    groupId = encodeURIComponent(groupId);
	    var url = buildURI("/groups/" + groupId);
	
	    if (force === true) {
	      url += "?force=true";
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "DELETE",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_DELETE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_DELETE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  editGroup: function editGroup(data, force) {
	    var groupId = encodeURIComponent(data.id);
	    var url = buildURI("/groups/" + groupId);
	    data = _Util2.default.omit(data, ["id"]);
	
	    if (force === true) {
	      url += "?force=true";
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "PUT",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_EDIT_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_GROUP_EDIT_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  /**
	   * Create a service (app, framework, or pod)
	   *
	   * @param {ServiceSpec} spec
	   */
	  createService: function createService(spec) {
	    // TODO (DCOS-9621): Validate input and only accept instances of ServiceSpec
	
	    // Always default to the `/apps` endpoint to create services
	    var url = buildURI("/apps");
	
	    if (spec instanceof _PodSpec2.default) {
	      url = buildURI("/pods");
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "POST",
	      data: spec,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_CREATE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_CREATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  /**
	   * Delete a service (app, framework, or pod)
	   *
	   * @param {Service} service - the service you want to delete
	   * @param {Boolean} force - force delete even if deploying
	   */
	  deleteService: function deleteService(service, force) {
	    var url = buildURI("/apps/" + service.getId());
	
	    if (service instanceof _Pod2.default) {
	      url = buildURI("/pods/" + service.getId());
	    }
	
	    if (force === true) {
	      url += "?force=true";
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "DELETE",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_DELETE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_DELETE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  /**
	   * Edit service (app, framework, or pod)
	   *
	   * @param {Service} service - the service you wish to edit
	   * @param {ServiceSpec} spec - the new service spec
	   * @param {Boolean} force - force deploy change
	   */
	  editService: function editService(service, spec, force) {
	    // TODO (DCOS-9621): Only accept instances of ServiceSpec for spec
	    if (!(service instanceof _Service2.default)) {
	      if (false) {
	        throw new TypeError("service is not an instance of Service");
	      }
	
	      return;
	    }
	
	    var url = buildURI("/apps/" + service.getId());
	    var params = {
	      force: force,
	      partialUpdate: false // Switching Marathon edit endpoint into proper PUT
	    };
	
	    if (service instanceof _Pod2.default) {
	      url = buildURI("/pods/" + service.getId());
	    }
	
	    url = url + _Util2.default.objectToGetParams(params);
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "PUT",
	      data: spec,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_EDIT_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_EDIT_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  restartService: function restartService(service) {
	    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!(service instanceof _Service2.default)) {
	      if (false) {
	        throw new TypeError("service is not an instance of Service");
	      }
	
	      return;
	    }
	
	    var url = buildURI("/apps/" + service.getId() + "/restart");
	
	    if (service instanceof _Pod2.default) {
	      url = buildURI("/pods/" + service.getId() + "/restart");
	    }
	
	    if (force === true) {
	      url += "?force=true";
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "POST",
	      data: force,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_RESTART_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_RESTART_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  fetchGroups: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function () {
	      var url = buildURI("/groups");
	      var embed = [{ name: "embed", value: "group.groups" }, { name: "embed", value: "group.apps" }, { name: "embed", value: "group.pods" }, { name: "embed", value: "group.apps.deployments" }, { name: "embed", value: "group.apps.counts" }, { name: "embed", value: "group.apps.tasks" }, { name: "embed", value: "group.apps.taskStats" }, { name: "embed", value: "group.apps.lastTaskFailure" }];
	
	      _mesosphereSharedReactjs.RequestUtil.json({
	        url: url,
	        data: embed,
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_GROUPS_SUCCESS,
	            data: _MarathonUtil2.default.parseGroups(response)
	          });
	          resolve();
	        },
	        error: function error(xhr) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_GROUPS_ERROR,
	            data: xhr.message,
	            xhr: xhr
	          });
	          reject();
	        },
	        hangingRequestCallback: function hangingRequestCallback() {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_GROUPS_ONGOING
	          });
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount }),
	
	  fetchDeployments: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function () {
	      _mesosphereSharedReactjs.RequestUtil.json({
	        url: buildURI("/deployments"),
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_DEPLOYMENTS_SUCCESS,
	            data: response
	          });
	          resolve();
	        },
	        error: function error(xhr) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_DEPLOYMENTS_ERROR,
	            data: xhr.message,
	            xhr: xhr
	          });
	          reject();
	        },
	        hangingRequestCallback: function hangingRequestCallback() {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_DEPLOYMENTS_ONGOING
	          });
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount }),
	
	  fetchServiceVersion: function fetchServiceVersion(serviceID, versionID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/apps/" + serviceID + "/versions/" + versionID),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_VERSION_SUCCESS,
	          data: { serviceID: serviceID, versionID: versionID, version: response }
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_VERSION_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchServiceVersions: function fetchServiceVersions(serviceID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/apps/" + serviceID + "/versions"),
	      success: function success(response) {
	        var versions = response.versions;
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_VERSIONS_SUCCESS,
	          data: { serviceID: serviceID, versions: versions }
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_SERVICE_VERSIONS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchMarathonInstanceInfo: function fetchMarathonInstanceInfo() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/info"),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_INSTANCE_INFO_SUCCESS,
	          data: response
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_INSTANCE_INFO_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  fetchQueue: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function () {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var queryParams = options.params || "";
	
	      _mesosphereSharedReactjs.RequestUtil.json({
	        url: buildURI("/queue" + queryParams),
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_QUEUE_SUCCESS,
	            data: response
	          });
	          resolve();
	        },
	        error: function error(xhr) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_QUEUE_ERROR,
	            data: xhr.message,
	            xhr: xhr
	          });
	          reject();
	        },
	        hangingRequestCallback: function hangingRequestCallback() {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_MARATHON_QUEUE_ONGOING
	          });
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount }),
	
	  revertDeployment: function revertDeployment(deploymentID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/deployments/" + deploymentID),
	      method: "DELETE",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS,
	          data: (0, _assign2.default)({ originalDeploymentID: deploymentID }, response)
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_ERROR,
	          data: {
	            originalDeploymentID: deploymentID,
	            error: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr)
	          },
	          xhr: xhr
	        });
	      }
	    });
	  },
	  killTasks: function killTasks(taskIDs, scaleTask, force) {
	    var params = [];
	    if (scaleTask) {
	      params.push("scale=true");
	    }
	    if (force) {
	      params.push("force=true");
	    }
	
	    if (params.length > 0) {
	      params = "?" + params.join("&");
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/tasks/delete" + params),
	      data: { ids: taskIDs },
	      method: "POST",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_TASK_KILL_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_TASK_KILL_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  killPodInstances: function killPodInstances(pod, instanceIDs, force) {
	    var podID = pod.getId().replace(/^\//, "");
	    var params = "";
	
	    if (force) {
	      params = "?force=true";
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: buildURI("/pods/" + podID + "::instances" + params),
	      data: instanceIDs,
	      method: "DELETE",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_POD_INSTANCE_KILL_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_MARATHON_POD_INSTANCE_KILL_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var groupsFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../../../tests/_fixtures/marathon-pods/groups.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.MarathonActions = {
	    createService: {
	      event: "success",
	      success: { response: {} }
	    },
	    deleteService: {
	      event: "success",
	      success: { response: {} }
	    },
	    editService: {
	      event: "success",
	      success: { response: {} }
	    },
	    restartService: {
	      event: "success",
	      success: { response: {} }
	    },
	    fetchGroups: {
	      event: "success",
	      success: { response: groupsFixture }
	    }
	  };
	
	  (0, _keys2.default)(global.actionTypes.MarathonActions).forEach(function (method) {
	    MarathonActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(MarathonActions, "MarathonActions", method);
	  });
	}
	
	module.exports = MarathonActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _VolumeTypes = __webpack_require__(1226);
	
	var _VolumeTypes2 = _interopRequireDefault(_VolumeTypes);
	
	var _VolumeStatus = __webpack_require__(1096);
	
	var _VolumeStatus2 = _interopRequireDefault(_VolumeStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseApp(app) {
	  var id = app.id,
	      _app$tasks = app.tasks,
	      tasks = _app$tasks === undefined ? [] : _app$tasks,
	      _app$container = app.container,
	      container = _app$container === undefined ? {} : _app$container;
	
	
	  if (id == null || !id.startsWith("/") || id.endsWith("/")) {
	    throw new Error("Id (" + id + ") must start with a leading slash (\"/\") " + "and should not end with a slash.");
	  }
	
	  if (container == null || !Array.isArray(container.volumes)) {
	    return app;
	  }
	
	  var volumeDefinitionMap = new _map2.default();
	  var volumes = [];
	
	  // Parse container volumes to extract external volumes
	  // and persistent volume definitions
	  container.volumes.forEach(function (_ref) {
	    var containerPath = _ref.containerPath,
	        external = _ref.external,
	        mode = _ref.mode,
	        persistent = _ref.persistent;
	
	    if (external != null) {
	      volumes.push((0, _assign2.default)({
	        containerPath: containerPath,
	        id: external.name,
	        mode: mode,
	        status: _VolumeStatus2.default.UNAVAILABLE,
	        type: _VolumeTypes2.default.EXTERNAL
	      }, external));
	    }
	
	    if (persistent != null) {
	      var size = persistent.size;
	
	
	      volumeDefinitionMap.set(containerPath, {
	        type: _VolumeTypes2.default.PERSISTENT,
	        mode: mode,
	        size: size
	      });
	    }
	  });
	
	  if (tasks == null || !Array.isArray(tasks)) {
	    return (0, _assign2.default)({ volumes: volumes }, app);
	  }
	
	  tasks.forEach(function (_ref2) {
	    var host = _ref2.host,
	        taskID = _ref2.id,
	        localVolumes = _ref2.localVolumes,
	        startedAt = _ref2.startedAt;
	
	    var status = _VolumeStatus2.default.DETACHED;
	    if (startedAt != null) {
	      status = _VolumeStatus2.default.ATTACHED;
	    }
	
	    if (!Array.isArray(localVolumes)) {
	      return;
	    }
	
	    localVolumes.forEach(function (_ref3) {
	      var containerPath = _ref3.containerPath,
	          id = _ref3.persistenceId;
	
	      var volumeDefinition = volumeDefinitionMap.get(containerPath);
	      var volume = (0, _assign2.default)({}, volumeDefinition, {
	        status: status,
	        host: host,
	        containerPath: containerPath,
	        id: id,
	        taskID: taskID
	      });
	
	      volumes.push(volume);
	    });
	  });
	
	  return (0, _assign2.default)({ volumes: volumes }, app);
	}
	
	function parsePod(pod) {
	  var id = pod.id;
	
	
	  if (id == null || !id.startsWith("/") || id.endsWith("/")) {
	    throw new Error("Id (" + id + ") must start with a leading slash (\"/\") " + "and should not end with a slash.");
	  }
	
	  return pod;
	}
	
	var MarathonUtil = {
	  parseGroups: function parseGroups(_ref4) {
	    var _ref4$id = _ref4.id,
	        id = _ref4$id === undefined ? "/" : _ref4$id,
	        _ref4$groups = _ref4.groups,
	        groups = _ref4$groups === undefined ? [] : _ref4$groups,
	        _ref4$apps = _ref4.apps,
	        apps = _ref4$apps === undefined ? [] : _ref4$apps,
	        _ref4$pods = _ref4.pods,
	        pods = _ref4$pods === undefined ? [] : _ref4$pods;
	
	    if (id !== "/" && (!id.startsWith("/") || id.endsWith("/"))) {
	      throw new Error("Id (" + id + ") must start with a leading slash (\"/\") " + "and should not end with a slash, except for root id which is only " + "a slash.");
	    }
	
	    // Parse items
	    var items = [].concat(groups.map(this.parseGroups.bind(this)), apps.map(parseApp), pods.map(parsePod));
	
	    return { id: id, items: items };
	  }
	};
	
	module.exports = MarathonUtil;

/***/ },
/* 1226 */
/***/ function(module, exports) {

	"use strict";
	
	var VolumeTypes = {
	  PERSISTENT: "Persistent",
	  EXTERNAL: "External"
	};
	
	module.exports = VolumeTypes;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _PodInstanceList = __webpack_require__(1228);
	
	var _PodInstanceList2 = _interopRequireDefault(_PodInstanceList);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _PodState = __webpack_require__(1236);
	
	var _PodState2 = _interopRequireDefault(_PodState);
	
	var _PodTerminationHistoryList = __webpack_require__(1237);
	
	var _PodTerminationHistoryList2 = _interopRequireDefault(_PodTerminationHistoryList);
	
	var _Service2 = __webpack_require__(1090);
	
	var _Service3 = _interopRequireDefault(_Service2);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	var _ServiceImages = __webpack_require__(1081);
	
	var _ServiceImages2 = _interopRequireDefault(_ServiceImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Service) {
	  (0, _inherits3.default)(Pod, _Service);
	
	  function Pod() {
	    (0, _classCallCheck3.default)(this, Pod);
	
	    // The variable is prefixed because `Item` will expose
	    // all the properties it gets as a properties of this object
	    // and we want to avoid any naming collisions.
	    //
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Pod.__proto__ || (0, _getPrototypeOf2.default)(Pod)).apply(this, arguments));
	
	    _this._spec = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Pod, [{
	    key: "getRunningInstancesCount",
	    value: function getRunningInstancesCount() {
	      return this.getInstanceList().reduceItems(function (counter, instance) {
	        if (instance.isRunning()) {
	          return counter + 1;
	        }
	
	        return counter;
	      }, 0);
	    }
	  }, {
	    key: "countNonTerminalInstances",
	    value: function countNonTerminalInstances() {
	      return this.getInstanceList().reduceItems(function (counter, instance) {
	        if (!instance.isTerminating()) {
	          return counter + 1;
	        }
	
	        return counter;
	      }, 0);
	    }
	  }, {
	    key: "countTotalInstances",
	    value: function countTotalInstances() {
	      return (this.get("instances") || []).length;
	    }
	
	    /**
	     * Return the normalized pod ID, used as a prefix in the marathon framework
	     * state, as fetched from Mesos state.
	     *
	     * @override
	     * @returns {String} The normalized mesos ID
	     */
	
	  }, {
	    key: "getMesosId",
	    value: function getMesosId() {
	      var id = this.getId().substr(1);
	
	      return id.replace(/\//g, "_");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getHealth",
	    value: function getHealth() {
	      switch (this.get("status")) {
	        // DEGRADED - The number of STABLE pod instances is less than the number
	        // of desired instances.
	        case _PodState2.default.DEGRADED:
	          return _HealthStatus2.default.UNHEALTHY;
	        // STABLE   - All launched pod instances have started and, if health
	        // checks were specified, are all healthy.
	        case _PodState2.default.STABLE:
	          return _HealthStatus2.default.HEALTHY;
	        // TERMINAL - Marathon is tearing down all of the instances for this pod.
	        case _PodState2.default.TERMINAL:
	          return _HealthStatus2.default.NA;
	
	        default:
	          return _HealthStatus2.default.NA;
	      }
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getImages",
	    value: function getImages() {
	      return _ServiceImages2.default.NA_IMAGES;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getInstancesCount",
	    value: function getInstancesCount() {
	      // Apparently this means 'get total number of scheduled instances'
	      return this.getSpec().getScalingInstances();
	    }
	  }, {
	    key: "getInstanceList",
	    value: function getInstanceList() {
	      return new _PodInstanceList2.default({ items: this.get("instances") || [] });
	    }
	  }, {
	    key: "getQueue",
	    value: function getQueue() {
	      return this.get("queue");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.getSpec().getLabels();
	    }
	  }, {
	    key: "getLastChanged",
	    value: function getLastChanged() {
	      return new Date(this.get("lastChanged"));
	    }
	  }, {
	    key: "getLastUpdated",
	    value: function getLastUpdated() {
	      return new Date(this.get("lastUpdated"));
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getServiceStatus",
	    value: function getServiceStatus() {
	      var scalingInstances = this.getSpec().getScalingInstances();
	      var runningInstances = this.getRunningInstancesCount();
	      var nonterminalInstances = this.countNonTerminalInstances();
	
	      if (nonterminalInstances === 0 && scalingInstances === 0) {
	        return _ServiceStatus2.default.SUSPENDED;
	      }
	
	      if (scalingInstances !== nonterminalInstances) {
	        return _ServiceStatus2.default.DEPLOYING;
	      }
	
	      if (runningInstances > 0) {
	        return _ServiceStatus2.default.RUNNING;
	      }
	
	      return _ServiceStatus2.default.NA;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getSpec",
	    value: function getSpec() {
	      if (this._spec == null) {
	        this._spec = new _PodSpec2.default(this.get("spec"));
	      }
	
	      return this._spec;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getTasksSummary",
	    value: function getTasksSummary() {
	      var taskSummary = {
	        tasksHealthy: 0,
	        tasksUnhealthy: 0,
	        tasksStaged: 0,
	        tasksRunning: 0,
	        tasksUnknown: 0,
	        tasksOverCapacity: 0
	      };
	
	      this.getInstanceList().mapItems(function (instance) {
	        if (instance.isRunning()) {
	          taskSummary.tasksRunning++;
	          if (instance.hasHealthChecks()) {
	            if (instance.isHealthy()) {
	              taskSummary.tasksHealthy++;
	            } else {
	              taskSummary.tasksUnhealthy++;
	            }
	          } else {
	            taskSummary.tasksUnknown++;
	          }
	        } else if (instance.isStaging()) {
	          taskSummary.tasksStaged++;
	        }
	      });
	
	      var totalInstances = taskSummary.tasksStaged + taskSummary.tasksRunning;
	      var definedInstances = this.getSpec().getScalingInstances();
	
	      if (totalInstances > definedInstances) {
	        taskSummary.tasksOverCapacity = totalInstances - definedInstances;
	      }
	
	      return taskSummary;
	    }
	  }, {
	    key: "getTerminationHistoryList",
	    value: function getTerminationHistoryList() {
	      return new _PodTerminationHistoryList2.default({
	        items: this.get("terminationHistory") || []
	      });
	    }
	  }]);
	  return Pod;
	}(_Service3.default);

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _PodInstance = __webpack_require__(1229);
	
	var _PodInstance2 = _interopRequireDefault(_PodInstance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodInstanceList = function (_List) {
	  (0, _inherits3.default)(PodInstanceList, _List);
	
	  function PodInstanceList() {
	    (0, _classCallCheck3.default)(this, PodInstanceList);
	    return (0, _possibleConstructorReturn3.default)(this, (PodInstanceList.__proto__ || (0, _getPrototypeOf2.default)(PodInstanceList)).apply(this, arguments));
	  }
	
	  return PodInstanceList;
	}(_List3.default);
	
	PodInstanceList.type = _PodInstance2.default;
	
	module.exports = PodInstanceList;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _create = __webpack_require__(979);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _PodContainer = __webpack_require__(1230);
	
	var _PodContainer2 = _interopRequireDefault(_PodContainer);
	
	var _PodContainerStatus = __webpack_require__(1231);
	
	var _PodContainerStatus2 = _interopRequireDefault(_PodContainerStatus);
	
	var _PodInstanceStatus = __webpack_require__(1233);
	
	var _PodInstanceStatus2 = _interopRequireDefault(_PodInstanceStatus);
	
	var _PodInstanceState = __webpack_require__(1234);
	
	var _PodInstanceState2 = _interopRequireDefault(_PodInstanceState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(PodInstance, _Item);
	
	  function PodInstance() {
	    (0, _classCallCheck3.default)(this, PodInstance);
	    return (0, _possibleConstructorReturn3.default)(this, (PodInstance.__proto__ || (0, _getPrototypeOf2.default)(PodInstance)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodInstance, [{
	    key: "getAgentAddress",
	    value: function getAgentAddress() {
	      return this.get("agentHostname") || "";
	    }
	  }, {
	    key: "getContainers",
	    value: function getContainers() {
	      var containers = this.get("containers") || [];
	
	      return containers.map(function (container) {
	        return new _PodContainer2.default(container);
	      });
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.get("id") || "";
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId();
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      // API returns mix of uppercase and lowercase depending on status :(
	      return this.get("status").toLowerCase();
	    }
	  }, {
	    key: "getInstanceStatus",
	    value: function getInstanceStatus() {
	      switch (this.getStatus()) {
	        case _PodInstanceState2.default.PENDING:
	          return _PodInstanceStatus2.default.STAGED;
	
	        case _PodInstanceState2.default.STAGING:
	          return _PodInstanceStatus2.default.STAGED;
	
	        case _PodInstanceState2.default.STABLE:
	          if (this.hasHealthChecks()) {
	            if (this.isHealthy()) {
	              return _PodInstanceStatus2.default.HEALTHY;
	            } else {
	              return _PodInstanceStatus2.default.UNHEALTHY;
	            }
	          } else {
	            return _PodInstanceStatus2.default.RUNNING;
	          }
	
	        case _PodInstanceState2.default.DEGRADED:
	          return _PodInstanceStatus2.default.UNHEALTHY;
	
	        case _PodInstanceState2.default.TERMINAL:
	          // If all containers are in completed state, mark us as completed
	          var containers = this.getContainers();
	          var isFinished = containers.length > 0 && containers.every(function (container) {
	            return container.getContainerStatus() === _PodContainerStatus2.default.FINISHED;
	          });
	
	          if (isFinished) {
	            return _PodInstanceStatus2.default.FINISHED;
	          }
	
	          return _PodInstanceStatus2.default.KILLED;
	
	        default:
	          return (0, _assign2.default)((0, _create2.default)(_PodInstanceStatus2.default.NA), {
	            displayName: _StringUtil2.default.capitalize(this.getStatus())
	          });
	      }
	    }
	  }, {
	    key: "getLastChanged",
	    value: function getLastChanged() {
	      return new Date(this.get("lastChanged"));
	    }
	  }, {
	    key: "getLastUpdated",
	    value: function getLastUpdated() {
	      return new Date(this.get("lastUpdated"));
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      var resources = this.get("resources") || {};
	
	      return (0, _assign2.default)({
	        cpus: 0,
	        mem: 0,
	        gpus: 0,
	        disk: 0
	      }, resources);
	    }
	  }, {
	    key: "hasHealthChecks",
	    value: function hasHealthChecks() {
	      // If for any reason any of the containers has at least 1 health
	      // check that is failing, assume that we have health checks
	      if (!this.isHealthy()) {
	        return true;
	      }
	
	      // If we have no containers, return false
	      var containers = this.getContainers();
	      if (!containers.length) {
	        return false;
	      }
	
	      // Otherwise ALL container must have health checks in order to be
	      // considered healthy.
	      return containers.every(function (container) {
	        return container.hasHealthChecks();
	      });
	    }
	  }, {
	    key: "isHealthy",
	    value: function isHealthy() {
	      if (this.getStatus() !== _PodInstanceState2.default.STABLE) {
	        return false;
	      }
	
	      return this.getContainers().every(function (container) {
	        return container.isHealthy();
	      });
	    }
	  }, {
	    key: "isRunning",
	    value: function isRunning() {
	      var status = this.getStatus();
	
	      return status === _PodInstanceState2.default.STABLE || status === _PodInstanceState2.default.DEGRADED;
	    }
	  }, {
	    key: "isStaging",
	    value: function isStaging() {
	      var status = this.getStatus();
	
	      return status === _PodInstanceState2.default.PENDING || status === _PodInstanceState2.default.STAGING;
	    }
	  }, {
	    key: "isTerminating",
	    value: function isTerminating() {
	      return this.getStatus() === _PodInstanceState2.default.TERMINAL;
	    }
	  }]);
	  return PodInstance;
	}(_Item3.default);

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _PodContainerStatus = __webpack_require__(1231);
	
	var _PodContainerStatus2 = _interopRequireDefault(_PodContainerStatus);
	
	var _PodContainerState = __webpack_require__(1232);
	
	var _PodContainerState2 = _interopRequireDefault(_PodContainerState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(PodContainer, _Item);
	
	  function PodContainer() {
	    (0, _classCallCheck3.default)(this, PodContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (PodContainer.__proto__ || (0, _getPrototypeOf2.default)(PodContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodContainer, [{
	    key: "getContainerStatus",
	    value: function getContainerStatus() {
	      switch (this.get("status")) {
	        case _PodContainerState2.default.RUNNING:
	          if (this.hasHealthChecks()) {
	            if (this.isHealthy()) {
	              return _PodContainerStatus2.default.HEALTHY;
	            } else {
	              return _PodContainerStatus2.default.UNHEALTHY;
	            }
	          } else {
	            return _PodContainerStatus2.default.RUNNING;
	          }
	        case _PodContainerState2.default.STAGING:
	          return _PodContainerStatus2.default.STAGING;
	        case _PodContainerState2.default.STARTING:
	          return _PodContainerStatus2.default.STARTING;
	        case _PodContainerState2.default.STARTED:
	          return _PodContainerStatus2.default.STARTED;
	        case _PodContainerState2.default.KILLING:
	          return _PodContainerStatus2.default.KILLING;
	        case _PodContainerState2.default.FINISHED:
	          return _PodContainerStatus2.default.FINISHED;
	        case _PodContainerState2.default.KILLED:
	          return _PodContainerStatus2.default.KILLED;
	        case _PodContainerState2.default.FAILED:
	          return _PodContainerStatus2.default.FAILED;
	        case _PodContainerState2.default.LOST:
	          return _PodContainerStatus2.default.LOST;
	        case _PodContainerState2.default.ERROR:
	          return _PodContainerStatus2.default.ERROR;
	        default:
	          return _PodContainerStatus2.default.NA;
	      }
	    }
	  }, {
	    key: "getEndpoints",
	    value: function getEndpoints() {
	      return this.get("endpoints") || [];
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.get("containerId") || "";
	    }
	  }, {
	    key: "getLastChanged",
	    value: function getLastChanged() {
	      return new Date(this.get("lastChanged") || "");
	    }
	  }, {
	    key: "getLastUpdated",
	    value: function getLastUpdated() {
	      return new Date(this.get("lastUpdated") || "");
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.get("name") || "";
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      return (0, _assign2.default)({
	        cpus: 0,
	        mem: 0,
	        gpus: 0,
	        disk: 0
	      }, this.get("resources"));
	    }
	  }, {
	    key: "hasHealthChecks",
	    value: function hasHealthChecks() {
	      // According to RAML specs:
	      //
	      // https://github.com/mesosphere/marathon/blob/feature/pods/docs/docs/rest-api/public/api/v2/types/container-status.raml#L49
	      // 'healthy: should only be present if a health check is defined for this endpoint'
	      //
	      var endpoints = this.getEndpoints();
	      var allHaveChecks = endpoints.length > 0;
	      var hasFailure = false;
	
	      this.getEndpoints().forEach(function (ep) {
	        if (ep.healthy === undefined) {
	          allHaveChecks = false;
	        }
	        if (ep.healthy === false) {
	          hasFailure = true;
	        }
	      });
	
	      return allHaveChecks || hasFailure;
	    }
	  }, {
	    key: "isHealthy",
	    value: function isHealthy() {
	      // If we have at least 1 health check and it has failed, we are assumed to
	      // be unhealthy.
	      return !this.getEndpoints().some(function (ep) {
	        return ep.healthy !== undefined && !ep.healthy;
	      });
	    }
	  }]);
	  return PodContainer;
	}(_Item3.default);

/***/ },
/* 1231 */
/***/ function(module, exports) {

	"use strict";
	
	var POD_CONTAINER_STATUS = {
	  CREATED: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "Created",
	    healthStatus: "NA"
	  },
	  STAGING: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "Staging",
	    healthStatus: "NA"
	  },
	  STARTING: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "Starting",
	    healthStatus: "NA"
	  },
	  STARTED: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "Started",
	    healthStatus: "NA"
	  },
	  HEALTHY: {
	    dotClassName: "dot healthy",
	    textClassName: "task-status-running",
	    displayName: "Running",
	    healthStatus: "HEALTHY"
	  },
	  UNHEALTHY: {
	    dotClassName: "dot unhealthy",
	    textClassName: "task-status-running",
	    displayName: "Unhealthy",
	    healthStatus: "UNHEALTHY"
	  },
	  RUNNING: {
	    dotClassName: "dot running",
	    textClassName: "task-status-running",
	    displayName: "Running",
	    healthStatus: "NA"
	  },
	  ERROR: {
	    dotClassName: "dot danger",
	    textClassName: "task-status-error",
	    displayName: "Error",
	    healthStatus: "UNHEALTHY"
	  },
	  FAILED: {
	    dotClassName: "dot danger",
	    textClassName: "task-status-error",
	    displayName: "Failed",
	    healthStatus: "UNHEALTHY"
	  },
	  KILLING: {
	    dotClassName: "dot danger",
	    textClassName: "",
	    displayName: "Killing",
	    healthStatus: "UNHEALTHY"
	  },
	  KILLED: {
	    dotClassName: "dot inactive danger",
	    textClassName: "",
	    displayName: "Killed",
	    healthStatus: "NA"
	  },
	  FINISHED: {
	    dotClassName: "dot inactive danger",
	    textClassName: "",
	    displayName: "Completed",
	    healthStatus: "NA"
	  },
	  LOST: {
	    dotClassName: "dot inactive danger",
	    textClassName: "",
	    displayName: "Lost",
	    healthStatus: "NA"
	  },
	  NA: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "N/A",
	    healthStatus: "NA"
	  }
	};
	
	module.exports = POD_CONTAINER_STATUS;

/***/ },
/* 1232 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * The possible values of ContainerState enum for Pods, according to:
	 * https://github.com/mesosphere/marathon/blob/feature/pods/docs/docs/rest-api/public/api/v2/types/podStatus.raml#L36
	 *
	 * TODO: Note that the SPEC currently states that this is not yet well-defined,
	 *       the current values are assumed to be correct (DCOS-9852).
	 */
	module.exports = {
	  STAGING: "TASK_STAGING",
	  STARTING: "TASK_STARTING",
	  STARTED: "TASK_STARTED",
	  RUNNING: "TASK_RUNNING",
	  KILLING: "TASK_KILLING",
	  FINISHED: "TASK_FINISHED",
	  KILLED: "TASK_KILLED",
	  FAILED: "TASK_FAILED",
	  LOST: "TASK_LOST",
	  ERROR: "TASK_ERROR"
	};

/***/ },
/* 1233 */
/***/ function(module, exports) {

	"use strict";
	
	var POD_INSTANCE_STATUS = {
	  HEALTHY: {
	    dotClassName: "dot healthy",
	    textClassName: "task-status-running",
	    displayName: "Running",
	    healthStatus: "HEALTHY"
	  },
	  UNHEALTHY: {
	    dotClassName: "dot unhealthy",
	    textClassName: "task-status-running",
	    displayName: "Unhealthy",
	    healthStatus: "UNHEALTHY"
	  },
	  RUNNING: {
	    dotClassName: "dot running",
	    textClassName: "task-status-running",
	    displayName: "Running",
	    healthStatus: "NA"
	  },
	  STAGED: {
	    dotClassName: "dot staged",
	    textClassName: "task-status-staging",
	    displayName: "Staging",
	    healthStatus: "NA"
	  },
	  KILLED: {
	    dotClassName: "dot inactive danger",
	    textClassName: "",
	    displayName: "Killed",
	    healthStatus: "NA"
	  },
	  FINISHED: {
	    dotClassName: "dot inactive danger",
	    textClassName: "",
	    displayName: "Completed",
	    healthStatus: "NA"
	  },
	  NA: {
	    dotClassName: "dot inactive unknown",
	    textClassName: "",
	    displayName: "N/A",
	    healthStatus: "NA"
	  }
	};
	
	module.exports = POD_INSTANCE_STATUS;

/***/ },
/* 1234 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * The possible values of PodInstanceState enum, according to:
	 * https://github.com/mesosphere/marathon/blob/feature/pods/docs/docs/rest-api/public/api/v2/types/podStatus.raml#L113
	 */
	module.exports = {
	  PENDING: "pending",
	  STAGING: "staging",
	  STABLE: "stable",
	  DEGRADED: "degraded",
	  TERMINAL: "terminal"
	};

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _ServiceSpec2 = __webpack_require__(1079);
	
	var _ServiceSpec3 = _interopRequireDefault(_ServiceSpec2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_ServiceSpec) {
	  (0, _inherits3.default)(PodSpec, _ServiceSpec);
	
	  function PodSpec() {
	    (0, _classCallCheck3.default)(this, PodSpec);
	    return (0, _possibleConstructorReturn3.default)(this, (PodSpec.__proto__ || (0, _getPrototypeOf2.default)(PodSpec)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodSpec, [{
	    key: "getContainers",
	    value: function getContainers() {
	      return this.get("containers") || [];
	    }
	  }, {
	    key: "getContainerSpec",
	    value: function getContainerSpec(name) {
	      return this.getContainers().find(function (container) {
	        return container.name === name;
	      });
	    }
	  }, {
	    key: "getContainerCount",
	    value: function getContainerCount() {
	      return this.getContainers().length;
	    }
	  }, {
	    key: "getEnvironment",
	    value: function getEnvironment() {
	      return this.get("environment") || {};
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.get("labels") || {};
	    }
	  }, {
	    key: "getNetworks",
	    value: function getNetworks() {
	      return this.get("networks") || [];
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      return this.getContainers().reduce(function (resources, container) {
	        (0, _keys2.default)(container.resources).forEach(function (key) {
	          resources[key] += container.resources[key];
	        });
	
	        return resources;
	      }, {
	        cpus: 0,
	        mem: 0,
	        gpus: 0,
	        disk: 0
	      });
	    }
	  }, {
	    key: "getScaling",
	    value: function getScaling() {
	      return this.get("scaling") || {};
	    }
	  }, {
	    key: "getScalingInstances",
	    value: function getScalingInstances() {
	      var scaling = this.get("scaling") || { kind: "fixed", instances: 1 };
	      if (false) {
	        if (scaling.kind !== "fixed") {
	          throw new TypeError("Unknown scaling type (expecting fixed)");
	        }
	      }
	
	      if (!_ValidatorUtil2.default.isNumber(scaling.instances)) {
	        return 1;
	      }
	
	      return scaling.instances;
	    }
	  }, {
	    key: "getSecrets",
	    value: function getSecrets() {
	      return this.get("secrets") || {};
	    }
	  }, {
	    key: "getVersion",
	    value: function getVersion() {
	      return this.get("version") || "";
	    }
	  }, {
	    key: "getVolumes",
	    value: function getVolumes() {
	      return this.get("volumes") || [];
	    }
	  }, {
	    key: "getUser",
	    value: function getUser() {
	      return this.get("user") || "";
	    }
	  }]);
	  return PodSpec;
	}(_ServiceSpec3.default);

/***/ },
/* 1236 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * The possible values of PodState enum, according to:
	 * https://github.com/mesosphere/marathon/blob/feature/pods/docs/docs/rest-api/public/api/v2/types/podStatus.raml#L98
	 */
	module.exports = {
	  DEGRADED: "degraded",
	  STABLE: "stable",
	  TERMINAL: "terminal"
	};

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _PodTerminationHistory = __webpack_require__(1238);
	
	var _PodTerminationHistory2 = _interopRequireDefault(_PodTerminationHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodTerminationHistoryList = function (_List) {
	  (0, _inherits3.default)(PodTerminationHistoryList, _List);
	
	  function PodTerminationHistoryList() {
	    (0, _classCallCheck3.default)(this, PodTerminationHistoryList);
	    return (0, _possibleConstructorReturn3.default)(this, (PodTerminationHistoryList.__proto__ || (0, _getPrototypeOf2.default)(PodTerminationHistoryList)).apply(this, arguments));
	  }
	
	  return PodTerminationHistoryList;
	}(_List3.default);
	
	PodTerminationHistoryList.type = _PodTerminationHistory2.default;
	
	module.exports = PodTerminationHistoryList;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _PodContainerTerminationHistory = __webpack_require__(1239);
	
	var _PodContainerTerminationHistory2 = _interopRequireDefault(_PodContainerTerminationHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(PodTerminationHistory, _Item);
	
	  function PodTerminationHistory() {
	    (0, _classCallCheck3.default)(this, PodTerminationHistory);
	    return (0, _possibleConstructorReturn3.default)(this, (PodTerminationHistory.__proto__ || (0, _getPrototypeOf2.default)(PodTerminationHistory)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodTerminationHistory, [{
	    key: "getContainers",
	    value: function getContainers() {
	      var containers = this.get("containers") || [];
	
	      return containers.map(function (container) {
	        return new _PodContainerTerminationHistory2.default(container);
	      });
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.get("instanceID");
	    }
	  }, {
	    key: "getMessage",
	    value: function getMessage() {
	      return this.get("message") || "Pod terminated";
	    }
	  }, {
	    key: "getStartedAt",
	    value: function getStartedAt() {
	      return new Date(this.get("startedAt"));
	    }
	  }, {
	    key: "getTerminatedAt",
	    value: function getTerminatedAt() {
	      return new Date(this.get("terminatedAt"));
	    }
	  }]);
	  return PodTerminationHistory;
	}(_Item3.default);

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(PodContainerTerminationHistory, _Item);
	
	  function PodContainerTerminationHistory() {
	    (0, _classCallCheck3.default)(this, PodContainerTerminationHistory);
	    return (0, _possibleConstructorReturn3.default)(this, (PodContainerTerminationHistory.__proto__ || (0, _getPrototypeOf2.default)(PodContainerTerminationHistory)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodContainerTerminationHistory, [{
	    key: "getId",
	    value: function getId() {
	      return this.get("containerId");
	    }
	  }, {
	    key: "getLastKnownState",
	    value: function getLastKnownState() {
	      return this.get("lastKnownState") || "unknown";
	    }
	  }, {
	    key: "getTermination",
	    value: function getTermination() {
	      return this.get("termination") || {
	        exitCode: 0,
	        message: ""
	      };
	    }
	  }]);
	  return PodContainerTerminationHistory;
	}(_Item3.default);

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List = __webpack_require__(947);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Tree2 = __webpack_require__(1220);
	
	var _Tree3 = _interopRequireDefault(_Tree2);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _HealthTypes = __webpack_require__(1089);
	
	var _HealthTypes2 = _interopRequireDefault(_HealthTypes);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceOther = __webpack_require__(1241);
	
	var _ServiceOther2 = _interopRequireDefault(_ServiceOther);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	var _ServiceUtil = __webpack_require__(1244);
	
	var _ServiceUtil2 = _interopRequireDefault(_ServiceUtil);
	
	var _VolumeList = __webpack_require__(1094);
	
	var _VolumeList2 = _interopRequireDefault(_VolumeList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Tree) {
	  (0, _inherits3.default)(ServiceTree, _Tree);
	
	  /**
	   * (Marathon) ServiceTree
	   * @param {{
	   *          id:string,
	   *          items:array<({id:string, items:array}|*)>,
	   *          groups:array<({id:string, groups:array, apps:array}|*)>,
	   *          apps:array,
	   *          filterProperties:{propertyName:(null|string|function)}
	   *        }} options
	   * @constructor
	   * @struct
	   */
	  function ServiceTree() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, ServiceTree);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceTree.__proto__ || (0, _getPrototypeOf2.default)(ServiceTree)).call(this, options));
	
	    _this.id = "/";
	    if (options.id || typeof options.id == "string") {
	      _this.id = options.id;
	    }
	
	    // Converts items into instances of ServiceTree, Application or Framework
	    // based on their properties.
	    _this.list = _this.list.map(function (item) {
	      if (item instanceof ServiceTree || item instanceof _Service2.default) {
	        return item;
	      }
	
	      // Check item properties and convert items with an items array (sub trees)
	      // into ServiceTree instances.
	      if (item.items != null && Array.isArray(item.items)) {
	        return new _this.constructor((0, _assign2.default)({ filterProperties: _this.getFilterProperties() }, item));
	      }
	
	      // Create the appropriate service according to definition
	      return _ServiceUtil2.default.createServiceFromResponse(item);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceTree, [{
	    key: "getDeployments",
	    value: function getDeployments() {
	      return this.reduceItems(function (deployments, item) {
	        if (item instanceof _Service2.default && item.getDeployments() != null) {
	          deployments = deployments.concat(item.getDeployments());
	        }
	
	        return deployments;
	      }, []);
	    }
	  }, {
	    key: "getQueue",
	    value: function getQueue() {
	      return null;
	    }
	  }, {
	    key: "getHealth",
	    value: function getHealth() {
	      return this.reduceItems(function (aggregatedHealth, item) {
	        if (item instanceof _Service2.default) {
	          var health = item.getHealth();
	          if (_HealthTypes2.default[aggregatedHealth.key] > _HealthTypes2.default[health.key]) {
	            aggregatedHealth = health;
	          }
	        }
	
	        return aggregatedHealth;
	      }, _HealthStatus2.default.NA);
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.id;
	    }
	  }, {
	    key: "getServiceFromTaskID",
	    value: function getServiceFromTaskID(taskID) {
	      return this.findItemById(_ServiceUtil2.default.getServiceIDFromTaskID(taskID));
	    }
	  }, {
	    key: "getTaskFromTaskID",
	    value: function getTaskFromTaskID(taskID) {
	      var service = this.getServiceFromTaskID(taskID);
	
	      if (service == null || service.tasks == null || !service.tasks.length) {
	        return null;
	      }
	
	      return service.tasks.find(function (task) {
	        return task.id === taskID;
	      });
	    }
	
	    /**
	     * @param {string} id
	     * @return {Service|ServiceTree} matching item
	     */
	
	  }, {
	    key: "findItemById",
	    value: function findItemById(id) {
	      if (this.getId() === id) {
	        return this;
	      }
	
	      return this.findItem(function (item) {
	        return item.getId() === id;
	      });
	    }
	
	    // TODO @pierlo-upitup MARATHON-1030: refactor for more generic usage
	
	  }, {
	    key: "filterItemsByFilter",
	    value: function filterItemsByFilter(filter) {
	      var services = this.getItems();
	
	      if (filter) {
	        if (filter.ids) {
	          services = services.filter(function (service) {
	            return this.ids.indexOf(service.id) !== -1;
	          }, { ids: filter.ids });
	        }
	
	        if (filter.id) {
	          var filterProperties = (0, _assign2.default)({}, this.getFilterProperties(), {
	            name: function name(item) {
	              return item.getName();
	            }
	          });
	
	          services = this.flattenItems().filterItemsByText(filter.id, filterProperties).getItems();
	        }
	
	        if (Array.isArray(filter.health) && filter.health.length !== 0) {
	          services = services.reduce(function (memo, service) {
	            filter.health.forEach(function (healthValue) {
	              if (service instanceof ServiceTree) {
	                memo = memo.concat(service.filterItemsByFilter({ health: [healthValue] }).getItems());
	
	                return;
	              }
	
	              if (service.getHealth().value === parseInt(healthValue, 10)) {
	                memo.push(service);
	              }
	            });
	
	            return memo;
	          }, []);
	        }
	
	        if (Array.isArray(filter.labels) && filter.labels.length > 0) {
	          services = services.reduce(function (memo, service) {
	            filter.labels.forEach(function (label) {
	              if (service instanceof ServiceTree) {
	                memo = memo.concat(service.filterItemsByFilter({ labels: [label] }).getItems());
	
	                return;
	              }
	
	              var serviceLabels = service.getLabels();
	
	              if (service instanceof _Service2.default) {
	                serviceLabels = _ServiceUtil2.default.convertServiceLabelsToArray(service);
	              }
	
	              var hasLabel = serviceLabels.some(function (serviceLabel) {
	                return serviceLabel.key === label.key && serviceLabel.value === label.value;
	              });
	
	              if (hasLabel) {
	                memo.push(service);
	              }
	            });
	
	            return memo;
	          }, []);
	        }
	
	        if (Array.isArray(filter.other) && filter.other.length !== 0) {
	          services = services.reduce(function (memo, service) {
	            filter.other.forEach(function (otherKey) {
	              if (parseInt(otherKey, 10) === _ServiceOther2.default.CATALOG.key) {
	                if (service instanceof ServiceTree) {
	                  memo = memo.concat(service.filterItemsByFilter({ other: [otherKey] }).getItems());
	                }
	
	                if (service instanceof _Framework2.default) {
	                  memo.push(service);
	                }
	              }
	
	              if (parseInt(otherKey, 10) === _ServiceOther2.default.VOLUMES.key) {
	                var volumes = service.getVolumes();
	
	                if (volumes.list && volumes.list.length > 0) {
	                  memo.push(service);
	                }
	              }
	
	              if (parseInt(otherKey, 10) === _ServiceOther2.default.PODS.key) {
	                if (service instanceof ServiceTree) {
	                  memo = memo.concat(service.filterItemsByFilter({ other: [otherKey] }).getItems());
	                }
	
	                if (service instanceof _Pod2.default) {
	                  memo.push(service);
	                }
	              }
	            });
	
	            return memo;
	          }, []);
	        }
	
	        if (Array.isArray(filter.status) && filter.status.length !== 0) {
	          services = services.reduce(function (memo, service) {
	            filter.status.some(function (statusValue) {
	              if (service instanceof ServiceTree) {
	                memo = memo.concat(service.filterItemsByFilter({ status: [statusValue] }).getItems());
	
	                return;
	              }
	
	              if (service.getServiceStatus().key === parseInt(statusValue, 10)) {
	                memo.push(service);
	              }
	            });
	
	            return memo;
	          }, []);
	        }
	      }
	
	      var _services$reduce = services.reduce(function (memo, service) {
	        if (!(service.getId() in memo.serviceIds)) {
	          memo.serviceIds[service.getId()] = true;
	          memo.uniques.push(service);
	        }
	
	        return memo;
	      }, { uniques: [], serviceIds: {} }),
	          uniques = _services$reduce.uniques;
	
	      return new this.constructor((0, _assign2.default)({}, this, { items: uniques }));
	    }
	  }, {
	    key: "getInstancesCount",
	    value: function getInstancesCount() {
	      return this.reduceItems(function (instances, item) {
	        if (item instanceof _Service2.default) {
	          instances += item.getInstancesCount();
	        }
	
	        return instances;
	      }, 0);
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.getId().split("/").pop();
	    }
	  }, {
	    key: "getResources",
	    value: function getResources() {
	      return this.reduceItems(function (resources, item) {
	        if (item instanceof _Service2.default) {
	          var _item$getResources = item.getResources(),
	              _item$getResources$cp = _item$getResources.cpus,
	              cpus = _item$getResources$cp === undefined ? 0 : _item$getResources$cp,
	              _item$getResources$me = _item$getResources.mem,
	              mem = _item$getResources$me === undefined ? 0 : _item$getResources$me,
	              _item$getResources$di = _item$getResources.disk,
	              disk = _item$getResources$di === undefined ? 0 : _item$getResources$di;
	
	          resources.cpus += cpus;
	          resources.mem += mem;
	          resources.disk += disk;
	        }
	
	        return resources;
	      }, { cpus: 0, mem: 0, disk: 0 });
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus() {
	      var status = this.getServiceStatus();
	      if (status == null) {
	        return null;
	      }
	
	      return status.displayName;
	    }
	  }, {
	    key: "getServiceStatus",
	    value: function getServiceStatus() {
	      return this.reduceItems(function (serviceTreeStatus, item) {
	        if (item instanceof _Service2.default) {
	          var status = item.getServiceStatus();
	          if (status == null) {
	            return serviceTreeStatus;
	          }
	
	          if (status.key > serviceTreeStatus.key) {
	            serviceTreeStatus = status;
	          }
	        }
	
	        return serviceTreeStatus;
	      }, _ServiceStatus2.default.NA);
	    }
	  }, {
	    key: "getServices",
	    value: function getServices() {
	      var items = this.reduceItems(function (services, item) {
	        if (item instanceof _Service2.default) {
	          services.push(item);
	        }
	
	        return services;
	      }, []);
	
	      return new _List2.default({ items: items });
	    }
	  }, {
	    key: "getTasksSummary",
	    value: function getTasksSummary() {
	      return this.reduceItems(function (taskSummary, item) {
	        if (item instanceof _Service2.default) {
	          var _item$getTasksSummary = item.getTasksSummary(),
	              _item$getTasksSummary2 = _item$getTasksSummary.tasksHealthy,
	              tasksHealthy = _item$getTasksSummary2 === undefined ? 0 : _item$getTasksSummary2,
	              _item$getTasksSummary3 = _item$getTasksSummary.tasksRunning,
	              tasksRunning = _item$getTasksSummary3 === undefined ? 0 : _item$getTasksSummary3,
	              _item$getTasksSummary4 = _item$getTasksSummary.tasksOverCapacity,
	              tasksOverCapacity = _item$getTasksSummary4 === undefined ? 0 : _item$getTasksSummary4,
	              _item$getTasksSummary5 = _item$getTasksSummary.tasksStaged,
	              tasksStaged = _item$getTasksSummary5 === undefined ? 0 : _item$getTasksSummary5,
	              _item$getTasksSummary6 = _item$getTasksSummary.tasksUnhealthy,
	              tasksUnhealthy = _item$getTasksSummary6 === undefined ? 0 : _item$getTasksSummary6;
	
	          taskSummary.tasksHealthy += tasksHealthy;
	          taskSummary.tasksRunning += tasksRunning;
	          taskSummary.tasksStaged += tasksStaged;
	          taskSummary.tasksUnhealthy += tasksUnhealthy;
	          taskSummary.tasksUnknown += tasksRunning - tasksHealthy - tasksUnhealthy;
	
	          taskSummary.tasksOverCapacity += tasksOverCapacity;
	        }
	
	        return taskSummary;
	      }, {
	        tasksHealthy: 0,
	        tasksRunning: 0,
	        tasksStaged: 0,
	        tasksUnhealthy: 0,
	        tasksUnknown: 0,
	        tasksOverCapacity: 0
	      });
	    }
	  }, {
	    key: "getRunningInstancesCount",
	    value: function getRunningInstancesCount() {
	      return this.flattenItems().getItems().reduce(function (memo, service) {
	        if (service instanceof ServiceTree) {
	          return memo;
	        }
	
	        return memo + service.getRunningInstancesCount();
	      }, 0);
	    }
	  }, {
	    key: "getFrameworks",
	    value: function getFrameworks() {
	      return this.reduceItems(function (frameworks, item) {
	        if (item instanceof _Framework2.default) {
	          frameworks.push(item);
	        }
	
	        return frameworks;
	      }, []);
	    }
	  }, {
	    key: "getVolumes",
	    value: function getVolumes() {
	      var items = this.reduceItems(function (serviceTreeVolumes, item) {
	        if (item instanceof _Service2.default) {
	          var itemVolumes = item.getVolumes().getItems();
	          if (itemVolumes && itemVolumes.length) {
	            serviceTreeVolumes.push(itemVolumes);
	          }
	        }
	
	        return serviceTreeVolumes;
	      }, []);
	
	      return new _VolumeList2.default({ items: items });
	    }
	  }, {
	    key: "getLabels",
	    value: function getLabels() {
	      return this.reduceItems(function (serviceTreeLabels, item) {
	        _ServiceUtil2.default.convertServiceLabelsToArray(item).forEach(function (_ref) {
	          var key = _ref.key,
	              value = _ref.value;
	
	          if (serviceTreeLabels.findIndex(function (label) {
	            return label.key === key && label.value === value;
	          }) < 0) {
	            serviceTreeLabels = serviceTreeLabels.concat([{ key: key, value: value }]);
	          }
	        });
	
	        return serviceTreeLabels;
	      }, []);
	    }
	  }]);
	  return ServiceTree;
	}(_Tree3.default);

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ServiceOtherLabels = __webpack_require__(1242);
	
	var _ServiceOtherLabels2 = _interopRequireDefault(_ServiceOtherLabels);
	
	var _ServiceOtherTypes = __webpack_require__(1243);
	
	var _ServiceOtherTypes2 = _interopRequireDefault(_ServiceOtherTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SERVICE_OTHER = {
	  CATALOG: {
	    key: _ServiceOtherTypes2.default.CATALOG,
	    displayName: _ServiceOtherLabels2.default.CATALOG
	  },
	  VOLUMES: {
	    key: _ServiceOtherTypes2.default.VOLUMES,
	    displayName: _ServiceOtherLabels2.default.VOLUMES
	  },
	  PODS: {
	    key: _ServiceOtherTypes2.default.PODS,
	    displayName: _ServiceOtherLabels2.default.PODS
	  }
	};
	
	module.exports = SERVICE_OTHER;

/***/ },
/* 1242 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceOtherLabels = {
	  CATALOG: "Catalog",
	  VOLUMES: "Volumes",
	  PODS: "Pods"
	};
	
	module.exports = ServiceOtherLabels;

/***/ },
/* 1243 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceOtherTypes = {
	  CATALOG: 0,
	  VOLUMES: 1,
	  PODS: 2
	};
	
	module.exports = ServiceOtherTypes;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _Application = __webpack_require__(1070);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceValidatorUtil = __webpack_require__(1247);
	
	var _ServiceValidatorUtil2 = _interopRequireDefault(_ServiceValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFindPropertiesRecursive = function getFindPropertiesRecursive(service, item) {
	  return (0, _keys2.default)(item).reduce(function (memo, subItem) {
	    if (item[subItem].type === "group") {
	      (0, _keys2.default)(item[subItem].properties).forEach(function (key) {
	        memo[key] = item[subItem].properties[key].default;
	
	        if (item[subItem].properties[key].getter && !!item[subItem].properties[key].getter(service)) {
	          memo[key] = item[subItem].properties[key].getter(service);
	        }
	      });
	
	      return memo;
	    }
	
	    if (item[subItem].type === "object") {
	      memo[subItem] = getFindPropertiesRecursive(service, item[subItem].properties);
	
	      return memo;
	    }
	
	    memo[subItem] = item[subItem].default;
	
	    if (item[subItem].getter) {
	      memo[subItem] = item[subItem].getter(service);
	    }
	
	    return memo;
	  }, {});
	};
	
	var ServiceUtil = {
	  createServiceFromResponse: function createServiceFromResponse(data) {
	    if (_ServiceValidatorUtil2.default.isPodResponse(data)) {
	      return new _Pod2.default(data);
	    }
	
	    if (_ServiceValidatorUtil2.default.isFrameworkResponse(data)) {
	      return new _Framework2.default(data);
	    }
	
	    if (_ServiceValidatorUtil2.default.isApplicationResponse(data)) {
	      return new _Application2.default(data);
	    }
	
	    throw Error("Unknown service response: " + (0, _stringify2.default)(data));
	  },
	  createFormModelFromSchema: function createFormModelFromSchema(schema) {
	    var service = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Application2.default();
	
	    console.warn("ServieUtil.createFormModelFromSchema has been deprecated.");
	
	    return getFindPropertiesRecursive(service, schema.properties);
	  },
	  isEqual: function isEqual(serviceA, serviceB) {
	    if (serviceA.constructor !== serviceB.constructor) {
	      return false;
	    }
	
	    // Only compare the service specs as everything else is status data
	    return (0, _deepEqual2.default)(serviceA.getSpec(), serviceB.getSpec());
	  },
	  getBaseID: function getBaseID(serviceID) {
	    // The regular expression `/^(\/.+)$/` is looking for the beginning of the
	    // string and matches if the string starts with a `/` and does contain more
	    // characters after the slash. This is combined into a group and then
	    // replaced with the first group which is the complete string and a `/` is
	    // appended. This is needed because in most case a path like
	    // `/group/another-group` will be given by `getId` except on root then the
	    // return value of `getId` would be `/` so in most cases we want to append a
	    // `/` so that the user can begin typing the `id` of their application.
	    return serviceID.replace(/^(\/.+)$/, "$1/");
	  },
	  getDefinitionFromSpec: function getDefinitionFromSpec(spec) {
	    var definition = spec.toJSON();
	
	    if (spec instanceof _ApplicationSpec2.default) {
	      _PluginSDK.Hooks.applyFilter("serviceToAppDefinition", definition, spec);
	    }
	
	    return definition;
	  },
	  getServiceJSON: function getServiceJSON(service) {
	    if (!service) {
	      return {};
	    }
	
	    if (service.toJSON !== undefined) {
	      return service.toJSON();
	    }
	
	    return service;
	  },
	
	
	  /**
	   * Get corresponding service ID
	   *
	   * @param  {string} taskID - the tasks' ID
	   * @return {string} service ID
	   */
	  getServiceIDFromTaskID: function getServiceIDFromTaskID() {
	    var taskID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    // Parse the task id (e.g. foo_bar.abc-123) to get the corresponding
	    // service id parts (foo, bar)
	    var parts = taskID.match(/([^_]+)(?=[_.])/g);
	
	    // Join service id parts and prepend with a slash to form a valid id
	    if (parts) {
	      return "/" + parts.join("/");
	    }
	
	    return "";
	  },
	  getServiceNameFromTaskID: function getServiceNameFromTaskID(taskID) {
	    var serviceName = taskID.split(".")[0].split("_");
	
	    return serviceName[serviceName.length - 1];
	  },
	  convertServiceLabelsToArray: function convertServiceLabelsToArray(service) {
	    if (!(service instanceof _Service2.default)) {
	      return [];
	    }
	
	    var labels = service.getLabels();
	    if (labels == null) {
	      return [];
	    }
	
	    return (0, _keys2.default)(labels).map(function (key) {
	      return { key: key, value: labels[key] };
	    });
	  },
	  isSDKService: function isSDKService(service) {
	    if (!(service instanceof _Service2.default)) {
	      return false;
	    }
	
	    var labels = service.getLabels();
	
	    return labels.DCOS_COMMONS_API_VERSION != null;
	  }
	};
	
	module.exports = ServiceUtil;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1246), __esModule: true };

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(870);
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return (core.JSON && core.JSON.stringify || JSON.stringify).apply(JSON, arguments);
	};

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceValidatorUtil = {
	  isValidServiceID: function isValidServiceID(serviceID) {
	    if (typeof serviceID !== "string" || serviceID === "") {
	      return false;
	    }
	
	    // This RegExp is taken from the ID field explanation described here:
	    // https://mesosphere.github.io/marathon/docs/rest-api.html#post-v2-apps
	    var serviceIDSegmentPattern = new RegExp("^(([a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])[.])" + "*([a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])$");
	
	    return serviceID.split("/").every(function (segment, index) {
	      return index === 0 && (segment == null || segment === "") || segment === "." || segment === ".." || serviceIDSegmentPattern.test(segment);
	    });
	  },
	
	
	  /**
	   * Checks if the given server response is a Pod
	   *
	   * @param {object} data - The server response
	   * @returns {boolean} - True if the response refers to a pod
	   */
	  isPodResponse: function isPodResponse(data) {
	    return (0, _typeof3.default)(data.spec) === "object" && ServiceValidatorUtil.isPodSpecDefinition(data.spec);
	  },
	
	
	  /**
	   * Checks if the given definition (commonly form the ServiceForm)
	   * is a Pod specification.
	   *
	   * @param {object} data - The definition
	   * @returns {boolean} - True if the response refers to a pod
	   */
	  isPodSpecDefinition: function isPodSpecDefinition(data) {
	    return Array.isArray(data.containers);
	  },
	
	
	  /**
	   * Checks if the given server response is an application
	   *
	   * @param {object} data - The server response
	   * @returns {boolean} - True if the response refers to a pod
	   */
	  isApplicationResponse: function isApplicationResponse() {
	    // TODO: Check how an application can be cleanly identified (DCOS-9618)
	    return true;
	  },
	
	
	  // Applications and frameworks have no different semantics
	  // between their spec and their server response.
	  isApplicationSpecDefinition: function isApplicationSpecDefinition(data) {
	    return ServiceValidatorUtil.isApplicationResponse(data);
	  },
	
	
	  /**
	   * Checks if the given server response is a framework
	   *
	   * @param {object} data - The server response
	   * @returns {boolean} - True if the response refers to a pod
	   */
	  isFrameworkResponse: function isFrameworkResponse(data) {
	    // Check the DCOS_PACKAGE_FRAMEWORK_NAME label to determine if the item
	    // should be converted to an Application or Framework instance.
	    return ServiceValidatorUtil.isApplicationResponse(data) && data.labels && data.labels.DCOS_PACKAGE_FRAMEWORK_NAME;
	  },
	
	
	  // Applications and frameworks have no different semantics
	  // between their spec and their server response.
	  isFrameworkSpecDefinition: function isFrameworkSpecDefinition(data) {
	    return ServiceValidatorUtil.isFrameworkResponse(data);
	  }
	};
	
	module.exports = ServiceValidatorUtil;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _from = __webpack_require__(1018);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _events = __webpack_require__(1009);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _EventTypes = __webpack_require__(933);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MetronomeActions = __webpack_require__(1256);
	
	var _MetronomeActions2 = _interopRequireDefault(_MetronomeActions);
	
	var _MetronomeUtil = __webpack_require__(1257);
	
	var _MetronomeUtil2 = _interopRequireDefault(_MetronomeUtil);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _JobTree = __webpack_require__(1212);
	
	var _JobTree2 = _interopRequireDefault(_JobTree);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = void 0;
	var jobDetailFetchTimers = {};
	
	function pauseJobDetailMonitors() {
	  (0, _keys2.default)(jobDetailFetchTimers).forEach(function (jobID) {
	    global.clearInterval(jobDetailFetchTimers[jobID]);
	    jobDetailFetchTimers[jobID] = null;
	  });
	}
	
	function startPolling() {
	  if (!requestInterval) {
	    _MetronomeActions2.default.fetchJobs();
	    requestInterval = global.setInterval(_MetronomeActions2.default.fetchJobs, _Config2.default.getRefreshRate());
	  }
	}
	
	function stopPolling() {
	  if (requestInterval) {
	    global.clearInterval(requestInterval);
	    requestInterval = null;
	  }
	}
	
	var MetronomeStore = function (_EventEmitter) {
	  (0, _inherits3.default)(MetronomeStore, _EventEmitter);
	
	  function MetronomeStore() {
	    (0, _classCallCheck3.default)(this, MetronomeStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MetronomeStore.__proto__ || (0, _getPrototypeOf2.default)(MetronomeStore)).apply(this, arguments));
	
	    _this.data = {
	      jobMap: new _map2.default(),
	      jobTree: null
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        jobCreateSuccess: _EventTypes.METRONOME_JOB_CREATE_SUCCESS,
	        jobCreateError: _EventTypes.METRONOME_JOB_CREATE_ERROR,
	        jobDeleteSuccess: _EventTypes.METRONOME_JOB_DELETE_SUCCESS,
	        jobDeleteError: _EventTypes.METRONOME_JOB_DELETE_ERROR,
	        jobDetailChange: _EventTypes.METRONOME_JOB_DETAIL_CHANGE,
	        jobDetailError: _EventTypes.METRONOME_JOB_DETAIL_ERROR,
	        jobUpdateSuccess: _EventTypes.METRONOME_JOB_UPDATE_SUCCESS,
	        jobUpdateError: _EventTypes.METRONOME_JOB_UPDATE_ERROR,
	        jobRunError: _EventTypes.METRONOME_JOB_RUN_ERROR,
	        jobRunSuccess: _EventTypes.METRONOME_JOB_RUN_SUCCESS,
	        jobStopRunError: _EventTypes.METRONOME_JOB_STOP_RUN_ERROR,
	        jobStopRunSuccess: _EventTypes.METRONOME_JOB_STOP_RUN_SUCCESS,
	        jobScheduleUpdateError: _EventTypes.METRONOME_JOB_SCHEDULE_UPDATE_ERROR,
	        jobScheduleUpdateSuccess: _EventTypes.METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS,
	        change: _EventTypes.METRONOME_JOBS_CHANGE,
	        error: _EventTypes.METRONOME_JOBS_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    // Handle app actions
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (_ref) {
	      var source = _ref.source,
	          action = _ref.action;
	
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	      switch (action.type) {
	        case _ActionTypes.REQUEST_METRONOME_JOB_CREATE_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_CREATE_SUCCESS);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_CREATE_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_CREATE_ERROR, action.data);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_DELETE_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_DELETE_ERROR, action.jobID, action.data);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_DELETE_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_DELETE_SUCCESS, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_SUCCESS:
	          _this.setJob(action.data);
	
	          _this.emit(_EventTypes.METRONOME_JOB_DETAIL_CHANGE);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_ONGOING:
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_DETAIL_ERROR);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_UPDATE_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_UPDATE_SUCCESS);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_UPDATE_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_UPDATE_ERROR, action.data);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_RUN_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_RUN_ERROR, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_RUN_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_RUN_SUCCESS, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_STOP_RUN_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_STOP_RUN_ERROR, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_STOP_RUN_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_STOP_RUN_SUCCESS, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOB_SCHEDULE_UPDATE_ERROR, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS:
	          _this.emit(_EventTypes.METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS, action.jobID);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOBS_SUCCESS:
	          action.data.forEach(_this.setJob.bind(_this));
	
	          _this.emit(_EventTypes.METRONOME_JOBS_CHANGE);
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOBS_ONGOING:
	          break;
	        case _ActionTypes.REQUEST_METRONOME_JOBS_ERROR:
	          _this.emit(_EventTypes.METRONOME_JOBS_ERROR);
	          break;
	      }
	
	      return true;
	    });
	
	    _VisibilityStore2.default.addChangeListener(_EventTypes.VISIBILITY_CHANGE, _this.onVisibilityStoreChange.bind(_this));
	    return _this;
	  }
	
	  (0, _createClass3.default)(MetronomeStore, [{
	    key: "setJob",
	    value: function setJob(job) {
	      var _job = job,
	          id = _job.id;
	
	
	      if (this.data.jobMap.has(id)) {
	        job = (0, _assign2.default)({}, this.data.jobMap.get(id), job);
	      }
	
	      this.data.jobMap.set(id, job);
	      this.data.jobTree = null;
	    }
	  }, {
	    key: "createJob",
	    value: function createJob(job) {
	      _MetronomeActions2.default.createJob(job);
	    }
	  }, {
	    key: "deleteJob",
	    value: function deleteJob(jobID, stopCurrentJobRuns) {
	      _MetronomeActions2.default.deleteJob(jobID, stopCurrentJobRuns);
	    }
	  }, {
	    key: "fetchJobDetail",
	    value: function fetchJobDetail(jobID) {
	      _MetronomeActions2.default.fetchJobDetail(jobID);
	    }
	  }, {
	    key: "updateJob",
	    value: function updateJob(jobId, job) {
	      _MetronomeActions2.default.updateJob(jobId, job);
	    }
	  }, {
	    key: "runJob",
	    value: function runJob(jobID) {
	      _MetronomeActions2.default.runJob(jobID);
	    }
	  }, {
	    key: "stopJobRun",
	    value: function stopJobRun(jobID, jobRunID) {
	      var job = this.getJob(jobID);
	
	      if (job == null || jobRunID == null) {
	        return;
	      }
	
	      _MetronomeActions2.default.stopJobRun(jobID, jobRunID);
	    }
	  }, {
	    key: "toggleSchedule",
	    value: function toggleSchedule(jobID) {
	      var isEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var job = this.getJob(jobID);
	
	      if (job == null) {
	        return null;
	      }
	
	      var _job$getSchedules = job.getSchedules(),
	          _job$getSchedules2 = (0, _slicedToArray3.default)(_job$getSchedules, 1),
	          schedule = _job$getSchedules2[0];
	
	      if (schedule == null) {
	        return null;
	      }
	
	      this.updateSchedule(jobID, (0, _assign2.default)({}, schedule, { enabled: isEnabled }));
	    }
	  }, {
	    key: "updateSchedule",
	    value: function updateSchedule(jobID, schedule) {
	      if (schedule == null) {
	        return;
	      }
	
	      _MetronomeActions2.default.updateSchedule(jobID, schedule);
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	
	      // Start polling if there is at least one listener
	      if (this.shouldPoll()) {
	        startPolling();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      // Stop polling if no one is listening
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "getJob",
	    value: function getJob(id) {
	      return this.jobTree.findItem(function (item) {
	        return item instanceof _Job2.default && item.getId() === id;
	      });
	    }
	  }, {
	    key: "monitorJobDetail",
	    value: function monitorJobDetail(jobID) {
	      if (jobDetailFetchTimers[jobID] != null || jobID == null) {
	        // Already monitoring
	        return;
	      }
	
	      if (!_VisibilityStore2.default.isInactive()) {
	        this.fetchJobDetail(jobID);
	
	        jobDetailFetchTimers[jobID] = global.setInterval(this.fetchJobDetail.bind(this, jobID), _Config2.default.getRefreshRate());
	      }
	    }
	  }, {
	    key: "onVisibilityStoreChange",
	    value: function onVisibilityStoreChange() {
	      var _this2 = this;
	
	      if (!_VisibilityStore2.default.isInactive()) {
	        (0, _keys2.default)(jobDetailFetchTimers).forEach(function (jobID) {
	          _this2.monitorJobDetail(jobID);
	        });
	
	        if (this.shouldPoll()) {
	          startPolling();
	
	          return;
	        }
	      }
	
	      pauseJobDetailMonitors();
	      stopPolling();
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return this.listeners(_EventTypes.METRONOME_JOBS_CHANGE).length > 0;
	    }
	  }, {
	    key: "stopJobDetailMonitor",
	    value: function stopJobDetailMonitor(jobID) {
	      if (jobID != null) {
	        global.clearInterval(jobDetailFetchTimers[jobID]);
	        delete jobDetailFetchTimers[jobID];
	
	        return;
	      }
	
	      (0, _keys2.default)(jobDetailFetchTimers).forEach(function (fetchTimerID) {
	        global.clearInterval(jobDetailFetchTimers[fetchTimerID]);
	        delete jobDetailFetchTimers[fetchTimerID];
	      });
	    }
	
	    /**
	     * @type {JobTree}
	     */
	
	  }, {
	    key: "jobTree",
	    get: function get() {
	      if (!(this.data.jobTree instanceof _JobTree2.default)) {
	        this.data.jobTree = new _JobTree2.default(_MetronomeUtil2.default.parseJobs((0, _from2.default)(this.data.jobMap.values())));
	      }
	
	      return this.data.jobTree;
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "metronome";
	    }
	  }]);
	  return MetronomeStore;
	}(_events.EventEmitter);
	
	module.exports = new MetronomeStore();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1250);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1253);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1251), __esModule: true };

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(899);
	__webpack_require__(883);
	module.exports = __webpack_require__(1252);

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(905)
	  , ITERATOR  = __webpack_require__(896)('iterator')
	  , Iterators = __webpack_require__(893);
	module.exports = __webpack_require__(870).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1254), __esModule: true };

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(899);
	__webpack_require__(883);
	module.exports = __webpack_require__(1255);

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(907)
	  , get      = __webpack_require__(913);
	module.exports = __webpack_require__(870).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetronomeActions = {
	  createJob: function createJob(data) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v0/scheduled-jobs",
	      method: "POST",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_CREATE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_CREATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	
	
	  fetchJobs: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function () {
	      _mesosphereSharedReactjs.RequestUtil.json({
	        url: _Config2.default.metronomeAPI + "/v1/jobs",
	        data: [{ name: "embed", value: "activeRuns" }, { name: "embed", value: "schedules" }, { name: "embed", value: "historySummary" }],
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_METRONOME_JOBS_SUCCESS,
	            data: response
	          });
	        },
	        error: function error(xhr) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_METRONOME_JOBS_ERROR,
	            data: xhr.message,
	            xhr: xhr
	          });
	          reject();
	        },
	        hangingRequestCallback: function hangingRequestCallback() {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_METRONOME_JOBS_ONGOING
	          });
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount }),
	
	  fetchJobDetail: function fetchJobDetail(jobID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v1/jobs/" + jobID,
	      data: [{ name: "embed", value: "activeRuns" }, { name: "embed", value: "history" }, { name: "embed", value: "schedules" }],
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_SUCCESS,
	          data: response,
	          jobID: jobID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          jobID: jobID,
	          xhr: xhr
	        });
	      },
	      hangingRequestCallback: function hangingRequestCallback() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_DETAIL_ONGOING,
	          jobID: jobID
	        });
	      }
	    });
	  },
	  deleteJob: function deleteJob(jobID) {
	    var stopCurrentJobRuns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v1/jobs/" + jobID + ("?stopCurrentJobRuns=" + stopCurrentJobRuns),
	      method: "DELETE",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_DELETE_SUCCESS,
	          jobID: jobID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_DELETE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          jobID: jobID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  updateJob: function updateJob(jobID, data) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v0/scheduled-jobs/" + jobID,
	      method: "PUT",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_UPDATE_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_UPDATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  runJob: function runJob(jobID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v1/jobs/" + jobID + "/runs",
	      method: "POST",
	      data: {},
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_RUN_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_RUN_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  stopJobRun: function stopJobRun(jobID, jobRunID) {
	    var url = _Config2.default.metronomeAPI + "/v1/jobs/" + jobID + ("/runs/" + jobRunID + "/actions/stop");
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: url,
	      method: "POST",
	      data: {},
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_STOP_RUN_SUCCESS
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_STOP_RUN_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  updateSchedule: function updateSchedule(jobID, data) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.metronomeAPI + "/v1/jobs/" + jobID + "/schedules/" + data.id,
	      method: "PUT",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_SUCCESS,
	          jobID: jobID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_METRONOME_JOB_SCHEDULE_UPDATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          jobID: jobID,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var jobFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/metronome/job.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var jobsFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/metronome/jobs.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.MetronomeActions = {
	    deleteJob: {
	      event: "success",
	      success: { response: {} }
	    },
	    fetchJobDetail: {
	      event: "success",
	      success: { response: jobFixture }
	    },
	    fetchJobs: {
	      event: "success",
	      success: { response: jobsFixture }
	    },
	    runJob: {
	      event: "success",
	      success: { response: {} }
	    },
	    stopJobRun: {
	      event: "success",
	      success: { response: {} }
	    },
	    updateSchedule: {
	      event: "success",
	      success: { response: {} }
	    }
	  };
	
	  (0, _keys2.default)(global.actionTypes.MetronomeActions).forEach(function (method) {
	    MetronomeActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(MetronomeActions, "MetronomeActions", method);
	  });
	}
	
	module.exports = MetronomeActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Pattern to extract the parent id (e.g. "a.b") from an item id (e.g. "a.b.c")
	 * by matching everything except the last bit (e.g. ".c")
	 *
	 * @type {RegExp}
	 */
	var PARENT_ID_REGEXP = /.*?(?=\.?[^.]+\.?$)/;
	
	/**
	 * Get the parent id (e.g. "a.b") from the item id (e.g. "a.b.c")
	 *
	 * @param {string} itemId
	 * @return {string} the items parent id
	 */
	function getParentId(itemId) {
	  var _itemId$match = itemId.match(PARENT_ID_REGEXP),
	      _itemId$match2 = (0, _slicedToArray3.default)(_itemId$match, 1),
	      _itemId$match2$ = _itemId$match2[0],
	      parentId = _itemId$match2$ === undefined ? "" : _itemId$match2$;
	
	  return parentId;
	}
	
	/**
	 * Add a job to the respective namespace based on the id property.
	 *
	 * @param {{id:string}} job
	 * @param {Map} jobMap hash map of all jobs that have already
	 * been created
	 * @param {Map} namespaceMap hash map of all namespaces that have already
	 * been created
	 * @return {{id:string}} job
	 */
	function addJob(job, jobMap, namespaceMap) {
	  var _job = job,
	      id = _job.id;
	
	
	  if (id.startsWith(".") || id.endsWith(".")) {
	    throw new Error("Id (" + id + ") must not start with a leading dot (\".\") " + "and should not end with a dot.");
	  }
	
	  // Check if the item (namespace or job) has already been added and merge with
	  // existing one
	  if (jobMap.has(id)) {
	    job = (0, _assign2.default)(jobMap.get(id), job);
	    jobMap.set(id, job);
	
	    return job;
	  }
	
	  var parentNamespace = getNamespaceWithId(getParentId(id), namespaceMap);
	
	  // Add job to the parent namespace and jobs map
	  parentNamespace.items.push(job);
	  jobMap.set(id, job);
	
	  return job;
	}
	
	/**
	 * Get a namespace with the respective id and create sub namespaces if needed.
	 *
	 * @param {String} namespaceId
	 * @param {Map} namespaceMap hash map of all namespaces that have already
	 * been created
	 * @return {{id:string, items:[]}} namespace
	 */
	function getNamespaceWithId(namespaceId, namespaceMap) {
	  // Check if the item (namespace or job) has already been added
	  if (namespaceMap.has(namespaceId)) {
	    return namespaceMap.get(namespaceId);
	  }
	
	  var namespace = { id: namespaceId, items: [] };
	  var parentNamespace = getNamespaceWithId(getParentId(namespaceId), namespaceMap);
	
	  // Save namespace and link with parent
	  namespaceMap.set(namespaceId, namespace);
	  parentNamespace.items.push(namespace);
	
	  return namespace;
	}
	
	var MetronomeUtil = {
	  /**
	   * [parseJobs description]
	   * @param  {array} jobs to be turned into an acceptable structure
	   * for Job or JobTree
	   * @return {{
	   *          id:string,
	   *          items:array<({id:string, items:array}|*)>,
	   * }} jobs and namespaces in a tree structure
	   */
	  parseJobs: function parseJobs(jobs) {
	    var namespacesMap = new _map2.default();
	    var jobsMap = new _map2.default();
	    var rootNamespace = { id: "", items: [] };
	
	    // Add initial root namespace. N.B. The namespaces must be added to the map
	    // without the "%" prefix.
	    namespacesMap.set("", rootNamespace);
	
	    if (!Array.isArray(jobs)) {
	      jobs = [jobs];
	    }
	
	    jobs.forEach(function (job) {
	      addJob(MetronomeUtil.parseJob(job), jobsMap, namespacesMap);
	    });
	
	    return rootNamespace;
	  },
	  parseJob: function parseJob(job) {
	    var history = job.history;
	
	
	    if (history == null) {
	      return job;
	    }
	
	    var _history = history,
	        _history$failedFinish = _history.failedFinishedRuns,
	        failedFinishedRuns = _history$failedFinish === undefined ? [] : _history$failedFinish,
	        _history$successfulFi = _history.successfulFinishedRuns,
	        successfulFinishedRuns = _history$successfulFi === undefined ? [] : _history$successfulFi;
	
	
	    failedFinishedRuns = failedFinishedRuns.map(function (jobRun) {
	      return (0, _assign2.default)({}, jobRun, { status: "FAILED", jobId: job.id });
	    });
	
	    successfulFinishedRuns = successfulFinishedRuns.map(function (jobRun) {
	      return (0, _assign2.default)({}, jobRun, { status: "COMPLETED", jobId: job.id });
	    });
	
	    history = (0, _assign2.default)({}, history, {
	      failedFinishedRuns: failedFinishedRuns,
	      successfulFinishedRuns: successfulFinishedRuns
	    });
	
	    return (0, _assign2.default)({}, job, { history: history });
	  }
	};
	
	module.exports = MetronomeUtil;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _EventTypes = __webpack_require__(933);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(NotificationStore, _GetSetBaseStore);
	
	  function NotificationStore() {
	    (0, _classCallCheck3.default)(this, NotificationStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationStore.__proto__ || (0, _getPrototypeOf2.default)(NotificationStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      notificationMap: {}
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        change: _EventTypes.NOTIFICATION_CHANGE
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(NotificationStore, [{
	    key: "setLocationValue",
	    value: function setLocationValue(notificationMap, location, notificationID, value) {
	      var locationMap = notificationMap[location];
	      if (locationMap == null) {
	        notificationMap[location] = {};
	      }
	
	      notificationMap[location][notificationID] = value;
	
	      return notificationMap;
	    }
	  }, {
	    key: "deleteLocation",
	    value: function deleteLocation(notificationMap, location, notificationID) {
	      if (!Object.prototype.hasOwnProperty.call(notificationMap, location)) {
	        return notificationMap;
	      }
	
	      delete notificationMap[location][notificationID];
	
	      return notificationMap;
	    }
	
	    // Public API Below
	    // TODO:  DCOS-7431 - Fix documentation style (jsdoc)
	    /*
	     Set the notification value for a specific location.
	      @param {Array|String} locations Location or locations to set.
	     @param {String} notificationID ID of the specific notification.
	     @param {Number} value The number of notifications.
	     @access public
	     */
	
	  }, {
	    key: "addNotification",
	    value: function addNotification(locations, notificationID, value) {
	      var _this2 = this;
	
	      var notificationMap = this.get("notificationMap");
	
	      if (Array.isArray(locations)) {
	        locations.forEach(function (location) {
	          _this2.setLocationValue(notificationMap, location, notificationID, value);
	        });
	      } else {
	        this.setLocationValue(notificationMap, locations, notificationID, value);
	      }
	
	      this.set({ notificationMap: notificationMap });
	      this.emit(_EventTypes.NOTIFICATION_CHANGE);
	    }
	
	    /*
	     Remove all the notifications for a specific location.
	      @param {Array|String} locations Location or locations to remove.
	     @param {String} notificationID ID of the specific notification.
	     @access public
	     */
	
	  }, {
	    key: "removeNotification",
	    value: function removeNotification(locations, notificationID) {
	      var _this3 = this;
	
	      var notificationMap = this.get("notificationMap");
	
	      if (Array.isArray(locations)) {
	        locations.forEach(function (location) {
	          _this3.deleteLocation(notificationMap, location, notificationID);
	        });
	      } else {
	        this.deleteLocation(notificationMap, locations, notificationID);
	      }
	
	      this.set({ notificationMap: notificationMap });
	      this.emit(_EventTypes.NOTIFICATION_CHANGE);
	    }
	
	    /*
	     Get the notification value for a specific location
	      @param {String} tabName Location or locations to get the notification count.
	     @access public
	     @return {Number} value representing the number of notifications.
	     */
	
	  }, {
	    key: "getNotificationCount",
	    value: function getNotificationCount(tabName) {
	      var notificationMap = this.get("notificationMap");
	      if (!Object.prototype.hasOwnProperty.call(notificationMap, tabName)) {
	        return 0;
	      }
	
	      notificationMap = notificationMap[tabName];
	
	      return (0, _values2.default)(notificationMap).reduce(function (tally, count) {
	        return tally += count;
	      }, 0);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "notification";
	    }
	  }]);
	  return NotificationStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new NotificationStore();

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	var _StateSummary = __webpack_require__(1260);
	
	var _StateSummary2 = _interopRequireDefault(_StateSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummaryList = function (_List) {
	  (0, _inherits3.default)(SummaryList, _List);
	
	  function SummaryList() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, SummaryList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SummaryList.__proto__ || (0, _getPrototypeOf2.default)(SummaryList)).apply(this, arguments));
	
	    _this.maxLength = options.maxLength || null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SummaryList, [{
	    key: "add",
	    value: function add() {
	      (0, _get3.default)(SummaryList.prototype.__proto__ || (0, _getPrototypeOf2.default)(SummaryList.prototype), "add", this).apply(this, arguments);
	
	      if (this.maxLength && this.list.length > this.maxLength) {
	        this.list.shift();
	      }
	    }
	  }, {
	    key: "addSnapshot",
	    value: function addSnapshot(snapshot, date, successful) {
	      this.add(new _StateSummary2.default({ snapshot: snapshot, date: date, successful: successful }));
	    }
	  }, {
	    key: "getActiveNodesByState",
	    value: function getActiveNodesByState() {
	      return this.getItems().map(function (state) {
	        var slavesCount = null;
	
	        if (state.isSnapshotSuccessful()) {
	          slavesCount = state.getActiveSlaves().length;
	        }
	
	        return {
	          date: state.getSnapshotDate(),
	          slavesCount: slavesCount
	        };
	      });
	    }
	  }, {
	    key: "lastSuccessful",
	    value: function lastSuccessful() {
	      // finds last StateSummary with successful snapshot
	      var stateResources = this.getItems();
	      for (var i = stateResources.length - 1; i >= 0; i--) {
	        if (stateResources[i].isSnapshotSuccessful()) {
	          return stateResources[i];
	        }
	      }
	
	      return new _StateSummary2.default({ successful: false });
	    }
	  }, {
	    key: "getResourceStatesForServiceIDs",
	    value: function getResourceStatesForServiceIDs(ids) {
	      var items = this.getItems() || [];
	      var stateResources = items.map(function (state) {
	        var resources = null,
	            totalResources = null;
	
	        if (state.isSnapshotSuccessful()) {
	          resources = state.getServiceList().filter({ ids: ids }).sumUsedResources();
	          totalResources = state.getSlaveTotalResources();
	        }
	
	        return {
	          date: state.getSnapshotDate(),
	          resources: resources,
	          totalResources: totalResources
	        };
	      });
	
	      return _MesosSummaryUtil2.default.stateResourcesToResourceStates(stateResources);
	    }
	  }, {
	    key: "getResourceStatesForNodeIDs",
	    value: function getResourceStatesForNodeIDs(ids) {
	      var stateResources = this.getItems().map(function (state) {
	        var resources = null,
	            totalResources = null;
	
	        if (state.isSnapshotSuccessful()) {
	          resources = state.getNodesList().filter({ ids: ids }).sumUsedResources();
	          totalResources = state.getNodesList().filter({ ids: ids }).sumResources();
	        }
	
	        return {
	          date: state.getSnapshotDate(),
	          resources: resources,
	          totalResources: totalResources
	        };
	      });
	
	      return _MesosSummaryUtil2.default.stateResourcesToResourceStates(stateResources);
	    }
	  }]);
	  return SummaryList;
	}(_List3.default);
	
	module.exports = SummaryList;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	var _ServicesList = __webpack_require__(1059);
	
	var _ServicesList2 = _interopRequireDefault(_ServicesList);
	
	var _NodesList = __webpack_require__(1049);
	
	var _NodesList2 = _interopRequireDefault(_NodesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function () {
	  function StateSummary() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, StateSummary);
	
	    this.snapshot = {
	      frameworks: [],
	      slaves: [],
	      cluster: "",
	      hostname: ""
	    };
	
	    this.metadata = {
	      date: undefined,
	      successfulSnapshot: true,
	      serviceUsedResources: { cpus: 0, mem: 0, disk: 0 },
	      slaveUsedResources: { cpus: 0, mem: 0, disk: 0 },
	      slaveTotalResources: { cpus: 0, mem: 0, disk: 0 }
	    };
	    var snapshot = options.snapshot || this.snapshot;
	    // Only place where we normalize server data
	    // we may be able to remove this, but it needs testing
	    snapshot.slaves = snapshot.slaves || [];
	    this.snapshot = snapshot;
	
	    if (options.successful != null) {
	      this.metadata.successfulSnapshot = options.successful;
	    }
	    this.metadata.date = options.date || Date.now();
	
	    var slaves = this.snapshot.slaves;
	
	    // Store computed data – this is something we may not need to store
	    this.metadata.slaveTotalResources = _MesosSummaryUtil2.default.sumResources(
	    // We may only want to get the active slaves...
	    slaves.map(function (slave) {
	      return slave.resources;
	    }));
	
	    this.metadata.slaveUsedResources = _MesosSummaryUtil2.default.sumResources(
	    // We may only want to get the active slaves...
	    slaves.map(function (slave) {
	      return slave.used_resources;
	    }));
	
	    var frameworks = this.snapshot.frameworks || [];
	    this.metadata.serviceUsedResources = _MesosSummaryUtil2.default.sumResources(frameworks.map(function (framework) {
	      return framework.used_resources;
	    }));
	  }
	
	  (0, _createClass3.default)(StateSummary, [{
	    key: "getSnapshotDate",
	    value: function getSnapshotDate() {
	      return this.metadata.date;
	    }
	  }, {
	    key: "getClusterName",
	    value: function getClusterName() {
	      return this.snapshot.cluster;
	    }
	  }, {
	    key: "getActiveSlaves",
	    value: function getActiveSlaves() {
	      return this.snapshot.slaves.filter(function (slave) {
	        return slave.active === true;
	      });
	    }
	  }, {
	    key: "getServiceList",
	    value: function getServiceList() {
	      return new _ServicesList2.default({ items: this.snapshot.frameworks });
	    }
	  }, {
	    key: "getNodesList",
	    value: function getNodesList() {
	      return new _NodesList2.default({ items: this.snapshot.slaves });
	    }
	  }, {
	    key: "getSlaveTotalResources",
	    value: function getSlaveTotalResources() {
	      return this.metadata.slaveTotalResources;
	    }
	  }, {
	    key: "getSlaveUsedResources",
	    value: function getSlaveUsedResources() {
	      return this.metadata.slaveUsedResources;
	    }
	  }, {
	    key: "getServiceUsedResources",
	    value: function getServiceUsedResources() {
	      return this.metadata.serviceUsedResources;
	    }
	  }, {
	    key: "isSnapshotSuccessful",
	    value: function isSnapshotSuccessful() {
	      return this.metadata.successfulSnapshot;
	    }
	  }]);
	  return StateSummary;
	}();

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MesosStateUtil = __webpack_require__(1262);
	
	var _MesosStateUtil2 = _interopRequireDefault(_MesosStateUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MesosStateActions = {
	  fetchState: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function () {
	      _mesosphereSharedReactjs.RequestUtil.json({
	        url: _Config2.default.historyServer + "/mesos/master/state",
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes2.default.REQUEST_MESOS_STATE_SUCCESS,
	            data: _MesosStateUtil2.default.flagMarathonTasks(response)
	          });
	          resolve();
	        },
	        error: function error(xhr) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes2.default.REQUEST_MESOS_STATE_ERROR,
	            data: xhr.message,
	            xhr: xhr
	          });
	          reject();
	        },
	        hangingRequestCallback: function hangingRequestCallback() {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes2.default.REQUEST_MESOS_STATE_ONGOING
	          });
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount })
	};
	
	module.exports = MesosStateActions;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _StructUtil = __webpack_require__(936);
	
	var _StructUtil2 = _interopRequireDefault(_StructUtil);
	
	var _ExecutorTypes = __webpack_require__(1263);
	
	var _ExecutorTypes2 = _interopRequireDefault(_ExecutorTypes);
	
	var _PodInstanceState = __webpack_require__(1234);
	
	var _PodInstanceState2 = _interopRequireDefault(_PodInstanceState);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RESOURCE_KEYS = ["cpus", "disk", "mem"];
	
	// Based on the regex that marathon uses to validate task IDs,
	// but keeping only the 'instance-' prefix, that refers to pods.
	// The 'marathon-' prefix is used for task launched because of an AppDefinition.
	//
	// https://github.com/mesosphere/marathon/blob/feature/pods/src/main/scala/mesosphere/marathon/core/task/Task.scala#L134
	var POD_TASK_REGEX = /^(.+)\.instance-([^_.]+)[._]([^_.]+)$/;
	
	function setIsStartedByMarathonFlag(name, tasks) {
	  return tasks.map(function (task) {
	    return (0, _assign2.default)({ isStartedByMarathon: name === "marathon" }, task);
	  });
	}
	
	var MesosStateUtil = {
	  /**
	   * De-compose the given task id into it's primitive components
	   *
	   * @param {String} taskID - The task ID to decompose
	   * @returns {{podID, instanceID}} Returns the ID components
	   */
	  decomposePodTaskId: function decomposePodTaskId(taskID) {
	    var _POD_TASK_REGEX$exec = POD_TASK_REGEX.exec(taskID),
	        _POD_TASK_REGEX$exec2 = (0, _slicedToArray3.default)(_POD_TASK_REGEX$exec, 4),
	        podID = _POD_TASK_REGEX$exec2[1],
	        instanceID = _POD_TASK_REGEX$exec2[2],
	        taskName = _POD_TASK_REGEX$exec2[3];
	
	    return {
	      podID: podID,
	      instanceID: instanceID,
	      taskName: taskName
	    };
	  },
	  flagMarathonTasks: function flagMarathonTasks(state) {
	    var newState = (0, _assign2.default)({}, state);
	
	    newState.frameworks = state.frameworks.map(function (framework) {
	      var _framework$tasks = framework.tasks,
	          tasks = _framework$tasks === undefined ? [] : _framework$tasks,
	          _framework$completed_ = framework.completed_tasks,
	          completed_tasks = _framework$completed_ === undefined ? [] : _framework$completed_,
	          name = framework.name;
	
	
	      return (0, _assign2.default)({}, framework, {
	        tasks: setIsStartedByMarathonFlag(name, tasks),
	        completed_tasks: setIsStartedByMarathonFlag(name, completed_tasks)
	      });
	    });
	
	    return newState;
	  },
	
	
	  /**
	   * @param {{frameworks:array,completed_frameworks:array}} state
	   * @param {string} frameworkID
	   * @returns {{executors:Array, completed_executors:Array}|null} framework
	   */
	  getFramework: function getFramework(state, frameworkID) {
	    var frameworks = state.frameworks,
	        completed_frameworks = state.completed_frameworks;
	
	
	    return [].concat(frameworks, completed_frameworks).find(function (framework) {
	      return framework != null && framework.id === frameworkID;
	    });
	  },
	
	
	  /**
	   * @param  {Object} state A document of mesos state
	   * @param  {Array} filter Allows us to filter by framework id
	   *   All other frameworks will be put into an 'other' category
	   * @returns {Object} A map of frameworks running on host
	   */
	  getHostResourcesByFramework: function getHostResourcesByFramework(state) {
	    var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return state.frameworks.map(function (framework) {
	      return framework.tasks.concat(framework.executors);
	    }).reduce(function (memo, tasksList) {
	      return memo.concat(tasksList);
	    }, []).reduce(function (memo, element) {
	      if (memo[element.slave_id] == null) {
	        memo[element.slave_id] = {};
	      }
	
	      var frameworkKey = element.framework_id;
	      if (filter.includes(frameworkKey)) {
	        frameworkKey = "other";
	      }
	
	      var resources = element.resources;
	      if (memo[element.slave_id][frameworkKey] == null) {
	        memo[element.slave_id][frameworkKey] = _StructUtil2.default.copyRawObject(resources);
	      } else {
	        // Aggregates used resources from each executor
	        RESOURCE_KEYS.forEach(function (key) {
	          memo[element.slave_id][frameworkKey][key] += resources[key];
	        });
	      }
	
	      return memo;
	    }, {});
	  },
	  getTasksFromVirtualNetworkName: function getTasksFromVirtualNetworkName() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var overlayName = arguments[1];
	
	    var frameworks = state.frameworks || [];
	
	    return frameworks.reduce(function (memo, framework) {
	      var tasks = framework.tasks || [];
	
	      return memo.concat(tasks.filter(function (task) {
	        var appPath = "container.network_infos.0.name";
	        var podPath = "statuses.0.container_status.network_infos.0.name";
	
	        return _Util2.default.findNestedPropertyInObject(task, appPath) === overlayName || _Util2.default.findNestedPropertyInObject(task, podPath) === overlayName;
	      }));
	    }, []);
	  },
	
	
	  /**
	   * Return historical instances (killed, terminated, failed etc.) for the given
	   * pod by digging into the marathon state.
	   *
	   * @param {Object} state - The mesos state response
	   * @param {Pod} pod - The related pod
	   * @returns {Array} The array of historical instances
	   */
	  getPodHistoricalInstances: function getPodHistoricalInstances(state, pod) {
	    var frameworks = state.frameworks || [];
	    var marathonFramework = frameworks.find(function (framework) {
	      return framework.name === "marathon";
	    });
	
	    if (!marathonFramework) {
	      return [];
	    }
	
	    var instancesMap = marathonFramework.completed_tasks.reduce(function (memo, task) {
	      if (MesosStateUtil.isPodTaskId(task.id)) {
	        var _MesosStateUtil$decom = MesosStateUtil.decomposePodTaskId(task.id),
	            podID = _MesosStateUtil$decom.podID,
	            instanceID = _MesosStateUtil$decom.instanceID;
	
	        if (podID === pod.getMesosId()) {
	          var fullInstanceID = podID + ".instance-" + instanceID;
	          var containerArray = memo[fullInstanceID];
	          if (containerArray === undefined) {
	            containerArray = memo[fullInstanceID] = [];
	          }
	
	          // The last status can give us information about the time the
	          // container was last updated, so we need the latest status item
	          var lastStatus = task.statuses.reduce(function (memo, status) {
	            if (!memo || status.timestamp > memo.timestamp) {
	              return status;
	            }
	
	            return memo;
	          }, null);
	
	          // Add additional fields to the task structure in order to make it
	          // as close as possible to something a PodContainer will understand.
	          containerArray.push((0, _assign2.default)({
	            containerId: task.id,
	            status: task.state,
	            //
	            // NOTE: We are creating a Date object from this value, so we
	            //       should be OK with the timestamp
	            //
	            lastChanged: lastStatus.timestamp * 1000,
	            lastUpdated: lastStatus.timestamp * 1000
	          }, task));
	        }
	      }
	
	      return memo;
	    }, {});
	
	    // Try to compose actual PodInstance structures from the information we
	    // have so far. Obviously we don't have any details, but we can populate
	    // most of the UI-interesting fields by summarizing container details
	    return (0, _keys2.default)(instancesMap).map(function (instanceID) {
	      var containers = instancesMap[instanceID];
	      var summaryProperties = containers.reduce(function (memo, instance) {
	        var _instance$resources = instance.resources,
	            resources = _instance$resources === undefined ? {} : _instance$resources,
	            _instance$lastChanged = instance.lastChanged,
	            lastChanged = _instance$lastChanged === undefined ? 0 : _instance$lastChanged;
	
	
	        memo.resources.cpus += resources.cpus || 0;
	        memo.resources.mem += resources.mem || 0;
	        memo.resources.gpus += resources.gpus || 0;
	        memo.resources.disk += resources.disk || 0;
	
	        // TODO: Currently both lastChanged and lastUpdated are pointing to the
	        //       same timestamp. Is there any way to get more information?
	        if (lastChanged > memo.lastChanged) {
	          memo.lastChanged = lastChanged;
	          memo.lastUpdated = lastChanged;
	        }
	
	        return memo;
	      }, {
	        resources: { cpus: 0, mem: 0, gpus: 0, disk: 0 },
	        lastChanged: 0,
	        lastUpdated: 0
	      });
	
	      // Compose something as close as possible to what `PodInstance` understand
	      return (0, _assign2.default)({
	        id: instanceID,
	        status: _PodInstanceState2.default.TERMINAL,
	        containers: containers
	      }, summaryProperties);
	    });
	  },
	
	
	  /**
	   * @param {{frameworks:array, completed_frameworks:array}} state
	   * @param {{id:string, executor_id:string, framework_id:string}} task
	   * @param {string} path
	   * @returns {string} task path
	   */
	  getTaskPath: function getTaskPath(state, task) {
	    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	    var taskID = task.id,
	        frameworkID = task.framework_id,
	        executorID = task.executor_id;
	
	    var framework = MesosStateUtil.getFramework(state, frameworkID);
	    if (state == null || task == null || framework == null) {
	      return "";
	    }
	
	    var taskPath = "";
	    // Find matching executor or task to construct the task path
	    [].concat(framework.executors, framework.completed_executors).every(function (executor) {
	      if (executor.id === executorID || executor.id === taskID) {
	        // Use the executor task path construct if it's a "pod" / TaskGroup
	        // executor (type: DEFAULT), otherwise fallback to the default
	        // app/framework behavior.
	        if (executor.type === _ExecutorTypes2.default.DEFAULT) {
	          // For a detail documentation on how to construct the task path
	          // please see: https://reviews.apache.org/r/52376/
	          taskPath = executor.directory + "/tasks/" + taskID + "/" + path;
	
	          return false;
	        }
	
	        // Simply use the executors directory for "apps" and "frameworks",
	        // as well as any other executor
	        taskPath = executor.directory + "/" + path;
	
	        return false;
	      }
	
	      return true;
	    });
	
	    return taskPath;
	  },
	  getTaskContainerID: function getTaskContainerID(task) {
	    var container = _Util2.default.findNestedPropertyInObject(task, "statuses.0.container_status.container_id");
	
	    if (!container || !container.value) {
	      return null;
	    }
	
	    var containerIDs = [];
	    while (container) {
	      containerIDs.push(container.value);
	      container = container.parent;
	    }
	
	    return containerIDs.reverse().join(".");
	  },
	
	
	  /**
	   * Check if the given string looks like a pod task ID
	   *
	   * @param {String} taskID - The task ID to test
	   * @returns {Boolean} Returns true if the function passes the test
	   */
	  isPodTaskId: function isPodTaskId(taskID) {
	    return POD_TASK_REGEX.test(taskID);
	  }
	};
	
	module.exports = MesosStateUtil;

/***/ },
/* 1263 */
/***/ function(module, exports) {

	"use strict";
	
	var ExecutorTypes = {
	  DEFAULT: "DEFAULT"
	};
	
	module.exports = ExecutorTypes;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _ServiceImages = __webpack_require__(1081);
	
	var _ServiceImages2 = _interopRequireDefault(_ServiceImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(Task, _Item);
	
	  function Task() {
	    (0, _classCallCheck3.default)(this, Task);
	    return (0, _possibleConstructorReturn3.default)(this, (Task.__proto__ || (0, _getPrototypeOf2.default)(Task)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Task, [{
	    key: "getId",
	    value: function getId() {
	      return this.get("id") || "";
	    }
	  }, {
	    key: "getImages",
	    value: function getImages() {
	      return _ServiceImages2.default.NA_IMAGES;
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.get("name");
	    }
	  }]);
	  return Task;
	}(_Item3.default);

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _TimeScales = __webpack_require__(1266);
	
	var _TimeScales2 = _interopRequireDefault(_TimeScales);
	
	var _MesosSummaryUtil = __webpack_require__(1050);
	
	var _MesosSummaryUtil2 = _interopRequireDefault(_MesosSummaryUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _historyServiceOnline = true;
	
	function testHistoryServerResponse(response) {
	  // If response is a range, check the last element
	  var responseToTest = response;
	  if (Array.isArray(response)) {
	    responseToTest = response[response.length - 1];
	  }
	  // If the response is an empty object, that means something is whack
	  // Fall back to making requests to Mesos
	  // TODO (DCOS-7764): This should be improved to validate against a schema
	  if (!(0, _keys2.default)(responseToTest).length || !Array.isArray(responseToTest.frameworks) || !Array.isArray(responseToTest.slaves)) {
	    _historyServiceOnline = false;
	  }
	}
	
	function testHistoryOnline() {
	  _mesosphereSharedReactjs.RequestUtil.json({
	    url: _Config2.default.historyServer + "/dcos-history-service/history/last",
	    success: function success(response) {
	      _historyServiceOnline = true;
	      testHistoryServerResponse(response);
	    },
	    error: function error() {
	      setTimeout(testHistoryOnline, _Config2.default.testHistoryInterval);
	    }
	  });
	}
	
	function requestFromHistoryServer(resolve, reject) {
	  var timeScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "last";
	
	  var url = _Config2.default.historyServer + "/dcos-history-service/history/" + timeScale;
	  var successEventType = _ActionTypes.REQUEST_SUMMARY_SUCCESS;
	
	  if (timeScale === _TimeScales2.default.MINUTE) {
	    successEventType = _ActionTypes.REQUEST_SUMMARY_HISTORY_SUCCESS;
	  }
	
	  _mesosphereSharedReactjs.RequestUtil.json({
	    url: url,
	    success: function success(response) {
	      testHistoryServerResponse(response);
	      _AppDispatcher2.default.handleServerAction({
	        type: successEventType,
	        data: response
	      });
	      resolve();
	    },
	    error: function error() {
	      _historyServiceOnline = false;
	
	      setTimeout(testHistoryOnline, _Config2.default.testHistoryInterval);
	      // Immediately fall back on state-summary
	      requestFromMesos(resolve, reject);
	    },
	    hangingRequestCallback: function hangingRequestCallback() {
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_SUMMARY_HISTORY_ONGOING
	      });
	    }
	  });
	}
	
	function requestFromMesos(resolve, reject) {
	  _mesosphereSharedReactjs.RequestUtil.json({
	    url: _Config2.default.rootUrl + "/mesos/master/state-summary",
	    success: function success(response) {
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_SUMMARY_SUCCESS,
	        data: response
	      });
	      resolve();
	    },
	    error: function error(xhr) {
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_SUMMARY_ERROR,
	        data: xhr.message,
	        xhr: xhr
	      });
	      reject();
	    },
	    hangingRequestCallback: function hangingRequestCallback() {
	      _AppDispatcher2.default.handleServerAction({ type: _ActionTypes.REQUEST_SUMMARY_ONGOING });
	    }
	  });
	}
	
	var MesosSummaryActions = {
	  fetchSummary: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function (timeScale) {
	      var canAccessHistoryAPI = _PluginSDK.Hooks.applyFilter("hasCapability", false, "historyServiceAPI");
	
	      if (!_historyServiceOnline || !canAccessHistoryAPI) {
	        var canAccessMesosAPI = _PluginSDK.Hooks.applyFilter("hasCapability", false, "mesosAPI");
	        if (canAccessMesosAPI) {
	          requestFromMesos(resolve, reject);
	        } else {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_SUMMARY_SUCCESS,
	            data: _MesosSummaryUtil2.default.getEmptyState()
	          });
	        }
	      } else {
	        requestFromHistoryServer(resolve, reject, timeScale);
	      }
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount })
	};
	
	module.exports = MesosSummaryActions;

/***/ },
/* 1266 */
/***/ function(module, exports) {

	"use strict";
	
	var TimeScales = {
	  MINUTE: "minute",
	  HOUR: "hour",
	  DAY: "day"
	};
	
	module.exports = TimeScales;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Exports a higher-order component that checks if user is logged in using the
	 * AuthStore. If the user is logged in, the component will render.
	 * If the user is not logged in, the user will be redirected to the login page.
	 */
	module.exports = function (ComposedComponent) {
	  return function (_React$Component) {
	    (0, _inherits3.default)(Authenticated, _React$Component);
	
	    function Authenticated() {
	      (0, _classCallCheck3.default)(this, Authenticated);
	      return (0, _possibleConstructorReturn3.default)(this, (Authenticated.__proto__ || (0, _getPrototypeOf2.default)(Authenticated)).apply(this, arguments));
	    }
	
	    (0, _createClass3.default)(Authenticated, [{
	      key: "render",
	      value: function render() {
	        return _react2.default.createElement(ComposedComponent, this.props);
	      }
	    }], [{
	      key: "willTransitionTo",
	      value: function willTransitionTo(nextState, replace) {
	        if (!_AuthStore2.default.isLoggedIn()) {
	          _PluginSDK2.default.Hooks.doAction("redirectToLogin", nextState, replace);
	        }
	      }
	    }]);
	    return Authenticated;
	  }(_react2.default.Component);
	};

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ConfigActions = __webpack_require__(1269);
	
	var _ConfigActions2 = _interopRequireDefault(_ConfigActions);
	
	var _EventTypes = __webpack_require__(933);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(ConfigStore, _GetSetBaseStore);
	
	  function ConfigStore() {
	    (0, _classCallCheck3.default)(this, ConfigStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ConfigStore.__proto__ || (0, _getPrototypeOf2.default)(ConfigStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      ccid: {},
	      config: null
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.CONFIG_LOADED,
	        error: _EventTypes.CONFIG_ERROR,
	        ccidSuccess: _EventTypes.CLUSTER_CCID_SUCCESS,
	        ccidError: _EventTypes.CLUSTER_CCID_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        case _ActionTypes.REQUEST_CONFIG_SUCCESS:
	          _this.processConfigSuccess(action.data);
	          break;
	        case _ActionTypes.REQUEST_CONFIG_ERROR:
	          _this.emit(_EventTypes.CONFIG_ERROR);
	          break;
	        case _ActionTypes.REQUEST_CLUSTER_CCID_SUCCESS:
	          _this.processCCIDSuccess(action.data);
	          break;
	        case _ActionTypes.REQUEST_CLUSTER_CCID_ERROR:
	          _this.emit(_EventTypes.CLUSTER_CCID_ERROR);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ConfigStore, [{
	    key: "set",
	    value: function set(config) {
	      (0, _get3.default)(ConfigStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfigStore.prototype), "set", this).call(this, config);
	
	      // Dispatch new Store data
	      _PluginSDK2.default.dispatch({
	        type: _EventTypes.APP_STORE_CHANGE,
	        storeID: this.storeID,
	        data: this.getSet_data
	      });
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "processConfigSuccess",
	    value: function processConfigSuccess(config) {
	      this.set({ config: config });
	      this.emit(_EventTypes.CONFIG_LOADED);
	    }
	  }, {
	    key: "processCCIDSuccess",
	    value: function processCCIDSuccess(ccid) {
	      this.set({ ccid: ccid });
	      this.emit(_EventTypes.CLUSTER_CCID_SUCCESS);
	    }
	  }, {
	    key: "fetchConfig",
	    value: function fetchConfig() {
	      return _ConfigActions2.default.fetchConfig.apply(_ConfigActions2.default, arguments);
	    }
	  }, {
	    key: "fetchCCID",
	    value: function fetchCCID() {
	      return _ConfigActions2.default.fetchCCID.apply(_ConfigActions2.default, arguments);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "config";
	    }
	  }]);
	  return ConfigStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new ConfigStore();

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigActions = {
	  fetchConfig: function fetchConfig() {
	    if (global.APPLICATION_CONFIGURATION) {
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes2.default.REQUEST_CONFIG_SUCCESS,
	        data: JSON.parse(global.APPLICATION_CONFIGURATION)
	      });
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/dcos-metadata/ui-config.json",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_CONFIG_SUCCESS,
	          data: response
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_CONFIG_ERROR,
	          data: xhr.message,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchCCID: function fetchCCID() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/navstar/lashup/key",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_CLUSTER_CCID_SUCCESS,
	          data: response
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_CLUSTER_CCID_ERROR,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures || _Config2.default.useUIConfigFixtures) {
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.ConfigActions = {
	    fetchConfig: {
	      event: "success",
	      success: {
	        response: _Config2.default.uiConfigurationFixture
	      }
	    }
	  };
	
	  (0, _keys2.default)(global.actionTypes.ConfigActions).forEach(function (method) {
	    ConfigActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(ConfigActions, "ConfigActions", method);
	  });
	}
	
	module.exports = ConfigActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _OrganizationTab = __webpack_require__(1276);
	
	var _OrganizationTab2 = _interopRequireDefault(_OrganizationTab);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _UsersStore = __webpack_require__(1351);
	
	var _UsersStore2 = _interopRequireDefault(_UsersStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var METHODS_TO_BIND = ["onUsersStoreSuccess", "onUsersStoreError"];
	/* eslint-disable no-unused-vars */
	
	
	var UsersBreadcrumbs = function UsersBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Users" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/organization/users" },
	        "Users"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "users", breadcrumbs: crumbs });
	};
	
	var UsersPage = function (_mixin) {
	  (0, _inherits3.default)(UsersPage, _mixin);
	
	  function UsersPage() {
	    (0, _classCallCheck3.default)(this, UsersPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersPage.__proto__ || (0, _getPrototypeOf2.default)(UsersPage)).apply(this, arguments));
	
	    _this.store_listeners = _PluginSDK.Hooks.applyFilter("usersPageStoreListeners", [{ name: "users", events: ["success", "error"], suppressUpdate: true }]);
	
	    _this.state = {
	      usersStoreError: false,
	      usersStoreSuccess: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(UsersPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(UsersPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(UsersPage.prototype), "componentDidMount", this).call(this);
	      _UsersStore2.default.fetchUsers();
	    }
	  }, {
	    key: "onUsersChange",
	    value: function onUsersChange() {
	      _UsersStore2.default.fetchUsers();
	    }
	  }, {
	    key: "onUsersStoreSuccess",
	    value: function onUsersStoreSuccess() {
	      this.setState({
	        usersStoreError: false,
	        usersStoreSuccess: true
	      });
	    }
	  }, {
	    key: "onUsersStoreError",
	    value: function onUsersStoreError() {
	      this.setState({
	        usersStoreError: true,
	        usersStoreSuccess: false
	      });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange(searchString) {
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(UsersBreadcrumbs, null) }),
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "getContents",
	    value: function getContents() {
	      // We want to always render the portals (side panel and modal),
	      // so only this part is showing loading and error screen.
	      if (this.state.usersStoreError) {
	        return _react2.default.createElement(_RequestErrorMsg2.default, null);
	      }
	
	      if (!this.state.usersStoreSuccess) {
	        return this.getLoadingScreen();
	      }
	
	      var items = _UsersStore2.default.getUsers().getItems();
	
	      return _PluginSDK.Hooks.applyFilter("usersPageContent", _react2.default.createElement(_OrganizationTab2.default, {
	        key: "organization-tab",
	        items: items,
	        itemID: "uid",
	        itemName: "user"
	      }), this);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.getContents();
	    }
	  }]);
	  return UsersPage;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	UsersPage.propTypes = {
	  params: _react2.default.PropTypes.object
	};
	
	UsersPage.routeConfig = {
	  label: "Users",
	  matches: /^\/organization\/users/
	};
	
	module.exports = UsersPage;

/***/ },
/* 1271 */,
/* 1272 */,
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3.default)(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumb.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumb)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Breadcrumb, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          isCaret = _props.isCaret,
	          isIcon = _props.isIcon;
	
	
	      if (!children) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      var classes = (0, _classnames2.default)("breadcrumb", {
	        "breadcrumb--is-caret": isCaret,
	        "breadcrumb--is-icon": isIcon
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        children
	      );
	    }
	  }]);
	  return Breadcrumb;
	}(_react2.default.Component);
	
	Breadcrumb.defaultProps = {
	  isCaret: false,
	  isIcon: false
	};
	
	Breadcrumb.propTypes = {
	  isCaret: _react2.default.PropTypes.bool,
	  isIcon: _react2.default.PropTypes.bool,
	  title: _react2.default.PropTypes.string.isRequired
	};
	
	module.exports = Breadcrumb;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbTextContent = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbTextContent, _React$Component);
	
	  function BreadcrumbTextContent() {
	    (0, _classCallCheck3.default)(this, BreadcrumbTextContent);
	    return (0, _possibleConstructorReturn3.default)(this, (BreadcrumbTextContent.__proto__ || (0, _getPrototypeOf2.default)(BreadcrumbTextContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BreadcrumbTextContent, [{
	    key: "render",
	    value: function render() {
	      if (!this.props.children) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "breadcrumb__content breadcrumb__content--text" },
	        this.props.children
	      );
	    }
	  }]);
	  return BreadcrumbTextContent;
	}(_react2.default.Component);
	
	BreadcrumbTextContent.propTypes = {
	  title: _react2.default.PropTypes.string
	};
	
	module.exports = BreadcrumbTextContent;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _from = __webpack_require__(1018);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Example usage:
	 * <Loader type="ballSpinFadeLoader" />
	 */
	
	// Available types:
	var typeMap = {
	  ballBeat: { className: "ball-beat", divCount: 3 },
	  ballScale: { className: "ball-scale", divCount: 1 },
	  ballSpinFadeLoader: { className: "ball-spin-fade-loader", divCount: 8 },
	  lineSpinFadeLoader: { className: "line-spin-fade-loader", divCount: 8 }
	
	  /* Other available loaders: */
	  // ballClipRotate: {className: 'ball-clip-rotate', divCount: 1},
	  // ballClipRotateMultiple:
	  //   {className: 'ball-clip-rotate-multiple', divCount: 2},
	  // ballClipRotatePulse: {className: 'ball-clip-rotate-pulse', divCount: 2},
	  // ballGridBeat: {className: 'ball-grid-beat', divCount: 9},
	  // ballGridPulse: {className: 'ball-grid-pulse', divCount: 9},
	  // ballPulseRise: {className: 'ball-pulse-rise', divCount: 5},
	  // ballPulseSync: {className: 'ball-pulse-sync', divCount: 3},
	  // ballRotate: {className: 'ball-rotate', divCount: 1},
	  // ballScaleMultiple: {className: 'ball-scale-multiple', divCount: 3},
	  // ballScaleRandom: {className: 'ball-scale-random', divCount: 3},
	  // ballScaleRipple: {className: 'ball-scale-ripple', divCount: 1},
	  // ballScaleRippleMultiple:
	  //   {className: 'ball-scale-ripple-multiple', divCount: 3},
	  // ballTrianglePath: {className: 'ball-triangle-path', divCount: 3},
	  // ballZigZag: {className: 'ball-zig-zag', divCount: 2},
	  // ballZigZagDeflect: {className: 'ball-zig-zag-deflect', divCount: 2},
	  // cubeTransition: {className: 'cube-transition', divCount: 2},
	  // lineScale: {className: 'line-scale', divCount: 5},
	  // lineScaleParty: {className: 'line-scale-party', divCount: 4},
	  // lineScalePulseOut: {className: 'line-scale-pulse-out', divCount: 5},
	  // lineScalePulseOutRapid:
	  //   {className: 'line-scale-pulse-out-rapid', divCount: 5},
	  // pacman: {className: 'pacman', divCount: 5},
	  // semiCircleSpin: {className: 'semi-circle-spin', divCount: 1},
	  // triangleSkewSpin: {className: 'triangle-skew-spin', divCount: 1}
	};
	
	var Loader = function (_React$Component) {
	  (0, _inherits3.default)(Loader, _React$Component);
	
	  function Loader() {
	    (0, _classCallCheck3.default)(this, Loader);
	    return (0, _possibleConstructorReturn3.default)(this, (Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Loader, [{
	    key: "getDivs",
	    value: function getDivs(length) {
	      return (0, _from2.default)({ length: length }).map(function (_, index) {
	        return _react2.default.createElement("div", { className: "loader-element", key: index });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          innerClassName = _props.innerClassName,
	          flip = _props.flip,
	          size = _props.size,
	          type = _props.type;
	
	      var config = typeMap[type] || typeMap.ballScale;
	      var classes = (0, _dedupe2.default)("loader", className, {
	        "horizontal-center": !this.props.suppressHorizontalCenter
	      });
	
	      var innerClasses = (0, _dedupe2.default)(config.className, (0, _defineProperty3.default)({
	        "loader--small": size === "small",
	        "loader--mini": size === "mini"
	      }, "loader--flip-" + flip, flip != null), innerClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        _react2.default.createElement(
	          "div",
	          { className: innerClasses },
	          this.getDivs(config.divCount)
	        )
	      );
	    }
	  }]);
	  return Loader;
	}(_react2.default.Component);
	
	Loader.defaultProps = {
	  className: "",
	  innerClassName: "",
	  type: "ballScale",
	  suppressHorizontalCenter: false
	};
	
	var classPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	Loader.propTypes = {
	  suppressHorizontalCenter: _react2.default.PropTypes.bool,
	  className: classPropType,
	  flip: _react2.default.PropTypes.oneOf(["horizontal"]),
	  innerClassName: classPropType,
	  size: _react2.default.PropTypes.oneOf(["small", "mini"]),
	  type: _react2.default.PropTypes.oneOf(["ballBeat", "ballScale", "ballSpinFadeLoader", "lineSpinFadeLoader"])
	};
	
	module.exports = Loader;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _BulkOptions = __webpack_require__(1315);
	
	var _BulkOptions2 = _interopRequireDefault(_BulkOptions);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UsersActionsModal = __webpack_require__(1344);
	
	var _UsersActionsModal2 = _interopRequireDefault(_UsersActionsModal);
	
	var _UserFormModal = __webpack_require__(1349);
	
	var _UserFormModal2 = _interopRequireDefault(_UserFormModal);
	
	var _UsersStore = __webpack_require__(1351);
	
	var _UsersStore2 = _interopRequireDefault(_UsersStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var USERS_CHANGE_EVENTS = ["onUserStoreCreateSuccess", "onUserStoreDeleteSuccess"];
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["getTableRowOptions", "handleActionSelection", "handleActionSelectionClose", "handleCheckboxChange", "handleHeadingCheckboxChange", "handleNewUserClick", "handleNewUserClose", "handleSearchStringChange", "renderCheckbox", "renderFullName", "renderHeadingCheckbox", "renderUsername", "resetFilter"];
	
	var UsersBreadcrumbs = function UsersBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Users" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/organization/users" },
	        "Users"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "users", breadcrumbs: crumbs });
	};
	
	var OrganizationTab = function (_mixin) {
	  (0, _inherits3.default)(OrganizationTab, _mixin);
	
	  function OrganizationTab() {
	    (0, _classCallCheck3.default)(this, OrganizationTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OrganizationTab.__proto__ || (0, _getPrototypeOf2.default)(OrganizationTab)).call(this, arguments));
	
	    _this.store_listeners = [{
	      name: "user",
	      events: ["createSuccess", "deleteSuccess"],
	      suppressUpdate: true
	    }];
	
	    _this.state = {
	      checkableCount: 0,
	      checkedCount: 0,
	      openNewUserModal: false,
	      showActionDropdown: false,
	      searchString: "",
	      selectedAction: null,
	      usersStoreError: false,
	      usersStoreSuccess: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      this[method] = this[method].bind(this);
	    }, _this);
	
	    _PluginSDK.Hooks.applyFilter("organizationTabChangeEvents", USERS_CHANGE_EVENTS).forEach(function (event) {
	      _this[event] = _this.onUsersChange;
	    });
	
	    _this.internalStorage_update({ selectedIDSet: {} });
	    return _this;
	  }
	
	  (0, _createClass3.default)(OrganizationTab, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(OrganizationTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(OrganizationTab.prototype), "componentWillMount", this).call(this);
	      this.resetTablewideCheckboxTabulations();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(OrganizationTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(OrganizationTab.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	
	      if (nextProps.items.length !== this.props.items.length) {
	        this.resetTablewideCheckboxTabulations();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      (0, _get3.default)(OrganizationTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(OrganizationTab.prototype), "componentDidUpdate", this).apply(this, arguments);
	
	      if (prevState.searchString !== this.state.searchString || prevProps.items.length !== this.props.items.length) {
	        this.resetTablewideCheckboxTabulations();
	      }
	    }
	  }, {
	    key: "onUsersChange",
	    value: function onUsersChange() {
	      _UsersStore2.default.fetchUsers();
	    }
	  }, {
	    key: "handleActionSelection",
	    value: function handleActionSelection(dropdownItem) {
	      this.setState({
	        selectedAction: dropdownItem.id
	      });
	    }
	  }, {
	    key: "handleActionSelectionClose",
	    value: function handleActionSelectionClose() {
	      this.setState({
	        selectedAction: null
	      });
	      this.bulkCheck(false);
	    }
	  }, {
	    key: "handleCheckboxChange",
	    value: function handleCheckboxChange(prevCheckboxState, eventObject) {
	      var isChecked = eventObject.fieldValue;
	      var checkedCount = this.state.checkedCount + (isChecked || -1);
	      var selectedIDSet = this.internalStorage_get().selectedIDSet;
	
	      selectedIDSet[eventObject.fieldName] = isChecked;
	      this.internalStorage_update({ selectedIDSet: selectedIDSet });
	
	      this.setState({
	        checkedCount: checkedCount,
	        showActionDropdown: checkedCount > 0
	      });
	    }
	  }, {
	    key: "handleHeadingCheckboxChange",
	    value: function handleHeadingCheckboxChange(prevCheckboxState, eventObject) {
	      var isChecked = eventObject.fieldValue;
	      this.bulkCheck(isChecked);
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	      this.bulkCheck(false);
	    }
	  }, {
	    key: "handleNewUserClick",
	    value: function handleNewUserClick() {
	      this.setState({ openNewUserModal: true });
	    }
	  }, {
	    key: "handleNewUserClose",
	    value: function handleNewUserClose() {
	      this.setState({ openNewUserModal: false });
	    }
	  }, {
	    key: "renderFullName",
	    value: function renderFullName(prop, subject) {
	      return subject.get("description");
	    }
	  }, {
	    key: "renderUsername",
	    value: function renderUsername(prop, subject) {
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "column-small-12 column-large-12 column-x-large-12 text-overflow" },
	          subject.get("uid")
	        )
	      );
	    }
	  }, {
	    key: "renderCheckbox",
	    value: function renderCheckbox(prop, row) {
	      var rowID = row[this.props.itemID];
	      var remoteIDSet = this.internalStorage_get().remoteIDSet;
	      var _state = this.state,
	          checkableCount = _state.checkableCount,
	          checkedCount = _state.checkedCount;
	
	      var disabled = remoteIDSet[rowID] === true;
	      var checked = null;
	
	      if (disabled || checkedCount === 0) {
	        checked = false;
	      } else if (checkedCount === checkableCount) {
	        checked = true;
	      } else {
	        checked = this.internalStorage_get().selectedIDSet[rowID];
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Form, {
	        formGroupClass: "form-group flush-bottom",
	        definition: [{
	          checked: checked,
	          disabled: disabled,
	          value: checked,
	          fieldType: "checkbox",
	          labelClass: "form-row-element form-element-checkbox",
	          name: rowID,
	          showLabel: false
	        }],
	        onChange: this.handleCheckboxChange
	      });
	    }
	  }, {
	    key: "renderHeadingCheckbox",
	    value: function renderHeadingCheckbox() {
	      var checked = false;
	      var indeterminate = false;
	
	      switch (this.state.checkedCount) {
	        case 0:
	          checked = false;
	          break;
	        case this.state.checkableCount:
	          checked = true;
	          break;
	        default:
	          indeterminate = true;
	          break;
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Form, {
	        formGroupClass: "form-group flush-bottom",
	        definition: [{
	          checked: checked,
	          value: checked,
	          fieldType: "checkbox",
	          indeterminate: indeterminate,
	          labelClass: "form-row-element form-element-checkbox",
	          name: "headingCheckbox",
	          showLabel: false
	        }],
	        onChange: this.handleHeadingCheckboxChange
	      });
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "40px" } }),
	        _react2.default.createElement("col", null)
	      );
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)({
	        clickable: row == null // this is a header
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = this.getClassName;
	
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "selected",
	        render: this.renderCheckbox,
	        sortable: false,
	        heading: this.renderHeadingCheckbox
	      }, {
	        cacheCell: true,
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "uid",
	        render: this.renderUsername,
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction(this.props.itemID, function (item, prop) {
	          return item.get(prop);
	        }),
	        heading: _ResourceTableUtil2.default.renderHeading({ uid: "USERNAME" })
	      }];
	    }
	  }, {
	    key: "getActionDropdown",
	    value: function getActionDropdown(itemName) {
	      if (!this.state.showActionDropdown) {
	        return null;
	      }
	
	      var actionPhrases = _BulkOptions2.default[itemName];
	      var initialID = null;
	
	      // Get first Action to set as initially selected option in dropdown.
	      initialID = (0, _keys2.default)(actionPhrases)[0] || null;
	
	      var dropdownItems = this.getActionsDropdownItems(actionPhrases);
	      if (dropdownItems.length === 1) {
	        return _react2.default.createElement(
	          "button",
	          {
	            className: "button",
	            onClick: this.handleActionSelection.bind(this, dropdownItems[0])
	          },
	          dropdownItems[0].html
	        );
	      }
	
	      return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(_reactjsComponents.Dropdown, {
	          buttonClassName: "button dropdown-toggle",
	          dropdownMenuClassName: "dropdown-menu",
	          dropdownMenuListClassName: "dropdown-menu-list",
	          dropdownMenuListItemClassName: "clickable",
	          initialID: initialID,
	          items: dropdownItems,
	          onItemSelection: this.handleActionSelection,
	          scrollContainer: ".gm-scroll-view",
	          scrollContainerParentSelector: ".gm-prevented",
	          transition: true,
	          transitionName: "dropdown-menu",
	          wrapperClassName: "dropdown"
	        })
	      );
	    }
	  }, {
	    key: "getActionsDropdownItems",
	    value: function getActionsDropdownItems(actionPhrases) {
	      return (0, _keys2.default)(actionPhrases).map(function (action) {
	        return {
	          html: actionPhrases[action].dropdownOption,
	          id: action,
	          selectedHtml: "Actions"
	        };
	      });
	    }
	  }, {
	    key: "getCheckedItemObjects",
	    value: function getCheckedItemObjects(items, itemIDName) {
	      if (this.state.selectedAction) {
	        var checkboxStates = this.internalStorage_get().selectedIDSet;
	        var selectedItems = {};
	
	        (0, _keys2.default)(checkboxStates).forEach(function (id) {
	          if (checkboxStates[id] === true) {
	            selectedItems[id] = true;
	          }
	        });
	
	        return items.filter(function (item) {
	          var itemID = item[itemIDName];
	
	          return selectedItems[itemID] || false;
	        });
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: "getVisibleItems",
	    value: function getVisibleItems(items) {
	      var _this2 = this;
	
	      var searchString = this.state.searchString;
	
	      searchString = searchString.toLowerCase();
	
	      if (searchString !== "") {
	        return items.filter(function (item) {
	          var description = item.get("description").toLowerCase();
	          var id = item.get(_this2.props.itemID).toLowerCase();
	
	          return description.indexOf(searchString) > -1 || id.indexOf(searchString) > -1;
	        });
	      }
	
	      return items;
	    }
	  }, {
	    key: "getActionsModal",
	    value: function getActionsModal(action, items, itemID, itemName) {
	      if (action === null) {
	        return null;
	      }
	
	      var checkedItemObjects = this.getCheckedItemObjects(items, itemID) || [];
	
	      return _react2.default.createElement(_UsersActionsModal2.default, {
	        action: action,
	        actionText: _BulkOptions2.default[itemName][action],
	        bodyClass: "modal-content allow-overflow",
	        itemID: itemID,
	        itemType: itemName,
	        onClose: this.handleActionSelectionClose,
	        selectedItems: checkedItemObjects
	      });
	    }
	  }, {
	    key: "getTableRowOptions",
	    value: function getTableRowOptions(row) {
	      var selectedIDSet = this.internalStorage_get().selectedIDSet;
	      if (selectedIDSet[row[this.props.itemID]]) {
	        return { className: "selected" };
	      }
	
	      return {};
	    }
	  }, {
	    key: "bulkCheck",
	    value: function bulkCheck(isChecked) {
	      var checkedCount = 0;
	      var selectedIDSet = this.internalStorage_get().selectedIDSet;
	
	      (0, _keys2.default)(selectedIDSet).forEach(function (id) {
	        selectedIDSet[id] = isChecked;
	      });
	      this.internalStorage_update({ selectedIDSet: selectedIDSet });
	
	      if (isChecked) {
	        checkedCount = this.state.checkableCount;
	      }
	
	      this.setState({
	        checkedCount: checkedCount,
	        showActionDropdown: checkedCount > 0
	      });
	    }
	  }, {
	    key: "resetTablewideCheckboxTabulations",
	    value: function resetTablewideCheckboxTabulations() {
	      var _props = this.props,
	          items = _props.items,
	          itemID = _props.itemID;
	
	      items = this.getVisibleItems(items);
	      var selectedIDSet = {};
	      var remoteIDSet = {};
	      var checkableCount = 0;
	
	      // Initializing hash of items' IDs and corresponding checkbox state.
	      items.forEach(function (item) {
	        var id = item.get(itemID);
	        checkableCount += 1;
	        selectedIDSet[id] = false;
	      });
	
	      this.internalStorage_update({ selectedIDSet: selectedIDSet, remoteIDSet: remoteIDSet });
	      this.setState({ checkableCount: checkableCount });
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      this.setState({ searchString: "" });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          items = _props2.items,
	          itemID = _props2.itemID,
	          itemName = _props2.itemName;
	
	      var state = this.state;
	      var action = state.selectedAction;
	      var capitalizedItemName = _StringUtil2.default.capitalize(itemName);
	      var visibleItems = this.getVisibleItems(items);
	      var actionDropdown = this.getActionDropdown(itemName);
	      var actionsModal = this.getActionsModal(action, items, itemID, itemName);
	      var sortProp = itemID;
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(UsersBreadcrumbs, null),
	          addButton: {
	            onItemSelect: this.handleNewUserClick,
	            label: "New " + capitalizedItemName
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "flex-container-col" },
	          _react2.default.createElement(
	            "div",
	            { className: itemName + "s-table-header" },
	            _react2.default.createElement(_FilterHeadline2.default, {
	              onReset: this.resetFilter,
	              name: capitalizedItemName,
	              currentLength: visibleItems.length,
	              totalLength: items.length
	            }),
	            _react2.default.createElement(
	              _FilterBar2.default,
	              null,
	              _react2.default.createElement(_FilterInputText2.default, {
	                className: "flush-bottom",
	                searchString: this.state.searchString,
	                handleFilterChange: this.handleSearchStringChange
	              }),
	              actionDropdown,
	              actionsModal
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "page-body-content-fill flex-grow flex-container-col" },
	            _react2.default.createElement(_reactjsComponents.Table, {
	              buildRowOptions: this.getTableRowOptions,
	              className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	              columns: this.getColumns(),
	              colGroup: this.getColGroup(),
	              containerSelector: ".gm-scroll-view",
	              data: visibleItems,
	              itemHeight: _TableUtil2.default.getRowHeight(),
	              sortBy: { prop: sortProp, order: "asc" }
	            })
	          )
	        ),
	        _react2.default.createElement(_UserFormModal2.default, {
	          open: this.state.openNewUserModal,
	          onClose: this.handleNewUserClose
	        })
	      );
	    }
	  }]);
	  return OrganizationTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _InternalStorageMixin2.default));
	
	OrganizationTab.propTypes = {
	  items: _react2.default.PropTypes.array.isRequired,
	  itemID: _react2.default.PropTypes.string.isRequired,
	  itemName: _react2.default.PropTypes.string.isRequired
	};
	
	module.exports = OrganizationTab;

/***/ },
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var BulkOptions = {
	  user: {
	    delete: {
	      dropdownOption: _react2.default.createElement(
	        "span",
	        { className: "text-danger" },
	        _StringUtil2.default.capitalize(_UserActions2.default.DELETE)
	      ),
	      title: "Are you sure?",
	      actionPhrase: "will be " + _UserActions2.default.DELETED
	    }
	  }
	}; /* eslint-disable no-unused-vars */
	
	
	module.exports = BulkOptions;

/***/ },
/* 1316 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  DELETE: "delete",
	  DELETED: "deleted",
	  DELETING: "deleting"
	};

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterBar = function (_React$Component) {
	  (0, _inherits3.default)(FilterBar, _React$Component);
	
	  function FilterBar() {
	    (0, _classCallCheck3.default)(this, FilterBar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterBar.__proto__ || (0, _getPrototypeOf2.default)(FilterBar)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FilterBar, [{
	    key: "getFilterBarLeft",
	    value: function getFilterBarLeft(filterItems, rightAlignCount) {
	      if (filterItems.length === rightAlignCount) {
	        return null;
	      }
	
	      if (rightAlignCount > 0) {
	        filterItems = filterItems.slice(0, filterItems.length - rightAlignCount);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: this.props.leftChildrenClass },
	        this.getFilterItems(filterItems)
	      );
	    }
	  }, {
	    key: "getFilterBarRight",
	    value: function getFilterBarRight(filterItems, rightAlignCount) {
	      if (rightAlignCount === 0) {
	        return null;
	      } else {
	        filterItems = filterItems.slice(rightAlignCount * -1);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: this.props.rightChildrenClass },
	        this.getFilterItems(filterItems)
	      );
	    }
	  }, {
	    key: "getFilterItems",
	    value: function getFilterItems(filterItemArray) {
	      return filterItemArray.map(function (item, index) {
	        return _react2.default.createElement(
	          "div",
	          { className: "filter-bar-item", key: index },
	          item
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          rightAlignLastNChildren = _props.rightAlignLastNChildren;
	
	      var filterItems = _react2.default.Children.toArray(this.props.children);
	
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        this.getFilterBarLeft(filterItems, rightAlignLastNChildren),
	        this.getFilterBarRight(filterItems, rightAlignLastNChildren)
	      );
	    }
	  }]);
	  return FilterBar;
	}(_react2.default.Component);
	
	FilterBar.propTypes = {
	  className: _react2.default.PropTypes.string,
	  rightAlignLastNChildren: _react2.default.PropTypes.number,
	  leftChildrenClass: _react2.default.PropTypes.string,
	  rightChildrenClass: _react2.default.PropTypes.string
	};
	
	FilterBar.defaultProps = {
	  className: "filter-bar",
	  leftChildrenClass: "filter-bar-left",
	  rightAlignLastNChildren: 0,
	  rightChildrenClass: "filter-bar-right"
	};
	
	module.exports = FilterBar;

/***/ },
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleReset"];
	
	var FilterHeadline = function (_React$Component) {
	  (0, _inherits3.default)(FilterHeadline, _React$Component);
	
	  function FilterHeadline() {
	    (0, _classCallCheck3.default)(this, FilterHeadline);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterHeadline.__proto__ || (0, _getPrototypeOf2.default)(FilterHeadline)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FilterHeadline, [{
	    key: "handleReset",
	    value: function handleReset(e) {
	      e.preventDefault();
	      this.props.onReset();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          currentLength = _props.currentLength,
	          inverseStyle = _props.inverseStyle,
	          isFiltering = _props.isFiltering,
	          name = _props.name,
	          totalLength = _props.totalLength;
	
	      var hideFilteredClasses = isFiltering == null && currentLength === totalLength || isFiltering != null && !isFiltering;
	      name = _StringUtil2.default.pluralize(name, totalLength);
	
	      var filteredClassSet = (0, _classnames2.default)("flush", {
	        inverse: inverseStyle,
	        hidden: hideFilteredClasses
	      });
	
	      var unfilteredClassSet = (0, _classnames2.default)("flush", {
	        inverse: inverseStyle,
	        hidden: !hideFilteredClasses
	      });
	
	      var anchorClassSet = (0, _classnames2.default)("clickable flush-top", {
	        inverse: inverseStyle,
	        hidden: hideFilteredClasses
	      });
	
	      var listClassSet = (0, _classnames2.default)("filter-headline list list-unstyled list-inline h4 flush-left flush-top", {
	        inverse: inverseStyle
	      }, className);
	
	      return _react2.default.createElement(
	        "ul",
	        { className: listClassSet },
	        _react2.default.createElement(
	          "li",
	          { className: filteredClassSet },
	          "Showing ",
	          currentLength,
	          " of ",
	          totalLength,
	          " ",
	          name
	        ),
	        _react2.default.createElement(
	          "li",
	          { className: anchorClassSet, onClick: this.handleReset },
	          _react2.default.createElement(
	            "a",
	            { className: "small flush" },
	            "(Clear)"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          { className: unfilteredClassSet },
	          totalLength,
	          " ",
	          name
	        )
	      );
	    }
	  }]);
	  return FilterHeadline;
	}(_react2.default.Component);
	
	FilterHeadline.defaultProps = {
	  inverseStyle: false
	};
	
	FilterHeadline.propTypes = {
	  className: _react.PropTypes.string,
	  currentLength: _react.PropTypes.number.isRequired,
	  inverseStyle: _react.PropTypes.bool,
	  // Optional prop used to force the "Clear" button to show even when n of n
	  // items are currently displayed.
	  isFiltering: _react.PropTypes.bool,
	  name: _react.PropTypes.string.isRequired,
	  onReset: _react.PropTypes.func.isRequired,
	  totalLength: _react.PropTypes.number.isRequired
	};
	
	module.exports = FilterHeadline;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ServiceFilterTypes = __webpack_require__(1323);
	
	var _ServiceFilterTypes2 = _interopRequireDefault(_ServiceFilterTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleBlur", "handleFocus", "handleChange", "handleInputClear"];
	
	var FilterInputText = function (_React$Component) {
	  (0, _inherits3.default)(FilterInputText, _React$Component);
	
	  function FilterInputText() {
	    (0, _classCallCheck3.default)(this, FilterInputText);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterInputText.__proto__ || (0, _getPrototypeOf2.default)(FilterInputText)).apply(this, arguments));
	
	    _this.state = {
	      focus: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FilterInputText, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var focus = this.state.focus;
	
	
	      if (prevState.focus !== focus && focus && this.inputField) {
	        this.inputField.focus();
	      }
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(event) {
	      var target = event.target;
	
	      // Make sure to never emit falsy values
	
	      var value = target.value || "";
	      this.props.handleFilterChange(value, _ServiceFilterTypes2.default.TEXT);
	    }
	  }, {
	    key: "handleInputClear",
	    value: function handleInputClear() {
	      this.props.handleFilterChange("", _ServiceFilterTypes2.default.TEXT);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        focus: false
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.setState({
	        focus: true
	      });
	    }
	  }, {
	    key: "getInputField",
	    value: function getInputField() {
	      var _this2 = this;
	
	      var _props = this.props,
	          inverseStyle = _props.inverseStyle,
	          placeholder = _props.placeholder,
	          searchString = _props.searchString;
	
	
	      var inputClasses = (0, _classnames2.default)({
	        "form-control filter-input-text": true,
	        "form-control-inverse": inverseStyle
	      });
	
	      return _react2.default.createElement("input", {
	        className: inputClasses,
	        placeholder: placeholder,
	        onChange: this.handleChange,
	        ref: function ref(_ref) {
	          return _this2.inputField = _ref;
	        },
	        type: "text",
	        value: searchString
	      });
	    }
	  }, {
	    key: "getClearIcon",
	    value: function getClearIcon() {
	      if (!this.props.searchString) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          inverseStyle = _props2.inverseStyle,
	          sideText = _props2.sideText;
	
	      var color = "white";
	
	      if (!inverseStyle) {
	        color = "purple";
	      }
	
	      var iconClassNames = (0, _classnames2.default)("clickable", {
	        "icon-margin-left": !!sideText
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: "form-control-group-add-on" },
	        sideText,
	        _react2.default.createElement(
	          "a",
	          { onClick: this.handleInputClear },
	          _react2.default.createElement(_Icon2.default, {
	            id: "circle-close",
	            size: "mini",
	            className: iconClassNames,
	            color: color
	          })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          inputContainerClass = _props3.inputContainerClass,
	          inverseStyle = _props3.inverseStyle;
	      var focus = this.state.focus;
	
	
	      var iconColor = "grey";
	      var iconSearchClasses = (0, _classnames2.default)({
	        active: focus
	      });
	
	      if (!inverseStyle && focus) {
	        iconColor = "purple";
	      }
	
	      var inputContainerClasses = (0, _classnames2.default)({
	        focus: focus,
	        "form-control form-control-group filter-input-text-group": true,
	        "form-control-inverse": inverseStyle
	      }, inputContainerClass);
	
	      var formGroupClasses = (0, _classnames2.default)("form-group", className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: formGroupClasses },
	        _react2.default.createElement(
	          "div",
	          {
	            className: inputContainerClasses,
	            onClick: this.handleFocus,
	            onBlur: this.handleBlur
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "form-control-group-add-on form-control-group-add-on-prepend" },
	            _react2.default.createElement(_Icon2.default, {
	              id: "search",
	              size: "mini",
	              className: iconSearchClasses,
	              color: iconColor
	            })
	          ),
	          this.getInputField(),
	          this.getClearIcon()
	        )
	      );
	    }
	  }]);
	  return FilterInputText;
	}(_react2.default.Component);
	
	FilterInputText.defaultProps = {
	  inverseStyle: false,
	  placeholder: "Filter",
	  searchString: "",
	  sideText: null
	};
	
	FilterInputText.propTypes = {
	  handleFilterChange: _react.PropTypes.func.isRequired,
	  inverseStyle: _react.PropTypes.bool,
	  placeholder: _react.PropTypes.string,
	  searchString: _react.PropTypes.string,
	  sideText: _react.PropTypes.node
	};
	
	module.exports = FilterInputText;

/***/ },
/* 1323 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceFilterTypes = {
	  HEALTH: "filterHealth",
	  OTHER: "filterOther",
	  STATUS: "filterStatus",
	  LABELS: "filterLabels",
	  TEXT: "searchString"
	};
	
	module.exports = ServiceFilterTypes;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin to store component data that isn't part of properties or
	 * part of state.
	 */
	
	var InternalStorageMixin = {
	  internalStorage_data: {},
	
	  internalStorage_get: function internalStorage_get() {
	    return this.internalStorage_data;
	  },
	  internalStorage_update: function internalStorage_update(diff) {
	    if ((0, _typeof3.default)(this.internalStorage_data) !== "object") {
	      throw new Error("Can only update internalStorage_data if that is of type Object or Array.");
	    }
	
	    this.internalStorage_data = (0, _assign2.default)(this.internalStorage_get(), diff);
	  },
	  internalStorage_set: function internalStorage_set(data) {
	    this.internalStorage_data = data;
	  }
	};
	
	module.exports = InternalStorageMixin;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _PageHeader = __webpack_require__(1326);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _FluidGeminiScrollbar = __webpack_require__(1339);
	
	var _FluidGeminiScrollbar2 = _interopRequireDefault(_FluidGeminiScrollbar);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	var _SidebarToggle = __webpack_require__(1333);
	
	var _SidebarToggle2 = _interopRequireDefault(_SidebarToggle);
	
	var _TemplateUtil = __webpack_require__(1341);
	
	var _TemplateUtil2 = _interopRequireDefault(_TemplateUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function PageHeader(_ref) {
	  var actions = _ref.actions,
	      addButton = _ref.addButton,
	      breadcrumbs = _ref.breadcrumbs,
	      supplementalContent = _ref.supplementalContent,
	      tabs = _ref.tabs;
	
	  return _react2.default.createElement(_PageHeader2.default, {
	    actions: actions,
	    addButton: addButton,
	    breadcrumbs: breadcrumbs,
	    supplementalContent: supplementalContent,
	    tabs: tabs
	  });
	};
	
	_TemplateUtil2.default.defineChildren(PageHeader, {
	  Breadcrumbs: _PageHeader2.default.Breadcrumbs,
	  Actions: _PageHeader2.default.Actions,
	  Tabs: _PageHeader2.default.Actions
	});
	
	PageHeader.defaultProps = {
	  actions: [],
	  tabs: []
	};
	
	PageHeader.propTypes = {
	  actions: _react2.default.PropTypes.array,
	  addButton: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object), _react2.default.PropTypes.object]),
	  breadcrumbs: _react2.default.PropTypes.node,
	  supplementalContent: _react2.default.PropTypes.node,
	  tabs: _react2.default.PropTypes.array
	};
	
	var Page = _react2.default.createClass({
	  displayName: "Page",
	
	  mixins: [_InternalStorageMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  propTypes: {
	    className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	    dontScroll: _react2.default.PropTypes.bool,
	    navigation: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	    title: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string])
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.store_listeners = [{
	      name: "sidebar",
	      events: ["widthChange"]
	    }];
	  },
	  componentDidMount: function componentDidMount() {
	    this.internalStorage_set({
	      rendered: true
	    });
	    this.forceUpdate();
	  },
	  onSidebarStoreWidthChange: function onSidebarStoreWidthChange() {
	    _ScrollbarUtil2.default.updateWithRef(this.refs.gemini);
	  },
	  getChildren: function getChildren() {
	    var data = this.internalStorage_get();
	    if (data.rendered === true) {
	      // Avoid rendering template children twice
	      return _TemplateUtil2.default.filterTemplateChildren(this.constructor, this.props.children);
	    }
	
	    return null;
	  },
	  getNavigation: function getNavigation(navigation) {
	    if (!navigation) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "page-header-navigation" },
	      navigation
	    );
	  },
	  getPageHeader: function getPageHeader() {
	    return _TemplateUtil2.default.getChildOfType(this.props.children, this.constructor.Header);
	  },
	  getTitle: function getTitle(title) {
	    if (!title) {
	      return null;
	    }
	
	    if (_react2.default.isValidElement(title)) {
	      return title;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "page-header-title-container" },
	      _react2.default.createElement(_SidebarToggle2.default, null),
	      _react2.default.createElement(
	        "h1",
	        { className: "page-header-title flush" },
	        title
	      )
	    );
	  },
	  getContent: function getContent() {
	    var dontScroll = this.props.dontScroll;
	
	    var contentClassSet = (0, _dedupe2.default)("page-body-content pod pod-tall flex", "flex-direction-top-to-bottom flex-item-grow-1", {
	      "flex-item-shrink-1": dontScroll
	    });
	
	    var content = _react2.default.createElement(
	      "div",
	      { className: contentClassSet },
	      this.getChildren()
	    );
	
	    if (dontScroll) {
	      return content;
	    }
	
	    return _react2.default.createElement(
	      _FluidGeminiScrollbar2.default,
	      {
	        autoshow: true,
	        className: "page-body flex flex-direction-top-to-bottom flex-direction-left-to-right-screen-large flex-item-grow-1 flex-item-shrink-1 gm-scrollbar-container-flex",
	        ref: "gemini"
	      },
	      content
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        navigation = _props.navigation,
	        dontScroll = _props.dontScroll,
	        title = _props.title;
	
	
	    var classSet = (0, _dedupe2.default)("page flex flex-direction-top-to-bottom flex-item-grow-1", {
	      "flex-item-shrink-1": dontScroll
	    }, className);
	
	    return _react2.default.createElement(
	      "div",
	      { className: classSet },
	      this.getPageHeader(title, navigation),
	      this.getContent()
	    );
	  }
	});
	
	_TemplateUtil2.default.defineChildren(Page, { Header: PageHeader });
	
	module.exports = Page;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageHeaderActions = __webpack_require__(1327);
	
	var _PageHeaderActions2 = _interopRequireDefault(_PageHeaderActions);
	
	var _PageHeaderBreadcrumbs = __webpack_require__(1329);
	
	var _PageHeaderBreadcrumbs2 = _interopRequireDefault(_PageHeaderBreadcrumbs);
	
	var _PageHeaderTabs = __webpack_require__(1331);
	
	var _PageHeaderTabs2 = _interopRequireDefault(_PageHeaderTabs);
	
	var _SidebarToggle = __webpack_require__(1333);
	
	var _SidebarToggle2 = _interopRequireDefault(_SidebarToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (PageHeader.__proto__ || (0, _getPrototypeOf2.default)(PageHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PageHeader, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          addButton = _props.addButton,
	          breadcrumbs = _props.breadcrumbs,
	          className = _props.className,
	          innerClassName = _props.innerClassName,
	          primaryContentClassName = _props.primaryContentClassName,
	          secondaryContentDetail = _props.secondaryContentDetail,
	          secondaryContentClassName = _props.secondaryContentClassName,
	          supplementalContent = _props.supplementalContent,
	          tabs = _props.tabs;
	
	
	      var classes = (0, _dedupe2.default)("page-header", className);
	      var innerClasses = (0, _dedupe2.default)("page-header-inner pod", innerClassName);
	      var primaryContentClasses = (0, _dedupe2.default)("page-header-content-section page-header-content-section-primary", primaryContentClassName);
	      var secondaryContentClasses = (0, _dedupe2.default)("page-header-content-section page-header-content-section-secondary", secondaryContentClassName);
	      var secondaryContentDetailElement = null;
	
	      if (secondaryContentDetail) {
	        secondaryContentDetailElement = _react2.default.createElement(
	          "div",
	          { className: "page-header-content-section-secondary-detail" },
	          secondaryContentDetail
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        _react2.default.createElement(
	          "div",
	          { className: innerClasses },
	          _react2.default.createElement(
	            "div",
	            { className: primaryContentClasses },
	            _react2.default.createElement(_SidebarToggle2.default, null),
	            breadcrumbs,
	            _react2.default.createElement(_PageHeaderActions2.default, {
	              actions: actions,
	              addButton: addButton,
	              supplementalContent: supplementalContent
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: secondaryContentClasses },
	            _react2.default.createElement(_PageHeaderTabs2.default, { tabs: tabs }),
	            secondaryContentDetailElement
	          )
	        )
	      );
	    }
	  }]);
	  return PageHeader;
	}(_react2.default.Component);
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	PageHeader.defaultProps = {
	  actions: [],
	  tabs: []
	};
	
	PageHeader.propTypes = {
	  addButton: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object), _react2.default.PropTypes.object]),
	  actions: _react2.default.PropTypes.array,
	  breadcrumbs: _react2.default.PropTypes.node.isRequired,
	  className: classProps,
	  innerClassName: classProps,
	  primaryContentClassName: classProps,
	  secondaryContentClassName: classProps,
	  secondaryContentDetail: _react2.default.PropTypes.node,
	  supplementalContent: _react2.default.PropTypes.node,
	  tabs: _react2.default.PropTypes.array
	};
	
	PageHeader.Breadcrumbs = _PageHeaderBreadcrumbs2.default;
	PageHeader.Actions = _PageHeaderActions2.default;
	PageHeader.Tabs = _PageHeaderTabs2.default;
	
	module.exports = PageHeader;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PageHeaderActionsMenu = __webpack_require__(1328);
	
	var _PageHeaderActionsMenu2 = _interopRequireDefault(_PageHeaderActionsMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDropdownAction = function getDropdownAction(action, index) {
	  if (_react2.default.isValidElement(action)) {
	    return action;
	  }
	
	  var className = action.className,
	      label = action.label,
	      onItemSelect = action.onItemSelect;
	
	  var itemClasses = (0, _dedupe2.default)(className);
	
	  return _react2.default.createElement(
	    "span",
	    { className: itemClasses, onItemSelect: onItemSelect, key: index },
	    label
	  );
	};
	
	var PageHeaderActions = function (_React$Component) {
	  (0, _inherits3.default)(PageHeaderActions, _React$Component);
	
	  function PageHeaderActions() {
	    (0, _classCallCheck3.default)(this, PageHeaderActions);
	    return (0, _possibleConstructorReturn3.default)(this, (PageHeaderActions.__proto__ || (0, _getPrototypeOf2.default)(PageHeaderActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PageHeaderActions, [{
	    key: "renderActionsMenu",
	    value: function renderActionsMenu() {
	      var actions = this.props.actions;
	
	
	      if (actions.length > 0) {
	        var dropdownElements = actions.map(getDropdownAction);
	
	        return _react2.default.createElement(
	          _PageHeaderActionsMenu2.default,
	          null,
	          dropdownElements
	        );
	      }
	    }
	  }, {
	    key: "renderAddButton",
	    value: function renderAddButton() {
	      var addButton = this.props.addButton;
	
	
	      if (Array.isArray(addButton) && addButton.length > 0) {
	        var dropdownElements = addButton.map(getDropdownAction);
	
	        return _react2.default.createElement(
	          _PageHeaderActionsMenu2.default,
	          { iconID: "plus" },
	          dropdownElements
	        );
	      }
	
	      if (addButton != null) {
	        var label = addButton.label,
	            onItemSelect = addButton.onItemSelect,
	            className = addButton.className;
	
	        var buttonClasses = (0, _dedupe2.default)("button button-link button-narrow", className);
	
	        var button = _react2.default.createElement(
	          "button",
	          { className: buttonClasses, onClick: onItemSelect },
	          _react2.default.createElement(_Icon2.default, { id: "plus", size: "mini" })
	        );
	
	        if (label != null) {
	          return _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            { content: label },
	            button
	          );
	        }
	
	        return button;
	      }
	    }
	  }, {
	    key: "renderSupplementalContent",
	    value: function renderSupplementalContent() {
	      var supplementalContent = this.props.supplementalContent;
	
	
	      if (supplementalContent == null) {
	        return null;
	      }
	
	      return supplementalContent;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "page-header-actions" },
	        this.renderSupplementalContent(),
	        _react2.default.createElement(
	          "div",
	          { className: "button-collection-flush-bottom" },
	          this.renderAddButton(),
	          this.renderActionsMenu()
	        )
	      );
	    }
	  }]);
	  return PageHeaderActions;
	}(_react2.default.Component);
	
	PageHeaderActions.defaultProps = {
	  actions: []
	};
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	var menuActionsProps = _react2.default.PropTypes.shape({
	  className: classProps,
	  onItemSelect: _react2.default.PropTypes.func.isRequired,
	  label: _react2.default.PropTypes.node.isRequired
	});
	
	PageHeaderActions.propTypes = {
	  addButton: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(menuActionsProps), menuActionsProps]),
	  actions: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.node, menuActionsProps])),
	  supplementalContent: _react2.default.PropTypes.node
	};
	
	module.exports = PageHeaderActions;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getMenuItems = function getMenuItems(children, iconID) {
	  return [{
	    className: "hidden",
	    html: _react2.default.createElement(_Icon2.default, { id: iconID, size: "mini" }),
	    id: "trigger"
	  }].concat((0, _toConsumableArray3.default)(_react2.default.Children.map(children, getDropdownItemFromComponent)));
	};
	
	var handleItemSelection = function handleItemSelection(item) {
	  if (item.onItemSelect) {
	    item.onItemSelect();
	  }
	};
	
	var getDropdownItemFromComponent = function getDropdownItemFromComponent(child, index) {
	  return {
	    onItemSelect: child.props.onItemSelect,
	    html: child,
	    id: index
	  };
	};
	
	var PageHeaderActionsMenu = function PageHeaderActionsMenu(_ref) {
	  var anchorRight = _ref.anchorRight,
	      children = _ref.children,
	      iconID = _ref.iconID;
	
	  return _react2.default.createElement(_reactjsComponents.Dropdown, {
	    anchorRight: anchorRight,
	    buttonClassName: "button button-link button-narrow",
	    items: getMenuItems(children, iconID),
	    onItemSelection: handleItemSelection,
	    persistentID: "trigger",
	    transition: true,
	    dropdownMenuClassName: "dropdown-menu",
	    dropdownMenuListClassName: "dropdown-menu-list",
	    wrapperClassName: "dropdown"
	  });
	};
	
	PageHeaderActionsMenu.defaultProps = {
	  anchorRight: true,
	  iconID: "ellipsis-vertical"
	};
	
	PageHeaderActionsMenu.propTypes = {
	  // anchorRight gets passed to Dropdown. It's truthy here unlike in the Dropdown.
	  anchorRight: _react2.default.PropTypes.bool,
	  children: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    props: _react2.default.PropTypes.shape({
	      onItemSelect: _react2.default.PropTypes.func
	    })
	  })),
	  iconID: _react2.default.PropTypes.string
	};
	
	module.exports = PageHeaderActionsMenu;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbCaret = __webpack_require__(1330);
	
	var _BreadcrumbCaret2 = _interopRequireDefault(_BreadcrumbCaret);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeaderBreadcrumbs = function (_React$Component) {
	  (0, _inherits3.default)(PageHeaderBreadcrumbs, _React$Component);
	
	  function PageHeaderBreadcrumbs() {
	    (0, _classCallCheck3.default)(this, PageHeaderBreadcrumbs);
	    return (0, _possibleConstructorReturn3.default)(this, (PageHeaderBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(PageHeaderBreadcrumbs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PageHeaderBreadcrumbs, [{
	    key: "getCaret",
	    value: function getCaret(key) {
	      return _react2.default.createElement(_BreadcrumbCaret2.default, { key: "caret-" + key });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          breadcrumbs = _props.breadcrumbs,
	          iconID = _props.iconID,
	          iconRoute = _props.iconRoute;
	
	      var breadcrumbCount = breadcrumbs.length;
	      var sectionIcon = _react2.default.createElement(
	        _Breadcrumb2.default,
	        { key: -1, isIcon: true, title: "Section Icon" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: iconRoute },
	          _react2.default.createElement(_Icon2.default, { family: "product", id: iconID, size: "small" })
	        )
	      );
	      var shouldTruncateBreadcrumbs = breadcrumbCount > 3;
	
	      var breadcrumbElements = breadcrumbs.reduce(function (memo, breadcrumb, index) {
	        if (index === 0) {
	          memo.push(_this2.getCaret("first-caret"));
	        }
	
	        if (shouldTruncateBreadcrumbs && index === breadcrumbCount - 3) {
	          memo.push(_react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              content: breadcrumb.props.title,
	              key: "breadcrumb-ellipsis",
	              wrapperClassName: "breadcrumb breadcrumb--force-ellipsis"
	            },
	            breadcrumb
	          ), _this2.getCaret(index));
	        }
	
	        if (shouldTruncateBreadcrumbs && index < breadcrumbCount - 2) {
	          return memo;
	        }
	
	        memo.push(_react2.default.cloneElement(breadcrumb, { key: index }));
	
	        if (index !== breadcrumbs.length - 1) {
	          memo.push(_this2.getCaret(index));
	        }
	
	        return memo;
	      }, [sectionIcon]);
	
	      var breadcrumbClasses = (0, _classnames2.default)("breadcrumbs", {
	        "breadcrumbs--is-truncated": shouldTruncateBreadcrumbs
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: breadcrumbClasses },
	        breadcrumbElements
	      );
	    }
	  }]);
	  return PageHeaderBreadcrumbs;
	}(_react2.default.Component);
	
	PageHeaderBreadcrumbs.propTypes = {
	  iconID: _react2.default.PropTypes.string.isRequired,
	  breadcrumbs: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node).isRequired
	};
	
	module.exports = PageHeaderBreadcrumbs;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BreadcrumbCaret() {
	  return _react2.default.createElement(
	    _Breadcrumb2.default,
	    { isCaret: true, title: "Caret" },
	    _react2.default.createElement(_Icon2.default, { color: "light-grey", id: "caret-right", size: "mini" })
	  );
	}
	
	module.exports = BreadcrumbCaret;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageHeaderNavigationDropdown = __webpack_require__(1332);
	
	var _PageHeaderNavigationDropdown2 = _interopRequireDefault(_PageHeaderNavigationDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleNavigationItemSelection"];
	
	var PageHeaderTabs = function (_React$Component) {
	  (0, _inherits3.default)(PageHeaderTabs, _React$Component);
	
	  function PageHeaderTabs() {
	    (0, _classCallCheck3.default)(this, PageHeaderTabs);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PageHeaderTabs.__proto__ || (0, _getPrototypeOf2.default)(PageHeaderTabs)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PageHeaderTabs, [{
	    key: "handleNavigationItemSelection",
	    value: function handleNavigationItemSelection(navItem) {
	      var callback = navItem.callback,
	          routePath = navItem.routePath;
	
	
	      if (callback != null) {
	        callback();
	      }
	
	      if (routePath != null) {
	        this.context.router.push(routePath);
	      }
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var tabs = this.props.tabs;
	
	
	      var tabElements = tabs.map(function (tab, index) {
	        var isActive = tab.isActive,
	            callback = tab.callback,
	            label = tab.label,
	            routePath = tab.routePath;
	
	        var classes = (0, _classnames2.default)("menu-tabbed-item", { active: isActive });
	        var linkClasses = (0, _classnames2.default)("menu-tabbed-item-label", {
	          active: isActive
	        });
	
	        var innerLinkSpan = _react2.default.createElement(
	          "span",
	          { className: "menu-tabbed-item-label-text" },
	          label
	        );
	        var link = _react2.default.createElement(
	          "a",
	          { className: linkClasses, onClick: callback },
	          innerLinkSpan
	        );
	
	        if (callback == null && routePath != null) {
	          link = _react2.default.createElement(
	            _reactRouter.Link,
	            { className: linkClasses, to: routePath, activeClassName: "active" },
	            innerLinkSpan
	          );
	        }
	
	        return _react2.default.createElement(
	          "li",
	          { className: classes, key: index },
	          link
	        );
	      });
	
	      return _react2.default.createElement(
	        "ul",
	        { className: "page-header-navigation-tabs menu-tabbed" },
	        tabElements
	      );
	    }
	  }, {
	    key: "getNavigationDropdownItems",
	    value: function getNavigationDropdownItems() {
	      var _this2 = this;
	
	      var tabs = this.props.tabs;
	
	
	      if (tabs == null) {
	        return [];
	      }
	
	      return tabs.map(function (tab, index) {
	        var callback = tab.callback,
	            isActive = tab.isActive,
	            label = tab.label,
	            routePath = tab.routePath;
	        // We add 1 to index for the ID to avoid an ID of 0, due to coercion in
	        // the Dropdown component.
	
	        var id = index + 1;
	
	        return {
	          label: label,
	          id: id,
	          isActive: isActive || _this2.isRouteActive(routePath),
	          callback: callback,
	          routePath: routePath
	        };
	      });
	    }
	  }, {
	    key: "isRouteActive",
	    value: function isRouteActive(route) {
	      return route != null && this.context.router.isActive(route);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "page-header-navigation" },
	        this.getTabs(),
	        _react2.default.createElement(_PageHeaderNavigationDropdown2.default, {
	          handleNavigationItemSelection: this.handleNavigationItemSelection,
	          items: this.getNavigationDropdownItems()
	        })
	      );
	    }
	  }]);
	  return PageHeaderTabs;
	}(_react2.default.Component);
	
	PageHeaderTabs.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	PageHeaderTabs.defaultProps = {
	  tabs: []
	};
	
	PageHeaderTabs.propTypes = {
	  tabs: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    isActive: _react2.default.PropTypes.bool,
	    label: _react2.default.PropTypes.node.isRequired,
	    routePath: _react2.default.PropTypes.string,
	    callback: _react2.default.PropTypes.func
	  }))
	};
	
	module.exports = PageHeaderTabs;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeaderNavigationDropdown = function (_React$Component) {
	  (0, _inherits3.default)(PageHeaderNavigationDropdown, _React$Component);
	
	  function PageHeaderNavigationDropdown() {
	    (0, _classCallCheck3.default)(this, PageHeaderNavigationDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, (PageHeaderNavigationDropdown.__proto__ || (0, _getPrototypeOf2.default)(PageHeaderNavigationDropdown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PageHeaderNavigationDropdown, [{
	    key: "getActiveItemID",
	    value: function getActiveItemID() {
	      var items = this.props.items;
	
	      var activeTab = items.find(function (item) {
	        return item.isActive;
	      });
	
	      if (activeTab) {
	        return activeTab.id;
	      }
	
	      if (items.length > 0) {
	        return items[0].id;
	      }
	    }
	  }, {
	    key: "getItems",
	    value: function getItems() {
	      return this.props.items.map(function (item) {
	        var label = item.label;
	
	
	        return (0, _assign2.default)({}, item, {
	          html: label,
	          selectedHtml: _react2.default.createElement(
	            "div",
	            { className: "page-header-navigation-dropdown-active-item" },
	            _react2.default.createElement(
	              "span",
	              { className: "page-header-navigation-dropdown-label" },
	              label
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "page-header-navigation-dropdown-caret" },
	              _react2.default.createElement(_Icon2.default, {
	                id: "caret-down",
	                color: "light-grey",
	                family: "tiny",
	                size: "tiny"
	              })
	            )
	          )
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var handleNavigationItemSelection = this.props.handleNavigationItemSelection;
	
	      var dropdownItems = this.getItems();
	
	      if (dropdownItems.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        buttonClassName: "page-header-navigation-dropdown-button button button-transparent",
	        dropdownMenuClassName: "page-header-navigation-dropdown-menu dropdown-menu",
	        dropdownMenuListClassName: "dropdown-menu-list",
	        dropdownMenuListItemClassName: "clickable",
	        items: this.getItems(),
	        onItemSelection: handleNavigationItemSelection,
	        persistentID: this.getActiveItemID(),
	        scrollContainer: ".gm-scroll-view",
	        scrollContainerParentSelector: ".gm-prevented",
	        transition: true,
	        transitionName: "dropdown-menu",
	        wrapperClassName: "page-header-navigation-dropdown dropdown"
	      });
	    }
	  }]);
	  return PageHeaderNavigationDropdown;
	}(_react2.default.Component);
	
	PageHeaderNavigationDropdown.defaultProps = {
	  items: []
	};
	
	PageHeaderNavigationDropdown.propTypes = {
	  items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    id: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired,
	    isActive: _react2.default.PropTypes.bool.isRequired,
	    label: _react2.default.PropTypes.node.isRequired
	  }))
	};
	
	module.exports = PageHeaderNavigationDropdown;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _SidebarStore = __webpack_require__(1335);
	
	var _SidebarStore2 = _interopRequireDefault(_SidebarStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSidebarState() {
	  return {
	    isDocked: _SidebarStore2.default.get("isDocked"),
	    isVisible: _SidebarStore2.default.get("isVisible")
	  };
	}
	
	var SidebarToggle = _react2.default.createClass({
	  displayName: "SidebarToggle",
	
	  mixins: [_InternalStorageMixin2.default],
	
	  componentWillMount: function componentWillMount() {
	    this.internalStorage_set(getSidebarState());
	  },
	  componentDidMount: function componentDidMount() {
	    _SidebarStore2.default.addChangeListener(_EventTypes2.default.SIDEBAR_CHANGE, this.onSidebarStateChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _SidebarStore2.default.removeChangeListener(_EventTypes2.default.SIDEBAR_CHANGE, this.onSidebarStateChange);
	  },
	  onSidebarStateChange: function onSidebarStateChange() {
	    this.internalStorage_set(getSidebarState());
	    this.forceUpdate();
	  },
	  onClick: function onClick(e) {
	    var data = this.internalStorage_get();
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if (data.isVisible) {
	      _SidebarActions2.default.close();
	    } else {
	      _SidebarActions2.default.open();
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "page-header-sidebar-toggle", onClick: this.onClick },
	      _react2.default.createElement(_Icon2.default, {
	        className: "page-header-sidebar-toggle-icon",
	        id: "menu",
	        size: "mini",
	        color: "grey"
	      }),
	      _react2.default.createElement(
	        "span",
	        { className: "page-header-sidebar-toggle-label" },
	        "Show/Hide Sidebar"
	      )
	    );
	  }
	});
	
	module.exports = SidebarToggle;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  open: function open() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_SIDEBAR_OPEN,
	      data: true
	    });
	  },
	  close: function close() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_SIDEBAR_CLOSE,
	      data: false
	    });
	  },
	  dock: function dock() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_SIDEBAR_DOCK,
	      data: true
	    });
	  },
	  undock: function undock() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_SIDEBAR_UNDOCK,
	      data: false
	    });
	  },
	  openCliInstructions: function openCliInstructions() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_CLI_INSTRUCTIONS,
	      data: false
	    });
	  },
	  sidebarWidthChange: function sidebarWidthChange() {
	    _AppDispatcher2.default.handleSidebarAction({
	      type: _ActionTypes.REQUEST_SIDEBAR_WIDTH_CHANGE
	    });
	  }
	};

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _EventTypes = __webpack_require__(933);
	
	var _UserSettings = __webpack_require__(1336);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _UserSettingsStore = __webpack_require__(1337);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(SidebarStore, _GetSetBaseStore);
	
	  function SidebarStore() {
	    (0, _classCallCheck3.default)(this, SidebarStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarStore.__proto__ || (0, _getPrototypeOf2.default)(SidebarStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        widthChange: _EventTypes.SIDEBAR_WIDTH_CHANGE
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      var source = payload.source;
	      if (source !== _ActionTypes.SIDEBAR_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_SIDEBAR_DOCK:
	        case _ActionTypes.REQUEST_SIDEBAR_UNDOCK:
	          var nextDockedState = action.data;
	
	          if (_this.get("isDocked") !== nextDockedState) {
	            var savedStates = _UserSettingsStore2.default.getKey(_UserSettings.SAVED_STATE_KEY) || {};
	
	            _this.set({
	              isVisible: nextDockedState ? false : nextDockedState,
	              isDocked: nextDockedState
	            });
	
	            _this.emitChange(_EventTypes.SIDEBAR_CHANGE);
	
	            savedStates.sidebar = { isDocked: nextDockedState };
	            _UserSettingsStore2.default.setKey(_UserSettings.SAVED_STATE_KEY, savedStates);
	          }
	          break;
	        case _ActionTypes.REQUEST_SIDEBAR_CLOSE:
	        case _ActionTypes.REQUEST_SIDEBAR_OPEN:
	          var oldisVisible = _this.get("isVisible");
	          var isVisible = action.data;
	
	          // only emitting on change
	          if (oldisVisible !== isVisible) {
	            _this.set({ isVisible: isVisible });
	            _this.emitChange(_EventTypes.SIDEBAR_CHANGE);
	          }
	          break;
	        case _ActionTypes.REQUEST_CLI_INSTRUCTIONS:
	          _this.emitChange(_EventTypes.SHOW_CLI_INSTRUCTIONS);
	          break;
	        case _ActionTypes.REQUEST_VERSIONS_SUCCESS:
	          _this.set({ versions: action.data });
	          _this.emitChange(_EventTypes.SHOW_VERSIONS_SUCCESS);
	          break;
	        case _ActionTypes.REQUEST_VERSIONS_ERROR:
	          _this.emitChange(_EventTypes.SHOW_VERSIONS_ERROR);
	          break;
	        case _ActionTypes.REQUEST_SIDEBAR_WIDTH_CHANGE:
	          _this.emitChange(_EventTypes.SIDEBAR_WIDTH_CHANGE);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(SidebarStore, [{
	    key: "init",
	    value: function init() {
	      var isDocked = _Util2.default.findNestedPropertyInObject(_UserSettingsStore2.default.getKey(_UserSettings.SAVED_STATE_KEY), "sidebar.isDocked");
	
	      if (isDocked == null) {
	        isDocked = true;
	      }
	
	      this.set({
	        isDocked: isDocked,
	        isVisible: false,
	        versions: {}
	      });
	    }
	
	    // TODO: DCOS-7430 - Remove emitChange method
	
	  }, {
	    key: "emitChange",
	    value: function emitChange(eventName) {
	      this.emit(eventName);
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "sidebar";
	    }
	  }]);
	  return SidebarStore;
	}(_GetSetBaseStore3.default);
	
	var store = new SidebarStore();
	store.setMaxListeners(1000);
	
	module.exports = store;

/***/ },
/* 1336 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  SAVED_STATE_KEY: "savedStates"
	};

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _LocalStorageUtil = __webpack_require__(1338);
	
	var _LocalStorageUtil2 = _interopRequireDefault(_LocalStorageUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_STORAGE_KEY = "dcosUserSettings";
	
	function getLocalStorageObject() {
	  var localStorageObject = _LocalStorageUtil2.default.get(LOCAL_STORAGE_KEY);
	  try {
	    return JSON.parse(localStorageObject);
	  } catch (e) {
	    return null;
	  }
	}
	
	var UserSettingsStore = function (_EventEmitter) {
	  (0, _inherits3.default)(UserSettingsStore, _EventEmitter);
	
	  function UserSettingsStore() {
	    (0, _classCallCheck3.default)(this, UserSettingsStore);
	    return (0, _possibleConstructorReturn3.default)(this, (UserSettingsStore.__proto__ || (0, _getPrototypeOf2.default)(UserSettingsStore)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UserSettingsStore, [{
	    key: "getKey",
	    value: function getKey(key) {
	      var localStorageObject = getLocalStorageObject();
	      if (localStorageObject == null) {
	        return null;
	      }
	
	      return localStorageObject[key];
	    }
	  }, {
	    key: "setKey",
	    value: function setKey(key, value) {
	      var localStorageObject = getLocalStorageObject();
	      if (localStorageObject == null) {
	        localStorageObject = {};
	      }
	
	      localStorageObject[key] = value;
	      _LocalStorageUtil2.default.set(LOCAL_STORAGE_KEY, (0, _stringify2.default)(localStorageObject));
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "userSettings";
	    }
	  }]);
	  return UserSettingsStore;
	}(_events2.default);
	
	module.exports = new UserSettingsStore();

/***/ },
/* 1338 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var LocalStorageUtil = {
	  set: function set() {
	    return global.localStorage.setItem.apply(global.localStorage, arguments);
	  },
	  get: function get() {
	    return global.localStorage.getItem.apply(global.localStorage, arguments);
	  }
	};
	
	module.exports = LocalStorageUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactGeminiScrollbar = __webpack_require__(1281);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A component to use as in place of GeminiScrollbar when the parent's width
	 * will be animated. This component is unaware of any sort of animation; its
	 * job is simply to calculate the width of the browser's scrollbar and apply a
	 * width to Gemini's .gm-scroll-view element. The effect is the .gm-scroll-view
	 * element will always match the width of its parent.
	 *
	 * It writes an inline <style> tag to the document's head in order to
	 * dynamically apply a width with an offset equal to the width of the browser's
	 * scrollbar. This is only added once, as the same styles apply for all
	 * instances of this component.
	 *
	 * When the last component of its kind unmounts, the <style> tag is removed.
	 * It passes all props to the GeminiScrollbar component, with the exception that
	 * it adds a class to the provided className prop.
	 *
	 * @example
	 *
	 * <FluidGeminiScrollbar>
	 *   ...content...
	 * </FluidGeminiScrollbar>
	 *
	 */
	
	var componentMountCount = 0;
	var styleElement = null;
	
	var FluidGeminiScrollbar = function (_React$Component) {
	  (0, _inherits3.default)(FluidGeminiScrollbar, _React$Component);
	
	  function FluidGeminiScrollbar() {
	    (0, _classCallCheck3.default)(this, FluidGeminiScrollbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FluidGeminiScrollbar.__proto__ || (0, _getPrototypeOf2.default)(FluidGeminiScrollbar)).apply(this, arguments));
	
	    _this.geminiRef = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(FluidGeminiScrollbar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // If the browser's scrollbar width is larger than zero and this is the
	      // first instance of the component, then add the stylesheet to the
	      // document's head.
	      if (componentMountCount <= 0) {
	        var scrollbarWidth = _ScrollbarUtil2.default.getScrollbarWidth();
	
	        // Reset component mount counter
	        componentMountCount = 0;
	
	        if (scrollbarWidth > 0) {
	          var head = global.document.head || global.document.getElementsByTagName("head")[0];
	
	          var cssString = "\n          .gm-scrollbar-container-fluid-view-width > .gm-scroll-view {\n            width: calc(100% + " + scrollbarWidth + "px) !important;\n          }\n        ";
	
	          styleElement = global.document.createElement("style");
	          styleElement.type = "text/css";
	
	          if (styleElement.styleSheet) {
	            styleElement.styleSheet.cssText = cssString;
	          } else {
	            styleElement.appendChild(global.document.createTextNode(cssString));
	          }
	
	          head.appendChild(styleElement);
	        }
	      }
	
	      // Keep track of the number of mounted instances.
	      componentMountCount++;
	    }
	
	    /**
	     * Handle component will unmount and remove the gemini style sheet if it's the
	     * last mounted {FluidGeminiScrollbar} instance.
	     */
	
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (--componentMountCount > 0) {
	        return;
	      }
	
	      if (styleElement instanceof Element && styleElement.parentNode instanceof Node) {
	        styleElement.parentNode.removeChild(styleElement);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var props = this.props;
	
	      var classes = (0, _classnames2.default)("gm-scrollbar-container-fluid-view-width", props.className);
	
	      return _react2.default.createElement(_reactGeminiScrollbar2.default, (0, _extends3.default)({
	        className: classes,
	        ref: function ref(_ref) {
	          return _this2.geminiRef = _ref;
	        }
	      }, _Util2.default.omit(props, ["className"])));
	    }
	  }]);
	  return FluidGeminiScrollbar;
	}(_react2.default.Component);
	
	FluidGeminiScrollbar.propTypes = {
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.object])
	};
	
	module.exports = FluidGeminiScrollbar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _reactGeminiScrollbar = __webpack_require__(1281);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scrollbarWidth = null;
	
	var ScrollbarUtil = {
	  /**
	   * Taken from Gemini's source code with some edits
	   * https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js#L22
	   * @param  {Object} options
	   * @return {Number} The width of the native scrollbar
	   */
	  getScrollbarWidth: function getScrollbarWidth() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (scrollbarWidth == null || options.forceUpdate) {
	      var element = global.document.createElement("div");
	
	      element.style.position = "absolute";
	      element.style.top = "-9999px";
	      element.style.width = "100px";
	      element.style.height = "100px";
	      element.style.overflow = "scroll";
	      element.style.msOverflowStyle = "scrollbar";
	
	      global.document.body.appendChild(element);
	      scrollbarWidth = element.offsetWidth - element.clientWidth;
	      global.document.body.removeChild(element);
	    }
	
	    return scrollbarWidth;
	  },
	  updateWithRef: function updateWithRef(containerRef) {
	    // Use the containers gemini ref if present
	    if (containerRef != null && containerRef.geminiRef != null) {
	      this.updateWithRef(containerRef.geminiRef);
	
	      return;
	    }
	
	    if (containerRef instanceof _reactGeminiScrollbar2.default) {
	      containerRef.scrollbar.update();
	    }
	  }
	};
	
	module.exports = ScrollbarUtil;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateUtil = {
	  /**
	   * Defines each item in children as a template child of the parent class.
	   *
	   * As well as adding the component to its parent namespace, this method
	   * tracks each template item together with its reference on
	   *
	   * @param {React.Component} Parent
	   * @param {React.Children} children
	   */
	  defineChildren: function defineChildren(Parent, children) {
	    (0, _assign2.default)(Parent, children);
	
	    if (Parent.templateItems == null) {
	      Parent.templateItems = children;
	    } else {
	      (0, _assign2.default)(Parent.templateItems, children);
	    }
	  },
	
	
	  /**
	   * Gets all types of template children for a given component.
	   *
	   * @return {Array} a list of children.
	   */
	  getTypesOfTemplateChildren: function getTypesOfTemplateChildren(_ref) {
	    var _ref$templateItems = _ref.templateItems,
	        templateItems = _ref$templateItems === undefined ? {} : _ref$templateItems;
	
	    return (0, _values2.default)(templateItems);
	  },
	
	
	  /**
	   * Get all children of an instance which are not template children.
	   *
	   * @param {React.Component} T
	   * @param {React.Children} children
	   *
	   * @return {Array} a list of children.
	   */
	  filterTemplateChildren: function filterTemplateChildren(T, children) {
	    var types = this.getTypesOfTemplateChildren(T);
	
	    return _react2.default.Children.toArray(children).filter(function (child) {
	      return !types.includes(child.type);
	    });
	  },
	
	
	  /**
	   * Returns the first child with
	   *
	   * @param {React.Children} children
	   * @param {React.Component} T
	   *
	   * @return {React.Component} a single child of type <T>.
	   */
	  getChildOfType: function getChildOfType(children, T) {
	    return _react2.default.Children.toArray(children).find(function (child) {
	      return child.type === T;
	    });
	  }
	};
	
	module.exports = TemplateUtil;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var LEFT_ALIGN_PROPS = ["cpus", "disk", "log", "mem", "mtime", "priority", "size"];
	/* eslint-disable no-unused-vars */
	
	
	function leftAlignCaret(prop) {
	  return LEFT_ALIGN_PROPS.includes(prop);
	}
	
	function getUpdatedTimestamp(model) {
	  var lastStatus = _Util2.default.last(model.statuses);
	
	  return lastStatus && lastStatus.timestamp || null;
	}
	
	var ResourceTableUtil = {
	  getClassName: function getClassName(prop, sortBy, row) {
	    return (0, _classnames2.default)({
	      "text-align-right": leftAlignCaret(prop) || prop === "TASK_RUNNING" || prop === "action",
	      "hidden-small-down": leftAlignCaret(prop),
	      active: prop === sortBy.prop,
	      clickable: row == null // this is a header
	    });
	  },
	  renderHeading: function renderHeading(config) {
	    return function (prop, order, sortBy) {
	      var _classNames;
	
	      var title = config[prop];
	      var caret = {
	        before: null,
	        after: null
	      };
	      var caretClassSet = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", prop === sortBy.prop), _classNames));
	      var helpIcon = null;
	
	      if (leftAlignCaret(prop) || prop === "TASK_RUNNING") {
	        caret.before = _react2.default.createElement("span", { className: caretClassSet });
	      } else {
	        caret.after = _react2.default.createElement("span", { className: caretClassSet });
	      }
	
	      if (this.helpText != null) {
	        helpIcon = _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: this.helpText,
	            wrapText: true,
	            interactive: true,
	            wrapperClassName: "tooltip-wrapper text-align-center table-header-help-icon"
	          },
	          _react2.default.createElement(_Icon2.default, { id: "circle-question", size: "mini", color: "grey" })
	        );
	      }
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        caret.before,
	        _react2.default.createElement(
	          "span",
	          { className: "table-header-title" },
	          title
	        ),
	        helpIcon,
	        caret.after
	      );
	    };
	  },
	  renderUpdated: function renderUpdated(prop, model) {
	    var updatedAt = getUpdatedTimestamp(model);
	
	    if (updatedAt == null) {
	      return "N/A";
	    }
	
	    var ms = updatedAt.toFixed(3) * 1000;
	
	    return _react2.default.createElement(_TimeAgo2.default, { time: ms, autoUpdate: false });
	  },
	  renderTask: function renderTask(prop, model) {
	    return _react2.default.createElement(
	      "span",
	      null,
	      model[prop],
	      _react2.default.createElement(
	        "span",
	        { className: "visible-mini-inline" },
	        " tasks"
	      )
	    );
	  }
	};
	
	module.exports = ResourceTableUtil;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SECOND = 1000;
	var MINUTE = 60 * MINUTE;
	var HOUR = 60 * HOUR;
	var DAY = 24 * DAY;
	var METHODS_TO_BIND = ["updateTime"];
	
	var TimeAgo = function (_React$Component) {
	  (0, _inherits3.default)(TimeAgo, _React$Component);
	
	  function TimeAgo() {
	    (0, _classCallCheck3.default)(this, TimeAgo);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TimeAgo.__proto__ || (0, _getPrototypeOf2.default)(TimeAgo)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.state = {};
	
	    if (_this.props.autoUpdate && _this.props.time) {
	      _this.state.interval = global.setTimeout(_this.updateTime, _this.getUpdateInterval());
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(TimeAgo, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.interval) {
	        global.clearInterval(this.state.interval);
	      }
	    }
	  }, {
	    key: "getUpdateInterval",
	    value: function getUpdateInterval() {
	      var timeAgo = Date.now() - new Date(this.props.time);
	
	      if (timeAgo > DAY) {
	        return DAY;
	      }
	
	      if (timeAgo > HOUR) {
	        return HOUR;
	      }
	
	      if (timeAgo > MINUTE) {
	        return MINUTE;
	      }
	
	      return SECOND;
	    }
	  }, {
	    key: "updateTime",
	    value: function updateTime() {
	      this.setState({
	        interval: global.setTimeout(this.updateTime, this.getUpdateInterval())
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          prefix = _props.prefix,
	          suppressSuffix = _props.suppressSuffix,
	          time = _props.time;
	
	      var relativeTime = "N/A";
	      if (time) {
	        relativeTime = _DateUtil2.default.msToRelativeTime(time, suppressSuffix);
	      }
	
	      var prefixString = void 0;
	      if (prefix) {
	        prefixString = prefix + " ";
	      }
	
	      return _react2.default.createElement(
	        "time",
	        {
	          className: this.props.className,
	          title: _DateUtil2.default.msToUTCDate(time),
	          dateTime: _DateUtil2.default.msToUTCDate(time)
	        },
	        prefixString,
	        relativeTime
	      );
	    }
	  }]);
	  return TimeAgo;
	}(_react2.default.Component);
	
	TimeAgo.defaultProps = {
	  autoUpdate: true,
	  suppressSuffix: false
	};
	
	TimeAgo.propTypes = {
	  autoUpdate: _react2.default.PropTypes.bool,
	  className: _react2.default.PropTypes.string,
	  prefix: _react2.default.PropTypes.node,
	  suppressSuffix: _react2.default.PropTypes.bool,
	  time: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.number])
	};
	
	module.exports = TimeAgo;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActionsModal2 = __webpack_require__(1345);
	
	var _ActionsModal3 = _interopRequireDefault(_ActionsModal2);
	
	var _UserStore = __webpack_require__(1347);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var UsersActionsModal = function (_ActionsModal) {
	  (0, _inherits3.default)(UsersActionsModal, _ActionsModal);
	
	  function UsersActionsModal() {
	    (0, _classCallCheck3.default)(this, UsersActionsModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersActionsModal.__proto__ || (0, _getPrototypeOf2.default)(UsersActionsModal)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "user",
	      events: ["deleteError", "deleteSuccess"],
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(UsersActionsModal, [{
	    key: "onUserStoreDeleteError",
	    value: function onUserStoreDeleteError(requestError) {
	      this.onActionError(requestError);
	    }
	  }, {
	    key: "onUserStoreDeleteSuccess",
	    value: function onUserStoreDeleteSuccess() {
	      this.onActionSuccess();
	    }
	  }, {
	    key: "handleButtonConfirm",
	    value: function handleButtonConfirm() {
	      var _props = this.props,
	          itemID = _props.itemID,
	          selectedItems = _props.selectedItems;
	
	      var itemsByID = selectedItems.map(function (item) {
	        return item[itemID];
	      });
	
	      itemsByID.forEach(function (userID) {
	        _UserStore2.default.deleteUser(userID);
	      });
	
	      this.setState({ pendingRequest: true, requestErrors: [] });
	    }
	  }]);
	  return UsersActionsModal;
	}(_ActionsModal3.default); /* eslint-disable no-unused-vars */
	
	
	UsersActionsModal.propTypes = {
	  action: _react2.default.PropTypes.string.isRequired,
	  actionText: _react2.default.PropTypes.object.isRequired,
	  itemID: _react2.default.PropTypes.string.isRequired,
	  onClose: _react2.default.PropTypes.func.isRequired,
	  selectedItems: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = UsersActionsModal;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleButtonCancel", "handleButtonConfirm", "handleItemSelection", "onActionError", "onActionSuccess"];
	
	var DEFAULT_ID = "DEFAULT";
	var ITEMS_DISPLAYED = 3;
	
	var ActionsModal = function (_mixin) {
	  (0, _inherits3.default)(ActionsModal, _mixin);
	
	  function ActionsModal() {
	    (0, _classCallCheck3.default)(this, ActionsModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ActionsModal.__proto__ || (0, _getPrototypeOf2.default)(ActionsModal)).apply(this, arguments));
	
	    _this.state = {
	      pendingRequest: false,
	      requestErrors: [],
	      requestsRemaining: 0,
	      selectedItem: null,
	      validationError: null
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ActionsModal, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.setState({
	        requestsRemaining: this.props.selectedItems.length
	      });
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps, nextState) {
	      var requestsRemaining = nextState.requestsRemaining,
	          requestErrors = nextState.requestErrors;
	
	
	      if (requestsRemaining === 0 && !requestErrors.length) {
	        this.handleButtonCancel();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var requestsRemaining = this.state.requestsRemaining;
	
	
	      if (requestsRemaining === 0) {
	        /* eslint-disable react/no-did-update-set-state */
	        this.setState({
	          pendingRequest: false,
	          requestsRemaining: this.props.selectedItems.length
	        });
	        /* eslint-enable react/no-did-update-set-state */
	      }
	    }
	  }, {
	    key: "handleButtonCancel",
	    value: function handleButtonCancel() {
	      this.setState({
	        pendingRequest: false,
	        requestErrors: [],
	        requestsRemaining: 0,
	        selectedItem: null,
	        validationError: null
	      });
	      this.props.onClose();
	    }
	  }, {
	    key: "handleItemSelection",
	    value: function handleItemSelection(item) {
	      this.setState({
	        requestErrors: [],
	        selectedItem: item,
	        validationError: null
	      });
	    }
	  }, {
	    key: "onActionError",
	    value: function onActionError(error) {
	      this.state.requestErrors.push(error);
	
	      this.setState({
	        requestErrors: this.state.requestErrors,
	        requestsRemaining: this.state.requestsRemaining - 1
	      });
	    }
	  }, {
	    key: "onActionSuccess",
	    value: function onActionSuccess() {
	      this.setState({
	        requestsRemaining: this.state.requestsRemaining - 1
	      });
	    }
	  }, {
	    key: "getActionsModalContents",
	    value: function getActionsModalContents() {
	      var itemType = this.props.itemType;
	      var _state = this.state,
	          requestErrors = _state.requestErrors,
	          validationError = _state.validationError;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        this.getActionsModalContentsText(),
	        this.getDropdown(itemType),
	        this.getErrorMessage(validationError),
	        this.getRequestErrorMessage(requestErrors)
	      );
	    }
	  }, {
	    key: "getActionsModalContentsText",
	    value: function getActionsModalContentsText() {
	      var _props = this.props,
	          actionText = _props.actionText,
	          itemID = _props.itemID,
	          selectedItems = _props.selectedItems;
	
	
	      var selectedItemsString = "";
	      if (selectedItems.length === 1) {
	        selectedItemsString = selectedItems[0][itemID];
	      } else {
	        // Truncate list of selected user/groups for ease of reading
	        var selectedItemsShown = selectedItems.slice(0, ITEMS_DISPLAYED + 1);
	
	        // Create a string concatenating n-1 items
	        var selectedItemsShownMinusOne = selectedItemsShown.slice(0, -1);
	        var itemIDs = selectedItemsShownMinusOne.map(function (item) {
	          return item[itemID];
	        });
	        itemIDs.forEach(function (_itemID) {
	          selectedItemsString += _itemID + ", ";
	        });
	
	        // Handle grammar for nth element and concatenate to list
	        if (selectedItems.length <= ITEMS_DISPLAYED) {
	          // SelectedItems may be 0 length and Util.last will return null
	          if (selectedItems.length > 0) {
	            selectedItemsString += "and " + _Util2.default.last(selectedItems)[itemID] + " ";
	          }
	        } else if (selectedItems.length === ITEMS_DISPLAYED + 1) {
	          selectedItemsString += "and 1 other ";
	        } else {
	          var overflow = selectedItems.length - ITEMS_DISPLAYED;
	          selectedItemsString += "and " + overflow + " others ";
	        }
	        if (actionText.phraseFirst) {
	          selectedItemsString = selectedItemsString.slice(0, selectedItemsString.length - 1);
	        }
	      }
	      if (actionText.phraseFirst) {
	        return _react2.default.createElement(
	          "p",
	          null,
	          actionText.actionPhrase,
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            selectedItemsString
	          ),
	          "."
	        );
	      } else {
	        return _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "strong",
	            null,
	            selectedItemsString
	          ),
	          " ",
	          actionText.actionPhrase,
	          "."
	        );
	      }
	    }
	  }, {
	    key: "getDropdown",
	    value: function getDropdown(itemType) {
	      if (this.props.action === "delete") {
	        return null;
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        buttonClassName: "button dropdown-toggle",
	        dropdownMenuClassName: "dropdown-menu",
	        dropdownMenuListClassName: "dropdown-menu-list",
	        dropdownMenuListItemClassName: "clickable",
	        initialID: DEFAULT_ID,
	        items: this.getDropdownItems(itemType),
	        onItemSelection: this.handleItemSelection,
	        scrollContainer: ".gm-scroll-view",
	        scrollContainerParentSelector: ".gm-prevented",
	        transition: true,
	        transitionName: "dropdown-menu",
	        wrapperClassName: "dropdown text-align-left"
	      });
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage(error) {
	      if (error != null) {
	        return _react2.default.createElement(
	          "p",
	          { className: "text-error-state" },
	          error
	        );
	      }
	    }
	  }, {
	    key: "getRequestErrorMessage",
	    value: function getRequestErrorMessage(errors) {
	      if (errors.length > 0) {
	        var errorMap = errors.reduce(function (memo, error) {
	          if (memo[error] == null) {
	            memo[error] = 0;
	          }
	          memo[error]++;
	
	          return memo;
	        }, {});
	
	        // Compose error messages
	        var errorMessages = (0, _keys2.default)(errorMap).map(function (error, index) {
	          var repeatTimes = errorMap[error];
	
	          if (repeatTimes === 1) {
	            return _react2.default.createElement(
	              "p",
	              { className: "text-error-state", key: index },
	              error
	            );
	          } else {
	            return _react2.default.createElement(
	              "p",
	              { className: "text-error-state", key: index },
	              _react2.default.createElement(
	                "span",
	                { className: "badge badge-danger badge-rounded" },
	                repeatTimes + "x"
	              ),
	              " " + error
	            );
	          }
	        });
	
	        // Only show 5 first errors
	        return _react2.default.createElement(
	          "div",
	          { className: "pod pod-short flush-left flush-right" },
	          errorMessages.slice(0, 5)
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var action = this.props.action;
	      var props = this.props;
	      if (action === null) {
	        return null;
	      }
	
	      var heading = _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        this.props.actionText.title
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        (0, _extends3.default)({
	          disabled: this.state.pendingRequest,
	          header: heading,
	          open: !!action,
	          onClose: this.handleButtonCancel,
	          leftButtonCallback: this.handleButtonCancel,
	          rightButtonCallback: this.handleButtonConfirm,
	          rightButtonText: _StringUtil2.default.capitalize(action),
	          showHeader: true,
	          useGemini: false
	        }, props),
	        this.getActionsModalContents()
	      );
	    }
	  }]);
	  return ActionsModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	ActionsModal.propTypes = {
	  action: _react2.default.PropTypes.string.isRequired,
	  actionText: _react2.default.PropTypes.object.isRequired,
	  itemID: _react2.default.PropTypes.string.isRequired,
	  itemType: _react2.default.PropTypes.string.isRequired,
	  onClose: _react2.default.PropTypes.func.isRequired,
	  selectedItems: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = ActionsModal;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalHeading = function ModalHeading(props) {
	  var align = props.align,
	      children = props.children,
	      className = props.className,
	      flush = props.flush,
	      level = props.level;
	
	
	  return _react2.default.createElement("h" + level, {
	    className: (0, _classnames2.default)("text-align-" + align, {
	      flush: flush
	    }, className)
	  }, children);
	};
	
	ModalHeading.defaultProps = {
	  align: "center",
	  flush: true,
	  level: 2
	};
	
	ModalHeading.propTypes = {
	  align: _react2.default.PropTypes.oneOf(["left", "right", "center"]),
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  flush: _react2.default.PropTypes.bool,
	  level: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6])
	};
	
	module.exports = ModalHeading;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _events = __webpack_require__(1009);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _EventTypes = __webpack_require__(933);
	
	var _UsersActions = __webpack_require__(1348);
	
	var _UsersActions2 = _interopRequireDefault(_UsersActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This store will keep track of users and their details
	 */
	var UserStore = function (_EventEmitter) {
	  (0, _inherits3.default)(UserStore, _EventEmitter);
	
	  function UserStore() {
	    (0, _classCallCheck3.default)(this, UserStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UserStore.__proto__ || (0, _getPrototypeOf2.default)(UserStore)).apply(this, arguments));
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        createSuccess: _EventTypes.USER_CREATE_SUCCESS,
	        createError: _EventTypes.USER_CREATE_ERROR,
	        deleteSuccess: _EventTypes.USER_DELETE_SUCCESS,
	        deleteError: _EventTypes.USER_DELETE_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        // Create user
	        case _ActionTypes.REQUEST_USER_CREATE_SUCCESS:
	          _this.emit(_EventTypes.USER_CREATE_SUCCESS, action.userID);
	          break;
	        case _ActionTypes.REQUEST_USER_CREATE_ERROR:
	          _this.emit(_EventTypes.USER_CREATE_ERROR, action.data, action.userID, action.xhr);
	          break;
	        // Delete user
	        case _ActionTypes.REQUEST_USER_DELETE_SUCCESS:
	          _this.emit(_EventTypes.USER_DELETE_SUCCESS, action.userID);
	          break;
	        case _ActionTypes.REQUEST_USER_DELETE_ERROR:
	          _this.emit(_EventTypes.USER_DELETE_ERROR, action.data, action.userID);
	          break;
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(UserStore, [{
	    key: "fetchUsers",
	    value: function fetchUsers() {
	      return _UsersActions2.default.fetch.apply(_UsersActions2.default, arguments);
	    }
	  }, {
	    key: "addUser",
	    value: function addUser() {
	      return _UsersActions2.default.addUser.apply(_UsersActions2.default, arguments);
	    }
	  }, {
	    key: "deleteUser",
	    value: function deleteUser() {
	      return _UsersActions2.default.deleteUser.apply(_UsersActions2.default, arguments);
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "user";
	    }
	  }]);
	  return UserStore;
	}(_events2.default);
	
	module.exports = new UserStore();

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersActions = {
	  fetch: function fetch() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.acsAPIPrefix + "/users",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USERS_SUCCESS,
	          data: response.array
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USERS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  addUser: function addUser(data) {
	    var userID = data.uid;
	    data = _Util2.default.omit(data, ["uid"]);
	
	    if (!userID && data.description) {
	      userID = data.description.replace(/\s+/g, "").toLowerCase();
	    }
	
	    userID = encodeURIComponent(userID);
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.acsAPIPrefix + "/users/" + userID,
	      method: "PUT",
	      data: data,
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USER_CREATE_SUCCESS,
	          userID: userID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USER_CREATE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          userID: userID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  deleteUser: function deleteUser(userID) {
	    userID = encodeURIComponent(userID);
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.acsAPIPrefix + "/users/" + userID,
	      method: "DELETE",
	      success: function success() {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USER_DELETE_SUCCESS,
	          userID: userID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_USER_DELETE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          userID: userID,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var usersFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/acl/users-unicode.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.UsersActions = {
	    fetch: { event: "success", success: { response: usersFixture } },
	    addUser: { event: "success" },
	    deleteUser: { event: "success" }
	  };
	
	  (0, _keys2.default)(global.actionTypes.UsersActions).forEach(function (method) {
	    UsersActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(UsersActions, "UsersActions", method);
	  });
	}
	
	module.exports = UsersActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _FormModal = __webpack_require__(1350);
	
	var _FormModal2 = _interopRequireDefault(_FormModal);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _UserStore = __webpack_require__(1347);
	
	var _UserStore2 = _interopRequireDefault(_UserStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var TELEMETRY_NOTIFICATION = "Because telemetry is disabled you must manually notify users of ACL changes.";
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleNewUserSubmit", "onUserStoreCreateSuccess"];
	
	var UserFormModal = function (_mixin) {
	  (0, _inherits3.default)(UserFormModal, _mixin);
	
	  function UserFormModal() {
	    (0, _classCallCheck3.default)(this, UserFormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UserFormModal.__proto__ || (0, _getPrototypeOf2.default)(UserFormModal)).call(this));
	
	    _this.state = {
	      disableNewUser: false,
	      errorMsg: false,
	      errorCode: null
	    };
	
	    _this.store_listeners = [{
	      name: "user",
	      events: ["createSuccess", "createError"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(UserFormModal, [{
	    key: "onUserStoreCreateSuccess",
	    value: function onUserStoreCreateSuccess() {
	      this.setState({
	        disableNewUser: false,
	        errorMsg: false,
	        errorCode: null
	      });
	      this.props.onClose();
	    }
	  }, {
	    key: "onUserStoreCreateError",
	    value: function onUserStoreCreateError(errorMsg, userID, xhr) {
	      this.setState({
	        disableNewUser: false,
	        errorMsg: errorMsg,
	        errorCode: xhr.status
	      });
	    }
	  }, {
	    key: "handleNewUserSubmit",
	    value: function handleNewUserSubmit(model) {
	      this.setState({ disableNewUser: true });
	
	      var userModelObject = _PluginSDK.Hooks.applyFilter("userModelObject", (0, _assign2.default)({}, model, {
	        creator_uid: _AuthStore2.default.getUser().uid,
	        cluster_url: global.location.protocol + "//" + global.location.hostname
	      }));
	      _UserStore2.default.addUser(userModelObject);
	    }
	  }, {
	    key: "getButtonDefinition",
	    value: function getButtonDefinition() {
	      return _PluginSDK.Hooks.applyFilter("userFormModalButtonDefinition", [{
	        text: "Cancel",
	        className: "button button-medium",
	        isClose: true
	      }, {
	        text: "Add User",
	        className: "button button-success button-medium",
	        isSubmit: true
	      }]);
	    }
	  }, {
	    key: "getNewUserFormDefinition",
	    value: function getNewUserFormDefinition() {
	      var props = this.props,
	          state = this.state;
	
	
	      return _PluginSDK.Hooks.applyFilter("userFormModalDefinition", [{
	        fieldType: "text",
	        name: "uid",
	        placeholder: "Email",
	        required: true,
	        showError: state.errorMsg,
	        showLabel: false,
	        writeType: "input",
	        validation: function validation() {
	          return true;
	        },
	
	        value: ""
	      }], props, state);
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      return _PluginSDK.Hooks.applyFilter("userFormModalHeader", _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Add User to Cluster"
	      ));
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _PluginSDK.Hooks.applyFilter("userAddPolicy", null),
	        _PluginSDK.Hooks.applyFilter("userFormModalFooter", _react2.default.createElement(
	          "p",
	          { className: "form-group-without-top-label flush-bottom text-align-center" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Important:"
	          ),
	          " ",
	          TELEMETRY_NOTIFICATION
	        ))
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_FormModal2.default, {
	        buttonDefinition: this.getButtonDefinition(),
	        definition: this.getNewUserFormDefinition(),
	        disabled: this.state.disableNewUser,
	        modalProps: {
	          header: this.getHeader(),
	          showHeader: true
	        },
	        onClose: this.props.onClose,
	        onSubmit: this.handleNewUserSubmit,
	        open: this.props.open,
	        contentFooter: this.getFooter()
	      });
	    }
	  }]);
	  return UserFormModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	module.exports = UserFormModal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getTriggerSubmit", "handleTriggerSubmit", "handleError"];
	
	var FormModal = function (_React$Component) {
	  (0, _inherits3.default)(FormModal, _React$Component);
	
	  function FormModal() {
	    (0, _classCallCheck3.default)(this, FormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FormModal.__proto__ || (0, _getPrototypeOf2.default)(FormModal)).call(this));
	
	    _this.triggerSubmit = function () {};
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FormModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.focusOnField();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open === false && this.props.open === true) {
	        this.focusOnField();
	      }
	    }
	  }, {
	    key: "handleTriggerSubmit",
	    value: function handleTriggerSubmit() {
	      this.triggerSubmit();
	    }
	  }, {
	    key: "getTriggerSubmit",
	    value: function getTriggerSubmit(trigger) {
	      this.triggerSubmit = trigger;
	      this.forceUpdate();
	    }
	  }, {
	    key: "handleNewButtonClick",
	    value: function handleNewButtonClick() {
	      this.triggerSubmit();
	    }
	  }, {
	    key: "handleError",
	    value: function handleError() {
	      this.forceUpdate();
	    }
	  }, {
	    key: "focusOnField",
	    value: function focusOnField() {
	      var _this2 = this;
	
	      // Gotta account for animation
	      setTimeout(function () {
	        var el = _this2.refs["form-wrapper"];
	        if (el) {
	          var input = el.querySelector("form input");
	          if (input) {
	            input.focus();
	          }
	        }
	      }, 100);
	    }
	  }, {
	    key: "getButtons",
	    value: function getButtons() {
	      var _this3 = this;
	
	      return this.props.buttonDefinition.map(function (buttonDefinition, i) {
	        var buttonClassSet = {
	          disabled: _this3.props.disabled
	        };
	        buttonClassSet[buttonDefinition.className] = true;
	        buttonClassSet = (0, _dedupe2.default)(buttonClassSet);
	
	        var handleOnClick = function handleOnClick() {};
	        if (buttonDefinition.isClose) {
	          handleOnClick = _this3.props.onClose;
	        }
	
	        if (buttonDefinition.isSubmit) {
	          handleOnClick = _this3.handleTriggerSubmit;
	        }
	
	        if (buttonDefinition.onClick) {
	          handleOnClick = buttonDefinition.onClick;
	        }
	
	        return _react2.default.createElement(
	          "button",
	          {
	            className: buttonClassSet,
	            disabled: _this3.props.disabled,
	            key: i,
	            onClick: handleOnClick
	          },
	          buttonDefinition.text
	        );
	      });
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection text-align-center flush" },
	        this.getButtons(),
	        this.props.extraFooterContent
	      );
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(hasContentFooter) {
	      if (hasContentFooter) {
	        return "form";
	      }
	
	      return "form flush-bottom";
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      return _react2.default.createElement(
	        "div",
	        { ref: "form-wrapper", className: (0, _dedupe2.default)(this.props.contentClasses) },
	        this.props.children,
	        _react2.default.createElement(_reactjsComponents.Form, {
	          className: this.getClassName(!!this.props.contentFooter),
	          definition: this.props.definition,
	          triggerSubmit: this.getTriggerSubmit,
	          onSubmit: this.props.onSubmit,
	          onChange: this.props.onChange,
	          onError: this.handleError
	        }),
	        this.props.contentFooter
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        (0, _extends3.default)({
	          closeByBackdropClick: !this.props.disabled,
	          modalClass: "modal form-modal",
	          onClose: this.props.onClose,
	          open: this.props.open,
	          showHeader: false,
	          showFooter: true,
	          footer: this.getFooter(),
	          titleClass: "text-align-center flush"
	        }, this.props.modalProps),
	        this.getContent()
	      );
	    }
	  }]);
	  return FormModal;
	}(_react2.default.Component);
	
	FormModal.defaultProps = {
	  buttonDefinition: [{
	    text: "Cancel",
	    className: "button button-medium",
	    isClose: true
	  }, {
	    text: "Create",
	    className: "button button-success button-medium",
	    isSubmit: true
	  }],
	  disabled: false,
	  extraFooterContent: null,
	  onChange: function onChange() {},
	  onClose: function onClose() {},
	
	  open: false,
	  modalProps: {}
	};
	
	FormModal.propTypes = {
	  buttonDefinition: _react2.default.PropTypes.array,
	  children: _react2.default.PropTypes.node,
	  contentClasses: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  contentFooter: _react2.default.PropTypes.node,
	  definition: _react2.default.PropTypes.array,
	  disabled: _react2.default.PropTypes.bool,
	  extraFooterContent: _react2.default.PropTypes.node,
	  modalProps: _react2.default.PropTypes.object,
	  onChange: _react2.default.PropTypes.func,
	  onClose: _react2.default.PropTypes.func.isRequired,
	  onSubmit: _react2.default.PropTypes.func,
	  open: _react2.default.PropTypes.bool
	};
	
	module.exports = FormModal;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _EventTypes = __webpack_require__(933);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _UsersActions = __webpack_require__(1348);
	
	var _UsersActions2 = _interopRequireDefault(_UsersActions);
	
	var _UsersList = __webpack_require__(1352);
	
	var _UsersList2 = _interopRequireDefault(_UsersList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(UsersStore, _GetSetBaseStore);
	
	  function UsersStore() {
	    (0, _classCallCheck3.default)(this, UsersStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersStore.__proto__ || (0, _getPrototypeOf2.default)(UsersStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      users: []
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.USERS_CHANGE,
	        error: _EventTypes.USERS_REQUEST_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      switch (action.type) {
	        case _ActionTypes.REQUEST_USERS_SUCCESS:
	          _this.processUsers(action.data);
	          break;
	        case _ActionTypes.REQUEST_USERS_ERROR:
	          _this.processUsersError(action.data);
	          break;
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(UsersStore, [{
	    key: "fetchUsers",
	    value: function fetchUsers() {
	      return _UsersActions2.default.fetch.apply(_UsersActions2.default, arguments);
	    }
	  }, {
	    key: "getUsers",
	    value: function getUsers() {
	      return new _UsersList2.default({ items: this.getUsersRaw() });
	    }
	  }, {
	    key: "getUsersRaw",
	    value: function getUsersRaw() {
	      return this.get("users");
	    }
	  }, {
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "processUsers",
	    value: function processUsers(users) {
	      this.set({ users: users });
	      this.emit(_EventTypes.USERS_CHANGE);
	    }
	  }, {
	    key: "processUsersError",
	    value: function processUsersError(error) {
	      this.emit(_EventTypes.USERS_REQUEST_ERROR, error);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "users";
	    }
	  }]);
	  return UsersStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new UsersStore();

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersList = function (_List) {
	  (0, _inherits3.default)(UsersList, _List);
	
	  function UsersList() {
	    (0, _classCallCheck3.default)(this, UsersList);
	    return (0, _possibleConstructorReturn3.default)(this, (UsersList.__proto__ || (0, _getPrototypeOf2.default)(UsersList)).apply(this, arguments));
	  }
	
	  return UsersList;
	}(_List3.default);
	
	UsersList.type = _Item2.default;
	
	module.exports = UsersList;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDefaultMessage() {
	  var slackLink = _react2.default.createElement(
	    "a",
	    { href: _Config2.default.slackChannel, target: "_blank" },
	    "Slack channel"
	  );
	  var supportLink = _react2.default.createElement(
	    "a",
	    { href: "mailto:" + _Config2.default.supportEmail },
	    _Config2.default.supportEmail
	  );
	
	  return _react2.default.createElement(
	    "p",
	    { className: "text-align-center flush-bottom" },
	    "You can also join us on our",
	    " ",
	    slackLink,
	    " ",
	    "or send us an email at",
	    " ",
	    supportLink,
	    "."
	  );
	}
	
	var RequestErrorMsg = function (_React$Component) {
	  (0, _inherits3.default)(RequestErrorMsg, _React$Component);
	
	  function RequestErrorMsg() {
	    (0, _classCallCheck3.default)(this, RequestErrorMsg);
	    return (0, _possibleConstructorReturn3.default)(this, (RequestErrorMsg.__proto__ || (0, _getPrototypeOf2.default)(RequestErrorMsg)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RequestErrorMsg, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          columnClasses = _props.columnClasses,
	          header = _props.header,
	          message = _props.message;
	
	
	      columnClasses = (0, _dedupe2.default)("column-small-8 column-small-offset-2", "column-medium-6 column-medium-offset-3", columnClasses);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            "h3",
	            { className: "text-align-center flush-top" },
	            header
	          ),
	          message
	        )
	      );
	    }
	  }]);
	  return RequestErrorMsg;
	}(_react2.default.Component);
	
	RequestErrorMsg.defaultProps = {
	  columnClasses: {},
	  header: "Cannot Connect With The Server",
	  message: getDefaultMessage()
	};
	
	RequestErrorMsg.propTypes = {
	  columnClasses: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  header: _react2.default.PropTypes.node,
	  message: _react2.default.PropTypes.node
	};
	
	module.exports = RequestErrorMsg;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _UserAccountDropdown2 = __webpack_require__(1355);
	
	var _UserAccountDropdown3 = _interopRequireDefault(_UserAccountDropdown2);
	
	var _UserAccountDropdownTrigger = __webpack_require__(1356);
	
	var _UserAccountDropdownTrigger2 = _interopRequireDefault(_UserAccountDropdownTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthenticatedUserAccountDropdown = function (_UserAccountDropdown) {
	  (0, _inherits3.default)(AuthenticatedUserAccountDropdown, _UserAccountDropdown);
	
	  function AuthenticatedUserAccountDropdown() {
	    (0, _classCallCheck3.default)(this, AuthenticatedUserAccountDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, (AuthenticatedUserAccountDropdown.__proto__ || (0, _getPrototypeOf2.default)(AuthenticatedUserAccountDropdown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(AuthenticatedUserAccountDropdown, [{
	    key: "getUserLabel",
	    value: function getUserLabel() {
	      var user = _AuthStore2.default.getUser();
	
	      var userLabel = null;
	
	      if (user && !user.is_remote) {
	        userLabel = user.description;
	      } else if (user && user.is_remote) {
	        userLabel = user.uid;
	      }
	
	      return userLabel;
	    }
	
	    /**
	     * Adds the authenticated user's account information to the dropdown items.
	     * @return {array} Dropdown menu items.
	     * @override
	     */
	
	  }, {
	    key: "getMenuItems",
	    value: function getMenuItems() {
	      var _props = this.props,
	          clusterName = _props.clusterName,
	          menuItems = _props.menuItems;
	
	      var nextMenuItems = menuItems.slice();
	      var userLabel = this.getUserLabel();
	
	      nextMenuItems.unshift({
	        className: "hidden",
	        html: _react2.default.createElement(_UserAccountDropdownTrigger2.default, {
	          primaryContent: clusterName,
	          secondaryContent: userLabel
	        }),
	        id: "dropdown-trigger",
	        selectable: false
	      });
	
	      nextMenuItems.push({
	        className: "dropdown-menu-section-header",
	        html: _react2.default.createElement(
	          "label",
	          { className: "text-overflow" },
	          userLabel
	        ),
	        id: "header-user-label",
	        selectable: false
	      }, {
	        html: "Sign Out",
	        id: "sign-out",
	        onClick: _AuthStore2.default.logout
	      });
	
	      return nextMenuItems;
	    }
	  }]);
	  return AuthenticatedUserAccountDropdown;
	}(_UserAccountDropdown3.default);
	
	module.exports = AuthenticatedUserAccountDropdown;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserAccountDropdownTrigger = __webpack_require__(1356);
	
	var _UserAccountDropdownTrigger2 = _interopRequireDefault(_UserAccountDropdownTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserAccountDropdown = function (_React$Component) {
	  (0, _inherits3.default)(UserAccountDropdown, _React$Component);
	
	  function UserAccountDropdown() {
	    (0, _classCallCheck3.default)(this, UserAccountDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, (UserAccountDropdown.__proto__ || (0, _getPrototypeOf2.default)(UserAccountDropdown)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UserAccountDropdown, [{
	    key: "getMenuItems",
	    value: function getMenuItems() {
	      return [{
	        className: "hidden",
	        html: _react2.default.createElement(_UserAccountDropdownTrigger2.default, { primaryContent: this.props.clusterName }),
	        id: "dropdown-trigger",
	        selectable: false
	      }].concat(this.props.menuItems);
	    }
	  }, {
	    key: "handleItemSelection",
	    value: function handleItemSelection(item) {
	      if (item.onClick) {
	        item.onClick();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        buttonClassName: "user-account-dropdown-button text-no-transform",
	        dropdownMenuClassName: "user-account-dropdown-menu dropdown-menu",
	        dropdownMenuListClassName: "user-account-dropdown-list dropdown-menu-list",
	        items: this.getMenuItems(),
	        onItemSelection: this.handleItemSelection,
	        persistentID: "dropdown-trigger",
	        transition: true,
	        wrapperClassName: "user-account-dropdown dropdown header flex-item-shrink-0"
	      });
	    }
	  }]);
	  return UserAccountDropdown;
	}(_react2.default.Component);
	
	module.exports = UserAccountDropdown;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserAccountDropdownTrigger = function (_mixin) {
	  (0, _inherits3.default)(UserAccountDropdownTrigger, _mixin);
	
	  function UserAccountDropdownTrigger() {
	    (0, _classCallCheck3.default)(this, UserAccountDropdownTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UserAccountDropdownTrigger.__proto__ || (0, _getPrototypeOf2.default)(UserAccountDropdownTrigger)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "metadata",
	      events: ["success"],
	      listenAlways: false
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(UserAccountDropdownTrigger, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.onUpdate) {
	        this.props.onUpdate();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          primaryContent = _props.primaryContent,
	          _props$secondaryConte = _props.secondaryContent,
	          secondaryContent = _props$secondaryConte === undefined ? null : _props$secondaryConte;
	
	      // Promote secondary content to primary content in the event that secondary
	      // is the only available content.
	
	      if (!primaryContent && secondaryContent) {
	        primaryContent = secondaryContent;
	        secondaryContent = null;
	      } else if (secondaryContent) {
	        secondaryContent = _react2.default.createElement(
	          "div",
	          { className: "cluster-header-secondary" },
	          secondaryContent
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "cluster-header" },
	        _react2.default.createElement(
	          "div",
	          { className: "cluster-header-primary-wrapper" },
	          _react2.default.createElement(
	            "h5",
	            { className: "cluster-header-primary inverse text-overflow flush" },
	            primaryContent
	          ),
	          _react2.default.createElement(_Icon2.default, { family: "tiny", id: "triangle-down", key: "caret", size: "tiny" })
	        ),
	        secondaryContent
	      );
	    }
	  }]);
	  return UserAccountDropdownTrigger;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	UserAccountDropdownTrigger.defaultProps = {
	  showCaret: false
	};
	
	UserAccountDropdownTrigger.propTypes = {
	  clusterName: _react2.default.PropTypes.node,
	  onUpdate: _react2.default.PropTypes.func,
	  showCaret: _react2.default.PropTypes.bool
	};
	
	module.exports = UserAccountDropdownTrigger;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _AuthStore = __webpack_require__(998);
	
	var _AuthStore2 = _interopRequireDefault(_AuthStore);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SDK = __webpack_require__(1022).getSDK();
	
	var METHODS_TO_BIND = ["handleModalClose", "onMessageReceived"];
	
	var LoginPage = function (_mixin) {
	  (0, _inherits3.default)(LoginPage, _mixin);
	
	  function LoginPage() {
	    (0, _classCallCheck3.default)(this, LoginPage);
	    return (0, _possibleConstructorReturn3.default)(this, (LoginPage.__proto__ || (0, _getPrototypeOf2.default)(LoginPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LoginPage, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _get3.default)(LoginPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(LoginPage.prototype), "componentWillMount", this).call(this);
	
	      if (_AuthStore2.default.getUser()) {
	        this.context.router.push("/");
	      }
	
	      this.store_listeners = [{
	        name: "auth",
	        events: ["success", "error"],
	        suppressUpdate: true
	      }];
	
	      this.state = {
	        showClusterError: false
	      };
	
	      METHODS_TO_BIND.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	
	      global.addEventListener("message", this.onMessageReceived);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _get3.default)(LoginPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(LoginPage.prototype), "componentWillUnmount", this).call(this);
	
	      global.removeEventListener("message", this.onMessageReceived);
	    }
	  }, {
	    key: "onMessageReceived",
	    value: function onMessageReceived(event) {
	      if (event.origin !== SDK.config.authHost) {
	        console.warn("Event Origin \"" + event.origin + "\" does not match allowed origin \"" + SDK.config.authHost + "\"");
	
	        return;
	      }
	
	      var data = JSON.parse(event.data);
	
	      switch (data.type) {
	        case "token":
	          _AuthStore2.default.login({ token: data.token });
	          break;
	        case "error":
	          this.navigateToAccessDenied();
	          break;
	      }
	    }
	  }, {
	    key: "onAuthStoreError",
	    value: function onAuthStoreError(message, xhr) {
	      if (xhr.status >= 400 && xhr.status < 500) {
	        this.navigateToAccessDenied();
	      } else {
	        this.setState({ showClusterError: true });
	      }
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose() {
	      this.setState({ showClusterError: false });
	    }
	  }, {
	    key: "navigateToAccessDenied",
	    value: function navigateToAccessDenied() {
	      var router = this.context.router;
	
	      router.replace("/access-denied");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var firstUser = SDK.Store.getAppState().config.config.clusterConfiguration.firstUser;
	
	      var location = "/login?firstUser=" + firstUser;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "iframe-page-container" },
	          _react2.default.createElement("iframe", {
	            width: "100%",
	            height: "100%",
	            frameBorder: "0",
	            id: "oauth-iframe",
	            src: location
	          })
	        ),
	        _react2.default.createElement(
	          _reactjsComponents.Modal,
	          {
	            onClose: this.handleModalClose,
	            open: this.state.showClusterError,
	            showCloseButton: true,
	            showHeader: false,
	            showFooter: false
	          },
	          _react2.default.createElement(
	            "p",
	            { className: "text-align-center" },
	            "Unable to login to your DC/OS cluster. Clusters must be connected to the internet."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "flush-bottom text-align-center" },
	            "Please contact your system administrator or see the ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: _MetadataStore2.default.buildDocsURI("/administration/installing/"),
	                target: "_blank"
	              },
	              "documentation"
	            ),
	            "."
	          )
	        )
	      );
	    }
	  }]);
	  return LoginPage;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	LoginPage.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = LoginPage;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1358 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _moment = __webpack_require__(1106);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.updateLocale("en", {
	  relativeTime: {
	    future: "in %s",
	    past: "%s ago",
	    s: "%d seconds",
	    m: "a minute",
	    mm: "%d minutes",
	    h: "an hour",
	    hh: "%d hours",
	    d: "a day",
	    dd: "%d days",
	    M: "a month",
	    MM: "%d months",
	    y: "a year",
	    yy: "%d years"
	  }
	});

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _foundationUi = __webpack_require__(1024);
	
	var _reactRouter = __webpack_require__(785);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _components = __webpack_require__(1364);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _dashboard = __webpack_require__(1384);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _Index = __webpack_require__(1407);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _jobs = __webpack_require__(1429);
	
	var _jobs2 = _interopRequireDefault(_jobs);
	
	var _network = __webpack_require__(1527);
	
	var _network2 = _interopRequireDefault(_network);
	
	var _nodes = __webpack_require__(1540);
	
	var _nodes2 = _interopRequireDefault(_nodes);
	
	var _NotFoundPage = __webpack_require__(1593);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	var _organization = __webpack_require__(1594);
	
	var _organization2 = _interopRequireDefault(_organization);
	
	var _services = __webpack_require__(1596);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _settings = __webpack_require__(1845);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _systemOverview = __webpack_require__(1857);
	
	var _systemOverview2 = _interopRequireDefault(_systemOverview);
	
	var _catalog = __webpack_require__(1860);
	
	var _catalog2 = _interopRequireDefault(_catalog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Modules that produce routes
	var routeFactories = [_organization2.default, _network2.default];
	
	function getApplicationRoutes() {
	  // Statically defined routes
	  var routes = [].concat({
	    type: _reactRouter.Redirect,
	    path: "/",
	    to: _PluginSDK.Hooks.applyFilter("applicationRedirectRoute", "/dashboard")
	  }, _dashboard2.default, _services2.default, _jobs2.default, _nodes2.default, _catalog2.default, _systemOverview2.default, _components2.default, _settings2.default
	  // Plugins routes will be appended to this array
	  );
	
	  routeFactories.forEach(function (routeFactory) {
	    routes = routes.concat(routeFactory.getRoutes());
	  });
	
	  routes = [{
	    type: _reactRouter.Route,
	    children: [{
	      type: _reactRouter.Route,
	      id: "index",
	      children: routes,
	      component: _Index2.default
	    }, {
	      // This is a bit tricky.
	      //
	      // `NotFoundPage` should not be among children of `id: index` route
	      // because `path: '*'` is a glob and matches everything
	      // so it will prevent all the routes that go after from being resolved
	      // in our case these will be plugins routes
	      //
	      // Yet it expects Index to be its parent,
	      // this is why we have `component: Index` twice
	      // I decided not to add component Index inside NotFoundPage
	      // to make it explicit
	      // TODO: DCOS-11913 make it less tricky
	      type: _reactRouter.Route,
	      component: _Index2.default,
	      children: [{
	        type: _reactRouter.Route,
	        path: "*",
	        component: _NotFoundPage2.default
	      }]
	    }]
	  }];
	
	  return routes;
	}
	
	function getRoutes() {
	  // Get application routes
	  var routes = getApplicationRoutes();
	
	  // Provide opportunity for plugins to inject routes
	  routes = _PluginSDK.Hooks.applyFilter("applicationRoutes", routes);
	
	  var indexRoute = routes[0].children.find(function (route) {
	    return route.id === "index";
	  });
	
	  // Register packages
	  indexRoute.children = indexRoute.children.concat(_foundationUi.routing.RoutingService.getDefinition());
	
	  return routes;
	}
	
	module.exports = {
	  getRoutes: getRoutes
	};

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _ComponentsPage = __webpack_require__(1365);
	
	var _ComponentsPage2 = _interopRequireDefault(_ComponentsPage);
	
	var _UnitsHealthDetail = __webpack_require__(1366);
	
	var _UnitsHealthDetail2 = _interopRequireDefault(_UnitsHealthDetail);
	
	var _ComponentsUnitsHealthNodeDetailPage = __webpack_require__(1373);
	
	var _ComponentsUnitsHealthNodeDetailPage2 = _interopRequireDefault(_ComponentsUnitsHealthNodeDetailPage);
	
	var _UnitsHealthTab = __webpack_require__(1382);
	
	var _UnitsHealthTab2 = _interopRequireDefault(_UnitsHealthTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var componentsRoutes = {
	  type: _reactRouter.Route,
	  path: "components",
	  component: _ComponentsPage2.default,
	  category: "system",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.IndexRoute,
	    component: _UnitsHealthTab2.default
	  }, {
	    type: _reactRouter.Route,
	    path: ":unitID",
	    component: _UnitsHealthDetail2.default,
	    hideHeaderNavigation: true
	  }, {
	    type: _reactRouter.Route,
	    path: ":unitID/nodes/:unitNodeID",
	    component: _ComponentsUnitsHealthNodeDetailPage2.default,
	    hideHeaderNavigation: true
	  }]
	};
	/* eslint-enable no-unused-vars */
	
	
	module.exports = componentsRoutes;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentsPage = function (_React$Component) {
	  (0, _inherits3.default)(ComponentsPage, _React$Component);
	
	  function ComponentsPage() {
	    (0, _classCallCheck3.default)(this, ComponentsPage);
	    return (0, _possibleConstructorReturn3.default)(this, (ComponentsPage.__proto__ || (0, _getPrototypeOf2.default)(ComponentsPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ComponentsPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ComponentsPage;
	}(_react2.default.Component);
	
	ComponentsPage.routeConfig = {
	  label: "Components",
	  icon: _react2.default.createElement(_Icon2.default, { id: "components-inverse", size: "small", family: "product" }),
	  matches: /^\/components/
	};
	
	module.exports = ComponentsPage;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _UnitHealthDropdown = __webpack_require__(1367);
	
	var _UnitHealthDropdown2 = _interopRequireDefault(_UnitHealthDropdown);
	
	var _UnitHealthNodesTable = __webpack_require__(1368);
	
	var _UnitHealthNodesTable2 = _interopRequireDefault(_UnitHealthNodesTable);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var UnitHealthDetailBreadcrumbs = function UnitHealthDetailBreadcrumbs(_ref) {
	  var unit = _ref.unit;
	
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Components" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/components" },
	        "Components"
	      )
	    )
	  )];
	
	  if (unit != null) {
	    var healthStatus = unit.getHealth();
	    var unitTitle = unit.getTitle();
	
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 0, title: "Components" },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/components/" + unit.get("id") },
	          unitTitle + " ",
	          _react2.default.createElement(
	            "span",
	            { className: healthStatus.classNames },
	            "(",
	            healthStatus.title,
	            ")"
	          )
	        )
	      )
	    ));
	  }
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "components", breadcrumbs: crumbs });
	};
	/* eslint-disable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleHealthSelection", "handleSearchStringChange", "resetFilter"];
	
	var UnitsHealthDetail = function (_mixin) {
	  (0, _inherits3.default)(UnitsHealthDetail, _mixin);
	
	  function UnitsHealthDetail() {
	    (0, _classCallCheck3.default)(this, UnitsHealthDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitsHealthDetail.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthDetail)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "unitHealth",
	      events: ["unitSuccess", "unitError", "nodesSuccess", "nodesError"],
	      suppressUpdate: true
	    }];
	
	    _this.state = {
	      hasError: false,
	      healthFilter: "all",
	      isLoadingUnit: true,
	      isLoadingNodes: true,
	      searchString: ""
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitsHealthDetail, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(UnitsHealthDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthDetail.prototype), "componentDidMount", this).call(this);
	
	      _UnitHealthStore2.default.fetchUnit(this.props.params.unitID);
	      _UnitHealthStore2.default.fetchUnitNodes(this.props.params.unitID);
	    }
	  }, {
	    key: "onUnitHealthStoreUnitSuccess",
	    value: function onUnitHealthStoreUnitSuccess() {
	      this.setState({ isLoadingUnit: false });
	    }
	  }, {
	    key: "onUnitHealthStoreUnitError",
	    value: function onUnitHealthStoreUnitError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "onUnitHealthStoreNodesSuccess",
	    value: function onUnitHealthStoreNodesSuccess() {
	      this.setState({ isLoadingNodes: false });
	    }
	  }, {
	    key: "onUnitHealthStoreNodeError",
	    value: function onUnitHealthStoreNodeError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "handleHealthSelection",
	    value: function handleHealthSelection(selectedHealth) {
	      this.setState({ healthFilter: selectedHealth.id });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      if (this.healthFilter !== null && this.healthFilter.dropdown !== null) {
	        this.healthFilter.setDropdownValue("all");
	      }
	
	      this.setState({
	        searchString: "",
	        healthFilter: "all"
	      });
	    }
	  }, {
	    key: "getErrorNotice",
	    value: function getErrorNotice() {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod" },
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getNodesTable",
	    value: function getNodesTable(unit, visibleData) {
	      return _react2.default.createElement(_UnitHealthNodesTable2.default, { nodes: visibleData, params: this.props.params });
	    }
	  }, {
	    key: "getUnit",
	    value: function getUnit() {
	      var _state = this.state,
	          hasError = _state.hasError,
	          isLoadingUnit = _state.isLoadingUnit,
	          isLoadingNodes = _state.isLoadingNodes;
	
	
	      if (hasError) {
	        return null;
	      }
	
	      if (isLoadingUnit || isLoadingNodes) {
	        return null;
	      }
	
	      return _UnitHealthStore2.default.getUnit(this.props.params.unitID);
	    }
	  }, {
	    key: "getVisibleData",
	    value: function getVisibleData(data, searchString, healthFilter) {
	      return data.filter({ ip: searchString, health: healthFilter }).getItems();
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          healthFilter = _state2.healthFilter,
	          searchString = _state2.searchString,
	          hasError = _state2.hasError,
	          isLoadingUnit = _state2.isLoadingUnit,
	          isLoadingNodes = _state2.isLoadingNodes;
	
	
	      if (hasError) {
	        return this.getErrorNotice();
	      }
	
	      if (isLoadingUnit || isLoadingNodes) {
	        return this.getLoadingScreen();
	      }
	
	      var nodes = _UnitHealthStore2.default.getNodes(this.props.params.unitID);
	      var visibleData = this.getVisibleData(nodes, searchString, healthFilter);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-container-col" },
	        _react2.default.createElement(_FilterHeadline2.default, {
	          currentLength: visibleData.length,
	          isFiltering: healthFilter !== "all" || searchString !== "",
	          name: "Health Check",
	          onReset: this.resetFilter,
	          totalLength: nodes.getItems().length
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "form-group flush-bottom" },
	            _react2.default.createElement(_FilterInputText2.default, {
	              className: "flush-bottom",
	              searchString: searchString,
	              handleFilterChange: this.handleSearchStringChange
	            })
	          ),
	          _react2.default.createElement(_UnitHealthDropdown2.default, {
	            className: "button dropdown-toggle text-align-left",
	            dropdownMenuClassName: "dropdown-menu",
	            initialID: "all",
	            onHealthSelection: this.handleHealthSelection,
	            ref: function ref(_ref2) {
	              return _this2.healthFilter = _ref2;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flex-container-col flex-grow no-overflow" },
	          this.getNodesTable(this.getUnit(), visibleData)
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(UnitHealthDetailBreadcrumbs, { unit: this.getUnit() })
	        }),
	        this.getContent()
	      );
	    }
	  }]);
	  return UnitsHealthDetail;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	module.exports = UnitsHealthDetail;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UnitHealthStatus = __webpack_require__(1055);
	
	var _UnitHealthStatus2 = _interopRequireDefault(_UnitHealthStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_ITEM = {
	  id: "all",
	  html: "All Health Checks",
	  selectedHtml: "All Health Checks"
	};
	
	var UnitHealthDropdown = function (_React$Component) {
	  (0, _inherits3.default)(UnitHealthDropdown, _React$Component);
	
	  function UnitHealthDropdown() {
	    (0, _classCallCheck3.default)(this, UnitHealthDropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitHealthDropdown.__proto__ || (0, _getPrototypeOf2.default)(UnitHealthDropdown)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    _this.state = { dropdownItems: _this.getDropdownItems() };
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitHealthDropdown, [{
	    key: "getDropdownItems",
	    value: function getDropdownItems() {
	      var keys = (0, _keys2.default)(_UnitHealthStatus2.default).filter(function (key) {
	        return key !== "NA" && key !== "WARN";
	      });
	
	      var items = keys.map(function (key) {
	        return {
	          id: key,
	          html: _UnitHealthStatus2.default[key].title,
	          selectedHtml: _UnitHealthStatus2.default[key].title
	        };
	      });
	
	      items.unshift(DEFAULT_ITEM);
	
	      return items;
	    }
	  }, {
	    key: "setDropdownValue",
	    value: function setDropdownValue(id) {
	      this.dropdown.setState({
	        selectedID: id
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          dropdownMenuClassName = _props.dropdownMenuClassName,
	          initialID = _props.initialID,
	          onHealthSelection = _props.onHealthSelection;
	      var dropdownItems = this.state.dropdownItems;
	
	
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        buttonClassName: className,
	        dropdownMenuClassName: dropdownMenuClassName,
	        dropdownMenuListClassName: "dropdown-menu-list",
	        initialID: initialID,
	        items: dropdownItems,
	        onItemSelection: onHealthSelection,
	        ref: function ref(_ref) {
	          return _this2.dropdown = _ref;
	        },
	        scrollContainer: ".gm-scroll-view",
	        scrollContainerParentSelector: ".gm-prevented",
	        transition: true,
	        wrapperClassName: "dropdown"
	      });
	    }
	  }]);
	  return UnitHealthDropdown;
	}(_react2.default.Component);
	
	UnitHealthDropdown.propTypes = {
	  className: _react2.default.PropTypes.string,
	  dropdownMenuClassName: _react2.default.PropTypes.string,
	  initialID: _react2.default.PropTypes.string,
	  onHealthSelection: _react2.default.PropTypes.func
	};
	
	UnitHealthDropdown.defaultProps = {
	  className: "button dropdown-toggle text-align-left",
	  dropdownMenuClassName: "dropdown-menu"
	};
	
	module.exports = UnitHealthDropdown;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["renderHealth", "renderNode", "renderNodeRole"];
	
	var UnitHealthNodesTable = function (_React$Component) {
	  (0, _inherits3.default)(UnitHealthNodesTable, _React$Component);
	
	  function UnitHealthNodesTable() {
	    (0, _classCallCheck3.default)(this, UnitHealthNodesTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitHealthNodesTable.__proto__ || (0, _getPrototypeOf2.default)(UnitHealthNodesTable)).call(this));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    }, _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitHealthNodesTable, [{
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "25%" } }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "25%" } })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var classNameFn = _ResourceTableUtil2.default.getClassName;
	      var headings = _ResourceTableUtil2.default.renderHeading({
	        health: "HEALTH",
	        host_ip: "NODE",
	        role: "ROLE"
	      });
	
	      var sortFunction = _TableUtil2.default.getSortFunction("host_ip", function (node, prop) {
	        if (prop === "health") {
	          return _UnitHealthUtil2.default.getHealthSorting(node);
	        }
	
	        return node.get(prop);
	      });
	
	      return [{
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: headings,
	        prop: "health",
	        render: this.renderHealth,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: headings,
	        prop: "host_ip",
	        render: this.renderNode,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: headings,
	        prop: "role",
	        render: this.renderNodeRole,
	        sortable: true,
	        sortFunction: sortFunction
	      }];
	    }
	  }, {
	    key: "getNodeLink",
	    value: function getNodeLink(node, linkText) {
	      var unitID = this.props.params.unitID;
	
	      var unitNodeID = node.get("host_ip");
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: "table-cell-link-primary text-overflow",
	          to: "/components/" + unitID + "/nodes/" + unitNodeID
	        },
	        linkText
	      );
	    }
	  }, {
	    key: "renderHealth",
	    value: function renderHealth(prop, node) {
	      var health = node.getHealth();
	
	      return _react2.default.createElement(
	        "span",
	        { className: health.classNames },
	        _StringUtil2.default.capitalize(health.title)
	      );
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(prop, node) {
	      return this.getNodeLink(node, node.get(prop));
	    }
	  }, {
	    key: "renderNodeRole",
	    value: function renderNodeRole(prop, node) {
	      return _StringUtil2.default.capitalize(node.get(prop));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        containerSelector: ".gm-scroll-view",
	        data: this.props.nodes,
	        itemHeight: _TableUtil2.default.getRowHeight(),
	        sortBy: { prop: "health", order: "asc" }
	      });
	    }
	  }]);
	  return UnitHealthNodesTable;
	}(_react2.default.Component);
	
	UnitHealthNodesTable.propTypes = {
	  nodes: _react2.default.PropTypes.array.isRequired,
	  params: _react2.default.PropTypes.object
	};
	
	module.exports = UnitHealthNodesTable;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _EventTypes = __webpack_require__(933);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _HealthUnit = __webpack_require__(1370);
	
	var _HealthUnit2 = _interopRequireDefault(_HealthUnit);
	
	var _HealthUnitsList = __webpack_require__(1371);
	
	var _HealthUnitsList2 = _interopRequireDefault(_HealthUnitsList);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _NodesList = __webpack_require__(1049);
	
	var _NodesList2 = _interopRequireDefault(_NodesList);
	
	var _UnitHealthActions = __webpack_require__(1372);
	
	var _UnitHealthActions2 = _interopRequireDefault(_UnitHealthActions);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = null;
	
	function startPolling() {
	  if (requestInterval == null) {
	    _UnitHealthActions2.default.fetchUnits();
	    requestInterval = setInterval(_UnitHealthActions2.default.fetchUnits, _Config2.default.getRefreshRate());
	  }
	}
	
	function stopPolling() {
	  if (requestInterval != null) {
	    clearInterval(requestInterval);
	    requestInterval = null;
	  }
	}
	
	var UnitHealthStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(UnitHealthStore, _GetSetBaseStore);
	
	  function UnitHealthStore() {
	    (0, _classCallCheck3.default)(this, UnitHealthStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitHealthStore.__proto__ || (0, _getPrototypeOf2.default)(UnitHealthStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      units: [],
	      unitsByID: {},
	      nodesByUnitID: {},
	      nodesByID: {}
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.HEALTH_UNITS_CHANGE,
	        error: _EventTypes.HEALTH_UNITS_ERROR,
	        unitSuccess: _EventTypes.HEALTH_UNIT_SUCCESS,
	        unitError: _EventTypes.HEALTH_UNIT_ERROR,
	        nodesSuccess: _EventTypes.HEALTH_UNIT_NODES_SUCCESS,
	        nodesError: _EventTypes.HEALTH_UNIT_NODES_ERROR,
	        nodeSuccess: _EventTypes.HEALTH_UNIT_NODE_SUCCESS,
	        nodeError: _EventTypes.HEALTH_UNIT_NODE_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      var data = action.data;
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_HEALTH_UNITS_SUCCESS:
	          _this.processUnits(data);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNITS_ERROR:
	          _this.emit(_EventTypes.HEALTH_UNITS_ERROR, data);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_SUCCESS:
	          _this.processUnit(data, action.unitID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_ERROR:
	          _this.emit(_EventTypes.HEALTH_UNIT_ERROR, data, action.unitID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_NODES_SUCCESS:
	          _this.processNodes(data, action.unitID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_NODES_ERROR:
	          _this.emit(_EventTypes.HEALTH_UNIT_NODES_ERROR, data, action.unitID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_NODE_SUCCESS:
	          _this.processNode(data, action.unitID, action.nodeID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_UNIT_NODE_ERROR:
	          _this.emit(_EventTypes.HEALTH_UNIT_NODE_ERROR, data, action.unitID, action.nodeID);
	          break;
	      }
	
	      return true;
	    });
	
	    _VisibilityStore2.default.addChangeListener(_EventTypes.VISIBILITY_CHANGE, _this.onVisibilityStoreChange.bind(_this));
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitHealthStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	
	      if (this.shouldPoll()) {
	        startPolling();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "onVisibilityStoreChange",
	    value: function onVisibilityStoreChange() {
	      if (!_VisibilityStore2.default.isInactive() && this.shouldPoll()) {
	        startPolling();
	
	        return;
	      }
	
	      stopPolling();
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return !(this.listeners(_EventTypes.HEALTH_UNITS_CHANGE).length === 0);
	    }
	  }, {
	    key: "getUnits",
	    value: function getUnits() {
	      return new _HealthUnitsList2.default({
	        items: this.get("units")
	      });
	    }
	  }, {
	    key: "getUnit",
	    value: function getUnit(id) {
	      return new _HealthUnit2.default(this.get("unitsByID")[id] || {});
	    }
	  }, {
	    key: "getNodes",
	    value: function getNodes(unitID) {
	      var nodes = this.get("nodesByUnitID")[unitID] || [];
	
	      return new _NodesList2.default({ items: nodes });
	    }
	  }, {
	    key: "getNode",
	    value: function getNode(nodeID) {
	      return new _Node2.default(this.get("nodesByID")[nodeID] || {});
	    }
	  }, {
	    key: "getDownloadURL",
	    value: function getDownloadURL() {
	      return "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/report/download";
	    }
	  }, {
	    key: "fetchUnits",
	    value: function fetchUnits() {
	      return _UnitHealthActions2.default.fetchUnits.apply(_UnitHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchUnit",
	    value: function fetchUnit() {
	      return _UnitHealthActions2.default.fetchUnit.apply(_UnitHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchUnitNodes",
	    value: function fetchUnitNodes() {
	      return _UnitHealthActions2.default.fetchUnitNodes.apply(_UnitHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchUnitNode",
	    value: function fetchUnitNode() {
	      return _UnitHealthActions2.default.fetchUnitNode.apply(_UnitHealthActions2.default, arguments);
	    }
	  }, {
	    key: "processUnits",
	    value: function processUnits(units) {
	      this.set({ units: units });
	
	      this.emit(_EventTypes.HEALTH_UNITS_CHANGE);
	    }
	  }, {
	    key: "processUnit",
	    value: function processUnit(unitData, unitID) {
	      var unitsByID = this.get("unitsByID");
	      unitsByID[unitID] = unitData;
	
	      this.set({ unitsByID: unitsByID });
	
	      this.emit(_EventTypes.HEALTH_UNIT_SUCCESS, unitID);
	    }
	  }, {
	    key: "processNodes",
	    value: function processNodes(nodes, unitID) {
	      var nodesByUnitID = this.get("nodesByUnitID");
	      nodesByUnitID[unitID] = nodes;
	
	      this.set({ nodesByUnitID: nodesByUnitID });
	
	      this.emit(_EventTypes.HEALTH_UNIT_NODES_SUCCESS, unitID);
	    }
	  }, {
	    key: "processNode",
	    value: function processNode(nodeData, unitID, nodeID) {
	      var nodesByID = this.get("nodesByID");
	      nodesByID[nodeID] = nodeData;
	
	      this.set({ nodesByID: nodesByID });
	
	      this.emit(_EventTypes.HEALTH_UNIT_NODE_SUCCESS, unitID, nodeID);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "unitHealth";
	    }
	  }]);
	  return UnitHealthStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new UnitHealthStore();

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ID_PREFIX = "dcos-";
	var REPLACE_IN_ID = { dns: "DNS" };
	
	var HealthUnit = function (_Item) {
	  (0, _inherits3.default)(HealthUnit, _Item);
	
	  function HealthUnit() {
	    (0, _classCallCheck3.default)(this, HealthUnit);
	    return (0, _possibleConstructorReturn3.default)(this, (HealthUnit.__proto__ || (0, _getPrototypeOf2.default)(HealthUnit)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HealthUnit, [{
	    key: "getHealth",
	    value: function getHealth() {
	      return _UnitHealthUtil2.default.getHealth(this.get("health"));
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle() {
	      var title = this.get("name");
	      if (!title) {
	        title = this.getPrettyPrintID();
	      }
	
	      return title;
	    }
	  }, {
	    key: "getPrettyPrintID",
	    value: function getPrettyPrintID() {
	      var id = this.get("id") || "";
	      var prefixIndex = id.indexOf(ID_PREFIX);
	
	      if (prefixIndex >= 0) {
	        id = id.slice(prefixIndex + ID_PREFIX.length);
	      }
	
	      return _StringUtil2.default.idToTitle([id], [".", "-"], REPLACE_IN_ID, true);
	    }
	  }]);
	  return HealthUnit;
	}(_Item3.default);
	
	module.exports = HealthUnit;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _HealthUnit = __webpack_require__(1370);
	
	var _HealthUnit2 = _interopRequireDefault(_HealthUnit);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HealthUnitsList = function (_List) {
	  (0, _inherits3.default)(HealthUnitsList, _List);
	
	  function HealthUnitsList() {
	    (0, _classCallCheck3.default)(this, HealthUnitsList);
	    return (0, _possibleConstructorReturn3.default)(this, (HealthUnitsList.__proto__ || (0, _getPrototypeOf2.default)(HealthUnitsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HealthUnitsList, [{
	    key: "filter",
	    value: function filter(filters) {
	      var components = this.getItems();
	
	      if (filters) {
	        if (filters.title) {
	          components = _StringUtil2.default.filterByString(components, function (component) {
	            return component.getTitle();
	          }, filters.title);
	        }
	
	        if (filters.health) {
	          components = _UnitHealthUtil2.default.filterByHealth(components, filters.health);
	        }
	      }
	
	      return new HealthUnitsList({ items: components });
	    }
	  }]);
	  return HealthUnitsList;
	}(_List3.default);
	
	HealthUnitsList.type = _HealthUnit2.default;
	
	module.exports = HealthUnitsList;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitHealthActions = {
	  fetchUnits: function fetchUnits() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/units",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNITS_SUCCESS,
	          data: response.units
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNITS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchUnit: function fetchUnit(unitID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/units/" + unitID,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_SUCCESS,
	          data: response,
	          unitID: unitID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          unitID: unitID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchUnitNodes: function fetchUnitNodes(unitID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/units/" + unitID + "/nodes",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_NODES_SUCCESS,
	          data: response.nodes,
	          unitID: unitID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_NODES_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          unitID: unitID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchUnitNode: function fetchUnitNode(unitID, nodeID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/units/" + unitID + "/nodes/" + nodeID,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_NODE_SUCCESS,
	          data: response,
	          unitID: unitID,
	          nodeID: nodeID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_UNIT_NODE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          unitID: unitID,
	          nodeID: nodeID,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var unitsFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/units.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var unitFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/unit.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var unitNodesFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/unit-nodes.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var unitNodeFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/unit-node.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.UnitHealthActions = {
	    fetchUnits: {
	      event: "success",
	      success: { response: unitsFixture }
	    },
	    fetchUnit: { event: "success", success: { response: unitFixture } },
	    fetchUnitNodes: {
	      event: "success",
	      success: { response: unitNodesFixture }
	    },
	    fetchUnitNode: {
	      event: "success",
	      success: { response: unitNodeFixture }
	    }
	  };
	
	  (0, _keys2.default)(global.actionTypes.UnitHealthActions).forEach(function (method) {
	    UnitHealthActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(UnitHealthActions, "UnitHealthActions", method);
	  });
	}
	
	module.exports = UnitHealthActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	var _UnitsHealthNodeDetailPanel = __webpack_require__(1374);
	
	var _UnitsHealthNodeDetailPanel2 = _interopRequireDefault(_UnitsHealthNodeDetailPanel);
	
	var _UnitSummaries = __webpack_require__(1381);
	
	var _UnitSummaries2 = _interopRequireDefault(_UnitSummaries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var UnitHealthNodeDetailBreadcrumbs = function UnitHealthNodeDetailBreadcrumbs(_ref) {
	  var node = _ref.node,
	      unit = _ref.unit;
	
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Components" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/components" },
	        "Components"
	      )
	    )
	  )];
	
	  if (unit != null) {
	    var unitTitle = unit.getTitle();
	
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 1, title: "unitTitle" },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/components/" + unit.get("id") },
	          unitTitle
	        )
	      )
	    ));
	  }
	
	  if (node != null && unit != null) {
	    var nodeIP = node.get("host_ip");
	    var healthStatus = node.getHealth();
	
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 2, title: nodeIP },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/components/" + unit.get("id") + "/" + nodeIP },
	          nodeIP + " ",
	          _react2.default.createElement(
	            "span",
	            { className: healthStatus.classNames },
	            "(",
	            healthStatus.title,
	            ")"
	          )
	        )
	      )
	    ));
	  }
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "components", breadcrumbs: crumbs });
	};
	/* eslint-enable no-unused-vars */
	
	var UnitsHealthNodeDetail = function (_mixin) {
	  (0, _inherits3.default)(UnitsHealthNodeDetail, _mixin);
	
	  function UnitsHealthNodeDetail() {
	    (0, _classCallCheck3.default)(this, UnitsHealthNodeDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitsHealthNodeDetail.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthNodeDetail)).apply(this, arguments));
	
	    _this.state = {
	      hasError: false,
	      isLoadingUnit: true,
	      isLoadingNode: true
	    };
	
	    _this.store_listeners = [{
	      name: "unitHealth",
	      events: ["unitSuccess", "unitError", "nodeSuccess", "nodeError"],
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitsHealthNodeDetail, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(UnitsHealthNodeDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthNodeDetail.prototype), "componentDidMount", this).apply(this, arguments);
	      var _props$params = this.props.params,
	          unitID = _props$params.unitID,
	          unitNodeID = _props$params.unitNodeID;
	
	
	      _UnitHealthStore2.default.fetchUnit(unitID);
	      _UnitHealthStore2.default.fetchUnitNode(unitID, unitNodeID);
	    }
	  }, {
	    key: "onUnitHealthStoreUnitSuccess",
	    value: function onUnitHealthStoreUnitSuccess() {
	      this.setState({ isLoadingUnit: false });
	    }
	  }, {
	    key: "onUnitHealthStoreUnitError",
	    value: function onUnitHealthStoreUnitError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "onUnitHealthStoreNodeSuccess",
	    value: function onUnitHealthStoreNodeSuccess() {
	      this.setState({ isLoadingNode: false });
	    }
	  }, {
	    key: "onUnitHealthStoreNodeError",
	    value: function onUnitHealthStoreNodeError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "getErrorNotice",
	    value: function getErrorNotice() {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod" },
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _state = this.state,
	          hasError = _state.hasError,
	          isLoadingNode = _state.isLoadingNode,
	          isLoadingUnit = _state.isLoadingUnit;
	
	
	      if (hasError) {
	        return this.getErrorNotice();
	      }
	
	      if (isLoadingNode || isLoadingUnit) {
	        return this.getLoadingScreen();
	      }
	
	      var _props$params2 = this.props.params,
	          unitID = _props$params2.unitID,
	          unitNodeID = _props$params2.unitNodeID;
	
	
	      var node = _UnitHealthStore2.default.getNode(unitNodeID);
	      var unit = _UnitHealthStore2.default.getUnit(unitID);
	
	      var unitSummary = _UnitSummaries2.default[unit.get("id")] || {};
	      var unitDocsURL = unitSummary.getDocumentationURI && unitSummary.getDocumentationURI();
	
	      return _react2.default.createElement(_UnitsHealthNodeDetailPanel2.default, {
	        routes: this.props.routes,
	        params: this.props.params,
	        docsURL: unitDocsURL,
	        hostIP: node.get("host_ip"),
	        output: node.getOutput(),
	        summary: unitSummary.summary
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$params3 = this.props.params,
	          unitID = _props$params3.unitID,
	          unitNodeID = _props$params3.unitNodeID;
	
	
	      var node = _UnitHealthStore2.default.getNode(unitNodeID);
	      var unit = _UnitHealthStore2.default.getUnit(unitID);
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(UnitHealthNodeDetailBreadcrumbs, { node: node, unit: unit })
	        }),
	        this.getContent()
	      );
	    }
	  }]);
	  return UnitsHealthNodeDetail;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	module.exports = UnitsHealthNodeDetail;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NodeInfoPanel = __webpack_require__(1375);
	
	var _NodeInfoPanel2 = _interopRequireDefault(_NodeInfoPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitsHealthNodeDetailPanel = function (_React$Component) {
	  (0, _inherits3.default)(UnitsHealthNodeDetailPanel, _React$Component);
	
	  function UnitsHealthNodeDetailPanel() {
	    (0, _classCallCheck3.default)(this, UnitsHealthNodeDetailPanel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitsHealthNodeDetailPanel.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthNodeDetailPanel)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitsHealthNodeDetailPanel, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          summary = _props.summary,
	          docsURL = _props.docsURL,
	          output = _props.output;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-container-col" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex-container-col flex-grow no-overflow" },
	          _react2.default.createElement(_NodeInfoPanel2.default, { docsURL: docsURL, output: output, summary: summary })
	        )
	      );
	    }
	  }]);
	  return UnitsHealthNodeDetailPanel;
	}(_react2.default.Component);
	
	UnitsHealthNodeDetailPanel.propTypes = {
	  docsURL: _react2.default.PropTypes.string,
	  hostIP: _react2.default.PropTypes.string,
	  output: _react2.default.PropTypes.string,
	  summary: _react2.default.PropTypes.string
	};
	
	module.exports = UnitsHealthNodeDetailPanel;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeInfoPanel = function (_React$Component) {
	  (0, _inherits3.default)(NodeInfoPanel, _React$Component);
	
	  function NodeInfoPanel() {
	    (0, _classCallCheck3.default)(this, NodeInfoPanel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodeInfoPanel.__proto__ || (0, _getPrototypeOf2.default)(NodeInfoPanel)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodeInfoPanel, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          summary = _props.summary,
	          docsURL = _props.docsURL,
	          output = _props.output;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Summary"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              summary
	            ),
	            docsURL && _react2.default.createElement(
	              "a",
	              { href: docsURL, target: "_blank" },
	              "View Documentation"
	            )
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Output"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                "pre",
	                { className: "flex-item-grow-1 flush-bottom" },
	                output
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return NodeInfoPanel;
	}(_react2.default.Component);
	
	NodeInfoPanel.propTypes = {
	  docsURL: _react2.default.PropTypes.string,
	  output: _react2.default.PropTypes.string,
	  summary: _react2.default.PropTypes.string
	};
	
	module.exports = NodeInfoPanel;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMap = function ConfigurationMap(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "configuration-map" },
	    props.children
	  );
	};
	
	module.exports = ConfigurationMap;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DetailViewSectionHeading = __webpack_require__(1378);
	
	var _DetailViewSectionHeading2 = _interopRequireDefault(_DetailViewSectionHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapHeading = function ConfigurationMapHeading(props) {
	  var children = props.children,
	      className = props.className,
	      level = props.level;
	
	  var classes = (0, _classnames2.default)("configuration-map-heading", className);
	
	  return _react2.default.createElement(
	    _DetailViewSectionHeading2.default,
	    { className: classes, level: level },
	    children
	  );
	};
	
	ConfigurationMapHeading.defaultProps = {
	  level: 1
	};
	
	ConfigurationMapHeading.propTypes = {
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  level: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6])
	};
	
	module.exports = ConfigurationMapHeading;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailViewSectionHeading = function DetailViewSectionHeading(props) {
	  var children = props.children,
	      className = props.className,
	      level = props.level;
	
	
	  var headingProps = {
	    className: (0, _classnames2.default)("detail-view-section-heading", { "detail-view-section-heading-primary": level === 1 }, className)
	  };
	
	  return _react2.default.createElement("h" + level, headingProps, children);
	};
	
	DetailViewSectionHeading.defaultProps = {
	  level: 1
	};
	
	DetailViewSectionHeading.propTypes = {
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  level: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6])
	};
	
	module.exports = DetailViewSectionHeading;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapRow = function ConfigurationMapRow(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "configuration-map-row table-row" },
	    props.children
	  );
	};
	
	module.exports = ConfigurationMapRow;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapSection = function ConfigurationMapSection(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "configuration-map-section" },
	    props.children
	  );
	};
	
	module.exports = ConfigurationMapSection;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitSummaries = {
	  "dcos-marathon.service": {
	    summary: "The " + _Config2.default.productName + " Marathon instance starts and monitors " + _Config2.default.productName + " applications and services.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/overview/components/");
	    }
	  },
	  "dcos-mesos-dns.service": {
	    summary: "Mesos DNS provides service discovery within the cluster.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/overview/components/");
	    }
	  },
	  "dcos-mesos-master.service": {
	    summary: "The Mesos master process orchestrates agent tasks.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/getting-started/installing/installing-enterprise-edition/troubleshooting/#scrollNav-2");
	    }
	  },
	  "dcos-signal.service": {
	    summary: "Sends a periodic ping back to Mesosphere with high-level cluster information to help improve " + _Config2.default.productName + ", and provides advance monitoring of cluster issues.'",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-gen-resolvconf.timer": {
	    summary: "Sets the dcos-gen-resolvconf.service to be run once a minute.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/getting-started/installing/installing-enterprise-edition/troubleshooting/#scrollNav-2");
	    }
	  },
	  "dcos-exhibitor.service": {
	    summary: "Manages " + _Config2.default.productName + " in-cluster Zookeeper, used by Mesos as well as " + _Config2.default.productName + " Marathon.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/getting-started/overview/");
	    }
	  },
	  "dcos-history-service.service": {
	    summary: "Caches recent cluster history in-memory so that the " + _Config2.default.productName + " web interface can show recent data",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-logrotate.service": {
	    summary: "Logrotate allows for the automatic rotation compression, removal, and mailing of log files.",
	    getDocumentationURI: function getDocumentationURI() {
	      return "https://github.com/logrotate/logrotate/blob/master/README.md";
	    }
	  },
	  "dcos-link-env.service": {
	    summary: "Makes vendored " + _Config2.default.productName + " binaries, such as the mesos-master, mesos-slave, available at the command line when SSHing to a host.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-download.service": {
	    summary: "Downloads and extracts the " + _Config2.default.productName + " bootstrap tarball into /opt/mesosphere on your nodes.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-logrotate.timer": {
	    summary: "Rotates the Mesos master and agent log files to prevent filling the disk.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-signal.timer": {
	    summary: "Sets the dcos-signal.service interval at once an hour.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-gunicorn-bouncer.service": {
	    summary: "Processes login requests from users, as well as checking if an authorization token is valid.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/installing-enterprise-edition-1-6/security-and-authentication/");
	    }
	  },
	  "dcos-adminrouter-reload.service": {
	    summary: "Restart the Admin Router Nginx server so that it picks up new DNS resolutions, for example master.mesos, leader.mesos.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-nginx-reload.timer": {
	    summary: "Sets the dcos-adminrouter-reload.service interval at once an hour.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-setup.service": {
	    summary: "Specializes the " + _Config2.default.productName + " bootstrap tarball for the particular cluster, as well as its cluster role.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-mesos-slave.service": {
	    summary: "Runs a Mesos agent on the node.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-keepalived.service": {
	    summary: "Runs keepalived to make a VRRP load balancer that can be used to access the masters.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-adminrouter.service": {
	    summary: "Runs the " + _Config2.default.productName + " web interface, as well as a reverse proxy so that administrative interfaces of " + _Config2.default.productName + " Service can be accessed from outside the cluster.'",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/");
	    }
	  },
	  "dcos-gen-resolvconf.service": {
	    summary: "Periodically writes /etc/resolv.conf so that only currently active Mesos masters with working Mesos DNS are in it.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/getting-started/installing/installing-enterprise-edition/troubleshooting/#scrollNav-6");
	    }
	  },
	  "dcos-mesos-slave-public": {
	    summary: "Runs a publicly accessible Mesos agent on the node.",
	    getDocumentationURI: function getDocumentationURI() {
	      return _MetadataStore2.default.buildDocsURI("/administration/dcosarchitecture/security/#scrollNav-3");
	    }
	  }
	};
	
	module.exports = UnitSummaries;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterButtons = __webpack_require__(1383);
	
	var _FilterButtons2 = _interopRequireDefault(_FilterButtons);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var UnitHealthBreadcrumbs = function UnitHealthBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Components" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/components" },
	        "Components"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "components", breadcrumbs: crumbs });
	};
	/* eslint-disable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleHealthFilterChange", "handleSearchStringChange", "renderUnit", "renderHealth", "resetFilter"];
	
	var UnitsHealthTab = function (_mixin) {
	  (0, _inherits3.default)(UnitsHealthTab, _mixin);
	
	  function UnitsHealthTab() {
	    (0, _classCallCheck3.default)(this, UnitsHealthTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitsHealthTab.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthTab)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "unitHealth",
	      events: ["success", "error"],
	      suppressUpdate: false
	    }];
	
	    _this.state = {
	      healthFilter: "all",
	      searchString: ""
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    }, _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitsHealthTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(UnitsHealthTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthTab.prototype), "componentDidMount", this).call(this);
	      _UnitHealthStore2.default.fetchUnits();
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "renderUnit",
	    value: function renderUnit(prop, unit) {
	      return _react2.default.createElement(
	        "div",
	        { className: "text-overflow" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: "/components/" + unit.get("id"),
	            className: "table-cell-link-primary"
	          },
	          unit.getTitle()
	        )
	      );
	    }
	  }, {
	    key: "renderHealth",
	    value: function renderHealth(prop, unit) {
	      var health = unit.getHealth();
	
	      return _react2.default.createElement(
	        "span",
	        { className: health.classNames },
	        _StringUtil2.default.capitalize(health.title)
	      );
	    }
	  }, {
	    key: "getButtonContent",
	    value: function getButtonContent(filterName, count) {
	      var dotClassSet = (0, _classnames2.default)({
	        dot: filterName !== "all",
	        danger: filterName === "unhealthy",
	        success: filterName === "healthy"
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: "badge-container button-align-content label flush" },
	        _react2.default.createElement("span", { className: dotClassSet }),
	        _react2.default.createElement(
	          "span",
	          { className: "badge-container-text" },
	          _react2.default.createElement(
	            "span",
	            null,
	            _StringUtil2.default.capitalize(filterName)
	          )
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "badge badge-rounded" },
	          count || 0
	        )
	      );
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "75%" } }),
	        _react2.default.createElement("col", { style: { width: "25%" } })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var classNameFn = _ResourceTableUtil2.default.getClassName;
	      var sortFunction = _UnitHealthUtil2.default.getHealthSortFunction;
	      var getHealthSortingOrder = _TableUtil2.default.getHealthSortingOrder;
	
	      return [{
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: _ResourceTableUtil2.default.renderHeading({ name: "NAME" }),
	        prop: "name",
	        render: this.renderUnit,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: _ResourceTableUtil2.default.renderHeading({ health: "HEALTH" }),
	        prop: "health",
	        render: this.renderHealth,
	        sortable: true,
	        sortFunction: getHealthSortingOrder
	      }];
	    }
	  }, {
	    key: "handleHealthFilterChange",
	    value: function handleHealthFilterChange(healthFilter) {
	      this.setState({ healthFilter: healthFilter });
	    }
	  }, {
	    key: "getVisibleData",
	    value: function getVisibleData(data, searchString, healthFilter) {
	      return data.filter({ title: searchString, health: healthFilter }).getItems();
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      this.setState({
	        searchString: "",
	        healthFilter: "all"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var data = _UnitHealthStore2.default.getUnits();
	      var dataItems = data.getItems();
	      var _state = this.state,
	          healthFilter = _state.healthFilter,
	          searchString = _state.searchString;
	
	      var visibleData = this.getVisibleData(data, searchString, healthFilter);
	      var dataHealth = dataItems.map(function (unit) {
	        return unit.getHealth();
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(UnitHealthBreadcrumbs, null) }),
	        _react2.default.createElement(
	          "div",
	          { className: "flex-container-col" },
	          _react2.default.createElement(
	            "div",
	            { className: "units-health-table-header" },
	            _react2.default.createElement(_FilterHeadline2.default, {
	              currentLength: visibleData.length,
	              isFiltering: healthFilter !== "all" || searchString !== "",
	              name: "Component",
	              onReset: this.resetFilter,
	              totalLength: dataItems.length
	            }),
	            _react2.default.createElement(
	              _FilterBar2.default,
	              { rightAlignLastNChildren: 1 },
	              _react2.default.createElement(_FilterInputText2.default, {
	                className: "flush-bottom",
	                searchString: searchString,
	                handleFilterChange: this.handleSearchStringChange
	              }),
	              _react2.default.createElement(_FilterButtons2.default, {
	                renderButtonContent: this.getButtonContent,
	                filters: ["all", "healthy", "unhealthy"],
	                filterByKey: "title",
	                onFilterChange: this.handleHealthFilterChange,
	                itemList: dataHealth,
	                selectedFilter: healthFilter
	              }),
	              _react2.default.createElement(
	                "a",
	                {
	                  href: _UnitHealthStore2.default.getDownloadURL(),
	                  className: "button button-primary",
	                  target: "_blank"
	                },
	                "Download Snapshot"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "page-body-content-fill flex-grow flex-container-col" },
	            _react2.default.createElement(_reactjsComponents.Table, {
	              className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	              columns: this.getColumns(),
	              colGroup: this.getColGroup(),
	              containerSelector: ".gm-scroll-view",
	              data: visibleData,
	              itemHeight: _TableUtil2.default.getRowHeight(),
	              sortBy: { prop: "health", order: "asc" }
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return UnitsHealthTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	UnitsHealthTab.routeConfig = {
	  label: "Components",
	  matches: /^\/components\/overview/
	};
	
	module.exports = UnitsHealthTab;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterButtons = function (_React$Component) {
	  (0, _inherits3.default)(FilterButtons, _React$Component);
	
	  function FilterButtons() {
	    (0, _classCallCheck3.default)(this, FilterButtons);
	    return (0, _possibleConstructorReturn3.default)(this, (FilterButtons.__proto__ || (0, _getPrototypeOf2.default)(FilterButtons)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FilterButtons, [{
	    key: "getCount",
	    value: function getCount(items) {
	      var counts = {};
	
	      items.forEach(function (value) {
	        if (typeof value === "string") {
	          value = value.toLowerCase();
	        }
	
	        counts[value] = counts[value] + 1 || 1;
	      });
	
	      // Include a key 'all' that is the total itemList size.
	      counts.all = items.length;
	
	      return counts;
	    }
	  }, {
	    key: "handleFilterChange",
	    value: function handleFilterChange(filter) {
	      this.props.onFilterChange(filter);
	    }
	  }, {
	    key: "getFilterButtons",
	    value: function getFilterButtons() {
	      var _this2 = this;
	
	      var _props = this.props,
	          filterByKey = _props.filterByKey,
	          filters = _props.filters,
	          inverseStyle = _props.inverseStyle,
	          itemList = _props.itemList,
	          selectedFilter = _props.selectedFilter;
	
	
	      if (filterByKey) {
	        itemList = itemList.map(function (item) {
	          return item[filterByKey];
	        });
	      }
	
	      var filterCount = this.getCount(itemList);
	
	      return filters.map(function (filter) {
	        var classSet = (0, _classnames2.default)("button button-stroke", {
	          "button-inverse": inverseStyle,
	          active: filter.toLowerCase() === selectedFilter.toLowerCase()
	        });
	
	        return _react2.default.createElement(
	          "button",
	          {
	            key: filter,
	            className: classSet,
	            onClick: _this2.handleFilterChange.bind(_this2, filter)
	          },
	          _this2.props.renderButtonContent(filter, filterCount[filter])
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "button-group flush-bottom" },
	        this.getFilterButtons()
	      );
	    }
	  }]);
	  return FilterButtons;
	}(_react2.default.Component);
	
	FilterButtons.defaultProps = {
	  inverseStyle: false,
	  onFilterChange: function onFilterChange() {},
	  renderButtonContent: function renderButtonContent(title) {
	    return title;
	  }
	};
	
	FilterButtons.propTypes = {
	  filters: _react2.default.PropTypes.array,
	  // The key in itemList that is being filtered
	  filterByKey: _react2.default.PropTypes.string,
	  inverseStyle: _react2.default.PropTypes.bool,
	  itemList: _react2.default.PropTypes.array.isRequired,
	  // A function that returns the onClick for a filter button given the filter.
	  onFilterChange: _react2.default.PropTypes.func,
	  // Optional function to generate button text. args: (filter, count)
	  renderButtonContent: _react2.default.PropTypes.func,
	  // The filter in props.filters that is currently selected.
	  selectedFilter: _react2.default.PropTypes.string
	};
	
	module.exports = FilterButtons;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _DashboardPage = __webpack_require__(1385);
	
	var _DashboardPage2 = _interopRequireDefault(_DashboardPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardRoutes = {
	  category: "root",
	  type: _reactRouter.Route,
	  path: "dashboard",
	  component: _DashboardPage2.default,
	  isInSidebar: true
	};
	
	module.exports = dashboardRoutes;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactIntl = __webpack_require__(753);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _ComponentList = __webpack_require__(1386);
	
	var _ComponentList2 = _interopRequireDefault(_ComponentList);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _HealthSorting = __webpack_require__(1058);
	
	var _HealthSorting2 = _interopRequireDefault(_HealthSorting);
	
	var _HostTimeSeriesChart = __webpack_require__(1387);
	
	var _HostTimeSeriesChart2 = _interopRequireDefault(_HostTimeSeriesChart);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Panel = __webpack_require__(1042);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _ResourceTimeSeriesChart = __webpack_require__(1399);
	
	var _ResourceTimeSeriesChart2 = _interopRequireDefault(_ResourceTimeSeriesChart);
	
	var _ServiceList = __webpack_require__(1401);
	
	var _ServiceList2 = _interopRequireDefault(_ServiceList);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TasksChart = __webpack_require__(1404);
	
	var _TasksChart2 = _interopRequireDefault(_TasksChart);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getMesosState() {
	  var states = _MesosSummaryStore2.default.get("states");
	  var last = states.lastSuccessful();
	
	  return {
	    activeNodes: states.getActiveNodesByState(),
	    hostCount: last.getActiveSlaves().length,
	    usedResourcesStates: states.getResourceStatesForNodeIDs(),
	    usedResources: last.getSlaveUsedResources(),
	    tasks: last.getServiceList().sumTaskStates(),
	    totalResources: last.getSlaveTotalResources()
	  };
	}
	
	var DashboardBreadcrumbs = function DashboardBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Dashboard" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/dashboard" },
	        "Dashboard"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "graph", breadcrumbs: crumbs });
	};
	
	var DashboardPage = _react2.default.createClass({
	  displayName: "DashboardPage",
	
	  mixins: [_InternalStorageMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  statics: {
	    routeConfig: {
	      label: "Dashboard",
	      icon: _react2.default.createElement(_Icon2.default, { id: "graph-inverse", size: "small", family: "product" }),
	      matches: /^\/dashboard/
	    },
	
	    // Static life cycle method from react router, that will be called
	    // 'when a handler is about to render', i.e. on route change:
	    // https://github.com/rackt/react-router/
	    // blob/master/docs/api/components/RouteHandler.md
	    willTransitionTo: function willTransitionTo() {
	      _SidebarActions2.default.close();
	    }
	  },
	
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      componentsListLength: 5,
	      servicesListLength: 5
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.store_listeners = [{ name: "dcos", events: ["change"], suppressUpdate: true }, { name: "summary", events: ["success", "error"], suppressUpdate: false }, {
	      name: "unitHealth",
	      events: ["success", "error"],
	      suppressUpdate: false
	    }];
	
	    this.internalStorage_set({
	      openServicePanel: false,
	      openTaskPanel: false
	    });
	    this.internalStorage_update(getMesosState());
	  },
	  onSummaryStoreError: function onSummaryStoreError() {
	    this.internalStorage_update(getMesosState());
	  },
	  onSummaryStoreSuccess: function onSummaryStoreSuccess() {
	    this.internalStorage_update(getMesosState());
	  },
	  getServicesList: function getServicesList() {
	    var services = _DCOSStore2.default.serviceTree.getServices().getItems();
	
	    var sortedServices = services.sort(function (service, other) {
	      var health = service.getHealth();
	      var otherHealth = other.getHealth();
	
	      return _HealthSorting2.default[health.key] - _HealthSorting2.default[otherHealth.key];
	    });
	
	    return sortedServices.slice(0, this.props.servicesListLength);
	  },
	  getUnits: function getUnits() {
	    return _UnitHealthStore2.default.getUnits();
	  },
	  getViewAllComponentsButton: function getViewAllComponentsButton() {
	    var componentCount = this.getUnits().getItems().length;
	    if (!componentCount) {
	      return null;
	    }
	
	    var componentCountWord = _StringUtil2.default.pluralize("Component", componentCount);
	
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      { to: "/components", className: "button button-rounded button-stroke" },
	      "View all " + componentCount + " " + componentCountWord
	    );
	  },
	  getViewAllServicesBtn: function getViewAllServicesBtn() {
	    var servicesCount = _DCOSStore2.default.serviceTree.getServices().getItems().length;
	    if (!servicesCount) {
	      return null;
	    }
	
	    if (servicesCount < this.props.servicesListLength) {
	      servicesCount = null;
	    }
	
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      { to: "/services", className: "button button-rounded button-stroke" },
	      _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: "DASHBOARD.VIEW_ALL",
	        values: {
	          servicesCount: servicesCount
	        }
	      })
	    );
	  },
	  getHeading: function getHeading(translationId) {
	    return _react2.default.createElement(
	      "h6",
	      { className: "flush text-align-center" },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: translationId })
	    );
	  },
	  render: function render() {
	    var columnClasses = "column-12 column-small-6 column-large-4";
	    var data = this.internalStorage_get();
	
	    return _react2.default.createElement(
	      _Page2.default,
	      { title: "Dashboard" },
	      _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(DashboardBreadcrumbs, null) }),
	      _react2.default.createElement(
	        "div",
	        { className: "panel-grid row" },
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-chart dashboard-panel-chart-timeseries panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.CPU")
	            },
	            _react2.default.createElement(_ResourceTimeSeriesChart2.default, {
	              colorIndex: 0,
	              usedResourcesStates: data.usedResourcesStates,
	              usedResources: data.usedResources,
	              totalResources: data.totalResources,
	              mode: "cpus",
	              refreshRate: _Config2.default.getRefreshRate()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-chart dashboard-panel-chart-timeseries panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.MEMORY")
	            },
	            _react2.default.createElement(_ResourceTimeSeriesChart2.default, {
	              colorIndex: 6,
	              usedResourcesStates: data.usedResourcesStates,
	              usedResources: data.usedResources,
	              totalResources: data.totalResources,
	              mode: "mem",
	              refreshRate: _Config2.default.getRefreshRate()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-chart dashboard-panel-chart-timeseries panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.DISK")
	            },
	            _react2.default.createElement(_ResourceTimeSeriesChart2.default, {
	              colorIndex: 3,
	              usedResourcesStates: data.usedResourcesStates,
	              usedResources: data.usedResources,
	              totalResources: data.totalResources,
	              mode: "disk",
	              refreshRate: _Config2.default.getRefreshRate()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-list dashboard-panel-list-service-health allow-overflow panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.SERVICES_HEALTH"),
	              footer: this.getViewAllServicesBtn(),
	              footerClass: "text-align-center"
	            },
	            _react2.default.createElement(_ServiceList2.default, {
	              healthProcessed: _DCOSStore2.default.serviceDataReceived,
	              services: this.getServicesList()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-chart panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.TASKS")
	            },
	            _react2.default.createElement(_TasksChart2.default, { tasks: data.tasks })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-list dashboard-panel-list-component-health panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.COMPONENT_HEALTH"),
	              footer: this.getViewAllComponentsButton(),
	              footerClass: "text-align-center"
	            },
	            _react2.default.createElement(_ComponentList2.default, {
	              displayCount: this.props.componentsListLength,
	              units: this.getUnits()
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: columnClasses },
	          _react2.default.createElement(
	            _Panel2.default,
	            {
	              className: "dashboard-panel dashboard-panel-chart dashboard-panel-chart-timeseries panel",
	              heading: this.getHeading("DASHBOARD.PANEL_HEADING.NODES")
	            },
	            _react2.default.createElement(_HostTimeSeriesChart2.default, {
	              data: data.activeNodes,
	              currentValue: data.hostCount,
	              refreshRate: _Config2.default.getRefreshRate()
	            })
	          )
	        )
	      )
	    );
	  }
	});
	
	module.exports = DashboardPage;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentList = function (_React$Component) {
	  (0, _inherits3.default)(ComponentList, _React$Component);
	
	  function ComponentList() {
	    (0, _classCallCheck3.default)(this, ComponentList);
	    return (0, _possibleConstructorReturn3.default)(this, (ComponentList.__proto__ || (0, _getPrototypeOf2.default)(ComponentList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ComponentList, [{
	    key: "getComponentListContent",
	    value: function getComponentListContent(units) {
	      return units.map(function (unit) {
	        var health = unit.getHealth();
	        var healthClasses = (0, _classnames2.default)("text-align-right", health.classNames);
	        var unitID = unit.get("id");
	
	        return {
	          content: [{
	            className: "dashboard-health-list-item-description text-overflow",
	            content: _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/components/" + unitID,
	                className: "dashboard-health-list-item-cell emphasis"
	              },
	              unit.getTitle()
	            ),
	            tag: "span"
	          }, {
	            className: "dashboard-health-list-health-label",
	            content: _react2.default.createElement(
	              "div",
	              { key: "health", className: healthClasses },
	              health.title
	            ),
	            tag: "div"
	          }]
	        };
	      });
	    }
	
	    /**
	    * Order health status
	    * based on HealthSorting mapping value
	    * where lowest (0) (top of the list) is most important for visibility
	    * and highest (3) (bottom of the list) 3 is least important for visibility
	    *
	    * @param {Array} items
	    * @returns {Number} item position
	    */
	
	  }, {
	    key: "getSortedHealthValues",
	    value: function getSortedHealthValues(items) {
	      items.sort(function (a, b) {
	        var aHealthScore = a.getHealth().sortingValue;
	        var bHealthScore = b.getHealth().sortingValue;
	
	        if (aHealthScore === bHealthScore) {
	          aHealthScore = a.getTitle();
	          bHealthScore = b.getTitle();
	        }
	
	        if (aHealthScore > bHealthScore) {
	          return 1;
	        }
	
	        if (aHealthScore < bHealthScore) {
	          return -1;
	        }
	
	        return 0;
	      });
	
	      return items;
	    }
	
	    /**
	     * Check if the number of units is greater
	     * than the number of possible visible units
	     * return the only what can be visible
	     *
	     * @param {Array} units
	     * @returns {Array} only units visible
	     *
	     * @memberOf ComponentList
	     */
	
	  }, {
	    key: "getVisibleComponents",
	    value: function getVisibleComponents(units) {
	      var displayCount = this.props.displayCount;
	
	
	      if (units.length > displayCount) {
	        return units.slice(0, displayCount);
	      }
	
	      return units;
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "flush-top text-align-center" },
	          "Components Not Found"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush text-align-center" },
	          "An error has occurred."
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var units = this.props.units;
	
	      units = units.getItems();
	
	      if (units.length === 0) {
	        return this.getErrorMessage();
	      }
	
	      var sortedUnits = this.getSortedHealthValues(units);
	      var visibleUnits = this.getVisibleComponents(sortedUnits);
	      var content = this.getComponentListContent(visibleUnits);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "dashboard-health-list" },
	        _react2.default.createElement(_reactjsComponents.List, {
	          className: "list list-unstyled",
	          content: content,
	          transition: false
	        })
	      );
	    }
	  }]);
	  return ComponentList;
	}(_react2.default.Component);
	
	ComponentList.defaultProps = {
	  displayCount: 0
	};
	
	ComponentList.propTypes = {
	  displayCount: _react2.default.PropTypes.number,
	  // Required object of type HealthUnitsList.
	  units: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = ComponentList;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _TimeSeriesChart = __webpack_require__(1389);
	
	var _TimeSeriesChart2 = _interopRequireDefault(_TimeSeriesChart);
	
	var _TimeSeriesLabel = __webpack_require__(1398);
	
	var _TimeSeriesLabel2 = _interopRequireDefault(_TimeSeriesLabel);
	
	var _ValueTypes = __webpack_require__(1397);
	
	var _ValueTypes2 = _interopRequireDefault(_ValueTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HostTimeSeriesChart = _react2.default.createClass({
	  displayName: "HostTimeSeriesChart",
	
	  propTypes: {
	    data: _react2.default.PropTypes.array.isRequired,
	    refreshRate: _react2.default.PropTypes.number.isRequired,
	    roundUpValue: _react2.default.PropTypes.number,
	    minMaxY: _react2.default.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      roundUpValue: 5,
	      minMaxY: 10
	    };
	  },
	  getMaxY: function getMaxY() {
	    var props = this.props;
	    var roundUpValue = props.roundUpValue;
	    var slavesCounts = props.data.map(function (agent) {
	      return agent.slavesCount;
	    });
	    var maxSlavesCount = Math.max.apply(Math, (0, _toConsumableArray3.default)(slavesCounts));
	
	    var maxY = maxSlavesCount + (roundUpValue - maxSlavesCount % roundUpValue);
	
	    if (maxY < props.minMaxY) {
	      maxY = props.minMaxY;
	    }
	
	    return maxY;
	  },
	  getData: function getData(props) {
	    return [{
	      name: "Nodes",
	      colorIndex: 4,
	      values: props.data
	    }];
	  },
	  getChart: function getChart(props) {
	    return _react2.default.createElement(
	      _Chart2.default,
	      null,
	      _react2.default.createElement(_TimeSeriesChart2.default, {
	        data: this.getData(props),
	        maxY: this.getMaxY(),
	        refreshRate: props.refreshRate,
	        y: "slavesCount",
	        yFormat: _ValueTypes2.default.ABSOLUTE
	      })
	    );
	  },
	  render: function render() {
	    var props = this.props;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "chart" },
	      _react2.default.createElement(_TimeSeriesLabel2.default, {
	        colorIndex: 4,
	        currentValue: props.currentValue,
	        subHeading: "Connected Nodes",
	        y: "slavesCount"
	      }),
	      this.getChart(props)
	    );
	  }
	});
	
	module.exports = HostTimeSeriesChart;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chart = _react2.default.createClass({
	  displayName: "Chart",
	
	  mixins: [_InternalStorageMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  propTypes: {
	    calcHeight: _react2.default.PropTypes.func,
	    delayRender: _react2.default.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      calcHeight: null,
	      delayRender: false
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.store_listeners = [{
	      name: "sidebar",
	      events: ["widthChange"],
	      suppressUpdate: false
	    }];
	
	    this.internalStorage_set({ width: null });
	  },
	  componentDidMount: function componentDidMount() {
	    if (this.props.delayRender) {
	      // As of right now this is used on the Side Panels
	      // because they animate in we need to wait on calling
	      // `window.getComputedStyle` because it'll cause a repaint
	      // which causes the panel to not animate
	      // Making this happen on the next tick fixes it.
	      setTimeout(this.updateWidth, 0);
	    } else {
	      this.updateWidth();
	    }
	    global.addEventListener("resize", this.updateWidth);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    global.removeEventListener("resize", this.updateWidth);
	  },
	  onSidebarStoreWidthChange: function onSidebarStoreWidthChange() {
	    this.updateWidth();
	  },
	  updateWidth: function updateWidth() {
	    if (!this.isMounted()) {
	      return;
	    }
	    var node = _reactDom2.default.findDOMNode(this);
	    var dimensions = _DOMUtils2.default.getComputedDimensions(node);
	    var data = this.internalStorage_get();
	
	    if (data.width !== dimensions.width || data.height !== dimensions.height) {
	      this.internalStorage_set(dimensions);
	      this.forceUpdate();
	    }
	  },
	  getChildren: function getChildren() {
	    var data = this.internalStorage_get();
	    var width = data.width;
	    var height = data.height;
	    if (width != null) {
	      var calcHeight = this.props.calcHeight;
	
	      if (typeof calcHeight === "function") {
	        height = calcHeight(width);
	      }
	
	      var children = this.props.children;
	      if (Array.isArray(children)) {
	        height = height / children.length;
	
	        return children.map(function (child) {
	          return _react2.default.cloneElement(child, { width: width, height: height });
	        });
	      } else {
	        return _react2.default.cloneElement(children, { width: width, height: height });
	      }
	    }
	  },
	  render: function render() {
	    // at the moment, 'chart' is used to inject the chart color palette.
	    // we should reclaim it as the rightful className of <Chart />
	    return _react2.default.createElement(
	      "div",
	      { className: "chart-chart" },
	      this.getChildren()
	    );
	  }
	});
	
	module.exports = Chart;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AnimationCircle = __webpack_require__(1391);
	
	var _AnimationCircle2 = _interopRequireDefault(_AnimationCircle);
	
	var _ChartMixin = __webpack_require__(1392);
	
	var _ChartMixin2 = _interopRequireDefault(_ChartMixin);
	
	var _ChartStripes = __webpack_require__(1393);
	
	var _ChartStripes2 = _interopRequireDefault(_ChartStripes);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _Maths = __webpack_require__(1051);
	
	var _Maths2 = _interopRequireDefault(_Maths);
	
	var _Rect = __webpack_require__(1394);
	
	var _Rect2 = _interopRequireDefault(_Rect);
	
	var _TimeSeriesArea = __webpack_require__(1395);
	
	var _TimeSeriesArea2 = _interopRequireDefault(_TimeSeriesArea);
	
	var _TimeSeriesMouseOver = __webpack_require__(1396);
	
	var _TimeSeriesMouseOver2 = _interopRequireDefault(_TimeSeriesMouseOver);
	
	var _ValueTypes = __webpack_require__(1397);
	
	var _ValueTypes2 = _interopRequireDefault(_ValueTypes);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeSeriesChart = _react2.default.createClass({
	  displayName: "TimeSeriesChart",
	
	  propTypes: {
	    axisConfiguration: _react2.default.PropTypes.object,
	    // [{name: 'Area Name', values: [{date: some time, y: 0}]}]
	    data: _react2.default.PropTypes.array.isRequired,
	    // `height` and `width` are required if this
	    // module isn't used as a child of the `Chart` component
	    // Otherwise Chart will automatically calculate this.
	    height: _react2.default.PropTypes.number,
	    margin: _react2.default.PropTypes.object.isRequired,
	    maxY: _react2.default.PropTypes.number,
	    refreshRate: _react2.default.PropTypes.number.isRequired,
	    ticksY: _react2.default.PropTypes.number,
	    y: _react2.default.PropTypes.string,
	    yFormat: _react2.default.PropTypes.string,
	    width: _react2.default.PropTypes.number
	  },
	
	  mixins: [_ChartMixin2.default, _InternalStorageMixin2.default],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      axisConfiguration: {
	        x: {
	          showZeroTick: true
	        }
	      },
	      margin: {
	        top: 10,
	        left: 45,
	        bottom: 25,
	        right: 5
	      },
	      maxY: 10,
	      refreshRate: 0,
	      ticksY: 3,
	      y: "y",
	      yFormat: _ValueTypes2.default.PERCENTAGE
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.internalStorage_set({
	      clipPathID: "clip-" + _Util2.default.uniqueID(),
	      maskID: "mask-" + _Util2.default.uniqueID()
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	    var height = this.getHeight(props);
	    var width = this.getWidth(props);
	
	    this.renderAxis(props, width, height);
	    this.createClipPath(width, height);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    var props = this.props;
	
	    // The d3 axis helper requires a <g> element passed into do its work. This
	    // happens after mount and ends up keeping the axis code outside of react
	    // unfortunately.
	    // If non `data` props change then we need to update the whole graph
	    if (!(0, _deepEqual2.default)(_Util2.default.omit(props, "data"), _Util2.default.omit(nextProps, "data"))) {
	      var height = this.getHeight(nextProps);
	      var width = this.getWidth(nextProps);
	
	      this.renderAxis(nextProps, width, height);
	
	      return true;
	    }
	
	    // This won't be scalable if we decide to stack graphs
	    var prevVal = props.data[0].values;
	    var nextVal = nextProps.data[0].values;
	
	    var prevY = prevVal.map(function (value) {
	      return value[props.y];
	    });
	    var nextY = nextVal.map(function (value) {
	      return value[props.y];
	    });
	
	    return !(0, _deepEqual2.default)(prevY, nextY);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var props = this.props;
	    var height = this.getHeight(props);
	    var width = this.getWidth(props);
	
	    this.updateClipPath(width, height);
	  },
	  createClipPath: function createClipPath(width, height) {
	    var data = this.internalStorage_get();
	    var el = this.refs.movingEls;
	
	    // create clip path for areas and x-axis
	    _d2.default.select(el).append("defs").append("clipPath").attr("id", data.clipPathID).append("rect");
	
	    this.updateClipPath(width, height);
	  },
	  createUnsuccessfulBlocks: function createUnsuccessfulBlocks(data, xTimeScale) {
	    var transitionTime = this.getTransitionTime(data);
	    var nextY = this.getNextXPosition(data, xTimeScale, transitionTime);
	    var props = this.props;
	    var width = props.width / data.length;
	
	    return data.map(function (obj) {
	      if (obj[props.y] == null) {
	        var x = xTimeScale(obj.date - props.refreshRate);
	        var uniqueMaskID = _Util2.default.uniqueID("singleMask");
	
	        return _react2.default.createElement(_Rect2.default, {
	          width: width,
	          height: props.height,
	          x: x,
	          y: 0,
	          className: "unsuccessful-block",
	          transitionDuration: props.refreshRate,
	          transform: "translate(" + -nextY + ", 0)",
	          key: "" + uniqueMaskID + x
	        });
	      }
	    });
	  },
	  updateClipPath: function updateClipPath(width, height) {
	    var data = this.internalStorage_get();
	
	    _d2.default.select("#" + data.clipPathID + " rect").attr({
	      width: width,
	      height: height
	    });
	  },
	  getArea: function getArea(y, xTimeScale, yScale, firstSuccessful) {
	    // We need firstSuccessful because if the current value is null,
	    // we want to make it equal to the most recent successful value in order to
	    // have a straight line on the graph.
	    var value = firstSuccessful[y] || 0;
	    var successfulValue = yScale(value);
	
	    return _d2.default.svg.area().x(function (d) {
	      return xTimeScale(d.date);
	    }).y0(function () {
	      return yScale(0);
	    }).y1(function (d) {
	      if (d[y] != null) {
	        successfulValue = yScale(d[y]);
	      }
	
	      return successfulValue;
	    }).interpolate("monotone");
	  },
	  getValueLine: function getValueLine(xTimeScale, yScale, firstSuccessful) {
	    // We need firstSuccessful because if the current value is null,
	    // we want to make it equal to the most recent successful value in order to
	    // have a straight line on the graph.
	    var y = this.props.y;
	    var value = firstSuccessful[y] || 0.1;
	    var successfulValue = yScale(value);
	
	    return _d2.default.svg.line().x(function (d) {
	      return xTimeScale(d.date);
	    }).y(function (d) {
	      if (d[y] != null) {
	        successfulValue = yScale(d[y] || 0.1);
	      }
	
	      return successfulValue;
	    }).interpolate("monotone");
	  },
	  getXTickValues: function getXTickValues(xScale) {
	    var domain = xScale.domain();
	    var mean = _Maths2.default.mean(domain);
	
	    return [domain[0], mean, domain[domain.length - 1]];
	  },
	  getXTimeScale: function getXTimeScale(data, width) {
	    var date = Date.now();
	    var dateDelta = Date.now();
	
	    var firstDataSet = data[0];
	    if (firstDataSet != null) {
	      var hiddenValuesCount = 1;
	      var values = firstDataSet.values;
	      // [first date, last date - 1]
	      // Restrict x domain to have one extra point outside of graph area,
	      // since we are animating the graph in from right
	      date = values[0].date;
	      dateDelta = values[values.length - 1 - hiddenValuesCount].date;
	    }
	
	    return _d2.default.time.scale().range([0, width]).domain([date, dateDelta]);
	  },
	  getYScale: function getYScale(height, maxY) {
	    return _d2.default.scale.linear()
	    // give a little space in the top for the number
	    .range([height, 0]).domain([0, maxY]);
	  },
	  getYCaption: function getYCaption(yFormat) {
	    if (yFormat === _ValueTypes2.default.PERCENTAGE) {
	      return "%";
	    }
	
	    return "";
	  },
	  formatYAxis: function formatYAxis(props) {
	    var maxY = props.maxY;
	    var ticksY = props.ticksY;
	    var yFormat = props.yFormat;
	
	    if (yFormat === _ValueTypes2.default.PERCENTAGE) {
	      var formatPercent = _d2.default.scale.linear().tickFormat(ticksY, ".0" + this.getYCaption(yFormat));
	
	      return function (d) {
	        if (d >= maxY) {
	          return "100%";
	        }
	
	        return formatPercent(d / maxY);
	      };
	    }
	
	    return function (d) {
	      if (d >= maxY) {
	        return maxY;
	      }
	
	      return d;
	    };
	  },
	  renderAxis: function renderAxis(props, width, height) {
	    var xScale = this.getXScale(props.data, width, props.refreshRate);
	    var yScale = this.getYScale(height, props.maxY);
	
	    var xAxis = _d2.default.svg.axis().scale(xScale).tickValues(this.getXTickValues(xScale)).tickFormat(this.formatXAxis).orient("bottom");
	    _d2.default.select(this.refs.xAxis).interrupt().attr("transform", "translate(0," + height + ")").call(xAxis);
	
	    var yAxis = _d2.default.svg.axis().scale(yScale).ticks(props.ticksY).tickFormat(this.formatYAxis(props)).orient("left");
	    _d2.default.select(this.refs.yAxis).call(yAxis);
	
	    _d2.default.select(this.refs.grid).call(_d2.default.svg.axis().scale(yScale).orient("left").ticks(props.ticksY).tickSize(-width, 0, 0).tickFormat(""));
	  },
	  getTransitionTime: function getTransitionTime(data) {
	    // look at the difference between the last and the third last point
	    // to calculate transition time
	    var l = data.length - 1;
	
	    return (data[l].date - data[l - 1].date) / 1;
	  },
	
	
	  /*
	   * Returns the x position of the data point that we are about to animate in
	   */
	  getNextXPosition: function getNextXPosition(values, xTimeScale, transitionTime) {
	    var firstDataSet = values[0];
	    var date = Date.now();
	
	    if (firstDataSet != null) {
	      date = firstDataSet.date;
	    }
	
	    // add transition time since we are moving towards new pos
	    return xTimeScale(date + transitionTime);
	  },
	
	
	  /*
	   * Returns the y position of the data point that we are about to animate in
	   */
	  getNextYPosition: function getNextYPosition(obj, y, yScale, height) {
	    var latestDataPoint = _Util2.default.last(obj.values);
	
	    // most recent y - height of chart
	    return yScale(latestDataPoint[y]) - height;
	  },
	  getAreaList: function getAreaList(props, yScale, xTimeScale) {
	    var _this = this;
	
	    var firstSuccess = props.data[0].values.find(function (stateResource) {
	      return stateResource[props.y] != null;
	    }) || {};
	    // We need firstSuccess because if the current value is null,
	    // we want to make it equal to the most recent successful value in order to
	    // have a straight line on the graph.
	    var area = this.getArea(props.y, xTimeScale, yScale, firstSuccess);
	    var valueLine = this.getValueLine(xTimeScale, yScale, firstSuccess);
	
	    return props.data.map(function (stateResource, i) {
	      var transitionTime = _this.getTransitionTime(stateResource.values);
	      var nextY = _this.getNextXPosition(stateResource.values, xTimeScale, transitionTime);
	
	      return _react2.default.createElement(_TimeSeriesArea2.default, {
	        className: "path-color-" + stateResource.colorIndex,
	        key: i,
	        line: valueLine(stateResource.values),
	        path: area(stateResource.values),
	        position: [-nextY, 0],
	        transitionTime: transitionTime
	      });
	    });
	  },
	  getCircleList: function getCircleList(props, yScale, width, height) {
	    var _this2 = this;
	
	    return props.data.map(function (obj, i) {
	      var transitionTime = _this2.getTransitionTime(obj.values);
	      var lastObj = _Util2.default.last(obj.values);
	
	      if (lastObj[props.y] == null) {
	        return null;
	      }
	
	      var nextX = _this2.getNextYPosition(obj, props.y, yScale, height);
	
	      return _react2.default.createElement(_AnimationCircle2.default, {
	        className: "arc path-color-" + obj.colorIndex,
	        cx: width,
	        cy: height,
	        key: i,
	        position: [0, nextX],
	        transitionTime: transitionTime
	      });
	    });
	  },
	  getBoundingBox: function getBoundingBox(props) {
	    var margin = props.margin;
	
	    return function () {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elPosition = el.getBoundingClientRect();
	
	      return {
	        top: elPosition.top + margin.top,
	        right: elPosition.left + props.width - margin.right,
	        bottom: elPosition.top + props.height - margin.bottom,
	        left: elPosition.left + margin.left
	      };
	    }.bind(this);
	  },
	  addMouseHandler: function addMouseHandler(handleMouseMove, handleMouseOut) {
	    var el = _reactDom2.default.findDOMNode(this);
	    el.addEventListener("mousemove", handleMouseMove);
	    el.addEventListener("mouseout", handleMouseOut);
	  },
	  removeMouseHandler: function removeMouseHandler(handleMouseMove, handleMouseOut) {
	    var el = _reactDom2.default.findDOMNode(this);
	    el.removeEventListener("mousemove", handleMouseMove);
	    el.removeEventListener("mouseout", handleMouseOut);
	  },
	  render: function render() {
	    var store = this.internalStorage_get();
	    var props = this.props;
	
	    var margin = props.margin;
	    var height = this.getHeight(props);
	    var width = this.getWidth(props);
	    var xScale = this.getXScale(props.data, width, props.refreshRate);
	    var xTimeScale = this.getXTimeScale(props.data, width);
	    var yScale = this.getYScale(height, props.maxY);
	    var clipPath = "url(#" + store.clipPathID + ")";
	    var maskID = this.internalStorage_get().maskID;
	    var unsuccessfulBlocks = this.createUnsuccessfulBlocks(props.data[0].values, xTimeScale);
	
	    return _react2.default.createElement(
	      "div",
	      { className: "timeseries-chart" },
	      _react2.default.createElement(
	        "svg",
	        { height: props.height, width: props.width },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(" + margin.left + "," + margin.top + ")" },
	          _react2.default.createElement(_ChartStripes2.default, { count: 4, height: height, width: width }),
	          _react2.default.createElement("g", { className: "bars grid-graph", ref: "grid" }),
	          _react2.default.createElement("g", { className: "y axis", ref: "yAxis" }),
	          _react2.default.createElement("g", { className: "x axis", ref: "xAxis" }),
	          _react2.default.createElement(_TimeSeriesMouseOver2.default, {
	            addMouseHandler: this.addMouseHandler,
	            data: props.data,
	            getBoundingBox: this.getBoundingBox(props),
	            height: height,
	            removeMouseHandler: this.removeMouseHandler,
	            width: width,
	            xScale: xScale,
	            y: props.y,
	            yCaption: this.getYCaption(props.yFormat),
	            yScale: yScale
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "svg",
	        {
	          height: props.height,
	          width: props.width,
	          ref: "movingEls",
	          className: "moving-elements"
	        },
	        _react2.default.createElement(
	          "g",
	          { transform: "translate(" + margin.left + "," + margin.top + ")" },
	          _react2.default.createElement(
	            "g",
	            { className: "area path-color-7", clipPath: clipPath },
	            unsuccessfulBlocks
	          ),
	          _react2.default.createElement(
	            "g",
	            { ref: "masking", mask: "url(#" + maskID + ")", clipPath: clipPath },
	            this.getAreaList(props, yScale, xTimeScale)
	          ),
	          this.getCircleList(props, yScale, width, height)
	        ),
	        _react2.default.createElement(
	          "defs",
	          null,
	          _react2.default.createElement(
	            "mask",
	            { ref: "maskDef", id: store.maskID },
	            _react2.default.createElement("rect", { x: "0", y: "0", width: width, height: height, fill: "white" }),
	            unsuccessfulBlocks
	          )
	        )
	      )
	    );
	  }
	});
	
	module.exports = TimeSeriesChart;

/***/ },
/* 1390 */,
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnimationCircle = _react2.default.createClass({
	  displayName: "AnimationCircle",
	
	  propTypes: {
	    className: _react2.default.PropTypes.string,
	    transitionTime: _react2.default.PropTypes.number.isRequired,
	    position: _react2.default.PropTypes.array.isRequired,
	    radius: _react2.default.PropTypes.number,
	    cx: _react2.default.PropTypes.number,
	    cy: _react2.default.PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      didRenderBefore: false
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      radius: 4,
	      cx: 0,
	      cy: 0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _d2.default.select(_reactDom2.default.findDOMNode(this)).attr("transform", "translate(" + this.props.position + ")");
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var node = _reactDom2.default.findDOMNode(this);
	
	    // Handle first position to not animate into position
	    // We need this because we get 0-data for graphs on the first render
	    if (!this.state.didRenderBefore) {
	      _d2.default.select(node).attr("transform", "translate(" + nextProps.position + ")");
	
	      this.setState({ didRenderBefore: true });
	
	      return;
	    }
	
	    _d2.default.select(node).transition().duration(nextProps.transitionTime).ease("linear").attr("transform", "translate(" + nextProps.position + ")");
	  },
	  render: function render() {
	    var props = this.props;
	    var radius = props.radius;
	    var className = props.className;
	
	    return _react2.default.createElement("circle", { className: className, r: radius, cx: props.cx, cy: props.cy });
	  }
	});
	
	module.exports = AnimationCircle;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartMixin = {
	  getXScale: function getXScale() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var width = arguments[1];
	    var refreshRate = arguments[2];
	
	    var length = width;
	    var firstDataSet = data[0];
	    if (firstDataSet != null) {
	      length = firstDataSet.values.length;
	    }
	
	    var timeAgo = -(length - 1) * (refreshRate / 1000);
	
	    return _d2.default.scale.linear().range([0, width]).domain([timeAgo, 0]);
	  },
	
	
	  // Only used by TimeSeriesChart, but is meant to be re-used elsewhere
	  getHeight: function getHeight(props) {
	    var margin = props.margin;
	
	    return props.height - margin.top - margin.bottom;
	  },
	
	
	  // Only used by TimeSeriesChart, but is meant to be re-used elsewhere
	  getWidth: function getWidth(props) {
	    var margin = props.margin;
	
	    return props.width - margin.left - margin.right;
	  },
	  formatXAxis: function formatXAxis(d) {
	    var hideMatch = this.props.axisConfiguration.x.hideMatch;
	    if (hideMatch && hideMatch.test(d.toString())) {
	      return "";
	    }
	
	    if (parseInt(Math.abs(d), 10) > 0) {
	      return d + "s";
	    }
	
	    return d;
	  }
	};
	
	module.exports = ChartMixin;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartStripes = _react2.default.createClass({
	  displayName: "ChartStripes",
	
	  propTypes: {
	    count: _react2.default.PropTypes.number.isRequired,
	    height: _react2.default.PropTypes.number.isRequired,
	    width: _react2.default.PropTypes.number.isRequired
	  },
	
	  getStripes: function getStripes(props) {
	    var count = props.count;
	    var width = props.width / (2 * count);
	
	    return Array(count).fill().map(function (v, i) {
	      // indent with margin, start one width length in
	      // and add two times width per step
	      var position = width + i * 2 * width;
	
	      return _react2.default.createElement("rect", {
	        key: i,
	        className: "background",
	        x: position + "px",
	        y: 0,
	        height: props.height,
	        width: width
	      });
	    });
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      "g",
	      null,
	      this.getStripes(this.props)
	    );
	  }
	});
	
	module.exports = ChartStripes;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var Rect = function (_React$Component) {
	  (0, _inherits3.default)(Rect, _React$Component);
	
	  function Rect() {
	    (0, _classCallCheck3.default)(this, Rect);
	    return (0, _possibleConstructorReturn3.default)(this, (Rect.__proto__ || (0, _getPrototypeOf2.default)(Rect)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Rect, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.transitionRect(this.props);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      this.transitionRect(nextProps);
	    }
	  }, {
	    key: "transitionRect",
	    value: function transitionRect(props) {
	      var transitionDuration = props.transitionDuration,
	          transform = props.transform;
	
	      var el = _reactDom2.default.findDOMNode(this);
	
	      d3.select(el).transition().duration(transitionDuration).ease("linear").attr("transform", transform);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          x = _props.x,
	          y = _props.y,
	          fill = _props.fill,
	          className = _props.className;
	
	
	      return _react2.default.createElement("rect", {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        fill: fill,
	        className: className
	      });
	    }
	  }]);
	  return Rect;
	}(_react2.default.Component);
	
	Rect.propTypes = {
	  width: PropTypes.number,
	  height: PropTypes.number,
	  x: PropTypes.number,
	  y: PropTypes.number,
	  fill: PropTypes.string,
	  className: PropTypes.string,
	  transitionDuration: PropTypes.number,
	  transform: PropTypes.string,
	  key: PropTypes.any
	};
	
	module.exports = Rect;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeSeriesArea = _react2.default.createClass({
	  displayName: "TimeSeriesArea",
	
	  propTypes: {
	    className: _react2.default.PropTypes.string,
	    line: _react2.default.PropTypes.string.isRequired,
	    path: _react2.default.PropTypes.string.isRequired,
	    position: _react2.default.PropTypes.array.isRequired,
	    transitionTime: _react2.default.PropTypes.number.isRequired
	  },
	
	  componentDidMount: function componentDidMount() {
	    var props = this.props;
	
	    _d2.default.select(_reactDom2.default.findDOMNode(this)).transition().duration(props.transitionTime).ease("linear").attr("transform", "translate(" + props.position + ")");
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    _d2.default.select(_reactDom2.default.findDOMNode(this)).interrupt().attr("transform", null).transition().duration(props.transitionTime).ease("linear").attr("transform", "translate(" + props.position + ")");
	  },
	  render: function render() {
	    var className = this.props.className;
	
	    return _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement("path", { className: "area " + className, d: this.props.path }),
	      _react2.default.createElement("path", { className: "line " + className, d: this.props.line })
	    );
	  }
	});
	
	module.exports = TimeSeriesArea;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Maths = __webpack_require__(1051);
	
	var _Maths2 = _interopRequireDefault(_Maths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeSeriesMouseOver = _react2.default.createClass({
	  displayName: "TimeSeriesMouseOver",
	
	  propTypes: {
	    addMouseHandler: _react2.default.PropTypes.func.isRequired,
	    data: _react2.default.PropTypes.array.isRequired,
	    getBoundingBox: _react2.default.PropTypes.func.isRequired,
	    height: _react2.default.PropTypes.number.isRequired,
	    removeMouseHandler: _react2.default.PropTypes.func.isRequired,
	    width: _react2.default.PropTypes.number.isRequired,
	    xScale: _react2.default.PropTypes.func.isRequired,
	    y: _react2.default.PropTypes.string.isRequired,
	    yScale: _react2.default.PropTypes.func.isRequired,
	    yCaption: _react2.default.PropTypes.string.isRequired
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.props.addMouseHandler(this.handleMouseMove, this.handleMouseOut);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.removeMouseHandler(this.handleMouseMove, this.handleMouseOut);
	  },
	  calculateMousePositionInGraph: function calculateMousePositionInGraph(e) {
	    var boundingBox = this.props.getBoundingBox();
	    var mouse = {
	      x: e.clientX || e.pageX,
	      y: e.clientY || e.pageY
	    };
	
	    if (mouse.x < boundingBox.left || mouse.y < boundingBox.top || mouse.x > boundingBox.right || mouse.y > boundingBox.bottom) {
	      return false;
	    }
	
	    mouse.x -= boundingBox.left;
	    mouse.y -= boundingBox.top;
	
	    return mouse;
	  },
	  handleMouseMove: function handleMouseMove(e) {
	    var mouse = this.calculateMousePositionInGraph(e);
	
	    // This means that mouse is out of bounds
	    if (mouse === false) {
	      return;
	    }
	
	    var props = this.props;
	    var domain = props.xScale.domain();
	
	    var firstDataSet = props.data[0];
	    // how many data points we don't show
	    var hiddenDataPoints = 1;
	    // find the data point at the given mouse position
	    var index = mouse.x * (firstDataSet.values.length - hiddenDataPoints - 1) / props.width;
	    index = Math.round(index + hiddenDataPoints);
	
	    _d2.default.select(this.refs.xMousePosition).style("opacity", 1).transition().duration(50).attr("x1", mouse.x).attr("x2", mouse.x);
	
	    _d2.default.select(this.refs.yMousePosition).style("opacity", 1).transition().duration(50).attr("y1", props.yScale(firstDataSet.values[index][props.y])).attr("y2", props.yScale(firstDataSet.values[index][props.y]));
	
	    _d2.default.select(this.refs.yAxisCurrent).transition().duration(50).attr("y", props.yScale(firstDataSet.values[index][props.y]))
	    // Default to 0 if state is unsuccessful.
	    .text((firstDataSet.values[index][props.y] || 0) + props.yCaption);
	
	    // An extra -2 on each because we show the extra data point at the end
	
	    var _index = mouse.x * (firstDataSet.values.length - 1) / props.width;
	
	    var mappedValue = _Maths2.default.mapValue(Math.round(_index), {
	      min: firstDataSet.values.length - hiddenDataPoints,
	      max: 0
	    });
	    var value = _Maths2.default.unmapValue(mappedValue, {
	      min: Math.abs(domain[1]),
	      max: Math.abs(domain[0])
	    });
	    value = Math.round(value);
	
	    var characterWidth = 7;
	    var xPosition = mouse.x - value.toString().length * characterWidth;
	    if (value === 0) {
	      xPosition += characterWidth / 2;
	    } else {
	      value = "-" + value + "s";
	    }
	    _d2.default.select(this.refs.xAxisCurrent).transition().duration(50).attr("x", xPosition)
	    // Default to 0 if state is unsuccessful.
	    .text(value || 0);
	  },
	  handleMouseOut: function handleMouseOut() {
	    _d2.default.select(this.refs.yMousePosition).interrupt().style("opacity", 0);
	    _d2.default.select(this.refs.xMousePosition).interrupt().style("opacity", 0);
	    _d2.default.select(this.refs.xAxisCurrent).text("");
	    _d2.default.select(this.refs.yAxisCurrent).text("");
	  },
	  render: function render() {
	    var height = this.props.height;
	
	    // dy=.71em, y=9 and x=-9, dy=.32em are magic numbers from looking at
	    // d3.js text values
	    return _react2.default.createElement(
	      "g",
	      null,
	      _react2.default.createElement(
	        "g",
	        { className: "x axis" },
	        _react2.default.createElement("text", {
	          className: "current-value shadow",
	          ref: "xAxisCurrent",
	          dy: ".71em",
	          y: "9",
	          transform: "translate(0," + height + ")"
	        })
	      ),
	      _react2.default.createElement(
	        "g",
	        { className: "y axis" },
	        _react2.default.createElement("text", {
	          className: "current-value shadow",
	          ref: "yAxisCurrent",
	          style: { textAnchor: "end" },
	          dy: ".32em",
	          x: "-9"
	        })
	      ),
	      _react2.default.createElement("line", {
	        className: "chart-cursor-position-marker",
	        ref: "xMousePosition",
	        style: { opacity: 0 },
	        y1: 0,
	        y2: height
	      }),
	      _react2.default.createElement("line", {
	        className: "chart-cursor-position-marker",
	        ref: "yMousePosition",
	        style: { opacity: 0 },
	        x1: 0,
	        x2: this.props.width
	      })
	    );
	  }
	});
	
	module.exports = TimeSeriesMouseOver;

/***/ },
/* 1397 */
/***/ function(module, exports) {

	"use strict";
	
	var ValueTypes = {
	  PERCENTAGE: "percentage",
	  ABSOLUTE: "absolute"
	};
	
	module.exports = ValueTypes;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValueTypes = __webpack_require__(1397);
	
	var _ValueTypes2 = _interopRequireDefault(_ValueTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeSeriesLabel = _react2.default.createClass({
	  displayName: "TimeSeriesLabel",
	
	  propTypes: {
	    colorIndex: _react2.default.PropTypes.number,
	    currentValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]).isRequired,
	    subHeading: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]).isRequired,
	    y: _react2.default.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      y: _ValueTypes2.default.PERCENTAGE,
	      colorIndex: 0
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    // If equal, do not update
	    return !(0, _deepEqual2.default)(this.props, nextProps);
	  },
	  render: function render() {
	    var props = this.props;
	
	    var percentageClassSet = (0, _classnames2.default)({
	      hidden: props.y !== _ValueTypes2.default.PERCENTAGE
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "text-align-center" },
	      _react2.default.createElement(
	        "span",
	        { className: "unit unit-primary" },
	        props.currentValue,
	        _react2.default.createElement(
	          "sup",
	          { className: percentageClassSet },
	          "%"
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        {
	          className: "h4 unit-label flush-top path-color-" + props.colorIndex
	        },
	        props.subHeading
	      )
	    );
	  }
	});
	
	module.exports = TimeSeriesLabel;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _TimeSeriesChart = __webpack_require__(1389);
	
	var _TimeSeriesChart2 = _interopRequireDefault(_TimeSeriesChart);
	
	var _TimeSeriesLabel = __webpack_require__(1398);
	
	var _TimeSeriesLabel2 = _interopRequireDefault(_TimeSeriesLabel);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceTimeSeriesChart = _react2.default.createClass({
	  displayName: "ResourceTimeSeriesChart",
	
	  propTypes: {
	    colorIndex: _react2.default.PropTypes.number.isRequired,
	    usedResources: _react2.default.PropTypes.object.isRequired,
	    totalResources: _react2.default.PropTypes.object.isRequired,
	    usedResourcesStates: _react2.default.PropTypes.object.isRequired,
	    mode: _react2.default.PropTypes.string,
	    refreshRate: _react2.default.PropTypes.number.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      colorIndex: 0
	    };
	  },
	  getData: function getData() {
	    var _props = this.props,
	        colorIndex = _props.colorIndex,
	        usedResourcesStates = _props.usedResourcesStates,
	        mode = _props.mode;
	
	
	    return [{
	      name: "Alloc",
	      colorIndex: colorIndex,
	      values: usedResourcesStates[mode]
	    }];
	  },
	  getHeadline: function getHeadline(usedValue, totalValue) {
	    var mode = this.props.mode;
	
	    if (mode === "cpus") {
	      return usedValue + " of " + totalValue + " Shares";
	    } else {
	      return _Units2.default.filesize(usedValue * 1024 * 1024, 0) + " of " + _Units2.default.filesize(totalValue * 1024 * 1024, 0);
	    }
	  },
	  getChart: function getChart() {
	    var refreshRate = this.props.refreshRate;
	
	
	    return _react2.default.createElement(
	      _Chart2.default,
	      null,
	      _react2.default.createElement(_TimeSeriesChart2.default, {
	        data: this.getData(),
	        maxY: 100,
	        y: "percentage",
	        refreshRate: refreshRate
	      })
	    );
	  },
	  render: function render() {
	    var _props2 = this.props,
	        colorIndex = _props2.colorIndex,
	        mode = _props2.mode,
	        usedResources = _props2.usedResources,
	        totalResources = _props2.totalResources;
	
	    var usedValue = +(Math.round(usedResources[mode] + "e+2") + "e-2");
	    var totalValue = +(Math.round(totalResources[mode] + "e+2") + "e-2");
	    var percentage = Math.round(100 * usedValue / totalValue) || 0;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "chart" },
	      _react2.default.createElement(_TimeSeriesLabel2.default, {
	        colorIndex: colorIndex,
	        currentValue: percentage,
	        subHeading: this.getHeadline(usedValue, totalValue)
	      }),
	      this.getChart()
	    );
	  }
	});
	
	module.exports = ResourceTimeSeriesChart;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Maths = __webpack_require__(1051);
	
	var _Maths2 = _interopRequireDefault(_Maths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Units = {
	  formatResource: function formatResource(resource, value) {
	    value = _Maths2.default.round(value, 2);
	
	    if (resource !== "cpus") {
	      value = Units.filesize(value * 1024 * 1024, 1);
	    }
	
	    return value;
	  },
	  filesize: function filesize(size, decimals, threshold, multiplier, units) {
	    size = size || 0;
	    if (decimals == null) {
	      decimals = 2;
	    }
	    threshold = threshold || 800; // Steps to next unit if exceeded
	    multiplier = multiplier || 1024;
	    units = units || ["B", "KiB", "MiB", "GiB", "TiB", "PiB"];
	
	    var factorize = 1;
	    var unitIndex;
	
	    for (unitIndex = 0; unitIndex < units.length; unitIndex++) {
	      if (unitIndex > 0) {
	        factorize = Math.pow(multiplier, unitIndex);
	      }
	
	      if (size < multiplier * factorize && size < threshold * factorize) {
	        break;
	      }
	    }
	
	    if (unitIndex >= units.length) {
	      unitIndex = units.length - 1;
	    }
	
	    var filesize = size / factorize;
	
	    filesize = filesize.toFixed(decimals);
	
	    // This removes unnecessary 0 or . chars at the end of the string/decimals
	    if (filesize.indexOf(".") > -1) {
	      filesize = filesize.replace(/\.?0*$/, "");
	    }
	
	    return filesize + " " + units[unitIndex];
	  },
	  contractNumber: function contractNumber(amount, options) {
	    if (amount == null) {
	      return amount;
	    }
	
	    options = (0, _assign2.default)({ decimalPlaces: 2 }, options);
	
	    if (amount > 1) {
	      var precision = Math.pow(10, options.decimalPlaces);
	      amount = Math.round(amount * precision) / precision;
	    } else if (amount < 1 && options.forceFixedPrecision && typeof amount === "number") {
	      amount = amount.toFixed(options.decimalPlaces);
	    }
	
	    if (amount < 5000) {
	      return "" + amount;
	    }
	
	    if (amount >= 5000 && amount < 10000 || amount >= 1000000 && amount < 9999999) {
	      options.decimalPlaces = 1;
	    } else if (amount >= 10000 && amount < 1000000 || amount >= 10000000) {
	      options.decimalPlaces = 0;
	    }
	
	    var suffixes = ["K", "M", "B", "T"];
	
	    var suffix = "";
	
	    if (amount >= 999999999999999) {
	      return "> 999T";
	    }
	
	    while (amount >= 1000) {
	      amount /= 1000;
	      amount = amount.toFixed(options.decimalPlaces);
	      amount = parseFloat(amount, 10);
	      suffix = suffixes.shift();
	    }
	
	    if (amount % 1 === 0) {
	      amount = amount.toFixed(0);
	    }
	
	    return amount + suffix;
	  }
	};
	
	module.exports = Units;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _HealthLabels = __webpack_require__(1402);
	
	var _HealthLabels2 = _interopRequireDefault(_HealthLabels);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	var _HealthTypesDescription = __webpack_require__(1403);
	
	var _HealthTypesDescription2 = _interopRequireDefault(_HealthTypesDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceList = _react2.default.createClass({
	  displayName: "ServiceList",
	
	  propTypes: {
	    services: _react2.default.PropTypes.array.isRequired,
	    healthProcessed: _react2.default.PropTypes.bool.isRequired
	  },
	
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      services: []
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var changedState = nextState !== undefined && !(0, _deepEqual2.default)(this.state, nextState);
	
	    return !(0, _deepEqual2.default)(this.props, nextProps) || changedState;
	  },
	  handleServiceClick: function handleServiceClick(service, event) {
	    // Open service in new window/tab if service has a web URL
	    if (service.getWebURL() && (event.ctrlKey || event.shiftKey || event.metaKey)) {
	      return;
	    }
	    var id = encodeURIComponent(service.getId());
	    // Modifier key not pressed or service didn't have a web URL, open detail
	    event.preventDefault();
	    this.context.router.push("/services/detail/" + id);
	  },
	  getServices: function getServices(services, healthProcessed) {
	    var _this = this;
	
	    return services.map(function (service) {
	      var appHealth = service.getHealth();
	      var state = _HealthStatus2.default.NA;
	      var tooltipContent = void 0;
	
	      if (appHealth != null) {
	        state = _HealthStatus2.default[appHealth.key];
	
	        if (appHealth.key === _HealthStatus2.default.HEALTHY.key) {
	          tooltipContent = _HealthTypesDescription2.default.HEALTHY;
	        } else if (appHealth.key === _HealthStatus2.default.UNHEALTHY.key) {
	          tooltipContent = _HealthTypesDescription2.default.UNHEALTHY;
	        } else if (appHealth.key === _HealthStatus2.default.IDLE.key) {
	          tooltipContent = _HealthTypesDescription2.default.IDLE;
	        } else if (appHealth.key === _HealthStatus2.default.NA.key) {
	          tooltipContent = _HealthTypesDescription2.default.NA;
	        }
	      }
	
	      var healthLabel = _HealthLabels2.default[state.key];
	      if (!healthProcessed) {
	        healthLabel = _react2.default.createElement(_Loader2.default, { size: "small", type: "ballBeat" });
	      }
	
	      var classSet = (0, _classnames2.default)("tooltip-wrapper", state.classNames);
	
	      return {
	        content: [{
	          className: "dashboard-health-list-item-description text-overflow",
	          content: _react2.default.createElement(
	            "a",
	            {
	              key: "title",
	              onClick: _this.handleServiceClick.bind(_this, service),
	              href: service.getWebURL(),
	              className: "dashboard-health-list-item-cell emphasis"
	            },
	            service.getName()
	          ),
	          tag: "span"
	        }, {
	          className: "dashboard-health-list-health-label",
	          content: _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              anchor: "end",
	              content: tooltipContent,
	              key: "health",
	              wrapperClassName: classSet,
	              wrapText: true,
	              width: 200
	            },
	            healthLabel
	          ),
	          tag: "div"
	        }]
	      };
	    });
	  },
	  getNoServicesMessage: function getNoServicesMessage() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h3",
	        { className: "flush-top text-align-center" },
	        "No Services Running"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "flush text-align-center" },
	        "Click the ",
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/services" },
	          "Services tab"
	        ),
	        " to install services."
	      )
	    );
	  },
	  getList: function getList() {
	    var props = this.props;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "dashboard-health-list" },
	      _react2.default.createElement(_reactjsComponents.List, {
	        className: "list list-unstyled",
	        content: this.getServices(props.services, props.healthProcessed),
	        transition: false,
	        transitionName: "something"
	      })
	    );
	  },
	  getContent: function getContent() {
	    if (this.props.services.length === 0) {
	      return this.getNoServicesMessage();
	    } else {
	      return this.getList();
	    }
	  },
	  render: function render() {
	    return this.getContent();
	  }
	});
	
	module.exports = ServiceList;

/***/ },
/* 1402 */
/***/ function(module, exports) {

	"use strict";
	
	var HEALTH_LABELS = {
	  ALL: "All",
	  HEALTHY: "Healthy",
	  UNHEALTHY: "Unhealthy",
	  IDLE: "Idle",
	  NA: "N/A"
	};
	
	module.exports = HEALTH_LABELS;

/***/ },
/* 1403 */
/***/ function(module, exports) {

	"use strict";
	
	var HealthTypesDescription = {
	  UNHEALTHY: "One or more health checks are failing.",
	  HEALTHY: "This service is operating normally.",
	  IDLE: "This service has no running tasks.",
	  NA: "No health checks are set up for this service."
	};
	
	module.exports = HealthTypesDescription;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _DialChart = __webpack_require__(1405);
	
	var _DialChart2 = _interopRequireDefault(_DialChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TASKS_PER_ROW = 3;
	var TASK_INFO = {
	  TASK_RUNNING: { label: "Tasks running", colorIndex: 4 },
	  TASK_STAGING: { label: "Tasks staging", colorIndex: 1 }
	};
	var DISPLAYED_TASK_KEYS = (0, _keys2.default)(TASK_INFO);
	
	function getEmptyTaskData() {
	  return DISPLAYED_TASK_KEYS.map(function (key) {
	    return {
	      name: key,
	      colorIndex: TASK_INFO[key].colorIndex,
	      value: 0
	    };
	  });
	}
	
	var TasksChart = _react2.default.createClass({
	  displayName: "TasksChart",
	
	  propTypes: {
	    // {TASK_RUNNING: 0, TASK_STAGING: 4}
	    tasks: _react2.default.PropTypes.object.isRequired
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    var previousTasks = this.getTasks(this.props.tasks);
	    var newTasks = this.getTasks(nextProps.tasks);
	
	    // If equal, do not update
	    return !(0, _deepEqual2.default)(previousTasks, newTasks);
	  },
	  getTaskInfo: function getTaskInfo(tasks) {
	    if (tasks.length === 0) {
	      tasks = getEmptyTaskData();
	    }
	
	    var numberOfTasks = DISPLAYED_TASK_KEYS.length;
	
	    return DISPLAYED_TASK_KEYS.map(function (key) {
	      var info = TASK_INFO[key];
	      var task = tasks.find(function (task) {
	        return task.name === key;
	      });
	      if (task === undefined) {
	        task = { value: 0 };
	      }
	      var classes = {
	        "unit-bordered-horizontal-small text-align-center column-12": true
	      };
	      // equalize columns for units
	      if (numberOfTasks > TASKS_PER_ROW) {
	        classes["column-small-4"] = true;
	      } else {
	        classes["column-small-" + 12 / numberOfTasks] = true;
	      }
	      var classSet = (0, _classnames2.default)(classes);
	
	      return _react2.default.createElement(
	        "div",
	        { key: key, className: classSet },
	        _react2.default.createElement(
	          "p",
	          { className: "h1 unit flush-top" },
	          task.value
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: "unit-label short-top flush-bottom path-color-" + info.colorIndex
	          },
	          info.label
	        )
	      );
	    });
	  },
	  getTotal: function getTotal(tasks) {
	    return tasks.reduce(function (acc, task) {
	      return acc + task.value;
	    }, 0);
	  },
	  getTasks: function getTasks() {
	    var tasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return DISPLAYED_TASK_KEYS.map(function (key) {
	      return {
	        colorIndex: TASK_INFO[key].colorIndex,
	        name: key,
	        value: tasks[key]
	      };
	    });
	  },
	  getDialChart: function getDialChart(tasks) {
	    var total = this.getTotal(tasks);
	
	    if (tasks.length === 0) {
	      tasks = getEmptyTaskData();
	    }
	
	    return _react2.default.createElement(
	      _DialChart2.default,
	      { data: tasks, slices: getEmptyTaskData() },
	      this.getDialChartChildren(total)
	    );
	  },
	  getDialChartChildren: function getDialChartChildren(total) {
	    return _react2.default.createElement(
	      "div",
	      { className: "description" },
	      _react2.default.createElement(
	        "span",
	        { className: "unit unit-primary" },
	        total
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "unit-label h4 flush text-muted" },
	        "Total Tasks"
	      )
	    );
	  },
	  render: function render() {
	    var tasks = this.getTasks(this.props.tasks);
	
	    return _react2.default.createElement(
	      "div",
	      { className: "chart" },
	      _react2.default.createElement(
	        _Chart2.default,
	        null,
	        this.getDialChart(tasks)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        this.getTaskInfo(tasks)
	      )
	    );
	  }
	});
	
	module.exports = TasksChart;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DialSlice = __webpack_require__(1406);
	
	var _DialSlice2 = _interopRequireDefault(_DialSlice);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// the data to render a single grey circle
	function getEmptyState() {
	  return [{ colorIndex: 7, value: 1 }];
	}
	
	var DialChart = _react2.default.createClass({
	  displayName: "DialChart",
	
	  mixins: [_InternalStorageMixin2.default],
	
	  propTypes: {
	    // [{colorIndex: 0, name: 'Some Name', value: 4}]
	    data: _react2.default.PropTypes.array.isRequired,
	    slices: _react2.default.PropTypes.array,
	    duration: _react2.default.PropTypes.number,
	    value: _react2.default.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      duration: 1000,
	      slices: [],
	      value: "value"
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var value = this.props.value;
	    var data = (0, _assign2.default)({
	      pie: _d2.default.layout.pie().sort(null).value(function (d) {
	        return d[value];
	      })
	    }, this.getArcs(this.props));
	
	    this.internalStorage_set(data);
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    var slice = this.getSlice(this.props);
	    var arcs = this.getArcs(this.props);
	    var innerArc = arcs.innerArc;
	
	    slice.each(function (d) {
	      this._current = d;
	    });
	
	    slice = this.getSlice(nextProps);
	    slice.each(function (d) {
	      if (d.value > 0) {
	        _d2.default.select(this).style("visibility", "inherit");
	      }
	    }).transition().duration(nextProps.duration).attrTween("d", function (d) {
	      var interpolate = _d2.default.interpolate(this._current, d);
	
	      return function (t) {
	        this._current = interpolate(t);
	
	        return innerArc(this._current);
	      }.bind(this);
	    }).each("end", function (d) {
	      if (d.value === 0) {
	        _d2.default.select(this).style("visibility", "hidden");
	      }
	    });
	  },
	  getNormalizedData: function getNormalizedData(slices, data) {
	    if (this.isEmpty(data)) {
	      return getEmptyState();
	    }
	
	    // Zero-length defaults are populated with actual data if available
	    var namedSlices = slices.reduce(function (indexByName, slice) {
	      indexByName[slice.name] = slice;
	
	      return indexByName;
	    }, {});
	
	    var namedData = data.reduce(function (indexByName, datum) {
	      indexByName[datum.name] = datum;
	
	      return indexByName;
	    }, {});
	
	    var normalizedNamedData = (0, _assign2.default)({}, namedSlices, namedData);
	
	    return (0, _values2.default)(normalizedNamedData);
	  },
	  isEmpty: function isEmpty(data) {
	    var sumOfData = data.reduce(function (memo, datum) {
	      return memo + datum.value;
	    }, 0);
	
	    return sumOfData === 0;
	  },
	  getSlice: function getSlice(props) {
	    var data = this.internalStorage_get();
	    var normalizedData = this.getNormalizedData(props.slices, props.data);
	
	    return _d2.default.select(_reactDom2.default.findDOMNode(this)).selectAll("path").data(data.pie(normalizedData));
	  },
	  getRadius: function getRadius(props) {
	    var smallSide = Math.min(props.width || Infinity, props.height || Infinity);
	
	    return smallSide / 2;
	  },
	  getArcs: function getArcs(props) {
	    var radius = this.getRadius(props);
	
	    return {
	      innerArc: _d2.default.svg.arc().outerRadius(radius * 0.9).innerRadius(radius * 0.84),
	      outerArc: _d2.default.svg.arc().outerRadius(radius).innerRadius(radius),
	      innerRadius: radius * 0.5
	    };
	  },
	  getPosition: function getPosition() {
	    return "translate(" + this.props.width / 2 + "," + this.props.height / 2 + ")";
	  },
	  getWedges: function getWedges() {
	    var data = this.internalStorage_get();
	    var innerArc = data.innerArc;
	    var pie = data.pie;
	    var normalizedData = this.getNormalizedData(this.props.slices, this.props.data);
	    var normalizedPie = pie(normalizedData);
	
	    return normalizedPie.map(function (element, i) {
	      return _react2.default.createElement(_DialSlice2.default, {
	        key: i,
	        colorIndex: element.data.colorIndex || i,
	        path: innerArc(element)
	      });
	    });
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "chart-dialchart",
	        height: this.props.height,
	        width: this.props.width
	      },
	      _react2.default.createElement(
	        "svg",
	        { height: this.props.height, width: this.props.width },
	        _react2.default.createElement(
	          "g",
	          { transform: this.getPosition(), className: "slices" },
	          this.getWedges()
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	
	module.exports = DialChart;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DialSlice = _react2.default.createClass({
	  displayName: "DialSlice",
	
	  propTypes: {
	    colorIndex: _react2.default.PropTypes.node,
	    path: _react2.default.PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    var classes = {
	      arc: true
	    };
	    if (this.props.colorIndex != null) {
	      classes["path-color-" + this.props.colorIndex] = true;
	    }
	    var classSet = (0, _classnames2.default)(classes);
	
	    return _react2.default.createElement(
	      "g",
	      { className: classSet },
	      _react2.default.createElement("path", { d: this.props.path })
	    );
	  }
	});
	
	module.exports = DialSlice;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ConfigStore = __webpack_require__(1268);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _Modals = __webpack_require__(1408);
	
	var _Modals2 = _interopRequireDefault(_Modals);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _ServerErrorModal = __webpack_require__(1414);
	
	var _ServerErrorModal2 = _interopRequireDefault(_ServerErrorModal);
	
	var _Sidebar = __webpack_require__(1415);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _SidebarStore = __webpack_require__(1335);
	
	var _SidebarStore2 = _interopRequireDefault(_SidebarStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSidebarState() {
	  return {
	    isDocked: _SidebarStore2.default.get("isDocked"),
	    isVisible: _SidebarStore2.default.get("isVisible")
	  };
	}
	
	var Index = _react2.default.createClass({
	  displayName: "Index",
	
	  mixins: [_InternalStorageMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  getInitialState: function getInitialState() {
	    return {
	      mesosSummaryErrorCount: 0,
	      showErrorModal: false,
	      modalErrorMsg: "",
	      configErrorCount: 0
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    _MetadataStore2.default.init();
	    _SidebarStore2.default.init();
	
	    // We want to always request the summary endpoint. This will ensure that
	    // our charts always have data to render.
	    this.store_listeners = [{
	      name: "summary",
	      events: ["success", "error"],
	      suppressUpdate: true
	    }];
	
	    var state = getSidebarState();
	    this.internalStorage_set(state);
	  },
	  componentDidMount: function componentDidMount() {
	    _SidebarStore2.default.addChangeListener(_EventTypes2.default.SIDEBAR_CHANGE, this.onSideBarChange);
	    global.addEventListener("resize", _SidebarActions2.default.close);
	
	    _ConfigStore2.default.addChangeListener(_EventTypes2.default.CONFIG_ERROR, this.onConfigError);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !((0, _deepEqual2.default)(this.props, nextProps) && (0, _deepEqual2.default)(this.state, nextState));
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _SidebarStore2.default.removeChangeListener(_EventTypes2.default.SIDEBAR_CHANGE, this.onSideBarChange);
	    global.removeEventListener("resize", _SidebarActions2.default.close);
	
	    _ConfigStore2.default.removeChangeListener(_EventTypes2.default.CONFIG_ERROR, this.onConfigError);
	  },
	  onSideBarChange: function onSideBarChange() {
	    this.internalStorage_update(getSidebarState());
	    this.forceUpdate();
	  },
	  onConfigError: function onConfigError() {
	    this.setState({ configErrorCount: this.state.configErrorCount + 1 });
	
	    if (this.state.configErrorCount < _Config2.default.delayAfterErrorCount) {
	      _ConfigStore2.default.fetchConfig();
	    }
	  },
	  onSummaryStoreSuccess: function onSummaryStoreSuccess() {
	    // Reset count as we've just received a successful response
	    if (this.state.mesosSummaryErrorCount > 0) {
	      this.setState({ mesosSummaryErrorCount: 0 });
	    }
	  },
	  onSummaryStoreError: function onSummaryStoreError() {
	    this.setState({
	      mesosSummaryErrorCount: this.state.mesosSummaryErrorCount + 1
	    });
	  },
	  getErrorScreen: function getErrorScreen(showErrorScreen) {
	    if (!showErrorScreen) {
	      return null;
	    }
	
	    return _react2.default.createElement(_RequestErrorMsg2.default, null);
	  },
	  getScreenOverlays: function getScreenOverlays(showErrorScreen) {
	    if (!showErrorScreen) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "pod flush-right flush-left vertical-center" },
	      this.getErrorScreen(showErrorScreen)
	    );
	  },
	  render: function render() {
	    var _internalStorage_get = this.internalStorage_get(),
	        isDocked = _internalStorage_get.isDocked,
	        isVisible = _internalStorage_get.isVisible;
	
	    var showErrorScreen = this.state.configErrorCount >= _Config2.default.delayAfterErrorCount;
	
	    var classSet = (0, _classnames2.default)("application-wrapper", {
	      "sidebar-visible": isVisible,
	      "sidebar-docked": isDocked
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: classSet },
	      this.getScreenOverlays(showErrorScreen),
	      _react2.default.createElement(_Sidebar2.default, { location: this.props.location }),
	      this.props.children,
	      _react2.default.createElement(_Modals2.default, {
	        showErrorModal: this.state.showErrorModal,
	        modalErrorMsg: this.state.modalErrorMsg
	      }),
	      _react2.default.createElement(_ServerErrorModal2.default, null)
	    );
	  }
	});
	
	module.exports = Index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _CliInstallModal = __webpack_require__(1409);
	
	var _CliInstallModal2 = _interopRequireDefault(_CliInstallModal);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ErrorModal = __webpack_require__(1412);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _SidebarStore = __webpack_require__(1335);
	
	var _SidebarStore2 = _interopRequireDefault(_SidebarStore);
	
	var _VersionsModal = __webpack_require__(1413);
	
	var _VersionsModal2 = _interopRequireDefault(_VersionsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modals = _react2.default.createClass({
	  displayName: "Modals",
	
	  mixins: [_InternalStorageMixin2.default],
	
	  propTypes: {
	    showErrorModal: _react2.default.PropTypes.bool,
	    modalErrorMsg: _react2.default.PropTypes.node
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showErrorModal: false,
	      modalErrorMsg: ""
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	
	    return {
	      modalErrorMsg: props.modalErrorMsg,
	      showingCliModal: false,
	      showingVersionsModal: false,
	      showErrorModal: props.showErrorModal
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.setState({
	      modalErrorMsg: props.modalErrorMsg,
	      showErrorModal: props.showErrorModal
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    _SidebarStore2.default.addChangeListener(_EventTypes2.default.SHOW_CLI_INSTRUCTIONS, this.handleShowCli);
	
	    _SidebarStore2.default.addChangeListener(_EventTypes2.default.SHOW_VERSIONS_SUCCESS, this.handleShowVersionsSuccess);
	
	    _SidebarStore2.default.addChangeListener(_EventTypes2.default.SHOW_VERSIONS_ERROR, this.handleShowVersionsError);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _SidebarStore2.default.removeChangeListener(_EventTypes2.default.SHOW_CLI_INSTRUCTIONS, this.handleShowCli);
	
	    _SidebarStore2.default.removeChangeListener(_EventTypes2.default.SHOW_VERSIONS_SUCCESS, this.handleShowVersionsSuccess);
	
	    _SidebarStore2.default.removeChangeListener(_EventTypes2.default.SHOW_VERSIONS_ERROR, this.handleShowVersionsError);
	  },
	  handleShowVersionsSuccess: function handleShowVersionsSuccess() {
	    this.setState({ showingVersionsModal: true });
	  },
	  handleShowVersionsError: function handleShowVersionsError() {
	    this.setState({
	      showErrorModal: true,
	      modalErrorMsg: _react2.default.createElement(
	        "p",
	        { className: "text-align-center flush-bottom" },
	        "We are unable to retrieve the version",
	        " ",
	        _Config2.default.productName,
	        " ",
	        "versions. Please try again."
	      )
	    });
	  },
	  handleShowCli: function handleShowCli() {
	    this.setState({ showingCliModal: true });
	  },
	  getCliModalOptions: function getCliModalOptions() {
	    var onClose = function () {
	      this.setState({ showingCliModal: false });
	    }.bind(this);
	
	    return {
	      onClose: onClose,
	      title: "Install DC/OS CLI",
	      showFooter: true,
	      footer: _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "row text-align-center" },
	          _react2.default.createElement(
	            "button",
	            {
	              className: "button button-primary button-medium",
	              onClick: onClose
	            },
	            "Close"
	          )
	        )
	      )
	    };
	  },
	  getCliInstallModal: function getCliInstallModal(showModal) {
	    var options = {
	      onClose: function onClose() {},
	
	      title: "",
	      showFooter: true,
	      footer: _react2.default.createElement("div", null)
	    };
	
	    if (this.state.showingCliModal) {
	      _PluginSDK.Hooks.doAction("logFakePageView", {
	        title: "CLI instructions",
	        path: "/v/cli-instructions",
	        referrer: "https://mesosphere.com/"
	      });
	
	      options = this.getCliModalOptions();
	    }
	
	    return _react2.default.createElement(_CliInstallModal2.default, (0, _extends3.default)({ open: showModal }, options));
	  },
	  getVersionsModal: function getVersionsModal(showModal) {
	    var onClose = function () {
	      this.setState({ showingVersionsModal: false });
	    }.bind(this);
	
	    var versions = _SidebarStore2.default.get("versions");
	
	    return _react2.default.createElement(_VersionsModal2.default, {
	      onClose: onClose,
	      versionDump: versions,
	      open: showModal
	    });
	  },
	  getErrorModal: function getErrorModal(show) {
	    var onClose = function () {
	      this.setState({ showErrorModal: false });
	    }.bind(this);
	
	    var errorMsg = null;
	    if (this.state.modalErrorMsg) {
	      errorMsg = this.state.modalErrorMsg;
	    }
	
	    return _react2.default.createElement(_ErrorModal2.default, { onClose: onClose, errorMsg: errorMsg, open: show });
	  },
	  render: function render() {
	    var showCliModal = this.state.showingCliModal;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.getCliInstallModal(showCliModal),
	      this.getVersionsModal(this.state.showingVersionsModal),
	      this.getErrorModal(this.state.showErrorModal)
	    );
	  }
	});
	
	module.exports = Modals;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _browserInfo = __webpack_require__(1410);
	
	var _browserInfo2 = _interopRequireDefault(_browserInfo);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClickToSelect = __webpack_require__(1411);
	
	var _ClickToSelect2 = _interopRequireDefault(_ClickToSelect);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onClose"];
	var osTypes = {
	  Windows: "windows",
	  "OS X": "darwin",
	  Linux: "linux"
	};
	
	var CliInstallModal = function (_React$Component) {
	  (0, _inherits3.default)(CliInstallModal, _React$Component);
	
	  function CliInstallModal() {
	    (0, _classCallCheck3.default)(this, CliInstallModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CliInstallModal.__proto__ || (0, _getPrototypeOf2.default)(CliInstallModal)).apply(this, arguments));
	
	    var selectedOS = (0, _browserInfo2.default)().os;
	    if (!(0, _keys2.default)(osTypes).includes(selectedOS)) {
	      selectedOS = "Linux";
	    }
	
	    _this.state = { selectedOS: selectedOS };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CliInstallModal, [{
	    key: "handleSelectedOSChange",
	    value: function handleSelectedOSChange(selectedOS) {
	      this.setState({ selectedOS: selectedOS });
	    }
	  }, {
	    key: "onClose",
	    value: function onClose() {
	      this.props.onClose();
	    }
	  }, {
	    key: "getSubHeader",
	    value: function getSubHeader() {
	      if (!this.props.subHeaderContent) {
	        return false;
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "text-align-center flush-bottom" },
	        this.props.subHeaderContent
	      );
	    }
	  }, {
	    key: "getCliInstructions",
	    value: function getCliInstructions() {
	      // TODO (DCOS-8495): Binary cli links have hardcoded version, these should
	      // be updated to a /latest endpoint, when that becomes available.
	      // Binary cli links are also all pointing to the open version, which is
	      // intentional.
	      var hostname = global.location.hostname;
	      var protocol = global.location.protocol.replace(/[^\w]/g, "");
	      var port = "";
	      if (global.location.port) {
	        port = ":" + global.location.port;
	      }
	      var clusterUrl = protocol + "://" + hostname + port;
	      var selectedOS = this.state.selectedOS;
	
	      var version = _MetadataStore2.default.parsedVersion;
	      // Prepend 'dcos-' to any version other than latest
	      if (version !== "latest") {
	        version = "dcos-" + version;
	      }
	      var downloadUrl = "https://downloads.dcos.io/binaries/cli/" + osTypes[selectedOS] + "/x86-64/" + version + "/dcos";
	      if (selectedOS === "Windows") {
	        return this.getWindowsInstallInstruction(clusterUrl, downloadUrl);
	      }
	
	      var instructions = ["[ -d /usr/local/bin ] || sudo mkdir -p /usr/local/bin", "curl " + downloadUrl + " -o dcos", "sudo mv dcos /usr/local/bin", "sudo chmod +x /usr/local/bin/dcos", "dcos cluster setup " + clusterUrl, "dcos"].filter(function (instruction) {
	        return instruction !== undefined;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          { className: "short-bottom" },
	          "Copy and paste the code snippet into the terminal:"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flush-top snippet-wrapper" },
	          _react2.default.createElement(
	            _ClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { className: "prettyprint flush-bottom" },
	              instructions.join(" && \n")
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getWindowsInstallInstruction",
	    value: function getWindowsInstallInstruction(clusterUrl, downloadUrl) {
	      var steps = ["cd path/to/download/directory", "dcos cluster setup " + clusterUrl, "dcos"].filter(function (instruction) {
	        return instruction !== undefined;
	      }).map(function (instruction, index) {
	        var helpText = "Enter";
	
	        if (index === 0) {
	          helpText = "In Terminal, enter";
	        }
	
	        return _react2.default.createElement(
	          "li",
	          { key: index },
	          _react2.default.createElement(
	            "p",
	            { className: "short-bottom" },
	            helpText
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "flush-top snippet-wrapper" },
	            _react2.default.createElement(
	              _ClickToSelect2.default,
	              null,
	              _react2.default.createElement(
	                "pre",
	                { className: "prettyprint flush-bottom prettyprinted" },
	                instruction
	              )
	            )
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        "ol",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "Download and install: ",
	          _react2.default.createElement(
	            "a",
	            { href: downloadUrl + ".exe" },
	            _react2.default.createElement(_Icon2.default, { id: "download", size: "mini" }),
	            " Download dcos.exe"
	          ),
	          "."
	        ),
	        steps
	      );
	    }
	  }, {
	    key: "getOSButtons",
	    value: function getOSButtons() {
	      var _this2 = this;
	
	      var selectedOS = this.state.selectedOS;
	
	
	      return (0, _keys2.default)(osTypes).map(function (name, index) {
	        var classSet = (0, _classnames2.default)({
	          "button button-stroke": true,
	          active: name === selectedOS
	        });
	
	        return _react2.default.createElement(
	          "button",
	          {
	            className: classSet,
	            key: index,
	            onClick: _this2.handleSelectedOSChange.bind(_this2, name)
	          },
	          name
	        );
	      });
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      return _react2.default.createElement(
	        "div",
	        { className: "install-cli-modal-content" },
	        _react2.default.createElement(
	          "h4",
	          { className: "flush-top" },
	          "Installation"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Choose your operating system and follow the instructions. For any issues or questions, please refer to our ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/usage/cli/install"),
	              target: "_blank"
	            },
	            "documentation"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "button-group" },
	          this.getOSButtons()
	        ),
	        this.getCliInstructions()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          footer = _props.footer,
	          open = _props.open,
	          showFooter = _props.showFooter,
	          title = _props.title;
	
	      var header = _react2.default.createElement(
	        _ModalHeading2.default,
	        { align: "left", level: 5 },
	        title
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          header: header,
	          footer: footer,
	          modalClass: "modal",
	          onClose: this.onClose,
	          open: open,
	          showHeader: true,
	          showFooter: showFooter,
	          subHeader: this.getSubHeader()
	        },
	        this.getContent()
	      );
	    }
	  }]);
	  return CliInstallModal;
	}(_react2.default.Component);
	
	CliInstallModal.propTypes = {
	  title: _react2.default.PropTypes.string.isRequired,
	  subHeaderContent: _react2.default.PropTypes.string,
	  showFooter: _react2.default.PropTypes.bool.isRequired,
	  footer: _react2.default.PropTypes.node,
	  onClose: _react2.default.PropTypes.func.isRequired
	};
	
	module.exports = CliInstallModal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1410 */,
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClickToSelect = function (_React$Component) {
	  (0, _inherits3.default)(ClickToSelect, _React$Component);
	
	  function ClickToSelect() {
	    (0, _classCallCheck3.default)(this, ClickToSelect);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ClickToSelect.__proto__ || (0, _getPrototypeOf2.default)(ClickToSelect)).call(this));
	
	    _this.selectAll = _this.selectAll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ClickToSelect, [{
	    key: "selectAll",
	    value: function selectAll() {
	      global.document.getSelection().selectAllChildren(this.refs.node);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "span",
	        { onClick: this.selectAll, ref: "node" },
	        this.props.children
	      );
	    }
	  }]);
	  return ClickToSelect;
	}(_react2.default.Component);
	
	ClickToSelect.propTypes = {
	  children: _react2.default.PropTypes.any
	};
	
	module.exports = ClickToSelect;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorModal = _react2.default.createClass({
	  displayName: "ErrorModal",
	
	  propTypes: {
	    onClose: _react2.default.PropTypes.func.isRequired,
	    errorMsg: _react2.default.PropTypes.element
	  },
	
	  onClose: function onClose() {
	    this.props.onClose();
	  },
	  render: function render() {
	    var header = _react2.default.createElement(
	      _ModalHeading2.default,
	      null,
	      "Looks Like Something is Wrong"
	    );
	
	    return _react2.default.createElement(
	      _reactjsComponents.Modal,
	      {
	        modalClass: "modal",
	        onClose: this.onClose,
	        open: this.props.open,
	        showHeader: true,
	        header: header
	      },
	      this.props.errorMsg
	    );
	  }
	});
	
	module.exports = ErrorModal;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ClickToSelect = __webpack_require__(1411);
	
	var _ClickToSelect2 = _interopRequireDefault(_ClickToSelect);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VersionsModal = _react2.default.createClass({
	  displayName: "VersionsModal",
	
	  propTypes: {
	    onClose: _react2.default.PropTypes.func.isRequired,
	    versionDump: _react2.default.PropTypes.object.isRequired
	  },
	
	  onClose: function onClose() {
	    this.props.onClose();
	  },
	  getContent: function getContent() {
	    var string = (0, _stringify2.default)(this.props.versionDump, null, 2);
	
	    return _react2.default.createElement(
	      "pre",
	      { className: "flush-bottom" },
	      string
	    );
	  },
	  render: function render() {
	    var header = _react2.default.createElement(
	      _ModalHeading2.default,
	      null,
	      _Config2.default.productName,
	      " Info"
	    );
	
	    return _react2.default.createElement(
	      _reactjsComponents.Modal,
	      {
	        onClose: this.onClose,
	        open: this.props.open,
	        showHeader: true,
	        header: header,
	        size: "large"
	      },
	      _react2.default.createElement(
	        _ClickToSelect2.default,
	        null,
	        this.getContent()
	      )
	    );
	  }
	});
	
	module.exports = VersionsModal;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var METHODS_TO_BIND = ["handleModalClose", "handleServerError"];
	/* eslint-enable no-unused-vars */
	
	
	function getEventsFromStoreListeners(storeListeners) {
	  var _this = this;
	
	  var events = [];
	
	  storeListeners.forEach(function (store) {
	    store.events.forEach(function (storeEvent) {
	      events.push(_this.store_getChangeFunctionName(store.name, storeEvent));
	    });
	  });
	
	  return events;
	}
	
	module.exports = function (_mixin) {
	  (0, _inherits3.default)(ServerErrorModal, _mixin);
	
	  function ServerErrorModal() {
	    (0, _classCallCheck3.default)(this, ServerErrorModal);
	
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ServerErrorModal.__proto__ || (0, _getPrototypeOf2.default)(ServerErrorModal)).call(this));
	
	    _this2.state = {
	      isOpen: false,
	      errors: []
	    };
	
	    _this2.store_listeners = _PluginSDK.Hooks.applyFilter("serverErrorModalListeners", []);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this2[method] = _this2[method].bind(_this2);
	    });
	
	    var events = getEventsFromStoreListeners.call(_this2, _this2.store_listeners);
	    events.forEach(function (event) {
	      _this2[event] = _this2.handleServerError;
	    });
	    return _this2;
	  }
	
	  (0, _createClass3.default)(ServerErrorModal, [{
	    key: "handleModalClose",
	    value: function handleModalClose() {
	      this.setState({
	        isOpen: false,
	        errors: []
	      });
	    }
	  }, {
	    key: "handleServerError",
	    value: function handleServerError(errorMessage) {
	      if (!errorMessage) {
	        throw "No error message defined!";
	      }
	
	      var isLocked = errorMessage && /force=true/.test(errorMessage);
	
	      var errors = this.state.errors.concat([errorMessage]);
	
	      this.setState({
	        errors: errors,
	        isOpen: !isLocked
	      });
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection text-align-center flush-bottom" },
	        _react2.default.createElement(
	          "div",
	          { className: "button", onClick: this.handleModalClose },
	          "Close"
	        )
	      );
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var errors = this.state.errors;
	
	      var lastErrorIndex = errors.length - 1;
	      var errorMessages = errors.map(function (error, index) {
	        var errorMessageClass = (0, _classnames2.default)("text-align-center", {
	          // Last error message doesn't have margin bottom.
	          "flush-bottom": index === lastErrorIndex
	        });
	
	        return _react2.default.createElement(
	          "p",
	          { className: errorMessageClass, key: index },
	          error
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pod pod-short flush-right flush-left" },
	        errorMessages
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var header = _react2.default.createElement(
	        _ModalHeading2.default,
	        { level: 5 },
	        "An error has occurred"
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          modalWrapperClass: "server-error-modal",
	          modalClass: "modal",
	          onClose: this.handleModalClose,
	          open: this.state.isOpen,
	          showHeader: true,
	          showFooter: true,
	          footer: this.getFooter(),
	          header: header
	        },
	        this.getContent()
	      );
	    }
	  }]);
	  return ServerErrorModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1283);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactGeminiScrollbar = __webpack_require__(1281);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _KeyboardUtil = __webpack_require__(1416);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _PrimarySidebarLink = __webpack_require__(1417);
	
	var _PrimarySidebarLink2 = _interopRequireDefault(_PrimarySidebarLink);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _SidebarHeader = __webpack_require__(1418);
	
	var _SidebarHeader2 = _interopRequireDefault(_SidebarHeader);
	
	var _SidebarStore = __webpack_require__(1335);
	
	var _SidebarStore2 = _interopRequireDefault(_SidebarStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationService = _foundationUi.navigation.NavigationService,
	    NAVIGATION_CHANGE = _foundationUi.navigation.EventTypes.NAVIGATION_CHANGE;
	
	
	var defaultMenuItems = ["/dashboard", "/services", "/jobs", "/catalog", "/nodes", "/networking", "/secrets", "/overview", "/components", "/settings", "/organization"];
	
	var Hooks = _PluginSDK2.default.Hooks;
	
	
	var Sidebar = _react2.default.createClass({
	  displayName: "Sidebar",
	
	  mixins: [_InternalStorageMixin2.default],
	
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  getInitialState: function getInitialState() {
	    return { expandedItems: [] };
	  },
	  componentWillMount: function componentWillMount() {
	    var pathnameSegments = this.props.location.pathname.split("/");
	
	    // If the user loaded the UI from a route other than `/`, we want to display
	    // it in its expanded state.
	    if (pathnameSegments.length > 1) {
	      this.setState({ expandedItems: ["/" + pathnameSegments[1]] });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    NavigationService.on(NAVIGATION_CHANGE, this.onNavigationChange);
	
	    this.internalStorage_update({
	      mesosInfo: _MesosSummaryStore2.default.get("states").lastSuccessful()
	    });
	
	    _MetadataStore2.default.addChangeListener(_EventTypes2.default.DCOS_METADATA_CHANGE, this.onDCOSMetadataChange);
	
	    if (this.sidebarWrapperRef) {
	      this.sidebarWrapperRef.addEventListener("transitionend", this.handleSidebarTransitionEnd);
	    }
	
	    global.addEventListener("keydown", this.handleKeyPress, true);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    NavigationService.removeListener(NAVIGATION_CHANGE, this.onNavigationChange);
	
	    _MetadataStore2.default.removeChangeListener(_EventTypes2.default.DCOS_METADATA_CHANGE, this.onDCOSMetadataChange);
	
	    if (this.sidebarWrapperRef) {
	      this.sidebarWrapperRef.removeEventListener("transitionend", this.handleSidebarTransitionEnd);
	    }
	
	    global.removeEventListener("keydown", this.handleKeyPress, true);
	  },
	  onDCOSMetadataChange: function onDCOSMetadataChange() {
	    this.forceUpdate();
	  },
	  onNavigationChange: function onNavigationChange() {
	    this.forceUpdate();
	  },
	  handleKeyPress: function handleKeyPress(event) {
	    var nodeName = event.target.nodeName;
	
	    if (event.keyCode === _KeyboardUtil.keyCodes.leftBracket && !(nodeName === "INPUT" || nodeName === "TEXTAREA") && !(event.ctrlKey || event.metaKey || event.shiftKey)) {
	      // #sidebarWidthChange is passed as a callback so that the sidebar
	      // has had a chance to update before Gemini re-renders.
	      this.toggleSidebarDocking();
	    }
	  },
	  handleSubmenuItemClick: function handleSubmenuItemClick() {
	    _SidebarActions2.default.close();
	  },
	  getNavigationSections: function getNavigationSections() {
	    var _this = this;
	
	    var definition = NavigationService.getDefinition();
	
	    return definition.map(function (group, index) {
	      var heading = null;
	      var menuItems = _this.getNavigationGroup(group);
	
	      if (menuItems == null) {
	        return null;
	      }
	
	      if (group.category !== "root") {
	        heading = _react2.default.createElement(
	          "h6",
	          { className: "sidebar-section-header" },
	          group.category
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "sidebar-section pod pod-short-bottom flush-top flush-left flush-right",
	          key: index
	        },
	        heading,
	        menuItems
	      );
	    });
	  },
	  getNavigationGroup: function getNavigationGroup(group) {
	    var _this2 = this;
	
	    var menuItems = Hooks.applyFilter("sidebarNavigation", defaultMenuItems).reduce(function (routesMap, path) {
	      return routesMap.set(path, true);
	    }, new _map2.default());
	
	    var filteredItems = group.children.filter(function (route) {
	      return menuItems.has(route.path);
	    });
	
	    var groupMenuItems = filteredItems.map(function (element, index) {
	      var pathname = _this2.props.location.pathname;
	
	
	      var hasChildren = element.children && element.children.length !== 0;
	      var isExpanded = _this2.state.expandedItems.includes(element.path);
	      var isParentActive = pathname.startsWith(element.path);
	
	      var submenu = void 0;
	      var isChildActive = false;
	      if (isExpanded && hasChildren) {
	        var _getGroupSubmenu = _this2.getGroupSubmenu(group.path, element.children);
	
	        var _getGroupSubmenu2 = (0, _slicedToArray3.default)(_getGroupSubmenu, 2);
	
	        submenu = _getGroupSubmenu2[0];
	        isChildActive = _getGroupSubmenu2[1];
	      }
	
	      var linkElement = element.link;
	      if (typeof linkElement === "string") {
	        linkElement = _react2.default.createElement(
	          _PrimarySidebarLink2.default,
	          {
	            hasChildren: hasChildren,
	            isChildActive: isChildActive,
	            isExpanded: isExpanded,
	            to: element.path,
	            icon: element.options.icon,
	            onClick: _this2.handlePrimarySidebarLinkClick.bind(_this2, element, isChildActive)
	          },
	          linkElement
	        );
	      }
	
	      var itemClassSet = (0, _classnames2.default)("sidebar-menu-item", {
	        selected: isParentActive && !isChildActive,
	        open: isExpanded
	      });
	
	      return _react2.default.createElement(
	        "li",
	        { className: itemClassSet, key: index },
	        linkElement,
	        submenu
	      );
	    });
	
	    if (groupMenuItems.length) {
	      return _react2.default.createElement(
	        "ul",
	        { className: "sidebar-menu" },
	        groupMenuItems
	      );
	    }
	
	    return null;
	  },
	  getGroupSubmenu: function getGroupSubmenu(path, children) {
	    var _this3 = this;
	
	    var pathname = this.props.location.pathname;
	
	    var isChildActive = false;
	
	    var childRoutesPaths = children.map(function (_ref) {
	      var path = _ref.path;
	      return path;
	    });
	    var filteredPaths = Hooks.applyFilter("secondaryNavigation", path, childRoutesPaths);
	
	    // Defaulting to unfiltered set of paths
	    var childRoutesMap = (filteredPaths || childRoutesPaths).reduce(function (routesMap, path) {
	      return routesMap.set(path, true);
	    }, new _map2.default());
	
	    var filteredChildRoutes = children.filter(function (_ref2) {
	      var path = _ref2.path;
	      return childRoutesMap.has(path);
	    });
	
	    var menuItems = filteredChildRoutes.reduce(function (children, currentChild, index) {
	      var isActive = currentChild.options.isActiveRegex != null ? currentChild.options.isActiveRegex.test(pathname) : pathname.startsWith(currentChild.path);
	
	      var menuItemClasses = (0, _classnames2.default)({ selected: isActive });
	
	      // First matched active child wins,
	      // ie in /path/child and /path/child-path without this conditional /path/child-path
	      // will always overrule /path/child
	      if (!isChildActive && isActive) {
	        isChildActive = true;
	      }
	
	      var linkElement = currentChild.link;
	      if (typeof linkElement === "string") {
	        linkElement = _react2.default.createElement(
	          _reactRouter.Link,
	          { to: currentChild.path },
	          linkElement
	        );
	      }
	
	      children.push(_react2.default.createElement(
	        "li",
	        {
	          className: menuItemClasses,
	          key: index,
	          onClick: _this3.handleSubmenuItemClick
	        },
	        linkElement
	      ));
	
	      return children;
	    }, []);
	
	    return [_react2.default.createElement(
	      "ul",
	      null,
	      menuItems
	    ), isChildActive];
	  },
	  getVersion: function getVersion() {
	    var data = _MetadataStore2.default.get("dcosMetadata");
	    if (data == null || data.version == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "span",
	      { className: "version-number" },
	      "v.",
	      data.version
	    );
	  },
	  handleClusterHeaderUpdate: function handleClusterHeaderUpdate() {
	    _ScrollbarUtil2.default.updateWithRef(this.geminiRef);
	  },
	  handlePrimarySidebarLinkClick: function handlePrimarySidebarLinkClick(element, isChildActive) {
	    var expandedItems = this.state.expandedItems;
	    var path = element.path;
	
	    var expandedItemIndex = expandedItems.indexOf(path);
	
	    if (expandedItemIndex === -1) {
	      expandedItems.push(path);
	    } else if (!isChildActive) {
	      expandedItems.splice(expandedItemIndex, 1);
	    }
	
	    this.setState({ expandedItems: expandedItems });
	  },
	  handleSidebarTransitionEnd: function handleSidebarTransitionEnd(event) {
	    // Some elements (graphs and Gemini) need to update when the main content
	    // width changes, so we emit an event.
	    if (event.target === this.sidebarWrapperRef) {
	      _SidebarActions2.default.sidebarWidthChange();
	    }
	  },
	  handleOverlayClick: function handleOverlayClick() {
	    _SidebarActions2.default.close();
	  },
	  toggleSidebarDocking: function toggleSidebarDocking() {
	    global.requestAnimationFrame(function () {
	      if (_SidebarStore2.default.get("isDocked")) {
	        _SidebarActions2.default.undock();
	      } else {
	        _SidebarActions2.default.dock();
	      }
	    });
	  },
	  render: function render() {
	    var _this4 = this;
	
	    var dockIconID = "sidebar-expand";
	    var overlay = null;
	
	    if (_SidebarStore2.default.get("isDocked")) {
	      dockIconID = "sidebar-collapse";
	    }
	
	    if (_SidebarStore2.default.get("isVisible")) {
	      overlay = _react2.default.createElement("div", { className: "sidebar-backdrop", onClick: this.handleOverlayClick });
	    }
	
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "sidebar-wrapper",
	        ref: function ref(_ref4) {
	          _this4.sidebarWrapperRef = _ref4;
	        }
	      },
	      _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: "sidebar-backdrop",
	          transitionEnterTimeout: 250,
	          transitionLeaveTimeout: 250
	        },
	        overlay
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "sidebar flex flex-direction-top-to-bottom" },
	        _react2.default.createElement(_SidebarHeader2.default, { onUpdate: this.handleClusterHeaderUpdate }),
	        _react2.default.createElement(
	          _reactGeminiScrollbar2.default,
	          {
	            autoshow: true,
	            className: "flex-item-grow-1 flex-item-shrink-1 gm-scrollbar-container-flex gm-scrollbar-container-flex-view inverse",
	            ref: function ref(_ref3) {
	              return _this4.geminiRef = _ref3;
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "sidebar-content-wrapper" },
	            _react2.default.createElement(
	              "div",
	              { className: "sidebar-sections pod pod-narrow" },
	              this.getNavigationSections()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "sidebar-dock-container" },
	          _react2.default.createElement(_Icon2.default, {
	            className: "sidebar-dock-trigger",
	            size: "mini",
	            id: dockIconID,
	            onClick: this.toggleSidebarDocking
	          })
	        )
	      )
	    );
	  }
	});
	
	module.exports = Sidebar;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1416 */
/***/ function(module, exports) {

	"use strict";
	
	var KeyboardUtil = {
	  keyCodes: {
	    leftArrow: 37,
	    rightArrow: 39,
	    leftBracket: 219,
	    enter: 13
	  }
	};
	
	module.exports = KeyboardUtil;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _NotificationStore = __webpack_require__(1258);
	
	var _NotificationStore2 = _interopRequireDefault(_NotificationStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimarySidebarLink = function PrimarySidebarLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      hasChildren = _ref.hasChildren,
	      icon = _ref.icon,
	      isChildActive = _ref.isChildActive,
	      isExpanded = _ref.isExpanded,
	      onClick = _ref.onClick;
	
	  var notificationCount = _NotificationStore2.default.getNotificationCount(to);
	
	  var sidebarText = _react2.default.createElement(
	    "span",
	    { className: "sidebar-menu-item-label" },
	    children
	  );
	
	  if (notificationCount > 0) {
	    sidebarText = _react2.default.createElement(
	      "span",
	      { className: "sidebar-menu-item-label badge-container" },
	      _react2.default.createElement(
	        "span",
	        { className: "sidebar-menu-item-label-text badge-container-text" },
	        children
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "badge badge-rounded" },
	        notificationCount
	      )
	    );
	  }
	
	  if (hasChildren) {
	    var classes = (0, _classnames2.default)({
	      clickable: !isChildActive,
	      "is-expanded": isExpanded
	    });
	
	    return _react2.default.createElement(
	      "a",
	      { className: classes, onClick: onClick },
	      icon,
	      sidebarText,
	      _react2.default.createElement(_Icon2.default, {
	        className: "sidebar-menu-item-expand-icon",
	        family: "tiny",
	        id: "triangle-down",
	        size: "tiny"
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: to },
	    icon,
	    sidebarText
	  );
	};
	
	module.exports = PrimarySidebarLink;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ClipboardTrigger = __webpack_require__(1419);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _UserAccountDropdown = __webpack_require__(1355);
	
	var _UserAccountDropdown2 = _interopRequireDefault(_UserAccountDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleItemSelect", "handleTextCopy"];
	
	var SidebarHeader = function (_mixin) {
	  (0, _inherits3.default)(SidebarHeader, _mixin);
	
	  function SidebarHeader() {
	    (0, _classCallCheck3.default)(this, SidebarHeader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarHeader.__proto__ || (0, _getPrototypeOf2.default)(SidebarHeader)).apply(this, arguments));
	
	    _this.state = {
	      isTextCopied: false
	    };
	
	    _this.store_listeners = [{
	      name: "metadata",
	      events: ["success"],
	      listenAlways: false
	    }, {
	      name: "summary",
	      events: ["success"],
	      listenAlways: false
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _foundationUi.MountService.MountService.registerComponent(_UserAccountDropdown2.default, "Sidebar:UserAccountDropdown");
	    return _this;
	  }
	
	  (0, _createClass3.default)(SidebarHeader, [{
	    key: "getClusterName",
	    value: function getClusterName() {
	      var states = _MesosSummaryStore2.default.get("states");
	      var clusterName = null;
	
	      if (states) {
	        var lastState = states.lastSuccessful();
	
	        if (lastState) {
	          clusterName = lastState.getClusterName();
	        }
	      }
	
	      return clusterName;
	    }
	  }, {
	    key: "getPublicIP",
	    value: function getPublicIP() {
	      var metadata = _MetadataStore2.default.get("metadata");
	
	      if ((typeof metadata === "undefined" ? "undefined" : (0, _typeof3.default)(metadata)) !== "object" || metadata.PUBLIC_IPV4 == null || metadata.PUBLIC_IPV4.length === 0) {
	        return null;
	      }
	
	      return metadata.PUBLIC_IPV4;
	    }
	  }, {
	    key: "handleTextCopy",
	    value: function handleTextCopy() {
	      this.setState({ isTextCopied: true });
	    }
	  }, {
	    key: "handleItemSelect",
	    value: function handleItemSelect() {
	      this.setState({ isTextCopied: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var clusterName = this.getClusterName();
	      var copyText = this.state.isTextCopied ? "Copied" : "Copy";
	      var publicIP = this.getPublicIP();
	      var menuItems = [{
	        className: "dropdown-menu-section-header",
	        html: _react2.default.createElement(
	          "label",
	          { className: "text-overflow" },
	          clusterName
	        ),
	        id: "header-cluster-name",
	        selectable: false
	      }, {
	        className: "user-account-dropdown-menu-public-ip",
	        html: _react2.default.createElement(
	          _ClipboardTrigger2.default,
	          {
	            className: "dropdown-menu-item-padding-surrogate clickable",
	            copyText: publicIP,
	            onTextCopy: this.handleTextCopy
	          },
	          publicIP,
	          _react2.default.createElement(
	            "span",
	            { className: "user-account-dropdown-menu-copy-text" },
	            copyText
	          )
	        ),
	        id: "public-ip",
	        onClick: this.handleItemSelect
	      }, {
	        html: "Overview",
	        id: "overview",
	        onClick: function onClick() {
	          _SidebarActions2.default.close();
	          _this2.context.router.push("/overview");
	        }
	      }, {
	        className: "dropdown-menu-section-header",
	        html: _react2.default.createElement(
	          "label",
	          null,
	          "Support"
	        ),
	        id: "header-support",
	        selectable: false
	      }, {
	        html: "Documentation",
	        id: "documentation",
	        onClick: function onClick() {
	          _SidebarActions2.default.close();
	          global.open(_MetadataStore2.default.buildDocsURI("/"), "_blank");
	        }
	      }, {
	        html: "Install CLI",
	        id: "install-cli",
	        onClick: function onClick() {
	          _SidebarActions2.default.close();
	          _SidebarActions2.default.openCliInstructions();
	        }
	      }];
	
	      return _react2.default.createElement(
	        "header",
	        { className: "header flex-item-shrink-0" },
	        _react2.default.createElement(_foundationUi.MountService.Mount, {
	          type: "Sidebar:UserAccountDropdown",
	          clusterName: this.getClusterName(),
	          limit: 1,
	          menuItems: menuItems,
	          onUpdate: this.props.onUpdate
	        })
	      );
	    }
	  }]);
	  return SidebarHeader;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	SidebarHeader.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = SidebarHeader;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _clipboard = __webpack_require__(1420);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleCopy", "handleCopyIconMouseEnter"];
	
	var ClipboardTrigger = function (_React$Component) {
	  (0, _inherits3.default)(ClipboardTrigger, _React$Component);
	
	  function ClipboardTrigger() {
	    (0, _classCallCheck3.default)(this, ClipboardTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ClipboardTrigger.__proto__ || (0, _getPrototypeOf2.default)(ClipboardTrigger)).call(this));
	
	    _this.state = {
	      hasCopiedToClipboard: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ClipboardTrigger, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.refs.copyButton) {
	        this.clipboard = new _clipboard2.default(_reactDom2.default.findDOMNode(this.refs.copyButton), {
	          text: function text() {
	            return _this2.props.copyText;
	          }
	        });
	
	        this.clipboard.on("success", this.handleCopy);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.clipboard) {
	        this.clipboard.destroy();
	      }
	    }
	  }, {
	    key: "getTriggerContent",
	    value: function getTriggerContent() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      if (children != null) {
	        return _react2.default.createElement(
	          "span",
	          {
	            className: className,
	            onMouseEnter: this.handleCopyIconMouseEnter,
	            ref: "copyButton"
	          },
	          children
	        );
	      }
	
	      return _react2.default.createElement(_Icon2.default, {
	        id: "clipboard",
	        size: "mini",
	        className: "clickable icon-clipboard " + className,
	        color: "purple",
	        onMouseEnter: this.handleCopyIconMouseEnter,
	        ref: "copyButton"
	      });
	    }
	  }, {
	    key: "handleCopy",
	    value: function handleCopy() {
	      this.setState({ hasCopiedToClipboard: true });
	
	      if (this.props.onTextCopy) {
	        this.props.onTextCopy();
	      }
	    }
	  }, {
	    key: "handleCopyIconMouseEnter",
	    value: function handleCopyIconMouseEnter() {
	      this.setState({ hasCopiedToClipboard: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          copiedText = _props2.copiedText,
	          tooltipContent = _props2.tooltipContent,
	          useTooltip = _props2.useTooltip;
	      var hasCopiedToClipboard = this.state.hasCopiedToClipboard;
	
	
	      if (useTooltip) {
	        var text = hasCopiedToClipboard ? copiedText : tooltipContent;
	
	        return _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          { position: "bottom", content: text },
	          this.getTriggerContent()
	        );
	      }
	
	      return this.getTriggerContent();
	    }
	  }]);
	  return ClipboardTrigger;
	}(_react2.default.Component);
	
	ClipboardTrigger.defaultProps = {
	  copiedText: "Copied!",
	  tooltipContent: "Copy to clipboard"
	};
	
	ClipboardTrigger.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  copiedText: _react.PropTypes.node,
	  copyText: _react.PropTypes.node,
	  onTextCopy: _react.PropTypes.func,
	  tooltipContent: _react.PropTypes.node,
	  useTooltip: _react.PropTypes.bool
	};
	
	module.exports = ClipboardTrigger;

/***/ },
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JobDetailPage = __webpack_require__(1430);
	
	var _JobDetailPage2 = _interopRequireDefault(_JobDetailPage);
	
	var _JobsPage = __webpack_require__(1483);
	
	var _JobsPage2 = _interopRequireDefault(_JobsPage);
	
	var _JobsTab = __webpack_require__(1484);
	
	var _JobsTab2 = _interopRequireDefault(_JobsTab);
	
	var _JobTaskDetailPage = __webpack_require__(1489);
	
	var _JobTaskDetailPage2 = _interopRequireDefault(_JobTaskDetailPage);
	
	var _TaskDetailsTab = __webpack_require__(1499);
	
	var _TaskDetailsTab2 = _interopRequireDefault(_TaskDetailsTab);
	
	var _TaskFileBrowser = __webpack_require__(1504);
	
	var _TaskFileBrowser2 = _interopRequireDefault(_TaskFileBrowser);
	
	var _TaskFilesTab = __webpack_require__(1507);
	
	var _TaskFilesTab2 = _interopRequireDefault(_TaskFilesTab);
	
	var _TaskFileViewer = __webpack_require__(1508);
	
	var _TaskFileViewer2 = _interopRequireDefault(_TaskFileViewer);
	
	var _TaskLogsContainer = __webpack_require__(1518);
	
	var _TaskLogsContainer2 = _interopRequireDefault(_TaskLogsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var jobsRoutes = [{
	  type: _reactRouter.Redirect,
	  from: "/jobs",
	  to: "/jobs/overview"
	}, {
	  type: _reactRouter.Route,
	  component: _JobsPage2.default,
	  path: "jobs",
	  category: "root",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.Route,
	    component: _JobsTab2.default,
	    path: "overview",
	    children: [{
	      type: _reactRouter.Route,
	      path: ":id"
	    }]
	  }, {
	    type: _reactRouter.Redirect,
	    from: "/job/detail/:id",
	    to: "/job/detail/:id/tasks"
	  }, {
	    type: _reactRouter.Route,
	    component: _JobDetailPage2.default,
	    path: "detail/:id",
	    children: [{
	      type: _reactRouter.Redirect,
	      path: "/jobs/detail/:id/tasks/:taskID",
	      to: "/jobs/detail/:id/tasks/:taskID/details"
	    }, {
	      type: _reactRouter.Route,
	      path: "tasks/:taskID",
	      component: _JobTaskDetailPage2.default,
	      hideHeaderNavigation: true,
	      children: [{
	        component: _TaskDetailsTab2.default,
	        isTab: true,
	        path: "details",
	        title: "Details",
	        type: _reactRouter.Route
	      }, {
	        hideHeaderNavigation: true,
	        component: _TaskFilesTab2.default,
	        isTab: true,
	        path: "files",
	        title: "Files",
	        type: _reactRouter.Route,
	        children: [{
	          component: _TaskFileBrowser2.default,
	          fileViewerRoutePath: "/jobs/detail/:id/tasks/:taskID/files/view(/:filePath(/:innerPath))",
	          hideHeaderNavigation: true,
	          type: _reactRouter.IndexRoute
	        }, {
	          component: _TaskFileViewer2.default,
	          hideHeaderNavigation: true,
	          path: "view(/:filePath(/:innerPath))",
	          type: _reactRouter.Route
	        }]
	      }, {
	        component: _TaskLogsContainer2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "logs",
	        title: "Logs",
	        type: _reactRouter.Route,
	        children: [{
	          path: ":filePath",
	          type: _reactRouter.Route
	        }]
	      }]
	    }]
	  }]
	}];
	/* eslint-enable no-unused-vars */
	
	module.exports = jobsRoutes;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _prettycron = __webpack_require__(1431);
	
	var _prettycron2 = _interopRequireDefault(_prettycron);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _JobConfiguration = __webpack_require__(1434);
	
	var _JobConfiguration2 = _interopRequireDefault(_JobConfiguration);
	
	var _JobFormModal = __webpack_require__(1438);
	
	var _JobFormModal2 = _interopRequireDefault(_JobFormModal);
	
	var _JobRunHistoryTable = __webpack_require__(1473);
	
	var _JobRunHistoryTable2 = _interopRequireDefault(_JobRunHistoryTable);
	
	var _JobsBreadcrumbs = __webpack_require__(1479);
	
	var _JobsBreadcrumbs2 = _interopRequireDefault(_JobsBreadcrumbs);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MetronomeStore = __webpack_require__(1248);
	
	var _MetronomeStore2 = _interopRequireDefault(_MetronomeStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var METHODS_TO_BIND = ["closeDialog", "handleEditButtonClick", "handleRunNowButtonClick", "handleDisableScheduleButtonClick", "handleEnableScheduleButtonClick", "handleDestroyButtonClick", "onMetronomeStoreJobDeleteError", "onMetronomeStoreJobDeleteSuccess", "onMetronomeStoreJobDetailError", "onMetronomeStoreJobDetailChange"];
	/* eslint-disable no-unused-vars */
	
	
	var DIALOGS = {
	  EDIT: "edit",
	  DESTROY: "destroy"
	};
	
	var JobDetailPage = function (_mixin) {
	  (0, _inherits3.default)(JobDetailPage, _mixin);
	
	  function JobDetailPage() {
	    (0, _classCallCheck3.default)(this, JobDetailPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobDetailPage.__proto__ || (0, _getPrototypeOf2.default)(JobDetailPage)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "metronome",
	      events: ["jobDeleteSuccess", "jobDeleteError", "jobDetailChange", "jobDetailError", "jobRunError", "jobRunSuccess", "jobScheduleUpdateError", "jobScheduleUpdateSuccess"],
	      suppressUpdate: false
	    }];
	
	    _this.tabs_tabs = {
	      runHistory: "Run History",
	      configuration: "Configuration"
	    };
	
	    _this.state = {
	      currentTab: (0, _keys2.default)(_this.tabs_tabs).shift(),
	      disabledDialog: null,
	      jobActionDialog: null,
	      errorMsg: null,
	      errorCount: 0,
	      isJobFormModalOpen: false,
	      isLoading: true
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobDetailPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(JobDetailPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(JobDetailPage.prototype), "componentDidMount", this).apply(this, arguments);
	      _MetronomeStore2.default.monitorJobDetail(this.props.params.id);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _get3.default)(JobDetailPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(JobDetailPage.prototype), "componentWillUnmount", this).apply(this, arguments);
	      _MetronomeStore2.default.stopJobDetailMonitor(this.props.params.id);
	    }
	  }, {
	    key: "onMetronomeStoreJobDeleteError",
	    value: function onMetronomeStoreJobDeleteError(id, error) {
	      var errorMsg = error.message;
	
	      if (id !== this.props.params.id || errorMsg == null) {
	        return;
	      }
	
	      this.setState({
	        jobActionDialog: DIALOGS.DESTROY,
	        disabledDialog: null,
	        errorMsg: errorMsg
	      });
	    }
	  }, {
	    key: "onMetronomeStoreJobDeleteSuccess",
	    value: function onMetronomeStoreJobDeleteSuccess() {
	      this.closeDialog();
	      this.context.router.push("/jobs");
	    }
	  }, {
	    key: "onMetronomeStoreJobDetailError",
	    value: function onMetronomeStoreJobDetailError() {
	      this.setState({ errorCount: this.state.errorCount + 1 });
	    }
	  }, {
	    key: "onMetronomeStoreJobDetailChange",
	    value: function onMetronomeStoreJobDetailChange() {
	      this.setState({ errorCount: 0, isLoading: false });
	    }
	  }, {
	    key: "handleEditButtonClick",
	    value: function handleEditButtonClick() {
	      this.setState({ jobActionDialog: DIALOGS.EDIT });
	    }
	  }, {
	    key: "handleRunNowButtonClick",
	    value: function handleRunNowButtonClick() {
	      var job = _MetronomeStore2.default.getJob(this.props.params.id);
	
	      _MetronomeStore2.default.runJob(job.getId());
	    }
	  }, {
	    key: "handleDisableScheduleButtonClick",
	    value: function handleDisableScheduleButtonClick() {
	      _MetronomeStore2.default.toggleSchedule(this.props.params.id, false);
	    }
	  }, {
	    key: "handleEnableScheduleButtonClick",
	    value: function handleEnableScheduleButtonClick() {
	      _MetronomeStore2.default.toggleSchedule(this.props.params.id, true);
	    }
	  }, {
	    key: "handleDestroyButtonClick",
	    value: function handleDestroyButtonClick() {
	      this.setState({ jobActionDialog: DIALOGS.DESTROY });
	    }
	  }, {
	    key: "handleAcceptDestroyDialog",
	    value: function handleAcceptDestroyDialog() {
	      var _this2 = this;
	
	      var stopCurrentJobRuns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this.setState({ disabledDialog: DIALOGS.DESTROY }, function () {
	        _MetronomeStore2.default.deleteJob(_this2.props.params.id, stopCurrentJobRuns);
	      });
	    }
	  }, {
	    key: "closeDialog",
	    value: function closeDialog() {
	      this.setState({
	        disabledDialog: null,
	        errorMsg: null,
	        jobActionDialog: null
	      });
	    }
	  }, {
	    key: "getDestroyConfirmDialog",
	    value: function getDestroyConfirmDialog() {
	      var id = this.props.params.id;
	      var _state = this.state,
	          disabledDialog = _state.disabledDialog,
	          jobActionDialog = _state.jobActionDialog,
	          errorMsg = _state.errorMsg;
	
	      var stopCurrentJobRuns = false;
	      var actionButtonLabel = _StringUtil2.default.capitalize(_UserActions2.default.DELETE) + " Job";
	      var message = "Are you sure you want to " + _UserActions2.default.DELETE + " " + id + "? " + "This action is irreversible.";
	
	      if (/stopCurrentJobRuns=true/.test(errorMsg)) {
	        actionButtonLabel = "Stop Current Runs and " + _StringUtil2.default.capitalize(_UserActions2.default.DELETE) + " Job";
	        stopCurrentJobRuns = true;
	        message = "Couldn't " + _UserActions2.default.DELETE + " " + id + " as there are currently active job runs. Do you want to stop all runs and " + _UserActions2.default.DELETE + " the job?";
	      }
	
	      var content = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "text-danger text-align-center flush-top" },
	          _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	          " Job"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          message
	        )
	      );
	
	      return _react2.default.createElement(_reactjsComponents.Confirm, {
	        children: content,
	        disabled: disabledDialog === DIALOGS.DESTROY,
	        open: jobActionDialog === DIALOGS.DESTROY,
	        onClose: this.closeDialog,
	        leftButtonText: "Cancel",
	        leftButtonCallback: this.closeDialog,
	        rightButtonText: actionButtonLabel,
	        rightButtonClassName: "button button-danger",
	        rightButtonCallback: this.handleAcceptDestroyDialog.bind(this, stopCurrentJobRuns)
	      });
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _MetronomeStore2.default.jobTree })
	        }),
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _MetronomeStore2.default.jobTree })
	        }),
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "getNavigationTabs",
	    value: function getNavigationTabs() {
	      return _react2.default.createElement(
	        "ul",
	        { className: "menu-tabbed" },
	        this.tabs_getUnroutedTabs()
	      );
	    }
	  }, {
	    key: "getPrettySchedule",
	    value: function getPrettySchedule(job) {
	      var schedules = job.getSchedules();
	      if (schedules == null || schedules.length === 0) {
	        return null;
	      }
	
	      var schedule = schedules[0];
	      if (schedule.enabled) {
	        return _prettycron2.default.toString(schedule.cron);
	      }
	    }
	  }, {
	    key: "getSubTitle",
	    value: function getSubTitle(job) {
	      var nodes = [];
	      var scheduleText = this.getPrettySchedule(job);
	      var longestRunningTask = null;
	      var longestRunningActiveRun = job.getActiveRuns().getLongestRunningActiveRun();
	
	      if (longestRunningActiveRun != null) {
	        longestRunningTask = longestRunningActiveRun.getTasks().getLongestRunningTask();
	      }
	
	      if (longestRunningTask == null && scheduleText == null) {
	        return null;
	      }
	
	      if (scheduleText != null) {
	        nodes.push(_react2.default.createElement(
	          "p",
	          { className: "text-overflow flush", key: "schedule-text" },
	          _react2.default.createElement(_Icon2.default, {
	            className: "icon-margin-right",
	            key: "schedule-icon",
	            color: "grey",
	            id: "repeat",
	            size: "mini"
	          }),
	          _react2.default.createElement(
	            "span",
	            null,
	            "Scheduled ",
	            _StringUtil2.default.lowercase(scheduleText)
	          )
	        ));
	      }
	
	      if (longestRunningTask != null) {
	        var dateCompleted = longestRunningTask.getDateCompleted();
	
	        var status = _TaskStates2.default[longestRunningTask.getStatus()];
	        var statusClasses = (0, _classnames2.default)("job-details-header-status", {
	          "text-success": status.stateTypes.includes("success") && !status.stateTypes.includes("failure"),
	          "text-danger": status.stateTypes.includes("failure")
	        });
	
	        var timePrefix = null;
	        var shouldSuppressRelativeTime = dateCompleted == null;
	
	        if (shouldSuppressRelativeTime) {
	          timePrefix = "for ";
	        }
	
	        nodes.push(_react2.default.createElement(
	          "span",
	          { className: statusClasses, key: "status-text" },
	          status.displayName
	        ), _react2.default.createElement(
	          "span",
	          { key: "time-running" },
	          _react2.default.createElement(_TimeAgo2.default, {
	            prefix: timePrefix,
	            suppressSuffix: shouldSuppressRelativeTime,
	            time: longestRunningActiveRun.getDateCreated()
	          })
	        ));
	      }
	
	      return nodes;
	    }
	  }, {
	    key: "renderConfigurationTabView",
	    value: function renderConfigurationTabView(job) {
	      return _react2.default.createElement(_JobConfiguration2.default, { job: job });
	    }
	  }, {
	    key: "renderRunHistoryTabView",
	    value: function renderRunHistoryTabView(job) {
	      return _react2.default.createElement(_JobRunHistoryTable2.default, { job: job });
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      var job = _MetronomeStore2.default.getJob(this.props.params.id);
	
	      var _job$getSchedules = job.getSchedules(),
	          _job$getSchedules2 = (0, _slicedToArray3.default)(_job$getSchedules, 1),
	          schedule = _job$getSchedules2[0];
	
	      var actions = [];
	
	      actions.push({
	        label: "Edit",
	        onItemSelect: this.handleEditButtonClick
	      });
	
	      actions.push({
	        label: "Run Now",
	        onItemSelect: this.handleRunNowButtonClick
	      });
	
	      if (schedule != null && schedule.enabled) {
	        actions.push({
	          label: "Disable Schedule",
	          onItemSelect: this.handleDisableScheduleButtonClick
	        });
	      }
	
	      if (schedule != null && !schedule.enabled) {
	        actions.push({
	          label: "Enable Schedule",
	          onItemSelect: this.handleEnableScheduleButtonClick
	        });
	      }
	
	      actions.push({
	        className: "text-danger",
	        label: _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	        onItemSelect: this.handleDestroyButtonClick
	      });
	
	      return actions;
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var _this3 = this;
	
	      var activeTab = this.state.currentTab;
	
	      return [{
	        label: "Run History",
	        callback: function callback() {
	          _this3.setState({ currentTab: "runHistory" });
	        },
	        isActive: activeTab === "runHistory"
	      }, {
	        label: "Configuration",
	        callback: function callback() {
	          _this3.setState({ currentTab: "configuration" });
	        },
	        isActive: activeTab === "configuration"
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.errorCount > 3) {
	        return this.getErrorScreen();
	      }
	
	      if (this.state.isLoading) {
	        return this.getLoadingScreen();
	      }
	
	      // TaskDetailView
	      if (this.props.params.taskID) {
	        return this.props.children;
	      }
	
	      var job = _MetronomeStore2.default.getJob(this.props.params.id);
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          actions: this.getActions(),
	          breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _MetronomeStore2.default.jobTree, item: job }),
	          tabs: this.getTabs()
	        }),
	        this.tabs_getTabView(job),
	        _react2.default.createElement(_JobFormModal2.default, {
	          isEdit: true,
	          job: job,
	          open: this.state.jobActionDialog === DIALOGS.EDIT,
	          onClose: this.closeDialog
	        }),
	        this.getDestroyConfirmDialog()
	      );
	    }
	  }]);
	  return JobDetailPage;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _TabsMixin2.default));
	
	JobDetailPage.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = JobDetailPage;

/***/ },
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _HashMapDisplay = __webpack_require__(1437);
	
	var _HashMapDisplay2 = _interopRequireDefault(_HashMapDisplay);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobConfiguration = function (_React$Component) {
	  (0, _inherits3.default)(JobConfiguration, _React$Component);
	
	  function JobConfiguration() {
	    (0, _classCallCheck3.default)(this, JobConfiguration);
	    return (0, _possibleConstructorReturn3.default)(this, (JobConfiguration.__proto__ || (0, _getPrototypeOf2.default)(JobConfiguration)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobConfiguration, [{
	    key: "getSchedule",
	    value: function getSchedule(job) {
	      var lastSchedule = job.getSchedules()[0];
	
	      if (!!lastSchedule && !!lastSchedule.cron) {
	        return lastSchedule.cron;
	      }
	
	      return "No schedule available.";
	    }
	  }, {
	    key: "getGeneralSection",
	    value: function getGeneralSection(job) {
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "General"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "ID"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            job.getId()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Description"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            job.getDescription()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "CPUs"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            job.getCpus()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Memory (MiB)"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            job.getMem()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Disk Space (Mib)"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            job.getDisk()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Command"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { className: "flush transparent wrap" },
	              job.getCommand()
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getScheduleSection",
	    value: function getScheduleSection(job) {
	      var _job$getSchedules = job.getSchedules(),
	          _job$getSchedules2 = (0, _slicedToArray3.default)(_job$getSchedules, 1),
	          schedule = _job$getSchedules2[0];
	
	      if (schedule == null) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Schedule"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "ID"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            schedule.id
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Enabled"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            schedule.enabled
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "CRON Schedule"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            schedule.cron
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Time Zone"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            schedule.timezone
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Starting Deadline"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            schedule.startingDeadlineSeconds
	          )
	        )
	      );
	    }
	  }, {
	    key: "getDockerContainerSection",
	    value: function getDockerContainerSection(job) {
	      var docker = job.getDocker();
	      if (docker == null || !docker.image) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Docker Container"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Image"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            docker.image
	          )
	        )
	      );
	    }
	  }, {
	    key: "getLabelSection",
	    value: function getLabelSection(job) {
	      return _react2.default.createElement(_HashMapDisplay2.default, { hash: job.getLabels(), headline: "Labels" });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var job = this.props.job;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          this.getGeneralSection(job),
	          this.getScheduleSection(job),
	          this.getDockerContainerSection(job),
	          this.getLabelSection(job)
	        )
	      );
	    }
	  }]);
	  return JobConfiguration;
	}(_react2.default.Component);
	
	JobConfiguration.propTypes = {
	  job: _react2.default.PropTypes.instanceOf(_Job2.default).isRequired
	};
	
	module.exports = JobConfiguration;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapLabel = function ConfigurationMapLabel(props) {
	  var labelClasses = (0, _classnames2.default)("configuration-map-label", {
	    "configuration-map-label-no-text-transform": props.keepTextCase
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: labelClasses },
	    props.children
	  );
	};
	
	ConfigurationMapLabel.propTypes = {
	  keepTextCase: _react2.default.PropTypes.bool
	};
	
	module.exports = ConfigurationMapLabel;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapValue = function ConfigurationMapValue(props) {
	  var classes = (0, _classnames2.default)("configuration-map-value", {
	    "configuration-map-value-stacked": props.stacked
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes },
	    props.value || props.children
	  );
	};
	
	module.exports = ConfigurationMapValue;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashMapDisplay = function (_React$Component) {
	  (0, _inherits3.default)(HashMapDisplay, _React$Component);
	
	  function HashMapDisplay() {
	    (0, _classCallCheck3.default)(this, HashMapDisplay);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HashMapDisplay.__proto__ || (0, _getPrototypeOf2.default)(HashMapDisplay)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(HashMapDisplay, [{
	    key: "getHeadline",
	    value: function getHeadline() {
	      var _props = this.props,
	          headline = _props.headline,
	          headlineClassName = _props.headlineClassName,
	          headingLevel = _props.headingLevel;
	
	      if (!headline) {
	        return null;
	      }
	
	      // Wrap in headline element and classes
	      return _react2.default.createElement(
	        _ConfigurationMapHeading2.default,
	        {
	          className: headlineClassName,
	          level: headingLevel
	        },
	        headline
	      );
	    }
	  }, {
	    key: "getItems",
	    value: function getItems() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          hash = _props2.hash,
	          headingLevel = _props2.headingLevel,
	          renderKeys = _props2.renderKeys;
	
	
	      return (0, _keys2.default)(hash).map(function (key, index) {
	        var value = hash[key];
	
	        // Check whether we are trying to render an object that is not a
	        // React component
	        if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && !Array.isArray(value) && value !== null && !_react2.default.isValidElement(value)) {
	          // Increase the heading level for each nested description list, making
	          // ensuring we don't surpass heading level 6.
	          var nextHeadingLevel = Math.min(headingLevel + 1, 6);
	
	          return _react2.default.createElement(HashMapDisplay, (0, _extends3.default)({}, _this2.props, {
	            hash: value,
	            headingLevel: nextHeadingLevel,
	            key: index,
	            headline: key
	          }));
	        }
	
	        if (typeof value === "boolean") {
	          value = value.toString();
	        }
	
	        if (Array.isArray(value)) {
	          value = value.join(", ");
	        }
	
	        // Check if we need to render a component in the dt
	        if (Object.prototype.hasOwnProperty.call(renderKeys, key)) {
	          key = renderKeys[key];
	        }
	
	        var isAttribute = _this2.props.headline === "Attributes";
	
	        return _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: index },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            { keepTextCase: isAttribute },
	            key
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            value
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var hash = this.props.hash;
	
	      if (!hash || (0, _keys2.default)(hash).length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        { key: this.props.key },
	        this.getHeadline(),
	        this.getItems()
	      );
	    }
	  }]);
	  return HashMapDisplay;
	}(_react2.default.Component);
	
	HashMapDisplay.defaultProps = {
	  headingLevel: 1,
	  key: "",
	  renderKeys: {}
	};
	
	HashMapDisplay.propTypes = {
	  headingLevel: _react2.default.PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
	  headlineClassName: _react2.default.PropTypes.string,
	  headline: _react2.default.PropTypes.node,
	  hash: _react2.default.PropTypes.object,
	  key: _react2.default.PropTypes.string,
	  // Optional object with keys consisting of keys in `props.hash` to be
	  // replaced, and with corresponding values of the replacement to be rendered.
	  renderKeys: _react2.default.PropTypes.object
	};
	
	module.exports = HashMapDisplay;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAce = __webpack_require__(1439);
	
	var _reactAce2 = _interopRequireDefault(_reactAce);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	__webpack_require__(1449);
	
	__webpack_require__(1451);
	
	__webpack_require__(1452);
	
	var _CollapsibleErrorMessage = __webpack_require__(1453);
	
	var _CollapsibleErrorMessage2 = _interopRequireDefault(_CollapsibleErrorMessage);
	
	var _CleanJSONUtil = __webpack_require__(1065);
	
	var _FormUtil = __webpack_require__(1454);
	
	var _FormUtil2 = _interopRequireDefault(_FormUtil);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _JobForm = __webpack_require__(1455);
	
	var _JobForm2 = _interopRequireDefault(_JobForm);
	
	var _JobUtil = __webpack_require__(1463);
	
	var _JobUtil2 = _interopRequireDefault(_JobUtil);
	
	var _JobSchema = __webpack_require__(1464);
	
	var _JobSchema2 = _interopRequireDefault(_JobSchema);
	
	var _MetronomeStore = __webpack_require__(1248);
	
	var _MetronomeStore2 = _interopRequireDefault(_MetronomeStore);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _SchemaUtil = __webpack_require__(1460);
	
	var _SchemaUtil2 = _interopRequireDefault(_SchemaUtil);
	
	var _ToggleButton = __webpack_require__(1472);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleCancel", "handleFormChange", "handleJSONEditorChange", "handleInputModeToggle", "handleSubmit", "handleTabChange", "handleTriggerSubmit", "onMetronomeStoreJobCreateSuccess", "onMetronomeStoreJobCreateError", "onMetronomeStoreJobUpdateSuccess", "onMetronomeStoreJobUpdateError"];
	
	var serverResponseMappings = {
	  "error.path.missing": "Specify a path",
	  "error.minLength": "Field may not be blank",
	  "error.expected.jsnumber": "A number is expected",
	  "error.expected.jsstring": "A string is expected"
	};
	
	// The values of this map are only used to generate the error strings atm.
	// This mapping will make sense when we introduce client-side validation.
	var responseAttributePathToFieldIdMap = {
	  "/id": "id",
	  "/description": "description",
	  "/run/cpus": "cpus",
	  "/run/mem": "mem",
	  "/run/disk": "disk",
	  "/run/cmd": "cmd",
	  "/run/docker/image": "docker/image",
	  "/schedules/{INDEX}/id": "schedules/{INDEX}/id",
	  "/schedules/{INDEX}/cron": "schedules/{INDEX}/cron",
	  "/schedules({INDEX})/cron": "schedules/{INDEX}/cron",
	  "/schedules/{INDEX}/concurrencyPolicy": "schedules/{INDEX}/concurrencyPolicy",
	  "/schedules/{INDEX}/enabled": "schedules/{INDEX}/enabled",
	  "/labels": "labels"
	};
	
	var JobFormModal = function (_mixin) {
	  (0, _inherits3.default)(JobFormModal, _mixin);
	
	  function JobFormModal() {
	    (0, _classCallCheck3.default)(this, JobFormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobFormModal.__proto__ || (0, _getPrototypeOf2.default)(JobFormModal)).apply(this, arguments));
	
	    _this.state = {
	      defaultTab: "",
	      errorMessage: null,
	      job: new _Job2.default(),
	      jobFormModel: null,
	      jobJsonString: null,
	      jsonMode: false
	    };
	
	    _this.store_listeners = [{
	      name: "metronome",
	      events: ["jobCreateSuccess", "jobCreateError", "jobUpdateSuccess", "jobUpdateError"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.triggerFormSubmit = undefined;
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobFormModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open !== this.props.open) {
	        this.resetState();
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var _state = this.state,
	          errorMessage = _state.errorMessage,
	          jsonMode = _state.jsonMode;
	      var open = this.props.open;
	
	
	      return nextProps.open !== open || nextState.errorMessage !== errorMessage || nextState.jsonMode !== jsonMode;
	    }
	  }, {
	    key: "onMetronomeStoreJobCreateSuccess",
	    value: function onMetronomeStoreJobCreateSuccess() {
	      this.resetState();
	      this.props.onClose();
	    }
	  }, {
	    key: "onMetronomeStoreJobCreateError",
	    value: function onMetronomeStoreJobCreateError(errorMessage) {
	      this.setState({
	        errorMessage: errorMessage
	      });
	    }
	  }, {
	    key: "onMetronomeStoreJobUpdateSuccess",
	    value: function onMetronomeStoreJobUpdateSuccess() {
	      this.resetState();
	      this.props.onClose();
	    }
	  }, {
	    key: "onMetronomeStoreJobUpdateError",
	    value: function onMetronomeStoreJobUpdateError(errorMessage) {
	      this.setState({
	        errorMessage: errorMessage
	      });
	    }
	  }, {
	    key: "resetState",
	    value: function resetState() {
	      var job = this.props.job;
	
	      this.setState({
	        defaultTab: "",
	        errorMessage: null,
	        jobFormModel: _JobUtil2.default.createFormModelFromSchema(_JobSchema2.default, job),
	        jobJsonString: (0, _stringify2.default)((0, _CleanJSONUtil.cleanJobJSON)(_JobUtil2.default.createJobSpecFromJob(job)), null, 2),
	        jsonMode: false
	      });
	    }
	  }, {
	    key: "createJobFromEditorContents",
	    value: function createJobFromEditorContents() {
	      var keepValidationErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var _state2 = this.state,
	          jobJsonString = _state2.jobJsonString,
	          jsonMode = _state2.jsonMode;
	
	      var jobDefinition = null;
	
	      // Try to parse JSON string and detect errors
	      try {
	        jobDefinition = JSON.parse(jobJsonString);
	      } catch (e) {
	        this.setState({
	          errorMessage: {
	            message: "Invalid JSON syntax",
	            details: [{ path: "/", errors: [e.toString()] }]
	          }
	        });
	
	        return null;
	      }
	
	      var job = new _Job2.default(jobDefinition);
	
	      if (jsonMode) {
	        // Really hackish way to validate the json string schema, trying to re-use
	        // as much code as possilbe without getting nasty.
	        var dummyItemRenderer = function dummyItemRenderer() {
	          return _react2.default.createElement("div", null);
	        };
	
	        var formModel = _JobUtil2.default.createFormModelFromSchema(_JobSchema2.default, job);
	        var formMultiDef = _SchemaUtil2.default.schemaToMultipleDefinition({
	          schema: _JobSchema2.default,
	          renderSubheader: dummyItemRenderer,
	          renderLabel: dummyItemRenderer,
	          renderRemove: dummyItemRenderer,
	          renderAdd: dummyItemRenderer
	        });
	        var errorDetails = [];
	
	        _FormUtil2.default.forEachDefinition(formMultiDef, function (definition) {
	          definition.showError = false;
	
	          if (typeof definition.externalValidator !== "function") {
	            return null;
	          }
	
	          var fieldValidated = definition.externalValidator(formModel, definition);
	          if (!fieldValidated) {
	            errorDetails.push({
	              path: "/",
	              errors: [definition.showError]
	            });
	          }
	        });
	
	        // If we have errors, display them
	        if (errorDetails.length) {
	          this.setState({
	            errorMessage: {
	              message: "There are errors in your JSON definition",
	              details: errorDetails
	            }
	          });
	          if (!keepValidationErrors) {
	            return null;
	          }
	        }
	
	        return job;
	      }
	
	      // Even though we have our model already in the state, we cannot
	      // perform validation on it's data. It's true that `onChange`
	      // returns validation information, but that's not the case when the
	      // user clicks the `submit` button without changing anything.
	
	      // Therefore we need to ask the SchemaForm to perform validation
	      // and return the model once again
	
	      var _triggerFormSubmit = this.triggerFormSubmit(),
	          model = _triggerFormSubmit.model,
	          isValidated = _triggerFormSubmit.isValidated;
	
	      if (!isValidated) {
	        this.setState({
	          errorMessage: {
	            message: "Please fix all the errors first",
	            details: null
	          }
	        });
	        if (!keepValidationErrors) {
	          return null;
	        }
	      }
	
	      return _JobUtil2.default.createJobFromFormModel(model, job.get());
	    }
	  }, {
	    key: "handleCancel",
	    value: function handleCancel() {
	      this.props.onClose();
	    }
	  }, {
	    key: "handleInputModeToggle",
	    value: function handleInputModeToggle() {
	      var job = this.createJobFromEditorContents(true) || this.props.job;
	
	      if (this.state.jsonMode) {
	        this.setState({
	          errorMessage: null,
	          jobFormModel: _JobUtil2.default.createFormModelFromSchema(_JobSchema2.default, job),
	          jsonMode: false
	        });
	      } else {
	        this.setState({
	          errorMessage: null,
	          jobJsonString: (0, _stringify2.default)((0, _CleanJSONUtil.cleanJobJSON)(_JobUtil2.default.createJobSpecFromJob(job)), null, 2),
	          jsonMode: true
	        });
	      }
	    }
	  }, {
	    key: "handleFormChange",
	    value: function handleFormChange(event) {
	      if (!event.model) {
	        return;
	      }
	
	      this.setState({
	        errorMessage: null
	      });
	    }
	  }, {
	    key: "handleJSONEditorChange",
	    value: function handleJSONEditorChange(jsonDefinition) {
	      this.setState({
	        errorMessage: null,
	        jobJsonString: jsonDefinition
	      });
	    }
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit() {
	      var job = this.createJobFromEditorContents();
	      if (!job) {
	        return;
	      }
	
	      var jobSpec = _JobUtil2.default.createJobSpecFromJob(job);
	
	      if (!this.props.isEdit) {
	        _MetronomeStore2.default.createJob(jobSpec);
	      } else {
	        _MetronomeStore2.default.updateJob(job.getId(), jobSpec);
	      }
	    }
	  }, {
	    key: "handleTabChange",
	    value: function handleTabChange(tab) {
	      this.setState({ defaultTab: tab });
	    }
	  }, {
	    key: "handleTriggerSubmit",
	    value: function handleTriggerSubmit(submitFunction) {
	      this.triggerFormSubmit = submitFunction;
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var errorMessage = this.state.errorMessage;
	
	      var errorList = null;
	
	      if (!errorMessage) {
	        return null;
	      }
	
	      // Stringify error details
	      if (errorMessage.details != null) {
	        errorList = errorMessage.details.map(function (_ref) {
	          var path = _ref.path,
	              errors = _ref.errors;
	
	          var fieldId = "general";
	
	          // See: https://github.com/dcos/metronome/issues/71
	          // Check if attributePath contains an index like path(0)/attribute
	          // Matches as defined: [0] : '/0/' (or [0] : '(0)'), [1]: '0'
	          var matches = path.match(/[/(](\d+)[/)]/);
	          if (matches != null) {
	            // Keep the separator characters as returned by the server
	            // Example: (0), /0/  -> ({INDEX}), /{INDEX}/
	            var placeholder = matches[0].replace(/(\d+)/, "{INDEX}");
	            var resolvePath = responseAttributePathToFieldIdMap[path.replace(matches[0], placeholder)];
	
	            if (resolvePath != null) {
	              fieldId = resolvePath.replace("{INDEX}", matches[1]);
	            }
	          } else {
	            fieldId = responseAttributePathToFieldIdMap[path] || fieldId;
	          }
	
	          errors = errors.map(function (error) {
	            if (serverResponseMappings[error]) {
	              return serverResponseMappings[error];
	            }
	
	            return error;
	          });
	
	          // Return path-prefixed error string
	          return fieldId + ": " + errors;
	        });
	      }
	
	      return _react2.default.createElement(_CollapsibleErrorMessage2.default, {
	        className: "error-for-modal",
	        details: errorList,
	        message: errorMessage.message
	      });
	    }
	  }, {
	    key: "getModalContents",
	    value: function getModalContents() {
	      var _state3 = this.state,
	          defaultTab = _state3.defaultTab,
	          jobFormModel = _state3.jobFormModel,
	          jobJsonString = _state3.jobJsonString,
	          jsonMode = _state3.jsonMode;
	
	
	      if (jsonMode) {
	        return _react2.default.createElement(_reactAce2.default, {
	          editorProps: { $blockScrolling: true },
	          mode: "json",
	          onChange: this.handleJSONEditorChange,
	          showGutter: true,
	          showPrintMargin: false,
	          theme: "monokai",
	          height: "100%",
	          value: jobJsonString,
	          width: "100%"
	        });
	      }
	
	      return _react2.default.createElement(_JobForm2.default, {
	        defaultTab: defaultTab,
	        onTabChange: this.handleTabChange,
	        onChange: this.handleFormChange,
	        getTriggerSubmit: this.handleTriggerSubmit,
	        model: jobFormModel,
	        isEdit: this.props.isEdit,
	        schema: _JobSchema2.default
	      });
	    }
	  }, {
	    key: "getModalFooter",
	    value: function getModalFooter() {
	      var submitLabel = "Create Job";
	      if (this.props.isEdit) {
	        submitLabel = "Save Job";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          "button",
	          { className: "button", onClick: this.handleCancel },
	          "Cancel"
	        ),
	        _react2.default.createElement(
	          "button",
	          { className: "button button-success", onClick: this.handleSubmit },
	          submitLabel
	        )
	      );
	    }
	  }, {
	    key: "getModalTitle",
	    value: function getModalTitle() {
	      var heading = " New Job";
	      if (this.props.isEdit) {
	        heading = "Edit Job (" + this.props.job.getName() + ")";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "header-flex" },
	          _react2.default.createElement(
	            "div",
	            { className: "header-left" },
	            _react2.default.createElement(
	              _ModalHeading2.default,
	              { align: "left", level: 4 },
	              heading
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "header-right" },
	            _react2.default.createElement(
	              _ToggleButton2.default,
	              {
	                className: "modal-form-title-label flush-bottom",
	                checkboxClassName: "toggle-button",
	                checked: this.state.jsonMode,
	                onChange: this.handleInputModeToggle
	              },
	              "JSON mode"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "header-full-width" },
	          this.getErrorMessage()
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          backdropClass: "modal-backdrop default-cursor",
	          modalWrapperClass: "multiple-form-modal modal-form",
	          open: this.props.open,
	          scrollContainerClass: "multiple-form-modal-body",
	          showHeader: true,
	          footer: this.getModalFooter(),
	          header: this.getModalTitle(),
	          showFooter: true,
	          useGemini: false
	        },
	        this.getModalContents()
	      );
	    }
	  }]);
	  return JobFormModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	JobFormModal.defaultProps = {
	  isEdit: false,
	  job: new _Job2.default(),
	  onClose: function onClose() {},
	
	  open: false
	};
	
	JobFormModal.propTypes = {
	  isEdit: _react2.default.PropTypes.bool,
	  job: _react2.default.PropTypes.instanceOf(_Job2.default),
	  open: _react2.default.PropTypes.bool,
	  onClose: _react2.default.PropTypes.func
	};
	
	module.exports = JobFormModal;

/***/ },
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;
	
	var JsonHighlightRules = function() {
	    this.$rules = {
	        "start" : [
	            {
	                token : "variable", // single line
	                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
	            }, {
	                token : "string", // single line
	                regex : '"',
	                next  : "string"
	            }, {
	                token : "constant.numeric", // hex
	                regex : "0[xX][0-9a-fA-F]+\\b"
	            }, {
	                token : "constant.numeric", // float
	                regex : "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
	            }, {
	                token : "constant.language.boolean",
	                regex : "(?:true|false)\\b"
	            }, {
	                token : "invalid.illegal", // single quoted strings are not allowed
	                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
	            }, {
	                token : "invalid.illegal", // comments are not allowed
	                regex : "\\/\\/.*$"
	            }, {
	                token : "paren.lparen",
	                regex : "[[({]"
	            }, {
	                token : "paren.rparen",
	                regex : "[\\])}]"
	            }, {
	                token : "text",
	                regex : "\\s+"
	            }
	        ],
	        "string" : [
	            {
	                token : "constant.language.escape",
	                regex : /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
	            }, {
	                token : "string",
	                regex : '[^"\\\\]+'
	            }, {
	                token : "string",
	                regex : '"',
	                next  : "start"
	            }, {
	                token : "string",
	                regex : "",
	                next  : "start"
	            }
	        ]
	    };
	    
	};
	
	oop.inherits(JsonHighlightRules, TextHighlightRules);
	
	exports.JsonHighlightRules = JsonHighlightRules;
	});
	
	ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
	"use strict";
	
	var Range = acequire("../range").Range;
	
	var MatchingBraceOutdent = function() {};
	
	(function() {
	
	    this.checkOutdent = function(line, input) {
	        if (! /^\s+$/.test(line))
	            return false;
	
	        return /^\s*\}/.test(input);
	    };
	
	    this.autoOutdent = function(doc, row) {
	        var line = doc.getLine(row);
	        var match = line.match(/^(\s*\})/);
	
	        if (!match) return 0;
	
	        var column = match[1].length;
	        var openBracePos = doc.findMatchingBracket({row: row, column: column});
	
	        if (!openBracePos || openBracePos.row == row) return 0;
	
	        var indent = this.$getIndent(doc.getLine(openBracePos.row));
	        doc.replace(new Range(row, 0, row, column-1), indent);
	    };
	
	    this.$getIndent = function(line) {
	        return line.match(/^\s*/)[0];
	    };
	
	}).call(MatchingBraceOutdent.prototype);
	
	exports.MatchingBraceOutdent = MatchingBraceOutdent;
	});
	
	ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Behaviour = acequire("../behaviour").Behaviour;
	var TokenIterator = acequire("../../token_iterator").TokenIterator;
	var lang = acequire("../../lib/lang");
	
	var SAFE_INSERT_IN_TOKENS =
	    ["text", "paren.rparen", "punctuation.operator"];
	var SAFE_INSERT_BEFORE_TOKENS =
	    ["text", "paren.rparen", "punctuation.operator", "comment"];
	
	var context;
	var contextCache = {};
	var initContext = function(editor) {
	    var id = -1;
	    if (editor.multiSelect) {
	        id = editor.selection.index;
	        if (contextCache.rangeCount != editor.multiSelect.rangeCount)
	            contextCache = {rangeCount: editor.multiSelect.rangeCount};
	    }
	    if (contextCache[id])
	        return context = contextCache[id];
	    context = contextCache[id] = {
	        autoInsertedBrackets: 0,
	        autoInsertedRow: -1,
	        autoInsertedLineEnd: "",
	        maybeInsertedBrackets: 0,
	        maybeInsertedRow: -1,
	        maybeInsertedLineStart: "",
	        maybeInsertedLineEnd: ""
	    };
	};
	
	var getWrapped = function(selection, selected, opening, closing) {
	    var rowDiff = selection.end.row - selection.start.row;
	    return {
	        text: opening + selected + closing,
	        selection: [
	                0,
	                selection.start.column + 1,
	                rowDiff,
	                selection.end.column + (rowDiff ? 0 : 1)
	            ]
	    };
	};
	
	var CstyleBehaviour = function() {
	    this.add("braces", "insertion", function(state, action, editor, session, text) {
	        var cursor = editor.getCursorPosition();
	        var line = session.doc.getLine(cursor.row);
	        if (text == '{') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && selected !== "{" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '{', '}');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                if (/[\]\}\)]/.test(line[cursor.column]) || editor.inMultiSelectMode) {
	                    CstyleBehaviour.recordAutoInsert(editor, session, "}");
	                    return {
	                        text: '{}',
	                        selection: [1, 1]
	                    };
	                } else {
	                    CstyleBehaviour.recordMaybeInsert(editor, session, "{");
	                    return {
	                        text: '{',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        } else if (text == '}') {
	            initContext(editor);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == '}') {
	                var matching = session.$findOpeningBracket('}', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        } else if (text == "\n" || text == "\r\n") {
	            initContext(editor);
	            var closing = "";
	            if (CstyleBehaviour.isMaybeInsertedClosing(cursor, line)) {
	                closing = lang.stringRepeat("}", context.maybeInsertedBrackets);
	                CstyleBehaviour.clearMaybeInsertedClosing();
	            }
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar === '}') {
	                var openBracePos = session.findMatchingBracket({row: cursor.row, column: cursor.column+1}, '}');
	                if (!openBracePos)
	                     return null;
	                var next_indent = this.$getIndent(session.getLine(openBracePos.row));
	            } else if (closing) {
	                var next_indent = this.$getIndent(line);
	            } else {
	                CstyleBehaviour.clearMaybeInsertedClosing();
	                return;
	            }
	            var indent = next_indent + session.getTabString();
	
	            return {
	                text: '\n' + indent + '\n' + next_indent + closing,
	                selection: [1, indent.length, 1, indent.length]
	            };
	        } else {
	            CstyleBehaviour.clearMaybeInsertedClosing();
	        }
	    });
	
	    this.add("braces", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '{') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.end.column, range.end.column + 1);
	            if (rightChar == '}') {
	                range.end.column++;
	                return range;
	            } else {
	                context.maybeInsertedBrackets--;
	            }
	        }
	    });
	
	    this.add("parens", "insertion", function(state, action, editor, session, text) {
	        if (text == '(') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '(', ')');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                CstyleBehaviour.recordAutoInsert(editor, session, ")");
	                return {
	                    text: '()',
	                    selection: [1, 1]
	                };
	            }
	        } else if (text == ')') {
	            initContext(editor);
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == ')') {
	                var matching = session.$findOpeningBracket(')', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        }
	    });
	
	    this.add("parens", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '(') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == ')') {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	    this.add("brackets", "insertion", function(state, action, editor, session, text) {
	        if (text == '[') {
	            initContext(editor);
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, '[', ']');
	            } else if (CstyleBehaviour.isSaneInsertion(editor, session)) {
	                CstyleBehaviour.recordAutoInsert(editor, session, "]");
	                return {
	                    text: '[]',
	                    selection: [1, 1]
	                };
	            }
	        } else if (text == ']') {
	            initContext(editor);
	            var cursor = editor.getCursorPosition();
	            var line = session.doc.getLine(cursor.row);
	            var rightChar = line.substring(cursor.column, cursor.column + 1);
	            if (rightChar == ']') {
	                var matching = session.$findOpeningBracket(']', {column: cursor.column + 1, row: cursor.row});
	                if (matching !== null && CstyleBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                    CstyleBehaviour.popAutoInsertedClosing();
	                    return {
	                        text: '',
	                        selection: [1, 1]
	                    };
	                }
	            }
	        }
	    });
	
	    this.add("brackets", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && selected == '[') {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == ']') {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	    this.add("string_dquotes", "insertion", function(state, action, editor, session, text) {
	        if (text == '"' || text == "'") {
	            initContext(editor);
	            var quote = text;
	            var selection = editor.getSelectionRange();
	            var selected = session.doc.getTextRange(selection);
	            if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) {
	                return getWrapped(selection, selected, quote, quote);
	            } else if (!selected) {
	                var cursor = editor.getCursorPosition();
	                var line = session.doc.getLine(cursor.row);
	                var leftChar = line.substring(cursor.column-1, cursor.column);
	                var rightChar = line.substring(cursor.column, cursor.column + 1);
	                
	                var token = session.getTokenAt(cursor.row, cursor.column);
	                var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
	                if (leftChar == "\\" && token && /escape/.test(token.type))
	                    return null;
	                
	                var stringBefore = token && /string|escape/.test(token.type);
	                var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
	                
	                var pair;
	                if (rightChar == quote) {
	                    pair = stringBefore !== stringAfter;
	                } else {
	                    if (stringBefore && !stringAfter)
	                        return null; // wrap string with different quote
	                    if (stringBefore && stringAfter)
	                        return null; // do not pair quotes inside strings
	                    var wordRe = session.$mode.tokenRe;
	                    wordRe.lastIndex = 0;
	                    var isWordBefore = wordRe.test(leftChar);
	                    wordRe.lastIndex = 0;
	                    var isWordAfter = wordRe.test(leftChar);
	                    if (isWordBefore || isWordAfter)
	                        return null; // before or after alphanumeric
	                    if (rightChar && !/[\s;,.})\]\\]/.test(rightChar))
	                        return null; // there is rightChar and it isn't closing
	                    pair = true;
	                }
	                return {
	                    text: pair ? quote + quote : "",
	                    selection: [1,1]
	                };
	            }
	        }
	    });
	
	    this.add("string_dquotes", "deletion", function(state, action, editor, session, range) {
	        var selected = session.doc.getTextRange(range);
	        if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
	            initContext(editor);
	            var line = session.doc.getLine(range.start.row);
	            var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	            if (rightChar == selected) {
	                range.end.column++;
	                return range;
	            }
	        }
	    });
	
	};
	
	    
	CstyleBehaviour.isSaneInsertion = function(editor, session) {
	    var cursor = editor.getCursorPosition();
	    var iterator = new TokenIterator(session, cursor.row, cursor.column);
	    if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
	        var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
	        if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS))
	            return false;
	    }
	    iterator.stepForward();
	    return iterator.getCurrentTokenRow() !== cursor.row ||
	        this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
	};
	
	CstyleBehaviour.$matchTokenType = function(token, types) {
	    return types.indexOf(token.type || token) > -1;
	};
	
	CstyleBehaviour.recordAutoInsert = function(editor, session, bracket) {
	    var cursor = editor.getCursorPosition();
	    var line = session.doc.getLine(cursor.row);
	    if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0]))
	        context.autoInsertedBrackets = 0;
	    context.autoInsertedRow = cursor.row;
	    context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
	    context.autoInsertedBrackets++;
	};
	
	CstyleBehaviour.recordMaybeInsert = function(editor, session, bracket) {
	    var cursor = editor.getCursorPosition();
	    var line = session.doc.getLine(cursor.row);
	    if (!this.isMaybeInsertedClosing(cursor, line))
	        context.maybeInsertedBrackets = 0;
	    context.maybeInsertedRow = cursor.row;
	    context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
	    context.maybeInsertedLineEnd = line.substr(cursor.column);
	    context.maybeInsertedBrackets++;
	};
	
	CstyleBehaviour.isAutoInsertedClosing = function(cursor, line, bracket) {
	    return context.autoInsertedBrackets > 0 &&
	        cursor.row === context.autoInsertedRow &&
	        bracket === context.autoInsertedLineEnd[0] &&
	        line.substr(cursor.column) === context.autoInsertedLineEnd;
	};
	
	CstyleBehaviour.isMaybeInsertedClosing = function(cursor, line) {
	    return context.maybeInsertedBrackets > 0 &&
	        cursor.row === context.maybeInsertedRow &&
	        line.substr(cursor.column) === context.maybeInsertedLineEnd &&
	        line.substr(0, cursor.column) == context.maybeInsertedLineStart;
	};
	
	CstyleBehaviour.popAutoInsertedClosing = function() {
	    context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
	    context.autoInsertedBrackets--;
	};
	
	CstyleBehaviour.clearMaybeInsertedClosing = function() {
	    if (context) {
	        context.maybeInsertedBrackets = 0;
	        context.maybeInsertedRow = -1;
	    }
	};
	
	
	
	oop.inherits(CstyleBehaviour, Behaviour);
	
	exports.CstyleBehaviour = CstyleBehaviour;
	});
	
	ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../../lib/oop");
	var Range = acequire("../../range").Range;
	var BaseFoldMode = acequire("./fold_mode").FoldMode;
	
	var FoldMode = exports.FoldMode = function(commentRegex) {
	    if (commentRegex) {
	        this.foldingStartMarker = new RegExp(
	            this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start)
	        );
	        this.foldingStopMarker = new RegExp(
	            this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end)
	        );
	    }
	};
	oop.inherits(FoldMode, BaseFoldMode);
	
	(function() {
	    
	    this.foldingStartMarker = /(\{|\[)[^\}\]]*$|^\s*(\/\*)/;
	    this.foldingStopMarker = /^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/;
	    this.singleLineBlockCommentRe= /^\s*(\/\*).*\*\/\s*$/;
	    this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
	    this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
	    this._getFoldWidgetBase = this.getFoldWidget;
	    this.getFoldWidget = function(session, foldStyle, row) {
	        var line = session.getLine(row);
	    
	        if (this.singleLineBlockCommentRe.test(line)) {
	            if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line))
	                return "";
	        }
	    
	        var fw = this._getFoldWidgetBase(session, foldStyle, row);
	    
	        if (!fw && this.startRegionRe.test(line))
	            return "start"; // lineCommentRegionStart
	    
	        return fw;
	    };
	
	    this.getFoldWidgetRange = function(session, foldStyle, row, forceMultiline) {
	        var line = session.getLine(row);
	        
	        if (this.startRegionRe.test(line))
	            return this.getCommentRegionBlock(session, line, row);
	        
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            var i = match.index;
	
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, i);
	                
	            var range = session.getCommentFoldRange(row, i + match[0].length, 1);
	            
	            if (range && !range.isMultiLine()) {
	                if (forceMultiline) {
	                    range = this.getSectionRange(session, row);
	                } else if (foldStyle != "all")
	                    range = null;
	            }
	            
	            return range;
	        }
	
	        if (foldStyle === "markbegin")
	            return;
	
	        var match = line.match(this.foldingStopMarker);
	        if (match) {
	            var i = match.index + match[0].length;
	
	            if (match[1])
	                return this.closingBracketBlock(session, match[1], row, i);
	
	            return session.getCommentFoldRange(row, i, -1);
	        }
	    };
	    
	    this.getSectionRange = function(session, row) {
	        var line = session.getLine(row);
	        var startIndent = line.search(/\S/);
	        var startRow = row;
	        var startColumn = line.length;
	        row = row + 1;
	        var endRow = row;
	        var maxRow = session.getLength();
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var indent = line.search(/\S/);
	            if (indent === -1)
	                continue;
	            if  (startIndent > indent)
	                break;
	            var subRange = this.getFoldWidgetRange(session, "all", row);
	            
	            if (subRange) {
	                if (subRange.start.row <= startRow) {
	                    break;
	                } else if (subRange.isMultiLine()) {
	                    row = subRange.end.row;
	                } else if (startIndent == indent) {
	                    break;
	                }
	            }
	            endRow = row;
	        }
	        
	        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
	    };
	    this.getCommentRegionBlock = function(session, line, row) {
	        var startColumn = line.search(/\s*$/);
	        var maxRow = session.getLength();
	        var startRow = row;
	        
	        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
	        var depth = 1;
	        while (++row < maxRow) {
	            line = session.getLine(row);
	            var m = re.exec(line);
	            if (!m) continue;
	            if (m[1]) depth--;
	            else depth++;
	
	            if (!depth) break;
	        }
	
	        var endRow = row;
	        if (endRow > startRow) {
	            return new Range(startRow, startColumn, endRow, line.length);
	        }
	    };
	
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"], function(acequire, exports, module) {
	"use strict";
	
	var oop = acequire("../lib/oop");
	var TextMode = acequire("./text").Mode;
	var HighlightRules = acequire("./json_highlight_rules").JsonHighlightRules;
	var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
	var CstyleBehaviour = acequire("./behaviour/cstyle").CstyleBehaviour;
	var CStyleFoldMode = acequire("./folding/cstyle").FoldMode;
	var WorkerClient = acequire("../worker/worker_client").WorkerClient;
	
	var Mode = function() {
	    this.HighlightRules = HighlightRules;
	    this.$outdent = new MatchingBraceOutdent();
	    this.$behaviour = new CstyleBehaviour();
	    this.foldingRules = new CStyleFoldMode();
	};
	oop.inherits(Mode, TextMode);
	
	(function() {
	
	    this.getNextLineIndent = function(state, line, tab) {
	        var indent = this.$getIndent(line);
	
	        if (state == "start") {
	            var match = line.match(/^.*[\{\(\[]\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        }
	
	        return indent;
	    };
	
	    this.checkOutdent = function(state, line, input) {
	        return this.$outdent.checkOutdent(line, input);
	    };
	
	    this.autoOutdent = function(state, doc, row) {
	        this.$outdent.autoOutdent(doc, row);
	    };
	
	    this.createWorker = function(session) {
	        var worker = new WorkerClient(["ace"], __webpack_require__(1450), "JsonWorker");
	        worker.attachToDocument(session.getDocument());
	
	        worker.on("annotate", function(e) {
	            session.setAnnotations(e.data);
	        });
	
	        worker.on("terminate", function() {
	            session.clearAnnotations();
	        });
	
	        return worker;
	    };
	
	
	    this.$id = "ace/mode/json";
	}).call(Mode.prototype);
	
	exports.Mode = Mode;
	});


/***/ },
/* 1450 */
/***/ function(module, exports) {

	module.exports.id = 'ace/mode/json_worker';
	module.exports.src = "\"no use strict\";(function(window){function resolveModuleId(id,paths){for(var testPath=id,tail=\"\";testPath;){var alias=paths[testPath];if(\"string\"==typeof alias)return alias+tail;if(alias)return alias.location.replace(/\\/*$/,\"/\")+(tail||alias.main||alias.name);if(alias===!1)return\"\";var i=testPath.lastIndexOf(\"/\");if(-1===i)break;tail=testPath.substr(i)+tail,testPath=testPath.slice(0,i)}return id}if(!(void 0!==window.window&&window.document||window.acequire&&window.define)){window.console||(window.console=function(){var msgs=Array.prototype.slice.call(arguments,0);postMessage({type:\"log\",data:msgs})},window.console.error=window.console.warn=window.console.log=window.console.trace=window.console),window.window=window,window.ace=window,window.onerror=function(message,file,line,col,err){postMessage({type:\"error\",data:{message:message,data:err.data,file:file,line:line,col:col,stack:err.stack}})},window.normalizeModule=function(parentId,moduleName){if(-1!==moduleName.indexOf(\"!\")){var chunks=moduleName.split(\"!\");return window.normalizeModule(parentId,chunks[0])+\"!\"+window.normalizeModule(parentId,chunks[1])}if(\".\"==moduleName.charAt(0)){var base=parentId.split(\"/\").slice(0,-1).join(\"/\");for(moduleName=(base?base+\"/\":\"\")+moduleName;-1!==moduleName.indexOf(\".\")&&previous!=moduleName;){var previous=moduleName;moduleName=moduleName.replace(/^\\.\\//,\"\").replace(/\\/\\.\\//,\"/\").replace(/[^\\/]+\\/\\.\\.\\//,\"\")}}return moduleName},window.acequire=function acequire(parentId,id){if(id||(id=parentId,parentId=null),!id.charAt)throw Error(\"worker.js acequire() accepts only (parentId, id) as arguments\");id=window.normalizeModule(parentId,id);var module=window.acequire.modules[id];if(module)return module.initialized||(module.initialized=!0,module.exports=module.factory().exports),module.exports;if(!window.acequire.tlns)return console.log(\"unable to load \"+id);var path=resolveModuleId(id,window.acequire.tlns);return\".js\"!=path.slice(-3)&&(path+=\".js\"),window.acequire.id=id,window.acequire.modules[id]={},importScripts(path),window.acequire(parentId,id)},window.acequire.modules={},window.acequire.tlns={},window.define=function(id,deps,factory){if(2==arguments.length?(factory=deps,\"string\"!=typeof id&&(deps=id,id=window.acequire.id)):1==arguments.length&&(factory=id,deps=[],id=window.acequire.id),\"function\"!=typeof factory)return window.acequire.modules[id]={exports:factory,initialized:!0},void 0;deps.length||(deps=[\"require\",\"exports\",\"module\"]);var req=function(childId){return window.acequire(id,childId)};window.acequire.modules[id]={exports:{},factory:function(){var module=this,returnExports=factory.apply(this,deps.map(function(dep){switch(dep){case\"require\":return req;case\"exports\":return module.exports;case\"module\":return module;default:return req(dep)}}));return returnExports&&(module.exports=returnExports),module}}},window.define.amd={},acequire.tlns={},window.initBaseUrls=function(topLevelNamespaces){for(var i in topLevelNamespaces)acequire.tlns[i]=topLevelNamespaces[i]},window.initSender=function(){var EventEmitter=window.acequire(\"ace/lib/event_emitter\").EventEmitter,oop=window.acequire(\"ace/lib/oop\"),Sender=function(){};return function(){oop.implement(this,EventEmitter),this.callback=function(data,callbackId){postMessage({type:\"call\",id:callbackId,data:data})},this.emit=function(name,data){postMessage({type:\"event\",name:name,data:data})}}.call(Sender.prototype),new Sender};var main=window.main=null,sender=window.sender=null;window.onmessage=function(e){var msg=e.data;if(msg.event&&sender)sender._signal(msg.event,msg.data);else if(msg.command)if(main[msg.command])main[msg.command].apply(main,msg.args);else{if(!window[msg.command])throw Error(\"Unknown command:\"+msg.command);window[msg.command].apply(window,msg.args)}else if(msg.init){window.initBaseUrls(msg.tlns),acequire(\"ace/lib/es5-shim\"),sender=window.sender=window.initSender();var clazz=acequire(msg.module)[msg.classname];main=window.main=new clazz(sender)}}}})(this),ace.define(\"ace/lib/oop\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.inherits=function(ctor,superCtor){ctor.super_=superCtor,ctor.prototype=Object.create(superCtor.prototype,{constructor:{value:ctor,enumerable:!1,writable:!0,configurable:!0}})},exports.mixin=function(obj,mixin){for(var key in mixin)obj[key]=mixin[key];return obj},exports.implement=function(proto,mixin){exports.mixin(proto,mixin)}}),ace.define(\"ace/range\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},Range=function(startRow,startColumn,endRow,endColumn){this.start={row:startRow,column:startColumn},this.end={row:endRow,column:endColumn}};(function(){this.isEqual=function(range){return this.start.row===range.start.row&&this.end.row===range.end.row&&this.start.column===range.start.column&&this.end.column===range.end.column},this.toString=function(){return\"Range: [\"+this.start.row+\"/\"+this.start.column+\"] -> [\"+this.end.row+\"/\"+this.end.column+\"]\"},this.contains=function(row,column){return 0==this.compare(row,column)},this.compareRange=function(range){var cmp,end=range.end,start=range.start;return cmp=this.compare(end.row,end.column),1==cmp?(cmp=this.compare(start.row,start.column),1==cmp?2:0==cmp?1:0):-1==cmp?-2:(cmp=this.compare(start.row,start.column),-1==cmp?-1:1==cmp?42:0)},this.comparePoint=function(p){return this.compare(p.row,p.column)},this.containsRange=function(range){return 0==this.comparePoint(range.start)&&0==this.comparePoint(range.end)},this.intersects=function(range){var cmp=this.compareRange(range);return-1==cmp||0==cmp||1==cmp},this.isEnd=function(row,column){return this.end.row==row&&this.end.column==column},this.isStart=function(row,column){return this.start.row==row&&this.start.column==column},this.setStart=function(row,column){\"object\"==typeof row?(this.start.column=row.column,this.start.row=row.row):(this.start.row=row,this.start.column=column)},this.setEnd=function(row,column){\"object\"==typeof row?(this.end.column=row.column,this.end.row=row.row):(this.end.row=row,this.end.column=column)},this.inside=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)||this.isStart(row,column)?!1:!0:!1},this.insideStart=function(row,column){return 0==this.compare(row,column)?this.isEnd(row,column)?!1:!0:!1},this.insideEnd=function(row,column){return 0==this.compare(row,column)?this.isStart(row,column)?!1:!0:!1},this.compare=function(row,column){return this.isMultiLine()||row!==this.start.row?this.start.row>row?-1:row>this.end.row?1:this.start.row===row?column>=this.start.column?0:-1:this.end.row===row?this.end.column>=column?0:1:0:this.start.column>column?-1:column>this.end.column?1:0},this.compareStart=function(row,column){return this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.compareEnd=function(row,column){return this.end.row==row&&this.end.column==column?1:this.compare(row,column)},this.compareInside=function(row,column){return this.end.row==row&&this.end.column==column?1:this.start.row==row&&this.start.column==column?-1:this.compare(row,column)},this.clipRows=function(firstRow,lastRow){if(this.end.row>lastRow)var end={row:lastRow+1,column:0};else if(firstRow>this.end.row)var end={row:firstRow,column:0};if(this.start.row>lastRow)var start={row:lastRow+1,column:0};else if(firstRow>this.start.row)var start={row:firstRow,column:0};return Range.fromPoints(start||this.start,end||this.end)},this.extend=function(row,column){var cmp=this.compare(row,column);if(0==cmp)return this;if(-1==cmp)var start={row:row,column:column};else var end={row:row,column:column};return Range.fromPoints(start||this.start,end||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return Range.fromPoints(this.start,this.end)},this.collapseRows=function(){return 0==this.end.column?new Range(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new Range(this.start.row,0,this.end.row,0)},this.toScreenRange=function(session){var screenPosStart=session.documentToScreenPosition(this.start),screenPosEnd=session.documentToScreenPosition(this.end);return new Range(screenPosStart.row,screenPosStart.column,screenPosEnd.row,screenPosEnd.column)},this.moveBy=function(row,column){this.start.row+=row,this.start.column+=column,this.end.row+=row,this.end.column+=column}}).call(Range.prototype),Range.fromPoints=function(start,end){return new Range(start.row,start.column,end.row,end.column)},Range.comparePoints=comparePoints,Range.comparePoints=function(p1,p2){return p1.row-p2.row||p1.column-p2.column},exports.Range=Range}),ace.define(\"ace/apply_delta\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.applyDelta=function(docLines,delta){var row=delta.start.row,startColumn=delta.start.column,line=docLines[row]||\"\";switch(delta.action){case\"insert\":var lines=delta.lines;if(1===lines.length)docLines[row]=line.substring(0,startColumn)+delta.lines[0]+line.substring(startColumn);else{var args=[row,1].concat(delta.lines);docLines.splice.apply(docLines,args),docLines[row]=line.substring(0,startColumn)+docLines[row],docLines[row+delta.lines.length-1]+=line.substring(startColumn)}break;case\"remove\":var endColumn=delta.end.column,endRow=delta.end.row;row===endRow?docLines[row]=line.substring(0,startColumn)+line.substring(endColumn):docLines.splice(row,endRow-row+1,line.substring(0,startColumn)+docLines[endRow].substring(endColumn))}}}),ace.define(\"ace/lib/event_emitter\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";var EventEmitter={},stopPropagation=function(){this.propagationStopped=!0},preventDefault=function(){this.defaultPrevented=!0};EventEmitter._emit=EventEmitter._dispatchEvent=function(eventName,e){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var listeners=this._eventRegistry[eventName]||[],defaultHandler=this._defaultHandlers[eventName];if(listeners.length||defaultHandler){\"object\"==typeof e&&e||(e={}),e.type||(e.type=eventName),e.stopPropagation||(e.stopPropagation=stopPropagation),e.preventDefault||(e.preventDefault=preventDefault),listeners=listeners.slice();for(var i=0;listeners.length>i&&(listeners[i](e,this),!e.propagationStopped);i++);return defaultHandler&&!e.defaultPrevented?defaultHandler(e,this):void 0}},EventEmitter._signal=function(eventName,e){var listeners=(this._eventRegistry||{})[eventName];if(listeners){listeners=listeners.slice();for(var i=0;listeners.length>i;i++)listeners[i](e,this)}},EventEmitter.once=function(eventName,callback){var _self=this;callback&&this.addEventListener(eventName,function newCallback(){_self.removeEventListener(eventName,newCallback),callback.apply(null,arguments)})},EventEmitter.setDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers||(handlers=this._defaultHandlers={_disabled_:{}}),handlers[eventName]){var old=handlers[eventName],disabled=handlers._disabled_[eventName];disabled||(handlers._disabled_[eventName]=disabled=[]),disabled.push(old);var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}handlers[eventName]=callback},EventEmitter.removeDefaultHandler=function(eventName,callback){var handlers=this._defaultHandlers;if(handlers){var disabled=handlers._disabled_[eventName];if(handlers[eventName]==callback)handlers[eventName],disabled&&this.setDefaultHandler(eventName,disabled.pop());else if(disabled){var i=disabled.indexOf(callback);-1!=i&&disabled.splice(i,1)}}},EventEmitter.on=EventEmitter.addEventListener=function(eventName,callback,capturing){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];return listeners||(listeners=this._eventRegistry[eventName]=[]),-1==listeners.indexOf(callback)&&listeners[capturing?\"unshift\":\"push\"](callback),callback},EventEmitter.off=EventEmitter.removeListener=EventEmitter.removeEventListener=function(eventName,callback){this._eventRegistry=this._eventRegistry||{};var listeners=this._eventRegistry[eventName];if(listeners){var index=listeners.indexOf(callback);-1!==index&&listeners.splice(index,1)}},EventEmitter.removeAllListeners=function(eventName){this._eventRegistry&&(this._eventRegistry[eventName]=[])},exports.EventEmitter=EventEmitter}),ace.define(\"ace/anchor\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/lib/event_emitter\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Anchor=exports.Anchor=function(doc,row,column){this.$onChange=this.onChange.bind(this),this.attach(doc),column===void 0?this.setPosition(row.row,row.column):this.setPosition(row,column)};(function(){function $pointsInOrder(point1,point2,equalPointsInOrder){var bColIsAfter=equalPointsInOrder?point1.column<=point2.column:point1.column<point2.column;return point1.row<point2.row||point1.row==point2.row&&bColIsAfter}function $getTransformedPoint(delta,point,moveIfEqual){var deltaIsInsert=\"insert\"==delta.action,deltaRowShift=(deltaIsInsert?1:-1)*(delta.end.row-delta.start.row),deltaColShift=(deltaIsInsert?1:-1)*(delta.end.column-delta.start.column),deltaStart=delta.start,deltaEnd=deltaIsInsert?deltaStart:delta.end;return $pointsInOrder(point,deltaStart,moveIfEqual)?{row:point.row,column:point.column}:$pointsInOrder(deltaEnd,point,!moveIfEqual)?{row:point.row+deltaRowShift,column:point.column+(point.row==deltaEnd.row?deltaColShift:0)}:{row:deltaStart.row,column:deltaStart.column}}oop.implement(this,EventEmitter),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(delta){if(!(delta.start.row==delta.end.row&&delta.start.row!=this.row||delta.start.row>this.row)){var point=$getTransformedPoint(delta,{row:this.row,column:this.column},this.$insertRight);this.setPosition(point.row,point.column,!0)}},this.setPosition=function(row,column,noClip){var pos;if(pos=noClip?{row:row,column:column}:this.$clipPositionToDocument(row,column),this.row!=pos.row||this.column!=pos.column){var old={row:this.row,column:this.column};this.row=pos.row,this.column=pos.column,this._signal(\"change\",{old:old,value:pos})}},this.detach=function(){this.document.removeEventListener(\"change\",this.$onChange)},this.attach=function(doc){this.document=doc||this.document,this.document.on(\"change\",this.$onChange)},this.$clipPositionToDocument=function(row,column){var pos={};return row>=this.document.getLength()?(pos.row=Math.max(0,this.document.getLength()-1),pos.column=this.document.getLine(pos.row).length):0>row?(pos.row=0,pos.column=0):(pos.row=row,pos.column=Math.min(this.document.getLine(pos.row).length,Math.max(0,column))),0>column&&(pos.column=0),pos}}).call(Anchor.prototype)}),ace.define(\"ace/document\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/apply_delta\",\"ace/lib/event_emitter\",\"ace/range\",\"ace/anchor\"],function(acequire,exports){\"use strict\";var oop=acequire(\"./lib/oop\"),applyDelta=acequire(\"./apply_delta\").applyDelta,EventEmitter=acequire(\"./lib/event_emitter\").EventEmitter,Range=acequire(\"./range\").Range,Anchor=acequire(\"./anchor\").Anchor,Document=function(textOrLines){this.$lines=[\"\"],0===textOrLines.length?this.$lines=[\"\"]:Array.isArray(textOrLines)?this.insertMergedLines({row:0,column:0},textOrLines):this.insert({row:0,column:0},textOrLines)};(function(){oop.implement(this,EventEmitter),this.setValue=function(text){var len=this.getLength()-1;this.remove(new Range(0,0,len,this.getLine(len).length)),this.insert({row:0,column:0},text)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(row,column){return new Anchor(this,row,column)},this.$split=0===\"aaa\".split(/a/).length?function(text){return text.replace(/\\r\\n|\\r/g,\"\\n\").split(\"\\n\")}:function(text){return text.split(/\\r\\n|\\r|\\n/)},this.$detectNewLine=function(text){var match=text.match(/^.*?(\\r\\n|\\r|\\n)/m);this.$autoNewLine=match?match[1]:\"\\n\",this._signal(\"changeNewLineMode\")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case\"windows\":return\"\\r\\n\";case\"unix\":return\"\\n\";default:return this.$autoNewLine||\"\\n\"}},this.$autoNewLine=\"\",this.$newLineMode=\"auto\",this.setNewLineMode=function(newLineMode){this.$newLineMode!==newLineMode&&(this.$newLineMode=newLineMode,this._signal(\"changeNewLineMode\"))},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(text){return\"\\r\\n\"==text||\"\\r\"==text||\"\\n\"==text},this.getLine=function(row){return this.$lines[row]||\"\"},this.getLines=function(firstRow,lastRow){return this.$lines.slice(firstRow,lastRow+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(range){return this.getLinesForRange(range).join(this.getNewLineCharacter())},this.getLinesForRange=function(range){var lines;if(range.start.row===range.end.row)lines=[this.getLine(range.start.row).substring(range.start.column,range.end.column)];else{lines=this.getLines(range.start.row,range.end.row),lines[0]=(lines[0]||\"\").substring(range.start.column);var l=lines.length-1;range.end.row-range.start.row==l&&(lines[l]=lines[l].substring(0,range.end.column))}return lines},this.insertLines=function(row,lines){return console.warn(\"Use of document.insertLines is deprecated. Use the insertFullLines method instead.\"),this.insertFullLines(row,lines)},this.removeLines=function(firstRow,lastRow){return console.warn(\"Use of document.removeLines is deprecated. Use the removeFullLines method instead.\"),this.removeFullLines(firstRow,lastRow)},this.insertNewLine=function(position){return console.warn(\"Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead.\"),this.insertMergedLines(position,[\"\",\"\"])},this.insert=function(position,text){return 1>=this.getLength()&&this.$detectNewLine(text),this.insertMergedLines(position,this.$split(text))},this.insertInLine=function(position,text){var start=this.clippedPos(position.row,position.column),end=this.pos(position.row,position.column+text.length);return this.applyDelta({start:start,end:end,action:\"insert\",lines:[text]},!0),this.clonePos(end)},this.clippedPos=function(row,column){var length=this.getLength();void 0===row?row=length:0>row?row=0:row>=length&&(row=length-1,column=void 0);var line=this.getLine(row);return void 0==column&&(column=line.length),column=Math.min(Math.max(column,0),line.length),{row:row,column:column}},this.clonePos=function(pos){return{row:pos.row,column:pos.column}},this.pos=function(row,column){return{row:row,column:column}},this.$clipPosition=function(position){var length=this.getLength();return position.row>=length?(position.row=Math.max(0,length-1),position.column=this.getLine(length-1).length):(position.row=Math.max(0,position.row),position.column=Math.min(Math.max(position.column,0),this.getLine(position.row).length)),position},this.insertFullLines=function(row,lines){row=Math.min(Math.max(row,0),this.getLength());var column=0;this.getLength()>row?(lines=lines.concat([\"\"]),column=0):(lines=[\"\"].concat(lines),row--,column=this.$lines[row].length),this.insertMergedLines({row:row,column:column},lines)},this.insertMergedLines=function(position,lines){var start=this.clippedPos(position.row,position.column),end={row:start.row+lines.length-1,column:(1==lines.length?start.column:0)+lines[lines.length-1].length};return this.applyDelta({start:start,end:end,action:\"insert\",lines:lines}),this.clonePos(end)},this.remove=function(range){var start=this.clippedPos(range.start.row,range.start.column),end=this.clippedPos(range.end.row,range.end.column);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})}),this.clonePos(start)},this.removeInLine=function(row,startColumn,endColumn){var start=this.clippedPos(row,startColumn),end=this.clippedPos(row,endColumn);return this.applyDelta({start:start,end:end,action:\"remove\",lines:this.getLinesForRange({start:start,end:end})},!0),this.clonePos(start)},this.removeFullLines=function(firstRow,lastRow){firstRow=Math.min(Math.max(0,firstRow),this.getLength()-1),lastRow=Math.min(Math.max(0,lastRow),this.getLength()-1);var deleteFirstNewLine=lastRow==this.getLength()-1&&firstRow>0,deleteLastNewLine=this.getLength()-1>lastRow,startRow=deleteFirstNewLine?firstRow-1:firstRow,startCol=deleteFirstNewLine?this.getLine(startRow).length:0,endRow=deleteLastNewLine?lastRow+1:lastRow,endCol=deleteLastNewLine?0:this.getLine(endRow).length,range=new Range(startRow,startCol,endRow,endCol),deletedLines=this.$lines.slice(firstRow,lastRow+1);return this.applyDelta({start:range.start,end:range.end,action:\"remove\",lines:this.getLinesForRange(range)}),deletedLines},this.removeNewLine=function(row){this.getLength()-1>row&&row>=0&&this.applyDelta({start:this.pos(row,this.getLine(row).length),end:this.pos(row+1,0),action:\"remove\",lines:[\"\",\"\"]})},this.replace=function(range,text){if(range instanceof Range||(range=Range.fromPoints(range.start,range.end)),0===text.length&&range.isEmpty())return range.start;if(text==this.getTextRange(range))return range.end;this.remove(range);var end;return end=text?this.insert(range.start,text):range.start},this.applyDeltas=function(deltas){for(var i=0;deltas.length>i;i++)this.applyDelta(deltas[i])},this.revertDeltas=function(deltas){for(var i=deltas.length-1;i>=0;i--)this.revertDelta(deltas[i])},this.applyDelta=function(delta,doNotValidate){var isInsert=\"insert\"==delta.action;(isInsert?1>=delta.lines.length&&!delta.lines[0]:!Range.comparePoints(delta.start,delta.end))||(isInsert&&delta.lines.length>2e4&&this.$splitAndapplyLargeDelta(delta,2e4),applyDelta(this.$lines,delta,doNotValidate),this._signal(\"change\",delta))},this.$splitAndapplyLargeDelta=function(delta,MAX){for(var lines=delta.lines,l=lines.length,row=delta.start.row,column=delta.start.column,from=0,to=0;;){from=to,to+=MAX-1;var chunk=lines.slice(from,to);if(to>l){delta.lines=chunk,delta.start.row=row+from,delta.start.column=column;break}chunk.push(\"\"),this.applyDelta({start:this.pos(row+from,column),end:this.pos(row+to,column=0),action:delta.action,lines:chunk},!0)}},this.revertDelta=function(delta){this.applyDelta({start:this.clonePos(delta.start),end:this.clonePos(delta.end),action:\"insert\"==delta.action?\"remove\":\"insert\",lines:delta.lines.slice()})},this.indexToPosition=function(index,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,i=startRow||0,l=lines.length;l>i;i++)if(index-=lines[i].length+newlineLength,0>index)return{row:i,column:index+lines[i].length+newlineLength};return{row:l-1,column:lines[l-1].length}},this.positionToIndex=function(pos,startRow){for(var lines=this.$lines||this.getAllLines(),newlineLength=this.getNewLineCharacter().length,index=0,row=Math.min(pos.row,lines.length),i=startRow||0;row>i;++i)index+=lines[i].length+newlineLength;return index+pos.column}}).call(Document.prototype),exports.Document=Document}),ace.define(\"ace/lib/lang\",[\"require\",\"exports\",\"module\"],function(acequire,exports){\"use strict\";exports.last=function(a){return a[a.length-1]},exports.stringReverse=function(string){return string.split(\"\").reverse().join(\"\")},exports.stringRepeat=function(string,count){for(var result=\"\";count>0;)1&count&&(result+=string),(count>>=1)&&(string+=string);return result};var trimBeginRegexp=/^\\s\\s*/,trimEndRegexp=/\\s\\s*$/;exports.stringTrimLeft=function(string){return string.replace(trimBeginRegexp,\"\")},exports.stringTrimRight=function(string){return string.replace(trimEndRegexp,\"\")},exports.copyObject=function(obj){var copy={};for(var key in obj)copy[key]=obj[key];return copy},exports.copyArray=function(array){for(var copy=[],i=0,l=array.length;l>i;i++)copy[i]=array[i]&&\"object\"==typeof array[i]?this.copyObject(array[i]):array[i];return copy},exports.deepCopy=function deepCopy(obj){if(\"object\"!=typeof obj||!obj)return obj;var copy;if(Array.isArray(obj)){copy=[];for(var key=0;obj.length>key;key++)copy[key]=deepCopy(obj[key]);return copy}var cons=obj.constructor;if(cons===RegExp)return obj;copy=cons();for(var key in obj)copy[key]=deepCopy(obj[key]);return copy},exports.arrayToMap=function(arr){for(var map={},i=0;arr.length>i;i++)map[arr[i]]=1;return map},exports.createMap=function(props){var map=Object.create(null);for(var i in props)map[i]=props[i];return map},exports.arrayRemove=function(array,value){for(var i=0;array.length>=i;i++)value===array[i]&&array.splice(i,1)},exports.escapeRegExp=function(str){return str.replace(/([.*+?^${}()|[\\]\\/\\\\])/g,\"\\\\$1\")},exports.escapeHTML=function(str){return str.replace(/&/g,\"&#38;\").replace(/\"/g,\"&#34;\").replace(/'/g,\"&#39;\").replace(/</g,\"&#60;\")},exports.getMatchOffsets=function(string,regExp){var matches=[];return string.replace(regExp,function(str){matches.push({offset:arguments[arguments.length-2],length:str.length})}),matches},exports.deferredCall=function(fcn){var timer=null,callback=function(){timer=null,fcn()},deferred=function(timeout){return deferred.cancel(),timer=setTimeout(callback,timeout||0),deferred};return deferred.schedule=deferred,deferred.call=function(){return this.cancel(),fcn(),deferred},deferred.cancel=function(){return clearTimeout(timer),timer=null,deferred},deferred.isPending=function(){return timer},deferred},exports.delayedCall=function(fcn,defaultTimeout){var timer=null,callback=function(){timer=null,fcn()},_self=function(timeout){null==timer&&(timer=setTimeout(callback,timeout||defaultTimeout))};return _self.delay=function(timeout){timer&&clearTimeout(timer),timer=setTimeout(callback,timeout||defaultTimeout)},_self.schedule=_self,_self.call=function(){this.cancel(),fcn()},_self.cancel=function(){timer&&clearTimeout(timer),timer=null},_self.isPending=function(){return timer},_self}}),ace.define(\"ace/worker/mirror\",[\"require\",\"exports\",\"module\",\"ace/range\",\"ace/document\",\"ace/lib/lang\"],function(acequire,exports){\"use strict\";acequire(\"../range\").Range;var Document=acequire(\"../document\").Document,lang=acequire(\"../lib/lang\"),Mirror=exports.Mirror=function(sender){this.sender=sender;var doc=this.doc=new Document(\"\"),deferredUpdate=this.deferredUpdate=lang.delayedCall(this.onUpdate.bind(this)),_self=this;sender.on(\"change\",function(e){var data=e.data;if(data[0].start)doc.applyDeltas(data);else for(var i=0;data.length>i;i+=2){if(Array.isArray(data[i+1]))var d={action:\"insert\",start:data[i],lines:data[i+1]};else var d={action:\"remove\",start:data[i],end:data[i+1]};doc.applyDelta(d,!0)}return _self.$timeout?deferredUpdate.schedule(_self.$timeout):(_self.onUpdate(),void 0)})};(function(){this.$timeout=500,this.setTimeout=function(timeout){this.$timeout=timeout},this.setValue=function(value){this.doc.setValue(value),this.deferredUpdate.schedule(this.$timeout)},this.getValue=function(callbackId){this.sender.callback(this.doc.getValue(),callbackId)},this.onUpdate=function(){},this.isPending=function(){return this.deferredUpdate.isPending()}}).call(Mirror.prototype)}),ace.define(\"ace/mode/json/json_parse\",[\"require\",\"exports\",\"module\"],function(){\"use strict\";var at,ch,text,value,escapee={'\"':'\"',\"\\\\\":\"\\\\\",\"/\":\"/\",b:\"\\b\",f:\"\\f\",n:\"\\n\",r:\"\\r\",t:\"\t\"},error=function(m){throw{name:\"SyntaxError\",message:m,at:at,text:text}},next=function(c){return c&&c!==ch&&error(\"Expected '\"+c+\"' instead of '\"+ch+\"'\"),ch=text.charAt(at),at+=1,ch},number=function(){var number,string=\"\";for(\"-\"===ch&&(string=\"-\",next(\"-\"));ch>=\"0\"&&\"9\">=ch;)string+=ch,next();if(\".\"===ch)for(string+=\".\";next()&&ch>=\"0\"&&\"9\">=ch;)string+=ch;if(\"e\"===ch||\"E\"===ch)for(string+=ch,next(),(\"-\"===ch||\"+\"===ch)&&(string+=ch,next());ch>=\"0\"&&\"9\">=ch;)string+=ch,next();return number=+string,isNaN(number)?(error(\"Bad number\"),void 0):number},string=function(){var hex,i,uffff,string=\"\";if('\"'===ch)for(;next();){if('\"'===ch)return next(),string;if(\"\\\\\"===ch)if(next(),\"u\"===ch){for(uffff=0,i=0;4>i&&(hex=parseInt(next(),16),isFinite(hex));i+=1)uffff=16*uffff+hex;string+=String.fromCharCode(uffff)}else{if(\"string\"!=typeof escapee[ch])break;string+=escapee[ch]}else string+=ch}error(\"Bad string\")},white=function(){for(;ch&&\" \">=ch;)next()},word=function(){switch(ch){case\"t\":return next(\"t\"),next(\"r\"),next(\"u\"),next(\"e\"),!0;case\"f\":return next(\"f\"),next(\"a\"),next(\"l\"),next(\"s\"),next(\"e\"),!1;case\"n\":return next(\"n\"),next(\"u\"),next(\"l\"),next(\"l\"),null}error(\"Unexpected '\"+ch+\"'\")},array=function(){var array=[];if(\"[\"===ch){if(next(\"[\"),white(),\"]\"===ch)return next(\"]\"),array;for(;ch;){if(array.push(value()),white(),\"]\"===ch)return next(\"]\"),array;next(\",\"),white()}}error(\"Bad array\")},object=function(){var key,object={};if(\"{\"===ch){if(next(\"{\"),white(),\"}\"===ch)return next(\"}\"),object;for(;ch;){if(key=string(),white(),next(\":\"),Object.hasOwnProperty.call(object,key)&&error('Duplicate key \"'+key+'\"'),object[key]=value(),white(),\"}\"===ch)return next(\"}\"),object;next(\",\"),white()}}error(\"Bad object\")};return value=function(){switch(white(),ch){case\"{\":return object();case\"[\":return array();case'\"':return string();case\"-\":return number();default:return ch>=\"0\"&&\"9\">=ch?number():word()}},function(source,reviver){var result;return text=source,at=0,ch=\" \",result=value(),white(),ch&&error(\"Syntax error\"),\"function\"==typeof reviver?function walk(holder,key){var k,v,value=holder[key];if(value&&\"object\"==typeof value)for(k in value)Object.hasOwnProperty.call(value,k)&&(v=walk(value,k),void 0!==v?value[k]=v:delete value[k]);return reviver.call(holder,key,value)}({\"\":result},\"\"):result}}),ace.define(\"ace/mode/json_worker\",[\"require\",\"exports\",\"module\",\"ace/lib/oop\",\"ace/worker/mirror\",\"ace/mode/json/json_parse\"],function(acequire,exports){\"use strict\";var oop=acequire(\"../lib/oop\"),Mirror=acequire(\"../worker/mirror\").Mirror,parse=acequire(\"./json/json_parse\"),JsonWorker=exports.JsonWorker=function(sender){Mirror.call(this,sender),this.setTimeout(200)};oop.inherits(JsonWorker,Mirror),function(){this.onUpdate=function(){var value=this.doc.getValue(),errors=[];try{value&&parse(value)}catch(e){var pos=this.doc.indexToPosition(e.at-1);errors.push({row:pos.row,column:pos.column,text:e.message,type:\"error\"})}this.sender.emit(\"annotate\",errors)}}.call(JsonWorker.prototype)}),ace.define(\"ace/lib/es5-shim\",[\"require\",\"exports\",\"module\"],function(){function Empty(){}function doesDefinePropertyWork(object){try{return Object.defineProperty(object,\"sentinel\",{}),\"sentinel\"in object}catch(exception){}}function toInteger(n){return n=+n,n!==n?n=0:0!==n&&n!==1/0&&n!==-(1/0)&&(n=(n>0||-1)*Math.floor(Math.abs(n))),n}Function.prototype.bind||(Function.prototype.bind=function(that){var target=this;if(\"function\"!=typeof target)throw new TypeError(\"Function.prototype.bind called on incompatible \"+target);var args=slice.call(arguments,1),bound=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))};return target.prototype&&(Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null),bound});var defineGetter,defineSetter,lookupGetter,lookupSetter,supportsAccessors,call=Function.prototype.call,prototypeOfArray=Array.prototype,prototypeOfObject=Object.prototype,slice=prototypeOfArray.slice,_toString=call.bind(prototypeOfObject.toString),owns=call.bind(prototypeOfObject.hasOwnProperty);if((supportsAccessors=owns(prototypeOfObject,\"__defineGetter__\"))&&(defineGetter=call.bind(prototypeOfObject.__defineGetter__),defineSetter=call.bind(prototypeOfObject.__defineSetter__),lookupGetter=call.bind(prototypeOfObject.__lookupGetter__),lookupSetter=call.bind(prototypeOfObject.__lookupSetter__)),2!=[1,2].splice(0).length)if(function(){function makeArray(l){var a=Array(l+2);return a[0]=a[1]=0,a}var lengthBefore,array=[];return array.splice.apply(array,makeArray(20)),array.splice.apply(array,makeArray(26)),lengthBefore=array.length,array.splice(5,0,\"XXX\"),lengthBefore+1==array.length,lengthBefore+1==array.length?!0:void 0\n}()){var array_splice=Array.prototype.splice;Array.prototype.splice=function(start,deleteCount){return arguments.length?array_splice.apply(this,[void 0===start?0:start,void 0===deleteCount?this.length-start:deleteCount].concat(slice.call(arguments,2))):[]}}else Array.prototype.splice=function(pos,removeCount){var length=this.length;pos>0?pos>length&&(pos=length):void 0==pos?pos=0:0>pos&&(pos=Math.max(length+pos,0)),length>pos+removeCount||(removeCount=length-pos);var removed=this.slice(pos,pos+removeCount),insert=slice.call(arguments,2),add=insert.length;if(pos===length)add&&this.push.apply(this,insert);else{var remove=Math.min(removeCount,length-pos),tailOldPos=pos+remove,tailNewPos=tailOldPos+add-remove,tailCount=length-tailOldPos,lengthAfterRemove=length-remove;if(tailOldPos>tailNewPos)for(var i=0;tailCount>i;++i)this[tailNewPos+i]=this[tailOldPos+i];else if(tailNewPos>tailOldPos)for(i=tailCount;i--;)this[tailNewPos+i]=this[tailOldPos+i];if(add&&pos===lengthAfterRemove)this.length=lengthAfterRemove,this.push.apply(this,insert);else for(this.length=lengthAfterRemove+add,i=0;add>i;++i)this[pos+i]=insert[i]}return removed};Array.isArray||(Array.isArray=function(obj){return\"[object Array]\"==_toString(obj)});var boxedString=Object(\"a\"),splitString=\"a\"!=boxedString[0]||!(0 in boxedString);if(Array.prototype.forEach||(Array.prototype.forEach=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,thisp=arguments[1],i=-1,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError;for(;length>++i;)i in self&&fun.call(thisp,self[i],i,object)}),Array.prototype.map||(Array.prototype.map=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=Array(length),thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(result[i]=fun.call(thisp,self[i],i,object));return result}),Array.prototype.filter||(Array.prototype.filter=function(fun){var value,object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,result=[],thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)i in self&&(value=self[i],fun.call(thisp,value,i,object)&&result.push(value));return result}),Array.prototype.every||(Array.prototype.every=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&!fun.call(thisp,self[i],i,object))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0,thisp=arguments[1];if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");for(var i=0;length>i;i++)if(i in self&&fun.call(thisp,self[i],i,object))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduce of empty array with no initial value\");var result,i=0;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i++];break}if(++i>=length)throw new TypeError(\"reduce of empty array with no initial value\")}for(;length>i;i++)i in self&&(result=fun.call(void 0,result,self[i],i,object));return result}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(fun){var object=toObject(this),self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):object,length=self.length>>>0;if(\"[object Function]\"!=_toString(fun))throw new TypeError(fun+\" is not a function\");if(!length&&1==arguments.length)throw new TypeError(\"reduceRight of empty array with no initial value\");var result,i=length-1;if(arguments.length>=2)result=arguments[1];else for(;;){if(i in self){result=self[i--];break}if(0>--i)throw new TypeError(\"reduceRight of empty array with no initial value\")}do i in this&&(result=fun.call(void 0,result,self[i],i,object));while(i--);return result}),Array.prototype.indexOf&&-1==[0,1].indexOf(1,2)||(Array.prototype.indexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=0;for(arguments.length>1&&(i=toInteger(arguments[1])),i=i>=0?i:Math.max(0,length+i);length>i;i++)if(i in self&&self[i]===sought)return i;return-1}),Array.prototype.lastIndexOf&&-1==[0,1].lastIndexOf(0,-3)||(Array.prototype.lastIndexOf=function(sought){var self=splitString&&\"[object String]\"==_toString(this)?this.split(\"\"):toObject(this),length=self.length>>>0;if(!length)return-1;var i=length-1;for(arguments.length>1&&(i=Math.min(i,toInteger(arguments[1]))),i=i>=0?i:length-Math.abs(i);i>=0;i--)if(i in self&&sought===self[i])return i;return-1}),Object.getPrototypeOf||(Object.getPrototypeOf=function(object){return object.__proto__||(object.constructor?object.constructor.prototype:prototypeOfObject)}),!Object.getOwnPropertyDescriptor){var ERR_NON_OBJECT=\"Object.getOwnPropertyDescriptor called on a non-object: \";Object.getOwnPropertyDescriptor=function(object,property){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT+object);if(owns(object,property)){var descriptor,getter,setter;if(descriptor={enumerable:!0,configurable:!0},supportsAccessors){var prototype=object.__proto__;object.__proto__=prototypeOfObject;var getter=lookupGetter(object,property),setter=lookupSetter(object,property);if(object.__proto__=prototype,getter||setter)return getter&&(descriptor.get=getter),setter&&(descriptor.set=setter),descriptor}return descriptor.value=object[property],descriptor}}}if(Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(object){return Object.keys(object)}),!Object.create){var createEmpty;createEmpty=null===Object.prototype.__proto__?function(){return{__proto__:null}}:function(){var empty={};for(var i in empty)empty[i]=null;return empty.constructor=empty.hasOwnProperty=empty.propertyIsEnumerable=empty.isPrototypeOf=empty.toLocaleString=empty.toString=empty.valueOf=empty.__proto__=null,empty},Object.create=function(prototype,properties){var object;if(null===prototype)object=createEmpty();else{if(\"object\"!=typeof prototype)throw new TypeError(\"typeof prototype[\"+typeof prototype+\"] != 'object'\");var Type=function(){};Type.prototype=prototype,object=new Type,object.__proto__=prototype}return void 0!==properties&&Object.defineProperties(object,properties),object}}if(Object.defineProperty){var definePropertyWorksOnObject=doesDefinePropertyWork({}),definePropertyWorksOnDom=\"undefined\"==typeof document||doesDefinePropertyWork(document.createElement(\"div\"));if(!definePropertyWorksOnObject||!definePropertyWorksOnDom)var definePropertyFallback=Object.defineProperty}if(!Object.defineProperty||definePropertyFallback){var ERR_NON_OBJECT_DESCRIPTOR=\"Property description must be an object: \",ERR_NON_OBJECT_TARGET=\"Object.defineProperty called on non-object: \",ERR_ACCESSORS_NOT_SUPPORTED=\"getters & setters can not be defined on this javascript engine\";Object.defineProperty=function(object,property,descriptor){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(ERR_NON_OBJECT_TARGET+object);if(\"object\"!=typeof descriptor&&\"function\"!=typeof descriptor||null===descriptor)throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR+descriptor);if(definePropertyFallback)try{return definePropertyFallback.call(Object,object,property,descriptor)}catch(exception){}if(owns(descriptor,\"value\"))if(supportsAccessors&&(lookupGetter(object,property)||lookupSetter(object,property))){var prototype=object.__proto__;object.__proto__=prototypeOfObject,delete object[property],object[property]=descriptor.value,object.__proto__=prototype}else object[property]=descriptor.value;else{if(!supportsAccessors)throw new TypeError(ERR_ACCESSORS_NOT_SUPPORTED);owns(descriptor,\"get\")&&defineGetter(object,property,descriptor.get),owns(descriptor,\"set\")&&defineSetter(object,property,descriptor.set)}return object}}Object.defineProperties||(Object.defineProperties=function(object,properties){for(var property in properties)owns(properties,property)&&Object.defineProperty(object,property,properties[property]);return object}),Object.seal||(Object.seal=function(object){return object}),Object.freeze||(Object.freeze=function(object){return object});try{Object.freeze(function(){})}catch(exception){Object.freeze=function(freezeObject){return function(object){return\"function\"==typeof object?object:freezeObject(object)}}(Object.freeze)}if(Object.preventExtensions||(Object.preventExtensions=function(object){return object}),Object.isSealed||(Object.isSealed=function(){return!1}),Object.isFrozen||(Object.isFrozen=function(){return!1}),Object.isExtensible||(Object.isExtensible=function(object){if(Object(object)===object)throw new TypeError;for(var name=\"\";owns(object,name);)name+=\"?\";object[name]=!0;var returnValue=owns(object,name);return delete object[name],returnValue}),!Object.keys){var hasDontEnumBug=!0,dontEnums=[\"toString\",\"toLocaleString\",\"valueOf\",\"hasOwnProperty\",\"isPrototypeOf\",\"propertyIsEnumerable\",\"constructor\"],dontEnumsLength=dontEnums.length;for(var key in{toString:null})hasDontEnumBug=!1;Object.keys=function(object){if(\"object\"!=typeof object&&\"function\"!=typeof object||null===object)throw new TypeError(\"Object.keys called on a non-object\");var keys=[];for(var name in object)owns(object,name)&&keys.push(name);if(hasDontEnumBug)for(var i=0,ii=dontEnumsLength;ii>i;i++){var dontEnum=dontEnums[i];owns(object,dontEnum)&&keys.push(dontEnum)}return keys}}Date.now||(Date.now=function(){return(new Date).getTime()});var ws=\"\t\\n\u000b\\f\\r   ᠎             　\\u2028\\u2029﻿\";if(!String.prototype.trim||ws.trim()){ws=\"[\"+ws+\"]\";var trimBeginRegexp=RegExp(\"^\"+ws+ws+\"*\"),trimEndRegexp=RegExp(ws+ws+\"*$\");String.prototype.trim=function(){return(this+\"\").replace(trimBeginRegexp,\"\").replace(trimEndRegexp,\"\")}}var toObject=function(o){if(null==o)throw new TypeError(\"can't convert \"+o+\" to object\");return Object(o)}});";

/***/ },
/* 1451 */
/***/ function(module, exports) {

	ace.define("ace/theme/monokai",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {
	
	exports.isDark = true;
	exports.cssClass = "ace-monokai";
	exports.cssText = ".ace-monokai .ace_gutter {\
	background: #2F3129;\
	color: #8F908A\
	}\
	.ace-monokai .ace_print-margin {\
	width: 1px;\
	background: #555651\
	}\
	.ace-monokai {\
	background-color: #272822;\
	color: #F8F8F2\
	}\
	.ace-monokai .ace_cursor {\
	color: #F8F8F0\
	}\
	.ace-monokai .ace_marker-layer .ace_selection {\
	background: #49483E\
	}\
	.ace-monokai.ace_multiselect .ace_selection.ace_start {\
	box-shadow: 0 0 3px 0px #272822;\
	}\
	.ace-monokai .ace_marker-layer .ace_step {\
	background: rgb(102, 82, 0)\
	}\
	.ace-monokai .ace_marker-layer .ace_bracket {\
	margin: -1px 0 0 -1px;\
	border: 1px solid #49483E\
	}\
	.ace-monokai .ace_marker-layer .ace_active-line {\
	background: #202020\
	}\
	.ace-monokai .ace_gutter-active-line {\
	background-color: #272727\
	}\
	.ace-monokai .ace_marker-layer .ace_selected-word {\
	border: 1px solid #49483E\
	}\
	.ace-monokai .ace_invisible {\
	color: #52524d\
	}\
	.ace-monokai .ace_entity.ace_name.ace_tag,\
	.ace-monokai .ace_keyword,\
	.ace-monokai .ace_meta.ace_tag,\
	.ace-monokai .ace_storage {\
	color: #F92672\
	}\
	.ace-monokai .ace_punctuation,\
	.ace-monokai .ace_punctuation.ace_tag {\
	color: #fff\
	}\
	.ace-monokai .ace_constant.ace_character,\
	.ace-monokai .ace_constant.ace_language,\
	.ace-monokai .ace_constant.ace_numeric,\
	.ace-monokai .ace_constant.ace_other {\
	color: #AE81FF\
	}\
	.ace-monokai .ace_invalid {\
	color: #F8F8F0;\
	background-color: #F92672\
	}\
	.ace-monokai .ace_invalid.ace_deprecated {\
	color: #F8F8F0;\
	background-color: #AE81FF\
	}\
	.ace-monokai .ace_support.ace_constant,\
	.ace-monokai .ace_support.ace_function {\
	color: #66D9EF\
	}\
	.ace-monokai .ace_fold {\
	background-color: #A6E22E;\
	border-color: #F8F8F2\
	}\
	.ace-monokai .ace_storage.ace_type,\
	.ace-monokai .ace_support.ace_class,\
	.ace-monokai .ace_support.ace_type {\
	font-style: italic;\
	color: #66D9EF\
	}\
	.ace-monokai .ace_entity.ace_name.ace_function,\
	.ace-monokai .ace_entity.ace_other,\
	.ace-monokai .ace_entity.ace_other.ace_attribute-name,\
	.ace-monokai .ace_variable {\
	color: #A6E22E\
	}\
	.ace-monokai .ace_variable.ace_parameter {\
	font-style: italic;\
	color: #FD971F\
	}\
	.ace-monokai .ace_string {\
	color: #E6DB74\
	}\
	.ace-monokai .ace_comment {\
	color: #75715E\
	}\
	.ace-monokai .ace_indent-guide {\
	background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\
	}";
	
	var dom = acequire("../lib/dom");
	dom.importCssString(exports.cssText, exports.cssClass);
	});


/***/ },
/* 1452 */
/***/ function(module, exports) {

	ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"], function(acequire, exports, module) {
	"use strict";
	var oop = acequire("./lib/oop");
	var EventEmitter = acequire("./lib/event_emitter").EventEmitter;
	var lang = acequire("./lib/lang");
	var Range = acequire("./range").Range;
	var Anchor = acequire("./anchor").Anchor;
	var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
	var Tokenizer = acequire("./tokenizer").Tokenizer;
	var comparePoints = Range.comparePoints;
	
	var SnippetManager = function() {
	    this.snippetMap = {};
	    this.snippetNameMap = {};
	};
	
	(function() {
	    oop.implement(this, EventEmitter);
	    
	    this.getTokenizer = function() {
	        function TabstopToken(str, _, stack) {
	            str = str.substr(1);
	            if (/^\d+$/.test(str) && !stack.inFormatString)
	                return [{tabstopId: parseInt(str, 10)}];
	            return [{text: str}];
	        }
	        function escape(ch) {
	            return "(?:[^\\\\" + ch + "]|\\\\.)";
	        }
	        SnippetManager.$tokenizer = new Tokenizer({
	            start: [
	                {regex: /:/, onMatch: function(val, state, stack) {
	                    if (stack.length && stack[0].expectIf) {
	                        stack[0].expectIf = false;
	                        stack[0].elseBranch = stack[0];
	                        return [stack[0]];
	                    }
	                    return ":";
	                }},
	                {regex: /\\./, onMatch: function(val, state, stack) {
	                    var ch = val[1];
	                    if (ch == "}" && stack.length) {
	                        val = ch;
	                    }else if ("`$\\".indexOf(ch) != -1) {
	                        val = ch;
	                    } else if (stack.inFormatString) {
	                        if (ch == "n")
	                            val = "\n";
	                        else if (ch == "t")
	                            val = "\n";
	                        else if ("ulULE".indexOf(ch) != -1) {
	                            val = {changeCase: ch, local: ch > "a"};
	                        }
	                    }
	
	                    return [val];
	                }},
	                {regex: /}/, onMatch: function(val, state, stack) {
	                    return [stack.length ? stack.shift() : val];
	                }},
	                {regex: /\$(?:\d+|\w+)/, onMatch: TabstopToken},
	                {regex: /\$\{[\dA-Z_a-z]+/, onMatch: function(str, state, stack) {
	                    var t = TabstopToken(str.substr(1), state, stack);
	                    stack.unshift(t[0]);
	                    return t;
	                }, next: "snippetVar"},
	                {regex: /\n/, token: "newline", merge: false}
	            ],
	            snippetVar: [
	                {regex: "\\|" + escape("\\|") + "*\\|", onMatch: function(val, state, stack) {
	                    stack[0].choices = val.slice(1, -1).split(",");
	                }, next: "start"},
	                {regex: "/(" + escape("/") + "+)/(?:(" + escape("/") + "*)/)(\\w*):?",
	                 onMatch: function(val, state, stack) {
	                    var ts = stack[0];
	                    ts.fmtString = val;
	
	                    val = this.splitRegex.exec(val);
	                    ts.guard = val[1];
	                    ts.fmt = val[2];
	                    ts.flag = val[3];
	                    return "";
	                }, next: "start"},
	                {regex: "`" + escape("`") + "*`", onMatch: function(val, state, stack) {
	                    stack[0].code = val.splice(1, -1);
	                    return "";
	                }, next: "start"},
	                {regex: "\\?", onMatch: function(val, state, stack) {
	                    if (stack[0])
	                        stack[0].expectIf = true;
	                }, next: "start"},
	                {regex: "([^:}\\\\]|\\\\.)*:?", token: "", next: "start"}
	            ],
	            formatString: [
	                {regex: "/(" + escape("/") + "+)/", token: "regex"},
	                {regex: "", onMatch: function(val, state, stack) {
	                    stack.inFormatString = true;
	                }, next: "start"}
	            ]
	        });
	        SnippetManager.prototype.getTokenizer = function() {
	            return SnippetManager.$tokenizer;
	        };
	        return SnippetManager.$tokenizer;
	    };
	
	    this.tokenizeTmSnippet = function(str, startState) {
	        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function(x) {
	            return x.value || x;
	        });
	    };
	
	    this.$getDefaultValue = function(editor, name) {
	        if (/^[A-Z]\d+$/.test(name)) {
	            var i = name.substr(1);
	            return (this.variables[name[0] + "__"] || {})[i];
	        }
	        if (/^\d+$/.test(name)) {
	            return (this.variables.__ || {})[name];
	        }
	        name = name.replace(/^TM_/, "");
	
	        if (!editor)
	            return;
	        var s = editor.session;
	        switch(name) {
	            case "CURRENT_WORD":
	                var r = s.getWordRange();
	            case "SELECTION":
	            case "SELECTED_TEXT":
	                return s.getTextRange(r);
	            case "CURRENT_LINE":
	                return s.getLine(editor.getCursorPosition().row);
	            case "PREV_LINE": // not possible in textmate
	                return s.getLine(editor.getCursorPosition().row - 1);
	            case "LINE_INDEX":
	                return editor.getCursorPosition().column;
	            case "LINE_NUMBER":
	                return editor.getCursorPosition().row + 1;
	            case "SOFT_TABS":
	                return s.getUseSoftTabs() ? "YES" : "NO";
	            case "TAB_SIZE":
	                return s.getTabSize();
	            case "FILENAME":
	            case "FILEPATH":
	                return "";
	            case "FULLNAME":
	                return "Ace";
	        }
	    };
	    this.variables = {};
	    this.getVariableValue = function(editor, varName) {
	        if (this.variables.hasOwnProperty(varName))
	            return this.variables[varName](editor, varName) || "";
	        return this.$getDefaultValue(editor, varName) || "";
	    };
	    this.tmStrFormat = function(str, ch, editor) {
	        var flag = ch.flag || "";
	        var re = ch.guard;
	        re = new RegExp(re, flag.replace(/[^gi]/, ""));
	        var fmtTokens = this.tokenizeTmSnippet(ch.fmt, "formatString");
	        var _self = this;
	        var formatted = str.replace(re, function() {
	            _self.variables.__ = arguments;
	            var fmtParts = _self.resolveVariables(fmtTokens, editor);
	            var gChangeCase = "E";
	            for (var i  = 0; i < fmtParts.length; i++) {
	                var ch = fmtParts[i];
	                if (typeof ch == "object") {
	                    fmtParts[i] = "";
	                    if (ch.changeCase && ch.local) {
	                        var next = fmtParts[i + 1];
	                        if (next && typeof next == "string") {
	                            if (ch.changeCase == "u")
	                                fmtParts[i] = next[0].toUpperCase();
	                            else
	                                fmtParts[i] = next[0].toLowerCase();
	                            fmtParts[i + 1] = next.substr(1);
	                        }
	                    } else if (ch.changeCase) {
	                        gChangeCase = ch.changeCase;
	                    }
	                } else if (gChangeCase == "U") {
	                    fmtParts[i] = ch.toUpperCase();
	                } else if (gChangeCase == "L") {
	                    fmtParts[i] = ch.toLowerCase();
	                }
	            }
	            return fmtParts.join("");
	        });
	        this.variables.__ = null;
	        return formatted;
	    };
	
	    this.resolveVariables = function(snippet, editor) {
	        var result = [];
	        for (var i = 0; i < snippet.length; i++) {
	            var ch = snippet[i];
	            if (typeof ch == "string") {
	                result.push(ch);
	            } else if (typeof ch != "object") {
	                continue;
	            } else if (ch.skip) {
	                gotoNext(ch);
	            } else if (ch.processed < i) {
	                continue;
	            } else if (ch.text) {
	                var value = this.getVariableValue(editor, ch.text);
	                if (value && ch.fmtString)
	                    value = this.tmStrFormat(value, ch);
	                ch.processed = i;
	                if (ch.expectIf == null) {
	                    if (value) {
	                        result.push(value);
	                        gotoNext(ch);
	                    }
	                } else {
	                    if (value) {
	                        ch.skip = ch.elseBranch;
	                    } else
	                        gotoNext(ch);
	                }
	            } else if (ch.tabstopId != null) {
	                result.push(ch);
	            } else if (ch.changeCase != null) {
	                result.push(ch);
	            }
	        }
	        function gotoNext(ch) {
	            var i1 = snippet.indexOf(ch, i + 1);
	            if (i1 != -1)
	                i = i1;
	        }
	        return result;
	    };
	
	    this.insertSnippetForSelection = function(editor, snippetText) {
	        var cursor = editor.getCursorPosition();
	        var line = editor.session.getLine(cursor.row);
	        var tabString = editor.session.getTabString();
	        var indentString = line.match(/^\s*/)[0];
	        
	        if (cursor.column < indentString.length)
	            indentString = indentString.slice(0, cursor.column);
	
	        var tokens = this.tokenizeTmSnippet(snippetText);
	        tokens = this.resolveVariables(tokens, editor);
	        tokens = tokens.map(function(x) {
	            if (x == "\n")
	                return x + indentString;
	            if (typeof x == "string")
	                return x.replace(/\t/g, tabString);
	            return x;
	        });
	        var tabstops = [];
	        tokens.forEach(function(p, i) {
	            if (typeof p != "object")
	                return;
	            var id = p.tabstopId;
	            var ts = tabstops[id];
	            if (!ts) {
	                ts = tabstops[id] = [];
	                ts.index = id;
	                ts.value = "";
	            }
	            if (ts.indexOf(p) !== -1)
	                return;
	            ts.push(p);
	            var i1 = tokens.indexOf(p, i + 1);
	            if (i1 === -1)
	                return;
	
	            var value = tokens.slice(i + 1, i1);
	            var isNested = value.some(function(t) {return typeof t === "object"});          
	            if (isNested && !ts.value) {
	                ts.value = value;
	            } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
	                ts.value = value.join("");
	            }
	        });
	        tabstops.forEach(function(ts) {ts.length = 0});
	        var expanding = {};
	        function copyValue(val) {
	            var copy = [];
	            for (var i = 0; i < val.length; i++) {
	                var p = val[i];
	                if (typeof p == "object") {
	                    if (expanding[p.tabstopId])
	                        continue;
	                    var j = val.lastIndexOf(p, i - 1);
	                    p = copy[j] || {tabstopId: p.tabstopId};
	                }
	                copy[i] = p;
	            }
	            return copy;
	        }
	        for (var i = 0; i < tokens.length; i++) {
	            var p = tokens[i];
	            if (typeof p != "object")
	                continue;
	            var id = p.tabstopId;
	            var i1 = tokens.indexOf(p, i + 1);
	            if (expanding[id]) {
	                if (expanding[id] === p)
	                    expanding[id] = null;
	                continue;
	            }
	            
	            var ts = tabstops[id];
	            var arg = typeof ts.value == "string" ? [ts.value] : copyValue(ts.value);
	            arg.unshift(i + 1, Math.max(0, i1 - i));
	            arg.push(p);
	            expanding[id] = p;
	            tokens.splice.apply(tokens, arg);
	
	            if (ts.indexOf(p) === -1)
	                ts.push(p);
	        }
	        var row = 0, column = 0;
	        var text = "";
	        tokens.forEach(function(t) {
	            if (typeof t === "string") {
	                if (t[0] === "\n"){
	                    column = t.length - 1;
	                    row ++;
	                } else
	                    column += t.length;
	                text += t;
	            } else {
	                if (!t.start)
	                    t.start = {row: row, column: column};
	                else
	                    t.end = {row: row, column: column};
	            }
	        });
	        var range = editor.getSelectionRange();
	        var end = editor.session.replace(range, text);
	
	        var tabstopManager = new TabstopManager(editor);
	        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
	        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
	    };
	    
	    this.insertSnippet = function(editor, snippetText) {
	        var self = this;
	        if (editor.inVirtualSelectionMode)
	            return self.insertSnippetForSelection(editor, snippetText);
	        
	        editor.forEachSelection(function() {
	            self.insertSnippetForSelection(editor, snippetText);
	        }, null, {keepOrder: true});
	        
	        if (editor.tabstopManager)
	            editor.tabstopManager.tabNext();
	    };
	
	    this.$getScope = function(editor) {
	        var scope = editor.session.$mode.$id || "";
	        scope = scope.split("/").pop();
	        if (scope === "html" || scope === "php") {
	            if (scope === "php" && !editor.session.$mode.inlinePhp) 
	                scope = "html";
	            var c = editor.getCursorPosition();
	            var state = editor.session.getState(c.row);
	            if (typeof state === "object") {
	                state = state[0];
	            }
	            if (state.substring) {
	                if (state.substring(0, 3) == "js-")
	                    scope = "javascript";
	                else if (state.substring(0, 4) == "css-")
	                    scope = "css";
	                else if (state.substring(0, 4) == "php-")
	                    scope = "php";
	            }
	        }
	        
	        return scope;
	    };
	
	    this.getActiveScopes = function(editor) {
	        var scope = this.$getScope(editor);
	        var scopes = [scope];
	        var snippetMap = this.snippetMap;
	        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
	            scopes.push.apply(scopes, snippetMap[scope].includeScopes);
	        }
	        scopes.push("_");
	        return scopes;
	    };
	
	    this.expandWithTab = function(editor, options) {
	        var self = this;
	        var result = editor.forEachSelection(function() {
	            return self.expandSnippetForSelection(editor, options);
	        }, null, {keepOrder: true});
	        if (result && editor.tabstopManager)
	            editor.tabstopManager.tabNext();
	        return result;
	    };
	    
	    this.expandSnippetForSelection = function(editor, options) {
	        var cursor = editor.getCursorPosition();
	        var line = editor.session.getLine(cursor.row);
	        var before = line.substring(0, cursor.column);
	        var after = line.substr(cursor.column);
	
	        var snippetMap = this.snippetMap;
	        var snippet;
	        this.getActiveScopes(editor).some(function(scope) {
	            var snippets = snippetMap[scope];
	            if (snippets)
	                snippet = this.findMatchingSnippet(snippets, before, after);
	            return !!snippet;
	        }, this);
	        if (!snippet)
	            return false;
	        if (options && options.dryRun)
	            return true;
	        editor.session.doc.removeInLine(cursor.row,
	            cursor.column - snippet.replaceBefore.length,
	            cursor.column + snippet.replaceAfter.length
	        );
	
	        this.variables.M__ = snippet.matchBefore;
	        this.variables.T__ = snippet.matchAfter;
	        this.insertSnippetForSelection(editor, snippet.content);
	
	        this.variables.M__ = this.variables.T__ = null;
	        return true;
	    };
	
	    this.findMatchingSnippet = function(snippetList, before, after) {
	        for (var i = snippetList.length; i--;) {
	            var s = snippetList[i];
	            if (s.startRe && !s.startRe.test(before))
	                continue;
	            if (s.endRe && !s.endRe.test(after))
	                continue;
	            if (!s.startRe && !s.endRe)
	                continue;
	
	            s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
	            s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
	            s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
	            s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
	            return s;
	        }
	    };
	
	    this.snippetMap = {};
	    this.snippetNameMap = {};
	    this.register = function(snippets, scope) {
	        var snippetMap = this.snippetMap;
	        var snippetNameMap = this.snippetNameMap;
	        var self = this;
	        
	        if (!snippets) 
	            snippets = [];
	        
	        function wrapRegexp(src) {
	            if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src))
	                src = "(?:" + src + ")";
	
	            return src || "";
	        }
	        function guardedRegexp(re, guard, opening) {
	            re = wrapRegexp(re);
	            guard = wrapRegexp(guard);
	            if (opening) {
	                re = guard + re;
	                if (re && re[re.length - 1] != "$")
	                    re = re + "$";
	            } else {
	                re = re + guard;
	                if (re && re[0] != "^")
	                    re = "^" + re;
	            }
	            return new RegExp(re);
	        }
	
	        function addSnippet(s) {
	            if (!s.scope)
	                s.scope = scope || "_";
	            scope = s.scope;
	            if (!snippetMap[scope]) {
	                snippetMap[scope] = [];
	                snippetNameMap[scope] = {};
	            }
	
	            var map = snippetNameMap[scope];
	            if (s.name) {
	                var old = map[s.name];
	                if (old)
	                    self.unregister(old);
	                map[s.name] = s;
	            }
	            snippetMap[scope].push(s);
	
	            if (s.tabTrigger && !s.trigger) {
	                if (!s.guard && /^\w/.test(s.tabTrigger))
	                    s.guard = "\\b";
	                s.trigger = lang.escapeRegExp(s.tabTrigger);
	            }
	            
	            if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard)
	                return;
	            
	            s.startRe = guardedRegexp(s.trigger, s.guard, true);
	            s.triggerRe = new RegExp(s.trigger, "", true);
	
	            s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
	            s.endTriggerRe = new RegExp(s.endTrigger, "", true);
	        }
	
	        if (snippets && snippets.content)
	            addSnippet(snippets);
	        else if (Array.isArray(snippets))
	            snippets.forEach(addSnippet);
	        
	        this._signal("registerSnippets", {scope: scope});
	    };
	    this.unregister = function(snippets, scope) {
	        var snippetMap = this.snippetMap;
	        var snippetNameMap = this.snippetNameMap;
	
	        function removeSnippet(s) {
	            var nameMap = snippetNameMap[s.scope||scope];
	            if (nameMap && nameMap[s.name]) {
	                delete nameMap[s.name];
	                var map = snippetMap[s.scope||scope];
	                var i = map && map.indexOf(s);
	                if (i >= 0)
	                    map.splice(i, 1);
	            }
	        }
	        if (snippets.content)
	            removeSnippet(snippets);
	        else if (Array.isArray(snippets))
	            snippets.forEach(removeSnippet);
	    };
	    this.parseSnippetFile = function(str) {
	        str = str.replace(/\r/g, "");
	        var list = [], snippet = {};
	        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
	        var m;
	        while (m = re.exec(str)) {
	            if (m[1]) {
	                try {
	                    snippet = JSON.parse(m[1]);
	                    list.push(snippet);
	                } catch (e) {}
	            } if (m[4]) {
	                snippet.content = m[4].replace(/^\t/gm, "");
	                list.push(snippet);
	                snippet = {};
	            } else {
	                var key = m[2], val = m[3];
	                if (key == "regex") {
	                    var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
	                    snippet.guard = guardRe.exec(val)[1];
	                    snippet.trigger = guardRe.exec(val)[1];
	                    snippet.endTrigger = guardRe.exec(val)[1];
	                    snippet.endGuard = guardRe.exec(val)[1];
	                } else if (key == "snippet") {
	                    snippet.tabTrigger = val.match(/^\S*/)[0];
	                    if (!snippet.name)
	                        snippet.name = val;
	                } else {
	                    snippet[key] = val;
	                }
	            }
	        }
	        return list;
	    };
	    this.getSnippetByName = function(name, editor) {
	        var snippetMap = this.snippetNameMap;
	        var snippet;
	        this.getActiveScopes(editor).some(function(scope) {
	            var snippets = snippetMap[scope];
	            if (snippets)
	                snippet = snippets[name];
	            return !!snippet;
	        }, this);
	        return snippet;
	    };
	
	}).call(SnippetManager.prototype);
	
	
	var TabstopManager = function(editor) {
	    if (editor.tabstopManager)
	        return editor.tabstopManager;
	    editor.tabstopManager = this;
	    this.$onChange = this.onChange.bind(this);
	    this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
	    this.$onChangeSession = this.onChangeSession.bind(this);
	    this.$onAfterExec = this.onAfterExec.bind(this);
	    this.attach(editor);
	};
	(function() {
	    this.attach = function(editor) {
	        this.index = 0;
	        this.ranges = [];
	        this.tabstops = [];
	        this.$openTabstops = null;
	        this.selectedTabstop = null;
	
	        this.editor = editor;
	        this.editor.on("change", this.$onChange);
	        this.editor.on("changeSelection", this.$onChangeSelection);
	        this.editor.on("changeSession", this.$onChangeSession);
	        this.editor.commands.on("afterExec", this.$onAfterExec);
	        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	    };
	    this.detach = function() {
	        this.tabstops.forEach(this.removeTabstopMarkers, this);
	        this.ranges = null;
	        this.tabstops = null;
	        this.selectedTabstop = null;
	        this.editor.removeListener("change", this.$onChange);
	        this.editor.removeListener("changeSelection", this.$onChangeSelection);
	        this.editor.removeListener("changeSession", this.$onChangeSession);
	        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
	        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
	        this.editor.tabstopManager = null;
	        this.editor = null;
	    };
	
	    this.onChange = function(delta) {
	        var changeRange = delta;
	        var isRemove = delta.action[0] == "r";
	        var start = delta.start;
	        var end = delta.end;
	        var startRow = start.row;
	        var endRow = end.row;
	        var lineDif = endRow - startRow;
	        var colDiff = end.column - start.column;
	
	        if (isRemove) {
	            lineDif = -lineDif;
	            colDiff = -colDiff;
	        }
	        if (!this.$inChange && isRemove) {
	            var ts = this.selectedTabstop;
	            var changedOutside = ts && !ts.some(function(r) {
	                return comparePoints(r.start, start) <= 0 && comparePoints(r.end, end) >= 0;
	            });
	            if (changedOutside)
	                return this.detach();
	        }
	        var ranges = this.ranges;
	        for (var i = 0; i < ranges.length; i++) {
	            var r = ranges[i];
	            if (r.end.row < start.row)
	                continue;
	
	            if (isRemove && comparePoints(start, r.start) < 0 && comparePoints(end, r.end) > 0) {
	                this.removeRange(r);
	                i--;
	                continue;
	            }
	
	            if (r.start.row == startRow && r.start.column > start.column)
	                r.start.column += colDiff;
	            if (r.end.row == startRow && r.end.column >= start.column)
	                r.end.column += colDiff;
	            if (r.start.row >= startRow)
	                r.start.row += lineDif;
	            if (r.end.row >= startRow)
	                r.end.row += lineDif;
	
	            if (comparePoints(r.start, r.end) > 0)
	                this.removeRange(r);
	        }
	        if (!ranges.length)
	            this.detach();
	    };
	    this.updateLinkedFields = function() {
	        var ts = this.selectedTabstop;
	        if (!ts || !ts.hasLinkedRanges)
	            return;
	        this.$inChange = true;
	        var session = this.editor.session;
	        var text = session.getTextRange(ts.firstNonLinked);
	        for (var i = ts.length; i--;) {
	            var range = ts[i];
	            if (!range.linked)
	                continue;
	            var fmt = exports.snippetManager.tmStrFormat(text, range.original);
	            session.replace(range, fmt);
	        }
	        this.$inChange = false;
	    };
	    this.onAfterExec = function(e) {
	        if (e.command && !e.command.readOnly)
	            this.updateLinkedFields();
	    };
	    this.onChangeSelection = function() {
	        if (!this.editor)
	            return;
	        var lead = this.editor.selection.lead;
	        var anchor = this.editor.selection.anchor;
	        var isEmpty = this.editor.selection.isEmpty();
	        for (var i = this.ranges.length; i--;) {
	            if (this.ranges[i].linked)
	                continue;
	            var containsLead = this.ranges[i].contains(lead.row, lead.column);
	            var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
	            if (containsLead && containsAnchor)
	                return;
	        }
	        this.detach();
	    };
	    this.onChangeSession = function() {
	        this.detach();
	    };
	    this.tabNext = function(dir) {
	        var max = this.tabstops.length;
	        var index = this.index + (dir || 1);
	        index = Math.min(Math.max(index, 1), max);
	        if (index == max)
	            index = 0;
	        this.selectTabstop(index);
	        if (index === 0)
	            this.detach();
	    };
	    this.selectTabstop = function(index) {
	        this.$openTabstops = null;
	        var ts = this.tabstops[this.index];
	        if (ts)
	            this.addTabstopMarkers(ts);
	        this.index = index;
	        ts = this.tabstops[this.index];
	        if (!ts || !ts.length)
	            return;
	        
	        this.selectedTabstop = ts;
	        if (!this.editor.inVirtualSelectionMode) {        
	            var sel = this.editor.multiSelect;
	            sel.toSingleRange(ts.firstNonLinked.clone());
	            for (var i = ts.length; i--;) {
	                if (ts.hasLinkedRanges && ts[i].linked)
	                    continue;
	                sel.addRange(ts[i].clone(), true);
	            }
	            if (sel.ranges[0])
	                sel.addRange(sel.ranges[0].clone());
	        } else {
	            this.editor.selection.setRange(ts.firstNonLinked);
	        }
	        
	        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	    };
	    this.addTabstops = function(tabstops, start, end) {
	        if (!this.$openTabstops)
	            this.$openTabstops = [];
	        if (!tabstops[0]) {
	            var p = Range.fromPoints(end, end);
	            moveRelative(p.start, start);
	            moveRelative(p.end, start);
	            tabstops[0] = [p];
	            tabstops[0].index = 0;
	        }
	
	        var i = this.index;
	        var arg = [i + 1, 0];
	        var ranges = this.ranges;
	        tabstops.forEach(function(ts, index) {
	            var dest = this.$openTabstops[index] || ts;
	                
	            for (var i = ts.length; i--;) {
	                var p = ts[i];
	                var range = Range.fromPoints(p.start, p.end || p.start);
	                movePoint(range.start, start);
	                movePoint(range.end, start);
	                range.original = p;
	                range.tabstop = dest;
	                ranges.push(range);
	                if (dest != ts)
	                    dest.unshift(range);
	                else
	                    dest[i] = range;
	                if (p.fmtString) {
	                    range.linked = true;
	                    dest.hasLinkedRanges = true;
	                } else if (!dest.firstNonLinked)
	                    dest.firstNonLinked = range;
	            }
	            if (!dest.firstNonLinked)
	                dest.hasLinkedRanges = false;
	            if (dest === ts) {
	                arg.push(dest);
	                this.$openTabstops[index] = dest;
	            }
	            this.addTabstopMarkers(dest);
	        }, this);
	        
	        if (arg.length > 2) {
	            if (this.tabstops.length)
	                arg.push(arg.splice(2, 1)[0]);
	            this.tabstops.splice.apply(this.tabstops, arg);
	        }
	    };
	
	    this.addTabstopMarkers = function(ts) {
	        var session = this.editor.session;
	        ts.forEach(function(range) {
	            if  (!range.markerId)
	                range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
	        });
	    };
	    this.removeTabstopMarkers = function(ts) {
	        var session = this.editor.session;
	        ts.forEach(function(range) {
	            session.removeMarker(range.markerId);
	            range.markerId = null;
	        });
	    };
	    this.removeRange = function(range) {
	        var i = range.tabstop.indexOf(range);
	        range.tabstop.splice(i, 1);
	        i = this.ranges.indexOf(range);
	        this.ranges.splice(i, 1);
	        this.editor.session.removeMarker(range.markerId);
	        if (!range.tabstop.length) {
	            i = this.tabstops.indexOf(range.tabstop);
	            if (i != -1)
	                this.tabstops.splice(i, 1);
	            if (!this.tabstops.length)
	                this.detach();
	        }
	    };
	
	    this.keyboardHandler = new HashHandler();
	    this.keyboardHandler.bindKeys({
	        "Tab": function(ed) {
	            if (exports.snippetManager && exports.snippetManager.expandWithTab(ed)) {
	                return;
	            }
	
	            ed.tabstopManager.tabNext(1);
	        },
	        "Shift-Tab": function(ed) {
	            ed.tabstopManager.tabNext(-1);
	        },
	        "Esc": function(ed) {
	            ed.tabstopManager.detach();
	        },
	        "Return": function(ed) {
	            return false;
	        }
	    });
	}).call(TabstopManager.prototype);
	
	
	
	var changeTracker = {};
	changeTracker.onChange = Anchor.prototype.onChange;
	changeTracker.setPosition = function(row, column) {
	    this.pos.row = row;
	    this.pos.column = column;
	};
	changeTracker.update = function(pos, delta, $insertRight) {
	    this.$insertRight = $insertRight;
	    this.pos = pos; 
	    this.onChange(delta);
	};
	
	var movePoint = function(point, diff) {
	    if (point.row == 0)
	        point.column += diff.column;
	    point.row += diff.row;
	};
	
	var moveRelative = function(point, start) {
	    if (point.row == start.row)
	        point.column -= start.column;
	    point.row -= start.row;
	};
	
	
	acequire("./lib/dom").importCssString("\
	.ace_snippet-marker {\
	    -moz-box-sizing: border-box;\
	    box-sizing: border-box;\
	    background: rgba(194, 193, 208, 0.09);\
	    border: 1px dotted rgba(211, 208, 235, 0.62);\
	    position: absolute;\
	}");
	
	exports.snippetManager = new SnippetManager();
	
	
	var Editor = acequire("./editor").Editor;
	(function() {
	    this.insertSnippet = function(content, options) {
	        return exports.snippetManager.insertSnippet(this, content, options);
	    };
	    this.expandSnippet = function(options) {
	        return exports.snippetManager.expandWithTab(this, options);
	    };
	}).call(Editor.prototype);
	
	});
	
	ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"], function(acequire, exports, module) {
	"use strict";
	
	var Renderer = acequire("../virtual_renderer").VirtualRenderer;
	var Editor = acequire("../editor").Editor;
	var Range = acequire("../range").Range;
	var event = acequire("../lib/event");
	var lang = acequire("../lib/lang");
	var dom = acequire("../lib/dom");
	
	var $singleLineEditor = function(el) {
	    var renderer = new Renderer(el);
	
	    renderer.$maxLines = 4;
	
	    var editor = new Editor(renderer);
	
	    editor.setHighlightActiveLine(false);
	    editor.setShowPrintMargin(false);
	    editor.renderer.setShowGutter(false);
	    editor.renderer.setHighlightGutterLine(false);
	
	    editor.$mouseHandler.$focusWaitTimout = 0;
	    editor.$highlightTagPending = true;
	
	    return editor;
	};
	
	var AcePopup = function(parentNode) {
	    var el = dom.createElement("div");
	    var popup = new $singleLineEditor(el);
	
	    if (parentNode)
	        parentNode.appendChild(el);
	    el.style.display = "none";
	    popup.renderer.content.style.cursor = "default";
	    popup.renderer.setStyle("ace_autocomplete");
	
	    popup.setOption("displayIndentGuides", false);
	    popup.setOption("dragDelay", 150);
	
	    var noop = function(){};
	
	    popup.focus = noop;
	    popup.$isFocused = true;
	
	    popup.renderer.$cursorLayer.restartTimer = noop;
	    popup.renderer.$cursorLayer.element.style.opacity = 0;
	
	    popup.renderer.$maxLines = 8;
	    popup.renderer.$keepTextAreaAtCursor = false;
	
	    popup.setHighlightActiveLine(false);
	    popup.session.highlight("");
	    popup.session.$searchHighlight.clazz = "ace_highlight-marker";
	
	    popup.on("mousedown", function(e) {
	        var pos = e.getDocumentPosition();
	        popup.selection.moveToPosition(pos);
	        selectionMarker.start.row = selectionMarker.end.row = pos.row;
	        e.stop();
	    });
	
	    var lastMouseEvent;
	    var hoverMarker = new Range(-1,0,-1,Infinity);
	    var selectionMarker = new Range(-1,0,-1,Infinity);
	    selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");
	    popup.setSelectOnHover = function(val) {
	        if (!val) {
	            hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
	        } else if (hoverMarker.id) {
	            popup.session.removeMarker(hoverMarker.id);
	            hoverMarker.id = null;
	        }
	    };
	    popup.setSelectOnHover(false);
	    popup.on("mousemove", function(e) {
	        if (!lastMouseEvent) {
	            lastMouseEvent = e;
	            return;
	        }
	        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
	            return;
	        }
	        lastMouseEvent = e;
	        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
	        var row = lastMouseEvent.getDocumentPosition().row;
	        if (hoverMarker.start.row != row) {
	            if (!hoverMarker.id)
	                popup.setRow(row);
	            setHoverMarker(row);
	        }
	    });
	    popup.renderer.on("beforeRender", function() {
	        if (lastMouseEvent && hoverMarker.start.row != -1) {
	            lastMouseEvent.$pos = null;
	            var row = lastMouseEvent.getDocumentPosition().row;
	            if (!hoverMarker.id)
	                popup.setRow(row);
	            setHoverMarker(row, true);
	        }
	    });
	    popup.renderer.on("afterRender", function() {
	        var row = popup.getRow();
	        var t = popup.renderer.$textLayer;
	        var selected = t.element.childNodes[row - t.config.firstRow];
	        if (selected == t.selectedNode)
	            return;
	        if (t.selectedNode)
	            dom.removeCssClass(t.selectedNode, "ace_selected");
	        t.selectedNode = selected;
	        if (selected)
	            dom.addCssClass(selected, "ace_selected");
	    });
	    var hideHoverMarker = function() { setHoverMarker(-1) };
	    var setHoverMarker = function(row, suppressRedraw) {
	        if (row !== hoverMarker.start.row) {
	            hoverMarker.start.row = hoverMarker.end.row = row;
	            if (!suppressRedraw)
	                popup.session._emit("changeBackMarker");
	            popup._emit("changeHoverMarker");
	        }
	    };
	    popup.getHoveredRow = function() {
	        return hoverMarker.start.row;
	    };
	
	    event.addListener(popup.container, "mouseout", hideHoverMarker);
	    popup.on("hide", hideHoverMarker);
	    popup.on("changeSelection", hideHoverMarker);
	
	    popup.session.doc.getLength = function() {
	        return popup.data.length;
	    };
	    popup.session.doc.getLine = function(i) {
	        var data = popup.data[i];
	        if (typeof data == "string")
	            return data;
	        return (data && data.value) || "";
	    };
	
	    var bgTokenizer = popup.session.bgTokenizer;
	    bgTokenizer.$tokenizeRow = function(row) {
	        var data = popup.data[row];
	        var tokens = [];
	        if (!data)
	            return tokens;
	        if (typeof data == "string")
	            data = {value: data};
	        if (!data.caption)
	            data.caption = data.value || data.name;
	
	        var last = -1;
	        var flag, c;
	        for (var i = 0; i < data.caption.length; i++) {
	            c = data.caption[i];
	            flag = data.matchMask & (1 << i) ? 1 : 0;
	            if (last !== flag) {
	                tokens.push({type: data.className || "" + ( flag ? "completion-highlight" : ""), value: c});
	                last = flag;
	            } else {
	                tokens[tokens.length - 1].value += c;
	            }
	        }
	
	        if (data.meta) {
	            var maxW = popup.renderer.$size.scrollerWidth / popup.renderer.layerConfig.characterWidth;
	            var metaData = data.meta;
	            if (metaData.length + data.caption.length > maxW - 2) {
	                metaData = metaData.substr(0, maxW - data.caption.length - 3) + "\u2026"
	            }
	            tokens.push({type: "rightAlignedText", value: metaData});
	        }
	        return tokens;
	    };
	    bgTokenizer.$updateOnChange = noop;
	    bgTokenizer.start = noop;
	
	    popup.session.$computeWidth = function() {
	        return this.screenWidth = 0;
	    };
	
	    popup.$blockScrolling = Infinity;
	    popup.isOpen = false;
	    popup.isTopdown = false;
	
	    popup.data = [];
	    popup.setData = function(list) {
	        popup.setValue(lang.stringRepeat("\n", list.length), -1);
	        popup.data = list || [];
	        popup.setRow(0);
	    };
	    popup.getData = function(row) {
	        return popup.data[row];
	    };
	
	    popup.getRow = function() {
	        return selectionMarker.start.row;
	    };
	    popup.setRow = function(line) {
	        line = Math.max(0, Math.min(this.data.length, line));
	        if (selectionMarker.start.row != line) {
	            popup.selection.clearSelection();
	            selectionMarker.start.row = selectionMarker.end.row = line || 0;
	            popup.session._emit("changeBackMarker");
	            popup.moveCursorTo(line || 0, 0);
	            if (popup.isOpen)
	                popup._signal("select");
	        }
	    };
	
	    popup.on("changeSelection", function() {
	        if (popup.isOpen)
	            popup.setRow(popup.selection.lead.row);
	        popup.renderer.scrollCursorIntoView();
	    });
	
	    popup.hide = function() {
	        this.container.style.display = "none";
	        this._signal("hide");
	        popup.isOpen = false;
	    };
	    popup.show = function(pos, lineHeight, topdownOnly) {
	        var el = this.container;
	        var screenHeight = window.innerHeight;
	        var screenWidth = window.innerWidth;
	        var renderer = this.renderer;
	        var maxH = renderer.$maxLines * lineHeight * 1.4;
	        var top = pos.top + this.$borderSize;
	        if (top + maxH > screenHeight - lineHeight && !topdownOnly) {
	            el.style.top = "";
	            el.style.bottom = screenHeight - top + "px";
	            popup.isTopdown = false;
	        } else {
	            top += lineHeight;
	            el.style.top = top + "px";
	            el.style.bottom = "";
	            popup.isTopdown = true;
	        }
	
	        el.style.display = "";
	        this.renderer.$textLayer.checkForSizeChanges();
	
	        var left = pos.left;
	        if (left + el.offsetWidth > screenWidth)
	            left = screenWidth - el.offsetWidth;
	
	        el.style.left = left + "px";
	
	        this._signal("show");
	        lastMouseEvent = null;
	        popup.isOpen = true;
	    };
	
	    popup.getTextLeftOffset = function() {
	        return this.$borderSize + this.renderer.$padding + this.$imageSize;
	    };
	
	    popup.$imageSize = 0;
	    popup.$borderSize = 1;
	
	    return popup;
	};
	
	dom.importCssString("\
	.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\
	    background-color: #CAD6FA;\
	    z-index: 1;\
	}\
	.ace_editor.ace_autocomplete .ace_line-hover {\
	    border: 1px solid #abbffe;\
	    margin-top: -1px;\
	    background: rgba(233,233,253,0.4);\
	}\
	.ace_editor.ace_autocomplete .ace_line-hover {\
	    position: absolute;\
	    z-index: 2;\
	}\
	.ace_editor.ace_autocomplete .ace_scroller {\
	   background: none;\
	   border: none;\
	   box-shadow: none;\
	}\
	.ace_rightAlignedText {\
	    color: gray;\
	    display: inline-block;\
	    position: absolute;\
	    right: 4px;\
	    text-align: right;\
	    z-index: -1;\
	}\
	.ace_editor.ace_autocomplete .ace_completion-highlight{\
	    color: #000;\
	    text-shadow: 0 0 0.01em;\
	}\
	.ace_editor.ace_autocomplete {\
	    width: 280px;\
	    z-index: 200000;\
	    background: #fbfbfb;\
	    color: #444;\
	    border: 1px lightgray solid;\
	    position: fixed;\
	    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
	    line-height: 1.4;\
	}");
	
	exports.AcePopup = AcePopup;
	
	});
	
	ace.define("ace/autocomplete/util",["require","exports","module"], function(acequire, exports, module) {
	"use strict";
	
	exports.parForEach = function(array, fn, callback) {
	    var completed = 0;
	    var arLength = array.length;
	    if (arLength === 0)
	        callback();
	    for (var i = 0; i < arLength; i++) {
	        fn(array[i], function(result, err) {
	            completed++;
	            if (completed === arLength)
	                callback(result, err);
	        });
	    }
	};
	
	var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;
	
	exports.retrievePrecedingIdentifier = function(text, pos, regex) {
	    regex = regex || ID_REGEX;
	    var buf = [];
	    for (var i = pos-1; i >= 0; i--) {
	        if (regex.test(text[i]))
	            buf.push(text[i]);
	        else
	            break;
	    }
	    return buf.reverse().join("");
	};
	
	exports.retrieveFollowingIdentifier = function(text, pos, regex) {
	    regex = regex || ID_REGEX;
	    var buf = [];
	    for (var i = pos; i < text.length; i++) {
	        if (regex.test(text[i]))
	            buf.push(text[i]);
	        else
	            break;
	    }
	    return buf;
	};
	
	exports.getCompletionPrefix = function (editor) {
	    var pos = editor.getCursorPosition();
	    var line = editor.session.getLine(pos.row);
	    var prefix;
	    editor.completers.forEach(function(completer) {
	        if (completer.identifierRegexps) {
	            completer.identifierRegexps.forEach(function(identifierRegex) {
	                if (!prefix && identifierRegex)
	                    prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
	            }.bind(this));
	        }
	    }.bind(this));
	    return prefix || this.retrievePrecedingIdentifier(line, pos.column);
	};
	
	});
	
	ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"], function(acequire, exports, module) {
	"use strict";
	
	var HashHandler = acequire("./keyboard/hash_handler").HashHandler;
	var AcePopup = acequire("./autocomplete/popup").AcePopup;
	var util = acequire("./autocomplete/util");
	var event = acequire("./lib/event");
	var lang = acequire("./lib/lang");
	var dom = acequire("./lib/dom");
	var snippetManager = acequire("./snippets").snippetManager;
	
	var Autocomplete = function() {
	    this.autoInsert = false;
	    this.autoSelect = true;
	    this.exactMatch = false;
	    this.gatherCompletionsId = 0;
	    this.keyboardHandler = new HashHandler();
	    this.keyboardHandler.bindKeys(this.commands);
	
	    this.blurListener = this.blurListener.bind(this);
	    this.changeListener = this.changeListener.bind(this);
	    this.mousedownListener = this.mousedownListener.bind(this);
	    this.mousewheelListener = this.mousewheelListener.bind(this);
	
	    this.changeTimer = lang.delayedCall(function() {
	        this.updateCompletions(true);
	    }.bind(this));
	
	    this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
	};
	
	(function() {
	
	    this.$init = function() {
	        this.popup = new AcePopup(document.body || document.documentElement);
	        this.popup.on("click", function(e) {
	            this.insertMatch();
	            e.stop();
	        }.bind(this));
	        this.popup.focus = this.editor.focus.bind(this.editor);
	        this.popup.on("show", this.tooltipTimer.bind(null, null));
	        this.popup.on("select", this.tooltipTimer.bind(null, null));
	        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
	        return this.popup;
	    };
	
	    this.getPopup = function() {
	        return this.popup || this.$init();
	    };
	
	    this.openPopup = function(editor, prefix, keepPopupPosition) {
	        if (!this.popup)
	            this.$init();
	
	        this.popup.setData(this.completions.filtered);
	
	        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
	        
	        var renderer = editor.renderer;
	        this.popup.setRow(this.autoSelect ? 0 : -1);
	        if (!keepPopupPosition) {
	            this.popup.setTheme(editor.getTheme());
	            this.popup.setFontSize(editor.getFontSize());
	
	            var lineHeight = renderer.layerConfig.lineHeight;
	
	            var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
	            pos.left -= this.popup.getTextLeftOffset();
	
	            var rect = editor.container.getBoundingClientRect();
	            pos.top += rect.top - renderer.layerConfig.offset;
	            pos.left += rect.left - editor.renderer.scrollLeft;
	            pos.left += renderer.gutterWidth;
	
	            this.popup.show(pos, lineHeight);
	        } else if (keepPopupPosition && !prefix) {
	            this.detach();
	        }
	    };
	
	    this.detach = function() {
	        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
	        this.editor.off("changeSelection", this.changeListener);
	        this.editor.off("blur", this.blurListener);
	        this.editor.off("mousedown", this.mousedownListener);
	        this.editor.off("mousewheel", this.mousewheelListener);
	        this.changeTimer.cancel();
	        this.hideDocTooltip();
	
	        this.gatherCompletionsId += 1;
	        if (this.popup && this.popup.isOpen)
	            this.popup.hide();
	
	        if (this.base)
	            this.base.detach();
	        this.activated = false;
	        this.completions = this.base = null;
	    };
	
	    this.changeListener = function(e) {
	        var cursor = this.editor.selection.lead;
	        if (cursor.row != this.base.row || cursor.column < this.base.column) {
	            this.detach();
	        }
	        if (this.activated)
	            this.changeTimer.schedule();
	        else
	            this.detach();
	    };
	
	    this.blurListener = function(e) {
	        var el = document.activeElement;
	        var text = this.editor.textInput.getElement();
	        var fromTooltip = e.relatedTarget && e.relatedTarget == this.tooltipNode;
	        var container = this.popup && this.popup.container;
	        if (el != text && el.parentNode != container && !fromTooltip
	            && el != this.tooltipNode && e.relatedTarget != text
	        ) {
	            this.detach();
	        }
	    };
	
	    this.mousedownListener = function(e) {
	        this.detach();
	    };
	
	    this.mousewheelListener = function(e) {
	        this.detach();
	    };
	
	    this.goTo = function(where) {
	        var row = this.popup.getRow();
	        var max = this.popup.session.getLength() - 1;
	
	        switch(where) {
	            case "up": row = row <= 0 ? max : row - 1; break;
	            case "down": row = row >= max ? -1 : row + 1; break;
	            case "start": row = 0; break;
	            case "end": row = max; break;
	        }
	
	        this.popup.setRow(row);
	    };
	
	    this.insertMatch = function(data, options) {
	        if (!data)
	            data = this.popup.getData(this.popup.getRow());
	        if (!data)
	            return false;
	
	        if (data.completer && data.completer.insertMatch) {
	            data.completer.insertMatch(this.editor, data);
	        } else {
	            if (this.completions.filterText) {
	                var ranges = this.editor.selection.getAllRanges();
	                for (var i = 0, range; range = ranges[i]; i++) {
	                    range.start.column -= this.completions.filterText.length;
	                    this.editor.session.remove(range);
	                }
	            }
	            if (data.snippet)
	                snippetManager.insertSnippet(this.editor, data.snippet);
	            else
	                this.editor.execCommand("insertstring", data.value || data);
	        }
	        this.detach();
	    };
	
	
	    this.commands = {
	        "Up": function(editor) { editor.completer.goTo("up"); },
	        "Down": function(editor) { editor.completer.goTo("down"); },
	        "Ctrl-Up|Ctrl-Home": function(editor) { editor.completer.goTo("start"); },
	        "Ctrl-Down|Ctrl-End": function(editor) { editor.completer.goTo("end"); },
	
	        "Esc": function(editor) { editor.completer.detach(); },
	        "Return": function(editor) { return editor.completer.insertMatch(); },
	        "Shift-Return": function(editor) { editor.completer.insertMatch(null, {deleteSuffix: true}); },
	        "Tab": function(editor) {
	            var result = editor.completer.insertMatch();
	            if (!result && !editor.tabstopManager)
	                editor.completer.goTo("down");
	            else
	                return result;
	        },
	
	        "PageUp": function(editor) { editor.completer.popup.gotoPageUp(); },
	        "PageDown": function(editor) { editor.completer.popup.gotoPageDown(); }
	    };
	
	    this.gatherCompletions = function(editor, callback) {
	        var session = editor.getSession();
	        var pos = editor.getCursorPosition();
	
	        var line = session.getLine(pos.row);
	        var prefix = util.getCompletionPrefix(editor);
	
	        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
	        this.base.$insertRight = true;
	
	        var matches = [];
	        var total = editor.completers.length;
	        editor.completers.forEach(function(completer, i) {
	            completer.getCompletions(editor, session, pos, prefix, function(err, results) {
	                if (!err && results)
	                    matches = matches.concat(results);
	                var pos = editor.getCursorPosition();
	                var line = session.getLine(pos.row);
	                callback(null, {
	                    prefix: prefix,
	                    matches: matches,
	                    finished: (--total === 0)
	                });
	            });
	        });
	        return true;
	    };
	
	    this.showPopup = function(editor) {
	        if (this.editor)
	            this.detach();
	
	        this.activated = true;
	
	        this.editor = editor;
	        if (editor.completer != this) {
	            if (editor.completer)
	                editor.completer.detach();
	            editor.completer = this;
	        }
	
	        editor.on("changeSelection", this.changeListener);
	        editor.on("blur", this.blurListener);
	        editor.on("mousedown", this.mousedownListener);
	        editor.on("mousewheel", this.mousewheelListener);
	
	        this.updateCompletions();
	    };
	
	    this.updateCompletions = function(keepPopupPosition) {
	        if (keepPopupPosition && this.base && this.completions) {
	            var pos = this.editor.getCursorPosition();
	            var prefix = this.editor.session.getTextRange({start: this.base, end: pos});
	            if (prefix == this.completions.filterText)
	                return;
	            this.completions.setFilter(prefix);
	            if (!this.completions.filtered.length)
	                return this.detach();
	            if (this.completions.filtered.length == 1
	            && this.completions.filtered[0].value == prefix
	            && !this.completions.filtered[0].snippet)
	                return this.detach();
	            this.openPopup(this.editor, prefix, keepPopupPosition);
	            return;
	        }
	        var _id = this.gatherCompletionsId;
	        this.gatherCompletions(this.editor, function(err, results) {
	            var detachIfFinished = function() {
	                if (!results.finished) return;
	                return this.detach();
	            }.bind(this);
	
	            var prefix = results.prefix;
	            var matches = results && results.matches;
	
	            if (!matches || !matches.length)
	                return detachIfFinished();
	            if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId)
	                return;
	
	            this.completions = new FilteredList(matches);
	
	            if (this.exactMatch)
	                this.completions.exactMatch = true;
	
	            this.completions.setFilter(prefix);
	            var filtered = this.completions.filtered;
	            if (!filtered.length)
	                return detachIfFinished();
	            if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet)
	                return detachIfFinished();
	            if (this.autoInsert && filtered.length == 1 && results.finished)
	                return this.insertMatch(filtered[0]);
	
	            this.openPopup(this.editor, prefix, keepPopupPosition);
	        }.bind(this));
	    };
	
	    this.cancelContextMenu = function() {
	        this.editor.$mouseHandler.cancelContextMenu();
	    };
	
	    this.updateDocTooltip = function() {
	        var popup = this.popup;
	        var all = popup.data;
	        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
	        var doc = null;
	        if (!selected || !this.editor || !this.popup.isOpen)
	            return this.hideDocTooltip();
	        this.editor.completers.some(function(completer) {
	            if (completer.getDocTooltip)
	                doc = completer.getDocTooltip(selected);
	            return doc;
	        });
	        if (!doc)
	            doc = selected;
	
	        if (typeof doc == "string")
	            doc = {docText: doc};
	        if (!doc || !(doc.docHTML || doc.docText))
	            return this.hideDocTooltip();
	        this.showDocTooltip(doc);
	    };
	
	    this.showDocTooltip = function(item) {
	        if (!this.tooltipNode) {
	            this.tooltipNode = dom.createElement("div");
	            this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
	            this.tooltipNode.style.margin = 0;
	            this.tooltipNode.style.pointerEvents = "auto";
	            this.tooltipNode.tabIndex = -1;
	            this.tooltipNode.onblur = this.blurListener.bind(this);
	        }
	
	        var tooltipNode = this.tooltipNode;
	        if (item.docHTML) {
	            tooltipNode.innerHTML = item.docHTML;
	        } else if (item.docText) {
	            tooltipNode.textContent = item.docText;
	        }
	
	        if (!tooltipNode.parentNode)
	            document.body.appendChild(tooltipNode);
	        var popup = this.popup;
	        var rect = popup.container.getBoundingClientRect();
	        tooltipNode.style.top = popup.container.style.top;
	        tooltipNode.style.bottom = popup.container.style.bottom;
	
	        if (window.innerWidth - rect.right < 320) {
	            tooltipNode.style.right = window.innerWidth - rect.left + "px";
	            tooltipNode.style.left = "";
	        } else {
	            tooltipNode.style.left = (rect.right + 1) + "px";
	            tooltipNode.style.right = "";
	        }
	        tooltipNode.style.display = "block";
	    };
	
	    this.hideDocTooltip = function() {
	        this.tooltipTimer.cancel();
	        if (!this.tooltipNode) return;
	        var el = this.tooltipNode;
	        if (!this.editor.isFocused() && document.activeElement == el)
	            this.editor.focus();
	        this.tooltipNode = null;
	        if (el.parentNode)
	            el.parentNode.removeChild(el);
	    };
	
	}).call(Autocomplete.prototype);
	
	Autocomplete.startCommand = {
	    name: "startAutocomplete",
	    exec: function(editor) {
	        if (!editor.completer)
	            editor.completer = new Autocomplete();
	        editor.completer.autoInsert = false;
	        editor.completer.autoSelect = true;
	        editor.completer.showPopup(editor);
	        editor.completer.cancelContextMenu();
	    },
	    bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
	};
	
	var FilteredList = function(array, filterText) {
	    this.all = array;
	    this.filtered = array;
	    this.filterText = filterText || "";
	    this.exactMatch = false;
	};
	(function(){
	    this.setFilter = function(str) {
	        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0)
	            var matches = this.filtered;
	        else
	            var matches = this.all;
	
	        this.filterText = str;
	        matches = this.filterCompletions(matches, this.filterText);
	        matches = matches.sort(function(a, b) {
	            return b.exactMatch - a.exactMatch || b.score - a.score;
	        });
	        var prev = null;
	        matches = matches.filter(function(item){
	            var caption = item.snippet || item.caption || item.value;
	            if (caption === prev) return false;
	            prev = caption;
	            return true;
	        });
	
	        this.filtered = matches;
	    };
	    this.filterCompletions = function(items, needle) {
	        var results = [];
	        var upper = needle.toUpperCase();
	        var lower = needle.toLowerCase();
	        loop: for (var i = 0, item; item = items[i]; i++) {
	            var caption = item.value || item.caption || item.snippet;
	            if (!caption) continue;
	            var lastIndex = -1;
	            var matchMask = 0;
	            var penalty = 0;
	            var index, distance;
	
	            if (this.exactMatch) {
	                if (needle !== caption.substr(0, needle.length))
	                    continue loop;
	            }else{
	                for (var j = 0; j < needle.length; j++) {
	                    var i1 = caption.indexOf(lower[j], lastIndex + 1);
	                    var i2 = caption.indexOf(upper[j], lastIndex + 1);
	                    index = (i1 >= 0) ? ((i2 < 0 || i1 < i2) ? i1 : i2) : i2;
	                    if (index < 0)
	                        continue loop;
	                    distance = index - lastIndex - 1;
	                    if (distance > 0) {
	                        if (lastIndex === -1)
	                            penalty += 10;
	                        penalty += distance;
	                    }
	                    matchMask = matchMask | (1 << index);
	                    lastIndex = index;
	                }
	            }
	            item.matchMask = matchMask;
	            item.exactMatch = penalty ? 0 : 1;
	            item.score = (item.score || 0) - penalty;
	            results.push(item);
	        }
	        return results;
	    };
	}).call(FilteredList.prototype);
	
	exports.Autocomplete = Autocomplete;
	exports.FilteredList = FilteredList;
	
	});
	
	ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"], function(acequire, exports, module) {
	    var Range = acequire("../range").Range;
	    
	    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;
	
	    function getWordIndex(doc, pos) {
	        var textBefore = doc.getTextRange(Range.fromPoints({row: 0, column:0}, pos));
	        return textBefore.split(splitRegex).length - 1;
	    }
	    function wordDistance(doc, pos) {
	        var prefixPos = getWordIndex(doc, pos);
	        var words = doc.getValue().split(splitRegex);
	        var wordScores = Object.create(null);
	        
	        var currentWord = words[prefixPos];
	
	        words.forEach(function(word, idx) {
	            if (!word || word === currentWord) return;
	
	            var distance = Math.abs(prefixPos - idx);
	            var score = words.length - distance;
	            if (wordScores[word]) {
	                wordScores[word] = Math.max(score, wordScores[word]);
	            } else {
	                wordScores[word] = score;
	            }
	        });
	        return wordScores;
	    }
	
	    exports.getCompletions = function(editor, session, pos, prefix, callback) {
	        var wordScore = wordDistance(session, pos, prefix);
	        var wordList = Object.keys(wordScore);
	        callback(null, wordList.map(function(word) {
	            return {
	                caption: word,
	                value: word,
	                score: wordScore[word],
	                meta: "local"
	            };
	        }));
	    };
	});
	
	ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"], function(acequire, exports, module) {
	"use strict";
	
	var snippetManager = acequire("../snippets").snippetManager;
	var Autocomplete = acequire("../autocomplete").Autocomplete;
	var config = acequire("../config");
	var lang = acequire("../lib/lang");
	var util = acequire("../autocomplete/util");
	
	var textCompleter = acequire("../autocomplete/text_completer");
	var keyWordCompleter = {
	    getCompletions: function(editor, session, pos, prefix, callback) {
	        if (session.$mode.completer) {
	            return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
	        }
	        var state = editor.session.getState(pos.row);
	        var completions = session.$mode.getCompletions(state, session, pos, prefix);
	        callback(null, completions);
	    }
	};
	
	var snippetCompleter = {
	    getCompletions: function(editor, session, pos, prefix, callback) {
	        var snippetMap = snippetManager.snippetMap;
	        var completions = [];
	        snippetManager.getActiveScopes(editor).forEach(function(scope) {
	            var snippets = snippetMap[scope] || [];
	            for (var i = snippets.length; i--;) {
	                var s = snippets[i];
	                var caption = s.name || s.tabTrigger;
	                if (!caption)
	                    continue;
	                completions.push({
	                    caption: caption,
	                    snippet: s.content,
	                    meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
	                    type: "snippet"
	                });
	            }
	        }, this);
	        callback(null, completions);
	    },
	    getDocTooltip: function(item) {
	        if (item.type == "snippet" && !item.docHTML) {
	            item.docHTML = [
	                "<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>",
	                lang.escapeHTML(item.snippet)
	            ].join("");
	        }
	    }
	};
	
	var completers = [snippetCompleter, textCompleter, keyWordCompleter];
	exports.setCompleters = function(val) {
	    completers.length = 0;
	    if (val) completers.push.apply(completers, val);
	};
	exports.addCompleter = function(completer) {
	    completers.push(completer);
	};
	exports.textCompleter = textCompleter;
	exports.keyWordCompleter = keyWordCompleter;
	exports.snippetCompleter = snippetCompleter;
	
	var expandSnippet = {
	    name: "expandSnippet",
	    exec: function(editor) {
	        return snippetManager.expandWithTab(editor);
	    },
	    bindKey: "Tab"
	};
	
	var onChangeMode = function(e, editor) {
	    loadSnippetsForMode(editor.session.$mode);
	};
	
	var loadSnippetsForMode = function(mode) {
	    var id = mode.$id;
	    if (!snippetManager.files)
	        snippetManager.files = {};
	    loadSnippetFile(id);
	    if (mode.modes)
	        mode.modes.forEach(loadSnippetsForMode);
	};
	
	var loadSnippetFile = function(id) {
	    if (!id || snippetManager.files[id])
	        return;
	    var snippetFilePath = id.replace("mode", "snippets");
	    snippetManager.files[id] = {};
	    config.loadModule(snippetFilePath, function(m) {
	        if (m) {
	            snippetManager.files[id] = m;
	            if (!m.snippets && m.snippetText)
	                m.snippets = snippetManager.parseSnippetFile(m.snippetText);
	            snippetManager.register(m.snippets || [], m.scope);
	            if (m.includeScopes) {
	                snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
	                m.includeScopes.forEach(function(x) {
	                    loadSnippetFile("ace/mode/" + x);
	                });
	            }
	        }
	    });
	};
	
	var doLiveAutocomplete = function(e) {
	    var editor = e.editor;
	    var hasCompleter = editor.completer && editor.completer.activated;
	    if (e.command.name === "backspace") {
	        if (hasCompleter && !util.getCompletionPrefix(editor))
	            editor.completer.detach();
	    }
	    else if (e.command.name === "insertstring") {
	        var prefix = util.getCompletionPrefix(editor);
	        if (prefix && !hasCompleter) {
	            if (!editor.completer) {
	                editor.completer = new Autocomplete();
	            }
	            editor.completer.autoInsert = false;
	            editor.completer.showPopup(editor);
	        }
	    }
	};
	
	var Editor = acequire("../editor").Editor;
	acequire("../config").defineOptions(Editor.prototype, "editor", {
	    enableBasicAutocompletion: {
	        set: function(val) {
	            if (val) {
	                if (!this.completers)
	                    this.completers = Array.isArray(val)? val: completers;
	                this.commands.addCommand(Autocomplete.startCommand);
	            } else {
	                this.commands.removeCommand(Autocomplete.startCommand);
	            }
	        },
	        value: false
	    },
	    enableLiveAutocompletion: {
	        set: function(val) {
	            if (val) {
	                if (!this.completers)
	                    this.completers = Array.isArray(val)? val: completers;
	                this.commands.on('afterExec', doLiveAutocomplete);
	            } else {
	                this.commands.removeListener('afterExec', doLiveAutocomplete);
	            }
	        },
	        value: false
	    },
	    enableSnippets: {
	        set: function(val) {
	            if (val) {
	                this.commands.addCommand(expandSnippet);
	                this.on("changeMode", onChangeMode);
	                onChangeMode(null, this);
	            } else {
	                this.commands.removeCommand(expandSnippet);
	                this.off("changeMode", onChangeMode);
	            }
	        },
	        value: false
	    }
	});
	});
	                (function() {
	                    ace.acequire(["ace/ext/language_tools"], function() {});
	                })();
	            

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Methods to bind in 'this' context
	 */
	var METHODS_TO_BIND = ["toggleExpanded"];
	
	/**
	 * An error bar component commonly used in the ServiceForm and the JobsForm
	 * that contains collapsible error messages.
	 *
	 * @example <caption>How to use the CollapsibleErrorMessage</caption>
	 *   <CollapsibleErrorMessage
	 *
	 *        className="error-for-modal"
	 *
	 *        details={[ 'an', 'array', 'of', 'detailed errors' ]}
	 *        message="The message to display"
	 *
	 *        onToggle={function(isToggled) {
	 *          // Do something
	 *        }}
	 *
	 *      />
	 */
	
	var CollapsibleErrorMessage = function (_React$Component) {
	  (0, _inherits3.default)(CollapsibleErrorMessage, _React$Component);
	
	  /**
	   * Initialize superclass
	   */
	  function CollapsibleErrorMessage() {
	    (0, _classCallCheck3.default)(this, CollapsibleErrorMessage);
	
	    // Initial state
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CollapsibleErrorMessage.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleErrorMessage)).apply(this, arguments));
	
	    _this.state = {
	      expanded: false
	    };
	
	    // Bind methods in context
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * Set the default expanded state from the properties
	   */
	
	
	  (0, _createClass3.default)(CollapsibleErrorMessage, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded
	      });
	    }
	
	    /**
	     * Toggle the expanded state of the collapsible error bar
	     */
	
	  }, {
	    key: "toggleExpanded",
	    value: function toggleExpanded() {
	      var expanded = !this.state.expanded;
	      this.setState({ expanded: expanded });
	
	      // Call onToggle callback
	      this.props.onToggle(expanded);
	    }
	
	    /**
	     * The show more/less link
	     *
	     * @returns {React.Component|null} - The rendered content
	     */
	
	  }, {
	    key: "getShowDetailsLink",
	    value: function getShowDetailsLink() {
	      var _props = this.props,
	          message = _props.message,
	          details = _props.details;
	
	      // Check if we must not show the detail link at all
	
	      if (!message || !details || !details.length) {
	        return null;
	      }
	
	      // Get text
	      var moreLess = "more";
	      if (this.state.expanded) {
	        moreLess = "less";
	      }
	
	      // Render
	      return _react2.default.createElement(
	        "span",
	        {
	          className: "collapsible-toggle-label clickable",
	          onClick: this.toggleExpanded
	        },
	        "(Show ",
	        moreLess,
	        ")"
	      );
	    }
	
	    /**
	     * The list of errors in the details
	     *
	     * @returns {React.Component} - The rendered content
	     */
	
	  }, {
	    key: "getDetailsListItems",
	    value: function getDetailsListItems() {
	      var details = this.props.details;
	
	
	      return details.map(function (message, i) {
	        var msg = message.toString();
	
	        return _react2.default.createElement(
	          "li",
	          { key: i },
	          msg
	        );
	      });
	    }
	
	    /**
	     * The fixed message part
	     *
	     * @returns {React.Component|null} - The rendered content
	     */
	
	  }, {
	    key: "getFixedMessagePart",
	    value: function getFixedMessagePart() {
	      var message = this.props.message;
	
	      // If not visible, just exit
	
	      if (!message) {
	        return null;
	      }
	
	      // Render the fixed part of the message
	      return _react2.default.createElement(
	        "div",
	        { className: "collapsible-fixed" },
	        _react2.default.createElement(_Icon2.default, {
	          className: "icon-alert icon-margin-right",
	          color: "red",
	          id: "yield",
	          size: "mini"
	        }),
	        message,
	        this.getShowDetailsLink()
	      );
	    }
	
	    /**
	     * [Custom component] The toggled message part
	     *
	     * @returns {React.Component|null} - The rendered content
	     */
	
	  }, {
	    key: "getCollapsibleMessagePart",
	    value: function getCollapsibleMessagePart() {
	      var _props2 = this.props,
	          message = _props2.message,
	          details = _props2.details;
	
	      var isDetailed = !!message && details && details.length;
	
	      // If not expanded or detailed, just exit
	      if (!isDetailed || !this.state.expanded) {
	        return null;
	      }
	
	      // Render the toggled part of the message
	      // (Note: The nested div is used to float the contents when needed)
	      return _react2.default.createElement(
	        "div",
	        { className: "collapsible-toggled" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            null,
	            this.getDetailsListItems()
	          )
	        )
	      );
	    }
	
	    /**
	     * React.js Render Function
	     *
	     * @returns {React.Component|null} - The rendered content
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var message = this.props.message;
	
	      // If not visible, just exit
	
	      if (!message) {
	        return null;
	      }
	
	      // Compile classes
	      var className = (0, _dedupe2.default)("collapsible-error-message", { expanded: this.state.expanded }, this.props.className);
	
	      // Render message component
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        this.getFixedMessagePart(),
	        this.getCollapsibleMessagePart()
	      );
	    }
	  }]);
	  return CollapsibleErrorMessage;
	}(_react2.default.Component);
	
	CollapsibleErrorMessage.defaultProps = {
	  className: "",
	  details: null,
	  expanded: false,
	  message: "",
	  onToggle: function onToggle() {}
	};
	
	CollapsibleErrorMessage.propTypes = {
	  className: _react2.default.PropTypes.string,
	  details: _react2.default.PropTypes.array,
	  expanded: _react2.default.PropTypes.bool,
	  message: _react2.default.PropTypes.node,
	  onToggle: _react2.default.PropTypes.func
	};
	
	module.exports = CollapsibleErrorMessage;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Will return false if key isn't something like 'ports[0].value'.
	function isNotMultipleProp(key) {
	  return !key.includes("[") || !key.includes("]");
	}
	
	function containsMultipleProp(prop, fieldColumn, id) {
	  if (id) {
	    return !!(fieldColumn && fieldColumn.name && fieldColumn.name.includes(prop + "[" + id + "]"));
	  }
	
	  return !!(fieldColumn && fieldColumn.name && fieldColumn.name.startsWith(prop + "[") && fieldColumn.name.includes("]"));
	}
	
	var FormUtil = {
	  /**
	   * Creates a field definition with correctly formatted name.
	   *
	   * @return {Array} definition the created definition.
	   * @param {String} prop Property name for created definition.
	   * @param {Number} id Number for the instance. ex: port[id].value
	   * @param {Array} definition Definition to copy.
	   * @param {Object} model Default values to fill in field.
	   * @param {Number} index To add to make name unique (should reuse same index).
	   */
	  getMultipleFieldDefinition: function getMultipleFieldDefinition(prop, id, definition, model) {
	    var index = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	    return definition.map(function (definitionField) {
	      definitionField = _Util2.default.deepCopy(definitionField);
	      // Use index for key, so we can reuse same key for same field,
	      // to not make react think it is a completely new field
	      definitionField.key = prop + "[" + index + "]." + definitionField.name;
	      definitionField.name = prop + "[" + id + "]." + definitionField.name;
	
	      var propKey = FormUtil.getPropKey(definitionField.name);
	      if (model && Object.prototype.hasOwnProperty.call(model, propKey)) {
	        definitionField.value = model[propKey];
	      }
	
	      return definitionField;
	    });
	  },
	
	
	  /**
	   * Takes a model and turns all the multiple props (ports[0].key) into a
	   * format that makes sense (ports: [{key: 'value'}])
	   *
	   * @return {Object} newModel the created model.
	   * @param {Object} model Model to copy fields over from.
	   */
	  modelToCombinedProps: function modelToCombinedProps(model) {
	    var propValues = {};
	    model = (0, _assign2.default)({}, model);
	
	    (0, _keys2.default)(model).forEach(function (key) {
	      if (isNotMultipleProp(key) || !FormUtil.getProp(key)) {
	        return;
	      }
	
	      var multipleProperty = FormUtil.getProp(key);
	      var instanceValue = model[key];
	      delete model[key];
	      var valueIndex = FormUtil.getPropIndex(key);
	      var valueProperty = FormUtil.getPropKey(key);
	
	      if (propValues[multipleProperty] == null) {
	        propValues[multipleProperty] = [];
	      }
	
	      if (valueProperty) {
	        if ((0, _typeof3.default)(propValues[multipleProperty][valueIndex]) === "object") {
	          propValues[multipleProperty][valueIndex][valueProperty] = instanceValue;
	        } else if (propValues[multipleProperty][valueIndex] == null) {
	          propValues[multipleProperty][valueIndex] = (0, _defineProperty3.default)({}, valueProperty, instanceValue);
	        }
	      }
	    });
	
	    (0, _keys2.default)(propValues).forEach(function (propValue) {
	      propValues[propValue] = propValues[propValue].filter(function (item) {
	        return item !== undefined;
	      });
	    });
	
	    return (0, _assign2.default)({}, model, propValues);
	  },
	
	
	  /**
	   * Checks if a field definition is an instance of a duplicate. For example,
	   * it checks if the field's name is something like 'ports[0].key'.
	   *
	   * @param {String} prop Property name for fields to replace.
	   * @param {Object} field Field to check for match.
	   * @param {Number} id Id to match field.
	   * @return {Boolean} isFieldInstanceOfProp If the field is an instance.
	   */
	  isFieldInstanceOfProp: function isFieldInstanceOfProp(prop, field, id) {
	    var _this = this;
	
	    var isFieldArray = Array.isArray(field);
	    var recursiveCheck = function recursiveCheck(nestedField) {
	      return _this.isFieldInstanceOfProp(prop, nestedField, id);
	    };
	
	    return isFieldArray && field.some(recursiveCheck) || containsMultipleProp(prop, field, id);
	  },
	
	
	  /**
	   * Removes all props with an ID in a definition. For example, if you pass in
	   * 'ports' and 2 as the prop and id, it will remove things with the names like
	   * 'ports[2].key' and 'ports[2].value' from the definition.
	   *
	   * @param {Array} definition Definition to remove fields from.
	   * @param {String} prop Property name for fields to replace.
	   * @param {Number} id Id to match when removing fields.
	   * @return {undefined}
	   */
	  removePropID: function removePropID(definition, prop, id) {
	    var _this2 = this;
	
	    var fieldsToRemove = [];
	    definition.forEach(function (field) {
	      if (_this2.isFieldInstanceOfProp(prop, field, id)) {
	        fieldsToRemove.push(field);
	      }
	    });
	
	    fieldsToRemove.forEach(function (field) {
	      definition.splice(definition.indexOf(field), 1);
	    });
	  },
	
	
	  /**
	   * Ex: if key is 'variables[0].key', this method will return 'variables'.
	   *
	   * @param {String} key String to parse for prop.
	   * @return {String} prop
	   */
	  getProp: function getProp(key) {
	    return key && key.split("[")[0];
	  },
	
	
	  /**
	   * Ex: if key is 'variables[0].key', this method will return 0.
	   *
	   * @param {String} key String to parse for index.
	   * @return {Number} index
	   */
	  getPropIndex: function getPropIndex(key) {
	    if (key == null) {
	      return null;
	    }
	
	    var value = key.split("[");
	
	    return parseInt(value[1].split("]")[0], 10);
	  },
	
	
	  /**
	   * Ex: if key is 'variables[0].key', this method will return 'key'.
	   *
	   * @param {String} key String to parse for prop key.
	   * @return {String} prop key
	   */
	  getPropKey: function getPropKey(key) {
	    return key && key.split(".")[1];
	  },
	
	
	  /**
	   * Applies a callback on all field definitions within a form definition.
	   *
	   * @param {Array|Object} definition Definition to iterate through.
	   * @param {Function} callback Function that will receive the field definitions.
	   */
	  forEachDefinition: function forEachDefinition(definition, callback) {
	    // This means the field is an individual field. Here we just set the error
	    // to false.
	    if (FormUtil.isFieldDefinition(definition)) {
	      callback(definition);
	
	      return;
	    }
	
	    // If an array of definitions, then call on each individual field.
	    if (Array.isArray(definition)) {
	      definition.forEach(function (fieldDefinition) {
	        FormUtil.forEachDefinition(fieldDefinition, callback);
	      });
	
	      return;
	    }
	
	    // If has a property called 'definition' and it is an array, call on each
	    // individual field. This can happen for definitions from TabForms
	    // (multiple definitions).
	    if (Object.prototype.hasOwnProperty.call(definition, "definition") && Array.isArray(definition.definition)) {
	      FormUtil.forEachDefinition(definition.definition, callback);
	
	      return;
	    }
	
	    // This means we're at the root of a multiple definition.
	    if (!_react2.default.isValidElement(definition)) {
	      (0, _values2.default)(definition).forEach(function (nestedDefinition) {
	        var isNested = Object.prototype.hasOwnProperty.call(nestedDefinition, "definition");
	        if (isNested) {
	          FormUtil.forEachDefinition(nestedDefinition.definition, callback);
	        }
	      });
	    }
	  },
	
	
	  /**
	   * Checks if object is a proper field definition for a Form.
	   *
	   * @param {Object} fieldDefinition Definition to check.
	   * @return {Boolean} isFieldDefinition Whether it is a definition.
	   */
	  isFieldDefinition: function isFieldDefinition(fieldDefinition) {
	    return (typeof fieldDefinition === "undefined" ? "undefined" : (0, _typeof3.default)(fieldDefinition)) === "object" && fieldDefinition != null && Object.prototype.hasOwnProperty.call(fieldDefinition, "name") && Object.prototype.hasOwnProperty.call(fieldDefinition, "fieldType");
	  }
	};
	
	module.exports = FormUtil;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormUtil = __webpack_require__(1454);
	
	var _FormUtil2 = _interopRequireDefault(_FormUtil);
	
	var _SchemaForm2 = __webpack_require__(1456);
	
	var _SchemaForm3 = _interopRequireDefault(_SchemaForm2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleFormChange", "validateForm"];
	
	var SCHEDULE_FIELDS = ["enabled", "cron", "timezone", "startingDeadlineSeconds"];
	
	var DUPLICABLE_FIELDS_TO_WATCH = {};
	
	var FIELDS_TO_WATCH = {
	  runOnSchedule: {
	    forceUpdate: true
	  }
	};
	
	var JobForm = function (_SchemaForm) {
	  (0, _inherits3.default)(JobForm, _SchemaForm);
	
	  function JobForm() {
	    (0, _classCallCheck3.default)(this, JobForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobForm.__proto__ || (0, _getPrototypeOf2.default)(JobForm)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobForm, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.multipleDefinition = this.getNewDefinition();
	
	      this.props.getTriggerSubmit(this.handleExternalSubmit);
	    }
	  }, {
	    key: "shouldUpdateDefinition",
	    value: function shouldUpdateDefinition(changes, eventType, fieldName) {
	      var propKey = _FormUtil2.default.getPropKey(fieldName);
	      var blurChange = (0, _values2.default)(DUPLICABLE_FIELDS_TO_WATCH).some(function (item) {
	        return item.blurOnly && item.blurOnly.includes(propKey);
	      });
	
	      return (0, _keys2.default)(changes).some(function (changeKey) {
	        var tab = _FormUtil2.default.getProp(changeKey);
	
	        return tab in DUPLICABLE_FIELDS_TO_WATCH && DUPLICABLE_FIELDS_TO_WATCH[tab].fields.includes(propKey) && DUPLICABLE_FIELDS_TO_WATCH[tab].forceUpdate || fieldName in FIELDS_TO_WATCH && FIELDS_TO_WATCH[fieldName].forceUpdate;
	      }) || eventType === "blur" && blurChange;
	    }
	  }, {
	    key: "handleFormChange",
	    value: function handleFormChange(changes, eventObj) {
	      var eventType = eventObj.eventType,
	          fieldName = eventObj.fieldName;
	
	
	      if (!this.shouldUpdateDefinition(changes, eventType, fieldName)) {
	        return;
	      }
	
	      // Fetch the updated model from the <Form /> component
	      // nested deeper in the component tree.
	      this.model = this.triggerTabFormSubmit();
	
	      // Re-generate the definition in order to reset all errors.
	      // The first argument tells the `getNewDefinition` function to fuse
	      // the contents of the model into the definition.
	      this.multipleDefinition = this.getNewDefinition(this.model);
	
	      // Forward the onChange event to the parent
	      // The parent is responsible for updating the form with the new model
	      // in order to reflect the changes
	      this.props.onChange(this.getDataTriple());
	
	      // Force an update if we have clicked on the checkbox
	      if (eventObj.fieldName === "runOnSchedule") {
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: "handleTabClick",
	    value: function handleTabClick(tab) {
	      this.props.onTabChange(tab);
	    }
	  }, {
	    key: "validateForm",
	    value: function validateForm() {
	      var _this2 = this;
	
	      var isValidated = true;
	      this.model = this.triggerTabFormSubmit();
	      this.multipleDefinition = this.getNewDefinition(this.model);
	
	      // Apply all validations.
	      _FormUtil2.default.forEachDefinition(this.multipleDefinition, function (definition) {
	        definition.showError = false;
	
	        if (typeof definition.externalValidator !== "function") {
	          return;
	        }
	
	        var fieldValidated = definition.externalValidator(_this2.model, definition);
	        if (!fieldValidated) {
	          isValidated = false;
	        }
	      });
	
	      // Force an update only if we have changed validation state
	      if (this.isValidated !== isValidated) {
	        this.forceUpdate();
	      }
	
	      // Return validation status
	      this.isValidated = isValidated;
	
	      return isValidated;
	    }
	
	    // Fallback to props model, if provided model is not defined,
	    // i.e. more up to date
	
	  }, {
	    key: "getNewDefinition",
	    value: function getNewDefinition() {
	      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.model;
	
	      var multipleDefinition = (0, _get3.default)(JobForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(JobForm.prototype), "getNewDefinition", this).call(this);
	
	      var scheduleEnabled = model.schedule.runOnSchedule;
	      if (!scheduleEnabled) {
	        multipleDefinition.schedule.definition.forEach(function (definition) {
	          if (SCHEDULE_FIELDS.includes(definition.name)) {
	            definition.formElementClass = "hidden";
	            definition.value = null;
	          }
	        });
	      }
	
	      return multipleDefinition;
	    }
	  }]);
	  return JobForm;
	}(_SchemaForm3.default);
	
	JobForm.defaultProps = {
	  className: "multiple-form",
	  defaultTab: "",
	  getTriggerSubmit: function getTriggerSubmit() {},
	
	  isEdit: false,
	  onChange: function onChange() {},
	  onTabChange: function onTabChange() {},
	
	  schema: {}
	};
	
	JobForm.propTypes = {
	  className: _react2.default.PropTypes.string,
	  defaultTab: _react2.default.PropTypes.string,
	  isEdit: _react2.default.PropTypes.bool,
	  getTriggerSubmit: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func,
	  onTabChange: _react2.default.PropTypes.func,
	  schema: _react2.default.PropTypes.object
	};
	
	module.exports = JobForm;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _iconServiceDefaultSmall2x = __webpack_require__(1082);
	
	var _iconServiceDefaultSmall2x2 = _interopRequireDefault(_iconServiceDefaultSmall2x);
	
	var _FormUtil = __webpack_require__(1454);
	
	var _FormUtil2 = _interopRequireDefault(_FormUtil);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _SchemaFormUtil = __webpack_require__(1458);
	
	var _SchemaFormUtil2 = _interopRequireDefault(_SchemaFormUtil);
	
	var _SchemaUtil = __webpack_require__(1460);
	
	var _SchemaUtil2 = _interopRequireDefault(_SchemaUtil);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	var _TabForm = __webpack_require__(1461);
	
	var _TabForm2 = _interopRequireDefault(_TabForm);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getAddNewRowButton", "getRemoveRowButton", "getTriggerTabFormSubmit", "handleFormChange", "handleExternalSubmit", "handleTabClick", "validateForm"];
	
	var SchemaForm = function (_mixin) {
	  (0, _inherits3.default)(SchemaForm, _mixin);
	
	  function SchemaForm() {
	    (0, _classCallCheck3.default)(this, SchemaForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SchemaForm.__proto__ || (0, _getPrototypeOf2.default)(SchemaForm)).call(this));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.store_listeners = [];
	
	    _this.triggerSubmit = function () {};
	    _this.isValidated = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SchemaForm, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(SchemaForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(SchemaForm.prototype), "componentWillMount", this).apply(this, arguments);
	
	      if (this.props.definition) {
	        this.multipleDefinition = this.props.definition;
	      } else {
	        this.multipleDefinition = this.getNewDefinition();
	      }
	
	      if (this.props.model) {
	        this.model = this.props.model;
	        _SchemaFormUtil2.default.mergeModelIntoDefinition(this.model, this.multipleDefinition);
	      } else {
	        this.model = {};
	      }
	
	      this.props.getTriggerSubmit(this.handleExternalSubmit);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _get3.default)(SchemaForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(SchemaForm.prototype), "componentWillUnmount", this).apply(this, arguments);
	
	      // Unscheduled all validation if component unmounts.
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      (0, _get3.default)(SchemaForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(SchemaForm.prototype), "componentDidUpdate", this).apply(this, arguments);
	
	      // Timeout necessary due to modal content height updates on did mount
	      setTimeout(function () {
	        _ScrollbarUtil2.default.updateWithRef(_this2.refs.geminiForms);
	      });
	    }
	  }, {
	    key: "handleFormChange",
	    value: function handleFormChange(formData, eventObj) {
	      if (eventObj.eventType !== "blur") {
	        return;
	      }
	
	      this.validateForm();
	      this.props.onChange(this.getDataTriple());
	    }
	  }, {
	    key: "handleExternalSubmit",
	    value: function handleExternalSubmit() {
	      this.validateForm();
	
	      return this.getDataTriple();
	    }
	  }, {
	    key: "handleRemoveRow",
	    value: function handleRemoveRow(definition, prop, id) {
	      _FormUtil2.default.removePropID(definition, prop, id);
	      this.forceUpdate();
	    }
	  }, {
	    key: "handleTabClick",
	    value: function handleTabClick() {
	      // Default method.
	    }
	  }, {
	    key: "handleAddRow",
	    value: function handleAddRow(prop, definition, newDefinition, index) {
	      var propID = _Util2.default.uniqueID(prop);
	      newDefinition = _FormUtil2.default.getMultipleFieldDefinition(prop, propID, newDefinition, null, index);
	
	      var deleteButtonTop = (0, _values2.default)(definition.itemShapes || {}).some(function (itemShape) {
	        return itemShape.deleteButtonTop;
	      });
	
	      // Default to prepending.
	      var lastIndex = -1;
	      definition.forEach(function (field, i) {
	        if (_FormUtil2.default.isFieldInstanceOfProp(prop, field)) {
	          lastIndex = i;
	
	          return;
	        }
	
	        if (field.prop === prop) {
	          lastIndex = i - 1;
	        }
	      });
	
	      var arrayAction = "push";
	
	      if (deleteButtonTop) {
	        arrayAction = "unshift";
	      }
	      var title = null;
	      (0, _values2.default)(definition.itemShapes || {}).some(function (itemShape) {
	        if (itemShape.getTitle) {
	          title = itemShape.getTitle(lastIndex + 2);
	        }
	
	        return title;
	      });
	      newDefinition[arrayAction](this.getRemoveRowButton(definition, prop, propID, title));
	      definition.splice(lastIndex + 1, 0, newDefinition);
	
	      this.forceUpdate();
	    }
	  }, {
	    key: "getAddNewRowButton",
	    value: function getAddNewRowButton(prop, generalDefinition, definition) {
	      var labelText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	
	      var index = this.getIndexFromDefinition(generalDefinition);
	      var label = "Add New Line";
	
	      if (labelText !== "") {
	        label = labelText;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { prop: prop, key: prop + "-add-new-row" },
	        _react2.default.createElement(
	          "div",
	          { className: "row form-row-element" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "clickable row",
	              onClick: this.handleAddRow.bind(this, prop, generalDefinition, definition, index)
	            },
	            "+ ",
	            label
	          )
	        )
	      );
	    }
	  }, {
	    key: "getIndexFromDefinition",
	    value: function getIndexFromDefinition(definition) {
	      // This counts the number of arrays in the definition to determine
	      // the number of duplicable rows
	      return definition.reduce(function (total, item) {
	        if (Array.isArray(item)) {
	          return total + 1;
	        }
	
	        return total;
	      }, 0);
	    }
	  }, {
	    key: "getRemoveRowButton",
	    value: function getRemoveRowButton(generalDefinition, prop, id) {
	      var title = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      var deleteButton = _react2.default.createElement(
	        "div",
	        {
	          key: "" + prop + id + "-remove",
	          className: "form-row-element form-row-remove-button form-row-element-mixed-label-presence"
	        },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button-narrow button-link",
	            onClick: this.handleRemoveRow.bind(this, generalDefinition, prop, id)
	          },
	          _react2.default.createElement(_Icon2.default, { id: "close", size: "mini" })
	        )
	      );
	
	      if (!title) {
	        return deleteButton;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          key: "" + prop + id + "-title",
	          className: "form-row-element duplicable-row-title-wrapper"
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "duplicable-row-title-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "duplicable-row-title" },
	            title
	          )
	        ),
	        deleteButton
	      );
	    }
	  }, {
	    key: "getDataTriple",
	    value: function getDataTriple() {
	      return {
	        isValidated: this.isValidated,
	        model: _SchemaFormUtil2.default.processFormModel(this.model, this.multipleDefinition),
	        definition: this.multipleDefinition
	      };
	    }
	  }, {
	    key: "getNewDefinition",
	    value: function getNewDefinition() {
	      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.model;
	      var schema = this.props.schema;
	
	      var definition = _SchemaUtil2.default.schemaToMultipleDefinition({
	        schema: schema,
	        renderSubheader: this.getSubHeader,
	        renderLabel: this.getLabel,
	        renderRemove: this.getRemoveRowButton,
	        renderAdd: this.getAddNewRowButton
	      });
	
	      if (model) {
	        _SchemaFormUtil2.default.mergeModelIntoDefinition(model, definition, this.getRemoveRowButton);
	      }
	
	      return definition;
	    }
	  }, {
	    key: "getTriggerTabFormSubmit",
	    value: function getTriggerTabFormSubmit(submitTrigger) {
	      this.triggerTabFormSubmit = submitTrigger;
	    }
	  }, {
	    key: "validateForm",
	    value: function validateForm() {
	      var _this3 = this;
	
	      var schema = this.props.schema;
	      var isValidated = true;
	
	      this.model = this.triggerTabFormSubmit();
	      // Reset the definition in order to reset all errors.
	      this.multipleDefinition = this.getNewDefinition();
	      var model = _SchemaFormUtil2.default.processFormModel(this.model, this.multipleDefinition);
	
	      _SchemaFormUtil2.default.validateModelWithSchema(model, schema).forEach(function (error) {
	        var path = error.path;
	        var obj = _SchemaFormUtil2.default.getDefinitionFromPath(_this3.multipleDefinition, path);
	
	        isValidated = false;
	        obj.showError = error.message;
	        obj.validationErrorText = error.message;
	      });
	
	      this.forceUpdate();
	      this.isValidated = isValidated;
	
	      return isValidated;
	    }
	  }, {
	    key: "getSubHeader",
	    value: function getSubHeader(name, description, levelsDeep) {
	      var tooltip = null;
	      var subtitle = null;
	      if (description && levelsDeep > 0) {
	        tooltip = _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: description,
	            wrapperClassName: "tooltip-wrapper flush-bottom short-top media-object-item",
	            wrapText: true,
	            maxWidth: 300
	          },
	          _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	        );
	      } else if (description && levelsDeep === 0) {
	        subtitle = _react2.default.createElement(
	          "p",
	          null,
	          description
	        );
	      }
	
	      var subheaderClasses = (0, _classnames2.default)({
	        h3: levelsDeep === 0,
	        h4: levelsDeep === 1,
	        h5: levelsDeep >= 2
	      }, "form-header form-row-element flush-bottom flush-top");
	
	      return _react2.default.createElement(
	        "div",
	        { className: "media-object-spacing-wrapper media-object-spacing-narrow" },
	        _react2.default.createElement(
	          "div",
	          { className: "media-object" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object-item" },
	            _react2.default.createElement(
	              "div",
	              { className: subheaderClasses },
	              name
	            ),
	            subtitle
	          ),
	          tooltip
	        )
	      );
	    }
	  }, {
	    key: "getLabel",
	    value: function getLabel(description, label, fieldType) {
	      var tooltip = _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        {
	          content: description,
	          wrapperClassName: "tooltip-wrapper media-object-item",
	          wrapText: true,
	          maxWidth: 300,
	          interactive: true
	        },
	        _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	      );
	
	      if (fieldType === "boolean") {
	        return _react2.default.createElement(
	          "span",
	          { className: "media-object-spacing-wrapper media-object-spacing-wrapper-inline media-object-spacing-narrow" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object media-object-inline" },
	            _react2.default.createElement(
	              "span",
	              { className: "media-object-item" },
	              label
	            ),
	            tooltip
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "label",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "media-object-spacing-wrapper media-object-spacing-narrow" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object media-object-inline" },
	            _react2.default.createElement(
	              "span",
	              { className: "media-object-item" },
	              label
	            ),
	            tooltip
	          )
	        )
	      );
	    }
	  }, {
	    key: "getFormHeader",
	    value: function getFormHeader() {
	      var _props = this.props,
	          packageIcon = _props.packageIcon,
	          packageName = _props.packageName,
	          packageVersion = _props.packageVersion;
	
	
	      if (!packageName || !packageIcon) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "modal-header modal-header-padding-narrow modal-header-bottom-border modal-header-white flex-no-shrink" },
	        _react2.default.createElement(
	          "div",
	          { className: "media-object-spacing-wrapper media-object-spacing-narrow media-object-offset" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object media-object-align-middle" },
	            _react2.default.createElement(
	              "div",
	              { className: "media-object-item" },
	              _react2.default.createElement(
	                "div",
	                { className: "icon icon-medium icon-image-container icon-app-container icon-default-white" },
	                _react2.default.createElement(_Image2.default, { fallbackSrc: _iconServiceDefaultSmall2x2.default, src: packageIcon })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "media-object-item" },
	              _react2.default.createElement(
	                "h4",
	                { className: "flush-top flush-bottom text-color-neutral" },
	                packageName
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "side-panel-resource-label" },
	                packageVersion
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "tab-form-wrapper" },
	        this.getFormHeader(),
	        _react2.default.createElement(_TabForm2.default, {
	          defaultTab: this.props.defaultTab,
	          definition: this.multipleDefinition,
	          formRowClass: "flex",
	          getTriggerSubmit: this.getTriggerTabFormSubmit,
	          onChange: this.handleFormChange,
	          onTabClick: this.handleTabClick
	        })
	      );
	    }
	  }]);
	  return SchemaForm;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _InternalStorageMixin2.default));
	
	SchemaForm.defaultProps = {
	  className: "multiple-form",
	  getTriggerSubmit: function getTriggerSubmit() {},
	  onChange: function onChange() {},
	
	  schema: {}
	};
	
	SchemaForm.propTypes = {
	  getTriggerSubmit: _react2.default.PropTypes.func,
	  schema: _react2.default.PropTypes.object,
	  packageIcon: _react2.default.PropTypes.string,
	  packageName: _react2.default.PropTypes.string,
	  packageVersion: _react2.default.PropTypes.string
	};
	
	module.exports = SchemaForm;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onImageError"];
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3.default)(this, Image);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).apply(this, arguments));
	
	    _this.state = {
	      imageErrorCount: 0
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(Image, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          src = _props.src,
	          fallbackSrc = _props.fallbackSrc;
	
	      var newSrc = void 0;
	      if (src !== nextProps.src) {
	        newSrc = nextProps.src;
	      }
	
	      if (src === nextProps.src && fallbackSrc !== nextProps.fallbackSrc) {
	        newSrc = nextProps.fallbackSrc;
	      }
	
	      // Try again if a new url was provided
	      if (newSrc) {
	        var image = _reactDom2.default.findDOMNode(this);
	        image.src = newSrc;
	        this.setState({ imageErrorCount: 0 });
	      }
	    }
	  }, {
	    key: "onImageError",
	    value: function onImageError(event) {
	      var fallbackSrc = this.props.fallbackSrc,
	          imageErrorCount = this.state.imageErrorCount;
	
	
	      if (imageErrorCount === 0) {
	        event.target.src = fallbackSrc;
	      }
	
	      // Both src and fallback failed
	      this.setState({ imageErrorCount: imageErrorCount + 1 });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          imageErrorCount = this.state.imageErrorCount;
	
	      var classes = (0, _dedupe2.default)({ hidden: imageErrorCount > 1 }, props.className);
	
	      return _react2.default.createElement("img", { src: props.src, className: classes, onError: this.onImageError });
	    }
	  }]);
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = {
	  src: _react2.default.PropTypes.string.isRequired,
	  fallbackSrc: _react2.default.PropTypes.string,
	
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = Image;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _tv = __webpack_require__(1459);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	var _FormUtil = __webpack_require__(1454);
	
	var _FormUtil2 = _interopRequireDefault(_FormUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filteredPaths(combinedPath) {
	  return combinedPath.split("/").filter(function (path) {
	    return path.length > 0;
	  });
	}
	
	function getErroredFieldPositions(definition) {
	  var fieldsWithError = [];
	
	  definition.forEach(function (rowDefinition, indexInForm) {
	    if (Array.isArray(rowDefinition)) {
	      rowDefinition.forEach(function (columnDefinition, indexInRow) {
	        var hasError = !!columnDefinition.showError;
	
	        if (hasError) {
	          fieldsWithError.push({
	            indexInForm: indexInForm,
	            indexInRow: indexInRow,
	            showError: columnDefinition.showError
	          });
	        }
	      });
	    }
	  });
	
	  return fieldsWithError;
	}
	
	function setDefinitionValue(thingToSet, definition, renderRemove, model) {
	  var path = thingToSet.path,
	      value = thingToSet.value;
	
	  var definitionToSet = SchemaFormUtil.getDefinitionFromPath(definition, path);
	
	  if (Array.isArray(value) && value.length !== 0) {
	    var prop = path[path.length - 1];
	
	    var firstIndex = 0;
	    definitionToSet.definition.find(function (field, i) {
	      if (_FormUtil2.default.isFieldInstanceOfProp(prop, field)) {
	        firstIndex = i;
	
	        return true;
	      }
	
	      return false;
	    });
	
	    var indexesToError = getErroredFieldPositions(definitionToSet.definition);
	
	    _FormUtil2.default.removePropID(definitionToSet.definition, prop);
	
	    value.forEach(function (item, index) {
	      // Use index for key, so we can re-use same key for same field,
	      // to not make react think it is a completely new field
	      var propID = _Util2.default.uniqueID(prop);
	      var instanceDefinition = _FormUtil2.default.getMultipleFieldDefinition(prop, propID, definitionToSet.definition.itemShapes[prop].definition, item, index);
	
	      if (definitionToSet.definition.itemShapes[prop].filterProperties) {
	        definitionToSet.definition.itemShapes[prop].filterProperties(item, instanceDefinition, model);
	      }
	
	      var arrayAction = "push";
	      if (definitionToSet.definition.itemShapes[prop].deleteButtonTop) {
	        arrayAction = "unshift";
	      }
	
	      var title = null;
	      if (definitionToSet.definition.itemShapes[prop].getTitle) {
	        title = definitionToSet.definition.itemShapes[prop].getTitle(index + 1);
	      }
	      instanceDefinition[arrayAction](renderRemove(definitionToSet.definition, prop, propID, title));
	      definitionToSet.definition.splice(firstIndex++, 0, instanceDefinition);
	    });
	
	    indexesToError.forEach(function (indexToError) {
	      var needsToError = definitionToSet.definition[indexToError.indexInForm];
	      if (needsToError) {
	        needsToError = needsToError[indexToError.indexInRow];
	        if (needsToError) {
	          needsToError.showError = indexToError.showError;
	        }
	      }
	    });
	  }
	
	  definitionToSet.value = value;
	  definitionToSet.startValue = value;
	
	  if (definitionToSet.filterProperties) {
	    definitionToSet.filterProperties(value, definitionToSet, model);
	  }
	}
	
	function getThingsToSet(model, path) {
	  path = path || [];
	  var thingsToSet = [];
	
	  if (Array.isArray(model)) {
	    thingsToSet.push({
	      path: path,
	      value: model
	    });
	
	    return thingsToSet;
	  }
	
	  (0, _keys2.default)(model).forEach(function (key) {
	    var pathCopy = path.concat([key]);
	    var value = model[key];
	
	    if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && value !== null) {
	      thingsToSet = thingsToSet.concat(getThingsToSet(value, pathCopy));
	    } else {
	      thingsToSet.push({
	        path: pathCopy,
	        value: value
	      });
	    }
	  });
	
	  return thingsToSet;
	}
	
	function processValue(value, valueType) {
	  if (valueType === "integer" || valueType === "number") {
	    if (value !== null && value !== "") {
	      var parsedNumber = Number(value);
	      if (isNaN(parsedNumber)) {
	        return value;
	      }
	
	      return parsedNumber;
	    }
	  }
	
	  if (valueType === "array" && !value) {
	    return [];
	  }
	
	  if (valueType === "array" && typeof value === "string") {
	    return value.split(",").map(function (val) {
	      return val.trim();
	    }).filter(function (val) {
	      return val !== "";
	    });
	  }
	
	  if (valueType === "boolean" && value == null) {
	    return false;
	  }
	
	  // Since values might be converted to null or empty strings
	  // when processing values, let's make this test last,
	  // i.e. after valueType checks
	  if (value == null || value === "") {
	    return null;
	  }
	
	  return value;
	}
	
	/**
	 * Recursive function to flatten the 'group' types
	 * in a definition.
	 *
	 * @param {object} definition - The input definition
	 * @returns {object} The flattened definition
	 */
	function unnestGroupsInDefinition(definition) {
	  var defClone = (0, _assign2.default)({}, definition);
	  if (defClone.properties == null) {
	    return defClone;
	  }
	
	  // Make sure we are operating on a cloned properties
	  defClone.properties = (0, _assign2.default)({}, defClone.properties);
	
	  // Import group children
	  (0, _keys2.default)(defClone.properties).forEach(function (propName) {
	    var prop = unnestGroupsInDefinition(defClone.properties[propName]);
	
	    // If we encountered a group in our properties,
	    // merge its properties in our properties
	    if (prop.type === "group") {
	      // Adopt properties
	      (0, _keys2.default)(prop.properties).forEach(function (propName) {
	        defClone.properties[propName] = prop.properties[propName];
	      });
	
	      // Adopt requirements
	      if (prop.required != null) {
	        defClone.required = defClone.required.concat(prop.required);
	      }
	
	      // Now that all the child properties of this group are
	      // merged in the present definition we don't need this
	      // empty group any more.
	      delete defClone.properties[propName];
	    }
	
	    // Update property
	    defClone.properties[propName] = prop;
	  });
	
	  return defClone;
	}
	
	/**
	 * Introduce custom validation function to tv4
	 */
	_tv2.default.defineKeyword("validator", function (data, validationFunction) {
	  //
	  // Call the validation function and return:
	  //
	  //  - null     : No error
	  //  - 'string' : The error description
	  //
	  return validationFunction(data);
	});
	
	/**
	 * The default tv4 error messages are quite bad.
	 * Here are a bit more user-friendly alternatives
	 *
	 * The default language is 'en-gb', so by setting
	 * the language to 'en-us' we are introducing our
	 * prettier version of error messages :)
	 */
	_tv2.default.addLanguage("en-us", {
	  // Generic errors
	  INVALID_TYPE: "Expecting a {expected} here",
	  ENUM_MISMATCH: "No enum match for: {value}",
	  ANY_OF_MISSING: "Data does not match any schemas from 'anyOf'",
	  ONE_OF_MISSING: "Data does not match any schemas from 'oneOf'",
	  ONE_OF_MULTIPLE: "Data is valid against more than one schema from 'oneOf': indices {index1} and {index2}",
	  NOT_PASSED: "Data matches schema from 'not'",
	
	  // Numeric errors
	  NUMBER_MULTIPLE_OF: "Must be a multiple of {multipleOf}",
	  NUMBER_MINIMUM: "Must be bigger than or equal to {minimum}",
	  NUMBER_MINIMUM_EXCLUSIVE: "Must be bigger than {minimum}",
	  NUMBER_MAXIMUM: "Must be smaller than or equal to {maximum}",
	  NUMBER_MAXIMUM_EXCLUSIVE: "Must be smaller than {maximum}",
	  NUMBER_NOT_A_NUMBER: "'{value}' is not a valid number",
	
	  // String errors
	  STRING_LENGTH_SHORT: "Too short! Must be at least {minimum} characters long",
	  STRING_LENGTH_LONG: "Too long! Must be less than {maximum} characters long",
	  STRING_PATTERN: "Not in the expected format. Consult the documentation.",
	
	  // Object errors
	  OBJECT_PROPERTIES_MINIMUM: "Too few properties defined ({propertyCount}), minimum {minimum}",
	  OBJECT_PROPERTIES_MAXIMUM: "Too many properties defined ({propertyCount}), maximum {maximum}",
	  OBJECT_REQUIRED: "Missing required property: {key}",
	  OBJECT_ADDITIONAL_PROPERTIES: "Additional properties not allowed",
	  OBJECT_DEPENDENCY_KEY: "Dependency failed - key must exist: {missing} (due to key: {key})",
	
	  // Array errors
	  ARRAY_LENGTH_SHORT: "Array is too short ({length}), minimum {minimum}",
	  ARRAY_LENGTH_LONG: "Array is too long ({length}), maximum {maximum}",
	  ARRAY_UNIQUE: "Array items are not unique (indices {match1} and {match2})",
	  ARRAY_ADDITIONAL_ITEMS: "Additional items not allowed",
	
	  // Format errors
	  FORMAT_CUSTOM: "{message}",
	  KEYWORD_CUSTOM: "{message}",
	
	  // Schema structure
	  CIRCULAR_REFERENCE: "Circular $refs: {urls}",
	
	  // Non-standard validation options
	  UNKNOWN_PROPERTY: "Unknown property (not in schema)"
	});
	
	// Set the new language we just defined
	_tv2.default.language("en-us");
	
	var SchemaFormUtil = {
	  /**
	   * Finds a specific field definition when a path is passed in.
	   *
	   * @param {Object} definition Definition to traverse to find the field definition.
	   * @param {Array} paths Array of the properties needed to lookup to get to
	   * definition.
	   *
	   * @return {Object} definition The definition that was found, or the
	   * definition before the dead end.
	   */
	  getDefinitionFromPath: function getDefinitionFromPath(definition, paths) {
	    if (definition[paths[0]]) {
	      definition = definition[paths[0]];
	      paths = paths.slice(1);
	    }
	
	    paths.forEach(function (path) {
	      if (definition.definition == null) {
	        return;
	      }
	
	      var nextDefinition = Array.prototype.concat.apply([], definition.definition).find(function (definitionField) {
	        return definitionField.name === path || definitionField.title === path;
	      });
	
	      if (nextDefinition) {
	        definition = nextDefinition;
	      }
	    });
	
	    return definition;
	  },
	
	
	  /**
	   * Converts a model to a model that conforms to form properties.
	   * For example, {cpu: '10'} will be converted to {cpu: 10} if the field 'cpu'
	   * requires a number. This also transforms duplicable props like
	   * 'ports[0].key' and 'ports[0].value' into the correct format.
	   *
	   * @param {Object} model Model to process.
	   * @param {Object} multipleDefinition Definition to look at to enforce value
	   * types.
	   * @param {Array} prevPath (This argument is for internal recursive use.)
	   * The paths taken to get to this model. Needed in order to find the
	   * definition paths taken for each field.
	   *
	   * @return {Object} model Model that is created from definition.
	   */
	  processFormModel: function processFormModel(model, multipleDefinition) {
	    var prevPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var newModel = {};
	
	    (0, _keys2.default)(model).forEach(function (key) {
	      var value = model[key];
	      var path = prevPath.concat([key]);
	
	      // Nested model.
	      if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && value !== null) {
	        newModel[key] = SchemaFormUtil.processFormModel(value, multipleDefinition, path);
	
	        return;
	      }
	
	      var definition = SchemaFormUtil.getDefinitionFromPath(multipleDefinition, path);
	      if (definition == null) {
	        return;
	      }
	
	      var isRequired = definition.isRequired,
	          valueType = definition.valueType;
	
	      var processedValue = processValue(value, valueType);
	      if (processedValue != null || isRequired) {
	        newModel[key] = processedValue;
	      }
	    });
	
	    return _FormUtil2.default.modelToCombinedProps(newModel);
	  },
	
	
	  /**
	   * Merges a model into a form definition. It puts all of the values in the
	   * field definition's 'value' property.
	   *
	   * @param {Object} model Model to merge into definition.
	   * @param {Object} definition Definition to receive values from model.
	   * @param {Array} renderRemove Function to call to render a remove button.
	   * This is necessary because the model might have multiple values, and if we
	   * create more field definitions, we need to render a remove button after it.
	   */
	  mergeModelIntoDefinition: function mergeModelIntoDefinition(model, definition, renderRemove) {
	    var thingsToSet = getThingsToSet(model);
	
	    thingsToSet.forEach(function (thingToSet) {
	      setDefinitionValue(thingToSet, definition, renderRemove, model);
	    });
	  },
	
	
	  /**
	   * Parses the error that comes back from tv4 in order for it to be easily
	   * consumable.
	   *
	   * @param {Object} tv4Error The error that comes from tv4 to parse.
	   *
	   * @return {Object} errorObj An error object. 'message' is the error message.
	   * 'path' is the path towards the value in the model.
	   */
	  parseTV4Error: function parseTV4Error(tv4Error) {
	    var errorObj = {
	      message: tv4Error.message,
	      path: filteredPaths(tv4Error.dataPath)
	    };
	
	    var schemaPath = tv4Error.schemaPath.split("/");
	
	    if (tv4Error.code === 302) {
	      errorObj.path.push(tv4Error.params.key);
	    }
	
	    if (schemaPath[schemaPath.length - 2] === "items") {
	      errorObj.path.pop();
	    }
	
	    return errorObj;
	  },
	
	
	  /**
	   * Validates the model against a schema. For example, it'll check if it's the
	   * correct shape, and that the value types are the same as stated in the
	   * schema.
	   *
	   * @param {Object} model The model to validate.
	   * @param {Object} schema The schema for the model to validate against.
	   *
	   * @return {Array} errorObjs Array of error objects. Each object consists of
	   * the properties 'message' and 'path'.
	   */
	  validateModelWithSchema: function validateModelWithSchema(model, schema) {
	    var result = _tv2.default.validateMultiple(model, unnestGroupsInDefinition(schema));
	
	    if (result == null || result.valid) {
	      return [];
	    }
	
	    return result.errors.map(function (error) {
	      return SchemaFormUtil.parseTV4Error(error);
	    });
	  }
	};
	
	module.exports = SchemaFormUtil;

/***/ },
/* 1459 */,
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FormUtil = __webpack_require__(1454);
	
	var _FormUtil2 = _interopRequireDefault(_FormUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getValueFromSchemaProperty(fieldProps) {
	  var value = "";
	
	  if (fieldProps.default != null) {
	    value = fieldProps.default;
	    if (typeof value === "number") {
	      value = value.toString();
	    }
	  }
	
	  if (Array.isArray(fieldProps.default) && fieldProps.default.length === 0) {
	    value = "";
	  }
	
	  return value;
	}
	
	function setLabelFromSchemaProperty(fieldName, fieldProps, isRequired, renderLabel, definition) {
	  var label = fieldProps.title || fieldName;
	
	  if (isRequired) {
	    label = label + " *";
	  }
	
	  if (renderLabel && fieldProps.description) {
	    label = renderLabel(fieldProps.description, label, fieldProps.type);
	  }
	
	  // Set the label property of checkboxes if a label is defined.
	  if (fieldProps.type === "boolean") {
	    definition.label = fieldProps.label || label;
	
	    return;
	  }
	
	  definition.showLabel = label;
	}
	
	function schemaToFieldDefinition(options) {
	  var fieldName = options.fieldName,
	      fieldProps = options.fieldProps,
	      formParent = options.formParent,
	      isRequired = options.isRequired,
	      renderLabel = options.renderLabel,
	      renderRemove = options.renderRemove;
	
	  var value = getValueFromSchemaProperty(fieldProps);
	
	  var definition = {
	    fieldType: "text",
	    focused: false,
	    name: fieldName,
	    placeholder: "",
	    isRequired: isRequired,
	    required: false,
	    showError: false,
	    writeType: "input",
	    validation: function validation() {
	      return true;
	    },
	
	    externalValidator: fieldProps.externalValidator,
	    value: value,
	    valueType: fieldProps.type
	  };
	
	  if (fieldProps.className != null) {
	    definition.labelClass = fieldProps.className;
	  }
	
	  setLabelFromSchemaProperty(fieldName, fieldProps, isRequired, renderLabel, definition);
	
	  if (typeof value === "boolean") {
	    definition.checked = value;
	  }
	
	  if (fieldProps.type === "number") {
	    definition.fieldType = "number";
	  }
	
	  if (fieldProps.focused) {
	    definition.focused = true;
	  }
	
	  if (fieldProps.fieldType === "select") {
	    definition.fieldType = "select";
	    definition.options = fieldProps.options;
	  }
	
	  if (fieldProps.helpBlock) {
	    definition.helpBlock = fieldProps.helpBlock;
	  }
	
	  if (fieldProps.type === "boolean") {
	    definition.fieldType = "checkbox";
	    definition.checked = fieldProps.default || false;
	  }
	
	  if (fieldProps.multiLine === true) {
	    definition.fieldType = "textarea";
	  }
	
	  if (fieldProps.formElementClass) {
	    definition.formElementClass = fieldProps.formElementClass;
	  }
	
	  if (fieldProps.inputClass) {
	    definition.inputClass = fieldProps.inputClass;
	  }
	
	  if (fieldProps.filterProperties) {
	    definition.filterProperties = fieldProps.filterProperties;
	  }
	
	  if (fieldProps.duplicable === true && fieldProps.itemShape) {
	    var itemShape = nestedSchemaToFieldDefinition({
	      fieldName: fieldName,
	      fieldProps: fieldProps.itemShape,
	      renderSubheader: renderLabel,
	      renderLabel: renderLabel,
	      filterProperties: fieldProps.filterProperties
	    });
	    var propID = _Util2.default.uniqueID(fieldName);
	
	    definition = _FormUtil2.default.getMultipleFieldDefinition(fieldName, propID, itemShape.definition);
	
	    if (fieldProps.filterProperties) {
	      itemShape.filterProperties = fieldProps.filterProperties;
	    }
	
	    if (fieldProps.getTitle) {
	      itemShape.getTitle = fieldProps.getTitle;
	    }
	
	    if (renderRemove) {
	      var arrayAction = "push";
	      if (fieldProps.deleteButtonTop) {
	        itemShape.deleteButtonTop = true;
	        arrayAction = "unshift";
	      }
	      var title = null;
	      if (itemShape.getTitle) {
	        title = itemShape.getTitle();
	      }
	
	      definition[arrayAction](renderRemove(formParent, fieldName, propID, title));
	    }
	
	    if (formParent.itemShapes == null) {
	      formParent.itemShapes = {};
	    }
	
	    formParent.itemShapes[fieldName] = itemShape;
	
	    return definition;
	  }
	
	  return definition;
	}
	
	function nestedSchemaToFieldDefinition(options) {
	  var fieldName = options.fieldName,
	      fieldProps = options.fieldProps,
	      renderSubheader = options.renderSubheader,
	      renderLabel = options.renderLabel,
	      filterProperties = options.filterProperties,
	      _options$levelsDeep = options.levelsDeep,
	      levelsDeep = _options$levelsDeep === undefined ? 0 : _options$levelsDeep;
	
	  var nestedDefinition = {
	    name: fieldName,
	    render: null,
	    fieldType: "object",
	    definition: []
	  };
	
	  if (typeof renderSubheader === "function") {
	    nestedDefinition.render = renderSubheader.bind(null, fieldName, fieldProps.description, levelsDeep);
	  }
	
	  var properties = fieldProps.properties;
	  var requiredProps = fieldProps.required;
	
	  (0, _keys2.default)(properties).forEach(function (nestedFieldName) {
	    var nestedPropertyValue = properties[nestedFieldName];
	    if (nestedPropertyValue.properties) {
	      nestedDefinition.definition.push(nestedSchemaToFieldDefinition({
	        fieldName: nestedFieldName,
	        fieldProps: nestedPropertyValue,
	        renderSubheader: renderSubheader,
	        renderLabel: renderLabel,
	        filterProperties: filterProperties,
	        levelsDeep: levelsDeep + 1
	      }));
	    } else {
	      nestedDefinition.definition.push(schemaToFieldDefinition({
	        fieldName: nestedFieldName,
	        fieldProps: nestedPropertyValue,
	        formParent: nestedDefinition.definition,
	        isRequired: requiredProps && requiredProps.indexOf(nestedFieldName) > -1,
	        renderLabel: renderLabel
	      }));
	    }
	  });
	
	  if (filterProperties) {
	    filterProperties({}, nestedDefinition.definition);
	  }
	
	  return nestedDefinition;
	}
	
	var SchemaUtil = {
	  /**
	   * Turns a JSON Schema into a Form definition.
	   *
	   * @param {Object} options Object containing properties for transforming a
	   * schema into a form definition. The following properties are:
	   * {Object} schema Schema to transform.
	   * {Function} renderSubheader Function used to render a subheader. We render subheaders for properties that are nested.
	   * {Function} renderLabel Function used to render a label.
	   * {Function} renderRemove Function used to render a remove button for duplicable rows.
	   * {Function} renderAdd Function used to render an add button for duplicable rows.
	   *
	   * @return {Object} multipleDefinition The form definition.
	   */
	  schemaToMultipleDefinition: function schemaToMultipleDefinition(options) {
	    var schema = options.schema,
	        renderSubheader = options.renderSubheader,
	        renderLabel = options.renderLabel,
	        renderRemove = options.renderRemove,
	        renderAdd = options.renderAdd;
	
	    var multipleDefinition = {};
	    var schemaProperties = schema.properties;
	
	    (0, _keys2.default)(schemaProperties).forEach(function (topLevelProp) {
	      var topLevelPropertyObject = schemaProperties[topLevelProp];
	      var secondLevelProperties = topLevelPropertyObject.properties || {};
	      var requiredProps = topLevelPropertyObject.required;
	      var definitionForm = multipleDefinition[topLevelProp] = {};
	
	      definitionForm.title = topLevelPropertyObject.title || topLevelProp;
	      definitionForm.selectValue = topLevelProp;
	      definitionForm.description = topLevelPropertyObject.description;
	      definitionForm.definition = [];
	      (0, _keys2.default)(secondLevelProperties).forEach(function (secondLevelProp) {
	        var secondLevelObject = secondLevelProperties[secondLevelProp];
	        var fieldDefinition = void 0;
	
	        if (secondLevelObject.type === "group" && secondLevelObject.properties != null) {
	          fieldDefinition = (0, _keys2.default)(secondLevelObject.properties).map(function (key) {
	            var field = secondLevelObject.properties[key];
	
	            return schemaToFieldDefinition({
	              fieldName: key,
	              fieldProps: field,
	              formParent: topLevelProp,
	              isRequired: requiredProps && requiredProps.indexOf(secondLevelProp) > -1,
	              renderLabel: renderLabel
	            });
	          });
	        } else if (secondLevelObject.properties == null) {
	          fieldDefinition = schemaToFieldDefinition({
	            fieldName: secondLevelProp,
	            fieldProps: secondLevelObject,
	            formParent: definitionForm.definition,
	            isRequired: requiredProps && requiredProps.indexOf(secondLevelProp) > -1,
	            renderLabel: renderLabel,
	            renderRemove: renderRemove
	          });
	        } else {
	          fieldDefinition = nestedSchemaToFieldDefinition({
	            fieldName: secondLevelProp,
	            fieldProps: secondLevelObject,
	            renderSubheader: renderSubheader,
	            renderLabel: renderLabel,
	            filterProperties: secondLevelObject.filterProperties
	          });
	        }
	
	        if (secondLevelObject.duplicable === true) {
	          var itemShape = nestedSchemaToFieldDefinition({
	            fieldName: secondLevelProp,
	            fieldProps: secondLevelObject.itemShape,
	            renderLabel: renderLabel,
	            filterProperties: secondLevelObject.filterProperties
	          });
	
	          if (secondLevelObject.title) {
	            definitionForm.definition.push(renderSubheader(secondLevelObject.title, secondLevelObject.description));
	          }
	          definitionForm.definition.push(fieldDefinition);
	
	          if (renderAdd) {
	            definitionForm.definition.push({
	              render: renderAdd.bind(null, secondLevelProp, definitionForm.definition, itemShape.definition, secondLevelProperties[secondLevelProp].addLabel),
	              prop: secondLevelProp
	            });
	          }
	
	          return;
	        }
	
	        definitionForm.definition.push(fieldDefinition);
	      });
	    });
	
	    return multipleDefinition;
	  },
	
	
	  /**
	   * Turns a form definition into a model.
	   *
	   * @param {Object} definition Form definition to convert to model.
	   *
	   * @return {Object} multipleDefinition The form definition.
	   */
	  definitionToJSONDocument: function definitionToJSONDocument(definition) {
	    var jsonDocument = {};
	
	    (0, _keys2.default)(definition).forEach(function (topLevelProp) {
	      var topLevelProperties = definition[topLevelProp];
	      var topLevelDefinition = jsonDocument[topLevelProp] = {};
	      var topLevelDefinitionValues = topLevelProperties.definition;
	
	      if (!topLevelDefinitionValues) {
	        return;
	      }
	
	      topLevelDefinitionValues.forEach(function (formDefinition) {
	        if (formDefinition.definition) {
	          var nested = topLevelDefinition[formDefinition.name] = {};
	          formDefinition.definition.forEach(function (nestedDefinition) {
	            var fieldName = nestedDefinition.name;
	            var fieldValue = nestedDefinition.value;
	            nested[fieldName] = fieldValue;
	          });
	        } else {
	          var fieldName = formDefinition.name;
	          var fieldValue = formDefinition.value;
	          topLevelDefinition[fieldName] = fieldValue;
	        }
	      });
	    });
	
	    return jsonDocument;
	  },
	
	
	  /**
	   * Checks to see if object is a valid JSON schema.
	   *
	   * @param {Object} schema Schema to validate.
	   *
	   * @return {Boolean} isValidSchema Whether the schema is valid.
	   */
	  validateSchema: function validateSchema(schema) {
	    try {
	      SchemaUtil.definitionToJSONDocument(SchemaUtil.schemaToMultipleDefinition({ schema: schema }));
	
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	};
	
	module.exports = SchemaUtil;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactGeminiScrollbar = __webpack_require__(1281);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	var _SideTabs = __webpack_require__(1462);
	
	var _SideTabs2 = _interopRequireDefault(_SideTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getTriggerSubmit", "handleFormError", "handleTabClick", "handleExternalSubmit"];
	
	var TabForm = function (_mixin) {
	  (0, _inherits3.default)(TabForm, _mixin);
	
	  function TabForm() {
	    (0, _classCallCheck3.default)(this, TabForm);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TabForm.__proto__ || (0, _getPrototypeOf2.default)(TabForm)).call(this));
	
	    _this.state = { currentTab: "", renderGemini: false };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.triggerSubmit = function () {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(TabForm, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.model = {};
	      this.submitMap = {};
	
	      var currentTab = this.props.defaultTab || (0, _keys2.default)(this.props.definition)[0];
	
	      this.setState({ currentTab: currentTab });
	      this.props.getTriggerSubmit(this.handleExternalSubmit);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      /* eslint-disable react/no-did-mount-set-state */
	      this.setState({ renderGemini: true });
	      /* eslint-enable react/no-did-mount-set-state */
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      // Timeout necessary due to modal content height updates on did mount
	      setTimeout(function () {
	        _ScrollbarUtil2.default.updateWithRef(_this2.refs.geminiForms);
	      });
	    }
	  }, {
	    key: "handleTabClick",
	    value: function handleTabClick(currentTab) {
	      var _props;
	
	      (_props = this.props).onTabClick.apply(_props, arguments);
	      this.setState({ currentTab: currentTab });
	    }
	  }, {
	    key: "handleFormError",
	    value: function handleFormError() {
	      this.internalStorage_update({ isFormValidated: false });
	    }
	  }, {
	    key: "handleFormSubmit",
	    value: function handleFormSubmit(formKey, formModel) {
	      this.model[formKey] = formModel;
	    }
	  }, {
	    key: "handleExternalSubmit",
	    value: function handleExternalSubmit() {
	      this.buildModel();
	
	      var _internalStorage_get = this.internalStorage_get(),
	          isFormValidated = _internalStorage_get.isFormValidated;
	
	      if (isFormValidated) {
	        this.props.onSubmit(this.model);
	
	        return this.model;
	      } else {
	        this.props.onError();
	
	        return false;
	      }
	    }
	  }, {
	    key: "buildModel",
	    value: function buildModel() {
	      var _this3 = this;
	
	      this.internalStorage_update({ isFormValidated: true });
	
	      (0, _keys2.default)(this.props.definition).forEach(function (formKey) {
	        _this3.submitMap[formKey]();
	      });
	    }
	  }, {
	    key: "getTriggerSubmit",
	    value: function getTriggerSubmit(formKey, triggerSubmit) {
	      this.submitMap[formKey] = triggerSubmit;
	    }
	  }, {
	    key: "getSubHeader",
	    value: function getSubHeader(name) {
	      return _react2.default.createElement(
	        "div",
	        { key: name },
	        _react2.default.createElement(
	          "div",
	          { className: "h3 form-row-element flush-bottom flush-top" },
	          name
	        )
	      );
	    }
	  }, {
	    key: "getLabel",
	    value: function getLabel(description, label) {
	      return _react2.default.createElement(
	        "label",
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "media-object-spacing-wrapper media-object-spacing-narrow" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object" },
	            _react2.default.createElement(
	              "span",
	              { className: "media-object-item" },
	              label
	            ),
	            _react2.default.createElement(
	              _reactjsComponents.Tooltip,
	              {
	                content: description,
	                interactive: true,
	                wrapperClassName: "tooltip-wrapper media-object-item",
	                wrapText: true,
	                maxWidth: 300
	              },
	              _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader(title, description) {
	      return _react2.default.createElement(
	        "div",
	        { key: title, className: "form-row-element" },
	        _react2.default.createElement(
	          "h2",
	          { className: "form-header flush-top short-bottom" },
	          title
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush-bottom" },
	          description
	        )
	      );
	    }
	  }, {
	    key: "getSideContent",
	    value: function getSideContent(multipleDefinition) {
	      var currentTab = this.state.currentTab;
	
	      var classes = (0, _dedupe2.default)("multiple-form-left-column", this.props.navigationContentClassNames);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        _react2.default.createElement(_SideTabs2.default, {
	          onTabClick: this.handleTabClick,
	          selectedTab: currentTab,
	          tabs: (0, _values2.default)(multipleDefinition)
	        })
	      );
	    }
	  }, {
	    key: "getFormPanels",
	    value: function getFormPanels() {
	      var _this4 = this;
	
	      var currentTab = this.state.currentTab;
	      var multipleDefinition = this.props.definition;
	      var multipleDefinitionClasses = (0, _dedupe2.default)("multiple-form-right-column", this.props.formContentClassNames);
	      var formRowClass = this.props.formRowClass;
	
	      var panels = (0, _keys2.default)(multipleDefinition).map(function (formKey, i) {
	        var formPanelClassSet = (0, _dedupe2.default)("form-panel", {
	          hidden: currentTab !== formKey
	        });
	
	        var _multipleDefinition$f = multipleDefinition[formKey],
	            definition = _multipleDefinition$f.definition,
	            description = _multipleDefinition$f.description,
	            title = _multipleDefinition$f.title;
	
	        var formDefinition = [{
	          render: _this4.getHeader.bind(_this4, title, description)
	        }].concat(definition);
	
	        var formRowClassSet = (0, _dedupe2.default)("row", formRowClass, formKey);
	
	        return _react2.default.createElement(
	          "div",
	          { key: i, className: formPanelClassSet },
	          _react2.default.createElement(_reactjsComponents.Form, {
	            formGroupClass: "form-group flush",
	            formRowClass: formRowClassSet,
	            definition: formDefinition,
	            triggerSubmit: _this4.getTriggerSubmit.bind(_this4, formKey),
	            onChange: _this4.props.onChange,
	            onError: _this4.handleFormError,
	            onSubmit: _this4.handleFormSubmit.bind(_this4, formKey),
	            useExternalErrors: true
	          })
	        );
	      });
	
	      // On initial render, we don't want to render with Gemini because it will
	      // cancel the parent's animation, due to it measuring the component.
	      if (!this.state.renderGemini) {
	        return _react2.default.createElement(
	          "div",
	          { className: multipleDefinitionClasses },
	          panels
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactGeminiScrollbar2.default,
	        {
	          autoshow: true,
	          className: multipleDefinitionClasses,
	          ref: "geminiForms"
	        },
	        panels
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classNameSet = (0, _dedupe2.default)("multiple-form", this.props.className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classNameSet },
	        this.getSideContent(this.props.definition),
	        this.getFormPanels()
	      );
	    }
	  }]);
	  return TabForm;
	}((0, _reactjsMixin2.default)(_InternalStorageMixin2.default));
	
	TabForm.defaultProps = {
	  defaultTab: "",
	  getTriggerSubmit: function getTriggerSubmit() {},
	  onChange: function onChange() {},
	  onError: function onError() {},
	  onSubmit: function onSubmit() {},
	  onTabClick: function onTabClick() {}
	};
	
	var classPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	TabForm.propTypes = {
	  className: classPropType,
	  defaultTab: _react2.default.PropTypes.string,
	  definition: _react2.default.PropTypes.object.isRequired,
	  formContentClassNames: classPropType,
	  formRowClass: classPropType,
	  getTriggerSubmit: _react2.default.PropTypes.func,
	  navigationContentClassNames: classPropType,
	  onError: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func,
	  onSubmit: _react2.default.PropTypes.func,
	  onTabClick: _react2.default.PropTypes.func
	};
	
	module.exports = TabForm;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SideTabs = function (_React$Component) {
	  (0, _inherits3.default)(SideTabs, _React$Component);
	
	  function SideTabs() {
	    (0, _classCallCheck3.default)(this, SideTabs);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SideTabs.__proto__ || (0, _getPrototypeOf2.default)(SideTabs)).call(this));
	
	    _this.state = {
	      dropdownOpen: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SideTabs, [{
	    key: "handleTabClick",
	    value: function handleTabClick(title) {
	      var dropdownOpen = this.state.dropdownOpen,
	          _props = this.props,
	          onTabClick = _props.onTabClick,
	          selectedTab = _props.selectedTab;
	
	
	      if (title === selectedTab) {
	        this.setState({ dropdownOpen: !dropdownOpen });
	      } else {
	        this.setState({ dropdownOpen: false });
	      }
	      // Trigger on both open and close to make sure to trigger gemini update
	      onTabClick(title);
	    }
	  }, {
	    key: "getSelectedTabTitle",
	    value: function getSelectedTabTitle(selectedTab, tabs) {
	      var selectedTabDefinition = tabs.find(function (tab) {
	        return tab.selectValue === selectedTab;
	      });
	
	      if (selectedTabDefinition) {
	        return selectedTabDefinition.title;
	      }
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          selectedTab = _props2.selectedTab,
	          tabs = _props2.tabs;
	
	
	      return tabs.map(function (tab, index) {
	        var title = tab.title,
	            selectValue = tab.selectValue,
	            definition = tab.definition;
	
	        // Check if at least one field has errors
	
	        var hasErrors = definition && definition.reduce(function (lastErrors, field) {
	          return lastErrors || !!field.showError;
	        }, false);
	
	        // Prepare classes
	        var classes = (0, _classnames2.default)("multiple-form-modal-sidebar-menu-item clickable visible-block", {
	          selected: selectValue === selectedTab || title === selectedTab,
	          "has-errors": hasErrors
	        });
	
	        return _react2.default.createElement(
	          "li",
	          {
	            className: classes,
	            key: index,
	            onClick: _this2.handleTabClick.bind(_this2, selectValue)
	          },
	          title
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          selectedTab = _props3.selectedTab,
	          tabs = _props3.tabs,
	          dropdownOpen = this.state.dropdownOpen;
	
	
	      var classes = (0, _classnames2.default)("list-unstyled multiple-form-modal-sidebar-menu", {
	        "is-hidden": !dropdownOpen
	      });
	
	      var caretClasses = (0, _classnames2.default)("caret caret--desc caret--visible", {
	        dropup: dropdownOpen
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        _react2.default.createElement(
	          "span",
	          {
	            className: "multiple-form-modal-sidebar-menu-item multiple-form-modal-sidebar-collapsed-header clickable visible-mini",
	            onClick: this.handleTabClick.bind(this, selectedTab)
	          },
	          this.getSelectedTabTitle(selectedTab, tabs),
	          _react2.default.createElement("span", { className: caretClasses })
	        ),
	        _react2.default.createElement(
	          "ul",
	          { className: classes },
	          this.getTabs()
	        )
	      );
	    }
	  }]);
	  return SideTabs;
	}(_react2.default.Component);
	
	SideTabs.defaultProps = {
	  className: "multiple-form-modal-sidebar-tabs",
	  onTabClick: function onTabClick() {},
	
	  tabs: []
	};
	
	SideTabs.propTypes = {
	  className: _react2.default.PropTypes.string,
	  onTabClick: _react2.default.PropTypes.func,
	  selectedTab: _react2.default.PropTypes.string,
	  tabs: _react2.default.PropTypes.array
	};
	
	module.exports = SideTabs;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: DCOS-7747 Move this method as well as `createFormModelFromSchema` into
	// the SchemaUtil and refactor it accordingly.
	var getMatchingProperties = function getMatchingProperties(job, item) {
	  return (0, _keys2.default)(item).reduce(function (memo, subItem) {
	    if (item[subItem].type === "group") {
	      (0, _keys2.default)(item[subItem].properties).forEach(function (key) {
	        memo[key] = item[subItem].properties[key].default;
	
	        if (item[subItem].properties[key].getter && !!item[subItem].properties[key].getter(job)) {
	          memo[key] = item[subItem].properties[key].getter(job);
	        }
	      });
	
	      return memo;
	    }
	
	    if (item[subItem].type === "object") {
	      memo[subItem] = getMatchingProperties(job, item[subItem].properties);
	
	      return memo;
	    }
	
	    memo[subItem] = item[subItem].default;
	
	    if (item[subItem].getter) {
	      memo[subItem] = item[subItem].getter(job);
	    }
	
	    return memo;
	  }, {});
	};
	
	var JobUtil = {
	  createJobFromFormModel: function createJobFromFormModel(formModel) {
	    var spec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (formModel == null) {
	      return new _Job2.default();
	    }
	
	    var _formModel$general = formModel.general,
	        general = _formModel$general === undefined ? {
	      id: null
	    } : _formModel$general,
	        _formModel$labels = formModel.labels,
	        labels = _formModel$labels === undefined ? {} : _formModel$labels,
	        docker = formModel.docker,
	        docker_parameters = formModel.docker_parameters,
	        schedule = formModel.schedule;
	
	
	    spec.id = general.id;
	    spec.description = general.description;
	
	    if (labels != null && labels.items != null) {
	      spec.labels = labels.items.reduce(function (memo, _ref) {
	        var key = _ref.key,
	            value = _ref.value;
	
	        if (key == null) {
	          return memo;
	        }
	
	        // The 'undefined' value is not rendered by the JSON.stringify,
	        // so make sure empty environment variables are not left unrendered
	        memo[key] = value || "";
	
	        return memo;
	      }, {});
	    }
	
	    spec.run = (0, _assign2.default)(spec.run || {}, {
	      cmd: general.cmd,
	      cpus: general.cpus,
	      mem: general.mem,
	      disk: general.disk
	    });
	
	    if (docker && docker.image) {
	      (0, _assign2.default)(spec.run, { docker: docker });
	      if (docker_parameters != null && docker_parameters.items != null) {
	        spec.run.docker.parameters = docker_parameters.items;
	      } else {
	        spec.run.docker.parameters = [];
	      }
	    }
	
	    // default values for id and policy
	    var scheduleId = "default";
	    var schedulePolicy = "ALLOW";
	    // preserve id and concurrencyPolicy
	    if (Array.isArray(spec.schedules) && spec.schedules.length > 0) {
	      scheduleId = spec.schedules[0].id;
	      schedulePolicy = spec.schedules[0].concurrencyPolicy;
	    }
	
	    // Reset schedules
	    spec.schedules = [];
	
	    // Only transfer schedule if checkbox is set, and create job with reasonable
	    // defaults
	    if (!schedule || schedule.runOnSchedule) {
	      var _ref2 = schedule || {},
	          _ref2$id = _ref2.id,
	          id = _ref2$id === undefined ? scheduleId : _ref2$id,
	          _ref2$enabled = _ref2.enabled,
	          enabled = _ref2$enabled === undefined ? true : _ref2$enabled,
	          cron = _ref2.cron,
	          timezone = _ref2.timezone,
	          _ref2$concurrencyPoli = _ref2.concurrencyPolicy,
	          concurrencyPolicy = _ref2$concurrencyPoli === undefined ? schedulePolicy : _ref2$concurrencyPoli,
	          startingDeadlineSeconds = _ref2.startingDeadlineSeconds;
	
	      spec.schedules.push({
	        id: id,
	        enabled: enabled,
	        cron: cron,
	        timezone: timezone,
	        concurrencyPolicy: concurrencyPolicy,
	        startingDeadlineSeconds: startingDeadlineSeconds
	      });
	    }
	
	    return new _Job2.default(spec);
	  },
	  createFormModelFromSchema: function createFormModelFromSchema(schema) {
	    var job = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Job2.default();
	
	    return getMatchingProperties(job, schema.properties);
	  },
	  createJobSpecFromJob: function createJobSpecFromJob(job) {
	    var spec = JSON.parse((0, _stringify2.default)(job));
	
	    spec.id = job.getId() || null;
	    spec.description = job.getDescription();
	
	    spec.run = (0, _assign2.default)(spec.run || {}, {
	      cmd: job.getCommand(),
	      cpus: job.getCpus(),
	      mem: job.getMem(),
	      disk: job.getDisk()
	    });
	
	    var labels = job.getLabels();
	    if ((0, _keys2.default)(labels).length > 0) {
	      spec.labels = labels;
	    }
	
	    var docker = job.getDocker();
	
	    if (docker.image) {
	      (0, _assign2.default)(spec.run, { docker: docker });
	
	      var parameters = job.getParameters();
	      spec.run.docker.parameters = parameters;
	    }
	
	    var _job$getSchedules = job.getSchedules(),
	        _job$getSchedules2 = (0, _slicedToArray3.default)(_job$getSchedules, 1),
	        schedule = _job$getSchedules2[0];
	
	    if (schedule) {
	      var _schedule$id = schedule.id,
	          id = _schedule$id === undefined ? "default" : _schedule$id,
	          _schedule$enabled = schedule.enabled,
	          enabled = _schedule$enabled === undefined ? true : _schedule$enabled,
	          cron = schedule.cron,
	          timezone = schedule.timezone,
	          _schedule$concurrency = schedule.concurrencyPolicy,
	          concurrencyPolicy = _schedule$concurrency === undefined ? "ALLOW" : _schedule$concurrency,
	          startingDeadlineSeconds = schedule.startingDeadlineSeconds;
	      // Transfer schedule as with reasonable defaults
	
	      spec.schedules = [{
	        id: id,
	        enabled: enabled,
	        cron: cron,
	        timezone: timezone,
	        concurrencyPolicy: concurrencyPolicy,
	        startingDeadlineSeconds: startingDeadlineSeconds
	      }];
	    } else {
	      spec.schedules = [];
	    }
	
	    return spec;
	  }
	};
	
	module.exports = JobUtil;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Docker = __webpack_require__(1465);
	
	var _Docker2 = _interopRequireDefault(_Docker);
	
	var _General = __webpack_require__(1466);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _Labels = __webpack_require__(1469);
	
	var _Labels2 = _interopRequireDefault(_Labels);
	
	var _Schedule = __webpack_require__(1470);
	
	var _Schedule2 = _interopRequireDefault(_Schedule);
	
	var _Parameters = __webpack_require__(1471);
	
	var _Parameters2 = _interopRequireDefault(_Parameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var JobSchema = {
	  type: "object",
	  properties: {
	    general: _General2.default,
	    schedule: _Schedule2.default,
	    docker: _Docker2.default,
	    docker_parameters: _Parameters2.default,
	    labels: _Labels2.default
	  },
	  required: ["general"]
	};
	/* eslint-enable no-unused-vars */
	
	module.exports = JobSchema;

/***/ },
/* 1465 */
/***/ function(module, exports) {

	"use strict";
	
	var General = {
	  title: "Docker Container",
	  description: "Configure your job settings",
	  type: "object",
	  properties: {
	    image: {
	      title: "Image",
	      description: "Name of your Docker image",
	      type: "string",
	      getter: function getter(job) {
	        return job.getDocker().image;
	      }
	    },
	    privileged: {
	      type: "boolean",
	      description: "Run this docker image in privileged mode",
	      getter: function getter(job) {
	        return job.getDocker().privileged;
	      }
	    }
	  },
	  required: []
	};
	
	module.exports = General;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JobValidatorUtil = __webpack_require__(1467);
	
	var _JobValidatorUtil2 = _interopRequireDefault(_JobValidatorUtil);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _MesosConstants = __webpack_require__(1468);
	
	var _MesosConstants2 = _interopRequireDefault(_MesosConstants);
	
	var _JobResources = __webpack_require__(1219);
	
	var _JobResources2 = _interopRequireDefault(_JobResources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var General = {
	  title: "General",
	  description: "Configure your job settings",
	  type: "object",
	  properties: {
	    id: {
	      focused: true,
	      title: "ID",
	      description: "The job ID",
	      type: "string",
	      getter: function getter(job) {
	        return job.getId();
	      },
	      externalValidator: function externalValidator(_ref, definition) {
	        var general = _ref.general;
	
	        if (!_JobValidatorUtil2.default.isValidJobID(general.id)) {
	          definition.showError = "ID must not be empty, must not contain " + "whitespace, and should not contain any other characters than " + 'lowercase letters, digits, hyphens, ".", and ".."';
	
	          return false;
	        }
	
	        return true;
	      }
	    },
	    description: {
	      title: "Description",
	      description: "Job description",
	      type: "string",
	      getter: function getter(job) {
	        return job.getDescription();
	      }
	    },
	    resources: {
	      type: "group",
	      properties: {
	        cpus: {
	          title: "CPUs",
	          default: _JobResources2.default.DEFAULT_CPUS,
	          description: "The amount of CPUs the job requires",
	          type: "number",
	          getter: function getter(job) {
	            return "" + job.getCpus();
	          },
	          externalValidator: function externalValidator(_ref2, definition) {
	            var general = _ref2.general;
	
	            if (!_ValidatorUtil2.default.isNumberInRange(general.cpus, {
	              min: _MesosConstants2.default.MIN_CPUS
	            })) {
	              definition.showError = "CPUs must be a number at least equal to " + _MesosConstants2.default.MIN_CPUS;
	
	              return false;
	            }
	
	            return true;
	          }
	        },
	        mem: {
	          title: "Mem (MiB)",
	          default: _JobResources2.default.DEFAULT_MEM,
	          type: "number",
	          getter: function getter(job) {
	            return "" + job.getMem();
	          },
	          externalValidator: function externalValidator(_ref3, definition) {
	            var general = _ref3.general;
	
	            if (!_ValidatorUtil2.default.isNumberInRange(general.mem, {
	              min: _MesosConstants2.default.MIN_MEM
	            })) {
	              definition.showError = "Mem must be a number and at least " + _MesosConstants2.default.MIN_MEM + " MiB";
	
	              return false;
	            }
	
	            return true;
	          }
	        },
	        disk: {
	          title: "Disk (MiB)",
	          default: _JobResources2.default.DEFAULT_DISK,
	          type: "number",
	          getter: function getter(job) {
	            return "" + job.getDisk();
	          },
	          externalValidator: function externalValidator(_ref4, definition) {
	            var general = _ref4.general;
	
	            if (_ValidatorUtil2.default.isDefined(general.disk) && !_ValidatorUtil2.default.isNumberInRange(general.disk)) {
	              definition.showError = "Disk must be a positive number";
	
	              return false;
	            }
	
	            return true;
	          }
	        }
	      }
	    },
	    cmd: {
	      title: "Command",
	      description: "The command executed by the service",
	      type: "string",
	      multiLine: true,
	      getter: function getter(job) {
	        return job.getCommand();
	      }
	    }
	  },
	  required: ["id"]
	}; /* eslint-disable no-unused-vars */
	
	
	module.exports = General;

/***/ },
/* 1467 */
/***/ function(module, exports) {

	"use strict";
	
	var JobValidatorUtil = {
	  isValidJobID: function isValidJobID(serviceID) {
	    if (typeof serviceID !== "string" || serviceID === "") {
	      return false;
	    }
	
	    // This RegExp is taken from the metronome schema definition:
	    // https://github.com/dcos/metronome/blob/master/api/src/main/resources/public/api/v1/schema/jobspec.schema.json
	    var metronomeIdPattern = /^([a-z0-9]([a-z0-9-]*[a-z0-9]+)*)([.][a-z0-9]([a-z0-9-]*[a-z0-9]+)*)*$/;
	
	    return metronomeIdPattern.test(serviceID);
	  },
	  isValidCronSchedule: function isValidCronSchedule(cronString) {
	    if (typeof cronString !== "string" || cronString === "") {
	      return false;
	    }
	
	    // Expect exactly 5 components
	    var components = cronString.split(" ");
	    if (components.length !== 5) {
	      return false;
	    }
	
	    // Make sure each component contains valid characters
	    var cronComponentPattern = /^[0-9*]+([0-9\-,/*])*$/;
	
	    return components.every(function (component) {
	      return cronComponentPattern.test(component);
	    });
	  }
	};
	
	module.exports = JobValidatorUtil;

/***/ },
/* 1468 */
/***/ function(module, exports) {

	"use strict";
	
	var MesosConstants = {
	  // Minimum number of cpus per offer.
	  MIN_CPUS: 0.01,
	  // Minimum amount of memory per offer.
	  MIN_MEM: 32
	};
	
	module.exports = MesosConstants;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Labels = {
	  type: "object",
	  title: "Labels",
	  description: "Attach metadata to jobs to expose additional information to other jobs.",
	  properties: {
	    items: {
	      type: "array",
	      duplicable: true,
	      addLabel: "Add Label",
	      getter: function getter(job) {
	        var labels = job.getLabels() || {};
	
	        return (0, _keys2.default)(labels).map(function (key) {
	          return {
	            key: key,
	            value: labels[key]
	          };
	        });
	      },
	
	      itemShape: {
	        properties: {
	          key: {
	            title: "Label Name",
	            type: "string"
	          },
	          value: {
	            title: "Label Value",
	            type: "string"
	          }
	        }
	      }
	    }
	  }
	};
	
	module.exports = Labels;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JobValidatorUtil = __webpack_require__(1467);
	
	var _JobValidatorUtil2 = _interopRequireDefault(_JobValidatorUtil);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var Schedule = {
	  title: "Schedule",
	  description: "Set time and date for the job to run",
	  type: "object",
	  properties: {
	    runOnSchedule: {
	      label: "Run on a schedule",
	      showLabel: true,
	      title: "Run on a schedule",
	      type: "boolean",
	      getter: function getter(job) {
	        var _job$getSchedules = job.getSchedules(),
	            _job$getSchedules2 = (0, _slicedToArray3.default)(_job$getSchedules, 1),
	            schedule = _job$getSchedules2[0];
	
	        return schedule != null;
	      }
	    },
	    cron: {
	      title: "CRON Schedule",
	      helpBlock: _react2.default.createElement(
	        "span",
	        null,
	        "Use cron format to set your schedule, e.g. ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "0 0 20 * *"
	        ),
	        ". ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: _MetadataStore2.default.buildDocsURI("/usage/jobs/getting-started"),
	            target: "_blank"
	          },
	          "View documentation"
	        ),
	        "."
	      ),
	      type: "string",
	      getter: function getter(job) {
	        var _job$getSchedules3 = job.getSchedules(),
	            _job$getSchedules4 = (0, _slicedToArray3.default)(_job$getSchedules3, 1),
	            _job$getSchedules4$ = _job$getSchedules4[0],
	            schedule = _job$getSchedules4$ === undefined ? {} : _job$getSchedules4$;
	
	        return schedule.cron;
	      },
	      externalValidator: function externalValidator(_ref, definition) {
	        var schedule = _ref.schedule;
	
	        if (!schedule.runOnSchedule) {
	          return true;
	        }
	
	        if (!_JobValidatorUtil2.default.isValidCronSchedule(schedule.cron)) {
	          definition.showError = "CRON Schedule must not be empty and it must " + "follow the correct CRON format specifications";
	
	          return false;
	        }
	
	        return true;
	      }
	    },
	    timezone: {
	      title: "Time Zone",
	      description: _react2.default.createElement(
	        "span",
	        null,
	        "Enter time zone in ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "http://www.timezoneconverter.com/cgi-bin/zonehelp",
	            target: "_blank"
	          },
	          "TZ format"
	        ),
	        ", e.g. America/New_York."
	      ),
	      type: "string",
	      getter: function getter(job) {
	        var _job$getSchedules5 = job.getSchedules(),
	            _job$getSchedules6 = (0, _slicedToArray3.default)(_job$getSchedules5, 1),
	            _job$getSchedules6$ = _job$getSchedules6[0],
	            schedule = _job$getSchedules6$ === undefined ? {} : _job$getSchedules6$;
	
	        return schedule.timezone;
	      }
	    },
	    startingDeadlineSeconds: {
	      title: "Starting Deadline",
	      description: "Time in seconds to start the job if it misses " + "scheduled time for any reason. Missed jobs executions will be " + "counted as failed ones.",
	      type: "number",
	      getter: function getter(job) {
	        var _job$getSchedules7 = job.getSchedules(),
	            _job$getSchedules8 = (0, _slicedToArray3.default)(_job$getSchedules7, 1),
	            _job$getSchedules8$ = _job$getSchedules8[0],
	            schedule = _job$getSchedules8$ === undefined ? {} : _job$getSchedules8$;
	
	        return schedule.startingDeadlineSeconds;
	      },
	      externalValidator: function externalValidator(_ref2, definition) {
	        var schedule = _ref2.schedule;
	
	        if (!schedule.runOnSchedule) {
	          return true;
	        }
	
	        if (!_ValidatorUtil2.default.isDefined(schedule.startingDeadlineSeconds)) {
	          return true;
	        }
	
	        if (!_ValidatorUtil2.default.isNumberInRange(schedule.startingDeadlineSeconds)) {
	          definition.showError = "Expecting a positive number here";
	
	          return true;
	        }
	
	        return true;
	      }
	    },
	    enabled: {
	      label: "Enabled",
	      showLabel: true,
	      title: "Enabled",
	      type: "boolean",
	      getter: function getter(job) {
	        var _job$getSchedules9 = job.getSchedules(),
	            _job$getSchedules10 = (0, _slicedToArray3.default)(_job$getSchedules9, 1),
	            _job$getSchedules10$ = _job$getSchedules10[0],
	            schedule = _job$getSchedules10$ === undefined ? {} : _job$getSchedules10$;
	
	        return schedule.enabled !== undefined ? schedule.enabled : false;
	      }
	    }
	  },
	  required: ["cron"]
	};
	/* eslint-enable no-unused-vars */
	
	module.exports = Schedule;

/***/ },
/* 1471 */
/***/ function(module, exports) {

	"use strict";
	
	var Parameters = {
	  type: "object",
	  title: "Docker Parameters",
	  description: "Add runtime parameters to a docker job run.",
	  properties: {
	    items: {
	      type: "array",
	      duplicable: true,
	      addLabel: "Add Parameter",
	      getter: function getter(job) {
	        return job.getParameters() || [];
	      },
	
	      itemShape: {
	        properties: {
	          key: {
	            title: "Parameter Name",
	            type: "string"
	          },
	          value: {
	            title: "Parameter Value",
	            type: "string"
	          }
	        }
	      }
	    }
	  }
	};
	
	module.exports = Parameters;

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleButton = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    (0, _classCallCheck3.default)(this, ToggleButton);
	    return (0, _possibleConstructorReturn3.default)(this, (ToggleButton.__proto__ || (0, _getPrototypeOf2.default)(ToggleButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToggleButton, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          checkboxClassName = _props.checkboxClassName,
	          checked = _props.checked,
	          children = _props.children,
	          className = _props.className,
	          onChange = _props.onChange;
	
	
	      var textClassName = { muted: !checked };
	
	      return _react2.default.createElement(
	        "label",
	        { className: (0, _classnames2.default)(className) },
	        _react2.default.createElement("input", {
	          className: (0, _classnames2.default)(checkboxClassName),
	          checked: checked,
	          name: "checkbox",
	          onChange: onChange,
	          type: "checkbox"
	        }),
	        _react2.default.createElement(
	          "span",
	          { className: (0, _classnames2.default)(textClassName) },
	          children
	        )
	      );
	    }
	  }]);
	  return ToggleButton;
	}(_react2.default.Component);
	
	ToggleButton.defaultProps = {
	  checked: false,
	  onChange: function onChange() {},
	
	  checkboxClassName: "toggle-button"
	};
	
	ToggleButton.propTypes = {
	  checked: _react2.default.PropTypes.bool,
	  children: _react2.default.PropTypes.node,
	  onChange: _react2.default.PropTypes.func,
	
	  checkboxClassName: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = ToggleButton;

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(1106);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CollapsingString = __webpack_require__(1474);
	
	var _CollapsingString2 = _interopRequireDefault(_CollapsingString);
	
	var _CheckboxTable = __webpack_require__(1475);
	
	var _CheckboxTable2 = _interopRequireDefault(_CheckboxTable);
	
	var _ExpandingTable = __webpack_require__(1476);
	
	var _ExpandingTable2 = _interopRequireDefault(_ExpandingTable);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _JobStates = __webpack_require__(1477);
	
	var _JobStates2 = _interopRequireDefault(_JobStates);
	
	var _JobStopRunModal = __webpack_require__(1478);
	
	var _JobStopRunModal2 = _interopRequireDefault(_JobStopRunModal);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columnClasses = {
	  checkbox: "job-run-history-table-column-checkbox",
	  jobID: "job-run-history-table-column-id",
	  status: "job-run-history-table-column-status",
	  startedAt: "job-run-history-table-column-started",
	  finishedAt: "job-run-history-table-column-finished",
	  runTime: "job-run-history-table-column-run-time"
	};
	
	var METHODS_TO_BIND = ["renderJobIDColumn", "handleItemCheck", "handleStopClick", "handleStopJobRunModalClose", "handleStopJobRunSuccess"];
	
	function calculateRunTime(startedAt, finishedAt) {
	  if (finishedAt == null) {
	    return null;
	  }
	
	  return finishedAt - startedAt;
	}
	
	var JobRunHistoryTable = function (_React$Component) {
	  (0, _inherits3.default)(JobRunHistoryTable, _React$Component);
	
	  function JobRunHistoryTable() {
	    (0, _classCallCheck3.default)(this, JobRunHistoryTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobRunHistoryTable.__proto__ || (0, _getPrototypeOf2.default)(JobRunHistoryTable)).apply(this, arguments));
	
	    _this.state = {
	      checkedItems: {},
	      isStopRunModalShown: null
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobRunHistoryTable, [{
	    key: "handleItemCheck",
	    value: function handleItemCheck(idsChecked) {
	      var checkedItems = {};
	
	      idsChecked.forEach(function (id) {
	        checkedItems[id] = true;
	      });
	      this.setState({ checkedItems: checkedItems });
	    }
	  }, {
	    key: "handleStopClick",
	    value: function handleStopClick() {
	      this.setState({ isStopRunModalShown: true });
	    }
	  }, {
	    key: "handleStopJobRunModalClose",
	    value: function handleStopJobRunModalClose() {
	      this.setState({ isStopRunModalShown: false });
	    }
	  }, {
	    key: "handleStopJobRunSuccess",
	    value: function handleStopJobRunSuccess() {
	      this.setState({ checkedItems: {}, isStopRunModalShown: false });
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { className: columnClasses.checkbox }),
	        _react2.default.createElement("col", { className: columnClasses.jobID }),
	        _react2.default.createElement("col", { className: columnClasses.status }),
	        _react2.default.createElement("col", { className: columnClasses.startedAt }),
	        _react2.default.createElement("col", { className: columnClasses.finishedAt }),
	        _react2.default.createElement("col", { className: columnClasses.runTime })
	      );
	    }
	  }, {
	    key: "getColumnHeading",
	    value: function getColumnHeading(prop, order, sortBy) {
	      var _classNames;
	
	      var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", prop === sortBy.prop), _classNames));
	
	      var headingStrings = {
	        jobID: "Job ID",
	        status: "Status",
	        startedAt: "Started",
	        finishedAt: "Finished",
	        runTime: "Run Time"
	      };
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        headingStrings[prop],
	        _react2.default.createElement("span", { className: caretClassNames })
	      );
	    }
	  }, {
	    key: "getColumnClassName",
	    value: function getColumnClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)(columnClasses[prop], {
	        active: prop === sortBy.prop,
	        clickable: row == null
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "jobID",
	        render: this.renderJobIDColumn,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "status",
	        render: this.renderStatusColumn,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "startedAt",
	        render: this.renderTimeColumn,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "finishedAt",
	        render: this.renderTimeColumn,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "runTime",
	        render: this.renderRunTimeColumn,
	        sortable: true
	      }];
	    }
	
	    // TODO: DCOS-7766 Revisit this pre-rendering data transformation...
	
	  }, {
	    key: "getData",
	    value: function getData(job) {
	      var jobRuns = job.getJobRuns();
	
	      return jobRuns.getItems().map(function (jobRun) {
	        var children = jobRun.getTasks().getItems().map(function (jobTask) {
	          var startedAt = jobTask.getDateStarted();
	          var finishedAt = jobTask.getDateCompleted();
	          var runTime = calculateRunTime(startedAt, finishedAt);
	
	          return {
	            taskID: jobTask.getTaskID(),
	            status: jobTask.getStatus(),
	            startedAt: startedAt,
	            finishedAt: finishedAt,
	            runTime: runTime
	          };
	        });
	
	        var startedAt = jobRun.getDateCreated();
	        var finishedAt = jobRun.getDateFinished();
	        var runTime = calculateRunTime(startedAt, finishedAt);
	
	        return {
	          finishedAt: jobRun.getDateFinished(),
	          id: jobRun.id,
	          jobID: jobRun.getJobID(),
	          startedAt: jobRun.getDateCreated(),
	          status: jobRun.getStatus(),
	          runTime: runTime,
	          children: children
	        };
	      });
	    }
	  }, {
	    key: "getDisabledItemsMap",
	    value: function getDisabledItemsMap(job) {
	      return job.getJobRuns().getItems().reduce(function (memo, jobRun) {
	        var isDisabled = ["ACTIVE", "INITIAL", "STARTING"].indexOf(jobRun.getStatus()) < 0;
	        memo[jobRun.get("id")] = isDisabled;
	
	        return memo;
	      }, {});
	    }
	  }, {
	    key: "getStopButton",
	    value: function getStopButton(hasCheckedTasks) {
	      if (!hasCheckedTasks) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "button button-stroke button-danger",
	            onClick: this.handleStopClick
	          },
	          "Stop"
	        )
	      );
	    }
	  }, {
	    key: "getStopRunModal",
	    value: function getStopRunModal(checkedItems, hasCheckedTasks) {
	      if (!hasCheckedTasks) {
	        return null;
	      }
	
	      var isStopRunModalShown = this.state.isStopRunModalShown;
	
	      var jobRuns = (0, _keys2.default)(checkedItems);
	
	      return _react2.default.createElement(_JobStopRunModal2.default, {
	        jobID: this.props.job.getId(),
	        selectedItems: jobRuns,
	        onClose: this.handleStopJobRunModalClose,
	        onSuccess: this.handleStopJobRunSuccess,
	        open: isStopRunModalShown
	      });
	    }
	  }, {
	    key: "renderJobIDColumn",
	    value: function renderJobIDColumn(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (!rowOptions.isParent) {
	        var taskID = row.taskID;
	        var id = this.props.job.getId();
	
	        return _react2.default.createElement(
	          "div",
	          { className: "expanding-table-primary-cell-heading text-overflow" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: "table-cell-link-secondary text-overflow",
	              to: "/jobs/detail/" + id + "/tasks/" + taskID,
	              title: taskID
	            },
	            _react2.default.createElement(_CollapsingString2.default, { endLength: 15, string: taskID })
	          )
	        );
	      }
	
	      var cellContent = _react2.default.createElement(
	        "span",
	        { className: "table-cell-flex-box" },
	        _react2.default.createElement(_Icon2.default, {
	          className: "icon-margin-right table-cell-icon",
	          color: "grey",
	          id: "page-document",
	          size: "mini"
	        }),
	        _react2.default.createElement(_CollapsingString2.default, {
	          endLength: 15,
	          string: row[prop],
	          wrapperClassName: "collapsing-string table-cell-value"
	        })
	      );
	
	      if (row.children && row.children.length > 0) {
	        var classes = (0, _classnames2.default)("expanding-table-primary-cell is-expandable", {
	          "is-expanded": rowOptions.isExpanded
	        });
	        var clickHandler = rowOptions.clickHandler;
	
	
	        return _react2.default.createElement(
	          "div",
	          { className: classes, onClick: clickHandler },
	          cellContent
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "expanding-table-primary-cell" },
	        cellContent
	      );
	    }
	  }, {
	    key: "renderStatusColumn",
	    value: function renderStatusColumn(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (rowOptions.isParent) {
	        var _status = _JobStates2.default[row[prop]];
	        var _statusClasses = (0, _classnames2.default)({
	          "text-success": _status.stateTypes.includes("success") && !_status.stateTypes.includes("failure"),
	          "text-danger": _status.stateTypes.includes("failure"),
	          "text-neutral": _status.stateTypes.includes("active")
	        });
	
	        return _react2.default.createElement(
	          "span",
	          { className: _statusClasses },
	          _status.displayName
	        );
	      }
	
	      var status = _TaskStates2.default[row[prop]];
	      var statusClasses = (0, _classnames2.default)({
	        "text-success": status.stateTypes.includes("success") && !status.stateTypes.includes("failure"),
	        "text-danger": status.stateTypes.includes("failure")
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: statusClasses },
	        status.displayName
	      );
	    }
	  }, {
	    key: "renderRunTimeColumn",
	    value: function renderRunTimeColumn(prop, row) {
	      var time = row[prop];
	
	      if (time == null) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          "N/A"
	        );
	      }
	      var runTimeFormat = _moment2.default.duration(time).humanize();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        runTimeFormat
	      );
	    }
	  }, {
	    key: "renderTimeColumn",
	    value: function renderTimeColumn(prop, row) {
	      return _react2.default.createElement(_TimeAgo2.default, { time: row[prop], autoUpdate: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var job = this.props.job;
	      var checkedItems = this.state.checkedItems;
	
	      var disabledItems = this.getDisabledItemsMap(job);
	      var totalRunCount = job.getJobRuns().getItems().length;
	      var rightAlignLastNChildren = 0;
	      var hasCheckedTasks = false;
	
	      // Remove all disabled items from the checkedItems.
	      checkedItems = (0, _keys2.default)(checkedItems).reduce(function (filteredItems, key) {
	        if (!disabledItems[key]) {
	          filteredItems[key] = checkedItems[key];
	          hasCheckedTasks = true;
	        }
	
	        return filteredItems;
	      }, {});
	
	      if (hasCheckedTasks) {
	        rightAlignLastNChildren = 1;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _FilterBar2.default,
	          { rightAlignLastNChildren: rightAlignLastNChildren },
	          _react2.default.createElement(_FilterHeadline2.default, {
	            currentLength: totalRunCount,
	            name: "Run",
	            onReset: function onReset() {},
	            totalLength: totalRunCount
	          }),
	          this.getStopButton(hasCheckedTasks)
	        ),
	        _react2.default.createElement(_ExpandingTable2.default, {
	          allowMultipleSelect: false,
	          className: "expanding-table table table-hover table-borderless-outer table-borderless-inner-columns flush-bottom",
	          childRowClassName: "expanding-table-child",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          data: this.getData(job),
	          getColGroup: this.getColGroup,
	          uniqueProperty: "id",
	          checkedItemsMap: this.state.checkedItems,
	          disabledItemsMap: disabledItems,
	          onCheckboxChange: this.handleItemCheck,
	          sortOrder: "desc",
	          sortProp: "startedAt",
	          tableComponent: _CheckboxTable2.default
	        }),
	        this.getStopRunModal(checkedItems, hasCheckedTasks)
	      );
	    }
	  }]);
	  return JobRunHistoryTable;
	}(_react2.default.Component);
	
	JobRunHistoryTable.propTypes = {
	  params: _react2.default.PropTypes.object
	};
	
	module.exports = JobRunHistoryTable;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["updateDimensions"];
	
	var CollapsingString = function (_React$Component) {
	  (0, _inherits3.default)(CollapsingString, _React$Component);
	
	  function CollapsingString() {
	    (0, _classCallCheck3.default)(this, CollapsingString);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CollapsingString.__proto__ || (0, _getPrototypeOf2.default)(CollapsingString)).apply(this, arguments));
	
	    _this.state = {
	      collapsed: false,
	      parentWidth: null,
	      stringWidth: null
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CollapsingString, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (global != null) {
	        global.addEventListener("resize", this.updateDimensions);
	        global.addEventListener("focus", this.updateDimensions);
	      }
	
	      this.updateDimensions();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateDimensions();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (global != null) {
	        global.removeEventListener("resize", this.updateDimensions);
	        global.removeEventListener("focus", this.updateDimensions);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.parentWidth === null) {
	        return false;
	      }
	
	      return !(0, _deepEqual2.default)(this.state, nextState) || !(0, _deepEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: "getParentWidth",
	    value: function getParentWidth() {
	      var parent = null;
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (node == null) {
	        return 0;
	      }
	
	      if (this.props.parentSelector != null) {
	        parent = _DOMUtils2.default.closest(node, this.props.parentSelector);
	      } else {
	        parent = node.parentNode;
	      }
	
	      if (parent == null) {
	        parent = global.document.body;
	      }
	
	      return _DOMUtils2.default.getComputedWidth(parent);
	    }
	  }, {
	    key: "getStringWidth",
	    value: function getStringWidth() {
	      if (this.refs.fullString) {
	        return _DOMUtils2.default.getComputedWidth(this.refs.fullString);
	      }
	
	      return null;
	    }
	  }, {
	    key: "shouldCollapse",
	    value: function shouldCollapse(parentWidth, stringWidth) {
	      if (parentWidth == null || stringWidth == null) {
	        return false;
	      }
	
	      return stringWidth > parentWidth;
	    }
	  }, {
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      var parentWidth = this.getParentWidth();
	
	      // Return early if the parent width is 0, or the string isn't collapsed
	      // and the parent is growing.
	      if (parentWidth === 0 || this.state.parentWidth != null && parentWidth >= this.state.parentWidth && !this.state.collapsed) {
	        return;
	      }
	
	      // Return early if the string is collapsed and the parent is shrinking.
	      if (this.state.parentWidth != null && parentWidth <= this.state.parentWidth && this.state.collapsed) {
	        return;
	      }
	
	      var stringWidth = null;
	
	      if (this.refs.fullString != null) {
	        stringWidth = this.getStringWidth();
	      }
	
	      this.setState({
	        collapsed: this.shouldCollapse(parentWidth, stringWidth),
	        parentWidth: parentWidth,
	        stringWidth: stringWidth
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var fullString = this.props.string;
	      var endLength = this.props.endLength;
	      var stringEnding = null;
	
	      if (endLength == null) {
	        endLength = Math.floor(fullString.length * 1 / 3);
	      }
	
	      if (this.state.collapsed) {
	        stringEnding = _react2.default.createElement(
	          "span",
	          { className: this.props.truncatedStringEndClassName },
	          fullString.substring(fullString.length - endLength)
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: this.props.wrapperClassName, title: fullString },
	        _react2.default.createElement(
	          "span",
	          { className: this.props.fullStringClassName, ref: "fullString" },
	          fullString
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: this.props.truncatedWrapperClassName },
	          _react2.default.createElement(
	            "span",
	            { className: this.props.truncatedStringStartClassName },
	            fullString
	          ),
	          stringEnding
	        )
	      );
	    }
	  }]);
	  return CollapsingString;
	}(_react2.default.Component);
	
	CollapsingString.defaultProps = {
	  fullStringClassName: "collapsing-string-full-string",
	  truncatedStringEndClassName: "collapsing-string-truncated-end",
	  truncatedStringStartClassName: "collapsing-string-truncated-start",
	  truncatedWrapperClassName: "collapsing-string-truncated-wrapper",
	  wrapperClassName: "collapsing-string"
	};
	
	CollapsingString.propTypes = {
	  // The number of characters to keep visible at the end of the string.
	  endLength: _react2.default.PropTypes.number,
	  fullStringClassName: _react2.default.PropTypes.string,
	  // The selector for the parent whose width should be referenced. By default,
	  // the node's direct parent will be used.
	  parentSelector: _react2.default.PropTypes.string,
	  string: _react2.default.PropTypes.string.isRequired,
	  truncatedStringEndClassName: _react2.default.PropTypes.string,
	  truncatedStringStartClassName: _react2.default.PropTypes.string,
	  truncatedWrapperClassName: _react2.default.PropTypes.string,
	  wrapperClassName: _react2.default.PropTypes.string
	};
	
	module.exports = CollapsingString;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PropTypes = _react2.default.PropTypes;
	
	var METHODS_TO_BIND = ["getTableRowOptions", "handleCheckboxChange", "handleHeadingCheckboxChange", "renderCheckbox", "renderHeadingCheckbox"];
	
	var CheckboxTable = function (_React$Component) {
	  (0, _inherits3.default)(CheckboxTable, _React$Component);
	
	  function CheckboxTable() {
	    (0, _classCallCheck3.default)(this, CheckboxTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxTable.__proto__ || (0, _getPrototypeOf2.default)(CheckboxTable)).call(this));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CheckboxTable, [{
	    key: "handleCheckboxChange",
	    value: function handleCheckboxChange(prevCheckboxState, eventObject) {
	      var _props = this.props,
	          allowMultipleSelect = _props.allowMultipleSelect,
	          checkedItemsMap = _props.checkedItemsMap,
	          onCheckboxChange = _props.onCheckboxChange;
	
	      var isChecked = eventObject.fieldValue;
	      var rowID = eventObject.fieldName;
	      var checkedIDs = void 0;
	
	      if (isChecked) {
	        checkedIDs = (0, _keys2.default)(checkedItemsMap);
	        if (!allowMultipleSelect) {
	          checkedIDs = [rowID];
	        } else {
	          checkedIDs.push(rowID);
	        }
	      } else {
	        delete checkedItemsMap[rowID];
	        checkedIDs = (0, _keys2.default)(checkedItemsMap);
	      }
	
	      onCheckboxChange(checkedIDs);
	    }
	  }, {
	    key: "handleHeadingCheckboxChange",
	    value: function handleHeadingCheckboxChange(prevCheckboxState, eventObject) {
	      var isChecked = eventObject.fieldValue;
	      this.bulkCheck(isChecked);
	    }
	  }, {
	    key: "bulkCheck",
	    value: function bulkCheck(isChecked) {
	      var checkedIDs = [];
	      var _props2 = this.props,
	          data = _props2.data,
	          onCheckboxChange = _props2.onCheckboxChange,
	          uniqueProperty = _props2.uniqueProperty,
	          disabledItemsMap = _props2.disabledItemsMap;
	
	
	      data = data.filter(function (datum) {
	        return !disabledItemsMap[datum[uniqueProperty]];
	      });
	
	      if (isChecked) {
	        data.forEach(function (datum) {
	          checkedIDs.push(datum[uniqueProperty]);
	        });
	
	        return onCheckboxChange(checkedIDs);
	      }
	
	      onCheckboxChange(checkedIDs);
	    }
	  }, {
	    key: "getLabelClass",
	    value: function getLabelClass() {
	      return (0, _classnames2.default)("form-row-element form-element-checkbox", this.props.labelClass);
	    }
	  }, {
	    key: "renderHeadingCheckbox",
	    value: function renderHeadingCheckbox() {
	      var checked = false;
	      var indeterminate = false;
	      var _props3 = this.props,
	          allowMultipleSelect = _props3.allowMultipleSelect,
	          checkedItemsMap = _props3.checkedItemsMap,
	          disabledItemsMap = _props3.disabledItemsMap,
	          data = _props3.data;
	
	
	      if (!allowMultipleSelect) {
	        return null;
	      }
	
	      var checkedCount = (0, _keys2.default)(checkedItemsMap).length;
	      var disabledCount = (0, _keys2.default)(disabledItemsMap).length;
	
	      if (checkedCount > 0) {
	        indeterminate = true;
	      } else {
	        checked = false;
	      }
	
	      if (disabledCount + checkedCount === data.length && checkedCount !== 0) {
	        checked = true;
	        indeterminate = false;
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Form, {
	        className: "table-form-checkbox",
	        formGroupClass: "form-group flush-bottom",
	        definition: [{
	          checked: checked,
	          value: checked,
	          fieldType: "checkbox",
	          indeterminate: indeterminate,
	          labelClass: this.getLabelClass(),
	          name: "headingCheckbox",
	          showLabel: false
	        }],
	        onChange: this.handleHeadingCheckboxChange
	      });
	    }
	  }, {
	    key: "renderCheckbox",
	    value: function renderCheckbox(prop, row) {
	      var _props4 = this.props,
	          checkedItemsMap = _props4.checkedItemsMap,
	          disabledItemsMap = _props4.disabledItemsMap,
	          uniqueProperty = _props4.uniqueProperty;
	
	      var rowID = row[uniqueProperty];
	
	      if (disabledItemsMap[rowID]) {
	        return null;
	      }
	
	      var checked = false;
	
	      if (checkedItemsMap[rowID]) {
	        checked = true;
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Form, {
	        className: "table-form-checkbox",
	        formGroupClass: "form-group flush-bottom",
	        definition: [{
	          checked: checked,
	          value: checked,
	          fieldType: "checkbox",
	          labelClass: this.getLabelClass(),
	          name: rowID,
	          showLabel: false
	        }],
	        onChange: this.handleCheckboxChange
	      });
	    }
	  }, {
	    key: "getTableRowOptions",
	    value: function getTableRowOptions(row) {
	      var _props5 = this.props,
	          checkedItemsMap = _props5.checkedItemsMap,
	          inactiveItemsMap = _props5.inactiveItemsMap,
	          uniqueProperty = _props5.uniqueProperty;
	
	      // Override the key from index to our task ID to help React know, which
	      // row was rendered where and make its optimizations
	
	      var rowAttributes = {
	        key: row[uniqueProperty]
	      };
	
	      if (inactiveItemsMap[row[uniqueProperty]]) {
	        return (0, _assign2.default)(rowAttributes, { className: "inactive" });
	      }
	
	      if (checkedItemsMap[row[uniqueProperty]]) {
	        return (0, _assign2.default)(rowAttributes, { className: "selected" });
	      }
	
	      return rowAttributes;
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = _ResourceTableUtil2.default.getClassName;
	
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "selected",
	        render: this.renderCheckbox,
	        sortable: false,
	        heading: this.renderHeadingCheckbox
	      }].concat(this.props.columns);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props6 = this.props,
	          className = _props6.className,
	          data = _props6.data,
	          getColGroup = _props6.getColGroup,
	          sortOrder = _props6.sortOrder,
	          sortProp = _props6.sortProp;
	
	      var columns = this.getColumns();
	
	      var tableClassSet = (0, _classnames2.default)("table table-borderless-outer table-borderless-inner-columns table-hover", "flush-bottom", className);
	
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        buildRowOptions: this.getTableRowOptions,
	        className: tableClassSet,
	        columns: columns,
	        colGroup: getColGroup(),
	        containerSelector: ".gm-scroll-view",
	        data: data,
	        itemHeight: _TableUtil2.default.getRowHeight(),
	        sortBy: { prop: sortProp, order: sortOrder }
	      });
	    }
	  }]);
	  return CheckboxTable;
	}(_react2.default.Component);
	
	CheckboxTable.propTypes = {
	  checkedItemsMap: PropTypes.object,
	  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  columns: PropTypes.array,
	  data: PropTypes.array,
	  disabledItemsMap: PropTypes.object,
	  inactiveItemsMap: PropTypes.object,
	  getColGroup: PropTypes.func,
	  labelClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  onCheckboxChange: PropTypes.func,
	  sortProp: PropTypes.string,
	  sortOrder: PropTypes.string,
	  uniqueProperty: PropTypes.string.isRequired
	};
	
	CheckboxTable.defaultProps = {
	  allowMultipleSelect: true,
	  checkedItemsMap: {},
	  columns: [],
	  data: [],
	  disabledItemsMap: {},
	  inactiveItemsMap: {},
	  getColGroup: function getColGroup() {},
	
	  labelClass: {},
	  onCheckboxChange: function onCheckboxChange() {},
	
	  sortOrder: "asc"
	};
	
	module.exports = CheckboxTable;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WHITESPACE = "\xA0";
	
	var ExpandingTable = function (_React$Component) {
	  (0, _inherits3.default)(ExpandingTable, _React$Component);
	
	  function ExpandingTable(props) {
	    (0, _classCallCheck3.default)(this, ExpandingTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ExpandingTable.__proto__ || (0, _getPrototypeOf2.default)(ExpandingTable)).call(this, props));
	
	    var initialState = { expandedRows: {} };
	
	    if (props.expandRowsByDefault) {
	      initialState = props.data.reduce(function (memo, row) {
	        memo.expandedRows[row.id] = true;
	
	        return memo;
	      }, { expandedRows: {} });
	    }
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  (0, _createClass3.default)(ExpandingTable, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // Check for new rows and expand them if expandRowsByDefault is true.
	      if (nextProps.expandRowsByDefault) {
	        var shouldSetState = false;
	        var nextExpandedRows = this.state.expandedRows;
	
	        nextProps.data.forEach(function (row) {
	          if (nextExpandedRows[row.id] == null) {
	            shouldSetState = true;
	            nextExpandedRows[row.id] = true;
	          }
	        });
	
	        if (shouldSetState) {
	          this.setState({ expandedRows: nextExpandedRows });
	        }
	      }
	    }
	  }, {
	    key: "defaultRenderer",
	    value: function defaultRenderer(prop, row) {
	      return row[prop];
	    }
	  }, {
	    key: "expandRow",
	    value: function expandRow(row) {
	      var expandedRows = (0, _assign2.default)({}, this.state.expandedRows);
	      var rowID = this.getRowID(row);
	
	      // If the selected row is already expanded, then we want to collapse it.
	      if (expandedRows[rowID]) {
	        expandedRows[rowID] = false;
	      } else {
	        expandedRows[rowID] = true;
	      }
	
	      this.setState({ expandedRows: expandedRows });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns(columns) {
	      var _this2 = this;
	
	      // Replace the #render method on each column.
	      return columns.map(function (column) {
	        return (0, _assign2.default)({}, column, { render: _this2.getRenderer(column) });
	      });
	    }
	  }, {
	    key: "getRenderer",
	    value: function getRenderer(column) {
	      var _this3 = this;
	
	      // Get the column's #render method if it exists. Otherwise use our default.
	      var renderFn = column.render || this.defaultRenderer;
	      var expandAll = this.props.expandAll;
	
	
	      return function (prop, row) {
	        var hasChildren = !!row.children;
	        var isExpanded = !!_this3.state.expandedRows[_this3.getRowID(row)] || expandAll;
	
	        // Render the column's top-level item.
	        var cellContent = [_react2.default.createElement(
	          "div",
	          { key: -1 },
	          renderFn(prop, row, {
	            hasChildren: hasChildren,
	            isExpanded: isExpanded,
	            isParent: true,
	            clickHandler: _this3.expandRow.bind(_this3, row)
	          })
	        )];
	
	        // If there are children, and the expanded row ID matches this row, then
	        // render all children. We need to render a whitespace character if the
	        // property is undefined to retain proper spacing.
	        if (hasChildren && isExpanded) {
	          cellContent = cellContent.concat(row.children.map(function (child, childIndex) {
	            var cellValue = renderFn(prop, child, { isParent: false });
	
	            if (cellValue == null) {
	              cellValue = WHITESPACE;
	            }
	
	            return _react2.default.createElement(
	              "div",
	              { className: _this3.props.childRowClassName, key: childIndex },
	              cellValue
	            );
	          }));
	        }
	
	        return cellContent;
	      };
	    }
	  }, {
	    key: "getRowID",
	    value: function getRowID(row) {
	      return row.id;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	
	      var classes = (0, _classnames2.default)("table-hover", props.className, (0, _defineProperty3.default)({}, "table-align-" + props.alignCells, props.alignCells != null));
	      var TableComponent = props.tableComponent;
	
	      return _react2.default.createElement(TableComponent, (0, _extends3.default)({
	        className: classes
	      }, _Util2.default.omit(props, ["alignCells", "className", "childRowClassName"]), {
	        columns: this.getColumns(props.columns)
	      }));
	    }
	  }]);
	  return ExpandingTable;
	}(_react2.default.Component);
	
	ExpandingTable.defaultProps = {
	  alignCells: "top",
	  childRowClassName: "text-overflow",
	  expandAll: false,
	  expandRowsByDefault: false,
	  tableComponent: _reactjsComponents.Table
	};
	
	ExpandingTable.propTypes = {
	  alignCells: _react2.default.PropTypes.oneOf(["top", "middle", "bottom"]),
	  childRowClassName: _react2.default.PropTypes.string,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  expandAll: _react2.default.PropTypes.bool,
	  expandRowsByDefault: _react2.default.PropTypes.bool,
	  tableComponent: _react2.default.PropTypes.func
	};
	
	module.exports = ExpandingTable;

/***/ },
/* 1477 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	* Sort order is ordered by most important (lowest number, top of list)
	* to least important (largest number, bottom of list)
	*/
	var JobStates = {
	  INITIAL: {
	    stateTypes: ["active"],
	    displayName: "Starting",
	    sortOrder: 3
	  },
	  STARTING: {
	    stateTypes: ["active"],
	    displayName: "Starting",
	    sortOrder: 3
	  },
	  ACTIVE: {
	    stateTypes: ["active"],
	    displayName: "Running",
	    sortOrder: 4
	  },
	  FAILED: {
	    stateTypes: ["completed", "failure"],
	    displayName: "Failed",
	    sortOrder: 0
	  },
	  SUCCESS: {
	    stateTypes: ["success"],
	    displayName: "Success",
	    sortOrder: 6
	  },
	  COMPLETED: {
	    stateTypes: ["success"],
	    displayName: "Completed",
	    sortOrder: 5
	  },
	  SCHEDULED: {
	    stateTypes: [],
	    displayName: "Scheduled",
	    sortOrder: 2
	  },
	  UNSCHEDULED: {
	    stateTypes: [],
	    displayName: "Unscheduled",
	    sortOrder: 1
	  }
	};
	
	module.exports = JobStates;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _MetronomeStore = __webpack_require__(1248);
	
	var _MetronomeStore2 = _interopRequireDefault(_MetronomeStore);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleButtonConfirm"];
	
	var JobStopRunModal = function (_mixin) {
	  (0, _inherits3.default)(JobStopRunModal, _mixin);
	
	  function JobStopRunModal() {
	    (0, _classCallCheck3.default)(this, JobStopRunModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobStopRunModal.__proto__ || (0, _getPrototypeOf2.default)(JobStopRunModal)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "metronome",
	      events: ["jobStopRunSuccess", "jobStopRunError"],
	      suppressUpdate: true
	    }];
	
	    _this.state = {
	      pendingRequest: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobStopRunModal, [{
	    key: "handleButtonConfirm",
	    value: function handleButtonConfirm() {
	      var _props = this.props,
	          selectedItems = _props.selectedItems,
	          jobID = _props.jobID;
	      // TODO DCOS-8763 introduce support for multiple job run IDs
	
	      if (selectedItems.length === 1) {
	        _MetronomeStore2.default.stopJobRun(jobID, selectedItems[0]);
	      }
	
	      this.setState({ pendingRequest: true });
	    }
	  }, {
	    key: "onMetronomeStoreJobStopRunSuccess",
	    value: function onMetronomeStoreJobStopRunSuccess() {
	      this.setState({ pendingRequest: false });
	      this.props.onClose();
	      this.props.onSuccess();
	    }
	  }, {
	    key: "onMetronomeStoreJobStopRunError",
	    value: function onMetronomeStoreJobStopRunError() {
	      this.props.onClose();
	    }
	  }, {
	    key: "getContentHeader",
	    value: function getContentHeader(selectedItems, selectedItemsLength) {
	      var headerContent = " " + selectedItemsLength + " Job Runs";
	      if (selectedItemsLength === 1) {
	        headerContent = "this";
	      }
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        { key: "confirmHeader" },
	        "Are you sure you want to stop " + headerContent + "?"
	      );
	    }
	  }, {
	    key: "getConfirmTextBody",
	    value: function getConfirmTextBody(selectedItems, selectedItemsLength) {
	      var bodyText = void 0;
	
	      if (selectedItemsLength === 1) {
	        bodyText = "the job run with id " + selectedItems[0];
	      } else {
	        bodyText = "the selected job runs";
	      }
	
	      return _react2.default.createElement(
	        "span",
	        { key: "confirmText" },
	        "You are about to stop ",
	        bodyText,
	        "."
	      );
	    }
	  }, {
	    key: "getModalContents",
	    value: function getModalContents() {
	      var selectedItems = this.props.selectedItems;
	
	      var selectedItemsLength = selectedItems.length;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        this.getConfirmTextBody(selectedItems, selectedItemsLength)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          onClose = _props2.onClose,
	          open = _props2.open,
	          selectedItems = _props2.selectedItems;
	
	      var rightButtonText = "Stop Job Run";
	      var selectedItemsLength = selectedItems.length;
	
	      if (selectedItems.length > 1) {
	        rightButtonText = "Stop Job Runs";
	      }
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          closeByBackdropClick: true,
	          disabled: this.state.pendingRequest,
	          header: this.getContentHeader(selectedItems, selectedItemsLength),
	          open: open,
	          onClose: onClose,
	          leftButtonText: "Close",
	          leftButtonCallback: onClose,
	          rightButtonText: rightButtonText,
	          rightButtonClassName: "button button-danger",
	          rightButtonCallback: this.handleButtonConfirm,
	          showHeader: true
	        },
	        this.getModalContents()
	      );
	    }
	  }]);
	  return JobStopRunModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	JobStopRunModal.defaultProps = {
	  onSuccess: function onSuccess() {}
	};
	
	JobStopRunModal.propTypes = {
	  jobID: _react2.default.PropTypes.string.isRequired,
	  onClose: _react2.default.PropTypes.func.isRequired,
	  onSuccess: _react2.default.PropTypes.func,
	  open: _react2.default.PropTypes.bool.isRequired,
	  selectedItems: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = JobStopRunModal;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _prettycron = __webpack_require__(1431);
	
	var _prettycron2 = _interopRequireDefault(_prettycron);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Job = __webpack_require__(1213);
	
	var _Job2 = _interopRequireDefault(_Job);
	
	var _JobTree = __webpack_require__(1212);
	
	var _JobTree2 = _interopRequireDefault(_JobTree);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbSupplementalContent = __webpack_require__(1480);
	
	var _BreadcrumbSupplementalContent2 = _interopRequireDefault(_BreadcrumbSupplementalContent);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PageHeaderBreadcrumbs = __webpack_require__(1329);
	
	var _PageHeaderBreadcrumbs2 = _interopRequireDefault(_PageHeaderBreadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLongestRunningTask(item) {
	  if (!(item instanceof _Job2.default)) {
	    return null;
	  }
	
	  var longestRunningActiveRun = item.getActiveRuns().getLongestRunningActiveRun();
	
	  if (!longestRunningActiveRun) {
	    return null;
	  }
	
	  return longestRunningActiveRun.getTasks().getLongestRunningTask();
	}
	
	function getItemStatus(item) {
	  var longestRunningTask = getLongestRunningTask(item);
	
	  if (!longestRunningTask) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _BreadcrumbSupplementalContent2.default,
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "service-page-header-status muted" },
	      "(",
	      _TaskStates2.default[longestRunningTask.getStatus()].displayName,
	      ")"
	    )
	  );
	}
	
	function getItemSchedule(item) {
	  if (!(item instanceof _Job2.default)) {
	    return null;
	  }
	
	  var schedule = item.getSchedules()[0];
	
	  if (!schedule || !schedule.enabled) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _BreadcrumbSupplementalContent2.default,
	    null,
	    _react2.default.createElement(
	      _reactjsComponents.Tooltip,
	      {
	        content: _prettycron2.default.toString(schedule.cron),
	        maxWidth: 250,
	        wrapText: true
	      },
	      _react2.default.createElement(_Icon2.default, { color: "grey", id: "repeat", size: "mini" })
	    )
	  );
	}
	
	function getBreadcrumb(item) {
	  var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var id = item.getId();
	  var name = item.getName();
	  var link = item instanceof _Job2.default ? "/jobs/detail/" + id : "/jobs/overview/" + id;
	
	  return _react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: id, title: "Jobs" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: link },
	        name === "" ? "Jobs" : name
	      )
	    ),
	    details ? getItemSchedule(item) : null,
	    details ? getItemStatus(item) : null
	  );
	}
	
	function getBreadcrumbList(tree, item, details) {
	  if (item == null) {
	    return [];
	  }
	
	  return tree.filterItems(function (currentItem) {
	    return item.getId() === currentItem.getId() && item.constructor === currentItem.constructor;
	  }).reduceItems(function (acc, currentItem) {
	    return acc.concat(getBreadcrumb(currentItem, details));
	  }, []);
	}
	
	var JobsBreadcrumbs = function JobsBreadcrumbs(_ref) {
	  var tree = _ref.tree,
	      item = _ref.item,
	      children = _ref.children,
	      _ref$details = _ref.details,
	      details = _ref$details === undefined ? true : _ref$details;
	
	  var breadcrumbs = [].concat(getBreadcrumb(tree, details), getBreadcrumbList(tree, item, details), _react2.default.Children.toArray(children));
	
	  return _react2.default.createElement(_PageHeaderBreadcrumbs2.default, { iconID: "jobs", breadcrumbs: breadcrumbs });
	};
	
	JobsBreadcrumbs.propTypes = {
	  tree: _react2.default.PropTypes.instanceOf(_JobTree2.default).isRequired,
	  item: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_JobTree2.default), _react2.default.PropTypes.instanceOf(_Job2.default)])
	};
	
	module.exports = JobsBreadcrumbs;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbSupplementalContent = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbSupplementalContent, _React$Component);
	
	  function BreadcrumbSupplementalContent() {
	    (0, _classCallCheck3.default)(this, BreadcrumbSupplementalContent);
	    return (0, _possibleConstructorReturn3.default)(this, (BreadcrumbSupplementalContent.__proto__ || (0, _getPrototypeOf2.default)(BreadcrumbSupplementalContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BreadcrumbSupplementalContent, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          hasStatusBar = _props.hasStatusBar;
	
	
	      if (!children) {
	        return null;
	      }
	
	      var classes = (0, _classnames2.default)("breadcrumb__content breadcrumb__content--supplemental", { "breadcrumb__content--has-status-bar": hasStatusBar });
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        children
	      );
	    }
	  }]);
	  return BreadcrumbSupplementalContent;
	}(_react2.default.Component);
	
	BreadcrumbSupplementalContent.defaultProps = {
	  hasStatusBar: false
	};
	
	BreadcrumbSupplementalContent.propTypes = {
	  hasStatusBar: _react2.default.PropTypes.bool
	};
	
	module.exports = BreadcrumbSupplementalContent;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabsUtil = __webpack_require__(1482);
	
	var _TabsUtil2 = _interopRequireDefault(_TabsUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _NotificationStore = __webpack_require__(1258);
	
	var _NotificationStore2 = _interopRequireDefault(_NotificationStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds tabs-specific methods onto a class.
	 *
	 * Note that routes may be cascaded where multiple tab hierarchies are in place
	 * by prefixing one route with another, eg the route 'universe-packages-detail'
	 * will result in the tab 'universe-packages' being highlighted as active.
	 *
	 * @mixin
	 * @see {@link TabsUtil}
	 * @example
	 * class PageWithRoutableTabs extends mixin(TabsMixin) {
	 *   constructor() {
	 *     super(...args);
	 *     // The default selected tab may be defined so:
	 *     this.state = {
	 *       currentTab: 'defined-route-1'
	 *     }
	 *   }
	 *   componentWillMount() {
	 *     // The keys to this object must be defined routes
	 *     this.tabs_tabs = {
	 *      'defined-route-1': 'Tab Title 1',
	 *      'defined-route-2': 'Tab Title 2'
	 *     }
	 *     this.updateCurrentTab();
	 *   }
	 *   getNavigation() {
	 *     return (
	 *       <ul>
	 *         {this.tabs_getRoutedTabs()}
	 *       </ul>
	 *     );
	 *   }
	 *   render() {
	 *     return (
	 *       <Page
	 *         navigation={this.getNavigation()}>
	 *         {this.props.children}
	 *       </Page>
	 *     );
	 *   }
	 * }
	 */
	
	/* eslint-disable no-unused-vars */
	var TabsMixin = {
	  /**
	   * Returns a tab that has a callback when clicked.
	   * @see #tabs_handleTabClick
	   *
	   * @param  {Object} props to be added to the Link item
	   * @param  {String} tab key of tab to render
	   * @return {Component} React component to render
	   */
	  tabs_getUnroutedItem: function tabs_getUnroutedItem() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var tab = arguments[1];
	
	    var attributes = _Util2.default.omit(props, ["classNames"]);
	    var tabLabelClass = (0, _dedupe2.default)("menu-tabbed-item-label", props.classNames);
	
	    return _react2.default.createElement(
	      "span",
	      (0, _extends3.default)({
	        className: tabLabelClass,
	        onClick: this.tabs_handleTabClick.bind(this, tab)
	      }, attributes),
	      _react2.default.createElement(
	        "span",
	        { className: "menu-tabbed-item-label-text" },
	        this.tabs_tabs[tab]
	      )
	    );
	  },
	
	
	  /**
	   * Will return an array of tabs to be rendered.
	   * Will only have onClick handlers, as these tabs are not routable.
	   *
	   * @param  {Object} props to be added to the active component
	   * @return {Array} of tabs to render
	   */
	  tabs_getUnroutedTabs: function tabs_getUnroutedTabs(props) {
	    return _TabsUtil2.default.getTabs(this.tabs_tabs, this.state.currentTab, this.tabs_getUnroutedItem.bind(this, props));
	  },
	
	
	  /**
	   * Returns a Link for a given tab. This tab is expected to be routable.
	   *
	   * @param  {Object} props to be added to the Link item
	   * @param  {String} tab key of tab to render
	   * @return {Component} React component to render
	   */
	  tabs_getRoutedItem: function tabs_getRoutedItem() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var tab = arguments[1];
	
	    var attributes = _Util2.default.omit(props, ["classNames"]);
	    var badge = null;
	    var notificationCount = _NotificationStore2.default.getNotificationCount(tab);
	    var hasNotification = notificationCount > 0;
	    var tabLabelClasses = (0, _dedupe2.default)("menu-tabbed-item-label", { "badge-container": hasNotification }, props.classNames);
	    var textClasses = (0, _dedupe2.default)("menu-tabbed-item-label-text", {
	      "badge-container-text": hasNotification
	    });
	
	    if (hasNotification) {
	      badge = _react2.default.createElement(
	        "span",
	        { className: "badge badge-rounded" },
	        notificationCount
	      );
	    }
	
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      (0, _extends3.default)({
	        to: (0, _reactRouter.formatPattern)(tab, attributes.params),
	        className: tabLabelClasses,
	        onClick: this.tabs_handleTabClick.bind(this, tab)
	      }, attributes),
	      _react2.default.createElement(
	        "span",
	        { className: textClasses },
	        this.tabs_tabs[tab]
	      ),
	      badge
	    );
	  },
	
	
	  /**
	   * Will return an array of routed tabs to be rendered.
	   * Will have onClick handlers and active Link components with routes
	   *
	   * @param  {Object} props to be added to the active component
	   * @return {Array} of tabs to render
	   */
	  tabs_getRoutedTabs: function tabs_getRoutedTabs(props) {
	    return _TabsUtil2.default.getTabs(this.tabs_tabs, this.state.currentTab, this.tabs_getRoutedItem.bind(this, props));
	  },
	
	
	  /**
	   * Calls the function to render the active tab
	   *
	   * @return {Component} the result of the appropriate render function
	   */
	  tabs_getTabView: function tabs_getTabView() {
	    // Replace spaces in the currentTab string because we are calling the string
	    // as a function on the component, and functions cannot have spaces.
	    var currentTab = this.tabs_tabs[this.state.currentTab].replace(" ", "");
	    var renderFunction = this["render" + currentTab + "TabView"];
	
	    if (renderFunction == null) {
	      return null;
	    }
	
	    return renderFunction.apply(this, arguments);
	  },
	  tabs_handleTabClick: function tabs_handleTabClick(nextTab) {
	    this.setState({ currentTab: nextTab });
	  }
	};
	/* eslint-enable no-unused-vars */
	
	module.exports = TabsMixin;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var TabsUtil = {
	  /**
	   * Renders tabs for a given array
	   * This needs to be in a util because we can
	   * have tabs inside of tabs for a component
	   *
	   * @param  {Object} tabs with a key for each tab to render
	   * @param  {String} currentTab currently active tab
	   * @param  {Function} getElement render function to render each element
	   * @return {Array} of tabs to render
	   */
	  getTabs: function getTabs(tabs, currentTab, getElement) {
	    var tabSet = (0, _keys2.default)(tabs);
	
	    return tabSet.map(function (tab, index) {
	      var tabClass = (0, _classnames2.default)({
	        "menu-tabbed-item": true,
	        active: !!currentTab && currentTab.startsWith(tab)
	      });
	
	      return _react2.default.createElement(
	        "li",
	        { className: tabClass, key: tab },
	        getElement(tab, index)
	      );
	    });
	  },
	
	
	  /**
	   * Sorts tabs based on their priority
	   * @param  {Object} tabs - tabs with a key for each tab to render
	   * @return {Object}      tabs Object with sorted insertion order
	   */
	  sortTabs: function sortTabs(tabs) {
	    var comparator = function comparator(a, b) {
	      return b[1] - a[1];
	    };
	
	    return (0, _keys2.default)(tabs).map(function (key) {
	      return [key, tabs[key].priority || 0];
	    }).sort(comparator).map(function (val) {
	      return val[0];
	    }).reduce(function (acc, curr) {
	      acc[curr] = tabs[curr].content;
	
	      return acc;
	    }, {});
	  }
	};
	/* eslint-disable no-unused-vars */
	
	
	module.exports = TabsUtil;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JobsPage = function (_React$Component) {
	  (0, _inherits3.default)(JobsPage, _React$Component);
	
	  function JobsPage() {
	    (0, _classCallCheck3.default)(this, JobsPage);
	    return (0, _possibleConstructorReturn3.default)(this, (JobsPage.__proto__ || (0, _getPrototypeOf2.default)(JobsPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobsPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return JobsPage;
	}(_react2.default.Component);
	
	JobsPage.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	JobsPage.routeConfig = {
	  label: "Jobs",
	  icon: _react2.default.createElement(_Icon2.default, { id: "jobs-inverse", size: "small", family: "product" }),
	  matches: /^\/jobs/
	};
	
	JobsPage.willTransitionTo = function () {
	  _SidebarActions2.default.close();
	};
	
	module.exports = JobsPage;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _JobsBreadcrumbs = __webpack_require__(1479);
	
	var _JobsBreadcrumbs2 = _interopRequireDefault(_JobsBreadcrumbs);
	
	var _JobsTable = __webpack_require__(1485);
	
	var _JobsTable2 = _interopRequireDefault(_JobsTable);
	
	var _JobSearchFilter = __webpack_require__(1487);
	
	var _JobSearchFilter2 = _interopRequireDefault(_JobSearchFilter);
	
	var _JobFilterTypes = __webpack_require__(1488);
	
	var _JobFilterTypes2 = _interopRequireDefault(_JobFilterTypes);
	
	var _JobFormModal = __webpack_require__(1438);
	
	var _JobFormModal2 = _interopRequireDefault(_JobFormModal);
	
	var _JobTree = __webpack_require__(1212);
	
	var _JobTree2 = _interopRequireDefault(_JobTree);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ServiceFilterTypes = __webpack_require__(1323);
	
	var _ServiceFilterTypes2 = _interopRequireDefault(_ServiceFilterTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getHeadline", "handleFilterChange", "handleCloseJobFormModal", "handleOpenJobFormModal", "resetFilter", "resetFilterQueryParams"];
	
	var DEFAULT_FILTER_OPTIONS = {
	  searchString: ""
	};
	
	var JobsTab = function (_mixin) {
	  (0, _inherits3.default)(JobsTab, _mixin);
	
	  function JobsTab() {
	    (0, _classCallCheck3.default)(this, JobsTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobsTab.__proto__ || (0, _getPrototypeOf2.default)(JobsTab)).apply(this, arguments));
	
	    _this.state = (0, _assign2.default)({
	      isJobFormModalOpen: false
	    }, DEFAULT_FILTER_OPTIONS);
	
	    _this.store_listeners = [{ name: "dcos", events: ["change"], suppressUpdate: false }, {
	      name: "metronome",
	      events: ["change", "jobCreateSuccess"],
	      suppressUpdate: false
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobsTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(JobsTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(JobsTab.prototype), "componentDidMount", this).call(this);
	      this.updateFromProps(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(JobsTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(JobsTab.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      this.updateFromProps(nextProps);
	    }
	  }, {
	    key: "handleCloseJobFormModal",
	    value: function handleCloseJobFormModal() {
	      this.setState({ isJobFormModalOpen: false });
	    }
	  }, {
	    key: "handleOpenJobFormModal",
	    value: function handleOpenJobFormModal() {
	      this.setState({ isJobFormModalOpen: true });
	    }
	  }, {
	    key: "handleFilterChange",
	    value: function handleFilterChange(filterValue) {
	      var router = this.context.router;
	      var pathname = this.props.location.pathname;
	
	      var query = (0, _defineProperty3.default)({}, _JobFilterTypes2.default.TEXT, filterValue);
	
	      router.push({ pathname: pathname, query: query });
	
	      this.setState({
	        searchString: filterValue
	      });
	    }
	  }, {
	    key: "resetFilterQueryParams",
	    value: function resetFilterQueryParams() {
	      var pathname = this.props.location.pathname;
	
	      var query = (0, _assign2.default)({}, location.query);
	
	      (0, _values2.default)(_ServiceFilterTypes2.default).forEach(function (filterKey) {
	        delete query[filterKey];
	      });
	
	      this.context.router.push({ pathname: pathname, query: query });
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      var state = (0, _assign2.default)({}, this.state, DEFAULT_FILTER_OPTIONS);
	      this.setState(state, this.resetFilterQueryParams);
	    }
	  }, {
	    key: "updateFromProps",
	    value: function updateFromProps(props) {
	      var _props$location = props.location,
	          location = _props$location === undefined ? { query: {} } : _props$location;
	
	
	      if (location.query[_JobFilterTypes2.default.TEXT] != null) {
	        var state = {};
	
	        state[_JobFilterTypes2.default.TEXT] = location.query[_JobFilterTypes2.default.TEXT];
	        this.setState(state);
	      }
	    }
	  }, {
	    key: "getHeadline",
	    value: function getHeadline(item, filteredJobs) {
	      var state = this.state;
	
	      var jobs = item.getItems();
	
	      var hasFiltersApplied = (0, _keys2.default)(DEFAULT_FILTER_OPTIONS).some(function (filterKey) {
	        return state[filterKey] != null && state[filterKey].length > 0;
	      });
	
	      if (hasFiltersApplied) {
	        return _react2.default.createElement(_FilterHeadline2.default, {
	          onReset: this.resetFilter,
	          name: "Jobs",
	          currentLength: filteredJobs.length,
	          totalLength: jobs.length
	        });
	      }
	    }
	  }, {
	    key: "getFilteredJobs",
	    value: function getFilteredJobs(item) {
	      var searchString = this.state.searchString;
	
	      var jobs = item.getItems();
	
	      if (searchString) {
	        var filterProperties = (0, _assign2.default)({}, item.getFilterProperties(), {
	          name: function name(item) {
	            return item.getId();
	          }
	        });
	
	        jobs = item.filterItemsByText(searchString, filterProperties).getItems();
	      }
	
	      return jobs;
	    }
	  }, {
	    key: "getJobTreeView",
	    value: function getJobTreeView(item, modal) {
	      var filteredJobs = this.getFilteredJobs(item);
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          addButton: {
	            label: "Create a job",
	            onItemSelect: this.handleOpenJobFormModal
	          },
	          breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _DCOSStore2.default.jobTree, item: item })
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "flex-grow" },
	          this.getHeadline(item, filteredJobs),
	          _react2.default.createElement(
	            _FilterBar2.default,
	            null,
	            _react2.default.createElement(_JobSearchFilter2.default, {
	              onChange: this.handleFilterChange,
	              value: this.state.searchString
	            })
	          ),
	          _react2.default.createElement(_JobsTable2.default, { jobs: filteredJobs })
	        ),
	        modal
	      );
	    }
	  }, {
	    key: "getAlertPanelFooter",
	    value: function getAlertPanelFooter() {
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button-success",
	            onClick: this.handleOpenJobFormModal
	          },
	          "Create a Job"
	        )
	      );
	    }
	  }, {
	    key: "getContents",
	    value: function getContents(item, modal) {
	      // Render loading screen
	      if (!_DCOSStore2.default.jobDataReceived) {
	        return _react2.default.createElement(
	          _Page2.default,
	          null,
	          _react2.default.createElement(_Page2.default.Header, {
	            breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _DCOSStore2.default.jobTree })
	          }),
	          _react2.default.createElement(_Loader2.default, null)
	        );
	      }
	
	      if (item instanceof _JobTree2.default && item.getItems().length > 0) {
	        return this.getJobTreeView(item, modal);
	      }
	
	      // Render empty panel
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _DCOSStore2.default.jobTree })
	        }),
	        _react2.default.createElement(
	          _AlertPanel2.default,
	          null,
	          _react2.default.createElement(
	            _AlertPanelHeader2.default,
	            null,
	            "No active jobs"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "tall" },
	            "Create both one-off or scheduled jobs to perform tasks at a predefined interval."
	          ),
	          this.getAlertPanelFooter()
	        ),
	        modal
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var id = decodeURIComponent(this.props.params.id);
	      var jobTree = _DCOSStore2.default.jobTree.findItem(function (item) {
	        return item instanceof _JobTree2.default && item.id === id;
	      }) || _DCOSStore2.default.jobTree;
	
	      var modal = _react2.default.createElement(_JobFormModal2.default, {
	        open: this.state.isJobFormModalOpen,
	        onClose: this.handleCloseJobFormModal
	      });
	
	      return this.getContents(jobTree, modal);
	    }
	  }]);
	  return JobsTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	JobsTab.contextTypes = {
	  router: _reactRouter.routerShape,
	  location: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = JobsTab;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _prettycron = __webpack_require__(1431);
	
	var _prettycron2 = _interopRequireDefault(_prettycron);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _JobStates = __webpack_require__(1477);
	
	var _JobStates2 = _interopRequireDefault(_JobStates);
	
	var _JobStatus = __webpack_require__(1218);
	
	var _JobStatus2 = _interopRequireDefault(_JobStatus);
	
	var _JobTableHeaderLables = __webpack_require__(1486);
	
	var _JobTableHeaderLables2 = _interopRequireDefault(_JobTableHeaderLables);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _Tree = __webpack_require__(1220);
	
	var _Tree2 = _interopRequireDefault(_Tree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["renderHeadline", "jobSortFunction"];
	
	var JobsTable = function (_React$Component) {
	  (0, _inherits3.default)(JobsTable, _React$Component);
	
	  function JobsTable() {
	    (0, _classCallCheck3.default)(this, JobsTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JobsTable.__proto__ || (0, _getPrototypeOf2.default)(JobsTable)).call(this));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(JobsTable, [{
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "20%" } }),
	        _react2.default.createElement("col", { style: { width: "20%" } })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var className = _ResourceTableUtil2.default.getClassName;
	      var heading = _ResourceTableUtil2.default.renderHeading(_JobTableHeaderLables2.default);
	
	      return [{
	        className: className,
	        heading: heading,
	        headerClassName: className,
	        prop: "name",
	        render: this.renderHeadline,
	        sortable: true,
	        sortFunction: this.jobSortFunction
	      }, {
	        className: className,
	        heading: heading,
	        headerClassName: className,
	        prop: "status",
	        render: this.renderStatusColumn,
	        sortable: true,
	        sortFunction: this.jobSortFunction
	      }, {
	        className: className,
	        heading: heading,
	        headerClassName: className,
	        prop: "lastRun",
	        render: this.renderLastRunStatusColumn,
	        sortable: true,
	        sortFunction: this.jobSortFunction
	      }];
	    }
	
	    // TODO: DCOS-7766 Revisit this pre-rendering data transformation...
	
	  }, {
	    key: "getData",
	    value: function getData() {
	      return this.props.jobs.map(function (job) {
	        var isGroup = job instanceof _Tree2.default;
	        var lastRun = {};
	        var schedules = null;
	        var status = null;
	
	        if (!isGroup) {
	          var lastRunsSummary = job.getLastRunsSummary();
	
	          lastRun = {
	            status: job.getLastRunStatus().status,
	            lastSuccessAt: lastRunsSummary.lastSuccessAt,
	            lastFailureAt: lastRunsSummary.lastFailureAt
	          };
	
	          schedules = job.getSchedules();
	          status = job.getScheduleStatus();
	        }
	
	        return {
	          id: job.getId(),
	          isGroup: isGroup,
	          name: job.getName(),
	          schedules: schedules,
	          status: status,
	          lastRun: lastRun
	        };
	      });
	    }
	  }, {
	    key: "getCompareFunctionByProp",
	    value: function getCompareFunctionByProp(prop) {
	      switch (prop) {
	        case "name":
	          return function (a, b) {
	            return a.name.localeCompare(b.name);
	          };
	        case "status":
	          return function (a, b) {
	            return _JobStates2.default[a.status].sortOrder - _JobStates2.default[b.status].sortOrder;
	          };
	        case "lastRun":
	          return function (a, b) {
	            return _JobStatus2.default[a.lastRun.status].sortOrder - _JobStatus2.default[b.lastRun.status].sortOrder;
	          };
	      }
	    }
	  }, {
	    key: "jobSortFunction",
	    value: function jobSortFunction(prop, direction) {
	      var compareFunction = this.getCompareFunctionByProp(prop);
	      var score = 1;
	
	      if (direction === "desc") {
	        score = -1;
	      }
	
	      return function (a, b) {
	        // Hoist group trees to the top
	        if (a.isGroup && !b.isGroup) {
	          return score * -1;
	        } else if (b.isGroup && !a.isGroup) {
	          return score;
	        }
	
	        return compareFunction(a, b);
	      };
	    }
	  }, {
	    key: "renderHeadline",
	    value: function renderHeadline(prop, job) {
	      var id = job.id,
	          isGroup = job.isGroup,
	          name = job.name,
	          schedules = job.schedules;
	
	      var scheduleIcon = null;
	      var url = "/jobs/detail/" + encodeURIComponent(id);
	      var itemImage = _react2.default.createElement(_Icon2.default, {
	        className: "icon-margin-right",
	        color: "grey",
	        id: "page-document",
	        size: "mini"
	      });
	
	      if (isGroup) {
	        url = "/jobs/overview/" + encodeURIComponent(id);
	
	        itemImage = _react2.default.createElement(_Icon2.default, {
	          className: "icon-margin-right",
	          color: "grey",
	          id: "folder",
	          size: "mini"
	        });
	      }
	
	      if (schedules && schedules.length !== 0) {
	        var schedule = schedules[0];
	
	        if (schedule.enabled) {
	          scheduleIcon = _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              wrapperClassName: "tooltip-wrapper icon-margin-left",
	              content: _prettycron2.default.toString(schedule.cron),
	              maxWidth: 250,
	              wrapText: true
	            },
	            _react2.default.createElement(_Icon2.default, { color: "grey", id: "repeat", size: "mini" })
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "job-table-heading flex-box flex-box-align-vertical-center table-cell-flex-box" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: url, className: "table-cell-icon" },
	          itemImage
	        ),
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: url,
	            className: "table-cell-link-primary table-cell-value flex-box flex-box-col"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "text-overflow" },
	            name
	          ),
	          scheduleIcon
	        )
	      );
	    }
	  }, {
	    key: "renderLastRunStatusColumn",
	    value: function renderLastRunStatusColumn(prop, row) {
	      var _row$prop = row[prop],
	          lastFailureAt = _row$prop.lastFailureAt,
	          lastSuccessAt = _row$prop.lastSuccessAt,
	          status = _row$prop.status;
	
	      var statusClasses = (0, _classnames2.default)({
	        "text-success": status === "Success",
	        "text-danger": status === "Failed"
	      });
	      var nodes = [];
	      var statusNode = _react2.default.createElement(
	        "span",
	        { className: statusClasses },
	        status
	      );
	
	      if (lastFailureAt == null && lastSuccessAt == null) {
	        return statusNode;
	      }
	
	      if (lastSuccessAt != null) {
	        nodes.push(_react2.default.createElement(
	          "p",
	          { className: "flush-bottom", key: "tooltip-success-at" },
	          _react2.default.createElement(
	            "span",
	            { className: "text-success" },
	            "Last Success: "
	          ),
	          new Date(lastSuccessAt).toLocaleString()
	        ));
	      }
	
	      if (lastFailureAt != null) {
	        nodes.push(_react2.default.createElement(
	          "p",
	          { className: "flush-bottom", key: "tooltip-failure-at" },
	          _react2.default.createElement(
	            "span",
	            { className: "text-danger" },
	            "Last Failure: "
	          ),
	          new Date(lastFailureAt).toLocaleString()
	        ));
	      }
	
	      return _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { wrapperClassName: "tooltip-wrapper", content: nodes },
	        statusNode
	      );
	    }
	  }, {
	    key: "renderStatusColumn",
	    value: function renderStatusColumn(prop, col) {
	      var statusKey = col[prop],
	          isGroup = col.isGroup;
	
	      if (isGroup) {
	        return null;
	      }
	
	      var jobState = _JobStates2.default[statusKey];
	
	      var statusClasses = (0, _classnames2.default)({
	        "text-success": jobState.stateTypes.includes("success"),
	        "text-danger": jobState.stateTypes.includes("failure")
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: statusClasses },
	        jobState.displayName
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        colGroup: this.getColGroup(),
	        columns: this.getColumns(),
	        data: this.getData(),
	        itemHeight: _TableUtil2.default.getRowHeight(),
	        sortBy: { prop: "name", order: "asc" }
	      });
	    }
	  }]);
	  return JobsTable;
	}(_react2.default.Component);
	
	JobsTable.propTypes = {
	  jobs: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = JobsTable;

/***/ },
/* 1486 */
/***/ function(module, exports) {

	"use strict";
	
	var JobTableHeaderLabels = {
	  name: "JOB NAME",
	  status: "STATUS",
	  lastRun: "LAST RUN"
	};
	
	module.exports = JobTableHeaderLabels;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var JobSearchFilter = function (_React$Component) {
	  (0, _inherits3.default)(JobSearchFilter, _React$Component);
	
	  function JobSearchFilter() {
	    (0, _classCallCheck3.default)(this, JobSearchFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (JobSearchFilter.__proto__ || (0, _getPrototypeOf2.default)(JobSearchFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobSearchFilter, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_FilterInputText2.default, {
	        className: "flush-bottom",
	        handleFilterChange: this.props.onChange,
	        placeholder: "Search",
	        searchString: this.props.value
	      });
	    }
	  }]);
	  return JobSearchFilter;
	}(_react2.default.Component);
	/* eslint-enable no-unused-vars */
	
	
	JobSearchFilter.propTypes = {
	  onChange: _react2.default.PropTypes.func.isRequired,
	  value: _react2.default.PropTypes.string
	};
	
	module.exports = JobSearchFilter;

/***/ },
/* 1488 */
/***/ function(module, exports) {

	"use strict";
	
	var JobFilterTypes = {
	  TEXT: "searchString"
	};
	
	module.exports = JobFilterTypes;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _TaskDetail = __webpack_require__(1490);
	
	var _TaskDetail2 = _interopRequireDefault(_TaskDetail);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _MetronomeStore = __webpack_require__(1248);
	
	var _MetronomeStore2 = _interopRequireDefault(_MetronomeStore);
	
	var _JobsBreadcrumbs = __webpack_require__(1479);
	
	var _JobsBreadcrumbs2 = _interopRequireDefault(_JobsBreadcrumbs);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dontScrollRoutes = [/\/files\/view.*$/, /\/logs.*$/];
	
	var JobTaskDetailPage = function (_React$Component) {
	  (0, _inherits3.default)(JobTaskDetailPage, _React$Component);
	
	  function JobTaskDetailPage() {
	    (0, _classCallCheck3.default)(this, JobTaskDetailPage);
	    return (0, _possibleConstructorReturn3.default)(this, (JobTaskDetailPage.__proto__ || (0, _getPrototypeOf2.default)(JobTaskDetailPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(JobTaskDetailPage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          routes = _props.routes;
	      var id = params.id,
	          taskID = params.taskID;
	
	
	      var routePrefix = "/jobs/detail/" + encodeURIComponent(id) + "/tasks/" + encodeURIComponent(taskID);
	      var tabs = [{ label: "Details", routePath: routePrefix + "/details" }, { label: "Files", routePath: routePrefix + "/files" }, { label: "Logs", routePath: routePrefix + "/logs" }];
	
	      var job = _MetronomeStore2.default.getJob(id);
	      var task = _MesosStateStore2.default.getTaskFromTaskID(taskID);
	
	      var breadcrumbs = _react2.default.createElement(_JobsBreadcrumbs2.default, { tree: _DCOSStore2.default.jobTree, item: job, details: false });
	
	      if (task != null) {
	        breadcrumbs = _react2.default.createElement(
	          _JobsBreadcrumbs2.default,
	          { tree: _DCOSStore2.default.jobTree, item: job, details: false },
	          _react2.default.createElement(
	            _Breadcrumb2.default,
	            { key: "task-name", title: task.getName() },
	            _react2.default.createElement(
	              _BreadcrumbTextContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/jobs/detail/" + id + "/tasks/" + task.getId() },
	                task.getName()
	              )
	            )
	          )
	        );
	      }
	
	      var dontScroll = dontScrollRoutes.some(function (regex) {
	        return regex.test(location.pathname);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { dontScroll: dontScroll },
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs, tabs: tabs, iconID: "jobs" }),
	        _react2.default.createElement(
	          _TaskDetail2.default,
	          { params: params, routes: routes },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return JobTaskDetailPage;
	}(_react2.default.Component);
	
	JobTaskDetailPage.propTypes = {
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array
	};
	
	module.exports = JobTaskDetailPage;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _DetailViewHeader = __webpack_require__(1491);
	
	var _DetailViewHeader2 = _interopRequireDefault(_DetailViewHeader);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ManualBreadcrumbs = __webpack_require__(1492);
	
	var _ManualBreadcrumbs2 = _interopRequireDefault(_ManualBreadcrumbs);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _StatusMapping = __webpack_require__(1494);
	
	var _StatusMapping2 = _interopRequireDefault(_StatusMapping);
	
	var _TaskDirectoryStore = __webpack_require__(1495);
	
	var _TaskDirectoryStore2 = _interopRequireDefault(_TaskDirectoryStore);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleBreadcrumbClick", "handleOpenLogClick", "onTaskDirectoryStoreError", "onTaskDirectoryStoreSuccess"];
	
	// TODO remove
	
	/* eslint-enable no-unused-vars */
	
	/* eslint-disable no-unused-vars */
	var HIDE_BREADCRUMBS = ["/jobs/detail/:id/tasks/:taskID/details", "/jobs/detail/:id/tasks/:taskID/logs", "/jobs/detail/:id/tasks/:taskID/logs/:filePath", "/jobs/detail/:id/tasks/:taskID/files/view(/:filePath(/:innerPath))", "/networking/networks/:overlayName/tasks/:taskID/details", "/networking/networks/:overlayName/tasks/:taskID/logs", "/networking/networks/:overlayName/tasks/:taskID/logs/:filePath", "/networking/networks/:overlayName/tasks/:taskID/files/view(/:filePath(/:innerPath))", "/nodes/:nodeID/tasks/:taskID/details", "/nodes/:nodeID/tasks/:taskID/logs", "/nodes/:nodeID/tasks/:taskID/logs/:filePath", "/nodes/:nodeID/tasks/:taskID/files/view(/:filePath(/:innerPath))", "/services/detail/:id/tasks/:taskID/details", "/services/detail/:id/tasks/:taskID/logs", "/services/detail/:id/tasks/:taskID/logs/:filePath", "/services/detail/:id/tasks/:taskID/files/view(/:filePath(/:innerPath))"];
	
	var TaskDetail = function (_mixin) {
	  (0, _inherits3.default)(TaskDetail, _mixin);
	
	  function TaskDetail() {
	    (0, _classCallCheck3.default)(this, TaskDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskDetail.__proto__ || (0, _getPrototypeOf2.default)(TaskDetail)).apply(this, arguments));
	
	    _this.tabs_tabs = {};
	
	    _this.state = {
	      directory: null,
	      expandClass: "large",
	      selectedLogFile: null,
	      taskDirectoryErrorCount: 0
	    };
	
	    _this.store_listeners = [{ name: "marathon", events: ["appsSuccess"], listenAlways: false }, { name: "state", events: ["success"], listenAlways: false }, { name: "summary", events: ["success"], listenAlways: false }, {
	      name: "taskDirectory",
	      events: ["error", "success", "nodeStateError", "nodeStateSuccess"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.onTaskDirectoryStoreNodeStateError = _this.onTaskDirectoryStoreError;
	    _this.onTaskDirectoryStoreNodeStateSuccess = _this.onTaskDirectoryStoreSuccess;
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(TaskDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskDetail.prototype), "componentWillMount", this).apply(this, arguments);
	
	      var routes = this.props.routes;
	
	      // TODO: DCOS-7871 Refactor the TabsMixin to generalize this solution:
	
	      var topRouteIndex = routes.findIndex(function (_ref) {
	        var component = _ref.component;
	
	        return component === TaskDetail;
	      });
	      var topRoute = routes[topRouteIndex];
	
	      var parentRoutes = routes.slice(0, topRouteIndex + 1);
	      var parentPath = _RouterUtil2.default.reconstructPathFromRoutes(parentRoutes);
	
	      if (topRoute != null) {
	        this.tabs_tabs = topRoute.childRoutes.filter(function (_ref2) {
	          var isTab = _ref2.isTab;
	
	          return !!isTab;
	        }).reduce(function (tabs, _ref3) {
	          var path = _ref3.path,
	              title = _ref3.title;
	
	          var key = parentPath;
	          if (path) {
	            key = parentPath + "/" + path;
	          }
	
	          tabs[key] = title || path;
	
	          return tabs;
	        }, this.tabs_tabs);
	
	        this.updateCurrentTab();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(TaskDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskDetail.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      var _props$params = this.props.params,
	          innerPath = _props$params.innerPath,
	          taskID = _props$params.taskID;
	
	      if (nextProps.params.innerPath !== innerPath || nextProps.params.taskID !== taskID) {
	        this.setState({ directory: null });
	      }
	
	      this.updateCurrentTab(nextProps);
	    }
	  }, {
	    key: "updateCurrentTab",
	    value: function updateCurrentTab(nextProps) {
	      var _ref4 = nextProps || this.props,
	          routes = _ref4.routes;
	
	      var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	      if (currentTab != null) {
	        this.setState({ currentTab: currentTab });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(TaskDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskDetail.prototype), "componentDidMount", this).apply(this, arguments);
	      this.store_removeEventListenerForStoreID("summary", "success");
	    }
	  }, {
	    key: "onStateStoreSuccess",
	    value: function onStateStoreSuccess() {
	      this.handleFetchDirectory();
	    }
	  }, {
	    key: "onTaskDirectoryStoreError",
	    value: function onTaskDirectoryStoreError() {
	      this.setState({
	        taskDirectoryErrorCount: this.state.taskDirectoryErrorCount + 1
	      });
	    }
	  }, {
	    key: "onTaskDirectoryStoreSuccess",
	    value: function onTaskDirectoryStoreSuccess(taskID) {
	      if (this.props.params.taskID !== taskID) {
	        this.handleFetchDirectory();
	
	        return;
	      }
	
	      var directory = _TaskDirectoryStore2.default.get("directory");
	      this.setState({ directory: directory, taskDirectoryErrorCount: 0 });
	    }
	  }, {
	    key: "handleFetchDirectory",
	    value: function handleFetchDirectory() {
	      var params = this.props.params;
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(params.taskID);
	      // Declare undefined to not override default values in fetchDirectory
	      var innerPath = void 0;
	
	      if (params.innerPath != null) {
	        innerPath = decodeURIComponent(params.innerPath);
	      }
	
	      if (task != null) {
	        _TaskDirectoryStore2.default.fetchDirectory(task, innerPath);
	      }
	
	      this.setState({ directory: null });
	    }
	  }, {
	    key: "handleBreadcrumbClick",
	    value: function handleBreadcrumbClick(path) {
	      var router = this.context.router;
	      var _props = this.props,
	          params = _props.params,
	          routes = _props.routes;
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(params.taskID);
	      if (task != null) {
	        _TaskDirectoryStore2.default.setPath(task, path);
	      }
	      // Transition to parent route, which uses a default route
	      var parentPath = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	      router.push((0, _reactRouter.formatPattern)(parentPath, params));
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod" },
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "hasVolumes",
	    value: function hasVolumes(service) {
	      return !!service && service.getVolumes().getItems().length > 0;
	    }
	  }, {
	    key: "hasLoadingError",
	    value: function hasLoadingError() {
	      return this.state.taskDirectoryErrorCount >= 3;
	    }
	  }, {
	    key: "handleOpenLogClick",
	    value: function handleOpenLogClick(selectedLogFile) {
	      var router = this.context.router;
	
	      var routes = this.props.routes;
	      var params = (0, _assign2.default)({}, this.props.params, {
	        filePath: encodeURIComponent(selectedLogFile.get("path")),
	        innerPath: encodeURIComponent(_TaskDirectoryStore2.default.get("innerPath"))
	      });
	      var fileViewerRoutePath = routes[routes.length - 1].fileViewerRoutePath;
	
	      router.push((0, _reactRouter.formatPattern)(fileViewerRoutePath, params));
	    }
	  }, {
	    key: "getBasicInfo",
	    value: function getBasicInfo() {
	      var selectedLogFile = this.state.selectedLogFile;
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(this.props.params.taskID);
	
	      if (task == null) {
	        return null;
	      }
	
	      var service = _DCOSStore2.default.serviceTree.getServiceFromTaskID(task.getId());
	      var taskIcon = _react2.default.createElement("img", { src: task.getImages()["icon-large"] });
	      var filePath = selectedLogFile && selectedLogFile.get("path") || null;
	      var params = (0, _assign2.default)({ filePath: filePath }, this.props.params);
	
	      var tabsArray = this.tabs_getRoutedTabs({ params: params }) || [];
	
	      if (!this.hasVolumes(service)) {
	        tabsArray = tabsArray.filter(function (tab) {
	          if (tab.key === "/nodes/:nodeID/tasks/:taskID/volumes(/:volumeID)" || tab.key === "/services/detail/:id/tasks/:taskID/volumes") {
	            return false;
	          }
	
	          return true;
	        });
	      }
	
	      var navigationTabs = _react2.default.createElement(
	        "ul",
	        { className: "menu-tabbed" },
	        tabsArray
	      );
	
	      var taskState = task.get("state");
	      var serviceStatus = _TaskStates2.default[taskState].displayName;
	      var serviceStatusClassSet = _StatusMapping2.default[serviceStatus] || "";
	
	      return _react2.default.createElement(_DetailViewHeader2.default, {
	        icon: taskIcon,
	        iconClassName: "icon-app-container  icon-image-container",
	        subTitle: serviceStatus,
	        subTitleClassName: serviceStatusClassSet,
	        navigationTabs: navigationTabs,
	        title: task.getName()
	      });
	    }
	  }, {
	    key: "tabs_handleTabClick",
	    value: function tabs_handleTabClick() {
	      this.setState({ selectedLogFile: null });
	
	      // Only call super after we are done removing/adding listeners
	      (0, _get3.default)(TaskDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskDetail.prototype), "tabs_handleTabClick", this).apply(this, arguments);
	    }
	  }, {
	    key: "getNotFound",
	    value: function getNotFound(item, itemID) {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod flush-right flush-left text-align-center" },
	        _react2.default.createElement(
	          "h3",
	          { className: "flush-top text-align-center" },
	          "Error finding " + item
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush" },
	          "Did not find a " + item + " with id \"" + itemID + "\""
	        )
	      );
	    }
	  }, {
	    key: "getBreadcrumbs",
	    value: function getBreadcrumbs() {
	      var _this2 = this;
	
	      var path = _RouterUtil2.default.reconstructPathFromRoutes(this.props.routes);
	      if (HIDE_BREADCRUMBS.includes(path)) {
	        return null;
	      }
	
	      var innerPath = _TaskDirectoryStore2.default.get("innerPath").split("/");
	      var onClickPath = "";
	      var crumbs = innerPath.map(function (directoryItem, index) {
	        var textValue = directoryItem;
	
	        // First breadcrumb is always 'Working Directory'.
	        if (index === 0) {
	          textValue = "Working Directory";
	        } else {
	          onClickPath += "/" + directoryItem;
	        }
	
	        return {
	          className: "clickable",
	          label: textValue,
	          onClick: _this2.handleBreadcrumbClick.bind(_this2, onClickPath)
	        };
	      });
	
	      return _react2.default.createElement(_ManualBreadcrumbs2.default, { crumbs: crumbs });
	    }
	  }, {
	    key: "getSubView",
	    value: function getSubView() {
	      var task = _MesosStateStore2.default.getTaskFromTaskID(this.props.params.taskID);
	      var _state = this.state,
	          directory = _state.directory,
	          selectedLogFile = _state.selectedLogFile;
	
	      if (this.hasLoadingError()) {
	        return this.getErrorScreen();
	      }
	
	      if (!directory || !task) {
	        return this.getLoadingScreen();
	      }
	      var service = _DCOSStore2.default.serviceTree.getServiceFromTaskID(task.getId());
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        this.props.children && _react2.default.cloneElement(this.props.children, {
	          directory: directory,
	          selectedLogFile: selectedLogFile,
	          task: task,
	          onOpenLogClick: this.handleOpenLogClick,
	          service: service
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (_MesosStateStore2.default.get("lastMesosState").slaves == null) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex flex-item-shrink-0 control-group" },
	          this.getBreadcrumbs()
	        ),
	        this.getSubView()
	      );
	    }
	  }]);
	  return TaskDetail;
	}((0, _reactjsMixin2.default)(_InternalStorageMixin2.default, _TabsMixin2.default, _mesosphereSharedReactjs.StoreMixin));
	
	TaskDetail.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	TaskDetail.propTypes = {
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array
	};
	
	module.exports = TaskDetail;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollapsingString = __webpack_require__(1474);
	
	var _CollapsingString2 = _interopRequireDefault(_CollapsingString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailViewHeader = function (_React$Component) {
	  (0, _inherits3.default)(DetailViewHeader, _React$Component);
	
	  function DetailViewHeader() {
	    (0, _classCallCheck3.default)(this, DetailViewHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (DetailViewHeader.__proto__ || (0, _getPrototypeOf2.default)(DetailViewHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DetailViewHeader, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _props = this.props,
	          icon = _props.icon,
	          iconClassName = _props.iconClassName;
	
	
	      if (icon == null) {
	        return null;
	      }
	
	      var iconClasses = (0, _dedupe2.default)("icon icon-large", iconClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "detail-view-header-icon" },
	        _react2.default.createElement(
	          "div",
	          { className: iconClasses },
	          icon
	        )
	      );
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle() {
	      var _props2 = this.props,
	          title = _props2.title,
	          titleClassName = _props2.titleClassName;
	
	
	      if (title == null) {
	        return null;
	      }
	
	      var titleClasses = (0, _dedupe2.default)("h1 flush", titleClassName);
	
	      return _react2.default.createElement(
	        "span",
	        { className: titleClasses },
	        _react2.default.createElement(_CollapsingString2.default, { string: title })
	      );
	    }
	  }, {
	    key: "getSubTitle",
	    value: function getSubTitle() {
	      var _props3 = this.props,
	          subTitle = _props3.subTitle,
	          subTitleClassName = _props3.subTitleClassName;
	
	
	      if (subTitle == null) {
	        return null;
	      }
	
	      var subtitleClasses = (0, _dedupe2.default)("emphasize", subTitleClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { className: subtitleClasses },
	        subTitle
	      );
	    }
	  }, {
	    key: "renderActionButtons",
	    value: function renderActionButtons() {
	      var _props4 = this.props,
	          actionButtons = _props4.actionButtons,
	          buttonCollectionClassNames = _props4.buttonCollectionClassNames;
	
	      var buttonCollectionClasses = (0, _dedupe2.default)("button-collection", buttonCollectionClassNames);
	
	      if (actionButtons.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: buttonCollectionClasses },
	        actionButtons
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props5 = this.props,
	          children = _props5.children,
	          className = _props5.className,
	          detailViewHeaderContentWrapperClassNames = _props5.detailViewHeaderContentWrapperClassNames,
	          detailViewHeaderContentHeadingClassNames = _props5.detailViewHeaderContentHeadingClassNames,
	          navigationTabs = _props5.navigationTabs;
	
	
	      var detailViewHeaderClasses = (0, _dedupe2.default)("detail-view-header flex-item-shrink-0", { "has-tabs": !!navigationTabs }, className);
	
	      var detailViewHeaderContentWrapperClasses = (0, _dedupe2.default)("detail-view-header-content-wrapper", detailViewHeaderContentWrapperClassNames);
	
	      var detailViewHeaderContentHeadingClasses = (0, _dedupe2.default)("detail-view-header-content-heading", detailViewHeaderContentHeadingClassNames);
	
	      return _react2.default.createElement(
	        "div",
	        { className: detailViewHeaderClasses },
	        _react2.default.createElement(
	          "div",
	          { className: detailViewHeaderContentWrapperClasses },
	          _react2.default.createElement(
	            "div",
	            { className: detailViewHeaderContentHeadingClasses },
	            _react2.default.createElement(
	              "div",
	              { className: "detail-view-header-content-primary" },
	              this.getIcon(),
	              _react2.default.createElement(
	                "div",
	                { className: "detail-view-header-title" },
	                this.getTitle()
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "detail-view-header-content-secondary" },
	              this.renderActionButtons()
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "detail-view-header-sub-heading" },
	            this.getSubTitle()
	          )
	        ),
	        children,
	        navigationTabs
	      );
	    }
	  }]);
	  return DetailViewHeader;
	}(_react2.default.Component);
	
	var classPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	DetailViewHeader.defaultProps = {
	  actionButtons: []
	};
	
	DetailViewHeader.propTypes = {
	  actionButtons: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element),
	  icon: _react2.default.PropTypes.node,
	  navigationTabs: _react2.default.PropTypes.node,
	  subTitle: _react2.default.PropTypes.node,
	  title: _react2.default.PropTypes.string,
	
	  className: classPropType,
	  detailViewHeaderClassNames: classPropType,
	  detailViewHeaderContentHeadingClassNames: classPropType,
	  detailViewHeaderContentWrapperClassNames: classPropType,
	  titleClassName: classPropType,
	  iconClassName: classPropType,
	  subTitleClassName: classPropType
	};
	
	module.exports = DetailViewHeader;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _BreadcrumbSegmentLink = __webpack_require__(1493);
	
	var _BreadcrumbSegmentLink2 = _interopRequireDefault(_BreadcrumbSegmentLink);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLLAPSE_BUFFER = 12;
	var LAST_ITEM_OFFSET = 150; // Difference between scrollWidth and outerWidth
	var PADDED_ICON_WIDTH = 38; // Width of icon + padding
	
	var ManualBreadcrumbs = function (_React$Component) {
	  (0, _inherits3.default)(ManualBreadcrumbs, _React$Component);
	
	  function ManualBreadcrumbs() {
	    (0, _classCallCheck3.default)(this, ManualBreadcrumbs);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ManualBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(ManualBreadcrumbs)).apply(this, arguments));
	
	    _this.state = {
	      availableWidth: null,
	      collapsed: false,
	      expandedWidth: null
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ManualBreadcrumbs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (global != null) {
	        global.addEventListener("resize", this.handleResize);
	        global.addEventListener("focus", this.handleResize);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateDimensions();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (global != null) {
	        global.removeEventListener("resize", this.handleResize);
	        global.removeEventListener("focus", this.handleResize);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextState.availableWidth == null || nextState.expandedWidth == null) {
	        this.updateDimensions();
	
	        return false;
	      }
	      if (this.state.collapsed !== nextState.collapsed) {
	        return true;
	      }
	
	      return !(0, _deepEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var availableWidth = this.getAvailableWidth();
	
	      this.setState({
	        availableWidth: availableWidth,
	        collapsed: this.shouldCollapse(availableWidth, this.state.expandedWidth)
	      });
	    }
	  }, {
	    key: "updateDimensions",
	    value: function updateDimensions() {
	      var availableWidth = this.getAvailableWidth();
	      var expandedWidth = this.getExpandedWidth();
	
	      this.setState({
	        availableWidth: availableWidth,
	        expandedWidth: expandedWidth,
	        collapsed: this.shouldCollapse(availableWidth, expandedWidth)
	      });
	    }
	  }, {
	    key: "getAvailableWidth",
	    value: function getAvailableWidth() {
	      return _reactDom2.default.findDOMNode(this).offsetWidth;
	    }
	  }, {
	    key: "getWidthFromExpandedItem",
	    value: function getWidthFromExpandedItem(item) {
	      return item.offsetWidth + PADDED_ICON_WIDTH;
	    }
	  }, {
	    key: "getWidthFromCollapsedItem",
	    value: function getWidthFromCollapsedItem(item) {
	      var link = item.children[0];
	      var textWidth = link.scrollWidth - link.offsetWidth;
	
	      return textWidth + PADDED_ICON_WIDTH;
	    }
	  }, {
	    key: "getExpandedWidth",
	    value: function getExpandedWidth() {
	      var _this2 = this;
	
	      // array/splat casts NodeList to array
	      var listItems = [].concat((0, _toConsumableArray3.default)(_reactDom2.default.findDOMNode(this).children)).filter(function (_, index) {
	        // Filter out even nodes containing '>'
	        return index % 2 === 0;
	      });
	
	      return listItems.map(function (item, index) {
	        var isFirstItem = index === 0;
	        var isLastItem = index === listItems.length - 1;
	        if (isFirstItem || isLastItem) {
	          return _this2.getWidthFromExpandedItem(item);
	        }
	
	        return _this2.getWidthFromCollapsedItem(item);
	      }).reduce(function (totalWidth, itemWidth) {
	        return totalWidth + itemWidth;
	      }, this.getLastItemWidth());
	    }
	  }, {
	    key: "getLastItemWidth",
	    value: function getLastItemWidth() {
	      var lastItem = _reactDom2.default.findDOMNode(this).lastChild;
	
	      if (!lastItem || !lastItem.firstChild) {
	        return LAST_ITEM_OFFSET;
	      }
	
	      var lastItemLink = lastItem.firstChild;
	
	      return lastItemLink.scrollWidth + LAST_ITEM_OFFSET;
	    }
	  }, {
	    key: "wrapListItem",
	    value: function wrapListItem(breadcrumb, key) {
	      return _react2.default.createElement(
	        "li",
	        { className: "flush", key: key },
	        breadcrumb
	      );
	    }
	  }, {
	    key: "getBreadcrumb",
	    value: function getBreadcrumb(breadcrumb, key) {
	      if (!_react2.default.isValidElement(breadcrumb)) {
	        if (typeof breadcrumb === "string") {
	          breadcrumb = { label: breadcrumb };
	        }
	
	        breadcrumb = _react2.default.createElement(_BreadcrumbSegmentLink2.default, breadcrumb);
	      }
	
	      return this.wrapListItem(breadcrumb, key);
	    }
	  }, {
	    key: "getBreadcrumbDivider",
	    value: function getBreadcrumbDivider(key) {
	      return _react2.default.createElement(
	        "li",
	        { className: "flush", key: key },
	        _react2.default.createElement(_Icon2.default, { id: "caret-right", size: "mini" })
	      );
	    }
	  }, {
	    key: "shouldCollapse",
	    value: function shouldCollapse(availableWidth, expandedWidth) {
	      // Smooth collapse action to prevent flickering between states
	      if (this.state.collapsed) {
	        return expandedWidth >= availableWidth - COLLAPSE_BUFFER;
	      }
	
	      return expandedWidth >= availableWidth + COLLAPSE_BUFFER;
	    }
	  }, {
	    key: "renderCrumbs",
	    value: function renderCrumbs(crumbs) {
	      var _this3 = this;
	
	      var crumbKey = 0;
	
	      return crumbs.reduce(function (memo, crumb, crumbIndex) {
	        memo.push(_this3.getBreadcrumb(crumb, ++crumbKey));
	
	        if (crumbs.length - 1 !== crumbIndex) {
	          memo.push(_this3.getBreadcrumbDivider(++crumbKey));
	        }
	
	        return memo;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classSet = (0, _classnames2.default)("breadcrumb list list-inline list-unstyled h4 flush-top flush-left", { collapsed: this.state.collapsed }, this.props.breadcrumbClasses);
	
	      return _react2.default.createElement(
	        "ol",
	        { className: classSet },
	        this.renderCrumbs(this.props.crumbs)
	      );
	    }
	  }]);
	  return ManualBreadcrumbs;
	}(_react2.default.Component);
	
	ManualBreadcrumbs.defaultProps = {
	  crumbs: []
	};
	
	ManualBreadcrumbs.propTypes = {
	  breadcrumbClasses: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object, _react.PropTypes.string]),
	  crumbs: _react.PropTypes.array
	};
	
	module.exports = ManualBreadcrumbs;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreadcrumbSegmentLink = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbSegmentLink, _React$Component);
	
	  function BreadcrumbSegmentLink() {
	    (0, _classCallCheck3.default)(this, BreadcrumbSegmentLink);
	    return (0, _possibleConstructorReturn3.default)(this, (BreadcrumbSegmentLink.__proto__ || (0, _getPrototypeOf2.default)(BreadcrumbSegmentLink)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BreadcrumbSegmentLink, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	
	      var content = props.label;
	
	      if (props.route) {
	        var _props$route = props.route,
	            to = _props$route.to,
	            params = _props$route.params;
	
	
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: props.className,
	            to: (0, _reactRouter.formatPattern)(to, params),
	            title: content
	          },
	          content
	        );
	      } else if (props.onClick) {
	        return _react2.default.createElement(
	          "a",
	          { className: props.className, onClick: props.onClick, title: content },
	          content
	        );
	      } else {
	        return _react2.default.createElement(
	          "span",
	          null,
	          content
	        );
	      }
	    }
	  }]);
	  return BreadcrumbSegmentLink;
	}(_react2.default.Component);
	
	BreadcrumbSegmentLink.propTypes = {
	  label: _react.PropTypes.string.isRequired,
	  route: _react.PropTypes.object
	};
	
	module.exports = BreadcrumbSegmentLink;

/***/ },
/* 1494 */
/***/ function(module, exports) {

	"use strict";
	
	var StatusMapping = {
	  Running: "service-running-state"
	};
	
	module.exports = StatusMapping;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _ActionTypes2 = __webpack_require__(1223);
	
	var _EventTypes = __webpack_require__(1103);
	
	var _TaskDirectory = __webpack_require__(1496);
	
	var _TaskDirectory2 = _interopRequireDefault(_TaskDirectory);
	
	var _TaskDirectoryActions = __webpack_require__(1498);
	
	var _TaskDirectoryActions2 = _interopRequireDefault(_TaskDirectoryActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = null;
	var activeXHR = null;
	
	function fetchState(task, innerPath) {
	  var node = _MesosStateStore2.default.getNodeFromID(task.slave_id);
	  activeXHR = _TaskDirectoryActions2.default.fetchNodeState(task, node, innerPath);
	}
	
	function startPolling(task, innerPath) {
	  if (requestInterval == null) {
	    fetchState(task, innerPath);
	
	    requestInterval = setInterval(fetchState.bind(this, task, innerPath), _Config2.default.getRefreshRate());
	  }
	}
	
	var TaskDirectoryStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(TaskDirectoryStore, _GetSetBaseStore);
	
	  function TaskDirectoryStore() {
	    (0, _classCallCheck3.default)(this, TaskDirectoryStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskDirectoryStore.__proto__ || (0, _getPrototypeOf2.default)(TaskDirectoryStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      directory: null,
	      innerPath: ""
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        error: _EventTypes.TASK_DIRECTORY_ERROR,
	        success: _EventTypes.TASK_DIRECTORY_CHANGE,
	        nodeStateError: _ActionTypes2.REQUEST_NODE_STATE_ERROR,
	        nodeStateSuccess: _ActionTypes2.REQUEST_NODE_STATE_SUCCESS
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var _payload$action = payload.action,
	          data = _payload$action.data,
	          innerPath = _payload$action.innerPath,
	          task = _payload$action.task,
	          type = _payload$action.type;
	
	      switch (type) {
	        case _ActionTypes2.REQUEST_TASK_DIRECTORY_SUCCESS:
	          _this.processStateSuccess(data, innerPath, task.id);
	          break;
	        case _ActionTypes2.REQUEST_TASK_DIRECTORY_ERROR:
	          _this.emit(_EventTypes.TASK_DIRECTORY_ERROR, task.id);
	          break;
	        case _ActionTypes2.REQUEST_NODE_STATE_ERROR:
	          _this.emit(_EventTypes.NODE_STATE_ERROR, task.id);
	          break;
	        case _ActionTypes2.REQUEST_NODE_STATE_SUCCESS:
	          activeXHR = _TaskDirectoryActions2.default.fetchDirectory(task, innerPath, data);
	          _this.emit(_EventTypes.NODE_STATE_SUCCESS, task.id);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskDirectoryStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (this.listeners(_EventTypes.TASK_DIRECTORY_CHANGE).length === 0) {
	        this.resetRequests();
	        this.set({ innerPath: "", directory: null });
	      }
	    }
	  }, {
	    key: "resetRequests",
	    value: function resetRequests() {
	      if (requestInterval != null) {
	        clearInterval(requestInterval);
	        requestInterval = null;
	      }
	
	      if (activeXHR != null) {
	        activeXHR.abort();
	        activeXHR = null;
	      }
	    }
	
	    // Default innerPath to empty string so it matches with default innerPath
	
	  }, {
	    key: "fetchDirectory",
	    value: function fetchDirectory(task) {
	      var innerPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	      this.resetRequests();
	      this.set({ directory: null });
	      // Make sure to update innerPath if different before fetching
	      if (this.get("innerPath") !== innerPath) {
	        this.set({ innerPath: innerPath });
	      }
	
	      this.emit(_EventTypes.TASK_DIRECTORY_CHANGE, task.id);
	      startPolling(task, innerPath);
	    }
	  }, {
	    key: "addPath",
	    value: function addPath(task, path) {
	      this.set({ innerPath: this.get("innerPath") + "/" + path });
	      this.fetchDirectory(task, this.get("innerPath"));
	    }
	  }, {
	    key: "setPath",
	    value: function setPath(task, path) {
	      this.set({ innerPath: path });
	      this.fetchDirectory(task, path);
	    }
	  }, {
	    key: "processStateSuccess",
	    value: function processStateSuccess(items, innerPath, taskID) {
	      // Only update when receiving response from what was requested
	      if (this.get("innerPath") === innerPath) {
	        this.set({ directory: new _TaskDirectory2.default({ items: items }) });
	        this.emit(_EventTypes.TASK_DIRECTORY_CHANGE, taskID);
	      }
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "taskDirectory";
	    }
	  }]);
	  return TaskDirectoryStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new TaskDirectoryStore();

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _DirectoryItem = __webpack_require__(1497);
	
	var _DirectoryItem2 = _interopRequireDefault(_DirectoryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskDirectory = function (_List) {
	  (0, _inherits3.default)(TaskDirectory, _List);
	
	  function TaskDirectory() {
	    (0, _classCallCheck3.default)(this, TaskDirectory);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskDirectory.__proto__ || (0, _getPrototypeOf2.default)(TaskDirectory)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskDirectory, [{
	    key: "findFile",
	    value: function findFile(name) {
	      return this.getItems().find(function (file) {
	        return file.getName() === name;
	      });
	    }
	  }]);
	  return TaskDirectory;
	}(_List3.default);
	
	TaskDirectory.type = _DirectoryItem2.default;
	
	module.exports = TaskDirectory;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISPLAY_NAMES = {
	  stdout: "Output (stdout)",
	  stderr: "Error (stderr)"
	};
	
	var DirectoryItem = function (_Item) {
	  (0, _inherits3.default)(DirectoryItem, _Item);
	
	  function DirectoryItem() {
	    (0, _classCallCheck3.default)(this, DirectoryItem);
	    return (0, _possibleConstructorReturn3.default)(this, (DirectoryItem.__proto__ || (0, _getPrototypeOf2.default)(DirectoryItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DirectoryItem, [{
	    key: "getDisplayName",
	    value: function getDisplayName() {
	      var name = this.getName();
	      var displayName = DISPLAY_NAMES[name];
	      if (displayName) {
	        return displayName;
	      }
	
	      return _StringUtil2.default.capitalize(name);
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.get("path").replace(/^.*\//, "");
	    }
	  }, {
	    key: "isDirectory",
	    value: function isDirectory() {
	      // DirectoryItem is a directory if nlink is greater than 1.
	      return this.get("nlink") > 1;
	    }
	  }, {
	    key: "isLogFile",
	    value: function isLogFile() {
	      return !this.isDirectory();
	    }
	  }]);
	  return DirectoryItem;
	}(_Item3.default);
	
	module.exports = DirectoryItem;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _MesosStateUtil = __webpack_require__(1262);
	
	var _MesosStateUtil2 = _interopRequireDefault(_MesosStateUtil);
	
	var _ActionTypes = __webpack_require__(1223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNodeStateURL(task, node) {
	  var pid = void 0,
	      nodePID = void 0;
	
	  if (node) {
	    pid = node.pid;
	  }
	
	  if (pid) {
	    nodePID = pid.substring(0, pid.indexOf("@"));
	  }
	
	  return _Config2.default.rootUrl + "/agent/" + task.slave_id + "/" + nodePID + "/state";
	}
	
	var TaskDirectoryActions = {
	  getDownloadURL: function getDownloadURL(nodeID, path) {
	    return _Config2.default.rootUrl + "/agent/" + nodeID + "/files/download?path=" + path;
	  },
	
	
	  fetchNodeState: _mesosphereSharedReactjs.RequestUtil.debounceOnError(_Config2.default.getRefreshRate(), function (resolve, reject) {
	    return function (task, node, innerPath) {
	      return _mesosphereSharedReactjs.RequestUtil.json({
	        url: getNodeStateURL(task, node),
	        success: function success(response) {
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_NODE_STATE_SUCCESS,
	            data: response,
	            task: task,
	            node: node,
	            innerPath: innerPath
	          });
	          resolve();
	        },
	        error: function error(xhr) {
	          if (xhr.statusText === "abort") {
	            resolve();
	
	            return;
	          }
	
	          _AppDispatcher2.default.handleServerAction({
	            type: _ActionTypes.REQUEST_NODE_STATE_ERROR,
	            data: xhr.message,
	            task: task,
	            node: node,
	            xhr: xhr
	          });
	          reject();
	        }
	      });
	    };
	  }, { delayAfterCount: _Config2.default.delayAfterErrorCount }),
	
	  fetchDirectory: function fetchDirectory(task, innerPath, nodeState) {
	    var path = _MesosStateUtil2.default.getTaskPath(nodeState, task, innerPath);
	    if (path == null) {
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_TASK_DIRECTORY_ERROR,
	        task: task
	      });
	
	      return;
	    }
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/agent/" + task.slave_id + "/files/browse",
	      data: { path: path },
	      success: function success(directory) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_TASK_DIRECTORY_SUCCESS,
	          data: directory,
	          innerPath: innerPath,
	          task: task
	        });
	      },
	      error: function error(xhr) {
	        if (xhr.statusText === "abort") {
	          return;
	        }
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_TASK_DIRECTORY_ERROR,
	          data: xhr.message,
	          task: task,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	module.exports = TaskDirectoryActions;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _ResourcesUtil = __webpack_require__(1500);
	
	var _ResourcesUtil2 = _interopRequireDefault(_ResourcesUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _MarathonTaskDetailsList = __webpack_require__(1501);
	
	var _MarathonTaskDetailsList2 = _interopRequireDefault(_MarathonTaskDetailsList);
	
	var _TaskDirectoryStore = __webpack_require__(1495);
	
	var _TaskDirectoryStore2 = _interopRequireDefault(_TaskDirectoryStore);
	
	var _TaskEndpointsList = __webpack_require__(1502);
	
	var _TaskEndpointsList2 = _interopRequireDefault(_TaskEndpointsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskDetailsTab = function (_React$Component) {
	  (0, _inherits3.default)(TaskDetailsTab, _React$Component);
	
	  function TaskDetailsTab() {
	    (0, _classCallCheck3.default)(this, TaskDetailsTab);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskDetailsTab.__proto__ || (0, _getPrototypeOf2.default)(TaskDetailsTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskDetailsTab, [{
	    key: "getContainerInfo",
	    value: function getContainerInfo(task) {
	      if (task == null || !task.container) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Container Configuration"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            "pre",
	            { className: "flex-item-grow-1 mute prettyprint flush-bottom" },
	            (0, _stringify2.default)(task.container, null, 4)
	          )
	        )
	      );
	    }
	  }, {
	    key: "getMesosTaskDetails",
	    value: function getMesosTaskDetails(mesosTask) {
	      if (mesosTask == null) {
	        return null;
	      }
	
	      var services = _CompositeState2.default.getServiceList();
	      var service = services.filter({ ids: [mesosTask.framework_id] }).last();
	      var node = _CompositeState2.default.getNodesList().filter({ ids: [mesosTask.slave_id] }).last();
	      var sandBoxPath = _TaskDirectoryStore2.default.get("sandBoxPath");
	
	      var serviceRow = null;
	      var nodeRow = null;
	      var sandBoxRow = null;
	      var resourceRows = null;
	
	      if (mesosTask.resources != null) {
	        var resourceLabels = _ResourcesUtil2.default.getResourceLabels();
	
	        resourceRows = _ResourcesUtil2.default.getDefaultResources().map(function (resource, index) {
	          return _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            { key: index },
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              resourceLabels[resource]
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              _Units2.default.formatResource(resource, mesosTask.resources[resource])
	            )
	          );
	        });
	      }
	
	      if (service != null) {
	        serviceRow = _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Service"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            service.name,
	            " (",
	            service.id,
	            ")"
	          )
	        );
	      }
	
	      if (node != null) {
	        nodeRow = _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Node"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            node.getHostName(),
	            " (",
	            node.getID(),
	            ")"
	          )
	        );
	      }
	
	      if (sandBoxPath) {
	        sandBoxRow = _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Sandbox Path"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            sandBoxPath
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Configuration"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Task ID"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            mesosTask.id
	          )
	        ),
	        serviceRow,
	        nodeRow,
	        sandBoxRow,
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Endpoints"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            _react2.default.createElement(_TaskEndpointsList2.default, { task: mesosTask, node: node })
	          )
	        ),
	        resourceRows
	      );
	    }
	  }, {
	    key: "getMesosTaskLabels",
	    value: function getMesosTaskLabels(mesosTask) {
	      if (mesosTask == null) {
	        return null;
	      }
	
	      var labelRows = null;
	
	      if (mesosTask.labels) {
	        labelRows = mesosTask.labels.map(function (_ref) {
	          var key = _ref.key,
	              value = _ref.value;
	
	          return _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            { key: key },
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              key
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              value
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Labels"
	        ),
	        labelRows
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var task = this.props.task;
	
	
	      if (!_MesosSummaryStore2.default.get("statesProcessed")) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          this.getMesosTaskDetails(task),
	          this.getMesosTaskLabels(task),
	          _react2.default.createElement(_MarathonTaskDetailsList2.default, { taskID: task.id }),
	          this.getContainerInfo(task)
	        )
	      );
	    }
	  }]);
	  return TaskDetailsTab;
	}(_react2.default.Component);
	
	TaskDetailsTab.propTypes = {
	  task: _react2.default.PropTypes.object
	};
	
	TaskDetailsTab.defaultProps = {
	  task: {}
	};
	
	module.exports = TaskDetailsTab;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultResourceTypes = {
	  cpus: { label: "CPU", colorID: 0 },
	  mem: { label: "Memory", colorID: 6 },
	  disk: { label: "Disk", colorID: 3 }
	};
	
	// Let's create an instance of a Node with our default resources
	var fakeUsedResources = (0, _keys2.default)(DefaultResourceTypes).reduce(function (memo, resource) {
	  memo[resource] = 0;
	
	  return memo;
	}, {});
	var fakeNode = new _Node2.default({ used_resources: fakeUsedResources });
	
	var usedColors = (0, _keys2.default)(DefaultResourceTypes).map(function (resource) {
	  return DefaultResourceTypes[resource].colorID;
	});
	var availableColors = Array(9).fill().map(function (value, index) {
	  return index;
	}).filter(function (value) {
	  return usedColors.indexOf(value) === -1;
	});
	
	function getAvailableColors() {
	  var colors = availableColors.slice(0);
	
	  // Concat the array twice. In case there's many resources.
	  // Unlikely that there will more than 4 anyways.
	  return colors.concat(colors);
	}
	
	var ResourcesUtil = {
	  getDefaultResources: function getDefaultResources() {
	    return (0, _keys2.default)(DefaultResourceTypes);
	  },
	  getAvailableResources: function getAvailableResources() {
	    var excludeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var item = _CompositeState2.default.getNodesList().getItems()[0];
	
	    if (!item) {
	      item = _CompositeState2.default.getServiceList().getItems()[0];
	
	      if (!item) {
	        item = fakeNode;
	      }
	    }
	
	    var resources = (0, _keys2.default)(item.get("used_resources"));
	
	    if (excludeList.length > 0) {
	      resources = resources.filter(function (resource) {
	        // If it's not in the exclude list, we want it
	        return excludeList.indexOf(resource) === -1;
	      });
	    }
	
	    return resources;
	  },
	  getAdditionalResources: function getAdditionalResources() {
	    var rest = this.getAvailableResources(this.getDefaultResources());
	    // We sort so we get the same color in future calls to this method
	    rest.sort();
	
	    return rest;
	  },
	  getResourceLabel: function getResourceLabel(resource) {
	    if (DefaultResourceTypes[resource]) {
	      return DefaultResourceTypes[resource].label;
	    }
	
	    // If the resource name is 3 characters or less, let's uppercase it all
	    // otherwise we only capitalize the first letter.
	    if (resource.length <= 3) {
	      return resource.toUpperCase();
	    } else {
	      return _StringUtil2.default.capitalize(resource.toLowerCase());
	    }
	  },
	  getResourceLabels: function getResourceLabels() {
	    var _this = this;
	
	    var resources = this.getAvailableResources();
	
	    return resources.reduce(function (memo, resource) {
	      memo[resource] = _this.getResourceLabel(resource);
	
	      return memo;
	    }, {});
	  },
	  getResourceColor: function getResourceColor(resource) {
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (DefaultResourceTypes[resource]) {
	      return DefaultResourceTypes[resource].colorID;
	    }
	
	    if (!opts.availableColors) {
	      opts.availableColors = getAvailableColors();
	    }
	    if (!opts.resourceList) {
	      // We only want the ones for which there are no defaults, that way
	      // we're not skipping colors down below when we just grab an index
	      // of the available colors.
	      opts.resourceList = this.getAdditionalResources();
	    }
	
	    var index = opts.resourceList.indexOf(resource);
	
	    return opts.availableColors[index];
	  },
	  getResourceColors: function getResourceColors() {
	    var _this2 = this;
	
	    // Map the default ones first
	    var map = this.getDefaultResources().reduce(function (memo, resource) {
	      memo[resource] = _this2.getResourceColor(resource);
	
	      return memo;
	    }, {});
	
	    var rest = this.getAdditionalResources();
	
	    // Map the rest
	    return rest.reduce(function (memo, resource) {
	      memo[resource] = _this2.getResourceColor(resource, {
	        resourceList: rest
	      });
	
	      return memo;
	    }, map);
	  }
	};
	
	module.exports = ResourcesUtil;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarathonTaskDetailsList = function (_React$Component) {
	  (0, _inherits3.default)(MarathonTaskDetailsList, _React$Component);
	
	  function MarathonTaskDetailsList() {
	    (0, _classCallCheck3.default)(this, MarathonTaskDetailsList);
	    return (0, _possibleConstructorReturn3.default)(this, (MarathonTaskDetailsList.__proto__ || (0, _getPrototypeOf2.default)(MarathonTaskDetailsList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MarathonTaskDetailsList, [{
	    key: "getTaskPorts",
	    value: function getTaskPorts(task) {
	      var ports = task.ports;
	
	      if (!ports || !ports.length) {
	        return "None";
	      }
	
	      return ports.join(", ");
	    }
	  }, {
	    key: "getTaskStatus",
	    value: function getTaskStatus(task) {
	      if (task == null || task.state == null) {
	        return "Unknown";
	      }
	
	      return _TaskStates2.default[task.state].displayName;
	    }
	  }, {
	    key: "getTimeField",
	    value: function getTimeField(time) {
	      var timeString = "Never";
	
	      if (time != null) {
	        timeString = new Date(time).toLocaleString();
	      }
	
	      return _react2.default.createElement(
	        "time",
	        { dateTime: time, title: time },
	        timeString
	      );
	    }
	  }, {
	    key: "getMarathonTaskDetails",
	    value: function getMarathonTaskDetails(task) {
	      if (task == null) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Marathon Task Configuration"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Host"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            task.host
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Ports"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getTaskPorts(task)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Status"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getTaskStatus(task)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Staged at"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getTimeField(task.stagedAt)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Started at"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getTimeField(task.startedAt)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Version"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            task.version
	          )
	        )
	      );
	    }
	  }, {
	    key: "getMarathonTaskHealthCheckResults",
	    value: function getMarathonTaskHealthCheckResults(task) {
	      var _this2 = this;
	
	      if (task == null || task.healthCheckResults == null) {
	        return null;
	      }
	
	      return task.healthCheckResults.map(function (result, i) {
	        var consecutiveFailures = result.consecutiveFailures;
	        var alive = "Yes";
	
	        if (consecutiveFailures == null) {
	          consecutiveFailures = "None";
	        }
	
	        if (!result.alive) {
	          alive = "No";
	        }
	
	        return _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: i },
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            null,
	            "Health Check Result ",
	            i + 1
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "First success"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              _this2.getTimeField(result.firstSuccess)
	            )
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "Last success"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              _this2.getTimeField(result.lastSuccess)
	            )
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "Last failure"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              _this2.getTimeField(result.lastFailure)
	            )
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "Consecutive failures"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              consecutiveFailures
	            )
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "Alive"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapValue2.default,
	              null,
	              alive
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var marathonTask = _DCOSStore2.default.serviceTree.getTaskFromTaskID(this.props.taskID);
	      var taskConfiguration = this.getMarathonTaskDetails(marathonTask);
	      var healthCheckResults = this.getMarathonTaskHealthCheckResults(marathonTask);
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        taskConfiguration,
	        healthCheckResults
	      );
	    }
	  }]);
	  return MarathonTaskDetailsList;
	}(_react2.default.Component);
	
	MarathonTaskDetailsList.propTypes = {
	  taskID: _react2.default.PropTypes.string.isRequired
	};
	
	module.exports = MarathonTaskDetailsList;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _TaskUtil = __webpack_require__(1503);
	
	var _TaskUtil2 = _interopRequireDefault(_TaskUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getEndpointsList", "getPortsList", "getShowHideLink", "handlePortsToggle"];
	
	var TaskEndpointsList = function (_React$Component) {
	  (0, _inherits3.default)(TaskEndpointsList, _React$Component);
	
	  function TaskEndpointsList() {
	    (0, _classCallCheck3.default)(this, TaskEndpointsList);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskEndpointsList.__proto__ || (0, _getPrototypeOf2.default)(TaskEndpointsList)).call(this));
	
	    _this.state = {
	      expandedHosts: []
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskEndpointsList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _deepEqual2.default)(this.props.task, nextProps.task) || !(0, _deepEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: "getNullList",
	    value: function getNullList() {
	      return _react2.default.createElement(
	        "span",
	        null,
	        "N/A"
	      );
	    }
	  }, {
	    key: "getEndpointsList",
	    value: function getEndpointsList(hosts) {
	      var _this2 = this;
	
	      var ports = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      var totalPortCount = ports.length;
	
	      return hosts.map(function (host, hostIndex) {
	        var isExpanded = _this2.state.expandedHosts.includes(host);
	        var portLimit = _this2.props.portLimit;
	
	        var portsEl = null;
	        var showHideLink = null;
	
	        if (isExpanded) {
	          portLimit = totalPortCount;
	        }
	
	        var renderedPorts = ports.slice(0, portLimit);
	
	        if (renderedPorts.length < totalPortCount || isExpanded) {
	          showHideLink = _this2.getShowHideLink(totalPortCount - portLimit, host, isExpanded);
	        }
	
	        var portLinks = _this2.getPortsList(renderedPorts, host, hostIndex, isExpanded);
	
	        if (totalPortCount > 0) {
	          portsEl = _react2.default.createElement(
	            "span",
	            null,
	            ": [",
	            portLinks,
	            showHideLink,
	            "]"
	          );
	        } else {
	          host = _react2.default.createElement(
	            "a",
	            { href: "//" + host, target: "_blank" },
	            host
	          );
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { key: hostIndex },
	          host,
	          portsEl
	        );
	      });
	    }
	  }, {
	    key: "getPortsList",
	    value: function getPortsList(ports, host, hostIndex, isExpanded) {
	      var _this3 = this;
	
	      return ports.map(function (port, portIndex) {
	        var separator = ", ";
	
	        if (portIndex === ports.length - 1 || portIndex === _this3.props.portLimit - 1 && !isExpanded) {
	          separator = null;
	        }
	
	        return _react2.default.createElement(
	          "span",
	          { key: hostIndex + ":" + portIndex },
	          _react2.default.createElement(
	            "a",
	            { href: "//" + host + ":" + port, target: "_blank" },
	            port
	          ),
	          separator
	        );
	      });
	    }
	  }, {
	    key: "getShowHideLink",
	    value: function getShowHideLink(remainingPorts, host, isExpanded) {
	      var showHideText = remainingPorts + " more...";
	
	      if (isExpanded) {
	        showHideText = "less";
	      }
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        ", ",
	        _react2.default.createElement(
	          "a",
	          {
	            className: "clickable",
	            onClick: this.handlePortsToggle.bind(this, host)
	          },
	          showHideText
	        )
	      );
	    }
	  }, {
	    key: "handlePortsToggle",
	    value: function handlePortsToggle(host) {
	      // Prevent mutating state.
	      var expandedHosts = (0, _assign2.default)([], this.state.expandedHosts);
	      var hostIndex = expandedHosts.indexOf(host);
	
	      if (hostIndex > -1) {
	        expandedHosts.splice(hostIndex, 1);
	      } else {
	        expandedHosts.push(host);
	      }
	
	      this.setState({ expandedHosts: expandedHosts });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          node = _props.node,
	          task = _props.task;
	
	      if (task == null) {
	        return this.getNullList();
	      }
	
	      var _TaskUtil$getHostAndP = _TaskUtil2.default.getHostAndPortList(task, node),
	          hosts = _TaskUtil$getHostAndP.hosts,
	          ports = _TaskUtil$getHostAndP.ports;
	
	      var totalPortCount = ports.length;
	
	      if (hosts.length === 0 && totalPortCount === 0) {
	        return this.getNullList();
	      }
	
	      var content = null;
	
	      if (hosts.length === 1 && totalPortCount === 1) {
	        var url = hosts[0] + ":" + ports[0];
	        content = _react2.default.createElement(
	          "a",
	          { href: "//" + url, target: "_blank" },
	          url
	        );
	      } else {
	        content = this.getEndpointsList(hosts, ports);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "task-endpoint-list" },
	        content
	      );
	    }
	  }]);
	  return TaskEndpointsList;
	}(_react2.default.Component);
	
	TaskEndpointsList.defaultProps = {
	  portLimit: 3
	};
	
	TaskEndpointsList.propTypes = {
	  portLimit: _react2.default.PropTypes.number,
	  task: _react2.default.PropTypes.object,
	  node: _react2.default.PropTypes.object
	};
	
	module.exports = TaskEndpointsList;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var TaskUtil = {
	  /**
	   * Returns a list of ips or hosts from task
	   * @param  {object} task to return ip or host list from
	   * @param  {object} node to get host name from, if necessary
	   * @return {Array.<string>} an array of ip addresses or hosts
	   */
	  getHostAndPortList: function getHostAndPortList() {
	    var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var node = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _Node2.default();
	
	    var networkType = this.getNetworkType(task);
	    var ports = this.getPorts(task);
	    var hostName = node.getHostName();
	
	    // networkType is 'HOST', but no host name
	    if (networkType !== "BRIDGE" && networkType !== "USER" && !hostName) {
	      return { ports: [], hosts: [] };
	    }
	
	    // networkType is 'HOST'
	    if (networkType !== "BRIDGE" && networkType !== "USER") {
	      return { ports: ports, hosts: [hostName] };
	    }
	
	    // networkType is 'BRIDGE' or 'USER'
	    var portMappings = this.getPortMappings(task) || [];
	    if (portMappings.length) {
	      return {
	        ports: portMappings.map(function (mapping) {
	          return mapping.host_port;
	        }),
	        hosts: [hostName]
	      };
	    }
	
	    return { ports: ports, hosts: this.getIPAddresses(task) };
	  },
	
	
	  /**
	   * Returns a list of ports, if ports is available in discovery it will return
	   * those, otherwise it will fall back on ports property on the task
	   * @param  {object} task to return ports from
	   * @return {Array.<number>} an array of port numbers
	   */
	  getPorts: function getPorts() {
	    var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var ports = _Util2.default.findNestedPropertyInObject(task, "discovery.ports.ports");
	
	    // If there are no service ports, use task ports
	    if (!ports || !ports.length) {
	      return task.ports || [];
	    }
	
	    return ports.map(function (port) {
	      return port.number;
	    });
	  },
	  getTaskStatusSlug: function getTaskStatusSlug(task) {
	    return task.state.substring("TASK_".length).toLowerCase();
	  },
	  getTaskStatusClassName: function getTaskStatusClassName(task) {
	    var taskStatus = TaskUtil.getTaskStatusSlug(task);
	
	    return "task-status-" + taskStatus;
	  },
	  getPortMappings: function getPortMappings(task) {
	    var container = task.container;
	
	    if (!container || !container.type) {
	      return null;
	    }
	
	    var portMappings = _Util2.default.findNestedPropertyInObject(container, container.type.toLowerCase() + ".port_mappings");
	
	    if (!Array.isArray(portMappings)) {
	      return null;
	    }
	
	    return portMappings;
	  },
	  getNetworkType: function getNetworkType(task) {
	    var container = task.container;
	
	    if (!container || !container.type) {
	      return null;
	    }
	
	    return _Util2.default.findNestedPropertyInObject(container, container.type.toLowerCase() + ".network");
	  },
	  getIPAddresses: function getIPAddresses(task) {
	    var ipAddresses = _Util2.default.findNestedPropertyInObject(task, "statuses.0.container_status.network_infos.0.ip_addresses") || [];
	
	    return ipAddresses.map(function (item) {
	      return item.ip_address;
	    });
	  }
	}; /* eslint-disable no-unused-vars */
	
	
	module.exports = TaskUtil;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TaskDirectoryTable = __webpack_require__(1505);
	
	var _TaskDirectoryTable2 = _interopRequireDefault(_TaskDirectoryTable);
	
	var _TaskDirectoryStore = __webpack_require__(1495);
	
	var _TaskDirectoryStore2 = _interopRequireDefault(_TaskDirectoryStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleFileClick"];
	
	var TaskFileBrowser = function (_React$Component) {
	  (0, _inherits3.default)(TaskFileBrowser, _React$Component);
	
	  function TaskFileBrowser() {
	    (0, _classCallCheck3.default)(this, TaskFileBrowser);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskFileBrowser.__proto__ || (0, _getPrototypeOf2.default)(TaskFileBrowser)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskFileBrowser, [{
	    key: "handleFileClick",
	    value: function handleFileClick(path) {
	      _TaskDirectoryStore2.default.addPath(this.props.task, path);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          directory = _props.directory,
	          onOpenLogClick = _props.onOpenLogClick,
	          task = _props.task;
	
	
	      return _react2.default.createElement(_TaskDirectoryTable2.default, {
	        files: directory.getItems(),
	        onFileClick: this.handleFileClick,
	        onOpenLogClick: onOpenLogClick,
	        nodeID: task.slave_id
	      });
	    }
	  }]);
	  return TaskFileBrowser;
	}(_react2.default.Component);
	
	TaskFileBrowser.propTypes = {
	  directory: _react2.default.PropTypes.object,
	  task: _react2.default.PropTypes.object
	};
	
	TaskFileBrowser.defaultProps = {
	  task: {}
	};
	
	module.exports = TaskFileBrowser;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _TaskDirectoryActions = __webpack_require__(1498);
	
	var _TaskDirectoryActions2 = _interopRequireDefault(_TaskDirectoryActions);
	
	var _TaskDirectoryHeaderLabels = __webpack_require__(1506);
	
	var _TaskDirectoryHeaderLabels2 = _interopRequireDefault(_TaskDirectoryHeaderLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderByProperty(prop, directoryItem) {
	  return directoryItem.get(prop);
	}
	
	var TaskDirectoryTable = function (_React$Component) {
	  (0, _inherits3.default)(TaskDirectoryTable, _React$Component);
	
	  function TaskDirectoryTable() {
	    (0, _classCallCheck3.default)(this, TaskDirectoryTable);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskDirectoryTable.__proto__ || (0, _getPrototypeOf2.default)(TaskDirectoryTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskDirectoryTable, [{
	    key: "handleTaskClick",
	    value: function handleTaskClick(path) {
	      this.props.onFileClick(path);
	    }
	  }, {
	    key: "renderHeadline",
	    value: function renderHeadline(prop, directoryItem) {
	      var label = void 0;
	      var nodeID = this.props.nodeID;
	
	      var filePath = directoryItem.get("path");
	      var iconID = "page";
	      var value = directoryItem.getName();
	
	      if (directoryItem.isDirectory()) {
	        iconID = "folder";
	        label = _react2.default.createElement(
	          "a",
	          {
	            className: "table-cell-link-primary clickable",
	            onClick: this.handleTaskClick.bind(this, value)
	          },
	          value
	        );
	      } else {
	        label = _react2.default.createElement(
	          "a",
	          {
	            className: "table-cell-link-primary",
	            href: _TaskDirectoryActions2.default.getDownloadURL(nodeID, filePath)
	          },
	          value
	        );
	      }
	
	      var openLogView = void 0;
	      if (directoryItem.isLogFile()) {
	        openLogView = _react2.default.createElement(
	          "div",
	          {
	            className: "table-cell-icon table-display-on-row-hover fade-in-on-hover clickable",
	            onClick: this.props.onOpenLogClick.bind(this, directoryItem, this.props.directoryPath)
	          },
	          _react2.default.createElement(_Icon2.default, {
	            className: "icon-margin-left",
	            color: "grey",
	            id: "search",
	            size: "mini"
	          })
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-box flex-box-align-vertical-center table-cell-flex-box" },
	        _react2.default.createElement(
	          "div",
	          { className: "table-cell-icon" },
	          _react2.default.createElement(_Icon2.default, {
	            className: "icon-margin-right",
	            color: "grey",
	            id: iconID,
	            size: "mini"
	          })
	        ),
	        _react2.default.createElement(
	          "span",
	          { title: value, className: "table-cell-value text-overflow" },
	          label
	        ),
	        openLogView
	      );
	    }
	  }, {
	    key: "renderStats",
	    value: function renderStats(prop, directoryItem) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _Units2.default.filesize(directoryItem.get(prop), 1)
	      );
	    }
	  }, {
	    key: "renderDate",
	    value: function renderDate(prop, directoryItem) {
	      var ms = directoryItem.get(prop) * 1000;
	
	      return _react2.default.createElement(_TimeAgo2.default, { time: ms, autoUpdate: false });
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(prop, sortBy, row) {
	      var isHeader = row == null;
	      var propsToRight = ["uid", "size", "mtime"];
	
	      return (0, _classnames2.default)({
	        "text-align-right": propsToRight.includes(prop),
	        active: prop === sortBy.prop && isHeader,
	        clickable: isHeader
	      });
	    }
	  }, {
	    key: "getDirectorySortFunction",
	    value: function getDirectorySortFunction(baseProp) {
	      return function (prop, order) {
	        return function (a, b) {
	          var aIsDirectory = a.isDirectory();
	          var bIsDirectory = b.isDirectory();
	
	          if (aIsDirectory && !bIsDirectory) {
	            if (order === "desc") {
	              return 1;
	            }
	
	            return -1;
	          }
	
	          if (!aIsDirectory && bIsDirectory) {
	            if (order === "desc") {
	              return -1;
	            }
	
	            return 1;
	          }
	
	          return _TableUtil2.default.compareValues(a.get(prop), b.get(prop), a.get(baseProp), b.get(baseProp));
	        };
	      };
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var className = this.getClassName;
	      var heading = _ResourceTableUtil2.default.renderHeading(_TaskDirectoryHeaderLabels2.default);
	      var sortFunction = this.getDirectorySortFunction("path");
	
	      var defaultColumnSettings = {
	        className: className,
	        heading: heading,
	        headerClassName: className,
	        render: null,
	        sortable: true,
	        sortFunction: sortFunction
	      };
	
	      return [{
	        prop: "path",
	        render: this.renderHeadline.bind(this)
	      }, {
	        prop: "mode",
	        render: renderByProperty
	      }, {
	        prop: "uid",
	        render: renderByProperty
	      }, {
	        prop: "size",
	        render: this.renderStats,
	        sortFunction: sortFunction
	      }, {
	        prop: "mtime",
	        render: this.renderDate,
	        sortFunction: sortFunction
	      }].map(function (columnSetting) {
	        return (0, _assign2.default)({}, defaultColumnSettings, columnSetting);
	      });
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "150px" } }),
	        _react2.default.createElement("col", { style: { width: "110px" } }),
	        _react2.default.createElement("col", { style: { width: "100px" } }),
	        _react2.default.createElement("col", { style: { width: "125px" } })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        colGroup: this.getColGroup(),
	        columns: this.getColumns(),
	        containerSelector: ".gm-scroll-view",
	        data: this.props.files,
	        sortBy: { prop: "path", order: "asc" }
	      });
	    }
	  }]);
	  return TaskDirectoryTable;
	}(_react2.default.Component);
	
	TaskDirectoryTable.defaultProps = {
	  onOpenLogClick: function onOpenLogClick() {},
	
	  files: []
	};
	
	TaskDirectoryTable.propTypes = {
	  directoryPath: _react2.default.PropTypes.string,
	  onOpenLogClick: _react2.default.PropTypes.func,
	  files: _react2.default.PropTypes.array
	};
	
	module.exports = TaskDirectoryTable;

/***/ },
/* 1506 */
/***/ function(module, exports) {

	"use strict";
	
	var TaskDirectoryHeaderLabels = {
	  path: "NAME",
	  mode: "PERMISSIONS",
	  uid: "OWNER",
	  size: "SIZE",
	  mtime: "MODIFIED"
	};
	
	module.exports = TaskDirectoryHeaderLabels;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskFilesTab = function (_React$Component) {
	  (0, _inherits3.default)(TaskFilesTab, _React$Component);
	
	  function TaskFilesTab() {
	    (0, _classCallCheck3.default)(this, TaskFilesTab);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskFilesTab.__proto__ || (0, _getPrototypeOf2.default)(TaskFilesTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskFilesTab, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          directory = _props.directory,
	          onOpenLogClick = _props.onOpenLogClick,
	          task = _props.task;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        children && _react2.default.cloneElement(children, {
	          directory: directory,
	          task: task,
	          onOpenLogClick: onOpenLogClick
	        })
	      );
	    }
	  }]);
	  return TaskFilesTab;
	}(_react2.default.Component);
	
	TaskFilesTab.propTypes = {
	  children: _react2.default.PropTypes.node,
	  directory: _react2.default.PropTypes.object,
	  task: _react2.default.PropTypes.object
	};
	
	TaskFilesTab.defaultProps = {
	  task: {}
	};
	
	module.exports = TaskFilesTab;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.getNewRoute = getNewRoute;
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _DirectoryItem = __webpack_require__(1497);
	
	var _DirectoryItem2 = _interopRequireDefault(_DirectoryItem);
	
	var _MesosLogContainer = __webpack_require__(1509);
	
	var _MesosLogContainer2 = _interopRequireDefault(_MesosLogContainer);
	
	var _SearchLog = __webpack_require__(1517);
	
	var _SearchLog2 = _interopRequireDefault(_SearchLog);
	
	var _TaskDirectory = __webpack_require__(1496);
	
	var _TaskDirectory2 = _interopRequireDefault(_TaskDirectory);
	
	var _TaskDirectoryActions = __webpack_require__(1498);
	
	var _TaskDirectoryActions2 = _interopRequireDefault(_TaskDirectoryActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getNewRoute(routePath, params, path) {
	  var hasFilePathParam = routePath.indexOf(":filePath") !== -1;
	  if (!hasFilePathParam && routePath.endsWith("/")) {
	    routePath += ":filePath";
	  }
	  if (!hasFilePathParam && !routePath.endsWith("/")) {
	    routePath += "/:filePath";
	  }
	
	  return (0, _reactRouter.formatPattern)(routePath, (0, _assign2.default)({}, params, { filePath: encodeURIComponent(path) }));
	}
	
	var TaskFileViewer = function (_React$Component) {
	  (0, _inherits3.default)(TaskFileViewer, _React$Component);
	
	  function TaskFileViewer() {
	    (0, _classCallCheck3.default)(this, TaskFileViewer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskFileViewer.__proto__ || (0, _getPrototypeOf2.default)(TaskFileViewer)).apply(this, arguments));
	
	    _this.state = { currentFile: null };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskFileViewer, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var curProps = this.props;
	      var curState = this.state;
	
	      var task = curState.task;
	      var nextTask = nextState.task;
	      var didSlaveIdChange = task && nextTask && task.slave_id !== nextTask.slave_id;
	
	      var didTaskChange = curProps.task !== nextProps.task || didSlaveIdChange;
	
	      var directory = curProps.directory;
	      var nextDirectory = nextProps.directory;
	      var didDirectoryItemsChange = directory && nextDirectory && directory.getItems().length !== nextDirectory.getItems().length;
	
	      var didDirectoryChange = directory !== nextDirectory || didDirectoryItemsChange;
	
	      var didCurrentFileChange = curState.currentFile !== nextState.currentFile;
	
	      return didTaskChange || didCurrentFileChange || didDirectoryChange;
	    }
	  }, {
	    key: "handleViewChange",
	    value: function handleViewChange(currentFile) {
	      var path = currentFile.get("path");
	      if (path === this.getSelectedFile().get("path")) {
	        // File path didn't change, let's not try to update path
	        return;
	      }
	
	      var _props = this.props,
	          params = _props.params,
	          routes = _props.routes;
	
	      var routePath = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	
	      this.context.router.push(getNewRoute(routePath, params, path));
	    }
	  }, {
	    key: "getLogFiles",
	    value: function getLogFiles() {
	      var _props2 = this.props,
	          directory = _props2.directory,
	          limitLogFiles = _props2.limitLogFiles;
	
	      var logViews = [];
	      if (!directory) {
	        return logViews;
	      }
	
	      var limitLogFilesIsNotEmpty = limitLogFiles.length > 0;
	
	      directory.getItems().forEach(function (item) {
	        var excludeFile = limitLogFilesIsNotEmpty && !limitLogFiles.includes(item.getName());
	
	        if (!item.isLogFile() || excludeFile) {
	          return;
	        }
	
	        logViews.push(item);
	      });
	
	      return logViews;
	    }
	  }, {
	    key: "getLogSelectionAsButtons",
	    value: function getLogSelectionAsButtons(logFiles, selectedName) {
	      var _this2 = this;
	
	      var buttons = logFiles.map(function (item, index) {
	        var name = item.getName();
	
	        var classes = (0, _classnames2.default)({
	          "button button-stroke": true,
	          active: name === selectedName
	        });
	
	        return _react2.default.createElement(
	          "button",
	          {
	            className: classes,
	            key: index,
	            onClick: _this2.handleViewChange.bind(_this2, item)
	          },
	          item.getDisplayName()
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { key: "button-group", className: "button-group" },
	        buttons
	      );
	    }
	  }, {
	    key: "onItemSelection",
	    value: function onItemSelection(obj) {
	      this.handleViewChange(obj.value);
	    }
	  }, {
	    key: "getItemHtml",
	    value: function getItemHtml(displayName) {
	      return _react2.default.createElement(
	        "span",
	        { className: "flush dropdown-header" },
	        displayName
	      );
	    }
	  }, {
	    key: "getDropdownItems",
	    value: function getDropdownItems(logFiles) {
	      return logFiles.map(function (item) {
	        var displayName = item.getDisplayName();
	        var selectedHtml = this.getItemHtml(displayName);
	        var dropdownHtml = _react2.default.createElement(
	          "a",
	          null,
	          selectedHtml
	        );
	
	        return {
	          id: item.getName(),
	          name: displayName,
	          html: dropdownHtml,
	          selectedHtml: selectedHtml,
	          value: item
	        };
	      }, this);
	    }
	  }, {
	    key: "getSelectedFile",
	    value: function getSelectedFile() {
	      var props = this.props,
	          state = this.state;
	
	      var file = state.currentFile;
	      var paramsPath = decodeURIComponent(props.params.filePath);
	      if (!file && paramsPath !== "undefined") {
	        return new _DirectoryItem2.default({ path: paramsPath });
	      }
	
	      var files = this.getLogFiles();
	
	      return files.find(function (file) {
	        return file.getName() === "stderr";
	      }) || files[0];
	    }
	  }, {
	    key: "getSelectionComponent",
	    value: function getSelectionComponent(selectedLogFile) {
	      var selectedName = selectedLogFile && selectedLogFile.getName();
	      var logFiles = this.getLogFiles();
	      if (logFiles.length < 3) {
	        return this.getLogSelectionAsButtons(logFiles, selectedName);
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        key: "dropdown",
	        buttonClassName: "button dropdown-toggle",
	        dropdownMenuClassName: "dropdown-menu",
	        dropdownMenuListClassName: "dropdown-menu-list",
	        dropdownMenuListItemClassName: "clickable",
	        initialID: selectedName,
	        items: this.getDropdownItems(logFiles),
	        onItemSelection: this.onItemSelection.bind(this),
	        scrollContainer: ".gm-scroll-view",
	        scrollContainerParentSelector: ".gm-prevented",
	        transition: true,
	        transitionName: "dropdown-menu",
	        wrapperClassName: "dropdown form-group"
	      });
	    }
	  }, {
	    key: "getActions",
	    value: function getActions(selectedLogFile, filePath) {
	      var task = this.props.task;
	
	
	      return [this.getSelectionComponent(selectedLogFile), _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { key: "tooltip", anchor: "end", content: "Download log file" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "button button-stroke",
	            disabled: !filePath,
	            href: _TaskDirectoryActions2.default.getDownloadURL(task.slave_id, filePath)
	          },
	          _react2.default.createElement(_Icon2.default, { id: "download", size: "mini" })
	        )
	      )];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var task = this.props.task;
	
	      // Only try to get path if file exists
	
	      var selectedLogFile = this.getSelectedFile();
	      var selectedName = selectedLogFile && selectedLogFile.getName();
	      var filePath = selectedLogFile && selectedLogFile.get("path");
	
	      return _react2.default.createElement(
	        _SearchLog2.default,
	        { actions: this.getActions(selectedLogFile, filePath) },
	        _react2.default.createElement(_MesosLogContainer2.default, {
	          filePath: filePath,
	          task: task,
	          logName: selectedName
	        })
	      );
	    }
	  }]);
	  return TaskFileViewer;
	}(_react2.default.Component);
	
	exports.default = TaskFileViewer;
	
	
	TaskFileViewer.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	TaskFileViewer.defaultProps = {
	  limitLogFiles: [],
	  task: {}
	};
	
	TaskFileViewer.propTypes = {
	  directory: _react2.default.PropTypes.instanceOf(_TaskDirectory2.default),
	  limitLogFiles: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  selectedLogFile: _react2.default.PropTypes.object,
	  task: _react2.default.PropTypes.object
	};

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _SystemLogTypes = __webpack_require__(1510);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _LogView = __webpack_require__(1511);
	
	var _LogView2 = _interopRequireDefault(_LogView);
	
	var _MesosLogStore = __webpack_require__(1514);
	
	var _MesosLogStore2 = _interopRequireDefault(_MesosLogStore);
	
	var _TaskDirectoryStore = __webpack_require__(1495);
	
	var _TaskDirectoryStore2 = _interopRequireDefault(_TaskDirectoryStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleGoToWorkingDirectory", "handleFetchPreviousLog", "onMesosLogStoreError", "onMesosLogStoreSuccess", "onMesosLogStoreOffsetError", "onMesosLogStoreOffsetSuccess"];
	
	var MesosLogContainer = function (_mixin) {
	  (0, _inherits3.default)(MesosLogContainer, _mixin);
	
	  function MesosLogContainer() {
	    (0, _classCallCheck3.default)(this, MesosLogContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MesosLogContainer.__proto__ || (0, _getPrototypeOf2.default)(MesosLogContainer)).apply(this, arguments));
	
	    _this.state = {
	      direction: _SystemLogTypes.APPEND,
	      fullLog: null,
	      isFetchingPrevious: false,
	      isLoading: true,
	      hasLoadingError: 0,
	      hasOffsetLoadingError: false
	    };
	
	    _this.store_listeners = [{
	      events: ["success", "error", "offsetSuccess", "offsetError"],
	      name: "mesosLog",
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(MesosLogContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(MesosLogContainer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MesosLogContainer.prototype), "componentDidMount", this).apply(this, arguments);
	      var _props = this.props,
	          filePath = _props.filePath,
	          task = _props.task;
	
	      if (!filePath) {
	        return;
	      }
	
	      _MesosLogStore2.default.startTailing(task.slave_id, filePath);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(MesosLogContainer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MesosLogContainer.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      var props = this.props;
	
	      if (props.filePath === nextProps.filePath) {
	        return;
	      }
	
	      // Change to filePath has happened
	      this.setState({
	        direction: _SystemLogTypes.APPEND,
	        fullLog: null,
	        isFetchingPrevious: false,
	        isLoading: true,
	        hasLoadingError: 0
	      });
	      if (props.filePath) {
	        // Clean up data as well
	        _MesosLogStore2.default.stopTailing(props.filePath, true);
	      }
	      if (nextProps.filePath) {
	        _MesosLogStore2.default.startTailing(nextProps.task.slave_id, nextProps.filePath);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _get3.default)(MesosLogContainer.prototype.__proto__ || (0, _getPrototypeOf2.default)(MesosLogContainer.prototype), "componentWillUnmount", this).apply(this, arguments);
	      _MesosLogStore2.default.stopTailing(this.props.filePath, true);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var curProps = this.props;
	      var curState = this.state;
	
	      var propsToCheck = ["filePath", "logName", "highlightText", "watching", "onCountChange"];
	
	      var stateToCheck = ["direction", "hasLoadingError", "hasOffsetLoadingError", "isFetchingPrevious", "isLoading", "fullLog" // Check fullLog at the end, as this could be a long string
	      ];
	
	      // Check task (slave_id is the only property being used)
	      if (curProps.task.slave_id !== nextProps.task.slave_id) {
	        return true;
	      }
	
	      return propsToCheck.some(function (key) {
	        return curProps[key] !== nextProps[key];
	      }) || stateToCheck.some(function (key) {
	        return curState[key] !== nextState[key];
	      });
	    }
	  }, {
	    key: "onMesosLogStoreError",
	    value: function onMesosLogStoreError(path) {
	      // Check the filePath before we reload
	      if (path !== this.props.filePath) {
	        // This event is not for our filePath
	        return;
	      }
	
	      this.setState({
	        hasLoadingError: this.state.hasLoadingError + 1,
	        isFetchingPrevious: false
	      });
	    }
	  }, {
	    key: "onMesosLogStoreOffsetError",
	    value: function onMesosLogStoreOffsetError() {
	      this.setState({
	        hasOffsetLoadingError: true
	      });
	    }
	  }, {
	    key: "onMesosLogStoreOffsetSuccess",
	    value: function onMesosLogStoreOffsetSuccess() {
	      this.setState({
	        hasOffsetLoadingError: false
	      });
	    }
	  }, {
	    key: "onMesosLogStoreSuccess",
	    value: function onMesosLogStoreSuccess(path, direction) {
	      // Check the filePath before we reload
	      var filePath = this.props.filePath;
	
	      if (path !== filePath) {
	        // This event is not for our filePath
	        return;
	      }
	
	      var logBuffer = _MesosLogStore2.default.getLogBuffer(filePath);
	      var fullLog = logBuffer.getFullLog();
	
	      this.setState({
	        direction: direction,
	        hasLoadingError: 0,
	        isFetchingPrevious: false,
	        isLoading: !filePath,
	        fullLog: fullLog
	      });
	    }
	  }, {
	    key: "handleGoToWorkingDirectory",
	    value: function handleGoToWorkingDirectory() {
	      _TaskDirectoryStore2.default.setPath(this.props.task, "");
	    }
	  }, {
	    key: "handleFetchPreviousLog",
	    value: function handleFetchPreviousLog() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var isFetchingPrevious = this.state.isFetchingPrevious;
	      var task = props.task,
	          filePath = props.filePath;
	      // Ongoing previous log fetch, wait for that to complete
	
	      if (isFetchingPrevious) {
	        return;
	      }
	
	      _MesosLogStore2.default.getPreviousLogs(task.slave_id, filePath);
	      this.setState({ isFetchingPrevious: true });
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	  }, {
	    key: "getLog",
	    value: function getLog() {
	      var _props2 = this.props,
	          filePath = _props2.filePath,
	          highlightText = _props2.highlightText,
	          logName = _props2.logName,
	          onCountChange = _props2.onCountChange,
	          watching = _props2.watching;
	      var _state = this.state,
	          direction = _state.direction,
	          fullLog = _state.fullLog;
	
	
	      if (!logName) {
	        return this.getEmptyDirectoryScreen();
	      }
	
	      return _react2.default.createElement(_LogView2.default, {
	        direction: direction,
	        fetchPreviousLogs: this.handleFetchPreviousLog,
	        fullLog: fullLog,
	        hasLoadedTop: _MesosLogStore2.default.hasLoadedTop(filePath),
	        highlightText: highlightText,
	        logName: logName,
	        onCountChange: onCountChange,
	        watching: watching
	      });
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getEmptyDirectoryScreen",
	    value: function getEmptyDirectoryScreen() {
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-grow vertical-center" },
	        _react2.default.createElement(
	          "h3",
	          { className: "text-align-center flush-top" },
	          "This directory does not contain any logs."
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state2 = this.state,
	          hasLoadingError = _state2.hasLoadingError,
	          isLoading = _state2.isLoading,
	          hasOffsetLoadingError = _state2.hasOffsetLoadingError;
	
	
	      if (hasLoadingError >= 3 || hasOffsetLoadingError) {
	        return this.getErrorScreen();
	      }
	
	      if (isLoading) {
	        return this.getLoadingScreen();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "log-view flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        this.getLog()
	      );
	    }
	  }]);
	  return MesosLogContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	MesosLogContainer.defaultProps = {
	  highlightText: ""
	};
	
	MesosLogContainer.propTypes = {
	  filePath: _react2.default.PropTypes.string,
	  highlightText: _react2.default.PropTypes.string,
	  logName: _react2.default.PropTypes.string,
	  task: _react2.default.PropTypes.object.isRequired,
	  watching: _react2.default.PropTypes.number
	};
	
	module.exports = MesosLogContainer;

/***/ },
/* 1510 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  APPEND: "APPEND",
	  PREPEND: "PREPEND"
	};

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(1283);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _lodash = __webpack_require__(1101);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _SystemLogTypes = __webpack_require__(1510);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _EmptyLogScreen = __webpack_require__(1512);
	
	var _EmptyLogScreen2 = _interopRequireDefault(_EmptyLogScreen);
	
	var _Highlight = __webpack_require__(1513);
	
	var _Highlight2 = _interopRequireDefault(_Highlight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTAINER_OFFSET_HEIGHT = 25;
	
	var METHODS_TO_BIND = ["handleGoToBottom", "handleLogContainerScroll", "handleUpdateScrollPosition", "handleWindowResize"];
	
	var LogView = function (_React$Component) {
	  (0, _inherits3.default)(LogView, _React$Component);
	
	  function LogView() {
	    (0, _classCallCheck3.default)(this, LogView);
	
	    // Using variable on component to avoid the asynchronous `setState`
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LogView.__proto__ || (0, _getPrototypeOf2.default)(LogView)).apply(this, arguments));
	
	    _this.updatingScrollPosition = false;
	
	    _this.state = { isAtBottom: true };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    // Make sure to run this on the leading edge to capture this event as soon
	    // as possible. This has impact on both checkIfCloseToTop and
	    // checkIfAwayFromBottom. Trailing edge will call them too late, i.e. when
	    // the data is out of data and possibly scrolled passed the trigger range.
	    // We also want it at the trailing end because if a user scrolls too fast
	    // there's a chance that the callback will get fired but not where the
	    // scrolling position has ended.
	    // We need them to be called as soon as we hit the range wherein these will
	    // trigger handlers.
	    _this.handleLogContainerScroll = (0, _lodash2.default)(_this.handleLogContainerScroll, 50, { leading: true, trailing: true });
	
	    _this.handleWindowResize = (0, _lodash2.default)(_this.handleWindowResize, 50, {
	      leading: true,
	      trailing: false
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(LogView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      global.addEventListener("resize", this.handleWindowResize);
	      // Make sure to update scroll position on load. Needs to be did mount for
	      // logContainer to be defined
	      this.handleUpdateScrollPosition();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.handleUpdateScrollPosition(nextProps);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var curState = this.state;
	      var curProps = this.props;
	      var propsToCheck = ["hasLoadedTop", "highlightText", "logName", "watching"];
	
	      var stateToCheck = ["isAtBottom", "fullLog" // Check fullLog at the end, as this could be a long string
	      ];
	
	      return propsToCheck.some(function (key) {
	        return curProps[key] !== nextProps[key];
	      }) || stateToCheck.some(function (key) {
	        return curState[key] !== nextState[key];
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var logContainer = this.logContainer;
	
	      if (logContainer == null) {
	        return;
	      }
	
	      // Make sure to go to bottom if we are tailing
	      if (this.state.isAtBottom) {
	        // Set `updatingScrollPosition` guard to avoid 'at top' and
	        // 'at bottom' checks when computationally setting the `scrollTop`
	        this.updatingScrollPosition = true;
	        // Warning: Causes reflow!
	        logContainer.scrollTop = logContainer.scrollHeight;
	        this.updatingScrollPosition = false;
	
	        return;
	      }
	
	      if (prevProps.watching !== this.props.watching || prevProps.highlightText !== this.props.highlightText) {
	        this.goToNewHighlightedSearch();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      global.removeEventListener("resize", this.handleWindowResize);
	    }
	  }, {
	    key: "handleUpdateScrollPosition",
	    value: function handleUpdateScrollPosition() {
	      var _this2 = this;
	
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var direction = props.direction,
	          fullLog = props.fullLog;
	      // Prevent updates to fullLog, if it has not changed
	
	      if (this.state.fullLog !== fullLog) {
	        var logContainer = this.logContainer;
	
	        var previousScrollTop = void 0;
	        var previousScrollHeight = void 0;
	        if (logContainer && direction === _SystemLogTypes.PREPEND && !this.state.isAtBottom) {
	          // Warning: Causes reflow!
	          previousScrollTop = logContainer.scrollTop;
	          previousScrollHeight = logContainer.scrollHeight;
	        }
	        this.setState({ fullLog: fullLog }, function () {
	          // This allows the user to stay at the place of the log they were at
	          // before the prepend.
	          if (previousScrollHeight) {
	            var currentScrollHeight = logContainer.scrollHeight;
	            var heightDifference = currentScrollHeight - previousScrollHeight;
	            // Set `updatingScrollPosition` guard to avoid 'at top' and
	            // 'at bottom' checks when computationally setting the `scrollTop`
	            _this2.updatingScrollPosition = true;
	            // Warning: Causes reflow!
	            logContainer.scrollTop = previousScrollTop + heightDifference;
	            _this2.updatingScrollPosition = false;
	          }
	        });
	      }
	    }
	  }, {
	    key: "handleLogContainerScroll",
	    value: function handleLogContainerScroll() {
	      this.checkIfCloseToTop(this.logContainer);
	      this.checkIfAwayFromBottom(this.logContainer);
	    }
	  }, {
	    key: "handleGoToBottom",
	    value: function handleGoToBottom() {
	      var logContainer = this.logContainer,
	          highlightText = this.props.highlightText;
	      // Do not scroll to bottom if we want to highlight a word in the log,
	      // or we are already scrolling
	
	      if (logContainer == null || highlightText) {
	        return;
	      }
	
	      // Cap animation time between 500 and 3000
	      var scrollDistance = logContainer.scrollHeight - logContainer.scrollTop;
	      var animationTime = Math.max(500, Math.min(scrollDistance, 3000));
	
	      // Do not set `updatingScrollPosition` during animation as the user could
	      // decide to scroll away while we are animating
	      _DOMUtils2.default.scrollTo(logContainer, animationTime, logContainer.scrollHeight - logContainer.clientHeight);
	    }
	  }, {
	    key: "handleWindowResize",
	    value: function handleWindowResize() {
	      this.checkIfCloseToTop(this.logContainer);
	      this.checkIfAwayFromBottom(this.logContainer);
	    }
	  }, {
	    key: "checkIfCloseToTop",
	    value: function checkIfCloseToTop(container) {
	      // Cancel check if we are changing the scroll position computationally
	      if (!container || this.updatingScrollPosition) {
	        return;
	      }
	
	      // This number has been determined by trail and error to be a good
	      // measurement for close to the top
	      if (container.scrollTop < 2000) {
	        var _props = this.props,
	            hasLoadedTop = _props.hasLoadedTop,
	            fetchPreviousLogs = _props.fetchPreviousLogs;
	
	        if (!hasLoadedTop) {
	          fetchPreviousLogs();
	        }
	      }
	    }
	  }, {
	    key: "checkIfAwayFromBottom",
	    value: function checkIfAwayFromBottom(container) {
	      // Cancel check if we are changing the scroll position computationally
	      if (!container || this.updatingScrollPosition) {
	        return;
	      }
	
	      // The CONTAINER_OFFSET_HEIGHT is to give the checker a little bit of
	      // breathing room to determine when we are at the bottom
	      var isAtBottom = container.offsetHeight + container.scrollTop + CONTAINER_OFFSET_HEIGHT >= container.scrollHeight;
	
	      if (isAtBottom !== this.state.isAtBottom) {
	        this.setState({ isAtBottom: isAtBottom });
	      }
	    }
	  }, {
	    key: "goToNewHighlightedSearch",
	    value: function goToNewHighlightedSearch() {
	      var logContainer = this.logContainer;
	
	      var node = logContainer.querySelector(".highlight.selected");
	      if (!node || !logContainer) {
	        return;
	      }
	
	      // Warning: Causes reflow!
	      var containerHeight = logContainer.clientHeight;
	      var containerScrollTop = logContainer.scrollTop;
	      var nodeDistanceFromTop = _DOMUtils2.default.getDistanceFromTopOfParent(node);
	
	      if (nodeDistanceFromTop > containerHeight + containerScrollTop || nodeDistanceFromTop < containerScrollTop) {
	        // Set `updatingScrollPosition` guard to avoid 'at top' and
	        // 'at bottom' checks when computationally setting the `scrollTop`
	        this.updatingScrollPosition = true;
	        // Warning: Causes reflow!
	        logContainer.scrollTop = nodeDistanceFromTop - containerHeight / 2;
	        this.updatingScrollPosition = false;
	      }
	    }
	  }, {
	    key: "getLog",
	    value: function getLog() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          highlightText = _props2.highlightText,
	          logName = _props2.logName,
	          onCountChange = _props2.onCountChange,
	          watching = _props2.watching;
	      var fullLog = this.state.fullLog;
	
	
	      if (fullLog === "") {
	        return _react2.default.createElement(_EmptyLogScreen2.default, { logName: logName });
	      }
	
	      return [_react2.default.createElement(
	        "pre",
	        {
	          key: "log-container",
	          className: "flex-item-grow-1 flush-bottom prettyprint",
	          ref: function ref(_ref) {
	            _this3.logContainer = _ref;
	          },
	          onScroll: this.handleLogContainerScroll
	        },
	        this.getLogPrepend(),
	        _react2.default.createElement(
	          _Highlight2.default,
	          {
	            matchClass: "highlight",
	            matchElement: "span",
	            onCountChange: onCountChange,
	            search: highlightText,
	            watching: watching
	          },
	          fullLog
	        )
	      ), _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          key: "log-go-down-button",
	          transitionAppear: true,
	          transitionName: "button",
	          transitionAppearTimeout: 350,
	          transitionEnterTimeout: 350,
	          transitionLeaveTimeout: 350,
	          component: "div"
	        },
	        this.getGoToBottomButton()
	      )];
	    }
	  }, {
	    key: "getGoToBottomButton",
	    value: function getGoToBottomButton() {
	      var highlightText = this.props.highlightText;
	      var isAtBottom = this.state.isAtBottom;
	
	      // Do not show go to bottom button, if we are already at the bottom,
	      // or we are have highlighted text
	
	      if (isAtBottom || highlightText) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "button",
	        {
	          onClick: this.handleGoToBottom,
	          className: "button go-to-bottom-button"
	        },
	        "Go to bottom"
	      );
	    }
	  }, {
	    key: "getLogPrepend",
	    value: function getLogPrepend() {
	      if (this.props.hasLoadedTop) {
	        return _react2.default.createElement(
	          "div",
	          { className: "text-muted" },
	          "(AT BEGINNING OF FILE)"
	        );
	      }
	
	      // Show loader since we will start a request for more logs
	      return _react2.default.createElement(
	        "div",
	        { className: "pod flush-top" },
	        _react2.default.createElement(_Loader2.default, { innerClassName: "loader--small", type: "ballSpinFadeLoader" })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "log-view flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        this.getLog()
	      );
	    }
	  }]);
	  return LogView;
	}(_react2.default.Component);
	
	LogView.defaultProps = {
	  hasLoadedTop: false,
	  highlightText: "",
	  fetchPreviousLogs: function fetchPreviousLogs() {},
	  onCountChange: function onCountChange() {}
	};
	
	LogView.propTypes = {
	  hasLoadedTop: _react2.default.PropTypes.bool,
	  highlightText: _react2.default.PropTypes.string,
	  fetchPreviousLogs: _react2.default.PropTypes.func,
	  onCountChange: _react2.default.PropTypes.func,
	  logName: _react2.default.PropTypes.string,
	  watching: _react2.default.PropTypes.number
	};
	
	module.exports = LogView;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyLogScreen(_ref) {
	  var logName = _ref.logName;
	
	  // Append space if logName is defined
	  logName = logName && logName + " ";
	
	  return _react2.default.createElement(
	    "div",
	    { className: "flex-grow horizontal-center vertical-center" },
	    _react2.default.createElement(
	      "h3",
	      { className: "text-align-center flush-top" },
	      logName + " Log is Currently Empty"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "text-align-center flush-bottom" },
	      "Please try again later."
	    )
	  );
	}
	
	EmptyLogScreen.propTypes = {
	  logName: _react.PropTypes.string
	};
	
	module.exports = EmptyLogScreen;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MATCH_OPERATOR_RE = /[|\\{}()[\]^$+*?.]/g;
	
	function regExpPropType(props, propName, componentName, location) {
	  if (!(props[propName] instanceof RegExp)) {
	    var propType = (0, _typeof3.default)(props[propName]);
	
	    return new Error("\"Invalid " + location + " '" + propName + "' of type '" + propType + "' supplied to " + ("'" + componentName + "', expected 'RegExp'."));
	  }
	}
	
	function escapeStringRegexp(str) {
	  if (typeof str !== "string") {
	    throw new TypeError("Expected a string");
	  }
	
	  return str.replace(MATCH_OPERATOR_RE, "\\$&");
	}
	
	var debounceTimeout = null;
	
	var Highlight = function (_mixin) {
	  (0, _inherits3.default)(Highlight, _mixin);
	
	  function Highlight() {
	    (0, _classCallCheck3.default)(this, Highlight);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Highlight.__proto__ || (0, _getPrototypeOf2.default)(Highlight)).apply(this, arguments));
	
	    _this.count = 0;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Highlight, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var currentProps = this.props;
	
	      if (nextProps.search !== currentProps.search) {
	        clearTimeout(debounceTimeout);
	
	        var searchLength = nextProps.search.length;
	        var searchDebounceThreshold = currentProps.searchDebounceThreshold,
	            searchDebounceDelay = currentProps.searchDebounceDelay;
	
	        if (searchLength <= searchDebounceThreshold && searchLength > 0) {
	          debounceTimeout = setTimeout(function () {
	            _this2.forceUpdate();
	          }, searchDebounceDelay);
	
	          return false;
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _internalStorage_get = this.internalStorage_get(),
	          highlightCount = _internalStorage_get.highlightCount;
	
	      if (!this.props.search) {
	        highlightCount = 0;
	      }
	
	      this.props.onCountChange(highlightCount);
	    }
	
	    /**
	     * Determine if props are valid types for processing.
	     *
	     * @return {Boolean} Whether children is a scalar or not
	     */
	
	  }, {
	    key: "isScalar",
	    value: function isScalar() {
	      return (/string|number|boolean/.test((0, _typeof3.default)(this.props.children))
	      );
	    }
	
	    /**
	     * Determine if required search prop is defined and valid.
	     *
	     * @return {Boolean} Whether there is a requested search or not
	     */
	
	  }, {
	    key: "hasSearch",
	    value: function hasSearch() {
	      return typeof this.props.search !== "undefined" && this.props.search;
	    }
	
	    /**
	     * Get the search prop, but always in the form of a regular expression. Use
	     * this as a proxy to this.props.search for consistency.
	     *
	     * @return {RegExp} Gets the search as a regex
	     */
	
	  }, {
	    key: "getSearch",
	    value: function getSearch() {
	      if (this.props.search instanceof RegExp) {
	        return this.props.search;
	      }
	
	      var flags = "";
	      if (!this.props.caseSensitive) {
	        flags += "i";
	      }
	
	      var search = this.props.search;
	      if (typeof this.props.search === "string") {
	        search = escapeStringRegexp(search);
	      }
	
	      return new RegExp(search, flags);
	    }
	
	    /**
	     * Get the indexes of the first and last characters of the matched string.
	     *
	     * @param  {string} subject
	     *   The string to search against.
	     *
	     * @param  {RegExp} search
	     *   The regex search query.
	     *
	     * @return {Object}
	     *   An object consisting of 'first' and 'last' properties representing the
	     *   indexes of the first and last characters of a matching string.
	     */
	
	  }, {
	    key: "getMatchBoundaries",
	    value: function getMatchBoundaries(subject, search) {
	      var matches = search.exec(subject);
	      if (matches) {
	        return {
	          first: matches.index,
	          last: matches.index + matches[0].length
	        };
	      }
	    }
	
	    /**
	     * Determines which strings of text should be highlighted or not.
	     *
	     * @param  {string} subject
	     *   The body of text that will be searched for highlighted words.
	     * @param  {string} search
	     *   The search used to search for highlighted words.
	     *
	     * @return {Array}
	     *   An array of ReactElements
	     */
	
	  }, {
	    key: "highlightChildren",
	    value: function highlightChildren(subject, search) {
	      var children = [];
	      var watching = this.props.watching;
	
	      var remaining = subject;
	      var highlightCount = 0;
	
	      while (remaining) {
	        if (!search.test(remaining)) {
	          children.push(this.renderPlain(remaining));
	          this.internalStorage_set({ highlightCount: highlightCount });
	
	          return children;
	        }
	
	        var boundaries = this.getMatchBoundaries(remaining, search);
	
	        // Capture the string that leads up to a match...
	        var nonMatch = remaining.slice(0, boundaries.first);
	        if (nonMatch) {
	          children.push(this.renderPlain(nonMatch));
	        }
	
	        // Now, capture the matching string...
	        var match = remaining.slice(boundaries.first, boundaries.last);
	        if (match) {
	          highlightCount++;
	
	          if (highlightCount === watching) {
	            children.push(this.renderWatchingHighlight(match));
	          } else {
	            children.push(this.renderHighlight(match));
	          }
	        }
	
	        // And if there's anything left over, recursively run this method again.
	        remaining = remaining.slice(boundaries.last);
	      }
	
	      return children;
	    }
	
	    /**
	     * Responsible for rending a non-highlighted element.
	     *
	     * @param  {string} string
	     *   A string value to wrap an element around.
	     *
	     * @return {ReactElement} element to render, when there is not a match
	     */
	
	  }, {
	    key: "renderPlain",
	    value: function renderPlain(string) {
	      this.count++;
	
	      return _react2.default.createElement(
	        "span",
	        { key: this.count },
	        string
	      );
	    }
	
	    /**
	     * A wrapper to the highlight method to determine when the highlighting
	     * process should occur.
	     *
	     * @param  {string} subject
	     *   The body of text that will be searched for highlighted words.
	     *
	     * @return {Array}
	     *   An array of ReactElements
	     */
	
	  }, {
	    key: "renderElement",
	    value: function renderElement(subject) {
	      if (this.isScalar() && this.hasSearch()) {
	        return this.highlightChildren(subject, this.getSearch());
	      }
	
	      return this.props.children;
	    }
	
	    /**
	     * Responsible for rending a highlighted element.
	     *
	     * @param  {string} string
	     *   A string value to wrap an element around.
	     *
	     * @return {ReactElement} element to render, when highlighted
	     */
	
	  }, {
	    key: "renderHighlight",
	    value: function renderHighlight(string) {
	      this.count++;
	
	      return _react2.default.createElement(this.props.matchElement, { key: this.count, className: this.props.matchClass }, string);
	    }
	  }, {
	    key: "renderWatchingHighlight",
	    value: function renderWatchingHighlight(string) {
	      this.count++;
	
	      return _react2.default.createElement(
	        this.props.matchElement,
	        {
	          className: this.props.selectedMatchClass,
	          key: this.count
	        },
	        string
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        this.props,
	        this.renderElement(this.props.children)
	      );
	    }
	  }]);
	  return Highlight;
	}((0, _reactjsMixin2.default)(_InternalStorageMixin2.default));
	
	Highlight.defaultProps = {
	  caseSensitive: false,
	  matchElement: "strong",
	  matchClass: "highlight",
	  searchDebounceDelay: 500,
	  searchDebounceThreshold: 2,
	  selectedMatchClass: "highlight selected"
	};
	
	Highlight.propTypes = {
	  search: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number, _react2.default.PropTypes.bool, regExpPropType]).isRequired,
	  caseSensitive: _react2.default.PropTypes.bool,
	  matchElement: _react2.default.PropTypes.string,
	  matchClass: _react2.default.PropTypes.string,
	  searchDebounceDelay: _react2.default.PropTypes.number,
	  searchDebounceThreshold: _react2.default.PropTypes.number,
	  selectedMatchClass: _react2.default.PropTypes.string,
	  watching: _react2.default.PropTypes.number
	};
	
	module.exports = Highlight;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _BaseStore2 = __webpack_require__(1008);
	
	var _BaseStore3 = _interopRequireDefault(_BaseStore2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _SystemLogTypes = __webpack_require__(1510);
	
	var _ActionTypes2 = __webpack_require__(1223);
	
	var _EventTypes = __webpack_require__(1103);
	
	var _LogBuffer = __webpack_require__(1515);
	
	var _LogBuffer2 = _interopRequireDefault(_LogBuffer);
	
	var _MesosLogActions = __webpack_require__(1516);
	
	var _MesosLogActions2 = _interopRequireDefault(_MesosLogActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_FILE_SIZE = 50000;
	
	var MesosLogStore = function (_BaseStore) {
	  (0, _inherits3.default)(MesosLogStore, _BaseStore);
	
	  function MesosLogStore() {
	    (0, _classCallCheck3.default)(this, MesosLogStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MesosLogStore.__proto__ || (0, _getPrototypeOf2.default)(MesosLogStore)).apply(this, arguments));
	
	    _this.logs = {};
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.MESOS_LOG_CHANGE,
	        error: _EventTypes.MESOS_LOG_REQUEST_ERROR,
	        offsetSuccess: _EventTypes.MESOS_INITIALIZE_LOG_CHANGE,
	        offsetError: _EventTypes.MESOS_INITIALIZE_LOG_REQUEST_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true,
	      suppressUpdate: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      var source = payload.source;
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	
	      switch (action.type) {
	        case _ActionTypes2.REQUEST_MESOS_LOG_SUCCESS:
	          _this.processLogEntry(action.slaveID, action.path, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MESOS_LOG_ERROR:
	          _this.processLogError(action.slaveID, action.path);
	          break;
	        case _ActionTypes2.REQUEST_PREVIOUS_MESOS_LOG_SUCCESS:
	          _this.processLogPrepend(action.slaveID, action.path, action.data);
	          break;
	        case _ActionTypes2.REQUEST_PREVIOUS_MESOS_LOG_ERROR:
	          _this.processLogPrependError(action.slaveID, action.path);
	          break;
	        case _ActionTypes2.REQUEST_MESOS_LOG_OFFSET_SUCCESS:
	          _this.processOffset(action.slaveID, action.path, action.data);
	          break;
	        case _ActionTypes2.REQUEST_MESOS_LOG_OFFSET_ERROR:
	          _this.processOffsetError(action.slaveID, action.path);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(MesosLogStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	  }, {
	    key: "getPreviousLogs",
	    value: function getPreviousLogs(slaveID, path) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        return;
	      }
	
	      // Already at the top.
	      if (logBuffer.hasLoadedTop()) {
	        return;
	      }
	
	      var startOffset = logBuffer.getStart() - MAX_FILE_SIZE;
	      var length = MAX_FILE_SIZE;
	      if (startOffset < 0) {
	        startOffset = 0;
	        length = logBuffer.getStart();
	      }
	
	      _MesosLogActions2.default.fetchPreviousLog(slaveID, path, startOffset, length);
	    }
	  }, {
	    key: "startTailing",
	    value: function startTailing(slaveID, path) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        logBuffer = new _LogBuffer2.default();
	        this.logs[path] = { logBuffer: logBuffer, isTailing: true };
	        // Request offset to initialize logBuffer
	        _MesosLogActions2.default.requestOffset(slaveID, path);
	      } else {
	        // Continue tailing, whereever we left off
	        _MesosLogActions2.default.fetchLog(slaveID, path, logBuffer.getEnd(), MAX_FILE_SIZE);
	      }
	    }
	  }, {
	    key: "stopTailing",
	    value: function stopTailing(path) {
	      var clearLogBuffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      // As soon as any request responds (success or error) the tailing will stop
	      if (this.logs[path]) {
	        this.logs[path].isTailing = false;
	      }
	
	      if (clearLogBuffer) {
	        this.logs[path] = null;
	      }
	    }
	  }, {
	    key: "processOffset",
	    value: function processOffset(slaveID, path, entry) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer || !this.logs[path].isTailing) {
	        return;
	      }
	
	      // Initialize and start tailing
	      logBuffer.initialize(entry.offset);
	      _MesosLogActions2.default.fetchLog(slaveID, path, logBuffer.getEnd(), MAX_FILE_SIZE);
	
	      this.emit(_EventTypes.MESOS_INITIALIZE_LOG_CHANGE, path);
	    }
	  }, {
	    key: "processOffsetError",
	    value: function processOffsetError(slaveID, path) {
	      // Try to re-initialize from where we left off
	      setTimeout(function () {
	        _MesosLogActions2.default.requestOffset(slaveID, path);
	      }, _Config2.default.tailRefresh);
	
	      this.emit(_EventTypes.MESOS_INITIALIZE_LOG_REQUEST_ERROR, path);
	    }
	  }, {
	    key: "processLogEntry",
	    value: function processLogEntry(slaveID, path, entry) {
	      // We've stopped tailing, don't append more data
	      if (!this.logs[path] || !this.logs[path].isTailing) {
	        return;
	      }
	
	      var logBuffer = this.getLogBuffer(path);
	      var data = entry.data;
	      if (data.length > 0) {
	        logBuffer.add(new _Item2.default(entry));
	      }
	
	      // Fire event always, so listener knows that we have received data
	      // This way it is easier to tell whether we are for data or it was empty
	      this.emit(_EventTypes.MESOS_LOG_CHANGE, path, _SystemLogTypes.APPEND);
	
	      var end = logBuffer.getEnd();
	      if (data.length === MAX_FILE_SIZE) {
	        // Tail immediately if we received as much data as requested,
	        // since that might mean that there is more data to show
	        _MesosLogActions2.default.fetchLog(slaveID, path, end, MAX_FILE_SIZE);
	      } else {
	        setTimeout(function () {
	          _MesosLogActions2.default.fetchLog(slaveID, path, end, MAX_FILE_SIZE);
	        }, _Config2.default.tailRefresh);
	      }
	    }
	  }, {
	    key: "processLogPrepend",
	    value: function processLogPrepend(slaveID, path, entry) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        return;
	      }
	
	      var data = entry.data;
	      if (data.length > 0) {
	        logBuffer.prepend(new _Item2.default(entry));
	      }
	
	      this.emit(_EventTypes.MESOS_LOG_CHANGE, path, _SystemLogTypes.PREPEND);
	    }
	  }, {
	    key: "processLogError",
	    value: function processLogError(slaveID, path) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        return;
	      }
	
	      // Try to re-start from where we left off
	      setTimeout(function () {
	        _MesosLogActions2.default.fetchLog(slaveID, path, logBuffer.getEnd(), MAX_FILE_SIZE);
	      }, _Config2.default.tailRefresh);
	
	      this.emit(_EventTypes.MESOS_LOG_REQUEST_ERROR, path);
	    }
	  }, {
	    key: "processLogPrependError",
	    value: function processLogPrependError(slaveID, path) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        return;
	      }
	
	      // Try request again immediately.
	      _MesosLogActions2.default.fetchLog(slaveID, path, logBuffer.getStart() - MAX_FILE_SIZE, MAX_FILE_SIZE);
	
	      this.emit(_EventTypes.MESOS_LOG_REQUEST_ERROR, path);
	    }
	  }, {
	    key: "getLogBuffer",
	    value: function getLogBuffer(path) {
	      var _ref = this.logs[path] || {},
	          logBuffer = _ref.logBuffer;
	
	      return logBuffer;
	    }
	  }, {
	    key: "hasLoadedTop",
	    value: function hasLoadedTop(path) {
	      var logBuffer = this.getLogBuffer(path);
	      if (!logBuffer) {
	        return false;
	      }
	
	      return logBuffer.hasLoadedTop();
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "mesosLog";
	    }
	  }]);
	  return MesosLogStore;
	}(_BaseStore3.default);
	
	module.exports = new MesosLogStore();

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_SIZE = 8 * 4096; // 32kb of data or 8 'pages'
	var DEFAULT_OPTIONS = {
	  end: -1,
	  initialized: false,
	  maxFileSize: 250000000,
	  start: -1
	};
	
	function truncateItemData(itemData, sizeDiff) {
	  // Truncate to fit within maxFileSize
	  itemData = itemData.substring(sizeDiff);
	  // Truncate to first newline
	  var newLineIndex = itemData.indexOf("\n") + 1;
	
	  return itemData.substring(newLineIndex);
	  // Update currentSize accordingly
	}
	
	var LogBuffer = function (_List) {
	  (0, _inherits3.default)(LogBuffer, _List);
	
	  function LogBuffer() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, LogBuffer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (LogBuffer.__proto__ || (0, _getPrototypeOf2.default)(LogBuffer)).apply(this, arguments));
	
	    _this.configuration = (0, _assign2.default)({}, DEFAULT_OPTIONS);
	
	    (0, _keys2.default)(DEFAULT_OPTIONS).forEach(function (key) {
	      if (Object.prototype.hasOwnProperty.call(options, key)) {
	        _this.configuration[key] = options[key];
	      }
	    });
	    return _this;
	  }
	
	  // Public API
	
	
	  (0, _createClass3.default)(LogBuffer, [{
	    key: "initialize",
	    value: function initialize(offset) {
	      // The point we are reading from in the log file
	      var end = this.getEnd(); // pointing to end of currently stored log
	      var start = this.getStart(); // pointing to start of currently stored log
	
	      // Get the last page of data.
	      if (offset > PAGE_SIZE) {
	        start = end = offset - PAGE_SIZE;
	      } else {
	        start = end = 0;
	      }
	
	      this.configuration.initialized = true;
	      this.configuration.start = start;
	      this.configuration.end = end;
	    }
	  }, {
	    key: "prepend",
	    value: function prepend(entry) {
	      var data = entry.get("data");
	      var offset = entry.get("offset");
	
	      var start = this.getStart();
	      var end = this.getEnd();
	
	      // If first entry ever for the LogBuffer.
	      if (start === end && offset !== 0) {
	        end = offset + data.length;
	      }
	
	      start = offset;
	
	      this.list.unshift(new _Item2.default({ data: data, start: start }));
	      this.configuration.start = start;
	      this.configuration.end = end;
	
	      var fromBack = true;
	      this.truncate(fromBack);
	    }
	  }, {
	    key: "add",
	    value: function add(entry) {
	      var data = entry.get("data");
	      var end = this.getEnd();
	      // The point we are reading from in the log file
	      var offset = entry.get("offset");
	      var start = this.getStart();
	
	      // Truncate to the first newline from beginning of received data,
	      // if this is the first request and the data received is not from the
	      // beginning of the log
	      if (start === end && offset !== 0) {
	        var index = data.indexOf("\n") + 1;
	        offset += index;
	        data = data.substring(index);
	        start = offset; // Adjust the actual start too!
	      }
	
	      // Update end to be offset + new addition to the log
	      this.configuration.end = offset + data.length;
	      this.configuration.start = start;
	
	      // Add log entry
	      (0, _get3.default)(LogBuffer.prototype.__proto__ || (0, _getPrototypeOf2.default)(LogBuffer.prototype), "add", this).call(this, new _Item2.default({ data: data, offset: offset }));
	      this.truncate();
	    }
	  }, {
	    key: "getEnd",
	    value: function getEnd() {
	      return this.configuration.end;
	    }
	  }, {
	    key: "getFullLog",
	    value: function getFullLog() {
	      return this.getItems().map(function (item) {
	        return item.get("data");
	      }).join("");
	    }
	  }, {
	    key: "getStart",
	    value: function getStart() {
	      return this.configuration.start;
	    }
	  }, {
	    key: "hasLoadedTop",
	    value: function hasLoadedTop() {
	      return this.configuration.start === 0;
	    }
	  }, {
	    key: "isInitialized",
	    value: function isInitialized() {
	      return this.configuration.initialized;
	    }
	
	    /**
	     * Truncates the log from beginning of file, to be within
	     * boundaries given by maxFileSize
	     * It will also truncate the data of the 'oldest item to stay in log',
	     * to the first newline index
	     * @param {boolean} fromBack Truncate from front or back.
	     */
	
	  }, {
	    key: "truncate",
	    value: function truncate(fromBack) {
	      var currentSize = this.getEnd() - this.getStart();
	      var maxFileSize = this.configuration.maxFileSize;
	      var sizeDiff = currentSize - maxFileSize;
	
	      if (sizeDiff <= 0) {
	        return;
	      }
	
	      var items = this.getItems();
	
	      // This is the index of which item to truncate. If fromBack is not set,
	      // truncate the first item. If fromBack is set, truncate the last item.
	      var index = 0;
	      if (fromBack) {
	        index = items.length - 1;
	      }
	
	      var item = items[index];
	      var itemData = item.get("data");
	      var originalDatasize = itemData.length;
	
	      itemData = truncateItemData(itemData, sizeDiff);
	      currentSize = currentSize - originalDatasize + itemData.length;
	
	      if (itemData.length > 0) {
	        items[index] = new _Item2.default({
	          data: itemData,
	          offset: item.get("offset")
	        });
	      } else {
	        this.list.splice(index, 1);
	      }
	
	      if (fromBack) {
	        this.configuration.end = this.getStart() + currentSize;
	      } else {
	        this.configuration.start = this.getEnd() - currentSize;
	      }
	
	      if (currentSize > maxFileSize) {
	        this.truncate(fromBack);
	      }
	    }
	  }]);
	  return LogBuffer;
	}(_List3.default);
	
	LogBuffer.type = _Item2.default;
	
	module.exports = LogBuffer;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ActionTypes = __webpack_require__(1223);
	
	var _ActionTypes2 = _interopRequireDefault(_ActionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MesosLogActions = {
	  requestOffset: function requestOffset(slaveID, path) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/agent/" + slaveID + "/files/read?path=" + path + "&offset=-1",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_MESOS_LOG_OFFSET_SUCCESS,
	          data: response,
	          path: path,
	          slaveID: slaveID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_MESOS_LOG_OFFSET_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          path: path,
	          slaveID: slaveID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchLog: function fetchLog(slaveID, path, offset, length) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/agent/" + slaveID + "/files/read?path=" + path + "&offset=" + offset + "&length=" + length,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_MESOS_LOG_SUCCESS,
	          data: response,
	          path: path,
	          slaveID: slaveID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_MESOS_LOG_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          path: path,
	          slaveID: slaveID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchPreviousLog: function fetchPreviousLog(slaveID, path, offset, length) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.rootUrl + "/agent/" + slaveID + "/files/read?path=" + path + "&offset=" + offset + "&length=" + length,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_PREVIOUS_MESOS_LOG_SUCCESS,
	          data: response,
	          path: path,
	          slaveID: slaveID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes2.default.REQUEST_PREVIOUS_MESOS_LOG_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          path: path,
	          slaveID: slaveID,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	module.exports = MesosLogActions;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _KeyboardUtil = __webpack_require__(1416);
	
	var _KeyboardUtil2 = _interopRequireDefault(_KeyboardUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleSearchStringChange", "handleCountChange", "handleKeyDown"];
	
	var SearchLog = function (_React$Component) {
	  (0, _inherits3.default)(SearchLog, _React$Component);
	
	  function SearchLog() {
	    (0, _classCallCheck3.default)(this, SearchLog);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchLog.__proto__ || (0, _getPrototypeOf2.default)(SearchLog)).apply(this, arguments));
	
	    _this.state = {
	      searchString: "",
	      totalFound: 0,
	      watching: 0
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(SearchLog, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var filterInput = _reactDom2.default.findDOMNode(this.refs.filterInput);
	
	      if (filterInput) {
	        filterInput.addEventListener("keydown", this.handleKeyDown);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var nextSearchString = nextState.searchString;
	      var nextTotalFound = nextState.totalFound;
	      var updatedState = {};
	
	      if (nextTotalFound === 0) {
	        updatedState.watching = 0;
	      } else if (this.state.watching === 0 || nextSearchString != null && this.state.searchString !== nextSearchString) {
	        updatedState.watching = 1;
	      }
	
	      this.setState(updatedState);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var filterInput = _reactDom2.default.findDOMNode(this.refs.filterInput);
	
	      if (filterInput) {
	        filterInput.removeEventListener("keydown", this.handleKeyDown);
	      }
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      var keyCode = event.keyCode;
	
	      if (keyCode === _KeyboardUtil2.default.keyCodes.enter) {
	        this.changeWatching("next");
	      }
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString, watching: 1 });
	    }
	  }, {
	    key: "handleCountChange",
	    value: function handleCountChange(totalFound) {
	      this.setState({ totalFound: totalFound });
	    }
	  }, {
	    key: "changeWatching",
	    value: function changeWatching(direction) {
	      var _state = this.state,
	          totalFound = _state.totalFound,
	          watching = _state.watching;
	
	      if (direction === "next") {
	        watching += 1;
	        if (watching > totalFound) {
	          watching = 1;
	        }
	      }
	
	      if (direction === "previous") {
	        watching -= 1;
	        if (watching < 1) {
	          watching = totalFound;
	        }
	      }
	
	      this.setState({ watching: watching });
	    }
	  }, {
	    key: "getSearchCount",
	    value: function getSearchCount() {
	      var _state2 = this.state,
	          searchString = _state2.searchString,
	          totalFound = _state2.totalFound,
	          watching = _state2.watching;
	
	
	      if (totalFound === 0 && !searchString) {
	        return null;
	      }
	
	      if (totalFound === 0 && searchString) {
	        watching = 0;
	      }
	
	      return _react2.default.createElement(
	        "span",
	        { className: "search-count small flush text-muted" },
	        watching + " out of " + totalFound
	      );
	    }
	  }, {
	    key: "getSearchButtons",
	    value: function getSearchButtons() {
	      if (this.state.totalFound === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-group button-group-directions" },
	        _react2.default.createElement("div", {
	          onClick: this.changeWatching.bind(this, "previous"),
	          className: "button button-default button-up-arrow button-stroke"
	        }),
	        _react2.default.createElement("div", {
	          onClick: this.changeWatching.bind(this, "next"),
	          className: "button button-default button-down-arrow button-stroke"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          actions = _props.actions,
	          children = _props.children;
	      var _state3 = this.state,
	          searchString = _state3.searchString,
	          watching = _state3.watching;
	
	      var clonedChildren = children && _react2.default.cloneElement(children, {
	        highlightText: searchString,
	        watching: watching,
	        onCountChange: this.handleCountChange
	      });
	
	      var inputContainerClassSet = (0, _classnames2.default)({
	        "filter-input-text-group-wide": this.state.searchString
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-direction-top-to-bottom flex-item-grow-1 flex-item-shrink-1" },
	        _react2.default.createElement(
	          _FilterBar2.default,
	          {
	            className: "filter-bar control-group form-group flex-wrap-items-none-screen-small flex-item-shrink-0 flush-bottom",
	            leftChildrenClass: "filter-bar-left filter-bar-search-container flex-wrap-items-none flex-item-grow-1 flex-item-shrink-1",
	            rightAlignLastNChildren: _react2.default.Children.count(actions)
	          },
	          _react2.default.createElement(_FilterInputText2.default, {
	            ref: "filterInput",
	            className: "flex-grow flex-box flush-bottom",
	            placeholder: "Search",
	            searchString: this.state.searchString,
	            sideText: this.getSearchCount(),
	            handleFilterChange: this.handleSearchStringChange,
	            inputContainerClass: inputContainerClassSet
	          }),
	          this.getSearchButtons(),
	          actions
	        ),
	        clonedChildren
	      );
	    }
	  }]);
	  return SearchLog;
	}(_react2.default.Component);
	
	SearchLog.defaultProps = {
	  logFiles: []
	};
	
	SearchLog.propTypes = {
	  logFiles: _react2.default.PropTypes.array,
	  actions: _react2.default.PropTypes.node,
	  children: _react2.default.PropTypes.node
	};
	
	module.exports = SearchLog;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ConfigStore = __webpack_require__(1268);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Util = __webpack_require__(982);
	
	var _MesosLoggingStrategy = __webpack_require__(1519);
	
	var _Task = __webpack_require__(1264);
	
	var _Task2 = _interopRequireDefault(_Task);
	
	var _TaskDirectory = __webpack_require__(1496);
	
	var _TaskDirectory2 = _interopRequireDefault(_TaskDirectory);
	
	var _TaskFileViewer = __webpack_require__(1508);
	
	var _TaskFileViewer2 = _interopRequireDefault(_TaskFileViewer);
	
	var _TaskSystemLogsContainer = __webpack_require__(1520);
	
	var _TaskSystemLogsContainer2 = _interopRequireDefault(_TaskSystemLogsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskLogsContainer = function (_mixin) {
	  (0, _inherits3.default)(TaskLogsContainer, _mixin);
	
	  function TaskLogsContainer() {
	    (0, _classCallCheck3.default)(this, TaskLogsContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskLogsContainer.__proto__ || (0, _getPrototypeOf2.default)(TaskLogsContainer)).apply(this, arguments));
	
	    _this.state = {
	      isLoading: true
	    };
	
	    _this.store_listeners = [{
	      name: "config",
	      events: ["success", "error"],
	      listenAlways: false
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskLogsContainer, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      // We already have a configuration, so stop loading. No need to fetch
	      if (this.state.isLoading && _ConfigStore2.default.get("config") != null) {
	        this.setState({ isLoading: false });
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // We did not already receive the configuration
	      if (this.state.isLoading && _ConfigStore2.default.get("config") == null) {
	        _ConfigStore2.default.fetch();
	      }
	    }
	  }, {
	    key: "onConfigStoreSuccess",
	    value: function onConfigStoreSuccess() {
	      this.setState({ isLoading: false });
	    }
	  }, {
	    key: "onConfigStoreError",
	    value: function onConfigStoreError() {
	      this.setState({ isLoading: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this.state.isLoading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      var _props = this.props,
	          directory = _props.directory,
	          params = _props.params,
	          routes = _props.routes,
	          selectedLogFile = _props.selectedLogFile,
	          task = _props.task;
	
	      var config = _ConfigStore2.default.get("config");
	      var loggingStrategy = (0, _Util.findNestedPropertyInObject)(config, "uiConfiguration.plugins.mesos.logging-strategy");
	
	      if (loggingStrategy === _MesosLoggingStrategy.SYSTEM_LOGS) {
	        return _react2.default.createElement(_TaskSystemLogsContainer2.default, { task: task });
	      }
	
	      return _react2.default.createElement(_TaskFileViewer2.default, {
	        directory: directory,
	        limitLogFiles: ["stdout", "stderr"],
	        params: params,
	        routes: routes,
	        selectedLogFile: selectedLogFile,
	        task: task
	      });
	    }
	  }]);
	  return TaskLogsContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	TaskLogsContainer.propTypes = {
	  directory: _react2.default.PropTypes.instanceOf(_TaskDirectory2.default),
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array,
	  selectedLogFile: _react2.default.PropTypes.object,
	  task: _react2.default.PropTypes.instanceOf(_Task2.default)
	};
	
	module.exports = TaskLogsContainer;

/***/ },
/* 1519 */
/***/ function(module, exports) {

	"use strict";
	
	var MesosLoggingStrategy = {
	  SYSTEM_LOGS: "journald",
	  MESOS_LOGS: "logrotate",
	  SYSTEM_AND_MESOS_LOGS: "journald+logrotate"
	};
	
	module.exports = MesosLoggingStrategy;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _SystemLogTypes = __webpack_require__(1510);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MesosStateUtil = __webpack_require__(1262);
	
	var _MesosStateUtil2 = _interopRequireDefault(_MesosStateUtil);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _SystemLogStore = __webpack_require__(1521);
	
	var _SystemLogStore2 = _interopRequireDefault(_SystemLogStore);
	
	var _SystemLogUtil = __webpack_require__(1525);
	
	var _SystemLogUtil2 = _interopRequireDefault(_SystemLogUtil);
	
	var _LogView = __webpack_require__(1511);
	
	var _LogView2 = _interopRequireDefault(_LogView);
	
	var _SearchLog = __webpack_require__(1517);
	
	var _SearchLog2 = _interopRequireDefault(_SearchLog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleFetchPreviousLog", "handleItemSelection"];
	
	// Number of lines (entries) we asses to be a page
	var PAGE_ENTRY_COUNT = 400;
	
	function getLogParameters(task, options) {
	  var frameworkID = task.framework_id,
	      executorID = task.executor_id,
	      id = task.id;
	
	  if (!executorID) {
	    executorID = id;
	  }
	
	  return (0, _assign2.default)({
	    containerID: _MesosStateUtil2.default.getTaskContainerID(task),
	    executorID: executorID,
	    frameworkID: frameworkID
	  }, options);
	}
	
	var TaskSystemLogsContainer = function (_mixin) {
	  (0, _inherits3.default)(TaskSystemLogsContainer, _mixin);
	
	  function TaskSystemLogsContainer() {
	    (0, _classCallCheck3.default)(this, TaskSystemLogsContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskSystemLogsContainer.__proto__ || (0, _getPrototypeOf2.default)(TaskSystemLogsContainer)).apply(this, arguments));
	
	    _this.state = {
	      direction: _SystemLogTypes.APPEND,
	      fullLog: null,
	      hasError: false,
	      streams: [],
	      isFetchingPrevious: false,
	      isLoading: true
	    };
	
	    _this.store_listeners = [{
	      events: ["success", "error", "streamSuccess", "streamError"],
	      name: "systemLog",
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * @override
	   */
	
	
	  (0, _createClass3.default)(TaskSystemLogsContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(TaskSystemLogsContainer.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskSystemLogsContainer.prototype), "componentDidMount", this).call(this);
	      _SystemLogStore2.default.fetchStreamTypes(this.props.task.slave_id);
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _get3.default)(TaskSystemLogsContainer.prototype.__proto__ || (0, _getPrototypeOf2.default)(TaskSystemLogsContainer.prototype), "componentWillUnmount", this).call(this);
	      // Unsubscribe and clean up stored log lines
	      _SystemLogStore2.default.stopTailing(this.state.subscriptionID, true);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var curState = this.state;
	      var _props = this.props,
	          highlightText = _props.highlightText,
	          _props$task = _props.task,
	          task = _props$task === undefined ? {} : _props$task,
	          watching = _props.watching;
	
	      var stateToCheck = ["direction", "fullLog", "hasError", "isFetchingPrevious", "isLoading"];
	
	      var didHighlightTextChange = highlightText !== nextProps.highlightText;
	      var didWatchingChange = watching !== nextProps.watching;
	
	      var didSlaveIdChange = nextProps.task && task.slave_id !== nextProps.task.slave_id;
	
	      return didHighlightTextChange || didWatchingChange || didSlaveIdChange || stateToCheck.some(function (key) {
	        return curState[key] !== nextState[key];
	      }) || !(0, _deepEqual2.default)(curState.streams, nextState.streams);
	    }
	  }, {
	    key: "onSystemLogStoreError",
	    value: function onSystemLogStoreError(subscriptionID, direction) {
	      if (subscriptionID !== this.state.subscriptionID) {
	        return;
	      }
	
	      var newState = {
	        hasError: true,
	        isLoading: false
	      };
	
	      // Only set isFetchingPrevious when we receive prepending log event
	      if (this.state.isFetchingPrevious && direction === _SystemLogTypes.PREPEND) {
	        newState.isFetchingPrevious = false;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: "onSystemLogStoreSuccess",
	    value: function onSystemLogStoreSuccess(subscriptionID, direction) {
	      if (subscriptionID !== this.state.subscriptionID) {
	        return;
	      }
	
	      // Because we don't know if we are at the top when file loads, it will also
	      // fire on file load to check whether we are at the top
	      if (this.state.isLoading) {
	        this.handleFetchPreviousLog();
	      }
	
	      var newState = {
	        hasError: false,
	        direction: direction,
	        isLoading: false,
	        fullLog: _SystemLogStore2.default.getFullLog(subscriptionID)
	      };
	
	      // Only set isFetchingPrevious when we receive prepending log event
	      if (this.state.isFetchingPrevious && direction === _SystemLogTypes.PREPEND) {
	        newState.isFetchingPrevious = false;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: "onSystemLogStoreStreamError",
	    value: function onSystemLogStoreStreamError() {
	      this.setState({ hasError: true, isLoading: false });
	    }
	  }, {
	    key: "onSystemLogStoreStreamSuccess",
	    value: function onSystemLogStoreStreamSuccess(streams) {
	      if (!Array.isArray(streams) || !streams.length) {
	        this.setState({ hasError: true, isLoading: false });
	
	        return false;
	      }
	
	      var task = this.props.task;
	      // See if we can find STDOUT, otherwise take the first entry
	
	      var selectedStream = streams.find(function (item) {
	        return item === "STDOUT";
	      }) || streams[0];
	      // Limit 0 means continuous stream
	      // Get a full page of previous log entries
	      var params = getLogParameters(task, {
	        filter: { STREAM: selectedStream },
	        limit: 0,
	        skip_prev: 1
	      });
	      var subscriptionID = _SystemLogStore2.default.startTailing(task.slave_id, params);
	
	      this.setState({ hasError: false, streams: streams, selectedStream: selectedStream, subscriptionID: subscriptionID });
	    }
	
	    /**
	     * Will fetch previous logs, but is also used to check whether we are at the
	     * top of the file.
	     */
	
	  }, {
	    key: "handleFetchPreviousLog",
	    value: function handleFetchPreviousLog() {
	      // Ongoing previous log fetch, wait for that to complete
	      if (this.state.isFetchingPrevious) {
	        return;
	      }
	
	      this.setState({ isFetchingPrevious: true });
	
	      var task = this.props.task;
	      var subscriptionID = this.state.subscriptionID;
	
	      // Fetch a full page previous log entries to gain more leverage to explore
	      // previous logs
	
	      var params = getLogParameters(task, {
	        filter: { STREAM: this.state.selectedStream },
	        limit: PAGE_ENTRY_COUNT,
	        subscriptionID: subscriptionID
	      });
	
	      _SystemLogStore2.default.fetchRange(task.slave_id, params);
	    }
	  }, {
	    key: "handleViewChange",
	    value: function handleViewChange(selectedStream) {
	      var task = this.props.task;
	      // Limit 0 means continuous stream
	      // Get a full page of previous log entries
	
	      var params = getLogParameters(task, {
	        filter: { STREAM: selectedStream },
	        limit: 0,
	        skip_prev: 1
	      });
	
	      // Unsubscribe and clean up stored log lines
	      _SystemLogStore2.default.stopTailing(this.state.subscriptionID, true);
	      var subscriptionID = _SystemLogStore2.default.startTailing(task.slave_id, params);
	      this.setState({ isLoading: true, selectedStream: selectedStream, subscriptionID: subscriptionID });
	    }
	  }, {
	    key: "getLogSelectionAsButtons",
	    value: function getLogSelectionAsButtons() {
	      var _this2 = this;
	
	      var _state = this.state,
	          streams = _state.streams,
	          selectedStream = _state.selectedStream;
	
	      var buttons = streams.map(function (name, index) {
	        var classes = (0, _classnames2.default)({
	          "button button-stroke": true,
	          active: name === selectedStream
	        });
	
	        return _react2.default.createElement(
	          "button",
	          {
	            className: classes,
	            key: index,
	            onClick: _this2.handleViewChange.bind(_this2, name)
	          },
	          name
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { key: "buttons", className: "button-group" },
	        buttons
	      );
	    }
	  }, {
	    key: "handleItemSelection",
	    value: function handleItemSelection(obj) {
	      this.handleViewChange.call(this, obj.value);
	    }
	  }, {
	    key: "getDropdownItems",
	    value: function getDropdownItems() {
	      return this.state.streams.map(function (name) {
	        var selectedHtml = _react2.default.createElement(
	          "span",
	          { className: "flush dropdown-header" },
	          name
	        );
	        var dropdownHtml = _react2.default.createElement(
	          "a",
	          null,
	          selectedHtml
	        );
	
	        return {
	          id: name,
	          name: name,
	          html: dropdownHtml,
	          selectedHtml: selectedHtml,
	          value: name
	        };
	      }, this);
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      var _state2 = this.state,
	          streams = _state2.streams,
	          selectedStream = _state2.selectedStream;
	
	      if (streams.length < 3) {
	        return this.getLogSelectionAsButtons();
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Dropdown, {
	        key: "dropdown",
	        buttonClassName: "button dropdown-toggle",
	        dropdownMenuClassName: "dropdown-menu",
	        dropdownMenuListClassName: "dropdown-menu-list",
	        dropdownMenuListItemClassName: "clickable",
	        initialID: selectedStream,
	        items: this.getDropdownItems(),
	        onItemSelection: this.handleItemSelection,
	        scrollContainer: ".gm-scroll-view",
	        scrollContainerParentSelector: ".gm-prevented",
	        transition: true,
	        transitionName: "dropdown-menu",
	        wrapperClassName: "dropdown form-group"
	      });
	    }
	  }, {
	    key: "getDownloadButton",
	    value: function getDownloadButton() {
	      var task = this.props.task;
	      var selectedStream = this.state.selectedStream;
	
	      var params = getLogParameters(task, {
	        // This will be added to the name
	        postfix: selectedStream && selectedStream.toLowerCase(),
	        filter: { STREAM: selectedStream }
	      });
	
	      // This is a hacky way of interacting with the API to be able to download
	      // logs with a POST request
	      return _react2.default.createElement(
	        "a",
	        {
	          className: "button button-stroke",
	          disabled: !task,
	          href: _SystemLogUtil2.default.getUrl(task.slave_id, params, false, "/download"),
	          key: "download"
	        },
	        _react2.default.createElement(_Icon2.default, { id: "download", size: "mini" })
	      );
	    }
	  }, {
	    key: "getLogView",
	    value: function getLogView() {
	      var _props2 = this.props,
	          highlightText = _props2.highlightText,
	          onCountChange = _props2.onCountChange,
	          watching = _props2.watching;
	      var _state3 = this.state,
	          hasError = _state3.hasError,
	          direction = _state3.direction,
	          fullLog = _state3.fullLog,
	          isLoading = _state3.isLoading,
	          selectedStream = _state3.selectedStream,
	          subscriptionID = _state3.subscriptionID;
	
	
	      if (hasError) {
	        return _react2.default.createElement(_RequestErrorMsg2.default, null);
	      }
	
	      if (isLoading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      return _react2.default.createElement(_LogView2.default, {
	        direction: direction,
	        fetchPreviousLogs: this.handleFetchPreviousLog,
	        fullLog: fullLog,
	        hasLoadedTop: _SystemLogStore2.default.hasLoadedTop(subscriptionID),
	        highlightText: highlightText,
	        logName: selectedStream,
	        onCountChange: onCountChange,
	        watching: watching
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var actions = [this.getActions(), this.getDownloadButton()];
	
	      return _react2.default.createElement(
	        _SearchLog2.default,
	        { actions: actions },
	        this.getLogView()
	      );
	    }
	  }]);
	  return TaskSystemLogsContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	TaskSystemLogsContainer.propTypes = {
	  task: _react2.default.PropTypes.shape({
	    slave_id: _react2.default.PropTypes.string
	  })
	};
	
	TaskSystemLogsContainer.defaultProps = {
	  highlightText: ""
	};
	
	TaskSystemLogsContainer.propTypes = {
	  filePath: _react2.default.PropTypes.string,
	  highlightText: _react2.default.PropTypes.string,
	  logName: _react2.default.PropTypes.string,
	  onCountChange: _react2.default.PropTypes.func,
	  task: _react2.default.PropTypes.object.isRequired,
	  watching: _react2.default.PropTypes.number
	};
	
	module.exports = TaskSystemLogsContainer;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _EventTypes = __webpack_require__(933);
	
	var _BaseStore2 = __webpack_require__(1008);
	
	var _BaseStore3 = _interopRequireDefault(_BaseStore2);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _SystemLogActions = __webpack_require__(1522);
	
	var _SystemLogActions2 = _interopRequireDefault(_SystemLogActions);
	
	var _SystemLogTypes = __webpack_require__(1510);
	
	var _Util = __webpack_require__(982);
	
	var _LogFields = __webpack_require__(1526);
	
	var _DateUtil = __webpack_require__(1105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SystemLogStore = function (_BaseStore) {
	  (0, _inherits3.default)(SystemLogStore, _BaseStore);
	
	  function SystemLogStore() {
	    (0, _classCallCheck3.default)(this, SystemLogStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SystemLogStore.__proto__ || (0, _getPrototypeOf2.default)(SystemLogStore)).apply(this, arguments));
	
	    _this.logs = {};
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.SYSTEM_LOG_CHANGE,
	        error: _EventTypes.SYSTEM_LOG_REQUEST_ERROR,
	        streamSuccess: _EventTypes.SYSTEM_LOG_STREAM_TYPES_SUCCESS,
	        streamError: _EventTypes.SYSTEM_LOG_STREAM_TYPES_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true,
	      suppressUpdate: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      var source = payload.source;
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var _payload$action = payload.action,
	          data = _payload$action.data,
	          firstEntry = _payload$action.firstEntry,
	          subscriptionID = _payload$action.subscriptionID,
	          type = _payload$action.type;
	
	
	      switch (type) {
	        case _ActionTypes.REQUEST_SYSTEM_LOG_SUCCESS:
	          _this.processLogAppend(subscriptionID, data);
	          break;
	        case _ActionTypes.REQUEST_SYSTEM_LOG_ERROR:
	          _this.processLogError(subscriptionID, data);
	          break;
	        case _ActionTypes.REQUEST_PREVIOUS_SYSTEM_LOG_SUCCESS:
	          _this.processLogPrepend(subscriptionID, firstEntry, data);
	          break;
	        case _ActionTypes.REQUEST_PREVIOUS_SYSTEM_LOG_ERROR:
	          _this.processLogPrependError(subscriptionID, data);
	          break;
	        case _ActionTypes.REQUEST_SYSTEM_LOG_STREAM_TYPES_SUCCESS:
	          _this.emit(_EventTypes.SYSTEM_LOG_STREAM_TYPES_SUCCESS, data);
	          break;
	        case _ActionTypes.REQUEST_SYSTEM_LOG_STREAM_TYPES_ERROR:
	          _this.emit(_EventTypes.SYSTEM_LOG_STREAM_TYPES_ERROR, data);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(SystemLogStore, [{
	    key: "addEntries",
	    value: function addEntries(logData, entries, eventType) {
	      var newLogData = (0, _assign2.default)({}, logData);
	      // Add new entries
	      if (eventType === _SystemLogTypes.APPEND) {
	        newLogData.entries = logData.entries.concat(entries);
	      } else {
	        newLogData.entries = entries.concat(logData.entries);
	      }
	      var length = entries.reduce(function (sum, entry) {
	        return sum + (0, _Util.findNestedPropertyInObject)(entry, "fields." + _LogFields.MESSAGE + ".length") || 0;
	      }, 0);
	
	      // Update new size
	      newLogData.totalSize += length;
	
	      return newLogData;
	    }
	  }, {
	    key: "getFullLog",
	    value: function getFullLog(subscriptionID) {
	      var entries = (0, _Util.findNestedPropertyInObject)(this.logs[subscriptionID], "entries") || [];
	
	      // Formatting logs as we do in the CLI:
	      // https://github.com/dcos/dcos-cli/pull/817/files#diff-8f3b06e62cf338c8e4e2ac6414447d26R260
	      return entries.filter(function (entry) {
	        return Boolean((0, _Util.findNestedPropertyInObject)(entry, "fields." + _LogFields.MESSAGE));
	      }).map(function (entry) {
	        var _entry$fields = entry.fields,
	            fields = _entry$fields === undefined ? {} : _entry$fields;
	
	        var lineData = [];
	        // entry.realtime_timestamp returns a unix time in microseconds
	        // https://www.freedesktop.org/software/systemd/man/sd_journal_get_realtime_usec.html
	        if (typeof entry.realtime_timestamp === "number") {
	          lineData.push((0, _DateUtil.msToLogTime)(entry.realtime_timestamp / 1000));
	        }
	        // Concat `:` to last element if there is data
	        if (lineData.length) {
	          var lastElement = lineData[lineData.length - 1];
	          lineData[lineData.length - 1] = lastElement + ":";
	        }
	
	        lineData.push(fields[_LogFields.MESSAGE]);
	
	        // Format: `date: MESSAGE`
	        return "" + lineData.join(" ");
	      }).join("\n");
	    }
	  }, {
	    key: "hasLoadedTop",
	    value: function hasLoadedTop(subscriptionID) {
	      var logs = this.logs[subscriptionID];
	      if (!logs || !logs.hasLoadedTop) {
	        return false;
	      }
	
	      return logs.hasLoadedTop;
	    }
	  }, {
	    key: "startTailing",
	    value: function startTailing(nodeID, options) {
	      var _this2 = this;
	
	      var _options = options,
	          subscriptionID = _options.subscriptionID,
	          cursor = _options.cursor;
	
	      if (!cursor && subscriptionID && this.logs[subscriptionID]) {
	        var entries = this.logs[subscriptionID].entries;
	
	        cursor = entries[entries.length - 1].cursor;
	        options = (0, _assign2.default)({}, options, { cursor: cursor });
	      }
	
	      // Will return unchanged subscriptionID if provided in the options
	      subscriptionID = _SystemLogActions2.default.startTail(nodeID, options);
	
	      // Start a timer to notify view if we have received nothing
	      // within reasonable time
	      setTimeout(function () {
	        if (subscriptionID && !_this2.logs[subscriptionID]) {
	          // Send event that we have not received anything. However,
	          // keep connection open, if we receive data later, we want to show it.
	          _this2.emit(_EventTypes.SYSTEM_LOG_CHANGE, subscriptionID, _SystemLogTypes.APPEND);
	        }
	        // Let's wait 2 x stateRefresh ~ 2 errors,
	        // as we do in other views
	      }, _Config2.default.stateRefresh * 2);
	
	      // Return received subscriptionID
	      return subscriptionID;
	    }
	  }, {
	    key: "stopTailing",
	    value: function stopTailing(subscriptionID) {
	      var shouldClearData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (shouldClearData) {
	        delete this.logs[subscriptionID];
	      }
	
	      _SystemLogActions2.default.stopTail(subscriptionID);
	    }
	  }, {
	    key: "fetchRange",
	    value: function fetchRange(nodeID, options) {
	      var subscriptionID = options.subscriptionID;
	
	      var cursor = (0, _Util.findNestedPropertyInObject)(this.logs[subscriptionID], "entries.0.cursor");
	      if (!cursor && !options.cursor || this.hasLoadedTop(subscriptionID)) {
	        return false;
	      }
	
	      _SystemLogActions2.default.fetchRange(nodeID, (0, _assign2.default)({ cursor: cursor }, options));
	    }
	  }, {
	    key: "fetchStreamTypes",
	    value: function fetchStreamTypes(nodeID) {
	      _SystemLogActions2.default.fetchStreamTypes(nodeID);
	    }
	  }, {
	    key: "processLogAppend",
	    value: function processLogAppend(subscriptionID, entries) {
	      if (!this.logs[subscriptionID]) {
	        this.logs[subscriptionID] = { entries: [], totalSize: 0 };
	      }
	
	      this.logs[subscriptionID] = this.addEntries(this.logs[subscriptionID], entries, _SystemLogTypes.APPEND);
	      this.emit(_EventTypes.SYSTEM_LOG_CHANGE, subscriptionID, _SystemLogTypes.APPEND);
	    }
	  }, {
	    key: "processLogError",
	    value: function processLogError(subscriptionID, data) {
	      if (!this.logs[subscriptionID]) {
	        this.logs[subscriptionID] = { entries: [], totalSize: 0 };
	      }
	      this.emit(_EventTypes.SYSTEM_LOG_REQUEST_ERROR, subscriptionID, _SystemLogTypes.APPEND, data);
	    }
	  }, {
	    key: "processLogPrepend",
	    value: function processLogPrepend(subscriptionID, firstEntry) {
	      var entries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	      if (!this.logs[subscriptionID]) {
	        this.logs[subscriptionID] = { entries: [], totalSize: 0 };
	      }
	
	      this.logs[subscriptionID].hasLoadedTop = firstEntry;
	
	      this.logs[subscriptionID] = this.addEntries(this.logs[subscriptionID], entries, _SystemLogTypes.PREPEND);
	
	      this.emit(_EventTypes.SYSTEM_LOG_CHANGE, subscriptionID, _SystemLogTypes.PREPEND);
	    }
	  }, {
	    key: "processLogPrependError",
	    value: function processLogPrependError(subscriptionID, data) {
	      if (!this.logs[subscriptionID]) {
	        this.logs[subscriptionID] = { entries: [], totalSize: 0 };
	      }
	      this.emit(_EventTypes.SYSTEM_LOG_REQUEST_ERROR, subscriptionID, _SystemLogTypes.PREPEND, data);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "systemLog";
	    }
	  }]);
	  return SystemLogStore;
	}(_BaseStore3.default);
	
	module.exports = new SystemLogStore();

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _for = __webpack_require__(1523);
	
	var _for2 = _interopRequireDefault(_for);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _SystemLogUtil = __webpack_require__(1525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Implementation of server sent event handling for
	 * https://github.com/dcos/dcos-log
	 */
	
	var eventThroughPutTime = 500;
	// Store of current open connections
	var urlToEventSourceMap = {};
	var subscriptionIDtoURLMap = {};
	
	function subscribe(url, onMessage, onError) {
	  // Unsubscribe if any open connection exists with the same ID
	  unsubscribe(url);
	
	  var source = new EventSource(url);
	
	  source.addEventListener("message", onMessage, false);
	  source.addEventListener("error", onError, false);
	
	  // Store listeners along with EventSource reference, so we can clean up
	  urlToEventSourceMap[url] = {
	    errorListener: onError,
	    messageListener: onMessage,
	    source: source
	  };
	
	  return url;
	}
	
	function unsubscribe(url) {
	  if (!urlToEventSourceMap[url]) {
	    return;
	  }
	
	  var _urlToEventSourceMap$ = urlToEventSourceMap[url],
	      errorListener = _urlToEventSourceMap$.errorListener,
	      messageListener = _urlToEventSourceMap$.messageListener,
	      source = _urlToEventSourceMap$.source;
	
	
	  source.removeEventListener("message", messageListener, false);
	  source.removeEventListener("error", errorListener, false);
	
	  source.close();
	
	  delete urlToEventSourceMap[url];
	}
	
	function parseEvents(eventData) {
	  var globalOrigin = global.location.origin;
	
	  return eventData.reduce(function (memo, event) {
	    // Only take first argument, which holds the event
	    var _ref = event[0] || {},
	        data = _ref.data,
	        origin = _ref.origin;
	
	    if (origin !== globalOrigin) {
	      // Ignore events that are not from this origin
	      return memo;
	    }
	
	    try {
	      // Attempt parsing
	      var parsedEvent = JSON.parse(data);
	      // Append when regular reverse order
	      memo.events.push(parsedEvent);
	    } catch (error) {
	      memo.errors.push(error);
	    }
	
	    return memo;
	  }, { events: [], errors: [] });
	}
	
	var SystemLogActions = {
	  /**
	   * Subscribes to the events stream for logs given the parameters provided
	   * @param {String} nodeID ID of the node to retrieve logs from
	   * @param {Object} [options] Optional parameters for request
	   * @param {String} [options.cursor] ID of the cursor to request entries from
	   * @param {String} [options.subscriptionID] ID to emit events to,
	   *   if omitted a new one will be created
	   * @param {Number} [options.skip_prev] how many entries backwards to look.
	   * NB: This _needs_ to be present to start streaming from the bottom!!
	   * @param {Number} [options.skip_next] how many entries to look ahead
	   * @param {Number} [options.limit] limit how many entries to receive
	   * @param {Object} [options.filter] filter parameters to add to URL
	   * @param {String} [options.frameworkID] ID for framework to retrieve logs from
	   * @param {String} [options.executorID] ID for executor to retrieve logs from
	   * @param {String} [options.containerID] ID for container to retrieve logs from
	   * @param {String} [options.read_reverse] will read events in reverse order if set to true
	   * @return {Symbol} subscriptionID to unsubscribe or resubscribe with
	   */
	  startTail: function startTail(nodeID) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var subscriptionID = options.subscriptionID,
	        cursor = options.cursor,
	        skip_prev = options.skip_prev;
	
	    // NB: When subscriptionID is passed from the store and an ongoing stream
	    // is open, it will close the connection before opening a new one
	
	    this.stopTail(subscriptionID);
	
	    var url = (0, _SystemLogUtil.getUrl)(nodeID, options);
	    // NB: User can pass `subscriptionID` to associate it with their local data
	    // accumulation
	    subscriptionID = subscriptionID || (0, _for2.default)(url);
	
	    // Will receive an array of events through the accumulatedThrottle function
	    function messageListener(eventData) {
	      var _parseEvents = parseEvents(eventData),
	          events = _parseEvents.events,
	          errors = _parseEvents.errors;
	
	      if (errors.length > 0) {
	        // Some data was corrupt and could not be parsed
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_SYSTEM_LOG_ERROR,
	          data: errors,
	          subscriptionID: subscriptionID
	        });
	      }
	
	      // Skip if we are hitting the same cursor as we requested with and we are
	      // not looking backwards. This is only relevant for the first item we hit
	      if (!skip_prev && events[0] && events[0].cursor === cursor) {
	        events.shift();
	      }
	
	      // No data to emit
	      if (events.length <= 0) {
	        return;
	      }
	
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_SYSTEM_LOG_SUCCESS,
	        data: events,
	        subscriptionID: subscriptionID
	      });
	    }
	
	    var throttledMessageListener = (0, _SystemLogUtil.accumulatedThrottle)(messageListener, eventThroughPutTime);
	
	    function errorListener() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _AppDispatcher2.default.handleServerAction({
	        type: _ActionTypes.REQUEST_SYSTEM_LOG_ERROR,
	        data: event,
	        subscriptionID: subscriptionID
	      });
	    }
	
	    subscriptionIDtoURLMap[subscriptionID] = url;
	
	    subscribe(url, throttledMessageListener, errorListener);
	
	    return subscriptionID;
	  },
	
	
	  /**
	   * Unsubscribes from the event stream from the given subscriptionID
	   * @param {String} subscriptionID ID returned from subscribe function
	   */
	  stopTail: function stopTail(subscriptionID) {
	    if (!subscriptionIDtoURLMap[subscriptionID]) {
	      return;
	    }
	
	    unsubscribe(subscriptionIDtoURLMap[subscriptionID]);
	    delete subscriptionIDtoURLMap[subscriptionID];
	  },
	
	
	  /**
	   * Fetches a range of log entries given the parameters provided
	   * @param {String} nodeID ID of the node to retrieve logs from
	   * @param {Object} [options] Optional parameters for request
	   * @param {String} [options.cursor] ID of the cursor to request entries from
	   * @param {String} [options.subscriptionID] ID to emit events to,
	   *   if omitted a new one will be created
	   * @param {Number} [options.skip_prev] how many entries backwards to look
	   * @param {Number} [options.skip_next] how many entries to look ahead
	   * @param {Number} [options.limit] limit how many entries to receive
	   * @param {Object} [options.filter] filter parameters to add to URL
	   * @param {String} [options.frameworkID] ID for framework to retrieve logs from
	   * @param {String} [options.executorID] ID for executor to retrieve logs from
	   * @param {String} [options.containerID] ID for container to retrieve logs from
	   */
	  fetchRange: function fetchRange(nodeID) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var limit = options.limit,
	        subscriptionID = options.subscriptionID;
	
	    var url = (0, _SystemLogUtil.getUrl)(nodeID,
	    // Avoiding duplicate events by using read reverse (stream backwards).
	    // Connection will close all events are received or have reached the top
	    (0, _assign2.default)(options, { read_reverse: true }), false);
	    // NB: User can pass `subscriptionID` to associate it with their local data
	    // accumulation
	    subscriptionID = subscriptionID || (0, _for2.default)(url);
	
	    var items = [];
	
	    function messageListener() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          data = _ref2.data,
	          origin = _ref2.origin;
	
	      if (origin !== global.location.origin) {
	        // Ignore events that are not from this origin
	        return false;
	      }
	
	      var parsedData = void 0;
	      try {
	        parsedData = JSON.parse(data);
	      } catch (error) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_PREVIOUS_SYSTEM_LOG_ERROR,
	          data: error,
	          subscriptionID: subscriptionID
	        });
	      }
	
	      // Unshift items as the come in opposite order
	      items.unshift(parsedData);
	    }
	
	    function errorListener() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var eventPhase = event.eventPhase;
	
	
	      if (eventPhase === EventSource.CLOSED) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_PREVIOUS_SYSTEM_LOG_SUCCESS,
	          data: items,
	          firstEntry: items.length < limit,
	          subscriptionID: subscriptionID
	        });
	      } else {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_PREVIOUS_SYSTEM_LOG_ERROR,
	          data: event,
	          subscriptionID: subscriptionID
	        });
	      }
	
	      unsubscribe(url);
	    }
	
	    subscribe(url, messageListener, errorListener);
	  },
	  fetchStreamTypes: function fetchStreamTypes(nodeID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: _Config2.default.logsAPIPrefix + "/" + nodeID + "/logs/v1/fields/STREAM",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_SYSTEM_LOG_STREAM_TYPES_SUCCESS,
	          data: response
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_SYSTEM_LOG_STREAM_TYPES_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	module.exports = SystemLogActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1524), __esModule: true };

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(942);
	module.exports = __webpack_require__(870).Symbol['for'];

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paramOptions = ["cursor", "limit", "postfix", "read_reverse", "skip_prev", "skip_next"];
	
	var SystemLogUtil = {
	  /**
	   * Creates a URL to use with the events stream for logs
	   * given the parameters provided
	   * @param {String} nodeID ID of the node to retrieve logs from
	   * @param {Object} [options] Optional parameters for request
	   * @param {String} [options.cursor] ID of the cursor to request entries from
	   * @param {String} [options.subscriptionID] ID to emit events to,
	   *   if omitted a new one will be created
	   * @param {String} [options.containerID] ID for container to retrieve logs from
	   * @param {String} [options.executorID] ID for executor to retrieve logs from
	   * @param {String} [options.frameworkID] ID for framework to retrieve logs from
	   * @param {Object} [options.filter] filter parameters to add to URL
	   * @param {Number} [options.limit] limit how many entries to receive
	   * @param {Number} [options.postfix] postifx to add to the download name
	   * @param {String} [options.read_reverse] will read events in reverse order if set to true
	   * @param {Number} [options.skip_prev] how many entries backwards to look
	   * @param {Number} [options.skip_next] how many entries to look ahead
	   * @param {Boolean} [isStream = true] whether to use stream or range base
	   * @param {String} [endpoint = ''] add aditional endpoint to the url
	   * @returns {String} URL for system logs request
	   */
	  getUrl: function getUrl(nodeID, options) {
	    var isStream = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var endpoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
	    var _options$filter = options.filter,
	        filter = _options$filter === undefined ? {} : _options$filter;
	
	
	    var range = paramOptions.reduce(function (memo, key) {
	      if (options[key] !== "" && options[key] != null) {
	        memo.push(key + "=" + encodeURIComponent(options[key]));
	      }
	
	      return memo;
	    }, []);
	
	    var paramsArray = (0, _keys2.default)(filter).reduce(function (memo, key) {
	      if (filter[key] !== "" && filter[key] != null) {
	        memo.push("filter=" + encodeURIComponent(key) + ":" + encodeURIComponent(filter[key]));
	      }
	
	      return memo;
	    }, range);
	
	    var base = "range";
	    if (isStream) {
	      base = "stream";
	    }
	
	    var idArray = ["framework", "executor", "container"].reduce(function (memo, key) {
	      var id = key + "ID";
	      if (options[id] !== "" && options[id] != null) {
	        memo.push(key, options[id]);
	      }
	
	      return memo;
	    }, []);
	
	    return _Config2.default.logsAPIPrefix + "/" + nodeID + "/logs/v1/" + base + "/" + idArray.join("/") + endpoint + "?" + paramsArray.join("&");
	  },
	
	
	  /**
	   * A throttle function that will make sure callback is not called more than
	   * once per `wait` miliseconds. It will accumulate arguments and pass it to
	   * the callback as an array (Arguments[]).
	   * @param  {Function} callback to be throttled
	   * @param  {Number} wait miliseconds to wait before attemting next execution
	   * @return {Function} throttled function, which can be called extensively
	   */
	  accumulatedThrottle: function accumulatedThrottle(callback, wait) {
	    var timeoutID = void 0;
	    var accumulatedData = [];
	
	    return function () {
	      // Gather data for each call
	      accumulatedData.push(arguments);
	
	      if (!timeoutID) {
	        var context = this;
	
	        // Call callback immediately with accumulatedData
	        callback.call(context, accumulatedData);
	        // Clear the accumulated data array
	        accumulatedData = [];
	
	        timeoutID = setTimeout(function () {
	          // Call callback after wait with accumulatedData
	          callback.call(context, accumulatedData);
	          // Clear the accumulated data array
	          accumulatedData = [];
	
	          // Clean up our timeoutID
	          clearTimeout(timeoutID);
	          timeoutID = undefined;
	        }, wait);
	      }
	    };
	  }
	};
	
	module.exports = SystemLogUtil;

/***/ },
/* 1526 */
/***/ function(module, exports) {

	"use strict";
	
	var LogFields = {
	  HOSTNAME: "_HOSTNAME",
	  MESSAGE: "MESSAGE",
	  PID: "_PID",
	  SYSLOG_IDENTIFIER: "SYSLOG_IDENTIFIER"
	};
	
	module.exports = LogFields;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _NetworkPage = __webpack_require__(1528);
	
	var _NetworkPage2 = _interopRequireDefault(_NetworkPage);
	
	var _TaskDetailsTab = __webpack_require__(1499);
	
	var _TaskDetailsTab2 = _interopRequireDefault(_TaskDetailsTab);
	
	var _TaskFileBrowser = __webpack_require__(1504);
	
	var _TaskFileBrowser2 = _interopRequireDefault(_TaskFileBrowser);
	
	var _TaskFilesTab = __webpack_require__(1507);
	
	var _TaskFilesTab2 = _interopRequireDefault(_TaskFilesTab);
	
	var _TaskFileViewer = __webpack_require__(1508);
	
	var _TaskFileViewer2 = _interopRequireDefault(_TaskFileViewer);
	
	var _TaskLogsContainer = __webpack_require__(1518);
	
	var _TaskLogsContainer2 = _interopRequireDefault(_TaskLogsContainer);
	
	var _VirtualNetworkDetail = __webpack_require__(1529);
	
	var _VirtualNetworkDetail2 = _interopRequireDefault(_VirtualNetworkDetail);
	
	var _VirtualNetworkDetailsTab = __webpack_require__(1534);
	
	var _VirtualNetworkDetailsTab2 = _interopRequireDefault(_VirtualNetworkDetailsTab);
	
	var _VirtualNetworksTab = __webpack_require__(1535);
	
	var _VirtualNetworksTab2 = _interopRequireDefault(_VirtualNetworksTab);
	
	var _VirtualNetworkTaskPage = __webpack_require__(1537);
	
	var _VirtualNetworkTaskPage2 = _interopRequireDefault(_VirtualNetworkTaskPage);
	
	var _VirtualNetworkTaskTab = __webpack_require__(1538);
	
	var _VirtualNetworkTaskTab2 = _interopRequireDefault(_VirtualNetworkTaskTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var RouteFactory = {
	  getNetworkRoutes: function getNetworkRoutes() {
	    var virtualNetworksRoute = [{
	      type: _reactRouter.Route,
	      path: "networks",
	      component: _VirtualNetworksTab2.default,
	      isInSidebar: true
	    }, {
	      type: _reactRouter.Route,
	      path: "networks/:overlayName",
	      component: _VirtualNetworkDetail2.default,
	      children: [{
	        type: _reactRouter.IndexRoute,
	        component: _VirtualNetworkTaskTab2.default,
	        hideHeaderNavigation: true
	      }, {
	        type: _reactRouter.Route,
	        path: "details",
	        component: _VirtualNetworkDetailsTab2.default,
	        hideHeaderNavigation: true
	      }]
	    }, {
	      type: _reactRouter.Redirect,
	      path: "/networking/networks/:overlayName/tasks/:taskID",
	      to: "/networking/networks/:overlayName/tasks/:taskID/details"
	    }, {
	      type: _reactRouter.Route,
	      path: "networks/:overlayName/tasks/:taskID",
	      component: _VirtualNetworkTaskPage2.default,
	      hideHeaderNavigation: true,
	      children: [{
	        component: _TaskDetailsTab2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "details",
	        title: "Details",
	        type: _reactRouter.Route
	      }, {
	        hideHeaderNavigation: true,
	        component: _TaskFilesTab2.default,
	        isTab: true,
	        path: "files",
	        title: "Files",
	        type: _reactRouter.Route,
	        children: [{
	          component: _TaskFileBrowser2.default,
	          fileViewerRoutePath: "/networking/networks/:overlayName/tasks/:taskID/files/view(/:filePath(/:innerPath))",
	          hideHeaderNavigation: true,
	          type: _reactRouter.IndexRoute
	        }, {
	          component: _TaskFileViewer2.default,
	          hideHeaderNavigation: true,
	          path: "view(/:filePath(/:innerPath))",
	          type: _reactRouter.Route
	        }]
	      }, {
	        component: _TaskLogsContainer2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "logs",
	        title: "Logs",
	        type: _reactRouter.Route,
	        children: [{
	          path: ":filePath",
	          type: _reactRouter.Route
	        }]
	      }]
	    }];
	
	    // Return filtered Routes
	    // Pass in Object so Plugins can mutate routes and the default redirect
	    return _PluginSDK.Hooks.applyFilter("networkRoutes", {
	      routes: virtualNetworksRoute,
	      redirect: {
	        type: _reactRouter.Redirect,
	        from: "/networking",
	        to: "/networking/networks"
	      }
	    });
	  },
	  getRoutes: function getRoutes() {
	    var _getNetworkRoutes = this.getNetworkRoutes(),
	        routes = _getNetworkRoutes.routes,
	        redirect = _getNetworkRoutes.redirect;
	
	    return [
	    // Redirect should always go before path, otherwise router won't ever reach it
	    redirect, {
	      type: _reactRouter.Route,
	      path: "networking",
	      component: _NetworkPage2.default,
	      category: "resources",
	      isInSidebar: true,
	      children: routes
	    }];
	  }
	};
	/* eslint-enable no-unused-vars */
	
	
	module.exports = RouteFactory;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _promise = __webpack_require__(880);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var NetworkingBreadcrumbs = function NetworkingBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Networks" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/networking" },
	        "Networks"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "network", breadcrumbs: crumbs });
	};
	/* eslint-disable no-unused-vars */
	
	var NetworkPage = function (_mixin) {
	  (0, _inherits3.default)(NetworkPage, _mixin);
	
	  function NetworkPage() {
	    (0, _classCallCheck3.default)(this, NetworkPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NetworkPage.__proto__ || (0, _getPrototypeOf2.default)(NetworkPage)).apply(this, arguments));
	
	    _this.state = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(NetworkPage, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _get3.default)(NetworkPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(NetworkPage.prototype), "componentWillMount", this).apply(this, arguments);
	
	      var networkPageReady = _PluginSDK.Hooks.applyFilter("networkPageReady", _promise2.default.resolve({ isReady: true }));
	
	      if (!networkPageReady.isReady) {
	        // Set page ready once promise resolves
	        networkPageReady.then(function () {
	          _this2.setState({ networkPageReady: true });
	        });
	      }
	
	      this.setState({ networkPageReady: networkPageReady.isReady });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!this.state.networkPageReady) {
	        return _react2.default.createElement(
	          _Page2.default,
	          null,
	          _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(NetworkingBreadcrumbs, null) }),
	          _react2.default.createElement(_Loader2.default, null)
	        );
	      }
	
	      return this.props.children;
	    }
	  }]);
	  return NetworkPage;
	}((0, _reactjsMixin2.default)(_TabsMixin2.default));
	
	NetworkPage.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	NetworkPage.routeConfig = {
	  label: "Networking",
	  icon: _react2.default.createElement(_Icon2.default, { id: "network-inverse", size: "small", family: "product" }),
	  matches: /^\/networking/
	};
	
	NetworkPage.willTransitionTo = function () {
	  _SidebarActions2.default.close();
	};
	
	module.exports = NetworkPage;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _VirtualNetworksStore = __webpack_require__(1530);
	
	var _VirtualNetworksStore2 = _interopRequireDefault(_VirtualNetworksStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var NetworksDetailBreadcrumbs = function NetworksDetailBreadcrumbs(_ref) {
	  var overlayID = _ref.overlayID,
	      overlay = _ref.overlay;
	
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Networks" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/networking/networks" },
	        "Networks"
	      )
	    )
	  )];
	
	  if (overlay) {
	    var name = overlay.getName();
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 1, title: name },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/networking/networks/" + name },
	          name
	        )
	      )
	    ));
	  } else {
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 1, title: overlayID },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        overlayID
	      )
	    ));
	  }
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "network", breadcrumbs: crumbs });
	};
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["onVirtualNetworksStoreError", "onVirtualNetworksStoreSuccess"];
	
	var VirtualNetworkDetail = function (_mixin) {
	  (0, _inherits3.default)(VirtualNetworkDetail, _mixin);
	
	  function VirtualNetworkDetail() {
	    (0, _classCallCheck3.default)(this, VirtualNetworkDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VirtualNetworkDetail.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkDetail)).apply(this, arguments));
	
	    _this.state = {
	      errorCount: 0,
	      receivedVirtualNetworks: false
	    };
	
	    // Virtual Network Detail Tabs
	    _this.tabs_tabs = {
	      "/networking/networks/:overlayName": "Tasks",
	      "/networking/networks/:overlayName/details": "Details"
	    };
	
	    _this.store_listeners = [{
	      name: "virtualNetworks",
	      events: ["success", "error"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VirtualNetworkDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(VirtualNetworkDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkDetail.prototype), "componentWillMount", this).apply(this, arguments);
	      this.updateCurrentTab();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(VirtualNetworkDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkDetail.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      this.updateCurrentTab(nextProps);
	    }
	  }, {
	    key: "updateCurrentTab",
	    value: function updateCurrentTab(nextProps) {
	      var _ref2 = nextProps || this.props,
	          routes = _ref2.routes;
	
	      var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	
	      this.setState({ currentTab: currentTab });
	    }
	  }, {
	    key: "onVirtualNetworksStoreError",
	    value: function onVirtualNetworksStoreError() {
	      var errorCount = this.state.errorCount + 1;
	      this.setState({ errorCount: errorCount });
	    }
	  }, {
	    key: "onVirtualNetworksStoreSuccess",
	    value: function onVirtualNetworksStoreSuccess() {
	      this.setState({ receivedVirtualNetworks: true, errorCount: 0 });
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      var breadcrumbs = _react2.default.createElement(NetworksDetailBreadcrumbs, { overlayID: this.props.params.overlayName });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs }),
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      var breadcrumbs = _react2.default.createElement(NetworksDetailBreadcrumbs, { overlayID: this.props.params.overlayName });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs }),
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          currentTab = _state.currentTab,
	          errorCount = _state.errorCount,
	          receivedVirtualNetworks = _state.receivedVirtualNetworks;
	
	
	      if (errorCount >= 3) {
	        return this.getErrorScreen();
	      }
	
	      if (!receivedVirtualNetworks) {
	        return this.getLoadingScreen();
	      }
	
	      var tabs = [{
	        label: "Tasks",
	        callback: function callback() {
	          _this2.setState({ currentTab: "/networking/networks/:overlayName" });
	          _this2.context.router.push("/networking/networks/" + _this2.props.params.overlayName);
	        },
	        isActive: currentTab === "/networking/networks/:overlayName"
	      }, {
	        label: "Details",
	        callback: function callback() {
	          _this2.setState({
	            currentTab: "/networking/networks/:overlayName/details"
	          });
	          _this2.context.router.push("/networking/networks/" + _this2.props.params.overlayName + "/details");
	        },
	        isActive: currentTab === "/networking/networks/:overlayName/details"
	      }];
	
	      var overlay = _VirtualNetworksStore2.default.getOverlays().findItem(function (overlay) {
	        return overlay.getName() === _this2.props.params.overlayName;
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(NetworksDetailBreadcrumbs, { overlay: overlay }),
	          tabs: tabs
	        }),
	        _react2.default.cloneElement(this.props.children, { overlay: overlay })
	      );
	    }
	  }]);
	  return VirtualNetworkDetail;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _TabsMixin2.default));
	
	VirtualNetworkDetail.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = VirtualNetworkDetail;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _EventTypes = __webpack_require__(933);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _BaseStore2 = __webpack_require__(1008);
	
	var _BaseStore3 = _interopRequireDefault(_BaseStore2);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _OverlayList = __webpack_require__(1531);
	
	var _OverlayList2 = _interopRequireDefault(_OverlayList);
	
	var _VirtualNetworksActions = __webpack_require__(1533);
	
	var _VirtualNetworksActions2 = _interopRequireDefault(_VirtualNetworksActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fetchInterval = null;
	
	var VirtualNetworksStore = function (_BaseStore) {
	  (0, _inherits3.default)(VirtualNetworksStore, _BaseStore);
	
	  function VirtualNetworksStore() {
	    (0, _classCallCheck3.default)(this, VirtualNetworksStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VirtualNetworksStore.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworksStore)).apply(this, arguments));
	
	    _this.data = { overlays: [] };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.VIRTUAL_NETWORKS_CHANGE,
	        error: _EventTypes.VIRTUAL_NETWORKS_REQUEST_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    // Handle app actions
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (_ref) {
	      var source = _ref.source,
	          action = _ref.action;
	
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	      switch (action.type) {
	        case _ActionTypes.REQUEST_VIRTUAL_NETWORKS_SUCCESS:
	          _this.processVirtualNetworks(action.data);
	          break;
	        case _ActionTypes.REQUEST_VIRTUAL_NETWORKS_ERROR:
	          _this.processVirtualNetworksError(action.data);
	          break;
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VirtualNetworksStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      (0, _get3.default)(VirtualNetworksStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworksStore.prototype), "addChangeListener", this).call(this, eventName, callback);
	
	      // Start polling if there is at least one listener
	      if (this.shouldPoll()) {
	        this.startPolling();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      (0, _get3.default)(VirtualNetworksStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworksStore.prototype), "removeChangeListener", this).call(this, eventName, callback);
	
	      // Stop polling if no one is listening
	      if (!this.shouldPoll()) {
	        this.stopPolling();
	      }
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return this.listeners(_EventTypes.VIRTUAL_NETWORKS_CHANGE).length > 0;
	    }
	  }, {
	    key: "startPolling",
	    value: function startPolling() {
	      if (fetchInterval) {
	        return;
	      }
	
	      _VirtualNetworksActions2.default.fetch();
	
	      fetchInterval = global.setInterval(_VirtualNetworksActions2.default.fetch, _Config2.default.getRefreshRate());
	    }
	  }, {
	    key: "stopPolling",
	    value: function stopPolling() {
	      if (fetchInterval) {
	        global.clearInterval(fetchInterval);
	        fetchInterval = null;
	      }
	    }
	  }, {
	    key: "getOverlays",
	    value: function getOverlays() {
	      return new _OverlayList2.default({ items: this.data.overlays });
	    }
	  }, {
	    key: "fetch",
	    value: function fetch() {
	      return _VirtualNetworksActions2.default.fetch.apply(_VirtualNetworksActions2.default, arguments);
	    }
	  }, {
	    key: "processVirtualNetworks",
	    value: function processVirtualNetworks() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          overlays = _ref2.overlays,
	          vtep_mac_oui = _ref2.vtep_mac_oui,
	          vtep_subnet = _ref2.vtep_subnet;
	
	      this.data.overlays = overlays || [];
	      this.data.vtep_mac_oui = vtep_mac_oui;
	      this.data.vtep_subnet = vtep_subnet;
	      this.emit(_EventTypes.VIRTUAL_NETWORKS_CHANGE);
	    }
	  }, {
	    key: "processVirtualNetworksError",
	    value: function processVirtualNetworksError(error) {
	      this.emit(_EventTypes.VIRTUAL_NETWORKS_REQUEST_ERROR, error);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "virtualNetworks";
	    }
	  }]);
	  return VirtualNetworksStore;
	}(_BaseStore3.default);
	
	module.exports = new VirtualNetworksStore();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Overlay = __webpack_require__(1532);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverlayList = function (_List) {
	  (0, _inherits3.default)(OverlayList, _List);
	
	  function OverlayList() {
	    (0, _classCallCheck3.default)(this, OverlayList);
	    return (0, _possibleConstructorReturn3.default)(this, (OverlayList.__proto__ || (0, _getPrototypeOf2.default)(OverlayList)).apply(this, arguments));
	  }
	
	  return OverlayList;
	}(_List3.default);
	
	OverlayList.type = _Overlay2.default;
	
	module.exports = OverlayList;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (_Item) {
	  (0, _inherits3.default)(Overlay, _Item);
	
	  function Overlay() {
	    var _ref;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, Overlay);
	
	    // Make sure info is available in Overlay
	    if (!options.info) {
	      options.info = {};
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn3.default)(this, (_ref = Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).call.apply(_ref, [this, options].concat(args)));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: "getName",
	    value: function getName() {
	      return this.get("info").name;
	    }
	  }, {
	    key: "getPrefix",
	    value: function getPrefix() {
	      return this.get("info").prefix;
	    }
	  }, {
	    key: "getSubnet",
	    value: function getSubnet() {
	      return this.get("info").subnet;
	    }
	  }]);
	  return Overlay;
	}(_Item3.default);

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VirtualNetworksActions = {
	  fetch: function fetch() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.virtualNetworksApi + "/state",
	      success: function success(response) {
	        var _response$network = response.network,
	            overlays = _response$network.overlays,
	            vtep_mac_oui = _response$network.vtep_mac_oui,
	            vtep_subnet = _response$network.vtep_subnet;
	        // Map structure to mimic agents overlays
	
	        overlays = overlays.map(function (overlay) {
	          return { info: overlay };
	        });
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_VIRTUAL_NETWORKS_SUCCESS,
	          data: { overlays: overlays, vtep_mac_oui: vtep_mac_oui, vtep_subnet: vtep_subnet }
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_VIRTUAL_NETWORKS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var virtualNetworksFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/networking/virtual-networks.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.VirtualNetworksActions = {
	    fetch: { event: "success", success: { response: virtualNetworksFixture } }
	  };
	
	  (0, _keys2.default)(global.actionTypes.VirtualNetworksActions).forEach(function (method) {
	    VirtualNetworksActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(VirtualNetworksActions, "VirtualNetworksActions", method);
	  });
	}
	
	module.exports = VirtualNetworksActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _Overlay = __webpack_require__(1532);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VirtualNetworkDetailsTab = function (_React$Component) {
	  (0, _inherits3.default)(VirtualNetworkDetailsTab, _React$Component);
	
	  function VirtualNetworkDetailsTab() {
	    (0, _classCallCheck3.default)(this, VirtualNetworkDetailsTab);
	    return (0, _possibleConstructorReturn3.default)(this, (VirtualNetworkDetailsTab.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkDetailsTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VirtualNetworkDetailsTab, [{
	    key: "render",
	    value: function render() {
	      var overlay = this.props.overlay;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Name"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                overlay.getName()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "IP Subnet"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                overlay.getSubnet()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return VirtualNetworkDetailsTab;
	}(_react2.default.Component);
	
	VirtualNetworkDetailsTab.propTypes = {
	  overlay: _react2.default.PropTypes.instanceOf(_Overlay2.default)
	};
	
	module.exports = VirtualNetworkDetailsTab;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _VirtualNetworksStore = __webpack_require__(1530);
	
	var _VirtualNetworksStore2 = _interopRequireDefault(_VirtualNetworksStore);
	
	var _VirtualNetworksTable = __webpack_require__(1536);
	
	var _VirtualNetworksTable2 = _interopRequireDefault(_VirtualNetworksTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var NetworksBreadcrumbs = function NetworksBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Networks" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/networking/networks" },
	        "Networks"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "network", breadcrumbs: crumbs });
	};
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleSearchStringChange", "onVirtualNetworksStoreError", "onVirtualNetworksStoreSuccess", "resetFilter"];
	
	var VirtualNetworksTabContent = function (_mixin) {
	  (0, _inherits3.default)(VirtualNetworksTabContent, _mixin);
	
	  function VirtualNetworksTabContent() {
	    (0, _classCallCheck3.default)(this, VirtualNetworksTabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VirtualNetworksTabContent.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworksTabContent)).apply(this, arguments));
	
	    _this.state = {
	      receivedVirtualNetworks: false,
	      searchString: "",
	      errorCount: 0
	    };
	
	    _this.store_listeners = [{
	      name: "virtualNetworks",
	      events: ["success", "error"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VirtualNetworksTabContent, [{
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "onVirtualNetworksStoreError",
	    value: function onVirtualNetworksStoreError() {
	      var errorCount = this.state.errorCount + 1;
	      this.setState({ errorCount: errorCount });
	    }
	  }, {
	    key: "onVirtualNetworksStoreSuccess",
	    value: function onVirtualNetworksStoreSuccess() {
	      this.setState({ receivedVirtualNetworks: true, errorCount: 0 });
	    }
	  }, {
	    key: "isLoading",
	    value: function isLoading() {
	      return !this.state.receivedVirtualNetworks;
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      this.setState({ searchString: "" });
	    }
	  }, {
	    key: "getEmptyScreen",
	    value: function getEmptyScreen() {
	      return _react2.default.createElement(
	        _AlertPanel2.default,
	        null,
	        _react2.default.createElement(
	          _AlertPanelHeader2.default,
	          null,
	          "No virtual networks detected"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush" },
	          "There a currently no other virtual networks found on your datacenter. Virtual networks are configured during setup of your DC/OS cluster."
	        )
	      );
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	  }, {
	    key: "getFilteredOverlayList",
	    value: function getFilteredOverlayList(overlayList) {
	      var searchString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	      if (searchString === "") {
	        return overlayList;
	      }
	
	      return overlayList.filterItems(function (overlay) {
	        return overlay.getName() && overlay.getName().includes(searchString) || overlay.getSubnet() && overlay.getSubnet().includes(searchString);
	      });
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _state = this.state,
	          errorCount = _state.errorCount,
	          searchString = _state.searchString;
	
	      if (errorCount >= 3) {
	        return this.getErrorScreen();
	      }
	
	      if (this.isLoading()) {
	        return this.getLoadingScreen();
	      }
	
	      var overlayList = _VirtualNetworksStore2.default.getOverlays();
	      var filteredOverlayList = this.getFilteredOverlayList(overlayList, searchString);
	      if (filteredOverlayList.length === 0) {
	        return this.getEmptyScreen();
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_FilterHeadline2.default, {
	          onReset: this.resetFilter,
	          name: "Network",
	          currentLength: filteredOverlayList.getItems().length,
	          totalLength: overlayList.getItems().length
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          null,
	          _react2.default.createElement(_FilterInputText2.default, {
	            searchString: searchString,
	            handleFilterChange: this.handleSearchStringChange
	          })
	        ),
	        _react2.default.createElement(_VirtualNetworksTable2.default, { overlays: filteredOverlayList })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(NetworksBreadcrumbs, null) }),
	        this.getContent(),
	        this.props.children
	      );
	    }
	  }]);
	  return VirtualNetworksTabContent;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	VirtualNetworksTabContent.routeConfig = {
	  label: "Networks",
	  matches: /^\/networking\/networks/
	};
	
	module.exports = VirtualNetworksTabContent;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _OverlayList = __webpack_require__(1531);
	
	var _OverlayList2 = _interopRequireDefault(_OverlayList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headerMapping = {
	  name: "Name",
	  subnet: "IP Subnet",
	  prefix: "Agent Prefix Length"
	};
	
	var VirtualNetworksTable = function (_React$Component) {
	  (0, _inherits3.default)(VirtualNetworksTable, _React$Component);
	
	  function VirtualNetworksTable() {
	    (0, _classCallCheck3.default)(this, VirtualNetworksTable);
	    return (0, _possibleConstructorReturn3.default)(this, (VirtualNetworksTable.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworksTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VirtualNetworksTable, [{
	    key: "getClassName",
	    value: function getClassName(prop, sortBy) {
	      return (0, _classnames2.default)({
	        active: prop === sortBy.prop
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = this.getClassName;
	      var heading = this.renderHeading;
	
	      return [{
	        className: getClassName,
	        getValue: function getValue(overlay) {
	          return overlay.getName();
	        },
	
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "name",
	        render: this.renderName,
	        sortable: false
	      }, {
	        className: getClassName,
	        getValue: function getValue(overlay) {
	          return overlay.getSubnet();
	        },
	
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "subnet",
	        sortable: false
	      }, {
	        className: getClassName,
	        getValue: function getValue(overlay) {
	          return overlay.getPrefix();
	        },
	
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "prefix",
	        sortable: false
	      }];
	    }
	  }, {
	    key: "renderHeading",
	    value: function renderHeading(prop) {
	      return _react2.default.createElement(
	        "span",
	        { className: "table-header-title" },
	        headerMapping[prop]
	      );
	    }
	  }, {
	    key: "renderName",
	    value: function renderName(prop, overlay) {
	      var overlayName = overlay.getName();
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: "table-cell-link-primary",
	          title: overlayName,
	          to: "/networking/networks/" + overlayName
	        },
	        overlayName
	      );
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "30%" } }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", null)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        data: this.props.overlays.getItems()
	      });
	    }
	  }]);
	  return VirtualNetworksTable;
	}(_react2.default.Component);
	
	VirtualNetworksTable.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	VirtualNetworksTable.propTypes = {
	  overlays: _react2.default.PropTypes.instanceOf(_OverlayList2.default)
	};
	
	module.exports = VirtualNetworksTable;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _TaskDetail = __webpack_require__(1490);
	
	var _TaskDetail2 = _interopRequireDefault(_TaskDetail);
	
	var _VirtualNetworksStore = __webpack_require__(1530);
	
	var _VirtualNetworksStore2 = _interopRequireDefault(_VirtualNetworksStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dontScrollRoutes = [/\/files\/view.*$/, /\/logs.*$/];
	
	var NetworksDetailTaskBreadcrumbs = function NetworksDetailTaskBreadcrumbs(_ref) {
	  var overlayID = _ref.overlayID,
	      overlay = _ref.overlay,
	      taskID = _ref.taskID,
	      task = _ref.task;
	
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Networks" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/networking/networks" },
	        "Networks"
	      )
	    )
	  )];
	
	  var overlayName = overlayID;
	  if (overlay) {
	    overlayName = overlay.getName();
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 1, title: overlayName },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/networking/networks/" + overlayName },
	          overlayName
	        )
	      )
	    ));
	  } else {
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 1, title: overlayID },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        overlayID
	      )
	    ));
	  }
	
	  if (task) {
	    var taskName = task.getName();
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 2, title: taskName },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/networking/networks/" + overlayName + "/tasks/" + taskName },
	          taskName
	        )
	      )
	    ));
	  } else {
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: 2, title: taskID },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        taskID
	      )
	    ));
	  }
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "network", breadcrumbs: crumbs });
	};
	
	var VirtualNetworkTaskPage = function (_React$Component) {
	  (0, _inherits3.default)(VirtualNetworkTaskPage, _React$Component);
	
	  function VirtualNetworkTaskPage() {
	    (0, _classCallCheck3.default)(this, VirtualNetworkTaskPage);
	    return (0, _possibleConstructorReturn3.default)(this, (VirtualNetworkTaskPage.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkTaskPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VirtualNetworkTaskPage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          routes = _props.routes;
	      var overlayName = params.overlayName,
	          taskID = params.taskID;
	
	
	      var routePrefix = "/networking/networks/" + overlayName + "/tasks/" + taskID;
	      var tabs = [{ label: "Details", routePath: routePrefix + "/details" }, { label: "Files", routePath: routePrefix + "/files" }, { label: "Logs", routePath: routePrefix + "/logs" }];
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(taskID);
	
	      var overlay = _VirtualNetworksStore2.default.getOverlays().findItem(function (overlay) {
	        return overlay.getName() === overlayName;
	      });
	
	      var breadcrumbs = void 0;
	      if (task != null) {
	        breadcrumbs = _react2.default.createElement(NetworksDetailTaskBreadcrumbs, {
	          overlayID: overlayName,
	          overlay: overlay,
	          taskID: taskID,
	          taskName: task.getName()
	        });
	      } else {
	        breadcrumbs = _react2.default.createElement(NetworksDetailTaskBreadcrumbs, null);
	      }
	
	      var dontScroll = dontScrollRoutes.some(function (regex) {
	        return regex.test(location.pathname);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { dontScroll: dontScroll },
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs, tabs: tabs, iconID: "Networks" }),
	        _react2.default.createElement(
	          _TaskDetail2.default,
	          { params: params, routes: routes },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return VirtualNetworkTaskPage;
	}(_react2.default.Component);
	
	VirtualNetworkTaskPage.propTypes = {
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array
	};
	
	module.exports = VirtualNetworkTaskPage;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Overlay = __webpack_require__(1532);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _TaskUtil = __webpack_require__(1503);
	
	var _TaskUtil2 = _interopRequireDefault(_TaskUtil);
	
	var _VirtualNetworkUtil = __webpack_require__(1539);
	
	var _VirtualNetworkUtil2 = _interopRequireDefault(_VirtualNetworkUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var headerMapping = {
	  id: "TASK",
	  ip_address: "CONTAINER IP",
	  port_mappings: "PORT MAPPINGS"
	};
	/* eslint-enable no-unused-vars */
	
	var METHODS_TO_BIND = ["handleSearchStringChange", "renderAgentIP", "renderID", "renderPorts", "resetFilter"];
	
	var agentIPPath = "statuses.0.container_status.network_infos.0.ip_addresses";
	
	var VirtualNetworkTaskTab = function (_mixin) {
	  (0, _inherits3.default)(VirtualNetworkTaskTab, _mixin);
	
	  function VirtualNetworkTaskTab() {
	    (0, _classCallCheck3.default)(this, VirtualNetworkTaskTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VirtualNetworkTaskTab.__proto__ || (0, _getPrototypeOf2.default)(VirtualNetworkTaskTab)).apply(this, arguments));
	
	    _this.state = {
	      errorMessage: null,
	      searchString: "",
	      tasksDataReceived: false
	    };
	
	    _this.store_listeners = [{
	      name: "state",
	      events: ["success", "error"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VirtualNetworkTaskTab, [{
	    key: "onStateStoreError",
	    value: function onStateStoreError(errorMessage) {
	      this.setState({ tasksDataReceived: true, errorMessage: errorMessage });
	    }
	  }, {
	    key: "onStateStoreSuccess",
	    value: function onStateStoreSuccess() {
	      this.setState({ tasksDataReceived: true, errorMessage: null });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      this.setState({ searchString: "" });
	    }
	  }, {
	    key: "isLoading",
	    value: function isLoading() {
	      return !this.state.tasksDataReceived;
	    }
	  }, {
	    key: "getFilteredTasks",
	    value: function getFilteredTasks(tasks) {
	      var searchString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	      if (searchString === "") {
	        return tasks;
	      }
	
	      return tasks.filter(function (task) {
	        return task.name.includes(searchString) || task.id.includes(searchString);
	      });
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(prop, sortBy) {
	      return (0, _classnames2.default)({
	        active: prop === sortBy.prop
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = this.getClassName;
	      var heading = this.renderHeading;
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "id",
	        render: this.renderID,
	        sortable: false
	      }, {
	        className: getClassName,
	        getValue: this.getAgentIP,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "ip_address",
	        render: this.renderAgentIP,
	        sortable: false
	      }, {
	        className: getClassName,
	        getValue: _TaskUtil2.default.getPortMappings,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "port_mappings",
	        render: this.renderPorts,
	        sortable: false
	      }];
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "50%" } }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", null)
	      );
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getTaskLink",
	    value: function getTaskLink(taskID, value, title) {
	      var hierarchy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	      if (!value) {
	        value = taskID;
	      }
	
	      if (!title) {
	        title = taskID;
	      }
	
	      var classes = (0, _classnames2.default)({
	        "table-cell-link-primary": hierarchy.primary,
	        "table-cell-link-secondary": hierarchy.secondary
	      });
	
	      var overlayName = this.props.overlay.getName();
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: classes,
	          key: value,
	          title: title,
	          to: "/networking/networks/" + overlayName + "/tasks/" + taskID
	        },
	        value
	      );
	    }
	  }, {
	    key: "getTitle",
	    value: function getTitle(portMappings) {
	      return portMappings.map(function (mapping) {
	        return mapping.container_port + " > " + mapping.host_port + " (" + mapping.protocol + ")";
	      }).join(", ");
	    }
	  }, {
	    key: "getAgentIP",
	    value: function getAgentIP(task) {
	      var ipAddresses = _Util2.default.findNestedPropertyInObject(task, agentIPPath);
	
	      if (!ipAddresses || !Array.isArray(ipAddresses)) {
	        return ipAddresses;
	      }
	
	      return ipAddresses.map(function (ipAddress) {
	        return ipAddress.ip_address;
	      }).join(", ");
	    }
	  }, {
	    key: "renderAgentIP",
	    value: function renderAgentIP(prop, task) {
	      var ipAddress = this.getAgentIP(task);
	
	      if (!ipAddress) {
	        return "N/A";
	      }
	
	      return ipAddress;
	    }
	  }, {
	    key: "renderHeading",
	    value: function renderHeading(prop) {
	      return _react2.default.createElement(
	        "span",
	        { className: "table-header-title" },
	        headerMapping[prop]
	      );
	    }
	  }, {
	    key: "renderID",
	    value: function renderID(prop, task) {
	      return this.getTaskLink(task.id, null, null, { primary: true });
	    }
	  }, {
	    key: "renderPorts",
	    value: function renderPorts(prop, task) {
	      var _this2 = this;
	
	      var portMappings = _TaskUtil2.default.getPortMappings(task);
	      if (!portMappings) {
	        return "N/A";
	      }
	
	      var title = this.getTitle(portMappings);
	      if (portMappings.length > 3) {
	        portMappings = portMappings.slice(0, 2);
	        portMappings.push({ container_port: "..." });
	      }
	
	      var id = task.id;
	
	
	      return portMappings.map(function (mapping, index) {
	        var mapTo = null;
	
	        if (mapping.host_port) {
	          mapTo = _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(_Icon2.default, {
	              className: "list-inline-separator",
	              family: "tiny",
	              id: "caret-right",
	              size: "tiny"
	            }),
	            _this2.getTaskLink(id, mapping.host_port + " (" + mapping.protocol + ")", title, { secondary: true })
	          );
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { key: index, className: "table-cell-value" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-cell-details-secondary flex-box flex-box-align-vertical-center table-cell-flex-box" },
	            _react2.default.createElement(
	              "div",
	              { className: "text-overflow service-link" },
	              _this2.getTaskLink(id, mapping.container_port, title, {
	                secondary: true
	              }),
	              mapTo
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          errorMessage = _state.errorMessage,
	          searchString = _state.searchString;
	
	      if (this.isLoading()) {
	        return this.getLoadingScreen();
	      }
	
	      if (errorMessage) {
	        return this.getErrorScreen();
	      }
	
	      var overlay = this.props.overlay;
	
	      if (!overlay) {
	        return _VirtualNetworkUtil2.default.getEmptyNetworkScreen();
	      }
	
	      var tasks = _MesosStateStore2.default.getTasksFromVirtualNetworkName(overlay.getName());
	      var filteredTasks = this.getFilteredTasks(tasks, searchString);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_FilterHeadline2.default, {
	          onReset: this.resetFilter,
	          name: "Task",
	          currentLength: filteredTasks.length,
	          totalLength: tasks.length
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          null,
	          _react2.default.createElement(_FilterInputText2.default, {
	            searchString: searchString,
	            handleFilterChange: this.handleSearchStringChange
	          })
	        ),
	        _react2.default.createElement(_reactjsComponents.Table, {
	          className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          data: filteredTasks
	        })
	      );
	    }
	  }]);
	  return VirtualNetworkTaskTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	VirtualNetworkTaskTab.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	VirtualNetworkTaskTab.propTypes = {
	  overlay: _react2.default.PropTypes.instanceOf(_Overlay2.default)
	};
	
	module.exports = VirtualNetworkTaskTab;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var VirtualNetworkUtil = {
	  getEmptyNetworkScreen: function getEmptyNetworkScreen() {
	    return _react2.default.createElement(
	      _AlertPanel2.default,
	      null,
	      _react2.default.createElement(
	        _AlertPanelHeader2.default,
	        null,
	        "Virtual network not found"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "flush" },
	        "Could not find the requested virtual network. Go to",
	        " ",
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/networking/networks" },
	          "Networks"
	        ),
	        " ",
	        "overview to see all virtual networks."
	      )
	    );
	  }
	};
	/* eslint-disable no-unused-vars */
	
	
	module.exports = VirtualNetworkUtil;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NodeDetailHealthTab = __webpack_require__(1541);
	
	var _NodeDetailHealthTab2 = _interopRequireDefault(_NodeDetailHealthTab);
	
	var _NodeDetailPage = __webpack_require__(1545);
	
	var _NodeDetailPage2 = _interopRequireDefault(_NodeDetailPage);
	
	var _NodeDetailTab = __webpack_require__(1550);
	
	var _NodeDetailTab2 = _interopRequireDefault(_NodeDetailTab);
	
	var _NodeDetailTaskTab = __webpack_require__(1551);
	
	var _NodeDetailTaskTab2 = _interopRequireDefault(_NodeDetailTaskTab);
	
	var _NodesGridContainer = __webpack_require__(1568);
	
	var _NodesGridContainer2 = _interopRequireDefault(_NodesGridContainer);
	
	var _NodesOverview = __webpack_require__(1572);
	
	var _NodesOverview2 = _interopRequireDefault(_NodesOverview);
	
	var _NodesPage = __webpack_require__(1576);
	
	var _NodesPage2 = _interopRequireDefault(_NodesPage);
	
	var _NodesTableContainer = __webpack_require__(1577);
	
	var _NodesTableContainer2 = _interopRequireDefault(_NodesTableContainer);
	
	var _NodesTaskDetailPage = __webpack_require__(1581);
	
	var _NodesTaskDetailPage2 = _interopRequireDefault(_NodesTaskDetailPage);
	
	var _TaskDetailsTab = __webpack_require__(1499);
	
	var _TaskDetailsTab2 = _interopRequireDefault(_TaskDetailsTab);
	
	var _TaskFileBrowser = __webpack_require__(1504);
	
	var _TaskFileBrowser2 = _interopRequireDefault(_TaskFileBrowser);
	
	var _TaskFilesTab = __webpack_require__(1507);
	
	var _TaskFilesTab2 = _interopRequireDefault(_TaskFilesTab);
	
	var _TaskFileViewer = __webpack_require__(1508);
	
	var _TaskFileViewer2 = _interopRequireDefault(_TaskFileViewer);
	
	var _TaskLogsContainer = __webpack_require__(1518);
	
	var _TaskLogsContainer2 = _interopRequireDefault(_TaskLogsContainer);
	
	var _TaskVolumeContainer = __webpack_require__(1582);
	
	var _TaskVolumeContainer2 = _interopRequireDefault(_TaskVolumeContainer);
	
	var _NodesUnitsHealthDetailPage = __webpack_require__(1590);
	
	var _NodesUnitsHealthDetailPage2 = _interopRequireDefault(_NodesUnitsHealthDetailPage);
	
	var _VolumeTable = __webpack_require__(1592);
	
	var _VolumeTable2 = _interopRequireDefault(_VolumeTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var nodesRoutes = {
	  type: _reactRouter.Route,
	  path: "nodes",
	  component: _NodesPage2.default,
	  category: "resources",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.Route,
	    component: _NodesOverview2.default,
	    children: [{
	      type: _reactRouter.IndexRoute,
	      component: _NodesTableContainer2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "grid",
	      component: _NodesGridContainer2.default
	    }]
	  }, {
	    type: _reactRouter.Redirect,
	    from: "/nodes/:nodeID",
	    to: "/nodes/:nodeID/tasks"
	  }, {
	    type: _reactRouter.Route,
	    path: ":nodeID",
	    component: _NodeDetailPage2.default,
	    children: [{
	      type: _reactRouter.Route,
	      title: "Tasks",
	      path: "tasks",
	      component: _NodeDetailTaskTab2.default
	    }, {
	      type: _reactRouter.Redirect,
	      path: "/nodes/:nodeID/tasks/:taskID",
	      to: "/nodes/:nodeID/tasks/:taskID/details"
	    }, {
	      type: _reactRouter.Route,
	      path: "health",
	      title: "Health",
	      component: _NodeDetailHealthTab2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "details",
	      title: "Details",
	      component: _NodeDetailTab2.default
	    }]
	  }, {
	    type: _reactRouter.Route,
	    path: ":nodeID/tasks/:taskID",
	    component: _NodesTaskDetailPage2.default,
	    hideHeaderNavigation: true,
	    children: [{
	      type: _reactRouter.Route,
	      component: _TaskDetailsTab2.default,
	      hideHeaderNavigation: true,
	      title: "Details",
	      path: "details",
	      isTab: true
	    }, {
	      hideHeaderNavigation: true,
	      component: _TaskFilesTab2.default,
	      isTab: true,
	      path: "files",
	      title: "Files",
	      type: _reactRouter.Route,
	      children: [{
	        component: _TaskFileBrowser2.default,
	        fileViewerRoutePath: "/nodes/:nodeID/tasks/:taskID/files/view(/:filePath(/:innerPath))",
	        hideHeaderNavigation: true,
	        type: _reactRouter.IndexRoute
	      }, {
	        component: _TaskFileViewer2.default,
	        hideHeaderNavigation: true,
	        path: "view(/:filePath(/:innerPath))",
	        type: _reactRouter.Route
	      }]
	    }, {
	      component: _TaskLogsContainer2.default,
	      hideHeaderNavigation: true,
	      isTab: true,
	      path: "logs",
	      title: "Logs",
	      type: _reactRouter.Route,
	      children: [{
	        path: ":filePath",
	        type: _reactRouter.Route
	      }]
	    }, {
	      component: _VolumeTable2.default,
	      hideHeaderNavigation: true,
	      isTab: true,
	      path: "volumes",
	      title: "Volumes",
	      type: _reactRouter.Route
	    }]
	  },
	  // This route needs to be rendered outside of the tabs that are rendered
	  // in the nodes-task-details route.
	  {
	    type: _reactRouter.Route,
	    path: ":nodeID/tasks/:taskID/volumes/:volumeID",
	    component: _TaskVolumeContainer2.default
	  },
	  // This needs to be outside of the children array of node routes
	  // so that it can be responsible for rendering its own header.
	  {
	    type: _reactRouter.Route,
	    path: ":nodeID/health/:unitNodeID/:unitID",
	    component: _NodesUnitsHealthDetailPage2.default
	  }]
	};
	/* eslint-enable no-unused-vars */
	
	module.exports = nodesRoutes;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _NodeHealthStore = __webpack_require__(1542);
	
	var _NodeHealthStore2 = _interopRequireDefault(_NodeHealthStore);
	
	var _HealthTab = __webpack_require__(1544);
	
	var _HealthTab2 = _interopRequireDefault(_HealthTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeDetailHealthTab = function (_React$Component) {
	  (0, _inherits3.default)(NodeDetailHealthTab, _React$Component);
	
	  function NodeDetailHealthTab() {
	    (0, _classCallCheck3.default)(this, NodeDetailHealthTab);
	    return (0, _possibleConstructorReturn3.default)(this, (NodeDetailHealthTab.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailHealthTab)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NodeDetailHealthTab, [{
	    key: "render",
	    value: function render() {
	      var node = this.props.node;
	
	      var units = _NodeHealthStore2.default.getUnits(node.hostname);
	
	      return _react2.default.createElement(_HealthTab2.default, { node: node, units: units, params: this.props.params });
	    }
	  }]);
	  return NodeDetailHealthTab;
	}(_react2.default.Component);
	
	NodeDetailHealthTab.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	NodeDetailHealthTab.propTypes = {
	  node: _react2.default.PropTypes.instanceOf(_Node2.default).isRequired
	};
	
	module.exports = NodeDetailHealthTab;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _EventTypes = __webpack_require__(933);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _HealthUnit = __webpack_require__(1370);
	
	var _HealthUnit2 = _interopRequireDefault(_HealthUnit);
	
	var _HealthUnitsList = __webpack_require__(1371);
	
	var _HealthUnitsList2 = _interopRequireDefault(_HealthUnitsList);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _NodeHealthActions = __webpack_require__(1543);
	
	var _NodeHealthActions2 = _interopRequireDefault(_NodeHealthActions);
	
	var _NodesList = __webpack_require__(1049);
	
	var _NodesList2 = _interopRequireDefault(_NodesList);
	
	var _VisibilityStore = __webpack_require__(1222);
	
	var _VisibilityStore2 = _interopRequireDefault(_VisibilityStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestInterval = null;
	
	function startPolling() {
	  if (requestInterval == null) {
	    _NodeHealthActions2.default.fetchNodes();
	    requestInterval = setInterval(_NodeHealthActions2.default.fetchNodes, _Config2.default.getRefreshRate());
	  }
	}
	
	function stopPolling() {
	  if (requestInterval != null) {
	    clearInterval(requestInterval);
	    requestInterval = null;
	  }
	}
	
	var NodeHealthStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(NodeHealthStore, _GetSetBaseStore);
	
	  function NodeHealthStore() {
	    (0, _classCallCheck3.default)(this, NodeHealthStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodeHealthStore.__proto__ || (0, _getPrototypeOf2.default)(NodeHealthStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      nodes: [],
	      nodesByID: {},
	      unitsByNodeID: {},
	      unitsByID: {}
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        success: _EventTypes.HEALTH_NODES_CHANGE,
	        error: _EventTypes.HEALTH_NODES_ERROR,
	        nodeSuccess: _EventTypes.HEALTH_NODE_SUCCESS,
	        nodeError: _EventTypes.HEALTH_NODE_ERROR,
	        unitsSuccess: _EventTypes.HEALTH_NODE_UNITS_SUCCESS,
	        unitsError: _EventTypes.HEALTH_NODE_UNITS_ERROR,
	        unitSuccess: _EventTypes.HEALTH_NODE_UNIT_SUCCESS,
	        unitError: _EventTypes.HEALTH_NODE_UNIT_ERROR
	      },
	      unmountWhen: function unmountWhen() {
	        return true;
	      },
	
	      listenAlways: true
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      if (payload.source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      var data = action.data;
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_HEALTH_NODES_SUCCESS:
	          _this.processNodes(data);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODES_ERROR:
	          _this.emit(_EventTypes.HEALTH_NODES_ERROR, data);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_SUCCESS:
	          _this.processNode(data, action.nodeID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_ERROR:
	          _this.emit(_EventTypes.HEALTH_NODE_ERROR, data, action.nodeID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_UNITS_SUCCESS:
	          _this.processUnits(data, action.nodeID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_UNITS_ERROR:
	          _this.emit(_EventTypes.HEALTH_NODE_UNITS_ERROR, data, action.nodeID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_UNIT_SUCCESS:
	          _this.processNode(data, action.nodeID, action.unitID);
	          break;
	        case _ActionTypes.REQUEST_HEALTH_NODE_UNIT_ERROR:
	          _this.emit(_EventTypes.HEALTH_NODE_UNIT_ERROR, data, action.nodeID, action.unitID);
	          break;
	      }
	
	      return true;
	    });
	
	    _VisibilityStore2.default.addChangeListener(_EventTypes.VISIBILITY_CHANGE, _this.onVisibilityStoreChange.bind(_this));
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodeHealthStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	      if (this.shouldPoll()) {
	        startPolling();
	      }
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	
	      if (!this.shouldPoll()) {
	        stopPolling();
	      }
	    }
	  }, {
	    key: "onVisibilityStoreChange",
	    value: function onVisibilityStoreChange() {
	      if (!_VisibilityStore2.default.isInactive() && this.shouldPoll()) {
	        startPolling();
	
	        return;
	      }
	
	      stopPolling();
	    }
	  }, {
	    key: "shouldPoll",
	    value: function shouldPoll() {
	      return !(this.listeners(_EventTypes.HEALTH_NODES_CHANGE).length === 0);
	    }
	  }, {
	    key: "getNodes",
	    value: function getNodes() {
	      return new _NodesList2.default({
	        items: this.get("nodes")
	      });
	    }
	  }, {
	    key: "getNode",
	    value: function getNode(id) {
	      return new _Node2.default(this.get("nodesByID")[id] || {});
	    }
	  }, {
	    key: "getUnits",
	    value: function getUnits(nodeID) {
	      var units = this.get("unitsByNodeID")[nodeID] || [];
	
	      return new _HealthUnitsList2.default({ items: units });
	    }
	  }, {
	    key: "getUnit",
	    value: function getUnit(unitID) {
	      return new _HealthUnit2.default(this.get("unitsByID")[unitID] || []);
	    }
	  }, {
	    key: "fetchNodes",
	    value: function fetchNodes() {
	      return _NodeHealthActions2.default.fetchNodes.apply(_NodeHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchNode",
	    value: function fetchNode() {
	      return _NodeHealthActions2.default.fetchNode.apply(_NodeHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchNodeUnits",
	    value: function fetchNodeUnits() {
	      return _NodeHealthActions2.default.fetchNodeUnits.apply(_NodeHealthActions2.default, arguments);
	    }
	  }, {
	    key: "fetchNodeUnit",
	    value: function fetchNodeUnit() {
	      return _NodeHealthActions2.default.fetchNodeUnit.apply(_NodeHealthActions2.default, arguments);
	    }
	  }, {
	    key: "processNodes",
	    value: function processNodes(nodes) {
	      this.set({ nodes: nodes });
	
	      _CompositeState2.default.addNodeHealth(nodes);
	
	      this.emit(_EventTypes.HEALTH_NODES_CHANGE);
	    }
	  }, {
	    key: "processNode",
	    value: function processNode(nodeData, nodeID) {
	      var nodesByID = this.get("nodesByID");
	      nodesByID[nodeID] = nodeData;
	
	      this.set({ nodesByID: nodesByID });
	
	      this.emit(_EventTypes.HEALTH_NODE_SUCCESS, nodeID);
	    }
	  }, {
	    key: "processUnits",
	    value: function processUnits(units, nodeID) {
	      var unitsByNodeID = this.get("unitsByNodeID");
	      unitsByNodeID[nodeID] = units;
	
	      this.set({ unitsByNodeID: unitsByNodeID });
	
	      this.emit(_EventTypes.HEALTH_NODE_UNITS_SUCCESS, nodeID);
	    }
	  }, {
	    key: "processUnit",
	    value: function processUnit(unitData, nodeID, unitID) {
	      var unitsByID = this.get("unitsByID");
	      unitsByID[unitID] = unitData;
	
	      this.set({ unitsByID: unitsByID });
	
	      this.emit(_EventTypes.HEALTH_NODE_UNIT_SUCCESS, nodeID, unitID);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "nodeHealth";
	    }
	  }]);
	  return NodeHealthStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new NodeHealthStore();

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeHealthActions = {
	  fetchNodes: function fetchNodes() {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/nodes",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODES_SUCCESS,
	          data: response.nodes
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODES_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchNode: function fetchNode(nodeID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/nodes/" + nodeID,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_SUCCESS,
	          data: response,
	          nodeID: nodeID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          nodeID: nodeID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchNodeUnits: function fetchNodeUnits(nodeID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/nodes/" + nodeID + "/units",
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_UNITS_SUCCESS,
	          data: response.units,
	          nodeID: nodeID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_UNITS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          nodeID: nodeID,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchNodeUnit: function fetchNodeUnit(nodeID, unitID) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      url: "" + _Config2.default.rootUrl + _Config2.default.unitHealthAPIPrefix + "/nodes/" + nodeID + "/units/" + unitID,
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_UNIT_SUCCESS,
	          data: response,
	          nodeID: nodeID,
	          unitID: unitID
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_HEALTH_NODE_UNIT_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          nodeID: nodeID,
	          unitID: unitID,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var nodesFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/nodes.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var nodeFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/node.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var nodeUnitsFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/node-units.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var nodeUnitFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/unit-health/node-unit.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.NodeHealthActions = {
	    fetchNodes: {
	      event: "success",
	      success: { response: nodesFixture }
	    },
	    fetchNode: { event: "success", success: { response: nodeFixture } },
	    fetchNodeUnits: {
	      event: "success",
	      success: { response: nodeUnitsFixture }
	    },
	    fetchNodeUnit: {
	      event: "success",
	      success: { response: nodeUnitFixture }
	    }
	  };
	
	  (0, _keys2.default)(global.actionTypes.NodeHealthActions).forEach(function (method) {
	    NodeHealthActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(NodeHealthActions, "NodeHealthActions", method);
	  });
	}
	
	module.exports = NodeHealthActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UnitHealthDropdown = __webpack_require__(1367);
	
	var _UnitHealthDropdown2 = _interopRequireDefault(_UnitHealthDropdown);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleHealthSelection", "handleSearchStringChange", "renderHealth", "renderUnitHealthCheck", "resetFilter"];
	
	var HealthTab = function (_React$Component) {
	  (0, _inherits3.default)(HealthTab, _React$Component);
	
	  function HealthTab() {
	    (0, _classCallCheck3.default)(this, HealthTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HealthTab.__proto__ || (0, _getPrototypeOf2.default)(HealthTab)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    _this.state = {
	      healthFilter: "all",
	      searchString: ""
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(HealthTab, [{
	    key: "handleHealthSelection",
	    value: function handleHealthSelection(selectedHealth) {
	      this.setState({ healthFilter: selectedHealth.id });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "25%" } }),
	        _react2.default.createElement("col", null)
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var classNameFn = _ResourceTableUtil2.default.getClassName;
	      var headings = _ResourceTableUtil2.default.renderHeading({
	        health: "HEALTH",
	        id: "HEALTH CHECK NAME",
	        role: "ROLE"
	      });
	      var sortFunction = _UnitHealthUtil2.default.getHealthSortFunction;
	      var getHealthSorting = _TableUtil2.default.getHealthSortingOrder;
	
	      return [{
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: headings,
	        prop: "health",
	        render: this.renderHealth,
	        sortable: true,
	        sortFunction: getHealthSorting
	      }, {
	        className: classNameFn,
	        headerClassName: classNameFn,
	        heading: headings,
	        prop: "id",
	        render: this.renderUnitHealthCheck,
	        sortable: true,
	        sortFunction: sortFunction
	      }];
	    }
	  }, {
	    key: "getVisibleData",
	    value: function getVisibleData(data, searchString, healthFilter) {
	      return data.filter({ title: searchString, health: healthFilter }).getItems();
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      if (this.healthFilter !== null && this.healthFilter.dropdown !== null) {
	        this.healthFilter.setDropdownValue("all");
	      }
	
	      this.setState({
	        searchString: "",
	        healthFilter: "all"
	      });
	    }
	  }, {
	    key: "renderHealth",
	    value: function renderHealth(prop, node) {
	      var health = node.getHealth();
	
	      return _react2.default.createElement(
	        "span",
	        { className: health.classNames },
	        _StringUtil2.default.capitalize(health.title)
	      );
	    }
	  }, {
	    key: "renderUnitHealthCheck",
	    value: function renderUnitHealthCheck(prop, unit) {
	      var healthCheckName = unit.getTitle();
	      var nodeID = this.props.params.nodeID;
	
	      var unitNodeID = this.props.node.get("hostname");
	      var unitID = unit.get("id");
	
	      return _react2.default.createElement(
	        "a",
	        {
	          className: "emphasize clickable text-overflow",
	          onClick: function onClick() {
	            _reactRouter.hashHistory.push("/nodes/" + nodeID + "/health/" + unitNodeID + "/" + unitID);
	          },
	          title: healthCheckName
	        },
	        healthCheckName
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          healthFilter = _state.healthFilter,
	          searchString = _state.searchString;
	
	      var units = this.props.units;
	      var visibleData = this.getVisibleData(units, searchString, healthFilter);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_FilterHeadline2.default, {
	          currentLength: visibleData.length,
	          isFiltering: healthFilter !== "all" || searchString !== "",
	          name: "Health Check",
	          onReset: this.resetFilter,
	          totalLength: units.getItems().length
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          null,
	          _react2.default.createElement(_FilterInputText2.default, {
	            className: "flush-bottom",
	            handleFilterChange: this.handleSearchStringChange,
	            searchString: searchString
	          }),
	          _react2.default.createElement(_UnitHealthDropdown2.default, {
	            className: "button dropdown-toggle text-align-left",
	            dropdownMenuClassName: "dropdown-menu",
	            initialID: "all",
	            onHealthSelection: this.handleHealthSelection,
	            ref: function ref(_ref) {
	              return _this2.healthFilter = _ref;
	            }
	          })
	        ),
	        _react2.default.createElement(_reactjsComponents.Table, {
	          className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          containerSelector: ".gm-scroll-view",
	          data: visibleData,
	          itemHeight: _TableUtil2.default.getRowHeight(),
	          sortBy: { prop: "health", order: "asc" }
	        })
	      );
	    }
	  }]);
	  return HealthTab;
	}(_react2.default.Component);
	
	HealthTab.propTypes = {
	  node: _react2.default.PropTypes.object.isRequired,
	  units: _react2.default.PropTypes.object.isRequired,
	  params: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = HealthTab;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ResourceChart = __webpack_require__(1546);
	
	var _ResourceChart2 = _interopRequireDefault(_ResourceChart);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _NodeBreadcrumbs = __webpack_require__(1549);
	
	var _NodeBreadcrumbs2 = _interopRequireDefault(_NodeBreadcrumbs);
	
	var _NodeHealthStore = __webpack_require__(1542);
	
	var _NodeHealthStore2 = _interopRequireDefault(_NodeHealthStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var NodeDetailPage = function (_mixin) {
	  (0, _inherits3.default)(NodeDetailPage, _mixin);
	
	  function NodeDetailPage() {
	    (0, _classCallCheck3.default)(this, NodeDetailPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodeDetailPage.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailPage)).apply(this, arguments));
	
	    _this.store_listeners = [{ name: "summary", events: ["success"], suppressUpdate: false }, { name: "state", events: ["success"], suppressUpdate: false }, {
	      name: "nodeHealth",
	      events: ["nodeSuccess", "nodeError", "unitsSuccess", "unitsError"],
	      suppressUpdate: false
	    }];
	
	    _this.tabs_tabs = {
	      "/nodes/:nodeID/tasks": "Tasks",
	      "/nodes/:nodeID/health": "Health",
	      "/nodes/:nodeID/details": "Details"
	    };
	
	    _this.state = {
	      mesosStateLoaded: false,
	      node: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodeDetailPage, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(NodeDetailPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailPage.prototype), "componentWillMount", this).apply(this, arguments);
	
	      var node = this.getNode(this.props);
	      if (node) {
	        this.setState({ node: node });
	        _NodeHealthStore2.default.fetchNodeUnits(node.hostname);
	      }
	
	      // TODO: DCOS-7871 Refactor the TabsMixin to generalize this solution:
	      var routes = this.props.routes;
	      var currentRoute = routes.find(function (route) {
	        return route.component === NodeDetailPage;
	      });
	      if (currentRoute != null) {
	        this.tabs_tabs = currentRoute.childRoutes.filter(function (_ref) {
	          var isTab = _ref.isTab;
	
	          return !!isTab;
	        }).reduce(function (tabs, _ref2) {
	          var path = _ref2.path,
	              title = _ref2.title;
	
	          tabs[path] = title;
	
	          return tabs;
	        }, this.tabs_tabs);
	      }
	      this.updateCurrentTab();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.params.nodeID !== nextProps.params.nodeID) {
	        var node = this.getNode(nextProps);
	        this.setState({ node: node });
	      }
	
	      this.updateCurrentTab(nextProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate() {
	      (0, _get3.default)(NodeDetailPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailPage.prototype), "componentWillUpdate", this).apply(this, arguments);
	
	      var node = this.getNode(this.props);
	      if (node && !this.state.node) {
	        this.setState({ node: node });
	        _NodeHealthStore2.default.fetchNodeUnits(node.hostname);
	      }
	    }
	  }, {
	    key: "onStateStoreSuccess",
	    value: function onStateStoreSuccess() {
	      if (this.state.mesosStateLoaded === false) {
	        this.setState({ mesosStateLoaded: true });
	      }
	    }
	  }, {
	    key: "updateCurrentTab",
	    value: function updateCurrentTab(nextProps) {
	      var _ref3 = nextProps || this.props,
	          routes = _ref3.routes;
	
	      var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	      if (currentTab != null) {
	        this.setState({ currentTab: currentTab });
	      }
	    }
	  }, {
	    key: "getNode",
	    value: function getNode(props) {
	      return _CompositeState2.default.getNodesList().filter({ ids: [props.params.nodeID] }).last();
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(_NodeBreadcrumbs2.default, null) }),
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "getNotFound",
	    value: function getNotFound(nodeID) {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(_NodeBreadcrumbs2.default, null) }),
	        _react2.default.createElement(
	          "div",
	          { className: "pod text-align-center" },
	          _react2.default.createElement(
	            "h3",
	            { className: "flush-top text-align-center" },
	            "Error finding node"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "flush" },
	            "Did not find a node by the id \"" + nodeID + "\""
	          )
	        )
	      );
	    }
	  }, {
	    key: "getCharts",
	    value: function getCharts(itemType, item) {
	      if (!item) {
	        return null;
	      }
	
	      var states = _MesosSummaryStore2.default.get("states");
	      var resources = states["getResourceStatesFor" + itemType + "IDs"]([item.id]);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(_ResourceChart2.default, { resourceName: "cpus", resources: resources }),
	        _react2.default.createElement(_ResourceChart2.default, { resourceName: "mem", resources: resources }),
	        _react2.default.createElement(_ResourceChart2.default, { resourceName: "disk", resources: resources })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (!_MesosSummaryStore2.default.get("statesProcessed") || !this.state.mesosStateLoaded) {
	        return this.getLoadingScreen();
	      }
	
	      var node = this.state.node;
	      var nodeID = this.props.params.nodeID;
	
	
	      if (!node) {
	        return this.getNotFound(nodeID);
	      }
	
	      var currentTab = this.state.currentTab;
	
	      var tabs = [{
	        label: "Tasks",
	        callback: function callback() {
	          _this2.context.router.push("/nodes/" + nodeID + "/tasks");
	        },
	        isActive: currentTab === "/nodes/:nodeID/tasks"
	      }, {
	        label: "Health",
	        callback: function callback() {
	          _this2.context.router.push("/nodes/" + nodeID + "/health");
	        },
	        isActive: currentTab === "/nodes/:nodeID/health"
	      }, {
	        label: "Details",
	        callback: function callback() {
	          _this2.context.router.push("/nodes/" + nodeID + "/details");
	        },
	        isActive: currentTab === "/nodes/:nodeID/details"
	      }];
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(_NodeBreadcrumbs2.default, { nodeID: nodeID }),
	          tabs: tabs
	        }),
	        _react2.default.cloneElement(this.props.children, { node: node })
	      );
	    }
	  }]);
	  return NodeDetailPage;
	}((0, _reactjsMixin2.default)(_TabsMixin2.default, _mesosphereSharedReactjs.StoreMixin));
	/* eslint-enable no-unused-vars */
	
	
	NodeDetailPage.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = NodeDetailPage;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BarChart = __webpack_require__(1547);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ResourcesUtil = __webpack_require__(1500);
	
	var _ResourcesUtil2 = _interopRequireDefault(_ResourcesUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// number to fit design of width vs. height ratio
	var WIDTH_HEIGHT_RATIO = 4.5;
	
	var ResourceChart = function (_React$Component) {
	  (0, _inherits3.default)(ResourceChart, _React$Component);
	
	  function ResourceChart() {
	    (0, _classCallCheck3.default)(this, ResourceChart);
	    return (0, _possibleConstructorReturn3.default)(this, (ResourceChart.__proto__ || (0, _getPrototypeOf2.default)(ResourceChart)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ResourceChart, [{
	    key: "getResourceChart",
	    value: function getResourceChart(resource, totalResources) {
	      var colorIndex = _ResourcesUtil2.default.getResourceColor(resource);
	      var resourceLabel = _ResourcesUtil2.default.getResourceLabel(resource);
	      var resourceData = [{
	        name: "Alloc",
	        colorIndex: colorIndex,
	        values: totalResources[resource]
	      }];
	      var resourceValue = _Units2.default.formatResource(resource, _Util2.default.last(totalResources[resource]).value);
	
	      var axisConfiguration = {
	        x: { hideMatch: /^0$/ },
	        y: { showPercentage: false, suffix: "%" }
	      };
	
	      var maxY = 5;
	      totalResources[resource].forEach(function (resourceTotal) {
	        if (resourceTotal.percentage > maxY) {
	          maxY = resourceTotal.percentage;
	        }
	      });
	
	      maxY *= 1.5; // Multiply by 150%
	      maxY /= 10; // Divide so that we can round to nearest tenth
	      maxY = Math.round(maxY); // Round
	      maxY *= 10; // Multiply so that we get a percentage number between 0-100
	      maxY = Math.min(100, maxY); // Don't let it be greater than 100%
	
	      return _react2.default.createElement(
	        "div",
	        { key: resource, className: "column-12" },
	        _react2.default.createElement(
	          "h4",
	          { className: "flush-top flush-bottom" },
	          resourceValue
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "side-panel-resource-label\n            text-color-" + colorIndex
	          },
	          resourceLabel.toUpperCase()
	        ),
	        _react2.default.createElement(
	          _Chart2.default,
	          {
	            calcHeight: function calcHeight(w) {
	              return w / WIDTH_HEIGHT_RATIO;
	            },
	            delayRender: true
	          },
	          _react2.default.createElement(_BarChart2.default, {
	            axisConfiguration: axisConfiguration,
	            data: resourceData,
	            margin: { top: 0, left: 43, right: 10, bottom: 40 },
	            maxY: maxY,
	            refreshRate: _Config2.default.getRefreshRate(),
	            ticksY: 3,
	            xGridLines: 0,
	            y: "percentage"
	          })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	
	      return _react2.default.createElement(
	        "div",
	        { className: props.className },
	        _react2.default.createElement(
	          "div",
	          { className: "row chart" },
	          this.getResourceChart(props.resourceName, props.resources)
	        )
	      );
	    }
	  }]);
	  return ResourceChart;
	}(_react2.default.Component);
	
	ResourceChart.defaultProps = {
	  className: "column-12 column-small-4"
	};
	
	ResourceChart.propTypes = {
	  className: _react2.default.PropTypes.string,
	  resourceName: _react2.default.PropTypes.string,
	  resources: _react2.default.PropTypes.object
	};
	
	module.exports = ResourceChart;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Bar = __webpack_require__(1548);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _ChartMixin = __webpack_require__(1392);
	
	var _ChartMixin2 = _interopRequireDefault(_ChartMixin);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarChart = _react2.default.createClass({
	  displayName: "BarChart",
	
	  mixins: [_ChartMixin2.default, _InternalStorageMixin2.default],
	
	  propTypes: {
	    axisConfiguration: _react2.default.PropTypes.object,
	    data: _react2.default.PropTypes.array.isRequired,
	    // `height` and `width` are required if this
	    // module isn't used as a child of the `Chart` component
	    // Otherwise Chart will automatically calculate this.
	    height: _react2.default.PropTypes.number,
	    inverseStyle: _react2.default.PropTypes.bool,
	    peakline: _react2.default.PropTypes.bool,
	    refreshRate: _react2.default.PropTypes.number.isRequired,
	    y: _react2.default.PropTypes.string,
	    width: _react2.default.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      axisConfiguration: {
	        x: { hideMatch: false },
	        y: { hideMatch: false, showPercentage: true }
	      },
	      inverseStyle: false,
	      margin: {
	        top: 0,
	        right: 5,
	        bottom: 40,
	        left: 43
	      },
	      maxY: 10,
	      peakline: false,
	      ticksY: 10,
	      transition: {
	        delay: 200,
	        duration: 800
	      },
	      refreshRate: 0,
	      xGridLines: null,
	      y: "y"
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return this.props.height !== nextProps.height || this.props.width !== nextProps.width || !(0, _deepEqual2.default)(this.props.data, nextProps.data);
	  },
	  componentWillMount: function componentWillMount() {
	    var props = this.props;
	
	    var width = this.getWidth(props);
	    var xScale = this.getXScale(props.data, width, props.refreshRate);
	    var yScale = this.getYScale(props);
	
	    var data = {
	      stack: this.getStack(),
	      xScale: xScale,
	      yScale: yScale,
	      clipPathID: "clip-" + _Util2.default.uniqueID()
	    };
	
	    this.internalStorage_set(data);
	
	    // #prepareValues needs data.stack, so we must set that first
	    this.internalStorage_update(this.prepareValues(this.props));
	  },
	  componentDidMount: function componentDidMount() {
	    var data = this.internalStorage_get();
	    var props = this.props;
	
	    this.renderAxis(props, data.xScale, data.yScale);
	    this.createClipPath();
	    this.resetXAxis(props);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    var width = this.getWidth(props);
	    var xScale = this.getXScale(props.data, width, props.refreshRate);
	    var yScale = this.getYScale(props);
	    // the d3 axis helper requires a <g> element passed into do its work. This
	    // happens after mount and ends up keeping the axis code outside of react
	    // unfortunately.
	    this.renderAxis(props, xScale, yScale);
	
	    this.internalStorage_update((0, _assign2.default)(this.prepareValues(props), {
	      xScale: xScale,
	      yScale: yScale
	    }));
	
	    this.resetXAxis(props);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.updateClipPath();
	  },
	  createClipPath: function createClipPath() {
	    var data = this.internalStorage_get();
	    var el = _reactDom2.default.findDOMNode(this);
	
	    _d2.default.select(el).append("defs").append("clipPath").attr("id", data.clipPathID).append("rect");
	
	    this.updateClipPath();
	  },
	  updateClipPath: function updateClipPath() {
	    var data = this.internalStorage_get();
	    var props = this.props;
	    var width = props.width - props.margin.left - props.margin.right;
	    var height = props.height + 1; // +1 for the base axis line
	
	    _d2.default.select("#" + data.clipPathID + " rect").attr({
	      width: width,
	      height: height
	    });
	  },
	  getStack: function getStack() {
	    return _d2.default.layout.stack().values(function (d) {
	      return d.values;
	    }).x(function (d) {
	      return d.date;
	    });
	  },
	  getYScale: function getYScale(props) {
	    return _d2.default.scale.linear().domain([0, props.maxY]).range([props.height, 0]);
	  },
	  formatYAxis: function formatYAxis(ticks, maxY) {
	    var _this = this;
	
	    var formatPercent = _d2.default.scale.linear().tickFormat(ticks, ".0%");
	
	    return function (d) {
	      var axisConfiguration = _this.props.axisConfiguration;
	      var hideMatch = axisConfiguration.y.hideMatch;
	      if (hideMatch && hideMatch.test(d.toString())) {
	        return "";
	      }
	
	      var value = d;
	
	      if (axisConfiguration.y.showPercentage) {
	        value = formatPercent(d / maxY);
	
	        if (d >= maxY) {
	          value = "100%";
	        }
	      }
	
	      if (axisConfiguration.y.suffix) {
	        value += axisConfiguration.y.suffix;
	      }
	
	      return value;
	    };
	  },
	  renderAxis: function renderAxis(props, xScale, yScale) {
	    var length = props.width;
	    var firstDataSet = props.data[0];
	    if (firstDataSet != null) {
	      length = firstDataSet.values.length;
	    }
	
	    // The 4 is a number that works, though random :)
	    if (firstDataSet) {
	      var xAxisClass = (0, _classnames2.default)("x axis", {
	        "text-small": props.width < 350
	      });
	
	      var xTicks = length / (props.refreshRate / 1000) / 4;
	      var xAxis = _d2.default.svg.axis().scale(xScale).ticks(xTicks).tickFormat(this.formatXAxis).orient("bottom");
	      _d2.default.select(this.refs.xAxis).interrupt().attr("class", xAxisClass).call(xAxis);
	    }
	
	    var yAxisClass = (0, _classnames2.default)("y axis", {
	      "text-small": props.width < 350,
	      inverse: props.inverseStyle
	    });
	    var yAxis = _d2.default.svg.axis().scale(yScale).ticks(props.ticksY).tickFormat(this.formatYAxis(props.ticksY, props.maxY)).orient("left");
	    _d2.default.select(this.refs.yAxis).attr("class", yAxisClass).call(yAxis);
	
	    _d2.default.select(this.refs.yGrid).attr("class", "grid y").call(_d2.default.svg.axis().scale(yScale).orient("left").ticks(props.ticksY).tickSize(-props.width, 0, 0).tickFormat(""));
	
	    var xGridLines = props.ticksY;
	    if (props.xGridLines != null) {
	      xGridLines = props.xGridLines;
	    }
	    _d2.default.select(this.refs.xGrid).attr("class", "grid x").call(_d2.default.svg.axis().scale(xScale).orient("top").ticks(xGridLines).tickSize(-props.height, 0, 0).tickFormat(""));
	  },
	  prepareValues: function prepareValues(props) {
	    var data = this.internalStorage_get();
	    var stackedData = data.stack(props.data);
	    var valuesLength = 0;
	    var rectWidth = 0;
	
	    if (stackedData.length !== 0) {
	      valuesLength = _Util2.default.last(stackedData).values.length;
	      rectWidth = (props.width - props.margin.left - props.margin.right) / valuesLength;
	    }
	
	    return {
	      valuesLength: valuesLength,
	      rectWidth: rectWidth,
	      stackedData: stackedData
	    };
	  },
	  resetXAxis: function resetXAxis(props) {
	    var data = this.internalStorage_get();
	    // here we reset the position of the axis to what it was before the animation started
	    // the axis is reset right before we update the bar to the new value/position
	    // prevents subsequent animations from animating from 0
	    if (data.rectWidth) {
	      _d2.default.select(this.refs.xAxis).interrupt().transition().delay(0).attr("transform", "translate(" + [0, props.height] + ")");
	    }
	  },
	  getBarList: function getBarList() {
	    var data = this.internalStorage_get();
	    var props = this.props;
	    var marginLeft = props.margin.left;
	    var marginRight = props.margin.right;
	    var chartWidth = props.width;
	    var y = props.y;
	    var valuesLength = data.valuesLength;
	    var posY = Array(valuesLength).fill(props.height);
	    var peaklineHeight = 2;
	    var lineClass;
	    if (!props.peakline) {
	      peaklineHeight = 0;
	      lineClass = "hidden ";
	    }
	
	    return data.stackedData.map(function (service) {
	      var rectWidth = (chartWidth - marginLeft - marginRight) / (valuesLength - 1);
	
	      return service.values.map(function (val, j) {
	        var rectHeight = void 0,
	            colorClass = void 0;
	        var barMargin = 0;
	        var shapeRendering = "auto";
	        var posX = chartWidth - marginLeft - marginRight - rectWidth * (valuesLength - 1 - j);
	
	        if (val.percentage == null) {
	          rectHeight = props.height - peaklineHeight;
	          colorClass = "path-color-7";
	
	          // flush svg rect edges together
	          shapeRendering = "crispEdges";
	        } else {
	          rectHeight = props.height * val[y] / props.maxY - peaklineHeight;
	          colorClass = "path-color-" + service.colorIndex;
	
	          // Will increase the margin between bars as they become smaller
	          // to make it visually easier to parse
	          barMargin = 1 + Math.pow(rectWidth, -0.4);
	        }
	
	        posY[j] -= rectHeight;
	
	        return _react2.default.createElement(_Bar2.default, {
	          posX: posX,
	          posY: posY[j],
	          rectHeight: rectHeight,
	          rectWidth: rectWidth,
	          margin: barMargin,
	          colorClass: colorClass,
	          transitionDelay: props.transition.delay,
	          transitionDuration: props.transition.duration,
	          lineClass: lineClass + colorClass,
	          shapeRendering: shapeRendering
	        });
	      });
	    });
	  },
	  render: function render() {
	    var data = this.internalStorage_get();
	    var props = this.props;
	    var margin = props.margin;
	    var clipPath = "url(#" + data.clipPathID + ")";
	
	    var gridClassSet = (0, _classnames2.default)({
	      "grid-graph": true,
	      inverse: props.inverseStyle
	    });
	
	    return _react2.default.createElement(
	      "svg",
	      {
	        height: props.height + margin.bottom,
	        width: props.width,
	        className: "barchart",
	        ref: "barchart"
	      },
	      _react2.default.createElement(
	        "g",
	        { transform: "translate(" + [margin.left, margin.bottom / 2] + ")" },
	        _react2.default.createElement("g", { className: "y axis", ref: "yAxis" }),
	        _react2.default.createElement("g", {
	          className: "x axis",
	          transform: "translate(" + [0, props.height] + ")",
	          ref: "xAxis"
	        }),
	        _react2.default.createElement(
	          "g",
	          { className: gridClassSet, clipPath: clipPath },
	          _react2.default.createElement("g", { ref: "yGrid" }),
	          _react2.default.createElement("g", { ref: "xGrid" }),
	          this.getBarList()
	        )
	      )
	    );
	  }
	});
	
	module.exports = BarChart;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _d = __webpack_require__(1390);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bar = _react2.default.createClass({
	  displayName: "Bar",
	
	  propTypes: {
	    posX: _react2.default.PropTypes.number.isRequired,
	    posY: _react2.default.PropTypes.number.isRequired,
	    rectHeight: _react2.default.PropTypes.number.isRequired,
	    rectWidth: _react2.default.PropTypes.number.isRequired,
	    colorClass: _react2.default.PropTypes.string.isRequired,
	    lineClass: _react2.default.PropTypes.string.isRequired
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.animate(this.props);
	  },
	  componentWillUpdate: function componentWillUpdate() {
	    if (!this.props.transitionDelay && !this.props.transitionDuration) {
	      return;
	    }
	
	    // here we reset the position of the bar to what it was before the animation started
	    // the bar is reset right before we update the bar to the new value
	    var el = _reactDom2.default.findDOMNode(this);
	    _d2.default.select(el).interrupt().transition().duration(0).attr("transform", "translate(" + this.props.posX + ")");
	  },
	  componentDidUpdate: function componentDidUpdate(props) {
	    this.animate(props);
	  },
	  animate: function animate(props) {
	    if (!props.transitionDelay && !props.transitionDuration) {
	      return;
	    }
	    var el = _reactDom2.default.findDOMNode(this);
	    _d2.default.select(el).interrupt().transition().delay(props.transitionDelay).duration(props.transitionDuration).ease("linear").attr("transform", "translate(" + (props.posX - props.rectWidth) + ")");
	  },
	  render: function render() {
	    var props = this.props;
	    var posY = props.posY || 0;
	    // Show 1px height when value is 0, to not confuse user with an empty graph
	    var rectHeight = props.rectHeight || 1;
	    var rectWidth = props.rectWidth || 0;
	
	    return _react2.default.createElement(
	      "g",
	      { className: "bar", transform: "translate(" + [props.posX, 0] + ")" },
	      _react2.default.createElement("line", {
	        className: props.lineClass,
	        x1: 0,
	        y1: posY,
	        x2: rectWidth - props.margin,
	        y2: posY
	      }),
	      _react2.default.createElement("rect", {
	        "shape-rendering": props.shapeRendering,
	        className: props.colorClass,
	        y: posY,
	        height: rectHeight,
	        width: rectWidth - props.margin
	      })
	    );
	  }
	});
	
	module.exports = Bar;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _PageHeaderBreadcrumbs = __webpack_require__(1329);
	
	var _PageHeaderBreadcrumbs2 = _interopRequireDefault(_PageHeaderBreadcrumbs);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeBreadcrumbs = function NodeBreadcrumbs(_ref) {
	  var nodeID = _ref.nodeID,
	      taskID = _ref.taskID,
	      taskName = _ref.taskName,
	      unitID = _ref.unitID;
	
	  var trimmedNodeID = decodeURIComponent(nodeID).replace(/^\//, "");
	  var encodedNodeID = encodeURIComponent(trimmedNodeID);
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: -1, title: "Nodes" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/nodes", key: -1 },
	        "Nodes"
	      )
	    )
	  )];
	  var node = void 0;
	
	  if (nodeID != null && trimmedNodeID.length > 0) {
	    node = _CompositeState2.default.getNodesList().filter({ ids: [nodeID] }).last();
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: "hostname", title: node.hostname },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/nodes/" + encodedNodeID },
	          node.hostname
	        )
	      )
	    ));
	  }
	
	  if (taskID != null && taskName != null) {
	    var encodedTaskID = encodeURIComponent(taskID);
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: "task-name", title: taskName },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/nodes/" + encodedNodeID + "/tasks/" + encodedTaskID },
	          taskName
	        )
	      )
	    ));
	  }
	
	  if (unitID != null) {
	    var unit = _UnitHealthStore2.default.getUnit(unitID);
	    var healthStatus = _UnitHealthStore2.default.getNode(node.hostname).getHealth();
	    var unitTitle = unit.getTitle();
	
	    crumbs.push(_react2.default.createElement(
	      _Breadcrumb2.default,
	      { key: "unit-health", title: unitTitle },
	      _react2.default.createElement(
	        _BreadcrumbTextContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            to: "/nodes/" + encodedNodeID + "/health/" + node.hostname + "/" + unit.get("id"),
	            key: -1
	          },
	          unitTitle + " ",
	          _react2.default.createElement(
	            "span",
	            { className: healthStatus.classNames },
	            "(",
	            healthStatus.title,
	            ")"
	          )
	        )
	      )
	    ));
	  }
	
	  return _react2.default.createElement(_PageHeaderBreadcrumbs2.default, { iconID: "servers", breadcrumbs: crumbs });
	};
	
	module.exports = NodeBreadcrumbs;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _HashMapDisplay = __webpack_require__(1437);
	
	var _HashMapDisplay2 = _interopRequireDefault(_HashMapDisplay);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Node = __webpack_require__(1052);
	
	var _Node2 = _interopRequireDefault(_Node);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodeDetailTab = function (_React$Component) {
	  (0, _inherits3.default)(NodeDetailTab, _React$Component);
	
	  function NodeDetailTab() {
	    (0, _classCallCheck3.default)(this, NodeDetailTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodeDetailTab.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailTab)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodeDetailTab, [{
	    key: "render",
	    value: function render() {
	      var node = this.props.node;
	
	      var resources = node.get("resources");
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "ID"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                node.id
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Active"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _StringUtil2.default.capitalize(node.active.toString().toLowerCase())
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Registered"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _DateUtil2.default.msToDateStr(node.registered_time.toFixed(3) * 1000)
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Master Version"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _MesosStateStore2.default.get("lastMesosState").version
	              )
	            )
	          ),
	          _react2.default.createElement(_HashMapDisplay2.default, { hash: node.attributes, headline: "Attributes" }),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Resources"
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Disk"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _Units2.default.formatResource("disk", resources.disk)
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Mem"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _Units2.default.formatResource("mem", resources.mem)
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "CPUs"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                _Units2.default.formatResource("cpus", resources.cpus)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return NodeDetailTab;
	}(_react2.default.Component);
	
	NodeDetailTab.propTypes = {
	  node: _react2.default.PropTypes.instanceOf(_Node2.default).isRequired
	};
	
	module.exports = NodeDetailTab;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _EventTypes = __webpack_require__(933);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _TasksContainer = __webpack_require__(1552);
	
	var _TasksContainer2 = _interopRequireDefault(_TasksContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onStoreChange"];
	
	var NodeDetailTaskTab = function (_React$Component) {
	  (0, _inherits3.default)(NodeDetailTaskTab, _React$Component);
	
	  function NodeDetailTaskTab() {
	    (0, _classCallCheck3.default)(this, NodeDetailTaskTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodeDetailTaskTab.__proto__ || (0, _getPrototypeOf2.default)(NodeDetailTaskTab)).apply(this, arguments));
	
	    _this.state = {
	      isLoading: true,
	      lastUpdate: 0
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodeDetailTaskTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _DCOSStore2.default.addChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "onStoreChange",
	    value: function onStoreChange() {
	      // Throttle updates from DCOSStore
	      if (Date.now() - this.state.lastUpdate > 1000 || _DCOSStore2.default.serviceDataReceived && this.state.isLoading) {
	        this.setState({
	          isLoading: !_DCOSStore2.default.serviceDataReceived,
	          lastUpdate: Date.now()
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nodeID = this.props.params.nodeID;
	
	      var tasks = _MesosStateStore2.default.getTasksFromNodeID(nodeID);
	
	      return _react2.default.createElement(_TasksContainer2.default, { params: this.props.params, tasks: tasks });
	    }
	  }]);
	  return NodeDetailTaskTab;
	}(_react2.default.Component);
	
	NodeDetailTaskTab.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = NodeDetailTaskTab;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ContainerUtil = __webpack_require__(1553);
	
	var _ContainerUtil2 = _interopRequireDefault(_ContainerUtil);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionItem2 = _interopRequireDefault(_ServiceActionItem);
	
	var _TaskModals = __webpack_require__(1556);
	
	var _TaskModals2 = _interopRequireDefault(_TaskModals);
	
	var _TasksView = __webpack_require__(1560);
	
	var _TasksView2 = _interopRequireDefault(_TasksView);
	
	var _ActionTypes = __webpack_require__(1223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleServerAction", "handleModalClose", "clearActionError", "killTasks"];
	
	var TasksContainer = function (_React$Component) {
	  (0, _inherits3.default)(TasksContainer, _React$Component);
	
	  function TasksContainer() {
	    (0, _classCallCheck3.default)(this, TasksContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TasksContainer.__proto__ || (0, _getPrototypeOf2.default)(TasksContainer)).apply(this, arguments));
	
	    _this.state = {
	      actionErrors: {},
	      pendingActions: {}
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TasksContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Listen for server actions so we can update state immediately
	      // on the completion of an API request.
	      this.dispatcher = _AppDispatcher2.default.register(this.handleServerAction);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _AppDispatcher2.default.unregister(this.dispatcher);
	    }
	  }, {
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        modalHandlers: this.getModalHandlers()
	      };
	    }
	  }, {
	    key: "killTasks",
	    value: function killTasks() {
	      this.setPendingAction(_ActionKeys2.default.TASK_KILL);
	
	      return _MarathonActions2.default.killTasks.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "handleServerAction",
	    value: function handleServerAction(payload) {
	      var action = payload.action;
	
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_MARATHON_TASK_KILL_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.TASK_KILL, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_TASK_KILL_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.TASK_KILL);
	          break;
	      }
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose(key) {
	      if (key) {
	        this.clearActionError(key);
	      }
	      this.setState({ modal: {} });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {}
	    // Re-fetch data - this will end up being a single Relay request
	
	    /**
	     * Sets the actionType to pending in state which will in turn be pushed
	     * to children components as a prop. Also clears any existing error for
	     * the actionType
	     * @param {String} actionType
	     */
	
	  }, {
	    key: "setPendingAction",
	    value: function setPendingAction(actionType) {
	      var _state = this.state,
	          actionErrors = _state.actionErrors,
	          pendingActions = _state.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, true)
	      });
	    }
	    /**
	     * Sets the pending actionType to false in state which will in turn be
	     * pushed down to children via props. Can optional set an error for the
	     * actionType
	     * @param  {String} actionType
	     * @param  {Any} error
	     */
	
	  }, {
	    key: "unsetPendingAction",
	    value: function unsetPendingAction(actionType) {
	      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var _state2 = this.state,
	          actionErrors = _state2.actionErrors,
	          pendingActions = _state2.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, error),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, false)
	      });
	
	      // Fetch new data if action was successful
	      if (!error) {
	        this.fetchData();
	      }
	    }
	  }, {
	    key: "clearActionError",
	    value: function clearActionError(actionType) {
	      var actionErrors = this.state.actionErrors;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null)
	      });
	    }
	  }, {
	    key: "getModalHandlers",
	    value: function getModalHandlers() {
	      var _this2 = this;
	
	      var set = function set(id, props) {
	        // Set props to be passed into modal
	        _this2.setState({
	          modal: (0, _assign2.default)({}, props, { id: id })
	        });
	      };
	
	      return {
	        killTasks: function killTasks(props) {
	          return set(_ServiceActionItem2.default.KILL_TASKS, props);
	        }
	      };
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      return {
	        killTasks: this.killTasks
	      };
	    }
	  }, {
	    key: "getModals",
	    value: function getModals() {
	      var modalProps = (0, _assign2.default)({}, this.state.modal);
	
	      return _react2.default.createElement(_TaskModals2.default, {
	        actions: this.getActions(),
	        actionErrors: this.state.actionErrors,
	        clearError: this.clearActionError,
	        onClose: this.handleModalClose,
	        pendingActions: this.state.pendingActions,
	        modalProps: modalProps
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_TasksView2.default, { params: this.props.params, tasks: this.props.tasks }),
	        this.getModals()
	      );
	    }
	  }]);
	  return TasksContainer;
	}(_react2.default.Component);
	
	// Make these modal handlers available via context
	// so any child can trigger the opening of modals
	
	
	TasksContainer.childContextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    killTasks: _react.PropTypes.func
	  })
	};
	
	TasksContainer.propTypes = {
	  tasks: _react.PropTypes.array.isRequired,
	  params: _react.PropTypes.object.isRequired
	};
	
	module.exports = TasksContainer;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContainerUtil = {
	  /**
	   * Sets or clears error for actionType
	   * @param {Object} actionErrors
	   * @param  {String} actionType
	   * @param  {Any} error
	   * @return {Object} updated action errors
	   */
	  adjustActionErrors: function adjustActionErrors(actionErrors, actionType, error) {
	    return (0, _assign2.default)({}, actionErrors, (0, _defineProperty3.default)({}, actionType, error));
	  },
	
	  /**
	   * Sets pending action to true/false
	   * @param {Object} pendingActions
	   * @param  {String}  actionType
	   * @param  {Boolean} isPending
	   * @return {Object} updated pending actions
	   */
	  adjustPendingActions: function adjustPendingActions(pendingActions, actionType, isPending) {
	    return (0, _assign2.default)({}, pendingActions, (0, _defineProperty3.default)({}, actionType, isPending));
	  }
	};
	
	module.exports = ContainerUtil;

/***/ },
/* 1554 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  REVERT_DEPLOYMENT: "revertDeployment",
	  GROUP_CREATE: "groupCreate",
	  GROUP_DELETE: "groupDelete",
	  GROUP_EDIT: "groupEdit",
	  SERVICE_CREATE: "serviceCreate",
	  SERVICE_DELETE: "serviceDelete",
	  SERVICE_EDIT: "serviceEdit",
	  SERVICE_RESTART: "serviceRestart",
	  POD_INSTANCES_KILL: "killPodInstances",
	  TASK_KILL: "taskKill"
	};

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceActionItem = {
	  CREATE: "create",
	  CREATE_GROUP: "create_group",
	  EDIT: "edit",
	  DELETE: _UserActions2.default.DELETE,
	  OPEN: "open",
	  RESTART: "restart",
	  RESUME: "resume",
	  SCALE: "scale",
	  SUSPEND: "suspend",
	  MORE: "more",
	  KILL_POD_INSTANCES: "kill_pod_instances",
	  KILL_TASKS: "kill_tasks"
	};
	
	module.exports = ServiceActionItem;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _KillPodInstanceModal = __webpack_require__(1557);
	
	var _KillPodInstanceModal2 = _interopRequireDefault(_KillPodInstanceModal);
	
	var _KillTaskModal = __webpack_require__(1559);
	
	var _KillTaskModal2 = _interopRequireDefault(_KillTaskModal);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionItem2 = _interopRequireDefault(_ServiceActionItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TaskModals = function (_React$Component) {
	  (0, _inherits3.default)(TaskModals, _React$Component);
	
	  function TaskModals() {
	    (0, _classCallCheck3.default)(this, TaskModals);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskModals.__proto__ || (0, _getPrototypeOf2.default)(TaskModals)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskModals, [{
	    key: "getKillPodInstancesModal",
	    value: function getKillPodInstancesModal() {
	      var _props = this.props,
	          actions = _props.actions,
	          actionErrors = _props.actionErrors,
	          _clearError = _props.clearError,
	          _onClose = _props.onClose,
	          modalProps = _props.modalProps,
	          pendingActions = _props.pendingActions;
	
	
	      var key = _ActionKeys2.default.POD_INSTANCES_KILL;
	
	      return _react2.default.createElement(_KillPodInstanceModal2.default, (0, _extends3.default)({
	        killPodInstances: actions.killPodInstances,
	        clearError: function clearError() {
	          return _clearError(key);
	        },
	        isPending: !!pendingActions[key],
	        errors: actionErrors[key],
	        open: modalProps.id === _ServiceActionItem2.default.KILL_POD_INSTANCES,
	        onClose: function onClose() {
	          return _onClose(key);
	        }
	      }, modalProps));
	    }
	  }, {
	    key: "getKillTasksModal",
	    value: function getKillTasksModal() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          actionErrors = _props2.actionErrors,
	          _clearError2 = _props2.clearError,
	          _onClose2 = _props2.onClose,
	          modalProps = _props2.modalProps,
	          pendingActions = _props2.pendingActions;
	
	
	      var key = _ActionKeys2.default.TASK_KILL;
	
	      return _react2.default.createElement(_KillTaskModal2.default, (0, _extends3.default)({
	        killTasks: actions.killTasks,
	        clearError: function clearError() {
	          return _clearError2(key);
	        },
	        isPending: !!pendingActions[key],
	        errors: actionErrors[key],
	        open: modalProps.id === _ServiceActionItem2.default.KILL_TASKS,
	        onClose: function onClose() {
	          return _onClose2(key);
	        }
	      }, modalProps));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.getKillPodInstancesModal(),
	        this.getKillTasksModal()
	      );
	    }
	  }]);
	  return TaskModals;
	}(_react2.default.Component);
	
	var actionPropTypes = _react.PropTypes.shape({
	  killPodInstances: _react.PropTypes.func,
	  killTasks: _react.PropTypes.func
	}).isRequired;
	
	TaskModals.propTypes = {
	  actionErrors: _react.PropTypes.object.isRequired,
	  actions: actionPropTypes,
	  clearError: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  modalProps: _react.PropTypes.object,
	  pendingActions: _react.PropTypes.object
	};
	
	module.exports = TaskModals;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_DISPLAY_NAMES = {
	  restart: "Restart",
	  stop: "Stop"
	};
	
	var KillPodInstanceModal = function (_React$Component) {
	  (0, _inherits3.default)(KillPodInstanceModal, _React$Component);
	
	  function KillPodInstanceModal() {
	    (0, _classCallCheck3.default)(this, KillPodInstanceModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (KillPodInstanceModal.__proto__ || (0, _getPrototypeOf2.default)(KillPodInstanceModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(KillPodInstanceModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var errorMsg = this.state.errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, null);
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getModalContents",
	    value: function getModalContents() {
	      var selectedItemsLength = this.props.selectedItems.length;
	      var action = ACTION_DISPLAY_NAMES[this.props.action];
	      var instanceCountContent = selectedItemsLength + " " + _StringUtil2.default.pluralize("Instance", selectedItemsLength);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "You are about to ",
	          action.toLowerCase(),
	          " ",
	          instanceCountContent,
	          ".",
	          _react2.default.createElement("br", null),
	          "Are you sure you want to continue?"
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          isPending = _props.isPending,
	          killPodInstances = _props.killPodInstances,
	          onClose = _props.onClose,
	          open = _props.open,
	          pod = _props.pod,
	          selectedItems = _props.selectedItems;
	
	
	      var buttonText = ACTION_DISPLAY_NAMES[action];
	
	      if (this.shouldForceUpdate()) {
	        buttonText = "Force " + buttonText;
	      }
	
	      var killAction = function killAction() {
	        return killPodInstances(pod, selectedItems.map(function (item) {
	          return item.id;
	        }), _this2.shouldForceUpdate());
	      };
	
	      var header = _react2.default.createElement(
	        _ModalHeading2.default,
	        { className: "text-danger" },
	        ACTION_DISPLAY_NAMES[action],
	        " ",
	        _StringUtil2.default.pluralize("Instance", selectedItems.length)
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          closeByBackdropClick: true,
	          disabled: isPending,
	          header: header,
	          open: open,
	          onClose: onClose,
	          leftButtonText: "Close",
	          leftButtonCallback: onClose,
	          rightButtonText: buttonText,
	          rightButtonClassName: "button button-danger",
	          rightButtonCallback: killAction,
	          showHeader: true
	        },
	        this.getModalContents()
	      );
	    }
	  }]);
	  return KillPodInstanceModal;
	}(_react2.default.Component);
	
	KillPodInstanceModal.defaultProps = {
	  action: "restart",
	  killPodInstances: function killPodInstances() {},
	  pod: new _Pod2.default(),
	  selectedItems: []
	};
	
	KillPodInstanceModal.propTypes = {
	  action: _react.PropTypes.string,
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  killPodInstances: _react.PropTypes.func,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  pod: _react.PropTypes.instanceOf(_Pod2.default),
	  selectedItems: _react.PropTypes.array
	};
	
	module.exports = KillPodInstanceModal;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	var AppLockedMessage = function AppLockedMessage(_ref) {
	  var service = _ref.service;
	
	  var itemType = "Service";
	
	  if (service instanceof _Pod2.default) {
	    itemType = "Pod";
	  }
	
	  if (service instanceof _ServiceTree2.default) {
	    itemType = "Group";
	  }
	
	  return _react2.default.createElement(
	    "h4",
	    { className: "text-align-center text-danger flush-top" },
	    itemType,
	    " ",
	    "is currently locked by one or more deployments. Press the button again to forcefully change and deploy the new configuration."
	  );
	}; /* eslint-disable no-unused-vars */
	
	
	module.exports = AppLockedMessage;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_DISPLAY_NAMES = {
	  restart: "Restart",
	  stop: "Stop"
	};
	
	var KillTaskModal = function (_React$Component) {
	  (0, _inherits3.default)(KillTaskModal, _React$Component);
	
	  function KillTaskModal() {
	    (0, _classCallCheck3.default)(this, KillTaskModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (KillTaskModal.__proto__ || (0, _getPrototypeOf2.default)(KillTaskModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(KillTaskModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var errorMsg = this.state.errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, null);
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getModalContents",
	    value: function getModalContents() {
	      var selectedItemsLength = this.props.selectedItems.length;
	      var action = ACTION_DISPLAY_NAMES[this.props.action] || "";
	      var taskCountContent = selectedItemsLength + " " + _StringUtil2.default.pluralize("task", selectedItemsLength);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "You are about to ",
	          action.toLowerCase(),
	          " ",
	          taskCountContent,
	          ".",
	          _react2.default.createElement("br", null),
	          "Are you sure you want to continue?"
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          isPending = _props.isPending,
	          killTasks = _props.killTasks,
	          onClose = _props.onClose,
	          open = _props.open,
	          selectedItems = _props.selectedItems;
	
	
	      var buttonText = ACTION_DISPLAY_NAMES[action];
	
	      if (this.shouldForceUpdate()) {
	        buttonText = "Force " + buttonText;
	      }
	
	      var killTasksAction = function killTasksAction() {
	        return killTasks(selectedItems, action === "stop", _this2.shouldForceUpdate());
	      };
	
	      var header = _react2.default.createElement(
	        _ModalHeading2.default,
	        { className: "text-danger" },
	        ACTION_DISPLAY_NAMES[action],
	        " ",
	        _StringUtil2.default.pluralize("task", selectedItems.length)
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          closeByBackdropClick: true,
	          disabled: isPending,
	          header: header,
	          open: open,
	          onClose: onClose,
	          leftButtonText: "Close",
	          leftButtonCallback: onClose,
	          rightButtonText: buttonText,
	          rightButtonClassName: "button button-danger",
	          rightButtonCallback: killTasksAction,
	          showHeader: true
	        },
	        this.getModalContents()
	      );
	    }
	  }]);
	  return KillTaskModal;
	}(_react2.default.Component);
	
	KillTaskModal.defaultProps = {
	  action: "restart",
	  killTasks: function killTasks() {},
	  selectedItems: []
	};
	
	KillTaskModal.propTypes = {
	  action: _react.PropTypes.string,
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  killTasks: _react.PropTypes.func,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  selectedItems: _react.PropTypes.array
	};
	
	module.exports = KillTaskModal;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterButtons = __webpack_require__(1383);
	
	var _FilterButtons2 = _interopRequireDefault(_FilterButtons);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SaveStateMixin = __webpack_require__(1561);
	
	var _SaveStateMixin2 = _interopRequireDefault(_SaveStateMixin);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _ServiceStatusTypes = __webpack_require__(1093);
	
	var _ServiceStatusTypes2 = _interopRequireDefault(_ServiceStatusTypes);
	
	var _GraphQLTaskUtil = __webpack_require__(1562);
	
	var _GraphQLTaskUtil2 = _interopRequireDefault(_GraphQLTaskUtil);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _TaskTable = __webpack_require__(1564);
	
	var _TaskTable2 = _interopRequireDefault(_TaskTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleItemCheck", "handleSearchStringChange", "handleStatusFilterChange", "resetFilter"];
	
	var STATUS_FILTER_BUTTONS = ["all", "active", "completed"];
	
	var TasksView = function (_mixin) {
	  (0, _inherits3.default)(TasksView, _mixin);
	
	  function TasksView() {
	    (0, _classCallCheck3.default)(this, TasksView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TasksView.__proto__ || (0, _getPrototypeOf2.default)(TasksView)).call(this));
	
	    _this.state = {
	      checkedItems: {},
	      searchString: "",
	      filterByStatus: "active"
	    };
	
	    _this.saveState_properties = ["filterByStatus"];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      this[method] = this[method].bind(this);
	    }, _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(TasksView, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.saveState_key = "tasksView#" + this.props.itemID;
	      (0, _get3.default)(TasksView.prototype.__proto__ || (0, _getPrototypeOf2.default)(TasksView.prototype), "componentWillMount", this).call(this);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var prevCheckedItems = this.state.checkedItems;
	      var checkedItems = {};
	
	      nextProps.tasks.forEach(function (task) {
	        if (prevCheckedItems[task.id]) {
	          checkedItems[task.id] = true;
	        }
	      });
	
	      this.setState({ checkedItems: checkedItems });
	    }
	  }, {
	    key: "handleItemCheck",
	    value: function handleItemCheck(idsChecked) {
	      var checkedItems = {};
	      idsChecked.forEach(function (id) {
	        checkedItems[id] = true;
	      });
	
	      this.setState({ checkedItems: checkedItems });
	    }
	  }, {
	    key: "handleActionClick",
	    value: function handleActionClick(killAction) {
	      var checkedItems = this.state.checkedItems;
	
	
	      if (!(0, _keys2.default)(checkedItems).length) {
	        return;
	      }
	
	      this.context.modalHandlers.killTasks({
	        action: killAction,
	        selectedItems: (0, _keys2.default)(checkedItems)
	      });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "handleStatusFilterChange",
	    value: function handleStatusFilterChange(filterByStatus) {
	      this.setState({ filterByStatus: filterByStatus });
	    }
	  }, {
	    key: "getFilteredTasks",
	    value: function getFilteredTasks() {
	      var tasks = this.props.tasks;
	      var _state = this.state,
	          filterByStatus = _state.filterByStatus,
	          searchString = _state.searchString;
	
	
	      if (searchString !== "") {
	        tasks = _StringUtil2.default.filterByString(tasks, "id", searchString);
	      }
	
	      if (filterByStatus !== "all") {
	        tasks = tasks.filter(function (task) {
	          return _TaskStates2.default[task.state].stateTypes.includes(filterByStatus);
	        });
	      }
	
	      return tasks;
	    }
	  }, {
	    key: "getTaskTable",
	    value: function getTaskTable(tasks, checkedItems) {
	      var _props = this.props,
	          inverseStyle = _props.inverseStyle,
	          params = _props.params;
	
	
	      var classSet = (0, _classnames2.default)({
	        "table table-borderless-outer table-borderless-inner-columns": true,
	        "flush-bottom": true,
	        inverse: inverseStyle
	      });
	
	      return _react2.default.createElement(_TaskTable2.default, {
	        checkedItemsMap: checkedItems,
	        className: classSet,
	        params: params,
	        onCheckboxChange: this.handleItemCheck,
	        tasks: tasks
	      });
	    }
	  }, {
	    key: "resetFilter",
	    value: function resetFilter() {
	      this.setState({
	        searchString: "",
	        filterByStatus: "all"
	      });
	    }
	  }, {
	    key: "getButtonContent",
	    value: function getButtonContent(filterName, count) {
	      return _react2.default.createElement(
	        "span",
	        { className: "button-align-content badge-container label flush" },
	        _react2.default.createElement(
	          "span",
	          { className: "badge-container-text" },
	          _StringUtil2.default.capitalize(filterName)
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "badge badge-rounded" },
	          count || 0
	        )
	      );
	    }
	  }, {
	    key: "isSchedulerTask",
	    value: function isSchedulerTask(task) {
	      return task.labels.some(function (_ref) {
	        var key = _ref.key;
	        return key === "DCOS_PACKAGE_FRAMEWORK_NAME";
	      });
	    }
	  }, {
	    key: "getStopButtons",
	    value: function getStopButtons() {
	      var _this2 = this;
	
	      var tasks = this.props.tasks;
	      var checkedItems = this.state.checkedItems;
	
	
	      if (!(0, _keys2.default)(checkedItems).length) {
	        return null;
	      }
	
	      // Only allow restarting the task if the service isn't deploying.
	      var isDeploying = (0, _keys2.default)(checkedItems).some(function (taskId) {
	        var service = _DCOSStore2.default.serviceTree.getServiceFromTaskID(taskId);
	
	        return service.getServiceStatus().key === _ServiceStatusTypes2.default.DEPLOYING;
	      });
	
	      var isSDK = (0, _keys2.default)(checkedItems).some(function (taskId) {
	        var service = _DCOSStore2.default.serviceTree.getServiceFromTaskID(taskId);
	
	        return (0, _ServiceUtil.isSDKService)(service);
	      });
	
	      // Only show Stop if a scheduler task isn't selected
	      var hasSchedulerTask = tasks.some(function (task) {
	        return task.id in checkedItems && _this2.isSchedulerTask(task);
	      });
	
	      // Using Button's native "disabled" prop prevents onMouseLeave from
	      // being correctly called, preventing correct dismissal of the Tooltip.
	      //
	      // So we overwrite the click handlers manually.
	      var handleRestartClick = function handleRestartClick() {};
	      var handleStopClick = function handleStopClick() {};
	
	      if (!isDeploying && !isSDK) {
	        handleRestartClick = this.handleActionClick.bind(this, "restart");
	      }
	
	      if (!hasSchedulerTask) {
	        handleStopClick = this.handleActionClick.bind(this, "stop");
	      }
	
	      var restartButtonClasses = (0, _classnames2.default)("button button-link", {
	        disabled: isDeploying || isSDK
	      });
	      var stopButtonClasses = (0, _classnames2.default)("button button-link", {
	        disabled: hasSchedulerTask
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "Restarting tasks is not supported while the service is deploying.",
	            suppress: !isDeploying || isSDK,
	            width: 200,
	            wrapperClassName: "button-group",
	            wrapText: true
	          },
	          _react2.default.createElement(
	            "button",
	            { className: restartButtonClasses, onClick: handleRestartClick },
	            _react2.default.createElement(_Icon2.default, { id: "repeat", size: "mini" }),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Restart"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "Stopping a scheduler task is not supported.",
	            suppress: !hasSchedulerTask,
	            width: 200,
	            wrapText: true,
	            wrapperClassName: "button-group"
	          },
	          _react2.default.createElement(
	            "button",
	            { className: stopButtonClasses, onClick: handleStopClick },
	            _react2.default.createElement(_Icon2.default, { id: "circle-close", size: "mini" }),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Stop"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          inverseStyle = _props2.inverseStyle,
	          tasks = _props2.tasks;
	      var _state2 = this.state,
	          checkedItems = _state2.checkedItems,
	          filterByStatus = _state2.filterByStatus,
	          searchString = _state2.searchString;
	
	      var filteredTasks = this.getFilteredTasks();
	
	      // Get task states based on TaskStates types
	      var taskStates = tasks.map(function (task) {
	        var stateTypes = _TaskStates2.default[task.state].stateTypes;
	
	
	        return stateTypes.find(function (state) {
	          return state === "active" || state === "completed";
	        });
	      });
	
	      var rightAlignLastNChildren = 0;
	      var hasCheckedTasks = (0, _keys2.default)(checkedItems).length !== 0;
	
	      if (hasCheckedTasks) {
	        rightAlignLastNChildren = 1;
	      }
	
	      filteredTasks = _GraphQLTaskUtil2.default.mergeTaskData(filteredTasks);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-container-col flex-grow" },
	        _react2.default.createElement(_FilterHeadline2.default, {
	          currentLength: filteredTasks.length,
	          inverseStyle: inverseStyle,
	          isFiltering: filterByStatus !== "all" || searchString !== "",
	          onReset: this.resetFilter,
	          name: "task",
	          totalLength: tasks.length
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          { rightAlignLastNChildren: rightAlignLastNChildren },
	          _react2.default.createElement(_FilterInputText2.default, {
	            className: "flush-bottom",
	            searchString: searchString,
	            handleFilterChange: this.handleSearchStringChange,
	            inverseStyle: inverseStyle
	          }),
	          _react2.default.createElement(_FilterButtons2.default, {
	            renderButtonContent: this.getButtonContent,
	            filters: STATUS_FILTER_BUTTONS,
	            onFilterChange: this.handleStatusFilterChange,
	            inverseStyle: inverseStyle,
	            itemList: taskStates,
	            selectedFilter: filterByStatus
	          }),
	          this.getStopButtons()
	        ),
	        this.getTaskTable(filteredTasks, checkedItems)
	      );
	    }
	  }]);
	  return TasksView;
	}((0, _reactjsMixin2.default)(_SaveStateMixin2.default));
	
	TasksView.contextTypes = {
	  modalHandlers: _react2.default.PropTypes.shape({
	    killTasks: _react2.default.PropTypes.func.isRequired
	  }).isRequired
	};
	
	TasksView.defaultProps = {
	  inverseStyle: false,
	  itemID: "",
	  tasks: []
	};
	
	TasksView.propTypes = {
	  params: _react2.default.PropTypes.object.isRequired,
	  inverseStyle: _react2.default.PropTypes.bool,
	  itemID: _react2.default.PropTypes.string,
	  tasks: _react2.default.PropTypes.array
	};
	
	module.exports = TasksView;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _UserSettingsStore = __webpack_require__(1337);
	
	var _UserSettingsStore2 = _interopRequireDefault(_UserSettingsStore);
	
	var _UserSettings = __webpack_require__(1336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SaveStateMixin = {
	  componentWillMount: function componentWillMount() {
	    var key = this.saveState_key;
	    if (!key) {
	      return;
	    }
	
	    var savedStates = _UserSettingsStore2.default.getKey(_UserSettings.SAVED_STATE_KEY);
	    if (savedStates == null || savedStates[key] == null) {
	      return;
	    }
	
	    this.setState(savedStates[key]);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.saveState_save();
	  },
	  saveState_save: function saveState_save() {
	    var saveState_key = this.saveState_key,
	        saveState_properties = this.saveState_properties,
	        state = this.state;
	
	    var savedStates = _UserSettingsStore2.default.getKey(_UserSettings.SAVED_STATE_KEY);
	    if (savedStates == null) {
	      savedStates = {};
	    }
	
	    var stateToSave = {};
	    if (saveState_properties) {
	      stateToSave = saveState_properties.reduce(function (newState, property) {
	        newState[property] = state[property];
	
	        return newState;
	      }, {});
	    }
	
	    if ((0, _keys2.default)(stateToSave).length) {
	      savedStates[saveState_key] = stateToSave;
	      _UserSettingsStore2.default.setKey(_UserSettings.SAVED_STATE_KEY, savedStates);
	    } else if (_Config2.default.environment === "development") {
	      console.warn("No state saved. Please set saveState_properties.");
	    }
	  }
	};
	
	module.exports = SaveStateMixin;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _TaskHealthStates = __webpack_require__(1563);
	
	var _TaskHealthStates2 = _interopRequireDefault(_TaskHealthStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTaskHealthFromMesos(task) {
	  if (task.statuses == null) {
	    return null;
	  }
	
	  var healths = task.statuses.map(function (status) {
	    return status.healthy;
	  });
	
	  var healthDataExists = healths.length > 0 && healths.every(function (health) {
	    return typeof health !== "undefined";
	  });
	
	  if (healthDataExists) {
	    return healths.some(function (health) {
	      return health;
	    });
	  }
	
	  return null;
	}
	
	function getTaskHealthFromMarathon(task, taskLookupTable) {
	  var marathonTask = taskLookupTable[task.id];
	
	  if (marathonTask != null) {
	    var healthCheckResults = marathonTask.healthCheckResults;
	
	
	    if (healthCheckResults != null && healthCheckResults.length > 0) {
	      return healthCheckResults.every(function (result) {
	        return result.alive;
	      });
	    }
	  }
	
	  return null;
	}
	
	function mergeHealth(task, taskLookupTable) {
	  var health = _TaskHealthStates2.default.UNKNOWN;
	
	  var taskHealth = getTaskHealthFromMesos(task);
	
	  if (taskHealth === null) {
	    taskHealth = getTaskHealthFromMarathon(task, taskLookupTable);
	  }
	  // task status should only reflect health if taskHealth is defined
	  if (taskHealth === true) {
	    health = _TaskHealthStates2.default.HEALTHY;
	  }
	  if (taskHealth === false) {
	    health = _TaskHealthStates2.default.UNHEALTHY;
	  }
	
	  if (health === _TaskHealthStates2.default.UNKNOWN && task.sdkTask && task.state === "TASK_RUNNING") {
	    health = _TaskHealthStates2.default.HEALTHY;
	  }
	
	  task.health = health;
	
	  return task;
	}
	
	function mergeVersion(task, taskLookupTable) {
	  var marathonTask = taskLookupTable[task.id];
	
	  if (marathonTask) {
	    task.version = marathonTask.version;
	  }
	
	  return task;
	}
	
	function mergeHostname(task) {
	  var node = _CompositeState2.default.getNodesList().filter({
	    ids: [task.slave_id]
	  }).last();
	
	  if (node) {
	    task.hostname = node.hostname;
	  }
	
	  return task;
	}
	
	function mergeData(task, taskLookupTable) {
	  // Merge version from Marathon
	  task = mergeVersion(task, taskLookupTable);
	  // Get Health from Mesos first, and fallback on Marathon
	  task = mergeHealth(task, taskLookupTable);
	  // Merge hostname if we can find it
	  task = mergeHostname(task);
	
	  return task;
	}
	
	function mergeTaskData(tasks) {
	  return tasks.map(function (task) {
	    return mergeData(task, _DCOSStore2.default.taskLookupTable);
	  });
	}
	
	module.exports = {
	  mergeTaskData: mergeTaskData
	};

/***/ },
/* 1563 */
/***/ function(module, exports) {

	"use strict";
	
	var TaskHealthStates = {
	  HEALTHY: "Healthy",
	  UNHEALTHY: "Unhealthy",
	  UNKNOWN: "Unknown"
	};
	
	module.exports = TaskHealthStates;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _CheckboxTable = __webpack_require__(1475);
	
	var _CheckboxTable2 = _interopRequireDefault(_CheckboxTable);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _TaskHealthStates = __webpack_require__(1563);
	
	var _TaskHealthStates2 = _interopRequireDefault(_TaskHealthStates);
	
	var _TaskStates = __webpack_require__(1053);
	
	var _TaskStates2 = _interopRequireDefault(_TaskStates);
	
	var _TaskTableHeaderLabels = __webpack_require__(1565);
	
	var _TaskTableHeaderLabels2 = _interopRequireDefault(_TaskTableHeaderLabels);
	
	var _TaskTableUtil = __webpack_require__(1566);
	
	var _TaskTableUtil2 = _interopRequireDefault(_TaskTableUtil);
	
	var _TaskUtil = __webpack_require__(1503);
	
	var _TaskUtil2 = _interopRequireDefault(_TaskUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableColumnClasses = {
	  checkbox: "task-table-column-checkbox",
	  id: "task-table-column-primary",
	  name: "task-table-column-name",
	  host: "task-table-column-host-address",
	  status: "task-table-column-status",
	  health: "task-table-column-health",
	  logs: "task-table-column-logs",
	  cpus: "task-table-column-cpus",
	  mem: "task-table-column-mem",
	  updated: "task-table-column-updated",
	  version: "task-table-column-version"
	};
	
	var METHODS_TO_BIND = ["getStatusValue", "renderHeadline", "renderHost", "renderLog", "renderStatus", "renderStats", "renderVersion"];
	
	var TaskTable = function (_React$Component) {
	  (0, _inherits3.default)(TaskTable, _React$Component);
	
	  function TaskTable() {
	    (0, _classCallCheck3.default)(this, TaskTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskTable.__proto__ || (0, _getPrototypeOf2.default)(TaskTable)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskTable, [{
	    key: "getStatValue",
	    value: function getStatValue(task, prop) {
	      return task.resources[prop];
	    }
	  }, {
	    key: "getStatusValue",
	    value: function getStatusValue(task) {
	      return _TaskStates2.default[task.state].displayName;
	    }
	  }, {
	    key: "getVersionValue",
	    value: function getVersionValue(task) {
	      return task.version || null;
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)(tableColumnClasses[prop], {
	        highlight: prop === sortBy.prop,
	        clickable: row == null && prop !== "logs" // this is a header
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var _this2 = this;
	
	      var className = this.getClassName;
	      var heading = _ResourceTableUtil2.default.renderHeading(_TaskTableHeaderLabels2.default);
	      var sortFunction = _TaskTableUtil2.default.getSortFunction("id");
	      var getHealthSorting = _TableUtil2.default.getHealthSortingOrder;
	
	      return [{
	        className: className,
	        headerClassName: className,
	        heading: heading,
	        prop: "id",
	        render: this.renderHeadline({ primary: true }),
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: className,
	        headerClassName: className,
	        heading: heading,
	        prop: "name",
	        render: this.renderHeadline({ secondary: true }),
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: className,
	        headerClassName: className,
	        heading: heading,
	        prop: "host",
	        render: this.renderHost,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        cacheCell: false,
	        className: className,
	        getValue: this.getStatusValue,
	        headerClassName: className,
	        heading: heading,
	        prop: "status",
	        render: this.renderStatus,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        cacheCell: false,
	        className: className,
	        getValue: this.getStatusValue,
	        headerClassName: className,
	        heading: heading,
	        prop: "health",
	        render: this.renderHealth,
	        sortable: true,
	        sortFunction: getHealthSorting
	      }, {
	        cacheCell: false,
	        className: className,
	        headerClassName: className,
	        heading: heading,
	        prop: "logs",
	        render: this.renderLog,
	        sortable: false
	      }, {
	        cacheCell: true,
	        className: className,
	        getValue: this.getStatValue,
	        headerClassName: className,
	        heading: heading,
	        prop: "cpus",
	        render: this.renderStats,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        cacheCell: true,
	        className: className,
	        getValue: this.getStatValue,
	        headerClassName: className,
	        heading: heading,
	        prop: "mem",
	        render: this.renderStats,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: className,
	        headerClassName: className,
	        heading: heading,
	        prop: "updated",
	        render: _ResourceTableUtil2.default.renderUpdated,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        cacheCell: true,
	        className: className,
	        getValue: this.getVersionValue,
	        headerClassName: className,
	        heading: heading,
	        prop: "version",
	        render: this.renderVersion,
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("id", function (task) {
	          var version = _this2.getVersionValue(task);
	          if (version == null) {
	            return null;
	          }
	
	          return new Date(version);
	        })
	      }];
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { className: tableColumnClasses.checkbox }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { className: tableColumnClasses.name }),
	        _react2.default.createElement("col", { className: tableColumnClasses.host }),
	        _react2.default.createElement("col", { className: tableColumnClasses.status }),
	        _react2.default.createElement("col", { className: tableColumnClasses.health }),
	        _react2.default.createElement("col", { className: tableColumnClasses.logs }),
	        _react2.default.createElement("col", { className: tableColumnClasses.cpus }),
	        _react2.default.createElement("col", { className: tableColumnClasses.mem }),
	        _react2.default.createElement("col", { className: tableColumnClasses.updated }),
	        _react2.default.createElement("col", { className: tableColumnClasses.version })
	      );
	    }
	  }, {
	    key: "getDisabledItemsMap",
	    value: function getDisabledItemsMap(tasks) {
	      return tasks.filter(function (task) {
	        return task.state !== "TASK_UNREACHABLE" && (_TaskStates2.default[task.state].stateTypes.includes("completed") || !task.isStartedByMarathon);
	      }).reduce(function (acc, task) {
	        acc[task.id] = true;
	
	        return acc;
	      }, {});
	    }
	  }, {
	    key: "getInactiveItemsMap",
	    value: function getInactiveItemsMap(tasks) {
	      return tasks.reduce(function (acc, task) {
	        if (_TaskStates2.default[task.state].stateTypes.includes("completed")) {
	          acc[task.id] = true;
	        }
	
	        return acc;
	      }, {});
	    }
	  }, {
	    key: "renderHeadline",
	    value: function renderHeadline(options) {
	      var _this3 = this;
	
	      var anchorClasses = (0, _classnames2.default)("text-overflow", {
	        "table-cell-link-primary": options.primary,
	        "table-cell-link-secondary": options.secondary
	      });
	
	      return function (prop, task) {
	        var title = task[prop];
	        var _props$params = _this3.props.params,
	            id = _props$params.id,
	            nodeID = _props$params.nodeID;
	
	
	        var linkTo = "/services/detail/" + encodeURIComponent(id) + "/tasks/" + task.id;
	        if (nodeID != null) {
	          linkTo = "/nodes/" + nodeID + "/tasks/" + task.id;
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { className: "flex-box flex-box-align-vertical-center table-cell-flex-box" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-cell-value flex-box flex-box-col" },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { className: anchorClasses, to: linkTo, title: title },
	              title
	            )
	          )
	        );
	      };
	    }
	  }, {
	    key: "renderLog",
	    value: function renderLog(prop, task) {
	      var title = task.name || task.id;
	      var _props$params2 = this.props.params,
	          id = _props$params2.id,
	          nodeID = _props$params2.nodeID;
	
	
	      var linkTo = "/services/detail/" + encodeURIComponent(id) + "/tasks/" + task.id + "/logs";
	      if (nodeID != null) {
	        linkTo = "/nodes/" + nodeID + "/tasks/" + task.id + "/logs";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-box flex-box-align-vertical-center table-cell-flex-box flex-align-items-center flex-direction-top-to-bottom" },
	        _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "View logs",
	            wrapperClassName: "tooltip-wrapper text-align-center description"
	          },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: linkTo, title: title },
	            _react2.default.createElement(_Icon2.default, { color: "grey", id: "page-document", size: "mini" })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderHost",
	    value: function renderHost(prop, task) {
	      if (!task.hostname) {
	        return "N/A";
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	          className: "table-cell-link-secondary text-overflow",
	          to: "/nodes/" + task.slave_id,
	          title: task.hostname
	        },
	        task.hostname
	      );
	    }
	  }, {
	    key: "renderStats",
	    value: function renderStats(prop, task) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _Units2.default.formatResource(prop, this.getStatValue(task, prop))
	      );
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus(prop, task) {
	      var statusClassName = _TaskUtil2.default.getTaskStatusClassName(task);
	      var statusLabelClasses = statusClassName + " table-cell-value";
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-box flex-box-align-vertical-center table-cell-flex-box" },
	        _react2.default.createElement(
	          "span",
	          { className: statusLabelClasses },
	          this.getStatusValue(task)
	        )
	      );
	    }
	  }, {
	    key: "renderHealth",
	    value: function renderHealth(prop, task) {
	      var state = task.state;
	
	
	      var dangerState = _TaskStates2.default[state].stateTypes.includes("failure");
	      var activeState = _TaskStates2.default[state].stateTypes.includes("active");
	      var transitional = ["TASK_KILLING", "TASK_STARTING", "TASK_STAGING"].includes(state);
	
	      var healthy = task.health === _TaskHealthStates2.default.HEALTHY;
	      var unhealthy = task.health === _TaskHealthStates2.default.UNHEALTHY;
	      var unknown = task.health === _TaskHealthStates2.default.UNKNOWN;
	
	      var tooltipContent = _TaskHealthStates2.default.HEALTHY;
	
	      if (unhealthy) {
	        tooltipContent = _TaskHealthStates2.default.UNHEALTHY;
	      }
	
	      if (!activeState || unknown || transitional) {
	        tooltipContent = "No health checks available";
	      }
	
	      var failing = ["TASK_ERROR", "TASK_FAILED"].includes(state);
	      var running = ["TASK_RUNNING", "TASK_STARTING"].includes(state);
	
	      var statusClass = (0, _classnames2.default)({
	        dot: true,
	        flush: true,
	        inactive: !activeState || transitional,
	        success: healthy && running,
	        running: unknown && running,
	        danger: dangerState || unhealthy || failing
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-box flex-box-align-vertical-center table-cell-flex-box flex-align-items-center flex-direction-top-to-bottom" },
	        _react2.default.createElement(
	          "div",
	          { className: "table-cell-icon table-cell-task-dot task-status-indicator" },
	          _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            { anchor: "center", content: tooltipContent },
	            _react2.default.createElement("span", { className: statusClass })
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderVersion",
	    value: function renderVersion(prop, task) {
	      var version = this.getVersionValue(task);
	
	      if (version == null) {
	        return null;
	      }
	
	      var localeVersion = new Date(version).toLocaleString();
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        localeVersion
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          checkedItemsMap = _props.checkedItemsMap,
	          className = _props.className,
	          onCheckboxChange = _props.onCheckboxChange,
	          tasks = _props.tasks;
	
	
	      return _react2.default.createElement(_CheckboxTable2.default, {
	        checkedItemsMap: checkedItemsMap,
	        className: className,
	        columns: this.getColumns(),
	        data: tasks.slice(),
	        disabledItemsMap: this.getDisabledItemsMap(tasks),
	        inactiveItemsMap: this.getInactiveItemsMap(tasks),
	        getColGroup: this.getColGroup,
	        onCheckboxChange: onCheckboxChange,
	        sortBy: { prop: "updated", order: "desc" },
	        sortOrder: "desc",
	        sortProp: "updated",
	        uniqueProperty: "id"
	      });
	    }
	  }]);
	  return TaskTable;
	}(_react2.default.Component);
	
	TaskTable.contextTypes = {
	  router: _reactRouter.routerShape.isRequired
	};
	
	TaskTable.propTypes = {
	  checkedItemsMap: _react2.default.PropTypes.object,
	  className: _react2.default.PropTypes.string,
	  onCheckboxChange: _react2.default.PropTypes.func,
	  params: _react2.default.PropTypes.object.isRequired,
	  tasks: _react2.default.PropTypes.array.isRequired
	};
	
	TaskTable.defaultProps = {
	  className: "table table-borderless-outer table-borderless-inner-columns flush-bottom",
	  tasks: []
	};
	
	module.exports = TaskTable;

/***/ },
/* 1565 */
/***/ function(module, exports) {

	"use strict";
	
	var TaskTableHeaderLabels = {
	  cpus: "CPU",
	  disk: "DISK",
	  host: "HOST",
	  mem: "MEM",
	  id: "ID",
	  name: "NAME",
	  status: "STATUS",
	  health: "HEALTH",
	  updated: "UPDATED",
	  version: "VERSION"
	};
	
	module.exports = TaskTableHeaderLabels;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _TaskStatusSortingOrder = __webpack_require__(1567);
	
	var _TaskStatusSortingOrder2 = _interopRequireDefault(_TaskStatusSortingOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	function getUpdatedTimestamp(model) {
	  var lastStatus = _Util2.default.last(model.statuses);
	
	  return lastStatus && lastStatus.timestamp || null;
	}
	/* eslint-enable no-unused-vars */
	
	
	var TaskTableUtil = {
	  getSortFunction: function getSortFunction(tieBreakerProp) {
	    return _TableUtil2.default.getSortFunction(tieBreakerProp, function (item, prop) {
	      var hasGetter = typeof item.get === "function";
	
	      if (prop === "updated") {
	        return getUpdatedTimestamp(item) || 0;
	      }
	
	      if (prop === "status" && !hasGetter) {
	        return _TaskStatusSortingOrder2.default[item.state];
	      }
	
	      if (prop === "cpus" || prop === "mem" || prop === "disk") {
	        // This is necessary for tasks, since they are not structs
	        var value = item[prop];
	
	        if (!value && hasGetter) {
	          value = item.get(prop);
	        }
	
	        if (item.getUsageStats) {
	          value = item.getUsageStats(prop).value;
	        }
	
	        if (_Util2.default.findNestedPropertyInObject(item, "resources." + prop)) {
	          value = item.resources[prop];
	        }
	
	        if (Array.isArray(value)) {
	          return _Util2.default.last(value).value;
	        }
	
	        return value;
	      }
	
	      // This is necessary for tasks, since they are not structs
	      if (!hasGetter) {
	        return item[prop];
	      }
	
	      return item.get(prop);
	    });
	  }
	};
	
	module.exports = TaskTableUtil;

/***/ },
/* 1567 */
/***/ function(module, exports) {

	"use strict";
	
	var TaskStatusSorting = {
	  TASK_RUNNING: 0,
	  TASK_STAGING: 1,
	  TASK_FAILED: 2,
	  TASK_ERROR: 3,
	  TASK_KILLED: 4,
	  TASK_KILLING: 5,
	  TASK_FINISHED: 6,
	  TASK_LOST: 7,
	  TASK_UNREACHABLE: 8,
	  TASK_GONE_BY_OPERATOR: 9,
	  TASK_GONE: 10,
	  TASK_CREATED: 11,
	  TASK_STARTED: 12,
	  TASK_DROPPED: 13,
	  TASK_STARTING: 14,
	  TASK_UNKNOWN: 15
	};
	
	module.exports = TaskStatusSorting;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _QueryParamsMixin = __webpack_require__(1569);
	
	var _QueryParamsMixin2 = _interopRequireDefault(_QueryParamsMixin);
	
	var _NodesGridView = __webpack_require__(1570);
	
	var _NodesGridView2 = _interopRequireDefault(_NodesGridView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_SERVICES_TO_SHOW = 32;
	var METHODS_TO_BIND = ["handleShowServices"];
	var OTHER_SERVICES_COLOR = 32;
	
	var NodesGridContainer = function (_mixin) {
	  (0, _inherits3.default)(NodesGridContainer, _mixin);
	
	  function NodesGridContainer() {
	    (0, _classCallCheck3.default)(this, NodesGridContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodesGridContainer.__proto__ || (0, _getPrototypeOf2.default)(NodesGridContainer)).apply(this, arguments));
	
	    _this.state = {
	      filteredNodes: [],
	      filters: { health: "all", name: "", service: null },
	      hasLoadingError: false,
	      hiddenServices: [],
	      mesosStateErrorCount: 0,
	      receivedEmptyMesosState: true,
	      receivedNodeHealthResponse: false,
	      resourcesByFramework: {},
	      serviceColors: {},
	      showServices: false
	    };
	    _this.store_listeners = [{
	      events: ["success"],
	      listenAlways: false,
	      name: "nodeHealth",
	      suppressUpdate: true
	    }, {
	      events: ["success", "error"],
	      name: "state",
	      suppressUpdate: true
	    }];
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodesGridContainer, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(props) {
	      var services = props.services,
	          query = props.location.query;
	
	      var ids = services.map(function (service) {
	        return service.id;
	      });
	
	      var serviceColors = this.state.serviceColors;
	
	
	      if (!(0, _deepEqual2.default)((0, _keys2.default)(serviceColors), ids)) {
	        this.computeServiceColors(services);
	        this.computeShownServices(services);
	      }
	
	      var filters = {
	        health: query.filterHealth || "all",
	        name: query.searchString || "",
	        service: query.filterService || null
	      };
	      this.setFilters(filters);
	    }
	  }, {
	    key: "computeServiceColors",
	    value: function computeServiceColors(services) {
	      var colors = {};
	
	      services.forEach(function (service, index) {
	        // Drop all others into the same 'other' color
	        if (index < MAX_SERVICES_TO_SHOW) {
	          colors[service.id] = index;
	        } else {
	          colors.other = OTHER_SERVICES_COLOR;
	        }
	      });
	
	      this.setState({ serviceColors: colors });
	    }
	  }, {
	    key: "computeShownServices",
	    value: function computeShownServices(services) {
	      var hidden = services.slice(MAX_SERVICES_TO_SHOW).map(function (service) {
	        return service.id;
	      });
	
	      this.setState({ hiddenServices: hidden });
	    }
	  }, {
	    key: "getFilteredNodes",
	    value: function getFilteredNodes() {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.filters;
	
	      return _CompositeState2.default.getNodesList().filter(filters).getItems();
	    }
	  }, {
	    key: "setFilters",
	    value: function setFilters(newFilters, callback) {
	      if (newFilters.service === "") {
	        newFilters.service = null;
	      }
	      var filters = (0, _assign2.default)({}, this.state.filters, newFilters);
	      var filteredNodes = this.getFilteredNodes(filters);
	
	      this.setState({ filters: filters, filteredNodes: filteredNodes }, callback);
	    }
	  }, {
	    key: "handleShowServices",
	    value: function handleShowServices(value) {
	      this.setState({ showServices: value });
	    }
	  }, {
	    key: "onStateStoreSuccess",
	    value: function onStateStoreSuccess() {
	      var hiddenServices = this.state.hiddenServices;
	
	      var resourcesByFramework = _MesosStateStore2.default.getHostResourcesByFramework(hiddenServices);
	      var receivedEmptyMesosState = (0, _keys2.default)(_MesosStateStore2.default.get("lastMesosState")).length === 0;
	      this.setState({ resourcesByFramework: resourcesByFramework, receivedEmptyMesosState: receivedEmptyMesosState });
	    }
	  }, {
	    key: "onStateStoreError",
	    value: function onStateStoreError() {
	      var mesosStateErrorCount = this.state.mesosStateErrorCount + 1;
	      if (mesosStateErrorCount > 3) {
	        this.setState({ mesosStateErrorCount: mesosStateErrorCount, hasLoadingError: true });
	      } else {
	        this.setState({ mesosStateErrorCount: mesosStateErrorCount });
	      }
	    }
	  }, {
	    key: "onNodeHealthStoreSuccess",
	    value: function onNodeHealthStoreSuccess() {
	      this.setState({
	        filteredNodes: this.getFilteredNodes(),
	        receivedNodeHealthResponse: true
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          filteredNodes = _state.filteredNodes,
	          hasLoadingError = _state.hasLoadingError,
	          hiddenServices = _state.hiddenServices,
	          receivedEmptyMesosState = _state.receivedEmptyMesosState,
	          receivedNodeHealthResponse = _state.receivedNodeHealthResponse,
	          resourcesByFramework = _state.resourcesByFramework,
	          serviceColors = _state.serviceColors,
	          showServices = _state.showServices;
	      var _props = this.props,
	          services = _props.services,
	          selectedResource = _props.selectedResource;
	
	
	      return _react2.default.createElement(_NodesGridView2.default, {
	        hasLoadingError: hasLoadingError,
	        hiddenServices: hiddenServices,
	        hosts: filteredNodes,
	        receivedEmptyMesosState: receivedEmptyMesosState,
	        receivedNodeHealthResponse: receivedNodeHealthResponse,
	        onShowServices: this.handleShowServices,
	        resourcesByFramework: resourcesByFramework,
	        selectedResource: selectedResource,
	        serviceColors: serviceColors,
	        services: services,
	        showServices: showServices
	      });
	    }
	  }]);
	  return NodesGridContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _QueryParamsMixin2.default));
	
	NodesGridContainer.contextTypes = {
	  router: _reactRouter.routerShape.isRequired,
	  selectedResource: _react2.default.PropTypes.string
	};
	
	module.exports = NodesGridContainer;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _reactRouter = __webpack_require__(785);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function encodeValuesToURIComponents(values) {
	  if (!Array.isArray(values)) {
	    return encodeURIComponent(values);
	  }
	
	  return values.map(function (param) {
	    // Replace commas for nested arrays with semi-colon
	    return encodeURIComponent(param).replace(/%2C/g, ";");
	  });
	}
	
	var QueryParamsMixin = {
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  getCurrentPathname: function getCurrentPathname() {
	    var pathname = this.props.location.pathname;
	
	
	    return pathname || {};
	  },
	  getQueryParamObject: function getQueryParamObject() {
	    var query = this.props.location.query;
	
	
	    return query || {};
	  },
	  resetQueryParams: function resetQueryParams(params) {
	    var router = this.context.router;
	
	    if (!router) {
	      return;
	    }
	
	    var location = this.props.location;
	
	    var query = (0, _assign2.default)({}, location.query);
	
	    if (params == null) {
	      params = (0, _keys2.default)(query);
	    }
	
	    params.forEach(function (param) {
	      delete query[param];
	    });
	
	    router.push({ pathname: location.pathname, query: query });
	  },
	  setQueryParam: function setQueryParam(paramKey, paramValue) {
	    var router = this.context.router;
	    var location = this.props.location;
	
	    var query = (0, _assign2.default)({}, location.query);
	
	    if (paramValue != null && paramValue.length !== 0) {
	      var encodedFilter = encodeValuesToURIComponents(paramValue);
	
	      query = (0, _assign2.default)(query, (0, _defineProperty3.default)({}, paramKey, encodedFilter));
	    } else {
	      delete query[paramKey];
	    }
	
	    router.push({ pathname: location.pathname, query: query });
	  },
	  decodeQueryParamArray: function decodeQueryParamArray(array) {
	    return array.split(";").map(function (segment) {
	      return decodeURIComponent(segment);
	    });
	  }
	};
	
	module.exports = QueryParamsMixin;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _NodesGridDials = __webpack_require__(1571);
	
	var _NodesGridDials2 = _interopRequireDefault(_NodesGridDials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_SERVICES_TO_SHOW = 32;
	var OTHER_SERVICES_COLOR = 32;
	
	var NodesGridView = _react2.default.createClass({
	  displayName: "NodesGridView",
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  propTypes: {
	    hasLoadingError: _react2.default.PropTypes.bool,
	    hiddenServices: _react2.default.PropTypes.array,
	    hosts: _react2.default.PropTypes.array.isRequired,
	    receivedEmptyMesosState: _react2.default.PropTypes.bool,
	    receivedNodeHealthResponse: _react2.default.PropTypes.bool,
	    onShowServices: _react2.default.PropTypes.func.isRequired,
	    resourcesByFramework: _react2.default.PropTypes.object.isRequired,
	    selectedResource: _react2.default.PropTypes.string.isRequired,
	    serviceColors: _react2.default.PropTypes.object.isRequired,
	    services: _react2.default.PropTypes.array.isRequired,
	    showServices: _react2.default.PropTypes.bool
	  },
	
	  defaultProps: {
	    hasLoadingError: false,
	    hiddenServices: [],
	    receivedNodeHealthResponse: false,
	    showServices: false
	  },
	
	  handleCheckboxChange: function handleCheckboxChange(model) {
	    this.props.onShowServices(model.showServices);
	  },
	  getLoadingScreen: function getLoadingScreen() {
	    var hasLoadingError = this.props.hasLoadingError;
	
	    var errorMsg = null;
	    if (hasLoadingError) {
	      errorMsg = _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	
	    var loadingClassSet = (0, _classnames2.default)({
	      hidden: hasLoadingError
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "pod flush-left flush-right" },
	      _react2.default.createElement(_Loader2.default, { className: loadingClassSet }),
	      errorMsg
	    );
	  },
	  getActiveServiceIds: function getActiveServiceIds() {
	    return this.props.services.map(function (service) {
	      return service.getId();
	    });
	  },
	  getServicesList: function getServicesList(props) {
	    // Return a list of unique service IDs from the selected hosts.
	    var activeServiceIds = this.getActiveServiceIds();
	
	    // Filter out inactive services
	    var items = props.services.filter(function (service) {
	      return activeServiceIds.includes(service.id);
	    })
	    // Limit to max amount
	    .slice(0, MAX_SERVICES_TO_SHOW)
	    // Return view definition
	    .map(function (service) {
	      var color = props.serviceColors[service.id];
	      var className = "dot service-color-" + color;
	
	      return _react2.default.createElement(
	        "li",
	        { key: service.id },
	        _react2.default.createElement("span", { className: className }),
	        _react2.default.createElement(
	          "span",
	          null,
	          service.name
	        )
	      );
	    });
	
	    // Add 'Others' node to the list
	    if (activeServiceIds.length > MAX_SERVICES_TO_SHOW) {
	      var classNameOther = "service-legend-color service-color-" + OTHER_SERVICES_COLOR;
	      items.push(_react2.default.createElement(
	        "li",
	        { key: "other" },
	        _react2.default.createElement("span", { className: classNameOther }),
	        _react2.default.createElement(
	          "span",
	          null,
	          "Other"
	        )
	      ));
	    }
	
	    return _react2.default.createElement(
	      "ul",
	      { className: "list list-unstyled nodes-grid-service-list" },
	      items
	    );
	  },
	  getNodesGrid: function getNodesGrid() {
	    var props = this.props;
	
	
	    var classSet = (0, _classnames2.default)({
	      "side-list nodes-grid-legend": true,
	      disabled: !props.showServices
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "nodes-grid" },
	      _react2.default.createElement(
	        "div",
	        { className: classSet },
	        _react2.default.createElement(
	          "label",
	          { className: "show-services-label h5 tall flush-top" },
	          _react2.default.createElement(_reactjsComponents.Form, {
	            definition: [{
	              fieldType: "checkbox",
	              name: "showServices",
	              checked: props.showServices,
	              label: "Show Services by Share",
	              value: props.showServices
	            }],
	            onChange: this.handleCheckboxChange
	          })
	        ),
	        this.getServicesList(props)
	      ),
	      _react2.default.createElement(_NodesGridDials2.default, {
	        hosts: props.hosts,
	        resourcesByFramework: props.resourcesByFramework,
	        selectedResource: props.selectedResource,
	        serviceColors: props.serviceColors,
	        showServices: props.showServices
	      })
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        hasLoadingError = _props.hasLoadingError,
	        receivedEmptyMesosState = _props.receivedEmptyMesosState,
	        receivedNodeHealthResponse = _props.receivedNodeHealthResponse;
	
	
	    if (hasLoadingError || receivedEmptyMesosState || !receivedNodeHealthResponse) {
	      return this.getLoadingScreen();
	    } else {
	      return this.getNodesGrid();
	    }
	  }
	});
	
	module.exports = NodesGridView;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _DialChart = __webpack_require__(1405);
	
	var _DialChart2 = _interopRequireDefault(_DialChart);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ResourcesUtil = __webpack_require__(1500);
	
	var _ResourcesUtil2 = _interopRequireDefault(_ResourcesUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = {
	  error: 2,
	  unused: "unused"
	};
	
	var NodesGridDials = _react2.default.createClass({
	  displayName: "NodesGridDials",
	
	  propTypes: {
	    hosts: _react2.default.PropTypes.array.isRequired,
	    selectedResource: _react2.default.PropTypes.string.isRequired,
	    serviceColors: _react2.default.PropTypes.object.isRequired,
	    showServices: _react2.default.PropTypes.bool.isRequired,
	    resourcesByFramework: _react2.default.PropTypes.object.isRequired
	  },
	
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  handleDialClick: function handleDialClick(nodeID) {
	    // Using handler, since Link in arrays cannot get router context
	    this.context.router.push("/nodes/" + nodeID);
	  },
	  getServiceSlicesConfig: function getServiceSlicesConfig(node) {
	    var config = [];
	    var props = this.props;
	    var resourcesByFramework = props.resourcesByFramework[node.get("id")];
	
	    if (!resourcesByFramework) {
	      return config;
	    }
	
	    (0, _keys2.default)(resourcesByFramework).forEach(function (frameworkID) {
	      var percentage = resourcesByFramework[frameworkID][props.selectedResource] * 100;
	      percentage /= node.getUsageStats(props.selectedResource).total;
	
	      config.push({
	        colorIndex: props.serviceColors[frameworkID],
	        name: frameworkID,
	        percentage: percentage
	      });
	    });
	
	    return config;
	  },
	  getUsedSliceConfig: function getUsedSliceConfig(node) {
	    var selectedResource = this.props.selectedResource;
	
	    var colorIndex = _ResourcesUtil2.default.getResourceColor(selectedResource);
	    var label = _ResourcesUtil2.default.getResourceLabel(selectedResource);
	    var serviceSlices = this.getServiceSlicesConfig(node);
	    var percentage;
	
	    if (serviceSlices.length > 0) {
	      percentage = serviceSlices.reduce(function (memo, slice) {
	        return memo + slice.percentage;
	      }, 0);
	    } else {
	      percentage = node.getUsageStats(selectedResource).percentage;
	    }
	
	    return [{
	      colorIndex: colorIndex,
	      name: label,
	      percentage: percentage
	    }];
	  },
	  getActiveSliceData: function getActiveSliceData(node) {
	    var config;
	    var props = this.props;
	
	    if (props.showServices) {
	      config = this.getServiceSlicesConfig(node);
	    } else {
	      config = this.getUsedSliceConfig(node);
	    }
	
	    var percentage = config.reduce(function (memo, slice) {
	      memo += slice.percentage;
	
	      return memo;
	    }, 0);
	    percentage = Math.round(percentage);
	
	    config.push({
	      colorIndex: colors.unused,
	      name: "Unused",
	      percentage: 100 - percentage
	    });
	
	    return {
	      data: config,
	      usedPercentage: percentage
	    };
	  },
	  getInactiveSliceData: function getInactiveSliceData() {
	    return [{
	      colorIndex: colors.error,
	      name: "Error",
	      percentage: 100
	    }];
	  },
	  getDialConfig: function getDialConfig(node) {
	    var selectedResource = this.props.selectedResource;
	
	    var resourceLabel = _ResourcesUtil2.default.getResourceLabel(selectedResource);
	
	    if (node.isActive()) {
	      var sliceData = this.getActiveSliceData(node);
	
	      return {
	        data: sliceData.data,
	        description: [_react2.default.createElement(
	          "span",
	          { className: "unit", key: "unit" },
	          sliceData.usedPercentage,
	          "%"
	        ), _react2.default.createElement(
	          "span",
	          { className: "unit-label text-muted", key: "unit-label" },
	          resourceLabel
	        )]
	      };
	    } else {
	      return {
	        data: this.getInactiveSliceData(),
	        description: _react2.default.createElement(
	          "span",
	          { className: "error" },
	          _react2.default.createElement(_Icon2.default, { id: "yield", className: "icon-alert", color: "neutral" })
	        )
	      };
	    }
	  },
	  getDials: function getDials() {
	    var _this = this;
	
	    return this.props.hosts.map(function (node) {
	      var config = _this.getDialConfig(node);
	      var description = _react2.default.createElement(
	        "div",
	        { className: "description" },
	        config.description
	      );
	
	      if (!node.isActive()) {
	        description = _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "Connection to node lost",
	            wrapperClassName: "tooltip-wrapper text-align-center description"
	          },
	          config.description
	        );
	      }
	
	      return _react2.default.createElement(
	        "a",
	        {
	          className: "nodes-grid-dials-item clickable",
	          onClick: _this.handleDialClick.bind(_this, node.get("id")),
	          key: node.get("id")
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "chart" },
	          _react2.default.createElement(
	            _Chart2.default,
	            {
	              calcHeight: function calcHeight(w) {
	                return w;
	              }
	            },
	            _react2.default.createElement(
	              _DialChart2.default,
	              { data: config.data, value: "percentage" },
	              description
	            )
	          )
	        )
	      );
	    });
	  },
	
	
	  // Zero-height spacer items force dial charts in the last line of the flex layout
	  // not to spread themselves across the line.
	  getSpacers: function getSpacers() {
	    return Array(30).fill().map(function (v, index) {
	      return _react2.default.createElement("div", { className: "nodes-grid-dials-spacer", key: index });
	    });
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "nodes-grid-dials" },
	      this.getDials(),
	      this.getSpacers()
	    );
	  }
	});
	
	module.exports = NodesGridDials;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _MesosSummaryStore = __webpack_require__(1047);
	
	var _MesosSummaryStore2 = _interopRequireDefault(_MesosSummaryStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _QueryParamsMixin = __webpack_require__(1569);
	
	var _QueryParamsMixin2 = _interopRequireDefault(_QueryParamsMixin);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _HostsPageContent = __webpack_require__(1573);
	
	var _HostsPageContent2 = _interopRequireDefault(_HostsPageContent);
	
	var _NodeBreadcrumbs = __webpack_require__(1549);
	
	var _NodeBreadcrumbs2 = _interopRequireDefault(_NodeBreadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NODES_DISPLAY_LIMIT = 300;
	
	function getMesosHosts(state) {
	  var states = _MesosSummaryStore2.default.get("states");
	  var lastState = states.lastSuccessful();
	  var nodes = _CompositeState2.default.getNodesList();
	
	  var byServiceFilter = state.byServiceFilter,
	      healthFilter = state.healthFilter,
	      searchString = state.searchString;
	
	  var filteredNodes = nodes.filter({
	    service: byServiceFilter,
	    name: searchString,
	    health: healthFilter
	  }).getItems();
	  var nodeIDs = filteredNodes.map(function (node) {
	    return node.id;
	  });
	
	  return {
	    nodes: filteredNodes,
	    refreshRate: _Config2.default.getRefreshRate(),
	    services: lastState.getServiceList().getItems(),
	    totalHostsResources: states.getResourceStatesForNodeIDs(nodeIDs),
	    totalNodes: nodes.getItems().length,
	    totalResources: lastState.getSlaveTotalResources()
	  };
	}
	
	var DEFAULT_FILTER_OPTIONS = {
	  byServiceFilter: null,
	  healthFilter: "all",
	  searchString: ""
	};
	
	var NodesOverview = _react2.default.createClass({
	  displayName: "NodesOverview",
	
	  mixins: [_InternalStorageMixin2.default, _QueryParamsMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  statics: {
	    routeConfig: {
	      label: "Nodes",
	      icon: _react2.default.createElement(_Icon2.default, { family: "product", id: "servers-inverse" }),
	      matches: /^\/nodes/
	    },
	    // Static life cycle method from react router, that will be called
	    // 'when a handler is about to render', i.e. on route change:
	    // https://github.com/rackt/react-router/
	    // blob/master/docs/api/components/RouteHandler.md
	    willTransitionTo: function willTransitionTo() {
	      _SidebarActions2.default.close();
	    }
	  },
	
	  contextTypes: {
	    router: _reactRouter.routerShape.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return (0, _assign2.default)({ selectedResource: "cpus" }, DEFAULT_FILTER_OPTIONS);
	  },
	  componentWillMount: function componentWillMount() {
	    this.internalStorage_set(getMesosHosts(this.state));
	    this.internalStorage_update({
	      openNodePanel: false,
	      openTaskPanel: false
	    });
	
	    this.store_listeners = [{
	      name: "nodeHealth",
	      events: ["success", "error"]
	    }];
	  },
	  componentDidMount: function componentDidMount() {
	    _MesosSummaryStore2.default.addChangeListener(_EventTypes2.default.MESOS_SUMMARY_CHANGE, this.onMesosStateChange);
	
	    _MesosSummaryStore2.default.addChangeListener(_EventTypes2.default.MESOS_SUMMARY_REQUEST_ERROR, this.onMesosStateChange);
	
	    this.internalStorage_update({
	      openNodePanel: this.props.params.nodeID != null,
	      openTaskPanel: this.props.params.taskID != null
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.internalStorage_update({
	      openNodePanel: nextProps.params.nodeID != null,
	      openTaskPanel: nextProps.params.taskID != null
	    });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _MesosSummaryStore2.default.removeChangeListener(_EventTypes2.default.MESOS_SUMMARY_CHANGE, this.onMesosStateChange);
	
	    _MesosSummaryStore2.default.removeChangeListener(_EventTypes2.default.MESOS_SUMMARY_REQUEST_ERROR, this.onMesosStateChange);
	  },
	  onMesosStateChange: function onMesosStateChange() {
	    this.internalStorage_update(getMesosHosts(this.state));
	    this.forceUpdate();
	  },
	  resetFilter: function resetFilter() {
	    var state = (0, _assign2.default)({}, DEFAULT_FILTER_OPTIONS);
	
	    this.setState(state);
	    this.internalStorage_update(getMesosHosts(state));
	
	    this.resetQueryParams(["searchString", "filterService", "filterHealth"]);
	  },
	  handleSearchStringChange: function handleSearchStringChange() {
	    var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    var stateChanges = (0, _assign2.default)({}, this.state, {
	      searchString: searchString
	    });
	
	    this.internalStorage_update(getMesosHosts(stateChanges));
	    this.setState({ searchString: searchString });
	    this.setQueryParam("searchString", searchString);
	  },
	  handleByServiceFilterChange: function handleByServiceFilterChange(byServiceFilter) {
	    if (byServiceFilter === "") {
	      byServiceFilter = null;
	    }
	
	    var stateChanges = (0, _assign2.default)({}, this.state, {
	      byServiceFilter: byServiceFilter
	    });
	
	    this.internalStorage_update(getMesosHosts(stateChanges));
	    this.setState({ byServiceFilter: byServiceFilter });
	    this.setQueryParam("filterService", byServiceFilter);
	  },
	  handleHealthFilterChange: function handleHealthFilterChange(healthFilter) {
	    this.internalStorage_update(getMesosHosts({ healthFilter: healthFilter }));
	    this.setState({ healthFilter: healthFilter });
	    this.setQueryParam("filterHealth", healthFilter);
	  },
	  onResourceSelectionChange: function onResourceSelectionChange(selectedResource) {
	    if (this.state.selectedResource !== selectedResource) {
	      this.setState({ selectedResource: selectedResource });
	    }
	  },
	  getButtonContent: function getButtonContent(filterName, count) {
	    var dotClassSet = (0, _classnames2.default)({
	      dot: filterName !== "all",
	      danger: filterName === "unhealthy",
	      success: filterName === "healthy"
	    });
	
	    return _react2.default.createElement(
	      "span",
	      { className: "badge-container button-align-content label flush" },
	      _react2.default.createElement("span", { className: dotClassSet }),
	      _react2.default.createElement(
	        "span",
	        { className: "badge-container-text" },
	        _react2.default.createElement(
	          "span",
	          null,
	          _StringUtil2.default.capitalize(filterName)
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "badge badge-rounded" },
	        count || 0
	      )
	    );
	  },
	  getFilterInputText: function getFilterInputText() {
	    var isVisible = this.props.location.pathname.endsWith("/nodes/");
	
	    if (!isVisible) {
	      return null;
	    }
	
	    return _react2.default.createElement(_FilterInputText2.default, {
	      className: "flush-bottom",
	      searchString: this.state.searchString,
	      handleFilterChange: this.handleSearchStringChange
	    });
	  },
	  getViewTypeRadioButtons: function getViewTypeRadioButtons(resetFilter) {
	    var isGridActive = /\/nodes\/grid\/?/i.test(this.props.location.pathname);
	
	    var listClassSet = (0, _classnames2.default)("button button-stroke", {
	      active: !isGridActive
	    });
	
	    var gridClassSet = (0, _classnames2.default)("button button-stroke", {
	      active: isGridActive
	    });
	
	    return _react2.default.createElement(
	      "div",
	      { className: "button-group flush-bottom" },
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { className: listClassSet, onClick: resetFilter, to: "/nodes" },
	        "List"
	      ),
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { className: gridClassSet, onClick: resetFilter, to: "/nodes/grid" },
	        "Grid"
	      )
	    );
	  },
	  getHostsPageContent: function getHostsPageContent() {
	    var _state = this.state,
	        byServiceFilter = _state.byServiceFilter,
	        healthFilter = _state.healthFilter,
	        searchString = _state.searchString,
	        selectedResource = _state.selectedResource;
	
	    var data = this.internalStorage_get();
	    var nodes = data.nodes || [];
	    var nodesList = nodes.slice(0, NODES_DISPLAY_LIMIT);
	    var nodesHealth = _CompositeState2.default.getNodesList().getItems().map(function (node) {
	      return node.getHealth();
	    });
	    var isFiltering = byServiceFilter !== null || healthFilter !== "all" || searchString !== "";
	
	    return _react2.default.createElement(
	      _Page2.default,
	      null,
	      _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(_NodeBreadcrumbs2.default, null) }),
	      _react2.default.createElement(
	        _HostsPageContent2.default,
	        {
	          byServiceFilter: byServiceFilter,
	          filterButtonContent: this.getButtonContent,
	          filterInputText: this.getFilterInputText(),
	          filterItemList: nodesHealth,
	          filteredNodeCount: nodesList.length,
	          handleFilterChange: this.handleByServiceFilterChange,
	          hosts: nodesList,
	          isFiltering: isFiltering,
	          nodeCount: data.nodes.length,
	          onFilterChange: this.handleHealthFilterChange,
	          onResetFilter: this.resetFilter,
	          onResourceSelectionChange: this.onResourceSelectionChange,
	          refreshRate: data.refreshRate,
	          selectedFilter: healthFilter,
	          selectedResource: selectedResource,
	          services: data.services,
	          totalHostsResources: data.totalHostsResources,
	          totalNodeCount: data.totalNodes,
	          totalResources: data.totalResources,
	          viewTypeRadioButtons: this.getViewTypeRadioButtons(this.resetFilter)
	        },
	        this.props.children
	      )
	    );
	  },
	  getEmptyHostsPageContent: function getEmptyHostsPageContent() {
	    return _react2.default.createElement(
	      _Page2.default,
	      null,
	      _react2.default.createElement(
	        _AlertPanel2.default,
	        null,
	        _react2.default.createElement(
	          _AlertPanelHeader2.default,
	          null,
	          "No nodes detected"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush-bottom" },
	          "There a currently no other nodes in your datacenter other than your DC/OS master node."
	        )
	      )
	    );
	  },
	  getContents: function getContents(isEmpty) {
	    if (isEmpty) {
	      return this.getEmptyHostsPageContent();
	    } else {
	      return this.getHostsPageContent();
	    }
	  },
	  render: function render() {
	    var data = this.internalStorage_get();
	    var statesProcessed = _MesosSummaryStore2.default.get("statesProcessed");
	    var isEmpty = statesProcessed && data.totalNodes === 0;
	
	    return this.getContents(isEmpty);
	  }
	});
	
	module.exports = NodesOverview;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterButtons = __webpack_require__(1383);
	
	var _FilterButtons2 = _interopRequireDefault(_FilterButtons);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _ResourceBarChart = __webpack_require__(1574);
	
	var _ResourceBarChart2 = _interopRequireDefault(_ResourceBarChart);
	
	var _FilterByService = __webpack_require__(1575);
	
	var _FilterByService2 = _interopRequireDefault(_FilterByService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEALTH_FILTER_BUTTONS = ["all", "healthy", "unhealthy"];
	
	var METHODS_TO_BIND = ["onResetFilter"];
	
	var HostsPageContent = function (_React$Component) {
	  (0, _inherits3.default)(HostsPageContent, _React$Component);
	
	  function HostsPageContent() {
	    (0, _classCallCheck3.default)(this, HostsPageContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HostsPageContent.__proto__ || (0, _getPrototypeOf2.default)(HostsPageContent)).apply(this, arguments));
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(HostsPageContent, [{
	    key: "onResetFilter",
	    value: function onResetFilter() {
	      var _props;
	
	      (_props = this.props).onResetFilter.apply(_props, arguments);
	
	      if (this.serviceFilter !== null && this.serviceFilter.dropdown !== null) {
	        this.serviceFilter.setDropdownValue("default");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          byServiceFilter = _props2.byServiceFilter,
	          children = _props2.children,
	          filterButtonContent = _props2.filterButtonContent,
	          filterInputText = _props2.filterInputText,
	          filterItemList = _props2.filterItemList,
	          filteredNodeCount = _props2.filteredNodeCount,
	          handleFilterChange = _props2.handleFilterChange,
	          hosts = _props2.hosts,
	          isFiltering = _props2.isFiltering,
	          nodeCount = _props2.nodeCount,
	          onFilterChange = _props2.onFilterChange,
	          onResourceSelectionChange = _props2.onResourceSelectionChange,
	          refreshRate = _props2.refreshRate,
	          selectedFilter = _props2.selectedFilter,
	          selectedResource = _props2.selectedResource,
	          services = _props2.services,
	          totalHostsResources = _props2.totalHostsResources,
	          totalNodeCount = _props2.totalNodeCount,
	          totalResources = _props2.totalResources,
	          viewTypeRadioButtons = _props2.viewTypeRadioButtons;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_ResourceBarChart2.default, {
	          itemCount: nodeCount,
	          onResourceSelectionChange: onResourceSelectionChange,
	          refreshRate: refreshRate,
	          resourceType: "Nodes",
	          resources: totalHostsResources,
	          selectedResource: selectedResource,
	          totalResources: totalResources
	        }),
	        _react2.default.createElement(_FilterHeadline2.default, {
	          currentLength: filteredNodeCount,
	          isFiltering: isFiltering,
	          name: "Node",
	          onReset: this.onResetFilter,
	          totalLength: totalNodeCount
	        }),
	        _react2.default.createElement(
	          _FilterBar2.default,
	          { rightAlignLastNChildren: 1 },
	          filterInputText,
	          _react2.default.createElement(_FilterButtons2.default, {
	            filterByKey: "title",
	            filters: HEALTH_FILTER_BUTTONS,
	            itemList: filterItemList,
	            onFilterChange: onFilterChange,
	            renderButtonContent: filterButtonContent,
	            selectedFilter: selectedFilter
	          }),
	          _react2.default.createElement(
	            "div",
	            { className: "form-group flush-bottom" },
	            _react2.default.createElement(_FilterByService2.default, {
	              byServiceFilter: byServiceFilter,
	              handleFilterChange: handleFilterChange,
	              ref: function ref(_ref) {
	                return _this2.serviceFilter = _ref;
	              },
	              services: services,
	              totalHostsCount: totalNodeCount
	            })
	          ),
	          viewTypeRadioButtons
	        ),
	        _react2.default.cloneElement(children, {
	          hosts: hosts,
	          selectedResource: selectedResource,
	          services: services
	        })
	      );
	    }
	  }]);
	  return HostsPageContent;
	}(_react2.default.Component);
	
	HostsPageContent.propTypes = {
	  byServiceFilter: _react2.default.PropTypes.string,
	  filterButtonContent: _react2.default.PropTypes.func,
	  filterInputText: _react2.default.PropTypes.node,
	  filterItemList: _react2.default.PropTypes.array.isRequired,
	  filteredNodeCount: _react2.default.PropTypes.number.isRequired,
	  handleFilterChange: _react2.default.PropTypes.func.isRequired,
	  hosts: _react2.default.PropTypes.array.isRequired,
	  isFiltering: _react2.default.PropTypes.bool,
	  nodeCount: _react2.default.PropTypes.number.isRequired,
	  onFilterChange: _react2.default.PropTypes.func,
	  onResetFilter: _react2.default.PropTypes.func.isRequired,
	  onResourceSelectionChange: _react2.default.PropTypes.func.isRequired,
	  refreshRate: _react2.default.PropTypes.number.isRequired,
	  selectedFilter: _react2.default.PropTypes.string,
	  selectedResource: _react2.default.PropTypes.string.isRequired,
	  services: _react2.default.PropTypes.array.isRequired,
	  totalHostsResources: _react2.default.PropTypes.object.isRequired,
	  totalNodeCount: _react2.default.PropTypes.number.isRequired,
	  totalResources: _react2.default.PropTypes.object.isRequired,
	  viewTypeRadioButtons: _react2.default.PropTypes.node.isRequired
	};
	
	module.exports = HostsPageContent;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BarChart = __webpack_require__(1547);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _Chart = __webpack_require__(1388);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _ResourcesUtil = __webpack_require__(1500);
	
	var _ResourcesUtil2 = _interopRequireDefault(_ResourcesUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// number to fit design of width vs. height ratio
	var WIDTH_HEIGHT_RATIO = 4.5;
	
	var ResourceBarChart = _react2.default.createClass({
	  displayName: "ResourceBarChart",
	
	  propTypes: {
	    onResourceSelectionChange: _react2.default.PropTypes.func.isRequired,
	    itemCount: _react2.default.PropTypes.number.isRequired,
	    resources: _react2.default.PropTypes.object.isRequired,
	    refreshRate: _react2.default.PropTypes.number.isRequired,
	    resourceType: _react2.default.PropTypes.string,
	    selectedResource: _react2.default.PropTypes.string.isRequired,
	    totalResources: _react2.default.PropTypes.object.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      itemCount: 0,
	      totalResources: {},
	      y: "percentage",
	      refreshRate: 0,
	      resourceType: ""
	    };
	  },
	  getData: function getData() {
	    var props = this.props;
	
	    if (props.itemCount === 0) {
	      return [];
	    }
	
	    var selectedResource = props.selectedResource;
	
	    return [{
	      id: "used_resources",
	      name: selectedResource + " allocated",
	      colorIndex: _ResourcesUtil2.default.getResourceColor(selectedResource),
	      values: props.resources[selectedResource]
	    }];
	  },
	  getMaxY: function getMaxY() {
	    if (this.props.totalResources[this.props.selectedResource]) {
	      return 100;
	    } else {
	      return 0;
	    }
	  },
	  handleSelectedResourceChange: function handleSelectedResourceChange(selectedResource) {
	    this.props.onResourceSelectionChange(selectedResource);
	  },
	  getModeButtons: function getModeButtons() {
	    var _this = this;
	
	    var selectedResource = this.props.selectedResource;
	
	    var resourceColors = _ResourcesUtil2.default.getResourceColors();
	    var resourceLabels = _ResourcesUtil2.default.getResourceLabels();
	
	    return _ResourcesUtil2.default.getDefaultResources().map(function (resource) {
	      var classSet = (0, _classnames2.default)("button button-stroke", {
	        active: selectedResource === resource
	      });
	
	      return _react2.default.createElement(
	        "button",
	        {
	          key: resource,
	          className: classSet + " path-color-" + resourceColors[resource],
	          onClick: _this.handleSelectedResourceChange.bind(_this, resource)
	        },
	        resourceLabels[resource]
	      );
	    });
	  },
	  getBarChart: function getBarChart() {
	    return _react2.default.createElement(
	      _Chart2.default,
	      {
	        calcHeight: function calcHeight(w) {
	          return w / WIDTH_HEIGHT_RATIO;
	        }
	      },
	      _react2.default.createElement(_BarChart2.default, {
	        data: this.getData(),
	        maxY: this.getMaxY(),
	        ticksY: 4,
	        y: this.props.y,
	        refreshRate: this.props.refreshRate
	      })
	    );
	  },
	  getHeadline: function getHeadline(resource) {
	    var label = _ResourcesUtil2.default.getResourceLabel(resource);
	    var headline = label + " Allocation Rate";
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h4",
	        { className: "flush" },
	        headline
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "flush" },
	        this.props.itemCount + " Total " + this.props.resourceType
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "pod flush-top flush-right flush-left" },
	      _react2.default.createElement(
	        "div",
	        { className: "chart panel" },
	        _react2.default.createElement(
	          "div",
	          { className: "panel-cell panel-header panel-cell-borderless flush-bottom text-align-center" },
	          _react2.default.createElement(
	            "div",
	            { className: "panel-options button-group" },
	            this.getModeButtons()
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            this.getHeadline(this.props.selectedResource)
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "panel-cell panel-content", ref: "panelContent" },
	          this.getBarChart()
	        )
	      )
	    );
	  }
	});
	
	module.exports = ResourceBarChart;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultId = "default";
	
	var FilterByService = _react2.default.createClass({
	  displayName: "FilterByService",
	
	  propTypes: {
	    byServiceFilter: _react2.default.PropTypes.string,
	    services: _react2.default.PropTypes.array.isRequired,
	    totalHostsCount: _react2.default.PropTypes.number.isRequired,
	    handleFilterChange: _react2.default.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      byServiceFilter: defaultId,
	      services: [],
	      totalHostsCount: 0,
	      handleFilterChange: function handleFilterChange() {}
	    };
	  },
	  handleItemSelection: function handleItemSelection(obj) {
	    if (obj.id === defaultId) {
	      this.props.handleFilterChange(null);
	    } else {
	      this.props.handleFilterChange(obj.id);
	    }
	  },
	  getItemHtml: function getItemHtml(service) {
	    return _react2.default.createElement(
	      "span",
	      { className: "badge-container" },
	      _react2.default.createElement(
	        "span",
	        { className: "badge-container-text" },
	        service.get("name")
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "badge badge-rounded" },
	        service.getNodeIDs().length
	      )
	    );
	  },
	  getDropdownItems: function getDropdownItems() {
	    var _this = this;
	
	    // TODO (mlunoe, orlandohohmeier): Refactor after introducing new unified
	    // service struct featuring frameworks and apps.
	    var defaultItem = new _Framework2.default({
	      id: defaultId,
	      name: "All Services",
	      // This is literally the worst way of doing this.
	      slave_ids: new Array(this.props.totalHostsCount)
	    });
	    var items = [defaultItem].concat(this.props.services);
	
	    return items.map(function (service) {
	      var selectedHtml = _this.getItemHtml(service);
	      var dropdownHtml = _react2.default.createElement(
	        "a",
	        null,
	        selectedHtml
	      );
	
	      var item = {
	        id: service.get("id"),
	        name: service.get("name"),
	        html: dropdownHtml,
	        selectedHtml: selectedHtml
	      };
	
	      if (service.get("id") === defaultId) {
	        item.selectedHtml = _react2.default.createElement(
	          "span",
	          null,
	          "Filter by Service"
	        );
	      }
	
	      return item;
	    });
	  },
	  getSelectedId: function getSelectedId(id) {
	    if (id == null) {
	      return defaultId;
	    }
	
	    return id;
	  },
	  setDropdownValue: function setDropdownValue(id) {
	    this.dropdown.setState({
	      selectedID: id
	    });
	  },
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_reactjsComponents.Dropdown, {
	      buttonClassName: "button dropdown-toggle",
	      dropdownMenuClassName: "dropdown-menu",
	      dropdownMenuListClassName: "dropdown-menu-list",
	      dropdownMenuListItemClassName: "clickable",
	      wrapperClassName: "dropdown",
	      items: this.getDropdownItems(),
	      initialID: this.getSelectedId(this.props.byServiceFilter),
	      onItemSelection: this.handleItemSelection,
	      ref: function ref(_ref) {
	        return _this2.dropdown = _ref;
	      },
	      scrollContainer: ".gm-scroll-view",
	      scrollContainerParentSelector: ".gm-prevented",
	      transition: true,
	      transitionName: "dropdown-menu"
	    });
	  }
	});
	
	module.exports = FilterByService;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodesPage = function (_React$Component) {
	  (0, _inherits3.default)(NodesPage, _React$Component);
	
	  function NodesPage() {
	    (0, _classCallCheck3.default)(this, NodesPage);
	    return (0, _possibleConstructorReturn3.default)(this, (NodesPage.__proto__ || (0, _getPrototypeOf2.default)(NodesPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NodesPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return NodesPage;
	}(_react2.default.Component);
	
	NodesPage.routeConfig = {
	  label: "Nodes",
	  icon: _react2.default.createElement(_Icon2.default, { id: "servers-inverse", size: "small", family: "product" }),
	  matches: /^\/nodes/
	};
	
	module.exports = NodesPage;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CompositeState = __webpack_require__(1048);
	
	var _CompositeState2 = _interopRequireDefault(_CompositeState);
	
	var _QueryParamsMixin = __webpack_require__(1569);
	
	var _QueryParamsMixin2 = _interopRequireDefault(_QueryParamsMixin);
	
	var _NodesTable = __webpack_require__(1578);
	
	var _NodesTable2 = _interopRequireDefault(_NodesTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NodesTableContainer = function (_mixin) {
	  (0, _inherits3.default)(NodesTableContainer, _mixin);
	
	  function NodesTableContainer() {
	    (0, _classCallCheck3.default)(this, NodesTableContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodesTableContainer.__proto__ || (0, _getPrototypeOf2.default)(NodesTableContainer)).apply(this, arguments));
	
	    _this.state = {
	      filteredNodes: [],
	      filters: { health: "all", name: "", service: null },
	      receivedNodeHealthResponse: false
	    };
	    _this.store_listeners = [{
	      events: ["success"],
	      listenAlways: false,
	      name: "nodeHealth",
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodesTableContainer, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var query = nextProps.location.query;
	
	      var filters = {
	        health: query.filterHealth || "all",
	        name: query.searchString || "",
	        service: query.filterService || null
	      };
	      this.setFilters(filters);
	    }
	  }, {
	    key: "getFilteredNodes",
	    value: function getFilteredNodes() {
	      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.filters;
	
	      return _CompositeState2.default.getNodesList().filter(filters).getItems();
	    }
	  }, {
	    key: "setFilters",
	    value: function setFilters(newFilters, callback) {
	      if (newFilters.service === "") {
	        newFilters.service = null;
	      }
	      var filters = (0, _assign2.default)({}, this.state.filters, newFilters);
	      var filteredNodes = this.getFilteredNodes(filters);
	
	      this.setState({ filters: filters, filteredNodes: filteredNodes }, callback);
	    }
	  }, {
	    key: "onNodeHealthStoreSuccess",
	    value: function onNodeHealthStoreSuccess() {
	      this.setState({
	        filteredNodes: this.getFilteredNodes(),
	        receivedNodeHealthResponse: true
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          receivedNodeHealthResponse = _state.receivedNodeHealthResponse,
	          filteredNodes = _state.filteredNodes;
	
	
	      return _react2.default.createElement(_NodesTable2.default, {
	        hosts: filteredNodes,
	        receivedNodeHealthResponse: receivedNodeHealthResponse
	      });
	    }
	  }]);
	  return NodesTableContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin, _QueryParamsMixin2.default));
	
	module.exports = NodesTableContainer;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _NodesTableHeaderLabels = __webpack_require__(1579);
	
	var _NodesTableHeaderLabels2 = _interopRequireDefault(_NodesTableHeaderLabels);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StatusBar = __webpack_require__(1580);
	
	var _StatusBar2 = _interopRequireDefault(_StatusBar);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UnitHealthUtil = __webpack_require__(1054);
	
	var _UnitHealthUtil2 = _interopRequireDefault(_UnitHealthUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLOR_CLASSNAMES = {
	  cpus: "color-1",
	  mem: "color-2",
	  disk: "color-3"
	};
	
	var NodesTable = _react2.default.createClass({
	  displayName: "NodesTable",
	
	  mixins: [_reactAddonsPureRenderMixin2.default],
	
	  propTypes: {
	    hosts: _react2.default.PropTypes.array.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hosts: []
	    };
	  },
	  renderHeadline: function renderHeadline(prop, node) {
	    var headline = node.get(prop);
	
	    if (!node.isActive()) {
	      headline = _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { anchor: "start", content: "Connection to node lost" },
	        _react2.default.createElement(_Icon2.default, {
	          className: "icon-alert icon-margin-right",
	          color: "neutral",
	          id: "yield",
	          size: "mini"
	        }),
	        headline
	      );
	    }
	
	    var nodeID = node.get("id");
	
	    return _react2.default.createElement(
	      _reactRouter.Link,
	      { className: "table-cell-link-primary", to: "/nodes/" + nodeID },
	      headline
	    );
	  },
	  renderHealth: function renderHealth(prop, node) {
	    var requestReceived = this.props.receivedNodeHealthResponse;
	
	    if (!requestReceived) {
	      return _react2.default.createElement(_Loader2.default, { size: "small", type: "ballBeat" });
	    }
	
	    var health = node.getHealth();
	
	    return _react2.default.createElement(
	      "span",
	      { className: health.classNames },
	      _StringUtil2.default.capitalize(health.title)
	    );
	  },
	  renderStats: function renderStats(prop, node) {
	    var value = node.getUsageStats(prop).percentage;
	
	    return _react2.default.createElement(
	      "span",
	      { className: "status-bar-with-label-wrapper" },
	      _react2.default.createElement(_StatusBar2.default, {
	        data: [{ value: value, className: COLOR_CLASSNAMES[prop] }],
	        scale: 100
	      }),
	      _react2.default.createElement(
	        "span",
	        { className: "label" },
	        value,
	        "%"
	      )
	    );
	  },
	  getColumns: function getColumns() {
	    var className = _ResourceTableUtil2.default.getClassName;
	    var heading = _ResourceTableUtil2.default.renderHeading(_NodesTableHeaderLabels2.default);
	    var getHealthSorting = _TableUtil2.default.getHealthSortingOrder;
	    var sortFunction = _TableUtil2.default.getSortFunction("hostname", function (node, prop) {
	      if (prop === "cpus" || prop === "mem" || prop === "disk") {
	        return node.getUsageStats(prop).percentage;
	      }
	
	      if (prop === "health") {
	        return _UnitHealthUtil2.default.getHealthSorting(node);
	      }
	
	      return node.get(prop);
	    });
	
	    return [{
	      className: className,
	      headerClassName: className,
	      prop: "hostname",
	      render: this.renderHeadline,
	      sortable: true,
	      sortFunction: sortFunction,
	      heading: heading
	    }, {
	      className: className,
	      headerClassName: className,
	      prop: "health",
	      render: this.renderHealth,
	      sortable: true,
	      sortFunction: getHealthSorting,
	      heading: _ResourceTableUtil2.default.renderHeading({ health: "HEALTH" })
	    }, {
	      className: className,
	      headerClassName: className,
	      prop: "TASK_RUNNING",
	      render: _ResourceTableUtil2.default.renderTask,
	      sortable: true,
	      sortFunction: sortFunction,
	      heading: heading
	    }, {
	      className: className,
	      headerClassName: className,
	      prop: "cpus",
	      render: this.renderStats,
	      sortable: true,
	      sortFunction: sortFunction,
	      heading: heading
	    }, {
	      className: className,
	      headerClassName: className,
	      prop: "mem",
	      render: this.renderStats,
	      sortable: true,
	      sortFunction: sortFunction,
	      heading: heading
	    }, {
	      className: className,
	      headerClassName: className,
	      prop: "disk",
	      render: this.renderStats,
	      sortable: true,
	      sortFunction: sortFunction,
	      heading: heading
	    }];
	  },
	  getColGroup: function getColGroup() {
	    return _react2.default.createElement(
	      "colgroup",
	      null,
	      _react2.default.createElement("col", null),
	      _react2.default.createElement("col", { style: { width: "100px" } }),
	      _react2.default.createElement("col", { style: { width: "125px" } }),
	      _react2.default.createElement("col", { className: "hidden-small-down", style: { width: "135px" } }),
	      _react2.default.createElement("col", { className: "hidden-small-down", style: { width: "135px" } }),
	      _react2.default.createElement("col", { className: "hidden-small-down", style: { width: "135px" } })
	    );
	  },
	  getRowAttributes: function getRowAttributes(node) {
	    return {
	      className: (0, _classnames2.default)({
	        danger: node.isActive() === false
	      })
	    };
	  },
	  render: function render() {
	    return _react2.default.createElement(_reactjsComponents.Table, {
	      buildRowOptions: this.getRowAttributes,
	      className: "node-table table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	      colGroup: this.getColGroup(),
	      columns: this.getColumns(),
	      containerSelector: ".gm-scroll-view",
	      data: this.props.hosts.slice(),
	      itemHeight: _TableUtil2.default.getRowHeight(),
	      sortBy: { prop: "health", order: "asc" }
	    });
	  }
	});
	
	module.exports = NodesTable;

/***/ },
/* 1579 */
/***/ function(module, exports) {

	"use strict";
	
	var NodesTableHeaderLabels = {
	  health: "HEALTH",
	  cpus: "CPU",
	  disk: "DISK",
	  hostname: "HOSTNAME",
	  mem: "MEM",
	  TASK_RUNNING: "TOTAL TASKS"
	};
	
	module.exports = NodesTableHeaderLabels;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Size of largest portion to give to smallest portion. We have a max of 5
	// status types so we want to keep this growth ratio relatively small.
	var GROW_RATIO = 0.07;
	// Grow anything below this threshold by stealing from the biggest portion
	var MIN_SIZE = 7; // (% of statusBar width)
	
	function stealPortion(barSizes, indexesLessThanThreshold, unassignedPortion) {
	  if (!indexesLessThanThreshold.length) {
	    return;
	  }
	  // Try to steal some width from the largest portion
	  // and give it to the first portion in indexesLessThanThreshold
	  var maxSize = 0;
	  var maxIndex = 0;
	  // Find new Max (could be different after we've stolen from a portion already)
	  barSizes.forEach(function (relativeSize, index) {
	    if (relativeSize > maxSize) {
	      maxSize = relativeSize;
	      maxIndex = index;
	    }
	  });
	  // Possible we have unassigned portion that we should steal from first
	  if (unassignedPortion > maxSize) {
	    maxSize = unassignedPortion;
	    maxIndex = -1;
	  }
	
	  var currentGrowthIndex = indexesLessThanThreshold[0];
	  var sizeToSteal = maxSize * GROW_RATIO;
	  // Reassign the portion
	  barSizes[currentGrowthIndex] += sizeToSteal;
	  if (maxIndex > -1) {
	    barSizes[maxIndex] -= sizeToSteal;
	  } else {
	    unassignedPortion -= sizeToSteal;
	  }
	
	  if (barSizes[currentGrowthIndex] > MIN_SIZE) {
	    // Done with growing this portion. Otherwise it stays on the stack
	    // and will get another % added to it from the largest portion
	    // calculated in the next iteration.
	    indexesLessThanThreshold = indexesLessThanThreshold.slice(1);
	  }
	  // Recurse till we have grown everything above threshold
	  stealPortion(barSizes, indexesLessThanThreshold, unassignedPortion);
	}
	
	var StatusBar = function (_React$Component) {
	  (0, _inherits3.default)(StatusBar, _React$Component);
	
	  function StatusBar() {
	    (0, _classCallCheck3.default)(this, StatusBar);
	    return (0, _possibleConstructorReturn3.default)(this, (StatusBar.__proto__ || (0, _getPrototypeOf2.default)(StatusBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StatusBar, [{
	    key: "getBars",
	    value: function getBars(data) {
	      var max = data.reduce(function (sum, item) {
	        return sum + item.value;
	      }, 0);
	      var unassignedValue = this.props.scale - max;
	
	      max = Math.max(this.props.scale, max);
	
	      if (max === 0) {
	        return null;
	      }
	      var indexesLessThanThreshold = [];
	      var unassignedPortion = unassignedValue / max * 100;
	
	      var barSizes = data.map(function (status, index) {
	        var value = status.value;
	
	
	        var relativeSize = value / max * 100;
	
	        if (relativeSize > 0 && relativeSize < MIN_SIZE) {
	          indexesLessThanThreshold.push(index);
	        }
	
	        return relativeSize;
	      });
	
	      // Fudge barSizes to ensure small portions are visible
	      stealPortion(barSizes, indexesLessThanThreshold, unassignedPortion);
	
	      return data.map(function (status, index) {
	        var className = status.className,
	            _status$style = status.style,
	            style = _status$style === undefined ? {} : _status$style;
	
	        var scale = barSizes[index];
	
	        if (className == null) {
	          className = "element-" + index;
	        }
	
	        className = (0, _dedupe2.default)("bar", className);
	
	        if (scale === 0) {
	          return null;
	        }
	
	        style.width = scale + "%";
	
	        return _react2.default.createElement("span", { style: style, key: index, className: className });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          className = _props.className;
	
	
	      if (!data) {
	        return null;
	      }
	
	      var classes = (0, _dedupe2.default)("status-bar flex-box", className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getBars(data)
	      );
	    }
	  }]);
	  return StatusBar;
	}(_react2.default.Component);
	
	StatusBar.defaultProps = {
	  scale: 0
	};
	
	StatusBar.propTypes = {
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  scale: _react2.default.PropTypes.number,
	  data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    className: _react2.default.PropTypes.string,
	    value: _react2.default.PropTypes.number.isRequired
	  })).isRequired
	};
	
	module.exports = StatusBar;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _TaskDetail = __webpack_require__(1490);
	
	var _TaskDetail2 = _interopRequireDefault(_TaskDetail);
	
	var _NodeBreadcrumbs = __webpack_require__(1549);
	
	var _NodeBreadcrumbs2 = _interopRequireDefault(_NodeBreadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var dontScrollRoutes = [/\/files\/view.*$/, /\/logs.*$/];
	/* eslint-enable no-unused-vars */
	
	var NodesTaskDetailPage = function (_mixin) {
	  (0, _inherits3.default)(NodesTaskDetailPage, _mixin);
	
	  function NodesTaskDetailPage() {
	    (0, _classCallCheck3.default)(this, NodesTaskDetailPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodesTaskDetailPage.__proto__ || (0, _getPrototypeOf2.default)(NodesTaskDetailPage)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "summary",
	      events: ["success"],
	      listenAlways: false
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodesTaskDetailPage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          routes = _props.routes;
	      var nodeID = params.nodeID,
	          taskID = params.taskID;
	
	
	      var routePrefix = "/nodes/" + encodeURIComponent(nodeID) + "/tasks/" + encodeURIComponent(taskID);
	      var tabs = [{ label: "Details", routePath: routePrefix + "/details" }, { label: "Files", routePath: routePrefix + "/files" }, { label: "Logs", routePath: routePrefix + "/logs" }];
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(taskID);
	      var breadcrumbs = void 0;
	      if (task != null) {
	        breadcrumbs = _react2.default.createElement(_NodeBreadcrumbs2.default, {
	          nodeID: nodeID,
	          taskID: task.getId(),
	          taskName: task.getName()
	        });
	      } else {
	        breadcrumbs = _react2.default.createElement(_NodeBreadcrumbs2.default, { nodeID: nodeID });
	      }
	
	      var dontScroll = dontScrollRoutes.some(function (regex) {
	        return regex.test(location.pathname);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { dontScroll: dontScroll },
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs, tabs: tabs, iconID: "servers" }),
	        _react2.default.createElement(
	          _TaskDetail2.default,
	          { params: params, routes: routes },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return NodesTaskDetailPage;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	NodesTaskDetailPage.propTypes = {
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array
	};
	
	module.exports = NodesTaskDetailPage;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventTypes = __webpack_require__(933);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ServiceItemNotFound = __webpack_require__(1583);
	
	var _ServiceItemNotFound2 = _interopRequireDefault(_ServiceItemNotFound);
	
	var _VolumeDetail = __webpack_require__(1584);
	
	var _VolumeDetail2 = _interopRequireDefault(_VolumeDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onStoreChange"];
	
	var TaskVolumeContainer = function (_React$Component) {
	  (0, _inherits3.default)(TaskVolumeContainer, _React$Component);
	
	  function TaskVolumeContainer() {
	    (0, _classCallCheck3.default)(this, TaskVolumeContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskVolumeContainer.__proto__ || (0, _getPrototypeOf2.default)(TaskVolumeContainer)).apply(this, arguments));
	
	    _this.state = {
	      isLoading: !_DCOSStore2.default.serviceDataReceived,
	      lastUpdate: 0
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TaskVolumeContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _DCOSStore2.default.addChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "onStoreChange",
	    value: function onStoreChange() {
	      // Throttle updates from DCOSStore
	      if (Date.now() - this.state.lastUpdate > 1000 || _DCOSStore2.default.serviceDataReceived && this.state.isLoading) {
	        this.setState({
	          isLoading: !_DCOSStore2.default.serviceDataReceived,
	          lastUpdate: Date.now()
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$params = this.props.params,
	          taskID = _props$params.taskID,
	          volumeID = _props$params.volumeID;
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(taskID);
	      var service = _DCOSStore2.default.serviceTree.getServiceFromTaskID(task.getId());
	      var volumeId = decodeURIComponent(volumeID);
	
	      if (this.state.isLoading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      if (!service) {
	        return _react2.default.createElement(_ServiceItemNotFound2.default, {
	          message: "The service with the ID of \"" + taskID + "\" could not be found."
	        });
	      }
	
	      var volume = service.getVolumes().findItem(function (volume) {
	        return volume.getId() === volumeId;
	      });
	
	      if (!volume) {
	        return _react2.default.createElement(_ServiceItemNotFound2.default, { message: "Volume '" + volumeId + "' was not found." });
	      }
	
	      return _react2.default.createElement(_VolumeDetail2.default, { service: service, volume: volume });
	    }
	  }]);
	  return TaskVolumeContainer;
	}(_react2.default.Component);
	
	TaskVolumeContainer.propTypes = {
	  params: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = TaskVolumeContainer;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceItemNotFound = function ServiceItemNotFound(_ref) {
	  var message = _ref.message;
	
	  var footer = _react2.default.createElement(
	    "div",
	    { className: "button-collection flush-bottom" },
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: "/services", className: "button button-stroke" },
	      "View Services"
	    )
	  );
	
	  return _react2.default.createElement(
	    _AlertPanel2.default,
	    null,
	    _react2.default.createElement(
	      _AlertPanelHeader2.default,
	      null,
	      "Service not found"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "tall" },
	      message
	    ),
	    footer
	  );
	};
	
	ServiceItemNotFound.defaultProps = {
	  message: "Not Found."
	};
	
	ServiceItemNotFound.propTypes = {
	  message: _react.PropTypes.node
	};
	
	module.exports = ServiceItemNotFound;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _DetailViewHeader = __webpack_require__(1491);
	
	var _DetailViewHeader2 = _interopRequireDefault(_DetailViewHeader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	var _VolumeStatus = __webpack_require__(1096);
	
	var _VolumeStatus2 = _interopRequireDefault(_VolumeStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VolumeDetail = function (_React$Component) {
	  (0, _inherits3.default)(VolumeDetail, _React$Component);
	
	  function VolumeDetail() {
	    (0, _classCallCheck3.default)(this, VolumeDetail);
	    return (0, _possibleConstructorReturn3.default)(this, (VolumeDetail.__proto__ || (0, _getPrototypeOf2.default)(VolumeDetail)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VolumeDetail, [{
	    key: "getSizeLabel",
	    value: function getSizeLabel() {
	      if (this.props.volume.type === "External") {
	        return "Size (GiB)";
	      }
	
	      return "Size (MiB)";
	    }
	  }, {
	    key: "renderSubHeader",
	    value: function renderSubHeader() {
	      var volume = this.props.volume;
	
	
	      var status = volume.getStatus();
	      var classes = (0, _classnames2.default)({
	        "text-danger": status === _VolumeStatus2.default.DETACHED,
	        "text-success": status === _VolumeStatus2.default.ATTACHED
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: classes },
	        status
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          service = _props.service,
	          volume = _props.volume;
	
	
	      var serviceID = service.getId();
	      var encodedServiceId = encodeURIComponent(serviceID);
	      var volumeId = volume.getId();
	
	      var extraCrumbs = [_react2.default.createElement(
	        _Breadcrumb2.default,
	        { key: -1, title: "Services" },
	        _react2.default.createElement(
	          _BreadcrumbTextContent2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              to: "/services/detail/" + encodedServiceId + "/volumes/" + volumeId,
	              key: "volume"
	            },
	            volumeId
	          )
	        )
	      )];
	
	      var breadcrumbs = _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: serviceID, extra: extraCrumbs });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs }),
	        _react2.default.createElement(_DetailViewHeader2.default, { subTitle: this.renderSubHeader(), title: volumeId }),
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Container Path"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                volume.getContainerPath()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Mode"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                volume.getMode()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                this.getSizeLabel()
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                volume.getSize()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Application"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                serviceID
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Task ID"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                volume.getTaskID()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Host"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                volume.getHost()
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return VolumeDetail;
	}(_react2.default.Component);
	
	VolumeDetail.propTypes = {
	  service: _react2.default.PropTypes.object.isRequired,
	  volume: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = VolumeDetail;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbSupplementalContent = __webpack_require__(1480);
	
	var _BreadcrumbSupplementalContent2 = _interopRequireDefault(_BreadcrumbSupplementalContent);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _PageHeaderBreadcrumbs = __webpack_require__(1329);
	
	var _PageHeaderBreadcrumbs2 = _interopRequireDefault(_PageHeaderBreadcrumbs);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(785);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _HealthBar = __webpack_require__(1586);
	
	var _HealthBar2 = _interopRequireDefault(_HealthBar);
	
	var _ServiceStatusWarningWithDebugInstruction = __webpack_require__(1588);
	
	var _ServiceStatusWarningWithDebugInstruction2 = _interopRequireDefault(_ServiceStatusWarningWithDebugInstruction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The breadcrumb's margin is hardcoded to avoid calling #getComputedStyle.
	var BREADCRUMB_CONTENT_MARGIN = 7;
	var METHODS_TO_BIND = ["checkBreadcrumbOverflow", "handleViewportResize"];
	
	var ServiceBreadcrumbs = function (_React$Component) {
	  (0, _inherits3.default)(ServiceBreadcrumbs, _React$Component);
	
	  function ServiceBreadcrumbs() {
	    (0, _classCallCheck3.default)(this, ServiceBreadcrumbs);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceBreadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(ServiceBreadcrumbs)).call(this));
	
	    _this.breadcrumbStatusRef = null;
	    _this.primaryBreadcrumbTextRef = null;
	    _this.lastStatusWidth = 0;
	
	    _this.state = {
	      shouldRenderServiceStatus: true
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.handleViewportResize = _Util2.default.debounce(_this.handleViewportResize, 100);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceBreadcrumbs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.checkBreadcrumbOverflow();
	      global.addEventListener("resize", this.handleViewportResize);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var hasServiceIDChanged = this.props.serviceID !== nextProps.serviceID;
	      var hasTaskIDChanged = this.props.taskID !== nextProps.taskID;
	      var hasTaskNameChanged = this.props.taskName !== nextProps.taskName;
	      var hasExtraNotChanged = this.props.extra === nextProps.extra || (0, _deepEqual2.default)(this.props.extra, nextProps.extra);
	
	      return hasServiceIDChanged || hasTaskIDChanged || hasTaskNameChanged || !hasExtraNotChanged;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.checkBreadcrumbOverflow();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      global.removeEventListener("resize", this.handleViewportResize);
	    }
	  }, {
	    key: "handleViewportResize",
	    value: function handleViewportResize() {
	      this.checkBreadcrumbOverflow();
	    }
	
	    /**
	     * Check if the breadcrumbs are overflowing their container. If they are,
	     * we hide the service's status bar.
	     */
	
	  }, {
	    key: "checkBreadcrumbOverflow",
	    value: function checkBreadcrumbOverflow() {
	      if (this.primaryBreadcrumbTextRef != null) {
	        var availableWidth = this.getAvailableBreadcrumbWidth();
	        var statusBarWidth = this.getBreadcrumbStatusBarWidth();
	
	        if (availableWidth <= 0 && this.state.shouldRenderServiceStatus) {
	          // Hide the status bar when the breadcrumbs are wider than the
	          // container's width.
	          this.setState({ shouldRenderServiceStatus: false });
	        } else if (availableWidth > statusBarWidth && !this.state.shouldRenderServiceStatus) {
	          // Show the status bar if its width is less than the amount of available
	          // space.
	          this.setState({ shouldRenderServiceStatus: true });
	        }
	      }
	    }
	
	    /**
	     * Calculates the number of unused pixels after the last breadcrumb.
	     *
	     * @returns {Number} width in pixels
	     */
	
	  }, {
	    key: "getAvailableBreadcrumbWidth",
	    value: function getAvailableBreadcrumbWidth() {
	      var breadcrumbsNode = _reactDom2.default.findDOMNode(this);
	      var breadcrumbsDimensions = breadcrumbsNode.getBoundingClientRect();
	      var lastBreadcrumbNode = breadcrumbsNode.querySelector(".breadcrumb:last-child");
	      var lastBreadcrumbDimensions = lastBreadcrumbNode.getBoundingClientRect();
	
	      return breadcrumbsDimensions.left + breadcrumbsDimensions.width - lastBreadcrumbDimensions.right;
	    }
	
	    /**
	     * Calculates the width of the status indicator, plus its sibling's margin.
	     *
	     * @returns {Number} width in pixels
	     */
	
	  }, {
	    key: "getBreadcrumbStatusBarWidth",
	    value: function getBreadcrumbStatusBarWidth() {
	      if (this.breadcrumbStatusRef != null) {
	        this.lastStatusWidth = _reactDom2.default.findDOMNode(this.breadcrumbStatusRef).clientWidth + BREADCRUMB_CONTENT_MARGIN;
	      }
	
	      return this.lastStatusWidth;
	    }
	  }, {
	    key: "getHealthStatus",
	    value: function getHealthStatus(service) {
	      var _this2 = this;
	
	      if (service == null || !this.state.shouldRenderServiceStatus) {
	        return null;
	      }
	
	      var serviceStatus = service.getStatus();
	      var tasksSummary = service.getTasksSummary();
	      var runningTasksCount = service.getRunningInstancesCount();
	      var instancesCount = service.getInstancesCount();
	      var isDeploying = serviceStatus === "Deploying";
	
	      if (instancesCount === 0) {
	        return null;
	      }
	
	      var taskCountDetails = runningTasksCount === instancesCount ? "(" + runningTasksCount + ")" : "(" + runningTasksCount + " of " + instancesCount + ")";
	
	      return _react2.default.createElement(
	        _BreadcrumbSupplementalContent2.default,
	        {
	          ref: function ref(_ref) {
	            return _this2.breadcrumbStatusRef = _ref;
	          }
	        },
	        _react2.default.createElement(
	          _BreadcrumbSupplementalContent2.default,
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "muted" },
	            serviceStatus,
	            " ",
	            taskCountDetails
	          ),
	          _react2.default.createElement(_ServiceStatusWarningWithDebugInstruction2.default, { item: service })
	        ),
	        _react2.default.createElement(
	          _BreadcrumbSupplementalContent2.default,
	          { hasStatusBar: true },
	          _react2.default.createElement(_HealthBar2.default, {
	            key: "status-bar",
	            instancesCount: instancesCount,
	            isDeploying: isDeploying,
	            tasksSummary: tasksSummary
	          })
	        )
	      );
	    }
	  }, {
	    key: "getServiceImage",
	    value: function getServiceImage(service, aggregateIDs) {
	      if (service == null || service instanceof _ServiceTree2.default) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _BreadcrumbSupplementalContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/services/detail/" + aggregateIDs },
	          _react2.default.createElement(
	            "span",
	            { className: "icon icon-small icon-image-container icon-app-container" },
	            _react2.default.createElement("img", { src: service.getImages()["icon-small"] })
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          serviceID = _props.serviceID,
	          taskID = _props.taskID,
	          taskName = _props.taskName,
	          extra = _props.extra;
	
	
	      var crumbs = [_react2.default.createElement(
	        _Breadcrumb2.default,
	        { key: -1, title: "Services" },
	        _react2.default.createElement(
	          _BreadcrumbTextContent2.default,
	          null,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/services" },
	            "Services"
	          )
	        )
	      )];
	
	      var aggregateIDs = "";
	      var trimmedServiceID = decodeURIComponent(serviceID).replace(/^\//, "");
	      var ids = trimmedServiceID.split("/");
	
	      if (serviceID != null && trimmedServiceID.length > 0) {
	        var _crumbs;
	
	        var serviceCrumbs = ids.map(function (id, index) {
	          var breadcrumbHealth = null;
	          var serviceImage = null;
	
	          aggregateIDs += encodeURIComponent("/" + id);
	          var routePath = "/services/overview/" + aggregateIDs;
	          if (index === ids.length - 1) {
	            var service = _DCOSStore2.default.serviceTree.findItemById(serviceID);
	            // Make sure to change to detail route if service is not a group
	            if (!(service instanceof _ServiceTree2.default)) {
	              routePath = "/services/detail/" + aggregateIDs;
	            }
	            breadcrumbHealth = _this3.getHealthStatus(service);
	            serviceImage = _this3.getServiceImage(service, aggregateIDs);
	          }
	
	          return _react2.default.createElement(
	            _Breadcrumb2.default,
	            { key: index, title: ids.slice(0, index + 1).join("/") },
	            serviceImage,
	            _react2.default.createElement(
	              _BreadcrumbTextContent2.default,
	              {
	                ref: function ref(_ref2) {
	                  return _this3.primaryBreadcrumbTextRef = _ref2;
	                }
	              },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: routePath },
	                id
	              )
	            ),
	            breadcrumbHealth
	          );
	        });
	
	        (_crumbs = crumbs).push.apply(_crumbs, (0, _toConsumableArray3.default)(serviceCrumbs));
	      }
	
	      if (taskID != null && taskName != null) {
	        var encodedTaskID = encodeURIComponent(taskID);
	        crumbs.push(_react2.default.createElement(
	          _Breadcrumb2.default,
	          { key: trimmedServiceID.length + 1, title: taskID },
	          _react2.default.createElement(
	            _BreadcrumbTextContent2.default,
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: "/services/detail/" + aggregateIDs + "/tasks/" + encodedTaskID,
	                index: taskID
	              },
	              taskName
	            )
	          )
	        ));
	      }
	
	      if (Array.isArray(extra)) {
	        crumbs = crumbs.concat(extra);
	      }
	
	      return _react2.default.createElement(_PageHeaderBreadcrumbs2.default, {
	        iconID: "services",
	        iconRoute: "/services",
	        breadcrumbs: crumbs
	      });
	    }
	  }]);
	  return ServiceBreadcrumbs;
	}(_react2.default.Component);
	
	ServiceBreadcrumbs.defaultProps = {
	  serviceID: ""
	};
	
	ServiceBreadcrumbs.propTypes = {
	  extra: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node),
	  serviceID: _react2.default.PropTypes.string,
	  taskID: _react2.default.PropTypes.string,
	  taskName: _react2.default.PropTypes.string
	};
	
	module.exports = ServiceBreadcrumbs;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _StatusBar = __webpack_require__(1580);
	
	var _StatusBar2 = _interopRequireDefault(_StatusBar);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _HealthBarStates = __webpack_require__(1587);
	
	var _HealthBarStates2 = _interopRequireDefault(_HealthBarStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HealthBar = function (_React$Component) {
	  (0, _inherits3.default)(HealthBar, _React$Component);
	
	  function HealthBar() {
	    (0, _classCallCheck3.default)(this, HealthBar);
	    return (0, _possibleConstructorReturn3.default)(this, (HealthBar.__proto__ || (0, _getPrototypeOf2.default)(HealthBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HealthBar, [{
	    key: "getMappedTasksSummary",
	    value: function getMappedTasksSummary(tasksSummary) {
	      return (0, _keys2.default)(tasksSummary).filter(function (task) {
	        return task !== "tasksRunning";
	      }).map(function (taskStatus) {
	        return {
	          className: _HealthBarStates2.default[taskStatus].className,
	          value: tasksSummary[taskStatus]
	        };
	      });
	    }
	  }, {
	    key: "getTaskList",
	    value: function getTaskList(tasksSummary, instancesCount) {
	      return (0, _keys2.default)(tasksSummary).filter(function (task) {
	        return tasksSummary[task] !== 0 && task !== "tasksRunning";
	      }).map(function (task, index) {
	        var taskCount = tasksSummary[task];
	        var taskNoun = _StringUtil2.default.pluralize("Task", taskCount);
	        var percentage = parseInt(taskCount / instancesCount * 100, 10);
	
	        var classSet = (0, _classnames2.default)(_HealthBarStates2.default[task].className, "dot icon");
	
	        return _react2.default.createElement(
	          "div",
	          { key: index, className: "tooltip-line-item" },
	          _react2.default.createElement("span", { className: classSet }),
	          " " + taskCount + " " + _HealthBarStates2.default[task].label + " " + taskNoun + " ",
	          _react2.default.createElement(
	            "span",
	            { className: "health-bar-tooltip-instances-total" },
	            "of ",
	            instancesCount
	          ),
	          " (" + percentage + "%)"
	        );
	      });
	    }
	  }, {
	    key: "renderToolTip",
	    value: function renderToolTip() {
	      var _props = this.props,
	          tasksSummary = _props.tasksSummary,
	          instancesCount = _props.instancesCount;
	
	
	      tasksSummary = this.getTaskList(tasksSummary, Math.max(tasksSummary.tasksRunning, instancesCount));
	
	      if (tasksSummary.length === 0) {
	        return "No Running Tasks";
	      }
	
	      return tasksSummary;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          tasksSummary = _props2.tasksSummary,
	          instancesCount = _props2.instancesCount,
	          isDeploying = _props2.isDeploying;
	
	
	      if (tasksSummary == null) {
	        return null;
	      }
	
	      // This filters overCapacity ou
	      tasksSummary = (0, _keys2.default)(tasksSummary).filter(function (key) {
	        return key !== "tasksOverCapacity";
	      }).reduce(function (memo, key) {
	        memo[key] = tasksSummary[key];
	
	        return memo;
	      }, {});
	
	      if (isDeploying) {
	        tasksSummary = {
	          tasksStaged: instancesCount
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { interactive: true, content: this.renderToolTip() },
	        _react2.default.createElement(_StatusBar2.default, {
	          className: "status-bar--large",
	          data: this.getMappedTasksSummary(tasksSummary),
	          scale: instancesCount
	        })
	      );
	    }
	  }]);
	  return HealthBar;
	}(_react2.default.Component);
	
	HealthBar.defaultProps = {
	  isDeploying: false,
	  instancesCount: null
	};
	
	HealthBar.propTypes = {
	  isDeploying: _react2.default.PropTypes.bool,
	  instancesCount: _react2.default.PropTypes.number,
	  tasksSummary: _react2.default.PropTypes.shape({
	    tasksRunning: _react2.default.PropTypes.number,
	    tasksHealthy: _react2.default.PropTypes.number,
	    tasksOverCapacity: _react2.default.PropTypes.number,
	    tasksStaged: _react2.default.PropTypes.number,
	    tasksUnhealthy: _react2.default.PropTypes.number,
	    tasksUnknown: _react2.default.PropTypes.number
	  }).isRequired
	};
	
	module.exports = HealthBar;

/***/ },
/* 1587 */
/***/ function(module, exports) {

	"use strict";
	
	var HealthBarStates = {
	  tasksUnknown: {
	    className: "unknown",
	    label: "Unknown"
	  },
	  tasksHealthy: {
	    className: "healthy",
	    label: "Healthy"
	  },
	  tasksOverCapacity: {
	    className: "over-capacity",
	    label: "Over Capacity"
	  },
	  tasksUnhealthy: {
	    className: "unhealthy",
	    label: "Unhealthy"
	  },
	  tasksStaged: {
	    className: "staged",
	    label: "Staged"
	  }
	};
	
	module.exports = HealthBarStates;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _ServiceStatusWarning2 = __webpack_require__(1589);
	
	var _ServiceStatusWarning3 = _interopRequireDefault(_ServiceStatusWarning2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceStatusWarningWithDebugInstruction = function (_ServiceStatusWarning) {
	  (0, _inherits3.default)(ServiceStatusWarningWithDebugInstruction, _ServiceStatusWarning);
	
	  function ServiceStatusWarningWithDebugInstruction() {
	    (0, _classCallCheck3.default)(this, ServiceStatusWarningWithDebugInstruction);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceStatusWarningWithDebugInstruction.__proto__ || (0, _getPrototypeOf2.default)(ServiceStatusWarningWithDebugInstruction)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceStatusWarningWithDebugInstruction, [{
	    key: "getTooltipContent",
	    value: function getTooltipContent(timeWaiting) {
	      var additionalCopy = " See more information in the debug tab.";
	
	      return "DC/OS has been waiting for resources and is unable to complete this deployment for " + _DateUtil2.default.getDuration(timeWaiting, null) + "." + additionalCopy;
	    }
	  }]);
	  return ServiceStatusWarningWithDebugInstruction;
	}(_ServiceStatusWarning3.default);
	
	module.exports = ServiceStatusWarningWithDebugInstruction;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _DeclinedOffersUtil = __webpack_require__(1104);
	
	var _DeclinedOffersUtil2 = _interopRequireDefault(_DeclinedOffersUtil);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UNABLE_TO_LAUNCH_TIMEOUT = 1000 * 60 * 30; // 30 minutes
	
	var ServiceStatusWarning = function (_Component) {
	  (0, _inherits3.default)(ServiceStatusWarning, _Component);
	
	  function ServiceStatusWarning() {
	    (0, _classCallCheck3.default)(this, ServiceStatusWarning);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceStatusWarning.__proto__ || (0, _getPrototypeOf2.default)(ServiceStatusWarning)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceStatusWarning, [{
	    key: "getDeclinedOffersWarning",
	    value: function getDeclinedOffersWarning(item) {
	      if (_DeclinedOffersUtil2.default.shouldDisplayDeclinedOffersWarning(item)) {
	        var timeWaiting = Date.now() - _DateUtil2.default.strToMs(_DeclinedOffersUtil2.default.getTimeWaiting(item.getQueue()));
	
	        return this.getTooltip("DC/OS has been waiting for resources and is unable to complete this deployment for " + _DateUtil2.default.getDuration(timeWaiting, null) + ".");
	      }
	
	      return null;
	    }
	  }, {
	    key: "getServiceTreeWarning",
	    value: function getServiceTreeWarning(item) {
	      var _this2 = this;
	
	      var appsWithWarningsCount = item.filterItems(function (item) {
	        if (!(item instanceof _ServiceTree2.default)) {
	          return _DeclinedOffersUtil2.default.shouldDisplayDeclinedOffersWarning(item) || _this2.shouldShowUnableToLaunchWarning(item);
	        }
	
	        return false;
	      }).flattenItems().getItems().length;
	
	      if (appsWithWarningsCount > 0) {
	        return this.getTooltip("DC/OS is waiting for resources and is unable to complete the deployment of " + appsWithWarningsCount + " " + _StringUtil2.default.pluralize("service", appsWithWarningsCount) + " in this group.");
	      }
	
	      return _react2.default.createElement("noscript", null);
	    }
	  }, {
	    key: "getTooltip",
	    value: function getTooltip(content) {
	      var icon = _react2.default.createElement(_Icon2.default, { color: "red", id: "yield", size: "mini" });
	
	      if (this.props.item instanceof _Service2.default) {
	        var servicePath = encodeURIComponent(this.props.item.getId());
	        icon = _react2.default.createElement(
	          _reactRouter.Link,
	          { to: "/services/detail/" + servicePath + "/debug" },
	          icon
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        {
	          content: content,
	          width: 250,
	          wrapText: true,
	          wrapperClassName: "tooltip-wrapper status-waiting-indicator"
	        },
	        icon
	      );
	    }
	  }, {
	    key: "getUnableToLaunchWarning",
	    value: function getUnableToLaunchWarning(item) {
	      if (this.shouldShowUnableToLaunchWarning(item)) {
	        return this.getTooltip("DC/OS has been unable to complete this deployment for " + _DateUtil2.default.getDuration(Date.now() - _DateUtil2.default.strToMs(item.getQueue().since), null) + ".");
	      }
	
	      return null;
	    }
	  }, {
	    key: "shouldShowUnableToLaunchWarning",
	    value: function shouldShowUnableToLaunchWarning(item) {
	      var queue = item.getQueue();
	
	      if (queue == null) {
	        return false;
	      }
	
	      return Date.now() - _DateUtil2.default.strToMs(queue.since) >= UNABLE_TO_LAUNCH_TIMEOUT;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var item = this.props.item;
	
	
	      if (item instanceof _ServiceTree2.default) {
	        return this.getServiceTreeWarning(item);
	      }
	
	      // Display the declined offers warning if that's causing a delay. If not,
	      // we try to display an unable to launch warning, then default to nothing.
	      return this.getDeclinedOffersWarning(item) || this.getUnableToLaunchWarning(item) || _react2.default.createElement("noscript", null);
	    }
	  }]);
	  return ServiceStatusWarning;
	}(_react.Component);
	
	ServiceStatusWarning.propTypes = {
	  item: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_Service2.default), _react2.default.PropTypes.instanceOf(_ServiceTree2.default), _react2.default.PropTypes.instanceOf(_Pod2.default)])
	};
	
	module.exports = ServiceStatusWarning;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _UnitsHealthNodeDetail = __webpack_require__(1591);
	
	var _UnitsHealthNodeDetail2 = _interopRequireDefault(_UnitsHealthNodeDetail);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	var _NodeBreadcrumbs = __webpack_require__(1549);
	
	var _NodeBreadcrumbs2 = _interopRequireDefault(_NodeBreadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var NodesUnitsHealthDetailPage = function (_mixin) {
	  (0, _inherits3.default)(NodesUnitsHealthDetailPage, _mixin);
	
	  function NodesUnitsHealthDetailPage() {
	    (0, _classCallCheck3.default)(this, NodesUnitsHealthDetailPage);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NodesUnitsHealthDetailPage.__proto__ || (0, _getPrototypeOf2.default)(NodesUnitsHealthDetailPage)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "unitHealth",
	      events: ["unitSuccess", "nodeSuccess"]
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(NodesUnitsHealthDetailPage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(NodesUnitsHealthDetailPage.prototype.__proto__ || (0, _getPrototypeOf2.default)(NodesUnitsHealthDetailPage.prototype), "componentDidMount", this).apply(this, arguments);
	      var _props$params = this.props.params,
	          unitID = _props$params.unitID,
	          unitNodeID = _props$params.unitNodeID;
	
	
	      _UnitHealthStore2.default.fetchUnit(unitID);
	      _UnitHealthStore2.default.fetchUnitNode(unitID, unitNodeID);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$params2 = this.props.params,
	          unitID = _props$params2.unitID,
	          nodeID = _props$params2.nodeID;
	
	      var breadcrumbs = _react2.default.createElement(_NodeBreadcrumbs2.default, { nodeID: nodeID, unitID: unitID });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs }),
	        _react2.default.createElement(_UnitsHealthNodeDetail2.default, { params: this.props.params })
	      );
	    }
	  }]);
	  return NodesUnitsHealthDetailPage;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	/* eslint-enable no-unused-vars */
	
	
	module.exports = NodesUnitsHealthDetailPage;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _UnitHealthStore = __webpack_require__(1369);
	
	var _UnitHealthStore2 = _interopRequireDefault(_UnitHealthStore);
	
	var _UnitsHealthNodeDetailPanel = __webpack_require__(1374);
	
	var _UnitsHealthNodeDetailPanel2 = _interopRequireDefault(_UnitsHealthNodeDetailPanel);
	
	var _UnitSummaries = __webpack_require__(1381);
	
	var _UnitSummaries2 = _interopRequireDefault(_UnitSummaries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var UnitsHealthNodeDetail = function (_mixin) {
	  (0, _inherits3.default)(UnitsHealthNodeDetail, _mixin);
	
	  function UnitsHealthNodeDetail() {
	    (0, _classCallCheck3.default)(this, UnitsHealthNodeDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnitsHealthNodeDetail.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthNodeDetail)).apply(this, arguments));
	
	    _this.state = {
	      hasError: false,
	      isLoadingUnit: true,
	      isLoadingNode: true
	    };
	
	    _this.store_listeners = [{
	      name: "unitHealth",
	      events: ["unitSuccess", "unitError", "nodeSuccess", "nodeError"],
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(UnitsHealthNodeDetail, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(UnitsHealthNodeDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(UnitsHealthNodeDetail.prototype), "componentDidMount", this).apply(this, arguments);
	      var _props$params = this.props.params,
	          unitID = _props$params.unitID,
	          unitNodeID = _props$params.unitNodeID;
	
	
	      _UnitHealthStore2.default.fetchUnit(unitID);
	      _UnitHealthStore2.default.fetchUnitNode(unitID, unitNodeID);
	    }
	  }, {
	    key: "onUnitHealthStoreUnitSuccess",
	    value: function onUnitHealthStoreUnitSuccess() {
	      this.setState({ isLoadingUnit: false });
	    }
	  }, {
	    key: "onUnitHealthStoreUnitError",
	    value: function onUnitHealthStoreUnitError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "onUnitHealthStoreNodeSuccess",
	    value: function onUnitHealthStoreNodeSuccess() {
	      this.setState({ isLoadingNode: false });
	    }
	  }, {
	    key: "onUnitHealthStoreNodeError",
	    value: function onUnitHealthStoreNodeError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "getErrorNotice",
	    value: function getErrorNotice() {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod" },
	        _react2.default.createElement(_RequestErrorMsg2.default, null)
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          hasError = _state.hasError,
	          isLoadingNode = _state.isLoadingNode,
	          isLoadingUnit = _state.isLoadingUnit;
	
	
	      if (hasError) {
	        return this.getErrorNotice();
	      }
	
	      if (isLoadingNode || isLoadingUnit) {
	        return this.getLoadingScreen();
	      }
	
	      var _props$params2 = this.props.params,
	          unitID = _props$params2.unitID,
	          unitNodeID = _props$params2.unitNodeID;
	
	
	      var node = _UnitHealthStore2.default.getNode(unitNodeID);
	      var unit = _UnitHealthStore2.default.getUnit(unitID);
	
	      var unitSummary = _UnitSummaries2.default[unit.get("id")] || {};
	      var unitDocsURL = unitSummary.getDocumentationURI && unitSummary.getDocumentationURI();
	
	      return _react2.default.createElement(_UnitsHealthNodeDetailPanel2.default, {
	        routes: this.props.routes,
	        params: this.props.params,
	        docsURL: unitDocsURL,
	        hostIP: node.get("host_ip"),
	        output: node.getOutput(),
	        summary: unitSummary.summary
	      });
	    }
	  }]);
	  return UnitsHealthNodeDetail;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	/* eslint-disable no-unused-vars */
	
	
	module.exports = UnitsHealthNodeDetail;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _Volume = __webpack_require__(1095);
	
	var _Volume2 = _interopRequireDefault(_Volume);
	
	var _VolumeStatus = __webpack_require__(1096);
	
	var _VolumeStatus2 = _interopRequireDefault(_VolumeStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["renderIDColumn"];
	
	var VolumeTable = function (_React$Component) {
	  (0, _inherits3.default)(VolumeTable, _React$Component);
	
	  function VolumeTable() {
	    (0, _classCallCheck3.default)(this, VolumeTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (VolumeTable.__proto__ || (0, _getPrototypeOf2.default)(VolumeTable)).call(this));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(VolumeTable, [{
	    key: "getData",
	    value: function getData(volumes) {
	      return volumes.map(function (volume) {
	        return {
	          id: volume.getId(),
	          host: volume.getHost(),
	          type: volume.getType(),
	          path: volume.getContainerPath(),
	          size: volume.getSize(),
	          mode: volume.getMode(),
	          status: volume.getStatus()
	        };
	      });
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "30%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "5%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } })
	      );
	    }
	  }, {
	    key: "getColumnClassName",
	    value: function getColumnClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)({
	        active: prop === sortBy.prop,
	        clickable: row == null
	      });
	    }
	  }, {
	    key: "getColumnHeading",
	    value: function getColumnHeading(prop, order, sortBy) {
	      var _classNames;
	
	      var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", prop === sortBy.prop), _classNames));
	
	      var headingStrings = {
	        id: "ID",
	        host: "HOST",
	        type: "TYPE",
	        path: "PATH",
	        size: "SIZE",
	        mode: "MODE",
	        status: "STATUS"
	      };
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        headingStrings[prop],
	        _react2.default.createElement("span", { className: caretClassNames })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "id",
	        render: this.renderIDColumn,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "host",
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "type",
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "path",
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "size",
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "mode",
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "status",
	        render: this.renderStatusColumn,
	        sortable: true
	      }];
	    }
	  }, {
	    key: "renderIDColumn",
	    value: function renderIDColumn(prop, row) {
	      var id = row[prop];
	      var _props$params = this.props.params,
	          nodeID = _props$params.nodeID,
	          taskID = _props$params.taskID;
	
	      var volumeID = encodeURIComponent(id);
	      var serviceID = encodeURIComponent(this.props.params.id);
	      var currentroutePath = (0, _RouterUtil.reconstructPathFromRoutes)(this.props.routes);
	      var routePath = null;
	
	      if (currentroutePath === "/services/detail/:id/volumes") {
	        routePath = "/services/detail/" + serviceID + "/volumes/" + volumeID;
	      } else if (currentroutePath === "/services/detail/:id/tasks/:taskID/volumes") {
	        routePath = "/services/detail/" + serviceID + "/tasks/" + taskID + "/volumes/" + volumeID;
	      } else if (currentroutePath === "/nodes/:nodeID/tasks/:taskID/volumes") {
	        routePath = "/nodes/" + nodeID + "/tasks/" + taskID + "/volumes/" + volumeID;
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: "table-cell-link-primary", to: routePath },
	        id
	      );
	    }
	  }, {
	    key: "renderStatusColumn",
	    value: function renderStatusColumn(prop, row) {
	      var value = row[prop];
	      var classes = (0, _classnames2.default)({
	        "text-danger": value === _VolumeStatus2.default.DETACHED,
	        "text-success": value === _VolumeStatus2.default.ATTACHED
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: classes },
	        row[prop]
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        data: this.getData(this.props.service.getVolumes().getItems()),
	        sortBy: { prop: "id", order: "asc" }
	      });
	    }
	  }]);
	  return VolumeTable;
	}(_react2.default.Component);
	
	VolumeTable.propTypes = {
	  volumes: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.instanceOf(_Volume2.default)),
	  params: _react2.default.PropTypes.object.isRequired,
	  routes: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = VolumeTable;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SidebarActions = __webpack_require__(1334);
	
	var _SidebarActions2 = _interopRequireDefault(_SidebarActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = _react2.default.createClass({
	  displayName: "NotFoundPage",
	
	  statics: {
	    // Static life cycle method from react router, that will be called
	    // 'when a handler is about to render', i.e. on route change:
	    // https://github.com/rackt/react-router/
	    // blob/master/docs/api/components/RouteHandler.md
	    willTransitionTo: function willTransitionTo() {
	      _SidebarActions2.default.close();
	    }
	  },
	
	  render: function render() {
	    return _react2.default.createElement(
	      _Page2.default,
	      { title: "Page Not Found" },
	      _react2.default.createElement(
	        _AlertPanel2.default,
	        null,
	        _react2.default.createElement(
	          _AlertPanelHeader2.default,
	          null,
	          "Page not found"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The page you requested cannot be found. Check the address you provided, or head back to the",
	          " ",
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/dashboard" },
	            "Dashboard"
	          ),
	          "."
	        )
	      )
	    );
	  }
	});
	
	module.exports = NotFoundPage;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _OrganizationPage = __webpack_require__(1595);
	
	var _OrganizationPage2 = _interopRequireDefault(_OrganizationPage);
	
	var _UsersPage = __webpack_require__(1270);
	
	var _UsersPage2 = _interopRequireDefault(_UsersPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var RouteFactory = {
	  getOrganizationRoutes: function getOrganizationRoutes() {
	    // Return filtered Routes
	    return _PluginSDK.Hooks.applyFilter("organizationRoutes", {
	      routes: [{
	        type: _reactRouter.Route,
	        path: "users",
	        component: _UsersPage2.default,
	        isInSidebar: true,
	        children: []
	      }],
	      redirect: {
	        type: _reactRouter.Redirect,
	        from: "/organization",
	        to: "/organization/users"
	      }
	    });
	  },
	  getRoutes: function getRoutes() {
	    var _getOrganizationRoute = this.getOrganizationRoutes(),
	        routes = _getOrganizationRoute.routes,
	        redirect = _getOrganizationRoute.redirect;
	
	    return [
	    // Redirect should always go before path, otherwise router won't ever reach it
	    redirect, {
	      type: _reactRouter.Route,
	      path: "organization",
	      component: _OrganizationPage2.default,
	      category: "system",
	      isInSidebar: true,
	      children: routes
	    }];
	  }
	}; /* eslint-disable no-unused-vars */
	
	
	module.exports = RouteFactory;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationPage = function (_React$Component) {
	  (0, _inherits3.default)(OrganizationPage, _React$Component);
	
	  function OrganizationPage() {
	    (0, _classCallCheck3.default)(this, OrganizationPage);
	    return (0, _possibleConstructorReturn3.default)(this, (OrganizationPage.__proto__ || (0, _getPrototypeOf2.default)(OrganizationPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(OrganizationPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return OrganizationPage;
	}(_react2.default.Component);
	
	OrganizationPage.routeConfig = {
	  label: "Organization",
	  icon: _react2.default.createElement(_Icon2.default, { id: "users-inverse", size: "small", family: "product" }),
	  matches: /^\/organization/
	};
	
	module.exports = OrganizationPage;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ServicesContainer = __webpack_require__(1597);
	
	var _ServicesContainer2 = _interopRequireDefault(_ServicesContainer);
	
	var _CreateServiceModal = __webpack_require__(1661);
	
	var _CreateServiceModal2 = _interopRequireDefault(_CreateServiceModal);
	
	var _ServicesPage = __webpack_require__(1822);
	
	var _ServicesPage2 = _interopRequireDefault(_ServicesPage);
	
	var _ServiceTaskDetailPage = __webpack_require__(1823);
	
	var _ServiceTaskDetailPage2 = _interopRequireDefault(_ServiceTaskDetailPage);
	
	var _ServiceVolumeContainer = __webpack_require__(1824);
	
	var _ServiceVolumeContainer2 = _interopRequireDefault(_ServiceVolumeContainer);
	
	var _TaskDetailsTab = __webpack_require__(1499);
	
	var _TaskDetailsTab2 = _interopRequireDefault(_TaskDetailsTab);
	
	var _TaskFileBrowser = __webpack_require__(1504);
	
	var _TaskFileBrowser2 = _interopRequireDefault(_TaskFileBrowser);
	
	var _TaskFilesTab = __webpack_require__(1507);
	
	var _TaskFilesTab2 = _interopRequireDefault(_TaskFilesTab);
	
	var _TaskFileViewer = __webpack_require__(1508);
	
	var _TaskFileViewer2 = _interopRequireDefault(_TaskFileViewer);
	
	var _TaskLogsContainer = __webpack_require__(1518);
	
	var _TaskLogsContainer2 = _interopRequireDefault(_TaskLogsContainer);
	
	var _TaskVolumeContainer = __webpack_require__(1582);
	
	var _TaskVolumeContainer2 = _interopRequireDefault(_TaskVolumeContainer);
	
	var _VolumeTable = __webpack_require__(1592);
	
	var _VolumeTable2 = _interopRequireDefault(_VolumeTable);
	
	var _HighOrderServiceConfiguration = __webpack_require__(1825);
	
	var _HighOrderServiceConfiguration2 = _interopRequireDefault(_HighOrderServiceConfiguration);
	
	var _HighOrderServiceDebug = __webpack_require__(1829);
	
	var _HighOrderServiceDebug2 = _interopRequireDefault(_HighOrderServiceDebug);
	
	var _HighOrderServiceInstances = __webpack_require__(1837);
	
	var _HighOrderServiceInstances2 = _interopRequireDefault(_HighOrderServiceInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var serviceRoutes = [{
	  type: _reactRouter.Redirect,
	  from: "/services",
	  to: "/services/overview"
	}, {
	  type: _reactRouter.Route,
	  component: _ServicesPage2.default,
	  path: "services",
	  category: "root",
	  isInSidebar: true,
	  children: [
	  // Service Tree View routes
	  {
	    type: _reactRouter.Route,
	    component: _ServicesContainer2.default,
	    path: "overview",
	    children: [{
	      type: _reactRouter.Route,
	      path: "create",
	      component: _CreateServiceModal2.default
	    }, {
	      type: _reactRouter.Route,
	      path: ":id",
	      children: [{
	        type: _reactRouter.Route,
	        path: "create",
	        component: _CreateServiceModal2.default
	      }]
	    }]
	  },
	  // Service Detail routes
	  {
	    type: _reactRouter.Redirect,
	    from: "/services/detail/:id",
	    to: "/services/detail/:id/tasks"
	  }, {
	    type: _reactRouter.Route,
	    component: _ServicesContainer2.default,
	    path: "detail/:id",
	    children: [{
	      type: _reactRouter.Route,
	      path: "create",
	      component: _CreateServiceModal2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "edit(/:version)",
	      component: _CreateServiceModal2.default
	    },
	    // This route needs to be rendered outside of the tabs that are
	    // rendered in the service-task-details route.
	    {
	      type: _reactRouter.Route,
	      path: "volumes/:volumeID",
	      component: _ServiceVolumeContainer2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "configuration",
	      title: "Configuration",
	      component: _HighOrderServiceConfiguration2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "debug",
	      title: "Debug",
	      component: _HighOrderServiceDebug2.default
	    }, {
	      type: _reactRouter.Route,
	      path: "volumes",
	      title: "Volumes",
	      component: _VolumeTable2.default
	    }, {
	      type: _reactRouter.Route,
	      title: "Instances",
	      path: "tasks",
	      component: _HighOrderServiceInstances2.default
	    }, {
	      type: _reactRouter.Redirect,
	      path: "/services/detail/:id/tasks/:taskID",
	      to: "/services/detail/:id/tasks/:taskID/details"
	    }, {
	      type: _reactRouter.Route,
	      title: "Instances",
	      path: "tasks/:taskID",
	      component: _ServiceTaskDetailPage2.default,
	      hideHeaderNavigation: true,
	      children: [{
	        type: _reactRouter.Route,
	        component: _TaskDetailsTab2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "details",
	        title: "Details"
	      }, {
	        hideHeaderNavigation: true,
	        component: _TaskFilesTab2.default,
	        isTab: true,
	        path: "files",
	        title: "Files",
	        type: _reactRouter.Route,
	        children: [{
	          component: _TaskFileBrowser2.default,
	          fileViewerRoutePath: "/services/detail/:id/tasks/:taskID/files/view(/:filePath(/:innerPath))",
	          hideHeaderNavigation: true,
	          type: _reactRouter.IndexRoute
	        }, {
	          component: _TaskFileViewer2.default,
	          hideHeaderNavigation: true,
	          path: "view(/:filePath(/:innerPath))",
	          type: _reactRouter.Route
	        }]
	      }, {
	        component: _TaskLogsContainer2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "logs",
	        title: "Logs",
	        type: _reactRouter.Route,
	        children: [{
	          path: ":filePath",
	          type: _reactRouter.Route
	        }]
	      }, {
	        component: _VolumeTable2.default,
	        hideHeaderNavigation: true,
	        isTab: true,
	        path: "volumes",
	        title: "Volumes",
	        type: _reactRouter.Route
	      }, {
	        type: _reactRouter.Route,
	        hideHeaderNavigation: true,
	        path: "volumes/:volumeID",
	        component: _TaskVolumeContainer2.default
	      }]
	    }]
	  }]
	}];
	/* eslint-enable no-unused-vars */
	
	module.exports = serviceRoutes;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _EventTypes = __webpack_require__(933);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ContainerUtil = __webpack_require__(1553);
	
	var _ContainerUtil2 = _interopRequireDefault(_ContainerUtil);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLFilterList = __webpack_require__(1606);
	
	var _DSLFilterList2 = _interopRequireDefault(_DSLFilterList);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodDetail = __webpack_require__(1609);
	
	var _PodDetail2 = _interopRequireDefault(_PodDetail);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionItem2 = _interopRequireDefault(_ServiceActionItem);
	
	var _ServiceAttributeHasVolumesFilter = __webpack_require__(1626);
	
	var _ServiceAttributeHasVolumesFilter2 = _interopRequireDefault(_ServiceAttributeHasVolumesFilter);
	
	var _ServiceAttributeHealthFilter = __webpack_require__(1628);
	
	var _ServiceAttributeHealthFilter2 = _interopRequireDefault(_ServiceAttributeHealthFilter);
	
	var _ServiceAttributeIsFilter = __webpack_require__(1629);
	
	var _ServiceAttributeIsFilter2 = _interopRequireDefault(_ServiceAttributeIsFilter);
	
	var _ServiceAttributeIsPodFilter = __webpack_require__(1630);
	
	var _ServiceAttributeIsPodFilter2 = _interopRequireDefault(_ServiceAttributeIsPodFilter);
	
	var _ServiceAttributeIsCatalogFilter = __webpack_require__(1631);
	
	var _ServiceAttributeIsCatalogFilter2 = _interopRequireDefault(_ServiceAttributeIsCatalogFilter);
	
	var _ServiceAttributeNoHealthchecksFilter = __webpack_require__(1632);
	
	var _ServiceAttributeNoHealthchecksFilter2 = _interopRequireDefault(_ServiceAttributeNoHealthchecksFilter);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	var _ServiceDetail = __webpack_require__(1633);
	
	var _ServiceDetail2 = _interopRequireDefault(_ServiceDetail);
	
	var _ServiceItemNotFound = __webpack_require__(1583);
	
	var _ServiceItemNotFound2 = _interopRequireDefault(_ServiceItemNotFound);
	
	var _ServiceModals = __webpack_require__(1614);
	
	var _ServiceModals2 = _interopRequireDefault(_ServiceModals);
	
	var _ServiceNameTextFilter = __webpack_require__(1636);
	
	var _ServiceNameTextFilter2 = _interopRequireDefault(_ServiceNameTextFilter);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _ServiceTreeView = __webpack_require__(1637);
	
	var _ServiceTreeView2 = _interopRequireDefault(_ServiceTreeView);
	
	var _ActionTypes = __webpack_require__(1223);
	
	var _EventTypes2 = __webpack_require__(1103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SERVICE_FILTERS = new _DSLFilterList2.default([new _ServiceAttributeHealthFilter2.default(), new _ServiceAttributeHasVolumesFilter2.default(), new _ServiceAttributeIsFilter2.default(), new _ServiceAttributeIsPodFilter2.default(), new _ServiceAttributeIsCatalogFilter2.default(), new _ServiceAttributeNoHealthchecksFilter2.default(), new _ServiceNameTextFilter2.default()]);
	
	/**
	 * Increments error count for each fetch type when we have a request error and
	 * resets to zero when fetch was successful for type
	 * @param  {Object} fetchErrors
	 * @param  {Object} action
	 * @return {Object} updated fetch errors
	 */
	function countFetchErrors(fetchErrors, action) {
	  switch (action.type) {
	    case _EventTypes2.MARATHON_DEPLOYMENTS_ERROR:
	    case _EventTypes2.MARATHON_GROUPS_ERROR:
	    case _EventTypes2.MARATHON_QUEUE_ERROR:
	    case _EventTypes2.MARATHON_SERVICE_VERSIONS_ERROR:
	      fetchErrors[action.type] = (fetchErrors[action.type] || 0) + 1;
	
	      return fetchErrors;
	
	    case _EventTypes2.MARATHON_DEPLOYMENTS_CHANGE:
	    case _EventTypes2.MARATHON_GROUPS_CHANGE:
	    case _EventTypes2.MARATHON_QUEUE_CHANGE:
	    case _EventTypes2.MARATHON_SERVICE_VERSIONS_CHANGE:
	      fetchErrors[action.type] = 0;
	
	      return fetchErrors;
	
	    default:
	      return false;
	  }
	}
	
	var METHODS_TO_BIND = ["handleServerAction", "handleFilterExpressionChange", "handleModalClose", "clearActionError", "createGroup", "revertDeployment", "deleteGroup", "editGroup", "deleteService", "editService", "restartService", "onStoreChange"];
	
	var ServicesContainer = function (_React$Component) {
	  (0, _inherits3.default)(ServicesContainer, _React$Component);
	
	  function ServicesContainer() {
	    (0, _classCallCheck3.default)(this, ServicesContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServicesContainer.__proto__ || (0, _getPrototypeOf2.default)(ServicesContainer)).apply(this, arguments));
	
	    _this.state = {
	      actionErrors: {},
	      fetchErrors: {},
	      filterExpression: new _DSLExpression2.default(),
	      isLoading: true,
	      lastUpdate: 0,
	      pendingActions: {}
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServicesContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _DCOSStore2.default.addChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	
	      // Listen for server actions so we can update state immediately
	      // on the completion of an API request.
	      this.dispatcher = _AppDispatcher2.default.register(this.handleServerAction);
	    }
	  }, {
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.propsToState(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.propsToState(nextProps);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _AppDispatcher2.default.unregister(this.dispatcher);
	
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        modalHandlers: this.getModalHandlers()
	      };
	    }
	  }, {
	    key: "propsToState",
	    value: function propsToState(props) {
	      var itemId = decodeURIComponent(props.params.id || "/");
	      var filterQuery = props.location.query["q"] || "";
	
	      this.setState({
	        filterExpression: new _DSLExpression2.default(filterQuery),
	        itemId: itemId
	      });
	    }
	  }, {
	    key: "onStoreChange",
	    value: function onStoreChange() {
	      // Throttle updates from DCOSStore
	      if (Date.now() - this.state.lastUpdate > 1000 || _DCOSStore2.default.serviceDataReceived && this.state.isLoading) {
	        this.setState({
	          isLoading: !_DCOSStore2.default.serviceDataReceived,
	          lastUpdate: Date.now()
	        });
	      }
	    }
	  }, {
	    key: "revertDeployment",
	    value: function revertDeployment() {
	      this.setPendingAction(_ActionKeys2.default.REVERT_DEPLOYMENT);
	
	      return _MarathonActions2.default.revertDeployment.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "createGroup",
	    value: function createGroup() {
	      this.setPendingAction(_ActionKeys2.default.GROUP_CREATE);
	
	      return _MarathonActions2.default.createGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "deleteGroup",
	    value: function deleteGroup() {
	      this.setPendingAction(_ActionKeys2.default.GROUP_DELETE);
	
	      return _MarathonActions2.default.deleteGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "editGroup",
	    value: function editGroup() {
	      this.setPendingAction(_ActionKeys2.default.GROUP_EDIT);
	
	      return _MarathonActions2.default.editGroup.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "deleteService",
	    value: function deleteService() {
	      this.setPendingAction(_ActionKeys2.default.SERVICE_DELETE);
	
	      return _MarathonActions2.default.deleteService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "editService",
	    value: function editService() {
	      this.setPendingAction(_ActionKeys2.default.SERVICE_EDIT);
	
	      return _MarathonActions2.default.editService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "restartService",
	    value: function restartService() {
	      this.setPendingAction(_ActionKeys2.default.SERVICE_RESTART);
	
	      return _MarathonActions2.default.restartService.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "handleServerAction",
	    value: function handleServerAction(payload) {
	      var action = payload.action;
	
	      // Increment/clear fetching errors based on action
	
	      var fetchErrors = countFetchErrors((0, _assign2.default)({}, this.state.fetchErrors), action);
	
	      // Only set state if fetchErrors changed
	      if (fetchErrors) {
	        this.setState({ fetchErrors: fetchErrors });
	      }
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.REVERT_DEPLOYMENT, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_DEPLOYMENT_ROLLBACK_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.REVERT_DEPLOYMENT);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_GROUP_CREATE_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_CREATE, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_GROUP_CREATE_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_CREATE);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_GROUP_DELETE_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_DELETE, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_GROUP_DELETE_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_DELETE);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_GROUP_EDIT_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_EDIT, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_GROUP_EDIT_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.GROUP_EDIT);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_DELETE_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_DELETE, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_DELETE_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_DELETE);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_EDIT_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_EDIT, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_EDIT_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_EDIT);
	          break;
	
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_RESTART_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_RESTART, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_SERVICE_RESTART_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.SERVICE_RESTART);
	          break;
	      }
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose(key) {
	      if (key) {
	        this.clearActionError(key);
	      }
	      this.setState({ modal: {} });
	    }
	  }, {
	    key: "handleFilterExpressionChange",
	    value: function handleFilterExpressionChange(filterExpression) {
	      var router = this.context.router;
	      var pathname = this.props.location.pathname;
	
	      router.push({ pathname: pathname, query: { q: filterExpression.value } });
	
	      this.setState({ filterExpression: filterExpression });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {}
	    // Re-fetch data - this will end up being a single Relay request
	
	    /**
	     * Sets the actionType to pending in state which will in turn be pushed
	     * to children components as a prop. Also clears any existing error for
	     * the actionType
	     * @param {String} actionType
	     */
	
	  }, {
	    key: "setPendingAction",
	    value: function setPendingAction(actionType) {
	      var _state = this.state,
	          actionErrors = _state.actionErrors,
	          pendingActions = _state.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, true)
	      });
	    }
	    /**
	     * Sets the pending actionType to false in state which will in turn be
	     * pushed down to children via props. Can optional set an error for the
	     * actionType
	     * @param  {String} actionType
	     * @param  {Any} error
	     */
	
	  }, {
	    key: "unsetPendingAction",
	    value: function unsetPendingAction(actionType) {
	      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var _state2 = this.state,
	          actionErrors = _state2.actionErrors,
	          pendingActions = _state2.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, error),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, false)
	      });
	
	      // Fetch new data if action was successful
	      if (!error) {
	        this.fetchData();
	      }
	    }
	  }, {
	    key: "clearActionError",
	    value: function clearActionError(actionType) {
	      var actionErrors = this.state.actionErrors;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null)
	      });
	    }
	  }, {
	    key: "getModalHandlers",
	    value: function getModalHandlers() {
	      var _this2 = this;
	
	      var set = function set(id, props) {
	        // Set props to be passed into modal
	        _this2.setState({
	          modal: (0, _assign2.default)({}, props, { id: id })
	        });
	      };
	
	      return {
	        createGroup: function createGroup() {
	          return set(_ServiceActionItem2.default.CREATE_GROUP);
	        },
	        openServiceUI: function openServiceUI(props) {
	          global.open(props.service.getWebURL(), "_blank");
	        },
	
	        // All methods below work on ServiceTree and Service types
	        deleteService: function deleteService(props) {
	          return set(_ServiceActionItem2.default.DELETE, props);
	        },
	        editService: function editService(props) {
	          return set(_ServiceActionItem2.default.EDIT, props);
	        },
	        restartService: function restartService(props) {
	          return set(_ServiceActionItem2.default.RESTART, props);
	        },
	        resumeService: function resumeService(props) {
	          return set(_ServiceActionItem2.default.RESUME, props);
	        },
	        scaleService: function scaleService(props) {
	          return set(_ServiceActionItem2.default.SCALE, props);
	        },
	        suspendService: function suspendService(props) {
	          return set(_ServiceActionItem2.default.SUSPEND, props);
	        }
	      };
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      return {
	        revertDeployment: this.revertDeployment,
	        createGroup: this.createGroup,
	        deleteGroup: this.deleteGroup,
	        editGroup: this.editGroup,
	        deleteService: this.deleteService,
	        editService: this.editService,
	        restartService: this.restartService
	      };
	    }
	  }, {
	    key: "getModals",
	    value: function getModals(service) {
	      var modalProps = (0, _assign2.default)({}, this.state.modal);
	
	      if (!modalProps.service) {
	        modalProps.service = service;
	      }
	
	      return _react2.default.createElement(_ServiceModals2.default, {
	        actions: this.getActions(),
	        actionErrors: this.state.actionErrors,
	        clearError: this.clearActionError,
	        onClose: this.handleModalClose,
	        pendingActions: this.state.pendingActions,
	        modalProps: modalProps
	      });
	    }
	  }, {
	    key: "getEmpyPage",
	    value: function getEmpyPage(itemType) {
	      var itemId = this.state.itemId;
	
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(_ServiceBreadcrumbs2.default, null) }),
	        _react2.default.createElement(_ServiceItemNotFound2.default, {
	          message: "The " + itemType + " with the ID of \"" + itemId + "\" could not be found."
	        })
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      var itemId = this.state.itemId;
	
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: itemId }) }),
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "getPodDetail",
	    value: function getPodDetail(item) {
	      var _props = this.props,
	          children = _props.children,
	          params = _props.params,
	          routes = _props.routes;
	
	
	      return _react2.default.createElement(
	        _PodDetail2.default,
	        {
	          actions: this.getActions(),
	          params: params,
	          pod: item,
	          routes: routes
	        },
	        children,
	        this.getModals(item)
	      );
	    }
	  }, {
	    key: "getServiceDetail",
	    value: function getServiceDetail(item) {
	      var _props2 = this.props,
	          children = _props2.children,
	          params = _props2.params,
	          routes = _props2.routes;
	
	
	      return _react2.default.createElement(
	        _ServiceDetail2.default,
	        {
	          actions: this.getActions(),
	          errors: this.state.actionErrors,
	          clearError: this.clearActionError,
	          params: params,
	          routes: routes,
	          service: item
	        },
	        children,
	        this.getModals(item)
	      );
	    }
	  }, {
	    key: "getServiceTree",
	    value: function getServiceTree(item) {
	      var _props3 = this.props,
	          children = _props3.children,
	          params = _props3.params,
	          routes = _props3.routes;
	      var filterExpression = this.state.filterExpression;
	
	
	      var isEmpty = item.getItems().length === 0;
	      var filteredServices = item;
	
	      if (filterExpression.defined) {
	        filteredServices = filterExpression.filter(SERVICE_FILTERS, filteredServices.flattenItems());
	      }
	
	      // TODO: move modals to Page
	      return _react2.default.createElement(
	        _ServiceTreeView2.default,
	        {
	          filters: SERVICE_FILTERS,
	          filterExpression: filterExpression,
	          isEmpty: isEmpty,
	          onFilterExpressionChange: this.handleFilterExpressionChange,
	          params: params,
	          routes: routes,
	          services: filteredServices.getItems(),
	          serviceTree: item
	        },
	        children,
	        this.getModals(item)
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props4 = this.props,
	          children = _props4.children,
	          params = _props4.params,
	          routes = _props4.routes;
	      var _state3 = this.state,
	          fetchErrors = _state3.fetchErrors,
	          isLoading = _state3.isLoading,
	          itemId = _state3.itemId;
	      // TODO react-router: Temp hack if we are deeper than overview/:id we should render child routes
	
	      if ((0, _keys2.default)(params).length > 1) {
	        return children;
	      }
	
	      // Still Loading
	      if (isLoading) {
	        return this.getLoadingScreen();
	      }
	
	      // Check if a single endpoint has failed more than 3 times
	      var fetchError = (0, _values2.default)(fetchErrors).some(function (errorCount) {
	        return errorCount > 3;
	      });
	
	      // API Failures
	      if (fetchError) {
	        return _react2.default.createElement(_RequestErrorMsg2.default, null);
	      }
	
	      // Find item in root tree
	      var item = itemId === "/" ? _DCOSStore2.default.serviceTree : _DCOSStore2.default.serviceTree.findItemById(itemId);
	
	      // Show Tree
	      var currentRoutePath = (0, _RouterUtil.reconstructPathFromRoutes)(routes);
	      if (currentRoutePath.startsWith("/services/overview")) {
	        // Not found
	        if (!(item instanceof _ServiceTree2.default)) {
	          return this.getEmpyPage("group");
	        }
	
	        // TODO: move modals to Page
	        return this.getServiceTree(item);
	      }
	
	      if (item instanceof _Pod2.default) {
	        return this.getPodDetail(item);
	      }
	
	      if (item instanceof _Service2.default) {
	        return this.getServiceDetail(item);
	      }
	
	      // Not found
	      return this.getEmpyPage("service");
	    }
	  }]);
	  return ServicesContainer;
	}(_react2.default.Component);
	
	// Make these modal handlers available via context
	// so any child can trigger the opening of modals
	
	
	ServicesContainer.childContextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    createGroup: _react.PropTypes.func,
	    deleteService: _react.PropTypes.func,
	    editService: _react.PropTypes.func,
	    restartService: _react.PropTypes.func,
	    resumeService: _react.PropTypes.func,
	    scaleService: _react.PropTypes.func,
	    suspendService: _react.PropTypes.func,
	    openServiceUI: _react.PropTypes.func
	  })
	};
	
	ServicesContainer.propTypes = {
	  params: _react.PropTypes.object.isRequired,
	  location: _react.PropTypes.object.isRequired
	};
	
	ServicesContainer.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	ServicesContainer.routeConfig = {
	  label: "Services",
	  icon: _react2.default.createElement(_Icon2.default, { id: "services", size: "small", family: "product" }),
	  matches: /^\/services\/(detail|overview)/
	};
	
	module.exports = ServicesContainer;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperties = __webpack_require__(1599);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _SearchDSL = __webpack_require__(1601);
	
	var _SearchDSL2 = _interopRequireDefault(_SearchDSL);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is a high-level compnent that wraps
	 */
	var DSLExpression =
	/**
	 * Construct an immutable DSL expression
	 *
	 * @param {String} value - The expression string
	 */
	function DSLExpression() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	  (0, _classCallCheck3.default)(this, DSLExpression);
	
	  var ast = null;
	  var cleanValue = value.trim();
	  var filter = function filter(filters, resultset) {
	    return resultset;
	  };
	  var hasErrors = false;
	
	  if (cleanValue !== "") {
	    // Try to parse the expression
	    try {
	      var result = _SearchDSL2.default.parse(cleanValue);
	      if (result.ast && result.filter) {
	        ast = result.ast;
	        filter = result.filter;
	      }
	    } catch (e) {
	      hasErrors = true;
	    }
	  }
	
	  // Define properties
	  (0, _defineProperties2.default)(this, {
	    ast: {
	      value: ast,
	      writable: false,
	      enumerable: true
	    },
	    defined: {
	      value: Boolean(value),
	      writable: false,
	      enumerable: true
	    },
	    filter: {
	      value: filter,
	      writable: false,
	      enumerable: true
	    },
	    hasErrors: {
	      value: hasErrors,
	      writable: false,
	      enumerable: true
	    },
	    value: {
	      value: value,
	      writable: false,
	      enumerable: true
	    }
	  });
	};
	
	module.exports = DSLExpression;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1600), __esModule: true };

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(874);
	module.exports = function defineProperties(T, D){
	  return $.setDescs(T, D);
	};

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/* parser generated by jison 0.4.17 */
	/*
	  Returns a Parser object of the following structure:
	
	  Parser: {
	    yy: {}
	  }
	
	  Parser.prototype: {
	    yy: {},
	    trace: function(),
	    symbols_: {associative list: name ==> number},
	    terminals_: {associative list: number ==> name},
	    productions_: [...],
	    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
	    table: [...],
	    defaultActions: {...},
	    parseError: function(str, hash),
	    parse: function(input),
	
	    lexer: {
	        EOF: 1,
	        parseError: function(str, hash),
	        setInput: function(input),
	        input: function(),
	        unput: function(str),
	        more: function(),
	        less: function(n),
	        pastInput: function(),
	        upcomingInput: function(),
	        showPosition: function(),
	        test_match: function(regex_match_array, rule_index),
	        next: function(),
	        lex: function(),
	        begin: function(condition),
	        popState: function(),
	        _currentRules: function(),
	        topState: function(),
	        pushState: function(condition),
	
	        options: {
	            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
	            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
	            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
	        },
	
	        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
	        rules: [...],
	        conditions: {associative list: name ==> set},
	    }
	  }
	
	
	  token location info (@$, _$, etc.): {
	    first_line: n,
	    last_line: n,
	    first_column: n,
	    last_column: n,
	    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
	  }
	
	
	  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
	    text:        (matched text)
	    token:       (the produced terminal token, if any)
	    line:        (yylineno)
	  }
	  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
	    loc:         (yylloc)
	    expected:    (string describing the set of expected tokens)
	    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
	  }
	*/
	var parser = (function(){
	var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,4],$V1=[1,5],$V2=[1,3],$V3=[1,6],$V4=[1,8],$V5=[1,9],$V6=[5,10,11,13],$V7=[1,12],$V8=[1,13],$V9=[5,9,10,11,13];
	var parser = {trace: function trace() { },
	yy: {},
	symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"lv":6,"LITERAL":7,"STRING":8,"TIGHT_COMMA":9,"WS":10,"COMMA":11,"(":12,")":13,"LABEL":14,"$accept":0,"$end":1},
	terminals_: {2:"error",5:"EOF",7:"LITERAL",8:"STRING",9:"TIGHT_COMMA",10:"WS",11:"COMMA",12:"(",13:")",14:"LABEL"},
	productions_: [0,[3,2],[6,1],[6,1],[6,3],[4,3],[4,3],[4,3],[4,1],[4,1],[4,2],[4,1]],
	performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
	/* this == yyval */
	
	var $0 = $$.length - 1;
	switch (yystate) {
	case 1:
	return $$[$0-1];
	break;
	case 2: case 3:
	this.$ = [{text:yytext, start:_$[$0].first_column, end:_$[$0].last_column}];
	break;
	case 4:
	this.$ = [].concat($$[$0-2], $$[$0]);
	break;
	case 5:
	this.$ = Merge.and($$[$0-2], $$[$0]);
	break;
	case 6:
	this.$ = Merge.or($$[$0-2], $$[$0]);
	break;
	case 7:
	this.$ = $$[$0-1];
	break;
	case 8:
	this.$ = Operator.fuzzy(yytext, _$[$0].first_column, _$[$0].last_column);
	break;
	case 9:
	this.$ = Operator.exact(yytext, _$[$0].first_column, _$[$0].last_column);
	break;
	case 10:
	this.$ = $$[$0].reduce(function (last_fn, v) {
	            var fn = Operator.attribute($$[$0-1], v.text, _$[$0-1].first_column, _$[$0-1].last_column, v.start, v.end);
	            if (last_fn) {
	                return Merge.or(last_fn, fn);
	            } else {
	                return fn;
	            }
	        }, null);
	break;
	case 11:
	this.$ = yytext;
	break;
	}
	},
	table: [{3:1,4:2,7:$V0,8:$V1,12:$V2,14:$V3},{1:[3]},{5:[1,7],10:$V4,11:$V5},{4:10,7:$V0,8:$V1,12:$V2,14:$V3},o($V6,[2,8]),o($V6,[2,9]),o($V6,[2,11],{6:11,7:$V7,8:$V8}),{1:[2,1]},{4:14,7:$V0,8:$V1,12:$V2,14:$V3},{4:15,7:$V0,8:$V1,12:$V2,14:$V3},{10:$V4,11:$V5,13:[1,16]},o($V6,[2,10],{9:[1,17]}),o($V9,[2,2]),o($V9,[2,3]),o($V6,[2,5]),o($V6,[2,6]),o($V6,[2,7]),{6:18,7:$V7,8:$V8},o($V9,[2,4])],
	defaultActions: {7:[2,1]},
	parseError: function parseError(str, hash) {
	    if (hash.recoverable) {
	        this.trace(str);
	    } else {
	        function _parseError (msg, hash) {
	            this.message = msg;
	            this.hash = hash;
	        }
	        _parseError.prototype = Error;
	
	        throw new _parseError(str, hash);
	    }
	},
	parse: function parse(input) {
	    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
	    var args = lstack.slice.call(arguments, 1);
	    var lexer = Object.create(this.lexer);
	    var sharedState = { yy: {} };
	    for (var k in this.yy) {
	        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
	            sharedState.yy[k] = this.yy[k];
	        }
	    }
	    lexer.setInput(input, sharedState.yy);
	    sharedState.yy.lexer = lexer;
	    sharedState.yy.parser = this;
	    if (typeof lexer.yylloc == 'undefined') {
	        lexer.yylloc = {};
	    }
	    var yyloc = lexer.yylloc;
	    lstack.push(yyloc);
	    var ranges = lexer.options && lexer.options.ranges;
	    if (typeof sharedState.yy.parseError === 'function') {
	        this.parseError = sharedState.yy.parseError;
	    } else {
	        this.parseError = Object.getPrototypeOf(this).parseError;
	    }
	    function popStack(n) {
	        stack.length = stack.length - 2 * n;
	        vstack.length = vstack.length - n;
	        lstack.length = lstack.length - n;
	    }
	    _token_stack:
	        var lex = function () {
	            var token;
	            token = lexer.lex() || EOF;
	            if (typeof token !== 'number') {
	                token = self.symbols_[token] || token;
	            }
	            return token;
	        };
	    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	    while (true) {
	        state = stack[stack.length - 1];
	        if (this.defaultActions[state]) {
	            action = this.defaultActions[state];
	        } else {
	            if (symbol === null || typeof symbol == 'undefined') {
	                symbol = lex();
	            }
	            action = table[state] && table[state][symbol];
	        }
	                    if (typeof action === 'undefined' || !action.length || !action[0]) {
	                var errStr = '';
	                expected = [];
	                for (p in table[state]) {
	                    if (this.terminals_[p] && p > TERROR) {
	                        expected.push('\'' + this.terminals_[p] + '\'');
	                    }
	                }
	                if (lexer.showPosition) {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
	                } else {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
	                }
	                this.parseError(errStr, {
	                    text: lexer.match,
	                    token: this.terminals_[symbol] || symbol,
	                    line: lexer.yylineno,
	                    loc: yyloc,
	                    expected: expected
	                });
	            }
	        if (action[0] instanceof Array && action.length > 1) {
	            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
	        }
	        switch (action[0]) {
	        case 1:
	            stack.push(symbol);
	            vstack.push(lexer.yytext);
	            lstack.push(lexer.yylloc);
	            stack.push(action[1]);
	            symbol = null;
	            if (!preErrorSymbol) {
	                yyleng = lexer.yyleng;
	                yytext = lexer.yytext;
	                yylineno = lexer.yylineno;
	                yyloc = lexer.yylloc;
	                if (recovering > 0) {
	                    recovering--;
	                }
	            } else {
	                symbol = preErrorSymbol;
	                preErrorSymbol = null;
	            }
	            break;
	        case 2:
	            len = this.productions_[action[1]][1];
	            yyval.$ = vstack[vstack.length - len];
	            yyval._$ = {
	                first_line: lstack[lstack.length - (len || 1)].first_line,
	                last_line: lstack[lstack.length - 1].last_line,
	                first_column: lstack[lstack.length - (len || 1)].first_column,
	                last_column: lstack[lstack.length - 1].last_column
	            };
	            if (ranges) {
	                yyval._$.range = [
	                    lstack[lstack.length - (len || 1)].range[0],
	                    lstack[lstack.length - 1].range[1]
	                ];
	            }
	            r = this.performAction.apply(yyval, [
	                yytext,
	                yyleng,
	                yylineno,
	                sharedState.yy,
	                action[1],
	                vstack,
	                lstack
	            ].concat(args));
	            if (typeof r !== 'undefined') {
	                return r;
	            }
	            if (len) {
	                stack = stack.slice(0, -1 * len * 2);
	                vstack = vstack.slice(0, -1 * len);
	                lstack = lstack.slice(0, -1 * len);
	            }
	            stack.push(this.productions_[action[1]][0]);
	            vstack.push(yyval.$);
	            lstack.push(yyval._$);
	            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	            stack.push(newState);
	            break;
	        case 3:
	            return true;
	        }
	    }
	    return true;
	}};
	
	var DSLParserUtil = __webpack_require__(1602);
	var Merge = DSLParserUtil.Merge;
	var Operator = DSLParserUtil.Operator;
	/* generated by jison-lex 0.3.4 */
	var lexer = (function(){
	var lexer = ({
	
	EOF:1,
	
	parseError:function parseError(str, hash) {
	        if (this.yy.parser) {
	            this.yy.parser.parseError(str, hash);
	        } else {
	            throw new Error(str);
	        }
	    },
	
	// resets the lexer, sets new input
	setInput:function (input, yy) {
	        this.yy = yy || this.yy || {};
	        this._input = input;
	        this._more = this._backtrack = this.done = false;
	        this.yylineno = this.yyleng = 0;
	        this.yytext = this.matched = this.match = '';
	        this.conditionStack = ['INITIAL'];
	        this.yylloc = {
	            first_line: 1,
	            first_column: 0,
	            last_line: 1,
	            last_column: 0
	        };
	        if (this.options.ranges) {
	            this.yylloc.range = [0,0];
	        }
	        this.offset = 0;
	        return this;
	    },
	
	// consumes and returns one char from the input
	input:function () {
	        var ch = this._input[0];
	        this.yytext += ch;
	        this.yyleng++;
	        this.offset++;
	        this.match += ch;
	        this.matched += ch;
	        var lines = ch.match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno++;
	            this.yylloc.last_line++;
	        } else {
	            this.yylloc.last_column++;
	        }
	        if (this.options.ranges) {
	            this.yylloc.range[1]++;
	        }
	
	        this._input = this._input.slice(1);
	        return ch;
	    },
	
	// unshifts one char (or a string) into the input
	unput:function (ch) {
	        var len = ch.length;
	        var lines = ch.split(/(?:\r\n?|\n)/g);
	
	        this._input = ch + this._input;
	        this.yytext = this.yytext.substr(0, this.yytext.length - len);
	        //this.yyleng -= len;
	        this.offset -= len;
	        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	        this.match = this.match.substr(0, this.match.length - 1);
	        this.matched = this.matched.substr(0, this.matched.length - 1);
	
	        if (lines.length - 1) {
	            this.yylineno -= lines.length - 1;
	        }
	        var r = this.yylloc.range;
	
	        this.yylloc = {
	            first_line: this.yylloc.first_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.first_column,
	            last_column: lines ?
	                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
	                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
	              this.yylloc.first_column - len
	        };
	
	        if (this.options.ranges) {
	            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	        }
	        this.yyleng = this.yytext.length;
	        return this;
	    },
	
	// When called from action, caches matched text and appends it on next action
	more:function () {
	        this._more = true;
	        return this;
	    },
	
	// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
	reject:function () {
	        if (this.options.backtrack_lexer) {
	            this._backtrack = true;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	
	        }
	        return this;
	    },
	
	// retain first n characters of the match
	less:function (n) {
	        this.unput(this.match.slice(n));
	    },
	
	// displays already matched input, i.e. for error messages
	pastInput:function () {
	        var past = this.matched.substr(0, this.matched.length - this.match.length);
	        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
	    },
	
	// displays upcoming input, i.e. for error messages
	upcomingInput:function () {
	        var next = this.match;
	        if (next.length < 20) {
	            next += this._input.substr(0, 20-next.length);
	        }
	        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	    },
	
	// displays the character position where the lexing error occurred, i.e. for error messages
	showPosition:function () {
	        var pre = this.pastInput();
	        var c = new Array(pre.length + 1).join("-");
	        return pre + this.upcomingInput() + "\n" + c + "^";
	    },
	
	// test the lexed token: return FALSE when not a match, otherwise return token
	test_match:function (match, indexed_rule) {
	        var token,
	            lines,
	            backup;
	
	        if (this.options.backtrack_lexer) {
	            // save context
	            backup = {
	                yylineno: this.yylineno,
	                yylloc: {
	                    first_line: this.yylloc.first_line,
	                    last_line: this.last_line,
	                    first_column: this.yylloc.first_column,
	                    last_column: this.yylloc.last_column
	                },
	                yytext: this.yytext,
	                match: this.match,
	                matches: this.matches,
	                matched: this.matched,
	                yyleng: this.yyleng,
	                offset: this.offset,
	                _more: this._more,
	                _input: this._input,
	                yy: this.yy,
	                conditionStack: this.conditionStack.slice(0),
	                done: this.done
	            };
	            if (this.options.ranges) {
	                backup.yylloc.range = this.yylloc.range.slice(0);
	            }
	        }
	
	        lines = match[0].match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno += lines.length;
	        }
	        this.yylloc = {
	            first_line: this.yylloc.last_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.last_column,
	            last_column: lines ?
	                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
	                         this.yylloc.last_column + match[0].length
	        };
	        this.yytext += match[0];
	        this.match += match[0];
	        this.matches = match;
	        this.yyleng = this.yytext.length;
	        if (this.options.ranges) {
	            this.yylloc.range = [this.offset, this.offset += this.yyleng];
	        }
	        this._more = false;
	        this._backtrack = false;
	        this._input = this._input.slice(match[0].length);
	        this.matched += match[0];
	        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
	        if (this.done && this._input) {
	            this.done = false;
	        }
	        if (token) {
	            return token;
	        } else if (this._backtrack) {
	            // recover context
	            for (var k in backup) {
	                this[k] = backup[k];
	            }
	            return false; // rule action called reject() implying the next rule should be tested instead.
	        }
	        return false;
	    },
	
	// return next match in input
	next:function () {
	        if (this.done) {
	            return this.EOF;
	        }
	        if (!this._input) {
	            this.done = true;
	        }
	
	        var token,
	            match,
	            tempMatch,
	            index;
	        if (!this._more) {
	            this.yytext = '';
	            this.match = '';
	        }
	        var rules = this._currentRules();
	        for (var i = 0; i < rules.length; i++) {
	            tempMatch = this._input.match(this.rules[rules[i]]);
	            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                match = tempMatch;
	                index = i;
	                if (this.options.backtrack_lexer) {
	                    token = this.test_match(tempMatch, rules[i]);
	                    if (token !== false) {
	                        return token;
	                    } else if (this._backtrack) {
	                        match = false;
	                        continue; // rule action called reject() implying a rule MISmatch.
	                    } else {
	                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	                        return false;
	                    }
	                } else if (!this.options.flex) {
	                    break;
	                }
	            }
	        }
	        if (match) {
	            token = this.test_match(match, rules[index]);
	            if (token !== false) {
	                return token;
	            }
	            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	            return false;
	        }
	        if (this._input === "") {
	            return this.EOF;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	        }
	    },
	
	// return next match that has a token
	lex:function lex() {
	        var r = this.next();
	        if (r) {
	            return r;
	        } else {
	            return this.lex();
	        }
	    },
	
	// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
	begin:function begin(condition) {
	        this.conditionStack.push(condition);
	    },
	
	// pop the previously active lexer condition state off the condition stack
	popState:function popState() {
	        var n = this.conditionStack.length - 1;
	        if (n > 0) {
	            return this.conditionStack.pop();
	        } else {
	            return this.conditionStack[0];
	        }
	    },
	
	// produce the lexer rule set which is active for the currently active lexer condition state
	_currentRules:function _currentRules() {
	        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
	            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	        } else {
	            return this.conditions["INITIAL"].rules;
	        }
	    },
	
	// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
	topState:function topState(n) {
	        n = this.conditionStack.length - 1 - Math.abs(n || 0);
	        if (n >= 0) {
	            return this.conditionStack[n];
	        } else {
	            return "INITIAL";
	        }
	    },
	
	// alias for begin(condition)
	pushState:function pushState(condition) {
	        this.begin(condition);
	    },
	
	// return the number of states currently on the stack
	stateStackSize:function stateStackSize() {
	        return this.conditionStack.length;
	    },
	options: {},
	performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
	var YYSTATE=YY_START;
	switch($avoiding_name_collisions) {
	case 0:return 10;
	break;
	case 1:return 9
	break;
	case 2:return 11;
	break;
	case 3:yy_.yytext=yy_.yytext.slice(0,-1);   return 14;
	break;
	case 4:yy_.yytext=yy_.yytext.slice(1,-1);   return 8;
	break;
	case 5:yy_.yytext=yy_.yytext.slice(1,-1);   return 8;
	break;
	case 6:return 7;
	break;
	case 7:return 12;
	break;
	case 8:return 13;
	break;
	case 9:return 5;
	break;
	}
	},
	rules: [/^(?:\s+)/,/^(?:[,](?=\S))/,/^(?:\s*[,]\s)/,/^(?:[a-z0-9_-]+:)/,/^(?:"(?:[^\"\\]|\\.)*?")/,/^(?:'(?:[^\'\\]|\\.)*?')/,/^(?:[^\s\(\)\:,]+)/,/^(?:\()/,/^(?:\))/,/^(?:$)/],
	conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9],"inclusive":true}}
	});
	return lexer;
	})();
	parser.lexer = lexer;
	function Parser () {
	  this.yy = {};
	}
	Parser.prototype = parser;parser.Parser = Parser;
	return new Parser;
	})();
	
	
	if (true) {
	exports.parser = parser;
	exports.Parser = parser.Parser;
	exports.parse = function () { return parser.parse.apply(parser, arguments); };
	exports.main = function commonjsMain(args) {
	    if (!args[1]) {
	        console.log('Usage: '+args[0]+' FILE');
	        process.exit(1);
	    }
	    var source = __webpack_require__(1607).readFileSync(__webpack_require__(1608).normalize(args[1]), "utf8");
	    return exports.parser.parse(source);
	};
	if (typeof module !== 'undefined' && __webpack_require__.c[0] === module) {
	  exports.main(process.argv.slice(1));
	}
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(586), __webpack_require__(1107)(module)))

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLASTNodes = __webpack_require__(1605);
	
	var _DSLFilterList = __webpack_require__(1606);
	
	var _DSLFilterList2 = _interopRequireDefault(_DSLFilterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Factory for filter-combining functions (operators)
	 *
	 * This factory function creates the appropriate run-time function for combining
	 * two other run-time filter functions based on an operator.
	 *
	 * By the term `run-time` we refer to a function that will be called by the user
	 * in order to actually apply the filter chain on a resultset. Note that this
	 * factory function will be created by the AST parser.
	 *
	 * For example, when the expression: `string AND attribute:value`
	 * is encountered, two run-time filter functions will be produced by the
	 * `filterFunctionFactory` function (see below), and combined into one,
	 * using this function.
	 *
	 * @private
	 * @param {CombineNode} ast - The AST node for the combine operator
	 * @param {function} leftFilterFn - The filter function on the left side of the operator
	 * @param {function} rightFilterFn - The filter function on the right side of the operator
	 * @returns {function} - Returns the fabricated filter combiner
	 */
	function combineFunctionFactory(ast, leftFilterFn, rightFilterFn) {
	  switch (ast.combinerType) {
	    case _DSLCombinerTypes2.default.AND:
	      /**
	       * This function calculates the intersection of the resultsets of the two
	       * filter functions, effectively implementing the `AND` operator.
	       *
	       * The `filters` object is a library with the available filters that can
	       * be used in this context, while the `resultset` is an instance of `List`
	       * on which the filers have to be applied.
	       *
	       * @param {Object} filters - An object containing the valid filters that can be used
	       * @param {List} resultset - An instance of List or Tree containing the items to filter
	       * @returns {List} resultset - A new instance of a List, containing the results
	       */
	      return function (filters, resultset) {
	        // We are interested in the intersection of the results of the two filters
	        var intermediateResultset = leftFilterFn(filters, resultset);
	
	        return rightFilterFn(filters, intermediateResultset);
	      };
	
	    case _DSLCombinerTypes2.default.OR:
	      /**
	       * This function calculates the union of the resultsets of the two filter
	       * functions, effectively implementing the `OR` operator.
	       *
	       * The `filters` object is a library with the available filters that can
	       * be used in this context, while the `resultset` is an instance of `List`
	       * on which the filers have to be applied.
	       *
	       * @param {Object} filters - An object containing the valid filters that can be used
	       * @param {List} resultset - An instance of List or Tree containing the items to filter
	       * @returns {List} resultset - A new instance of a List, containing the results
	       */
	      return function (filters, resultset) {
	        // We are interested in the union of the results of the two filters
	        var intermediateResultset = leftFilterFn(filters, resultset);
	
	        return intermediateResultset.combine(rightFilterFn(filters, resultset));
	      };
	  }
	}
	
	/**
	 * Factory for filter functions (operands)
	 *
	 * This factory function creates the appropriate run-time function that filters
	 * a given resultset according to the configuration of the `ast` node provided.
	 *
	 * @private
	 * @param {FilterNode} ast - The AST node for the filter operation
	 * @returns {function} - Returns the fabricated filter function
	 */
	function filterFunctionFactory(ast) {
	  /**
	   * This function is accessible directly to the user, or combined into a chain
	   * of filters using combination operators (see the `combineFunctionFactory`
	   * above).
	   *
	   * Given an input `List` resultset, it should keep only the items that passes
	   * the tests, as defined in the `ast` configuration.
	   *
	   * @param {Object} filters - An object containing the valid filters that can be used
	   * @param {List} resultset - An instance of List or Tree containing the items to filter
	   * @returns {List} resultset - A new instance of a List, containing the results
	   */
	  return function (filters, resultset) {
	    if (!(filters instanceof _DSLFilterList2.default)) {
	      throw TypeError("Expecting first argument to be an instance of DSLFilterList");
	    }
	
	    // Apply matching filters from the filters database to the current
	    // result set, and produce the new resultset.
	    //
	    // If more than one filters exists for the same type, the results are combined
	    // using an OR operator.
	    //
	    // For example, if you want to test for `is:running` in a resultset that
	    // contains both Nodes and Services, you could plug two different filters,
	    // one that knows how to handle Nodes and one that knows how to handle
	    // Services. However, since both are operating on the same `is:XXX` token
	    // the will be both fetched from the `getMatchingFilters` function.
	    //
	    return filters.getMatchingFilters(ast.filterType, ast.filterParams).reduce(function (currentResultset, filter) {
	      return currentResultset.combine(filter.filterApply(resultset, ast.filterType, ast.filterParams));
	    }, new resultset.constructor());
	  };
	}
	
	/**
	 * The following functions are used by the JISON parser in order to parse
	 * the expression into a properly nested set of functions and AST nodes.
	 *
	 * @name DSLParserUtil
	 */
	module.exports = {
	  /**
	   * Namespace for the merge operator
	   *
	   * @namespace
	   */
	  Merge: {
	    /**
	     * Combines two filter functions using the AND operator
	     *
	     * @param {Function} f1 - The first operation function
	     * @param {Function} f2 - The second operation function
	     *
	     * @returns {Function} Returns a combined filter function
	     */
	    and: function and(f1, f2) {
	      var ast = new _DSLASTNodes.CombinerNode(_DSLCombinerTypes2.default.AND, f1.ast, f2.ast);
	
	      return {
	        filter: combineFunctionFactory(ast, f1.filter, f2.filter),
	        ast: ast
	      };
	    },
	
	
	    /**
	     * Combines two filter functions using the OR operator
	     *
	     * @param {Function} f1 - The first operation function
	     * @param {Function} f2 - The second operation function
	     *
	     * @returns {Function} Returns a combined filter function
	     */
	    or: function or(f1, f2) {
	      var ast = new _DSLASTNodes.CombinerNode(_DSLCombinerTypes2.default.OR, f1.ast, f2.ast);
	
	      return {
	        filter: combineFunctionFactory(ast, f1.filter, f2.filter),
	        ast: ast
	      };
	    }
	  },
	
	  /**
	   * Operator namespace
	   *
	   * @namespace
	   */
	  Operator: {
	    /**
	     * Return filter function for an attribute operator
	     *
	     * @param {String} label - The attribute label
	     * @param {String} text - The attribute value
	     * @param {Number} lstart - The starting position of the label token
	     * @param {Number} lend - The ending position of the label token
	     * @param {Number} vstart - The starting position of the value token
	     * @param {Number} vend - The ending position of the value token
	     *
	     * @returns {Function} Returns a filter function
	     */
	    attribute: function attribute(label, text, lstart, lend, vstart, vend) {
	      var ast = new _DSLASTNodes.FilterNode(lstart, lend, _DSLFilterTypes2.default.ATTRIB, {
	        text: text,
	        label: label
	      });
	      ast.position.push([vstart, vend]);
	
	      return {
	        filter: filterFunctionFactory(ast),
	        ast: ast
	      };
	    },
	
	
	    /**
	     * Return a filter function for exact string matching
	     *
	     * @param {String} text - The fuzzy filter text input
	     * @param {Number} start - The starting position of the filter token
	     * @param {Number} end - The ending position of the filter token
	     *
	     * @returns {Function} Returns a filter function
	     */
	    exact: function exact(text, start, end) {
	      var ast = new _DSLASTNodes.FilterNode(start, end, _DSLFilterTypes2.default.EXACT, { text: text });
	
	      return {
	        filter: filterFunctionFactory(ast),
	        ast: ast
	      };
	    },
	
	
	    /**
	     * Return a filter function for fuzzy-text matching
	     *
	     * @param {String} text - The fuzzy filter text input
	     * @param {Number} start - The starting position of the filter token
	     * @param {Number} end - The ending position of the filter token
	     *
	     * @returns {Function} Returns a filter function
	     */
	    fuzzy: function fuzzy(text, start, end) {
	      var ast = new _DSLASTNodes.FilterNode(start, end, _DSLFilterTypes2.default.FUZZY, { text: text });
	
	      return {
	        filter: filterFunctionFactory(ast),
	        ast: ast
	      };
	    }
	  }
	};

/***/ },
/* 1603 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Different types of filters (operands) in a DSL expression
	 */
	var FILTER_TYPES = {
	  ATTRIB: 1,
	  EXACT: 2,
	  FUZZY: 3
	};
	
	module.exports = FILTER_TYPES;

/***/ },
/* 1604 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Different types of combiners (operators) in a DSL expression
	 */
	var COMBINER_TYPES = {
	  AND: 1,
	  OR: 2
	};
	
	module.exports = COMBINER_TYPES;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Base class for AST nodes in DSL, representing a token in the user input
	 */
	var ASTNode =
	/**
	 * @param {number} start - The starting point of the token in the input string
	 * @param {number} end - The ending point of the token in the input string
	 * @param {ASTNode[]} children - Child nodes to this node
	 */
	function ASTNode(start, end) {
	  var children = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  (0, _classCallCheck3.default)(this, ASTNode);
	
	  /**
	   * The position array contains an array of tuples, containing the start-end
	   * position of each relevant text portions that composes this token.
	   *
	   * In 99.9% of the cases, this is an array with only 1 tuple. However, when
	   * the `attribute:value1,value2` shorthand is used, this array will contain
	   * 2 tuples, pointing to the `attribute:` and `valueX` parts separately.
	   *
	   * @var {Array}
	   */
	  this.position = [[start, end]];
	
	  /**
	   * Child tokens in this token tree
	   *
	   * @var {Array}
	   */
	  this.children = children;
	};
	
	/**
	 * Combiner (operator) AST node
	 */
	
	
	var CombinerNode = function (_ASTNode) {
	  (0, _inherits3.default)(CombinerNode, _ASTNode);
	
	  /**
	   * @param {DSLCombinerTypes} combinerType - The combiner type (AND, OR)
	   * @param {ASTNode} child1 - The left-side operator
	   * @param {ASTNode} child2 - The right-side operator
	   */
	  function CombinerNode(combinerType, child1, child2) {
	    (0, _classCallCheck3.default)(this, CombinerNode);
	
	    /**
	     * The type of the combiner
	     * @var {Number}
	     */
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CombinerNode.__proto__ || (0, _getPrototypeOf2.default)(CombinerNode)).call(this, child1.position[0][0], child2.position[child2.position.length - 1][1], [child1, child2]));
	
	    _this.combinerType = combinerType;
	    return _this;
	  }
	
	  return CombinerNode;
	}(ASTNode);
	
	/**
	 * Filter (operand) AST node
	 */
	
	
	var FilterNode = function (_ASTNode2) {
	  (0, _inherits3.default)(FilterNode, _ASTNode2);
	
	  /**
	   * @param {number} start - The starting point of the token in the input string
	   * @param {number} end - The ending point of the token in the input string
	   * @param {DSLFilterTypes} filterType - The filter type (ATTRIB, EXACT, FUZZY)
	   * @param {Object} filterParams - Arbitrary parameters to the filter (ex. text)
	   */
	  function FilterNode(start, end, filterType, filterParams) {
	    (0, _classCallCheck3.default)(this, FilterNode);
	
	    /**
	     * The type of the filter
	     * @var {Number}
	     */
	    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FilterNode.__proto__ || (0, _getPrototypeOf2.default)(FilterNode)).call(this, start, end));
	
	    _this2.filterType = filterType;
	
	    /**
	     * The parameters to the filter
	     * @var {{text, [label]}}
	     */
	    _this2.filterParams = filterParams;
	    return _this2;
	  }
	
	  return FilterNode;
	}(ASTNode);
	
	/**
	 * Expose the leaf nodes that can be used in more than one place
	 */
	
	
	module.exports = {
	  CombinerNode: CombinerNode,
	  FilterNode: FilterNode
	};

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This class maintains a list with available filters that can be used
	 * with a DSL expression.
	 */
	var DSLFilterList = function () {
	  /**
	   * DSLFilterList constructor with optional initial filters array
	   *
	   * @param {Array} [filters] - An array with the initial filters
	   */
	  function DSLFilterList() {
	    var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    (0, _classCallCheck3.default)(this, DSLFilterList);
	
	    this.add = this.add.bind(filters);
	    this.getMatchingFilters = this.getMatchingFilters.bind(filters);
	  }
	
	  /**
	   * Add a filter to the list of filters
	   *
	   * @param {...DSLFilter} filter - The filter to plug
	   * @returns {DSLFilterList} Returns a new DSLFilterList object
	   */
	
	
	  (0, _createClass3.default)(DSLFilterList, [{
	    key: "add",
	    value: function add() {
	      for (var _len = arguments.length, filters = Array(_len), _key = 0; _key < _len; _key++) {
	        filters[_key] = arguments[_key];
	      }
	
	      return new DSLFilterList(this.concat(filters));
	    }
	
	    /**
	     * Returns an array of filter objects that match the specified filter token
	     * array and arguments.
	     *
	     * @param {Number} filterType - The filter type (attribute, fuzzy, freetext)
	     * @param {Object} filterArguments - The filter arguments, with `text` containing the string the user provided
	     * @returns {Array} Returns an array of DSLFilter objects that can handle the given token
	     */
	
	  }, {
	    key: "getMatchingFilters",
	    value: function getMatchingFilters(filterType, filterArguments) {
	      return this.filter(function (filter) {
	        return filter.filterCanHandle(filterType, filterArguments);
	      });
	    }
	  }]);
	  return DSLFilterList;
	}();
	
	module.exports = DSLFilterList;

/***/ },
/* 1607 */
882,
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(586)))

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodHeader = __webpack_require__(1610);
	
	var _PodHeader2 = _interopRequireDefault(_PodHeader);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceActionDisabledModal = __webpack_require__(1612);
	
	var _ServiceActionDisabledModal2 = _interopRequireDefault(_ServiceActionDisabledModal);
	
	var _ServiceActionLabels = __webpack_require__(1613);
	
	var _ServiceActionLabels2 = _interopRequireDefault(_ServiceActionLabels);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	var _ServiceModals = __webpack_require__(1614);
	
	var _ServiceModals2 = _interopRequireDefault(_ServiceModals);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleActionDisabledModalOpen", "handleActionDisabledModalClose"];
	
	var PodDetail = function (_mixin) {
	  (0, _inherits3.default)(PodDetail, _mixin);
	
	  function PodDetail() {
	    (0, _classCallCheck3.default)(this, PodDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodDetail.__proto__ || (0, _getPrototypeOf2.default)(PodDetail)).apply(this, arguments));
	
	    _this.tabs_tabs = {
	      "/services/overview/:id/tasks": "Instances",
	      "/services/overview/:id/configuration": "Configuration",
	      "/services/overview/:id/debug": "Debug"
	    };
	
	    _this.state = {
	      actionDisabledID: null,
	      actionDisabledModalOpen: false,
	      currentTab: (0, _keys2.default)(_this.tabs_tabs).shift()
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(PodDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(PodDetail.prototype), "componentWillMount", this).apply(this, arguments);
	      this.updateCurrentTab();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(PodDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(PodDetail.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      this.updateCurrentTab(nextProps);
	    }
	  }, {
	    key: "updateCurrentTab",
	    value: function updateCurrentTab() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var routes = props.routes;
	
	      var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	      if (currentTab != null) {
	        this.setState({ currentTab: currentTab });
	      }
	    }
	  }, {
	    key: "onActionsItemSelection",
	    value: function onActionsItemSelection(actionID) {
	      var pod = this.props.pod;
	
	      var isGroup = pod instanceof _ServiceTree2.default;
	      var containsSDKService = false;
	
	      if (isGroup) {
	        containsSDKService = pod.findItem(function (item) {
	          return item instanceof _Service2.default && (0, _ServiceUtil.isSDKService)(item);
	        }) != null;
	      }
	
	      // We still want to support the `open` action to display the web view
	      if ((containsSDKService || (0, _ServiceUtil.isSDKService)(pod)) && !_PluginSDK.Hooks.applyFilter("isEnabledSDKAction", actionID === _ServiceActionItem.EDIT || actionID === _ServiceActionItem.OPEN, actionID)) {
	        this.handleActionDisabledModalOpen(actionID);
	      } else {
	        this.handleServiceAction(actionID);
	      }
	    }
	  }, {
	    key: "handleServiceAction",
	    value: function handleServiceAction(actionID) {
	      var _context = this.context,
	          modalHandlers = _context.modalHandlers,
	          router = _context.router;
	      var pod = this.props.pod;
	
	
	      switch (actionID) {
	        case _ServiceActionItem.EDIT:
	          router.push("/services/detail/" + encodeURIComponent(pod.getId()) + "/edit/");
	          break;
	        case _ServiceActionItem.SCALE:
	          modalHandlers.scaleService({ service: pod });
	          break;
	        case _ServiceActionItem.OPEN:
	          modalHandlers.openServiceUI({ service: pod });
	          break;
	        case _ServiceActionItem.RESTART:
	          modalHandlers.restartService({ service: pod });
	          break;
	        case _ServiceActionItem.RESUME:
	          modalHandlers.resumeService({ service: pod });
	          break;
	        case _ServiceActionItem.SUSPEND:
	          modalHandlers.suspendService({ service: pod });
	          break;
	        case _ServiceActionItem.DELETE:
	          modalHandlers.deleteService({ service: pod });
	          break;
	      }
	    }
	  }, {
	    key: "handleActionDisabledModalOpen",
	    value: function handleActionDisabledModalOpen(actionDisabledID) {
	      this.setState({ actionDisabledModalOpen: true, actionDisabledID: actionDisabledID });
	    }
	  }, {
	    key: "handleActionDisabledModalClose",
	    value: function handleActionDisabledModalClose() {
	      this.setState({ actionDisabledModalOpen: false, actionDisabledID: null });
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      var pod = this.props.pod;
	
	      var instanceCount = pod.getInstancesCount();
	
	      var actions = [];
	
	      if (pod instanceof _Service2.default && pod.getWebURL() != null && pod.getWebURL() !== "") {
	        actions.push({
	          label: this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default.open
	          }),
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.OPEN)
	        });
	      }
	
	      actions.push({
	        label: "Edit",
	        onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.EDIT)
	      });
	
	      if (instanceCount > 0) {
	        actions.push({
	          label: "Restart",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.RESTART)
	        });
	      }
	      if (!pod.getLabels().MARATHON_SINGLE_INSTANCE_APP) {
	        actions.push({
	          label: "Scale",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.SCALE)
	        });
	      }
	
	      if (instanceCount > 0) {
	        actions.push({
	          label: "Suspend",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.SUSPEND)
	        });
	      }
	
	      if (instanceCount === 0) {
	        actions.push({
	          label: "Resume",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.RESUME)
	        });
	      }
	
	      actions.push({
	        className: "text-danger",
	        label: _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	        onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.DELETE)
	      });
	
	      return actions;
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var id = this.props.pod.id;
	
	      var routePrefix = "/services/detail/" + encodeURIComponent(id);
	
	      return [{ label: "Instances", routePath: routePrefix + "/tasks" }, { label: "Configuration", routePath: routePrefix + "/configuration" }, { label: "Debug", routePath: routePrefix + "/debug" }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          pod = _props.pod;
	      var _state = this.state,
	          actionDisabledModalOpen = _state.actionDisabledModalOpen,
	          actionDisabledID = _state.actionDisabledID;
	
	
	      var breadcrumbs = _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: pod.id });
	
	      // TODO (DCOS_OSS-1038): Move cloned props to route parameters
	      var clonedProps = { service: pod };
	      var clonedChildren = _react2.default.Children.map(children, function (child) {
	        // Only add props to children that are not ServiceModals
	        if (child.type === _ServiceModals2.default) {
	          return child;
	        }
	
	        return _react2.default.cloneElement(child, clonedProps);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(
	          _Page2.default.Header,
	          {
	            actions: this.getActions(),
	            breadcrumbs: breadcrumbs,
	            tabs: this.getTabs()
	          },
	          _react2.default.createElement(_PodHeader2.default, {
	            onDestroy: this.handleActionDestroy,
	            onEdit: this.handleActionEdit,
	            onScale: this.handleActionScale,
	            onSuspend: this.handleActionSuspend,
	            pod: pod,
	            tabs: this.getTabs()
	          })
	        ),
	        clonedChildren,
	        _react2.default.createElement(_ServiceActionDisabledModal2.default, {
	          actionID: actionDisabledID,
	          open: actionDisabledModalOpen,
	          onClose: this.handleActionDisabledModalClose,
	          service: pod
	        })
	      );
	    }
	  }]);
	  return PodDetail;
	}((0, _reactjsMixin2.default)(_TabsMixin2.default));
	
	PodDetail.contextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    scaleService: _react.PropTypes.func,
	    suspendService: _react.PropTypes.func,
	    deleteService: _react.PropTypes.func
	  }).isRequired,
	  router: _reactRouter.routerShape
	};
	
	PodDetail.propTypes = {
	  children: _react.PropTypes.node,
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default)
	};
	
	module.exports = PodDetail;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DetailViewHeader = __webpack_require__(1491);
	
	var _DetailViewHeader2 = _interopRequireDefault(_DetailViewHeader);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _HealthBar = __webpack_require__(1586);
	
	var _HealthBar2 = _interopRequireDefault(_HealthBar);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	var _StatusMapping = __webpack_require__(1494);
	
	var _StatusMapping2 = _interopRequireDefault(_StatusMapping);
	
	var _PodActionItem = __webpack_require__(1611);
	
	var _PodActionItem2 = _interopRequireDefault(_PodActionItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleDropdownAction"];
	
	var PodHeader = function (_React$Component) {
	  (0, _inherits3.default)(PodHeader, _React$Component);
	
	  function PodHeader() {
	    (0, _classCallCheck3.default)(this, PodHeader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodHeader.__proto__ || (0, _getPrototypeOf2.default)(PodHeader)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodHeader, [{
	    key: "getActionButtons",
	    value: function getActionButtons() {
	      var pod = this.props.pod;
	
	
	      var dropdownItems = [
	      // This item is used as a label to the dropdown
	      {
	        className: "hidden",
	        id: "__MORE__",
	        html: "",
	        selectedHtml: "More"
	      }, {
	        className: (0, _dedupe2.default)({
	          hidden: pod.getInstancesCount() === 0
	        }),
	        id: _PodActionItem2.default.SUSPEND,
	        html: "Suspend"
	      }, {
	        id: _PodActionItem2.default.DELETE,
	        html: _react2.default.createElement(
	          "span",
	          { className: "text-danger" },
	          _StringUtil2.default.capitalize(_UserActions2.default.DELETE)
	        )
	      }];
	
	      var actionButtons = [_react2.default.createElement(
	        "button",
	        {
	          className: "button flush-bottom  button-primary",
	          key: "action-button-scale",
	          onClick: this.props.onScale
	        },
	        "Scale"
	      ), _react2.default.createElement(
	        "button",
	        {
	          className: "button flush-bottom button-stroke",
	          key: "action-button-edit",
	          onClick: this.props.onEdit
	        },
	        "Edit"
	      ), _react2.default.createElement(_reactjsComponents.Dropdown, {
	        key: "actions-dropdown",
	        anchorRight: true,
	        buttonClassName: "button button-stroke dropdown-toggle",
	        dropdownMenuClassName: "dropdown-menu",
	        dropdownMenuListClassName: "dropdown-menu-list",
	        dropdownMenuListItemClassName: "clickable",
	        wrapperClassName: "dropdown flush-bottom",
	        items: dropdownItems,
	        persistentID: "__MORE__",
	        onItemSelection: this.handleDropdownAction,
	        transition: true,
	        transitionName: "dropdown-menu"
	      })];
	
	      return actionButtons;
	    }
	  }, {
	    key: "handleDropdownAction",
	    value: function handleDropdownAction(action) {
	      switch (action.id) {
	        case _PodActionItem2.default.SUSPEND:
	          this.props.onSuspend();
	          break;
	
	        case _PodActionItem2.default.DELETE:
	          this.props.onDestroy();
	          break;
	      }
	    }
	  }, {
	    key: "getSubHeader",
	    value: function getSubHeader(pod) {
	      var serviceHealth = pod.getHealth();
	      var serviceStatus = pod.getServiceStatus();
	      var tasksSummary = pod.getTasksSummary();
	      var serviceStatusClassSet = _StatusMapping2.default[serviceStatus.displayName] || "";
	      var runningTasksCount = tasksSummary.tasksRunning;
	      var instancesCount = pod.getInstancesCount();
	      var runningTasksSubHeader = _StringUtil2.default.pluralize("Instance", runningTasksCount);
	      var subHeaderItems = [{
	        classes: "media-object-item " + serviceStatusClassSet,
	        label: serviceStatus.displayName,
	        shouldShow: serviceHealth.key != null
	      }, {
	        classes: "media-object-item",
	        label: runningTasksCount + " " + runningTasksSubHeader,
	        shouldShow: runningTasksCount != null && runningTasksSubHeader != null
	      }, {
	        label: _react2.default.createElement(_HealthBar2.default, {
	          tasksSummary: tasksSummary,
	          isDeploying: serviceStatus === _ServiceStatus2.default.DEPLOYING,
	          instancesCount: instancesCount
	        }),
	        shouldShow: true
	      }].map(function (item, index) {
	        if (!item.shouldShow) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          "span",
	          { className: item.classes, key: index },
	          item.label
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "media-object-spacing-wrapper media-object-spacing-narrow media-object-offset" },
	        subHeaderItems
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pod = this.props.pod;
	      var podIcon = null;
	      var podImages = pod.getImages();
	      if (podImages && podImages["icon-large"]) {
	        podIcon = _react2.default.createElement("img", { src: podImages["icon-large"] });
	      }
	
	      var tabs = _react2.default.createElement(
	        "ul",
	        { className: "menu-tabbed" },
	        this.props.tabs
	      );
	
	      return _react2.default.createElement(_DetailViewHeader2.default, {
	        actionButtons: this.getActionButtons(),
	        icon: podIcon,
	        iconClassName: "icon-image-container icon-app-container",
	        subTitle: this.getSubHeader(pod),
	        navigationTabs: tabs,
	        title: pod.getName()
	      });
	    }
	  }]);
	  return PodHeader;
	}(_react2.default.Component);
	
	PodHeader.defaultProps = {
	  onDestroy: function onDestroy() {},
	  onEdit: function onEdit() {},
	  onScale: function onScale() {},
	  onSuspend: function onSuspend() {},
	
	  pod: null,
	  tabs: []
	};
	
	PodHeader.propTypes = {
	  onDestroy: _react2.default.PropTypes.func,
	  onEdit: _react2.default.PropTypes.func,
	  onScale: _react2.default.PropTypes.func,
	  onSuspend: _react2.default.PropTypes.func,
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default).isRequired,
	  tabs: _react2.default.PropTypes.array
	};
	
	module.exports = PodHeader;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodActionItem = {
	  EDIT: "edit",
	  DELETE: _UserActions2.default.DELETE,
	  SCALE: "scale",
	  SUSPEND: "suspend"
	};
	
	module.exports = PodActionItem;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(753);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ClipboardTrigger = __webpack_require__(1419);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceActionLabels = __webpack_require__(1613);
	
	var _ServiceActionLabels2 = _interopRequireDefault(_ServiceActionLabels);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleTextCopy"];
	
	var ServiceActionDisabledModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceActionDisabledModal, _React$Component);
	
	  function ServiceActionDisabledModal() {
	    (0, _classCallCheck3.default)(this, ServiceActionDisabledModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceActionDisabledModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceActionDisabledModal)).apply(this, arguments));
	
	    _this.state = { copiedCommand: false };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceActionDisabledModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.open !== nextProps.open) {
	        this.setState({ copiedCommand: false });
	      }
	    }
	  }, {
	    key: "handleTextCopy",
	    value: function handleTextCopy(copiedCommand) {
	      this.setState({ copiedCommand: copiedCommand });
	    }
	  }, {
	    key: "getUpdateCommand",
	    value: function getUpdateCommand() {
	      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.service;
	
	      var serviceID = service ? service.getId() : "";
	      var packageName = service.getLabels().DCOS_PACKAGE_NAME;
	
	      // For everything SDK, not other packages
	      if ((0, _ServiceUtil.isSDKService)(service)) {
	        return "dcos " + packageName + " --name=" + serviceID + " update start --options=options.json";
	      }
	
	      return "dcos marathon app update " + serviceID + " options.json";
	    }
	  }, {
	    key: "getRestartCommand",
	    value: function getRestartCommand() {
	      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.service;
	
	      var serviceID = service ? service.getId() : "";
	
	      return "dcos marathon app restart " + serviceID;
	    }
	  }, {
	    key: "getDeleteCommand",
	    value: function getDeleteCommand() {
	      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.service;
	
	      var serviceID = service ? service.getId() : "";
	      var packageName = service.getLabels().DCOS_PACKAGE_NAME;
	
	      // For groups, not services
	      if (service instanceof _ServiceTree2.default) {
	        return "dcos marathon group remove " + serviceID;
	      }
	
	      return "dcos package uninstall " + packageName + " --app-id=" + serviceID;
	    }
	  }, {
	    key: "getServiceRestartMessage",
	    value: function getServiceRestartMessage() {
	      var intl = this.props.intl;
	
	      var command = this.getRestartCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_SERVICE_RESTART" }),
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/cli/command-reference/dcos-marathon/dcos-marathon-app-restart/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger(command)
	      );
	    }
	  }, {
	    key: "getServiceSuspendMessage",
	    value: function getServiceSuspendMessage() {
	      var intl = this.props.intl;
	
	      var command = this.getUpdateCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_SERVICE_SUSPEND" }),
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/deploying-services/config-universe-service/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger(command)
	      );
	    }
	  }, {
	    key: "getServiceResumeMessage",
	    value: function getServiceResumeMessage() {
	      var intl = this.props.intl;
	
	      var command = this.getUpdateCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_SERVICE_RESUME" }),
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/deploying-services/config-universe-service/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger(command)
	      );
	    }
	  }, {
	    key: "getServiceScaleMessage",
	    value: function getServiceScaleMessage() {
	      var intl = this.props.intl;
	
	      var command = this.getUpdateCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_SERVICE_SCALE" })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "emphasis" },
	            "Note:"
	          ),
	          " ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_SERVICE_SCALE_NOTE" }),
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/usage/managing-services/config-universe-service"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          ),
	          " "
	        ),
	        this.getClipboardTrigger(command)
	      );
	    }
	  }, {
	    key: "getServiceDeleteMessage",
	    value: function getServiceDeleteMessage() {
	      var _props = this.props,
	          intl = _props.intl,
	          service = _props.service;
	
	      var serviceID = service ? service.getId() : "";
	      var command = this.getDeleteCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({
	            id: "SERVICE_ACTIONS.SDK_SERVICE_DELETE_PART_1"
	          }),
	          " ",
	          _react2.default.createElement(
	            "span",
	            { className: "emphasis" },
	            serviceID
	          ),
	          " ",
	          intl.formatMessage({
	            id: "SERVICE_ACTIONS.SDK_SERVICE_DELETE_PART_2"
	          }),
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/deploying-services/uninstall/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.DOCUMENTATION" })
	          ),
	          " for complete instructions.",
	          " "
	        ),
	        this.getClipboardTrigger(command)
	      );
	    }
	  }, {
	    key: "getServiceEditMessage",
	    value: function getServiceEditMessage() {
	      var _props2 = this.props,
	          intl = _props2.intl,
	          service = _props2.service;
	
	
	      return _react2.default.createElement(
	        _foundationUi.MountService.Mount,
	        {
	          type: "ServiceEditMessage:Modal",
	          intl: intl,
	          service: service
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "center" },
	          "Editing this service is only available on",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://mesosphere.com/product/", target: "_blank" },
	            "Mesosphere Enterprise DC/OS"
	          ),
	          "."
	        )
	      );
	    }
	  }, {
	    key: "getServiceMessage",
	    value: function getServiceMessage() {
	      var actionID = this.props.actionID;
	
	
	      switch (actionID) {
	        case _ServiceActionItem.RESTART:
	          return this.getServiceRestartMessage();
	        case _ServiceActionItem.SUSPEND:
	          return this.getServiceSuspendMessage();
	        case _ServiceActionItem.RESUME:
	          return this.getServiceResumeMessage();
	        case _ServiceActionItem.SCALE:
	          return this.getServiceScaleMessage();
	        case _ServiceActionItem.DELETE:
	          return this.getServiceDeleteMessage();
	        case _ServiceActionItem.EDIT:
	          return this.getServiceEditMessage();
	        default:
	          return _react2.default.createElement("noscript", null);
	      }
	    }
	  }, {
	    key: "getServiceTypes",
	    value: function getServiceTypes(testFunction) {
	      return this.props.service.flattenItems().getItems().reduce(function (memo, item) {
	        if (testFunction(item)) {
	          memo.selectedServices.push(item);
	        } else {
	          memo.otherServices.push(item);
	        }
	
	        return memo;
	      }, { selectedServices: [], otherServices: [] });
	    }
	  }, {
	    key: "getServiceList",
	    value: function getServiceList(services) {
	      return services.map(function (item, index) {
	        var comma = index === services.length - 1 ? "" : ", ";
	        var itemID = item.getId();
	
	        return _react2.default.createElement(
	          "span",
	          { key: itemID },
	          _react2.default.createElement(
	            "span",
	            { className: "emphasis" },
	            itemID
	          ),
	          comma
	        );
	      });
	    }
	  }, {
	    key: "getServiceListCommand",
	    value: function getServiceListCommand(services, commandFunction) {
	      return services.map(function (item) {
	        return commandFunction(item);
	      }).join(" &&\n");
	    }
	  }, {
	    key: "getGroupUpdateMessage",
	    value: function getGroupUpdateMessage(updateDescription) {
	      var _props3 = this.props,
	          actionID = _props3.actionID,
	          intl = _props3.intl;
	
	      var _getServiceTypes = this.getServiceTypes(_ServiceUtil.isSDKService),
	          selectedServices = _getServiceTypes.selectedServices,
	          otherServices = _getServiceTypes.otherServices;
	
	      var sdkServicesList = this.getServiceList(selectedServices);
	      var sdkCommand = this.getServiceListCommand(selectedServices, this.getUpdateCommand);
	
	      var otherServicesMessage = "";
	      if (otherServices.length > 0) {
	        var otherServicesList = this.getServiceList(otherServices);
	        var otherCommand = this.getServiceListCommand(otherServices, this.getUpdateCommand);
	
	        otherServicesMessage = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_7" }),
	            " ",
	            otherServicesList,
	            ": ",
	            intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_8" }),
	            " ",
	            _react2.default.createElement(
	              "code",
	              null,
	              "options.json"
	            ),
	            ". ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: _MetadataStore2.default.buildDocsURI("/deploying-services/config-universe-service/"),
	                target: "_blank"
	              },
	              intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	            )
	          ),
	          this.getClipboardTrigger('{"instances": 0}'),
	          _react2.default.createElement(
	            "p",
	            null,
	            intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_9" }),
	            "."
	          ),
	          this.getClipboardTrigger(otherCommand)
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: _ServiceActionLabels2.default[actionID] }),
	          " ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_1" }),
	          " ",
	          updateDescription,
	          " ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_2" }),
	          "."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_3" }),
	          " ",
	          sdkServicesList,
	          ": ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_4" }),
	          " ",
	          _react2.default.createElement(
	            "code",
	            null,
	            "<package-name>-options.json"
	          ),
	          " ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_5" }),
	          ". ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/deploying-services/config-universe-service/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger('{"env": {"<PACKAGE_NAME>_COUNT": "0"}}'),
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_6" }),
	          "."
	        ),
	        this.getClipboardTrigger(sdkCommand),
	        otherServicesMessage
	      );
	    }
	  }, {
	    key: "getGroupDeleteMessage",
	    value: function getGroupDeleteMessage() {
	      var _props4 = this.props,
	          actionID = _props4.actionID,
	          service = _props4.service,
	          intl = _props4.intl;
	
	      var serviceID = service ? service.getId() : "";
	
	      var _getServiceTypes2 = this.getServiceTypes(_ServiceUtil.isSDKService),
	          selectedServices = _getServiceTypes2.selectedServices;
	
	      var packageCommand = this.getServiceListCommand(selectedServices, this.getDeleteCommand);
	      var groupCommand = this.getDeleteCommand();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_DELETE_1" }),
	          ". ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/deploying-services/uninstall/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger(packageCommand),
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_DELETE_4" }),
	          ", ",
	          intl.formatMessage({ id: _ServiceActionLabels2.default[actionID] }).toLowerCase(),
	          " ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_DELETE_5" }),
	          " ",
	          _react2.default.createElement(
	            "span",
	            { className: "emphasis" },
	            serviceID
	          ),
	          ": ",
	          intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_DELETE_6" }),
	          ".",
	          " ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/cli/command-reference/dcos-marathon/dcos-marathon-group-remove/"),
	              target: "_blank"
	            },
	            intl.formatMessage({ id: "DOCS.MORE_INFORMATION" })
	          )
	        ),
	        this.getClipboardTrigger(groupCommand)
	      );
	    }
	  }, {
	    key: "getGroupMessage",
	    value: function getGroupMessage() {
	      var _props5 = this.props,
	          actionID = _props5.actionID,
	          intl = _props5.intl;
	
	
	      switch (actionID) {
	        case _ServiceActionItem.SUSPEND:
	          return this.getGroupUpdateMessage(intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_SUSPEND" }));
	        case _ServiceActionItem.SCALE:
	          return this.getGroupUpdateMessage(intl.formatMessage({ id: "SERVICE_ACTIONS.SDK_GROUP_UPDATE_SCALE" }));
	        case _ServiceActionItem.DELETE:
	          return this.getGroupDeleteMessage();
	        default:
	          return _react2.default.createElement("noscript", null);
	      }
	    }
	  }, {
	    key: "getClipboardTrigger",
	    value: function getClipboardTrigger(command) {
	      return _react2.default.createElement(
	        "div",
	        { className: "code-copy-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "code-copy-icon" },
	          _react2.default.createElement(
	            _ClipboardTrigger2.default,
	            {
	              className: "clickable",
	              copyText: command,
	              onTextCopy: this.handleTextCopy.bind(this, command),
	              useTooltip: true
	            },
	            _react2.default.createElement(_Icon2.default, { id: "clipboard", size: "mini", ref: "copyButton", color: "grey" })
	          )
	        ),
	        _react2.default.createElement(
	          "pre",
	          { className: "prettyprint flush-bottom prettyprinted" },
	          command
	        )
	      );
	    }
	  }, {
	    key: "getHeading",
	    value: function getHeading() {
	      var _props6 = this.props,
	          actionID = _props6.actionID,
	          intl = _props6.intl,
	          service = _props6.service;
	
	
	      var itemText = "Service";
	
	      if (service instanceof _Pod2.default) {
	        itemText = "Pod";
	      }
	
	      if (service instanceof _ServiceTree2.default) {
	        itemText = "Group";
	      }
	
	      var action = actionID ? intl.formatMessage({ id: _ServiceActionLabels2.default[actionID] }) : actionID;
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        action + " " + itemText
	      );
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      var _props7 = this.props,
	          intl = _props7.intl,
	          onClose = _props7.onClose;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection text-align-center flush-bottom" },
	        _react2.default.createElement(
	          "button",
	          { className: "button", onClick: onClose },
	          intl.formatMessage({ id: "BUTTON.CLOSE" })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props8 = this.props,
	          open = _props8.open,
	          onClose = _props8.onClose,
	          service = _props8.service;
	
	      var message = service instanceof _ServiceTree2.default ? this.getGroupMessage() : this.getServiceMessage();
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          open: open,
	          onClose: onClose,
	          header: this.getHeading(),
	          showCloseButton: false,
	          showHeader: true,
	          showFooter: true,
	          footer: this.getFooter()
	        },
	        message
	      );
	    }
	  }]);
	  return ServiceActionDisabledModal;
	}(_react2.default.Component);
	
	ServiceActionDisabledModal.propTypes = {
	  actionID: _react.PropTypes.string,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)])
	};
	
	module.exports = (0, _reactIntl.injectIntl)(ServiceActionDisabledModal);

/***/ },
/* 1613 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceActionLabels = {
	  edit: "SERVICE_ACTIONS.EDIT",
	  delete: "SERVICE_ACTIONS.DELETE",
	  restart: "SERVICE_ACTIONS.RESTART",
	  resume: "SERVICE_ACTIONS.RESUME",
	  open: "SERVICE_ACTIONS.OPEN_SERVICE",
	  scale: "SERVICE_ACTIONS.SCALE",
	  scale_by: "SERVICE_ACTIONS.SCALE_BY",
	  suspend: "SERVICE_ACTIONS.SUSPEND"
	};
	
	module.exports = ServiceActionLabels;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionItem2 = _interopRequireDefault(_ServiceActionItem);
	
	var _ServiceDestroyModal = __webpack_require__(1615);
	
	var _ServiceDestroyModal2 = _interopRequireDefault(_ServiceDestroyModal);
	
	var _ServiceGroupFormModal = __webpack_require__(1616);
	
	var _ServiceGroupFormModal2 = _interopRequireDefault(_ServiceGroupFormModal);
	
	var _ServiceRestartModal = __webpack_require__(1617);
	
	var _ServiceRestartModal2 = _interopRequireDefault(_ServiceRestartModal);
	
	var _ServiceResumeModal = __webpack_require__(1618);
	
	var _ServiceResumeModal2 = _interopRequireDefault(_ServiceResumeModal);
	
	var _ServiceScaleFormModal = __webpack_require__(1623);
	
	var _ServiceScaleFormModal2 = _interopRequireDefault(_ServiceScaleFormModal);
	
	var _ServiceSpecUtil = __webpack_require__(1624);
	
	var _ServiceSpecUtil2 = _interopRequireDefault(_ServiceSpecUtil);
	
	var _ServiceSuspendModal = __webpack_require__(1625);
	
	var _ServiceSuspendModal2 = _interopRequireDefault(_ServiceSuspendModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceModals = function (_React$Component) {
	  (0, _inherits3.default)(ServiceModals, _React$Component);
	
	  function ServiceModals() {
	    (0, _classCallCheck3.default)(this, ServiceModals);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceModals.__proto__ || (0, _getPrototypeOf2.default)(ServiceModals)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceModals, [{
	    key: "getGroupModal",
	    value: function getGroupModal() {
	      var _props = this.props,
	          actions = _props.actions,
	          actionErrors = _props.actionErrors,
	          _clearError = _props.clearError,
	          _onClose = _props.onClose,
	          modalProps = _props.modalProps,
	          pendingActions = _props.pendingActions;
	
	
	      var key = _ActionKeys2.default.GROUP_CREATE;
	      var service = modalProps.service;
	
	
	      return _react2.default.createElement(_ServiceGroupFormModal2.default, {
	        createGroup: actions.createGroup,
	        clearError: function clearError() {
	          return _clearError(key);
	        },
	        isPending: !!pendingActions[key],
	        errors: actionErrors[key],
	        parentGroupId: service.getId(),
	        open: modalProps.id === _ServiceActionItem2.default.CREATE_GROUP,
	        onClose: function onClose() {
	          return _onClose(key);
	        }
	      });
	    }
	  }, {
	    key: "getDestroyModal",
	    value: function getDestroyModal() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          actionErrors = _props2.actionErrors,
	          _onClose2 = _props2.onClose,
	          modalProps = _props2.modalProps,
	          pendingActions = _props2.pendingActions;
	      var service = modalProps.service;
	
	      var isGroup = service instanceof _ServiceTree2.default;
	
	      var deleteItem = function deleteItem(force) {
	        return _this2.props.actions.deleteService(service, force);
	      };
	      var key = _ActionKeys2.default.SERVICE_DELETE;
	
	      if (isGroup) {
	        deleteItem = function deleteItem(force) {
	          return _this2.props.actions.deleteGroup(service.getId(), force);
	        };
	        key = _ActionKeys2.default.GROUP_DELETE;
	      }
	
	      return _react2.default.createElement(_ServiceDestroyModal2.default, {
	        deleteItem: deleteItem,
	        errors: actionErrors[key],
	        isPending: !!pendingActions[key],
	        open: modalProps.id === _ServiceActionItem2.default.DELETE,
	        onClose: function onClose() {
	          return _onClose2(key);
	        },
	        service: service
	      });
	    }
	  }, {
	    key: "getRestartModal",
	    value: function getRestartModal() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionErrors = _props3.actionErrors,
	          _onClose3 = _props3.onClose,
	          modalProps = _props3.modalProps,
	          pendingActions = _props3.pendingActions;
	
	
	      var key = _ActionKeys2.default.SERVICE_RESTART;
	      var service = modalProps.service;
	
	
	      return _react2.default.createElement(_ServiceRestartModal2.default, {
	        restartService: actions.restartService,
	        isPending: !!pendingActions[key],
	        errors: actionErrors[key],
	        open: modalProps.id === _ServiceActionItem2.default.RESTART,
	        onClose: function onClose() {
	          return _onClose3(key);
	        },
	        service: service
	      });
	    }
	  }, {
	    key: "getResumeModal",
	    value: function getResumeModal() {
	      var _props4 = this.props,
	          actions = _props4.actions,
	          actionErrors = _props4.actionErrors,
	          _onClose4 = _props4.onClose,
	          modalProps = _props4.modalProps,
	          pendingActions = _props4.pendingActions;
	
	
	      var key = _ActionKeys2.default.SERVICE_EDIT;
	      var service = modalProps.service;
	
	
	      var resumeService = function resumeService(instances, force) {
	        return actions.editService(service, _ServiceSpecUtil2.default.setServiceInstances(service.getSpec(), parseInt(instances, 10)), force);
	      };
	
	      return _react2.default.createElement(_ServiceResumeModal2.default, {
	        resumeService: resumeService,
	        isPending: !!pendingActions[key],
	        errors: actionErrors[key],
	        open: modalProps.id === _ServiceActionItem2.default.RESUME,
	        onClose: function onClose() {
	          return _onClose4(key);
	        },
	        service: service
	      });
	    }
	  }, {
	    key: "getScaleModal",
	    value: function getScaleModal() {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          actionErrors = _props5.actionErrors,
	          _onClose5 = _props5.onClose,
	          modalProps = _props5.modalProps,
	          pendingActions = _props5.pendingActions;
	      var service = modalProps.service;
	
	      var isGroup = service instanceof _ServiceTree2.default;
	
	      var key = _ActionKeys2.default.SERVICE_EDIT;
	      var scaleItem = function scaleItem(instances, force) {
	        return _this3.props.actions.editService(service, _ServiceSpecUtil2.default.setServiceInstances(service.getSpec(), parseInt(instances, 10)), force);
	      };
	
	      if (isGroup) {
	        key = _ActionKeys2.default.GROUP_EDIT;
	        scaleItem = function scaleItem(instances, force) {
	          return _this3.props.actions.editGroup({
	            id: service.id,
	            scaleBy: parseInt(instances, 10)
	          }, force);
	        };
	      }
	
	      return _react2.default.createElement(_ServiceScaleFormModal2.default, {
	        scaleItem: scaleItem,
	        errors: actionErrors[key],
	        isPending: !!pendingActions[key],
	        open: modalProps.id === _ServiceActionItem2.default.SCALE,
	        onClose: function onClose() {
	          return _onClose5(key);
	        },
	        service: service
	      });
	    }
	  }, {
	    key: "getSuspendModal",
	    value: function getSuspendModal() {
	      var _this4 = this;
	
	      var _props6 = this.props,
	          actionErrors = _props6.actionErrors,
	          _onClose6 = _props6.onClose,
	          modalProps = _props6.modalProps,
	          pendingActions = _props6.pendingActions;
	      var service = modalProps.service;
	
	      var isGroup = service instanceof _ServiceTree2.default;
	
	      var key = _ActionKeys2.default.SERVICE_EDIT;
	      var suspendItem = function suspendItem(force) {
	        return _this4.props.actions.editService(service, _ServiceSpecUtil2.default.setServiceInstances(service.getSpec(), 0), force);
	      };
	
	      if (isGroup) {
	        key = _ActionKeys2.default.GROUP_EDIT;
	        suspendItem = function suspendItem(force) {
	          return _this4.props.actions.editGroup({
	            id: service.getId(),
	            scaleBy: 0
	          }, force);
	        };
	      }
	
	      return _react2.default.createElement(_ServiceSuspendModal2.default, {
	        suspendItem: suspendItem,
	        errors: actionErrors[key],
	        isPending: !!pendingActions[key],
	        open: modalProps.id === _ServiceActionItem2.default.SUSPEND,
	        onClose: function onClose() {
	          return _onClose6(key);
	        },
	        service: service
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.getGroupModal(),
	        this.getDestroyModal(),
	        this.getRestartModal(),
	        this.getResumeModal(),
	        this.getScaleModal(),
	        this.getSuspendModal()
	      );
	    }
	  }]);
	  return ServiceModals;
	}(_react2.default.Component);
	
	var actionPropTypes = _react.PropTypes.shape({
	  revertDeployment: _react.PropTypes.func,
	  createGroup: _react.PropTypes.func,
	  deleteGroup: _react.PropTypes.func,
	  editGroup: _react.PropTypes.func,
	  deleteService: _react.PropTypes.func,
	  restartService: _react.PropTypes.func
	}).isRequired;
	
	ServiceModals.propTypes = {
	  actionErrors: _react.PropTypes.object.isRequired,
	  actions: actionPropTypes,
	  clearError: _react.PropTypes.func.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  modalProps: _react.PropTypes.object,
	  pendingActions: _react.PropTypes.object
	};
	
	module.exports = ServiceModals;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(753);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ClickToSelect = __webpack_require__(1411);
	
	var _ClickToSelect2 = _interopRequireDefault(_ClickToSelect);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This needs to be at least equal to @modal-animation-duration
	var REDIRECT_DELAY = 300;
	var METHODS_TO_BIND = ["handleChangeInputFieldDestroy", "handleModalClose", "handleRightButtonClick"];
	
	var ServiceDestroyModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceDestroyModal, _React$Component);
	
	  function ServiceDestroyModal() {
	    (0, _classCallCheck3.default)(this, ServiceDestroyModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceDestroyModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceDestroyModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null,
	      serviceNameConfirmationValue: ""
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceDestroyModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.redirectToServices();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose() {
	      this.setState({ serviceNameConfirmationValue: "" });
	      this.props.onClose();
	    }
	  }, {
	    key: "handleRightButtonClick",
	    value: function handleRightButtonClick() {
	      if (!this.getIsRightButtonDisabled()) {
	        this.props.deleteItem(this.shouldForceUpdate());
	        this.setState({ serviceNameConfirmationValue: "" });
	      }
	    }
	  }, {
	    key: "handleChangeInputFieldDestroy",
	    value: function handleChangeInputFieldDestroy(event) {
	      this.setState({
	        serviceNameConfirmationValue: event.target.value
	      });
	    }
	  }, {
	    key: "getIsRightButtonDisabled",
	    value: function getIsRightButtonDisabled() {
	      return this.props.service.getName() !== this.state.serviceNameConfirmationValue;
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var _state$errorMsg = this.state.errorMsg,
	          errorMsg = _state$errorMsg === undefined ? null : _state$errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, { service: this.props.service });
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "redirectToServices",
	    value: function redirectToServices() {
	      var router = this.context.router;
	
	      // Close the modal and redirect after the close animation has completed
	
	      this.handleModalClose();
	      setTimeout(function () {
	        router.push({ pathname: "/services/overview" });
	      }, REDIRECT_DELAY);
	    }
	  }, {
	    key: "getCloseButton",
	    value: function getCloseButton() {
	      return _react2.default.createElement(
	        "div",
	        { className: "row text-align-center" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button-primary button-medium",
	            onClick: this.handleModalClose
	          },
	          "Close"
	        )
	      );
	    }
	  }, {
	    key: "getDestroyFrameworkModal",
	    value: function getDestroyFrameworkModal() {
	      var _props = this.props,
	          open = _props.open,
	          service = _props.service,
	          intl = _props.intl;
	
	      var packageName = service.getPackageName();
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          header: this.getModalHeading(),
	          footer: this.getCloseButton(),
	          modalClass: "modal",
	          onClose: this.handleModalClose,
	          open: open,
	          showHeader: true,
	          showFooter: true,
	          subHeader: this.getSubHeader()
	        },
	        _react2.default.createElement(
	          "p",
	          null,
	          intl.formatMessage({
	            id: "SERVICE_ACTIONS.DELETE_SERVICE_FRAMEWORK"
	          }),
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://docs.mesosphere.com/service-docs/",
	              target: "_blank",
	              title: intl.formatMessage({
	                id: "COMMON.DOCUMENTATION_TITLE"
	              })
	            },
	            intl.formatMessage({
	              id: "COMMON.DOCUMENTATION"
	            })
	          ),
	          intl.formatMessage({
	            id: "SERVICE_ACTIONS.DELETE_SERVICE_FRAMEWORK_2"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "flush-top snippet-wrapper" },
	          _react2.default.createElement(
	            _ClickToSelect2.default,
	            null,
	            _react2.default.createElement(
	              "pre",
	              { className: "prettyprint flush-bottom" },
	              "dcos package uninstall",
	              " ",
	              packageName,
	              " --app-id=",
	              service.getId()
	            )
	          )
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }, {
	    key: "getDestroyServiceModal",
	    value: function getDestroyServiceModal() {
	      var _props2 = this.props,
	          open = _props2.open,
	          service = _props2.service;
	
	      var serviceName = service.getName();
	      var serviceLabel = this.getServiceLabel();
	      var itemText = _StringUtil2.default.capitalize(_UserActions2.default.DELETE) + " " + serviceLabel;
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          disabled: this.getIsRightButtonDisabled(),
	          header: this.getModalHeading(),
	          open: open,
	          onClose: this.handleModalClose,
	          leftButtonText: "Cancel",
	          leftButtonCallback: this.handleModalClose,
	          rightButtonText: itemText,
	          rightButtonClassName: "button button-danger",
	          rightButtonCallback: this.handleRightButtonClick,
	          showHeader: true
	        },
	        _react2.default.createElement(
	          "p",
	          null,
	          "This action",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "CANNOT"
	          ),
	          " be undone. This will permanently delete the",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            serviceName
	          ),
	          " ",
	          serviceLabel.toLowerCase(),
	          ". Type (\"",
	          _react2.default.createElement(
	            "strong",
	            null,
	            serviceName
	          ),
	          "\") below to confirm you want to delete the",
	          " ",
	          serviceLabel.toLowerCase(),
	          "."
	        ),
	        _react2.default.createElement("input", {
	          className: "form-control filter-input-text",
	          onChange: this.handleChangeInputFieldDestroy,
	          type: "text",
	          value: this.state.serviceNameConfirmationValue,
	          autoFocus: true
	        }),
	        this.getErrorMessage()
	      );
	    }
	  }, {
	    key: "getModalHeading",
	    value: function getModalHeading() {
	      var serviceLabel = this.getServiceLabel();
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        { className: "text-danger" },
	        _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	        " ",
	        serviceLabel
	      );
	    }
	  }, {
	    key: "getSubHeader",
	    value: function getSubHeader() {
	      if (!this.props.subHeaderContent) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "text-align-center flush-bottom" },
	        this.props.subHeaderContent
	      );
	    }
	  }, {
	    key: "getServiceLabel",
	    value: function getServiceLabel() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Pod2.default) {
	        return "Pod";
	      }
	
	      if (service instanceof _ServiceTree2.default) {
	        return "Group";
	      }
	
	      return "Service";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Framework2.default) {
	        return this.getDestroyFrameworkModal();
	      }
	
	      return this.getDestroyServiceModal();
	    }
	  }]);
	  return ServiceDestroyModal;
	}(_react2.default.Component);
	
	ServiceDestroyModal.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	ServiceDestroyModal.propTypes = {
	  deleteItem: _react.PropTypes.func.isRequired,
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  intl: _reactIntl.intlShape.isRequired,
	  isPending: _react.PropTypes.bool.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_Framework2.default), _react.PropTypes.instanceOf(_Pod2.default), _react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)]).isRequired
	};
	
	module.exports = (0, _reactIntl.injectIntl)(ServiceDestroyModal);

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _FormModal = __webpack_require__(1350);
	
	var _FormModal2 = _interopRequireDefault(_FormModal);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ServiceValidatorUtil = __webpack_require__(1247);
	
	var _ServiceValidatorUtil2 = _interopRequireDefault(_ServiceValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleNewGroupSubmit"];
	
	var ServiceGroupFormModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceGroupFormModal, _React$Component);
	
	  function ServiceGroupFormModal() {
	    (0, _classCallCheck3.default)(this, ServiceGroupFormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceGroupFormModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceGroupFormModal)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceGroupFormModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "handleNewGroupSubmit",
	    value: function handleNewGroupSubmit(model) {
	      var parentGroupId = this.props.parentGroupId;
	
	
	      this.props.createGroup((0, _assign2.default)({}, model, { id: parentGroupId + "/" + model.id }));
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var errors = this.props.errors;
	
	      if (!errors) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errors
	      );
	    }
	  }, {
	    key: "getNewGroupFormDefinition",
	    value: function getNewGroupFormDefinition() {
	      return [{
	        fieldType: "text",
	        name: "id",
	        placeholder: "Group name",
	        required: true,
	        showLabel: false,
	        writeType: "input",
	        validation: _ServiceValidatorUtil2.default.isValidServiceID,
	        validationErrorText: "Group name must be at least 1 character and " + "may only contain digits (0-9), dashes (-), dots (.), " + "and lowercase letters (a-z). The name may not begin or end " + "with a dash."
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          clearError = _props.clearError,
	          isPending = _props.isPending,
	          onClose = _props.onClose,
	          open = _props.open,
	          parentGroupId = _props.parentGroupId;
	
	
	      var buttonDefinition = [{
	        text: "Cancel",
	        className: "button button-medium",
	        isClose: true
	      }, {
	        text: "Create Group",
	        className: "button button-success button-medium",
	        isSubmit: true
	      }];
	
	      return _react2.default.createElement(
	        _FormModal2.default,
	        {
	          ref: "form",
	          buttonDefinition: buttonDefinition,
	          disabled: isPending,
	          modalProps: {
	            header: _react2.default.createElement(
	              _ModalHeading2.default,
	              null,
	              "Create Group"
	            ),
	            showHeader: true
	          },
	          onClose: onClose,
	          onSubmit: this.handleNewGroupSubmit,
	          onChange: clearError,
	          open: open,
	          definition: this.getNewGroupFormDefinition()
	        },
	        _react2.default.createElement(
	          "p",
	          { className: "text-align-center flush-top" },
	          "Enter a path for the new group under ",
	          _react2.default.createElement(
	            "span",
	            { className: "emphasize" },
	            parentGroupId
	          )
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return ServiceGroupFormModal;
	}(_react2.default.Component);
	
	ServiceGroupFormModal.propTypes = {
	  clearError: _react.PropTypes.func.isRequired,
	  createGroup: _react.PropTypes.func.isRequired,
	  errors: _react.PropTypes.string,
	  isPending: _react.PropTypes.bool.isRequired,
	  parentGroupId: _react.PropTypes.string,
	  onClose: _react.PropTypes.func.isRequired
	};
	
	module.exports = ServiceGroupFormModal;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceRestartModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceRestartModal, _React$Component);
	
	  function ServiceRestartModal() {
	    (0, _classCallCheck3.default)(this, ServiceRestartModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceRestartModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceRestartModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceRestartModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var _state$errorMsg = this.state.errorMsg,
	          errorMsg = _state$errorMsg === undefined ? null : _state$errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, { service: this.props.service });
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getServiceLabel",
	    value: function getServiceLabel() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Pod2.default) {
	        return "Pod";
	      }
	
	      if (service instanceof _ServiceTree2.default) {
	        return "Group";
	      }
	
	      return "Service";
	    }
	  }, {
	    key: "getModalHeading",
	    value: function getModalHeading() {
	      var serviceLabel = this.getServiceLabel();
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Restart ",
	        serviceLabel
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isPending = _props.isPending,
	          onClose = _props.onClose,
	          open = _props.open,
	          service = _props.service,
	          restartService = _props.restartService;
	
	      var serviceName = service.getName();
	      var serviceLabel = this.getServiceLabel();
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          disabled: isPending,
	          header: this.getModalHeading(),
	          open: open,
	          onClose: onClose,
	          leftButtonCallback: onClose,
	          rightButtonText: "Restart " + serviceLabel,
	          rightButtonClassName: "button button-danger",
	          rightButtonCallback: function rightButtonCallback() {
	            return restartService(service, _this2.shouldForceUpdate());
	          },
	          showHeader: true
	        },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Restarting the",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            serviceName
	          ),
	          " ",
	          serviceLabel.toLowerCase(),
	          " ",
	          "will remove all currently running instances of the",
	          " ",
	          serviceLabel.toLowerCase(),
	          " ",
	          "and then attempt to create new instances identical to those removed."
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return ServiceRestartModal;
	}(_react2.default.Component);
	
	ServiceRestartModal.propTypes = {
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  restartService: _react.PropTypes.func.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)]).isRequired
	};
	
	module.exports = ServiceRestartModal;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleConfirmation", "handleInstancesFieldChange"];
	
	var ServiceResumeModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceResumeModal, _React$Component);
	
	  function ServiceResumeModal() {
	    (0, _classCallCheck3.default)(this, ServiceResumeModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceResumeModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceResumeModal)).apply(this, arguments));
	
	    _this.state = {
	      instancesFieldValue: null,
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceResumeModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "handleConfirmation",
	    value: function handleConfirmation() {
	      var instances = this.state.instancesFieldValue == null ? 1 : this.state.instancesFieldValue;
	
	      this.props.resumeService(instances, this.shouldForceUpdate());
	    }
	  }, {
	    key: "handleInstancesFieldChange",
	    value: function handleInstancesFieldChange(event) {
	      this.setState({
	        instancesFieldValue: event.target.value
	      });
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var _state$errorMsg = this.state.errorMsg,
	          errorMsg = _state$errorMsg === undefined ? null : _state$errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, { service: this.props.service });
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getModalContent",
	    value: function getModalContent() {
	      var service = this.props.service;
	
	
	      if (service.getLabels().MARATHON_SINGLE_INSTANCE_APP) {
	        return _react2.default.createElement(
	          "p",
	          null,
	          "This service is currently suspended. Do you want to resume this service?"
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "This service is currently suspended. Do you want to resume this service? You can change the number of instances to resume by using the field below."
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12 column-small-6 column-small-offset-3 flush-bottom" },
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "instances",
	              onChange: this.handleInstancesFieldChange,
	              type: "number",
	              value: "1"
	            })
	          )
	        )
	      );
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          isPending = _props.isPending,
	          onClose = _props.onClose,
	          open = _props.open;
	
	
	      var heading = _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Resume Service"
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          disabled: isPending,
	          header: heading,
	          open: open,
	          onClose: onClose,
	          leftButtonCallback: onClose,
	          rightButtonText: "Resume Service",
	          rightButtonClassName: "button button-primary",
	          rightButtonCallback: this.handleConfirmation,
	          showHeader: true
	        },
	        this.getModalContent(),
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return ServiceResumeModal;
	}(_react2.default.Component);
	
	ServiceResumeModal.propTypes = {
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  resumeService: _react.PropTypes.func.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)]).isRequired
	};
	
	module.exports = ServiceResumeModal;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldInput = function FieldInput(props) {
	  var className = props.className,
	      type = props.type;
	
	  var classes = (0, _dedupe2.default)("form-control", className);
	
	  var toggleIndicator = void 0;
	  if (["radio", "checkbox"].includes(type)) {
	    toggleIndicator = _react2.default.createElement("span", { className: "form-control-toggle-indicator" });
	  }
	
	  return _react2.default.createElement(
	    "span",
	    null,
	    _react2.default.createElement("input", (0, _extends3.default)({ className: classes }, (0, _Util.omit)(props, ["className"]))),
	    toggleIndicator
	  );
	};
	
	FieldInput.defaultProps = {
	  onChange: function onChange() {},
	
	  value: ""
	};
	
	FieldInput.propTypes = {
	  type: _react2.default.PropTypes.string,
	  onChange: _react2.default.PropTypes.func,
	  checked: _react2.default.PropTypes.bool,
	  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]),
	
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = FieldInput;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormGroup = function FormGroup(props) {
	  var _classNames;
	
	  var children = props.children,
	      className = props.className,
	      errorClassName = props.errorClassName,
	      hasNarrowMargins = props.hasNarrowMargins,
	      applyLabelOffset = props.applyLabelOffset,
	      showError = props.showError;
	
	
	  var clonedChildren = _react2.default.Children.map(children, function (child) {
	    if (child != null && !showError && child.type === _FieldError2.default) {
	      return null;
	    }
	
	    return child;
	  });
	
	  var classes = (0, _dedupe2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, errorClassName, showError), (0, _defineProperty3.default)(_classNames, "form-group-without-top-label", applyLabelOffset), (0, _defineProperty3.default)(_classNames, "column-auto flush-left flush-right", hasNarrowMargins), _classNames), "form-group", className);
	
	  return _react2.default.createElement(
	    "div",
	    (0, _extends3.default)({ className: classes }, (0, _Util.omit)(props, (0, _keys2.default)(FormGroup.propTypes))),
	    clonedChildren
	  );
	};
	
	FormGroup.defaultProps = {
	  errorClassName: "form-group-danger",
	  applyLabelOffset: false,
	  hasNarrowMargins: false
	};
	
	var classPropType = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	FormGroup.propTypes = {
	  children: _react2.default.PropTypes.node,
	  // Optional boolean to display error
	  showError: _react2.default.PropTypes.bool,
	
	  // Classes
	  className: classPropType,
	  // Class to be toggled, can be overridden by className
	  errorClassName: _react2.default.PropTypes.string,
	  // When true, will add padding to the top of the form group to vertically
	  // align it with its siblings that have labels.
	  applyLabelOffset: _react2.default.PropTypes.bool,
	  // When true, the component will apply specific styles for use with the delete
	  // row button
	  hasNarrowMargins: _react2.default.PropTypes.bool
	};
	
	module.exports = FormGroup;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldError = function FieldError(props) {
	  var className = props.className;
	
	  var classes = (0, _dedupe2.default)("form-control-feedback", className);
	
	  return _react2.default.createElement("p", (0, _extends3.default)({
	    className: classes
	  }, (0, _Util.omit)(props, (0, _keys2.default)(FieldError.propTypes))));
	};
	
	FieldError.propTypes = {
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = FieldError;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormRow = function FormRow(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "form-row row" },
	    children
	  );
	};
	
	module.exports = FormRow;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _FormModal = __webpack_require__(1350);
	
	var _FormModal2 = _interopRequireDefault(_FormModal);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceScaleFormModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceScaleFormModal, _React$Component);
	
	  function ServiceScaleFormModal() {
	    (0, _classCallCheck3.default)(this, ServiceScaleFormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceScaleFormModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceScaleFormModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceScaleFormModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var _state$errorMsg = this.state.errorMsg,
	          errorMsg = _state$errorMsg === undefined ? null : _state$errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, { service: this.props.service });
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getScaleFormDefinition",
	    value: function getScaleFormDefinition() {
	      var service = this.props.service;
	
	      var instancesCount = service.getInstancesCount();
	
	      if (service instanceof _ServiceTree2.default) {
	        instancesCount = "1.0";
	      }
	
	      return [{
	        fieldType: "number",
	        formElementClass: "horizontal-center",
	        min: 0,
	        name: "instances",
	        placeholder: instancesCount,
	        value: instancesCount.toString(),
	        required: true,
	        showLabel: false,
	        writeType: "input"
	      }];
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      var headerText = "Service";
	
	      if (this.props.service instanceof _Pod2.default) {
	        headerText = "Pod";
	      }
	
	      if (this.props.service instanceof _ServiceTree2.default) {
	        headerText = "Group";
	      }
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Scale ",
	        headerText
	      );
	    }
	  }, {
	    key: "getBodyText",
	    value: function getBodyText() {
	      var bodyText = "How many instances would you like to scale to?";
	
	      if (this.props.service instanceof _ServiceTree2.default) {
	        bodyText = "By which factor would you like to scale all applications within this group?";
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "text-align-center flush-top" },
	        bodyText
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          clearError = _props.clearError,
	          isPending = _props.isPending,
	          onClose = _props.onClose,
	          open = _props.open;
	
	
	      var buttonDefinition = [{
	        text: "Cancel",
	        className: "button button-medium",
	        isClose: true
	      }, {
	        text: "Scale Service",
	        className: "button button-primary button-medium",
	        isSubmit: true
	      }];
	
	      var onSubmit = function onSubmit(model) {
	        _this2.props.scaleItem(model.instances, _this2.shouldForceUpdate());
	      };
	
	      return _react2.default.createElement(
	        _FormModal2.default,
	        {
	          buttonDefinition: buttonDefinition,
	          definition: this.getScaleFormDefinition(),
	          modalProps: {
	            header: this.getHeader(),
	            showHeader: true
	          },
	          disabled: isPending,
	          onClose: onClose,
	          onSubmit: onSubmit,
	          onChange: clearError,
	          open: open
	        },
	        this.getBodyText(),
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return ServiceScaleFormModal;
	}(_react2.default.Component);
	
	ServiceScaleFormModal.propTypes = {
	  scaleItem: _react.PropTypes.func.isRequired,
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)]).isRequired
	};
	
	module.exports = ServiceScaleFormModal;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _FrameworkSpec = __webpack_require__(1099);
	
	var _FrameworkSpec2 = _interopRequireDefault(_FrameworkSpec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceSpecUtil = {
	  /**
	   * Creates a new PodSpec with the scaling specifications
	   * changed to fixed, and with the number of instances defined
	   * from the second argument.
	   *
	   * @param {PodSpec} spec - The spec to change
	   * @param {number} instancesCount - The new number of instances
	   * @returns {PodSpec} - Returns a new PodSpec instance
	   */
	  setPodInstances: function setPodInstances(spec, instancesCount) {
	    var newSpec = _Util2.default.deepCopy(spec.get());
	    if (!newSpec.scaling) {
	      newSpec.scaling = {};
	    }
	    if (newSpec.scaling.kind !== "fixed") {
	      newSpec.scaling = {
	        kind: "fixed",
	        instances: 1
	      };
	    }
	
	    newSpec.scaling.instances = instancesCount;
	
	    return new _PodSpec2.default(newSpec);
	  },
	
	
	  /**
	   * Create a new ApplicationSpec with the instances property
	   * set to the instancesCount specified.
	   *
	   * @param {ApplicationSpec} spec - The spec to change
	   * @param {number} instancesCount - The new number of instances
	   * @returns {ApplicationSpec} - Returns a new ApplicationSpec instance
	   */
	  setApplicationInstances: function setApplicationInstances(spec, instancesCount) {
	    var newSpec = _Util2.default.deepCopy(spec.get());
	    newSpec.instances = instancesCount;
	
	    return new _ApplicationSpec2.default(newSpec);
	  },
	
	
	  /**
	   * Create a new FrameworkSpec with the instances property
	   * set to the instancesCount specified.
	   *
	   * @param {FrameworkSpec} spec - The spec to change
	   * @param {number} instancesCount - The new number of instances
	   * @returns {FrameworkSpec} - Returns a new FrameworkSpec instance
	   */
	  setFrameworkInstances: function setFrameworkInstances(spec, instancesCount) {
	    var newSpec = _Util2.default.deepCopy(spec.get());
	    newSpec.instances = instancesCount;
	
	    return new _FrameworkSpec2.default(newSpec);
	  },
	
	
	  /**
	   * High-level action for picking the correct scaling function according
	   * to spec type.
	   *
	   * @param {PodSpec|ApplicationSpec|FrameworkSpec} spec - The spec to change
	   * @param {number} instancesCount - The new number of instances
	   * @returns {PodSpec|ApplicationSpec|FrameworkSpec} - Returns a new instance
	   */
	  setServiceInstances: function setServiceInstances(spec, instancesCount) {
	    if (spec instanceof _PodSpec2.default) {
	      return ServiceSpecUtil.setPodInstances(spec, instancesCount);
	    } else if (spec instanceof _FrameworkSpec2.default) {
	      return ServiceSpecUtil.setFrameworkInstances(spec, instancesCount);
	    } else if (spec instanceof _ApplicationSpec2.default) {
	      return ServiceSpecUtil.setApplicationInstances(spec, instancesCount);
	    }
	  }
	};
	
	module.exports = ServiceSpecUtil;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(1318);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _AppLockedMessage = __webpack_require__(1558);
	
	var _AppLockedMessage2 = _interopRequireDefault(_AppLockedMessage);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceSuspendModal = function (_React$Component) {
	  (0, _inherits3.default)(ServiceSuspendModal, _React$Component);
	
	  function ServiceSuspendModal() {
	    (0, _classCallCheck3.default)(this, ServiceSuspendModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceSuspendModal.__proto__ || (0, _getPrototypeOf2.default)(ServiceSuspendModal)).apply(this, arguments));
	
	    _this.state = {
	      errorMsg: null
	    };
	
	    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceSuspendModal, [{
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps) {
	      var requestCompleted = this.props.isPending && !nextProps.isPending;
	
	      var shouldClose = requestCompleted && !nextProps.errors;
	
	      if (shouldClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var errors = nextProps.errors;
	
	      if (!errors) {
	        this.setState({ errorMsg: null });
	
	        return;
	      }
	
	      if (typeof errors === "string") {
	        this.setState({ errorMsg: errors });
	
	        return;
	      }
	
	      var _errors$message = errors.message,
	          errorMsg = _errors$message === undefined ? "" : _errors$message,
	          details = errors.details;
	
	      var hasDetails = details && details.length !== 0;
	
	      if (hasDetails) {
	        errorMsg = details.reduce(function (memo, error) {
	          return memo + " " + error.errors.join(" ");
	        }, "");
	      }
	
	      if (!errorMsg || !errorMsg.length) {
	        errorMsg = null;
	      }
	
	      this.setState({ errorMsg: errorMsg });
	    }
	  }, {
	    key: "shouldForceUpdate",
	    value: function shouldForceUpdate() {
	      return this.state.errorMsg && /force=true/.test(this.state.errorMsg);
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var _state$errorMsg = this.state.errorMsg,
	          errorMsg = _state$errorMsg === undefined ? null : _state$errorMsg;
	
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      if (this.shouldForceUpdate()) {
	        return _react2.default.createElement(_AppLockedMessage2.default, { service: this.props.service });
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "getServiceLabel",
	    value: function getServiceLabel() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Pod2.default) {
	        return "Pod";
	      }
	
	      if (service instanceof _ServiceTree2.default) {
	        return "Group";
	      }
	
	      return "Service";
	    }
	  }, {
	    key: "getModalHeading",
	    value: function getModalHeading() {
	      var serviceLabel = this.getServiceLabel();
	
	      return _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Suspend ",
	        serviceLabel
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isPending = _props.isPending,
	          onClose = _props.onClose,
	          open = _props.open,
	          service = _props.service,
	          suspendItem = _props.suspendItem;
	
	      var serviceLabel = this.getServiceLabel();
	      var serviceName = service.getName();
	
	      return _react2.default.createElement(
	        _reactjsComponents.Confirm,
	        {
	          disabled: isPending,
	          header: this.getModalHeading(),
	          open: open,
	          onClose: onClose,
	          leftButtonCallback: onClose,
	          rightButtonText: "Suspend " + serviceLabel,
	          rightButtonCallback: function rightButtonCallback() {
	            return suspendItem(_this2.shouldForceUpdate());
	          },
	          showHeader: true
	        },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Suspending the",
	          " ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            serviceName
	          ),
	          " ",
	          serviceLabel.toLowerCase(),
	          " ",
	          "will remove all currently running instances of the",
	          " ",
	          serviceLabel.toLowerCase(),
	          ".",
	          " ",
	          "The ",
	          serviceLabel.toLowerCase(),
	          " will not be deleted."
	        ),
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return ServiceSuspendModal;
	}(_react2.default.Component);
	
	ServiceSuspendModal.propTypes = {
	  suspendItem: _react.PropTypes.func.isRequired,
	  errors: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  isPending: _react.PropTypes.bool.isRequired,
	  onClose: _react.PropTypes.func.isRequired,
	  open: _react.PropTypes.bool.isRequired,
	  service: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_ServiceTree2.default), _react.PropTypes.instanceOf(_Service2.default)]).isRequired
	};
	
	module.exports = ServiceSuspendModal;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "has";
	var LABEL_TEXT = "volumes";
	
	/**
	 * This filter handles the `has:volumes` for filtering services with volumes
	 */
	
	var ServiceAttributeHasVolumesFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttributeHasVolumesFilter, _DSLFilter);
	
	  function ServiceAttributeHasVolumesFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttributeHasVolumesFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttributeHasVolumesFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttributeHasVolumesFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttributeHasVolumesFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `has:volumes` attrib filters.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && filterArguments.text.toLowerCase() === LABEL_TEXT;
	    }
	
	    /**
	     * Keep only services that contain more than 1 volume
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset) {
	      return resultset.filterItems(function (service) {
	        var volumes = service.getVolumes();
	
	        return volumes.list && volumes.list.length > 0;
	      });
	    }
	  }]);
	  return ServiceAttributeHasVolumesFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttributeHasVolumesFilter;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This is the base class for implementing custom DSL Filters
	 */
	var DSLFilter = function () {
	  function DSLFilter() {
	    (0, _classCallCheck3.default)(this, DSLFilter);
	  }
	
	  (0, _createClass3.default)(DSLFilter, [{
	    key: "filterCanHandle",
	
	    /* eslint-disable no-unused-vars */
	
	    /**
	     * Returns true if the filter can be applied to the given operand
	     *
	     * @abstract
	     * @param {DSLFilterTypes} filterType -
	     *  The filter type (ex. fuzzy or attribute)
	     * @param {Object} filterArguments - The filter arguments
	     * @returns {Boolean} True if the filter can be applied to the given operand
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return false;
	    }
	
	    /**
	     * Apply the filter to the given result set, using the operand details given
	     *
	     * @abstract
	     * @param {List} resultset - The list with the results to filter
	     * @param {DSLFilterTypes} filterType -
	     *  The filter type (ex. fuzzy or attribute)
	     * @param {Object} filterArguments - The filter arguments
	     * @returns {List} Returns the new, filtered list
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset, filterType, filterArguments) {
	      return resultset;
	    }
	
	    /**
	     * Return typeahead components for the given state of the filter
	     *
	     * @abstract
	     * @param {DSLFilterTypes} filterType -
	     *  The filter type (ex. fuzzy or attribute)
	     * @param {Object} filterArguments - The filter arguments
	     * @returns {Array} Returns an array of React.Components to display in the typeahead dropdown
	     */
	
	  }, {
	    key: "filterTypeahead",
	    value: function filterTypeahead(filterType, filterArguments) {
	      return [];
	    }
	
	    /* eslint-enable no-unused-vars */
	
	  }]);
	  return DSLFilter;
	}();
	
	module.exports = DSLFilter;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "is";
	
	var LABEL_TO_HEALTH = {
	  healthy: _HealthStatus2.default.HEALTHY,
	  unhealthy: _HealthStatus2.default.UNHEALTHY
	};
	
	/**
	 * This filter handles the `health:status` for services using `getHealth`
	 */
	
	var ServiceAttribHealthFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttribHealthFilter, _DSLFilter);
	
	  function ServiceAttribHealthFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttribHealthFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttribHealthFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttribHealthFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttribHealthFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `health:XXXX` attribute filters that we can handle.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && LABEL_TO_HEALTH[filterArguments.text.toLowerCase()] != null;
	    }
	
	    /**
	     * Keep only services whose health status matches the value of
	     * the `health` label
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset, filterType, filterArguments) {
	      var testStatus = LABEL_TO_HEALTH[filterArguments.text.toLowerCase()];
	
	      return resultset.filterItems(function (service) {
	        return service.getHealth() === testStatus;
	      });
	    }
	  }]);
	  return ServiceAttribHealthFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttribHealthFilter;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	var _ServiceStatus = __webpack_require__(1091);
	
	var _ServiceStatus2 = _interopRequireDefault(_ServiceStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "is";
	
	var LABEL_TO_INSTANCE = {
	  delayed: _ServiceStatus2.default.DELAYED,
	  deploying: _ServiceStatus2.default.DEPLOYING,
	  na: _ServiceStatus2.default.NA,
	  running: _ServiceStatus2.default.RUNNING,
	  suspended: _ServiceStatus2.default.SUSPENDED,
	  waiting: _ServiceStatus2.default.WAITING
	};
	
	/**
	 * This filter handles the `is:status` for services using `getServiceStatus`
	 */
	
	var ServiceAttribIsFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttribIsFilter, _DSLFilter);
	
	  function ServiceAttribIsFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttribIsFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttribIsFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttribIsFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttribIsFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `is:XXXX` attribute filters that we can handle.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && LABEL_TO_INSTANCE[filterArguments.text.toLowerCase()] != null;
	    }
	
	    /**
	     * Keep only services whose health service matches the value of
	     * the `is` label
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset, filterType, filterArguments) {
	      var testStatus = LABEL_TO_INSTANCE[filterArguments.text.toLowerCase()];
	
	      return resultset.filterItems(function (service) {
	        return service.getServiceStatus() === testStatus;
	      });
	    }
	  }]);
	  return ServiceAttribIsFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttribIsFilter;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "is";
	var LABEL_TEXT = "pod";
	
	/**
	 * This filter handles the `is:pod` for filtering pod instances
	 */
	
	var ServiceAttributeIsPodFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttributeIsPodFilter, _DSLFilter);
	
	  function ServiceAttributeIsPodFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttributeIsPodFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttributeIsPodFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttributeIsPodFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttributeIsPodFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `is:pod` attribute filters.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && filterArguments.text.toLowerCase() === LABEL_TEXT;
	    }
	
	    /**
	     * Keep only services whose instance is of type `Pod`
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset) {
	      return resultset.filterItems(function (service) {
	        return service instanceof _Pod2.default;
	      });
	    }
	  }]);
	  return ServiceAttributeIsPodFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttributeIsPodFilter;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "is";
	var LABEL_TEXT = "catalog";
	
	/**
	 * This filter handles the `is:catalog` for filtering catalog frameworks
	 */
	
	var ServiceAttributeIsCatalogFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttributeIsCatalogFilter, _DSLFilter);
	
	  function ServiceAttributeIsCatalogFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttributeIsCatalogFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttributeIsCatalogFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttributeIsCatalogFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttributeIsCatalogFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `is:catalog` attrib filters that we can handle.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && filterArguments.text.toLowerCase() === LABEL_TEXT;
	    }
	
	    /**
	     * Keep only services whose instance is of type `Framework`
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset) {
	      return resultset.filterItems(function (service) {
	        return service instanceof _Framework2.default;
	      });
	    }
	  }]);
	  return ServiceAttributeIsCatalogFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttributeIsCatalogFilter;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	var _HealthStatus = __webpack_require__(1088);
	
	var _HealthStatus2 = _interopRequireDefault(_HealthStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LABEL = "no";
	var LABEL_TEXT = "healthchecks";
	
	/**
	 * This filter handles the `no:healthckecks` filter that returns the services
	 * without health checks
	 */
	
	var ServiceAttributeNoHealthchecksFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceAttributeNoHealthchecksFilter, _DSLFilter);
	
	  function ServiceAttributeNoHealthchecksFilter() {
	    (0, _classCallCheck3.default)(this, ServiceAttributeNoHealthchecksFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceAttributeNoHealthchecksFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceAttributeNoHealthchecksFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceAttributeNoHealthchecksFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `no:healthckecks` attribute filters.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType, filterArguments) {
	      return filterType === _DSLFilterTypes2.default.ATTRIB && filterArguments.label === LABEL && filterArguments.text.toLowerCase() === LABEL_TEXT;
	    }
	
	    /**
	     * Keep only services whose health checks is N/A
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset) {
	      return resultset.filterItems(function (service) {
	        return service.getHealth() === _HealthStatus2.default.NA;
	      });
	    }
	  }]);
	  return ServiceAttributeNoHealthchecksFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceAttributeNoHealthchecksFilter;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactIntl = __webpack_require__(753);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _MarathonErrorUtil = __webpack_require__(1634);
	
	var _MarathonErrorUtil2 = _interopRequireDefault(_MarathonErrorUtil);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	var _ServiceActionLabels = __webpack_require__(1613);
	
	var _ServiceActionLabels2 = _interopRequireDefault(_ServiceActionLabels);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	var _ServiceModals = __webpack_require__(1614);
	
	var _ServiceModals2 = _interopRequireDefault(_ServiceModals);
	
	var _ServiceActionDisabledModal = __webpack_require__(1612);
	
	var _ServiceActionDisabledModal2 = _interopRequireDefault(_ServiceActionDisabledModal);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleEditClearError", "handleActionDisabledModalOpen", "handleActionDisabledModalClose"];
	
	var ServiceDetail = function (_mixin) {
	  (0, _inherits3.default)(ServiceDetail, _mixin);
	
	  function ServiceDetail() {
	    (0, _classCallCheck3.default)(this, ServiceDetail);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceDetail.__proto__ || (0, _getPrototypeOf2.default)(ServiceDetail)).apply(this, arguments));
	
	    _this.tabs_tabs = {
	      "/services/overview/:id/tasks": "Instances",
	      "/services/overview/:id/configuration": "Configuration",
	      "/services/overview/:id/debug": "Debug"
	    };
	
	    _this.state = {
	      actionDisabledID: null,
	      actionDisabledModalOpen: false,
	      currentTab: (0, _keys2.default)(_this.tabs_tabs).shift()
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      (0, _get3.default)(ServiceDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(ServiceDetail.prototype), "componentWillMount", this).apply(this, arguments);
	      this.updateCurrentTab();
	      this.checkForVolumes();
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(ServiceDetail.prototype.__proto__ || (0, _getPrototypeOf2.default)(ServiceDetail.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      this.updateCurrentTab(nextProps);
	      this.checkForVolumes();
	    }
	  }, {
	    key: "updateCurrentTab",
	    value: function updateCurrentTab() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var routes = props.routes;
	
	      var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(routes);
	      if (currentTab != null) {
	        this.setState({ currentTab: currentTab });
	      }
	    }
	  }, {
	    key: "handleEditClearError",
	    value: function handleEditClearError() {
	      this.props.clearError(_ActionKeys2.default.SERVICE_EDIT);
	    }
	  }, {
	    key: "onActionsItemSelection",
	    value: function onActionsItemSelection(actionID) {
	      var service = this.props.service;
	
	      var isGroup = service instanceof _ServiceTree2.default;
	      var containsSDKService = false;
	
	      if (isGroup) {
	        containsSDKService = service.findItem(function (item) {
	          return item instanceof _Service2.default && (0, _ServiceUtil.isSDKService)(item);
	        }) != null;
	      }
	
	      if ((containsSDKService || (0, _ServiceUtil.isSDKService)(service)) && !_PluginSDK.Hooks.applyFilter("isEnabledSDKAction", actionID === _ServiceActionItem.EDIT || actionID === _ServiceActionItem.OPEN, actionID)) {
	        this.handleActionDisabledModalOpen(actionID);
	      } else {
	        this.handleServiceAction(actionID);
	      }
	    }
	  }, {
	    key: "handleServiceAction",
	    value: function handleServiceAction(actionID) {
	      var _context = this.context,
	          modalHandlers = _context.modalHandlers,
	          router = _context.router;
	      var service = this.props.service;
	
	
	      switch (actionID) {
	        case _ServiceActionItem.EDIT:
	          router.push("/services/detail/" + encodeURIComponent(service.getId()) + "/edit/");
	          break;
	        case _ServiceActionItem.SCALE:
	          modalHandlers.scaleService({ service: service });
	          break;
	        case _ServiceActionItem.OPEN:
	          modalHandlers.openServiceUI({ service: service });
	          break;
	        case _ServiceActionItem.RESTART:
	          modalHandlers.restartService({ service: service });
	          break;
	        case _ServiceActionItem.RESUME:
	          modalHandlers.resumeService({ service: service });
	          break;
	        case _ServiceActionItem.SUSPEND:
	          modalHandlers.suspendService({ service: service });
	          break;
	        case _ServiceActionItem.DELETE:
	          modalHandlers.deleteService({ service: service });
	          break;
	      }
	    }
	  }, {
	    key: "handleActionDisabledModalOpen",
	    value: function handleActionDisabledModalOpen(actionDisabledID) {
	      this.setState({ actionDisabledModalOpen: true, actionDisabledID: actionDisabledID });
	    }
	  }, {
	    key: "handleActionDisabledModalClose",
	    value: function handleActionDisabledModalClose() {
	      this.setState({ actionDisabledModalOpen: false, actionDisabledID: null });
	    }
	  }, {
	    key: "hasVolumes",
	    value: function hasVolumes() {
	      return !!this.props.service && this.props.service.getVolumes().getItems().length > 0;
	    }
	  }, {
	    key: "checkForVolumes",
	    value: function checkForVolumes() {
	      // Add the Volumes tab if it isn't already there and the service has
	      // at least one volume.
	      if (this.tabs_tabs["/services/overview/:id/volumes"] == null && this.hasVolumes()) {
	        this.tabs_tabs["/services/overview/:id/volumes"] = "Volumes";
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      var service = this.props.service;
	
	      var instanceCount = service.getInstancesCount();
	      var isSDK = (0, _ServiceUtil.isSDKService)(service);
	
	      var actions = [];
	
	      if (service instanceof _Service2.default && !(0, _ServiceUtil.isSDKService)(service) && service.getWebURL() != null && service.getWebURL() !== "") {
	        actions.push({
	          label: this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default.open
	          }),
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.OPEN)
	        });
	      }
	
	      actions.push({
	        label: "Edit",
	        onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.EDIT)
	      });
	
	      if (instanceCount > 0 && !isSDK) {
	        actions.push({
	          label: "Restart",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.RESTART)
	        });
	      }
	      if (!service.getLabels().MARATHON_SINGLE_INSTANCE_APP) {
	        actions.push({
	          label: "Scale",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.SCALE)
	        });
	      }
	
	      if (instanceCount > 0 && !isSDK) {
	        actions.push({
	          label: "Suspend",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.SUSPEND)
	        });
	      }
	
	      if (instanceCount === 0 && !isSDK) {
	        actions.push({
	          label: "Resume",
	          onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.RESUME)
	        });
	      }
	
	      actions.push({
	        className: "text-danger",
	        label: _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	        onItemSelect: this.onActionsItemSelection.bind(this, _ServiceActionItem.DELETE)
	      });
	
	      return actions;
	    }
	  }, {
	    key: "getTabs",
	    value: function getTabs() {
	      var id = this.props.service.id;
	
	      var routePrefix = "/services/detail/" + encodeURIComponent(id);
	
	      var tabs = [{ label: "Instances", routePath: routePrefix + "/tasks" }, { label: "Configuration", routePath: routePrefix + "/configuration" }, { label: "Debug", routePath: routePrefix + "/debug" }];
	
	      if (this.hasVolumes()) {
	        tabs.push({
	          label: "Volumes",
	          routePath: routePrefix + "/volumes"
	        });
	      }
	
	      return tabs;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          actions = _props.actions,
	          errors = _props.errors,
	          params = _props.params,
	          routes = _props.routes,
	          service = _props.service;
	      var _state = this.state,
	          actionDisabledModalOpen = _state.actionDisabledModalOpen,
	          actionDisabledID = _state.actionDisabledID;
	
	      var breadcrumbs = _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: service.id });
	      var clonedProps = {
	        params: params,
	        routes: routes,
	        service: service,
	        errors: _MarathonErrorUtil2.default.parseErrors(errors[_ActionKeys2.default.SERVICE_EDIT]),
	        onClearError: this.handleEditClearError,
	        onEditClick: actions.editService,
	        volumes: service.getVolumes().getItems()
	      };
	
	      // TODO (DCOS_OSS-1038): Move cloned props to route parameters
	      var clonedChildren = _react2.default.Children.map(children, function (child) {
	        // Only add props to children that are not ServiceModals
	        if (child.type === _ServiceModals2.default) {
	          return child;
	        }
	
	        return _react2.default.cloneElement(child, clonedProps);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          actions: this.getActions(),
	          tabs: this.getTabs(),
	          breadcrumbs: breadcrumbs,
	          iconID: "services"
	        }),
	        clonedChildren,
	        _react2.default.createElement(_ServiceActionDisabledModal2.default, {
	          actionID: actionDisabledID,
	          open: actionDisabledModalOpen,
	          onClose: this.handleActionDisabledModalClose,
	          service: service
	        })
	      );
	    }
	  }]);
	  return ServiceDetail;
	}((0, _reactjsMixin2.default)(_TabsMixin2.default));
	
	ServiceDetail.contextTypes = {
	  clearError: function clearError() {},
	
	  modalHandlers: _react.PropTypes.shape({
	    scaleService: _react.PropTypes.func,
	    restartService: _react.PropTypes.func,
	    suspendService: _react.PropTypes.func,
	    deleteService: _react.PropTypes.func,
	    openService: _react.PropTypes.func
	  }).isRequired,
	  router: _reactRouter.routerShape
	};
	
	ServiceDetail.propTypes = {
	  actions: _react.PropTypes.object.isRequired,
	  clearError: _react.PropTypes.func,
	  errors: _react.PropTypes.object.isRequired,
	  params: _react.PropTypes.object.isRequired,
	  service: _react.PropTypes.instanceOf(_Service2.default).isRequired,
	  children: _react.PropTypes.node
	};
	
	module.exports = (0, _reactIntl.injectIntl)(ServiceDetail);

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _ServiceErrorTypes = __webpack_require__(1635);
	
	var _ServiceErrorTypes2 = _interopRequireDefault(_ServiceErrorTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarathonErrorUtil = {
	  /**
	   * Try to guess an error type from it's contents
	   *
	   * @param {String} message - The marathon error string
	   * @returns {String} Returns the message type
	   */
	  // eslint-disable-next-line no-unused-vars
	  getErrorType: function getErrorType(message) {
	    // Check for 'service is deploying' error messages
	    if (/force=true/.test(message)) {
	      return _ServiceErrorTypes2.default.SERVICE_DEPLOYING;
	    }
	
	    return _ServiceErrorTypes2.default.GENERIC;
	  },
	
	
	  /**
	   * Parses errros from the given input format into the common error format
	   * used internally
	   *
	   * For reference, marathon responds an error according to the exception that
	   * occurred and it's translated with the following checks:
	   *
	   * https://github.com/mesosphere/marathon/blob/master/src/main/scala/mesosphere/marathon/api/MarathonExceptionMapper.scala#L63
	   *
	   * @param {Object|String} error - The marathon error(s) to process
	   * @returns {Array} Returns an array of error objects
	   */
	  parseErrors: function parseErrors(error) {
	    if (error == null) {
	      return [];
	    }
	
	    // `error` could be a string, if the error has no details
	    if (typeof error === "string") {
	      return [{
	        path: [],
	        message: error,
	        type: MarathonErrorUtil.getErrorType(error),
	        variables: {}
	      }];
	    }
	
	    // Both `details` and `errors` can be missing
	    if (_ValidatorUtil2.default.isEmpty(error.details) && _ValidatorUtil2.default.isEmpty(error.message)) {
	      // `null` is a special case
	      if (error.message === null) {
	        return [{
	          path: [],
	          message: "An unknown error occurred (Marathon did not provide any description)",
	          type: _ServiceErrorTypes2.default.GENERIC,
	          variables: {}
	        }];
	      }
	
	      return [];
	    }
	
	    // Only `details` can be missing
	    if (_ValidatorUtil2.default.isEmpty(error.details) && !_ValidatorUtil2.default.isEmpty(error.message)) {
	      return [{
	        path: [],
	        message: error.message,
	        type: MarathonErrorUtil.getErrorType(error.message),
	        variables: {}
	      }];
	    }
	
	    // `details` can be a string
	    if (typeof error.details === "string") {
	      return [{
	        path: [],
	        message: error.details,
	        type: MarathonErrorUtil.getErrorType(error.details),
	        variables: {}
	      }];
	    }
	
	    if (!Array.isArray(error.details)) {
	      return [];
	    }
	
	    // `details` can be an array of errors
	    return error.details.reduce(function (memo, _ref) {
	      var _ref$errors = _ref.errors,
	          errors = _ref$errors === undefined ? [] : _ref$errors,
	          path = _ref.path;
	
	      // Convert marathon path components to a dot-separated string
	      // and then split it into an array
	      //
	      // A marathon path looks like: /container(0)/containerPath
	      //
	      var pathString = path.replace(/\((\d+)\)/g, function (_, id) {
	        return "/" + id;
	      }).slice(1);
	
	      // Don't create array with empty first item when we have an empty path
	      var pathComponents = [];
	      if (pathString !== "") {
	        pathComponents = pathString.split("/").map(function (component) {
	          if (_ValidatorUtil2.default.isNumber(component)) {
	            return Number(component);
	          }
	
	          return component;
	        });
	      }
	
	      if (errors.length === 0) {
	        errors = errors.concat(error.message);
	      }
	
	      // For every error, create the correct message
	      return errors.reduce(function (memo, errorMessage) {
	        memo.push({
	          path: pathComponents,
	          message: errorMessage,
	          type: MarathonErrorUtil.getErrorType(errorMessage),
	          variables: {}
	        });
	
	        return memo;
	      }, memo);
	    }, []);
	  }
	};
	
	module.exports = MarathonErrorUtil;

/***/ },
/* 1635 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceErrorTypes = {
	  /**
	   * A generic type of error without any detailed information
	   */
	  GENERIC: "GENERIC",
	
	  /**
	   * Two or more properties are present in the configuration that are are
	   * conflicting to eachother.
	   *
	   * Expected variables:
	   * {
	   *   "feature1": "first conflicting feature",
	   *   "feature2": "second conflicting feature"
	   * }
	   */
	  PROP_CONFLICT: "PROP_CONFLICT",
	
	  /**
	   * The specified property is part of a deprecated API
	   *
	   * Expected variables:
	   * {
	   *   "name": "property name"
	   * }
	   */
	  PROP_DEPRECATED: "PROP_DEPRECATED",
	
	  /**
	   * All of the specified properties must be specified
	   *
	   * Expected variables:
	   * {
	   *    "names": "prop1, prop2, prop3, ..."
	   * }
	   */
	  PROP_MISSING_ALL: "PROP_MISSING_ALL",
	
	  /**
	   * At least one of the specified properties must be specified
	   *
	   * Expected variables:
	   * {
	   *    "names": "prop1, prop2, prop3, ..."
	   * }
	   */
	  PROP_MISSING_ONE: "PROP_MISSING_ONE",
	
	  /*
	   * Service is locked for deployment
	   */
	  SERVICE_DEPLOYING: "SERVICE_DEPLOYING",
	
	  /**
	   * The user input is syntactically incorrect and cannot be parsed
	   *
	   * Expected variables:
	   * {
	   * }
	   */
	  SYNTAX_ERROR: "SYNTAX_ERROR"
	};
	
	module.exports = ServiceErrorTypes;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLFilter2 = __webpack_require__(1627);
	
	var _DSLFilter3 = _interopRequireDefault(_DSLFilter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This filter handles the `text` attributes against service's `getName` value
	 */
	var ServiceNameTextFilter = function (_DSLFilter) {
	  (0, _inherits3.default)(ServiceNameTextFilter, _DSLFilter);
	
	  function ServiceNameTextFilter() {
	    (0, _classCallCheck3.default)(this, ServiceNameTextFilter);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceNameTextFilter.__proto__ || (0, _getPrototypeOf2.default)(ServiceNameTextFilter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceNameTextFilter, [{
	    key: "filterCanHandle",
	
	    /**
	     * Handle all `name` attribute filters that we can handle.
	     *
	     * @override
	     */
	    value: function filterCanHandle(filterType) {
	      return filterType === _DSLFilterTypes2.default.EXACT || filterType === _DSLFilterTypes2.default.FUZZY;
	    }
	
	    /**
	     * Keep only services whose status
	     *
	     * @override
	     */
	
	  }, {
	    key: "filterApply",
	    value: function filterApply(resultset, filterType, filterArguments) {
	      return resultset.filterItems(function (service) {
	        return service.getName().indexOf(filterArguments.text) !== -1;
	      });
	    }
	  }]);
	  return ServiceNameTextFilter;
	}(_DSLFilter3.default);
	
	module.exports = ServiceNameTextFilter;

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLFilterField = __webpack_require__(1638);
	
	var _DSLFilterField2 = _interopRequireDefault(_DSLFilterField);
	
	var _DSLFilterList = __webpack_require__(1606);
	
	var _DSLFilterList2 = _interopRequireDefault(_DSLFilterList);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _DeploymentStatusIndicator = __webpack_require__(1642);
	
	var _DeploymentStatusIndicator2 = _interopRequireDefault(_DeploymentStatusIndicator);
	
	var _EmptyServiceTree = __webpack_require__(1644);
	
	var _EmptyServiceTree2 = _interopRequireDefault(_EmptyServiceTree);
	
	var _FuzzyTextDSLSection = __webpack_require__(1645);
	
	var _FuzzyTextDSLSection2 = _interopRequireDefault(_FuzzyTextDSLSection);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	var _ServiceHealthDSLSection = __webpack_require__(1653);
	
	var _ServiceHealthDSLSection2 = _interopRequireDefault(_ServiceHealthDSLSection);
	
	var _ServiceOtherDSLSection = __webpack_require__(1654);
	
	var _ServiceOtherDSLSection2 = _interopRequireDefault(_ServiceOtherDSLSection);
	
	var _ServicesTable = __webpack_require__(1655);
	
	var _ServicesTable2 = _interopRequireDefault(_ServicesTable);
	
	var _ServiceStatusDSLSection = __webpack_require__(1660);
	
	var _ServiceStatusDSLSection2 = _interopRequireDefault(_ServiceStatusDSLSection);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceTreeView = function (_React$Component) {
	  (0, _inherits3.default)(ServiceTreeView, _React$Component);
	
	  function ServiceTreeView() {
	    (0, _classCallCheck3.default)(this, ServiceTreeView);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceTreeView.__proto__ || (0, _getPrototypeOf2.default)(ServiceTreeView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceTreeView, [{
	    key: "getFilterBar",
	    value: function getFilterBar() {
	      var _props = this.props,
	          filters = _props.filters,
	          filterExpression = _props.filterExpression,
	          onFilterExpressionChange = _props.onFilterExpressionChange;
	
	
	      var hostClasses = (0, _classnames2.default)({
	        "column-medium-5": !filterExpression.value,
	        "column-medium-12": filterExpression.value
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: hostClasses },
	          _react2.default.createElement(_DSLFilterField2.default, {
	            filters: filters,
	            formSections: [_ServiceStatusDSLSection2.default, _ServiceHealthDSLSection2.default, _ServiceOtherDSLSection2.default, _FuzzyTextDSLSection2.default],
	            expression: filterExpression,
	            onChange: onFilterExpressionChange
	          })
	        )
	      );
	    }
	  }, {
	    key: "getSearchHeader",
	    value: function getSearchHeader() {
	      var filterExpression = this.props.filterExpression;
	
	      if (filterExpression.defined) {
	        return _react2.default.createElement(
	          "h5",
	          { className: "muted" },
	          "Search Results"
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          filterExpression = _props2.filterExpression,
	          isEmpty = _props2.isEmpty,
	          serviceTree = _props2.serviceTree,
	          services = _props2.services;
	      var modalHandlers = this.context.modalHandlers;
	      // Only add id if service is not root
	
	      var routePath = serviceTree.id === "/" ? "/services/overview/create" : "/services/overview/" + encodeURIComponent(serviceTree.id) + "/create";
	
	      var createService = function createService() {
	        _this2.context.router.push(routePath);
	      };
	
	      if (isEmpty) {
	        return _react2.default.createElement(
	          _Page2.default,
	          null,
	          _react2.default.createElement(_Page2.default.Header, {
	            breadcrumbs: _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: serviceTree.id })
	          }),
	          _react2.default.createElement(_EmptyServiceTree2.default, {
	            onCreateGroup: modalHandlers.createGroup,
	            onCreateService: createService
	          }),
	          children
	        );
	      }
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: serviceTree.id }),
	          actions: [{ onItemSelect: modalHandlers.createGroup, label: "Create Group" }],
	          addButton: { onItemSelect: createService, label: "Run a Service" },
	          supplementalContent: _react2.default.createElement(_DeploymentStatusIndicator2.default, null)
	        }),
	        _react2.default.createElement(
	          "div",
	          null,
	          this.getFilterBar(),
	          this.getSearchHeader(),
	          _react2.default.createElement(_ServicesTable2.default, {
	            isFiltered: filterExpression.defined,
	            modalHandlers: modalHandlers,
	            services: services
	          })
	        ),
	        children
	      );
	    }
	  }]);
	  return ServiceTreeView;
	}(_react2.default.Component);
	
	ServiceTreeView.contextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    createGroup: _react.PropTypes.func
	  }).isRequired,
	  router: _reactRouter.routerShape
	};
	
	ServiceTreeView.defaultProps = {
	  onFilterExpressionChange: function onFilterExpressionChange() {},
	
	  isEmpty: false
	};
	
	ServiceTreeView.propTypes = {
	  filters: _react.PropTypes.instanceOf(_DSLFilterList2.default).isRequired,
	  filterExpression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired,
	  isEmpty: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  onFilterExpressionChange: _react.PropTypes.func,
	  services: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_Service2.default), _react.PropTypes.instanceOf(_ServiceTree2.default)])).isRequired,
	  serviceTree: _react.PropTypes.instanceOf(_ServiceTree2.default)
	};
	
	module.exports = ServiceTreeView;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLFilterList = __webpack_require__(1606);
	
	var _DSLFilterList2 = _interopRequireDefault(_DSLFilterList);
	
	var _DSLInputField = __webpack_require__(1639);
	
	var _DSLInputField2 = _interopRequireDefault(_DSLInputField);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLFormDropdownPanel = __webpack_require__(1640);
	
	var _DSLFormDropdownPanel2 = _interopRequireDefault(_DSLFormDropdownPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleDismissClick", "handleDropdownClick", "handleIgnoreClick", "handleDropdownClose"];
	
	/**
	 * This component interactively edits a DSL expression and calls back with the
	 * filtering function when there is a change.
	 */
	
	var DSLFilterField = function (_React$Component) {
	  (0, _inherits3.default)(DSLFilterField, _React$Component);
	
	  function DSLFilterField() {
	    (0, _classCallCheck3.default)(this, DSLFilterField);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DSLFilterField.__proto__ || (0, _getPrototypeOf2.default)(DSLFilterField)).apply(this, arguments));
	
	    _this.state = {
	      dropdownVisible: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * Listen for body-wide events for dismissing the panel
	   * @override
	   */
	
	
	  (0, _createClass3.default)(DSLFilterField, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      global.addEventListener("click", this.handleDismissClick, false);
	    }
	
	    /**
	     * Remove body-wide listeners
	     * @override
	     */
	
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      global.removeEventListener("click", this.handleDismissClick);
	    }
	
	    /**
	     * Component should update only when filters or expressions changes
	     *
	     * @override
	     */
	
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.expression !== nextProps.expression || this.props.filters !== nextProps.filters || this.state.dropdownVisible !== nextState.dropdownVisible;
	    }
	
	    /**
	     * Clicks on the body are dismissing the panel
	     */
	
	  }, {
	    key: "handleDismissClick",
	    value: function handleDismissClick() {
	      if (!this.state.dropdownVisible) {
	        return;
	      }
	
	      this.setState({ dropdownVisible: false });
	    }
	
	    /**
	     * Handle click on the dropdown button of the input field
	     */
	
	  }, {
	    key: "handleDropdownClick",
	    value: function handleDropdownClick() {
	      this.setState({ dropdownVisible: !this.state.dropdownVisible });
	    }
	
	    /**
	     * Handle closing of the dropdown
	     */
	
	  }, {
	    key: "handleDropdownClose",
	    value: function handleDropdownClose() {
	      this.setState({ dropdownVisible: false });
	    }
	
	    /**
	     * Clicks on the panel region are stopped in order for them not to reach
	     * the body handler (that dismisses the dropdown)
	     *
	     * @param {SyntheticEvent} event - The click event
	     */
	
	  }, {
	    key: "handleIgnoreClick",
	    value: function handleIgnoreClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          expression = _props.expression,
	          formSections = _props.formSections,
	          onChange = _props.onChange;
	      var dropdownVisible = this.state.dropdownVisible;
	
	      var hasForm = formSections.length > 0;
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "form-group dropdown-panel-group",
	          onClick: this.handleIgnoreClick
	        },
	        _react2.default.createElement(_DSLInputField2.default, {
	          hasErrors: expression.hasErrors,
	          hasDropdown: hasForm,
	          dropdownVisible: dropdownVisible,
	          onChange: onChange,
	          onDropdownClick: this.handleDropdownClick,
	          expression: expression
	        }),
	        _react2.default.createElement(_DSLFormDropdownPanel2.default, {
	          expression: expression,
	          isVisible: dropdownVisible,
	          onChange: onChange,
	          onClose: this.handleDropdownClose,
	          sections: formSections
	        })
	      );
	    }
	  }]);
	  return DSLFilterField;
	}(_react2.default.Component);
	
	DSLFilterField.defaultProps = {
	  formSections: [],
	  onChange: function onChange() {}
	};
	
	DSLFilterField.propTypes = {
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired,
	  filters: _react.PropTypes.instanceOf(_DSLFilterList2.default).isRequired,
	  formSections: _react.PropTypes.array,
	  onChange: _react.PropTypes.func
	};
	
	module.exports = DSLFilterField;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEBOUNCE_TIMEOUT = 250;
	
	var METHODS_TO_BIND = ["handleBlur", "handleChange", "handleDebounceUpdate", "handleFocus", "handleInputClear"];
	
	/**
	 * This is a very simple, low-level input field for DSL expressions, with
	 * embedded clear and dropdown buttons.
	 *
	 * WARNING: This component is stateless, meaning that the hosting component is
	 *          responsible for updating the `expression` property on a change event
	 *
	 * @example <caption>Using the DSLInputField</caption>
	 *
	 * <DSLInputField
	 *
	 *   dropdownVisible={this.state.dropdownVisible}
	 *   onDropdownClick={this.handleDropdownToggle}
	 *
	 *   expression={this.state.expression}
	 *   onChange={this.handleChange}
	 *
	 *   />
	 */
	
	var DSLInputField = function (_React$Component) {
	  (0, _inherits3.default)(DSLInputField, _React$Component);
	
	  function DSLInputField() {
	    (0, _classCallCheck3.default)(this, DSLInputField);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DSLInputField.__proto__ || (0, _getPrototypeOf2.default)(DSLInputField)).apply(this, arguments));
	
	    _this.state = {
	      expression: _this.props.expression,
	      focus: false
	    };
	
	    _this.debounceTimer = null;
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.handleDebounceUpdate = _Util2.default.debounce(_this.handleDebounceUpdate, DEBOUNCE_TIMEOUT);
	    return _this;
	  }
	
	  /**
	   * Import component property updates.
	   *
	   * @override
	   */
	
	
	  (0, _createClass3.default)(DSLInputField, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var expression = nextProps.expression;
	
	
	      if (expression !== this.state.expression) {
	        this.setState({ expression: expression });
	      }
	    }
	
	    /**
	     * Focus to the input field every time the focus state switches to `true`
	     *
	     * @override
	     */
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var focus = this.state.focus;
	
	
	      if (prevState.focus !== focus && focus && this.inputField) {
	        this.inputField.focus();
	      }
	    }
	
	    /**
	     * Reset field state to unfocused when the user blurs from the field
	     */
	
	  }, {
	    key: "handleBlur",
	    value: function handleBlur() {
	      this.setState({
	        focus: false
	      });
	      this.props.onBlur();
	    }
	
	    /**
	     * Callback with the new text on every keystroke
	     *
	     * @param {SyntheticEvent} event - The change event
	     */
	
	  }, {
	    key: "handleChange",
	    value: function handleChange(event) {
	      this.setState({
	        expression: new _DSLExpression2.default(event.target.value)
	      });
	
	      this.handleDebounceUpdate();
	    }
	
	    /**
	     * Forward property change update after the debounce timer expired
	     */
	
	  }, {
	    key: "handleDebounceUpdate",
	    value: function handleDebounceUpdate() {
	      this.props.onChange(this.state.expression);
	    }
	
	    /**
	     * Switch to focused state (that triggers .focus to the input field) when
	     * the user focuses on the overall component
	     */
	
	  }, {
	    key: "handleFocus",
	    value: function handleFocus() {
	      this.setState({
	        focus: true
	      });
	      this.props.onFocus();
	    }
	
	    /**
	     * Callback with empty text  when user clears the input
	     */
	
	  }, {
	    key: "handleInputClear",
	    value: function handleInputClear() {
	      this.props.onChange(new _DSLExpression2.default());
	    }
	
	    /**
	     * Return the "X" button when we have some input
	     *
	     * @returns {Node|null} The button contents or null if empty
	     */
	
	  }, {
	    key: "getClearButton",
	    value: function getClearButton() {
	      if (!this.state.expression.defined) {
	        return null;
	      }
	
	      var expression = this.state.expression;
	      var inverseStyle = this.props.inverseStyle;
	
	      var color = "purple";
	
	      if (inverseStyle) {
	        color = "white";
	      }
	
	      if (expression.hasErrors) {
	        color = "red";
	      }
	
	      return _react2.default.createElement(
	        "span",
	        { className: "form-control-group-add-on" },
	        _react2.default.createElement(_Icon2.default, {
	          family: "system",
	          id: "close",
	          size: "mini",
	          className: "clickable",
	          color: color,
	          onClick: this.handleInputClear
	        })
	      );
	    }
	
	    /**
	     * Return the "v" button for showing the filter dropdown
	     *
	     * @returns {Node|null} The button contents or null if empty
	     */
	
	  }, {
	    key: "getDropdownButton",
	    value: function getDropdownButton() {
	      var color = "grey";
	      var _props = this.props,
	          dropdownVisible = _props.dropdownVisible,
	          hasDropdown = _props.hasDropdown,
	          inverseStyle = _props.inverseStyle,
	          onDropdownClick = _props.onDropdownClick;
	
	
	      if (!hasDropdown) {
	        return null;
	      }
	
	      if (inverseStyle) {
	        color = "white";
	      }
	
	      if (dropdownVisible) {
	        color = "purple";
	      }
	
	      return _react2.default.createElement(
	        "span",
	        { className: "form-control-group-add-on" },
	        _react2.default.createElement(_Icon2.default, {
	          family: "system",
	          id: "caret-down",
	          size: "mini",
	          className: "clickable",
	          color: color,
	          onClick: onDropdownClick
	        })
	      );
	    }
	
	    /**
	     * Return input field with it's proper style
	     *
	     * @returns {Node} The input field
	     */
	
	  }, {
	    key: "getInputField",
	    value: function getInputField() {
	      var _this2 = this;
	
	      var expression = this.state.expression;
	      var _props2 = this.props,
	          inverseStyle = _props2.inverseStyle,
	          placeholder = _props2.placeholder;
	
	
	      var inputClasses = (0, _classnames2.default)({
	        "form-control filter-input-text": true,
	        "form-control-inverse": inverseStyle
	      });
	
	      return _react2.default.createElement("input", {
	        className: inputClasses,
	        placeholder: placeholder,
	        onChange: this.handleChange,
	        ref: function ref(_ref) {
	          return _this2.inputField = _ref;
	        },
	        type: "text",
	        value: expression.value
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          inputContainerClass = _props3.inputContainerClass,
	          inverseStyle = _props3.inverseStyle;
	      var _state = this.state,
	          expression = _state.expression,
	          focus = _state.focus;
	
	
	      var iconColor = "grey";
	      var iconSearchClasses = (0, _classnames2.default)({
	        active: focus
	      });
	
	      if (!inverseStyle && (focus || expression.defined)) {
	        iconColor = "purple";
	      }
	
	      if (expression.hasErrors) {
	        iconColor = "red";
	      }
	
	      var inputContainerClasses = (0, _classnames2.default)({
	        focus: focus,
	        "form-control form-control-group": true,
	        "form-control-inverse": inverseStyle
	      }, inputContainerClass);
	
	      var formGroupClasses = (0, _classnames2.default)({
	        "form-group": true,
	        "form-group-danger": expression.hasErrors
	      }, className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: formGroupClasses },
	        _react2.default.createElement(
	          "div",
	          {
	            className: inputContainerClasses,
	            onClick: this.handleFocus,
	            onBlur: this.handleBlur
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "form-control-group-add-on form-control-group-add-on-prepend" },
	            _react2.default.createElement(_Icon2.default, {
	              family: "system",
	              id: "search",
	              size: "mini",
	              className: iconSearchClasses,
	              color: iconColor
	            })
	          ),
	          this.getInputField(),
	          this.getClearButton(),
	          this.getDropdownButton()
	        )
	      );
	    }
	  }]);
	  return DSLInputField;
	}(_react2.default.Component);
	
	DSLInputField.defaultProps = {
	  className: {},
	  dropdownVisible: false,
	  hasDropdown: true,
	  inverseStyle: false,
	  onChange: function onChange() {},
	  onBlur: function onBlur() {},
	  onDropdownClick: function onDropdownClick() {},
	  onFocus: function onFocus() {},
	
	  placeholder: "Filter"
	};
	
	DSLInputField.propTypes = {
	  className: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
	  dropdownVisible: _react.PropTypes.bool,
	  hasDropdown: _react.PropTypes.bool,
	  inverseStyle: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onBlur: _react.PropTypes.func,
	  onDropdownClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  placeholder: _react.PropTypes.string,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = DSLInputField;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLForm = __webpack_require__(1641);
	
	var _DSLForm2 = _interopRequireDefault(_DSLForm);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleApply", "handleChange"];
	
	/**
	 * A SearchDSL component dropdown panel that renders the high-level interaction
	 * components for the expression being edited.
	 *
	 * This component synchronizes
	 */
	
	var DSLFormDropdownPanel = function (_React$Component) {
	  (0, _inherits3.default)(DSLFormDropdownPanel, _React$Component);
	
	  function DSLFormDropdownPanel() {
	    (0, _classCallCheck3.default)(this, DSLFormDropdownPanel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DSLFormDropdownPanel.__proto__ || (0, _getPrototypeOf2.default)(DSLFormDropdownPanel)).apply(this, arguments));
	
	    _this.state = {
	      expression: _this.props.expression
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * Import expression property updates and reset expression when the dropdown
	   * is first shown.
	   *
	   * @override
	   */
	
	
	  (0, _createClass3.default)(DSLFormDropdownPanel, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.expression !== nextProps.expression || !this.props.isVisible && nextProps.isVisible) {
	        this.setState({ expression: nextProps.expression });
	      }
	    }
	
	    /**
	     * Apply changes to the expression back to the parent component
	     */
	
	  }, {
	    key: "handleApply",
	    value: function handleApply() {
	      this.props.onChange(this.state.expression);
	      this.props.onClose();
	    }
	
	    /**
	     * Handle changes to the DSL expression from the form
	     *
	     * @param {DSLExpression} expression - The new expression
	     */
	
	  }, {
	    key: "handleChange",
	    value: function handleChange(expression) {
	      this.setState({ expression: expression });
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var expression = this.state.expression;
	      var _props = this.props,
	          sections = _props.sections,
	          isVisible = _props.isVisible;
	
	
	      var dropdownPanelClasses = (0, _classnames2.default)({
	        "dsl-dropdown-panel dropdown-panel dropdown-panel-animated panel": true,
	        "is-visible": isVisible
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: dropdownPanelClasses },
	        _react2.default.createElement(
	          "div",
	          { className: "panel-cell panel-cell-borderless" },
	          _react2.default.createElement(_DSLForm2.default, {
	            expression: expression,
	            onChange: this.handleChange,
	            onApply: this.handleApply,
	            sections: sections
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "panel-cell panel-cell-short flush-top text-align-right" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "button button-small button-primary-link",
	              onClick: this.handleApply
	            },
	            "Apply"
	          )
	        )
	      );
	    }
	  }]);
	  return DSLFormDropdownPanel;
	}(_react2.default.Component);
	
	DSLFormDropdownPanel.defaultProps = {
	  isVisible: false,
	  onChange: function onChange() {},
	  onClose: function onClose() {}
	};
	
	DSLFormDropdownPanel.propTypes = {
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired,
	  isVisible: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onClose: _react.PropTypes.func,
	  sections: _react.PropTypes.array.isRequired
	};
	
	module.exports = DSLFormDropdownPanel;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component wraps one or more DSLOptionSection components and
	 * handles the transparent mutation of the expression based on user actions.
	 */
	var DSLForm = function (_React$Component) {
	  (0, _inherits3.default)(DSLForm, _React$Component);
	
	  function DSLForm() {
	    (0, _classCallCheck3.default)(this, DSLForm);
	    return (0, _possibleConstructorReturn3.default)(this, (DSLForm.__proto__ || (0, _getPrototypeOf2.default)(DSLForm)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DSLForm, [{
	    key: "render",
	
	    /**
	     * @override
	     */
	    value: function render() {
	      var _props = this.props,
	          expression = _props.expression,
	          onApply = _props.onApply,
	          onChange = _props.onChange,
	          sections = _props.sections;
	
	      // Render each group component wrapped with a dedicated form that receives
	      // the updates targeting each dedicated component.
	
	      var components = sections.map(function (SectionComponent, key) {
	        return _react2.default.createElement(SectionComponent, {
	          expression: expression,
	          key: key,
	          onApply: onApply,
	          onChange: onChange
	        });
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        components
	      );
	    }
	  }]);
	  return DSLForm;
	}(_react2.default.Component);
	
	DSLForm.defaultProps = {
	  onApply: function onApply() {},
	  onChange: function onChange() {}
	};
	
	DSLForm.propTypes = {
	  onApply: _react.PropTypes.func,
	  onChange: _react.PropTypes.func,
	  sections: _react.PropTypes.array.isRequired,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = DSLForm;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactIntl = __webpack_require__(753);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DeploymentsModal = __webpack_require__(1643);
	
	var _DeploymentsModal2 = _interopRequireDefault(_DeploymentsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var METHODS_TO_BIND = ["handleDeploymentsButtonClick", "handleModalClose"];
	/* eslint-disable no-unused-vars */
	
	var DeploymentStatusIndicator = function (_mixin) {
	  (0, _inherits3.default)(DeploymentStatusIndicator, _mixin);
	
	  function DeploymentStatusIndicator() {
	    (0, _classCallCheck3.default)(this, DeploymentStatusIndicator);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DeploymentStatusIndicator.__proto__ || (0, _getPrototypeOf2.default)(DeploymentStatusIndicator)).apply(this, arguments));
	
	    _this.store_listeners = [{
	      name: "dcos",
	      events: ["change"],
	      listenAlways: true
	    }];
	
	    _this.state = {
	      isOpen: false
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(DeploymentStatusIndicator, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {
	      var deployments = _DCOSStore2.default.deploymentsList.getItems();
	
	      if (this.state.isOpen && deployments.length === 0) {
	        this.setState({ isOpen: false });
	      }
	    }
	  }, {
	    key: "handleDeploymentsButtonClick",
	    value: function handleDeploymentsButtonClick() {
	      this.setState({ isOpen: true });
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose() {
	      this.setState({ isOpen: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var deployments = _DCOSStore2.default.deploymentsList.getItems();
	      var deploymentsCount = deployments.length;
	      var loading = !_DCOSStore2.default.serviceDataReceived;
	
	      if (loading || deploymentsCount === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "button",
	        {
	          className: "button button-link button-primary button--deployments",
	          onClick: this.handleDeploymentsButtonClick
	        },
	        _react2.default.createElement(_Loader2.default, {
	          className: "button--deployments__loader icon icon-mini",
	          flip: "horizontal",
	          size: "mini",
	          type: "lineSpinFadeLoader",
	          suppressHorizontalCenter: true
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "button--deployments__copy" },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: "SERVICES.DEPLOYMENT_COUNT",
	            values: { deploymentsCount: deploymentsCount }
	          })
	        ),
	        _react2.default.createElement(_DeploymentsModal2.default, {
	          isOpen: this.state.isOpen,
	          onClose: this.handleModalClose
	        })
	      );
	    }
	  }]);
	  return DeploymentStatusIndicator;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	DeploymentStatusIndicator.defaultProps = {};
	
	DeploymentStatusIndicator.propTypes = {};
	
	module.exports = DeploymentStatusIndicator;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactIntl = __webpack_require__(753);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _CollapsingString = __webpack_require__(1474);
	
	var _CollapsingString2 = _interopRequireDefault(_CollapsingString);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _ExpandingTable = __webpack_require__(1476);
	
	var _ExpandingTable2 = _interopRequireDefault(_ExpandingTable);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _ServiceUtil2 = _interopRequireDefault(_ServiceUtil);
	
	var _StatusBar = __webpack_require__(1580);
	
	var _StatusBar2 = _interopRequireDefault(_StatusBar);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _iconServiceDefaultSmall2x = __webpack_require__(1082);
	
	var _iconServiceDefaultSmall2x2 = _interopRequireDefault(_iconServiceDefaultSmall2x);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var columnClasses = {
	  id: "deployments-table-column-id",
	  startTime: "deployments-table-column-start-time",
	  status: "deployments-table-column-status",
	  action: "deployments-table-column-actions"
	};
	/* eslint-disable no-unused-vars */
	
	var columnHeadings = _ResourceTableUtil2.default.renderHeading({
	  id: "Affected Services",
	  startTime: "Started",
	  status: "Status",
	  action: null
	});
	var METHODS_TO_BIND = ["renderAffectedServices", "renderStartTime", "renderStatus", "renderActionsMenu", "handleRollbackClick", "handleRollbackCancel", "handleRollbackConfirm", "onMarathonStoreDeploymentRollbackSuccess", "onMarathonStoreDeploymentRollbackError"];
	
	// collapsing columns are tightly coupled to the left-align caret property;
	// this wrapper allows ordinary columns to collapse.
	function columnClassNameGetter(prop, sortBy, row) {
	  return (0, _classnames2.default)(columnClasses[prop], _ResourceTableUtil2.default.getClassName(prop, sortBy, row));
	}
	
	var DeploymentsModal = function (_mixin) {
	  (0, _inherits3.default)(DeploymentsModal, _mixin);
	
	  function DeploymentsModal() {
	    (0, _classCallCheck3.default)(this, DeploymentsModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DeploymentsModal.__proto__ || (0, _getPrototypeOf2.default)(DeploymentsModal)).apply(this, arguments));
	
	    _this.state = {};
	    _this.store_listeners = [{ name: "dcos", events: ["change"], suppressUpdate: false }, {
	      name: "marathon",
	      events: ["deploymentRollbackSuccess", "deploymentRollbackError"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    }, _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(DeploymentsModal, [{
	    key: "onMarathonStoreDeploymentRollbackSuccess",
	    value: function onMarathonStoreDeploymentRollbackSuccess(data) {
	      var deploymentToRollback = this.state.deploymentToRollback;
	
	      if (deploymentToRollback != null && deploymentToRollback.getId() === data.originalDeploymentID) {
	        this.setState({
	          awaitingRevertDeploymentResponse: false,
	          deploymentToRollback: null,
	          deploymentRollbackError: null
	        });
	      }
	    }
	  }, {
	    key: "onMarathonStoreDeploymentRollbackError",
	    value: function onMarathonStoreDeploymentRollbackError(data) {
	      var deploymentToRollback = this.state.deploymentToRollback;
	
	      if (deploymentToRollback != null && deploymentToRollback.getId() === data.originalDeploymentID) {
	        this.setState({
	          awaitingRevertDeploymentResponse: false,
	          deploymentRollbackError: data.error
	        });
	      }
	    }
	  }, {
	    key: "handleActionSelect",
	    value: function handleActionSelect(deployment, action) {
	      if (action.id === "rollback") {
	        this.handleRollbackClick(deployment);
	      }
	    }
	  }, {
	    key: "handleRollbackClick",
	    value: function handleRollbackClick(deployment) {
	      this.setState({ deploymentToRollback: deployment });
	    }
	  }, {
	    key: "handleRollbackCancel",
	    value: function handleRollbackCancel() {
	      this.setState({
	        awaitingRevertDeploymentResponse: false,
	        deploymentToRollback: null,
	        deploymentRollbackError: null
	      });
	    }
	  }, {
	    key: "handleRollbackConfirm",
	    value: function handleRollbackConfirm() {
	      var deploymentToRollback = this.state.deploymentToRollback;
	
	
	      if (deploymentToRollback != null) {
	        this.setState({ awaitingRevertDeploymentResponse: true });
	        _MarathonActions2.default.revertDeployment(deploymentToRollback.getId());
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: "getChildTableData",
	    value: function getChildTableData(deployment) {
	      return [].concat((0, _toConsumableArray3.default)(deployment.getAffectedServices().map(function (service) {
	        service.deployment = deployment;
	        service.isStale = false;
	
	        return service;
	      })), (0, _toConsumableArray3.default)(deployment.getStaleServiceIds().map(function (serviceID) {
	        return {
	          deployment: deployment,
	          serviceID: serviceID,
	          isStale: true
	        };
	      })));
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { className: columnClasses.id }),
	        _react2.default.createElement("col", { className: columnClasses.startTime }),
	        _react2.default.createElement("col", { className: columnClasses.status }),
	        _react2.default.createElement("col", { className: columnClasses.action })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        className: columnClassNameGetter,
	        heading: columnHeadings,
	        prop: "id",
	        render: this.renderAffectedServices
	      }, {
	        className: columnClassNameGetter,
	        heading: columnHeadings,
	        prop: "startTime",
	        render: this.renderStartTime
	      }, {
	        className: columnClassNameGetter,
	        heading: columnHeadings,
	        prop: "status",
	        render: this.renderStatus
	      }, {
	        className: columnClassNameGetter,
	        heading: columnHeadings,
	        prop: "action",
	        render: this.renderActionsMenu,
	        sortable: false
	      }];
	    }
	  }, {
	    key: "getRollbackModalText",
	    value: function getRollbackModalText(deploymentToRollback) {
	      var serviceNames = deploymentToRollback.getAffectedServices().map(function (service) {
	        return _StringUtil2.default.capitalize(service.getName());
	      });
	      var listOfServiceNames = _StringUtil2.default.humanizeArray(serviceNames);
	      var serviceCount = serviceNames.length;
	
	      var service = _StringUtil2.default.pluralize("service", serviceCount);
	      var its = serviceCount === 1 ? "its" : "their";
	      var version = _StringUtil2.default.pluralize("version", serviceCount);
	
	      if (deploymentToRollback.isStarting()) {
	        return "This will stop the current deployment of " + listOfServiceNames + " and\n              start a new deployment to " + _UserActions2.default.DELETE + " the affected\n              " + service + ".";
	      }
	
	      return "This will stop the current deployment of " + listOfServiceNames + " and\n            start a new deployment to revert the affected " + service + " to " + its + "\n            previous " + version + ".";
	    }
	  }, {
	    key: "getServiceDisplayPath",
	    value: function getServiceDisplayPath(service) {
	      // Remove the service's name from the end of the path.
	      var servicePath = service.getId().replace(new RegExp("/" + service.getName() + "$"), "");
	
	      return _react2.default.createElement(
	        "a",
	        {
	          href: "#/services/overview/" + encodeURIComponent(servicePath),
	          onClick: this.props.onClose
	        },
	        "services" + servicePath
	      );
	    }
	  }, {
	    key: "getTableData",
	    value: function getTableData(deploymentsItems) {
	      var _this2 = this;
	
	      return deploymentsItems.map(function (deployment) {
	        deployment.children = _this2.getChildTableData(deployment);
	
	        return deployment;
	      });
	    }
	  }, {
	    key: "renderActionsMenu",
	    value: function renderActionsMenu(prop, deployment, rowOptions) {
	      var _deployment$children = deployment.children,
	          children = _deployment$children === undefined ? [] : _deployment$children;
	
	
	      var doesDeploymentContainSDKService = children.some(function (service) {
	        return _ServiceUtil2.default.isSDKService(service);
	      });
	
	      if (!doesDeploymentContainSDKService && rowOptions.isParent && deployment != null) {
	        var actionText = "Rollback";
	        if (deployment.isStarting()) {
	          actionText = actionText + " & " + _StringUtil2.default.capitalize(_UserActions2.default.DELETE);
	        }
	
	        var dropdownItems = [{
	          className: "hidden",
	          id: "default",
	          html: "",
	          selectedHtml: _react2.default.createElement(_Icon2.default, { id: "ellipsis-vertical", size: "mini" })
	        }, {
	          id: "rollback",
	          html: _react2.default.createElement(
	            "span",
	            { className: "text-danger" },
	            actionText
	          )
	        }];
	
	        return _react2.default.createElement(_reactjsComponents.Dropdown, {
	          anchorRight: true,
	          buttonClassName: "button button-mini button-link",
	          dropdownMenuClassName: "dropdown-menu",
	          dropdownMenuListClassName: "dropdown-menu-list",
	          dropdownMenuListItemClassName: "clickable",
	          wrapperClassName: "dropdown flush-bottom table-cell-icon",
	          items: dropdownItems,
	          persistentID: "default",
	          onItemSelection: this.handleActionSelect.bind(this, deployment),
	          scrollContainer: ".gm-scroll-view",
	          scrollContainerParentSelector: ".gm-prevented",
	          title: "More actions",
	          transition: true,
	          transitionName: "dropdown-menu"
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderAffectedServices",
	    value: function renderAffectedServices(prop, item, rowOptions) {
	      // item is an instance of Deployment
	      if (rowOptions.isParent) {
	        var classes = null;
	
	        if (item.children && item.children.length > 0) {
	          classes = (0, _classnames2.default)("expanding-table-primary-cell is-expandable", {
	            "is-expanded": rowOptions.isExpanded
	          });
	        }
	
	        return _react2.default.createElement(
	          "div",
	          { className: classes, onClick: rowOptions.clickHandler },
	          _react2.default.createElement(_CollapsingString2.default, { string: item.getId() })
	        );
	      }
	
	      if (item.isStale) {
	        return _react2.default.createElement(
	          "div",
	          { className: "expanding-table-primary-cell-heading expanding-table-primary-cell-heading--no-nested-indicator" },
	          _react2.default.createElement(
	            "div",
	            { className: "table-cell-flex-box", key: "stale_" + item.serviceID },
	            _react2.default.createElement(
	              "span",
	              { className: "icon icon-mini icon-image-container icon-app-container icon-margin-right deployment-service-icon" },
	              _react2.default.createElement(_Image2.default, { src: _iconServiceDefaultSmall2x2.default })
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "table-cell-value" },
	              item.serviceID
	            )
	          )
	        );
	      }
	
	      // item is an instance of Service
	      var id = encodeURIComponent(item.getId());
	      var image = item.getImages()["icon-small"];
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "expanding-table-primary-cell-heading expanding-table-primary-cell-heading--no-nested-indicator" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "deployment-service-name table-cell-link-primary table-cell-flex-box clickable",
	              onClick: function onClick() {
	                _reactRouter.hashHistory.push("/services/detail/" + id);
	              }
	            },
	            _react2.default.createElement(
	              "span",
	              { className: "table-cell-icon icon icon-mini icon-image-container icon-margin-right icon-app-container deployment-service-icon" },
	              _react2.default.createElement(_Image2.default, { fallbackSrc: _iconServiceDefaultSmall2x2.default, src: image })
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "table-cell-value" },
	              item.getName()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "deployment-service-path text-overflow" },
	          this.getServiceDisplayPath(item)
	        )
	      );
	    }
	  }, {
	    key: "renderEmpty",
	    value: function renderEmpty() {
	      return _react2.default.createElement(
	        _AlertPanel2.default,
	        null,
	        _react2.default.createElement(
	          _AlertPanelHeader2.default,
	          null,
	          "No active deployments"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "flush" },
	          "Active deployments will be shown here."
	        )
	      );
	    }
	  }, {
	    key: "renderLoading",
	    value: function renderLoading() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "renderRollbackModal",
	    value: function renderRollbackModal() {
	      var _state = this.state,
	          awaitingRevertDeploymentResponse = _state.awaitingRevertDeploymentResponse,
	          deploymentToRollback = _state.deploymentToRollback,
	          deploymentRollbackError = _state.deploymentRollbackError;
	
	
	      var heading = _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Are you sure?"
	      );
	
	      if (deploymentToRollback != null) {
	        return _react2.default.createElement(
	          _reactjsComponents.Confirm,
	          {
	            closeByBackdropClick: true,
	            disabled: awaitingRevertDeploymentResponse,
	            header: heading,
	            onClose: this.handleRollbackCancel,
	            leftButtonCallback: this.handleRollbackCancel,
	            leftButtonText: "Cancel",
	            rightButtonClassName: "button button-danger",
	            rightButtonCallback: this.handleRollbackConfirm,
	            rightButtonText: "Continue Rollback",
	            showHeader: true
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "text-align-center" },
	            _react2.default.createElement(
	              "p",
	              null,
	              this.getRollbackModalText(deploymentToRollback)
	            ),
	            this.renderRollbackError(deploymentRollbackError)
	          )
	        );
	      }
	    }
	  }, {
	    key: "renderStartTime",
	    value: function renderStartTime(prop, deployment, rowOptions) {
	      if (rowOptions.isParent) {
	        return _react2.default.createElement(_TimeAgo2.default, {
	          className: "deployment-start-time",
	          time: deployment.getStartTime()
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus(prop, item, rowOptions) {
	      if (rowOptions.isParent) {
	        var currentStep = item.getCurrentStep();
	        var totalSteps = item.getTotalSteps();
	
	        return this.renderStatusBar(currentStep, totalSteps);
	      }
	
	      var currentActions = {};
	      if (item.deployment.currentActions && item.deployment.currentActions.length > 0) {
	        currentActions = item.deployment.currentActions.reduce(function (memo, action) {
	          memo[action.app] = action.action;
	
	          return memo;
	        }, {});
	      }
	
	      var statusText = item.getStatus();
	
	      if (currentActions[item.id] != null) {
	        statusText = currentActions[item.id];
	      }
	
	      return statusText;
	    }
	  }, {
	    key: "renderStatusBar",
	    value: function renderStatusBar(currentStep, totalSteps) {
	      var data = [{ className: "color-4", value: currentStep - 1 }, { className: "staged", value: 1 }, { className: "", value: totalSteps - currentStep }];
	
	      return _react2.default.createElement(_StatusBar2.default, { className: "status-bar--large", data: data });
	    }
	  }, {
	    key: "renderTable",
	    value: function renderTable(deploymentsItems) {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_ExpandingTable2.default, {
	          childRowClassName: "expanding-table-child",
	          className: "deployments-table expanding-table table table-hover table-borderless-outer table-borderless-inner-columns flush-bottom",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          data: this.getTableData(deploymentsItems),
	          expandRowsByDefault: true
	        }),
	        this.renderRollbackModal()
	      );
	    }
	  }, {
	    key: "renderRollbackError",
	    value: function renderRollbackError(deploymentRollbackError) {
	      if (deploymentRollbackError != null) {
	        return _react2.default.createElement(
	          "p",
	          { className: "text-error-state flush-bottom" },
	          deploymentRollbackError
	        );
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var content = null;
	      var deployments = _DCOSStore2.default.deploymentsList.getItems();
	      var _props = this.props,
	          intl = _props.intl,
	          isOpen = _props.isOpen,
	          onClose = _props.onClose;
	
	      var loading = !_DCOSStore2.default.serviceDataReceived;
	
	      if (loading) {
	        content = this.renderLoading();
	      } else if (deployments.length === 0) {
	        content = this.renderEmpty();
	      } else if (isOpen) {
	        content = this.renderTable(deployments);
	      }
	
	      var footer = _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        _react2.default.createElement(
	          "button",
	          { className: "button", onClick: onClose },
	          "Close"
	        )
	      );
	      var heading = _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        intl.formatMessage({
	          id: "SERVICES.DEPLOYMENT_MODAL_HEADING"
	        }, {
	          deploymentsCount: deployments.length
	        })
	      );
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          modalClass: "modal modal-large modal--deployments",
	          footer: footer,
	          header: heading,
	          onClose: onClose,
	          open: isOpen,
	          showFooter: true,
	          showHeader: true
	        },
	        content
	      );
	    }
	  }]);
	  return DeploymentsModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	module.exports = (0, _reactIntl.injectIntl)(DeploymentsModal);

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyServiceTree = function EmptyServiceTree(_ref) {
	  var onCreateGroup = _ref.onCreateGroup,
	      onCreateService = _ref.onCreateService;
	
	  var footer = _react2.default.createElement(
	    "div",
	    { className: "button-collection flush-bottom" },
	    _react2.default.createElement(
	      "button",
	      { className: "button button-stroke", onClick: onCreateGroup },
	      "Create Group"
	    ),
	    _react2.default.createElement(
	      "button",
	      { className: "button button-success", onClick: onCreateService },
	      "Run a Service"
	    )
	  );
	
	  return _react2.default.createElement(
	    _AlertPanel2.default,
	    null,
	    _react2.default.createElement(
	      _AlertPanelHeader2.default,
	      null,
	      "No running services"
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "tall" },
	      "Run a new service or create a new group to help organize your services."
	    ),
	    footer
	  );
	};
	
	EmptyServiceTree.defaultProps = {
	  onCreateGroup: function onCreateGroup() {},
	  onCreateService: function onCreateService() {}
	};
	
	EmptyServiceTree.propTypes = {
	  onCreateGroup: _react.PropTypes.func,
	  onCreateService: _react.PropTypes.func
	};
	
	module.exports = EmptyServiceTree;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLExpressionPart = __webpack_require__(1646);
	
	var _DSLExpressionPart2 = _interopRequireDefault(_DSLExpressionPart);
	
	var _DSLFormWithExpressionUpdates = __webpack_require__(1647);
	
	var _DSLFormWithExpressionUpdates2 = _interopRequireDefault(_DSLFormWithExpressionUpdates);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPRESSION_PARTS = {
	  text: _DSLExpressionPart2.default.fuzzy
	};
	
	var METHODS_TO_BIND = ["handleTextChange"];
	
	var FuzzyTextDSLSection = function (_React$Component) {
	  (0, _inherits3.default)(FuzzyTextDSLSection, _React$Component);
	
	  function FuzzyTextDSLSection() {
	    (0, _classCallCheck3.default)(this, FuzzyTextDSLSection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FuzzyTextDSLSection.__proto__ || (0, _getPrototypeOf2.default)(FuzzyTextDSLSection)).apply(this, arguments));
	
	    _this.state = {
	      data: {
	        text: ""
	      }
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(FuzzyTextDSLSection, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var expression = nextProps.expression;
	
	      var data = _DSLUtil2.default.getPartValues(expression, EXPRESSION_PARTS);
	      this.setState({ data: data });
	    }
	  }, {
	    key: "handleTextChange",
	    value: function handleTextChange(event) {
	      var target = event.target;
	
	      event.stopPropagation();
	      this.setState({
	        data: (0, _assign2.default)({}, this.state.data, {
	          text: target.value
	        })
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var data = this.state.data;
	      var _props = this.props,
	          expression = _props.expression,
	          onApply = _props.onApply,
	          onChange = _props.onChange;
	
	      var enabled = _DSLUtil2.default.canProcessParts(expression, EXPRESSION_PARTS);
	
	      return _react2.default.createElement(
	        _DSLFormWithExpressionUpdates2.default,
	        {
	          expression: expression,
	          groupCombiner: _DSLCombinerTypes2.default.AND,
	          itemCombiner: _DSLCombinerTypes2.default.OR,
	          onChange: onChange,
	          onSubmit: onApply,
	          parts: EXPRESSION_PARTS
	        },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          null,
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            "Has the words"
	          ),
	          _react2.default.createElement(_FieldInput2.default, {
	            disabled: !enabled,
	            name: "text",
	            onChange: this.handleTextChange,
	            placeholder: "Enter words found in name",
	            value: data.text
	          })
	        )
	      );
	    }
	  }]);
	  return FuzzyTextDSLSection;
	}(_react2.default.Component);
	
	FuzzyTextDSLSection.propTypes = {
	  onApply: _react.PropTypes.func,
	  onChange: _react.PropTypes.func.isRequired,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = FuzzyTextDSLSection;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLASTNodes = __webpack_require__(1605);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The DSL Expression Parts are used by components inserted in a `DSLInputForm`
	 * in order to specify the expression's AST nodes they are targeting.
	 *
	 * The functions and getters in this file are just shorthands to create virtual
	 * AST nodes (without any position information) that are used as comparision
	 * targets for selecting the correct nodes from the parsed AST nodes.
	 *
	 * @example <caption>How to use DSLExpressionPart</caption>
	 *
	 * const EXPRESSION_PARTS = {
	 *
	 *   // Create a boolean property that is defined when the attribute is:healthy
	 *   // exists in the parsed DSL
	 *   is_healthy: DSLExpressionPart.attribute('is', 'healthy'),
	 *
	 *   // Create a string property that contains the first exact-match node
	 *   text: DSLExpressionPart.exact,
	 *
	 *   // Create a string property that contains all the fuzzy-match nodes,
	 *   // concatenated with spaces
	 *   text: DSLExpressionPart.fuzzy
	 *
	 * }
	 *
	 * class MyComponent {
	 *   render() {
	 *      const {expression} = this.props;
	 *      const data = DSLUtil.getExpressionParts(expression, EXPRESSION_PARTS);
	 *
	 *      return (
	 *         <div>
	 *           <p>
	 *             Is healthy: <input type="checkbox" checked={data.is_healthy} />
	 *           </p>
	 *         </div>
	 *      );
	 *   }
	 * }
	 *
	 */
	var DSLExpressionPart = function () {
	  function DSLExpressionPart() {
	    (0, _classCallCheck3.default)(this, DSLExpressionPart);
	  }
	
	  (0, _createClass3.default)(DSLExpressionPart, null, [{
	    key: "attribute",
	    value: function attribute(label) {
	      var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	      return new _DSLASTNodes.FilterNode(0, 0, _DSLFilterTypes2.default.ATTRIB, { label: label, text: text });
	    }
	  }, {
	    key: "exact",
	    get: function get() {
	      return new _DSLASTNodes.FilterNode(0, 0, _DSLFilterTypes2.default.EXACT, {});
	    }
	  }, {
	    key: "fuzzy",
	    get: function get() {
	      return new _DSLASTNodes.FilterNode(0, 0, _DSLFilterTypes2.default.FUZZY, {});
	    }
	  }]);
	  return DSLExpressionPart;
	}();
	
	module.exports = DSLExpressionPart;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLUpdatePolicy = __webpack_require__(1648);
	
	var _DSLUpdatePolicy2 = _interopRequireDefault(_DSLUpdatePolicy);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLUpdateUtil = __webpack_require__(1649);
	
	var _DSLUpdateUtil2 = _interopRequireDefault(_DSLUpdateUtil);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	var _DSLASTNodes = __webpack_require__(1605);
	
	var _DSLFormUtil = __webpack_require__(1651);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleFormBlur", "handleFormChange", "handleFormSubmit"];
	
	/**
	 * This <form /> component wraps a set of <input /> elements and automates
	 * the update of the DSL expression based on the part definition given.
	 */
	
	var DSLFormWithExpressionUpdates = function (_React$Component) {
	  (0, _inherits3.default)(DSLFormWithExpressionUpdates, _React$Component);
	
	  function DSLFormWithExpressionUpdates() {
	    (0, _classCallCheck3.default)(this, DSLFormWithExpressionUpdates);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DSLFormWithExpressionUpdates.__proto__ || (0, _getPrototypeOf2.default)(DSLFormWithExpressionUpdates)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(DSLFormWithExpressionUpdates, [{
	    key: "handleFormBlur",
	    value: function handleFormBlur(event) {
	      var target = event.target;
	      var _props = this.props,
	          onChange = _props.onChange,
	          parts = _props.parts;
	      var value = target.value;
	
	
	      var name = target.getAttribute("name");
	      if (!name) {
	        return;
	      }
	
	      if (target.type === "checkbox") {
	        value = target.checked;
	      }
	
	      // Locate the respective DSL part node
	      var updateNode = parts[name];
	      if (updateNode == null) {
	        return;
	      }
	
	      // Update with blur only text & fuzzy
	      if (updateNode.filterType === _DSLFilterTypes2.default.ATTRIB) {
	        return;
	      }
	
	      // Callback with the new expression
	      onChange(this.getUpdatedExpression(updateNode, value));
	    }
	
	    /**
	     * Handle a change to the form
	     *
	     * @param {Object} event
	     */
	
	  }, {
	    key: "handleFormChange",
	    value: function handleFormChange(event) {
	      var target = event.target;
	      var _props2 = this.props,
	          onChange = _props2.onChange,
	          parts = _props2.parts;
	      var value = target.value;
	
	
	      var name = target.getAttribute("name");
	      if (!name) {
	        return;
	      }
	
	      if (target.type === "checkbox") {
	        value = target.checked;
	      }
	
	      // Locate the respective DSL part node
	      var updateNode = parts[name];
	      if (updateNode == null) {
	        return;
	      }
	
	      // Update directly only attributes. Free text is updated on blur
	      if (updateNode.filterType !== _DSLFilterTypes2.default.ATTRIB) {
	        return;
	      }
	
	      // Callback with the new expression
	      onChange(this.getUpdatedExpression(updateNode, value));
	    }
	  }, {
	    key: "handleFormSubmit",
	    value: function handleFormSubmit(event) {
	      event.preventDefault();
	      this.props.onSubmit();
	    }
	
	    /**
	     * Update the current expression (from props) by updating the given FilterNode
	     * to the given value according to the current update policies.
	     *
	     * @param {FilterNode} updateNode - The node to update
	     * @param {String|Boolean} value - The value to update to
	     * @returns {Expression} Returns the updated expression
	     */
	
	  }, {
	    key: "getUpdatedExpression",
	    value: function getUpdatedExpression(updateNode, value) {
	      var _props3 = this.props,
	          expression = _props3.expression,
	          groupCombiner = _props3.groupCombiner,
	          itemCombiner = _props3.itemCombiner,
	          parts = _props3.parts,
	          updatePolicy = _props3.updatePolicy;
	
	      // The node(s) relevant to the property we are updating
	
	      var matchingNodes = _DSLUtil2.default.findNodesByFilter(expression.ast, updateNode);
	
	      // All the existing nodes for all properties
	      var allMatchingNodes = (0, _keys2.default)(parts).reduce(function (memo, part) {
	        return memo.concat(_DSLUtil2.default.findNodesByFilter(expression.ast, parts[part]));
	      }, []);
	
	      switch (updateNode.filterType) {
	        //
	        // The way an attribute updates depends on the `dslUpdatePolicy`.
	        //
	        // In case of Checkbox policy, the attribute is added/removed, but in Radio
	        // policy the previous labels must be removed.
	        //
	        case _DSLFilterTypes2.default.ATTRIB:
	          // On 'Radio' update policy the new value is replacing any occurrence
	          // of all of the specified nodes.
	          if (updatePolicy === _DSLUpdatePolicy2.default.Radio) {
	            if (value) {
	              expression = _DSLUpdateUtil2.default.applyReplace(expression, allMatchingNodes, [updateNode], {
	                nodeCompareFunction: (0, _DSLFormUtil.createNodeComparisionFunction)(parts),
	                itemCombiner: itemCombiner,
	                newCombiner: groupCombiner
	              });
	            } else {
	              expression = _DSLUpdateUtil2.default.applyDelete(expression, matchingNodes);
	            }
	            break;
	          }
	
	          // On 'Checkbox' policy, we just add/remove the matching AST node
	          if (value) {
	            expression = _DSLUpdateUtil2.default.applyAdd(expression, [updateNode], {
	              nodeCompareFunction: (0, _DSLFormUtil.createNodeComparisionFunction)(parts),
	              itemCombiner: itemCombiner,
	              newCombiner: groupCombiner
	            });
	          } else {
	            expression = _DSLUpdateUtil2.default.applyDelete(expression, matchingNodes);
	          }
	          break;
	        //
	        // The exact attribute updates just replaces the node with a new text
	        //
	        case _DSLFilterTypes2.default.EXACT:
	          var newExactNode = new _DSLASTNodes.FilterNode(0, 0, _DSLFilterTypes2.default.EXACT, {
	            text: value
	          });
	
	          expression = _DSLUpdateUtil2.default.applyReplace(expression, matchingNodes, [newExactNode], {
	            newCombiner: groupCombiner
	          });
	          break;
	        //
	        // The fuzzy attribute replaces as many attributes as in the new text
	        //
	        case _DSLFilterTypes2.default.FUZZY:
	          var newFuzzyNodes = value.replace(":", " ").split(" ").map(function (text) {
	            return new _DSLASTNodes.FilterNode(0, 0, _DSLFilterTypes2.default.FUZZY, { text: text });
	          });
	
	          // And replace the existing fuzzy nodes
	          expression = _DSLUpdateUtil2.default.applyReplace(expression, matchingNodes, newFuzzyNodes, {
	            newCombiner: groupCombiner
	          });
	          break;
	      }
	
	      return expression;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var enabled = this.props.enabled;
	
	      var formClasses = (0, _classnames2.default)({
	        "dsl-form-group form-group tall": true,
	        disabled: !enabled
	      });
	
	      return _react2.default.createElement(
	        "form",
	        {
	          className: formClasses,
	          onChange: this.handleFormChange,
	          onBlur: this.handleFormBlur,
	          onSubmit: this.handleFormSubmit
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return DSLFormWithExpressionUpdates;
	}(_react2.default.Component);
	
	DSLFormWithExpressionUpdates.defaultProps = {
	  enabled: true,
	  groupCombiner: _DSLCombinerTypes2.default.AND,
	  itemCombiner: _DSLCombinerTypes2.default.AND,
	  onChange: function onChange() {},
	  onSubmit: function onSubmit() {},
	
	  updatePolicy: _DSLUpdatePolicy2.default.Checkbox
	};
	
	DSLFormWithExpressionUpdates.propTypes = {
	  enabled: _react.PropTypes.bool,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired,
	  groupCombiner: _react.PropTypes.oneOf((0, _keys2.default)(_DSLCombinerTypes2.default).map(function (key) {
	    return _DSLCombinerTypes2.default[key];
	  })),
	  itemCombiner: _react.PropTypes.oneOf((0, _keys2.default)(_DSLCombinerTypes2.default).map(function (key) {
	    return _DSLCombinerTypes2.default[key];
	  })),
	  onChange: _react.PropTypes.func,
	  onSubmit: _react.PropTypes.func,
	  parts: _react.PropTypes.objectOf(_react.PropTypes.instanceOf(_DSLASTNodes.FilterNode)).isRequired,
	  updatePolicy: _react.PropTypes.oneOf((0, _keys2.default)(_DSLUpdatePolicy2.default).map(function (key) {
	    return _DSLUpdatePolicy2.default[key];
	  }))
	};
	
	module.exports = DSLFormWithExpressionUpdates;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _symbol = __webpack_require__(940);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Different policies for updating DSL attributes
	 */
	var DSL_UPDATE_POLICY = {
	  Checkbox: (0, _symbol2.default)("Checkbox"),
	  Radio: (0, _symbol2.default)("Radio")
	};
	
	module.exports = DSL_UPDATE_POLICY;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRING_EXPR = /(['"])[^\1]+?(?=\1)\1/;
	
	var DSLUpdateUtil = {
	  /**
	   * Default function used by the `applyAdd` function to detect is similar node
	   * already exists in the expression.
	   *
	   * @param {FilterNode} referenceNode - The node to compare against
	   * @param {FilterNode} compareNode - The node to compare
	   * @returns {Boolean} Returns `true` if there is no similar node in the AST
	   */
	  defaultNodeCompareFunction: function defaultNodeCompareFunction(referenceNode, compareNode) {
	    if (referenceNode.filterType !== compareNode.filterType) {
	      return false;
	    }
	
	    if (referenceNode.filterType !== _DSLFilterTypes2.default.ATTRIB) {
	      return true;
	    }
	
	    return referenceNode.filterParams.label === compareNode.filterParams.label;
	  },
	
	
	  /**
	   * Clean-up a DSL expression without damaging it's semantic meaning.
	   * This function does the following:
	   *
	   * - Expands single parenthesis (ex. "foo (bar) baz")
	   * - Trims consecutive whitespaces (ex "foo  bar ")
	   * - Trims consecutive or empty commas (ex. "foo,, bar, , baz")
	   * - Removes orphan comas (ex. ", foo (, bar) label:,baz")
	   *
	   * @param {String} src - The source expression string
	   * @returns {String} The cleaned-up expression string
	   */
	  cleanupExpressionString: function cleanupExpressionString(src) {
	    var strings = [];
	
	    // Extract string expressions so we have a simpler expression to work with
	    src = src.replace(STRING_EXPR, function (match) {
	      strings.push(match);
	
	      return "\x01";
	    });
	
	    // Perform clean-ups
	    src = src.replace(/\(([^ ,]+)\)/g, "$1"); // Single parenthesis
	    src = src.replace(/\s+/g, " "); // Consecutive spaces
	    src = src.replace(/,(\s*,)+/g, ","); // Consecutive commas
	    src = src.replace(/^\s*,/g, ""); // Orphan commas (left-side)
	    src = src.replace(/,\s*$/g, ""); // Orphan commas (right-side)
	    src = src.replace(/\(\s*,\s*/g, "("); // Orphan commas (left-paren)
	    src = src.replace(/\s*,\s*\)/g, ")"); // Orphan commas (right-paren)
	    src = src.replace(/:,+/g, ":"); // Orphan commas (multi-value)
	    src = src.replace(/\s+,\s+/g, ", "); // Commas with surrounding whitespace
	
	    // Put strings back
	    /* eslint-disable no-control-regex */
	    src = src.replace(/\x01/g, function () {
	      return strings.pop(0);
	    });
	    /* eslint-enable no-control-regex */
	
	    return src.trim();
	  },
	
	
	  /**
	   * Update the text representation of a node in order to match the new node.
	   *
	   * @param {String} src - The source expression string
	   * @param {ASTNode} node - The ast node to replace
	   * @param {ASTNode} newNode - The ast node to replace with
	   * @param {number} offset - The offset to apply on position indices
	   * @returns {String} Returns the updated string
	   */
	  updateNodeTextString: function updateNodeTextString(src, node, newNode) {
	    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var position = node.position,
	        filterType = node.filterType;
	
	    var textStart = position[0][0] + offset;
	    var textEnd = position[0][1] + offset;
	    var text = newNode.filterParams.text;
	
	
	    if (filterType !== newNode.filterType) {
	      if (_Config2.default.environment === "development") {
	        throw new Error("Trying to update a node with a mismatching node!");
	      }
	
	      return src;
	    }
	
	    // Attributes have their value on position[1]
	    if (filterType === _DSLFilterTypes2.default.ATTRIB) {
	      textStart = position[1][0] + offset;
	      textEnd = position[1][1] + offset;
	    }
	
	    // Exact matches are not quoted, so quote them now
	    if (filterType === _DSLFilterTypes2.default.EXACT) {
	      text = "\"" + text + "\"";
	    }
	
	    // Replace the entire string
	    return src.substr(0, textStart) + text + src.substr(textEnd);
	  },
	
	
	  /**
	   * Update the label of an attribute node with the new label from `newNode`.
	   *
	   * @param {String} src - The source expression string
	   * @param {ASTNode} node - The ast node to replace
	   * @param {ASTNode} newNode - The ast node to replace with
	   * @param {number} offset - The offset to apply on position indices
	   * @returns {String} Returns the updated string
	   */
	  updateNodeValueString: function updateNodeValueString(src, node, newNode) {
	    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var position = node.position,
	        filterType = node.filterType;
	
	    var labelStart = position[0][0] + offset;
	    var labelEnd = position[0][1] + offset;
	    var label = newNode.filterParams.label;
	
	
	    if (filterType !== newNode.filterType) {
	      if (_Config2.default.environment === "development") {
	        throw new Error("Trying to update a node with a mismatching node!");
	      }
	
	      return src;
	    }
	
	    if (filterType !== _DSLFilterTypes2.default.ATTRIB) {
	      if (_Config2.default.environment === "development") {
	        throw new Error("Trying to update a non-label node as label!");
	      }
	
	      return src;
	    }
	
	    // Replace only label
	    return src.substr(0, labelStart) + (label + ":") + src.substr(labelEnd);
	  },
	
	
	  /**
	   * Delete the string representation of the given expression string
	   *
	   * @param {String} src - The source expression string
	   * @param {ASTNode} node - The node node to replace
	   * @param {number} offset - The offset to apply on position indices
	   * @param {Boolean} [bleed] - Set to true if you want to trim bleeding spaces
	   * @returns {String} Returns the updated string
	   */
	  deleteNodeString: function deleteNodeString(src, node) {
	    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var position = node.position;
	
	    var endingRegex = /^(\s|,\s|$)/;
	    var start = position[0][0] + offset;
	    var end = position[0][1] + offset;
	
	    // Attributes have a special handling, in case they are multi-valued
	    if (node.filterType === _DSLFilterTypes2.default.ATTRIB) {
	      // Change scope to value
	      start = position[1][0] + offset;
	      end = position[1][1] + offset;
	
	      // Increase the scope to the entire value only if the node is the only
	      // value in the attribute. To test for this, we are checking if the
	      // character right before is the label ':' and the character after is a
	      // whitespace or a comma with whitespace
	      if (src[start - 1] === ":" && endingRegex.exec(src.substr(end))) {
	        start = position[0][0] + offset;
	        end = position[1][1] + offset;
	
	        // Otherwise, bleed left to remove the comma if we are part of multi-value
	      } else if (src[start - 1] === ",") {
	        start -= 1;
	
	        // Or bleed right if we were the first item
	      } else if (src[end] === ",") {
	        end += 1;
	      }
	    }
	
	    // Strip and cleanup any damage caused by it
	    return DSLUpdateUtil.cleanupExpressionString(src.substr(0, start) + src.substr(end));
	  },
	
	
	  /**
	   * Append the given node at the end of the expression
	   *
	   * @param {String} src - The source expression string
	   * @param {ASTNode} node - The node node to add
	   * @param {ASTNode} fullAst - The representation of the current full AST
	   * @param {number} offset - The offset to apply on position indices
	   * @param {DSLCombinerTypes} [combiner] - The combiner operation to use
	   * @returns {String} Returns the updated string
	   */
	  addNodeString: function addNodeString(src, node, fullAst) {
	    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var combiner = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _DSLCombinerTypes2.default.AND;
	
	    var whitespaceRegex = /\s+$/;
	
	    // Trim tailing whitespace
	    src = src.replace(whitespaceRegex, "");
	
	    // If we are using AND operation just append node string with whitespace
	    if (combiner === _DSLCombinerTypes2.default.AND) {
	      if (src) {
	        src += " ";
	      }
	
	      return src + _DSLUtil2.default.getNodeString(node);
	    }
	
	    // If we are using OR operator, just append
	    if (src) {
	      src += ", ";
	    }
	
	    return src + _DSLUtil2.default.getNodeString(node);
	  },
	
	
	  /**
	   * Append the given node at the end of the given attribute node, creating
	   * or updating a multi-value node
	   *
	   * @param {String} src - The source expression string
	   * @param {ASTNode} node - The node node to append
	   * @param {ASTNode} toNode - The attribute node to add onto
	   * @param {number} offset - The offset to apply on position indices
	   * @returns {String} Returns the updated string
	   */
	  appendAttribNodeString: function appendAttribNodeString(src, node, toNode) {
	    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    // Inject only the text into the given label
	    return src.substr(0, toNode.position[1][1] + offset) + "," + node.filterParams.text + src.substr(toNode.position[1][1] + offset);
	  },
	
	
	  /**
	   * Append the given nodes at the end of the expression
	   *
	   * @param {DSLExpression} expression - The expression to update
	   * @param {Array} nodes - The node(s) to append
	   * @param {Object} [options] - Combine options
	   * @returns {DSLExpression} expression - The updated expression
	   */
	  applyAdd: function applyAdd(expression, nodes) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var _options$nodeCompareF = options.nodeCompareFunction,
	        nodeCompareFunction = _options$nodeCompareF === undefined ? DSLUpdateUtil.defaultNodeCompareFunction : _options$nodeCompareF,
	        _options$itemCombiner = options.itemCombiner,
	        itemCombiner = _options$itemCombiner === undefined ? _DSLCombinerTypes2.default.AND : _options$itemCombiner,
	        _options$newCombiner = options.newCombiner,
	        newCombiner = _options$newCombiner === undefined ? _DSLCombinerTypes2.default.AND : _options$newCombiner;
	
	
	    var expressionUpdate = nodes.reduce(function (_ref, node, index) {
	      var value = _ref.value,
	          offset = _ref.offset;
	
	      var combiner = itemCombiner;
	      var newValue = value;
	
	      // Find all the existing nodes, related to the node being added
	      var relevantNodes = _DSLUtil2.default.reduceAstFilters(expression.ast, function (memo, filterNode) {
	        if (nodeCompareFunction(node, filterNode)) {
	          memo.push(filterNode);
	        }
	
	        return memo;
	      }, []);
	
	      // If this is the first element, check if we have previous relevant
	      // occurrences in the expression, and if yes, use the `newCombiner`
	      if (index === 0) {
	        if (relevantNodes.length === 0) {
	          combiner = newCombiner;
	        }
	      }
	
	      // In case of an OR operator + attribute node we take special care for
	      // creating multi-value attributes when possible
	      if (combiner === _DSLCombinerTypes2.default.OR && node.filterType === _DSLFilterTypes2.default.ATTRIB && relevantNodes.length !== 0 && node.filterParams.label === relevantNodes[0].filterParams.label) {
	        newValue = DSLUpdateUtil.appendAttribNodeString(value, node, relevantNodes[0], offset);
	
	        // Otherwise we use regular node concatenation
	      } else {
	        newValue = DSLUpdateUtil.addNodeString(value, node, expression.ast, offset, combiner);
	      }
	
	      // Update offset in order for the token positions in the expression
	      // AST to be processable even after the updates
	      offset += newValue.length - value.length;
	
	      return { offset: offset, value: newValue };
	    }, { offset: 0, value: expression.value });
	
	    return new _DSLExpression2.default(expressionUpdate.value);
	  },
	
	
	  /**
	   * Delete the given list of nodes from the expression
	   *
	   * @param {DSLExpression} expression - The expression to update
	   * @param {Array} nodes - The node(s) to delete
	   * @returns {DSLExpression} expression - The updated expression
	   */
	  applyDelete: function applyDelete(expression, nodes) {
	    var newExpression = nodes.reduce(function (_ref2, node) {
	      var value = _ref2.value,
	          offset = _ref2.offset;
	
	      // Delete value
	      var newValue = DSLUpdateUtil.deleteNodeString(value, node, offset);
	
	      // This action shifted the location of the tokens in the original
	      // expression. Update offset.
	      offset += newValue.length - value.length;
	
	      return { value: newValue, offset: offset };
	    }, { value: expression.value, offset: 0 });
	
	    return new _DSLExpression2.default(newExpression.value);
	  },
	
	
	  /**
	   * Replace the given nodes in the expression with the new array of nodes
	   * taking correcting actions if the lengths do not match.
	   *
	   * @param {DSLExpression} expression - The expression to update
	   * @param {Array} nodes - The node(s) to update
	   * @param {Array} newNodes - The node(s) to update with
	   * @param {Object} [addOptions] - Options for adding nodes
	   * @returns {DSLExpression} expression - The updated expression
	   */
	  applyReplace: function applyReplace(expression, nodes, newNodes) {
	    var addOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var updateCount = Math.min(nodes.length, newNodes.length);
	    var expressionValue = expression.value;
	    var offset = 0;
	
	    // First update nodes
	    for (var i = 0; i < updateCount; ++i) {
	      var updateNode = nodes[i];
	      var withNode = newNodes[i];
	
	      // Update expression value
	      var newValue = DSLUpdateUtil.updateNodeTextString(expressionValue, updateNode, withNode, offset);
	
	      // This action may have shifted the location of the tokens
	      // in the original expression. Update offset.
	      offset += newValue.length - expressionValue.length;
	
	      expressionValue = newValue;
	    }
	
	    // Compile the status of the expression so far
	    var newExpression = new _DSLExpression2.default(expressionValue);
	
	    // Delete nodes using applyDelete
	    if (newNodes.length < nodes.length) {
	      // Note that the offsets in the `nodes` array point to the old expression
	      // so they have to be updated in order to match the new expression
	      var deleteNodes = nodes.slice(updateCount).map(function (node) {
	        node.position = node.position.map(function (_ref3) {
	          var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	              start = _ref4[0],
	              end = _ref4[1];
	
	          return [start + offset, end + offset];
	        });
	
	        return node;
	      });
	
	      // We avoid expanding the logic of `applyDelete` and instead we use the
	      // 'hack' of the offset update above in order to isolate the logic.
	      return DSLUpdateUtil.applyDelete(newExpression, deleteNodes);
	    }
	
	    // Add nodes using applyAdd
	    if (newNodes.length > nodes.length) {
	      return DSLUpdateUtil.applyAdd(newExpression, newNodes.slice(updateCount), addOptions);
	    }
	
	    // Otherwise just return the expression
	    return newExpression;
	  }
	};
	
	module.exports = DSLUpdateUtil;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	var _DSLASTNodes = __webpack_require__(1605);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENDING_WHITESPACE = /\s+$/;
	
	var DSLUtil = {
	  /**
	   * Checks if the given expression can be processed by the UI
	   *
	   * @param {DSLExpression} expression - The expression to process
	   * @returns {Boolean} Returns the expression state
	   */
	  canFormProcessExpression: function canFormProcessExpression(expression) {
	    var hasGroups = expression.value.indexOf("(") !== -1;
	    var repeatingStatus = DSLUtil.reduceAstFilters(expression.ast, function (memo, filter) {
	      if (memo.isRepeating) {
	        return memo;
	      }
	
	      // Ignore fuzzy tokens
	      if (filter.filterType === _DSLFilterTypes2.default.FUZZY) {
	        return memo;
	      }
	
	      // Keep track of the tokens we have found so far
	      var filterStr = DSLUtil.getNodeString(filter);
	      if (memo.found[filterStr] == null) {
	        memo.found[filterStr] = true;
	
	        return memo;
	      }
	
	      // If we found a repeating token, mark repeating
	      memo.isRepeating = true;
	
	      return memo;
	    }, { isRepeating: false, found: {} });
	
	    // We can process an expression only if we have no groups if we
	    // have groups and no repeating nodes
	    return !hasGroups || !repeatingStatus.isRepeating;
	  },
	
	
	  /**
	   * This function checks if the given partFilters can create clean results
	   * with the given AST structure as input.
	   *
	   * @param {DSLExpression} expression - The parsed expression
	   * @param {Array} partFilters - An array of `FilterNode` to use for match ref.
	   * @returns {Boolean} Returns true if the expression can be handled by the UI
	   */
	  canProcessParts: function canProcessParts(expression, partFilters) {
	    var propNames = (0, _keys2.default)(partFilters);
	
	    return propNames.every(function (prop) {
	      var matchAgainst = partFilters[prop];
	      var matchingNodes = DSLUtil.findNodesByFilter(expression.ast, matchAgainst);
	
	      // NOTE: Be aware that the entire form should be disabled if the
	      //       expression is difficult for the UI to process. This means
	      //       that if we have a grouping operator and at least one repeating
	      //       node, this code shouldn't be executed at all.
	      //       You can use `DSLUtil.canFormProcessExpression` for this.
	
	      switch (matchAgainst.filterType) {
	        // Attrib nodes can only handle 1 match
	        case _DSLFilterTypes2.default.ATTRIB:
	          return matchingNodes.length <= 1;
	        // Exact nodes can only handle 1 match
	        case _DSLFilterTypes2.default.EXACT:
	          return matchingNodes.length <= 1;
	        // We are concatenating all fuzzy-matching nodes into a string
	        // so we have no problem if we have more than one.
	        case _DSLFilterTypes2.default.FUZZY:
	          return true;
	      }
	    });
	  },
	
	
	  /**
	   * This function walks the given AST and extracts all the nodes matching the
	   * given filter node.
	   *
	   * @param {ASTNode} ast - The AST node to walk on
	   * @param {FilterNode} filter - The reference AST node to compare against
	   * @returns {Array} Returns an array of FilterNodes tha match filter
	   */
	  findNodesByFilter: function findNodesByFilter(ast, filter) {
	    return DSLUtil.reduceAstFilters(ast, function (memo, astFilter) {
	      var filterParams = astFilter.filterParams,
	          filterType = astFilter.filterType;
	      var compareFilterParams = filter.filterParams,
	          compareFilterType = filter.filterType;
	
	      // Require types to match
	
	      if (filterType !== compareFilterType) {
	        return memo;
	      }
	
	      // Require only testing properties to match
	      var compareParamNames = (0, _keys2.default)(compareFilterParams);
	      var comparePropMatches = compareParamNames.every(function (prop) {
	        return filterParams[prop] === compareFilterParams[prop];
	      });
	
	      if (compareParamNames.length === 0 || comparePropMatches) {
	        return memo.concat(astFilter);
	      }
	
	      return memo;
	    }, []);
	  },
	
	
	  /**
	   * Get the string representation of the given AST node
	   *
	   * @param {ASTNode} node - The DSL AST Node
	   * @returns {String} The string representation of the node
	   */
	  getNodeString: function getNodeString(node) {
	    var filterParams = node.filterParams,
	        filterType = node.filterType;
	
	    switch (filterType) {
	      case _DSLFilterTypes2.default.ATTRIB:
	        return filterParams.label + ":" + filterParams.text;
	
	      case _DSLFilterTypes2.default.EXACT:
	        return "\"" + filterParams.text + "\"";
	
	      case _DSLFilterTypes2.default.FUZZY:
	        return filterParams.text;
	    }
	  },
	
	
	  /**
	   * This function returns an object with the values for all the given
	   * partFilters by analyzing the ast given as input.
	   *
	   * @param {DSLExpression} expression - The parsed expression
	   * @param {Array} partFilters - An array of `FilterNode` to use for match ref.
	   * @returns {Object} Returns an object with the propType keys and their values
	   */
	  getPartValues: function getPartValues(expression, partFilters) {
	    var propNames = (0, _keys2.default)(partFilters);
	
	    // NOTE: We assume that `canProcessParts` is called before and this
	    //       function is called only after a positive answer. Therefore we are
	    //       safe to do some unsafe assumptions for this.
	
	    return propNames.reduce(function (memo, prop) {
	      var matchAgainst = partFilters[prop];
	      var matchingNodes = DSLUtil.findNodesByFilter(expression.ast, matchAgainst);
	
	      switch (matchAgainst.filterType) {
	        //
	        // Properties created through attribute filter will get a boolean value
	        //
	        case _DSLFilterTypes2.default.ATTRIB:
	          memo[prop] = matchingNodes.length === 1;
	
	          return memo;
	        //
	        // Properties created through exact filter will get a string value
	        //
	        case _DSLFilterTypes2.default.EXACT:
	          if (matchingNodes.length === 0) {
	            memo[prop] = null;
	
	            return memo;
	          }
	
	          memo[prop] = matchingNodes[0].filterParams.text;
	
	          return memo;
	        //
	        // Properties created through fuzzy filter will get a string value,
	        // composed by joining together any individual item in the string
	        //
	        case _DSLFilterTypes2.default.FUZZY:
	          if (matchingNodes.length === 0) {
	            memo[prop] = null;
	
	            return memo;
	          }
	
	          memo[prop] = matchingNodes.map(function (ast) {
	            return ast.filterParams.text;
	          }).join(" ");
	
	          // Also append whatever whitespace remains at the end of the raw value
	          //
	          // NOTE: This is a trick to allow dynamic updates of a React component
	          //       since white spaces at the end of the expression are not part
	          //       of a regular DSL expression and are trimmed.
	          //
	          var tailingWhitespace = ENDING_WHITESPACE.exec(expression.value);
	          if (tailingWhitespace) {
	            memo[prop] += tailingWhitespace[0];
	          }
	
	          return memo;
	      }
	    }, {});
	  },
	
	
	  /**
	   * This function walks the provided ast tree and calls back the given
	   * callback function in the same way the `Array.reduce` function works.
	   *
	   * @param {ASTNode} ast - The AST node to walk on
	   * @param {function} callback - The function to call for every filter
	   * @param {any} memo - The AST node to walk on
	   * @returns {any} Returns the result of the reduce operation
	   */
	  reduceAstFilters: function reduceAstFilters(ast, callback, memo) {
	    if (!ast) {
	      return memo;
	    }
	
	    // Collect terminal nodes
	    if (ast instanceof _DSLASTNodes.FilterNode) {
	      return callback(memo, ast);
	    }
	
	    // Traverse children of combiner nodes
	    if (ast instanceof _DSLASTNodes.CombinerNode) {
	      return ast.children.reduce(function (curMemo, child) {
	        return DSLUtil.reduceAstFilters(child, callback, curMemo);
	      }, memo);
	    }
	
	    return memo;
	  }
	};
	
	module.exports = DSLUtil;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _DSLFilterTypes = __webpack_require__(1603);
	
	var _DSLFilterTypes2 = _interopRequireDefault(_DSLFilterTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DSLFormUtil = {
	  /**
	   * This function creates a `nodeCompareFunction` function, used by the
	   * expression update utilities to detect relevant nodes.
	   *
	   * This is used internally by DSLUpdateUtil in order to update existing nodes
	   * or detect if the node being added is the first one and therefore needs
	   * to have a different combine operator.
	   *
	   * @param {Object} parts - An object with the part configuration
	   * @returns {function} Returns a compatible function for use by applyadd
	   */
	  createNodeComparisionFunction: function createNodeComparisionFunction(parts) {
	    var referenceNodes = (0, _keys2.default)(parts).map(function (key) {
	      return parts[key];
	    });
	
	    /**
	     * The returned function is called when the node `nodeAdded` is about to
	     * be added on the AST. The `astNode` is the current node being walked over.
	     *
	     * Returning `true` means that the AST already contains a relevant node and
	     * that node must be updated (if possible).
	     *
	     * The default behavior is to loosely compare AST nodes, meaning that
	     * attribute nodes will be compared only against their `label`. However this
	     * function makes attribute matching more strict, and scoped to the parts
	     * given.
	     *
	     * This makes it possible to have attributes that share the same `label` yet
	     * still be considered separate nodes. For example, when the OR operator is
	     * applied between matching labels they will be processed as `is:a, is:b`
	     * instead of `is:a,b`.
	     *
	     * @param {FilterNode} nodeAdded - The node being added to the expression
	     * @param {FilterNode} astNode - The node in the AST to compare against
	     * @returns {Boolean} Return true if the two nodes are compatible
	     */
	    return function (nodeAdded, astNode) {
	      return referenceNodes.some(function (referenceNode) {
	        if (referenceNode.filterType !== astNode.filterType) {
	          return false;
	        }
	
	        // Free-text nodes are not strict
	        if (referenceNode.filterType !== _DSLFilterTypes2.default.ATTRIB) {
	          return true;
	        }
	
	        // But attribute nodes are strict
	        return referenceNode.filterParams.label === astNode.filterParams.label && referenceNode.filterParams.text === astNode.filterParams.text;
	      });
	    };
	  }
	};
	
	module.exports = DSLFormUtil;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldLabel = function FieldLabel(props) {
	  var children = props.children,
	      className = props.className,
	      matchInputHeight = props.matchInputHeight,
	      required = props.required;
	
	  var isToggle = false;
	  _react2.default.Children.forEach(children, function (child) {
	    var type = (0, _Util.findNestedPropertyInObject)(child, "props.type");
	    if (["radio", "checkbox"].includes(type)) {
	      isToggle = true;
	    }
	  });
	  var classes = (0, _dedupe2.default)({ "form-control-toggle form-control-toggle-custom": isToggle }, className);
	
	  var requiredNode = void 0;
	  if (required) {
	    requiredNode = _react2.default.createElement(
	      "span",
	      { className: "text-danger" },
	      " *"
	    );
	  }
	
	  var label = _react2.default.createElement(
	    "label",
	    (0, _extends3.default)({
	      className: classes
	    }, (0, _Util.omit)(props, (0, _keys2.default)(FieldLabel.propTypes))),
	    children,
	    requiredNode
	  );
	
	  if (!matchInputHeight) {
	    return label;
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "form-control-input-height" },
	    label
	  );
	};
	
	FieldLabel.propTypes = {
	  children: _react2.default.PropTypes.node,
	  // Vertically center the element based on the height of input fields
	  matchInputHeight: _react2.default.PropTypes.bool,
	  // Optional boolean to show a required indicator
	  required: _react2.default.PropTypes.bool,
	
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = FieldLabel;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLExpressionPart = __webpack_require__(1646);
	
	var _DSLExpressionPart2 = _interopRequireDefault(_DSLExpressionPart);
	
	var _DSLFormWithExpressionUpdates = __webpack_require__(1647);
	
	var _DSLFormWithExpressionUpdates2 = _interopRequireDefault(_DSLFormWithExpressionUpdates);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPRESSION_PARTS = {
	  is_healthy: _DSLExpressionPart2.default.attribute("is", "healthy"),
	  is_unhealthy: _DSLExpressionPart2.default.attribute("is", "unhealthy"),
	  no_healthchecks: _DSLExpressionPart2.default.attribute("no", "healthchecks")
	};
	
	var ServiceHealthDSLSection = function (_React$Component) {
	  (0, _inherits3.default)(ServiceHealthDSLSection, _React$Component);
	
	  function ServiceHealthDSLSection() {
	    (0, _classCallCheck3.default)(this, ServiceHealthDSLSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceHealthDSLSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceHealthDSLSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceHealthDSLSection, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          expression = _props.expression,
	          onChange = _props.onChange;
	
	      var enabled = _DSLUtil2.default.canProcessParts(expression, EXPRESSION_PARTS);
	      var data = _DSLUtil2.default.getPartValues(expression, EXPRESSION_PARTS);
	
	      return _react2.default.createElement(
	        _DSLFormWithExpressionUpdates2.default,
	        {
	          enabled: enabled,
	          expression: expression,
	          groupCombiner: _DSLCombinerTypes2.default.AND,
	          itemCombiner: _DSLCombinerTypes2.default.OR,
	          onChange: onChange,
	          parts: EXPRESSION_PARTS
	        },
	        _react2.default.createElement(
	          "label",
	          null,
	          "Health"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_healthy,
	                  disabled: !enabled,
	                  name: "is_healthy",
	                  type: "checkbox"
	                }),
	                "Healthy"
	              ),
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.no_healthchecks,
	                  disabled: !enabled,
	                  name: "no_healthchecks",
	                  type: "checkbox"
	                }),
	                "N/A"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_unhealthy,
	                  disabled: !enabled,
	                  name: "is_unhealthy",
	                  type: "checkbox"
	                }),
	                "Unhealthy"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ServiceHealthDSLSection;
	}(_react2.default.Component);
	
	ServiceHealthDSLSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = ServiceHealthDSLSection;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLExpressionPart = __webpack_require__(1646);
	
	var _DSLExpressionPart2 = _interopRequireDefault(_DSLExpressionPart);
	
	var _DSLFormWithExpressionUpdates = __webpack_require__(1647);
	
	var _DSLFormWithExpressionUpdates2 = _interopRequireDefault(_DSLFormWithExpressionUpdates);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPRESSION_PARTS = {
	  is_pod: _DSLExpressionPart2.default.attribute("is", "pod"),
	  is_package: _DSLExpressionPart2.default.attribute("is", "package"),
	  has_volumes: _DSLExpressionPart2.default.attribute("has", "volumes")
	};
	
	var ServiceOtherDSLSection = function (_React$Component) {
	  (0, _inherits3.default)(ServiceOtherDSLSection, _React$Component);
	
	  function ServiceOtherDSLSection() {
	    (0, _classCallCheck3.default)(this, ServiceOtherDSLSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceOtherDSLSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceOtherDSLSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceOtherDSLSection, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          expression = _props.expression,
	          onChange = _props.onChange;
	
	      var enabled = _DSLUtil2.default.canProcessParts(expression, EXPRESSION_PARTS);
	      var data = _DSLUtil2.default.getPartValues(expression, EXPRESSION_PARTS);
	
	      return _react2.default.createElement(
	        _DSLFormWithExpressionUpdates2.default,
	        {
	          enabled: enabled,
	          expression: expression,
	          groupCombiner: _DSLCombinerTypes2.default.AND,
	          itemCombiner: _DSLCombinerTypes2.default.OR,
	          onChange: onChange,
	          parts: EXPRESSION_PARTS
	        },
	        _react2.default.createElement(
	          "label",
	          null,
	          "Other"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_package,
	                  disabled: !enabled,
	                  name: "is_package",
	                  type: "checkbox"
	                }),
	                "Catalog"
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_pod,
	                  disabled: !enabled,
	                  name: "is_pod",
	                  type: "checkbox"
	                }),
	                "Pod"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.has_volumes,
	                  disabled: !enabled,
	                  name: "has_volumes",
	                  type: "checkbox"
	                }),
	                "Volumes"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ServiceOtherDSLSection;
	}(_react2.default.Component);
	
	ServiceOtherDSLSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = ServiceOtherDSLSection;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactIntl = __webpack_require__(753);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Links = __webpack_require__(1656);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	var _NestedServiceLinks = __webpack_require__(1657);
	
	var _NestedServiceLinks2 = _interopRequireDefault(_NestedServiceLinks);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _HealthBar = __webpack_require__(1586);
	
	var _HealthBar2 = _interopRequireDefault(_HealthBar);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceActionDisabledModal = __webpack_require__(1612);
	
	var _ServiceActionDisabledModal2 = _interopRequireDefault(_ServiceActionDisabledModal);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionLabels = __webpack_require__(1613);
	
	var _ServiceActionLabels2 = _interopRequireDefault(_ServiceActionLabels);
	
	var _ServiceStatusTypes = __webpack_require__(1093);
	
	var _ServiceStatusTypes2 = _interopRequireDefault(_ServiceStatusTypes);
	
	var _ServiceStatusWarning = __webpack_require__(1589);
	
	var _ServiceStatusWarning2 = _interopRequireDefault(_ServiceStatusWarning);
	
	var _ServiceTableHeaderLabels = __webpack_require__(1658);
	
	var _ServiceTableHeaderLabels2 = _interopRequireDefault(_ServiceTableHeaderLabels);
	
	var _ServiceTableUtil = __webpack_require__(1659);
	
	var _ServiceTableUtil2 = _interopRequireDefault(_ServiceTableUtil);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusMapping = {
	  Running: "running-state"
	};
	
	var columnClasses = {
	  name: "service-table-column-name",
	  status: "service-table-column-status",
	  cpus: "service-table-column-cpus",
	  mem: "service-table-column-mem",
	  disk: "service-table-column-disk",
	  actions: "service-table-column-actions"
	};
	
	var METHODS_TO_BIND = ["onActionsItemSelection", "handleServiceAction", "handleActionDisabledModalOpen", "handleActionDisabledModalClose", "renderHeadline", "renderStats", "renderStatus", "renderServiceActions"];
	
	var ServicesTable = function (_React$Component) {
	  (0, _inherits3.default)(ServicesTable, _React$Component);
	
	  function ServicesTable() {
	    (0, _classCallCheck3.default)(this, ServicesTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServicesTable.__proto__ || (0, _getPrototypeOf2.default)(ServicesTable)).apply(this, arguments));
	
	    _this.state = { actionDisabledService: null };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServicesTable, [{
	    key: "onActionsItemSelection",
	    value: function onActionsItemSelection(service, actionItem) {
	      var isGroup = service instanceof _ServiceTree2.default;
	      var containsSDKService = false;
	
	      if (isGroup) {
	        containsSDKService =
	        // #findItem will flatten the service tree
	        service.findItem(function (item) {
	          return item instanceof _Service2.default && (0, _ServiceUtil.isSDKService)(item);
	        }) != null;
	      }
	
	      // We still want to support the `open` action to display the web view
	      if ((containsSDKService || (0, _ServiceUtil.isSDKService)(service)) && !_PluginSDK.Hooks.applyFilter("isEnabledSDKAction", actionItem.id === _ServiceActionItem.EDIT || actionItem.id === _ServiceActionItem.OPEN, actionItem.id)) {
	        this.handleActionDisabledModalOpen(service, actionItem.id);
	      } else {
	        this.handleServiceAction(service, actionItem.id);
	      }
	    }
	  }, {
	    key: "handleServiceAction",
	    value: function handleServiceAction(service, actionID) {
	      var _context = this.context,
	          modalHandlers = _context.modalHandlers,
	          router = _context.router;
	
	
	      switch (actionID) {
	        case _ServiceActionItem.EDIT:
	          router.push("/services/detail/" + encodeURIComponent(service.getId()) + "/edit/");
	          break;
	        case _ServiceActionItem.SCALE:
	          modalHandlers.scaleService({ service: service });
	          break;
	        case _ServiceActionItem.OPEN:
	          modalHandlers.openServiceUI({ service: service });
	          break;
	        case _ServiceActionItem.RESTART:
	          modalHandlers.restartService({ service: service });
	          break;
	        case _ServiceActionItem.RESUME:
	          modalHandlers.resumeService({ service: service });
	          break;
	        case _ServiceActionItem.SUSPEND:
	          modalHandlers.suspendService({ service: service });
	          break;
	        case _ServiceActionItem.DELETE:
	          modalHandlers.deleteService({ service: service });
	          break;
	      }
	    }
	  }, {
	    key: "handleActionDisabledModalOpen",
	    value: function handleActionDisabledModalOpen(actionDisabledService, actionDisabledID) {
	      this.setState({ actionDisabledService: actionDisabledService, actionDisabledID: actionDisabledID });
	    }
	  }, {
	    key: "handleActionDisabledModalClose",
	    value: function handleActionDisabledModalClose() {
	      this.setState({ actionDisabledService: null, actionDisabledID: null });
	    }
	  }, {
	    key: "getOpenInNewWindowLink",
	    value: function getOpenInNewWindowLink(service) {
	      // This might be a serviceTree and therefore we need this check
	      // And getWebURL might therefore not be available
	      if (!this.hasWebUI(service)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "a",
	        {
	          className: "table-cell-icon table-display-on-row-hover",
	          href: service.getWebURL(),
	          target: "_blank",
	          title: "Open in a new window"
	        },
	        _react2.default.createElement(_Icon2.default, {
	          color: "neutral",
	          className: "icon-margin-left",
	          id: "open-external",
	          size: "mini"
	        })
	      );
	    }
	  }, {
	    key: "getServiceLink",
	    value: function getServiceLink(service) {
	      var id = encodeURIComponent(service.getId());
	      var isGroup = service instanceof _ServiceTree2.default;
	      var serviceLink = isGroup ? "/services/overview/" + id : "/services/detail/" + id;
	
	      if (this.props.isFiltered) {
	        return _react2.default.createElement(_NestedServiceLinks2.default, {
	          serviceID: id,
	          className: "service-breadcrumb",
	          majorLinkClassName: "service-breadcrumb-service-id",
	          minorLinkWrapperClassName: "service-breadcrumb-crumb"
	        });
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: "table-cell-link-primary text-overflow", to: serviceLink },
	        service.getName()
	      );
	    }
	  }, {
	    key: "getImage",
	    value: function getImage(service) {
	      if (service instanceof _ServiceTree2.default) {
	        // Get serviceTree image/icon
	        return _react2.default.createElement(_Icon2.default, {
	          className: "icon-margin-right",
	          color: "grey",
	          id: "folder",
	          size: "mini"
	        });
	      }
	
	      // Get service image/icon
	      return _react2.default.createElement(
	        "span",
	        { className: "icon icon-mini icon-image-container icon-app-container icon-margin-right" },
	        _react2.default.createElement("img", { src: service.getImages()["icon-small"] })
	      );
	    }
	  }, {
	    key: "hasWebUI",
	    value: function hasWebUI(service) {
	      return service instanceof _Service2.default && !(0, _ServiceUtil.isSDKService)(service) && service.getWebURL() != null && service.getWebURL() !== "";
	    }
	  }, {
	    key: "renderHeadline",
	    value: function renderHeadline(prop, service) {
	      var id = encodeURIComponent(service.getId());
	      var isGroup = service instanceof _ServiceTree2.default;
	      var serviceLink = isGroup ? "/services/overview/" + id : "/services/detail/" + id;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "service-table-heading flex-box flex-box-align-vertical-center table-cell-flex-box" },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { className: "table-cell-icon", to: serviceLink },
	          this.getImage(service)
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "table-cell-value table-cell-flex-box" },
	          this.getServiceLink(service),
	          this.getOpenInNewWindowLink(service)
	        )
	      );
	    }
	  }, {
	    key: "renderServiceActions",
	    value: function renderServiceActions(prop, service) {
	      var isGroup = service instanceof _ServiceTree2.default;
	      var isPod = service instanceof _Pod2.default;
	      var isSingleInstanceApp = service.getLabels().MARATHON_SINGLE_INSTANCE_APP;
	      var instancesCount = service.getInstancesCount();
	      var scaleTextID = isGroup ? _ServiceActionLabels2.default.scale_by : _ServiceActionLabels2.default[_ServiceActionItem.SCALE];
	      var isSDK = (0, _ServiceUtil.isSDKService)(service);
	
	      var actions = [];
	
	      actions.push({
	        className: "hidden",
	        id: _ServiceActionItem.MORE,
	        html: "",
	        selectedHtml: _react2.default.createElement(_Icon2.default, { id: "ellipsis-vertical", size: "mini" })
	      });
	
	      if (this.hasWebUI(service)) {
	        actions.push({
	          id: _ServiceActionItem.OPEN,
	          html: this.props.intl.formatMessage({ id: _ServiceActionLabels2.default.open })
	        });
	      }
	
	      if (!isGroup) {
	        actions.push({
	          id: _ServiceActionItem.EDIT,
	          html: this.props.intl.formatMessage({ id: _ServiceActionLabels2.default.edit })
	        });
	      }
	
	      // isSingleInstanceApp = Framework main scheduler
	      // instancesCount = service instances
	      if (isGroup && instancesCount > 0 || !isGroup && !isSingleInstanceApp) {
	        actions.push({
	          id: _ServiceActionItem.SCALE,
	          html: this.props.intl.formatMessage({ id: scaleTextID })
	        });
	      }
	
	      if (!isPod && !isGroup && instancesCount > 0 && !isSDK) {
	        actions.push({
	          id: _ServiceActionItem.RESTART,
	          html: this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default[_ServiceActionItem.RESTART]
	          })
	        });
	      }
	
	      if (instancesCount > 0 && !isSDK) {
	        actions.push({
	          id: _ServiceActionItem.SUSPEND,
	          html: this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default[_ServiceActionItem.SUSPEND]
	          })
	        });
	      }
	
	      if (!isGroup && instancesCount === 0 && !isSDK) {
	        actions.push({
	          id: _ServiceActionItem.RESUME,
	          html: this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default[_ServiceActionItem.RESUME]
	          })
	        });
	      }
	
	      actions.push({
	        id: _ServiceActionItem.DELETE,
	        html: _react2.default.createElement(
	          "span",
	          { className: "text-danger" },
	          this.props.intl.formatMessage({
	            id: _ServiceActionLabels2.default[_ServiceActionItem.DELETE]
	          })
	        )
	      });
	
	      return _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { content: "More actions" },
	        _react2.default.createElement(_reactjsComponents.Dropdown, {
	          anchorRight: true,
	          buttonClassName: "button button-mini button-link",
	          dropdownMenuClassName: "dropdown-menu",
	          dropdownMenuListClassName: "dropdown-menu-list",
	          dropdownMenuListItemClassName: "clickable",
	          wrapperClassName: "dropdown flush-bottom table-cell-icon",
	          items: actions,
	          persistentID: _ServiceActionItem.MORE,
	          onItemSelection: this.onActionsItemSelection.bind(this, service),
	          scrollContainer: ".gm-scroll-view",
	          scrollContainerParentSelector: ".gm-prevented",
	          title: "More actions",
	          transition: true,
	          transitionName: "dropdown-menu"
	        })
	      );
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus(prop, service) {
	      var instancesCount = service.getInstancesCount();
	      var serviceId = service.getId();
	      var serviceStatusText = service.getStatus();
	      var serviceStatusClassSet = StatusMapping[serviceStatusText] || "";
	
	      var _service$getServiceSt = service.getServiceStatus(),
	          serviceStatusKey = _service$getServiceSt.key;
	
	      var tasksSummary = service.getTasksSummary();
	      var tasksRunning = service.getRunningInstancesCount();
	      var isDeploying = serviceStatusKey === _ServiceStatusTypes2.default.WAITING || serviceStatusKey === _ServiceStatusTypes2.default.DEPLOYING;
	
	      var conciseOverview = tasksRunning === instancesCount ? " (" + tasksRunning + ")" : " (" + tasksRunning + "/" + instancesCount + ")";
	
	      var verboseOverview = tasksRunning === instancesCount ? " (" + tasksRunning + " " + _StringUtil2.default.pluralize("Instance", tasksRunning) + ")" : " (" + tasksRunning + " of " + instancesCount + " Instances)";
	
	      return _react2.default.createElement(
	        "div",
	        { className: "status-bar-wrapper" },
	        _react2.default.createElement(
	          "span",
	          { className: "status-bar-indicator" },
	          _react2.default.createElement(_HealthBar2.default, {
	            isDeploying: isDeploying,
	            key: serviceId,
	            tasksSummary: tasksSummary,
	            instancesCount: instancesCount
	          })
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "status-bar-text" },
	          _react2.default.createElement(
	            "span",
	            { className: serviceStatusClassSet },
	            serviceStatusText
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "hidden-large-down" },
	            verboseOverview
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "hidden-jumbo-up" },
	            conciseOverview
	          ),
	          _react2.default.createElement(_ServiceStatusWarning2.default, { item: service })
	        )
	      );
	    }
	  }, {
	    key: "renderStats",
	    value: function renderStats(prop, service) {
	      var resource = service.getResources()[prop];
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _Units2.default.formatResource(prop, resource)
	      );
	    }
	  }, {
	    key: "getCellClasses",
	    value: function getCellClasses(prop, sortBy, row) {
	      var isHeader = row == null;
	
	      return (0, _classnames2.default)(columnClasses[prop], {
	        active: prop === sortBy.prop,
	        clickable: isHeader
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var heading = _ResourceTableUtil2.default.renderHeading(_ServiceTableHeaderLabels2.default);
	
	      return [{
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "name",
	        render: this.renderHeadline,
	        sortable: true,
	        sortFunction: _ServiceTableUtil2.default.propCompareFunctionFactory,
	        heading: heading
	      }, {
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "status",
	        helpText: _react2.default.createElement(
	          "span",
	          null,
	          "At-a-glance overview of the global application or group state. ",
	          _react2.default.createElement(
	            "a",
	            { href: _Links2.default.statusHelpLink, target: "_blank" },
	            "Read more"
	          ),
	          "."
	        ),
	        render: this.renderStatus,
	        sortable: true,
	        sortFunction: _ServiceTableUtil2.default.propCompareFunctionFactory,
	        heading: heading
	      }, {
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "cpus",
	        render: this.renderStats,
	        sortable: true,
	        sortFunction: _ServiceTableUtil2.default.propCompareFunctionFactory,
	        heading: heading
	      }, {
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "mem",
	        render: this.renderStats,
	        sortable: true,
	        sortFunction: _ServiceTableUtil2.default.propCompareFunctionFactory,
	        heading: heading
	      }, {
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "disk",
	        render: this.renderStats,
	        sortable: true,
	        sortFunction: _ServiceTableUtil2.default.propCompareFunctionFactory,
	        heading: heading
	      }, {
	        className: this.getCellClasses,
	        headerClassName: this.getCellClasses,
	        prop: "actions",
	        render: this.renderServiceActions,
	        sortable: false,
	        heading: function heading() {
	          return null;
	        }
	      }];
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { className: columnClasses.name }),
	        _react2.default.createElement("col", { className: columnClasses.status }),
	        _react2.default.createElement("col", { className: columnClasses.cpus }),
	        _react2.default.createElement("col", { className: columnClasses.mem }),
	        _react2.default.createElement("col", { className: columnClasses.disk }),
	        _react2.default.createElement("col", { className: columnClasses.actions })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          actionDisabledService = _state.actionDisabledService,
	          actionDisabledID = _state.actionDisabledID;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactjsComponents.Table, {
	          buildRowOptions: this.getRowAttributes,
	          className: "table service-table table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          data: this.props.services.slice(),
	          itemHeight: _TableUtil2.default.getRowHeight(),
	          containerSelector: ".gm-scroll-view",
	          sortBy: { prop: "name", order: "asc" }
	        }),
	        _react2.default.createElement(_ServiceActionDisabledModal2.default, {
	          actionID: actionDisabledID,
	          open: actionDisabledService != null,
	          onClose: this.handleActionDisabledModalClose,
	          service: actionDisabledService
	        })
	      );
	    }
	  }]);
	  return ServicesTable;
	}(_react2.default.Component);
	
	ServicesTable.contextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    scaleService: _react.PropTypes.func,
	    restartService: _react.PropTypes.func,
	    resumeService: _react.PropTypes.func,
	    suspendService: _react.PropTypes.func,
	    deleteService: _react.PropTypes.func
	  }).isRequired,
	  router: _reactRouter.routerShape
	};
	
	ServicesTable.defaultProps = {
	  isFiltered: false,
	  services: []
	};
	
	ServicesTable.propTypes = {
	  isFiltered: _react.PropTypes.bool,
	  services: _react.PropTypes.array
	};
	
	module.exports = (0, _reactIntl.injectIntl)(ServicesTable);

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  statusHelpLink: _Config2.default.marathonDocsURI + "marathon-ui" + ".html#application-status-reference"
	};

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedServiceLinks = function (_React$Component) {
	  (0, _inherits3.default)(NestedServiceLinks, _React$Component);
	
	  function NestedServiceLinks() {
	    (0, _classCallCheck3.default)(this, NestedServiceLinks);
	    return (0, _possibleConstructorReturn3.default)(this, (NestedServiceLinks.__proto__ || (0, _getPrototypeOf2.default)(NestedServiceLinks)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(NestedServiceLinks, [{
	    key: "getMinorLink",
	    value: function getMinorLink(label, params, key, minorLinkClasses, minorLinkAnchorClasses) {
	      return _react2.default.createElement(
	        "div",
	        { key: key, className: "table-cell-value" },
	        _react2.default.createElement(
	          "div",
	          { className: minorLinkClasses },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: minorLinkAnchorClasses,
	              to: "/services/detail/" + params.id,
	              title: label
	            },
	            label
	          )
	        )
	      );
	    }
	  }, {
	    key: "getCrumbDivider",
	    value: function getCrumbDivider(key) {
	      return _react2.default.createElement(_Icon2.default, {
	        className: "list-inline-separator",
	        family: "tiny",
	        id: "caret-right",
	        key: key,
	        size: "tiny"
	      });
	    }
	  }, {
	    key: "getMinorLinks",
	    value: function getMinorLinks() {
	      var _this2 = this;
	
	      var componentKey = 0;
	      var _props = this.props,
	          minorLinkClassName = _props.minorLinkClassName,
	          minorLinkAnchorClassName = _props.minorLinkAnchorClassName,
	          taskID = _props.taskID;
	
	      var minorLinkClasses = (0, _dedupe2.default)("text-overflow service-link", minorLinkClassName);
	      var minorLinkAnchorClasses = (0, _dedupe2.default)("table-cell-link-secondary", minorLinkAnchorClassName);
	      var nestedGroups = this.getServicePathParts();
	      var popCount = 1;
	
	      if (taskID != null) {
	        popCount = 0;
	      }
	      nestedGroups = nestedGroups.slice(0, nestedGroups.length - popCount);
	
	      var links = nestedGroups.reduce(function (components, part, index) {
	        var id = encodeURIComponent(nestedGroups.slice(0, index + 1).join("/"));
	
	        components.push(_this2.getMinorLink(part, { id: id }, componentKey++, minorLinkClasses, minorLinkAnchorClasses));
	
	        if (index !== nestedGroups.length - 1) {
	          components.push(_this2.getCrumbDivider(componentKey++));
	        }
	
	        return components;
	      }, []);
	
	      return [this.getServicesLink(componentKey++)].concat((0, _toConsumableArray3.default)(links));
	    }
	  }, {
	    key: "getMajorLink",
	    value: function getMajorLink() {
	      var label = void 0;
	      var _props2 = this.props,
	          majorLinkAnchorClassName = _props2.majorLinkAnchorClassName,
	          serviceID = _props2.serviceID,
	          taskID = _props2.taskID;
	
	      var routePath = void 0;
	
	      var anchorClasses = (0, _dedupe2.default)("table-cell-link-primary", majorLinkAnchorClassName);
	
	      if (taskID != null) {
	        label = taskID;
	        routePath = "/services/detail/" + serviceID + "/tasks/" + taskID;
	      } else {
	        label = this.getServicePathParts().pop();
	        routePath = "/services/detail/" + encodeURIComponent(serviceID);
	      }
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { className: anchorClasses, to: routePath, title: label },
	        _react2.default.createElement(
	          "span",
	          { className: "text-overflow" },
	          label
	        )
	      );
	    }
	  }, {
	    key: "getServicesLink",
	    value: function getServicesLink(key) {
	      var minorLinkClasses = (0, _dedupe2.default)("text-overflow service-link", this.props.minorLinkClassName);
	
	      var minorLinkAnchorClasses = (0, _dedupe2.default)("table-cell-link-secondary", this.props.minorLinkAnchorClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { key: key, className: "table-cell-value" },
	        _react2.default.createElement(
	          "div",
	          { className: minorLinkClasses },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: minorLinkAnchorClasses,
	              to: "/services",
	              title: "services"
	            },
	            "Services"
	          )
	        )
	      );
	    }
	  }, {
	    key: "getServicePathParts",
	    value: function getServicePathParts() {
	      return decodeURIComponent(this.props.serviceID).split("/");
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          majorLinkClassName = _props3.majorLinkClassName,
	          minorLinkWrapperClassName = _props3.minorLinkWrapperClassName;
	
	
	      var classes = (0, _dedupe2.default)("nested-service-links", className);
	
	      var majorLinkClasses = (0, _dedupe2.default)("text-overflow", majorLinkClassName);
	
	      var minorLinkWrapperClasses = (0, _dedupe2.default)("table-cell-details-secondary flex", "flex-align-items-center table-cell-flex-box", minorLinkWrapperClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        _react2.default.createElement(
	          "div",
	          { className: majorLinkClasses },
	          this.getMajorLink()
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: minorLinkWrapperClasses },
	          this.getMinorLinks()
	        )
	      );
	    }
	  }]);
	  return NestedServiceLinks;
	}(_react2.default.Component);
	
	NestedServiceLinks.defaultProps = {
	  taskID: null
	};
	
	var classPropType = _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object, _react.PropTypes.string]);
	
	NestedServiceLinks.propTypes = {
	  serviceID: _react.PropTypes.string.isRequired,
	  taskID: _react.PropTypes.string,
	  // Classes
	  className: classPropType,
	  majorLinkAnchorClassName: classPropType,
	  majorLinkClassName: classPropType,
	  minorLinkAnchorClassName: classPropType,
	  minorLinkClassName: classPropType,
	  minorLinkWrapperClassName: classPropType
	};
	
	module.exports = NestedServiceLinks;

/***/ },
/* 1658 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceTableHeaderLabels = {
	  cpus: "CPU",
	  disk: "DISK",
	  mem: "MEM",
	  name: "NAME",
	  status: "STATUS"
	};
	
	module.exports = ServiceTableHeaderLabels;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _HealthSorting = __webpack_require__(1058);
	
	var _HealthSorting2 = _interopRequireDefault(_HealthSorting);
	
	var _ServiceTree = __webpack_require__(1240);
	
	var _ServiceTree2 = _interopRequireDefault(_ServiceTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Compare number values
	 * @param {number} a
	 * @param {number} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function numberCompareFunction(a, b) {
	  var delta = a - b;
	
	  return delta / Math.abs(delta || 1);
	}
	
	/**
	 * Compare service names
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function nameCompareFunction(a, b) {
	  return a.getName().localeCompare(b.getName());
	}
	
	/**
	 * Compare number of running tasks
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function taskCompareFunction(a, b) {
	  return numberCompareFunction(a.getTasksSummary().tasksRunning, b.getTasksSummary().tasksRunning);
	}
	
	/**
	 * Compare service health
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function healthCompareFunction(a, b) {
	  return numberCompareFunction(_HealthSorting2.default[a.getHealth().key], _HealthSorting2.default[b.getHealth().key]);
	}
	
	/**
	 * Compare service cpus
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function cpusCompareFunction(a, b) {
	  return numberCompareFunction(a.getResources().cpus, b.getResources().cpus);
	}
	
	/**
	 * Compare service memory
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function memCompareFunction(a, b) {
	  return numberCompareFunction(a.getResources().mem, b.getResources().mem);
	}
	
	/**
	 * Compare service disk
	 * @param {Service|ServiceTree} a
	 * @param {Service|ServiceTree} b
	 * @returns {number} a number indicating whether "a" comes before or after or
	 * is the same as "b" in sort order.
	 */
	function diskCompareFunction(a, b) {
	  return numberCompareFunction(a.getResources().disk, b.getResources().disk);
	}
	
	/**
	 * Get service table prop compare functions
	 * @param {string} prop
	 * @returns {function} prop compare function
	 */
	function getCompareFunctionByProp(prop) {
	  switch (prop) {
	    case "name":
	      return nameCompareFunction;
	    case "tasks":
	      return taskCompareFunction;
	    case "status":
	      return healthCompareFunction;
	    case "cpus":
	      return cpusCompareFunction;
	    case "mem":
	      return memCompareFunction;
	    case "disk":
	      return diskCompareFunction;
	    default:
	      return function () {
	        return 0;
	      };
	  }
	}
	
	var ServiceTableUtil = {
	  /**
	   * Create service table prop compare functions
	   * @param {string} prop
	   * @param {string} [direction]
	   * @returns {function} prop compare function
	   */
	  propCompareFunctionFactory: function propCompareFunctionFactory(prop, direction) {
	    var compareFunction = getCompareFunctionByProp(prop);
	    var score = 1;
	
	    if (direction === "desc") {
	      score = -1;
	    }
	
	    return function (a, b) {
	      // Hoist service trees to the top
	      if (a instanceof _ServiceTree2.default && !(b instanceof _ServiceTree2.default)) {
	        return score * -1;
	      } else if (b instanceof _ServiceTree2.default && !(a instanceof _ServiceTree2.default)) {
	        return score;
	      }
	
	      return compareFunction(a, b);
	    };
	  }
	};
	
	module.exports = ServiceTableUtil;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DSLCombinerTypes = __webpack_require__(1604);
	
	var _DSLCombinerTypes2 = _interopRequireDefault(_DSLCombinerTypes);
	
	var _DSLExpression = __webpack_require__(1598);
	
	var _DSLExpression2 = _interopRequireDefault(_DSLExpression);
	
	var _DSLExpressionPart = __webpack_require__(1646);
	
	var _DSLExpressionPart2 = _interopRequireDefault(_DSLExpressionPart);
	
	var _DSLFormWithExpressionUpdates = __webpack_require__(1647);
	
	var _DSLFormWithExpressionUpdates2 = _interopRequireDefault(_DSLFormWithExpressionUpdates);
	
	var _DSLUtil = __webpack_require__(1650);
	
	var _DSLUtil2 = _interopRequireDefault(_DSLUtil);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPRESSION_PARTS = {
	  is_running: _DSLExpressionPart2.default.attribute("is", "running"),
	  is_deploying: _DSLExpressionPart2.default.attribute("is", "deploying"),
	  is_suspended: _DSLExpressionPart2.default.attribute("is", "suspended"),
	  is_delayed: _DSLExpressionPart2.default.attribute("is", "delayed"),
	  is_waiting: _DSLExpressionPart2.default.attribute("is", "waiting")
	};
	
	var ServiceStatusDSLSection = function (_React$Component) {
	  (0, _inherits3.default)(ServiceStatusDSLSection, _React$Component);
	
	  function ServiceStatusDSLSection() {
	    (0, _classCallCheck3.default)(this, ServiceStatusDSLSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceStatusDSLSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceStatusDSLSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceStatusDSLSection, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          expression = _props.expression,
	          onChange = _props.onChange;
	
	      var enabled = _DSLUtil2.default.canProcessParts(expression, EXPRESSION_PARTS);
	      var data = _DSLUtil2.default.getPartValues(expression, EXPRESSION_PARTS);
	
	      return _react2.default.createElement(
	        _DSLFormWithExpressionUpdates2.default,
	        {
	          enabled: enabled,
	          expression: expression,
	          groupCombiner: _DSLCombinerTypes2.default.AND,
	          itemCombiner: _DSLCombinerTypes2.default.OR,
	          onChange: onChange,
	          parts: EXPRESSION_PARTS
	        },
	        _react2.default.createElement(
	          "label",
	          null,
	          "Status"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_running,
	                  disabled: !enabled,
	                  name: "is_running",
	                  type: "checkbox"
	                }),
	                "Running"
	              ),
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_deploying,
	                  disabled: !enabled,
	                  name: "is_deploying",
	                  type: "checkbox"
	                }),
	                "Deploying"
	              ),
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_suspended,
	                  disabled: !enabled,
	                  name: "is_suspended",
	                  type: "checkbox"
	                }),
	                "Suspended"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FormGroup2.default,
	              null,
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_delayed,
	                  disabled: !enabled,
	                  name: "is_delayed",
	                  type: "checkbox"
	                }),
	                "Delayed"
	              ),
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  checked: data.is_waiting,
	                  disabled: !enabled,
	                  name: "is_waiting",
	                  type: "checkbox"
	                }),
	                "Waiting"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ServiceStatusDSLSection;
	}(_react2.default.Component);
	
	ServiceStatusDSLSection.propTypes = {
	  onChange: _react.PropTypes.func.isRequired,
	  expression: _react.PropTypes.instanceOf(_DSLExpression2.default).isRequired
	};
	
	module.exports = ServiceStatusDSLSection;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _reactRouter = __webpack_require__(785);
	
	var _ParserUtil = __webpack_require__(1662);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _EventTypes = __webpack_require__(933);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _app = __webpack_require__(1672);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _DataValidatorUtil = __webpack_require__(1673);
	
	var _DataValidatorUtil2 = _interopRequireDefault(_DataValidatorUtil);
	
	var _FullScreenModal = __webpack_require__(1676);
	
	var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);
	
	var _FullScreenModalHeader = __webpack_require__(1677);
	
	var _FullScreenModalHeader2 = _interopRequireDefault(_FullScreenModalHeader);
	
	var _FullScreenModalHeaderActions = __webpack_require__(1678);
	
	var _FullScreenModalHeaderActions2 = _interopRequireDefault(_FullScreenModalHeaderActions);
	
	var _FullScreenModalHeaderTitle = __webpack_require__(1679);
	
	var _FullScreenModalHeaderTitle2 = _interopRequireDefault(_FullScreenModalHeaderTitle);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _pod = __webpack_require__(1680);
	
	var _pod2 = _interopRequireDefault(_pod);
	
	var _ToggleButton = __webpack_require__(1472);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _Application = __webpack_require__(1070);
	
	var _Application2 = _interopRequireDefault(_Application);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	var _MarathonStore = __webpack_require__(1221);
	
	var _MarathonStore2 = _interopRequireDefault(_MarathonStore);
	
	var _EventTypes2 = __webpack_require__(1103);
	
	var _DefaultApp = __webpack_require__(1681);
	
	var _DefaultPod = __webpack_require__(1683);
	
	var _ContainerServiceFormSection = __webpack_require__(1684);
	
	var _ContainerServiceFormSection2 = _interopRequireDefault(_ContainerServiceFormSection);
	
	var _CreateServiceJsonOnly = __webpack_require__(1702);
	
	var _CreateServiceJsonOnly2 = _interopRequireDefault(_CreateServiceJsonOnly);
	
	var _EnvironmentFormSection = __webpack_require__(1707);
	
	var _EnvironmentFormSection2 = _interopRequireDefault(_EnvironmentFormSection);
	
	var _MarathonAppValidators = __webpack_require__(1713);
	
	var _MarathonAppValidators2 = _interopRequireDefault(_MarathonAppValidators);
	
	var _MarathonErrorUtil = __webpack_require__(1634);
	
	var _MarathonErrorUtil2 = _interopRequireDefault(_MarathonErrorUtil);
	
	var _CreateServiceModalServicePicker = __webpack_require__(1716);
	
	var _CreateServiceModalServicePicker2 = _interopRequireDefault(_CreateServiceModalServicePicker);
	
	var _CreateServiceModalForm = __webpack_require__(1722);
	
	var _CreateServiceModalForm2 = _interopRequireDefault(_CreateServiceModalForm);
	
	var _ServiceConfigDisplay = __webpack_require__(1768);
	
	var _ServiceConfigDisplay2 = _interopRequireDefault(_ServiceConfigDisplay);
	
	var _GeneralServiceFormSection = __webpack_require__(1739);
	
	var _GeneralServiceFormSection2 = _interopRequireDefault(_GeneralServiceFormSection);
	
	var _HealthChecksFormSection = __webpack_require__(1746);
	
	var _HealthChecksFormSection2 = _interopRequireDefault(_HealthChecksFormSection);
	
	var _JSONSingleContainerReducers = __webpack_require__(1794);
	
	var _JSONSingleContainerReducers2 = _interopRequireDefault(_JSONSingleContainerReducers);
	
	var _JSONMultiContainerParser = __webpack_require__(1806);
	
	var _JSONMultiContainerParser2 = _interopRequireDefault(_JSONMultiContainerParser);
	
	var _JSONMultiContainerReducers = __webpack_require__(1817);
	
	var _JSONMultiContainerReducers2 = _interopRequireDefault(_JSONMultiContainerReducers);
	
	var _JSONSingleContainerParser = __webpack_require__(1818);
	
	var _JSONSingleContainerParser2 = _interopRequireDefault(_JSONSingleContainerParser);
	
	var _MultiContainerNetworkingFormSection = __webpack_require__(1750);
	
	var _MultiContainerNetworkingFormSection2 = _interopRequireDefault(_MultiContainerNetworkingFormSection);
	
	var _MultiContainerVolumesFormSection = __webpack_require__(1754);
	
	var _MultiContainerVolumesFormSection2 = _interopRequireDefault(_MultiContainerVolumesFormSection);
	
	var _NetworkingFormSection = __webpack_require__(1758);
	
	var _NetworkingFormSection2 = _interopRequireDefault(_NetworkingFormSection);
	
	var _ServiceErrorTypes = __webpack_require__(1635);
	
	var _ServiceErrorTypes2 = _interopRequireDefault(_ServiceErrorTypes);
	
	var _VolumesFormSection = __webpack_require__(1765);
	
	var _VolumesFormSection2 = _interopRequireDefault(_VolumesFormSection);
	
	var _VipLabelsValidators = __webpack_require__(1820);
	
	var _VipLabelsValidators2 = _interopRequireDefault(_VipLabelsValidators);
	
	var _ServiceUtil = __webpack_require__(1244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleClearError", "handleClose", "handleCloseConfirmModal", "handleConfirmGoBack", "handleConvertToPod", "handleGoBack", "handleJSONToggle", "handleRouterWillLeave", "handleServiceChange", "handleServiceErrorsChange", "handleServicePropertyChange", "handleServiceReview", "handleServiceRun", "handleServiceSelection", "handleStoreChange", "handleTabChange", "onMarathonStoreServiceCreateError", "onMarathonStoreServiceCreateSuccess", "onMarathonStoreServiceEditError", "onMarathonStoreServiceEditSuccess"];
	
	var APP_VALIDATORS = [_app2.default.App, _MarathonAppValidators2.default.containsCmdArgsOrContainer, _MarathonAppValidators2.default.complyWithResidencyRules, _MarathonAppValidators2.default.mustContainImageOnDocker, _MarathonAppValidators2.default.validateConstraints, _MarathonAppValidators2.default.validateLabels, _MarathonAppValidators2.default.mustNotContainUris, _VipLabelsValidators2.default.mustContainPort];
	
	var POD_VALIDATORS = [_pod2.default.Pod, _VipLabelsValidators2.default.mustContainPort];
	
	var CreateServiceModal = function (_Component) {
	  (0, _inherits3.default)(CreateServiceModal, _Component);
	
	  function CreateServiceModal() {
	    (0, _classCallCheck3.default)(this, CreateServiceModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateServiceModal.__proto__ || (0, _getPrototypeOf2.default)(CreateServiceModal)).apply(this, arguments));
	
	    _this.state = _this.getResetState(_this.props);
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CreateServiceModal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          location = _props.location,
	          route = _props.route;
	      var service = this.state.service;
	      var router = this.context.router;
	      // Add store change listeners the traditional way as React Router is
	      // not able to pass down correct props if we are using StoreMixin
	
	      _MarathonStore2.default.addChangeListener(_EventTypes2.MARATHON_SERVICE_CREATE_ERROR, this.onMarathonStoreServiceCreateError);
	      _MarathonStore2.default.addChangeListener(_EventTypes2.MARATHON_SERVICE_CREATE_SUCCESS, this.onMarathonStoreServiceCreateSuccess);
	      _MarathonStore2.default.addChangeListener(_EventTypes2.MARATHON_SERVICE_EDIT_ERROR, this.onMarathonStoreServiceEditError);
	      _MarathonStore2.default.addChangeListener(_EventTypes2.MARATHON_SERVICE_EDIT_SUCCESS, this.onMarathonStoreServiceEditSuccess);
	
	      this.unregisterLeaveHook = router.setRouteLeaveHook(route, this.handleRouterWillLeave);
	
	      // Only add change listener if we didn't receive our service in first try
	      if (!service && this.isLocationEdit(location)) {
	        _DCOSStore2.default.addChangeListener(_EventTypes.DCOS_CHANGE, this.handleStoreChange);
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          location = _props2.location,
	          params = _props2.params;
	      // Skip update if there was no change to props
	
	      if (nextProps.location.pathname === location.pathname && (0, _deepEqual2.default)(nextProps.params, params)) {
	        return;
	      }
	
	      this.setState(this.getResetState(nextProps));
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps, nextState) {
	      var requestCompleted = this.state.isPending && !nextState.isPending;
	      var shouldClose = requestCompleted && !nextState.apiErrors.length;
	
	      if (shouldClose) {
	        var serviceID = nextProps.params.id || "";
	
	        var path = nextProps.route.path;
	
	        var routePrefix = path.startsWith("edit") ? // When edit: navigate to the detail of the service which was edited
	        "/services/detail/" : // When create: navigate to the group service was created in
	        "/services/overview/";
	        this.context.router.push(routePrefix + encodeURIComponent(serviceID));
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _MarathonStore2.default.removeChangeListener(_EventTypes2.MARATHON_SERVICE_CREATE_ERROR, this.onMarathonStoreServiceCreateError);
	      _MarathonStore2.default.removeChangeListener(_EventTypes2.MARATHON_SERVICE_CREATE_SUCCESS, this.onMarathonStoreServiceCreateSuccess);
	      _MarathonStore2.default.removeChangeListener(_EventTypes2.MARATHON_SERVICE_EDIT_ERROR, this.onMarathonStoreServiceEditError);
	      _MarathonStore2.default.removeChangeListener(_EventTypes2.MARATHON_SERVICE_EDIT_SUCCESS, this.onMarathonStoreServiceEditSuccess);
	
	      // Clean up router leave hook
	      this.unregisterLeaveHook();
	
	      // Also remove DCOS change listener, if still subscribed
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.handleStoreChange);
	    }
	  }, {
	    key: "onMarathonStoreServiceCreateError",
	    value: function onMarathonStoreServiceCreateError(errors) {
	      this.setState({
	        apiErrors: _MarathonErrorUtil2.default.parseErrors(errors),
	        isPending: false
	      });
	    }
	  }, {
	    key: "onMarathonStoreServiceCreateSuccess",
	    value: function onMarathonStoreServiceCreateSuccess() {
	      this.setState({ apiErrors: [], isPending: false });
	    }
	  }, {
	    key: "onMarathonStoreServiceEditError",
	    value: function onMarathonStoreServiceEditError(errors) {
	      this.setState({
	        apiErrors: _MarathonErrorUtil2.default.parseErrors(errors),
	        isPending: false
	      });
	    }
	  }, {
	    key: "onMarathonStoreServiceEditSuccess",
	    value: function onMarathonStoreServiceEditSuccess() {
	      this.setState({ apiErrors: [], isPending: false });
	    }
	  }, {
	    key: "shouldForceSubmit",
	    value: function shouldForceSubmit() {
	      return this.state.apiErrors.some(function (error) {
	        return error.type === _ServiceErrorTypes2.default.SERVICE_DEPLOYING;
	      });
	    }
	  }, {
	    key: "handleRouterWillLeave",
	    value: function handleRouterWillLeave() {
	      var _state = this.state,
	          isOpen = _state.isOpen,
	          hasChangesApplied = _state.hasChangesApplied,
	          serviceReviewActive = _state.serviceReviewActive;
	      // If we are not about to close the modal and not on the review screen,
	      // confirm before navigating away
	
	      if (isOpen && hasChangesApplied && !serviceReviewActive) {
	        this.handleOpenConfirm();
	
	        // Cancel route change, if it is already open
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: "handleConfirmGoBack",
	    value: function handleConfirmGoBack() {
	      var location = this.props.location;
	      var _state2 = this.state,
	          serviceFormActive = _state2.serviceFormActive,
	          serviceJsonActive = _state2.serviceJsonActive;
	
	      // Close if editing a service in the form
	
	      if (serviceFormActive && this.isLocationEdit(location)) {
	        this.handleClose();
	
	        return;
	      }
	
	      // Switch back from form to picker
	      if (serviceFormActive) {
	        this.setState({
	          isConfirmOpen: false,
	          hasChangesApplied: false,
	          servicePickerActive: true,
	          serviceFormActive: false
	        });
	
	        return;
	      }
	
	      // Switch back from JSON to picker
	      if (serviceJsonActive) {
	        this.setState({
	          isConfirmOpen: false,
	          hasChangesApplied: false,
	          servicePickerActive: true,
	          serviceJsonActive: false
	        });
	      }
	    }
	  }, {
	    key: "handleStoreChange",
	    value: function handleStoreChange() {
	      // Unsubscribe from further events
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.handleStoreChange);
	
	      var params = this.props.params;
	
	      var serviceID = decodeURIComponent(params.id || "/");
	      var service = _DCOSStore2.default.serviceTree.findItemById(serviceID);
	
	      this.setState({ service: service, serviceSpec: service.getSpec() });
	    }
	  }, {
	    key: "handleGoBack",
	    value: function handleGoBack(event) {
	      var tabViewID = event.tabViewID;
	      var _state3 = this.state,
	          hasChangesApplied = _state3.hasChangesApplied,
	          serviceFormActive = _state3.serviceFormActive,
	          servicePickerActive = _state3.servicePickerActive,
	          serviceReviewActive = _state3.serviceReviewActive;
	
	
	      if (serviceReviewActive) {
	        // Remove the 'Application is deploying' error when we havigate back
	        // since it's not related to the form
	        var apiErrors = this.state.apiErrors.filter(function (error) {
	          return error.type !== _ServiceErrorTypes2.default.SERVICE_DEPLOYING;
	        });
	
	        // Just hide review screen. Form or JSON mode will be
	        // activated automatically depending on their last state
	        this.setState({
	          activeTab: tabViewID,
	          apiErrors: apiErrors,
	          serviceReviewActive: false,
	          showAllErrors: true
	        });
	
	        return;
	      }
	
	      // Close if picker is open
	      if (servicePickerActive && !serviceFormActive) {
	        this.handleClose();
	
	        return;
	      }
	
	      // Close if editing a service in the form, but confirm before
	      // if changes has been applied to the form
	      if (serviceFormActive && hasChangesApplied) {
	        this.handleOpenConfirm();
	
	        return;
	      }
	
	      this.handleConfirmGoBack();
	    }
	  }, {
	    key: "handleTabChange",
	    value: function handleTabChange(activeTab) {
	      this.setState({ activeTab: activeTab });
	    }
	  }, {
	    key: "handleClearError",
	    value: function handleClearError() {
	      this.setState({
	        apiErrors: [],
	        showAllErrors: false
	      });
	    }
	  }, {
	    key: "handleOpenConfirm",
	    value: function handleOpenConfirm() {
	      this.setState({ isConfirmOpen: true });
	    }
	  }, {
	    key: "handleCloseConfirmModal",
	    value: function handleCloseConfirmModal() {
	      this.setState({ isConfirmOpen: false });
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      var _this2 = this;
	
	      // Start the animation of the modal by setting isOpen to false
	      this.setState({ isConfirmOpen: false, isOpen: false }, function () {
	        // Once state is set, start a timer for the length of the animation and
	        // navigate away once the animation is over.
	        setTimeout(_this2.context.router.goBack, 300);
	      });
	    }
	  }, {
	    key: "handleConvertToPod",
	    value: function handleConvertToPod() {
	      this.handleServiceSelection({ type: "pod" });
	    }
	  }, {
	    key: "handleJSONToggle",
	    value: function handleJSONToggle() {
	      this.setState({ isJSONModeActive: !this.state.isJSONModeActive });
	    }
	  }, {
	    key: "handleServiceChange",
	    value: function handleServiceChange(newService) {
	      this.setState({ serviceSpec: newService, hasChangesApplied: true });
	    }
	  }, {
	    key: "handleServiceErrorsChange",
	    value: function handleServiceErrorsChange(errors) {
	      this.setState({ serviceFormErrors: errors });
	    }
	  }, {
	    key: "handleServicePropertyChange",
	    value: function handleServicePropertyChange(path) {
	      var refPath = path.join(".");
	      var apiErrors = this.state.apiErrors;
	
	
	      apiErrors = apiErrors.filter(function (error) {
	        var errorPath = error.path.join(".");
	
	        // Remove all root errors on a simple update
	        if (errorPath === "") {
	          return false;
	        }
	
	        // Otherwise remove errors on the given path
	        return errorPath !== refPath;
	      });
	
	      this.setState({ apiErrors: apiErrors });
	    }
	  }, {
	    key: "handleServiceSelection",
	    value: function handleServiceSelection(event) {
	      var route = event.route,
	          type = event.type;
	      var params = this.props.params;
	
	      var baseID = (0, _ServiceUtil.getBaseID)(decodeURIComponent(params.id || "/"));
	
	      switch (type) {
	        case "app":
	          this.setState({
	            activeTab: null,
	            apiErrors: [],
	            serviceFormErrors: [],
	            servicePickerActive: false,
	            serviceFormActive: true,
	            serviceSpec: new _ApplicationSpec2.default((0, _assign2.default)({ id: baseID }, _DefaultApp.DEFAULT_APP_SPEC)),
	            showAllErrors: false
	          });
	          break;
	
	        case "pod":
	          this.setState({
	            activeTab: null,
	            apiErrors: [],
	            serviceFormErrors: [],
	            servicePickerActive: false,
	            serviceFormActive: true,
	            serviceSpec: new _PodSpec2.default((0, _assign2.default)({ id: baseID }, _DefaultPod.DEFAULT_POD_SPEC)),
	            showAllErrors: false
	          });
	          break;
	
	        case "json":
	          this.setState({
	            activeTab: null,
	            apiErrors: [],
	            serviceFormErrors: [],
	            servicePickerActive: false,
	            serviceJsonActive: true,
	            serviceSpec: new _ApplicationSpec2.default((0, _assign2.default)({ id: baseID }, _DefaultApp.DEFAULT_APP_SPEC)),
	            showAllErrors: false
	          });
	          break;
	
	        case "redirect":
	          this.context.router.push(route);
	          break;
	      }
	    }
	  }, {
	    key: "handleServiceReview",
	    value: function handleServiceReview() {
	      var errors = this.getFormErrors();
	      if (errors.length === 0) {
	        this.setState({
	          apiErrors: [],
	          serviceReviewActive: true
	        });
	      } else {
	        this.setState({
	          showAllErrors: true
	        });
	      }
	    }
	  }, {
	    key: "handleServiceRun",
	    value: function handleServiceRun() {
	      var location = this.props.location;
	      var _state4 = this.state,
	          service = _state4.service,
	          serviceSpec = _state4.serviceSpec;
	
	      var force = this.shouldForceSubmit();
	      if (this.isLocationEdit(location) && service instanceof _Service2.default) {
	        _MarathonActions2.default.editService(service, serviceSpec, force);
	      } else {
	        _MarathonActions2.default.createService(serviceSpec, force);
	      }
	
	      this.setState({ isPending: true });
	    }
	  }, {
	    key: "isLocationEdit",
	    value: function isLocationEdit(location) {
	      return location.pathname.includes("/edit");
	    }
	
	    /**
	     * This function combines the errors received from marathon and the errors
	     * produced by the form into a unified error array
	     *
	     * @returns {Array} - An array of error objects
	     */
	
	  }, {
	    key: "getFormErrors",
	    value: function getFormErrors() {
	      var _state5 = this.state,
	          serviceFormErrors = _state5.serviceFormErrors,
	          serviceSpec = _state5.serviceSpec;
	
	      var validationErrors = [];
	
	      var appValidators = APP_VALIDATORS.concat(_PluginSDK.Hooks.applyFilter("appValidators", []));
	
	      var podValidators = POD_VALIDATORS.concat(_PluginSDK.Hooks.applyFilter("podValidators", []));
	
	      // Validate Application or Pod according to the contents
	      // of the serviceSpec property.
	
	      if (serviceSpec instanceof _ApplicationSpec2.default) {
	        validationErrors = _DataValidatorUtil2.default.validate((0, _ServiceUtil.getServiceJSON)(serviceSpec), appValidators);
	      }
	
	      if (serviceSpec instanceof _PodSpec2.default) {
	        validationErrors = _DataValidatorUtil2.default.validate((0, _ServiceUtil.getServiceJSON)(serviceSpec), podValidators);
	      }
	
	      return validationErrors.concat(serviceFormErrors);
	    }
	
	    /**
	     * This function combines the errors received from marathon and the errors
	     * produced by the form into a unified error array
	     *
	     * @returns {Array} - An array of error objects
	     */
	
	  }, {
	    key: "getAllErrors",
	    value: function getAllErrors() {
	      return this.state.apiErrors.concat(this.getFormErrors());
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      // NOTE: Always prioritize review screen check
	      if (this.state.serviceReviewActive) {
	        return _react2.default.createElement(
	          _FullScreenModalHeader2.default,
	          null,
	          _react2.default.createElement(_FullScreenModalHeaderActions2.default, {
	            actions: this.getSecondaryActions(),
	            type: "secondary"
	          }),
	          _react2.default.createElement(
	            _FullScreenModalHeaderTitle2.default,
	            null,
	            "Review & Run Service"
	          ),
	          _react2.default.createElement(_FullScreenModalHeaderActions2.default, {
	            actions: this.getPrimaryActions(),
	            type: "primary"
	          })
	        );
	      }
	
	      var title = "Run a Service";
	      var location = this.props.location;
	      var service = this.state.service;
	
	      var serviceName = service ? "\"" + service.getName() + "\"" : "Service";
	
	      if (this.isLocationEdit(location)) {
	        title = "Edit " + serviceName;
	      }
	
	      return _react2.default.createElement(
	        _FullScreenModalHeader2.default,
	        null,
	        _react2.default.createElement(_FullScreenModalHeaderActions2.default, {
	          actions: this.getSecondaryActions(),
	          type: "secondary"
	        }),
	        _react2.default.createElement(
	          _FullScreenModalHeaderTitle2.default,
	          null,
	          title
	        ),
	        _react2.default.createElement(_FullScreenModalHeaderActions2.default, {
	          actions: this.getPrimaryActions(),
	          type: "primary"
	        })
	      );
	    }
	  }, {
	    key: "getModalContent",
	    value: function getModalContent() {
	      var _this3 = this;
	
	      var _state6 = this.state,
	          isJSONModeActive = _state6.isJSONModeActive,
	          serviceSpec = _state6.serviceSpec,
	          serviceFormActive = _state6.serviceFormActive,
	          serviceJsonActive = _state6.serviceJsonActive,
	          servicePickerActive = _state6.servicePickerActive,
	          serviceReviewActive = _state6.serviceReviewActive;
	
	      // NOTE: Always prioritize review screen check
	
	      if (serviceReviewActive) {
	        return _react2.default.createElement(
	          "div",
	          { className: "flex-item-grow-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "container container-wide" },
	            _react2.default.createElement(_ServiceConfigDisplay2.default, {
	              onEditClick: this.handleGoBack,
	              appConfig: serviceSpec,
	              errors: this.getAllErrors()
	            })
	          )
	        );
	      }
	
	      if (servicePickerActive) {
	        return _react2.default.createElement(_CreateServiceModalServicePicker2.default, {
	          onServiceSelect: this.handleServiceSelection
	        });
	      }
	
	      if (serviceFormActive) {
	        var location = this.props.location;
	        var showAllErrors = this.state.showAllErrors;
	
	
	        var SINGLE_CONTAINER_SECTIONS = [_ContainerServiceFormSection2.default, _EnvironmentFormSection2.default, _GeneralServiceFormSection2.default, _HealthChecksFormSection2.default, _NetworkingFormSection2.default, _VolumesFormSection2.default];
	
	        var MULTI_CONTAINER_SECTIONS = [_ContainerServiceFormSection2.default, _EnvironmentFormSection2.default, _GeneralServiceFormSection2.default, _HealthChecksFormSection2.default, _NetworkingFormSection2.default, _VolumesFormSection2.default, _MultiContainerVolumesFormSection2.default, _MultiContainerNetworkingFormSection2.default];
	
	        var jsonParserReducers = void 0;
	        var jsonConfigReducers = void 0;
	        var inputConfigReducers = void 0;
	
	        if (serviceSpec instanceof _PodSpec2.default) {
	          jsonParserReducers = (0, _ParserUtil.combineParsers)(_PluginSDK.Hooks.applyFilter("multiContainerCreateJsonParserReducers", _JSONMultiContainerParser2.default));
	
	          jsonConfigReducers = (0, _ReducerUtil.combineReducers)(_PluginSDK.Hooks.applyFilter("multiContainerJsonConfigReducers", _JSONMultiContainerReducers2.default));
	
	          inputConfigReducers = (0, _ReducerUtil.combineReducers)(_PluginSDK.Hooks.applyFilter("multiContainerInputConfigReducers", _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(MULTI_CONTAINER_SECTIONS.map(function (item) {
	            return item.configReducers;
	          }))))));
	        } else {
	          jsonParserReducers = (0, _ParserUtil.combineParsers)(_PluginSDK.Hooks.applyFilter("serviceCreateJsonParserReducers", _JSONSingleContainerParser2.default));
	
	          jsonConfigReducers = (0, _ReducerUtil.combineReducers)(_PluginSDK.Hooks.applyFilter("serviceJsonConfigReducers", _JSONSingleContainerReducers2.default));
	
	          inputConfigReducers = (0, _ReducerUtil.combineReducers)(_PluginSDK.Hooks.applyFilter("serviceInputConfigReducers", _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(SINGLE_CONTAINER_SECTIONS.map(function (item) {
	            return item.configReducers;
	          }))))));
	        }
	
	        return _react2.default.createElement(_CreateServiceModalForm2.default, {
	          activeTab: this.state.activeTab,
	          errors: this.getAllErrors(),
	          jsonParserReducers: jsonParserReducers,
	          jsonConfigReducers: jsonConfigReducers,
	          handleTabChange: this.handleTabChange,
	          inputConfigReducers: inputConfigReducers,
	          isEdit: this.isLocationEdit(location),
	          isJSONModeActive: isJSONModeActive,
	          ref: function ref(_ref) {
	            return _this3.createComponent = _ref;
	          },
	          onChange: this.handleServiceChange,
	          onConvertToPod: this.handleConvertToPod,
	          onErrorsChange: this.handleServiceErrorsChange,
	          service: serviceSpec,
	          showAllErrors: showAllErrors
	        });
	      }
	
	      if (serviceJsonActive) {
	        // TODO (DCOS-13561): serviceSpec should be service
	
	        return _react2.default.createElement(_CreateServiceJsonOnly2.default, {
	          errors: this.getAllErrors(),
	          onChange: this.handleServiceChange,
	          onErrorsChange: this.handleServiceErrorsChange,
	          onPropertyChange: this.handleServicePropertyChange,
	          ref: function ref(_ref2) {
	            return _this3.createComponent = _ref2;
	          },
	          service: serviceSpec
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "getPrimaryActions",
	    value: function getPrimaryActions() {
	      var _state7 = this.state,
	          serviceFormActive = _state7.serviceFormActive,
	          serviceJsonActive = _state7.serviceJsonActive,
	          servicePickerActive = _state7.servicePickerActive,
	          serviceReviewActive = _state7.serviceReviewActive;
	
	
	      var force = this.shouldForceSubmit();
	      var runButtonLabel = force ? "Force Run Service" : "Run Service";
	      var runButtonClassNames = (0, _classnames2.default)("flush-vertical", {
	        "button-primary": !force,
	        "button-danger": force
	      });
	
	      // NOTE: Always prioritize review screen check
	      if (serviceReviewActive) {
	        return [{
	          className: runButtonClassNames,
	          clickHandler: this.handleServiceRun,
	          label: runButtonLabel
	        }];
	      }
	
	      if (servicePickerActive) {
	        return null;
	      }
	
	      if (serviceFormActive) {
	        return [{
	          node: _react2.default.createElement(
	            _ToggleButton2.default,
	            {
	              className: "flush",
	              checkboxClassName: "toggle-button toggle-button-align-left",
	              checked: this.state.isJSONModeActive,
	              onChange: this.handleJSONToggle,
	              key: "json-editor"
	            },
	            "JSON Editor"
	          )
	        }, {
	          className: "button-primary flush-vertical",
	          clickHandler: this.handleServiceReview,
	          label: "Review & Run"
	        }];
	      }
	
	      if (serviceJsonActive) {
	        return [{
	          className: "button-primary flush-vertical",
	          clickHandler: this.handleServiceReview,
	          label: "Review & Run"
	        }];
	      }
	
	      return [];
	    }
	  }, {
	    key: "getResetState",
	    value: function getResetState() {
	      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var location = nextProps.location,
	          params = nextProps.params;
	
	      var isEdit = this.isLocationEdit(location);
	      var serviceID = decodeURIComponent(params.id || "/");
	      var service = isEdit ? _DCOSStore2.default.serviceTree.findItemById(serviceID) : null;
	      var isSpecificVersion = service instanceof _Application2.default && params.version;
	      var serviceSpec = new _ApplicationSpec2.default((0, _assign2.default)({ id: (0, _ServiceUtil.getBaseID)(serviceID) }, _DefaultApp.DEFAULT_APP_SPEC));
	
	      if (isEdit && service instanceof _Service2.default && !isSpecificVersion) {
	        serviceSpec = service.getSpec();
	      }
	
	      if (isEdit && isSpecificVersion) {
	        serviceSpec = service.constructor(service.getVersions().get(params.version)).getSpec();
	      }
	
	      var newState = {
	        activeTab: null,
	        apiErrors: [],
	        hasChangesApplied: false,
	        isConfirmOpen: false,
	        isJSONModeActive: false,
	        isOpen: true,
	        isPending: false,
	        service: service,
	        serviceSpec: serviceSpec,
	        serviceFormActive: isEdit, // Switch directly to form/json if edit
	        serviceFormErrors: [],
	        serviceJsonActive: false,
	        servicePickerActive: !isEdit, // Switch directly to form/json if edit
	        serviceReviewActive: false,
	        serviceFormHasErrors: false,
	        showAllErrors: false
	      };
	
	      return newState;
	    }
	  }, {
	    key: "getSecondaryActions",
	    value: function getSecondaryActions() {
	      var location = this.props.location;
	      var _state8 = this.state,
	          servicePickerActive = _state8.servicePickerActive,
	          serviceReviewActive = _state8.serviceReviewActive;
	
	      var label = "Back";
	
	      if (servicePickerActive || this.isLocationEdit(location) && !serviceReviewActive) {
	        label = "Cancel";
	      }
	
	      return [{
	        className: "button-stroke",
	        clickHandler: this.handleGoBack,
	        label: label
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var _state9 = this.state,
	          hasChangesApplied = _state9.hasChangesApplied,
	          isOpen = _state9.isOpen,
	          servicePickerActive = _state9.servicePickerActive,
	          serviceReviewActive = _state9.serviceReviewActive;
	
	      var useGemini = false;
	      if (servicePickerActive || serviceReviewActive) {
	        useGemini = true;
	      }
	
	      var closeAction = this.handleClose;
	      if (hasChangesApplied) {
	        closeAction = this.handleOpenConfirm;
	      }
	
	      return _react2.default.createElement(
	        _FullScreenModal2.default,
	        (0, _extends3.default)({
	          header: this.getHeader(),
	          onClose: closeAction,
	          useGemini: useGemini,
	          open: isOpen
	        }, _Util2.default.omit(props, (0, _keys2.default)(CreateServiceModal.propTypes))),
	        this.getModalContent(),
	        _react2.default.createElement(
	          _reactjsComponents.Confirm,
	          {
	            closeByBackdropClick: true,
	            header: _react2.default.createElement(
	              _ModalHeading2.default,
	              null,
	              "Discard Changes?"
	            ),
	            open: this.state.isConfirmOpen,
	            onClose: this.handleCloseConfirmModal,
	            leftButtonText: "Cancel",
	            leftButtonCallback: this.handleCloseConfirmModal,
	            rightButtonText: "Discard",
	            rightButtonClassName: "button button-danger",
	            rightButtonCallback: this.handleConfirmGoBack,
	            showHeader: true
	          },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Are you sure you want to leave this page? Any data you entered will be lost."
	          )
	        )
	      );
	    }
	  }]);
	  return CreateServiceModal;
	}(_react.Component);
	
	CreateServiceModal.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	CreateServiceModal.propTypes = {
	  params: _react.PropTypes.object.isRequired,
	  location: _react.PropTypes.object.isRequired
	};
	
	module.exports = CreateServiceModal;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _Util = __webpack_require__(982);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  combineParsers: function combineParsers() {
	    var parsers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    parsers = parsers.filter(function (parser) {
	      return typeof parser === "function";
	    }).reverse();
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var index = parsers.length;
	
	      var transactionLog = [];
	
	      while (--index >= 0) {
	        var parser = parsers[index];
	
	        var transaction = parser(state);
	
	        if (transaction instanceof Array) {
	          transactionLog.push.apply(transactionLog, (0, _toConsumableArray3.default)(transaction));
	        } else {
	          transactionLog.push(transaction);
	        }
	      }
	
	      return transactionLog;
	    };
	  },
	  simpleParser: function simpleParser(path) {
	    var searchPath = path.join(".");
	
	    return function (state) {
	      var value = (0, _Util.findNestedPropertyInObject)(state, searchPath);
	
	      if (value == null) {
	        return [];
	      }
	
	      return new _Transaction2.default(path, value);
	    };
	  }
	};

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperties = __webpack_require__(1599);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _TransactionTypes2 = _interopRequireDefault(_TransactionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validTypes = (0, _values2.default)(_TransactionTypes2.default);
	var validKeys = (0, _keys2.default)(_TransactionTypes2.default);
	
	var Transaction = function Transaction(path, value) {
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _TransactionTypes2.default.SET;
	  (0, _classCallCheck3.default)(this, Transaction);
	
	  if (!validTypes.includes(type)) {
	    throw new TypeError("Only the following types are allowed: " + validKeys);
	  }
	  (0, _defineProperties2.default)(this, {
	    path: {
	      value: path,
	      writable: false,
	      enumerable: true
	    },
	    value: {
	      value: value,
	      writable: false,
	      enumerable: true
	    },
	    type: {
	      value: type,
	      writable: false,
	      enumerable: true
	    }
	  });
	};
	
	module.exports = Transaction;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _symbol = __webpack_require__(940);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  ADD_ITEM: (0, _symbol2.default)("ADD_ITEM"),
	  REMOVE_ITEM: (0, _symbol2.default)("REMOVE_ITEM"),
	  SET: (0, _symbol2.default)("SET"),
	  DEL: (0, _symbol2.default)("DEL")
	};

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _weakMap = __webpack_require__(1666);
	
	var _weakMap2 = _interopRequireDefault(_weakMap);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _TransactionTypes2 = _interopRequireDefault(_TransactionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  /**
	   * This function is heavily inspired by the combineReducer function from
	   * redux. https://github.com/reactjs/redux/blob/master/src/combineReducers.js
	   *
	   * It does await a structured object with a key: value combination where
	   * the value is a function that awaits a state and an action. Which is the
	   * same format as the usual reducer function does have. The function
	   * returns a single reducer function which calls all the functions and
	   * returns a object with the key values corresponding to the input.
	   *
	   * We removed all unnecessary checks which are used in the store use case.
	   * And boiled it
	   * down to only the bare minimum in code.
	   *
	   * We also added the feature that each reducer does have it's own context.
	   * which gets reset if the passed index is 0.
	   *
	   * @param {Object} reducers An object whose values correspond to different
	   * reducer functions that need to be combined into one.
	   *
	   * @returns {Function} A reducer function that invokes every reducer inside
	   *   the passed object, and builds a state object with the same shape.
	   */
	  combineReducers: function combineReducers() {
	    var reducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var reducerKeys = (0, _keys2.default)(reducers).filter(function (reducerKey) {
	      return typeof reducers[reducerKey] === "function";
	    });
	    // This is creating the context for this combined reducer.
	    var context = new _weakMap2.default();
	
	    return function (state, action) {
	      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      var reducerIndex = reducerKeys.length;
	      var localState = (0, _assign2.default)({}, state);
	
	      // As the while is faster then the Array.prototype.forEach and this
	      // function can potentially be called more often we choose while here.
	      while (--reducerIndex >= 0) {
	        var key = reducerKeys[reducerIndex];
	
	        var reducer = reducers[key];
	
	        if (index === 0 || reducer && !context.has(reducer)) {
	          context.set(reducer, {});
	        }
	
	        // This will call the reducer function with a context, and passes
	        // the current state of the field plus the action against a reducer
	        // function.
	        // This will result in the same as
	        // reducer.bind(context.get(reducer))(state[key], action);
	        // but it will not copy the function, which in this case is a huge
	        // increase in performance.
	        localState[key] = reducer.call(context.get(reducer), localState[key], action, index);
	      }
	
	      return localState;
	    };
	  },
	
	
	  /**
	   * Parse only integer values and passes-through any other types
	   *
	   * @param {any} value - The source value
	   * @returns {Number|any} - Returns a numerical value or the value itself
	   */
	  parseIntValue: function parseIntValue(value) {
	    var parsedValue = parseInt(value, 10);
	    if (!isNaN(parsedValue)) {
	      return parsedValue;
	    }
	
	    return value;
	  },
	  simpleReducer: function simpleReducer(needle) {
	    var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	      var _ref = arguments[1];
	      var path = _ref.path,
	          type = _ref.type,
	          value = _ref.value;
	
	      if (type === _TransactionTypes2.default.SET && path.join(".") === needle) {
	        return value;
	      }
	
	      return state;
	    };
	  },
	  simpleIntReducer: function simpleIntReducer(needle) {
	    var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	      var _ref2 = arguments[1];
	      var path = _ref2.path,
	          type = _ref2.type,
	          value = _ref2.value;
	
	      var parsedValue = parseInt(value, 10);
	      if (type === _TransactionTypes2.default.SET && path.join(".") === needle) {
	        if (!isNaN(parsedValue)) {
	          return parsedValue;
	        }
	
	        return value;
	      }
	
	      return state;
	    };
	  },
	  simpleFloatReducer: function simpleFloatReducer(needle) {
	    var defaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	      var _ref3 = arguments[1];
	      var path = _ref3.path,
	          type = _ref3.type,
	          value = _ref3.value;
	
	      var parsedValue = parseFloat(value);
	      if (type === _TransactionTypes2.default.SET && path.join(".") === needle) {
	        if (!isNaN(parsedValue)) {
	          return parsedValue;
	        }
	
	        return value;
	      }
	
	      return state;
	    };
	  }
	};

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1667), __esModule: true };

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(882);
	__webpack_require__(899);
	__webpack_require__(1668);
	module.exports = __webpack_require__(870).WeakMap;

/***/ },
/* 1668 */
[2103, 874, 888, 1669, 906, 892, 1075],
/* 1669 */
[2104, 889, 922, 907, 906, 908, 909, 1670, 892, 898],
/* 1670 */
[2061, 871, 877, 875, 912, 1671],
/* 1671 */
[2062, 906, 946, 896],
/* 1672 */
/***/ function(module, exports) {

	module.exports = (function() {
	
	const REPLACE_MESSAGE_TEMPLATE = /\{\{([^\}]+)\}\}/g;
	
	function RAMLError(path, context, type, _messageVariables) {
	  var messageVariables = _messageVariables || {};
	  var message = context.ERROR_MESSAGES[type];
	  Object.defineProperties(this, {
	    message: {
	      enumerable: true,
	      get: function() {
	        if (typeof message === 'function') {
	          return message(messageVariables, path);
	        }
	
	        return message.replace(REPLACE_MESSAGE_TEMPLATE, function(match) {
	          return ''+messageVariables[match.slice(2,-2)] || '';
	        });
	      }
	    },
	    path: {
	      enumerable: true,
	      value: path
	    },
	    type: {
	      enumerable: true,
	      value: type
	    },
	    variables: {
	      enumerable: true,
	      value: messageVariables
	    }
	  });
	}
	
	var DEFAULT_ERROR_MESSAGES = {
	  "PROP_IS_MISSING": "Must be defined",
	  "TYPE_NOT_OBJECT": "Must be an object",
	  "NUMBER_TYPE": "Must be of type `{{type}}`",
	  "NUMBER_MIN": "Must be bigger than or equal to {{value}}",
	  "TYPE_NOT_INTEGER": "Must be an integer number",
	  "ENUM": "Must be one of {{values}}",
	  "TYPE_NOT_STRING": "Must be a string",
	  "NUMBER_MAX": "Must be smaller than or equal to {{value}}",
	  "TYPE_NOT_NUMBER": "Must be a number",
	  "STRING_PATTERN": "Must match the pattern `{{pattern}}`",
	  "LENGTH_MIN": "Must be at least {{value}} characters long",
	  "ITEMS_UNIQUE": "Must contain only unique items",
	  "TYPE_NOT_ARRAY": "Must be an array",
	  "TYPE_NOT_BOOLEAN": "Must be a boolean value",
	  "TYPE_NOT_DATETIME": "Must be a date/time string",
	  "ITEMS_MIN": "Must contain at least {{value}} items in the array",
	  "ITEMS_MAX": "Must contain at most {{value}} items in the array",
	  "LENGTH_MAX": "Must be at most {{value}} characters long"
	}
	
	var DEFAULT_CONTEXT = {
		HELPERS: [
			new Float32Array(1),
		],
		ENUMS: [
			["wait_forever","relaunch_after_timeout"],
			["youngest_first","oldest_first"],
			["mesos","docker"],
			["disabled"],
			["bridge","host","none","user"],
			["http","https","tcp","command","mesos_tcp","mesos_http","mesos_https"],
			["container","container/bridge","host"],
			["tcp","udp","udp,tcp"],
			["http","https"],
			["ro","rw"],
			["root","path","mount"],
		],
		REGEX: [
			new RegExp('^(\/?((\.\.)|(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9]))?($|\/))+$'),
			new RegExp('^.*$'),
			new RegExp('^(//cmd)|(/?[^/]+(/[^/]+)*)|$'),
			new RegExp('.*'),
			new RegExp('^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$'),
			new RegExp('^[a-z0-9]([-a-z0-9]*[a-z0-9])?$'),
		],
	}
	
	var RAMLValidator = function(config) {
		if (!config) config = {};
		var context = Object.assign({}, DEFAULT_CONTEXT);
		
		// Override errorMessages through config
		context.ERROR_MESSAGES = Object.assign(
			{},
			DEFAULT_ERROR_MESSAGES,
			config.errorMessages
		)
		
		var PrivateValidators = {
			/**
			 * 3600
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int64
			 * - minimum: 0
			 */
			inlineIntegerType_b6d3b04861cdc2c21823de4e53983492: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int64"}));
					}
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * "WAIT_FOREVER"
			 * 
			 * This is an in-line specialization of TaskLostBehavior
			 * with the following constraints:
			 * 
			 * - enum: WAIT_FOREVER,RELAUNCH_AFTER_TIMEOUT
			 */
			inlineTaskLostBehavior_42f02b6c8ad50000c5ecfb3dfd33f3ac: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[0].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"wait_forever, relaunch_after_timeout"}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - format: double
			 * - minimum: 0
			 * - maximum: 1
			 */
			inlineNumberType_ad71b34619243f232a05ae91f25d0513: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
					if (value > 1) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "public-facing"
			 * ]
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - items: StringType
			 * - uniqueItems: true
			 */
			inlineStringType_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.StringType(value, path.concat([i]))
						);
					}, errors);
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - items: StringType
			 */
			inlineStringType_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.StringType(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * 1.15
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - format: double
			 * - minimum: 1
			 */
			inlineNumberType_c481ed52acea3ffa91ed57e7407ff87f: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 1) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int32
			 * - minimum: 0
			 */
			inlineIntegerType_1da39b1015745f6788e8467b4b016d08: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - minLength: 1
			 */
			inlineStringType_8cef7a2a976678a19a8d836c3a53c236: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   [
			 *     "hostname",
			 *     "UNIQUE"
			 *   ]
			 * ]
			 * 
			 * This is an in-line specialization of AppConstraint
			 * with the following constraints:
			 * 
			 * - items: AppConstraint
			 * - uniqueItems: true
			 */
			inlineAppConstraint_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.AppConstraint(value, path.concat([i]))
						);
					}, errors);
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - format: double
			 * - minimum: 0.001
			 */
			inlineNumberType_5471becca47d41cedb309da969544f87: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0.001) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0.001}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "/ops/audit"
			 * ]
			 * 
			 * This is an in-line specialization of PathId
			 * with the following constraints:
			 * 
			 * - items: PathId
			 * - uniqueItems: true
			 */
			inlinePathId_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.PathId(value, path.concat([i]))
						);
					}, errors);
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
				}
				return errors;
			},
		
			/**
			 * 0
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - format: double
			 * - minimum: 0
			 */
			inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * ""
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - pattern: ^(//cmd)|(/?[^/]+(/[^/]+)*)|$
			 */
			inlineStringType_d0e7c79ff122579a63d440783fa354cf: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[2].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^(//cmd)|(/?[^/]+(/[^/]+)*)|$"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "uri": "http://download.me/file.tgz",
			 *     "extract": true,
			 *     "executable": true,
			 *     "cache": false
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Artifact
			 * with the following constraints:
			 * 
			 * - items: Artifact
			 */
			inlineArtifact_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Artifact(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "command": {
			 *       "value": "some value"
			 *     },
			 *     "gracePeriodSeconds": 300,
			 *     "ignoreHttp1xx": true,
			 *     "intervalSeconds": 60,
			 *     "maxConsecutiveFailures": 3,
			 *     "path": "/path/to/health",
			 *     "port": 1,
			 *     "portIndex": 1,
			 *     "protocol": "HTTP",
			 *     "timeoutSeconds": 20,
			 *     "delaySeconds": 15
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of AppHealthCheck
			 * with the following constraints:
			 * 
			 * - uniqueItems: true
			 * - items: AppHealthCheck
			 */
			inlineAppHealthCheck_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.AppHealthCheck(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "mode": "container",
			 *     "labels": {}
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Network
			 * with the following constraints:
			 * 
			 * - items: Network
			 */
			inlineNetwork_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Network(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   0
			 * ]
			 * 
			 * This is an in-line specialization of AnyPort
			 * with the following constraints:
			 * 
			 * - items: AnyPort
			 */
			inlineAnyPort_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.AnyPort(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "port": 0,
			 *     "labels": {},
			 *     "name": "some value",
			 *     "protocol": "tcp"
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of PortDefinition
			 * with the following constraints:
			 * 
			 * - items: PortDefinition
			 */
			inlinePortDefinition_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.PortDefinition(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "readinessCheck",
			 *     "protocol": "HTTP",
			 *     "path": "/path/to/health.",
			 *     "portName": "http-api",
			 *     "intervalSeconds": 30,
			 *     "timeoutSeconds": 10,
			 *     "httpStatusCodesForReady": [
			 *       1
			 *     ],
			 *     "preserveLastResponse": false
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of ReadinessCheck
			 * with the following constraints:
			 * 
			 * - items: ReadinessCheck
			 */
			inlineReadinessCheck_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.ReadinessCheck(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * false
			 * 
			 * This is an in-line specialization of BooleanType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if ((value !== false) && (value !== true)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_BOOLEAN"));
				} else {
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 * 
			 * This is an in-line specialization of Uri
			 * with the following constraints:
			 * 
			 * - items: Uri
			 */
			inlineUri_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Uri(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineStringType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of DateTimeType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(new Date(value).getTime())) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_DATETIME"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "YOUNGEST_FIRST"
			 * 
			 * This is an in-line specialization of KillSelection
			 * with the following constraints:
			 * 
			 * - enum: YOUNGEST_FIRST,OLDEST_FIRST
			 */
			inlineKillSelection_af9950cc31a21fe24612f6bbfd35c849: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[1].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"youngest_first, oldest_first"}));
					}
				}
				return errors;
			},
		
			/**
			 * "DOCKER"
			 * 
			 * This is an in-line specialization of EngineType
			 * with the following constraints:
			 * 
			 * - enum: MESOS,DOCKER
			 */
			inlineEngineType_ac83465795b5f6d40807390b3f6c8ef5: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[2].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"mesos, docker"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "containerPath": "some value",
			 *     "persistent": {
			 *       "type": "some value",
			 *       "size": 1,
			 *       "maxSize": 1,
			 *       "constraints": [
			 *         [
			 *           "some value"
			 *         ]
			 *       ]
			 *     },
			 *     "mode": "some value"
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of AppVolume
			 * with the following constraints:
			 * 
			 * - items: AppVolume
			 */
			inlineAppVolume_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.AppVolume(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "containerPort": 0,
			 *     "hostPort": 1,
			 *     "labels": {},
			 *     "name": "some value",
			 *     "protocol": "tcp",
			 *     "servicePort": 0,
			 *     "networkNames": [
			 *       "some value"
			 *     ]
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of ContainerPortMapping
			 * with the following constraints:
			 * 
			 * - items: ContainerPortMapping
			 */
			inlineContainerPortMapping_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.ContainerPortMapping(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of DockerNetwork
			 * with the following constraints:
			 * 
			 * - enum: BRIDGE,HOST,NONE,USER
			 */
			inlineDockerNetwork_97392176b9645001a877ed1e9b844cc9: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[4].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"bridge, host, none, user"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "key": "some value",
			 *     "value": "some value"
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of DockerParameter
			 * with the following constraints:
			 * 
			 * - items: DockerParameter
			 */
			inlineDockerParameter_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.DockerParameter(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - minLength: 7
			 */
			inlineStringType_1c6abad92bbd0cfb11e1370a9fb70951: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 7) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":7}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of AnyPort
			 * with the following constraints:
			 * 
			 * - minimum: 0
			 * - maximum: 65535
			 * - format: int32
			 */
			inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
					if (value > 65535) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":65535}));
					}
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
				}
				return errors;
			},
		
			/**
			 * "HTTP"
			 * 
			 * This is an in-line specialization of AppHealthCheckProtocol
			 * with the following constraints:
			 * 
			 * - enum: HTTP,HTTPS,TCP,COMMAND,MESOS_TCP,MESOS_HTTP,MESOS_HTTPS
			 */
			inlineAppHealthCheckProtocol_d48bd5285cf380c9f3754324fc7feed2: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[5].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"http, https, tcp, command, mesos_tcp, mesos_http, mesos_https"}));
					}
				}
				return errors;
			},
		
			/**
			 * 20
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int32
			 */
			inlineIntegerType_d5ab06b03ff21f3a6085461bfd6e5065: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "number": 0,
			 *     "name": "some value",
			 *     "protocol": "tcp",
			 *     "labels": {}
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of IpDiscoveryPort
			 * with the following constraints:
			 * 
			 * - items: IpDiscoveryPort
			 */
			inlineIpDiscoveryPort_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.IpDiscoveryPort(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of NetworkName
			 * with the following constraints:
			 * 
			 * - pattern: ^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$
			 * - maxLength: 63
			 * - minLength: 1
			 */
			inlineNetworkName_d5930fd0fc0461b8008a443d59699e32: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[4].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$"}));
					}
					if (value.length > 63) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":63}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * "container"
			 * 
			 * This is an in-line specialization of NetworkMode
			 * with the following constraints:
			 * 
			 * - enum: container,container/bridge,host
			 */
			inlineNetworkMode_4cccbb4c3c88d1078bf95c85c1818632: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[6].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"container, container/bridge, host"}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of LegacyName
			 * with the following constraints:
			 * 
			 * - pattern: ^[a-z0-9]([-a-z0-9]*[a-z0-9])?$
			 * - minLength: 1
			 */
			inlineLegacyName_6b57bcbac18a961e5de097e580b2c3d1: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[5].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9]*[a-z0-9])?$"}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * "tcp"
			 * 
			 * This is an in-line specialization of NetworkProtocol
			 * with the following constraints:
			 * 
			 * - enum: tcp,udp,udp,tcp
			 */
			inlineNetworkProtocol_929ca93e4a730214947afb3b3214f365: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[7].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"tcp, udp, udp,tcp"}));
					}
				}
				return errors;
			},
		
			/**
			 * "HTTP"
			 * 
			 * This is an in-line specialization of HttpScheme
			 * with the following constraints:
			 * 
			 * - enum: HTTP,HTTPS
			 */
			inlineHttpScheme_9daecb70f32aeec3a0f8567d3168714f: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[8].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"http, https"}));
					}
				}
				return errors;
			},
		
			/**
			 * "/path/to/health."
			 * 
			 * This is an in-line specialization of Path
			 * with the following constraints:
			 * 
			 * - minLength: 1
			 * - maxLength: 1024
			 */
			inlinePath_293be7de6c009b1ca492ed5c5b0eafa1: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * 10
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int32
			 * - minimum: 1
			 */
			inlineIntegerType_c93f718de273ed296fcdc5ae52e1ebf3: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
					if (value < 1) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   1
			 * ]
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - items: IntegerType
			 * - uniqueItems: true
			 * - minItems: 1
			 */
			inlineIntegerType_9571dae39de95a138d04ae36ba2376aa: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.IntegerType(value, path.concat([i]))
						);
					}, errors);
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "ITEMS_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 * 
			 * This is an in-line specialization of Name
			 * with the following constraints:
			 * 
			 * - items: Name
			 */
			inlineName_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Name(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of ReadMode
			 * with the following constraints:
			 * 
			 * - enum: RO,RW
			 */
			inlineReadMode_ebf93bc60688d31156f7c38ab762ecab: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[9].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"ro, rw"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   [
			 *     "some value"
			 *   ]
			 * ]
			 * 
			 * This is an in-line specialization of VolumeConstraint
			 * with the following constraints:
			 * 
			 * - uniqueItems: true
			 * - items: VolumeConstraint
			 */
			inlineVolumeConstraint_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.VolumeConstraint(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
		};
		
		var Validators = {
			/**
			 * {
			 *   "relaunchEscalationTimeoutSeconds": 3600,
			 *   "taskLostBehavior": "WAIT_FOREVER"
			 * }
			 */
			AppResidency: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.relaunchEscalationTimeoutSeconds == null) {
						errors.push(new RAMLError(path.concat(['relaunchEscalationTimeoutSeconds']), context, "PROP_IS_MISSING", {name: 'relaunchEscalationTimeoutSeconds'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.relaunchEscalationTimeoutSeconds, path.concat(['relaunchEscalationTimeoutSeconds'])));
					}
					if (value.taskLostBehavior == null) {
						errors.push(new RAMLError(path.concat(['taskLostBehavior']), context, "PROP_IS_MISSING", {name: 'taskLostBehavior'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineTaskLostBehavior_42f02b6c8ad50000c5ecfb3dfd33f3ac(value.taskLostBehavior, path.concat(['taskLostBehavior'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "maximumOverCapacity": 1,
			 *   "minimumHealthCapacity": 1
			 * }
			 */
			UpgradeStrategy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.maximumOverCapacity == null) {
						errors.push(new RAMLError(path.concat(['maximumOverCapacity']), context, "PROP_IS_MISSING", {name: 'maximumOverCapacity'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineNumberType_ad71b34619243f232a05ae91f25d0513(value.maximumOverCapacity, path.concat(['maximumOverCapacity'])));
					}
					if (value.minimumHealthCapacity == null) {
						errors.push(new RAMLError(path.concat(['minimumHealthCapacity']), context, "PROP_IS_MISSING", {name: 'minimumHealthCapacity'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineNumberType_ad71b34619243f232a05ae91f25d0513(value.minimumHealthCapacity, path.concat(['minimumHealthCapacity'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "id": "/ops/audit",
			 *   "acceptedResourceRoles": [
			 *     "public-facing"
			 *   ],
			 *   "args": [
			 *     "some value"
			 *   ],
			 *   "backoffFactor": 1.15,
			 *   "backoffSeconds": 1,
			 *   "cmd": "some value",
			 *   "constraints": [
			 *     [
			 *       "hostname",
			 *       "UNIQUE"
			 *     ]
			 *   ],
			 *   "container": {
			 *     "type": "DOCKER",
			 *     "docker": {
			 *       "credential": {
			 *         "principal": "some value",
			 *         "secret": "some value"
			 *       },
			 *       "pullConfig": {
			 *         "secret": "some value"
			 *       },
			 *       "forcePullImage": false,
			 *       "image": "some value",
			 *       "network": "some value",
			 *       "parameters": [
			 *         {
			 *           "key": "some value",
			 *           "value": "some value"
			 *         }
			 *       ],
			 *       "portMappings": [
			 *         {
			 *           "containerPort": 0,
			 *           "hostPort": 1,
			 *           "labels": {},
			 *           "name": "some value",
			 *           "protocol": "tcp",
			 *           "servicePort": 0,
			 *           "networkNames": [
			 *             "some value"
			 *           ]
			 *         }
			 *       ],
			 *       "privileged": false
			 *     },
			 *     "appc": {
			 *       "image": "some value",
			 *       "id": "some value",
			 *       "labels": {},
			 *       "forcePullImage": false
			 *     },
			 *     "volumes": [
			 *       {
			 *         "containerPath": "some value",
			 *         "persistent": {
			 *           "type": "some value",
			 *           "size": 1,
			 *           "maxSize": 1,
			 *           "constraints": [
			 *             [
			 *               "some value"
			 *             ]
			 *           ]
			 *         },
			 *         "mode": "some value"
			 *       }
			 *     ],
			 *     "portMappings": [
			 *       {
			 *         "containerPort": 0,
			 *         "hostPort": 1,
			 *         "labels": {},
			 *         "name": "some value",
			 *         "protocol": "tcp",
			 *         "servicePort": 0,
			 *         "networkNames": [
			 *           "some value"
			 *         ]
			 *       }
			 *     ]
			 *   },
			 *   "cpus": 1,
			 *   "dependencies": [
			 *     "/ops/audit"
			 *   ],
			 *   "disk": 0,
			 *   "env": {},
			 *   "executor": "",
			 *   "fetch": [
			 *     {
			 *       "uri": "http://download.me/file.tgz",
			 *       "extract": true,
			 *       "executable": true,
			 *       "cache": false
			 *     }
			 *   ],
			 *   "healthChecks": [
			 *     {
			 *       "command": {
			 *         "value": "some value"
			 *       },
			 *       "gracePeriodSeconds": 300,
			 *       "ignoreHttp1xx": true,
			 *       "intervalSeconds": 60,
			 *       "maxConsecutiveFailures": 3,
			 *       "path": "/path/to/health",
			 *       "port": 1,
			 *       "portIndex": 1,
			 *       "protocol": "HTTP",
			 *       "timeoutSeconds": 20,
			 *       "delaySeconds": 15
			 *     }
			 *   ],
			 *   "instances": 1,
			 *   "labels": {},
			 *   "maxLaunchDelaySeconds": 3600,
			 *   "mem": 128,
			 *   "gpus": 0,
			 *   "ipAddress": {
			 *     "discovery": {
			 *       "ports": [
			 *         {
			 *           "number": 0,
			 *           "name": "some value",
			 *           "protocol": "tcp",
			 *           "labels": {}
			 *         }
			 *       ]
			 *     },
			 *     "groups": [
			 *       "some value"
			 *     ],
			 *     "labels": {},
			 *     "networkName": "some value"
			 *   },
			 *   "networks": [
			 *     {
			 *       "name": "some value",
			 *       "mode": "container",
			 *       "labels": {}
			 *     }
			 *   ],
			 *   "ports": [
			 *     0
			 *   ],
			 *   "portDefinitions": [
			 *     {
			 *       "port": 0,
			 *       "labels": {},
			 *       "name": "some value",
			 *       "protocol": "tcp"
			 *     }
			 *   ],
			 *   "readinessChecks": [
			 *     {
			 *       "name": "readinessCheck",
			 *       "protocol": "HTTP",
			 *       "path": "/path/to/health.",
			 *       "portName": "http-api",
			 *       "intervalSeconds": 30,
			 *       "timeoutSeconds": 10,
			 *       "httpStatusCodesForReady": [
			 *         1
			 *       ],
			 *       "preserveLastResponse": false
			 *     }
			 *   ],
			 *   "residency": {
			 *     "relaunchEscalationTimeoutSeconds": 3600,
			 *     "taskLostBehavior": "WAIT_FOREVER"
			 *   },
			 *   "requirePorts": false,
			 *   "secrets": {},
			 *   "taskKillGracePeriodSeconds": 1,
			 *   "upgradeStrategy": {
			 *     "maximumOverCapacity": 1,
			 *     "minimumHealthCapacity": 1
			 *   },
			 *   "uris": [
			 *     "some value"
			 *   ],
			 *   "user": "some value",
			 *   "version": "some value",
			 *   "versionInfo": {
			 *     "lastScalingAt": "some value",
			 *     "lastConfigChangeAt": "some value"
			 *   },
			 *   "killSelection": "YOUNGEST_FIRST",
			 *   "unreachableStrategy": "disabled",
			 *   "tty": true
			 * }
			 */
			App: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.id == null) {
						errors.push(new RAMLError(path.concat(['id']), context, "PROP_IS_MISSING", {name: 'id'}));
					} else {
						errors = errors.concat(Validators.PathId(value.id, path.concat(['id'])));
					}
					if (value.acceptedResourceRoles != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_3b1f04aede5a1e865648311c626a62e2(value.acceptedResourceRoles, path.concat(['acceptedResourceRoles'])));
					}
					if (value.args != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_c16b318f4fe8b85b2a89ed06127bb779(value.args, path.concat(['args'])));
					}
					if (value.backoffFactor != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_c481ed52acea3ffa91ed57e7407ff87f(value.backoffFactor, path.concat(['backoffFactor'])));
					}
					if (value.backoffSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.backoffSeconds, path.concat(['backoffSeconds'])));
					}
					if (value.cmd != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.cmd, path.concat(['cmd'])));
					}
					if (value.constraints != null) {
						errors = errors.concat(PrivateValidators.inlineAppConstraint_3b1f04aede5a1e865648311c626a62e2(value.constraints, path.concat(['constraints'])));
					}
					if (value.container != null) {
						errors = errors.concat(Validators.Container(value.container, path.concat(['container'])));
					}
					if (value.cpus != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_5471becca47d41cedb309da969544f87(value.cpus, path.concat(['cpus'])));
					}
					if (value.dependencies != null) {
						errors = errors.concat(PrivateValidators.inlinePathId_3b1f04aede5a1e865648311c626a62e2(value.dependencies, path.concat(['dependencies'])));
					}
					if (value.disk != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2(value.disk, path.concat(['disk'])));
					}
					if (value.env != null) {
						errors = errors.concat(Validators.LegacyEnvVars(value.env, path.concat(['env'])));
					}
					if (value.executor != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d0e7c79ff122579a63d440783fa354cf(value.executor, path.concat(['executor'])));
					}
					if (value.fetch != null) {
						errors = errors.concat(PrivateValidators.inlineArtifact_c16b318f4fe8b85b2a89ed06127bb779(value.fetch, path.concat(['fetch'])));
					}
					if (value.healthChecks != null) {
						errors = errors.concat(PrivateValidators.inlineAppHealthCheck_3b1f04aede5a1e865648311c626a62e2(value.healthChecks, path.concat(['healthChecks'])));
					}
					if (value.instances != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.instances, path.concat(['instances'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.maxLaunchDelaySeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.maxLaunchDelaySeconds, path.concat(['maxLaunchDelaySeconds'])));
					}
					if (value.mem != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2(value.mem, path.concat(['mem'])));
					}
					if (value.gpus != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.gpus, path.concat(['gpus'])));
					}
					if (value.ipAddress != null) {
						errors = errors.concat(Validators.IpAddress(value.ipAddress, path.concat(['ipAddress'])));
					}
					if (value.networks != null) {
						errors = errors.concat(PrivateValidators.inlineNetwork_c16b318f4fe8b85b2a89ed06127bb779(value.networks, path.concat(['networks'])));
					}
					if (value.ports != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_c16b318f4fe8b85b2a89ed06127bb779(value.ports, path.concat(['ports'])));
					}
					if (value.portDefinitions != null) {
						errors = errors.concat(PrivateValidators.inlinePortDefinition_c16b318f4fe8b85b2a89ed06127bb779(value.portDefinitions, path.concat(['portDefinitions'])));
					}
					if (value.readinessChecks != null) {
						errors = errors.concat(PrivateValidators.inlineReadinessCheck_c16b318f4fe8b85b2a89ed06127bb779(value.readinessChecks, path.concat(['readinessChecks'])));
					}
					if (value.residency != null) {
						errors = errors.concat(Validators.AppResidency(value.residency, path.concat(['residency'])));
					}
					if (value.requirePorts != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.requirePorts, path.concat(['requirePorts'])));
					}
					if (value.secrets != null) {
						errors = errors.concat(Validators.Secrets(value.secrets, path.concat(['secrets'])));
					}
					if (value.taskKillGracePeriodSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.taskKillGracePeriodSeconds, path.concat(['taskKillGracePeriodSeconds'])));
					}
					if (value.upgradeStrategy != null) {
						errors = errors.concat(Validators.UpgradeStrategy(value.upgradeStrategy, path.concat(['upgradeStrategy'])));
					}
					if (value.uris != null) {
						errors = errors.concat(PrivateValidators.inlineUri_c16b318f4fe8b85b2a89ed06127bb779(value.uris, path.concat(['uris'])));
					}
					if (value.user != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.user, path.concat(['user'])));
					}
					if (value.version != null) {
						errors = errors.concat(PrivateValidators.inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e(value.version, path.concat(['version'])));
					}
					if (value.versionInfo != null) {
						errors = errors.concat(Validators.VersionInfo(value.versionInfo, path.concat(['versionInfo'])));
					}
					if (value.killSelection != null) {
						errors = errors.concat(PrivateValidators.inlineKillSelection_af9950cc31a21fe24612f6bbfd35c849(value.killSelection, path.concat(['killSelection'])));
					}
					if (value.unreachableStrategy != null) {
						errors = errors.concat(Validators.UnreachableStrategy(value.unreachableStrategy, path.concat(['unreachableStrategy'])));
					}
					if (value.tty != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.tty, path.concat(['tty'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "apps": [
			 *     {
			 *       "id": "/ops/audit",
			 *       "acceptedResourceRoles": [
			 *         "public-facing"
			 *       ],
			 *       "args": [
			 *         "some value"
			 *       ],
			 *       "backoffFactor": 1.15,
			 *       "backoffSeconds": 1,
			 *       "cmd": "some value",
			 *       "constraints": [
			 *         [
			 *           "hostname",
			 *           "UNIQUE"
			 *         ]
			 *       ],
			 *       "container": {
			 *         "type": "DOCKER",
			 *         "docker": {
			 *           "credential": {
			 *             "principal": "some value",
			 *             "secret": "some value"
			 *           },
			 *           "pullConfig": {
			 *             "secret": "some value"
			 *           },
			 *           "forcePullImage": false,
			 *           "image": "some value",
			 *           "network": "some value",
			 *           "parameters": [
			 *             {
			 *               "key": "some value",
			 *               "value": "some value"
			 *             }
			 *           ],
			 *           "portMappings": [
			 *             {
			 *               "containerPort": 0,
			 *               "hostPort": 1,
			 *               "labels": {},
			 *               "name": "some value",
			 *               "protocol": "tcp",
			 *               "servicePort": 0,
			 *               "networkNames": [
			 *                 "some value"
			 *               ]
			 *             }
			 *           ],
			 *           "privileged": false
			 *         },
			 *         "appc": {
			 *           "image": "some value",
			 *           "id": "some value",
			 *           "labels": {},
			 *           "forcePullImage": false
			 *         },
			 *         "volumes": [
			 *           {
			 *             "containerPath": "some value",
			 *             "persistent": {
			 *               "type": "some value",
			 *               "size": 1,
			 *               "maxSize": 1,
			 *               "constraints": [
			 *                 [
			 *                   "some value"
			 *                 ]
			 *               ]
			 *             },
			 *             "mode": "some value"
			 *           }
			 *         ],
			 *         "portMappings": [
			 *           {
			 *             "containerPort": 0,
			 *             "hostPort": 1,
			 *             "labels": {},
			 *             "name": "some value",
			 *             "protocol": "tcp",
			 *             "servicePort": 0,
			 *             "networkNames": [
			 *               "some value"
			 *             ]
			 *           }
			 *         ]
			 *       },
			 *       "cpus": 1,
			 *       "dependencies": [
			 *         "/ops/audit"
			 *       ],
			 *       "disk": 0,
			 *       "env": {},
			 *       "executor": "",
			 *       "fetch": [
			 *         {
			 *           "uri": "http://download.me/file.tgz",
			 *           "extract": true,
			 *           "executable": true,
			 *           "cache": false
			 *         }
			 *       ],
			 *       "healthChecks": [
			 *         {
			 *           "command": {
			 *             "value": "some value"
			 *           },
			 *           "gracePeriodSeconds": 300,
			 *           "ignoreHttp1xx": true,
			 *           "intervalSeconds": 60,
			 *           "maxConsecutiveFailures": 3,
			 *           "path": "/path/to/health",
			 *           "port": 1,
			 *           "portIndex": 1,
			 *           "protocol": "HTTP",
			 *           "timeoutSeconds": 20,
			 *           "delaySeconds": 15
			 *         }
			 *       ],
			 *       "instances": 1,
			 *       "labels": {},
			 *       "maxLaunchDelaySeconds": 3600,
			 *       "mem": 128,
			 *       "gpus": 0,
			 *       "ipAddress": {
			 *         "discovery": {
			 *           "ports": [
			 *             {
			 *               "number": 0,
			 *               "name": "some value",
			 *               "protocol": "tcp",
			 *               "labels": {}
			 *             }
			 *           ]
			 *         },
			 *         "groups": [
			 *           "some value"
			 *         ],
			 *         "labels": {},
			 *         "networkName": "some value"
			 *       },
			 *       "networks": [
			 *         {
			 *           "name": "some value",
			 *           "mode": "container",
			 *           "labels": {}
			 *         }
			 *       ],
			 *       "ports": [
			 *         0
			 *       ],
			 *       "portDefinitions": [
			 *         {
			 *           "port": 0,
			 *           "labels": {},
			 *           "name": "some value",
			 *           "protocol": "tcp"
			 *         }
			 *       ],
			 *       "readinessChecks": [
			 *         {
			 *           "name": "readinessCheck",
			 *           "protocol": "HTTP",
			 *           "path": "/path/to/health.",
			 *           "portName": "http-api",
			 *           "intervalSeconds": 30,
			 *           "timeoutSeconds": 10,
			 *           "httpStatusCodesForReady": [
			 *             1
			 *           ],
			 *           "preserveLastResponse": false
			 *         }
			 *       ],
			 *       "residency": {
			 *         "relaunchEscalationTimeoutSeconds": 3600,
			 *         "taskLostBehavior": "WAIT_FOREVER"
			 *       },
			 *       "requirePorts": false,
			 *       "secrets": {},
			 *       "taskKillGracePeriodSeconds": 1,
			 *       "upgradeStrategy": {
			 *         "maximumOverCapacity": 1,
			 *         "minimumHealthCapacity": 1
			 *       },
			 *       "uris": [
			 *         "some value"
			 *       ],
			 *       "user": "some value",
			 *       "version": "some value",
			 *       "versionInfo": {
			 *         "lastScalingAt": "some value",
			 *         "lastConfigChangeAt": "some value"
			 *       },
			 *       "killSelection": "YOUNGEST_FIRST",
			 *       "unreachableStrategy": "disabled",
			 *       "tty": true
			 *     }
			 *   ]
			 * }
			 */
			AppList: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.apps == null) {
						errors.push(new RAMLError(path.concat(['apps']), context, "PROP_IS_MISSING", {name: 'apps'}));
					} else {
						errors = errors.concat(Validators.AppAsArray(value.apps, path.concat(['apps'])));
					}
				}
				return errors;
			},
		
			/**
			 * "/ops/audit"
			 */
			PathId: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[0].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^(\\/?((\\.\\.)|(([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9])\\.)*([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9]))?($|\\/))+$"}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "type": "DOCKER",
			 *   "docker": {
			 *     "credential": {
			 *       "principal": "some value",
			 *       "secret": "some value"
			 *     },
			 *     "pullConfig": {
			 *       "secret": "some value"
			 *     },
			 *     "forcePullImage": false,
			 *     "image": "some value",
			 *     "network": "some value",
			 *     "parameters": [
			 *       {
			 *         "key": "some value",
			 *         "value": "some value"
			 *       }
			 *     ],
			 *     "portMappings": [
			 *       {
			 *         "containerPort": 0,
			 *         "hostPort": 1,
			 *         "labels": {},
			 *         "name": "some value",
			 *         "protocol": "tcp",
			 *         "servicePort": 0,
			 *         "networkNames": [
			 *           "some value"
			 *         ]
			 *       }
			 *     ],
			 *     "privileged": false
			 *   },
			 *   "appc": {
			 *     "image": "some value",
			 *     "id": "some value",
			 *     "labels": {},
			 *     "forcePullImage": false
			 *   },
			 *   "volumes": [
			 *     {
			 *       "containerPath": "some value",
			 *       "persistent": {
			 *         "type": "some value",
			 *         "size": 1,
			 *         "maxSize": 1,
			 *         "constraints": [
			 *           [
			 *             "some value"
			 *           ]
			 *         ]
			 *       },
			 *       "mode": "some value"
			 *     }
			 *   ],
			 *   "portMappings": [
			 *     {
			 *       "containerPort": 0,
			 *       "hostPort": 1,
			 *       "labels": {},
			 *       "name": "some value",
			 *       "protocol": "tcp",
			 *       "servicePort": 0,
			 *       "networkNames": [
			 *         "some value"
			 *       ]
			 *     }
			 *   ]
			 * }
			 */
			Container: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.type == null) {
						errors.push(new RAMLError(path.concat(['type']), context, "PROP_IS_MISSING", {name: 'type'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineEngineType_ac83465795b5f6d40807390b3f6c8ef5(value.type, path.concat(['type'])));
					}
					if (value.docker != null) {
						errors = errors.concat(Validators.DockerContainer(value.docker, path.concat(['docker'])));
					}
					if (value.appc != null) {
						errors = errors.concat(Validators.AppCContainer(value.appc, path.concat(['appc'])));
					}
					if (value.volumes != null) {
						errors = errors.concat(PrivateValidators.inlineAppVolume_c16b318f4fe8b85b2a89ed06127bb779(value.volumes, path.concat(['volumes'])));
					}
					if (value.portMappings != null) {
						errors = errors.concat(PrivateValidators.inlineContainerPortMapping_c16b318f4fe8b85b2a89ed06127bb779(value.portMappings, path.concat(['portMappings'])));
					}
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			LegacyEnvVars: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[1].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(Validators.EnvVarValueOrSecret(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			KVLabels: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[3].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {
			 *   "discovery": {
			 *     "ports": [
			 *       {
			 *         "number": 0,
			 *         "name": "some value",
			 *         "protocol": "tcp",
			 *         "labels": {}
			 *       }
			 *     ]
			 *   },
			 *   "groups": [
			 *     "some value"
			 *   ],
			 *   "labels": {},
			 *   "networkName": "some value"
			 * }
			 */
			IpAddress: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.discovery != null) {
						errors = errors.concat(Validators.IpDiscovery(value.discovery, path.concat(['discovery'])));
					}
					if (value.groups != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_3b1f04aede5a1e865648311c626a62e2(value.groups, path.concat(['groups'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.networkName != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.networkName, path.concat(['networkName'])));
					}
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			Secrets: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[3].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(Validators.SecretDef(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {
			 *   "lastScalingAt": "some value",
			 *   "lastConfigChangeAt": "some value"
			 * }
			 */
			VersionInfo: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.lastScalingAt == null) {
						errors.push(new RAMLError(path.concat(['lastScalingAt']), context, "PROP_IS_MISSING", {name: 'lastScalingAt'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e(value.lastScalingAt, path.concat(['lastScalingAt'])));
					}
					if (value.lastConfigChangeAt == null) {
						errors.push(new RAMLError(path.concat(['lastConfigChangeAt']), context, "PROP_IS_MISSING", {name: 'lastConfigChangeAt'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e(value.lastConfigChangeAt, path.concat(['lastConfigChangeAt'])));
					}
				}
				return errors;
			},
		
			/**
			 * "disabled"
			 */
			UnreachableStrategy: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.UnreachableDisabled(value, path),
					Validators.UnreachableEnabled(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "id": "/ops/audit",
			 *     "acceptedResourceRoles": [
			 *       "public-facing"
			 *     ],
			 *     "args": [
			 *       "some value"
			 *     ],
			 *     "backoffFactor": 1.15,
			 *     "backoffSeconds": 1,
			 *     "cmd": "some value",
			 *     "constraints": [
			 *       [
			 *         "hostname",
			 *         "UNIQUE"
			 *       ]
			 *     ],
			 *     "container": {
			 *       "type": "DOCKER",
			 *       "docker": {
			 *         "credential": {
			 *           "principal": "some value",
			 *           "secret": "some value"
			 *         },
			 *         "pullConfig": {
			 *           "secret": "some value"
			 *         },
			 *         "forcePullImage": false,
			 *         "image": "some value",
			 *         "network": "some value",
			 *         "parameters": [
			 *           {
			 *             "key": "some value",
			 *             "value": "some value"
			 *           }
			 *         ],
			 *         "portMappings": [
			 *           {
			 *             "containerPort": 0,
			 *             "hostPort": 1,
			 *             "labels": {},
			 *             "name": "some value",
			 *             "protocol": "tcp",
			 *             "servicePort": 0,
			 *             "networkNames": [
			 *               "some value"
			 *             ]
			 *           }
			 *         ],
			 *         "privileged": false
			 *       },
			 *       "appc": {
			 *         "image": "some value",
			 *         "id": "some value",
			 *         "labels": {},
			 *         "forcePullImage": false
			 *       },
			 *       "volumes": [
			 *         {
			 *           "containerPath": "some value",
			 *           "persistent": {
			 *             "type": "some value",
			 *             "size": 1,
			 *             "maxSize": 1,
			 *             "constraints": [
			 *               [
			 *                 "some value"
			 *               ]
			 *             ]
			 *           },
			 *           "mode": "some value"
			 *         }
			 *       ],
			 *       "portMappings": [
			 *         {
			 *           "containerPort": 0,
			 *           "hostPort": 1,
			 *           "labels": {},
			 *           "name": "some value",
			 *           "protocol": "tcp",
			 *           "servicePort": 0,
			 *           "networkNames": [
			 *             "some value"
			 *           ]
			 *         }
			 *       ]
			 *     },
			 *     "cpus": 1,
			 *     "dependencies": [
			 *       "/ops/audit"
			 *     ],
			 *     "disk": 0,
			 *     "env": {},
			 *     "executor": "",
			 *     "fetch": [
			 *       {
			 *         "uri": "http://download.me/file.tgz",
			 *         "extract": true,
			 *         "executable": true,
			 *         "cache": false
			 *       }
			 *     ],
			 *     "healthChecks": [
			 *       {
			 *         "command": {
			 *           "value": "some value"
			 *         },
			 *         "gracePeriodSeconds": 300,
			 *         "ignoreHttp1xx": true,
			 *         "intervalSeconds": 60,
			 *         "maxConsecutiveFailures": 3,
			 *         "path": "/path/to/health",
			 *         "port": 1,
			 *         "portIndex": 1,
			 *         "protocol": "HTTP",
			 *         "timeoutSeconds": 20,
			 *         "delaySeconds": 15
			 *       }
			 *     ],
			 *     "instances": 1,
			 *     "labels": {},
			 *     "maxLaunchDelaySeconds": 3600,
			 *     "mem": 128,
			 *     "gpus": 0,
			 *     "ipAddress": {
			 *       "discovery": {
			 *         "ports": [
			 *           {
			 *             "number": 0,
			 *             "name": "some value",
			 *             "protocol": "tcp",
			 *             "labels": {}
			 *           }
			 *         ]
			 *       },
			 *       "groups": [
			 *         "some value"
			 *       ],
			 *       "labels": {},
			 *       "networkName": "some value"
			 *     },
			 *     "networks": [
			 *       {
			 *         "name": "some value",
			 *         "mode": "container",
			 *         "labels": {}
			 *       }
			 *     ],
			 *     "ports": [
			 *       0
			 *     ],
			 *     "portDefinitions": [
			 *       {
			 *         "port": 0,
			 *         "labels": {},
			 *         "name": "some value",
			 *         "protocol": "tcp"
			 *       }
			 *     ],
			 *     "readinessChecks": [
			 *       {
			 *         "name": "readinessCheck",
			 *         "protocol": "HTTP",
			 *         "path": "/path/to/health.",
			 *         "portName": "http-api",
			 *         "intervalSeconds": 30,
			 *         "timeoutSeconds": 10,
			 *         "httpStatusCodesForReady": [
			 *           1
			 *         ],
			 *         "preserveLastResponse": false
			 *       }
			 *     ],
			 *     "residency": {
			 *       "relaunchEscalationTimeoutSeconds": 3600,
			 *       "taskLostBehavior": "WAIT_FOREVER"
			 *     },
			 *     "requirePorts": false,
			 *     "secrets": {},
			 *     "taskKillGracePeriodSeconds": 1,
			 *     "upgradeStrategy": {
			 *       "maximumOverCapacity": 1,
			 *       "minimumHealthCapacity": 1
			 *     },
			 *     "uris": [
			 *       "some value"
			 *     ],
			 *     "user": "some value",
			 *     "version": "some value",
			 *     "versionInfo": {
			 *       "lastScalingAt": "some value",
			 *       "lastConfigChangeAt": "some value"
			 *     },
			 *     "killSelection": "YOUNGEST_FIRST",
			 *     "unreachableStrategy": "disabled",
			 *     "tty": true
			 *   }
			 * ]
			 */
			AppAsArray: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.App(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			StringType: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * [
			 *   "hostname",
			 *   "UNIQUE"
			 * ]
			 */
			AppConstraint: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.StringType(value, path.concat([i]))
						);
					}, errors);
					if (value.length < 2) {
						errors.push(new RAMLError(path, context, "ITEMS_MIN", {"value":2}));
					}
					if (value.length > 3) {
						errors.push(new RAMLError(path, context, "ITEMS_MAX", {"value":3}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "credential": {
			 *     "principal": "some value",
			 *     "secret": "some value"
			 *   },
			 *   "pullConfig": {
			 *     "secret": "some value"
			 *   },
			 *   "forcePullImage": false,
			 *   "image": "some value",
			 *   "network": "some value",
			 *   "parameters": [
			 *     {
			 *       "key": "some value",
			 *       "value": "some value"
			 *     }
			 *   ],
			 *   "portMappings": [
			 *     {
			 *       "containerPort": 0,
			 *       "hostPort": 1,
			 *       "labels": {},
			 *       "name": "some value",
			 *       "protocol": "tcp",
			 *       "servicePort": 0,
			 *       "networkNames": [
			 *         "some value"
			 *       ]
			 *     }
			 *   ],
			 *   "privileged": false
			 * }
			 */
			DockerContainer: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.credential != null) {
						errors = errors.concat(Validators.DockerCredentials(value.credential, path.concat(['credential'])));
					}
					if (value.pullConfig != null) {
						errors = errors.concat(Validators.DockerPullConfig(value.pullConfig, path.concat(['pullConfig'])));
					}
					if (value.forcePullImage != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.forcePullImage, path.concat(['forcePullImage'])));
					}
					if (value.image == null) {
						errors.push(new RAMLError(path.concat(['image']), context, "PROP_IS_MISSING", {name: 'image'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.image, path.concat(['image'])));
					}
					if (value.network != null) {
						errors = errors.concat(PrivateValidators.inlineDockerNetwork_97392176b9645001a877ed1e9b844cc9(value.network, path.concat(['network'])));
					}
					if (value.parameters != null) {
						errors = errors.concat(PrivateValidators.inlineDockerParameter_c16b318f4fe8b85b2a89ed06127bb779(value.parameters, path.concat(['parameters'])));
					}
					if (value.portMappings != null) {
						errors = errors.concat(PrivateValidators.inlineContainerPortMapping_c16b318f4fe8b85b2a89ed06127bb779(value.portMappings, path.concat(['portMappings'])));
					}
					if (value.privileged != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.privileged, path.concat(['privileged'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "image": "some value",
			 *   "id": "some value",
			 *   "labels": {},
			 *   "forcePullImage": false
			 * }
			 */
			AppCContainer: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.image == null) {
						errors.push(new RAMLError(path.concat(['image']), context, "PROP_IS_MISSING", {name: 'image'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.image, path.concat(['image'])));
					}
					if (value.id != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_1c6abad92bbd0cfb11e1370a9fb70951(value.id, path.concat(['id'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.forcePullImage != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.forcePullImage, path.concat(['forcePullImage'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			EnvVarValueOrSecret: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.EnvVarValue(value, path),
					Validators.EnvVarSecret(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * "{\n  \"uri\": \"http://download.me/file.tgz\",\n  \"extract\": true,\n  \"executable\": true,\n  \"cache\": false\n}\n"
			 */
			Artifact: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.uri == null) {
						errors.push(new RAMLError(path.concat(['uri']), context, "PROP_IS_MISSING", {name: 'uri'}));
					} else {
						errors = errors.concat(Validators.Uri(value.uri, path.concat(['uri'])));
					}
					if (value.extract != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.extract, path.concat(['extract'])));
					}
					if (value.executable != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.executable, path.concat(['executable'])));
					}
					if (value.cache != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.cache, path.concat(['cache'])));
					}
					if (value.destPath != null) {
						errors = errors.concat(Validators.Path(value.destPath, path.concat(['destPath'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "command": {
			 *     "value": "some value"
			 *   },
			 *   "gracePeriodSeconds": 300,
			 *   "ignoreHttp1xx": true,
			 *   "intervalSeconds": 60,
			 *   "maxConsecutiveFailures": 3,
			 *   "path": "/path/to/health",
			 *   "port": 1,
			 *   "portIndex": 1,
			 *   "protocol": "HTTP",
			 *   "timeoutSeconds": 20,
			 *   "delaySeconds": 15
			 * }
			 */
			AppHealthCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.command != null) {
						errors = errors.concat(Validators.CommandCheck(value.command, path.concat(['command'])));
					}
					if (value.gracePeriodSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.gracePeriodSeconds, path.concat(['gracePeriodSeconds'])));
					}
					if (value.ignoreHttp1xx != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.ignoreHttp1xx, path.concat(['ignoreHttp1xx'])));
					}
					if (value.intervalSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.intervalSeconds, path.concat(['intervalSeconds'])));
					}
					if (value.maxConsecutiveFailures != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.maxConsecutiveFailures, path.concat(['maxConsecutiveFailures'])));
					}
					if (value.path != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.path, path.concat(['path'])));
					}
					if (value.port != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.port, path.concat(['port'])));
					}
					if (value.portIndex != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.portIndex, path.concat(['portIndex'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineAppHealthCheckProtocol_d48bd5285cf380c9f3754324fc7feed2(value.protocol, path.concat(['protocol'])));
					}
					if (value.timeoutSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_d5ab06b03ff21f3a6085461bfd6e5065(value.timeoutSeconds, path.concat(['timeoutSeconds'])));
					}
					if (value.delaySeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.delaySeconds, path.concat(['delaySeconds'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "ports": [
			 *     {
			 *       "number": 0,
			 *       "name": "some value",
			 *       "protocol": "tcp",
			 *       "labels": {}
			 *     }
			 *   ]
			 * }
			 */
			IpDiscovery: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.ports != null) {
						errors = errors.concat(PrivateValidators.inlineIpDiscoveryPort_c16b318f4fe8b85b2a89ed06127bb779(value.ports, path.concat(['ports'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "mode": "container",
			 *   "labels": {}
			 * }
			 */
			Network: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkName_d5930fd0fc0461b8008a443d59699e32(value.name, path.concat(['name'])));
					}
					if (value.mode != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkMode_4cccbb4c3c88d1078bf95c85c1818632(value.mode, path.concat(['mode'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
				}
				return errors;
			},
		
			/**
			 * 0
			 */
			AnyPort: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
					if (value > 65535) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":65535}));
					}
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "port": 0,
			 *   "labels": {},
			 *   "name": "some value",
			 *   "protocol": "tcp"
			 * }
			 */
			PortDefinition: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.port != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.port, path.concat(['port'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineLegacyName_6b57bcbac18a961e5de097e580b2c3d1(value.name, path.concat(['name'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkProtocol_929ca93e4a730214947afb3b3214f365(value.protocol, path.concat(['protocol'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "readinessCheck",
			 *   "protocol": "HTTP",
			 *   "path": "/path/to/health.",
			 *   "portName": "http-api",
			 *   "intervalSeconds": 30,
			 *   "timeoutSeconds": 10,
			 *   "httpStatusCodesForReady": [
			 *     1
			 *   ],
			 *   "preserveLastResponse": false
			 * }
			 */
			ReadinessCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.name, path.concat(['name'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineHttpScheme_9daecb70f32aeec3a0f8567d3168714f(value.protocol, path.concat(['protocol'])));
					}
					if (value.path != null) {
						errors = errors.concat(PrivateValidators.inlinePath_293be7de6c009b1ca492ed5c5b0eafa1(value.path, path.concat(['path'])));
					}
					if (value.portName != null) {
						errors = errors.concat(PrivateValidators.inlineLegacyName_6b57bcbac18a961e5de097e580b2c3d1(value.portName, path.concat(['portName'])));
					}
					if (value.intervalSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.intervalSeconds, path.concat(['intervalSeconds'])));
					}
					if (value.timeoutSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_c93f718de273ed296fcdc5ae52e1ebf3(value.timeoutSeconds, path.concat(['timeoutSeconds'])));
					}
					if (value.httpStatusCodesForReady != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_9571dae39de95a138d04ae36ba2376aa(value.httpStatusCodesForReady, path.concat(['httpStatusCodesForReady'])));
					}
					if (value.preserveLastResponse != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.preserveLastResponse, path.concat(['preserveLastResponse'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "source": "some value"
			 * }
			 */
			SecretDef: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.source == null) {
						errors.push(new RAMLError(path.concat(['source']), context, "PROP_IS_MISSING", {name: 'source'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.source, path.concat(['source'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Uri: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * "disabled"
			 */
			UnreachableDisabled: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[3].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"disabled"}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "inactiveAfterSeconds": 0,
			 *   "expungeAfterSeconds": 0
			 * }
			 */
			UnreachableEnabled: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.inactiveAfterSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.inactiveAfterSeconds, path.concat(['inactiveAfterSeconds'])));
					}
					if (value.expungeAfterSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.expungeAfterSeconds, path.concat(['expungeAfterSeconds'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "principal": "some value",
			 *   "secret": "some value"
			 * }
			 */
			DockerCredentials: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.principal == null) {
						errors.push(new RAMLError(path.concat(['principal']), context, "PROP_IS_MISSING", {name: 'principal'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.principal, path.concat(['principal'])));
					}
					if (value.secret != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "secret": "some value"
			 * }
			 */
			DockerPullConfig: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "containerPath": "some value",
			 *   "persistent": {
			 *     "type": "some value",
			 *     "size": 1,
			 *     "maxSize": 1,
			 *     "constraints": [
			 *       [
			 *         "some value"
			 *       ]
			 *     ]
			 *   },
			 *   "mode": "some value"
			 * }
			 */
			AppVolume: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.AppPersistentVolume(value, path),
					Validators.AppExternalVolume(value, path),
					Validators.AppSecretVolume(value, path),
					Validators.AppDockerVolume(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * {
			 *   "containerPort": 0,
			 *   "hostPort": 1,
			 *   "labels": {},
			 *   "name": "some value",
			 *   "protocol": "tcp",
			 *   "servicePort": 0,
			 *   "networkNames": [
			 *     "some value"
			 *   ]
			 * }
			 */
			ContainerPortMapping: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.containerPort == null) {
						errors.push(new RAMLError(path.concat(['containerPort']), context, "PROP_IS_MISSING", {name: 'containerPort'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.containerPort, path.concat(['containerPort'])));
					}
					if (value.hostPort != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.hostPort, path.concat(['hostPort'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineLegacyName_6b57bcbac18a961e5de097e580b2c3d1(value.name, path.concat(['name'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkProtocol_929ca93e4a730214947afb3b3214f365(value.protocol, path.concat(['protocol'])));
					}
					if (value.servicePort != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.servicePort, path.concat(['servicePort'])));
					}
					if (value.networkNames != null) {
						errors = errors.concat(PrivateValidators.inlineName_c16b318f4fe8b85b2a89ed06127bb779(value.networkNames, path.concat(['networkNames'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			EnvVarValue: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * {
			 *   "secret": "some value"
			 * }
			 */
			EnvVarSecret: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Path: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "value": "some value"
			 * }
			 */
			CommandCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.value == null) {
						errors.push(new RAMLError(path.concat(['value']), context, "PROP_IS_MISSING", {name: 'value'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.value, path.concat(['value'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "key": "some value",
			 *   "value": "some value"
			 * }
			 */
			DockerParameter: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.key == null) {
						errors.push(new RAMLError(path.concat(['key']), context, "PROP_IS_MISSING", {name: 'key'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.key, path.concat(['key'])));
					}
					if (value.value == null) {
						errors.push(new RAMLError(path.concat(['value']), context, "PROP_IS_MISSING", {name: 'value'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.value, path.concat(['value'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "containerPath": "some value",
			 *   "persistent": {
			 *     "type": "some value",
			 *     "size": 1,
			 *     "maxSize": 1,
			 *     "constraints": [
			 *       [
			 *         "some value"
			 *       ]
			 *     ]
			 *   },
			 *   "mode": "some value"
			 * }
			 */
			AppPersistentVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.containerPath == null) {
						errors.push(new RAMLError(path.concat(['containerPath']), context, "PROP_IS_MISSING", {name: 'containerPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.containerPath, path.concat(['containerPath'])));
					}
					if (value.persistent == null) {
						errors.push(new RAMLError(path.concat(['persistent']), context, "PROP_IS_MISSING", {name: 'persistent'}));
					} else {
						errors = errors.concat(Validators.PersistentVolume(value.persistent, path.concat(['persistent'])));
					}
					if (value.mode == null) {
						errors.push(new RAMLError(path.concat(['mode']), context, "PROP_IS_MISSING", {name: 'mode'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineReadMode_ebf93bc60688d31156f7c38ab762ecab(value.mode, path.concat(['mode'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "containerPath": "some value",
			 *   "external": {
			 *     "size": 1,
			 *     "name": "some value",
			 *     "provider": "some value",
			 *     "options": {}
			 *   },
			 *   "mode": "some value"
			 * }
			 */
			AppExternalVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.containerPath == null) {
						errors.push(new RAMLError(path.concat(['containerPath']), context, "PROP_IS_MISSING", {name: 'containerPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.containerPath, path.concat(['containerPath'])));
					}
					if (value.external == null) {
						errors.push(new RAMLError(path.concat(['external']), context, "PROP_IS_MISSING", {name: 'external'}));
					} else {
						errors = errors.concat(Validators.ExternalVolume(value.external, path.concat(['external'])));
					}
					if (value.mode == null) {
						errors.push(new RAMLError(path.concat(['mode']), context, "PROP_IS_MISSING", {name: 'mode'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineReadMode_ebf93bc60688d31156f7c38ab762ecab(value.mode, path.concat(['mode'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "containerPath": "some value",
			 *   "secret": "some value"
			 * }
			 */
			AppSecretVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.containerPath == null) {
						errors.push(new RAMLError(path.concat(['containerPath']), context, "PROP_IS_MISSING", {name: 'containerPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.containerPath, path.concat(['containerPath'])));
					}
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "containerPath": "some value",
			 *   "hostPath": "some value",
			 *   "mode": "some value"
			 * }
			 */
			AppDockerVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.containerPath == null) {
						errors.push(new RAMLError(path.concat(['containerPath']), context, "PROP_IS_MISSING", {name: 'containerPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.containerPath, path.concat(['containerPath'])));
					}
					if (value.hostPath == null) {
						errors.push(new RAMLError(path.concat(['hostPath']), context, "PROP_IS_MISSING", {name: 'hostPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.hostPath, path.concat(['hostPath'])));
					}
					if (value.mode == null) {
						errors.push(new RAMLError(path.concat(['mode']), context, "PROP_IS_MISSING", {name: 'mode'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineReadMode_ebf93bc60688d31156f7c38ab762ecab(value.mode, path.concat(['mode'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "number": 0,
			 *   "name": "some value",
			 *   "protocol": "tcp",
			 *   "labels": {}
			 * }
			 */
			IpDiscoveryPort: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.number != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.number, path.concat(['number'])));
					}
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineLegacyName_6b57bcbac18a961e5de097e580b2c3d1(value.name, path.concat(['name'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkProtocol_929ca93e4a730214947afb3b3214f365(value.protocol, path.concat(['protocol'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 */
			IntegerType: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
					if (value < 100) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":100}));
					}
					if (value > 999) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":999}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "type": "some value",
			 *   "size": 1,
			 *   "maxSize": 1,
			 *   "constraints": [
			 *     [
			 *       "some value"
			 *     ]
			 *   ]
			 * }
			 */
			PersistentVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.type != null) {
						errors = errors.concat(Validators.PersistentVolumeType(value.type, path.concat(['type'])));
					}
					if (value.size == null) {
						errors.push(new RAMLError(path.concat(['size']), context, "PROP_IS_MISSING", {name: 'size'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.size, path.concat(['size'])));
					}
					if (value.maxSize != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.maxSize, path.concat(['maxSize'])));
					}
					if (value.constraints != null) {
						errors = errors.concat(PrivateValidators.inlineVolumeConstraint_3b1f04aede5a1e865648311c626a62e2(value.constraints, path.concat(['constraints'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "size": 1,
			 *   "name": "some value",
			 *   "provider": "some value",
			 *   "options": {}
			 * }
			 */
			ExternalVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.size != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.size, path.concat(['size'])));
					}
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.name, path.concat(['name'])));
					}
					if (value.provider != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.provider, path.concat(['provider'])));
					}
					if (value.options != null) {
						errors = errors.concat(Validators.KVLabels(value.options, path.concat(['options'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Name: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[5].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9]*[a-z0-9])?$"}));
					}
					if (value.length > 63) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":63}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			PersistentVolumeType: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[10].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"root, path, mount"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 */
			VolumeConstraint: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.StringType(value, path.concat([i]))
						);
					}, errors);
					if (value.length < 2) {
						errors.push(new RAMLError(path, context, "ITEMS_MIN", {"value":2}));
					}
					if (value.length > 3) {
						errors.push(new RAMLError(path, context, "ITEMS_MAX", {"value":3}));
					}
				}
				return errors;
			},
		
		};
		
		// Expose validator functions, bound to local overrides
		Object.keys(Validators).forEach((function(key) {
			this[key] = Validators[key];
		}).bind(this));
		
		// Expose .clone function that allows further overrides to apply
		this.clone = function(cloneConfig) {
			return new RAMLValidator(Object.assign(config, cloneConfig));
		}
	}
	
	return new RAMLValidator();
	})();

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _objektiv = __webpack_require__(1674);
	
	var _objektiv2 = _interopRequireDefault(_objektiv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert an object path to a lens
	 *
	 * @param {Array} path - The array of the path components
	 * @param {function} [strategy] - The trategy to chose for missing elements
	 * @return {Objectiv.lens} Returns the lens to address the path
	 */
	function path2lens(path) {
	  var strategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _objektiv2.default.resolve.tryhard;
	
	  return path.reduce(function (parent, segment) {
	    if (isNaN(segment)) {
	      return parent.then(_objektiv2.default.makeAttrLens(segment, strategy));
	    } else {
	      return parent.then(_objektiv2.default.makeAtLens(segment, strategy));
	    }
	  }, _objektiv2.default.full);
	}
	
	var DataValidatorUtil = {
	  /**
	   * This is a shorthand function to collect a list of validation errors for
	   * the given input data, passed through an array of validation functions.
	   *
	   * @param {any} inputData - The data to pass to the validator(s)
	   * @param {array|function} validatorFn - The validation function(s)
	   * @returns {[{path, message}]} Returns an array with the errors
	   */
	  validate: function validate(inputData, validatorFn) {
	    if (!Array.isArray(validatorFn)) {
	      validatorFn = [validatorFn];
	    }
	
	    return validatorFn.reduce(function (errors, validator) {
	      return errors.concat(validator(inputData));
	    }, []);
	  },
	
	
	  /**
	   * This function converts an array of errors returned from `validate`
	   * and creates an object with the errors in the correct location.
	   *
	   * @param {[{path, message}]} errors - The array of errors
	   * @returns {Object} Returns an object with the errors in the correct paths
	   */
	  errorArrayToMap: function errorArrayToMap(errors) {
	    return errors.reduce(function (errorMap, error) {
	      // We cannot place root errors in the map
	      if (error.path.length === 0) {
	        return errorMap;
	      }
	
	      var lens = path2lens(error.path);
	      var message = error.message;
	      var prevMessage = lens.get(errorMap);
	
	      if (prevMessage) {
	        message = prevMessage + ", " + message;
	      }
	
	      return lens.set(errorMap, message);
	    }, {});
	  },
	  updateOnlyOnPath: function updateOnlyOnPath(oldList, newList, path) {
	    var pathStr = path.join(".");
	    var newErrors = newList.filter(function (error) {
	      return error.path.join(".") === pathStr;
	    });
	
	    // Strip from the old error list:
	    // - Errors that exist on the current path
	    // - Errors that were removed with the new list
	    var cleanOldList = oldList.filter(function (error) {
	      if (error.path.join(".") === pathStr) {
	        return false;
	      }
	
	      return newList.some(function (newError) {
	        return error.path.join(".") === newError.path.join(".");
	      });
	    });
	
	    // Append new errors
	    return cleanOldList.concat(newErrors);
	  },
	  stripErrorsOnPath: function stripErrorsOnPath(errorList, path) {
	    var pathStr = path.join(".");
	
	    return errorList.filter(function (error) {
	      return error.path.join(".") !== pathStr;
	    });
	  }
	};
	
	module.exports = DataValidatorUtil;

/***/ },
/* 1674 */,
/* 1675 */,
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullScreenModal = function (_React$Component) {
	  (0, _inherits3.default)(FullScreenModal, _React$Component);
	
	  function FullScreenModal() {
	    (0, _classCallCheck3.default)(this, FullScreenModal);
	    return (0, _possibleConstructorReturn3.default)(this, (FullScreenModal.__proto__ || (0, _getPrototypeOf2.default)(FullScreenModal)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FullScreenModal, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	
	      var geminiClasses = (0, _classnames2.default)({
	        "gm-scrollbar-container-flex": props.useGemini !== false
	      });
	
	      var modalHeight = null;
	
	      if (props.useGemini) {
	        modalHeight = "100%";
	      }
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        (0, _extends3.default)({
	          geminiClass: geminiClasses,
	          isFullScreen: true,
	          modalClass: "modal modal-full-screen",
	          modalHeight: modalHeight,
	          showHeader: true,
	          showFooter: false,
	          transitionNameModal: "modal-full-screen"
	        }, _Util2.default.omit(props, ["children"])),
	        props.children
	      );
	    }
	  }]);
	  return FullScreenModal;
	}(_react2.default.Component);
	
	FullScreenModal.defaultProps = {
	  useGemini: true
	};
	
	FullScreenModal.propTypes = {
	  children: _react2.default.PropTypes.node,
	  useGemini: _react2.default.PropTypes.bool
	};
	
	module.exports = FullScreenModal;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullScreenModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(FullScreenModalHeader, _React$Component);
	
	  function FullScreenModalHeader() {
	    (0, _classCallCheck3.default)(this, FullScreenModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (FullScreenModalHeader.__proto__ || (0, _getPrototypeOf2.default)(FullScreenModalHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FullScreenModalHeader, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	      var classes = (0, _dedupe2.default)("modal-full-screen-header pod", className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        children
	      );
	    }
	  }]);
	  return FullScreenModalHeader;
	}(_react2.default.Component);
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	FullScreenModalHeader.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: classProps
	};
	
	module.exports = FullScreenModalHeader;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullScreenModalHeaderActions = function (_React$Component) {
	  (0, _inherits3.default)(FullScreenModalHeaderActions, _React$Component);
	
	  function FullScreenModalHeaderActions() {
	    (0, _classCallCheck3.default)(this, FullScreenModalHeaderActions);
	    return (0, _possibleConstructorReturn3.default)(this, (FullScreenModalHeaderActions.__proto__ || (0, _getPrototypeOf2.default)(FullScreenModalHeaderActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FullScreenModalHeaderActions, [{
	    key: "getActions",
	    value: function getActions() {
	      var actions = this.props.actions;
	
	
	      if (!actions || actions.length === 0) {
	        return null;
	      }
	
	      return actions.map(function (_ref, index) {
	        var className = _ref.className,
	            clickHandler = _ref.clickHandler,
	            label = _ref.label,
	            node = _ref.node,
	            disabled = _ref.disabled;
	
	        if (node) {
	          return node;
	        }
	
	        var classes = (0, _dedupe2.default)("button flush-top", className);
	
	        return _react2.default.createElement(
	          "button",
	          {
	            className: classes,
	            disabled: disabled,
	            key: index,
	            onClick: clickHandler
	          },
	          label
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          type = _props.type;
	
	
	      var classes = (0, _dedupe2.default)("modal-full-screen-actions modal-full-screen-actions-" + type + " button-collection flush-vertical", className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getActions()
	      );
	    }
	  }]);
	  return FullScreenModalHeaderActions;
	}(_react2.default.Component);
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	FullScreenModalHeaderActions.propTypes = {
	  actions: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    className: classProps,
	    clickHandler: _react2.default.PropTypes.func,
	    label: _react2.default.PropTypes.node
	  })),
	  className: classProps,
	  type: _react2.default.PropTypes.oneOf(["primary", "secondary"]).isRequired
	};
	
	module.exports = FullScreenModalHeaderActions;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullScreenModalHeaderTitle = function (_React$Component) {
	  (0, _inherits3.default)(FullScreenModalHeaderTitle, _React$Component);
	
	  function FullScreenModalHeaderTitle() {
	    (0, _classCallCheck3.default)(this, FullScreenModalHeaderTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (FullScreenModalHeaderTitle.__proto__ || (0, _getPrototypeOf2.default)(FullScreenModalHeaderTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FullScreenModalHeaderTitle, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	      var classes = (0, _dedupe2.default)("modal-full-screen-header-title", className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        children
	      );
	    }
	  }]);
	  return FullScreenModalHeaderTitle;
	}(_react2.default.Component);
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	FullScreenModalHeaderTitle.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: classProps
	};
	
	module.exports = FullScreenModalHeaderTitle;

/***/ },
/* 1680 */
/***/ function(module, exports) {

	module.exports = (function() {
	
	const REPLACE_MESSAGE_TEMPLATE = /\{\{([^\}]+)\}\}/g;
	
	function RAMLError(path, context, type, _messageVariables) {
	  var messageVariables = _messageVariables || {};
	  var message = context.ERROR_MESSAGES[type];
	  Object.defineProperties(this, {
	    message: {
	      enumerable: true,
	      get: function() {
	        if (typeof message === 'function') {
	          return message(messageVariables, path);
	        }
	
	        return message.replace(REPLACE_MESSAGE_TEMPLATE, function(match) {
	          return ''+messageVariables[match.slice(2,-2)] || '';
	        });
	      }
	    },
	    path: {
	      enumerable: true,
	      value: path
	    },
	    type: {
	      enumerable: true,
	      value: type
	    },
	    variables: {
	      enumerable: true,
	      value: messageVariables
	    }
	  });
	}
	
	var DEFAULT_ERROR_MESSAGES = {
	  "ENUM": "Must be one of {{values}}",
	  "TYPE_NOT_STRING": "Must be a string",
	  "PROP_IS_MISSING": "Must be defined",
	  "TYPE_NOT_OBJECT": "Must be an object",
	  "NUMBER_TYPE": "Must be of type `{{type}}`",
	  "NUMBER_MIN": "Must be bigger than or equal to {{value}}",
	  "TYPE_NOT_INTEGER": "Must be an integer number",
	  "TYPE_NOT_NUMBER": "Must be a number",
	  "NUMBER_MAX": "Must be smaller than or equal to {{value}}",
	  "ITEMS_UNIQUE": "Must contain only unique items",
	  "TYPE_NOT_ARRAY": "Must be an array",
	  "STRING_PATTERN": "Must match the pattern `{{pattern}}`",
	  "LENGTH_MIN": "Must be at least {{value}} characters long",
	  "TYPE_NOT_DATETIME": "Must be a date/time string",
	  "ITEMS_MIN": "Must contain at least {{value}} items in the array",
	  "LENGTH_MAX": "Must be at most {{value}} characters long",
	  "TYPE_NOT_BOOLEAN": "Must be a boolean value"
	}
	
	var DEFAULT_CONTEXT = {
		ENUMS: [
			["fixed"],
			["youngest_first","oldest_first"],
			["disabled"],
			["unique","cluster","group_by","like","unlike","max_per"],
			["container","container/bridge","host"],
			["docker","appc"],
			["http","https"],
		],
		HELPERS: [
			new Float32Array(1),
		],
		REGEX: [
			new RegExp('^(\/?((\.\.)|(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9]))?($|\/))+$'),
			new RegExp('.*'),
			new RegExp('^[a-zA-Z_][a-zA-Z0-9_]{0,253}?$'),
			new RegExp('^[a-z0-9]([-a-z0-9]*[a-z0-9])?$'),
			new RegExp('^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$'),
		],
	}
	
	var RAMLValidator = function(config) {
		if (!config) config = {};
		var context = Object.assign({}, DEFAULT_CONTEXT);
		
		// Override errorMessages through config
		context.ERROR_MESSAGES = Object.assign(
			{},
			DEFAULT_ERROR_MESSAGES,
			config.errorMessages
		)
		
		var PrivateValidators = {
			/**
			 * 1
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int32
			 * - minimum: 0
			 */
			inlineIntegerType_1da39b1015745f6788e8467b4b016d08: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 0
			 */
			inlineNumberType_57bfd98cf72e8ce725369576269362ad: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 0
			 * - maximum: 1
			 */
			inlineNumberType_755aef13143071d7e09ebe3f57078b7f: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
					if (value > 1) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "fieldName": "hostname",
			 *     "operator": "UNIQUE"
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Constraint
			 * with the following constraints:
			 * 
			 * - uniqueItems: true
			 * - items: Constraint
			 */
			inlineConstraint_3b1f04aede5a1e865648311c626a62e2: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					if ((function() {
						var valuesSoFar = Object.create(null);
						for (var i = 0; i < value.length; ++i) {
							var val = JSON.stringify(value[i]);
							if (val in valuesSoFar) {
								return true;
							}
							valuesSoFar[val] = true;
						}
						return false;
					})()) {
						errors.push(new RAMLError(path, context, "ITEMS_UNIQUE"));
					}
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Constraint(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   "public-facing"
			 * ]
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - items: StringType
			 */
			inlineStringType_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.StringType(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of DateTimeType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(new Date(value).getTime())) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_DATETIME"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineStringType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "exec": {
			 *       "command": {
			 *         "shell": "some value"
			 *       },
			 *       "overrideEntrypoint": true
			 *     },
			 *     "resources": {
			 *       "cpus": 0.1,
			 *       "mem": 512,
			 *       "disk": 0.2,
			 *       "gpus": 1
			 *     },
			 *     "endpoints": [
			 *       {
			 *         "name": "some value",
			 *         "containerPort": 1,
			 *         "hostPort": 1,
			 *         "protocol": [
			 *           "some value"
			 *         ],
			 *         "labels": {},
			 *         "networkNames": [
			 *           "some value"
			 *         ]
			 *       }
			 *     ],
			 *     "image": {
			 *       "kind": "some value",
			 *       "id": "mesosphere/marathon:1.3.0",
			 *       "pullConfig": {
			 *         "secret": "some value"
			 *       },
			 *       "forcePull": true,
			 *       "labels": {}
			 *     },
			 *     "environment": {},
			 *     "user": "some value",
			 *     "healthCheck": {
			 *       "http": {
			 *         "endpoint": "some value",
			 *         "path": "some value",
			 *         "scheme": "HTTP"
			 *       },
			 *       "tcp": {
			 *         "endpoint": "some value"
			 *       },
			 *       "exec": {
			 *         "command": {
			 *           "shell": "some value"
			 *         }
			 *       },
			 *       "gracePeriodSeconds": 300,
			 *       "intervalSeconds": 60,
			 *       "maxConsecutiveFailures": 3,
			 *       "timeoutSeconds": 20,
			 *       "delaySeconds": 15
			 *     },
			 *     "volumeMounts": [
			 *       {
			 *         "name": "some value",
			 *         "mountPath": "some value",
			 *         "readOnly": true
			 *       }
			 *     ],
			 *     "artifacts": [
			 *       {
			 *         "uri": "http://download.me/file.tgz",
			 *         "extract": true,
			 *         "executable": true,
			 *         "cache": false
			 *       }
			 *     ],
			 *     "labels": {},
			 *     "lifecycle": {
			 *       "killGracePeriodSeconds": 1
			 *     },
			 *     "tty": true
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of PodContainer
			 * with the following constraints:
			 * 
			 * - items: PodContainer
			 * - minItems: 1
			 */
			inlinePodContainer_5023763c58cb378ebf05c94ca2bf36a7: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.PodContainer(value, path.concat([i]))
						);
					}, errors);
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "ITEMS_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "secret": "some value"
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of PodVolume
			 * with the following constraints:
			 * 
			 * - items: PodVolume
			 */
			inlinePodVolume_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.PodVolume(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "mode": "container",
			 *     "labels": {}
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Network
			 * with the following constraints:
			 * 
			 * - items: Network
			 */
			inlineNetwork_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Network(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * 0.2
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 0.1
			 * - format: double
			 */
			inlineNumberType_2198049c676f86df910c1952accf87e1: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0.1) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0.1}));
					}
				}
				return errors;
			},
		
			/**
			 * 512
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 32
			 * - format: double
			 */
			inlineNumberType_5fc3df80503e193197ced2bef998de82: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 32) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":32}));
					}
				}
				return errors;
			},
		
			/**
			 * 50
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 10
			 * - format: double
			 */
			inlineNumberType_6914d15a748f523af0fc18474685aa42: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 10) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":10}));
					}
				}
				return errors;
			},
		
			/**
			 * 0
			 * 
			 * This is an in-line specialization of IntegerType
			 * with the following constraints:
			 * 
			 * - format: int64
			 * - minimum: 0
			 */
			inlineIntegerType_b6d3b04861cdc2c21823de4e53983492: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (!((value % 1 === 0))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int64"}));
					}
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of Name
			 * with the following constraints:
			 * 
			 * - pattern: ^[a-z0-9]([-a-z0-9]*[a-z0-9])?$
			 * - maxLength: 63
			 * - minLength: 1
			 */
			inlineName_e959b65d3a390d46cacd062be5baabe7: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[3].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9]*[a-z0-9])?$"}));
					}
					if (value.length > 63) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":63}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "containerPort": 1,
			 *     "hostPort": 1,
			 *     "protocol": [
			 *       "some value"
			 *     ],
			 *     "labels": {},
			 *     "networkNames": [
			 *       "some value"
			 *     ]
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Endpoint
			 * with the following constraints:
			 * 
			 * - items: Endpoint
			 */
			inlineEndpoint_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Endpoint(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "name": "some value",
			 *     "mountPath": "some value",
			 *     "readOnly": true
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of VolumeMount
			 * with the following constraints:
			 * 
			 * - items: VolumeMount
			 */
			inlineVolumeMount_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.VolumeMount(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * [
			 *   {
			 *     "uri": "http://download.me/file.tgz",
			 *     "extract": true,
			 *     "executable": true,
			 *     "cache": false
			 *   }
			 * ]
			 * 
			 * This is an in-line specialization of Artifact
			 * with the following constraints:
			 * 
			 * - items: Artifact
			 */
			inlineArtifact_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Artifact(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * true
			 * 
			 * This is an in-line specialization of BooleanType
			 * with the following constraints:
			 * 
			 * 
			 */
			inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e: function(value, path) {
				var errors = [];
				path = path || [];
				if ((value !== false) && (value !== true)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_BOOLEAN"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of StringType
			 * with the following constraints:
			 * 
			 * - minLength: 1
			 */
			inlineStringType_8cef7a2a976678a19a8d836c3a53c236: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 * 
			 * This is an in-line specialization of NetworkName
			 * with the following constraints:
			 * 
			 * - pattern: ^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$
			 * - maxLength: 63
			 * - minLength: 1
			 */
			inlineNetworkName_d5930fd0fc0461b8008a443d59699e32: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[4].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9_]*[a-z0-9])?$"}));
					}
					if (value.length > 63) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":63}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * "container"
			 * 
			 * This is an in-line specialization of NetworkMode
			 * with the following constraints:
			 * 
			 * - enum: container,container/bridge,host
			 */
			inlineNetworkMode_4cccbb4c3c88d1078bf95c85c1818632: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[4].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"container, container/bridge, host"}));
					}
				}
				return errors;
			},
		
			/**
			 * 0.1
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 0.001
			 * - format: double
			 */
			inlineNumberType_5471becca47d41cedb309da969544f87: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0.001) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0.001}));
					}
				}
				return errors;
			},
		
			/**
			 * 0.2
			 * 
			 * This is an in-line specialization of NumberType
			 * with the following constraints:
			 * 
			 * - minimum: 0
			 * - format: double
			 */
			inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_NUMBER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
				}
				return errors;
			},
		
			/**
			 * "mesosphere/marathon:1.3.0"
			 * 
			 * This is an in-line specialization of Path
			 * with the following constraints:
			 * 
			 * - minLength: 1
			 * - maxLength: 1024
			 */
			inlinePath_293be7de6c009b1ca492ed5c5b0eafa1: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of Port
			 * with the following constraints:
			 * 
			 * - minimum: 1
			 * - maximum: 65535
			 * - format: int32
			 */
			inlinePort_8a1fd38080fb8d93e0f812222c697fb9: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (value < 1) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":1}));
					}
					if (value > 65535) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":65535}));
					}
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
				}
				return errors;
			},
		
			/**
			 * 1
			 * 
			 * This is an in-line specialization of AnyPort
			 * with the following constraints:
			 * 
			 * - minimum: 0
			 * - maximum: 65535
			 * - format: int32
			 */
			inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf: function(value, path) {
				var errors = [];
				path = path || [];
				if (isNaN(value) || (value % 1 !== 0)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_INTEGER"));
				} else {
					if (value < 0) {
						errors.push(new RAMLError(path, context, "NUMBER_MIN", {"value":0}));
					}
					if (value > 65535) {
						errors.push(new RAMLError(path, context, "NUMBER_MAX", {"value":65535}));
					}
					if (!((value % 1 === 0) && (value >= -2147483648) && (value <= 2147483647))) {
						errors.push(new RAMLError(path, context, "NUMBER_TYPE", {"type":"int32"}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 * 
			 * This is an in-line specialization of Name
			 * with the following constraints:
			 * 
			 * - items: Name
			 * - minItems: 1
			 */
			inlineName_5023763c58cb378ebf05c94ca2bf36a7: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Name(value, path.concat([i]))
						);
					}, errors);
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "ITEMS_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * [
			 *   "some value"
			 * ]
			 * 
			 * This is an in-line specialization of Name
			 * with the following constraints:
			 * 
			 * - items: Name
			 */
			inlineName_c16b318f4fe8b85b2a89ed06127bb779: function(value, path) {
				var errors = [];
				path = path || [];
				if (!Array.isArray(value)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_ARRAY"));
				} else {
					errors = value.reduce(function(errors, value, i) {
						return errors.concat(
							Validators.Name(value, path.concat([i]))
						);
					}, errors);
				}
				return errors;
			},
		
			/**
			 * "HTTP"
			 * 
			 * This is an in-line specialization of HttpScheme
			 * with the following constraints:
			 * 
			 * - enum: HTTP,HTTPS
			 */
			inlineHttpScheme_9daecb70f32aeec3a0f8567d3168714f: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[6].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"http, https"}));
					}
				}
				return errors;
			},
		
		};
		
		var Validators = {
			/**
			 * "some value"
			 */
			PodScalingPolicyType: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[0].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"fixed"}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "kind": "some value"
			 * }
			 */
			PodScalingPolicy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.kind == null) {
						errors.push(new RAMLError(path.concat(['kind']), context, "PROP_IS_MISSING", {name: 'kind'}));
					} else {
						errors = errors.concat(Validators.PodScalingPolicyType(value.kind, path.concat(['kind'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "instances": 1,
			 *   "kind": "some value"
			 * }
			 */
			FixedPodScalingPolicy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.kind == null) {
						errors.push(new RAMLError(path.concat(['kind']), context, "PROP_IS_MISSING", {name: 'kind'}));
					} else {
						errors = errors.concat(Validators.PodScalingPolicyType(value.kind, path.concat(['kind'])));
					}
					if (value.instances == null) {
						errors.push(new RAMLError(path.concat(['instances']), context, "PROP_IS_MISSING", {name: 'instances'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.instances, path.concat(['instances'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "backoff": 1,
			 *   "backoffFactor": 1.15,
			 *   "maxLaunchDelay": 3600
			 * }
			 */
			PodSchedulingBackoffStrategy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.backoff != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_57bfd98cf72e8ce725369576269362ad(value.backoff, path.concat(['backoff'])));
					}
					if (value.backoffFactor != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_57bfd98cf72e8ce725369576269362ad(value.backoffFactor, path.concat(['backoffFactor'])));
					}
					if (value.maxLaunchDelay != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_57bfd98cf72e8ce725369576269362ad(value.maxLaunchDelay, path.concat(['maxLaunchDelay'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "minimumHealthCapacity": 1,
			 *   "maximumOverCapacity": 1
			 * }
			 */
			PodUpgradeStrategy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.minimumHealthCapacity != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_755aef13143071d7e09ebe3f57078b7f(value.minimumHealthCapacity, path.concat(['minimumHealthCapacity'])));
					}
					if (value.maximumOverCapacity != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_755aef13143071d7e09ebe3f57078b7f(value.maximumOverCapacity, path.concat(['maximumOverCapacity'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "constraints": [
			 *     {
			 *       "fieldName": "hostname",
			 *       "operator": "UNIQUE"
			 *     }
			 *   ],
			 *   "acceptedResourceRoles": [
			 *     "public-facing"
			 *   ]
			 * }
			 */
			PodPlacementPolicy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.constraints != null) {
						errors = errors.concat(PrivateValidators.inlineConstraint_3b1f04aede5a1e865648311c626a62e2(value.constraints, path.concat(['constraints'])));
					}
					if (value.acceptedResourceRoles != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_c16b318f4fe8b85b2a89ed06127bb779(value.acceptedResourceRoles, path.concat(['acceptedResourceRoles'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "backoff": {
			 *     "backoff": 1,
			 *     "backoffFactor": 1.15,
			 *     "maxLaunchDelay": 3600
			 *   },
			 *   "upgrade": {
			 *     "minimumHealthCapacity": 1,
			 *     "maximumOverCapacity": 1
			 *   },
			 *   "placement": {
			 *     "constraints": [
			 *       {
			 *         "fieldName": "hostname",
			 *         "operator": "UNIQUE"
			 *       }
			 *     ],
			 *     "acceptedResourceRoles": [
			 *       "public-facing"
			 *     ]
			 *   },
			 *   "killSelection": "YOUNGEST_FIRST",
			 *   "unreachableStrategy": "disabled"
			 * }
			 */
			PodSchedulingPolicy: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.backoff != null) {
						errors = errors.concat(Validators.PodSchedulingBackoffStrategy(value.backoff, path.concat(['backoff'])));
					}
					if (value.upgrade != null) {
						errors = errors.concat(Validators.PodUpgradeStrategy(value.upgrade, path.concat(['upgrade'])));
					}
					if (value.placement != null) {
						errors = errors.concat(Validators.PodPlacementPolicy(value.placement, path.concat(['placement'])));
					}
					if (value.killSelection != null) {
						errors = errors.concat(Validators.KillSelection(value.killSelection, path.concat(['killSelection'])));
					}
					if (value.unreachableStrategy != null) {
						errors = errors.concat(Validators.UnreachableStrategy(value.unreachableStrategy, path.concat(['unreachableStrategy'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "id": "/ops/audit",
			 *   "labels": {},
			 *   "version": "some value",
			 *   "user": "some value",
			 *   "environment": {},
			 *   "containers": [
			 *     {
			 *       "name": "some value",
			 *       "exec": {
			 *         "command": {
			 *           "shell": "some value"
			 *         },
			 *         "overrideEntrypoint": true
			 *       },
			 *       "resources": {
			 *         "cpus": 0.1,
			 *         "mem": 512,
			 *         "disk": 0.2,
			 *         "gpus": 1
			 *       },
			 *       "endpoints": [
			 *         {
			 *           "name": "some value",
			 *           "containerPort": 1,
			 *           "hostPort": 1,
			 *           "protocol": [
			 *             "some value"
			 *           ],
			 *           "labels": {},
			 *           "networkNames": [
			 *             "some value"
			 *           ]
			 *         }
			 *       ],
			 *       "image": {
			 *         "kind": "some value",
			 *         "id": "mesosphere/marathon:1.3.0",
			 *         "pullConfig": {
			 *           "secret": "some value"
			 *         },
			 *         "forcePull": true,
			 *         "labels": {}
			 *       },
			 *       "environment": {},
			 *       "user": "some value",
			 *       "healthCheck": {
			 *         "http": {
			 *           "endpoint": "some value",
			 *           "path": "some value",
			 *           "scheme": "HTTP"
			 *         },
			 *         "tcp": {
			 *           "endpoint": "some value"
			 *         },
			 *         "exec": {
			 *           "command": {
			 *             "shell": "some value"
			 *           }
			 *         },
			 *         "gracePeriodSeconds": 300,
			 *         "intervalSeconds": 60,
			 *         "maxConsecutiveFailures": 3,
			 *         "timeoutSeconds": 20,
			 *         "delaySeconds": 15
			 *       },
			 *       "volumeMounts": [
			 *         {
			 *           "name": "some value",
			 *           "mountPath": "some value",
			 *           "readOnly": true
			 *         }
			 *       ],
			 *       "artifacts": [
			 *         {
			 *           "uri": "http://download.me/file.tgz",
			 *           "extract": true,
			 *           "executable": true,
			 *           "cache": false
			 *         }
			 *       ],
			 *       "labels": {},
			 *       "lifecycle": {
			 *         "killGracePeriodSeconds": 1
			 *       },
			 *       "tty": true
			 *     }
			 *   ],
			 *   "secrets": {},
			 *   "volumes": [
			 *     {
			 *       "name": "some value",
			 *       "secret": "some value"
			 *     }
			 *   ],
			 *   "networks": [
			 *     {
			 *       "name": "some value",
			 *       "mode": "container",
			 *       "labels": {}
			 *     }
			 *   ],
			 *   "scaling": {
			 *     "kind": "some value"
			 *   },
			 *   "scheduling": {
			 *     "backoff": {
			 *       "backoff": 1,
			 *       "backoffFactor": 1.15,
			 *       "maxLaunchDelay": 3600
			 *     },
			 *     "upgrade": {
			 *       "minimumHealthCapacity": 1,
			 *       "maximumOverCapacity": 1
			 *     },
			 *     "placement": {
			 *       "constraints": [
			 *         {
			 *           "fieldName": "hostname",
			 *           "operator": "UNIQUE"
			 *         }
			 *       ],
			 *       "acceptedResourceRoles": [
			 *         "public-facing"
			 *       ]
			 *     },
			 *     "killSelection": "YOUNGEST_FIRST",
			 *     "unreachableStrategy": "disabled"
			 *   },
			 *   "executorResources": {
			 *     "cpus": 0.2,
			 *     "mem": 512,
			 *     "disk": 50
			 *   }
			 * }
			 */
			Pod: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.id == null) {
						errors.push(new RAMLError(path.concat(['id']), context, "PROP_IS_MISSING", {name: 'id'}));
					} else {
						errors = errors.concat(Validators.PathId(value.id, path.concat(['id'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.version != null) {
						errors = errors.concat(PrivateValidators.inlineDateTimeType_d41d8cd98f00b204e9800998ecf8427e(value.version, path.concat(['version'])));
					}
					if (value.user != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.user, path.concat(['user'])));
					}
					if (value.environment != null) {
						errors = errors.concat(Validators.EnvVars(value.environment, path.concat(['environment'])));
					}
					if (value.containers == null) {
						errors.push(new RAMLError(path.concat(['containers']), context, "PROP_IS_MISSING", {name: 'containers'}));
					} else {
						errors = errors.concat(PrivateValidators.inlinePodContainer_5023763c58cb378ebf05c94ca2bf36a7(value.containers, path.concat(['containers'])));
					}
					if (value.secrets != null) {
						errors = errors.concat(Validators.Secrets(value.secrets, path.concat(['secrets'])));
					}
					if (value.volumes != null) {
						errors = errors.concat(PrivateValidators.inlinePodVolume_c16b318f4fe8b85b2a89ed06127bb779(value.volumes, path.concat(['volumes'])));
					}
					if (value.networks != null) {
						errors = errors.concat(PrivateValidators.inlineNetwork_c16b318f4fe8b85b2a89ed06127bb779(value.networks, path.concat(['networks'])));
					}
					if (value.scaling != null) {
						errors = errors.concat(Validators.PodScalingPolicy(value.scaling, path.concat(['scaling'])));
					}
					if (value.scheduling != null) {
						errors = errors.concat(Validators.PodSchedulingPolicy(value.scheduling, path.concat(['scheduling'])));
					}
					if (value.executorResources != null) {
						errors = errors.concat(Validators.ExecutorResources(value.executorResources, path.concat(['executorResources'])));
					}
				}
				return errors;
			},
		
			/**
			 * "YOUNGEST_FIRST"
			 */
			KillSelection: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[1].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"youngest_first, oldest_first"}));
					}
				}
				return errors;
			},
		
			/**
			 * "disabled"
			 */
			UnreachableStrategy: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.UnreachableDisabled(value, path),
					Validators.UnreachableEnabled(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * "/ops/audit"
			 */
			PathId: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[0].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^(\\/?((\\.\\.)|(([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9])\\.)*([a-z0-9]|[a-z0-9][a-z0-9\\-]*[a-z0-9]))?($|\\/))+$"}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			KVLabels: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[1].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			EnvVars: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[2].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(Validators.EnvVarValueOrSecret(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {}
			 */
			Secrets: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					var matched = [];
					var props = Object.keys(value);
					var regexProps = props;
					matched = regexProps.filter(function(key) {
						return context.REGEX[1].exec(key);
					});
					errors = matched.reduce(function(errors, property) {
						return errors.concat(Validators.SecretDef(value[property], path.concat([property])));
					}, errors);
				}
				return errors;
			},
		
			/**
			 * {
			 *   "cpus": 0.2,
			 *   "mem": 512,
			 *   "disk": 50
			 * }
			 */
			ExecutorResources: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.cpus != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_2198049c676f86df910c1952accf87e1(value.cpus, path.concat(['cpus'])));
					}
					if (value.mem != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_5fc3df80503e193197ced2bef998de82(value.mem, path.concat(['mem'])));
					}
					if (value.disk != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_6914d15a748f523af0fc18474685aa42(value.disk, path.concat(['disk'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "fieldName": "hostname",
			 *   "operator": "UNIQUE"
			 * }
			 */
			Constraint: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.fieldName == null) {
						errors.push(new RAMLError(path.concat(['fieldName']), context, "PROP_IS_MISSING", {name: 'fieldName'}));
					} else {
						errors = errors.concat(Validators.StringType(value.fieldName, path.concat(['fieldName'])));
					}
					if (value.operator == null) {
						errors.push(new RAMLError(path.concat(['operator']), context, "PROP_IS_MISSING", {name: 'operator'}));
					} else {
						errors = errors.concat(Validators.ConstraintOperator(value.operator, path.concat(['operator'])));
					}
					if (value.value != null) {
						errors = errors.concat(Validators.StringType(value.value, path.concat(['value'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			StringType: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "disabled"
			 */
			UnreachableDisabled: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[2].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"disabled"}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "inactiveAfterSeconds": 0,
			 *   "expungeAfterSeconds": 0
			 * }
			 */
			UnreachableEnabled: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.inactiveAfterSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.inactiveAfterSeconds, path.concat(['inactiveAfterSeconds'])));
					}
					if (value.expungeAfterSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_b6d3b04861cdc2c21823de4e53983492(value.expungeAfterSeconds, path.concat(['expungeAfterSeconds'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			EnvVarValueOrSecret: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.EnvVarValue(value, path),
					Validators.EnvVarSecret(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "exec": {
			 *     "command": {
			 *       "shell": "some value"
			 *     },
			 *     "overrideEntrypoint": true
			 *   },
			 *   "resources": {
			 *     "cpus": 0.1,
			 *     "mem": 512,
			 *     "disk": 0.2,
			 *     "gpus": 1
			 *   },
			 *   "endpoints": [
			 *     {
			 *       "name": "some value",
			 *       "containerPort": 1,
			 *       "hostPort": 1,
			 *       "protocol": [
			 *         "some value"
			 *       ],
			 *       "labels": {},
			 *       "networkNames": [
			 *         "some value"
			 *       ]
			 *     }
			 *   ],
			 *   "image": {
			 *     "kind": "some value",
			 *     "id": "mesosphere/marathon:1.3.0",
			 *     "pullConfig": {
			 *       "secret": "some value"
			 *     },
			 *     "forcePull": true,
			 *     "labels": {}
			 *   },
			 *   "environment": {},
			 *   "user": "some value",
			 *   "healthCheck": {
			 *     "http": {
			 *       "endpoint": "some value",
			 *       "path": "some value",
			 *       "scheme": "HTTP"
			 *     },
			 *     "tcp": {
			 *       "endpoint": "some value"
			 *     },
			 *     "exec": {
			 *       "command": {
			 *         "shell": "some value"
			 *       }
			 *     },
			 *     "gracePeriodSeconds": 300,
			 *     "intervalSeconds": 60,
			 *     "maxConsecutiveFailures": 3,
			 *     "timeoutSeconds": 20,
			 *     "delaySeconds": 15
			 *   },
			 *   "volumeMounts": [
			 *     {
			 *       "name": "some value",
			 *       "mountPath": "some value",
			 *       "readOnly": true
			 *     }
			 *   ],
			 *   "artifacts": [
			 *     {
			 *       "uri": "http://download.me/file.tgz",
			 *       "extract": true,
			 *       "executable": true,
			 *       "cache": false
			 *     }
			 *   ],
			 *   "labels": {},
			 *   "lifecycle": {
			 *     "killGracePeriodSeconds": 1
			 *   },
			 *   "tty": true
			 * }
			 */
			PodContainer: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.name, path.concat(['name'])));
					}
					if (value.exec != null) {
						errors = errors.concat(Validators.MesosExec(value.exec, path.concat(['exec'])));
					}
					if (value.resources == null) {
						errors.push(new RAMLError(path.concat(['resources']), context, "PROP_IS_MISSING", {name: 'resources'}));
					} else {
						errors = errors.concat(Validators.Resources(value.resources, path.concat(['resources'])));
					}
					if (value.endpoints != null) {
						errors = errors.concat(PrivateValidators.inlineEndpoint_c16b318f4fe8b85b2a89ed06127bb779(value.endpoints, path.concat(['endpoints'])));
					}
					if (value.image != null) {
						errors = errors.concat(Validators.Image(value.image, path.concat(['image'])));
					}
					if (value.environment != null) {
						errors = errors.concat(Validators.EnvVars(value.environment, path.concat(['environment'])));
					}
					if (value.user != null) {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.user, path.concat(['user'])));
					}
					if (value.healthCheck != null) {
						errors = errors.concat(Validators.HealthCheck(value.healthCheck, path.concat(['healthCheck'])));
					}
					if (value.volumeMounts != null) {
						errors = errors.concat(PrivateValidators.inlineVolumeMount_c16b318f4fe8b85b2a89ed06127bb779(value.volumeMounts, path.concat(['volumeMounts'])));
					}
					if (value.artifacts != null) {
						errors = errors.concat(PrivateValidators.inlineArtifact_c16b318f4fe8b85b2a89ed06127bb779(value.artifacts, path.concat(['artifacts'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.lifecycle != null) {
						errors = errors.concat(Validators.Lifecycle(value.lifecycle, path.concat(['lifecycle'])));
					}
					if (value.tty != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.tty, path.concat(['tty'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "source": "some value"
			 * }
			 */
			SecretDef: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.source == null) {
						errors.push(new RAMLError(path.concat(['source']), context, "PROP_IS_MISSING", {name: 'source'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.source, path.concat(['source'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "secret": "some value"
			 * }
			 */
			PodVolume: function(value, path) {
				var errors = [];
				path = path || [];
				errors = errors.concat([
					Validators.PodSecretVolume(value, path),
					Validators.HostVolume(value, path),
					Validators.EphemeralVolume(value, path),
				].sort(function(a, b) {
					return a.length - b.length;
				})[0]);
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "mode": "container",
			 *   "labels": {}
			 * }
			 */
			Network: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkName_d5930fd0fc0461b8008a443d59699e32(value.name, path.concat(['name'])));
					}
					if (value.mode != null) {
						errors = errors.concat(PrivateValidators.inlineNetworkMode_4cccbb4c3c88d1078bf95c85c1818632(value.mode, path.concat(['mode'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			ConstraintOperator: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[3].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"unique, cluster, group_by, like, unlike, max_per"}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			EnvVarValue: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
				}
				return errors;
			},
		
			/**
			 * {
			 *   "secret": "some value"
			 * }
			 */
			EnvVarSecret: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "command": {
			 *     "shell": "some value"
			 *   },
			 *   "overrideEntrypoint": true
			 * }
			 */
			MesosExec: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.command == null) {
						errors.push(new RAMLError(path.concat(['command']), context, "PROP_IS_MISSING", {name: 'command'}));
					} else {
						errors = errors.concat(Validators.MesosCommand(value.command, path.concat(['command'])));
					}
					if (value.overrideEntrypoint != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.overrideEntrypoint, path.concat(['overrideEntrypoint'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "cpus": 0.1,
			 *   "mem": 512,
			 *   "disk": 0.2,
			 *   "gpus": 1
			 * }
			 */
			Resources: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.cpus == null) {
						errors.push(new RAMLError(path.concat(['cpus']), context, "PROP_IS_MISSING", {name: 'cpus'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineNumberType_5471becca47d41cedb309da969544f87(value.cpus, path.concat(['cpus'])));
					}
					if (value.mem == null) {
						errors.push(new RAMLError(path.concat(['mem']), context, "PROP_IS_MISSING", {name: 'mem'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineNumberType_5471becca47d41cedb309da969544f87(value.mem, path.concat(['mem'])));
					}
					if (value.disk != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2(value.disk, path.concat(['disk'])));
					}
					if (value.gpus != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.gpus, path.concat(['gpus'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "kind": "some value",
			 *   "id": "mesosphere/marathon:1.3.0",
			 *   "pullConfig": {
			 *     "secret": "some value"
			 *   },
			 *   "forcePull": true,
			 *   "labels": {}
			 * }
			 */
			Image: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.kind == null) {
						errors.push(new RAMLError(path.concat(['kind']), context, "PROP_IS_MISSING", {name: 'kind'}));
					} else {
						errors = errors.concat(Validators.ImageType(value.kind, path.concat(['kind'])));
					}
					if (value.id == null) {
						errors.push(new RAMLError(path.concat(['id']), context, "PROP_IS_MISSING", {name: 'id'}));
					} else {
						errors = errors.concat(PrivateValidators.inlinePath_293be7de6c009b1ca492ed5c5b0eafa1(value.id, path.concat(['id'])));
					}
					if (value.pullConfig != null) {
						errors = errors.concat(Validators.DockerPullConfig(value.pullConfig, path.concat(['pullConfig'])));
					}
					if (value.forcePull != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.forcePull, path.concat(['forcePull'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "http": {
			 *     "endpoint": "some value",
			 *     "path": "some value",
			 *     "scheme": "HTTP"
			 *   },
			 *   "tcp": {
			 *     "endpoint": "some value"
			 *   },
			 *   "exec": {
			 *     "command": {
			 *       "shell": "some value"
			 *     }
			 *   },
			 *   "gracePeriodSeconds": 300,
			 *   "intervalSeconds": 60,
			 *   "maxConsecutiveFailures": 3,
			 *   "timeoutSeconds": 20,
			 *   "delaySeconds": 15
			 * }
			 */
			HealthCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.http != null) {
						errors = errors.concat(Validators.HttpHealthCheck(value.http, path.concat(['http'])));
					}
					if (value.tcp != null) {
						errors = errors.concat(Validators.TcpHealthCheck(value.tcp, path.concat(['tcp'])));
					}
					if (value.exec != null) {
						errors = errors.concat(Validators.CommandHealthCheck(value.exec, path.concat(['exec'])));
					}
					if (value.gracePeriodSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.gracePeriodSeconds, path.concat(['gracePeriodSeconds'])));
					}
					if (value.intervalSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.intervalSeconds, path.concat(['intervalSeconds'])));
					}
					if (value.maxConsecutiveFailures != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.maxConsecutiveFailures, path.concat(['maxConsecutiveFailures'])));
					}
					if (value.timeoutSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.timeoutSeconds, path.concat(['timeoutSeconds'])));
					}
					if (value.delaySeconds != null) {
						errors = errors.concat(PrivateValidators.inlineIntegerType_1da39b1015745f6788e8467b4b016d08(value.delaySeconds, path.concat(['delaySeconds'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "killGracePeriodSeconds": 1
			 * }
			 */
			Lifecycle: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.killGracePeriodSeconds != null) {
						errors = errors.concat(PrivateValidators.inlineNumberType_fa1b78972b7b05a3129cc02bb09d01d2(value.killGracePeriodSeconds, path.concat(['killGracePeriodSeconds'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "secret": "some value"
			 * }
			 */
			PodSecretVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.name, path.concat(['name'])));
					}
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "host": "some value"
			 * }
			 */
			HostVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.name, path.concat(['name'])));
					}
					if (value.host == null) {
						errors.push(new RAMLError(path.concat(['host']), context, "PROP_IS_MISSING", {name: 'host'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_d41d8cd98f00b204e9800998ecf8427e(value.host, path.concat(['host'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value"
			 * }
			 */
			EphemeralVolume: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.name, path.concat(['name'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "shell": "some value"
			 * }
			 */
			MesosCommand: function(value, path) {
				var errors = [];
				path = path || [];
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "containerPort": 1,
			 *   "hostPort": 1,
			 *   "protocol": [
			 *     "some value"
			 *   ],
			 *   "labels": {},
			 *   "networkNames": [
			 *     "some value"
			 *   ]
			 * }
			 */
			Endpoint: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.name, path.concat(['name'])));
					}
					if (value.containerPort != null) {
						errors = errors.concat(PrivateValidators.inlinePort_8a1fd38080fb8d93e0f812222c697fb9(value.containerPort, path.concat(['containerPort'])));
					}
					if (value.hostPort != null) {
						errors = errors.concat(PrivateValidators.inlineAnyPort_f0c659cc7c5ba17b44d6bdf5278be7bf(value.hostPort, path.concat(['hostPort'])));
					}
					if (value.protocol != null) {
						errors = errors.concat(PrivateValidators.inlineName_5023763c58cb378ebf05c94ca2bf36a7(value.protocol, path.concat(['protocol'])));
					}
					if (value.labels != null) {
						errors = errors.concat(Validators.KVLabels(value.labels, path.concat(['labels'])));
					}
					if (value.networkNames != null) {
						errors = errors.concat(PrivateValidators.inlineName_c16b318f4fe8b85b2a89ed06127bb779(value.networkNames, path.concat(['networkNames'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			ImageType: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (context.ENUMS[5].indexOf(value.toLowerCase()) === -1) {
						errors.push(new RAMLError(path, context, "ENUM", {"values":"docker, appc"}));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "secret": "some value"
			 * }
			 */
			DockerPullConfig: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.secret == null) {
						errors.push(new RAMLError(path.concat(['secret']), context, "PROP_IS_MISSING", {name: 'secret'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineStringType_8cef7a2a976678a19a8d836c3a53c236(value.secret, path.concat(['secret'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "endpoint": "some value",
			 *   "path": "some value",
			 *   "scheme": "HTTP"
			 * }
			 */
			HttpHealthCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.endpoint == null) {
						errors.push(new RAMLError(path.concat(['endpoint']), context, "PROP_IS_MISSING", {name: 'endpoint'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.endpoint, path.concat(['endpoint'])));
					}
					if (value.path != null) {
						errors = errors.concat(Validators.Path(value.path, path.concat(['path'])));
					}
					if (value.scheme != null) {
						errors = errors.concat(PrivateValidators.inlineHttpScheme_9daecb70f32aeec3a0f8567d3168714f(value.scheme, path.concat(['scheme'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "endpoint": "some value"
			 * }
			 */
			TcpHealthCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.endpoint == null) {
						errors.push(new RAMLError(path.concat(['endpoint']), context, "PROP_IS_MISSING", {name: 'endpoint'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.endpoint, path.concat(['endpoint'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "command": {
			 *     "shell": "some value"
			 *   }
			 * }
			 */
			CommandHealthCheck: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.command == null) {
						errors.push(new RAMLError(path.concat(['command']), context, "PROP_IS_MISSING", {name: 'command'}));
					} else {
						errors = errors.concat(Validators.MesosCommand(value.command, path.concat(['command'])));
					}
				}
				return errors;
			},
		
			/**
			 * {
			 *   "name": "some value",
			 *   "mountPath": "some value",
			 *   "readOnly": true
			 * }
			 */
			VolumeMount: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.name == null) {
						errors.push(new RAMLError(path.concat(['name']), context, "PROP_IS_MISSING", {name: 'name'}));
					} else {
						errors = errors.concat(PrivateValidators.inlineName_e959b65d3a390d46cacd062be5baabe7(value.name, path.concat(['name'])));
					}
					if (value.mountPath == null) {
						errors.push(new RAMLError(path.concat(['mountPath']), context, "PROP_IS_MISSING", {name: 'mountPath'}));
					} else {
						errors = errors.concat(PrivateValidators.inlinePath_293be7de6c009b1ca492ed5c5b0eafa1(value.mountPath, path.concat(['mountPath'])));
					}
					if (value.readOnly != null) {
						errors = errors.concat(Validators.BooleanType(value.readOnly, path.concat(['readOnly'])));
					}
				}
				return errors;
			},
		
			/**
			 * "{\n  \"uri\": \"http://download.me/file.tgz\",\n  \"extract\": true,\n  \"executable\": true,\n  \"cache\": false\n}\n"
			 */
			Artifact: function(value, path) {
				var errors = [];
				path = path || [];
				if ((typeof value != "object") || (value === null)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_OBJECT"));
				} else {
					if (value.uri == null) {
						errors.push(new RAMLError(path.concat(['uri']), context, "PROP_IS_MISSING", {name: 'uri'}));
					} else {
						errors = errors.concat(Validators.Uri(value.uri, path.concat(['uri'])));
					}
					if (value.extract != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.extract, path.concat(['extract'])));
					}
					if (value.executable != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.executable, path.concat(['executable'])));
					}
					if (value.cache != null) {
						errors = errors.concat(PrivateValidators.inlineBooleanType_d41d8cd98f00b204e9800998ecf8427e(value.cache, path.concat(['cache'])));
					}
					if (value.destPath != null) {
						errors = errors.concat(Validators.Path(value.destPath, path.concat(['destPath'])));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Path: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * true
			 */
			BooleanType: function(value, path) {
				var errors = [];
				path = path || [];
				if ((value !== false) && (value !== true)) {
					errors.push(new RAMLError(path, context, "TYPE_NOT_BOOLEAN"));
				} else {
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Uri: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
					if (value.length > 1024) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":1024}));
					}
				}
				return errors;
			},
		
			/**
			 * "some value"
			 */
			Name: function(value, path) {
				var errors = [];
				path = path || [];
				if (typeof value != "string") {
					errors.push(new RAMLError(path, context, "TYPE_NOT_STRING"));
				} else {
					if (!context.REGEX[3].exec(value)) {
						errors.push(new RAMLError(path, context, "STRING_PATTERN", {"pattern":"^[a-z0-9]([-a-z0-9]*[a-z0-9])?$"}));
					}
					if (value.length > 63) {
						errors.push(new RAMLError(path, context, "LENGTH_MAX", {"value":63}));
					}
					if (value.length < 1) {
						errors.push(new RAMLError(path, context, "LENGTH_MIN", {"value":1}));
					}
				}
				return errors;
			},
		
		};
		
		// Expose validator functions, bound to local overrides
		Object.keys(Validators).forEach((function(key) {
			this[key] = Validators[key];
		}).bind(this));
		
		// Expose .clone function that allows further overrides to apply
		this.clone = function(cloneConfig) {
			return new RAMLValidator(Object.assign(config, cloneConfig));
		}
	}
	
	return new RAMLValidator();
	})();

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCKER = _ContainerConstants2.default.type.DOCKER;
	
	
	var DEFAULT_APP_RESOURCES = { cpus: 0.1, mem: 128 };
	var DEFAULT_APP_CONTAINER = { container: { type: DOCKER } };
	var DEFAULT_APP_SPEC = (0, _assign2.default)({ instances: 1, portDefinitions: [] }, DEFAULT_APP_CONTAINER, DEFAULT_APP_RESOURCES);
	
	module.exports = {
	  DEFAULT_APP_RESOURCES: DEFAULT_APP_RESOURCES,
	  DEFAULT_APP_SPEC: DEFAULT_APP_SPEC
	};

/***/ },
/* 1682 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  type: {
	    MESOS: "MESOS",
	    DOCKER: "DOCKER"
	  },
	  labelMap: {
	    DOCKER: "Docker Engine",
	    MESOS: "Universal Container Runtime (UCR)"
	  }
	};

/***/ },
/* 1683 */
/***/ function(module, exports) {

	"use strict";
	
	var DEFAULT_POD_RESOURCES = { cpus: 0.1, mem: 128 };
	var DEFAULT_POD_SCALING = { kind: "fixed", instances: 1 };
	var DEFAULT_POD_CONTAINER = {
	  name: "container-1",
	  resources: DEFAULT_POD_RESOURCES
	};
	var DEFAULT_POD_SPEC = {
	  containers: [DEFAULT_POD_CONTAINER],
	  scaling: DEFAULT_POD_SCALING
	};
	
	module.exports = {
	  DEFAULT_POD_CONTAINER: DEFAULT_POD_CONTAINER,
	  DEFAULT_POD_RESOURCES: DEFAULT_POD_RESOURCES,
	  DEFAULT_POD_SCALING: DEFAULT_POD_SCALING,
	  DEFAULT_POD_SPEC: DEFAULT_POD_SPEC
	};

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldTextarea = __webpack_require__(1686);
	
	var _FieldTextarea2 = _interopRequireDefault(_FieldTextarea);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Container = __webpack_require__(1689);
	
	var _Containers = __webpack_require__(1696);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appPaths = {
	  cmd: "cmd",
	  containerName: "",
	  cpus: "cpus",
	  image: "{basePath}.docker.image",
	  mem: "mem",
	  type: "{basePath}.type"
	};
	
	var podPaths = {
	  cmd: "{basePath}.exec.command.shell",
	  containerName: "{basePath}.name",
	  cpus: "{basePath}.resources.cpus",
	  image: "{basePath}.image.id",
	  mem: "{basePath}.resources.mem",
	  type: "{basePath}.type"
	};
	
	var ContainerServiceFormSection = function (_Component) {
	  (0, _inherits3.default)(ContainerServiceFormSection, _Component);
	
	  function ContainerServiceFormSection() {
	    (0, _classCallCheck3.default)(this, ContainerServiceFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ContainerServiceFormSection.__proto__ || (0, _getPrototypeOf2.default)(ContainerServiceFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContainerServiceFormSection, [{
	    key: "getFieldPath",
	    value: function getFieldPath(basePath, fieldName) {
	      if (this.props.service instanceof _PodSpec2.default) {
	        return podPaths[fieldName].replace("{basePath}", basePath);
	      }
	
	      return appPaths[fieldName].replace("{basePath}", basePath);
	    }
	  }, {
	    key: "getCMDLabel",
	    value: function getCMDLabel() {
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "The command value will be wrapped by the underlying Mesos executor via /bin/sh -c ${cmd}. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/application-basics.html",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FieldLabel2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroupHeading2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            { primary: true },
	            "Command"
	          ),
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            null,
	            _react2.default.createElement(
	              _reactjsComponents.Tooltip,
	              {
	                content: tooltipContent,
	                interactive: true,
	                wrapText: true,
	                maxWidth: 300
	              },
	              _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getImageLabel",
	    value: function getImageLabel() {
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Enter a Docker image or browse ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://hub.docker.com/explore/", target: "_blank" },
	          "Docker Hub"
	        ),
	        " to find more. You can also enter an image from your private registry. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://github.com/dcos/examples/tree/master/registry/1.8",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FieldLabel2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroupHeading2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            { primary: true },
	            "Container Image"
	          ),
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            null,
	            _react2.default.createElement(
	              _reactjsComponents.Tooltip,
	              {
	                content: tooltipContent,
	                interactive: true,
	                wrapText: true,
	                maxWidth: 300
	              },
	              _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getContainerNameField",
	    value: function getContainerNameField() {
	      var _props = this.props,
	          data = _props.data,
	          errors = _props.errors,
	          path = _props.path,
	          service = _props.service;
	
	      if (!(service instanceof _PodSpec2.default)) {
	        return null;
	      }
	
	      var containerNamePath = this.getFieldPath(path, "containerName");
	      var containerName = (0, _Util.findNestedPropertyInObject)(data, containerNamePath);
	      var containerNameErrors = (0, _Util.findNestedPropertyInObject)(errors, containerNamePath);
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          {
	            className: "column-6",
	            showError: Boolean(containerNameErrors)
	          },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            "Container Name"
	          ),
	          _react2.default.createElement(_FieldInput2.default, { name: containerNamePath, value: containerName }),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            containerNameErrors
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          data = _props2.data,
	          errors = _props2.errors,
	          path = _props2.path;
	
	      var imagePath = this.getFieldPath(path, "image");
	      var image = (0, _Util.findNestedPropertyInObject)(data, imagePath);
	      var imageErrors = (0, _Util.findNestedPropertyInObject)(errors, imagePath);
	      var cpusPath = this.getFieldPath(path, "cpus");
	      var cpusErrors = (0, _Util.findNestedPropertyInObject)(errors, cpusPath);
	      var memPath = this.getFieldPath(path, "mem");
	      var memErrors = (0, _Util.findNestedPropertyInObject)(errors, memPath);
	      var cmdPath = this.getFieldPath(path, "cmd");
	      var cmdErrors = (0, _Util.findNestedPropertyInObject)(errors, cmdPath);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pod pod-short flush-horizontal flush-bottom" },
	        this.getContainerNameField(),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-6", showError: Boolean(imageErrors) },
	            this.getImageLabel(),
	            _react2.default.createElement(_FieldInput2.default, { name: imagePath, value: image }),
	            _react2.default.createElement(
	              _FieldHelp2.default,
	              null,
	              "Enter a Docker image you want to run, e.g. nginx."
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              imageErrors
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-3", showError: Boolean(cpusErrors) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { className: "text-no-transform" },
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                { required: true },
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  "CPUs"
	                )
	              )
	            ),
	            _react2.default.createElement(_FieldInput2.default, {
	              min: "0.001",
	              name: cpusPath,
	              step: "any",
	              type: "number",
	              value: (0, _Util.findNestedPropertyInObject)(data, cpusPath)
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              cpusErrors
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-3", showError: Boolean(memErrors) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { className: "text-no-transform" },
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                { required: true },
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Memory (MiB)"
	                )
	              )
	            ),
	            _react2.default.createElement(_FieldInput2.default, {
	              min: "0.001",
	              name: memPath,
	              step: "any",
	              type: "number",
	              value: (0, _Util.findNestedPropertyInObject)(data, memPath)
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              memErrors
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12", showError: Boolean(cmdErrors) },
	            this.getCMDLabel(),
	            _react2.default.createElement(_FieldTextarea2.default, {
	              name: cmdPath,
	              value: (0, _Util.findNestedPropertyInObject)(data, cmdPath)
	            }),
	            _react2.default.createElement(
	              _FieldHelp2.default,
	              null,
	              "A shell command for your container to execute."
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              cmdErrors
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ContainerServiceFormSection;
	}(_react.Component);
	
	ContainerServiceFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {},
	
	  path: "container"
	};
	
	ContainerServiceFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func,
	  path: _react2.default.PropTypes.string
	};
	
	ContainerServiceFormSection.configReducers = {
	  container: _Container.FormReducer,
	  containers: _Containers.FormReducer
	};
	
	module.exports = ContainerServiceFormSection;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldHelp = function FieldHelp(props) {
	  var className = props.className,
	      textTransform = props.textTransform;
	
	  var classes = (0, _dedupe2.default)("form-control-feedback", className, {
	    "text-uppercase": textTransform === "uppercase",
	    "text-no-transform": textTransform === "none"
	  });
	
	  return _react2.default.createElement("p", (0, _extends3.default)({ className: classes }, (0, _Util.omit)(props, (0, _keys2.default)(FieldHelp.propTypes))));
	};
	
	FieldHelp.defaultProps = {
	  textTransform: "none"
	};
	
	FieldHelp.propTypes = {
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  textTransform: _react2.default.PropTypes.oneOf(["none", "uppercase"])
	};
	
	module.exports = FieldHelp;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldTextarea = function FieldTextarea(props) {
	  var className = props.className;
	
	  var classes = (0, _dedupe2.default)("form-control", className);
	
	  return _react2.default.createElement("textarea", (0, _extends3.default)({ className: classes }, (0, _Util.omit)(props, ["className"])));
	};
	
	FieldTextarea.defaultProps = {
	  onChange: function onChange() {},
	
	  value: ""
	};
	
	FieldTextarea.propTypes = {
	  onChange: _react2.default.PropTypes.func,
	  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]),
	
	  // Classes
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = FieldTextarea;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function injectAsteriskNode(children) {
	  var asteriskNode = _react2.default.createElement(
	    _FormGroupHeadingContent2.default,
	    { className: "text-danger", key: "asterisk" },
	    "*"
	  );
	  var nextChildren = _react2.default.Children.toArray(children);
	
	  nextChildren.splice(1, 0, asteriskNode);
	
	  return nextChildren;
	}
	
	function FormGroupHeading(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      required = _ref.required;
	
	  var classes = (0, _classnames2.default)("form-group-heading", className);
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes },
	    required ? injectAsteriskNode(children) : children
	  );
	}
	
	FormGroupHeading.defaultProps = {
	  required: false
	};
	
	FormGroupHeading.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  required: _react2.default.PropTypes.bool
	};
	
	module.exports = FormGroupHeading;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTitle(children) {
	  if (typeof children === "string") {
	    return children;
	  }
	
	  if (_Config2.default.environment === "development") {
	    console.warn("Primary FormGroupHeadingContent elements should be given " + "a title attribute.");
	  }
	
	  return null;
	}
	
	function FormGroupHeadingContent(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      primary = _ref.primary,
	      title = _ref.title;
	
	  if (children == null) {
	    return _react2.default.createElement("noscript", null);
	  }
	
	  var classes = (0, _classnames2.default)("form-group-heading-content", className, {
	    "form-group-heading-content-primary": primary
	  });
	
	  if (primary && !title) {
	    title = getTitle(children);
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes, title: title },
	    children
	  );
	}
	
	FormGroupHeadingContent.defaultProps = {
	  primary: false
	};
	
	FormGroupHeadingContent.propTypes = {
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  primary: _react2.default.PropTypes.bool,
	  title: _react2.default.PropTypes.string
	};
	
	module.exports = FormGroupHeadingContent;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Util = __webpack_require__(982);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ParserUtil = __webpack_require__(1662);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _Volumes = __webpack_require__(1691);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _Docker = __webpack_require__(1693);
	
	var _Docker2 = _interopRequireDefault(_Docker);
	
	var _PortMappingsReducer = __webpack_require__(1694);
	
	var _PortMappingsReducer2 = _interopRequireDefault(_PortMappingsReducer);
	
	var _VipLabelUtil = __webpack_require__(1695);
	
	var _VipLabelUtil2 = _interopRequireDefault(_VipLabelUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Networking$type = _Networking2.default.type,
	    BRIDGE = _Networking$type.BRIDGE,
	    HOST = _Networking$type.HOST,
	    CONTAINER = _Networking$type.CONTAINER;
	var _ContainerConstants$t = _ContainerConstants2.default.type,
	    DOCKER = _ContainerConstants$t.DOCKER,
	    MESOS = _ContainerConstants$t.MESOS;
	
	
	var containerJSONReducer = (0, _ReducerUtil.combineReducers)({
	  volumes: _Volumes.JSONReducer,
	  type: function type(state, _ref) {
	    var _type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.hasImage == null) {
	      this.hasImage = false;
	    }
	
	    if (this.noState == null) {
	      this.noState = true;
	    }
	
	    if (this.hasVolumes == null) {
	      this.hasVolumes = [];
	    }
	
	    var joinedPath = path.join(".");
	    if (_type === _TransactionTypes.SET && joinedPath === "container.docker.image") {
	      this.hasImage = !_ValidatorUtil2.default.isEmpty(value);
	    }
	
	    if (path[0] === "localVolumes" || path[0] === "externalVolumes") {
	      switch (_type) {
	        case _TransactionTypes.ADD_ITEM:
	          this.hasVolumes.push(true);
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          this.hasVolumes = this.hasVolumes.filter(function (item, index) {
	            return index !== value;
	          });
	      }
	    }
	
	    if (_type === _TransactionTypes.SET && joinedPath === "container.type") {
	      this.noState = false;
	
	      return value;
	    }
	
	    if (value === MESOS) {
	      this.noState = true;
	    }
	
	    var volumesState = null;
	
	    if (this.hasVolumes.length !== 0) {
	      volumesState = MESOS;
	    }
	
	    if (this.noState) {
	      return volumesState;
	    }
	
	    return state;
	  },
	  docker: function docker(_, _ref2, index) {
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    if (this.internalState == null) {
	      this.internalState = {};
	    }
	
	    // Passing down the index as well, for reducers to use context
	    this.internalState = (0, _Docker2.default)(this.internalState, { type: type, path: path, value: value }, index);
	
	    var joinedPath = path && path.join(".");
	
	    if (type === _TransactionTypes.SET && joinedPath === "container.docker") {
	      this.internalState = (0, _assign2.default)({}, this.internalState, value);
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "container.type") {
	      this.containerType = value;
	    }
	
	    if (!_ValidatorUtil2.default.isEmpty(this.internalState)) {
	      return (0, _assign2.default)({}, this.internalState);
	    }
	  },
	  portMappings: function portMappings(state, action) {
	    var _this = this;
	
	    var _action$path = action.path,
	        path = _action$path === undefined ? [] : _action$path,
	        value = action.value,
	        type = action.type;
	
	    if (!this.appState) {
	      this.appState = {
	        id: "",
	        networkType: HOST
	      };
	    }
	    if (!this.containerType) {
	      this.containerType = MESOS;
	    }
	
	    var joinedPath = path.join(".");
	    if (type === _TransactionTypes.SET && joinedPath === "container.type") {
	      this.containerType = value;
	    }
	
	    if (joinedPath === "networks.0.network" && value != null) {
	      var _value$split = value.split("."),
	          _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	          mode = _value$split2[0],
	          _name = _value$split2[1];
	
	      this.appState.networkType = mode;
	    }
	    if (joinedPath === "networks.0.mode" && value != null) {
	      this.appState.networkType = value;
	    }
	
	    if (joinedPath === "id" && Boolean(value)) {
	      this.appState.id = value;
	    }
	
	    // Apply PortMappingsReducer to retrieve updated local state
	    // Store the change no matter what network type we have
	    this.portDefinitions = (0, _PortMappingsReducer2.default)(this.portDefinitions, action);
	
	    // We only want portMappings for networks of type BRIDGE or CONTAINER
	    if (this.appState.networkType !== BRIDGE && this.appState.networkType !== CONTAINER) {
	      return null;
	    }
	
	    // Convert portDefinitions to portMappings
	    return this.portDefinitions.map(function (portDefinition, index) {
	      var vipLabel = "VIP_" + index;
	      var vipPort = Number(portDefinition.vipPort) || null;
	      var containerPort = Number(portDefinition.containerPort) || 0;
	      var servicePort = parseInt(portDefinition.servicePort, 10) || null;
	      var defaultVipPort = vipPort || containerPort;
	      var hostPort = Number(portDefinition.hostPort) || 0;
	      var protocol = _PortDefinitionConstants.PROTOCOLS.filter(function (protocol) {
	        return portDefinition.protocol[protocol];
	      }).join(",");
	
	      // Do not expose hostPort or protocol, when portMapping is turned off
	      if (_this.appState.networkType === CONTAINER && !portDefinition.portMapping) {
	        hostPort = null;
	        protocol = null;
	      }
	
	      // Prefer container port
	      // because this is what a user would expect to get load balanced
	      var labels = _VipLabelUtil2.default.generateVipLabel(_this.appState.id, portDefinition, vipLabel, vipPort || defaultVipPort);
	
	      return {
	        containerPort: containerPort,
	        hostPort: hostPort,
	        labels: labels,
	        protocol: protocol,
	        servicePort: servicePort,
	        name: portDefinition.name
	      };
	    });
	  }
	});
	
	var containerReducer = (0, _ReducerUtil.combineReducers)({
	  type: function type(state, _ref3) {
	    var _type2 = _ref3.type,
	        path = _ref3.path,
	        value = _ref3.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	    if (_type2 === _TransactionTypes.SET && joinedPath === "container.type") {
	      return value;
	    }
	
	    return state;
	  },
	  docker: function docker(_, _ref4, index) {
	    var _this2 = this;
	
	    var type = _ref4.type,
	        path = _ref4.path,
	        value = _ref4.value;
	
	    if (this.internalState == null) {
	      this.internalState = {};
	    }
	
	    // Passing down the index as well, for reducers to use context
	    this.internalState = (0, _Docker2.default)(this.internalState, { type: type, path: path, value: value }, index);
	
	    var joinedPath = path && path.join(".");
	    if (type === _TransactionTypes.SET && joinedPath === "container.type") {
	      this.containerType = value;
	    }
	
	    if (!_ValidatorUtil2.default.isEmpty(this.internalState)) {
	      var newState = (0, _assign2.default)({}, this.internalState);
	      (0, _keys2.default)(this.internalState).forEach(function (key) {
	        if (_ValidatorUtil2.default.isEmpty(_this2.internalState[key])) {
	          delete newState[key];
	        }
	      });
	
	      return newState;
	    }
	  }
	});
	
	module.exports = {
	  JSONReducer: function JSONReducer(_) {
	    if (this.internalState == null) {
	      this.internalState = {};
	    }
	
	    if (this.isMesosRuntime == null) {
	      this.isMesosRuntime = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var _args$ = args[0],
	        type = _args$.type,
	        path = _args$.path,
	        value = _args$.value;
	
	
	    if (type === _TransactionTypes.SET && path.join(".") === "container.type") {
	      this.isMesosRuntime = value === MESOS;
	    }
	
	    var newState = (0, _assign2.default)({}, containerJSONReducer.apply(this, [this.internalState].concat(args)));
	
	    this.internalState = newState;
	
	    if (_ValidatorUtil2.default.isEmpty(newState.docker)) {
	      delete newState.docker;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState.docker.image) && newState.type !== DOCKER) {
	      delete newState.docker;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState.type)) {
	      newState.type = null;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState)) {
	      return null;
	    }
	
	    return newState;
	  },
	  FormReducer: function FormReducer(_) {
	    if (this.internalState == null) {
	      this.internalState = {};
	    }
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    var newState = (0, _assign2.default)({}, containerReducer.apply(this, [this.internalState].concat(args)));
	
	    this.internalState = newState;
	
	    if (_ValidatorUtil2.default.isEmpty(newState.docker)) {
	      delete newState.docker;
	    } else if (_ValidatorUtil2.default.isEmpty(newState.type)) {
	      delete newState.docker;
	    } else if (this.isMesosRuntime && !_ValidatorUtil2.default.isEmpty(newState.docker)) {
	      delete newState.docker;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState.volumes)) {
	      delete newState.volumes;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState.type)) {
	      delete newState.type;
	    }
	
	    if (_ValidatorUtil2.default.isEmpty(newState)) {
	      return null;
	    }
	
	    return newState;
	  },
	
	
	  JSONParser: (0, _ParserUtil.combineParsers)([function (state) {
	    var value = (0, _Util.findNestedPropertyInObject)(state, "container.type");
	
	    if (value == null) {
	      value = MESOS;
	    }
	
	    return new _Transaction2.default(["container", "type"], value);
	  }, (0, _ParserUtil.simpleParser)(["container", DOCKER.toLowerCase()]), (0, _ParserUtil.simpleParser)(["container", DOCKER.toLowerCase(), "image"]), (0, _ParserUtil.simpleParser)(["container", MESOS.toLowerCase(), "image"]), (0, _ParserUtil.simpleParser)(["container", DOCKER.toLowerCase(), "forcePullImage"]), (0, _ParserUtil.simpleParser)(["container", MESOS.toLowerCase(), "forcePullImage"]), (0, _ParserUtil.simpleParser)(["container", DOCKER.toLowerCase(), "privileged"]), (0, _ParserUtil.simpleParser)(["container", MESOS.toLowerCase(), "privileged"])])
	};

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NETWORK_MODES = [["host", "HOST"], ["container", "CONTAINER"], ["container/bridge", "BRIDGE"]];
	
	var jsonToInternal = NETWORK_MODES.reduce(function (memo, tuple) {
	  var _tuple = (0, _slicedToArray3.default)(tuple, 2),
	      jsonType = _tuple[0],
	      internalType = _tuple[1];
	
	  memo[jsonType] = internalType;
	
	  return memo;
	}, {});
	
	var internalToJson = NETWORK_MODES.reduce(function (memo, tuple) {
	  var _tuple2 = (0, _slicedToArray3.default)(tuple, 2),
	      jsonType = _tuple2[0],
	      internalType = _tuple2[1];
	
	  memo[internalType] = jsonType;
	
	  return memo;
	}, {});
	
	var Networking = {
	  jsonToInternal: jsonToInternal,
	  internalToJson: internalToJson,
	  type: {
	    BRIDGE: "BRIDGE",
	    CONTAINER: "CONTAINER",
	    HOST: "HOST",
	    USER: "USER"
	  },
	  L4LB_ADDRESS: ".marathon.l4lb.thisdcos.directory",
	  VIP_LABEL_REGEX: /^VIP_[0-9]+$/,
	  VIP_LABEL_VALUE_REGEX: /([\w\d_\-./]+):(\d+)/
	};
	
	module.exports = Networking;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Util = __webpack_require__(982);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ContainerConstants$t = _ContainerConstants2.default.type,
	    MESOS = _ContainerConstants$t.MESOS,
	    DOCKER = _ContainerConstants$t.DOCKER;
	
	
	var mapLocalVolumes = function mapLocalVolumes(volume) {
	  if (volume.type === "PERSISTENT") {
	    return {
	      persistent: volume.persistent || {},
	      mode: volume.mode,
	      containerPath: volume.containerPath
	    };
	  }
	
	  return {
	    containerPath: volume.containerPath,
	    hostPath: volume.hostPath,
	    mode: volume.mode
	  };
	};
	
	var mapExternalVolumes = function mapExternalVolumes(volume) {
	  if (this.runtimeType === DOCKER && volume.external.size != null) {
	    return (0, _assign2.default)({}, volume, {
	      external: (0, _Util.omit)(volume.external, ["size"])
	    });
	  }
	
	  return volume;
	};
	
	function reduceVolumes(state, _ref) {
	  var type = _ref.type,
	      path = _ref.path,
	      value = _ref.value;
	
	  if (path == null) {
	    return state;
	  }
	
	  // `this` is a context which is given to every reducer so it could
	  // cache information.
	  // In this case we are caching an two array's one for the localVolumes
	  // and one for externalVolumes we need this so that there index is
	  // fitting with the ones in ExternalVolumes. we combine them before
	  // returning.
	  if (this.externalVolumes == null) {
	    this.externalVolumes = [];
	  }
	
	  if (this.localVolumes == null) {
	    this.localVolumes = [];
	  }
	
	  if (this.unknownVolumes == null) {
	    this.unknownVolumes = [];
	  }
	
	  if (this.dockerImage == null) {
	    this.dockerImage = false;
	  }
	
	  if (this.runtimeType == null) {
	    this.runtimeType = MESOS;
	  }
	
	  var joinedPath = path.join(".");
	
	  if (joinedPath === "container.docker.image") {
	    this.dockerImage = value !== "";
	  }
	
	  if (joinedPath === "container.type") {
	    this.dockerImage = value !== MESOS;
	    this.runtimeType = value;
	  }
	
	  if (joinedPath === "unknownVolumes" && type === _TransactionTypes.ADD_ITEM) {
	    this.unknownVolumes.push(value);
	  }
	
	  if (path[0] === "externalVolumes") {
	    if (joinedPath === "externalVolumes") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          this.externalVolumes.push(value || {
	            containerPath: null,
	            external: {
	              name: null,
	              provider: "dvdi",
	              options: { "dvdi/driver": "rexray" }
	            },
	            mode: "RW"
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          this.externalVolumes = this.externalVolumes.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	
	      /**
	       * localVolumes and externalVolumes share the same reducer and
	       * the section in the form but representing quite different things.
	       *
	       * Reducer should use the same format therefore we need to pick either
	       * localVolumes format or externalVolumes format.
	       * We picked externalVolumes format. External Volumes are just external volumes.
	       *
	       * The following code converts localVolumes by filtering HOST volumes and
	       * mapping them to the common structure
	       */
	      return [].concat(this.localVolumes.map(mapLocalVolumes), this.externalVolumes, this.unknownVolumes);
	    }
	
	    var index = path[1];
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".provider" === joinedPath) {
	      this.externalVolumes[index].external.provider = String(value);
	    }
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".options" === joinedPath) {
	      // Options is of type object, so we are not processing it
	      this.externalVolumes[index].external.options = value;
	    }
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".name" === joinedPath) {
	      this.externalVolumes[index].external.name = String(value);
	    }
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".containerPath" === joinedPath) {
	      this.externalVolumes[index].containerPath = String(value);
	    }
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".size" === joinedPath) {
	      this.externalVolumes[index].external.size = (0, _ReducerUtil.parseIntValue)(value);
	    }
	    if (type === _TransactionTypes.SET && "externalVolumes." + index + ".mode" === joinedPath) {
	      this.externalVolumes[index].mode = String(value);
	    }
	  }
	
	  if (joinedPath.search("localVolumes") !== -1) {
	    if (joinedPath === "localVolumes") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          this.localVolumes.push(value || {
	            containerPath: null,
	            persistent: { size: 0 },
	            mode: "RW"
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          this.localVolumes = this.localVolumes.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	
	      return [].concat(this.localVolumes.map(mapLocalVolumes), this.externalVolumes, this.unknownVolumes);
	    }
	
	    var _index = path[1];
	    if (type === _TransactionTypes.SET && "localVolumes." + _index + ".size" === joinedPath) {
	      if (this.localVolumes[_index].persistent == null) {
	        this.localVolumes[_index].persistent = { size: null };
	      }
	      this.localVolumes[_index].persistent.size = (0, _ReducerUtil.parseIntValue)(value);
	    }
	    if (type === _TransactionTypes.SET && "localVolumes." + _index + ".type" === joinedPath) {
	      this.localVolumes[_index].type = String(value);
	    }
	    if (type === _TransactionTypes.SET && "localVolumes." + _index + ".mode" === joinedPath) {
	      this.localVolumes[_index].mode = String(value);
	    }
	    if (type === _TransactionTypes.SET && "localVolumes." + _index + ".hostPath" === joinedPath) {
	      this.localVolumes[_index].hostPath = String(value);
	    }
	    if (type === _TransactionTypes.SET && "localVolumes." + _index + ".containerPath" === joinedPath) {
	      this.localVolumes[_index].containerPath = String(value);
	    }
	  }
	
	  return [].concat(this.localVolumes.map(mapLocalVolumes), this.externalVolumes.map(mapExternalVolumes.bind(this)), this.unknownVolumes);
	}
	
	module.exports = {
	  JSONReducer: reduceVolumes
	};

/***/ },
/* 1692 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  PROTOCOLS: ["udp", "tcp"] // Order is important, udp goes first
	};

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCKER = _ContainerConstants2.default.type.DOCKER;
	
	
	function getContainerSettingsReducer(name) {
	  return function (_, _ref) {
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var joinedPath = path.join(".");
	    if (joinedPath === "container.type" && Boolean(value)) {
	      this.networkType = value;
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "container.docker." + name) {
	      this.value = Boolean(value);
	    }
	    if (this.networkType === DOCKER && this.value != null) {
	      return this.value;
	    }
	
	    return null;
	  };
	}
	
	module.exports = (0, _ReducerUtil.combineReducers)({
	  privileged: getContainerSettingsReducer("privileged"),
	  forcePullImage: (0, _ReducerUtil.simpleReducer)("container.docker.forcePullImage", null),
	  image: (0, _ReducerUtil.simpleReducer)("container.docker.image", "")
	});

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = ["automaticPort", "containerPort", "hostPort", "labels", "loadBalanced", "portMapping", "name", "servicePort", "vip", "vipPort"];
	
	/**
	 * @param {Object[]} state
	 * @param {Object} action
	 * @param {(ADD_ITEM|REMOVE_ITEM|SET)} action.type - action to perform
	 * @param {String[]} action.path - location of value
	 * @param {*} action.value - to perform action with
	 * @return {Object[]} new portDefinitions with action performed on it
	 */
	function PortMappingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var type = action.type,
	      _action$path = action.path,
	      path = _action$path === undefined ? [] : _action$path,
	      value = action.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 4),
	      base = _path[0],
	      index = _path[1],
	      field = _path[2],
	      subfield = _path[3];
	
	  var joinedPath = path.join(".");
	
	  if (base === "portDefinitions") {
	    if (joinedPath === "portDefinitions") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          state.push(value || {
	            automaticPort: true,
	            containerPort: null,
	            hostPort: null,
	            labels: null,
	            loadBalanced: false,
	            name: null,
	            portMapping: false,
	            protocol: {
	              tcp: true,
	              udp: false
	            },
	            servicePort: null,
	            vip: null,
	            vipPort: null
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          state = state.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	    }
	
	    if (index != null && type === _TransactionTypes.SET) {
	      if (FIELDS.includes(field)) {
	        state[index][field] = value;
	      }
	
	      if (field === "protocol" && _PortDefinitionConstants.PROTOCOLS.includes(subfield)) {
	        state[index].protocol[subfield] = value;
	      }
	
	      // If port is assigned automatically, remove hostPort
	      if (state[index].automaticPort) {
	        state[index].hostPort = 0;
	      }
	    }
	  }
	
	  return state;
	}
	
	module.exports = PortMappingsReducer;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VipLabelUtil = {
	  generateVipLabel: function generateVipLabel(appId, portDefinition, vipLabel, vipPort) {
	    var labels = portDefinition.labels,
	        loadBalanced = portDefinition.loadBalanced,
	        vip = portDefinition.vip;
	
	    // Only set VIP labels if port mapping is load balanced
	
	    if (loadBalanced) {
	      var vipValue = vip;
	
	      if (vipValue == null) {
	        vipValue = appId + ":" + vipPort;
	      }
	
	      var vipMatch = vipValue.match(/(.+):\d+/);
	      if (vipMatch) {
	        vipValue = vipMatch[1] + ":" + vipPort;
	      }
	
	      return (0, _assign2.default)({}, labels, (0, _defineProperty3.default)({}, vipLabel, vipValue));
	    }
	
	    var labelsHadVip = labels && Object.prototype.hasOwnProperty.call(labels, vipLabel);
	
	    if (labelsHadVip) {
	      return (0, _assign2.default)({}, labels, (0, _defineProperty3.default)({}, vipLabel, undefined));
	    }
	
	    return labels;
	  },
	  defaultVip: function defaultVip(index) {
	    return "VIP_" + index;
	  }
	};
	
	module.exports = VipLabelUtil;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _DefaultPod = __webpack_require__(1683);
	
	var _Endpoints = __webpack_require__(1697);
	
	var _MultiContainerArtifacts = __webpack_require__(1698);
	
	var _MultiContainerHealthChecks = __webpack_require__(1699);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerReducer = (0, _ReducerUtil.combineReducers)({
	  cpus: (0, _ReducerUtil.simpleReducer)("resources.cpus"),
	  mem: (0, _ReducerUtil.simpleReducer)("resources.mem"),
	  disk: (0, _ReducerUtil.simpleReducer)("resources.disk")
	});
	
	module.exports = {
	  FormReducer: function FormReducer(state, _ref) {
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var _path = (0, _slicedToArray3.default)(path, 4),
	        _ = _path[0],
	        index = _path[1],
	        field = _path[2],
	        subField = _path[3];
	
	    if (!path.includes("containers")) {
	      return state;
	    }
	
	    if (this.cache == null) {
	      this.cache = [];
	    }
	
	    if (this.healthCheckState == null) {
	      this.healthCheckState = [];
	    }
	
	    if (!state) {
	      state = [];
	    }
	
	    var newState = state.slice();
	    var joinedPath = path.join(".");
	
	    if (joinedPath === "containers") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          var name = "container-" + (newState.length + 1);
	
	          newState.push((0, _assign2.default)({}, _DefaultPod.DEFAULT_POD_CONTAINER, { name: name }));
	          this.cache.push({});
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          newState = newState.filter(function (item, index) {
	            return index !== value;
	          });
	          this.cache = this.cache.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	
	      return newState;
	    }
	
	    if (field === "endpoints") {
	      if (newState[index].endpoints == null) {
	        newState[index].endpoints = [];
	      }
	
	      newState[index].endpoints = (0, _Endpoints.FormReducer)(newState[index].endpoints, { type: type, path: path, value: value });
	    }
	
	    if (field === "healthCheck") {
	      if (this.healthCheckState[index] == null) {
	        this.healthCheckState[index] = {};
	      }
	
	      newState[index].healthCheck = _MultiContainerHealthChecks.FormReducer.call(this.healthCheckState[index], newState[index].healthCheck, { type: type, path: path.slice(3), value: value });
	    }
	
	    if (field === "artifacts") {
	      if (newState[index].artifacts == null) {
	        newState[index].artifacts = [];
	      }
	
	      newState[index].artifacts = (0, _MultiContainerArtifacts.FormReducer)(newState[index].artifacts, { type: type, path: path, value: value });
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".name") {
	      newState[index].name = value;
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".exec.command.shell") {
	      newState[index].exec = (0, _assign2.default)({}, newState[index].exec, {
	        command: { shell: value }
	      });
	    }
	
	    if (type === _TransactionTypes.SET && field === "resources") {
	      // Do not parse numbers, as user might be in the middle of
	      // entering a number. 0.0 would then equal 0, yielding it impossible to
	      // enter, e.g. 0.001
	      newState[index].resources = containerReducer.call(this.cache[index], newState[index].resources, { type: type, value: value, path: [field, subField] });
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".image.id") {
	      newState[index].image = (0, _assign2.default)({}, newState[index].image, {
	        id: value
	      });
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".image.forcePull") {
	      newState[index].image = (0, _assign2.default)({}, newState[index].image, {
	        forcePull: value
	      });
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEndpointsFieldValues = {
	  automaticPort: true,
	  containerPort: null,
	  hostPort: null,
	  labels: null,
	  loadBalanced: false,
	  name: null,
	  protocol: {
	    tcp: true,
	    udp: false
	  },
	  servicePort: null,
	  vip: null,
	  vipPort: null
	};
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var newState = [].concat(state);
	
	    var _path = (0, _slicedToArray3.default)(path, 6),
	        _ = _path[0],
	        _index = _path[1],
	        field = _path[2],
	        secondIndex = _path[3],
	        name = _path[4],
	        subField = _path[5];
	
	    if (field !== "endpoints") {
	      return state;
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        var endpointDefinition = (0, _assign2.default)({}, defaultEndpointsFieldValues);
	        endpointDefinition.protocol = (0, _assign2.default)({}, defaultEndpointsFieldValues.protocol);
	        newState.push(endpointDefinition);
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState = newState.filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	    }
	
	    var fieldNames = ["name", "automaticPort", "loadBalanced", "vip", "vipPort"];
	    var numericalFiledNames = ["containerPort", "hostPort"];
	
	    if (type === _TransactionTypes.SET && name === "protocol") {
	      newState[secondIndex].protocol[subField] = value;
	    }
	    if (type === _TransactionTypes.SET && fieldNames.includes(name)) {
	      newState[secondIndex][name] = value;
	    }
	    if (type === _TransactionTypes.SET && numericalFiledNames.includes(name)) {
	      newState[secondIndex][name] = (0, _ReducerUtil.parseIntValue)(value);
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var newState = [].concat(state);
	
	    var _path = (0, _slicedToArray3.default)(path, 6),
	        _ = _path[0],
	        _index = _path[1],
	        field = _path[2],
	        secondIndex = _path[3],
	        name = _path[4],
	        _subField = _path[5];
	
	    if (field !== "artifacts") {
	      return state;
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        newState.push({ uri: null });
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState = newState.filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	      case _TransactionTypes.SET:
	        newState[secondIndex][name] = value;
	        break;
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	var _MesosCommandTypes = __webpack_require__(1701);
	
	var _MesosCommandTypes2 = _interopRequireDefault(_MesosCommandTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * JSON Parser Fragment for `HttpHealthCheck` type
	 *
	 * @param {Object} healthCheck - The healthcheck data to parse
	 * @param {Array} path - The path prefix to the transaction
	 * @returns {Array} - Returns an array with the new transactions to append
	 */
	function parseHttpHealthCheck(healthCheck, path) {
	  var memo = [];
	
	  if (healthCheck.endpoint != null) {
	    memo.push(new _Transaction2.default(path.concat(["endpoint"]), healthCheck.endpoint, _TransactionTypes.SET));
	  }
	
	  if (healthCheck.path != null) {
	    memo.push(new _Transaction2.default(path.concat(["path"]), healthCheck.path, _TransactionTypes.SET));
	  }
	
	  if (healthCheck.scheme != null) {
	    memo.push(new _Transaction2.default(path.concat(["https"]), healthCheck.scheme === _HealthCheckProtocols.HTTPS, _TransactionTypes.SET));
	  }
	
	  return memo;
	}
	
	function reduceHttpHealthCheck(state, field, value) {
	  var newState = (0, _assign2.default)({}, state);
	  newState.http = (0, _assign2.default)({}, newState.http || {});
	
	  switch (field) {
	    case "endpoint":
	      newState.http.endpoint = value;
	      break;
	
	    case "path":
	      newState.http.path = value;
	      break;
	
	    case "https":
	      if (value) {
	        newState.http.scheme = _HealthCheckProtocols.HTTPS;
	      } else {
	        newState.http.scheme = _HealthCheckProtocols.HTTP;
	      }
	      break;
	  }
	
	  return newState;
	}
	
	function reduceFormHttpHealthCheck(state, field, value) {
	  var newState = (0, _assign2.default)({}, state);
	  newState.http = (0, _assign2.default)({}, newState.http || {});
	
	  switch (field) {
	    case "https":
	      newState.http.https = value;
	      break;
	  }
	
	  return newState;
	}
	
	/**
	 * JSON Parser Fragment for `TcpHealthCheck` type
	 *
	 * @param {Object} healthCheck - The healthcheck data to parse
	 * @param {Array} path - The path prefix to the transaction
	 * @returns {Array} - Returns an array with the new transactions to append
	 */
	function parseTcpHealthCheck(healthCheck, path) {
	  var memo = [];
	
	  if (healthCheck.endpoint != null) {
	    memo.push(new _Transaction2.default(path.concat(["endpoint"]), healthCheck.endpoint, _TransactionTypes.SET));
	  }
	
	  return memo;
	}
	
	function reduceTcpHealthCheck(state, field, value) {
	  var newState = (0, _assign2.default)({}, state);
	  newState.tcp = (0, _assign2.default)({}, newState.tcp || {});
	
	  switch (field) {
	    case "endpoint":
	      newState.tcp.endpoint = value;
	      break;
	  }
	
	  return newState;
	}
	
	/**
	 * JSON Parser Fragment for `CommandHealthCheck` type
	 *
	 * @param {Object} healthCheck - The healthcheck data to parse
	 * @param {Array} path - The path prefix to the transaction
	 * @returns {Array} - Returns an array with the new transactions to append
	 */
	function parseCommandHealthCheck(healthCheck, path) {
	  var memo = [];
	  var _healthCheck$command = healthCheck.command,
	      command = _healthCheck$command === undefined ? {} : _healthCheck$command;
	
	
	  if (command.shell != null) {
	    memo.push(new _Transaction2.default(path.concat(["command", "type"]), _MesosCommandTypes2.default.SHELL, _TransactionTypes.SET));
	
	    memo.push(new _Transaction2.default(path.concat(["command", "value"]), command.shell, _TransactionTypes.SET));
	  }
	
	  if (command.argv != null && Array.isArray(command.argv)) {
	    memo.push(new _Transaction2.default(path.concat(["command", "type"]), _MesosCommandTypes2.default.ARGV, _TransactionTypes.SET));
	
	    // Always cast to string, since the UI cannot handle arrays
	    memo.push(new _Transaction2.default(path.concat(["command", "value"]), command.argv.join(" "), _TransactionTypes.SET));
	  }
	
	  return memo;
	}
	
	function reduceCommandHealthCheck(state, field, value) {
	  var newState = (0, _assign2.default)({}, state);
	  newState.exec = (0, _assign2.default)({}, newState.exec || {});
	  newState.exec.command = (0, _assign2.default)({}, newState.exec.command || {});
	  var command = newState.exec.command;
	
	  switch (field) {
	    case "type":
	      // Shell is a meta-field that denotes if we are going to populate
	      // the argument or the shell field. So, if we encounter an opposite
	      // field, we should convert and set-up a placeholder
	      if (value === _MesosCommandTypes2.default.SHELL) {
	        command.shell = "";
	        if (command.argv != null && Array.isArray(command.argv)) {
	          command.shell = command.argv.join(" ");
	          delete command.argv;
	        }
	
	        break;
	      }
	
	      if (value === _MesosCommandTypes2.default.ARGV) {
	        command.argv = [];
	        if (command.shell != null) {
	          command.argv = command.shell.split(" ");
	          delete command.shell;
	        }
	
	        break;
	      }
	      break;
	
	    case "value":
	      // By default we are creating `shell`. Only if `argv` exists
	      // we should create an array
	      if (command.argv != null) {
	        command.argv = value.split(" ");
	      } else {
	        command.shell = value;
	      }
	      break;
	  }
	
	  return newState;
	}
	
	function reduceFormCommandHealthCheck(state, field, value) {
	  var newState = (0, _assign2.default)({}, state);
	  newState.exec = (0, _assign2.default)({}, newState.exec || {});
	  newState.exec.command = (0, _assign2.default)({}, newState.exec.command || {});
	  var command = newState.exec.command;
	
	  switch (field) {
	    case "type":
	      command.type = value;
	      break;
	
	    case "value":
	      command.value = value;
	      break;
	  }
	
	  return newState;
	}
	
	var MultiContainerHealthChecks = {
	  JSONSegmentReducer: function JSONSegmentReducer(state, _ref) {
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    var newState = (0, _assign2.default)({}, state);
	
	    var _path = (0, _slicedToArray3.default)(path, 3),
	        group = _path[0],
	        field = _path[1],
	        secondField = _path[2];
	
	    // ADD_ITEM does nothing more but to define an object as a value,
	    // since we cannot have more than 1 items.
	
	
	    if (type === _TransactionTypes.ADD_ITEM) {
	      if (path.length !== 0) {
	        if (false) {
	          throw new TypeError("Trying to ADD_ITEM on a wrong health path");
	        }
	
	        return newState;
	      }
	
	      return {};
	    }
	
	    // REMOVE_ITEM resets the state back to `null` since we can only
	    // have one item.
	    if (type === _TransactionTypes.REMOVE_ITEM) {
	      if (path.length !== 0) {
	        if (false) {
	          throw new TypeError("Trying to REMOVE_ITEM on a wrong health path");
	        }
	
	        return newState;
	      }
	
	      return null;
	    }
	
	    // Format object structure according to protocol switch
	    if (group === "protocol") {
	      switch (value) {
	        case _HealthCheckProtocols.COMMAND:
	          newState.exec = {
	            command: {}
	          };
	          delete newState.http;
	          delete newState.tcp;
	          break;
	
	        case _HealthCheckProtocols.HTTP:
	          delete newState.exec;
	          newState.http = {
	            scheme: _HealthCheckProtocols.HTTP
	          };
	          delete newState.tcp;
	          break;
	
	        case _HealthCheckProtocols.TCP:
	          delete newState.exec;
	          delete newState.http;
	          newState.tcp = {};
	          break;
	      }
	
	      return newState;
	    }
	
	    // Assign properties
	    switch (group) {
	      case "exec":
	        return reduceCommandHealthCheck(newState, secondField, value);
	
	      case "http":
	        return reduceHttpHealthCheck(newState, field, value);
	
	      case "tcp":
	        return reduceTcpHealthCheck(newState, field, value);
	
	      case "gracePeriodSeconds":
	        newState.gracePeriodSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        break;
	
	      case "intervalSeconds":
	        newState.intervalSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        break;
	
	      case "maxConsecutiveFailures":
	        newState.maxConsecutiveFailures = (0, _ReducerUtil.parseIntValue)(value);
	        break;
	
	      case "timeoutSeconds":
	        newState.timeoutSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        break;
	
	      case "delaySeconds":
	        newState.delaySeconds = (0, _ReducerUtil.parseIntValue)(value);
	        break;
	    }
	
	    return newState;
	  },
	  JSONSegmentParser: function JSONSegmentParser(healthCheck, path) {
	    var memo = [];
	    if (_ValidatorUtil2.default.isEmpty(healthCheck)) {
	      return memo;
	    }
	
	    // Add an ADD_ITEM transaction
	    memo.push(new _Transaction2.default(path, null, _TransactionTypes.ADD_ITEM));
	
	    // Parse detailed fields according to type
	    if (healthCheck.http != null) {
	      memo.push(new _Transaction2.default(path.concat(["protocol"]), _HealthCheckProtocols.HTTP, _TransactionTypes.SET));
	      memo = memo.concat(parseHttpHealthCheck(healthCheck.http, path.concat(["http"]), memo));
	    }
	    if (healthCheck.tcp != null) {
	      memo.push(new _Transaction2.default(path.concat(["protocol"]), _HealthCheckProtocols.TCP, _TransactionTypes.SET));
	      memo = memo.concat(parseTcpHealthCheck(healthCheck.tcp, path.concat(["tcp"]), memo));
	    }
	    if (healthCheck.exec != null) {
	      memo.push(new _Transaction2.default(path.concat(["protocol"]), _HealthCheckProtocols.COMMAND, _TransactionTypes.SET));
	      memo = memo.concat(parseCommandHealthCheck(healthCheck.exec, path.concat(["exec"]), memo));
	    }
	
	    // Parse generic fields
	    if (healthCheck.gracePeriodSeconds != null) {
	      memo.push(new _Transaction2.default(path.concat(["gracePeriodSeconds"]), (0, _ReducerUtil.parseIntValue)(healthCheck.gracePeriodSeconds), _TransactionTypes.SET));
	    }
	    if (healthCheck.intervalSeconds != null) {
	      memo.push(new _Transaction2.default(path.concat(["intervalSeconds"]), (0, _ReducerUtil.parseIntValue)(healthCheck.intervalSeconds), _TransactionTypes.SET));
	    }
	    if (healthCheck.maxConsecutiveFailures != null) {
	      memo.push(new _Transaction2.default(path.concat(["maxConsecutiveFailures"]), (0, _ReducerUtil.parseIntValue)(healthCheck.maxConsecutiveFailures), _TransactionTypes.SET));
	    }
	    if (healthCheck.timeoutSeconds != null) {
	      memo.push(new _Transaction2.default(path.concat(["timeoutSeconds"]), (0, _ReducerUtil.parseIntValue)(healthCheck.timeoutSeconds), _TransactionTypes.SET));
	    }
	    if (healthCheck.delaySeconds != null) {
	      memo.push(new _Transaction2.default(path.concat(["delaySeconds"]), (0, _ReducerUtil.parseIntValue)(healthCheck.delaySeconds), _TransactionTypes.SET));
	    }
	
	    return memo;
	  },
	  FormReducer: function FormReducer(state, _ref2) {
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    var newState = MultiContainerHealthChecks.JSONSegmentReducer.call(this, state, { type: type, path: path, value: value });
	
	    // Bail early on nulled cases
	    if (newState == null) {
	      return newState;
	    }
	
	    var _path2 = (0, _slicedToArray3.default)(path, 3),
	        group = _path2[0],
	        field = _path2[1],
	        secondField = _path2[2];
	
	    // Include additional fields only present in the form
	
	
	    if (group === "protocol") {
	      newState.protocol = value;
	    }
	
	    // Assign detailed properties
	    switch (group) {
	      case "exec":
	        return reduceFormCommandHealthCheck(newState, secondField, value);
	
	      case "http":
	        return reduceFormHttpHealthCheck(newState, field, value);
	    }
	
	    return newState;
	  }
	};
	
	module.exports = MultiContainerHealthChecks;

/***/ },
/* 1700 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  COMMAND: "COMMAND",
	  HTTP: "HTTP",
	  HTTPS: "HTTPS",
	  TCP: "TCP",
	  MESOS_HTTP: "MESOS_HTTP",
	  MESOS_HTTPS: "MESOS_HTTPS",
	  MESOS_TCP: "MESOS_TCP"
	};

/***/ },
/* 1701 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  SHELL: "SHELL",
	  ARGV: "ARGV"
	};

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _JSONEditor = __webpack_require__(1703);
	
	var _JSONEditor2 = _interopRequireDefault(_JSONEditor);
	
	var _ServiceErrorTypes = __webpack_require__(1635);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _ServiceUtil = __webpack_require__(1244);
	
	var _ServiceUtil2 = _interopRequireDefault(_ServiceUtil);
	
	var _ServiceValidatorUtil = __webpack_require__(1247);
	
	var _ServiceValidatorUtil2 = _interopRequireDefault(_ServiceValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleJSONChange", "handleJSONErrorStateChange"];
	
	var CreateServiceJsonOnly = function (_React$Component) {
	  (0, _inherits3.default)(CreateServiceJsonOnly, _React$Component);
	
	  function CreateServiceJsonOnly() {
	    (0, _classCallCheck3.default)(this, CreateServiceJsonOnly);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateServiceJsonOnly.__proto__ || (0, _getPrototypeOf2.default)(CreateServiceJsonOnly)).apply(this, arguments));
	
	    _this.state = {
	      appConfig: _ServiceUtil2.default.getServiceJSON(_this.props.service)
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * @override
	   */
	
	
	  (0, _createClass3.default)(CreateServiceJsonOnly, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var service = nextProps.service;
	
	      var prevJSON = _ServiceUtil2.default.getServiceJSON(this.props.service);
	      var nextJSON = _ServiceUtil2.default.getServiceJSON(service);
	      // Make sure to not set state unless the service has actually changed
	      if ((0, _deepEqual2.default)(prevJSON, nextJSON)) {
	        return;
	      }
	
	      this.setState({
	        appConfig: _ServiceUtil2.default.getServiceJSON(service)
	      });
	    }
	
	    /**
	     * Emmit the correct ServiceSpec on JSON change
	     *
	     * @param {Object} jsonObject - The JSON object from which to build the spec
	     */
	
	  }, {
	    key: "handleJSONChange",
	    value: function handleJSONChange(jsonObject) {
	      var newObject = void 0;
	      if (_ServiceValidatorUtil2.default.isPodSpecDefinition(jsonObject)) {
	        newObject = new _PodSpec2.default(jsonObject);
	      } else {
	        newObject = new _ApplicationSpec2.default(jsonObject);
	      }
	
	      this.props.onChange(newObject);
	    }
	
	    /**
	     * Emmit JSON form errors if the syntax is invalid
	     *
	     * @param {Boolean} errorState - True if there are JSON syntax errors
	     */
	
	  }, {
	    key: "handleJSONErrorStateChange",
	    value: function handleJSONErrorStateChange(errorState) {
	      var _props = this.props,
	          errors = _props.errors,
	          onErrorsChange = _props.onErrorsChange;
	
	      var hasJsonError = errors.some(function (error) {
	        return error.type === _ServiceErrorTypes.SYNTAX_ERROR;
	      });
	
	      // Produce a JSON error if we have errors
	      if (errorState && !hasJsonError) {
	        onErrorsChange([{
	          path: [],
	          type: _ServiceErrorTypes.SYNTAX_ERROR,
	          variables: {},
	          message: "The input entered is not a valid JSON string"
	        }]);
	      }
	
	      // Remove JSON error if we are back to normal
	      if (!errorState && hasJsonError) {
	        onErrorsChange([]);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var appConfig = this.state.appConfig;
	      var _props2 = this.props,
	          errors = _props2.errors,
	          onPropertyChange = _props2.onPropertyChange;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "create-service-modal-json-only container container-wide" },
	        _react2.default.createElement(
	          "div",
	          { className: "create-service-modal-json-only-introduction" },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            "JSON Configuration"
	          ),
	          _react2.default.createElement(
	            _FieldHelp2.default,
	            null,
	            "Use this text area to customize your configuration via JSON."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "create-service-modal-json-only-editor-container" },
	          _react2.default.createElement(_JSONEditor2.default, {
	            className: "create-service-modal-json-only-editor",
	            errors: errors,
	            onChange: this.handleJSONChange,
	            onErrorStateChange: this.handleJSONErrorStateChange,
	            onPropertyChange: onPropertyChange,
	            showGutter: true,
	            showPrintMargin: false,
	            theme: "monokai",
	            value: appConfig
	          })
	        )
	      );
	    }
	  }]);
	  return CreateServiceJsonOnly;
	}(_react2.default.Component);
	
	CreateServiceJsonOnly.defaultProps = {
	  onChange: function onChange() {},
	  onErrorsChange: function onErrorsChange() {},
	  onPropertyChange: function onPropertyChange() {}
	};
	
	CreateServiceJsonOnly.propTypes = {
	  errors: _react.PropTypes.array.isRequired,
	  onChange: _react.PropTypes.func,
	  onErrorsChange: _react.PropTypes.func,
	  onPropertyChange: _react.PropTypes.func,
	  service: _react.PropTypes.object
	};
	
	module.exports = CreateServiceJsonOnly;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactAce = __webpack_require__(1439);
	
	var _reactAce2 = _interopRequireDefault(_reactAce);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	__webpack_require__(1704);
	
	var _Util = __webpack_require__(982);
	
	var _JSONUtil = __webpack_require__(1705);
	
	var _JSONUtil2 = _interopRequireDefault(_JSONUtil);
	
	var _JSONEditorUtil = __webpack_require__(1706);
	
	var _JSONEditorUtil2 = _interopRequireDefault(_JSONEditorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleBlur", "handleChange", "handleEditorLoad", "handleFocus"];
	
	/**
	 * How long to wait before clearing the `isTyping` flag, used internally to
	 * prohibit external updates to the editor while the user is typing.
	 *
	 * @const {number}
	 */
	var IS_TYPING_TIMEOUT = 2000;
	
	/**
	 * This is a high-order component on top of `AceEditor` that abstracts the JSON
	 * string manipulation and allows object-level access to the underlying data.
	 *
	 * It's features are:
	 *
	 * - Solve some bugs and peculiarities of AceEditor component
	 * - Maintain visual coherence between object updates
	 * - Callback on per-property updates as the user types
	 * - Receive errors through properties and show them in the gutter
	 *
	 * @example <caption>How to use the JSONEditor</caption>
	 *
	 * handleChange(newObject) {
	 *   console.log('New object:', newObject);
	 * }
	 *
	 * handlePropertyChange(path, value) {
	 *   console.log('Property /'+path.join('/'), 'changed to', value);
	 * }
	 *
	 * render() {
	 *   let value = {
	 *     some: {value: 'object'}
	 *   };
	 *   let errors = [
	 *     {path: ['some'], message: 'An error on object `some`'}
	 *   ];
	 *
	 *   return (
	 *     <JSONEditor
	 *       value={value}
	 *       errors={errors}
	 *       onChange={this.handleChange}
	 *       onPropertyChange={this.handlePropertyChange}
	 *       />
	 *   );
	 * };
	 *
	 */
	
	var JSONEditor = function (_React$Component) {
	  (0, _inherits3.default)(JSONEditor, _React$Component);
	
	  function JSONEditor() {
	    (0, _classCallCheck3.default)(this, JSONEditor);
	
	    // Clone the given initial value
	    var _this = (0, _possibleConstructorReturn3.default)(this, (JSONEditor.__proto__ || (0, _getPrototypeOf2.default)(JSONEditor)).apply(this, arguments));
	
	    var jsonText = (0, _stringify2.default)(_this.props.value || {}, null, 2);
	
	    // We are using the react-way of updating the component **only** when we
	    // need to define a new text to work upon (ex. when the owner component has
	    // updated the value).
	    //
	    // Updating the AceEditor on every render cycle seems to cause some trouble
	    // to it's internals, that I couldn't pinpoint yet.
	    _this.state = {
	      aceEditorState: {
	        jsonText: jsonText
	      }
	    };
	
	    //
	    // The following properties are part of the `internal`, non-react state
	    // and is synchronized with the react through `componentWillReceiveProps`
	    //
	    _this.externalErrors = (_this.props.errors || []).slice();
	    _this.jsonError = null;
	    _this.jsonMeta = [];
	    _this.jsonText = null;
	    _this.jsonValue = {};
	
	    //
	    // The following properties are flags and references used for other purposes
	    //
	    _this.aceEditor = null;
	    _this.isFocused = false;
	    _this.isTyping = false;
	    _this.timerIsTyping = null;
	
	    // Initial state synchronization
	    _this.updateLocalJsonState(_this.getNewJsonState(jsonText));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  /**
	   * @override
	   */
	
	
	  (0, _createClass3.default)(JSONEditor, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // Synchronize error updates
	      if (!(0, _deepEqual2.default)(this.externalErrors, nextProps.errors)) {
	        this.externalErrors = (nextProps.errors || []).slice();
	        this.updateEditorState();
	      }
	
	      // Ignore invalid values
	      if ((0, _typeof3.default)(nextProps.value) !== "object") {
	        return;
	      }
	
	      // Ignore property changes if the user is currently using the editor field
	      if (this.isTyping && this.isFocused) {
	        return;
	      }
	
	      // If this update originates from an onChange -> prop={value} loop, the
	      // object defined in the `internalValue` property should be equal to the
	      // `value` property we just received. In this case, don't update anything.
	      if ((0, _deepEqual2.default)(this.jsonValue, nextProps.value)) {
	        return;
	      }
	
	      // If we reached this point, the owning component has actually sent us a new
	      // json object that we must display. For visual coherence we must try our
	      // best to properly display the new values without breaking the JSON text
	      // arrangement.
	
	      // Align the order the properties appear & calculate new JSON text
	      var value = _JSONEditorUtil2.default.sortObjectKeys(this.jsonValue, nextProps.value);
	
	      var jsonText = (0, _stringify2.default)(value, null, 2);
	
	      // Update local state with the new, computed text
	      this.updateLocalJsonState(this.getNewJsonState(jsonText));
	      this.setState({ aceEditorState: { jsonText: jsonText } });
	    }
	
	    /**
	     * Since ACEEditor component does not behave nicely when we update the text
	     * as a response to an `onChange` event, we must be very careful never to
	     * render the ACEEditor when the user types.
	     *
	     * This way, the component is updated *only* when:
	     *
	     * - Editor-related properties change (ex. editorProps, width, height)
	     * - The text in the editor has to be replaced due to an external value change
	     *
	     * @override
	     */
	
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // Update if ACE editor properties are changed
	      if (!(0, _deepEqual2.default)(nextProps.editorProps, this.props.editorProps) || nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
	        return true;
	      }
	
	      // Otherwise update ONLY when initial value changes in state
	      return nextState.aceEditorState !== this.state.aceEditorState;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateEditorState();
	    }
	  }, {
	    key: "handleEditorLoad",
	    value: function handleEditorLoad(editor) {
	      this.aceEditor = editor;
	
	      // Disable tab index for JSON editor
	      this.aceEditor.renderer.textarea.setAttribute("tabIndex", -1);
	
	      // Disable syntax highlighting worker, since we are responsible for feeding
	      // the correct syntax error + provided error markers
	      var editorSession = editor.getSession();
	      editorSession.setUseWorker(false);
	
	      // Enable soft tabs and set tab space to 2
	      editorSession.setTabSize(2);
	
	      // Synchronize editor state
	      this.updateEditorState();
	    }
	
	    /**
	     * `onBlur` handler for the AceEditor
	     *
	     * @param {DOMEvent} event - The event object
	     */
	
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(event) {
	      this.props.onBlur(event, this.jsonValue);
	      this.isFocused = false;
	    }
	
	    /**
	     * `onChange` handler for the AceEditor
	     *
	     * @param {string} jsonText - The new JSON string
	     */
	
	  }, {
	    key: "handleChange",
	    value: function handleChange(jsonText) {
	      var _this2 = this;
	
	      var lastValue = this.jsonValue;
	      var lastError = this.jsonError;
	
	      // Calculate what the next state is going to be
	
	      var _getNewJsonState = this.getNewJsonState(jsonText),
	          jsonValue = _getNewJsonState.jsonValue,
	          jsonMeta = _getNewJsonState.jsonMeta,
	          jsonError = _getNewJsonState.jsonError;
	
	      // Update the `isTyping` flag
	
	
	      this.isTyping = true;
	      this.scheduleIsTypingReset(IS_TYPING_TIMEOUT);
	
	      // Handle errors
	      if (lastError !== jsonError) {
	        this.props.onErrorStateChange(jsonError);
	      }
	
	      // If we have errors don't continue with updating the local structures
	      if (!jsonError) {
	        // Calculate differences in the JSON and trigger `onPropertyChange`
	        // event for every property that changed in the JSON
	        var diff = _JSONEditorUtil2.default.deepObjectDiff(lastValue, jsonValue);
	
	        diff.forEach(function (_ref) {
	          var path = _ref.path,
	              value = _ref.value;
	
	          _this2.props.onPropertyChange(path, value, jsonValue);
	        });
	
	        // Trigger change with the latest json object
	        this.props.onChange(jsonValue);
	      }
	
	      // Update local json state
	      this.updateLocalJsonState({ jsonValue: jsonValue, jsonMeta: jsonMeta, jsonError: jsonError, jsonText: jsonText });
	    }
	
	    /**
	     * `onFocus` handler for the AceEditor
	     *
	     * @param {DOMEvent} event - The event object
	     */
	
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(event) {
	      this.props.onFocus(event, this.jsonValue);
	      this.isFocused = true;
	    }
	
	    /**
	     * Apply pending state updates to the ACE editor instance.
	     *
	     * This function operates purely on the `aceEditor` instance, created by the
	     * `AceEditor` composed and exposed through the `onLoad` event. Since the
	     * `AceEditor` component does a pretty bad job updating only what's needed,
	     * we had to use this approach and avoid re-rendering the component as much
	     * as possible.
	     */
	
	  }, {
	    key: "updateEditorState",
	    value: function updateEditorState() {
	      var _this3 = this;
	
	      if (!this.aceEditor) {
	        return;
	      }
	
	      // Defer the annotation update, since for some reason ACE editor
	      // does not get updated if the update comes from the same stack call
	      // that set it's state.
	      setTimeout(function () {
	        _this3.aceEditor.getSession().setAnnotations(_this3.getErrorMarkers());
	      }, 1);
	    }
	
	    /**
	     * Get new JSON state (parsed value and meta data) from json text.
	     *
	     * @param {String} jsonText - The JSON buffer to extract metadata from
	     * @return {null | {
	     *      jsonValue:object,
	     *      jsonText:string,
	     *      jsonMeta:object,
	     *      jsonError:string
	     *    }} jsonState - JSON state including parsed value and meta data
	     */
	
	  }, {
	    key: "getNewJsonState",
	    value: function getNewJsonState(jsonText) {
	      // Do not perform heavyweight calculations, such as `getObjectInformation`
	      // if the json text hasn't really changed.
	      if (this.jsonText === jsonText) {
	        return null;
	      }
	
	      // Reset some properties
	      var jsonValue = this.jsonValue,
	          jsonMeta = this.jsonMeta,
	          jsonError = this.jsonError;
	
	      // Try to parse and extract metadata
	
	      try {
	        jsonError = null;
	        jsonValue = JSON.parse(jsonText);
	        jsonMeta = _JSONUtil2.default.getObjectInformation(jsonText);
	      } catch (e) {
	        // Prettify the error message by resolving the line/column instead of
	        // just keeping the offset in the string
	        var errorStr = e.toString();
	        jsonError = errorStr.replace(/at position (\d+)/g, function (match, offset) {
	          var cursor = _JSONEditorUtil2.default.cursorFromOffset(parseInt(offset, 10), jsonText);
	
	          return "at line " + cursor.row + ":" + cursor.column;
	        });
	      }
	
	      return { jsonValue: jsonValue, jsonText: jsonText, jsonMeta: jsonMeta, jsonError: jsonError };
	    }
	
	    /**
	     * This function assigns the local JSON state (parsed value and meta data),
	     * outside the React state, since this does not necessarily trigger an update.
	     *
	     * This is useful in order to have the latest available metainformation when
	     * the user changes the text (on the `handleChange` handler), but we don't
	     * want to re-do the processing when this will eventually trigger an update
	     * to the `value` property with the same data.
	     *
	     * @param {object|null} jsonState
	     * @param {object} jsonState.jsonValue
	     * @param {string} jsonState.jsonText
	     * @param {object} jsonState.jsonMeta
	     * @param {string} jsonState.jsonError
	     */
	
	  }, {
	    key: "updateLocalJsonState",
	    value: function updateLocalJsonState(jsonState) {
	      if (jsonState == null) {
	        return;
	      }
	
	      this.jsonText = jsonState.jsonText;
	      this.jsonError = jsonState.jsonError;
	      this.jsonValue = jsonState.jsonValue;
	      this.jsonMeta = jsonState.jsonMeta;
	
	      // Sync editor without a render cycle
	      this.updateEditorState();
	    }
	
	    /**
	     * Schedule the `isTyping` state property to set back to `false` if this
	     * function is not called within the given timeout.
	     *
	     * @param {number} timeout - The timeout (in millisecond) on which to clear
	     *                 the flag
	     */
	
	  }, {
	    key: "scheduleIsTypingReset",
	    value: function scheduleIsTypingReset(timeout) {
	      var _this4 = this;
	
	      if (this.timerIsTyping) {
	        clearTimeout(this.timerIsTyping);
	      }
	
	      this.timerIsTyping = setTimeout(function () {
	        _this4.isTyping = false;
	      }, timeout);
	    }
	
	    /**
	     * Collects error markers to set on the Ace Editor
	     * @return {Array<({
	     *   row:Number,
	     *   text:String,
	     *   type:String
	     * })>} An array of errors to show in the Ace Editor
	     */
	
	  }, {
	    key: "getErrorMarkers",
	    value: function getErrorMarkers() {
	      var _this5 = this;
	
	      // Extract syntax errors, or other errors that refer to line
	      if (this.jsonError) {
	        // Strip out the 'at line xxx' message, and keep track of that line
	        var errorLine = 0;
	        var errorMsg = this.jsonError.replace(/at line ([\d:]+)/g, function (m, line) {
	          errorLine = parseInt(line.split(":")[0], 10);
	
	          return "";
	        });
	
	        // Return error marker
	        return [{
	          row: errorLine,
	          text: errorMsg,
	          type: "error"
	        }];
	      }
	
	      return this.externalErrors.map(function (error) {
	        var path = error.path,
	            message = error.message;
	
	        // All errors with empty paths go to line 0
	
	        if (path.length === 0) {
	          return {
	            row: 0,
	            text: message,
	            type: "error"
	          };
	        }
	
	        // Check if there is a token that matches the path completely
	        var errorPath = error.path.join(".");
	        var token = _this5.jsonMeta.find(function (token) {
	          return token.path.join(".") === errorPath;
	        });
	
	        if (token) {
	          return {
	            row: token.line - 1,
	            text: message,
	            type: "error"
	          };
	        }
	
	        // When we are not able to find an exact match we are going to gradually
	        // increase the error scope until we find a token that exists.
	        //
	        // If nothing is found, default to root ([])
	        //
	        var candidates = _this5.jsonMeta.reduce(function (memo, token) {
	          var isMatch = token.path.every(function (component, i) {
	            return path[i] === component;
	          });
	
	          if (isMatch) {
	            memo.push({
	              path: token.path,
	              row: token.line - 1
	            });
	          }
	
	          return memo;
	        }, [{ path: [], row: 0 }]);
	
	        // Find the most specific token line
	        var candidate = candidates.sort(function (a, b) {
	          return b.path.length - a.path.length;
	        })[0];
	
	        // Keep the difference between the original and the new path and display
	        // it as prefix in the error message:
	        var prefixPath = path.slice(candidate.path.length).join(".");
	
	        return {
	          row: candidate.row,
	          text: prefixPath + ": " + message,
	          type: "error"
	        };
	      });
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          editorProps = _props.editorProps;
	      var aceEditorState = this.state.aceEditorState;
	
	
	      var omitKeys = [].concat((0, _keys2.default)(JSONEditor.propTypes), "mode");
	
	      return _react2.default.createElement(_reactAce2.default, (0, _extends3.default)({}, (0, _Util.omit)(this.props, omitKeys), {
	        width: width,
	        height: height,
	        editorProps: editorProps,
	        mode: "json",
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onFocus: this.handleFocus,
	        onLoad: this.handleEditorLoad,
	        value: aceEditorState.jsonText
	      }));
	    }
	  }]);
	  return JSONEditor;
	}(_react2.default.Component);
	
	JSONEditor.defaultProps = {
	  errors: [],
	  editorProps: { $blockScrolling: Infinity },
	  height: "100%",
	  onBlur: function onBlur() {},
	  onChange: function onChange() {},
	  onErrorStateChange: function onErrorStateChange() {},
	  onFocus: function onFocus() {},
	  onPropertyChange: function onPropertyChange() {},
	
	  value: {},
	  width: "100%"
	};
	
	JSONEditor.propTypes = {
	  errors: _react2.default.PropTypes.array,
	  editorProps: _react2.default.PropTypes.object,
	  height: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	  onBlur: _react2.default.PropTypes.func,
	  onChange: _react2.default.PropTypes.func,
	  onErrorStateChange: _react2.default.PropTypes.func,
	  onFocus: _react2.default.PropTypes.func,
	  onPropertyChange: _react2.default.PropTypes.func,
	  value: _react2.default.PropTypes.object,
	  width: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number])
	};
	
	module.exports = JSONEditor;

/***/ },
/* 1704 */
/***/ function(module, exports) {

	ace.define("ace/ext/searchbox",["require","exports","module","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/keyboard/hash_handler","ace/lib/keys"], function(acequire, exports, module) {
	"use strict";
	
	var dom = acequire("../lib/dom");
	var lang = acequire("../lib/lang");
	var event = acequire("../lib/event");
	var searchboxCss = "\
	.ace_search {\
	background-color: #ddd;\
	border: 1px solid #cbcbcb;\
	border-top: 0 none;\
	max-width: 325px;\
	overflow: hidden;\
	margin: 0;\
	padding: 4px;\
	padding-right: 6px;\
	padding-bottom: 0;\
	position: absolute;\
	top: 0px;\
	z-index: 99;\
	white-space: normal;\
	}\
	.ace_search.left {\
	border-left: 0 none;\
	border-radius: 0px 0px 5px 0px;\
	left: 0;\
	}\
	.ace_search.right {\
	border-radius: 0px 0px 0px 5px;\
	border-right: 0 none;\
	right: 0;\
	}\
	.ace_search_form, .ace_replace_form {\
	border-radius: 3px;\
	border: 1px solid #cbcbcb;\
	float: left;\
	margin-bottom: 4px;\
	overflow: hidden;\
	}\
	.ace_search_form.ace_nomatch {\
	outline: 1px solid red;\
	}\
	.ace_search_field {\
	background-color: white;\
	border-right: 1px solid #cbcbcb;\
	border: 0 none;\
	-webkit-box-sizing: border-box;\
	-moz-box-sizing: border-box;\
	box-sizing: border-box;\
	float: left;\
	height: 22px;\
	outline: 0;\
	padding: 0 7px;\
	width: 214px;\
	margin: 0;\
	}\
	.ace_searchbtn,\
	.ace_replacebtn {\
	background: #fff;\
	border: 0 none;\
	border-left: 1px solid #dcdcdc;\
	cursor: pointer;\
	float: left;\
	height: 22px;\
	margin: 0;\
	position: relative;\
	}\
	.ace_searchbtn:last-child,\
	.ace_replacebtn:last-child {\
	border-top-right-radius: 3px;\
	border-bottom-right-radius: 3px;\
	}\
	.ace_searchbtn:disabled {\
	background: none;\
	cursor: default;\
	}\
	.ace_searchbtn {\
	background-position: 50% 50%;\
	background-repeat: no-repeat;\
	width: 27px;\
	}\
	.ace_searchbtn.prev {\
	background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpiSU1NZUAC/6E0I0yACYskCpsJiySKIiY0SUZk40FyTEgCjGgKwTRAgAEAQJUIPCE+qfkAAAAASUVORK5CYII=);    \
	}\
	.ace_searchbtn.next {\
	background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADRJREFUeNpiTE1NZQCC/0DMyIAKwGJMUAYDEo3M/s+EpvM/mkKwCQxYjIeLMaELoLMBAgwAU7UJObTKsvAAAAAASUVORK5CYII=);    \
	}\
	.ace_searchbtn_close {\
	background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAZ0lEQVR42u2SUQrAMAhDvazn8OjZBilCkYVVxiis8H4CT0VrAJb4WHT3C5xU2a2IQZXJjiQIRMdkEoJ5Q2yMqpfDIo+XY4k6h+YXOyKqTIj5REaxloNAd0xiKmAtsTHqW8sR2W5f7gCu5nWFUpVjZwAAAABJRU5ErkJggg==) no-repeat 50% 0;\
	border-radius: 50%;\
	border: 0 none;\
	color: #656565;\
	cursor: pointer;\
	float: right;\
	font: 16px/16px Arial;\
	height: 14px;\
	margin: 5px 1px 9px 5px;\
	padding: 0;\
	text-align: center;\
	width: 14px;\
	}\
	.ace_searchbtn_close:hover {\
	background-color: #656565;\
	background-position: 50% 100%;\
	color: white;\
	}\
	.ace_replacebtn.prev {\
	width: 54px\
	}\
	.ace_replacebtn.next {\
	width: 27px\
	}\
	.ace_button {\
	margin-left: 2px;\
	cursor: pointer;\
	-webkit-user-select: none;\
	-moz-user-select: none;\
	-o-user-select: none;\
	-ms-user-select: none;\
	user-select: none;\
	overflow: hidden;\
	opacity: 0.7;\
	border: 1px solid rgba(100,100,100,0.23);\
	padding: 1px;\
	-moz-box-sizing: border-box;\
	box-sizing:    border-box;\
	color: black;\
	}\
	.ace_button:hover {\
	background-color: #eee;\
	opacity:1;\
	}\
	.ace_button:active {\
	background-color: #ddd;\
	}\
	.ace_button.checked {\
	border-color: #3399ff;\
	opacity:1;\
	}\
	.ace_search_options{\
	margin-bottom: 3px;\
	text-align: right;\
	-webkit-user-select: none;\
	-moz-user-select: none;\
	-o-user-select: none;\
	-ms-user-select: none;\
	user-select: none;\
	}";
	var HashHandler = acequire("../keyboard/hash_handler").HashHandler;
	var keyUtil = acequire("../lib/keys");
	
	dom.importCssString(searchboxCss, "ace_searchbox");
	
	var html = '<div class="ace_search right">\
	    <button type="button" action="hide" class="ace_searchbtn_close"></button>\
	    <div class="ace_search_form">\
	        <input class="ace_search_field" placeholder="Search for" spellcheck="false"></input>\
	        <button type="button" action="findNext" class="ace_searchbtn next"></button>\
	        <button type="button" action="findPrev" class="ace_searchbtn prev"></button>\
	        <button type="button" action="findAll" class="ace_searchbtn" title="Alt-Enter">All</button>\
	    </div>\
	    <div class="ace_replace_form">\
	        <input class="ace_search_field" placeholder="Replace with" spellcheck="false"></input>\
	        <button type="button" action="replaceAndFindNext" class="ace_replacebtn">Replace</button>\
	        <button type="button" action="replaceAll" class="ace_replacebtn">All</button>\
	    </div>\
	    <div class="ace_search_options">\
	        <span action="toggleRegexpMode" class="ace_button" title="RegExp Search">.*</span>\
	        <span action="toggleCaseSensitive" class="ace_button" title="CaseSensitive Search">Aa</span>\
	        <span action="toggleWholeWords" class="ace_button" title="Whole Word Search">\\b</span>\
	    </div>\
	</div>'.replace(/>\s+/g, ">");
	
	var SearchBox = function(editor, range, showReplaceForm) {
	    var div = dom.createElement("div");
	    div.innerHTML = html;
	    this.element = div.firstChild;
	
	    this.$init();
	    this.setEditor(editor);
	};
	
	(function() {
	    this.setEditor = function(editor) {
	        editor.searchBox = this;
	        editor.container.appendChild(this.element);
	        this.editor = editor;
	    };
	
	    this.$initElements = function(sb) {
	        this.searchBox = sb.querySelector(".ace_search_form");
	        this.replaceBox = sb.querySelector(".ace_replace_form");
	        this.searchOptions = sb.querySelector(".ace_search_options");
	        this.regExpOption = sb.querySelector("[action=toggleRegexpMode]");
	        this.caseSensitiveOption = sb.querySelector("[action=toggleCaseSensitive]");
	        this.wholeWordOption = sb.querySelector("[action=toggleWholeWords]");
	        this.searchInput = this.searchBox.querySelector(".ace_search_field");
	        this.replaceInput = this.replaceBox.querySelector(".ace_search_field");
	    };
	    
	    this.$init = function() {
	        var sb = this.element;
	        
	        this.$initElements(sb);
	        
	        var _this = this;
	        event.addListener(sb, "mousedown", function(e) {
	            setTimeout(function(){
	                _this.activeInput.focus();
	            }, 0);
	            event.stopPropagation(e);
	        });
	        event.addListener(sb, "click", function(e) {
	            var t = e.target || e.srcElement;
	            var action = t.getAttribute("action");
	            if (action && _this[action])
	                _this[action]();
	            else if (_this.$searchBarKb.commands[action])
	                _this.$searchBarKb.commands[action].exec(_this);
	            event.stopPropagation(e);
	        });
	
	        event.addCommandKeyListener(sb, function(e, hashId, keyCode) {
	            var keyString = keyUtil.keyCodeToString(keyCode);
	            var command = _this.$searchBarKb.findKeyCommand(hashId, keyString);
	            if (command && command.exec) {
	                command.exec(_this);
	                event.stopEvent(e);
	            }
	        });
	
	        this.$onChange = lang.delayedCall(function() {
	            _this.find(false, false);
	        });
	
	        event.addListener(this.searchInput, "input", function() {
	            _this.$onChange.schedule(20);
	        });
	        event.addListener(this.searchInput, "focus", function() {
	            _this.activeInput = _this.searchInput;
	            _this.searchInput.value && _this.highlight();
	        });
	        event.addListener(this.replaceInput, "focus", function() {
	            _this.activeInput = _this.replaceInput;
	            _this.searchInput.value && _this.highlight();
	        });
	    };
	    this.$closeSearchBarKb = new HashHandler([{
	        bindKey: "Esc",
	        name: "closeSearchBar",
	        exec: function(editor) {
	            editor.searchBox.hide();
	        }
	    }]);
	    this.$searchBarKb = new HashHandler();
	    this.$searchBarKb.bindKeys({
	        "Ctrl-f|Command-f": function(sb) {
	            var isReplace = sb.isReplace = !sb.isReplace;
	            sb.replaceBox.style.display = isReplace ? "" : "none";
	            sb.searchInput.focus();
	        },
	        "Ctrl-H|Command-Option-F": function(sb) {
	            sb.replaceBox.style.display = "";
	            sb.replaceInput.focus();
	        },
	        "Ctrl-G|Command-G": function(sb) {
	            sb.findNext();
	        },
	        "Ctrl-Shift-G|Command-Shift-G": function(sb) {
	            sb.findPrev();
	        },
	        "esc": function(sb) {
	            setTimeout(function() { sb.hide();});
	        },
	        "Return": function(sb) {
	            if (sb.activeInput == sb.replaceInput)
	                sb.replace();
	            sb.findNext();
	        },
	        "Shift-Return": function(sb) {
	            if (sb.activeInput == sb.replaceInput)
	                sb.replace();
	            sb.findPrev();
	        },
	        "Alt-Return": function(sb) {
	            if (sb.activeInput == sb.replaceInput)
	                sb.replaceAll();
	            sb.findAll();
	        },
	        "Tab": function(sb) {
	            (sb.activeInput == sb.replaceInput ? sb.searchInput : sb.replaceInput).focus();
	        }
	    });
	
	    this.$searchBarKb.addCommands([{
	        name: "toggleRegexpMode",
	        bindKey: {win: "Alt-R|Alt-/", mac: "Ctrl-Alt-R|Ctrl-Alt-/"},
	        exec: function(sb) {
	            sb.regExpOption.checked = !sb.regExpOption.checked;
	            sb.$syncOptions();
	        }
	    }, {
	        name: "toggleCaseSensitive",
	        bindKey: {win: "Alt-C|Alt-I", mac: "Ctrl-Alt-R|Ctrl-Alt-I"},
	        exec: function(sb) {
	            sb.caseSensitiveOption.checked = !sb.caseSensitiveOption.checked;
	            sb.$syncOptions();
	        }
	    }, {
	        name: "toggleWholeWords",
	        bindKey: {win: "Alt-B|Alt-W", mac: "Ctrl-Alt-B|Ctrl-Alt-W"},
	        exec: function(sb) {
	            sb.wholeWordOption.checked = !sb.wholeWordOption.checked;
	            sb.$syncOptions();
	        }
	    }]);
	
	    this.$syncOptions = function() {
	        dom.setCssClass(this.regExpOption, "checked", this.regExpOption.checked);
	        dom.setCssClass(this.wholeWordOption, "checked", this.wholeWordOption.checked);
	        dom.setCssClass(this.caseSensitiveOption, "checked", this.caseSensitiveOption.checked);
	        this.find(false, false);
	    };
	
	    this.highlight = function(re) {
	        this.editor.session.highlight(re || this.editor.$search.$options.re);
	        this.editor.renderer.updateBackMarkers()
	    };
	    this.find = function(skipCurrent, backwards, preventScroll) {
	        var range = this.editor.find(this.searchInput.value, {
	            skipCurrent: skipCurrent,
	            backwards: backwards,
	            wrap: true,
	            regExp: this.regExpOption.checked,
	            caseSensitive: this.caseSensitiveOption.checked,
	            wholeWord: this.wholeWordOption.checked,
	            preventScroll: preventScroll
	        });
	        var noMatch = !range && this.searchInput.value;
	        dom.setCssClass(this.searchBox, "ace_nomatch", noMatch);
	        this.editor._emit("findSearchBox", { match: !noMatch });
	        this.highlight();
	    };
	    this.findNext = function() {
	        this.find(true, false);
	    };
	    this.findPrev = function() {
	        this.find(true, true);
	    };
	    this.findAll = function(){
	        var range = this.editor.findAll(this.searchInput.value, {            
	            regExp: this.regExpOption.checked,
	            caseSensitive: this.caseSensitiveOption.checked,
	            wholeWord: this.wholeWordOption.checked
	        });
	        var noMatch = !range && this.searchInput.value;
	        dom.setCssClass(this.searchBox, "ace_nomatch", noMatch);
	        this.editor._emit("findSearchBox", { match: !noMatch });
	        this.highlight();
	        this.hide();
	    };
	    this.replace = function() {
	        if (!this.editor.getReadOnly())
	            this.editor.replace(this.replaceInput.value);
	    };    
	    this.replaceAndFindNext = function() {
	        if (!this.editor.getReadOnly()) {
	            this.editor.replace(this.replaceInput.value);
	            this.findNext()
	        }
	    };
	    this.replaceAll = function() {
	        if (!this.editor.getReadOnly())
	            this.editor.replaceAll(this.replaceInput.value);
	    };
	
	    this.hide = function() {
	        this.element.style.display = "none";
	        this.editor.keyBinding.removeKeyboardHandler(this.$closeSearchBarKb);
	        this.editor.focus();
	    };
	    this.show = function(value, isReplace) {
	        this.element.style.display = "";
	        this.replaceBox.style.display = isReplace ? "" : "none";
	
	        this.isReplace = isReplace;
	
	        if (value)
	            this.searchInput.value = value;
	        
	        this.find(false, false, true);
	        
	        this.searchInput.focus();
	        this.searchInput.select();
	
	        this.editor.keyBinding.addKeyboardHandler(this.$closeSearchBarKb);
	    };
	
	    this.isFocused = function() {
	        var el = document.activeElement;
	        return el == this.searchInput || el == this.replaceInput;
	    }
	}).call(SearchBox.prototype);
	
	exports.SearchBox = SearchBox;
	
	exports.Search = function(editor, isReplace) {
	    var sb = editor.searchBox || new SearchBox(editor);
	    sb.show(editor.session.getTextRange(), isReplace);
	};
	
	});
	                (function() {
	                    ace.acequire(["ace/ext/searchbox"], function() {});
	                })();
	            

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tokenizer regular expressions
	 */
	var TOKENIZER_TOKENS = {
	  comma: /,/g,
	  "end-label": /:/g,
	  "begin-object": /\{/g,
	  "end-object": /\}/g,
	  "begin-array": /\[/g,
	  "end-array": /\]/g,
	  string: /"(\\["\\/bfnrtu"]|[^"\\"])*"/g,
	  null: /null/g,
	  boolean: /(true|false)/g,
	  number: /-?\d+(\.\d+)?([eE]-?\d+)?/g,
	  symbol: /\w+/g
	};
	
	// Extract only keys
	var TOKENIZER_NAMES = (0, _keys2.default)(TOKENIZER_TOKENS);
	
	/**
	 * Return the next JSON token from the given string
	 *
	 * @param {string} chunk - The source payload
	 * @param {number} offset - The offset to start searching from
	 * @returns {array} - Returns an array with [ name, match, offset ]
	 */
	function nextJSONToken(chunk, offset) {
	  var i = 0;
	  var lastName = "";
	  var lastMatch = "";
	  var lastOffset = chunk.length;
	  var tokenCount = TOKENIZER_NAMES.length;
	
	  while (i < tokenCount) {
	    var tokenName = TOKENIZER_NAMES[i];
	    var tokenRegExp = TOKENIZER_TOKENS[tokenName];
	
	    // Search for a token at given offset
	    tokenRegExp.lastIndex = offset;
	
	    // If we got something closer to the last match, prefer this one
	    var match = tokenRegExp.exec(chunk);
	    if (match && match.index < lastOffset) {
	      lastOffset = match.index;
	      lastName = tokenName;
	      lastMatch = match[0];
	    }
	
	    i++;
	  }
	
	  return [lastName, lastMatch, lastOffset];
	}
	
	/**
	 * Count how many lines exists in the string between
	 * given start and end indices.
	 *
	 * @param {string} src - The string to test
	 * @param {number} startAt - The index to start searching for new lines (inclusive)
	 * @param {number} endAt - The index to end searching for new lines (exclusive)
	 * @returns {number} - The number of new line characters found
	 */
	function countNewLines(src, startAt, endAt) {
	  var newLines = 0;
	  for (var i = startAt; i < endAt; i++) {
	    if (src[i] === "\n") {
	      newLines++;
	    }
	  }
	
	  return newLines;
	}
	
	/**
	 * This utility class provides useful functions for
	 * analyzing a JSON source from the ACE editor or other
	 * JSON sources.
	 */
	module.exports = {
	  /**
	   * Returns the JSON object on the specified line
	   *
	   * @param {array} objectInfo - The output of `getObjectInformation`
	   * @param {number} line - The line to locate
	   * @returns {object} - The related object on the given line or null
	   */
	  getObjectOnLine: function getObjectOnLine(objectInfo, line) {
	    return objectInfo.find(function (info) {
	      return info.line === line;
	    });
	  },
	
	
	  /**
	   * Process JSON source and return detailed information for every object
	   * in the object. The information processed for every token is:
	   *
	   * {
	   *   path: [ 'path', 'in', 'the', 'object' ],
	   *   line: 0,
	   *   type: 'object|array|literal',
	   *  [value]: 'literal value'
	   * }
	   *
	   * @param {string} source - The source code to parse
	   * @returns {array} - An array with the objects in the JSON
	   */
	  getObjectInformation: function getObjectInformation(source) {
	    var keyLines = [];
	    // Keeps track of the current line number
	    var lineNo = 1;
	    // The current path in the object trace
	    var path = [];
	    // Keeps track of last literal (number, string, null, boolean)
	    var lastLiteral = void 0;
	    // This variable is used only when the parser is within an array [ ],
	    // pointing to the current array index. Otherwise it's -1
	    var arrayIndex = -1;
	    // This variable keeps track of the current object key. It's used only
	    // when in an object { } and is populated only when a colon ':'' is encountered
	    var objectKey = null;
	    // Stack of block tokens, used to keep track of the last opened block
	    // token in order to update the ending position.
	    var blockTokens = [];
	
	    // First validate sanity of the JSON source, in order for us
	    // to safely assume that this is a legit JSON source
	    // (This will throw an exception)
	    JSON.parse(source);
	
	    // Process tokens
	    var i = 0;
	    var sourceLength = source.length;
	    while (i < sourceLength) {
	      // Get next token or exit if there are no more
	      var _nextJSONToken = nextJSONToken(source, i),
	          _nextJSONToken2 = (0, _slicedToArray3.default)(_nextJSONToken, 3),
	          token = _nextJSONToken2[0],
	          match = _nextJSONToken2[1],
	          offset = _nextJSONToken2[2];
	
	      if (!token) {
	        break;
	      }
	
	      // Count how many new lines we encountered since the
	      // last index and forward line number accordingly
	      var curr = i;
	      i = offset + match.length;
	      lineNo += countNewLines(source, curr, i);
	
	      // Process token
	      switch (token) {
	        //
	        // The last literal before '{' is the object name.
	        // This action should add a level in the path
	        //
	        case "begin-object":
	          // Keep track of keyed objects
	          if (objectKey) {
	            var blockToken = {
	              path: [].concat(path, objectKey),
	              line: lineNo,
	              type: "object",
	              position: [offset, i]
	            };
	
	            keyLines.push(blockToken);
	            blockTokens.push(blockToken);
	
	            path.push(objectKey);
	            objectKey = null;
	          }
	
	          // Keep track of indexed objects
	          if (arrayIndex !== -1) {
	            var _blockToken = {
	              path: [].concat(path, arrayIndex),
	              line: lineNo,
	              type: "object",
	              position: [offset, i]
	            };
	
	            keyLines.push(_blockToken);
	            blockTokens.push(_blockToken);
	
	            path.push(arrayIndex);
	          }
	
	          // Wipe array index
	          arrayIndex = -1;
	          break;
	        //
	        // When we start an array, push a numeric component on path
	        //
	        case "begin-array":
	          // Keep track of keyed arrays
	          if (objectKey) {
	            var _blockToken2 = {
	              path: [].concat(path, objectKey),
	              line: lineNo,
	              type: "array",
	              position: [offset, i]
	            };
	
	            keyLines.push(_blockToken2);
	            blockTokens.push(_blockToken2);
	
	            path.push(objectKey);
	            objectKey = null;
	          }
	
	          // Keep track of indexed arrays
	          if (arrayIndex !== -1) {
	            var _blockToken3 = {
	              path: [].concat(path, arrayIndex),
	              line: lineNo,
	              type: "array",
	              position: [offset, i]
	            };
	
	            keyLines.push(_blockToken3);
	            blockTokens.push(_blockToken3);
	
	            path.push(arrayIndex);
	          }
	
	          // Start array index
	          arrayIndex = 0;
	          break;
	        //
	        // When objects or arrays are ended, pop the last item
	        // and keep track of the array information
	        //
	        case "end-object":
	        case "end-array":
	          // Pop path and resume possible array tracking
	          var lastValue = path.pop();
	          if (typeof lastValue === "number") {
	            arrayIndex = lastValue;
	          } else {
	            arrayIndex = -1;
	          }
	
	          // Update the ending position of the last block token on stack
	          var lastBlockToken = blockTokens.pop();
	          if (lastBlockToken) {
	            lastBlockToken.position[1] = i;
	          }
	          break;
	        //
	        // A comma is handled only if we have an open array
	        // on the last path component. It should advance the
	        // index by one.
	        //
	        case "comma":
	          // Advance array index
	          if (arrayIndex !== -1) {
	            arrayIndex++;
	          }
	          break;
	        //
	        // The moment we find a label ':', the last literal
	        // is the key to a property. Keep track of it in the path.
	        //
	        case "end-label":
	          // Label after a literal defines an object key
	          if (lastLiteral) {
	            objectKey = lastLiteral;
	          }
	          break;
	        //
	        // String literals include their quotes,
	        // everything else is kept as-is
	        //
	        case "string":
	          match = match.slice(1, -1);
	        /* eslint-disable no-fallthrough */
	        case "maybe-string":
	        case "number":
	        case "boolean":
	        case "null":
	          /* eslint-enable no-fallthrough */
	
	          // Cast tokens to their correct type
	          if (token === "number") {
	            match = Number(match);
	          } else if (token === "boolean") {
	            match = match === "true";
	          } else if (token === "null") {
	            match = null;
	          }
	
	          // Keep last literal
	          lastLiteral = match;
	
	          // Keep track of keyed literals
	          if (objectKey) {
	            keyLines.push({
	              path: [].concat(path, objectKey),
	              line: lineNo,
	              value: match,
	              type: "literal",
	              position: [offset, i]
	            });
	            objectKey = null;
	          }
	
	          // Keep track of indexed literals
	          if (arrayIndex !== -1) {
	            keyLines.push({
	              path: [].concat(path, arrayIndex),
	              line: lineNo,
	              value: match,
	              type: "literal",
	              position: [offset, i]
	            });
	          }
	          break;
	      }
	    }
	
	    // Return the key line numbers
	    return keyLines;
	  }
	};

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This module contains the utility functions for the `JSONEditor` component,
	 * separated into a different file solely for organization purposes.
	 */
	var JSONEditorUtil = {
	  /**
	   * This function walks the `text` argument and locates the line and
	   * column the given string offset.
	   *
	   * Note: Both row/column values are 0-based
	   *
	   * @param {number} offset - The string offset
	   * @param {string} text - The source string
	   * @returns {{line, column}} Returns the line/column for the given offset
	   */
	  cursorFromOffset: function cursorFromOffset(offset, text) {
	    var column = 0;
	    var lastRowOffset = 0;
	    var row = 0;
	
	    // Handle negative offsets
	    if (offset < 0) {
	      return { row: 0, column: 0 };
	    }
	
	    // Find row
	    for (var index = 0; index <= offset; ++index) {
	      if (text[index] === "\n") {
	        row++;
	        lastRowOffset = index + 1;
	      }
	    }
	
	    // Find column
	    column = offset - lastRowOffset;
	
	    // Wrap to maximum length
	    if (lastRowOffset + column > text.length) {
	      column = text.length - lastRowOffset;
	    }
	
	    return { row: row, column: column };
	  },
	
	
	  /**
	   * Deep compare two objects and return an array of differences as an object
	   * with `path`, `value` and `previous` property.
	   *
	   * @param {any} oldObj - The old object to compare
	   * @param {any} newObj - The new object to compare
	   * @param {Array} [path] - The current object path
	   * @returns {[{path, previous, value}]} Returns an array with the differences
	   */
	  deepObjectDiff: function deepObjectDiff(oldObj, newObj) {
	    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    if (oldObj === newObj) {
	      return [];
	    }
	    if ((typeof oldObj === "undefined" ? "undefined" : (0, _typeof3.default)(oldObj)) !== (typeof newObj === "undefined" ? "undefined" : (0, _typeof3.default)(newObj)) || oldObj !== null && newObj === null || oldObj === null && newObj !== null) {
	      return [{ path: path, value: newObj, previous: oldObj }];
	    }
	    if ((typeof oldObj === "undefined" ? "undefined" : (0, _typeof3.default)(oldObj)) !== "object") {
	      return [{ path: path, value: newObj, previous: oldObj }];
	    }
	
	    var oldKeys = (0, _keys2.default)(oldObj);
	    var newKeys = (0, _keys2.default)(newObj);
	
	    // Process removed/changed keys
	    var diff = oldKeys.reduce(function (memo, key) {
	      var index = newKeys.indexOf(key);
	      if (index === -1) {
	        memo.push({
	          path: path.concat([key]),
	          value: undefined,
	          previous: oldObj[key]
	        });
	
	        return memo;
	      }
	
	      newKeys.splice(index, 1);
	
	      return memo.concat(JSONEditorUtil.deepObjectDiff(oldObj[key], newObj[key], path.concat([key])));
	    }, []);
	
	    // Process new keys
	    diff = newKeys.reduce(function (memo, key) {
	      memo.push({
	        path: path.concat([key]),
	        value: newObj[key],
	        previous: undefined
	      });
	
	      return memo;
	    }, diff);
	
	    // If something changed, include the current object as changed
	    if (diff.length) {
	      diff.push({ path: path, value: newObj, previous: oldObj });
	    }
	
	    return diff;
	  },
	
	
	  /**
	   * Find the location of a change between two strings
	   *
	   * @param {string} oldString - The old string
	   * @param {string} newString - The new string
	   * @returns {number} Returns the offset in the string with the first difference
	   */
	  diffLocation: function diffLocation(oldString, newString) {
	    var length = Math.min(oldString.length, newString.length);
	    for (var index = 0; index < length; ++index) {
	      if (oldString[index] !== newString[index]) {
	        return index;
	      }
	    }
	
	    return -1;
	  },
	
	
	  /**
	   * Arrange object keys (or array elements) of the given new value in order to
	   * match the ones in the old value.
	   *
	   * @param {any} oldVal - The previous value to match against
	   * @param {any} newVal - The new value to adapt
	   * @returns {any} Returns the newVal with it's element properly arranged
	   */
	  sortObjectKeys: function sortObjectKeys(oldVal, newVal) {
	    if (Array.isArray(oldVal) && Array.isArray(newVal)) {
	      return newVal;
	    }
	
	    // Since `null` is also considered an object, handle it before we reach
	    // the next statement where Object.keys will fail.
	    if (oldVal == null || newVal == null) {
	      return newVal;
	    }
	
	    if ((typeof oldVal === "undefined" ? "undefined" : (0, _typeof3.default)(oldVal)) === "object" && (typeof newVal === "undefined" ? "undefined" : (0, _typeof3.default)(newVal)) === "object") {
	      var oldKeys = (0, _keys2.default)(oldVal);
	      var newKeys = (0, _keys2.default)(newVal);
	
	      // Keep keys that exist in both objects, in the order they appear in the
	      // `oldKeys` array. In the same time, strip these keys out of the
	      // `newKeys` array in order to keep only the `new` keys.
	      var resultKeys = oldKeys.filter(function (key) {
	        if (Object.prototype.hasOwnProperty.call(newVal, key)) {
	          var index = newKeys.indexOf(key);
	          newKeys.splice(index, 1);
	
	          return true;
	        }
	
	        return false;
	      });
	
	      // Stack new keys at the end of the object
	      resultKeys.push.apply(resultKeys, (0, _toConsumableArray3.default)(newKeys));
	
	      // Convert keys array to an object
	      return resultKeys.reduce(function (resultObj, key) {
	        resultObj[key] = JSONEditorUtil.sortObjectKeys(oldVal[key], newVal[key]);
	
	        return resultObj;
	      }, {});
	    }
	
	    return newVal;
	  }
	};
	
	module.exports = JSONEditorUtil;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _DeleteRowButton = __webpack_require__(1709);
	
	var _DeleteRowButton2 = _interopRequireDefault(_DeleteRowButton);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _EnvironmentVariables = __webpack_require__(1711);
	
	var _Labels = __webpack_require__(1712);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EnvironmentFormSection = function (_Component) {
	  (0, _inherits3.default)(EnvironmentFormSection, _Component);
	
	  function EnvironmentFormSection() {
	    (0, _classCallCheck3.default)(this, EnvironmentFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (EnvironmentFormSection.__proto__ || (0, _getPrototypeOf2.default)(EnvironmentFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EnvironmentFormSection, [{
	    key: "getEnvironmentLines",
	    value: function getEnvironmentLines(data) {
	      var _this2 = this;
	
	      var errors = this.props.errors.env || {};
	
	      return data.filter(function (item) {
	        return item.value == null || typeof item.value === "string";
	      }).map(function (env, key) {
	        var keyLabel = null;
	        var valueLabel = null;
	        if (key === 0) {
	          keyLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Key"
	              )
	            )
	          );
	          valueLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Value"
	              )
	            )
	          );
	        }
	
	        var isValueWithoutKey = Boolean(!env.key && env.value);
	
	        return _react2.default.createElement(
	          _FormRow2.default,
	          { key: key },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: "column-6",
	              required: false,
	              showError: isValueWithoutKey
	            },
	            keyLabel,
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "env." + key + ".key",
	                type: "text",
	                value: env.key || ""
	              })
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              "An environment variable needs to contain at least a key."
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "emphasis form-colon" },
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: "column-6",
	              required: false,
	              showError: Boolean(errors[env.key])
	            },
	            valueLabel,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "env." + key + ".value",
	              type: "text",
	              value: env.value || ""
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              errors[env.key]
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { hasNarrowMargins: true, applyLabelOffset: key === 0 },
	            _react2.default.createElement(_DeleteRowButton2.default, {
	              onClick: _this2.props.onRemoveItem.bind(_this2, {
	                value: key,
	                path: "env"
	              })
	            })
	          )
	        );
	      });
	    }
	  }, {
	    key: "getLabelsLines",
	    value: function getLabelsLines(data) {
	      var _this3 = this;
	
	      var errors = this.props.errors.labels || {};
	
	      return data.map(function (label, key) {
	        var keyLabel = null;
	        var valueLabel = null;
	        if (key === 0) {
	          keyLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Key"
	              )
	            )
	          );
	          valueLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Value"
	              )
	            )
	          );
	        }
	
	        var isValueWithoutKey = Boolean(!label.key && label.value);
	
	        return _react2.default.createElement(
	          _FormRow2.default,
	          { key: key },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-6", showError: isValueWithoutKey },
	            keyLabel,
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "labels." + key + ".key",
	                type: "text",
	                value: label.key || ""
	              })
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              "A label needs to contain at least a key."
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "emphasis form-colon" },
	              ":"
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: "column-6",
	              required: false,
	              showError: Boolean(errors[label.key])
	            },
	            valueLabel,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "labels." + key + ".value",
	              type: "text",
	              value: label.value || ""
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              errors[label.key]
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { hasNarrowMargins: true, applyLabelOffset: key === 0 },
	            _react2.default.createElement(_DeleteRowButton2.default, {
	              onClick: _this3.props.onRemoveItem.bind(_this3, {
	                value: key,
	                path: "labels"
	              })
	            })
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          errors = _props.errors;
	
	
	      var envTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "DC/OS also exposes environment variables for host ports and metdata. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/task-environment-vars.html",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	      var labelsTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "For example, you could label services “staging” and “production” to mark them by their position in the pipeline. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: _MetadataStore2.default.buildDocsURI("/usage/tutorials/task-labels/"),
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Environment"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Configure any environment values to be attached to each instance that is launched."
	        ),
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Environment Variables"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: envTooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Set up environment variables for each instance your service launches."
	        ),
	        this.getEnvironmentLines(data.env),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: "env"
	                })
	              },
	              "Add Environment Variable"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Labels"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: labelsTooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Attach metadata to expose additional information to other services."
	        ),
	        this.getLabelsLines(data.labels),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  value: data.labels.length,
	                  path: "labels"
	                })
	              },
	              "Add Label"
	            )
	          )
	        ),
	        _react2.default.createElement(_foundationUi.MountService.Mount, {
	          type: this.props.mountType,
	          data: data,
	          errors: errors,
	          onAddItem: this.props.onAddItem.bind(this),
	          onRemoveItem: this.props.onRemoveItem.bind(this)
	        })
	      );
	    }
	  }]);
	  return EnvironmentFormSection;
	}(_react.Component);
	
	EnvironmentFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {},
	
	  mountType: "CreateService:EnvironmentFormSection"
	};
	
	EnvironmentFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func,
	  mountType: _react2.default.PropTypes.string
	};
	
	EnvironmentFormSection.configReducers = {
	  env: _EnvironmentVariables.FormReducer,
	  labels: _Labels.FormReducer
	};
	
	module.exports = EnvironmentFormSection;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddButton(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      icon = _ref.icon,
	      onClick = _ref.onClick;
	
	  var classes = (0, _dedupe2.default)("button button-primary-link button-flush", className);
	
	  return _react2.default.createElement(
	    "a",
	    { className: classes, onClick: onClick },
	    icon,
	    _react2.default.createElement(
	      "span",
	      null,
	      children
	    )
	  );
	}
	
	AddButton.defaultProps = {
	  icon: _react2.default.createElement(_Icon2.default, { color: "purple", id: "plus", size: "tiny" })
	};
	
	AddButton.propTypes = {
	  children: _react2.default.PropTypes.node,
	  onClick: _react2.default.PropTypes.func,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  icon: _react2.default.PropTypes.node
	};
	
	module.exports = AddButton;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteRowButton = function DeleteRowButton(_ref) {
	  var onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    _reactjsComponents.Tooltip,
	    {
	      content: _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	      interactive: false,
	      maxWidth: 300,
	      wrapText: true
	    },
	    _react2.default.createElement(
	      "a",
	      { className: "button button-link button-narrow", onClick: onClick },
	      _react2.default.createElement(_Icon2.default, { id: "close", family: "tiny", size: "tiny" })
	    )
	  );
	};
	
	module.exports = DeleteRowButton;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(615);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _DOMUtils = __webpack_require__(994);
	
	var _DOMUtils2 = _interopRequireDefault(_DOMUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lockFieldAutofocus = false;
	
	var FieldAutofocus = function (_React$Component) {
	  (0, _inherits3.default)(FieldAutofocus, _React$Component);
	
	  function FieldAutofocus() {
	    (0, _classCallCheck3.default)(this, FieldAutofocus);
	    return (0, _possibleConstructorReturn3.default)(this, (FieldAutofocus.__proto__ || (0, _getPrototypeOf2.default)(FieldAutofocus)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FieldAutofocus, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (lockFieldAutofocus) {
	        return;
	      }
	      var input = _DOMUtils2.default.getInputElement(_reactDom2.default.findDOMNode(this));
	      if (!input) {
	        return;
	      }
	      lockFieldAutofocus = true;
	      input.focus();
	
	      input.addEventListener("blur", function onBlurInput() {
	        lockFieldAutofocus = false;
	        this.removeEventListener("blur", onBlurInput);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return FieldAutofocus;
	}(_react2.default.Component);
	
	module.exports = FieldAutofocus;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("env") !== -1) {
	      if (joinedPath === "env") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            state.push({ key: null, value: null });
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            state = state.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return state;
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET && "env." + index + ".key" === joinedPath) {
	        state[index].key = value;
	      }
	      if (type === _TransactionTypes.SET && "env." + index + ".value" === joinedPath) {
	        state[index].value = value;
	      }
	    }
	
	    return state;
	  }
	};

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("labels") !== -1) {
	      if (joinedPath === "labels") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            state.push({ key: null, value: null });
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            state = state.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return state;
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET && "labels." + index + ".key" === joinedPath) {
	        state[index].key = value;
	      }
	      if (type === _TransactionTypes.SET && "labels." + index + ".value" === joinedPath) {
	        state[index].value = value;
	      }
	    }
	
	    return state;
	  }
	};

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _Util = __webpack_require__(982);
	
	var _ServiceErrorTypes = __webpack_require__(1635);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	var _PlacementConstraintsUtil2 = _interopRequireDefault(_PlacementConstraintsUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCKER = _ContainerConstants2.default.type.DOCKER;
	
	
	var MarathonAppValidators = {
	  /**
	   * Ensure that the user has provided either a `cmd` or a docker image field.
	   *
	   * The following checks are ported from the following marathon file:
	   *
	   * https://github.com/mesosphere/marathon/blob
	   *       /08bc0aed722ad9f3e989a597cb264a994387756f/src/main/scala/mesosphere
	   *       /marathon/state/AppDefinition.scala
	   *
	   * @param {Object} app - The data to validate
	   * @returns {Array} Returns an array with validation errors
	   */
	  containsCmdArgsOrContainer: function containsCmdArgsOrContainer(app) {
	    var hasCmd = !_ValidatorUtil2.default.isEmpty(app.cmd);
	    var hasArgs = !_ValidatorUtil2.default.isEmpty(app.args);
	
	    // Dont accept both `args` and `cmd`
	    if (hasCmd && hasArgs) {
	      var notBothMessage = "Please specify only one of `cmd` or `args`";
	      var _type = _ServiceErrorTypes.PROP_CONFLICT;
	      var _variables = {
	        feature1: "cmd",
	        feature2: "args"
	      };
	
	      return [{ path: ["cmd"], message: notBothMessage, type: _type, variables: _variables }, { path: ["args"], message: notBothMessage, type: _type, variables: _variables }];
	    }
	
	    // Check if we have either of them
	    if (hasCmd || hasArgs) {
	      return [];
	    }
	
	    // Additional checks if we have container
	    if (app.container) {
	      // MesosDocker type of container (AppDefinition.scala#L553)
	      if (app.container.docker && app.container.docker.image) {
	        return [];
	      }
	
	      // MesosAppC type of container (Container.scala#L165)
	      if (app.container.appc && app.container.appc.image) {
	        // An image ID is a string of the format 'hash-value', where 'hash' is
	        // the hash algorithm used and 'value' is the hex-encoded digest.
	        // Currently the only permitted hash algorithm is sha512.
	        // (Validation in Container.scala#L158)
	        if (app.container.appc.id && !/^sha512-./.exec(app.container.appc.id)) {
	          return [{
	            path: ["container", "appc", "id"],
	            message: "AppContainer id should start with 'sha512-'",
	            type: "STRING_PATTERN",
	            variables: {
	              pattern: "^sha512-"
	            }
	          }];
	        }
	
	        return [];
	      }
	    }
	
	    // Create one error for every field, instead of showing the error
	    // to the root.
	    var message = "You must specify a command, an argument or a container";
	    var type = _ServiceErrorTypes.PROP_MISSING_ONE;
	    var variables = {
	      names: "cmd, args, container.docker.image"
	    };
	
	    return [{ path: ["cmd"], message: message, type: type, variables: variables }, { path: ["args"], message: message, type: type, variables: variables }, { path: ["container", "docker", "image"], message: message, type: type, variables: variables }];
	  },
	
	
	  /**
	   * @param {Object} app - The data to validate
	   * @returns {Array} Returns an array with validation errors
	   */
	  complyWithResidencyRules: function complyWithResidencyRules(app) {
	    var hasAppResidency = !_ValidatorUtil2.default.isEmpty(app.residency);
	    var hasPersistentVolumes = false;
	
	    // Check if app has at leas one persistent volume
	    if (app.container && app.container.volumes) {
	      hasPersistentVolumes = app.container.volumes.some(function (volume) {
	        return !_ValidatorUtil2.default.isEmpty(volume.persistent);
	      });
	    }
	
	    if (hasAppResidency !== hasPersistentVolumes) {
	      var message = "AppDefinition must contain persistent volumes and " + "define residency";
	      var type = _ServiceErrorTypes.PROP_MISSING_ALL;
	      var variables = {
	        names: "residency, container.volumes"
	      };
	
	      return [{ path: ["residency"], message: message, type: type, variables: variables }, { path: ["container", "volumes"], message: message, type: type, variables: variables }];
	    }
	
	    return [];
	  },
	
	
	  /**
	   * @param {Object} app - The data to validate
	   * @returns {Array} Returns an array with validation errors
	   */
	  mustContainImageOnDocker: function mustContainImageOnDocker(app) {
	    var type = (0, _Util.findNestedPropertyInObject)(app, "container.type");
	    var image = (0, _Util.findNestedPropertyInObject)(app, "container.docker.image");
	
	    if (type === DOCKER && _ValidatorUtil2.default.isEmpty(image)) {
	      return [{
	        path: ["container", "docker", "image"],
	        message: 'Must be specified when using the Docker Engine runtime. You can change runtimes under "Advanced Settings"',
	        type: "PROP_IS_MISSING",
	        variables: {}
	      }];
	    }
	
	    return [];
	  },
	
	
	  /**
	   * @param {Object} app - The data to validate
	   * @returns {Array} Returns an array with validation errors
	   */
	  mustNotContainUris: function mustNotContainUris(app) {
	    if (_ValidatorUtil2.default.isDefined(app.uris) && _ValidatorUtil2.default.isDefined(app.fetch)) {
	      var message = "`uris` are deprecated. Please use `fetch` instead";
	      var type = _ServiceErrorTypes.PROP_DEPRECATED;
	      var variables = {
	        name: "uris"
	      };
	
	      return [{ path: ["uris"], message: message, type: type, variables: variables }];
	    }
	
	    // No errors
	    return [];
	  },
	  validateConstraints: function validateConstraints(app) {
	    var constraints = (0, _Util.findNestedPropertyInObject)(app, "constraints") || [];
	    if (constraints != null && !Array.isArray(constraints)) {
	      return [{
	        path: ["constraints"],
	        message: "constrains needs to be an array of 2 or 3 element arrays",
	        type: "TYPE_NOT_ARRAY"
	      }];
	    }
	
	    var isRequiredMessage = "You must specify a value for operator {{operator}}";
	    var isRequiredEmptyMessage = "Value must be empty for operator {{operator}}";
	    var isStringNumberMessage = "Must only contain characters between 0-9 for operator {{operator}}";
	    var variables = { name: "value" };
	
	    return constraints.reduce(function (errors, constraint, index) {
	      if (!Array.isArray(constraint)) {
	        errors.push({
	          path: ["constraints", index],
	          message: "Must be an array",
	          type: "TYPE_NOT_ARRAY"
	        });
	
	        return errors;
	      }
	
	      var _constraint = (0, _slicedToArray3.default)(constraint, 3),
	          _fieldName = _constraint[0],
	          operator = _constraint[1],
	          value = _constraint[2];
	
	      var isValueRequiredAndEmpty = _PlacementConstraintsUtil2.default.requiresValue(operator) && _ValidatorUtil2.default.isEmpty(value);
	
	      if (isValueRequiredAndEmpty) {
	        errors.push({
	          path: ["constraints", index, "value"],
	          message: isRequiredMessage.replace("{{operator}}", operator),
	          type: _ServiceErrorTypes.PROP_MISSING_ONE,
	          variables: variables
	        });
	      }
	
	      var isValueDefinedAndRequiredEmpty = _PlacementConstraintsUtil2.default.requiresEmptyValue(operator) && !_ValidatorUtil2.default.isEmpty(value);
	
	      if (isValueDefinedAndRequiredEmpty) {
	        errors.push({
	          path: ["constraints", index, "value"],
	          message: isRequiredEmptyMessage.replace("{{operator}}", operator),
	          type: _ServiceErrorTypes.SYNTAX_ERROR,
	          variables: variables
	        });
	      }
	
	      var isValueNotAStringNumberWhenRequired = _PlacementConstraintsUtil2.default.stringNumberValue(operator) && !_ValidatorUtil2.default.isEmpty(value) && !_ValidatorUtil2.default.isStringInteger(value);
	
	      if (isValueNotAStringNumberWhenRequired) {
	        errors.push({
	          path: ["constraints", index, "value"],
	          message: isStringNumberMessage.replace("{{operator}}", operator),
	          type: _ServiceErrorTypes.SYNTAX_ERROR,
	          variables: variables
	        });
	      }
	
	      return errors;
	    }, []);
	  },
	
	
	  /**
	   * @param {Object} app - The data to validate
	   * @returns {Array} Returns an array with validation errors
	   */
	  validateLabels: function validateLabels(app) {
	    if (_ValidatorUtil2.default.isDefined(app.labels)) {
	      return (0, _keys2.default)(app.labels).reduce(function (accumulator, labelKey) {
	        if (/^\s|\s$/.test(labelKey)) {
	          accumulator.push("labels." + labelKey);
	        }
	
	        return accumulator;
	      }, []).map(function (labelPath) {
	        return {
	          path: [labelPath],
	          message: "Keys must not start or end with whitespace characters",
	          type: _ServiceErrorTypes.SYNTAX_ERROR,
	          variables: { name: "labels" }
	        };
	      });
	    }
	
	    // No errors
	    return [];
	  }
	};
	
	module.exports = MarathonAppValidators;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _OperatorTypes = __webpack_require__(1715);
	
	var _OperatorTypes2 = _interopRequireDefault(_OperatorTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  requiresValue: function requiresValue(operator) {
	    var constraintType = _OperatorTypes2.default[operator] || {};
	
	    return constraintType.requiresValue;
	  },
	  stringNumberValue: function stringNumberValue(operator) {
	    var constraintType = _OperatorTypes2.default[operator] || {};
	
	    return constraintType.stringNumberValue;
	  },
	  requiresEmptyValue: function requiresEmptyValue(operator) {
	    var constraintType = _OperatorTypes2.default[operator] || {};
	
	    return constraintType.requiresEmptyValue;
	  }
	};

/***/ },
/* 1715 */
/***/ function(module, exports) {

	"use strict";
	
	var OperatorTypes = {
	  UNIQUE: {
	    requiresValue: false,
	    requiresEmptyValue: true,
	    stringNumberValue: false
	  },
	  CLUSTER: {
	    requiresValue: true,
	    requiresEmptyValue: false,
	    stringNumberValue: false
	  },
	  GROUP_BY: {
	    requiresValue: false,
	    requiresEmptyValue: false,
	    stringNumberValue: true
	  },
	  LIKE: {
	    requiresValue: true,
	    requiresEmptyValue: false,
	    stringNumberValue: false
	  },
	  UNLIKE: {
	    requiresValue: true,
	    requiresEmptyValue: false,
	    stringNumberValue: false
	  },
	  MAX_PER: {
	    requiresValue: true,
	    requiresEmptyValue: false,
	    stringNumberValue: true
	  }
	};
	
	module.exports = OperatorTypes;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateServiceModalServicePickerOption = __webpack_require__(1717);
	
	var _CreateServiceModalServicePickerOption2 = _interopRequireDefault(_CreateServiceModalServicePickerOption);
	
	var _CreateServiceModalServicePickerOptionContent = __webpack_require__(1718);
	
	var _CreateServiceModalServicePickerOptionContent2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionContent);
	
	var _CreateServiceModalServicePickerOptionImage = __webpack_require__(1719);
	
	var _CreateServiceModalServicePickerOptionImage2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionImage);
	
	var _CreateServiceModalServicePickerOptionWrapper = __webpack_require__(1720);
	
	var _CreateServiceModalServicePickerOptionWrapper2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionWrapper);
	
	var _iconServiceDefaultLarge2x = __webpack_require__(1084);
	
	var _iconServiceDefaultLarge2x2 = _interopRequireDefault(_iconServiceDefaultLarge2x);
	
	var _serviceImageJsonLarge2x = __webpack_require__(1721);
	
	var _serviceImageJsonLarge2x2 = _interopRequireDefault(_serviceImageJsonLarge2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	
	function SingleContainerOption(_ref) {
	  var columnClasses = _ref.columnClasses,
	      onOptionSelect = _ref.onOptionSelect;
	
	  return _react2.default.createElement(
	    _CreateServiceModalServicePickerOption2.default,
	    {
	      columnClasses: columnClasses,
	      onOptionSelect: onOptionSelect.bind(null, { type: "app" })
	    },
	    _react2.default.createElement(_CreateServiceModalServicePickerOptionImage2.default, { src: _iconServiceDefaultLarge2x2.default }),
	    _react2.default.createElement(
	      _CreateServiceModalServicePickerOptionContent2.default,
	      null,
	      "Single Container"
	    )
	  );
	}
	/* eslint-disable no-unused-vars */
	
	
	function MultiContainerOption(_ref2) {
	  var columnClasses = _ref2.columnClasses,
	      onOptionSelect = _ref2.onOptionSelect;
	
	  return _react2.default.createElement(
	    _CreateServiceModalServicePickerOption2.default,
	    {
	      columnClasses: columnClasses,
	      onOptionSelect: onOptionSelect.bind(null, { type: "pod" })
	    },
	    _react2.default.createElement(_CreateServiceModalServicePickerOptionImage2.default, { src: _iconServiceDefaultLarge2x2.default }),
	    _react2.default.createElement(
	      _CreateServiceModalServicePickerOptionContent2.default,
	      null,
	      "Multi-container (Pod)"
	    )
	  );
	}
	
	function JSONOption(_ref3) {
	  var columnClasses = _ref3.columnClasses,
	      onOptionSelect = _ref3.onOptionSelect;
	
	  return _react2.default.createElement(
	    _CreateServiceModalServicePickerOption2.default,
	    {
	      columnClasses: columnClasses,
	      onOptionSelect: onOptionSelect.bind(null, { type: "json" })
	    },
	    _react2.default.createElement(_CreateServiceModalServicePickerOptionImage2.default, { src: _serviceImageJsonLarge2x2.default }),
	    _react2.default.createElement(
	      _CreateServiceModalServicePickerOptionContent2.default,
	      null,
	      "JSON Configuration"
	    )
	  );
	}
	
	var OPTIONS = [JSONOption, MultiContainerOption, SingleContainerOption];
	
	var CreateServiceModalServicePicker = function (_React$Component) {
	  (0, _inherits3.default)(CreateServiceModalServicePicker, _React$Component);
	
	  function CreateServiceModalServicePicker() {
	    (0, _classCallCheck3.default)(this, CreateServiceModalServicePicker);
	    return (0, _possibleConstructorReturn3.default)(this, (CreateServiceModalServicePicker.__proto__ || (0, _getPrototypeOf2.default)(CreateServiceModalServicePicker)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CreateServiceModalServicePicker, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      OPTIONS.forEach(function (component, index) {
	        _foundationUi.MountService.MountService.registerComponent(component, "CreateService:ServicePicker:GridOptions", index + 1);
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      OPTIONS.forEach(function (component) {
	        _foundationUi.MountService.MountService.unregisterComponent(component, "CreateService:ServicePicker:GridOptions");
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "create-service-modal-service-picker container container-wide" },
	        _react2.default.createElement(
	          "div",
	          { className: "create-service-modal-service-picker-options" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(_foundationUi.MountService.Mount, {
	              alwaysWrap: true,
	              onOptionSelect: this.props.onServiceSelect,
	              type: "CreateService:ServicePicker:GridOptions",
	              wrapper: _CreateServiceModalServicePickerOptionWrapper2.default
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CreateServiceModalServicePicker;
	}(_react2.default.Component);
	
	CreateServiceModalServicePicker.propTypes = {
	  onServiceSelect: _react2.default.PropTypes.func
	};
	
	module.exports = CreateServiceModalServicePicker;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CreateServiceModalServicePickerOptionContent = __webpack_require__(1718);
	
	var _CreateServiceModalServicePickerOptionContent2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionContent);
	
	var _CreateServiceModalServicePickerOptionImage = __webpack_require__(1719);
	
	var _CreateServiceModalServicePickerOptionImage2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionImage);
	
	var _Panel = __webpack_require__(1042);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildOfType(children, type) {
	  return _react2.default.Children.toArray(children).filter(function (child) {
	    return child.type === type;
	  });
	}
	
	function CreateServiceModalServicePickerOption(_ref) {
	  var children = _ref.children,
	      columnClasses = _ref.columnClasses,
	      onOptionSelect = _ref.onOptionSelect;
	
	  var contentClasses = ["horizontal-center panel-cell flush-top", {
	    "panel-cell-short": false,
	    "panel-cell-shorter": false
	  }];
	  var headingClasses = ["panel-cell-borderless horizontal-center panel-cell", {
	    "panel-cell-light": false,
	    "panel-cell-shorter": false
	  }];
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "create-service-modal-service-picker-option panel-grid-item " + columnClasses
	    },
	    _react2.default.createElement(
	      _Panel2.default,
	      {
	        className: "panel-interactive clickable",
	        contentClass: contentClasses,
	        heading: getChildOfType(children, _CreateServiceModalServicePickerOptionImage2.default),
	        headingClass: headingClasses,
	        onClick: onOptionSelect
	      },
	      getChildOfType(children, _CreateServiceModalServicePickerOptionContent2.default)
	    )
	  );
	}
	
	module.exports = CreateServiceModalServicePickerOption;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreateServiceModalServicePickerOptionContent(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    "h5",
	    { className: "flush text-align-center" },
	    children
	  );
	}
	
	module.exports = CreateServiceModalServicePickerOptionContent;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreateServiceModalServicePickerOptionImage(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "icon icon-huge icon-image-container icon-app-container" },
	    _react2.default.createElement(_Image2.default, props)
	  );
	}
	
	module.exports = CreateServiceModalServicePickerOptionImage;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OptionsWrapper(_ref) {
	  var children = _ref.children;
	
	  var columnClasses = "column-12 column-small-6";
	  var containerClasses = "column-12 column-small-10 column-small-offset-1 column-large-8 column-large-offset-2";
	
	  // If the children are divisible evenly by 3, render 3 columns.
	  // Otherwise default to 2 columns.
	  if (children.length % 3 === 0) {
	    columnClasses = "column-12 column-small-4";
	    containerClasses = "column-12 column-medium-10 column-medium-offset-1";
	  }
	
	  var clonedChildren = _react2.default.Children.map(children, function (child) {
	    return _react2.default.cloneElement(child, { columnClasses: columnClasses });
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: containerClasses },
	    _react2.default.createElement(
	      "div",
	      { className: "row panel-grid" },
	      clonedChildren
	    )
	  );
	}
	
	module.exports = OptionsWrapper;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./c98fa68ffd53a764ba672cc627b53bfc-service-image-json-large@2x.png";

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(1723);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _StringUtil = __webpack_require__(952);
	
	var _AdvancedSection = __webpack_require__(1724);
	
	var _AdvancedSection2 = _interopRequireDefault(_AdvancedSection);
	
	var _AdvancedSectionContent = __webpack_require__(1725);
	
	var _AdvancedSectionContent2 = _interopRequireDefault(_AdvancedSectionContent);
	
	var _AdvancedSectionLabel = __webpack_require__(1726);
	
	var _AdvancedSectionLabel2 = _interopRequireDefault(_AdvancedSectionLabel);
	
	var _Batch = __webpack_require__(1727);
	
	var _Batch2 = _interopRequireDefault(_Batch);
	
	var _DataValidatorUtil = __webpack_require__(1673);
	
	var _DataValidatorUtil2 = _interopRequireDefault(_DataValidatorUtil);
	
	var _ErrorMessageUtil = __webpack_require__(1728);
	
	var _ErrorMessageUtil2 = _interopRequireDefault(_ErrorMessageUtil);
	
	var _ErrorsAlert = __webpack_require__(1729);
	
	var _ErrorsAlert2 = _interopRequireDefault(_ErrorsAlert);
	
	var _FluidGeminiScrollbar = __webpack_require__(1339);
	
	var _FluidGeminiScrollbar2 = _interopRequireDefault(_FluidGeminiScrollbar);
	
	var _JSONEditor = __webpack_require__(1703);
	
	var _JSONEditor2 = _interopRequireDefault(_JSONEditor);
	
	var _PageHeaderNavigationDropdown = __webpack_require__(1332);
	
	var _PageHeaderNavigationDropdown2 = _interopRequireDefault(_PageHeaderNavigationDropdown);
	
	var _TabButton = __webpack_require__(1731);
	
	var _TabButton2 = _interopRequireDefault(_TabButton);
	
	var _TabButtonList = __webpack_require__(1732);
	
	var _TabButtonList2 = _interopRequireDefault(_TabButtonList);
	
	var _Tabs = __webpack_require__(1733);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabView = __webpack_require__(1734);
	
	var _TabView2 = _interopRequireDefault(_TabView);
	
	var _TabViewList = __webpack_require__(1735);
	
	var _TabViewList2 = _interopRequireDefault(_TabViewList);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _TransactionTypes2 = _interopRequireDefault(_TransactionTypes);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ArtifactsSection = __webpack_require__(1737);
	
	var _ArtifactsSection2 = _interopRequireDefault(_ArtifactsSection);
	
	var _ContainerServiceFormSection = __webpack_require__(1684);
	
	var _ContainerServiceFormSection2 = _interopRequireDefault(_ContainerServiceFormSection);
	
	var _CreateServiceModalFormUtil = __webpack_require__(1738);
	
	var _CreateServiceModalFormUtil2 = _interopRequireDefault(_CreateServiceModalFormUtil);
	
	var _EnvironmentFormSection = __webpack_require__(1707);
	
	var _EnvironmentFormSection2 = _interopRequireDefault(_EnvironmentFormSection);
	
	var _GeneralServiceFormSection = __webpack_require__(1739);
	
	var _GeneralServiceFormSection2 = _interopRequireDefault(_GeneralServiceFormSection);
	
	var _HealthChecksFormSection = __webpack_require__(1746);
	
	var _HealthChecksFormSection2 = _interopRequireDefault(_HealthChecksFormSection);
	
	var _MultiContainerHealthChecksFormSection = __webpack_require__(1749);
	
	var _MultiContainerHealthChecksFormSection2 = _interopRequireDefault(_MultiContainerHealthChecksFormSection);
	
	var _MultiContainerNetworkingFormSection = __webpack_require__(1750);
	
	var _MultiContainerNetworkingFormSection2 = _interopRequireDefault(_MultiContainerNetworkingFormSection);
	
	var _MultiContainerVolumesFormSection = __webpack_require__(1754);
	
	var _MultiContainerVolumesFormSection2 = _interopRequireDefault(_MultiContainerVolumesFormSection);
	
	var _MultiContainerFormAdvancedSection = __webpack_require__(1757);
	
	var _MultiContainerFormAdvancedSection2 = _interopRequireDefault(_MultiContainerFormAdvancedSection);
	
	var _NetworkingFormSection = __webpack_require__(1758);
	
	var _NetworkingFormSection2 = _interopRequireDefault(_NetworkingFormSection);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _ServiceErrorMessages = __webpack_require__(1762);
	
	var _ServiceErrorMessages2 = _interopRequireDefault(_ServiceErrorMessages);
	
	var _ServiceErrorPathMapping = __webpack_require__(1764);
	
	var _ServiceErrorPathMapping2 = _interopRequireDefault(_ServiceErrorPathMapping);
	
	var _ServiceUtil = __webpack_require__(1244);
	
	var _ServiceUtil2 = _interopRequireDefault(_ServiceUtil);
	
	var _VolumesFormSection = __webpack_require__(1765);
	
	var _VolumesFormSection2 = _interopRequireDefault(_VolumesFormSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getNewStateForJSON", "handleAddItem", "handleConvertToPod", "handleDropdownNavigationSelection", "handleFormBlur", "handleFormFocus", "handleFormChange", "handleJSONChange", "handleJSONPropertyChange", "handleJSONErrorStateChange", "handleRemoveItem", "handleClickItem"];
	
	/**
	 * Since the form input fields operate on a different path than the one in the
	 * data, it's not always possible to figure out which error paths to unmute when
	 * the field is edited. Therefore, form fields that do not map 1:1 with the data
	 * are opted out from the error muting feature.
	 *
	 * TODO: This should be removed when DCOS-13524 is completed
	 */
	var CONSTANTLY_UNMUTED_ERRORS = [/^constraints\.[0-9]+\./, /^portDefinitions\.[0-9]+\./, /^container.docker.portMappings\.[0-9]+\./, /^localVolumes\.[0-9]+\./];
	
	function cleanConfig(config) {
	  var _config$labels = config.labels,
	      labels = _config$labels === undefined ? {} : _config$labels,
	      _config$env = config.env,
	      env = _config$env === undefined ? {} : _config$env,
	      _config$environment = config.environment,
	      environment = _config$environment === undefined ? {} : _config$environment,
	      serviceConfig = (0, _objectWithoutProperties3.default)(config, ["labels", "env", "environment"]);
	
	
	  var newServiceConfig = _CreateServiceModalFormUtil2.default.stripEmptyProperties(serviceConfig);
	  if ((0, _keys2.default)(labels).length !== 0) {
	    newServiceConfig = (0, _extends3.default)({
	      labels: labels
	    }, newServiceConfig);
	  }
	  if ((0, _keys2.default)(env).length !== 0) {
	    newServiceConfig = (0, _extends3.default)({
	      env: env
	    }, newServiceConfig);
	  }
	  if ((0, _keys2.default)(environment).length !== 0) {
	    newServiceConfig = (0, _extends3.default)({
	      environment: environment
	    }, newServiceConfig);
	  }
	
	  return newServiceConfig;
	}
	
	var CreateServiceModalForm = function (_Component) {
	  (0, _inherits3.default)(CreateServiceModalForm, _Component);
	
	  function CreateServiceModalForm() {
	    (0, _classCallCheck3.default)(this, CreateServiceModalForm);
	
	    // Hint: When you add something to the state, make sure to update the
	    //       shouldComponentUpdate function, since we are trying to reduce
	    //       the number of updates as much as possible.
	    // In the Next line we are destructing the config to keep labels as it is and even keep labels with an empty value
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateServiceModalForm.__proto__ || (0, _getPrototypeOf2.default)(CreateServiceModalForm)).apply(this, arguments));
	
	    var newServiceConfig = cleanConfig(_ServiceUtil2.default.getServiceJSON(_this.props.service));
	    _this.state = (0, _assign2.default)({
	      appConfig: null,
	      batch: new _Batch2.default(),
	      baseConfig: {},
	      editedFieldPaths: [],
	      editingFieldPath: null,
	      isPod: false,
	      jsonReducer: function jsonReducer() {},
	      jsonParser: function jsonParser() {}
	    }, _this.getNewStateForJSON(newServiceConfig, _this.props.service instanceof _PodSpec2.default));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CreateServiceModalForm, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var prevJSON = _ServiceUtil2.default.getServiceJSON(this.props.service);
	      var nextJSON = _ServiceUtil2.default.getServiceJSON(nextProps.service);
	      var isPod = nextProps.service instanceof _PodSpec2.default;
	
	      // Note: We ignore changes that might derive from the `onChange` event
	      // handler. In that case the contents of nextJSON would be the same
	      // as the contents of the last rendered appConfig in the state.
	      if (this.state.isPod !== isPod || !(0, _deepEqual2.default)(prevJSON, nextJSON) && !(0, _deepEqual2.default)(this.state.appConfig, nextJSON) && !(0, _deepEqual2.default)(this.props.errors, nextProps.errors)) {
	        this.setState(this.getNewStateForJSON(nextJSON, isPod));
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _state = this.state,
	          editingFieldPath = _state.editingFieldPath,
	          appConfig = _state.appConfig;
	      var _props = this.props,
	          onChange = _props.onChange,
	          service = _props.service;
	
	
	      var shouldUpdate = editingFieldPath === null && (prevState.editingFieldPath !== null || !(0, _deepEqual2.default)(appConfig, prevState.appConfig));
	      if (shouldUpdate) {
	        onChange(new service.constructor(appConfig));
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // Update if json state changed
	      if (this.props.isJSONModeActive !== nextProps.isJSONModeActive) {
	        return true;
	      }
	
	      // Update if showAllErrors changed
	      if (this.props.showAllErrors !== nextProps.showAllErrors) {
	        return true;
	      }
	
	      // Update if pod type changed
	      if (this.state.isPod !== nextProps.service instanceof _PodSpec2.default) {
	        return true;
	      }
	
	      // Update if service property has changed
	      //
	      // Note: We ignore changes that might derrive from the `onChange` event
	      // handler. In that case the contents of nextJSON would be the same
	      // as the contents of the last rendered appConfig in the state.
	      //
	      var prevJSON = _ServiceUtil2.default.getServiceJSON(this.props.service);
	      var nextJSON = _ServiceUtil2.default.getServiceJSON(nextProps.service);
	      if (!(0, _deepEqual2.default)(prevJSON, nextJSON) && !(0, _deepEqual2.default)(this.state.appConfig, nextJSON)) {
	        return true;
	      }
	
	      var didBaseConfigChange = this.state.baseConfig !== nextState.baseConfig;
	      var didBatchChange = this.state.batch !== nextState.batch;
	      var didEditingFieldPathChange = this.state.editingFieldPath !== nextState.editingFieldPath;
	      var didActiveTabChange = this.props.activeTab !== nextProps.activeTab;
	
	      // Otherwise update if the state has changed
	      return didBaseConfigChange || didBatchChange || didEditingFieldPathChange || didActiveTabChange || !(0, _deepEqual2.default)(this.props.errors, nextProps.errors);
	    }
	  }, {
	    key: "getNewStateForJSON",
	    value: function getNewStateForJSON() {
	      var baseConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.isPod;
	
	      var newState = {
	        baseConfig: baseConfig,
	        isPod: isPod
	      };
	
	      // Regenerate batch
	      newState.batch = this.props.jsonParserReducers((0, _Util.deepCopy)(baseConfig)).reduce(function (batch, item) {
	        return batch.add(item);
	      }, new _Batch2.default());
	
	      // Update appConfig
	      newState.appConfig = this.getAppConfig(newState.batch, baseConfig);
	
	      return newState;
	    }
	  }, {
	    key: "handleConvertToPod",
	    value: function handleConvertToPod() {
	      this.props.onConvertToPod(this.getAppConfig());
	    }
	  }, {
	    key: "handleDropdownNavigationSelection",
	    value: function handleDropdownNavigationSelection(item) {
	      this.props.handleTabChange(item.id);
	    }
	  }, {
	    key: "handleJSONChange",
	    value: function handleJSONChange(jsonObject) {
	      this.setState(this.getNewStateForJSON(jsonObject));
	    }
	  }, {
	    key: "handleJSONPropertyChange",
	    value: function handleJSONPropertyChange(path) {
	      var editedFieldPaths = this.state.editedFieldPaths;
	
	      var pathStr = path.join(".");
	      if (path.length === 0) {
	        return;
	      }
	
	      if (!editedFieldPaths.includes(pathStr)) {
	        this.setState({
	          editedFieldPaths: editedFieldPaths.concat([pathStr])
	        });
	      }
	    }
	  }, {
	    key: "handleJSONErrorStateChange",
	    value: function handleJSONErrorStateChange(errorMessage) {
	      if (errorMessage !== null) {
	        this.props.onErrorsChange([{ message: errorMessage, path: [] }]);
	      } else {
	        this.props.onErrorsChange([]);
	      }
	    }
	  }, {
	    key: "handleFormBlur",
	    value: function handleFormBlur(event) {
	      var editedFieldPaths = this.state.editedFieldPaths;
	
	      var fieldName = event.target.getAttribute("name");
	      var newState = {
	        editingFieldPath: null
	      };
	
	      if (!fieldName) {
	        return;
	      }
	
	      // Keep track of which fields have changed
	      if (!editedFieldPaths.includes(fieldName)) {
	        newState.editedFieldPaths = editedFieldPaths.concat([fieldName]);
	      }
	      this.setState(newState);
	    }
	  }, {
	    key: "handleFormFocus",
	    value: function handleFormFocus(event) {
	      var fieldName = event.target.getAttribute("name");
	      var newState = {
	        editingFieldPath: fieldName
	      };
	
	      if (!fieldName) {
	        return;
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: "handleFormChange",
	    value: function handleFormChange(event) {
	      var fieldName = event.target.getAttribute("name");
	      if (!fieldName) {
	        return;
	      }
	
	      var batch = this.state.batch;
	
	      var value = event.target.value;
	      if (event.target.type === "checkbox") {
	        value = event.target.checked;
	      }
	      var path = fieldName.split(".");
	      batch = batch.add(new _Transaction2.default(path, value));
	
	      var newState = {
	        appConfig: this.getAppConfig(batch),
	        batch: batch
	      };
	
	      this.setState(newState);
	    }
	  }, {
	    key: "handleAddItem",
	    value: function handleAddItem(event) {
	      var value = event.value,
	          path = event.path;
	      var batch = this.state.batch;
	
	
	      batch = batch.add(new _Transaction2.default(path.split("."), value, _TransactionTypes2.default.ADD_ITEM));
	
	      this.setState({ batch: batch, appConfig: this.getAppConfig(batch) });
	    }
	  }, {
	    key: "handleRemoveItem",
	    value: function handleRemoveItem(event) {
	      var value = event.value,
	          path = event.path;
	      var batch = this.state.batch;
	
	
	      batch = batch.add(new _Transaction2.default(path.split("."), value, _TransactionTypes2.default.REMOVE_ITEM));
	
	      this.setState({ batch: batch, appConfig: this.getAppConfig(batch) });
	    }
	  }, {
	    key: "handleClickItem",
	    value: function handleClickItem(item) {
	      this.props.handleTabChange(item);
	    }
	  }, {
	    key: "getAppConfig",
	    value: function getAppConfig() {
	      var batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.batch;
	      var baseConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.baseConfig;
	
	      // Do a deepCopy once before it goes to reducers
	      // so they don't need to perform Object.assign()
	      var baseConfigCopy = (0, _Util.deepCopy)(baseConfig);
	      var newConfig = batch.reduce(this.props.jsonConfigReducers, baseConfigCopy);
	
	      // In the Next line we are destructing the config to keep labels as it is and even keep labels with an empty value
	      return cleanConfig(newConfig);
	    }
	  }, {
	    key: "getErrors",
	    value: function getErrors() {
	      return _ErrorMessageUtil2.default.translateErrorMessages(this.props.errors, _ServiceErrorMessages2.default);
	    }
	  }, {
	    key: "getContainerList",
	    value: function getContainerList(data) {
	      if (Array.isArray(data.containers) && data.containers.length !== 0) {
	        return data.containers.map(function (item, index) {
	          var fakeContainer = { name: item.name || "container-" + (index + 1) };
	
	          return {
	            className: "text-overflow",
	            id: "container" + index,
	            label: (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(fakeContainer)
	          };
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "getContainerContent",
	    value: function getContainerContent(data, errors) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          service = _props2.service,
	          showAllErrors = _props2.showAllErrors;
	      var containers = data.containers;
	
	
	      if (containers == null) {
	        return [];
	      }
	
	      return containers.map(function (item, index) {
	        var artifactsPath = "containers." + index + ".artifacts";
	        var artifacts = (0, _Util.findNestedPropertyInObject)(data, artifactsPath) || [];
	        var artifactErrors = (0, _Util.findNestedPropertyInObject)(errors, artifactsPath) || [];
	
	        return _react2.default.createElement(
	          _TabView2.default,
	          { key: index, id: "container" + index },
	          _react2.default.createElement(_ErrorsAlert2.default, {
	            errors: _this2.getErrors(),
	            pathMapping: _ServiceErrorPathMapping2.default,
	            hideTopLevelErrors: !showAllErrors
	          }),
	          _react2.default.createElement(
	            "h2",
	            { className: "flush-top short-bottom" },
	            "Container"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Configure your container below. Enter a container image or command you want to run."
	          ),
	          _react2.default.createElement(_ContainerServiceFormSection2.default, {
	            data: data,
	            errors: errors,
	            onAddItem: _this2.handleAddItem,
	            onRemoveItem: _this2.handleRemoveItem,
	            path: "containers." + index,
	            service: service
	          }),
	          _react2.default.createElement(
	            _AdvancedSection2.default,
	            null,
	            _react2.default.createElement(
	              _AdvancedSectionLabel2.default,
	              null,
	              "More Settings"
	            ),
	            _react2.default.createElement(
	              _AdvancedSectionContent2.default,
	              null,
	              _react2.default.createElement(_MultiContainerFormAdvancedSection2.default, {
	                data: data,
	                path: "containers." + index
	              }),
	              _react2.default.createElement(_ArtifactsSection2.default, {
	                data: artifacts,
	                path: artifactsPath,
	                errors: artifactErrors,
	                onRemoveItem: _this2.handleRemoveItem,
	                onAddItem: _this2.handleAddItem
	              })
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "getFormDropdownList",
	    value: function getFormDropdownList(navigationItems, activeTab) {
	      var _this3 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var isNested = options.isNested;
	
	
	      return navigationItems.reduce(function (accumulator, item, index) {
	        accumulator.push({
	          className: (0, _classnames2.default)({ "page-header-menu-item-nested": isNested }),
	          id: item.id,
	          isActive: activeTab === item.id || activeTab == null && index === 0,
	          label: item.label
	        });
	
	        if (item.children) {
	          accumulator = accumulator.concat(_this3.getFormDropdownList(item.children, activeTab, { isNested: true }));
	        }
	
	        return accumulator;
	      }, []);
	    }
	  }, {
	    key: "getFormNavigationItems",
	    value: function getFormNavigationItems(appConfig, data) {
	      var serviceLabel = (0, _StringUtil.pluralize)("Service", (0, _Util.findNestedPropertyInObject)(appConfig, "containers.length") || 1);
	
	      var tabList = [{
	        id: "services",
	        label: serviceLabel,
	        children: this.getContainerList(data)
	      }];
	
	      if (this.state.isPod) {
	        tabList.push({ id: "networking", key: "multinetworking", label: "Networking" }, { id: "volumes", key: "multivolumes", label: "Volumes" }, {
	          id: "healthChecks",
	          key: "multihealthChecks",
	          label: "Health Checks"
	        }, { id: "environment", key: "multienvironment", label: "Environment" });
	      } else {
	        tabList.push({ id: "networking", key: "networking", label: "Networking" }, { id: "volumes", key: "volumes", label: "Volumes" }, { id: "healthChecks", key: "healthChecks", label: "Health Checks" }, { id: "environment", key: "environment", label: "Environment" });
	      }
	
	      return tabList;
	    }
	  }, {
	    key: "getFormTabList",
	    value: function getFormTabList(navigationItems) {
	      var _this4 = this;
	
	      if (navigationItems == null) {
	        return null;
	      }
	
	      return navigationItems.map(function (item) {
	        return _react2.default.createElement(
	          _TabButton2.default,
	          {
	            className: item.className,
	            id: item.id,
	            label: item.label,
	            key: item.key || item.id
	          },
	          _this4.getFormTabList(item.children)
	        );
	      });
	    }
	  }, {
	    key: "getSectionContent",
	    value: function getSectionContent(data, errorMap) {
	      var showAllErrors = this.props.showAllErrors;
	
	      var errors = this.getErrors();
	
	      if (this.state.isPod) {
	        return [_react2.default.createElement(
	          _TabView2.default,
	          { id: "networking", key: "multinetworking" },
	          _react2.default.createElement(_ErrorsAlert2.default, {
	            errors: errors,
	            pathMapping: _ServiceErrorPathMapping2.default,
	            hideTopLevelErrors: !showAllErrors
	          }),
	          _react2.default.createElement(_MultiContainerNetworkingFormSection2.default, {
	            data: data,
	            errors: errorMap,
	            onRemoveItem: this.handleRemoveItem,
	            onAddItem: this.handleAddItem
	          })
	        ), _react2.default.createElement(
	          _TabView2.default,
	          { id: "volumes", key: "multivolumes" },
	          _react2.default.createElement(_ErrorsAlert2.default, {
	            errors: errors,
	            pathMapping: _ServiceErrorPathMapping2.default,
	            hideTopLevelErrors: !showAllErrors
	          }),
	          _react2.default.createElement(_MultiContainerVolumesFormSection2.default, {
	            data: data,
	            errors: errorMap,
	            handleTabChange: this.props.handleTabChange,
	            onRemoveItem: this.handleRemoveItem,
	            onAddItem: this.handleAddItem
	          })
	        ), _react2.default.createElement(
	          _TabView2.default,
	          { id: "healthChecks", key: "multihealthChecks" },
	          _react2.default.createElement(_ErrorsAlert2.default, {
	            errors: errors,
	            pathMapping: _ServiceErrorPathMapping2.default,
	            hideTopLevelErrors: !showAllErrors
	          }),
	          _react2.default.createElement(_MultiContainerHealthChecksFormSection2.default, {
	            data: data,
	            errors: errorMap,
	            handleTabChange: this.props.handleTabChange,
	            onRemoveItem: this.handleRemoveItem,
	            onAddItem: this.handleAddItem
	          })
	        ), _react2.default.createElement(
	          _TabView2.default,
	          { id: "environment", key: "multienvironment" },
	          _react2.default.createElement(_ErrorsAlert2.default, {
	            errors: errors,
	            pathMapping: _ServiceErrorPathMapping2.default,
	            hideTopLevelErrors: !showAllErrors
	          }),
	          _react2.default.createElement(_EnvironmentFormSection2.default, {
	            mountType: "CreateService:MultiContainerEnvironmentFormSection",
	            data: data,
	            errors: errorMap,
	            onRemoveItem: this.handleRemoveItem,
	            onAddItem: this.handleAddItem
	          })
	        )];
	      }
	
	      return [_react2.default.createElement(
	        _TabView2.default,
	        { id: "networking", key: "networking" },
	        _react2.default.createElement(_ErrorsAlert2.default, {
	          errors: errors,
	          pathMapping: _ServiceErrorPathMapping2.default,
	          hideTopLevelErrors: !showAllErrors
	        }),
	        _react2.default.createElement(_NetworkingFormSection2.default, {
	          data: data,
	          errors: errorMap,
	          onRemoveItem: this.handleRemoveItem,
	          onAddItem: this.handleAddItem
	        })
	      ), _react2.default.createElement(
	        _TabView2.default,
	        { id: "volumes", key: "volumes" },
	        _react2.default.createElement(_ErrorsAlert2.default, {
	          errors: errors,
	          pathMapping: _ServiceErrorPathMapping2.default,
	          hideTopLevelErrors: !showAllErrors
	        }),
	        _react2.default.createElement(_VolumesFormSection2.default, {
	          data: data,
	          errors: errorMap,
	          onRemoveItem: this.handleRemoveItem,
	          onAddItem: this.handleAddItem
	        })
	      ), _react2.default.createElement(
	        _TabView2.default,
	        { id: "healthChecks", key: "healthChecks" },
	        _react2.default.createElement(_ErrorsAlert2.default, {
	          errors: errors,
	          pathMapping: _ServiceErrorPathMapping2.default,
	          hideTopLevelErrors: !showAllErrors
	        }),
	        _react2.default.createElement(_HealthChecksFormSection2.default, {
	          data: data,
	          errors: errorMap,
	          onRemoveItem: this.handleRemoveItem,
	          onAddItem: this.handleAddItem
	        })
	      ), _react2.default.createElement(
	        _TabView2.default,
	        { id: "environment", key: "environment" },
	        _react2.default.createElement(_ErrorsAlert2.default, {
	          errors: errors,
	          pathMapping: _ServiceErrorPathMapping2.default,
	          hideTopLevelErrors: !showAllErrors
	        }),
	        _react2.default.createElement(_EnvironmentFormSection2.default, {
	          mountType: "CreateService:EnvironmentFormSection",
	          data: data,
	          errors: errorMap,
	          onRemoveItem: this.handleRemoveItem,
	          onAddItem: this.handleAddItem
	        })
	      )];
	    }
	
	    /**
	     * This function filters the error list in order to keep only the
	     * errors that should be displayed to the UI.
	     *
	     * @returns {Array} - Returns an array of errors that passed the filter
	     */
	
	  }, {
	    key: "getUnmutedErrors",
	    value: function getUnmutedErrors() {
	      var showAllErrors = this.props.showAllErrors;
	      var _state2 = this.state,
	          editedFieldPaths = _state2.editedFieldPaths,
	          editingFieldPath = _state2.editingFieldPath;
	
	
	      return this.getErrors().filter(function (error) {
	        var errorPath = error.path.join(".");
	
	        // Always mute the error on the field we are editing
	        if (editingFieldPath != null && errorPath === editingFieldPath) {
	          return false;
	        }
	
	        // Never mute fields in the CONSTANTLY_UNMUTED_ERRORS fields
	        var isUnmuted = CONSTANTLY_UNMUTED_ERRORS.some(function (rule) {
	          return rule.test(errorPath);
	        });
	
	        return isUnmuted || showAllErrors || editedFieldPaths.includes(errorPath);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _state3 = this.state,
	          appConfig = _state3.appConfig,
	          batch = _state3.batch;
	      var _props3 = this.props,
	          activeTab = _props3.activeTab,
	          handleTabChange = _props3.handleTabChange,
	          isEdit = _props3.isEdit,
	          isJSONModeActive = _props3.isJSONModeActive,
	          onConvertToPod = _props3.onConvertToPod,
	          service = _props3.service,
	          showAllErrors = _props3.showAllErrors;
	
	      var data = batch.reduce(this.props.inputConfigReducers, {});
	      var unmutedErrors = this.getUnmutedErrors();
	      var errors = this.getErrors();
	
	      var jsonEditorPlaceholderClasses = (0, _classnames2.default)("modal-full-screen-side-panel-placeholder", { "is-visible": isJSONModeActive });
	      var jsonEditorClasses = (0, _classnames2.default)("modal-full-screen-side-panel", {
	        "is-visible": isJSONModeActive
	      });
	
	      var errorMap = _DataValidatorUtil2.default.errorArrayToMap(unmutedErrors);
	      var navigationItems = this.getFormNavigationItems(appConfig, data);
	      var tabButtonListItems = this.getFormTabList(navigationItems);
	      var navigationDropdownItems = this.getFormDropdownList(navigationItems, activeTab);
	
	      return _react2.default.createElement(
	        "div",
	        { className: "flex flex-item-grow-1" },
	        _react2.default.createElement(
	          "div",
	          { className: "create-service-modal-form__scrollbar-container modal-body-offset gm-scrollbar-container-flex" },
	          _react2.default.createElement(_PageHeaderNavigationDropdown2.default, {
	            handleNavigationItemSelection: this.handleDropdownNavigationSelection,
	            items: navigationDropdownItems
	          }),
	          _react2.default.createElement(
	            _FluidGeminiScrollbar2.default,
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "modal-body-padding-surrogate create-service-modal-form-container" },
	              _react2.default.createElement(
	                "form",
	                {
	                  className: "create-service-modal-form container container-wide",
	                  onChange: this.handleFormChange,
	                  onBlur: this.handleFormBlur,
	                  onFocus: this.handleFormFocus
	                },
	                _react2.default.createElement(
	                  _Tabs2.default,
	                  {
	                    activeTab: activeTab,
	                    handleTabChange: handleTabChange,
	                    vertical: true
	                  },
	                  _react2.default.createElement(
	                    _TabButtonList2.default,
	                    null,
	                    tabButtonListItems
	                  ),
	                  _react2.default.createElement(
	                    _TabViewList2.default,
	                    null,
	                    _react2.default.createElement(
	                      _TabView2.default,
	                      { id: "services" },
	                      _react2.default.createElement(_ErrorsAlert2.default, {
	                        errors: errors,
	                        pathMapping: _ServiceErrorPathMapping2.default,
	                        hideTopLevelErrors: !showAllErrors
	                      }),
	                      _react2.default.createElement(_GeneralServiceFormSection2.default, {
	                        errors: errorMap,
	                        data: data,
	                        isEdit: isEdit,
	                        onConvertToPod: onConvertToPod,
	                        service: service,
	                        onRemoveItem: function onRemoveItem(options, event) {
	                          event.stopPropagation();
	                          _this5.handleRemoveItem(options);
	                        },
	                        onClickItem: this.handleClickItem,
	                        onAddItem: this.handleAddItem
	                      })
	                    ),
	                    this.getContainerContent(data, errorMap),
	                    this.getSectionContent(data, errorMap)
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("div", { className: jsonEditorPlaceholderClasses }),
	        _react2.default.createElement(
	          "div",
	          { className: jsonEditorClasses },
	          _react2.default.createElement(_JSONEditor2.default, {
	            errors: errors,
	            onChange: this.handleJSONChange,
	            onPropertyChange: this.handleJSONPropertyChange,
	            onErrorStateChange: this.handleJSONErrorStateChange,
	            showGutter: true,
	            showPrintMargin: false,
	            theme: "monokai",
	            height: "100%",
	            value: appConfig,
	            width: "100%"
	          })
	        )
	      );
	    }
	  }]);
	  return CreateServiceModalForm;
	}(_react.Component);
	
	CreateServiceModalForm.defaultProps = {
	  errors: [],
	  handleTabChange: function handleTabChange() {},
	
	  isJSONModeActive: false,
	  onChange: function onChange() {},
	  onErrorStateChange: function onErrorStateChange() {},
	
	  showAllErrors: false
	};
	
	CreateServiceModalForm.propTypes = {
	  activeTab: _react.PropTypes.string,
	  errors: _react.PropTypes.array,
	  handleTabChange: _react.PropTypes.func,
	  isJSONModeActive: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onErrorStateChange: _react.PropTypes.func,
	  service: _react.PropTypes.object,
	  showAllErrors: _react.PropTypes.bool
	};
	
	module.exports = CreateServiceModalForm;

/***/ },
/* 1723 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdvancedSectionContent = __webpack_require__(1725);
	
	var _AdvancedSectionContent2 = _interopRequireDefault(_AdvancedSectionContent);
	
	var _AdvancedSectionLabel = __webpack_require__(1726);
	
	var _AdvancedSectionLabel2 = _interopRequireDefault(_AdvancedSectionLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleHeadingClick"];
	
	var AdvancedSection = function (_React$Component) {
	  (0, _inherits3.default)(AdvancedSection, _React$Component);
	
	  function AdvancedSection(props) {
	    (0, _classCallCheck3.default)(this, AdvancedSection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AdvancedSection.__proto__ || (0, _getPrototypeOf2.default)(AdvancedSection)).apply(this, arguments));
	
	    _this.state = { isExpanded: props.initialIsExpanded === true };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AdvancedSection, [{
	    key: "handleHeadingClick",
	    value: function handleHeadingClick() {
	      this.setState({ isExpanded: !this.state.isExpanded });
	    }
	  }, {
	    key: "getChildren",
	    value: function getChildren() {
	      var _this2 = this;
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (child.type === _AdvancedSectionLabel2.default) {
	          return _react2.default.cloneElement(child, {
	            onClick: _this2.handleHeadingClick,
	            isExpanded: _this2.state.isExpanded
	          });
	        }
	
	        if (child.type === _AdvancedSectionContent2.default && !_this2.state.isExpanded) {
	          return null;
	        }
	
	        return child;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classes = (0, _dedupe2.default)("advanced-section", this.props.className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getChildren()
	      );
	    }
	  }]);
	  return AdvancedSection;
	}(_react2.default.Component);
	
	AdvancedSection.propTypes = {
	  initialIsExpanded: _react2.default.PropTypes.bool,
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = AdvancedSection;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedSectionContent = function AdvancedSectionContent(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	
	  var classes = (0, _dedupe2.default)("advanced-section-content", className);
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes },
	    children
	  );
	};
	
	AdvancedSectionContent.propTypes = {
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = AdvancedSectionContent;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStateIndicator(isExpanded) {
	  var iconID = "triangle-right";
	
	  if (isExpanded) {
	    iconID = "triangle-down";
	  }
	
	  return _react2.default.createElement(_Icon2.default, { id: iconID, color: "purple", family: "tiny", size: "tiny" });
	}
	
	var AdvancedSectionLabel = function AdvancedSectionLabel(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      isExpanded = _ref.isExpanded,
	      onClick = _ref.onClick;
	
	  var classes = (0, _dedupe2.default)("advanced-section-label clickable button button-primary-link button-flush", className);
	
	  return _react2.default.createElement(
	    "a",
	    { className: classes, onClick: onClick },
	    getStateIndicator(isExpanded),
	    _react2.default.createElement(
	      "span",
	      null,
	      children
	    )
	  );
	};
	
	AdvancedSectionLabel.propTypes = {
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  isExpanded: _react2.default.PropTypes.bool,
	  onClick: _react2.default.PropTypes.func
	};
	
	module.exports = AdvancedSectionLabel;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _TransactionTypes2 = _interopRequireDefault(_TransactionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An immutable batch is an ever growing batch with a reduce capability.
	 *
	 * This can be used to keep action transactions that can be applied through
	 * a set of reducers to a data set in order to transform it.
	 *
	 * Why 'Batch'? Because it's not really a `Stack`, since you cannot `pop`
	 * items from it. Also not a `Log`, because it can be confused with the
	 * logging utilities.
	 *
	 * @example <caption>Using Batch</caption>
	 * class Component extends React.Component() {
	 *   constructor() {
	 *     super(...arguments);
	 *     this.state = {
	 *        batch: new Batch()
	 *     }
	 *   }
	 *
	 *   handleAction() {
	 *     let {batch} = this.state;
	 *     batch.add({
	 *           type: 'set',
	 *           path: ['foo'],
	 *           value: 'bar'
	 *        });
	 *     this.setState({batch});
	 *   }
	 *
	 *   render() {
	 *      let data = this.state.batch.reduce(
	 *            applyActionsToDataCallback,
	 *            this.props.data
	 *         );
	 *
	 *      return <Visualize data={data} />
	 *   }
	 * }
	 *
	 *
	 */
	
	var Batch = function () {
	  function Batch() {
	    var batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    (0, _classCallCheck3.default)(this, Batch);
	
	    this.add = this.add.bind(batch);
	    this.reduce = this.reduce.bind(batch);
	  }
	
	  /**
	   * Add an action to the batch.
	   *
	   * @this Array
	   * @param {Object} item
	   * @returns {Batch} Returns the new batch
	   */
	
	
	  (0, _createClass3.default)(Batch, [{
	    key: "add",
	    value: function add(item) {
	      // Operate on a new array
	      var batch = this.slice();
	
	      // Remove previous if path is the same as current to minimize
	      // number of actions
	
	      var _ref = batch[batch.length - 1] || {},
	          path = _ref.path;
	
	      var hasEqualPaths = item && Array.isArray(path) && Array.isArray(item.path) && path.join() === item.path.join();
	      if (item.type === _TransactionTypes2.default.SET && hasEqualPaths) {
	        batch.pop();
	      }
	
	      batch.push(item);
	
	      // Create new batch
	      return new Batch(batch);
	    }
	
	    /**
	     * Apply the given reducer function to the batch containing the provided data.
	     *
	     * This interface is exactly the same as the native Array.reduce function.
	     *
	     * @this Array
	     * @param {function(state, item)} callback - The callback function to use
	     * @param {*} data - The initial state of the reduce function
	     * @returns {any} - The resulting state of the reduce function
	     */
	
	  }, {
	    key: "reduce",
	    value: function reduce(callback, data) {
	      // Run at least once even if there are no actions in the batch
	      if (this.length === 0) {
	        return callback(data, { path: [], value: "INIT" }, 0);
	      }
	
	      return this.reduce(callback, data);
	    }
	  }]);
	  return Batch;
	}();
	
	module.exports = Batch;

/***/ },
/* 1728 */
/***/ function(module, exports) {

	"use strict";
	
	var MESSAGE_VARIABLE = /\{\{([^{}]+)\}\}/g;
	
	var ErrorMessageUtil = {
	  /**
	   * This function returns the `message` of the given array object,
	   * with the path and message components concatenated into a uniform
	   * string that can be displayed unanchored.
	   *
	   * @param {Object} error - The error message
	   * @param {Array} pathTranslationRules - The path translation rules
	   * @returns {String} Returns the composed error string
	   */
	  getUnanchoredErrorMessage: function getUnanchoredErrorMessage(error, pathTranslationRules) {
	    var message = error.message,
	        _error$path = error.path,
	        path = _error$path === undefined ? [] : _error$path;
	
	    var pathString = path.join(".");
	    var rule = pathTranslationRules.find(function (rule) {
	      return rule.match.exec(pathString);
	    });
	
	    if (!rule && !pathString) {
	      return message;
	    }
	    if (!rule) {
	      return pathString + ": " + message;
	    }
	
	    // We need to make the first letter of the error message lowercase
	    // in order to compose a proper sentence with the resolved path name.
	    var errorMessage = message[0].toLowerCase() + message.substr(1);
	
	    return rule.name + " " + errorMessage;
	  },
	
	
	  /**
	   * Translate the error messages in the `errors` array, using the translation
	   * rules in the `translationRules` array.
	   *
	   * @param {Array} errors - The list of errors to translate
	   * @param {Array} translationRules - The translation rules to use
	   * @returns {Array} Returns a new list with the translated error messages
	   */
	  translateErrorMessages: function translateErrorMessages(errors, translationRules) {
	    return errors.map(function (error) {
	      var _error$path2 = error.path,
	          path = _error$path2 === undefined ? [] : _error$path2,
	          type = error.type,
	          variables = error.variables;
	
	      var pathString = path.join(".");
	
	      var rule = translationRules.find(function (rule) {
	        return rule.type === type && rule.path.exec(pathString);
	      });
	
	      // If there is no translation rule, pass-through the message
	      if (rule == null) {
	        return error;
	      }
	
	      // Return the translated message
	      return {
	        message: rule.message.replace(MESSAGE_VARIABLE, function (match, variable) {
	          return "" + variables[variable] || "";
	        }),
	        path: path,
	        type: type,
	        variables: variables
	      };
	    });
	  }
	};
	
	module.exports = ErrorMessageUtil;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Alert = __webpack_require__(1730);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ErrorMessageUtil = __webpack_require__(1728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorsAlert = function ErrorsAlert(props) {
	  var errors = props.errors,
	      hideTopLevelErrors = props.hideTopLevelErrors,
	      pathMapping = props.pathMapping;
	
	  var showErrors = errors;
	
	  if (hideTopLevelErrors) {
	    showErrors = showErrors.filter(function (error) {
	      return error.path.length === 0;
	    });
	  }
	
	  if (showErrors.length === 0) {
	    return _react2.default.createElement("noscript", null);
	  }
	
	  // De-duplicate error messages that have exactly the same translated output
	  var errorMessages = showErrors.reduce(function (messages, error) {
	    var message = (0, _ErrorMessageUtil.getUnanchoredErrorMessage)(error, pathMapping);
	    if (messages.indexOf(message) !== -1) {
	      return messages;
	    }
	
	    messages.push(message);
	
	    return messages;
	  }, []);
	
	  var errorItems = errorMessages.map(function (message, index) {
	    return _react2.default.createElement(
	      "li",
	      { key: index, className: "short" },
	      message
	    );
	  });
	
	  return _react2.default.createElement(
	    _Alert2.default,
	    null,
	    _react2.default.createElement(
	      "strong",
	      null,
	      "There is an error with your configuration"
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "pod pod-narrower-left pod-shorter-top flush-bottom" },
	      _react2.default.createElement(
	        "ul",
	        { className: "short flush-bottom" },
	        errorItems
	      )
	    )
	  );
	};
	
	ErrorsAlert.defaultProps = {
	  errors: [],
	  hideTopLevelErrors: false,
	  pathMapping: []
	};
	
	ErrorsAlert.propTypes = {
	  errors: _react2.default.PropTypes.array,
	  hideTopLevelErrors: _react2.default.PropTypes.bool,
	  pathMapping: _react2.default.PropTypes.array
	};
	
	module.exports = ErrorsAlert;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alert = function Alert(_ref) {
	  var _classNames;
	
	  var children = _ref.children,
	      flushBottom = _ref.flushBottom,
	      showIcon = _ref.showIcon,
	      type = _ref.type;
	
	  var classes = (0, _classnames2.default)("alert", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "alert-" + type, type != null), (0, _defineProperty3.default)(_classNames, "flush-bottom", flushBottom === true), _classNames));
	  var icon = null;
	
	  if (showIcon) {
	    var ids = {
	      danger: "yield",
	      success: "checkmark"
	    };
	
	    icon = _react2.default.createElement(
	      "div",
	      { className: "alert-icon" },
	      _react2.default.createElement(_Icon2.default, { id: ids[type], size: "mini" })
	    );
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes },
	    icon,
	    _react2.default.createElement(
	      "div",
	      { className: "alert-content" },
	      children
	    )
	  );
	};
	
	Alert.defaultProps = {
	  flushBottom: false,
	  showIcon: true,
	  type: "danger"
	};
	
	Alert.propTypes = {
	  children: _react2.default.PropTypes.node.isRequired,
	  flushBottom: _react2.default.PropTypes.bool,
	  showIcon: _react2.default.PropTypes.bool,
	  type: _react2.default.PropTypes.oneOf(["danger", "success"])
	};
	
	module.exports = Alert;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleClick"];
	
	var TabButton = function (_React$Component) {
	  (0, _inherits3.default)(TabButton, _React$Component);
	
	  function TabButton() {
	    (0, _classCallCheck3.default)(this, TabButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TabButton.__proto__ || (0, _getPrototypeOf2.default)(TabButton)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(TabButton, [{
	    key: "getChildren",
	    value: function getChildren() {
	      var _props = this.props,
	          activeTab = _props.activeTab,
	          children = _props.children,
	          onClick = _props.onClick;
	
	
	      return _react2.default.Children.map(children, function (tabChild) {
	        if (tabChild.type === TabButton) {
	          return _react2.default.cloneElement(tabChild, { activeTab: activeTab, onClick: onClick });
	        }
	
	        return tabChild;
	      });
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.stopPropagation();
	
	      if (this.props.onClick) {
	        this.props.onClick(this.props.id);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          active = _props2.active,
	          activeTab = _props2.activeTab,
	          className = _props2.className,
	          label = _props2.label,
	          labelClassName = _props2.labelClassName,
	          id = _props2.id;
	
	      var classes = (0, _dedupe2.default)("menu-tabbed-item", {
	        active: active || activeTab === id
	      }, className);
	      var labelClasses = (0, _dedupe2.default)("menu-tabbed-item-label", labelClassName);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        _react2.default.createElement(
	          "span",
	          { className: labelClasses, onClick: this.handleClick },
	          label
	        ),
	        this.getChildren()
	      );
	    }
	  }]);
	  return TabButton;
	}(_react2.default.Component);
	
	var classProps = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]);
	
	TabButton.propTypes = {
	  active: _react2.default.PropTypes.bool,
	  children: _react2.default.PropTypes.node,
	  className: classProps,
	  id: _react2.default.PropTypes.string.isRequired,
	  label: _react2.default.PropTypes.node,
	  labelClassName: classProps
	};
	
	module.exports = TabButton;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabButtonList = function (_React$Component) {
	  (0, _inherits3.default)(TabButtonList, _React$Component);
	
	  function TabButtonList() {
	    (0, _classCallCheck3.default)(this, TabButtonList);
	    return (0, _possibleConstructorReturn3.default)(this, (TabButtonList.__proto__ || (0, _getPrototypeOf2.default)(TabButtonList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TabButtonList, [{
	    key: "getChildren",
	    value: function getChildren() {
	      var _props = this.props,
	          activeTab = _props.activeTab,
	          children = _props.children,
	          onChange = _props.onChange;
	
	
	      return _react2.default.Children.map(children, function (tab, index) {
	        if (tab === null) {
	          return tab;
	        }
	        var tabProps = { activeTab: activeTab, onClick: onChange };
	
	        if (tab.props.id === activeTab || !activeTab && index === 0) {
	          tabProps.active = true;
	        }
	
	        return _react2.default.cloneElement(tab, tabProps);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          vertical = _props2.vertical;
	
	      var classes = (0, _dedupe2.default)("menu-tabbed", {
	        "menu-tabbed-vertical": vertical
	      }, className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getChildren()
	      );
	    }
	  }]);
	  return TabButtonList;
	}(_react2.default.Component);
	
	TabButtonList.propTypes = {
	  activeTab: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  onChange: _react2.default.PropTypes.func,
	  vertical: _react2.default.PropTypes.bool
	};
	
	module.exports = TabButtonList;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabButtonList = __webpack_require__(1732);
	
	var _TabButtonList2 = _interopRequireDefault(_TabButtonList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, (Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: "getChildren",
	    value: function getChildren() {
	      var props = this.props;
	
	
	      return _react2.default.Children.map(props.children, function (tabElement) {
	        var newTabProps = { activeTab: props.activeTab };
	
	        if (tabElement.type === _TabButtonList2.default) {
	          newTabProps.onChange = props.handleTabChange;
	          newTabProps.vertical = props.vertical;
	        }
	
	        return _react2.default.cloneElement(tabElement, newTabProps);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classes = (0, _dedupe2.default)("menu-tabbed-container", this.props.className, {
	        "menu-tabbed-container-vertical": this.props.vertical
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getChildren()
	      );
	    }
	  }]);
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = {
	  // Optional variable to set active tab from owner component
	  activeTab: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.node.isRequired,
	  className: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  handleTabChange: _react2.default.PropTypes.func.isRequired,
	  vertical: _react2.default.PropTypes.bool
	};
	
	module.exports = Tabs;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dedupe = __webpack_require__(1041);
	
	var _dedupe2 = _interopRequireDefault(_dedupe);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabView = function (_React$Component) {
	  (0, _inherits3.default)(TabView, _React$Component);
	
	  function TabView() {
	    (0, _classCallCheck3.default)(this, TabView);
	    return (0, _possibleConstructorReturn3.default)(this, (TabView.__proto__ || (0, _getPrototypeOf2.default)(TabView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TabView, [{
	    key: "render",
	    value: function render() {
	      var classes = (0, _dedupe2.default)("menu-tabbed-view", this.props.className);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.props.children
	      );
	    }
	  }]);
	  return TabView;
	}(_react2.default.Component);
	
	TabView.propTypes = {
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOf([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string]),
	  id: _react2.default.PropTypes.string.isRequired
	};
	
	module.exports = TabView;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabViewList = function (_React$Component) {
	  (0, _inherits3.default)(TabViewList, _React$Component);
	
	  function TabViewList() {
	    (0, _classCallCheck3.default)(this, TabViewList);
	    return (0, _possibleConstructorReturn3.default)(this, (TabViewList.__proto__ || (0, _getPrototypeOf2.default)(TabViewList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TabViewList, [{
	    key: "getChildren",
	    value: function getChildren() {
	      var _props = this.props,
	          activeTab = _props.activeTab,
	          children = _props.children;
	
	
	      return _react2.default.Children.map(children, function (tab, index) {
	        if (tab.props.id === activeTab || !activeTab && index === 0) {
	          return tab;
	        }
	
	        return null;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var classes = (0, _classnames2.default)("menu-tabbed-view-container", this.props.classNames);
	
	      return _react2.default.createElement(
	        "div",
	        { className: classes },
	        this.getChildren()
	      );
	    }
	  }]);
	  return TabViewList;
	}(_react2.default.Component);
	
	TabViewList.propTypes = {
	  activeTab: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.node,
	  className: _react2.default.PropTypes.oneOf([_react2.default.PropTypes.array, _react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	
	module.exports = TabViewList;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceConfigDisplayUtil = {
	  getColumnClassNameFn: function getColumnClassNameFn(classes) {
	    return function (prop, sortBy) {
	      return (0, _classnames2.default)(classes, {
	        active: prop === sortBy.prop
	      });
	    };
	  },
	  getColumnHeadingFn: function getColumnHeadingFn(defaultHeading) {
	    return function (prop, order, sortBy) {
	      var _classNames;
	
	      var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null && sortBy.prop === prop), (0, _defineProperty3.default)(_classNames, "caret--visible", sortBy.prop === prop), _classNames));
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        defaultHeading || prop,
	        _react2.default.createElement("span", { className: caretClassNames })
	      );
	    };
	  },
	  getContainerNameWithIcon: function getContainerNameWithIcon(container) {
	    return _react2.default.createElement(
	      "span",
	      null,
	      _react2.default.createElement(_Icon2.default, { id: "container", size: "mini", color: "purple" }),
	      _react2.default.createElement(
	        "span",
	        null,
	        "\xA0",
	        container.name
	      )
	    );
	  },
	  getDisplayValue: function getDisplayValue(value) {
	    var isDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!isDisabled && (value == null || value === "")) {
	      return _react2.default.createElement(
	        "em",
	        null,
	        "Not Configured"
	      );
	    }
	    if (isDisabled && (value == null || value === "")) {
	      return _react2.default.createElement(
	        "em",
	        null,
	        "Not Supported"
	      );
	    }
	
	    // Display nested objects nicely if the render didn't already cover it.
	    if ((0, _Util.isObject)(value) && !_react2.default.isValidElement(value)) {
	      return _react2.default.createElement(
	        "pre",
	        { className: "flush transparent wrap" },
	        (0, _stringify2.default)(value)
	      );
	    }
	
	    return value;
	  },
	  getSharedIconWithLabel: function getSharedIconWithLabel() {
	    return _react2.default.createElement(
	      "span",
	      null,
	      _react2.default.createElement(_Icon2.default, { id: "container", size: "mini", color: "purple" }),
	      _react2.default.createElement(
	        "em",
	        null,
	        "\xA0Shared"
	      )
	    );
	  }
	};
	
	module.exports = ServiceConfigDisplayUtil;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _DeleteRowButton = __webpack_require__(1709);
	
	var _DeleteRowButton2 = _interopRequireDefault(_DeleteRowButton);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArtifactsSection = function (_Component) {
	  (0, _inherits3.default)(ArtifactsSection, _Component);
	
	  function ArtifactsSection() {
	    (0, _classCallCheck3.default)(this, ArtifactsSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ArtifactsSection.__proto__ || (0, _getPrototypeOf2.default)(ArtifactsSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ArtifactsSection, [{
	    key: "getArtifactsLabel",
	    value: function getArtifactsLabel() {
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "If your service requires additional files and/or archives of files, enter their URIs to download and, if necessary, extract these resources. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/application-basics.html",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FieldLabel2.default,
	        null,
	        "Artifact URI ",
	        _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: tooltipContent,
	            interactive: true,
	            maxWidth: 300,
	            wrapText: true
	          },
	          _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	        )
	      );
	    }
	  }, {
	    key: "getArtifactsInputs",
	    value: function getArtifactsInputs() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          errors = _props.errors,
	          path = _props.path;
	
	
	      if (data.length === 0) {
	        return _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-10" },
	            this.getArtifactsLabel()
	          )
	        );
	      }
	
	      return data.map(function (item, index) {
	        var error = (0, _Util.findNestedPropertyInObject)(errors, index + ".uri");
	        var label = null;
	        if (index === 0) {
	          label = _this2.getArtifactsLabel();
	        }
	
	        return _react2.default.createElement(
	          _FormRow2.default,
	          { key: path + "." + index },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12", showError: Boolean(error) },
	            label,
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, {
	                name: path + "." + index + ".uri",
	                placeholder: "http://example.com",
	                value: item.uri
	              })
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              error
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { hasNarrowMargins: true, applyLabelOffset: index === 0 },
	            _react2.default.createElement(_DeleteRowButton2.default, {
	              onClick: _this2.props.onRemoveItem.bind(_this2, {
	                path: path,
	                value: index
	              })
	            })
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var path = this.props.path;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "form-section" },
	        this.getArtifactsInputs(),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: path
	                })
	              },
	              "Add Artifact"
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ArtifactsSection;
	}(_react.Component);
	
	ArtifactsSection.propTypes = {
	  data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    uri: _react2.default.PropTypes.string
	  })),
	  path: _react2.default.PropTypes.string
	};
	
	module.exports = ArtifactsSection;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _isNan = __webpack_require__(987);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreateServiceModalFormUtil = {
	  /**
	   * Remove empty properties from the given input object, or pass through the
	   * value if it is a non-object.
	   *
	   * @param {*} object - The object to process (any other value passes through)
	   * @returns {*} A shallow copy of the object, with the non-empty values
	   */
	  stripEmptyProperties: function stripEmptyProperties(object) {
	    if ((typeof object === "undefined" ? "undefined" : (0, _typeof3.default)(object)) !== "object" || object === null) {
	      return object;
	    }
	
	    // Pick base object according to type
	    var baseObject = {};
	    if (Array.isArray(object)) {
	      baseObject = [];
	    }
	
	    return (0, _keys2.default)(object).reduce(function (memo, key) {
	      if (!_ValidatorUtil2.default.isEmpty(object[key]) && !(0, _isNan2.default)(object[key]) || Array.isArray(object[key])) {
	        // Apply the strip function recursively and keep only non-empty values
	        var value = CreateServiceModalFormUtil.stripEmptyProperties(object[key]);
	        if (!_ValidatorUtil2.default.isEmpty(value) && !(0, _isNan2.default)(value) || Array.isArray(value)) {
	          memo[key] = value;
	        }
	      }
	
	      return memo;
	    }, baseObject);
	  }
	};
	
	module.exports = CreateServiceModalFormUtil;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _containerRuntimes;
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _StringUtil = __webpack_require__(952);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AdvancedSection = __webpack_require__(1724);
	
	var _AdvancedSection2 = _interopRequireDefault(_AdvancedSection);
	
	var _AdvancedSectionContent = __webpack_require__(1725);
	
	var _AdvancedSectionContent2 = _interopRequireDefault(_AdvancedSectionContent);
	
	var _AdvancedSectionLabel = __webpack_require__(1726);
	
	var _AdvancedSectionLabel2 = _interopRequireDefault(_AdvancedSectionLabel);
	
	var _DeleteRowButton = __webpack_require__(1709);
	
	var _DeleteRowButton2 = _interopRequireDefault(_DeleteRowButton);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _ContainerServiceFormSection = __webpack_require__(1684);
	
	var _ContainerServiceFormSection2 = _interopRequireDefault(_ContainerServiceFormSection);
	
	var _ContainerServiceFormAdvancedSection = __webpack_require__(1742);
	
	var _ContainerServiceFormAdvancedSection2 = _interopRequireDefault(_ContainerServiceFormAdvancedSection);
	
	var _General = __webpack_require__(1743);
	
	var _General2 = _interopRequireDefault(_General);
	
	var _OperatorTypes = __webpack_require__(1715);
	
	var _OperatorTypes2 = _interopRequireDefault(_OperatorTypes);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	var _PlacementConstraintsUtil2 = _interopRequireDefault(_PlacementConstraintsUtil);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ContainerConstants$t = _ContainerConstants2.default.type,
	    MESOS = _ContainerConstants$t.MESOS,
	    DOCKER = _ContainerConstants$t.DOCKER,
	    labelMap = _ContainerConstants2.default.labelMap;
	
	
	var METHODS_TO_BIND = ["handleConvertToPod", "handleCloseConvertToPodModal", "handleOpenConvertToPodModal"];
	
	var containerRuntimes = (_containerRuntimes = {}, (0, _defineProperty3.default)(_containerRuntimes, DOCKER, {
	  label: _react2.default.createElement(
	    "span",
	    null,
	    labelMap[DOCKER]
	  ),
	  helpText: "Docker’s container runtime. No support for multiple containers (Pods) or GPU resources."
	}), (0, _defineProperty3.default)(_containerRuntimes, MESOS, {
	  label: _react2.default.createElement(
	    "span",
	    null,
	    labelMap[MESOS]
	  ),
	  helpText: "Universal Container Runtime using native Mesos engine. Supports Docker file format, multiple containers (Pods) and GPU resources."
	}), _containerRuntimes);
	
	function placementConstraintLabel(name, tooltipText) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _options$isRequired = options.isRequired,
	      isRequired = _options$isRequired === undefined ? false : _options$isRequired,
	      _options$linkText = options.linkText,
	      linkText = _options$linkText === undefined ? "More information" : _options$linkText;
	
	
	  var tooltipContent = _react2.default.createElement(
	    "span",
	    null,
	    tooltipText + " ",
	    _react2.default.createElement(
	      "a",
	      {
	        href: "https://mesosphere.github.io/marathon/docs/constraints.html",
	        target: "_blank"
	      },
	      linkText
	    ),
	    "."
	  );
	
	  return _react2.default.createElement(
	    _FieldLabel2.default,
	    null,
	    _react2.default.createElement(
	      _FormGroupHeading2.default,
	      { required: isRequired },
	      _react2.default.createElement(
	        _FormGroupHeadingContent2.default,
	        { primary: true },
	        name
	      ),
	      _react2.default.createElement(
	        _FormGroupHeadingContent2.default,
	        null,
	        _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: tooltipContent,
	            interactive: true,
	            maxWidth: 300,
	            wrapText: true
	          },
	          _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	        )
	      )
	    )
	  );
	}
	
	var GeneralServiceFormSection = function (_Component) {
	  (0, _inherits3.default)(GeneralServiceFormSection, _Component);
	
	  function GeneralServiceFormSection() {
	    (0, _classCallCheck3.default)(this, GeneralServiceFormSection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (GeneralServiceFormSection.__proto__ || (0, _getPrototypeOf2.default)(GeneralServiceFormSection)).apply(this, arguments));
	
	    _this.state = { convertToPodModalOpen: false };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(GeneralServiceFormSection, [{
	    key: "handleConvertToPod",
	    value: function handleConvertToPod() {
	      this.props.onConvertToPod();
	      this.handleCloseConvertToPodModal();
	    }
	  }, {
	    key: "handleCloseConvertToPodModal",
	    value: function handleCloseConvertToPodModal() {
	      this.setState({ convertToPodModalOpen: false });
	    }
	  }, {
	    key: "handleOpenConvertToPodModal",
	    value: function handleOpenConvertToPodModal() {
	      this.setState({ convertToPodModalOpen: true });
	    }
	  }, {
	    key: "getAdvancedContainerSection",
	    value: function getAdvancedContainerSection() {
	      var _props = this.props,
	          _props$data = _props.data,
	          data = _props$data === undefined ? {} : _props$data,
	          errors = _props.errors,
	          service = _props.service;
	
	
	      if (service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      return _react2.default.createElement(_ContainerServiceFormAdvancedSection2.default, {
	        data: data,
	        errors: errors,
	        onAddItem: this.props.onAddItem,
	        onRemoveItem: this.props.onRemoveItem,
	        path: "container",
	        service: service
	      });
	    }
	  }, {
	    key: "getContainerSection",
	    value: function getContainerSection() {
	      var _props2 = this.props,
	          _props2$data = _props2.data,
	          data = _props2$data === undefined ? {} : _props2$data,
	          errors = _props2.errors,
	          service = _props2.service;
	
	
	      if (service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      return _react2.default.createElement(_ContainerServiceFormSection2.default, {
	        data: data,
	        errors: errors,
	        onAddItem: this.props.onAddItem,
	        onRemoveItem: this.props.onRemoveItem,
	        path: "container",
	        service: service
	      });
	    }
	  }, {
	    key: "getConvertToPodAction",
	    value: function getConvertToPodAction() {
	      var _props3 = this.props,
	          service = _props3.service,
	          isEdit = _props3.isEdit;
	
	
	      if (isEdit || service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pod pod-short flush-horizontal flush-bottom" },
	        _react2.default.createElement(
	          "em",
	          null,
	          "Need to run a service with multiple containers? ",
	          _react2.default.createElement(
	            "a",
	            { className: "clickable", onClick: this.handleOpenConvertToPodModal },
	            "Add another container"
	          ),
	          "."
	        )
	      );
	    }
	  }, {
	    key: "getMultiContainerSection",
	    value: function getMultiContainerSection() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          _props4$data = _props4.data,
	          data = _props4$data === undefined ? {} : _props4$data,
	          service = _props4.service;
	
	      if (!(service instanceof _PodSpec2.default)) {
	        return null;
	      }
	
	      var _data$containers = data.containers,
	          containers = _data$containers === undefined ? [] : _data$containers;
	
	      var containerElements = containers.map(function (item, index) {
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: index,
	            onRemove: _this2.props.onRemoveItem.bind(_this2, {
	              value: index,
	              path: "containers"
	            }),
	            onClick: _this2.props.onClickItem.bind(_this2, "container" + index)
	          },
	          item.name || "container-" + (index + 1)
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          "Containers"
	        ),
	        containerElements,
	        _react2.default.createElement(
	          _AddButton2.default,
	          {
	            onClick: this.props.onAddItem.bind(this, {
	              path: "containers"
	            })
	          },
	          "Add Container"
	        )
	      );
	    }
	  }, {
	    key: "getOperatorTypes",
	    value: function getOperatorTypes() {
	      return (0, _keys2.default)(_OperatorTypes2.default).map(function (type, index) {
	        return _react2.default.createElement(
	          "option",
	          { key: index, value: type },
	          type
	        );
	      });
	    }
	  }, {
	    key: "getPlacementconstraints",
	    value: function getPlacementconstraints() {
	      var _props$data2 = this.props.data,
	          data = _props$data2 === undefined ? {} : _props$data2;
	
	      var constraintsErrors = (0, _Util.findNestedPropertyInObject)(this.props.errors, "constraints");
	      var errorNode = null;
	      var placementTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Constraints have three parts: a field name, an operator, and an optional parameter. The field can be the hostname of the agent node or any attribute of the agent node. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/constraints.html",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	      var hasErrors = constraintsErrors != null && !Array.isArray(constraintsErrors);
	
	      if (hasErrors) {
	        errorNode = _react2.default.createElement(
	          _FormGroup2.default,
	          { showError: hasErrors },
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            constraintsErrors
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Placement Constraints"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: placementTooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Constraints control where apps run to allow optimization for either fault tolerance or locality."
	        ),
	        this.getPlacementConstraintsFields(data.constraints),
	        errorNode,
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: "constraints"
	                })
	              },
	              "Add Placement Constraint"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getPlacementConstraintsFields",
	    value: function getPlacementConstraintsFields() {
	      var _this3 = this;
	
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var constraintsErrors = (0, _Util.findNestedPropertyInObject)(this.props.errors, "constraints");
	      var hasOneRequiredValue = data.some(function (constraint) {
	        return _PlacementConstraintsUtil2.default.requiresValue(constraint.operator);
	      });
	      var hideValueColumn = data.every(function (constraint) {
	        return _PlacementConstraintsUtil2.default.requiresEmptyValue(constraint.operator);
	      });
	
	      return data.map(function (constraint, index) {
	        var fieldLabel = null;
	        var operatorLabel = null;
	        var valueLabel = null;
	        var valueIsRequired = _PlacementConstraintsUtil2.default.requiresValue(constraint.operator);
	        var valueIsRequiredEmpty = _PlacementConstraintsUtil2.default.requiresEmptyValue(constraint.operator);
	        var fieldNameError = (0, _Util.findNestedPropertyInObject)(constraintsErrors, index + ".fieldName");
	        var operatorError = (0, _Util.findNestedPropertyInObject)(constraintsErrors, index + ".operator");
	        var valueError = (0, _Util.findNestedPropertyInObject)(constraintsErrors, index + ".value");
	        var commonFieldsClassNames = {
	          "column-4": !hideValueColumn,
	          "column-6": hideValueColumn
	        };
	
	        if (index === 0) {
	          fieldLabel = placementConstraintLabel("Field", "If you enter `hostname`, the constraint will map to the agent node hostname. If you do not enter an agent node hostname, the field will be treated as a Mesos agent node attribute, which allows you to tag an agent node.", { isRequired: true });
	          operatorLabel = placementConstraintLabel("Operator", "Operators specify where your app will run.", { isRequired: true });
	        }
	        if (index === 0 && !hideValueColumn) {
	          valueLabel = placementConstraintLabel("Value", "Values allow you to further specify your constraint.", { linkText: "Learn more", isRequired: hasOneRequiredValue });
	        }
	
	        return _react2.default.createElement(
	          _FormRow2.default,
	          { key: index },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: commonFieldsClassNames,
	              required: true,
	              showError: Boolean(fieldNameError)
	            },
	            fieldLabel,
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "constraints." + index + ".fieldName",
	                type: "text",
	                placeholder: "hostname",
	                value: constraint.fieldName
	              })
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              fieldNameError
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: commonFieldsClassNames,
	              required: true,
	              showError: Boolean(operatorError)
	            },
	            operatorLabel,
	            _react2.default.createElement(
	              _FieldSelect2.default,
	              {
	                name: "constraints." + index + ".operator",
	                type: "text",
	                value: String(constraint.operator)
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "" },
	                "Select"
	              ),
	              _this3.getOperatorTypes()
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              operatorError
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            {
	              className: {
	                "column-4": !hideValueColumn,
	                hidden: hideValueColumn
	              },
	              required: valueIsRequired,
	              showError: Boolean(valueError)
	            },
	            valueLabel,
	            _react2.default.createElement(_FieldInput2.default, {
	              className: { hidden: valueIsRequiredEmpty },
	              name: "constraints." + index + ".value",
	              type: "text",
	              value: constraint.value
	            }),
	            _react2.default.createElement(
	              _FieldHelp2.default,
	              {
	                className: { hidden: valueIsRequired || valueIsRequiredEmpty }
	              },
	              "This field is optional"
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              { className: { hidden: hideValueColumn } },
	              valueError
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { applyLabelOffset: index === 0, hasNarrowMargins: true },
	            _react2.default.createElement(_DeleteRowButton2.default, {
	              onClick: _this3.props.onRemoveItem.bind(_this3, {
	                value: index,
	                path: "constraints"
	              })
	            })
	          )
	        );
	      });
	    }
	  }, {
	    key: "getRuntimeSection",
	    value: function getRuntimeSection() {
	      var _props5 = this.props,
	          errors = _props5.errors,
	          service = _props5.service,
	          data = _props5.data;
	
	      if (service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      var typeErrors = (0, _Util.findNestedPropertyInObject)(errors, "container.type");
	      var runtimeTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "You can run Docker containers with both container runtimes. The Universal Container Runtime (UCR) is better supported in DC/OS. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: _MetadataStore2.default.buildDocsURI("/deploying-services/containerizers/"),
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Container Runtime"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: runtimeTooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The container runtime is responsible for running your service. We support the Docker Engine and Universal Container Runtime (UCR)."
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { showError: Boolean(typeErrors) },
	          this.getRuntimeSelections(data),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            typeErrors
	          )
	        )
	      );
	    }
	  }, {
	    key: "getRuntimeSelections",
	    value: function getRuntimeSelections() {
	      var _props$data3 = this.props.data,
	          data = _props$data3 === undefined ? {} : _props$data3;
	      var _data$container = data.container,
	          container = _data$container === undefined ? {} : _data$container,
	          gpus = data.gpus;
	
	      var isDisabled = {};
	      var disabledTooltipContent = void 0;
	      var type = MESOS;
	
	      if (container != null && container.type != null) {
	        type = container.type;
	      }
	
	      if (!(0, _ValidatorUtil.isEmpty)(gpus) && parseFloat(gpus) !== 0) {
	        isDisabled[DOCKER] = true;
	        disabledTooltipContent = "Docker Engine does not support GPU resources, please select Universal Container Runtime (UCR) if you want to use GPU resources.";
	      }
	
	      return (0, _keys2.default)(containerRuntimes).map(function (runtimeName, index) {
	        var _containerRuntimes$ru = containerRuntimes[runtimeName],
	            helpText = _containerRuntimes$ru.helpText,
	            label = _containerRuntimes$ru.label;
	
	        var field = _react2.default.createElement(
	          _FieldLabel2.default,
	          { className: "text-align-left", key: index },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: Boolean(type === runtimeName),
	            disabled: isDisabled[runtimeName],
	            name: "container.type",
	            type: "radio",
	            value: runtimeName
	          }),
	          label,
	          _react2.default.createElement(
	            _FieldHelp2.default,
	            null,
	            helpText
	          )
	        );
	
	        // Wrap field in tooltip if disabled and content populated
	        if (isDisabled[runtimeName] && disabledTooltipContent) {
	          field = _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              content: disabledTooltipContent,
	              interactive: true,
	              key: index,
	              maxWidth: 300,
	              wrapText: true
	            },
	            field
	          );
	        }
	
	        return field;
	      });
	    }
	  }, {
	    key: "shouldShowAdvancedOptions",
	    value: function shouldShowAdvancedOptions() {
	      var _props6 = this.props,
	          data = _props6.data,
	          container = _props6.data.container;
	
	      var _ref = container || {},
	          docker = _ref.docker;
	
	      return !(0, _ValidatorUtil.isEmpty)(data.disk) || !(0, _ValidatorUtil.isEmpty)(data.gpus) || !(0, _ValidatorUtil.isEmpty)(data.constraints) || !(0, _ValidatorUtil.isEmpty)((0, _Util.findNestedPropertyInObject)(docker, "forcePullImage")) || !(0, _ValidatorUtil.isEmpty)((0, _Util.findNestedPropertyInObject)(docker, "image")) || !(0, _ValidatorUtil.isEmpty)((0, _Util.findNestedPropertyInObject)(docker, "privileged")) || (0, _Util.findNestedPropertyInObject)(container, "type") !== DOCKER;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props7 = this.props,
	          data = _props7.data,
	          errors = _props7.errors;
	
	      var initialIsExpanded = this.shouldShowAdvancedOptions();
	      var title = (0, _StringUtil.pluralize)("Service", (0, _Util.findNestedPropertyInObject)(data, "containers.length") || 1);
	
	      var idTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Include the path to your service, if applicable. E.g. /dev/tools/my-service. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/application-groups.html",
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          title
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Configure your service below. Start by giving your service an ID."
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-9", showError: Boolean(errors.id) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                { required: true },
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Service ID"
	                ),
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  _react2.default.createElement(
	                    _reactjsComponents.Tooltip,
	                    {
	                      content: idTooltipContent,
	                      interactive: true,
	                      maxWidth: 300,
	                      wrapText: true
	                    },
	                    _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, { name: "id", type: "text", value: data.id })
	            ),
	            _react2.default.createElement(
	              _FieldHelp2.default,
	              null,
	              "Give your service a unique name within the cluster, e.g. my-service."
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              errors.id
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-3", showError: Boolean(errors.instances) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Instances"
	                )
	              )
	            ),
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "instances",
	              min: 0,
	              type: "number",
	              value: data.instances
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              errors.instances
	            )
	          )
	        ),
	        this.getContainerSection(),
	        _react2.default.createElement(
	          _AdvancedSection2.default,
	          { initialIsExpanded: initialIsExpanded },
	          _react2.default.createElement(
	            _AdvancedSectionLabel2.default,
	            null,
	            "More Settings"
	          ),
	          _react2.default.createElement(
	            _AdvancedSectionContent2.default,
	            null,
	            this.getRuntimeSection(),
	            this.getPlacementconstraints(),
	            this.getAdvancedContainerSection()
	          )
	        ),
	        this.getMultiContainerSection(),
	        this.getConvertToPodAction(),
	        _react2.default.createElement(
	          _reactjsComponents.Confirm,
	          {
	            closeByBackdropClick: true,
	            header: _react2.default.createElement(
	              _ModalHeading2.default,
	              null,
	              "Switching to a pod service"
	            ),
	            open: this.state.convertToPodModalOpen,
	            onClose: this.handleCloseConvertToPodModal,
	            leftButtonText: "Close",
	            leftButtonCallback: this.handleCloseConvertToPodModal,
	            rightButtonText: "Continue",
	            rightButtonClassName: "button button-success",
	            rightButtonCallback: this.handleConvertToPod,
	            showHeader: true
	          },
	          _react2.default.createElement(
	            "p",
	            null,
	            "Adding another container will automatically put multiple containers into a Pod definition. Your containers will be co-located on the same node and scale together. ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: _MetadataStore2.default.buildDocsURI("/usage/pods/"),
	                target: "_blank"
	              },
	              "More information"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Are you sure you would like to continue and create a Pod? Any data you have already entered will be lost."
	          )
	        )
	      );
	    }
	  }]);
	  return GeneralServiceFormSection;
	}(_react.Component);
	
	GeneralServiceFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	GeneralServiceFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func,
	  onClickItem: _react2.default.PropTypes.func
	};
	
	GeneralServiceFormSection.configReducers = _General2.default;
	
	module.exports = GeneralServiceFormSection;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldSelect = function FieldSelect(props) {
	  return _react2.default.createElement(
	    "span",
	    { className: "form-control form-control-select" },
	    _react2.default.createElement(
	      "select",
	      props,
	      props.children
	    )
	  );
	};
	
	FieldSelect.defaultProps = {
	  onChange: function onChange() {},
	
	  value: ""
	};
	
	FieldSelect.propTypes = {
	  name: _react2.default.PropTypes.string,
	  onChange: _react2.default.PropTypes.func,
	  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string])
	};
	
	module.exports = FieldSelect;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormGroupContainer = function FormGroupContainer(props) {
	  var removeButton = null;
	  if (props.onRemove != null) {
	    removeButton = _react2.default.createElement(
	      "div",
	      { className: "form-group-container-action-button-group" },
	      _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        {
	          content: _StringUtil2.default.capitalize(_UserActions2.default.DELETE),
	          maxWidth: 300,
	          wrapText: true
	        },
	        _react2.default.createElement(
	          "a",
	          { className: "button button-primary-link", onClick: props.onRemove },
	          _react2.default.createElement(_Icon2.default, { id: "close", color: "grey", size: "tiny", family: "tiny" })
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "panel panel-interactive pod-short clickable",
	      onClick: props.onClick
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "pod-narrow pod-short" },
	      removeButton,
	      props.children
	    )
	  );
	};
	
	FormGroupContainer.defaultProps = {
	  onRemove: null
	};
	
	FormGroupContainer.propTypes = {
	  children: _react2.default.PropTypes.node,
	  onRemove: _react2.default.PropTypes.func,
	  onClick: _react2.default.PropTypes.func
	};
	
	module.exports = FormGroupContainer;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Container = __webpack_require__(1689);
	
	var _Containers = __webpack_require__(1696);
	
	var _ArtifactsSection = __webpack_require__(1737);
	
	var _ArtifactsSection2 = _interopRequireDefault(_ArtifactsSection);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ContainerConstants$t = _ContainerConstants2.default.type,
	    DOCKER = _ContainerConstants$t.DOCKER,
	    MESOS = _ContainerConstants$t.MESOS;
	
	
	var containerSettings = {
	  privileged: {
	    runtimes: [DOCKER],
	    label: "Grant Runtime Privileges",
	    helpText: "By default, containers are “unprivileged” and cannot, for example, run a Docker daemon inside a Docker container.",
	    unavailableText: "Grant runtime privileges option isn't supported by selected runtime."
	  },
	  forcePullImage: {
	    runtimes: [DOCKER, MESOS],
	    label: "Force Pull Image On Launch",
	    helpText: "Force Docker to pull the image before launching each instance.",
	    unavailableText: "Force pull image on launch option isn't supported by selected runtime."
	  }
	};
	
	var appPaths = {
	  artifacts: "fetch",
	  cmd: "cmd",
	  containerName: "",
	  cpus: "cpus",
	  disk: "disk",
	  forcePullImage: "{basePath}.docker.forcePullImage",
	  gpus: "gpus",
	  image: "{basePath}.docker.image",
	  mem: "mem",
	  privileged: "{basePath}.docker.privileged",
	  type: "{basePath}.type"
	};
	
	var podPaths = {
	  artifacts: "{basePath}.artifacts",
	  cmd: "{basePath}.exec.command.shell",
	  containerName: "{basePath}.name",
	  cpus: "{basePath}.resources.cpus",
	  disk: "{basePath}.resources.disk",
	  forcePullImage: "",
	  gpus: "",
	  image: "{basePath}.image.id",
	  mem: "{basePath}.resources.mem",
	  privileged: "",
	  type: "{basePath}.type"
	};
	
	var ContainerServiceFormAdvancedSection = function (_Component) {
	  (0, _inherits3.default)(ContainerServiceFormAdvancedSection, _Component);
	
	  function ContainerServiceFormAdvancedSection() {
	    (0, _classCallCheck3.default)(this, ContainerServiceFormAdvancedSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ContainerServiceFormAdvancedSection.__proto__ || (0, _getPrototypeOf2.default)(ContainerServiceFormAdvancedSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ContainerServiceFormAdvancedSection, [{
	    key: "getFieldPath",
	    value: function getFieldPath(basePath, fieldName) {
	      if (this.props.service instanceof _PodSpec2.default) {
	        return podPaths[fieldName].replace("{basePath}", basePath);
	      }
	
	      return appPaths[fieldName].replace("{basePath}", basePath);
	    }
	  }, {
	    key: "isGpusDisabled",
	    value: function isGpusDisabled() {
	      var _props = this.props,
	          data = _props.data,
	          path = _props.path;
	
	      var typePath = this.getFieldPath(path, "type");
	
	      return (0, _Util.findNestedPropertyInObject)(data, typePath) === DOCKER;
	    }
	  }, {
	    key: "getGPUSField",
	    value: function getGPUSField() {
	      var _props2 = this.props,
	          data = _props2.data,
	          errors = _props2.errors,
	          path = _props2.path,
	          service = _props2.service;
	
	      if (service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      var gpusPath = this.getFieldPath(path, "gpus");
	      var gpusErrors = (0, _Util.findNestedPropertyInObject)(errors, gpusPath);
	      var gpusDisabled = this.isGpusDisabled();
	
	      var inputNode = _react2.default.createElement(_FieldInput2.default, {
	        disabled: gpusDisabled,
	        min: "0",
	        name: gpusPath,
	        step: "any",
	        type: "number",
	        value: (0, _Util.findNestedPropertyInObject)(data, gpusPath)
	      });
	
	      if (gpusDisabled) {
	        inputNode = _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "Docker Engine does not support GPU resources, please select Universal Container Runtime (UCR) if you want to use GPU resources.",
	            interactive: true,
	            maxWidth: 300,
	            wrapText: true,
	            wrapperClassName: "tooltip-wrapper tooltip-block-wrapper"
	          },
	          inputNode
	        );
	      }
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        {
	          className: "column-4",
	          showError: Boolean(!gpusDisabled && gpusErrors)
	        },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          { className: "text-no-transform" },
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            { primary: true },
	            "GPUs"
	          )
	        ),
	        inputNode,
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          gpusErrors
	        )
	      );
	    }
	  }, {
	    key: "getContainerSettings",
	    value: function getContainerSettings() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          errors = _props3.errors,
	          path = _props3.path,
	          service = _props3.service;
	
	      if (service instanceof _PodSpec2.default) {
	        return null;
	      }
	
	      var typePath = this.getFieldPath(path, "type");
	      var containerType = (0, _Util.findNestedPropertyInObject)(data, typePath);
	      var typeErrors = (0, _Util.findNestedPropertyInObject)(errors, typePath);
	      var sectionCount = (0, _keys2.default)(containerSettings).length;
	      var selections = (0, _keys2.default)(containerSettings).map(function (settingName, index) {
	        var _containerSettings$se = containerSettings[settingName],
	            runtimes = _containerSettings$se.runtimes,
	            helpText = _containerSettings$se.helpText,
	            label = _containerSettings$se.label,
	            unavailableText = _containerSettings$se.unavailableText;
	
	        var settingsPath = _this2.getFieldPath(path, settingName);
	        var checked = (0, _Util.findNestedPropertyInObject)(data, settingsPath);
	        var isDisabled = !runtimes.includes(containerType);
	        var labelNodeClasses = (0, _classnames2.default)({
	          "disabled muted": isDisabled,
	          "flush-bottom": index === sectionCount - 1
	        });
	
	        var labelNode = _react2.default.createElement(
	          _FieldLabel2.default,
	          { key: "label." + index, className: labelNodeClasses },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: !isDisabled && Boolean(checked),
	            name: settingsPath,
	            type: "checkbox",
	            disabled: isDisabled,
	            value: settingName
	          }),
	          label,
	          _react2.default.createElement(
	            _FieldHelp2.default,
	            null,
	            helpText
	          )
	        );
	
	        if (isDisabled) {
	          labelNode = _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              content: unavailableText,
	              elementTag: "label",
	              key: "tooltip." + index,
	              position: "top",
	              width: 300,
	              wrapperClassName: "tooltip-wrapper tooltip-block-wrapper",
	              wrapText: true
	            },
	            labelNode
	          );
	        }
	
	        return labelNode;
	      });
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { showError: Boolean(typeErrors) },
	        selections,
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          typeErrors
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props4 = this.props,
	          data = _props4.data,
	          errors = _props4.errors,
	          path = _props4.path;
	
	      var artifactsPath = this.getFieldPath(path, "artifacts");
	      var artifacts = (0, _Util.findNestedPropertyInObject)(data, artifactsPath) || [];
	      var artifactErrors = (0, _Util.findNestedPropertyInObject)(errors, artifactsPath) || [];
	      var diskPath = this.getFieldPath(path, "disk");
	      var diskErrors = (0, _Util.findNestedPropertyInObject)(errors, diskPath);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          "Advanced Settings"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Advanced settings related to the runtime you have selected above."
	        ),
	        this.getContainerSettings(),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          this.getGPUSField(),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-4", showError: Boolean(diskErrors) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { className: "text-no-transform" },
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Disk (MiB)"
	              )
	            ),
	            _react2.default.createElement(_FieldInput2.default, {
	              min: "0",
	              name: diskPath,
	              step: "any",
	              type: "number",
	              value: (0, _Util.findNestedPropertyInObject)(data, diskPath)
	            }),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              diskErrors
	            )
	          )
	        ),
	        _react2.default.createElement(_ArtifactsSection2.default, {
	          data: artifacts,
	          path: artifactsPath,
	          errors: artifactErrors,
	          onRemoveItem: this.props.onRemoveItem,
	          onAddItem: this.props.onAddItem
	        })
	      );
	    }
	  }]);
	  return ContainerServiceFormAdvancedSection;
	}(_react.Component);
	
	ContainerServiceFormAdvancedSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {},
	
	  path: "container"
	};
	
	ContainerServiceFormAdvancedSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func,
	  path: _react2.default.PropTypes.string
	};
	
	ContainerServiceFormAdvancedSection.configReducers = {
	  container: _Container.FormReducer,
	  containers: _Containers.FormReducer
	};
	
	module.exports = ContainerServiceFormAdvancedSection;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Constraints = __webpack_require__(1744);
	
	var _Artifacts = __webpack_require__(1745);
	
	module.exports = {
	  constraints: _Constraints.FormReducer,
	  fetch: _Artifacts.FormReducer,
	  id: (0, _ReducerUtil.simpleReducer)("id"),
	  instances: (0, _ReducerUtil.simpleReducer)("instances"),
	  // Container runtime is handled in ./serviceForm/Container
	  cpus: (0, _ReducerUtil.simpleReducer)("cpus"),
	  mem: (0, _ReducerUtil.simpleReducer)("mem"),
	  disk: (0, _ReducerUtil.simpleReducer)("disk"),
	  gpus: (0, _ReducerUtil.simpleReducer)("gpus"),
	  cmd: (0, _ReducerUtil.simpleReducer)("cmd")
	};

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONSTRAINT_FIELDS = ["fieldName", "operator", "value"];
	
	function processTransaction(state, _ref) {
	  var type = _ref.type,
	      path = _ref.path,
	      value = _ref.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 3),
	      fieldName = _path[0],
	      index = _path[1],
	      name = _path[2];
	
	  if (fieldName !== "constraints") {
	    return state;
	  }
	
	  var newState = state.slice();
	
	  if (type === _TransactionTypes.ADD_ITEM) {
	    newState.push({ fieldName: null, operator: null, value: null });
	  }
	  if (type === _TransactionTypes.REMOVE_ITEM) {
	    newState = newState.filter(function (item, index) {
	      return index !== value;
	    });
	  }
	  if (type === _TransactionTypes.SET && CONSTRAINT_FIELDS.includes(name) && !(0, _PlacementConstraintsUtil.requiresEmptyValue)(newState[index].operator)) {
	    newState[index][name] = value;
	  }
	
	  if (name === "operator" && (0, _PlacementConstraintsUtil.requiresEmptyValue)(value)) {
	    newState[index].value = null;
	  }
	
	  return newState;
	}
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref2 = arguments[1];
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    if (path == null || !Array.isArray(state)) {
	      return state;
	    }
	
	    return processTransaction(state, { type: type, path: path, value: value });
	  }
	};

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processTransaction(state, _ref) {
	  var type = _ref.type,
	      path = _ref.path,
	      value = _ref.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 3),
	      field = _path[0],
	      index = _path[1],
	      name = _path[2];
	
	  if (field !== "fetch") {
	    return state;
	  }
	
	  var newState = state.slice();
	
	  if (type === _TransactionTypes.ADD_ITEM) {
	    newState.push(value || { uri: null });
	  }
	
	  if (type === _TransactionTypes.REMOVE_ITEM) {
	    newState = newState.filter(function (item, index) {
	      return index !== value;
	    });
	  }
	
	  if (type === _TransactionTypes.SET && index != null && name != null) {
	    newState[index][name] = value;
	  }
	
	  return newState;
	}
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref2 = arguments[1];
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    state = processTransaction(state, { type: type, path: path, value: value });
	
	    return state;
	  }
	};

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _objektiv = __webpack_require__(1674);
	
	var _objektiv2 = _interopRequireDefault(_objektiv);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AdvancedSection = __webpack_require__(1724);
	
	var _AdvancedSection2 = _interopRequireDefault(_AdvancedSection);
	
	var _AdvancedSectionContent = __webpack_require__(1725);
	
	var _AdvancedSectionContent2 = _interopRequireDefault(_AdvancedSectionContent);
	
	var _AdvancedSectionLabel = __webpack_require__(1726);
	
	var _AdvancedSectionLabel2 = _interopRequireDefault(_AdvancedSectionLabel);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldTextarea = __webpack_require__(1686);
	
	var _FieldTextarea2 = _interopRequireDefault(_FieldTextarea);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	var _HealthChecks = __webpack_require__(1747);
	
	var _HealthCheckUtil = __webpack_require__(1748);
	
	var _HealthCheckUtil2 = _interopRequireDefault(_HealthCheckUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorsLens = _objektiv2.default.attr("healthChecks", []);
	
	var HealthChecksFormSection = function (_Component) {
	  (0, _inherits3.default)(HealthChecksFormSection, _Component);
	
	  function HealthChecksFormSection() {
	    (0, _classCallCheck3.default)(this, HealthChecksFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (HealthChecksFormSection.__proto__ || (0, _getPrototypeOf2.default)(HealthChecksFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(HealthChecksFormSection, [{
	    key: "getAdvancedSettings",
	    value: function getAdvancedSettings(healthCheck, key) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.COMMAND && healthCheck.protocol !== _HealthCheckProtocols.MESOS_HTTP && healthCheck.protocol !== _HealthCheckProtocols.MESOS_HTTPS) {
	        return null;
	      }
	
	      var errors = errorsLens.at(key, {}).get(this.props.errors);
	
	      var gracePeriodHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 300): Health check failures are ignored within this number of seconds or until the instance becomes healthy for the first time."
	      );
	
	      var intervalHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 60): Number of seconds to wait between health checks."
	      );
	
	      var timeoutHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 20): Number of seconds after which a health check is considered a failure regardless of the response."
	      );
	
	      var failuresHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 3): Number of consecutive health check failures after which the unhealthy instance should be killed. HTTP & TCP health checks: If this value is 0, instances will not be killed if they fail the health check."
	      );
	
	      return _react2.default.createElement(
	        _AdvancedSection2.default,
	        null,
	        _react2.default.createElement(
	          _AdvancedSectionLabel2.default,
	          null,
	          "Advanced Health Check Settings"
	        ),
	        _react2.default.createElement(
	          _AdvancedSectionContent2.default,
	          null,
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.gracePeriodSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Grace Period (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: gracePeriodHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldAutofocus2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  name: "healthChecks." + key + ".gracePeriodSeconds",
	                  type: "number",
	                  min: "0",
	                  placeholder: "300",
	                  value: healthCheck.gracePeriodSeconds
	                })
	              ),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.gracePeriodSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.intervalSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Interval (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: intervalHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "healthChecks." + key + ".intervalSeconds",
	                type: "number",
	                min: "0",
	                placeholder: "60",
	                value: healthCheck.intervalSeconds
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.intervalSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.timeoutSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Timeout (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: timeoutHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "healthChecks." + key + ".timeoutSeconds",
	                type: "number",
	                min: "0",
	                placeholder: "20",
	                value: healthCheck.timeoutSeconds
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.timeoutSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.maxConsecutiveFailures)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Max Failures"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: failuresHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "healthChecks." + key + ".maxConsecutiveFailures",
	                type: "number",
	                min: "0",
	                placeholder: "3",
	                value: healthCheck.maxConsecutiveFailures
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.maxConsecutiveFailures
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getCommandFields",
	    value: function getCommandFields(healthCheck, key) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.COMMAND) {
	        return null;
	      }
	
	      var errors = errorsLens.at(key, {}).attr("command", {}).get(this.props.errors);
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-12", showError: Boolean(errors.value) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Command"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldAutofocus2.default,
	            null,
	            _react2.default.createElement(_FieldTextarea2.default, {
	              name: "healthChecks." + key + ".command",
	              type: "text",
	              value: healthCheck.command
	            })
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.value
	          )
	        )
	      );
	    }
	  }, {
	    key: "getEndpoints",
	    value: function getEndpoints() {
	      var data = this.props.data;
	
	
	      return data.portDefinitions.map(function (port, index) {
	        return _react2.default.createElement(
	          "option",
	          { key: index, value: index },
	          port.name || index
	        );
	      });
	    }
	  }, {
	    key: "getHTTPFields",
	    value: function getHTTPFields(healthCheck, key) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.MESOS_HTTP && healthCheck.protocol !== _HealthCheckProtocols.MESOS_HTTPS) {
	        return null;
	      }
	
	      var errors = errorsLens.at(key, {}).get(this.props.errors);
	
	      var endpointHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "Select a service endpoint that you configured in Networking."
	      );
	      var pathHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "Enter a path that is reachable in your service and where you expect a response code between 200 and 399."
	      );
	
	      return [_react2.default.createElement(
	        _FormRow2.default,
	        { key: "path" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-6", showError: false },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Service Endpoint"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: endpointHelpText,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapperClassName: "tooltip-wrapper tooltip-block-wrapper text-align-center",
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSelect2.default,
	            {
	              name: "healthChecks." + key + ".portIndex",
	              value: String(healthCheck.portIndex)
	            },
	            _react2.default.createElement(
	              "option",
	              { value: "" },
	              "Select Endpoint"
	            ),
	            this.getEndpoints()
	          )
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-6", showError: Boolean(errors.path) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Path"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: pathHelpText,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldAutofocus2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "healthChecks." + key + ".path",
	              type: "text",
	              value: healthCheck.path
	            })
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.path
	          )
	        )
	      ), _react2.default.createElement(
	        _FormRow2.default,
	        { key: "MESOS_HTTPS" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { showError: false, className: "column-12" },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              checked: healthCheck.protocol === _HealthCheckProtocols.MESOS_HTTPS,
	              name: "healthChecks." + key + ".https",
	              type: "checkbox",
	              value: "HTTPS"
	            }),
	            "Make HTTPS"
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.protocol
	          )
	        )
	      )];
	    }
	  }, {
	    key: "getHealthChecksLines",
	    value: function getHealthChecksLines(data) {
	      var _this2 = this;
	
	      return data.map(function (healthCheck, key) {
	        var errors = errorsLens.at(key, {}).get(_this2.props.errors);
	
	        if (!_HealthCheckUtil2.default.isKnownProtocol(healthCheck.protocol) && healthCheck.protocol != null) {
	          return _react2.default.createElement(
	            _FormGroupContainer2.default,
	            {
	              key: key,
	              onRemove: _this2.props.onRemoveItem.bind(_this2, {
	                value: key,
	                path: "healthChecks"
	              })
	            },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              "Unable to edit this HealthCheck"
	            ),
	            _react2.default.createElement(
	              "pre",
	              null,
	              (0, _stringify2.default)(healthCheck, null, 2)
	            )
	          );
	        }
	
	        var tooltipContent = _react2.default.createElement(
	          "span",
	          null,
	          "You have several protocol options. ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: "https://mesosphere.github.io/marathon/docs/health-checks.html",
	              target: "_blank"
	            },
	            "More Information"
	          ),
	          "."
	        );
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: key,
	            onRemove: _this2.props.onRemoveItem.bind(_this2, {
	              value: key,
	              path: "healthChecks"
	            })
	          },
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-6",
	                showError: Boolean(errors.protocol)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Protocol"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: tooltipContent,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapperClassName: "tooltip-wrapper text-align-center",
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldSelect2.default,
	                {
	                  name: "healthChecks." + key + ".protocol",
	                  value: healthCheck.protocol && healthCheck.protocol.replace(_HealthCheckProtocols.MESOS_HTTPS, _HealthCheckProtocols.MESOS_HTTP)
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "" },
	                  "Select Protocol"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: _HealthCheckProtocols.COMMAND },
	                  "Command"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: _HealthCheckProtocols.MESOS_HTTP },
	                  "HTTP"
	                )
	              ),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.protocol
	              )
	            )
	          ),
	          _this2.getCommandFields(healthCheck, key),
	          _this2.getHTTPFields(healthCheck, key),
	          _this2.getAdvancedSettings(healthCheck, key)
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var data = this.props.data;
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "A health check passes if (1) its HTTP response code is between 200\n        and 399 inclusive, and (2) its response is received within the\n        timeoutSeconds period. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/health-checks.html",
	            target: "_blank"
	          },
	          "More Information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Health Checks"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: tooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapperClassName: "tooltip-wrapper text-align-center",
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Health checks may be specified per application to be run against the application",
	          "'",
	          "s instances."
	        ),
	        this.getHealthChecksLines(data.healthChecks),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: "healthChecks"
	                })
	              },
	              "Add Health Check"
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return HealthChecksFormSection;
	}(_react.Component);
	
	HealthChecksFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	HealthChecksFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	HealthChecksFormSection.configReducers = {
	  healthChecks: _HealthChecks.FormReducer
	};
	
	HealthChecksFormSection.validationReducers = {
	  healthChecks: function healthChecks() {
	    return [];
	  }
	};
	
	module.exports = HealthChecksFormSection;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	    if (this.cache == null) {
	      this.cache = [];
	    }
	
	    var joinedPath = path.join(".");
	
	    if (type === _TransactionTypes.REMOVE_ITEM && joinedPath === "portDefinitions") {
	      state = state.map(function (item) {
	        if (item.portIndex === value) {
	          return null;
	        }
	
	        if (item.portIndex > value) {
	          item.portIndex--;
	        }
	
	        return item;
	      }).filter(function (item) {
	        return item != null;
	      });
	    }
	
	    if (joinedPath.search("healthChecks") !== -1) {
	      if (joinedPath === "healthChecks") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            state.push(value || {});
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            state = state.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return state;
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET) {
	        if ("healthChecks." + index + ".protocol" === joinedPath) {
	          state[index].protocol = value;
	          if (value === _HealthCheckProtocols.MESOS_HTTP && this.cache[index]) {
	            state[index].protocol = _HealthCheckProtocols.MESOS_HTTPS;
	          }
	        }
	        if ("healthChecks." + index + ".portIndex" === joinedPath) {
	          state[index].portIndex = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".command" === joinedPath) {
	          state[index].command = value;
	        }
	        if ("healthChecks." + index + ".path" === joinedPath) {
	          state[index].path = value;
	        }
	        if ("healthChecks." + index + ".gracePeriodSeconds" === joinedPath) {
	          state[index].gracePeriodSeconds = value;
	        }
	        if ("healthChecks." + index + ".intervalSeconds" === joinedPath) {
	          state[index].intervalSeconds = value;
	        }
	        if ("healthChecks." + index + ".timeoutSeconds" === joinedPath) {
	          state[index].timeoutSeconds = value;
	        }
	        if ("healthChecks." + index + ".maxConsecutiveFailures" === joinedPath) {
	          state[index].maxConsecutiveFailures = value;
	        }
	        if ("healthChecks." + index + ".https" === joinedPath) {
	          this.cache[index] = value;
	          if (value === true) {
	            state[index].protocol = _HealthCheckProtocols.MESOS_HTTPS;
	          } else {
	            state[index].protocol = _HealthCheckProtocols.MESOS_HTTP;
	          }
	        }
	      }
	    }
	
	    return state;
	  }
	};

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	var _HealthCheckProtocols2 = _interopRequireDefault(_HealthCheckProtocols);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  isKnownProtocol: function isKnownProtocol(protocol) {
	    return [""].concat([_HealthCheckProtocols2.default.MESOS_HTTP, _HealthCheckProtocols2.default.MESOS_HTTPS, _HealthCheckProtocols2.default.COMMAND]).includes(protocol);
	  }
	};

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _objektiv = __webpack_require__(1674);
	
	var _objektiv2 = _interopRequireDefault(_objektiv);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AdvancedSection = __webpack_require__(1724);
	
	var _AdvancedSection2 = _interopRequireDefault(_AdvancedSection);
	
	var _AdvancedSectionContent = __webpack_require__(1725);
	
	var _AdvancedSectionContent2 = _interopRequireDefault(_AdvancedSectionContent);
	
	var _AdvancedSectionLabel = __webpack_require__(1726);
	
	var _AdvancedSectionLabel2 = _interopRequireDefault(_AdvancedSectionLabel);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FieldTextarea = __webpack_require__(1686);
	
	var _FieldTextarea2 = _interopRequireDefault(_FieldTextarea);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultiContainerHealthChecksFormSection = function (_Component) {
	  (0, _inherits3.default)(MultiContainerHealthChecksFormSection, _Component);
	
	  function MultiContainerHealthChecksFormSection() {
	    (0, _classCallCheck3.default)(this, MultiContainerHealthChecksFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (MultiContainerHealthChecksFormSection.__proto__ || (0, _getPrototypeOf2.default)(MultiContainerHealthChecksFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MultiContainerHealthChecksFormSection, [{
	    key: "getAdvancedSettings",
	    value: function getAdvancedSettings(healthCheck, path, errorsLens) {
	      var errors = errorsLens.get(this.props.errors);
	
	      var gracePeriodHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 300): Health check failures are ignored within this number of seconds or until the instance becomes healthy for the first time."
	      );
	
	      var intervalHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 60): Number of seconds to wait between health checks."
	      );
	
	      var timeoutHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 20): Number of seconds after which a health check is considered a failure regardless of the response."
	      );
	
	      var failuresHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "(Optional. Default: 3): Number of consecutive health check failures after which the unhealthy instance should be killed. HTTP & TCP health checks: If this value is 0, instances will not be killed if they fail the health check."
	      );
	
	      return _react2.default.createElement(
	        _AdvancedSection2.default,
	        null,
	        _react2.default.createElement(
	          _AdvancedSectionLabel2.default,
	          null,
	          "Advanced Health Check Settings"
	        ),
	        _react2.default.createElement(
	          _AdvancedSectionContent2.default,
	          null,
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.gracePeriodSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Grace Period (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: gracePeriodHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: path + ".gracePeriodSeconds",
	                type: "number",
	                min: "0",
	                placeholder: "300",
	                value: healthCheck.gracePeriodSeconds
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.gracePeriodSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.intervalSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Interval (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: intervalHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: path + ".intervalSeconds",
	                type: "number",
	                min: "0",
	                placeholder: "60",
	                value: healthCheck.intervalSeconds
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.intervalSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.timeoutSeconds)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Timeout (s)"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: timeoutHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: path + ".timeoutSeconds",
	                type: "number",
	                min: "0",
	                placeholder: "20",
	                value: healthCheck.timeoutSeconds
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.timeoutSeconds
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                showError: Boolean(errors.maxConsecutiveFailures)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Max Failures"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: failuresHelpText,
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: path + ".maxConsecutiveFailures",
	                type: "number",
	                min: "0",
	                placeholder: "3",
	                value: healthCheck.maxConsecutiveFailures
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                errors.maxConsecutiveFailures
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getCommandFields",
	    value: function getCommandFields(healthCheck, path, errorsLens) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.COMMAND) {
	        return null;
	      }
	
	      var exec = healthCheck.exec;
	
	      var errors = errorsLens.attr("exec", {}).attr("command", {}).get(this.props.errors);
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          {
	            className: "column-12",
	            showError: Boolean(errors.shell || errors.argv)
	          },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Command"
	              )
	            )
	          ),
	          _react2.default.createElement(_FieldTextarea2.default, {
	            name: path + ".exec.command.value",
	            type: "text",
	            value: exec && exec.command.value
	          }),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.shell || errors.argv
	          )
	        )
	      );
	    }
	  }, {
	    key: "getEndpoints",
	    value: function getEndpoints(container) {
	      if (container.endpoints == null) {
	        return [];
	      }
	
	      return container.endpoints.map(function (endpoint) {
	        return _react2.default.createElement(
	          "option",
	          { key: endpoint, value: endpoint.name },
	          endpoint.name
	        );
	      });
	    }
	  }, {
	    key: "getHTTPFields",
	    value: function getHTTPFields(healthCheck, container, path, errorsLens) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.HTTP) {
	        return null;
	      }
	
	      var errors = errorsLens.at("http", {}).get(this.props.errors);
	
	      var endpointHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "Select a service endpoint that you configured in Networking."
	      );
	      var pathHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "Enter a path that is reachable in your service and where you expect a response code between 200 and 399."
	      );
	
	      return [_react2.default.createElement(
	        _FormRow2.default,
	        { key: "path" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-6", showError: false },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Service Endpoint"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: endpointHelpText,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapperClassName: "tooltip-wrapper tooltip-block-wrapper text-align-center",
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSelect2.default,
	            {
	              name: path + ".http.endpoint",
	              value: String(healthCheck.http.endpoint)
	            },
	            _react2.default.createElement(
	              "option",
	              { value: "" },
	              "Select Endpoint"
	            ),
	            this.getEndpoints(container)
	          )
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-6", showError: Boolean(errors.path) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Path"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: pathHelpText,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FieldInput2.default, {
	            name: path + ".http.path",
	            type: "text",
	            value: healthCheck.http.path
	          }),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.path
	          )
	        )
	      ), _react2.default.createElement(
	        _FormRow2.default,
	        { key: "HTTPS" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { showError: false, className: "column-12" },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              checked: healthCheck.http.https,
	              name: path + ".http.https",
	              type: "checkbox"
	            }),
	            "Make HTTPS"
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            errors.protocol
	          )
	        )
	      )];
	    }
	  }, {
	    key: "getTCPFields",
	    value: function getTCPFields(healthCheck, container, path) {
	      if (healthCheck.protocol !== _HealthCheckProtocols.TCP) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        { key: "path" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-12", showError: false },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Service Endpoint"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSelect2.default,
	            {
	              name: path + ".tcp.endpoint",
	              value: String(healthCheck.tcp.endpoint)
	            },
	            _react2.default.createElement(
	              "option",
	              { value: "" },
	              "Select Endpoint"
	            ),
	            this.getEndpoints(container)
	          )
	        )
	      );
	    }
	  }, {
	    key: "getHealthChecksBody",
	    value: function getHealthChecksBody(container, index) {
	      var healthCheck = container.healthCheck;
	
	      var path = "containers." + index + ".healthCheck";
	      var errorsLens = _objektiv2.default.attr("containers", []).at(index, {}).attr("healthCheck", {});
	
	      if (healthCheck == null) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _AddButton2.default,
	            { onClick: this.props.onAddItem.bind(this, { path: path }) },
	            "Add Health Check"
	          )
	        );
	      }
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "You have several protocol options. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/health-checks.html",
	            target: "_blank"
	          },
	          "More Information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FormGroupContainer2.default,
	        {
	          onRemove: this.props.onRemoveItem.bind(this, { path: path })
	        },
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-6" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Protocol"
	                ),
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  _react2.default.createElement(
	                    _reactjsComponents.Tooltip,
	                    {
	                      content: tooltipContent,
	                      interactive: true,
	                      maxWidth: 300,
	                      wrapperClassName: "tooltip-wrapper text-align-center",
	                      wrapText: true
	                    },
	                    _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _FieldSelect2.default,
	              { name: path + ".protocol", value: healthCheck.protocol },
	              _react2.default.createElement(
	                "option",
	                { value: "" },
	                "Select Protocol"
	              ),
	              _react2.default.createElement(
	                "option",
	                { value: _HealthCheckProtocols.COMMAND },
	                "Command"
	              ),
	              _react2.default.createElement(
	                "option",
	                { value: _HealthCheckProtocols.HTTP },
	                "HTTP"
	              ),
	              _react2.default.createElement(
	                "option",
	                { value: _HealthCheckProtocols.TCP },
	                "TCP"
	              )
	            )
	          )
	        ),
	        this.getHTTPFields(healthCheck, container, path, errorsLens),
	        this.getTCPFields(healthCheck, container, path),
	        this.getCommandFields(healthCheck, path, errorsLens),
	        this.getAdvancedSettings(healthCheck, path, errorsLens)
	      );
	    }
	  }, {
	    key: "getContainerHealthChecks",
	    value: function getContainerHealthChecks(containers) {
	      var _this2 = this;
	
	      return containers.map(function (container, index) {
	        return _react2.default.createElement(
	          "div",
	          { key: container.name },
	          _react2.default.createElement(
	            "div",
	            { className: "form-row-element" },
	            _react2.default.createElement(
	              "h4",
	              { className: "form-header short-bottom" },
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  _react2.default.createElement(_Icon2.default, { id: "container", size: "mini", color: "purple" })
	                ),
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  container.name
	                )
	              )
	            )
	          ),
	          _this2.getHealthChecksBody(container, index)
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          handleTabChange = _props.handleTabChange;
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "A health check passes if (1) its HTTP response code is between 200\n        and 399 inclusive, and (2) its response is received within the\n        timeoutSeconds period. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/health-checks.html",
	            target: "_blank"
	          },
	          "More Information"
	        ),
	        "."
	      );
	      var heading = _react2.default.createElement(
	        _FormGroupHeading2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroupHeadingContent2.default,
	          { primary: true },
	          "Health Checks"
	        ),
	        _react2.default.createElement(
	          _FormGroupHeadingContent2.default,
	          null,
	          _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              content: tooltipContent,
	              interactive: true,
	              maxWidth: 300,
	              wrapperClassName: "tooltip-wrapper text-align-center",
	              wrapText: true
	            },
	            _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	          )
	        )
	      );
	
	      if (!data.containers || !data.containers.length) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { className: "flush-top short-bottom" },
	            heading
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Please ",
	            _react2.default.createElement(
	              "a",
	              {
	                onClick: handleTabChange.bind(null, "services"),
	                className: "clickable"
	              },
	              "add a container"
	            ),
	            " before configuring health checks."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "form flush-bottom" },
	        _react2.default.createElement(
	          "h2",
	          { className: "form-header flush-top short-bottom" },
	          heading
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Health checks may be specified per application to be run against the application",
	          "'",
	          "s instances."
	        ),
	        this.getContainerHealthChecks(data.containers)
	      );
	    }
	  }]);
	  return MultiContainerHealthChecksFormSection;
	}(_react.Component);
	
	MultiContainerHealthChecksFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  handleTabChange: function handleTabChange() {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	MultiContainerHealthChecksFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  handleTabChange: _react2.default.PropTypes.func,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	module.exports = MultiContainerHealthChecksFormSection;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Util = __webpack_require__(982);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _VirtualNetworksStore = __webpack_require__(1530);
	
	var _VirtualNetworksStore2 = _interopRequireDefault(_VirtualNetworksStore);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _MultiContainerNetwork = __webpack_require__(1751);
	
	var _ServiceConfigUtil = __webpack_require__(1752);
	
	var _ServiceConfigUtil2 = _interopRequireDefault(_ServiceConfigUtil);
	
	var _VipLabelUtil = __webpack_require__(1695);
	
	var _VipLabelUtil2 = _interopRequireDefault(_VipLabelUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Networking$type = _Networking2.default.type,
	    CONTAINER = _Networking$type.CONTAINER,
	    HOST = _Networking$type.HOST;
	
	var METHODS_TO_BIND = ["onVirtualNetworksStoreSuccess"];
	
	var MultiContainerNetworkingFormSection = function (_mixin) {
	  (0, _inherits3.default)(MultiContainerNetworkingFormSection, _mixin);
	
	  function MultiContainerNetworkingFormSection() {
	    (0, _classCallCheck3.default)(this, MultiContainerNetworkingFormSection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MultiContainerNetworkingFormSection.__proto__ || (0, _getPrototypeOf2.default)(MultiContainerNetworkingFormSection)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.store_listeners = [{
	      name: "virtualNetworks",
	      events: ["success"],
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(MultiContainerNetworkingFormSection, [{
	    key: "isHostNetwork",
	    value: function isHostNetwork() {
	      var networkType = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.mode") || HOST;
	
	      return networkType === HOST;
	    }
	  }, {
	    key: "onVirtualNetworksStoreSuccess",
	    value: function onVirtualNetworksStoreSuccess() {
	      this.forceUpdate();
	    }
	  }, {
	    key: "getContainerPortField",
	    value: function getContainerPortField(endpoint, network, index, containerIndex, errors) {
	      if (network !== CONTAINER) {
	        return null;
	      }
	
	      var containerPortError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".containerPort");
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        {
	          className: "column-3",
	          key: "container-port",
	          showError: Boolean(containerPortError)
	        },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Container Port"
	            )
	          )
	        ),
	        _react2.default.createElement(_FieldInput2.default, {
	          min: "0",
	          name: "containers." + containerIndex + ".endpoints." + index + ".containerPort",
	          type: "number",
	          value: endpoint.containerPort
	        }),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          containerPortError
	        )
	      );
	    }
	  }, {
	    key: "getHostPortFields",
	    value: function getHostPortFields(endpoint, index, containerIndex) {
	      var placeholder = void 0;
	      var environmentVariableName = "$ENDPOINT_{NAME}";
	      if (endpoint.name && typeof endpoint.name === "string") {
	        environmentVariableName = environmentVariableName.replace("{NAME}", endpoint.name.toUpperCase());
	      }
	      var value = endpoint.hostPort;
	      var errors = this.props.errors;
	
	      var hostPortError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".port");
	
	      if (endpoint.automaticPort) {
	        placeholder = environmentVariableName;
	        value = null;
	      }
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "This host port will be accessible as an environment variable called " + environmentVariableName + ". ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/ports.html",
	            target: "_blank"
	          },
	          "More information"
	        )
	      );
	
	      return [_react2.default.createElement(
	        _FormGroup2.default,
	        {
	          className: "column-4",
	          key: "host-port",
	          showError: Boolean(hostPortError)
	        },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Host Port"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: tooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FieldInput2.default, {
	          disabled: endpoint.automaticPort,
	          placeholder: placeholder,
	          min: "0",
	          name: "containers." + containerIndex + ".endpoints." + index + ".hostPort",
	          type: "number",
	          value: value
	        }),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          hostPortError
	        )
	      ), _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-auto flush-left", key: "assign-automatically" },
	        _react2.default.createElement(_FieldLabel2.default, null),
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          { matchInputHeight: true },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: endpoint.automaticPort,
	            name: "containers." + containerIndex + ".endpoints." + index + ".automaticPort",
	            type: "checkbox"
	          }),
	          "Assign Automatically"
	        )
	      )];
	    }
	  }, {
	    key: "getLoadBalancedServiceAddressField",
	    value: function getLoadBalancedServiceAddressField(endpoint, index, containerIndex) {
	      var containerPort = endpoint.containerPort,
	          hostPort = endpoint.hostPort,
	          loadBalanced = endpoint.loadBalanced,
	          vip = endpoint.vip;
	      var errors = this.props.errors;
	
	      var loadBalancedError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".labels");
	
	      if ((0, _Util.isObject)(loadBalancedError)) {
	        loadBalancedError = null;
	      }
	
	      var address = vip;
	      if (address == null) {
	        var port = "";
	        if (hostPort != null && hostPort !== "") {
	          port = hostPort;
	        }
	        if (containerPort != null && containerPort !== "") {
	          port = containerPort;
	        }
	        port = port || 0;
	
	        address = this.props.data.id + ":" + port;
	      }
	
	      var loadBalancerDocsURI = _MetadataStore2.default.buildDocsURI("/usage/service-discovery/load-balancing-vips");
	      var loadBalancerTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Load balance the service internally (layer 4), and create a service\n        address. For external (layer 7) load balancing, create an external\n        load balancer and attach this service. ",
	        _react2.default.createElement(
	          "a",
	          { href: loadBalancerDocsURI, target: "_blank" },
	          "More Information"
	        )
	      );
	
	      return [_react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-12", showError: Boolean(loadBalancedError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              checked: loadBalanced,
	              name: "containers." + containerIndex + ".endpoints." + index + ".loadBalanced",
	              type: "checkbox"
	            }),
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Enable Load Balanced Service Address"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: loadBalancerTooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapperClassName: "tooltip-wrapper text-align-center",
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            loadBalancedError
	          )
	        )
	      ), loadBalanced && this.getLoadBalancedPortField(endpoint, index, containerIndex)];
	    }
	  }, {
	    key: "getLoadBalancedPortField",
	    value: function getLoadBalancedPortField(endpoint, index, containerIndex) {
	      var _props = this.props,
	          errors = _props.errors,
	          _props$data = _props.data,
	          id = _props$data.id,
	          portsAutoAssign = _props$data.portsAutoAssign;
	      var hostPort = endpoint.hostPort,
	          containerPort = endpoint.containerPort,
	          vip = endpoint.vip,
	          vipPort = endpoint.vipPort;
	
	
	      var defaultVipPort = this.isHostNetwork() ? hostPort : containerPort;
	
	      // clear placeholder when HOST network portsAutoAssign is true
	      var placeholder = this.isHostNetwork() && portsAutoAssign ? "" : defaultVipPort;
	
	      var vipPortError = null;
	      var loadBalancedError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".labels");
	
	      var tooltipContent = "This port will be used to load balance this service address internally";
	      if ((0, _Util.isObject)(loadBalancedError)) {
	        vipPortError = loadBalancedError[_VipLabelUtil2.default.defaultVip(index)];
	        loadBalancedError = null;
	      }
	
	      var address = vip;
	
	      var port = "";
	      if (!portsAutoAssign && !_ValidatorUtil2.default.isEmpty(hostPort)) {
	        port = hostPort;
	      }
	      if (!_ValidatorUtil2.default.isEmpty(containerPort)) {
	        port = containerPort;
	      }
	      if (!_ValidatorUtil2.default.isEmpty(vipPort)) {
	        port = vipPort;
	      }
	
	      if (address == null) {
	        address = id + ":" + port;
	      }
	
	      var vipMatch = address.match(/(.+):\d+/);
	      if (vipMatch) {
	        address = vipMatch[1] + ":" + port;
	      }
	
	      var hostName = null;
	      if (!vipPortError) {
	        hostName = _ServiceConfigUtil2.default.buildHostNameFromVipLabel(address, port);
	      }
	
	      var helpText = _react2.default.createElement(
	        _FieldHelp2.default,
	        null,
	        "Load balance this service internally at ",
	        hostName
	      );
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        { key: "lb-port" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-12" },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Load Balanced Port"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: tooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                key: "vip-port",
	                showError: Boolean(vipPortError)
	              },
	              _react2.default.createElement(_FieldInput2.default, {
	                min: "1",
	                placeholder: placeholder,
	                name: "containers." + containerIndex + ".endpoints." + index + ".vipPort",
	                type: "number",
	                value: vipPort
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-12", showError: Boolean(vipPortError) },
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                vipPortError
	              ),
	              !vipPortError && helpText
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getProtocolField",
	    value: function getProtocolField(endpoint, index, containerIndex) {
	      var errors = this.props.errors;
	
	      var protocolError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".protocol");
	
	      var assignTooltip = _react2.default.createElement(
	        "span",
	        null,
	        "Most services will use TCP. ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://mesosphere.github.io/marathon/docs/ports.html" },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-3", showError: Boolean(protocolError) },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Protocol"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: assignTooltip,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-auto", key: "protocol-udp" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { matchInputHeight: true },
	              _react2.default.createElement(_FieldInput2.default, {
	                checked: endpoint.protocol.udp,
	                name: "containers." + containerIndex + ".endpoints." + index + ".protocol.udp",
	                type: "checkbox"
	              }),
	              "UDP"
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-auto", key: "protocol-tcp" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { matchInputHeight: true },
	              _react2.default.createElement(_FieldInput2.default, {
	                checked: endpoint.protocol.tcp,
	                name: "containers." + containerIndex + ".endpoints." + index + ".protocol.tcp",
	                type: "checkbox"
	              }),
	              "TCP"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          protocolError
	        )
	      );
	    }
	  }, {
	    key: "getServiceContainerEndpoints",
	    value: function getServiceContainerEndpoints() {
	      var _this2 = this;
	
	      var endpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var containerIndex = arguments[1];
	
	      var network = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.mode");
	      var errors = this.props.errors;
	
	
	      return endpoints.map(function (endpoint, index) {
	        var nameError = (0, _Util.findNestedPropertyInObject)(errors, "containers." + containerIndex + ".endpoints." + index + ".name");
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: index,
	            onRemove: _this2.props.onRemoveItem.bind(_this2, {
	              value: index,
	              path: "containers." + containerIndex + ".endpoints"
	            })
	          },
	          _react2.default.createElement(
	            _FormRow2.default,
	            { key: "port-name-group" },
	            _this2.getContainerPortField(endpoint, network, index, containerIndex, errors),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-6",
	                key: "endpoint-name",
	                showError: Boolean(nameError)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Service Endpoint Name"
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "containers." + containerIndex + ".endpoints." + index + ".name",
	                type: "text",
	                value: endpoint.name
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                nameError
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            { key: "host-protocol" },
	            _this2.getHostPortFields(endpoint, index, containerIndex),
	            _this2.getProtocolField(endpoint, index, containerIndex)
	          ),
	          _this2.getLoadBalancedServiceAddressField(endpoint, index, containerIndex)
	        );
	      });
	    }
	  }, {
	    key: "getServiceEndpoints",
	    value: function getServiceEndpoints() {
	      var _this3 = this;
	
	      var containers = this.props.data.containers;
	
	
	      return containers.map(function (container, index) {
	        var _container$endpoints = container.endpoints,
	            endpoints = _container$endpoints === undefined ? [] : _container$endpoints;
	
	
	        return _react2.default.createElement(
	          "div",
	          { key: index },
	          _react2.default.createElement(
	            "h4",
	            { className: "short-bottom" },
	            _react2.default.createElement(_Icon2.default, { id: "container", size: "mini", color: "purple" }),
	            " " + container.name
	          ),
	          _this3.getServiceContainerEndpoints(endpoints, index),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: _this3.props.onAddItem.bind(_this3, {
	                  path: "containers." + index + ".endpoints"
	                })
	              },
	              "Add Service Endpoint"
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "getVirtualNetworks",
	    value: function getVirtualNetworks() {
	      return _VirtualNetworksStore2.default.getOverlays().mapItems(function (overlay) {
	        var name = overlay.getName();
	
	        return {
	          text: "Virtual Network: " + name,
	          value: CONTAINER + "." + name
	        };
	      }).getItems().map(function (virtualNetwork, index) {
	        return _react2.default.createElement(
	          "option",
	          { key: index, value: virtualNetwork.value },
	          virtualNetwork.text
	        );
	      });
	    }
	  }, {
	    key: "getTypeSelections",
	    value: function getTypeSelections() {
	      var networkType = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.mode");
	      var networkName = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.name");
	
	      var network = networkType;
	      if (networkName) {
	        network = networkType + "." + networkName;
	      }
	
	      return _react2.default.createElement(
	        _FieldSelect2.default,
	        { name: "networks.0", value: network },
	        _react2.default.createElement(
	          "option",
	          { value: HOST },
	          "Host"
	        ),
	        this.getVirtualNetworks()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var networkError = (0, _Util.findNestedPropertyInObject)(this.props.errors, "container.docker.network");
	
	      var networkTypeTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Choose BRIDGE, HOST, or USER networking. Refer to the ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/ports.html",
	            target: "_blank"
	          },
	          "ports documentation"
	        ),
	        " for more information."
	      );
	
	      var serviceEndpointsDocsURI = _MetadataStore2.default.buildDocsURI("/usage/service-discovery/load-balancing-vips/virtual-ip-addresses/");
	      var serviceEndpointsTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Service endpoints map traffic from a single VIP to multiple IP addresses and ports. ",
	        _react2.default.createElement(
	          "a",
	          { href: serviceEndpointsDocsURI, target: "_blank" },
	          "More Information"
	        )
	      );
	
	      return _react2.default.createElement(
	        "div",
	        { className: "form flush-bottom" },
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          "Networking"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Configure the networking for your service."
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-6", showError: Boolean(networkError) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Network Type"
	                ),
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  _react2.default.createElement(
	                    _reactjsComponents.Tooltip,
	                    {
	                      content: networkTypeTooltipContent,
	                      interactive: true,
	                      maxWidth: 300,
	                      wrapText: true
	                    },
	                    _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                  )
	                )
	              )
	            ),
	            this.getTypeSelections(),
	            _react2.default.createElement(
	              _FieldHelp2.default,
	              null,
	              "The network type will be shared across all your containers."
	            ),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              networkError
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Service Endpoints"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: serviceEndpointsTooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapperClassName: "tooltip-wrapper text-align-center",
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "DC/OS can automatically generate a Service Address to connect to each of your load balanced endpoints"
	        ),
	        this.getServiceEndpoints()
	      );
	    }
	  }]);
	  return MultiContainerNetworkingFormSection;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	MultiContainerNetworkingFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	MultiContainerNetworkingFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	MultiContainerNetworkingFormSection.configReducers = {
	  networks: _MultiContainerNetwork.FormReducer
	};
	
	module.exports = MultiContainerNetworkingFormSection;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{ mode: _Networking2.default.type.HOST.toLowerCase() }];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    var _path = (0, _slicedToArray3.default)(path, 3),
	        element = _path[0],
	        _path$ = _path[1],
	        index = _path$ === undefined ? 0 : _path$,
	        field = _path[2];
	
	    var newState = state.slice();
	    if (element === "networks") {
	      if (type === _TransactionTypes.ADD_ITEM && index !== 0) {
	        newState.push(value || { mode: _Networking2.default.type.HOST.toLowerCase() });
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && field === "name") {
	        newState[index].name = value;
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && field === "mode") {
	        newState[index].mode = value.toLowerCase();
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && typeof value === "string") {
	        var _value$split = value.split("."),
	            _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	            mode = _value$split2[0],
	            name = _value$split2[1];
	
	        if (mode === _Networking2.default.type.CONTAINER) {
	          newState[index] = {
	            name: name,
	            mode: mode.toLowerCase()
	          };
	
	          return newState;
	        }
	
	        newState[index] = {
	          mode: mode.toLowerCase()
	        };
	      }
	    }
	
	    return newState;
	  },
	  JSONParser: function JSONParser(state) {
	    if (state == null || state.networks == null || !Array.isArray(state.networks)) {
	      return [];
	    }
	
	    if (state.networks.length === 0) {
	      return [new _Transaction2.default(["networks"], {}, _TransactionTypes.ADD_ITEM), new _Transaction2.default(["networks", 0], _Networking2.default.type.HOST)];
	    }
	
	    return state.networks.reduce(function (memo, network, index) {
	      memo.push(new _Transaction2.default(["networks"], network, _TransactionTypes.ADD_ITEM));
	
	      if (network.mode == null) {
	        return memo;
	      }
	
	      if (network.mode === _Networking2.default.type.CONTAINER.toLowerCase()) {
	        var mode = _Networking2.default.type.CONTAINER;
	        var name = network.name;
	
	        memo.push(new _Transaction2.default(["networks", index], mode + "." + name));
	
	        return memo;
	      }
	
	      memo.push(new _Transaction2.default(["networks", index], network.mode.toUpperCase()));
	
	      return memo;
	    }, []);
	  },
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{ mode: _Networking2.default.type.HOST }];
	    var _ref2 = arguments[1];
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    var _path2 = (0, _slicedToArray3.default)(path, 3),
	        element = _path2[0],
	        _path2$ = _path2[1],
	        index = _path2$ === undefined ? 0 : _path2$,
	        field = _path2[2];
	
	    var newState = state.slice();
	    if (element === "networks") {
	      if (type === _TransactionTypes.ADD_ITEM && index !== 0) {
	        newState.push(value || { mode: _Networking2.default.type.HOST });
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && field === "name") {
	        newState[index].name = value;
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && field === "mode") {
	        newState[index].mode = value;
	
	        return newState;
	      }
	
	      if (type === _TransactionTypes.SET && typeof value === "string") {
	        var _value$split3 = value.split("."),
	            _value$split4 = (0, _slicedToArray3.default)(_value$split3, 2),
	            mode = _value$split4[0],
	            name = _value$split4[1];
	
	        if (mode === _Networking2.default.type.CONTAINER) {
	          newState[index] = {
	            name: name,
	            mode: mode
	          };
	
	          return newState;
	        }
	
	        newState[index] = {
	          mode: mode
	        };
	      }
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _HostUtil = __webpack_require__(1753);
	
	var _HostUtil2 = _interopRequireDefault(_HostUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceConfigUtil = {
	  matchVIPLabel: function matchVIPLabel(str) {
	    return _Networking2.default.VIP_LABEL_REGEX.test(str);
	  },
	  findVIPLabel: function findVIPLabel() {
	    var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _keys2.default)(labels).find(ServiceConfigUtil.matchVIPLabel);
	  },
	  hasVIPLabel: function hasVIPLabel() {
	    var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return !!ServiceConfigUtil.findVIPLabel(labels);
	  },
	  buildHostName: function buildHostName(id, port) {
	    var hostname = _HostUtil2.default.stringToHostname(id);
	
	    return "" + hostname + _Networking2.default.L4LB_ADDRESS + ":" + port;
	  },
	  buildHostNameFromVipLabel: function buildHostNameFromVipLabel(label, port) {
	    var _label$split = label.split(":"),
	        _label$split2 = (0, _slicedToArray3.default)(_label$split, 2),
	        ipOrName = _label$split2[0],
	        _label$split2$ = _label$split2[1],
	        labelPort = _label$split2$ === undefined ? "" : _label$split2$;
	
	    // Sometimes we don't know the port yet
	
	
	    port = port || "<assigned port>";
	
	    // 0 means randomly assigned port
	    port = labelPort === "0" ? port : labelPort;
	
	    // it seems to be an IP address
	    if (/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(ipOrName)) {
	      return ipOrName + ":" + port;
	    }
	
	    var hostname = _HostUtil2.default.stringToHostname(ipOrName);
	
	    return "" + hostname + _Networking2.default.L4LB_ADDRESS + ":" + port;
	  }
	};
	
	module.exports = ServiceConfigUtil;

/***/ },
/* 1753 */
/***/ function(module, exports) {

	"use strict";
	
	var HostUtil = {
	  /**
	   * Util to "transform" a string to a valid hostname following the RFC-952
	   * standard. It mirrors the `dcos/mesos_state` implementation.
	   * The util  will remove empty labels and use the string to label util
	   * to ensure that labels don't include invalid characters and don't exceed
	   * the character limit.
	   *
	   * @param {string} string
	   * @return {string} hostname
	   */
	  stringToHostname: function stringToHostname(string) {
	    if (string == null) {
	      return null;
	    }
	
	    return string.split(".").filter(function (string) {
	      return string !== "";
	    }).map(HostUtil.stringToLabel).join(".");
	  },
	
	
	  /**
	   * Util to "convert" a given string to a RFC-952 compliant DNS label.
	   * It mirrors the respective `dcos/mesos_state` implementation.
	   * The util  will strip invalid characters and ensures that the label don't
	   * exceed the character limit.
	   *
	   * @param {string} string
	   * @return {string} label
	   */
	  stringToLabel: function stringToLabel(string) {
	    var LABEL_MAX_LENGTH = 63;
	
	    if (string == null) {
	      return "";
	    }
	
	    string = string.toLowerCase();
	
	    // Strip all invalid character including leading and trailing dashes
	    // or replace them with dashes.
	    string = string.replace(/(_)|^-+|-+$|[^a-z0-9-]/g, function (match, p1) {
	      // Replace underscores (first capture group) with dashes
	      if (p1 != null) {
	        return "-";
	      }
	
	      // Strip any other invalid character
	      return "";
	    });
	
	    // Trim labels if they exceed the allowed max length
	    if (string.length > LABEL_MAX_LENGTH) {
	      // Remove all dashes and groups of dashes that have an offset larger or
	      // equal to the allowed max length before trimming the label to ensure
	      // that no label ends with a dash.
	      string = string.replace(/[-]+/g, function (match, offset) {
	        if (offset + match.length >= LABEL_MAX_LENGTH) {
	          return "";
	        }
	
	        return match;
	      });
	
	      // Trim the label to the allowed max length
	      string = string.slice(0, LABEL_MAX_LENGTH);
	    }
	
	    return string;
	  }
	};
	
	module.exports = HostUtil;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objektiv = __webpack_require__(1674);
	
	var _objektiv2 = _interopRequireDefault(_objektiv);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _MultiContainerVolumes = __webpack_require__(1755);
	
	var _VolumeConstants = __webpack_require__(1756);
	
	var _VolumeConstants2 = _interopRequireDefault(_VolumeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var errorsLens = _objektiv2.default.attr("container", {}).attr("volumes", []);
	
	var MultiContainerVolumesFormSection = function (_Component) {
	  (0, _inherits3.default)(MultiContainerVolumesFormSection, _Component);
	
	  function MultiContainerVolumesFormSection() {
	    (0, _classCallCheck3.default)(this, MultiContainerVolumesFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (MultiContainerVolumesFormSection.__proto__ || (0, _getPrototypeOf2.default)(MultiContainerVolumesFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MultiContainerVolumesFormSection, [{
	    key: "getContainerMounts",
	    value: function getContainerMounts(containers, volumeMountIndex) {
	      var volumeMounts = this.props.data.volumeMounts;
	
	
	      return containers.map(function (container, containerIndex) {
	        var containersLabel = null;
	        var pathLabel = null;
	        if (containerIndex === 0) {
	          containersLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Containers"
	              )
	            )
	          );
	          pathLabel = _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Container Path"
	              )
	            )
	          );
	        }
	
	        return _react2.default.createElement(
	          _FormRow2.default,
	          { key: containerIndex },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-3" },
	            containersLabel,
	            _react2.default.createElement(
	              "div",
	              { className: "form-control-input-height" },
	              (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(container)
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-9" },
	            pathLabel,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "volumeMounts." + volumeMountIndex + ".mountPath." + containerIndex,
	              type: "text",
	              value: volumeMounts[volumeMountIndex].mountPath[containerIndex]
	            })
	          )
	        );
	      });
	    }
	
	    /**
	     * getExternalVolumesLines
	     *
	     * @param  {Object} data
	     * @param  {Number} offset as we have two independent sections that are 0
	     *   based we need to add an offset to the second one
	     * @return {Array} elements
	     */
	
	  }, {
	    key: "getVolumesMountLines",
	    value: function getVolumesMountLines(data, offset) {
	      var _this2 = this;
	
	      var containers = this.props.data.containers;
	
	
	      return data.map(function (volumes, key) {
	        var nameError = errorsLens.at(key + offset, {}).attr("volumes", {}).get(_this2.props.errors).name;
	        var removeHandler = _this2.props.onRemoveItem.bind(_this2, {
	          value: key,
	          path: "volumeMounts"
	        });
	
	        if (volumes.type === _VolumeConstants2.default.type.unknown) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          { onRemove: removeHandler, key: key },
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-6", showError: false },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Volume Type"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldSelect2.default,
	                {
	                  name: "volumeMounts." + key + ".type",
	                  value: volumes.type
	                },
	                _react2.default.createElement(
	                  "option",
	                  null,
	                  "Select..."
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: _VolumeConstants2.default.type.host },
	                  "Host Volume"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: _VolumeConstants2.default.type.ephemeral },
	                  "Ephemeral Volume"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-6", showError: Boolean(nameError) },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Name"
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "volumeMounts." + key + ".name",
	                type: "text",
	                value: volumes.name
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                nameError
	              )
	            )
	          ),
	          _this2.getHostPathInput(volumes, key),
	          _this2.getContainerMounts(containers, key)
	        );
	      });
	    }
	  }, {
	    key: "getHostPathInput",
	    value: function getHostPathInput(volumes, key) {
	      if (volumes.type === _VolumeConstants2.default.type.host) {
	        return _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Host Path"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _FieldAutofocus2.default,
	              null,
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "volumeMounts." + key + ".hostPath",
	                type: "text",
	                value: volumes.hostPath
	              })
	            )
	          )
	        );
	      }
	    }
	  }, {
	    key: "getHeadline",
	    value: function getHeadline() {
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "DC/OS offers several storage options. ",
	        _react2.default.createElement(
	          "a",
	          { href: _MetadataStore2.default.buildDocsURI("/usage/storage/"), target: "_blank" },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "h2",
	        { className: "flush-top short-bottom" },
	        _react2.default.createElement(
	          _FormGroupHeading2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            { primary: true },
	            "Volumes"
	          ),
	          _react2.default.createElement(
	            _FormGroupHeadingContent2.default,
	            null,
	            _react2.default.createElement(
	              _reactjsComponents.Tooltip,
	              {
	                content: tooltipContent,
	                interactive: true,
	                maxWidth: 300,
	                wrapText: true
	              },
	              _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          handleTabChange = _props.handleTabChange;
	
	
	      if (!data.containers || !data.containers.length) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          this.getHeadline(),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Please ",
	            _react2.default.createElement(
	              "a",
	              {
	                onClick: handleTabChange.bind(null, "services"),
	                className: "clickable"
	              },
	              "add a container"
	            ),
	            " before configuring Volumes."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        this.getHeadline(),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Create a stateful service by configuring a persistent volume. Persistent volumes enable instances to be restarted without data loss."
	        ),
	        this.getVolumesMountLines(data.volumeMounts, data.volumeMounts),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _AddButton2.default,
	            {
	              onClick: this.props.onAddItem.bind(this, {
	                path: "volumeMounts"
	              })
	            },
	            "Add Volume"
	          )
	        )
	      );
	    }
	  }]);
	  return MultiContainerVolumesFormSection;
	}(_react.Component);
	
	MultiContainerVolumesFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  handleTabChange: function handleTabChange() {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	MultiContainerVolumesFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  handleTabChange: _react2.default.PropTypes.func,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	MultiContainerVolumesFormSection.configReducers = {
	  volumeMounts: _MultiContainerVolumes.FormReducer
	};
	
	module.exports = MultiContainerVolumesFormSection;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _VolumeConstants = __webpack_require__(1756);
	
	var _VolumeConstants2 = _interopRequireDefault(_VolumeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * transformContainers
	 * converts nested container - volumeMounts structure into flat array of tuples
	 */
	function transformContainers(memo, container, containerIndex) {
	  if (container.volumeMounts == null) {
	    return memo;
	  }
	
	  var tuples = container.volumeMounts.map(function (mount) {
	    return [containerIndex, mount];
	  });
	
	  return memo.concat(tuples);
	}
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	    var counterIndex = arguments[2];
	
	    if (counterIndex === 0) {
	      state = [];
	    }
	
	    var _path = (0, _slicedToArray3.default)(path, 3),
	        base = _path[0],
	        index = _path[1],
	        name = _path[2];
	
	    if (this.hostPaths == null) {
	      this.hostPaths = {};
	    }
	
	    if (base !== "volumeMounts") {
	      return state;
	    }
	
	    var newState = state.slice();
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        newState.push(value || {});
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState = newState.filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	    }
	
	    if (name === "type" && value !== _VolumeConstants2.default.type.host) {
	      delete newState[index].host;
	    }
	    if (name === "type" && value === _VolumeConstants2.default.type.host) {
	      newState[index].host = this.hostPaths[index];
	    }
	    if (name === "name") {
	      newState[index].name = value;
	    }
	    if (name === "hostPath") {
	      this.hostPaths[index] = value;
	      newState[index].host = value;
	    }
	
	    return newState;
	  },
	  JSONParser: function JSONParser(state) {
	    if (state == null) {
	      return [];
	    }
	
	    var volumes = [];
	    var volumeIndexMap = {};
	
	    var transactions = [];
	
	    if (state.volumes != null) {
	      var volumeTransaction = state.volumes.reduce(function (memo, volume) {
	        if (volume.name == null) {
	          return memo;
	        }
	        volumeIndexMap[volume.name] = volumes.push(volume.name) - 1;
	
	        var volumeTypeTransactions = [new _Transaction2.default(["volumeMounts", volumeIndexMap[volume.name], "type"], _VolumeConstants2.default.type.unknown)];
	
	        // Ephemeral Volumes have only name
	        if ((0, _keys2.default)(volume).length === 1 && volume.name != null) {
	          volumeTypeTransactions = [new _Transaction2.default(["volumeMounts", volumeIndexMap[volume.name], "type"], _VolumeConstants2.default.type.ephemeral)];
	        }
	
	        if (volume.host != null) {
	          volumeTypeTransactions = [new _Transaction2.default(["volumeMounts", volumeIndexMap[volume.name], "type"], _VolumeConstants2.default.type.host), new _Transaction2.default(["volumeMounts", volumeIndexMap[volume.name], "hostPath"], volume.host)];
	        }
	
	        return memo.concat(new _Transaction2.default(["volumeMounts"], volume, _TransactionTypes.ADD_ITEM), new _Transaction2.default(["volumeMounts", volumeIndexMap[volume.name], "name"], volume.name), volumeTypeTransactions);
	      }, []);
	
	      transactions = transactions.concat(volumeTransaction);
	    }
	
	    var containers = state.containers || [];
	    var containerVolumesTransactions = containers.reduce(transformContainers, []).reduce(function (memo, _ref2) {
	      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	          containerIndex = _ref3[0],
	          volumeMount = _ref3[1];
	
	      var name = volumeMount.name,
	          mountPath = volumeMount.mountPath;
	
	
	      if (volumeIndexMap[name] == null) {
	        volumeIndexMap[name] = volumes.push(name) - 1;
	        memo = memo.concat(new _Transaction2.default(["volumeMounts"], volumeMount, _TransactionTypes.ADD_ITEM), new _Transaction2.default(["volumeMounts", volumeIndexMap[name], "name"], name));
	      }
	
	      memo.push(new _Transaction2.default(["volumeMounts", volumeIndexMap[name], "mountPath", containerIndex], mountPath));
	
	      return memo;
	    }, []);
	
	    return transactions.concat(containerVolumesTransactions);
	  },
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref4 = arguments[1];
	    var type = _ref4.type,
	        path = _ref4.path,
	        value = _ref4.value;
	
	    var _path2 = (0, _slicedToArray3.default)(path, 4),
	        base = _path2[0],
	        index = _path2[1],
	        name = _path2[2],
	        secondIndex = _path2[3];
	
	    var newState = state.slice();
	
	    if (base === "containers") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          newState = newState.map(function (volumeMount) {
	            volumeMount.mountPath.push("");
	
	            return volumeMount;
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          newState = newState.map(function (volumeMount) {
	            volumeMount.mountPath = volumeMount.mountPath.filter(function (item, index) {
	              return index !== value;
	            });
	
	            return volumeMount;
	          });
	          break;
	      }
	    }
	
	    if (base !== "volumeMounts") {
	      return newState;
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        newState.push({ mountPath: [] });
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState = newState.filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	    }
	
	    if (name === "type") {
	      newState[index].type = String(value);
	    }
	    if (name === "hostPath") {
	      newState[index].hostPath = String(value);
	    }
	    if (name === "name") {
	      newState[index].name = String(value);
	    }
	    if (name === "mountPath") {
	      newState[index].mountPath[secondIndex] = String(value);
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1756 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  type: {
	    host: "HOST",
	    ephemeral: "EPHEMERAL",
	    unknown: "UNKNOWN"
	  },
	  mode: {
	    rw: "RW",
	    ro: "RO"
	  }
	};

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getForcePullSection = function getForcePullSection(data, path) {
	  var imageForcePullPath = path + ".image.forcePull";
	  var imageForcePull = (0, _Util.findNestedPropertyInObject)(data, imageForcePullPath);
	
	  return _react2.default.createElement(
	    _FieldLabel2.default,
	    null,
	    _react2.default.createElement(_FieldInput2.default, {
	      checked: imageForcePull,
	      name: imageForcePullPath,
	      type: "checkbox",
	      value: imageForcePull
	    }),
	    "Force Pull Image On Launch",
	    _react2.default.createElement(
	      _FieldHelp2.default,
	      null,
	      "Force Docker to pull the image before launching each instance."
	    )
	  );
	};
	
	var MultiContainerFormAdvancedSection = function MultiContainerFormAdvancedSection(_ref) {
	  var data = _ref.data,
	      path = _ref.path;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h3",
	      { className: "short-top short-bottom" },
	      "Advanced Settings"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Advanced settings of the container."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      getForcePullSection(data, path)
	    )
	  );
	};
	
	MultiContainerFormAdvancedSection.defaultProps = {
	  data: {},
	  path: "container"
	};
	
	MultiContainerFormAdvancedSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  path: _react2.default.PropTypes.string
	};
	
	module.exports = MultiContainerFormAdvancedSection;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Util = __webpack_require__(982);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldHelp = __webpack_require__(1685);
	
	var _FieldHelp2 = _interopRequireDefault(_FieldHelp);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _VirtualNetworksStore = __webpack_require__(1530);
	
	var _VirtualNetworksStore2 = _interopRequireDefault(_VirtualNetworksStore);
	
	var _SingleContainerPortDefinitionsReducer = __webpack_require__(1759);
	
	var _SingleContainerPortDefinitionsReducer2 = _interopRequireDefault(_SingleContainerPortDefinitionsReducer);
	
	var _SingleContainerPortMappingsReducer = __webpack_require__(1760);
	
	var _SingleContainerPortMappingsReducer2 = _interopRequireDefault(_SingleContainerPortMappingsReducer);
	
	var _Networks = __webpack_require__(1761);
	
	var _ServiceConfigUtil = __webpack_require__(1752);
	
	var _ServiceConfigUtil2 = _interopRequireDefault(_ServiceConfigUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Networking$type = _Networking2.default.type,
	    BRIDGE = _Networking$type.BRIDGE,
	    HOST = _Networking$type.HOST,
	    CONTAINER = _Networking$type.CONTAINER;
	
	
	var METHODS_TO_BIND = ["onVirtualNetworksStoreSuccess"];
	
	var NetworkingFormSection = function (_mixin) {
	  (0, _inherits3.default)(NetworkingFormSection, _mixin);
	
	  function NetworkingFormSection() {
	    (0, _classCallCheck3.default)(this, NetworkingFormSection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (NetworkingFormSection.__proto__ || (0, _getPrototypeOf2.default)(NetworkingFormSection)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    _this.store_listeners = [{
	      name: "virtualNetworks",
	      events: ["success"],
	      suppressUpdate: true
	    }];
	    return _this;
	  }
	
	  (0, _createClass3.default)(NetworkingFormSection, [{
	    key: "onVirtualNetworksStoreSuccess",
	    value: function onVirtualNetworksStoreSuccess() {
	      this.forceUpdate();
	    }
	  }, {
	    key: "isHostNetwork",
	    value: function isHostNetwork() {
	      var networkType = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.mode") || HOST;
	
	      return networkType === HOST;
	    }
	  }, {
	    key: "getHostPortFields",
	    value: function getHostPortFields(portDefinition, index) {
	      var hostPortValue = portDefinition.hostPort;
	      var _props = this.props,
	          errors = _props.errors,
	          portsAutoAssign = _props.data.portsAutoAssign;
	
	      var hostPortError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".port") || (0, _Util.findNestedPropertyInObject)(errors, "container.portMappings." + index + ".hostPort");
	      var isInputDisabled = this.isHostNetwork() ? portsAutoAssign : portDefinition.automaticPort;
	
	      var placeholder = void 0;
	
	      if (isInputDisabled) {
	        placeholder = "$PORT" + index;
	        hostPortValue = "";
	      }
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "This host port will be accessible as an environment variable called '$PORT" + index + "'. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/ports.html",
	            target: "_blank"
	          },
	          "More information"
	        )
	      );
	
	      return [_react2.default.createElement(
	        _FormGroup2.default,
	        {
	          className: "column-3",
	          key: "host-port",
	          showError: Boolean(hostPortError)
	        },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Host Port"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: tooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_FieldInput2.default, {
	          disabled: isInputDisabled,
	          placeholder: placeholder,
	          min: "0",
	          name: "portDefinitions." + index + ".hostPort",
	          type: "number",
	          value: hostPortValue
	        }),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          hostPortError
	        )
	      ), !this.isHostNetwork() && this.getNonHostNetworkPortsAutoAssignSection(portDefinition, index)];
	    }
	  }, {
	    key: "getLoadBalancedServiceAddressField",
	    value: function getLoadBalancedServiceAddressField(endpoint, index) {
	      var errors = this.props.errors;
	      var loadBalanced = endpoint.loadBalanced;
	
	      var vipPortError = null;
	      var loadBalancedError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".labels") || (0, _Util.findNestedPropertyInObject)(errors, "container.portMappings." + index + ".labels");
	
	      if ((0, _Util.isObject)(loadBalancedError)) {
	        vipPortError = loadBalancedError["VIP_" + index];
	        loadBalancedError = null;
	      }
	
	      var loadBalancerDocsURI = _MetadataStore2.default.buildDocsURI("/usage/service-discovery/load-balancing-vips");
	      var loadBalancerTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Load balance the service internally (layer 4), and create a service\n        address. For external (layer 7) load balancing, create an external\n        load balancer and attach this service. ",
	        _react2.default.createElement(
	          "a",
	          { href: loadBalancerDocsURI, target: "_blank" },
	          "More Information"
	        )
	      );
	
	      return [_react2.default.createElement(
	        _FormRow2.default,
	        { key: "lb-enable" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          {
	            className: "column-12",
	            showError: Boolean(vipPortError || loadBalancedError)
	          },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              checked: loadBalanced,
	              name: "portDefinitions." + index + ".loadBalanced",
	              type: "checkbox"
	            }),
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Enable Load Balanced Service Address"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: loadBalancerTooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapperClassName: "tooltip-wrapper text-align-center",
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          )
	        )
	      ), loadBalanced && this.getLoadBalancedPortField(endpoint, index)];
	    }
	  }, {
	    key: "getLoadBalancedPortField",
	    value: function getLoadBalancedPortField(endpoint, index) {
	      var _props2 = this.props,
	          errors = _props2.errors,
	          _props2$data = _props2.data,
	          id = _props2$data.id,
	          portsAutoAssign = _props2$data.portsAutoAssign;
	      var hostPort = endpoint.hostPort,
	          containerPort = endpoint.containerPort,
	          vip = endpoint.vip,
	          vipPort = endpoint.vipPort;
	
	      var defaultVipPort = this.isHostNetwork() ? hostPort : containerPort;
	
	      // clear placeholder when HOST network portsAutoAssign is true
	      var placeholder = this.isHostNetwork() && portsAutoAssign ? "" : defaultVipPort;
	
	      var vipPortError = null;
	      var loadBalancedError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".labels") || (0, _Util.findNestedPropertyInObject)(errors, "container.docker.portMappings." + index + ".labels");
	
	      var tooltipContent = "This port will be used to load balance this service address internally";
	      if ((0, _Util.isObject)(loadBalancedError)) {
	        vipPortError = loadBalancedError["VIP_" + index];
	        loadBalancedError = null;
	      }
	
	      var address = vip;
	
	      var port = "";
	      if (!portsAutoAssign && !_ValidatorUtil2.default.isEmpty(hostPort)) {
	        port = hostPort;
	      }
	      if (!_ValidatorUtil2.default.isEmpty(containerPort)) {
	        port = containerPort;
	      }
	      if (!_ValidatorUtil2.default.isEmpty(vipPort)) {
	        port = vipPort;
	      }
	
	      if (address == null) {
	        address = id + ":" + port;
	      }
	
	      var vipMatch = address.match(/(.+):\d+/);
	      if (vipMatch) {
	        address = vipMatch[1] + ":" + port;
	      }
	
	      var hostName = null;
	      if (!vipPortError) {
	        hostName = _ServiceConfigUtil2.default.buildHostNameFromVipLabel(address, port);
	      }
	
	      var helpText = _react2.default.createElement(
	        _FieldHelp2.default,
	        null,
	        "Load balance this service internally at ",
	        hostName
	      );
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        { key: "lb-port" },
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-12" },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Load Balanced Port"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: tooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-3",
	                key: "vip-port",
	                showError: Boolean(vipPortError)
	              },
	              _react2.default.createElement(
	                _FieldAutofocus2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  min: "1",
	                  placeholder: placeholder,
	                  name: "portDefinitions." + index + ".vipPort",
	                  type: "number",
	                  value: vipPort
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-12", showError: Boolean(vipPortError) },
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                vipPortError
	              ),
	              !vipPortError && helpText
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getProtocolField",
	    value: function getProtocolField(portDefinition, index) {
	      var errors = this.props.errors;
	
	      var protocolError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".protocol") || (0, _Util.findNestedPropertyInObject)(errors, "container.portMappings." + index + ".protocol");
	
	      var assignHelpText = _react2.default.createElement(
	        "span",
	        null,
	        "Most services will use TCP. ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://mesosphere.github.io/marathon/docs/ports.html" },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-3", showError: Boolean(protocolError) },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Protocol"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: assignHelpText,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-auto" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { matchInputHeight: true },
	              _react2.default.createElement(_FieldInput2.default, {
	                checked: portDefinition.protocol.udp,
	                name: "portDefinitions." + index + ".protocol.udp",
	                type: "checkbox"
	              }),
	              "UDP"
	            )
	          ),
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-auto" },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              { matchInputHeight: true },
	              _react2.default.createElement(_FieldInput2.default, {
	                checked: portDefinition.protocol.tcp,
	                name: "portDefinitions." + index + ".protocol.tcp",
	                type: "checkbox"
	              }),
	              "TCP"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          protocolError
	        )
	      );
	    }
	  }, {
	    key: "getContainerPortField",
	    value: function getContainerPortField(portDefinition, network, errors, index) {
	      if (network == null || network === HOST) {
	        return null;
	      }
	
	      var containerPortError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".containerPort") || (0, _Util.findNestedPropertyInObject)(errors, "container.portMappings." + index + ".containerPort");
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-3", showError: Boolean(containerPortError) },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          "Container Port"
	        ),
	        _react2.default.createElement(
	          _FieldAutofocus2.default,
	          null,
	          _react2.default.createElement(_FieldInput2.default, {
	            min: "0",
	            name: "portDefinitions." + index + ".containerPort",
	            type: "number",
	            value: portDefinition.containerPort
	          })
	        ),
	        _react2.default.createElement(
	          _FieldError2.default,
	          null,
	          containerPortError
	        )
	      );
	    }
	
	    /**
	     * This field is actually not present in the appConfig, but is generated by
	     * the reducers, so we empower the user to show and hide fields
	     * @param  {Object} portDefinition, the portDefinition to turn port mapping on
	     * and off ofr
	     * @param  {String} network, type of network
	     * @param  {Number} index, position of port definition in the
	     * portDefinitions array
	     * @return {Component} Checkbox for turning port mapping on and off
	     */
	
	  }, {
	    key: "getPortMappingCheckbox",
	    value: function getPortMappingCheckbox(portDefinition, network, index) {
	      if ([BRIDGE, HOST].includes(network)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-3" },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Port Mapping"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          { matchInputHeight: true },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: portDefinition.portMapping,
	            name: "portDefinitions." + index + ".portMapping",
	            type: "checkbox"
	          }),
	          "Enabled"
	        )
	      );
	    }
	  }, {
	    key: "getServiceEndpoints",
	    value: function getServiceEndpoints() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          errors = _props3.errors,
	          networks = _props3.data.networks;
	
	      var networkType = (0, _Util.findNestedPropertyInObject)(networks, "0.mode") || HOST;
	
	      var endpoints = this.isHostNetwork() ? this.props.data.portDefinitions : this.props.data.portMappings;
	
	      return endpoints.map(function (endpoint, index) {
	        var portMappingFields = null;
	
	        var nameError = (0, _Util.findNestedPropertyInObject)(errors, "portDefinitions." + index + ".name") || (0, _Util.findNestedPropertyInObject)(errors, "container.portMappings." + index + ".name");
	
	        if (endpoint.portMapping || [BRIDGE, HOST].includes(networkType)) {
	          portMappingFields = _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _this2.getHostPortFields(endpoint, index),
	            _this2.getProtocolField(endpoint, index)
	          );
	        }
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: index,
	            onRemove: _this2.props.onRemoveItem.bind(_this2, {
	              value: index,
	              path: "portDefinitions"
	            })
	          },
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _this2.getContainerPortField(endpoint, networkType, errors, index),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-6", showError: Boolean(nameError) },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Service Endpoint Name"
	                  ),
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    null,
	                    _react2.default.createElement(
	                      _reactjsComponents.Tooltip,
	                      {
	                        content: "Name your endpoint to search for it by a meaningful name, rather than the port number.",
	                        interactive: true,
	                        maxWidth: 300,
	                        wrapperClassName: "tooltip-wrapper text-align-center",
	                        wrapText: true
	                      },
	                      _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldAutofocus2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  name: "portDefinitions." + index + ".name",
	                  type: "text",
	                  value: endpoint.name
	                })
	              ),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                nameError
	              )
	            ),
	            _this2.getPortMappingCheckbox(endpoint, networkType, index)
	          ),
	          portMappingFields,
	          _this2.getLoadBalancedServiceAddressField(endpoint, index)
	        );
	      });
	    }
	  }, {
	    key: "getVirtualNetworks",
	    value: function getVirtualNetworks() {
	      return _VirtualNetworksStore2.default.getOverlays().mapItems(function (overlay) {
	        var name = overlay.getName();
	
	        return {
	          text: "Virtual Network: " + name,
	          value: CONTAINER + "." + name
	        };
	      }).getItems().map(function (virtualNetwork, index) {
	        return _react2.default.createElement(
	          "option",
	          { key: index, value: virtualNetwork.value },
	          virtualNetwork.text
	        );
	      });
	    }
	  }, {
	    key: "getTypeSelections",
	    value: function getTypeSelections() {
	      var networkMode = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.mode");
	      var networkName = (0, _Util.findNestedPropertyInObject)(this.props.data, "networks.0.name");
	      var selectedValue = networkName ? networkMode + "." + networkName : networkMode;
	
	      var selections = _react2.default.createElement(
	        _FieldSelect2.default,
	        { name: "networks.0.network", value: selectedValue },
	        _react2.default.createElement(
	          "option",
	          { value: HOST },
	          "Host"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: BRIDGE },
	          "Bridge"
	        ),
	        this.getVirtualNetworks()
	      );
	
	      return selections;
	    }
	  }, {
	    key: "getServiceEndpointsSection",
	    value: function getServiceEndpointsSection() {
	      var serviceEndpointsDocsURI = _MetadataStore2.default.buildDocsURI("/usage/service-discovery/load-balancing-vips/virtual-ip-addresses/");
	      var serviceEndpointsTooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Service endpoints map traffic from a single VIP to multiple IP addresses and ports. ",
	        _react2.default.createElement(
	          "a",
	          { href: serviceEndpointsDocsURI, target: "_blank" },
	          "More Information"
	        )
	      );
	      var heading = _react2.default.createElement(
	        _FormGroupHeading2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroupHeadingContent2.default,
	          { primary: true },
	          "Service Endpoints"
	        ),
	        _react2.default.createElement(
	          _FormGroupHeadingContent2.default,
	          null,
	          _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            {
	              content: serviceEndpointsTooltipContent,
	              interactive: true,
	              maxWidth: 300,
	              wrapperClassName: "tooltip-wrapper text-align-center",
	              wrapText: true
	            },
	            _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom", key: "service-endpoints-header" },
	          heading
	        ),
	        _react2.default.createElement(
	          "p",
	          { key: "service-endpoints-description" },
	          "DC/OS can automatically generate a Service Address to connect to each of your load balanced endpoints."
	        ),
	        this.isHostNetwork() && this.getHostNetworkPortsAutoAssignSection(),
	        this.getServiceEndpoints(),
	        _react2.default.createElement(
	          _FormRow2.default,
	          { key: "service-endpoints-add-button" },
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: "portDefinitions"
	                })
	              },
	              "Add Service Endpoint"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getHostNetworkPortsAutoAssignSection",
	    value: function getHostNetworkPortsAutoAssignSection() {
	      var portsAutoAssignValue = this.props.data.portsAutoAssign;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          { matchInputHeight: true },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: portsAutoAssignValue,
	            name: "portsAutoAssign",
	            type: "checkbox"
	          }),
	          "Assign Host Ports Automatically"
	        )
	      );
	    }
	  }, {
	    key: "getNonHostNetworkPortsAutoAssignSection",
	    value: function getNonHostNetworkPortsAutoAssignSection(endpoint, index) {
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        { className: "column-auto flush-left", key: "assign-automatically" },
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          null,
	          "\xA0"
	        ),
	        _react2.default.createElement(
	          _FieldLabel2.default,
	          { matchInputHeight: true },
	          _react2.default.createElement(_FieldInput2.default, {
	            checked: endpoint.automaticPort,
	            name: "portDefinitions." + index + ".automaticPort",
	            type: "checkbox"
	          }),
	          "Assign Automatically"
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var networkError = (0, _Util.findNestedPropertyInObject)(this.props.errors, "networks");
	
	      var networks = this.props.data.networks;
	
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "Choose container/bridge, host, or container networking. Refer to the ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://mesosphere.github.io/marathon/docs/ports.html",
	            target: "_blank"
	          },
	          "ports documentation"
	        ),
	        " for more information."
	      );
	
	      if (networks != null && networks.length > 1) {
	        networks = networks.map(function (_ref) {
	          var mode = _ref.mode,
	              name = _ref.name;
	
	          return {
	            name: name,
	            mode: _Networking2.default.internalToJson[mode]
	          };
	        });
	
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h2",
	            { className: "flush-top short-bottom" },
	            "Networking"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "This service has advanced networking configuration, which we" + " don't currently support in the UI. Please use the JSON editor" + " to make changes."
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            (0, _stringify2.default)(networks, null, 2)
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          "Networking"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Configure the networking for your service."
	        ),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-6", showError: Boolean(networkError) },
	            _react2.default.createElement(
	              _FieldLabel2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeading2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  { primary: true },
	                  "Network Type"
	                ),
	                _react2.default.createElement(
	                  _FormGroupHeadingContent2.default,
	                  null,
	                  _react2.default.createElement(
	                    _reactjsComponents.Tooltip,
	                    {
	                      content: tooltipContent,
	                      interactive: true,
	                      maxWidth: 300,
	                      wrapText: true
	                    },
	                    _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                  )
	                )
	              )
	            ),
	            this.getTypeSelections(),
	            _react2.default.createElement(
	              _FieldError2.default,
	              null,
	              networkError
	            )
	          )
	        ),
	        this.getServiceEndpointsSection()
	      );
	    }
	  }]);
	  return NetworkingFormSection;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	NetworkingFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	NetworkingFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	NetworkingFormSection.configReducers = {
	  networks: _Networks.FormReducer,
	  portDefinitions: _SingleContainerPortDefinitionsReducer2.default,
	  portMappings: _SingleContainerPortMappingsReducer2.default,
	  portsAutoAssign: function portsAutoAssign(state, _ref2) {
	    var type = _ref2.type,
	        _ref2$path = _ref2.path,
	        path = _ref2$path === undefined ? [] : _ref2$path,
	        value = _ref2.value;
	
	    var joinedPath = path.join(".");
	
	    if (type === _TransactionTypes.SET && joinedPath === "portsAutoAssign") {
	      return value;
	    }
	
	    return state;
	  }
	};
	
	module.exports = NetworkingFormSection;

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = ["hostPort", "labels", "loadBalanced", "name", "servicePort", "vip", "vipPort"];
	
	/**
	 * @param {Object[]} state
	 * @param {Object} action
	 * @param {(ADD_ITEM|REMOVE_ITEM|SET)} action.type - action to perform
	 * @param {String[]} action.path - location of value
	 * @param {*} action.value - value to perform action with
	 * @return {Object[]} new portDefinitions with action performed on it
	 */
	function SingleContainerPortDefinitionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var type = action.type,
	      _action$path = action.path,
	      path = _action$path === undefined ? [] : _action$path,
	      value = action.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 4),
	      base = _path[0],
	      index = _path[1],
	      field = _path[2],
	      subfield = _path[3];
	
	  var joinedPath = path.join(".");
	
	  if (base === "portDefinitions") {
	    if (joinedPath === "portDefinitions") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          var definition = {
	            hostPort: null,
	            labels: null,
	            loadBalanced: false,
	            name: null,
	            protocol: {
	              tcp: false,
	              udp: false
	            },
	            servicePort: null,
	            vip: null,
	            vipPort: null
	          };
	          var defaults = { protocol: { tcp: true } };
	
	          state.push((0, _assign2.default)(definition, value || defaults));
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          state = state.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	    }
	
	    if (index != null && type === _TransactionTypes.SET) {
	      if (FIELDS.includes(field)) {
	        state[index][field] = value;
	      }
	
	      if (field === "protocol" && _PortDefinitionConstants.PROTOCOLS.includes(subfield)) {
	        if (state[index].protocol == null) {
	          state[index].protocol = {};
	        }
	
	        state[index].protocol[subfield] = value;
	      }
	    }
	  }
	
	  return state;
	}
	
	module.exports = SingleContainerPortDefinitionsReducer;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = ["automaticPort", "containerPort", "hostPort", "labels", "loadBalanced", "portMapping", "name", "servicePort", "vip", "vipPort"];
	
	/**
	 * @param {Object[]} state
	 * @param {Object} action
	 * @param {(ADD_ITEM|REMOVE_ITEM|SET)} action.type - action to perform
	 * @param {String[]} action.path - location of value
	 * @param {*} action.value - to perform action with
	 * @return {Object[]} new portDefinitions with action performed on it
	 */
	function SingleContainerPortMappingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var type = action.type,
	      _action$path = action.path,
	      path = _action$path === undefined ? [] : _action$path,
	      value = action.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 4),
	      base = _path[0],
	      index = _path[1],
	      field = _path[2],
	      subfield = _path[3];
	
	  var joinedPath = path.join(".");
	
	  if (base === "portDefinitions") {
	    if (joinedPath === "portDefinitions") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          state.push(value || {
	            automaticPort: true,
	            containerPort: null,
	            hostPort: null,
	            labels: null,
	            loadBalanced: false,
	            name: null,
	            portMapping: false,
	            protocol: {
	              tcp: true,
	              udp: false
	            },
	            servicePort: null,
	            vip: null,
	            vipPort: null
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          state = state.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	    }
	
	    if (index != null && type === _TransactionTypes.SET) {
	      if (FIELDS.includes(field)) {
	        state[index][field] = value;
	      }
	
	      if (field === "protocol" && _PortDefinitionConstants.PROTOCOLS.includes(subfield)) {
	        state[index].protocol[subfield] = value;
	      }
	
	      // If port is assigned automatically, remove hostPort
	      if (state[index].automaticPort) {
	        state[index].hostPort = 0;
	      }
	    }
	  }
	
	  return state;
	}
	
	module.exports = SingleContainerPortMappingsReducer;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  FormReducer: function FormReducer(state, _ref) {
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.networks == null) {
	      this.networks = [];
	    }
	
	    var _path = (0, _slicedToArray3.default)(path, 3),
	        base = _path[0],
	        index = _path[1],
	        field = _path[2];
	
	    if (base === "networks") {
	      if (type === _TransactionTypes.ADD_ITEM) {
	        this.networks.push(value || {});
	      }
	      if (type === _TransactionTypes.REMOVE_ITEM) {
	        this.networks = this.networks.filter(function (item, index) {
	          return index !== value;
	        });
	      }
	      if (type === _TransactionTypes.SET && field === "network") {
	        var _value$split = value.split("."),
	            _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	            mode = _value$split2[0],
	            name = _value$split2[1];
	
	        this.networks[index] = {};
	        this.networks[index].mode = mode;
	        this.networks[index].name = name;
	      }
	      if (type === _TransactionTypes.SET && field === "name") {
	        this.networks[index].name = value;
	      }
	      if (type === _TransactionTypes.SET && field === "mode") {
	        this.networks[index].mode = value;
	      }
	    }
	
	    return this.networks;
	  }
	};

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _DefaultErrorMessages = __webpack_require__(1763);
	
	var _DefaultErrorMessages2 = _interopRequireDefault(_DefaultErrorMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceErrorMessages = [{
	  path: /^id$/,
	  type: "PROP_IS_MISSING",
	  message: "Must be defined"
	}, {
	  path: /^id$/,
	  type: "ALREADY_EXISTS",
	  message: "Already exists"
	}, {
	  path: /^id$/,
	  type: "STRING_PATTERN",
	  message: "May only contain digits (0-9), dashes (-), " + "dots (.),lowercase letters (a-z), and slashes (/) e.g. /group/my-service"
	}, {
	  path: /.*/,
	  type: "SERVICE_DEPLOYING",
	  message: "The service is currently locked by one or more deployments. " + "Press again to force this operation."
	}, {
	  path: /^container\.docker\.portMappings\.[0-9]+\.name$/,
	  type: "STRING_PATTERN",
	  message: "May only contain digits (0-9), dashes (-) and " + "lowercase letters (a-z) e.g. web-server"
	}, {
	  path: /^portDefinitions\.[0-9]+\.name$/,
	  type: "STRING_PATTERN",
	  message: "May only contain digits (0-9), dashes (-) and " + "lowercase letters (a-z) e.g. web-server"
	}].concat(_DefaultErrorMessages2.default);
	
	module.exports = ServiceErrorMessages;

/***/ },
/* 1763 */
/***/ function(module, exports) {

	"use strict";
	
	var DefaultErrorMessages = [
	//
	// The following rule will match every message path, behaving
	// like the default sink if a path is not found.
	//
	// Remember to concat these error messages when you are composing
	// your own at a higher level. For example:
	//
	// const PathCustomizations = [
	//  {
	//    path: /^id$/,
	//    type: 'PROP_MISSING',
	//    message: 'Please specify an ID'
	//  }
	//  'id': {
	//    PROP_MISSING: 'Please specify an ID'
	//   },
	//  'container.[^.]+.id': {
	//    PROP_MISSING: 'Please specify an ID for this container'
	//   }
	// ].concat(DefaultErrorMessages);
	//
	
	//
	// NOTE: Every time you are about to write a description for the error
	//       message make sure that it sounds natural *both* on it's own
	//       (ex. 'Must be one of {{value}}') AND when prefixed with the
	//       expression 'The service' (ex. 'The service must be one of {{value}}')
	//
	
	//
	// [A] The following error constants are used by the RAML Validator Loader
	//
	
	{
	  path: /.*/,
	  type: "ENUM",
	  message: "Must be one of {{values}}"
	}, {
	  path: /.*/,
	  type: "ITEMS_MAX",
	  message: "Must contain at most {{value}} items in the array"
	}, {
	  path: /.*/,
	  type: "ITEMS_MIN",
	  message: "Must contain at least {{value}} items in the array"
	}, {
	  path: /.*/,
	  type: "ITEMS_UNIQUE",
	  message: "Must contain only unique items"
	}, {
	  path: /.*/,
	  type: "LENGTH_MAX",
	  message: "Must be at most {{value}} characters long"
	}, {
	  path: /.*/,
	  type: "LENGTH_MIN",
	  message: "Must be at least {{value}} characters long"
	}, {
	  path: /.*/,
	  type: "NUMBER_MAX",
	  message: "Must be smaller than or equal to {{value}}"
	}, {
	  path: /.*/,
	  type: "NUMBER_MIN",
	  message: "Must be bigger than or equal to {{value}}"
	}, {
	  path: /.*/,
	  type: "NUMBER_MULTIPLEOF",
	  message: "Must be multiple of {{value}}"
	}, {
	  path: /.*/,
	  type: "NUMBER_TYPE",
	  message: "Must be of type `{{type}}`"
	}, {
	  path: /.*/,
	  type: "PROPS_MAX",
	  message: "Must contain at most {{value}} properties"
	}, {
	  path: /.*/,
	  type: "PROPS_MIN",
	  message: "Must contain at least {{value}} properties"
	}, {
	  path: /.*/,
	  type: "PROP_ADDITIONAL_PROPS",
	  message: "Contains extraneous property `{{name}}`"
	}, {
	  path: /.*/,
	  type: "PROP_IS_MISSING",
	  message: "Must be defined"
	}, {
	  path: /.*/,
	  type: "PROP_MISSING",
	  message: "Must define property `{{name}}`"
	}, {
	  path: /.*/,
	  type: "PROP_MISSING_MATCH",
	  message: "Must contain a property that matches `{{pattern}}`"
	}, {
	  path: /.*/,
	  type: "STRING_PATTERN",
	  message: "Must match the pattern `{{pattern}}`"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_ARRAY",
	  message: "Must be an array"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_BOOLEAN",
	  message: "Must be a boolean value"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_DATETIME",
	  message: "Must be a date/time string"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_INTEGER",
	  message: "Must be an integer number"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_NULL",
	  message: "Must be null"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_NUMBER",
	  message: "Must be a number"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_OBJECT",
	  message: "Must be an object"
	}, {
	  path: /.*/,
	  type: "TYPE_NOT_STRING",
	  message: "Must be a string"
	},
	
	//
	// [B] The following error constants are generated by parsing the
	//     marathon error messages
	//
	
	{
	  path: /.*/,
	  type: "ALREADY_EXISTS",
	  message: "Already Exists"
	},
	
	//
	// [C] Custom Error Messages
	//
	
	/**
	 * Value of a certain shape
	 */
	{
	  path: /.*/,
	  type: "VALUE_SHAPE",
	  message: "Must be a certain shape: {{shape}}"
	}];
	
	module.exports = DefaultErrorMessages;

/***/ },
/* 1764 */
/***/ function(module, exports) {

	"use strict";
	
	var ServiceErrorPathMapping = [{
	  match: /^id$/,
	  name: "Service ID"
	}, {
	  match: /^instances$/,
	  name: "Instances"
	}, {
	  match: /^cpus$/,
	  name: "CPUs"
	}, {
	  match: /^mem$/,
	  name: "Memory"
	}, {
	  match: /^env\.\*$/,
	  name: "Environment variables"
	},
	
	//
	// Volumes
	//
	{
	  match: /^container\.volumes\.[0-9]+\.containerPath$/,
	  name: "Volume container path"
	}, {
	  match: /^container\.volumes\.[0-9]+\..*size$/,
	  name: "Volume size"
	}, {
	  match: /^container\.volumes\.[0-9]+\.hostPath$/,
	  name: "Volume host path"
	}, {
	  match: /^container\.volumes\.[0-9]+\.mode$/,
	  name: "Volume mode"
	},
	
	//
	// Networking (Host)
	//
	{
	  match: /^portDefinitions\.[0-9]+\.name$/,
	  name: "Service endpoint names"
	}, {
	  match: /^portDefinitions\.[0-9]+\.port$/,
	  name: "Service endpoint host ports"
	}, {
	  match: /^portDefinitions\.[0-9]+\.labels\.VIP_/,
	  name: "Service endpoint host ports"
	},
	
	//
	// Networking (Bridge)
	//
	{
	  match: /^container\.docker\.portMappings\.[0-9]+\.name/,
	  name: "Service endpoint names"
	}, {
	  match: /^container\.docker\.portMappings\.[0-9]+\.containerPort/,
	  name: "Service endpoint container ports"
	}, {
	  match: /^container\.docker\.portMappings\.[0-9]+\.hostPort/,
	  name: "Service endpoint host ports"
	},
	
	//
	// Health checks
	//
	{
	  match: /^healthChecks\.[0-9]+\.gracePeriodSeconds/,
	  name: "Health check grace periods"
	}, {
	  match: /^healthChecks\.[0-9]+\.intervalSeconds/,
	  name: "Health check intervals"
	}, {
	  match: /^healthChecks\.[0-9]+\.timeoutSeconds/,
	  name: "Health check timeouts"
	}, {
	  match: /^healthChecks\.[0-9]+\.maxConsecutiveFailures/,
	  name: "Health check max failures"
	}];
	
	module.exports = ServiceErrorPathMapping;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objektiv = __webpack_require__(1674);
	
	var _objektiv2 = _interopRequireDefault(_objektiv);
	
	var _AddButton = __webpack_require__(1708);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _FieldAutofocus = __webpack_require__(1710);
	
	var _FieldAutofocus2 = _interopRequireDefault(_FieldAutofocus);
	
	var _FieldError = __webpack_require__(1621);
	
	var _FieldError2 = _interopRequireDefault(_FieldError);
	
	var _FieldInput = __webpack_require__(1619);
	
	var _FieldInput2 = _interopRequireDefault(_FieldInput);
	
	var _FieldLabel = __webpack_require__(1652);
	
	var _FieldLabel2 = _interopRequireDefault(_FieldLabel);
	
	var _FieldSelect = __webpack_require__(1740);
	
	var _FieldSelect2 = _interopRequireDefault(_FieldSelect);
	
	var _Util = __webpack_require__(982);
	
	var _FormGroup = __webpack_require__(1620);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _FormGroupContainer = __webpack_require__(1741);
	
	var _FormGroupContainer2 = _interopRequireDefault(_FormGroupContainer);
	
	var _FormGroupHeading = __webpack_require__(1687);
	
	var _FormGroupHeading2 = _interopRequireDefault(_FormGroupHeading);
	
	var _FormGroupHeadingContent = __webpack_require__(1688);
	
	var _FormGroupHeadingContent2 = _interopRequireDefault(_FormGroupHeadingContent);
	
	var _FormRow = __webpack_require__(1622);
	
	var _FormRow2 = _interopRequireDefault(_FormRow);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _ExternalVolumes = __webpack_require__(1766);
	
	var _LocalVolumes = __webpack_require__(1767);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCKER = _ContainerConstants2.default.type.DOCKER;
	
	
	var errorsLens = _objektiv2.default.attr("container", {}).attr("volumes", []);
	
	var VolumesFormSection = function (_Component) {
	  (0, _inherits3.default)(VolumesFormSection, _Component);
	
	  function VolumesFormSection() {
	    (0, _classCallCheck3.default)(this, VolumesFormSection);
	    return (0, _possibleConstructorReturn3.default)(this, (VolumesFormSection.__proto__ || (0, _getPrototypeOf2.default)(VolumesFormSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(VolumesFormSection, [{
	    key: "getPersistentVolumeConfig",
	    value: function getPersistentVolumeConfig(volume, key) {
	      if (volume.type !== "PERSISTENT") {
	        return null;
	      }
	
	      var sizeError = errorsLens.at(key, {}).attr("persistent", {}).get(this.props.errors).size;
	      var containerPathError = errorsLens.at(key, {}).get(this.props.errors).containerPath;
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "The path where your application will read and write data. This must be a single-level path relative to the container. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: _MetadataStore2.default.buildDocsURI("/usage/storage/persistent-volume/"),
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-3", showError: Boolean(sizeError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            { className: "text-no-transform" },
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "SIZE (MiB)"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldAutofocus2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "localVolumes." + key + ".size",
	              type: "number",
	              value: volume.size
	            })
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            sizeError
	          )
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-6", showError: Boolean(containerPathError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Container Path"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: tooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FieldInput2.default, {
	            name: "localVolumes." + key + ".containerPath",
	            type: "text",
	            value: volume.containerPath
	          }),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            containerPathError
	          )
	        )
	      );
	    }
	  }, {
	    key: "getHostVolumeConfig",
	    value: function getHostVolumeConfig(volume, key) {
	      if (volume.type !== "HOST") {
	        return null;
	      }
	
	      var errors = errorsLens.at(key, {}).get(this.props.errors);
	      var hostPathError = errors.hostPath;
	      var containerPathError = errors.containerPath;
	      var modeError = errors.mode;
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "If you are using the Mesos containerizer, this must be a single-level path relative to the container. ",
	        _react2.default.createElement(
	          "a",
	          {
	            href: _MetadataStore2.default.buildDocsURI("/usage/storage/external-storage/"),
	            target: "_blank"
	          },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        _FormRow2.default,
	        null,
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-4", showError: Boolean(hostPathError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Host Path"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldAutofocus2.default,
	            null,
	            _react2.default.createElement(_FieldInput2.default, {
	              name: "localVolumes." + key + ".hostPath",
	              value: volume.hostPath
	            })
	          ),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            hostPathError
	          )
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-4", showError: Boolean(containerPathError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Container Path"
	              ),
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                null,
	                _react2.default.createElement(
	                  _reactjsComponents.Tooltip,
	                  {
	                    content: tooltipContent,
	                    interactive: true,
	                    maxWidth: 300,
	                    wrapText: true
	                  },
	                  _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_FieldInput2.default, {
	            name: "localVolumes." + key + ".containerPath",
	            type: "text",
	            value: volume.containerPath
	          }),
	          _react2.default.createElement(
	            _FieldError2.default,
	            null,
	            containerPathError
	          )
	        ),
	        _react2.default.createElement(
	          _FormGroup2.default,
	          { className: "column-4", showError: Boolean(modeError) },
	          _react2.default.createElement(
	            _FieldLabel2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeading2.default,
	              null,
	              _react2.default.createElement(
	                _FormGroupHeadingContent2.default,
	                { primary: true },
	                "Mode"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FieldSelect2.default,
	            { name: "localVolumes." + key + ".mode", value: volume.mode },
	            _react2.default.createElement(
	              "option",
	              { value: "RW" },
	              "Read and Write"
	            ),
	            _react2.default.createElement(
	              "option",
	              { value: "RO" },
	              "Read Only"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getLocalVolumesLines",
	    value: function getLocalVolumesLines(data) {
	      var _this2 = this;
	
	      return data.map(function (volume, key) {
	        var typeError = errorsLens.at(key, {}).get(_this2.props.errors).type;
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: key,
	            onRemove: _this2.props.onRemoveItem.bind(_this2, {
	              value: key,
	              path: "localVolumes"
	            })
	          },
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-6", showError: Boolean(typeError) },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Volume Type"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldSelect2.default,
	                {
	                  name: "localVolumes." + key + ".type",
	                  value: volume.type
	                },
	                _react2.default.createElement(
	                  "option",
	                  null,
	                  "Select..."
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "HOST" },
	                  "Host Volume"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "PERSISTENT" },
	                  "Persistent Volume"
	                )
	              )
	            )
	          ),
	          _this2.getPersistentVolumeConfig(volume, key),
	          _this2.getHostVolumeConfig(volume, key)
	        );
	      });
	    }
	
	    /**
	     * getExternalVolumesLines
	     *
	     * @param  {Object} data
	     * @param  {Number} offset as we have two independent sections that are 0
	     *                  based we need to add an offset to the second one
	     * @return {Array} elements
	     */
	
	  }, {
	    key: "getExternalVolumesLines",
	    value: function getExternalVolumesLines(data, offset) {
	      var _this3 = this;
	
	      return data.map(function (volume, key) {
	        var nameError = errorsLens.at(key + offset, {}).attr("external", {}).get(_this3.props.errors).name;
	
	        var sizeError = errorsLens.at(key, {}).attr("external", {}).get(_this3.props.errors).size;
	
	        var containerPathError = errorsLens.at(key + offset, {}).get(_this3.props.errors).containerPath;
	
	        var runtimeType = (0, _Util.findNestedPropertyInObject)(_this3.props.data, "container.type");
	
	        var sizeField = _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          {
	            content: "Docker Runtime only supports the default size for implicit volumes, please select Universal Container Runtime (UCR) if you want to modify the size.",
	            width: 300,
	            wrapperClassName: "tooltip-wrapper tooltip-block-wrapper text-align-center",
	            wrapText: true
	          },
	          _react2.default.createElement(_FieldInput2.default, {
	            name: "externalVolumes." + key + ".size",
	            type: "number",
	            disabled: true,
	            value: ""
	          })
	        );
	
	        if (runtimeType !== DOCKER) {
	          sizeField = _react2.default.createElement(_FieldInput2.default, {
	            name: "externalVolumes." + key + ".size",
	            type: "number",
	            value: volume.size
	          });
	        }
	
	        return _react2.default.createElement(
	          _FormGroupContainer2.default,
	          {
	            key: key,
	            onRemove: _this3.props.onRemoveItem.bind(_this3, {
	              value: key,
	              path: "externalVolumes"
	            })
	          },
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-6", showError: Boolean(nameError) },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Name"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _FieldAutofocus2.default,
	                null,
	                _react2.default.createElement(_FieldInput2.default, {
	                  name: "externalVolumes." + key + ".name",
	                  type: "text",
	                  value: volume.name
	                })
	              ),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                nameError
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _FormRow2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroup2.default,
	              { className: "column-3", showError: Boolean(sizeError) },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                { className: "text-no-transform" },
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "SIZE (GiB)"
	                  )
	                )
	              ),
	              sizeField,
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                sizeError
	              )
	            ),
	            _react2.default.createElement(
	              _FormGroup2.default,
	              {
	                className: "column-9",
	                showError: Boolean(containerPathError)
	              },
	              _react2.default.createElement(
	                _FieldLabel2.default,
	                null,
	                _react2.default.createElement(
	                  _FormGroupHeading2.default,
	                  null,
	                  _react2.default.createElement(
	                    _FormGroupHeadingContent2.default,
	                    { primary: true },
	                    "Container Path"
	                  )
	                )
	              ),
	              _react2.default.createElement(_FieldInput2.default, {
	                name: "externalVolumes." + key + ".containerPath",
	                type: "text",
	                value: volume.containerPath
	              }),
	              _react2.default.createElement(
	                _FieldError2.default,
	                null,
	                containerPathError
	              )
	            )
	          )
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var data = this.props.data;
	
	
	      var tooltipContent = _react2.default.createElement(
	        "span",
	        null,
	        "DC/OS offers several storage options. ",
	        _react2.default.createElement(
	          "a",
	          { href: _MetadataStore2.default.buildDocsURI("/usage/storage/"), target: "_blank" },
	          "More information"
	        ),
	        "."
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          { className: "flush-top short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Volumes"
	            ),
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              null,
	              _react2.default.createElement(
	                _reactjsComponents.Tooltip,
	                {
	                  content: tooltipContent,
	                  interactive: true,
	                  maxWidth: 300,
	                  wrapText: true
	                },
	                _react2.default.createElement(_Icon2.default, { color: "grey", id: "circle-question", size: "mini" })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Create a stateful service by configuring a persistent volume. Persistent volumes enable instances to be restarted without data loss."
	        ),
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "Local Volumes"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Choose a local persistent volume if you need quick access to stored data. ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/usage/storage/persistent-volume/"),
	              target: "_blank"
	            },
	            "More information"
	          ),
	          "."
	        ),
	        this.getLocalVolumesLines(data.localVolumes),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _AddButton2.default,
	            {
	              onClick: this.props.onAddItem.bind(this, {
	                path: "localVolumes"
	              })
	            },
	            "Add Local Volume"
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          { className: "short-bottom" },
	          _react2.default.createElement(
	            _FormGroupHeading2.default,
	            null,
	            _react2.default.createElement(
	              _FormGroupHeadingContent2.default,
	              { primary: true },
	              "External Volumes"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Choose an external persistent volume if fault-tolerance is crucial for your service. ",
	          _react2.default.createElement(
	            "a",
	            {
	              href: _MetadataStore2.default.buildDocsURI("/usage/storage/external-storage/"),
	              target: "_blank"
	            },
	            "More information"
	          ),
	          "."
	        ),
	        this.getExternalVolumesLines(data.externalVolumes, data.localVolumes.length),
	        _react2.default.createElement(
	          _FormRow2.default,
	          null,
	          _react2.default.createElement(
	            _FormGroup2.default,
	            { className: "column-12" },
	            _react2.default.createElement(
	              _AddButton2.default,
	              {
	                onClick: this.props.onAddItem.bind(this, {
	                  path: "externalVolumes"
	                })
	              },
	              "Add External Volume"
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return VolumesFormSection;
	}(_react.Component);
	
	VolumesFormSection.defaultProps = {
	  data: {},
	  errors: {},
	  onAddItem: function onAddItem() {},
	  onRemoveItem: function onRemoveItem() {}
	};
	
	VolumesFormSection.propTypes = {
	  data: _react2.default.PropTypes.object,
	  errors: _react2.default.PropTypes.object,
	  onAddItem: _react2.default.PropTypes.func,
	  onRemoveItem: _react2.default.PropTypes.func
	};
	
	VolumesFormSection.configReducers = {
	  externalVolumes: _ExternalVolumes.FormReducer,
	  localVolumes: _LocalVolumes.FormReducer
	};
	
	VolumesFormSection.validationReducers = {
	  localVolumes: function localVolumes() {
	    return [];
	  },
	  externalVolumes: function externalVolumes() {
	    return [];
	  }
	};
	
	module.exports = VolumesFormSection;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	
	    if (path[0] === "externalVolumes") {
	      if (joinedPath === "externalVolumes") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            var defaultVolume = {
	              containerPath: null,
	              name: null,
	              provider: "dvdi",
	              options: {
	                "dvdi/driver": "rexray"
	              },
	              mode: "RW"
	            };
	            state.push((0, _assign2.default)({}, value || defaultVolume));
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            state = state.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return state;
	      }
	
	      var index = path[1];
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".provider" === joinedPath) {
	        state[index].provider = String(value);
	      }
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".options" === joinedPath) {
	        // Options is of type object, so we are not processing it
	        state[index].options = value;
	      }
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".name" === joinedPath) {
	        state[index].name = String(value);
	      }
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".containerPath" === joinedPath) {
	        state[index].containerPath = String(value);
	      }
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".size" === joinedPath) {
	        state[index].size = (0, _ReducerUtil.parseIntValue)(value);
	      }
	      if (type === _TransactionTypes.SET && "externalVolumes." + index + ".mode" === joinedPath) {
	        state[index].mode = String(value);
	      }
	    }
	
	    return state;
	  }
	};

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("localVolumes") !== -1) {
	      if (joinedPath === "localVolumes") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            var defaultVolume = {
	              containerPath: null,
	              size: null,
	              mode: "RW"
	            };
	            state.push((0, _assign2.default)({}, value || defaultVolume));
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            state = state.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return state;
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".type" === joinedPath) {
	        state[index].type = String(value);
	      }
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".size" === joinedPath) {
	        state[index].size = (0, _ReducerUtil.parseIntValue)(value);
	      }
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".mode" === joinedPath) {
	        state[index].mode = String(value);
	      }
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".containerPath" === joinedPath) {
	        state[index].containerPath = String(value);
	      }
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".hostPath" === joinedPath) {
	        state[index].hostPath = String(value);
	      }
	    }
	
	    return state;
	  }
	};

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _ErrorsAlert = __webpack_require__(1729);
	
	var _ErrorsAlert2 = _interopRequireDefault(_ErrorsAlert);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ErrorMessageUtil = __webpack_require__(1728);
	
	var _PodContainersConfigSection = __webpack_require__(1769);
	
	var _PodContainersConfigSection2 = _interopRequireDefault(_PodContainersConfigSection);
	
	var _PodEnvironmentVariablesConfigSection = __webpack_require__(1778);
	
	var _PodEnvironmentVariablesConfigSection2 = _interopRequireDefault(_PodEnvironmentVariablesConfigSection);
	
	var _PodGeneralConfigSection = __webpack_require__(1779);
	
	var _PodGeneralConfigSection2 = _interopRequireDefault(_PodGeneralConfigSection);
	
	var _PodHealthChecksConfigSection = __webpack_require__(1781);
	
	var _PodHealthChecksConfigSection2 = _interopRequireDefault(_PodHealthChecksConfigSection);
	
	var _PodLabelsConfigSection = __webpack_require__(1782);
	
	var _PodLabelsConfigSection2 = _interopRequireDefault(_PodLabelsConfigSection);
	
	var _PodNetworkConfigSection = __webpack_require__(1783);
	
	var _PodNetworkConfigSection2 = _interopRequireDefault(_PodNetworkConfigSection);
	
	var _PodPlacementConstraintsConfigSection = __webpack_require__(1784);
	
	var _PodPlacementConstraintsConfigSection2 = _interopRequireDefault(_PodPlacementConstraintsConfigSection);
	
	var _PodSpec = __webpack_require__(1235);
	
	var _PodSpec2 = _interopRequireDefault(_PodSpec);
	
	var _PodStorageConfigSection = __webpack_require__(1785);
	
	var _PodStorageConfigSection2 = _interopRequireDefault(_PodStorageConfigSection);
	
	var _ServiceEnvironmentVariablesConfigSection = __webpack_require__(1786);
	
	var _ServiceEnvironmentVariablesConfigSection2 = _interopRequireDefault(_ServiceEnvironmentVariablesConfigSection);
	
	var _ServiceErrorMessages = __webpack_require__(1762);
	
	var _ServiceErrorMessages2 = _interopRequireDefault(_ServiceErrorMessages);
	
	var _ServiceErrorPathMapping = __webpack_require__(1764);
	
	var _ServiceErrorPathMapping2 = _interopRequireDefault(_ServiceErrorPathMapping);
	
	var _ServiceGeneralConfigSection = __webpack_require__(1788);
	
	var _ServiceGeneralConfigSection2 = _interopRequireDefault(_ServiceGeneralConfigSection);
	
	var _ServiceHealthChecksConfigSection = __webpack_require__(1789);
	
	var _ServiceHealthChecksConfigSection2 = _interopRequireDefault(_ServiceHealthChecksConfigSection);
	
	var _ServiceLabelsConfigSection = __webpack_require__(1790);
	
	var _ServiceLabelsConfigSection2 = _interopRequireDefault(_ServiceLabelsConfigSection);
	
	var _ServiceNetworkingConfigSection = __webpack_require__(1791);
	
	var _ServiceNetworkingConfigSection2 = _interopRequireDefault(_ServiceNetworkingConfigSection);
	
	var _ServicePlacementConstraintsConfigSection = __webpack_require__(1792);
	
	var _ServicePlacementConstraintsConfigSection2 = _interopRequireDefault(_ServicePlacementConstraintsConfigSection);
	
	var _ServiceStorageConfigSection = __webpack_require__(1793);
	
	var _ServiceStorageConfigSection2 = _interopRequireDefault(_ServiceStorageConfigSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIORITIES_PAD_NUMBER = 100;
	var DEFAULT_DISPLAY_COMPONENTS = [{
	  MOUNT_TYPE: "CreateService:ServiceConfigDisplay:App",
	  COMPONENTS: [_ServiceGeneralConfigSection2.default, _ServicePlacementConstraintsConfigSection2.default, _ServiceNetworkingConfigSection2.default, _ServiceStorageConfigSection2.default, _ServiceEnvironmentVariablesConfigSection2.default, _ServiceLabelsConfigSection2.default, _ServiceHealthChecksConfigSection2.default]
	}, {
	  MOUNT_TYPE: "CreateService:ServiceConfigDisplay:Pod",
	  COMPONENTS: [_PodGeneralConfigSection2.default, _PodContainersConfigSection2.default, _PodPlacementConstraintsConfigSection2.default, _PodNetworkConfigSection2.default, _PodStorageConfigSection2.default, _PodEnvironmentVariablesConfigSection2.default, _PodLabelsConfigSection2.default, _PodHealthChecksConfigSection2.default]
	}];
	
	// Register default config display components (this needs to only happen once)
	DEFAULT_DISPLAY_COMPONENTS.forEach(function (_ref) {
	  var MOUNT_TYPE = _ref.MOUNT_TYPE,
	      COMPONENTS = _ref.COMPONENTS;
	
	  COMPONENTS.forEach(function (component, index, componentArray) {
	    // Define  component priorities based on index (highest prio goes first)
	    // and pad priorities, so that we can add components in between.
	    var priority = (componentArray.length - index) * PRIORITIES_PAD_NUMBER;
	    _foundationUi.MountService.MountService.registerComponent(component, MOUNT_TYPE, priority);
	  });
	});
	
	var ServiceConfigDisplay = function (_React$Component) {
	  (0, _inherits3.default)(ServiceConfigDisplay, _React$Component);
	
	  function ServiceConfigDisplay() {
	    (0, _classCallCheck3.default)(this, ServiceConfigDisplay);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceConfigDisplay.__proto__ || (0, _getPrototypeOf2.default)(ServiceConfigDisplay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceConfigDisplay, [{
	    key: "getMountType",
	    value: function getMountType() {
	      if (this.props.appConfig instanceof _PodSpec2.default) {
	        return "CreateService:ServiceConfigDisplay:Pod";
	      }
	
	      return "CreateService:ServiceConfigDisplay:App";
	    }
	  }, {
	    key: "getErrors",
	    value: function getErrors() {
	      return (0, _ErrorMessageUtil.translateErrorMessages)(this.props.errors, _ServiceErrorMessages2.default);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          appConfig = _props.appConfig,
	          onEditClick = _props.onEditClick;
	
	      var errorsAlert = _react2.default.createElement(_ErrorsAlert2.default, {
	        errors: this.getErrors(),
	        pathMapping: _ServiceErrorPathMapping2.default
	      });
	
	      return _react2.default.createElement(
	        _ConfigurationMap2.default,
	        null,
	        errorsAlert,
	        _react2.default.createElement(_foundationUi.MountService.Mount, {
	          appConfig: appConfig,
	          errors: errorsAlert,
	          onEditClick: onEditClick,
	          type: this.getMountType()
	        })
	      );
	    }
	  }]);
	  return ServiceConfigDisplay;
	}(_react2.default.Component);
	
	ServiceConfigDisplay.defaultProps = {
	  errors: []
	};
	
	ServiceConfigDisplay.propTypes = {
	  appConfig: _react2.default.PropTypes.object.isRequired,
	  errors: _react2.default.PropTypes.array,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = ServiceConfigDisplay;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Alert = __webpack_require__(1730);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _PodContainerConfigSection = __webpack_require__(1770);
	
	var _PodContainerConfigSection2 = _interopRequireDefault(_PodContainerConfigSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderContainers(appConfig, handleEditClick) {
	  var _appConfig$containers = appConfig.containers,
	      containers = _appConfig$containers === undefined ? [] : _appConfig$containers;
	
	
	  return containers.map(function (container, index) {
	    return _react2.default.createElement(_PodContainerConfigSection2.default, {
	      appConfig: appConfig,
	      containerConfig: container,
	      key: "pod-container-" + container.name,
	      onEditClick: handleEditClick,
	      index: index
	    });
	  });
	}
	
	var PodContainersConfigSection = function PodContainersConfigSection(_ref) {
	  var appConfig = _ref.appConfig,
	      onEditClick = _ref.onEditClick;
	
	  if (!appConfig.containers || !appConfig.containers.length) {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapHeading2.default,
	        { level: 2 },
	        "Containers"
	      ),
	      _react2.default.createElement(
	        _Alert2.default,
	        null,
	        "No containers specified! Please specify at least one container when creating a multi-container definition!"
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ConfigurationMapHeading2.default,
	      { level: 2 },
	      "Containers"
	    ),
	    renderContainers(appConfig, onEditClick)
	  );
	};
	
	PodContainersConfigSection.propTypes = {
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodContainersConfigSection;

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ConfigurationMapBooleanValue = __webpack_require__(1772);
	
	var _ConfigurationMapBooleanValue2 = _interopRequireDefault(_ConfigurationMapBooleanValue);
	
	var _ConfigurationMapMultilineValue = __webpack_require__(1773);
	
	var _ConfigurationMapMultilineValue2 = _interopRequireDefault(_ConfigurationMapMultilineValue);
	
	var _ConfigurationMapSizeValue = __webpack_require__(1774);
	
	var _ConfigurationMapSizeValue2 = _interopRequireDefault(_ConfigurationMapSizeValue);
	
	var _ConfigurationMapValueWithDefault = __webpack_require__(1775);
	
	var _ConfigurationMapValueWithDefault2 = _interopRequireDefault(_ConfigurationMapValueWithDefault);
	
	var _PodContainerArtifactsConfigSection = __webpack_require__(1776);
	
	var _PodContainerArtifactsConfigSection2 = _interopRequireDefault(_PodContainerArtifactsConfigSection);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCommand(containerConfig) {
	  if (containerConfig.exec && containerConfig.exec.command) {
	    if (containerConfig.exec.command.shell) {
	      return containerConfig.exec.command.shell;
	    } else if (containerConfig.exec.command.argv) {
	      return containerConfig.exec.command.argv.join(" ");
	    }
	  }
	
	  return null;
	}
	
	var PodContainerConfigSection = function PodContainerConfigSection(_ref) {
	  var containerConfig = _ref.containerConfig,
	      appConfig = _ref.appConfig,
	      onEditClick = _ref.onEditClick,
	      index = _ref.index;
	
	  var fields = {
	    command: getCommand(containerConfig),
	    resources: containerConfig.resources || {},
	    user: containerConfig.user || appConfig.user
	  };
	
	  var tabViewID = "services";
	  if (index != null) {
	    tabViewID = "container" + index;
	  }
	
	  return _react2.default.createElement(
	    _ConfigurationMapSection2.default,
	    { key: "pod-general-section" },
	    _react2.default.createElement(
	      _ConfigurationMapHeading2.default,
	      { level: 3 },
	      (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(containerConfig)
	    ),
	    _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Container Image"
	      ),
	      _react2.default.createElement(_ConfigurationMapValueWithDefault2.default, {
	        value: (0, _Util.findNestedPropertyInObject)(containerConfig, "image.id")
	      }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Force pull on launch"
	      ),
	      _react2.default.createElement(_ConfigurationMapBooleanValue2.default, {
	        value: (0, _Util.findNestedPropertyInObject)(containerConfig, "image.forcePull")
	      }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.resources.cpus) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "CPUs"
	      ),
	      _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.resources.cpus }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.resources.mem) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Memory"
	      ),
	      _react2.default.createElement(_ConfigurationMapSizeValue2.default, { value: fields.resources.mem }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.resources.disk) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Disk"
	      ),
	      _react2.default.createElement(_ConfigurationMapSizeValue2.default, { value: fields.resources.disk }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.resources.gpus) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "GPUs"
	      ),
	      _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.resources.gpus }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.user) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Run as User"
	      ),
	      _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.user }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    Boolean(fields.command) && _react2.default.createElement(
	      _ConfigurationMapRow2.default,
	      null,
	      _react2.default.createElement(
	        _ConfigurationMapLabel2.default,
	        null,
	        "Command"
	      ),
	      _react2.default.createElement(_ConfigurationMapMultilineValue2.default, { value: fields.command }),
	      _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	        onEditClick: onEditClick,
	        tabViewID: tabViewID
	      })
	    ),
	    _react2.default.createElement(_PodContainerArtifactsConfigSection2.default, {
	      artifacts: containerConfig.artifacts,
	      onEditClick: onEditClick,
	      index: index
	    })
	  );
	};
	
	PodContainerConfigSection.propTypes = {
	  index: _react2.default.PropTypes.number,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodContainerConfigSection;

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfigurationMapEditAction = function ConfigurationMapEditAction(_ref) {
	  var tabViewID = _ref.tabViewID,
	      onEditClick = _ref.onEditClick;
	
	  if (!onEditClick) {
	    return _react2.default.createElement("noscript", null);
	  }
	
	  return _react2.default.createElement(
	    "a",
	    {
	      className: "button button-link flush table-display-on-row-hover",
	      onClick: onEditClick.bind(null, { tabViewID: tabViewID })
	    },
	    "Edit"
	  );
	};
	
	ConfigurationMapEditAction.propTypes = {
	  onEditClick: _react2.default.PropTypes.func,
	  tabViewID: _react2.default.PropTypes.string
	};
	
	module.exports = ConfigurationMapEditAction;

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Render a boolean value as a <ConfigurationMapValue>, with it's values being
	 * selected from an `options` array.
	 */
	var ConfigurationMapBooleanValue = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapBooleanValue, _React$Component);
	
	  function ConfigurationMapBooleanValue() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapBooleanValue);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapBooleanValue.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapBooleanValue)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapBooleanValue, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          options = _props.options,
	          value = _props.value;
	
	      // Bail early with default if empty
	
	      if (_ValidatorUtil2.default.isEmpty(value)) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          defaultValue
	        );
	      }
	
	      // Pick the appropriate value representation
	      if (value) {
	        value = options.truthy;
	      } else {
	        value = options.falsy;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapValue2.default,
	        null,
	        value
	      );
	    }
	  }]);
	  return ConfigurationMapBooleanValue;
	}(_react2.default.Component);
	
	ConfigurationMapBooleanValue.defaultProps = {
	  defaultValue: _react2.default.createElement(
	    "em",
	    null,
	    "Not Configured"
	  ),
	  options: {
	    truthy: "Enabled",
	    falsy: "Disabled"
	  },
	  value: null
	};
	
	ConfigurationMapBooleanValue.propTypes = {
	  defaultValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	  options: _react2.default.PropTypes.shape({
	    truthy: _react2.default.PropTypes.any,
	    falsy: _react2.default.PropTypes.any
	  }),
	  value: _react2.default.PropTypes.any
	};
	
	module.exports = ConfigurationMapBooleanValue;

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Render a multiline value as a <ConfigurationMapValue>, within the
	 * appropriate formatting.
	 */
	var ConfigurationMapMultilineValue = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapMultilineValue, _React$Component);
	
	  function ConfigurationMapMultilineValue() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapMultilineValue);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapMultilineValue.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapMultilineValue)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapMultilineValue, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          defaultValue = _props.defaultValue;
	
	      // Bail early with default if empty
	
	      if (_ValidatorUtil2.default.isEmpty(value)) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          defaultValue
	        );
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapValue2.default,
	        null,
	        _react2.default.createElement(
	          "pre",
	          { className: "flush transparent wrap" },
	          value
	        )
	      );
	    }
	  }]);
	  return ConfigurationMapMultilineValue;
	}(_react2.default.Component);
	
	ConfigurationMapMultilineValue.defaultProps = {
	  defaultValue: _react2.default.createElement(
	    "em",
	    null,
	    "Not Configured"
	  ),
	  value: ""
	};
	
	ConfigurationMapMultilineValue.propTypes = {
	  defaultValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	  value: _react2.default.PropTypes.string
	};
	
	module.exports = ConfigurationMapMultilineValue;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Render a size value as a <ConfigurationMapValue>, with it's values being
	 * appended a Mebibyte suffix.
	 *
	 * Practically, this is a component wrapper around the Units.filesize function,
	 * and you can file-tune it through it's properties.
	 */
	var ConfigurationMapSizeValue = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapSizeValue, _React$Component);
	
	  function ConfigurationMapSizeValue() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapSizeValue);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapSizeValue.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapSizeValue)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapSizeValue, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          decimals = _props.decimals,
	          defaultValue = _props.defaultValue,
	          multiplier = _props.multiplier,
	          scale = _props.scale,
	          threshold = _props.threshold,
	          units = _props.units,
	          value = _props.value;
	
	      // Bail early with default if empty
	
	      if (_ValidatorUtil2.default.isEmpty(value)) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          defaultValue
	        );
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapValue2.default,
	        null,
	        _Units2.default.filesize(value * scale, decimals, threshold, multiplier, units)
	      );
	    }
	  }]);
	  return ConfigurationMapSizeValue;
	}(_react2.default.Component);
	
	ConfigurationMapSizeValue.defaultProps = {
	  decimals: 2,
	  defaultValue: _react2.default.createElement(
	    "em",
	    null,
	    "Not Configured"
	  ),
	  multiplier: 1024,
	  scale: 1024 * 1024,
	  threshold: 800,
	  units: ["B", "KiB", "MiB", "GiB", "TiB", "PiB"],
	  value: 0
	};
	
	ConfigurationMapSizeValue.propTypes = {
	  decimals: _react2.default.PropTypes.number,
	  defaultValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	  multiplier: _react2.default.PropTypes.number,
	  scale: _react2.default.PropTypes.number,
	  threshold: _react2.default.PropTypes.number,
	  units: _react2.default.PropTypes.array,
	  value: _react2.default.PropTypes.number
	};
	
	module.exports = ConfigurationMapSizeValue;

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Render a defaultValue value if the value is empty or falsy.
	 */
	var ConfigurationMapValueWithDefault = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapValueWithDefault, _React$Component);
	
	  function ConfigurationMapValueWithDefault() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapValueWithDefault);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapValueWithDefault.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapValueWithDefault)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapValueWithDefault, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          value = _props.value;
	
	      // Bail early with default if empty
	
	      if (_ValidatorUtil2.default.isEmpty(value)) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          defaultValue
	        );
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapValue2.default,
	        null,
	        value
	      );
	    }
	  }]);
	  return ConfigurationMapValueWithDefault;
	}(_react2.default.Component);
	
	ConfigurationMapValueWithDefault.defaultProps = {
	  value: undefined,
	  defaultValue: _react2.default.createElement(
	    "em",
	    null,
	    "Not Configured"
	  )
	};
	
	ConfigurationMapValueWithDefault.propTypes = {
	  value: _react2.default.PropTypes.any,
	  defaultValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node])
	};
	
	module.exports = ConfigurationMapValueWithDefault;

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapBooleanValue = __webpack_require__(1772);
	
	var _ConfigurationMapBooleanValue2 = _interopRequireDefault(_ConfigurationMapBooleanValue);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOOLEAN_OPTIONS = {
	  truthy: "TRUE",
	  falsy: "FALSE"
	};
	
	var PodContainerArtifactsConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodContainerArtifactsConfigSection, _React$Component);
	
	  function PodContainerArtifactsConfigSection() {
	    (0, _classCallCheck3.default)(this, PodContainerArtifactsConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodContainerArtifactsConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodContainerArtifactsConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodContainerArtifactsConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Artifact URI",
	        prop: "uri"
	      }, {
	        heading: "Executable",
	        prop: "executable",
	        render: function render(prop, row) {
	          return _react2.default.createElement(_ConfigurationMapBooleanValue2.default, {
	            options: BOOLEAN_OPTIONS,
	            value: row[prop]
	          });
	        }
	      }, {
	        heading: "Extract",
	        prop: "extract",
	        render: function render(prop, row) {
	          return _react2.default.createElement(_ConfigurationMapBooleanValue2.default, {
	            options: BOOLEAN_OPTIONS,
	            value: row[prop]
	          });
	        }
	      }, {
	        heading: "Cache",
	        prop: "cache",
	        render: function render(prop, row) {
	          return _react2.default.createElement(_ConfigurationMapBooleanValue2.default, {
	            options: BOOLEAN_OPTIONS,
	            value: row[prop]
	          });
	        }
	      }, {
	        heading: "Destination Path",
	        prop: "destPath"
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          artifacts = _props.artifacts,
	          index = _props.index,
	          onEditClick = _props.onEditClick;
	
	      var tabViewID = "services";
	      if (index != null) {
	        tabViewID = "container" + index;
	      }
	
	      if (!artifacts || !artifacts.length) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 3 },
	          "Container Artifacts"
	        ),
	        _react2.default.createElement(_ConfigurationMapTable2.default, {
	          columnDefaults: { hideIfEmpty: true },
	          columns: this.getColumns(),
	          data: artifacts,
	          onEditClick: onEditClick,
	          tabViewID: tabViewID
	        })
	      );
	    }
	  }]);
	  return PodContainerArtifactsConfigSection;
	}(_react2.default.Component);
	
	PodContainerArtifactsConfigSection.defaultProps = {
	  artifacts: []
	};
	
	PodContainerArtifactsConfigSection.propTypes = {
	  artifacts: _react2.default.PropTypes.array,
	  index: _react2.default.PropTypes.number,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodContainerArtifactsConfigSection;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends2 = __webpack_require__(970);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigDisplayUtil2 = _interopRequireDefault(_ServiceConfigDisplayUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Optimized method to check if all row props are empty for a given column
	 *
	 * @param {Array} data - The array of rows top rocess
	 * @param {String} prop - The property name of the column
	 * @returns {Boolean} Returns `true` if all rows have empty value in this prop
	 */
	function isColumnEmpty(data, prop) {
	  return data.every(function (row) {
	    return _ValidatorUtil2.default.isEmpty(row[prop]);
	  });
	}
	
	/**
	 * Custom rendering function that takes care of replacing with default value
	 * if the field is empty.
	 *
	 * This function is bound into an object with a `placeholder` and `render`
	 * fields, holding the placeholder value and the reder function respectively.
	 *
	 * @this {Object}
	 * @param {String} prop - The property of the cell
	 * @param {Object} row - The current row
	 * @returns {Node} Returns a rendered React node
	 */
	function columnRenderFunction(prop, row) {
	  if (_ValidatorUtil2.default.isEmpty(row[prop])) {
	    return this.placeholder;
	  }
	
	  return this.render(prop, row);
	}
	
	/**
	 * Default render function if the user has not specified a custom renderer
	 *
	 * @param {String} prop - The property of the cell
	 * @param {Object} row - The current row
	 * @returns {Node} Returns a rendered React node
	 */
	function defaultRenderFunction(prop, row) {
	  var value = row[prop];
	  if (_react2.default.isValidElement(value)) {
	    return value;
	  }
	
	  return _react2.default.createElement(
	    "span",
	    null,
	    value.toString()
	  );
	}
	
	/**
	 * This stateless table component provides some additional functionality
	 * to the underlaying <Table /> component, trying to be as least intrusive
	 * as possible.
	 *
	 * @example <caption>Example of ConfigurationMapTable</caption>
	 * <ConfigurationMapTable
	 *   className='table table-simple table-break-word flush-bottom'
	 *   columnDefaults={{
	 *      hideIfEmpty: true,
	 *      className: 'configuration-map-table-value'
	 *   }}
	 *   columns={[
	 *      {
	 *        heading: 'Heading 1',
	 *        prop: 'prop1',
	 *      },
	 *      {
	 *        heading: 'Heading 2',
	 *        prop: 'prop2',
	 *      }
	 *   ]}
	 *   data={tableData} />
	 *
	 * @param {Object} props - The component properties
	 * @returns {Node} Returns the rendered table component
	 */
	
	var ConfigurationMapTable = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapTable, _React$Component);
	
	  function ConfigurationMapTable() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapTable);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapTable.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapTable, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          _props$columns = _props.columns,
	          columns = _props$columns === undefined ? [] : _props$columns,
	          _props$columnDefaults = _props.columnDefaults,
	          columnDefaults = _props$columnDefaults === undefined ? {} : _props$columnDefaults,
	          _props$data = _props.data,
	          data = _props$data === undefined ? [] : _props$data,
	          onEditClick = _props.onEditClick,
	          tabViewID = _props.tabViewID;
	
	
	      columns = columns.map(function (column) {
	        column = (0, _assign2.default)({}, columnDefaults, column);
	        var _column = column,
	            _column$className = _column.className,
	            className = _column$className === undefined ? "" : _column$className,
	            heading = _column.heading,
	            _column$hideIfEmpty = _column.hideIfEmpty,
	            hideIfEmpty = _column$hideIfEmpty === undefined ? false : _column$hideIfEmpty,
	            _column$placeholder = _column.placeholder,
	            placeholder = _column$placeholder === undefined ? _react2.default.createElement(
	          "em",
	          null,
	          "Not Configured"
	        ) : _column$placeholder,
	            prop = _column.prop,
	            _column$render = _column.render,
	            render = _column$render === undefined ? defaultRenderFunction : _column$render;
	
	        // Always use functions in order to display the sorting assets
	
	        if (typeof className !== "function") {
	          column.className = _ServiceConfigDisplayUtil2.default.getColumnClassNameFn(className);
	        }
	        if (typeof heading !== "function") {
	          column.heading = _ServiceConfigDisplayUtil2.default.getColumnHeadingFn(heading);
	        }
	
	        // Don't include columns that have an `hideIfEmpty` flag and are empty
	        if (hideIfEmpty && isColumnEmpty(data, prop)) {
	          return null;
	        }
	
	        // Compile render function
	        column.render = columnRenderFunction.bind({ placeholder: placeholder, render: render });
	
	        return column;
	      }).filter(function (column) {
	        return column !== null;
	      });
	
	      if (onEditClick) {
	        columns.push({
	          heading: function heading() {
	            return null;
	          },
	
	          className: "configuration-map-action",
	          prop: "edit",
	          render: function render() {
	            return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	              onEditClick: onEditClick,
	              tabViewID: tabViewID
	            });
	          }
	        });
	      }
	
	      return _react2.default.createElement(_reactjsComponents.Table, (0, _extends3.default)({
	        className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom"
	      }, (0, _assign2.default)({}, this.props, { columns: columns })));
	    }
	  }]);
	  return ConfigurationMapTable;
	}(_react2.default.Component);
	
	ConfigurationMapTable.propTypes = {
	  onEditClick: _react2.default.PropTypes.func,
	  tabViewID: _react2.default.PropTypes.string
	};
	
	module.exports = ConfigurationMapTable;

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columns = [{
	  heading: "Key",
	  prop: "key"
	}, {
	  heading: "Value",
	  prop: "value"
	}, {
	  heading: "Container",
	  prop: "container"
	}];
	
	var PodEnvironmentVariablesConfigSection = function PodEnvironmentVariablesConfigSection(_ref) {
	  var appConfig = _ref.appConfig,
	      onEditClick = _ref.onEditClick;
	  var _appConfig$environmen = appConfig.environment,
	      environment = _appConfig$environmen === undefined ? {} : _appConfig$environmen,
	      _appConfig$containers = appConfig.containers,
	      containers = _appConfig$containers === undefined ? [] : _appConfig$containers;
	
	
	  if (!environment || !containers) {
	    return _react2.default.createElement("noscript", null);
	  }
	
	  var combinedEnv = (0, _keys2.default)(environment).filter(function (key) {
	    return typeof environment[key] === "string";
	  }).reduce(function (memo, key) {
	    memo.push({
	      key: _react2.default.createElement(
	        "code",
	        null,
	        key
	      ),
	      value: environment[key],
	      container: (0, _ServiceConfigDisplayUtil.getSharedIconWithLabel)()
	    });
	
	    return memo;
	  }, []);
	
	  combinedEnv = containers.reduce(function (memo, container) {
	    var _container$environmen = container.environment,
	        environment = _container$environmen === undefined ? {} : _container$environmen;
	
	
	    return (0, _keys2.default)(environment).reduce(function (cvMemo, key) {
	      cvMemo.push({
	        key: _react2.default.createElement(
	          "code",
	          null,
	          key
	        ),
	        value: environment[key],
	        container: (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(container)
	      });
	
	      return cvMemo;
	    }, memo);
	  }, combinedEnv);
	
	  if (!combinedEnv.length) {
	    return _react2.default.createElement("noscript", null);
	  }
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ConfigurationMapHeading2.default,
	      { level: 1 },
	      "Environment Variables"
	    ),
	    _react2.default.createElement(
	      _ConfigurationMapSection2.default,
	      { key: "pod-general-section" },
	      _react2.default.createElement(_ConfigurationMapTable2.default, {
	        columnDefaults: { hideIfEmpty: true },
	        columns: columns,
	        data: combinedEnv,
	        onEditClick: onEditClick,
	        tabViewID: "multienvironment"
	      })
	    )
	  );
	};
	
	PodEnvironmentVariablesConfigSection.propTypes = {
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodEnvironmentVariablesConfigSection;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ConfigurationMapValueWithDefault = __webpack_require__(1775);
	
	var _ConfigurationMapValueWithDefault2 = _interopRequireDefault(_ConfigurationMapValueWithDefault);
	
	var _ConfigurationMapDurationValue = __webpack_require__(1780);
	
	var _ConfigurationMapDurationValue2 = _interopRequireDefault(_ConfigurationMapDurationValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Summarize the resources of every container, including the containers and
	 * their values in a comma-separated list after the value.
	 *
	 * @param {String} resource - The name of the resource in the field
	 * @param {Object} appConfig - The application configuration
	 * @returns {Node|String} Returns the contents to be rendered
	 */
	function getContainerResourceSummary(resource, _ref) {
	  var _ref$containers = _ref.containers,
	      containers = _ref$containers === undefined ? [] : _ref$containers;
	
	  var summary = containers.reduce(function (memo, _ref2) {
	    var name = _ref2.name,
	        _ref2$resources = _ref2.resources,
	        resources = _ref2$resources === undefined ? {} : _ref2$resources;
	
	    var value = resources[resource];
	    if (value) {
	      memo.value += value;
	      memo.parts.push(_Units2.default.formatResource(resource, value) + " " + name);
	    }
	
	    return memo;
	  }, { value: 0, parts: [] });
	
	  if (!summary.value) {
	    return _react2.default.createElement(
	      "em",
	      null,
	      "Not Supported"
	    );
	  }
	
	  return _Units2.default.formatResource(resource, summary.value) + " " + ("(" + summary.parts.join(", ") + ")");
	}
	
	/**
	 * Get the number of instances defined in the scaling policy,
	 * including additional information if needed (ex. maxInstances)
	 *
	 * @param {Object} appConfig - The application configuration
	 * @returns {String|null} Returns the expression to render or null if unknown
	 *                        scaling policy
	 */
	function getInstances(appConfig) {
	  if (appConfig.scaling && appConfig.scaling.kind === "fixed") {
	    var expr = "" + appConfig.scaling.instances;
	    if (appConfig.scaling.maxInstances) {
	      expr += " (Max " + appConfig.scaling.maxInstances + ")";
	    }
	
	    return expr;
	  }
	
	  return null;
	}
	
	var PodGeneralConfigSection = function PodGeneralConfigSection(_ref3) {
	  var appConfig = _ref3.appConfig,
	      onEditClick = _ref3.onEditClick;
	
	  var fields = {
	    instances: getInstances(appConfig),
	    backoff: (0, _Util.findNestedPropertyInObject)(appConfig, "scheduling.backoff.backoff"),
	    backoffFactor: (0, _Util.findNestedPropertyInObject)(appConfig, "scheduling.backoff.backoffFactor"),
	    maxLaunchDelay: (0, _Util.findNestedPropertyInObject)(appConfig, "scheduling.backoff.maxLaunchDelay"),
	    minimumHealthCapacity: (0, _Util.findNestedPropertyInObject)(appConfig, "scheduling.upgrade.minimumHealthCapacity"),
	    maximumOverCapacity: (0, _Util.findNestedPropertyInObject)(appConfig, "scheduling.upgrade.maximumOverCapacity")
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ConfigurationMapHeading2.default,
	      { level: 1 },
	      "General"
	    ),
	    _react2.default.createElement(
	      _ConfigurationMapSection2.default,
	      { key: "pod-general-section" },
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Service ID"
	        ),
	        _react2.default.createElement(_ConfigurationMapValue2.default, { value: appConfig.id }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Instances"
	        ),
	        _react2.default.createElement(_ConfigurationMapValueWithDefault2.default, { value: fields.instances }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "CPU"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          getContainerResourceSummary("cpus", appConfig)
	        ),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Memory"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          getContainerResourceSummary("mem", appConfig)
	        ),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Disk"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          getContainerResourceSummary("disk", appConfig)
	        ),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "GPU"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          getContainerResourceSummary("gpu", appConfig)
	        ),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      Boolean(fields.backoff) && _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Backoff"
	        ),
	        _react2.default.createElement(_ConfigurationMapDurationValue2.default, { units: "sec", value: fields.backoff }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      Boolean(fields.backoffFactor) && _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Backoff Factor"
	        ),
	        _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.backoffFactor }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      Boolean(fields.maxLaunchDelay) && _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Backoff Max Launch Delay"
	        ),
	        _react2.default.createElement(_ConfigurationMapDurationValue2.default, { units: "sec", value: fields.maxLaunchDelay }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      Boolean(fields.minimumHealthCapacity) && _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Upgrade Min Health Capacity"
	        ),
	        _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.minimumHealthCapacity }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      ),
	      Boolean(fields.maximumOverCapacity) && _react2.default.createElement(
	        _ConfigurationMapRow2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapLabel2.default,
	          null,
	          "Upgrade Max Overcapacity"
	        ),
	        _react2.default.createElement(_ConfigurationMapValue2.default, { value: fields.maximumOverCapacity }),
	        _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	          onEditClick: onEditClick,
	          tabViewID: "services"
	        })
	      )
	    )
	  );
	};
	
	PodGeneralConfigSection.propTypes = {
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodGeneralConfigSection;

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MULTIPLICANTS = {
	  ms: 1,
	  sec: 1000,
	  min: 60000,
	  h: 3600000,
	  d: 86400000
	};
	
	/**
	 * Render a JSON object as a <ConfigurationMapValue>, within the
	 * appropriate formatting.
	 */
	
	var ConfigurationMapDurationValue = function (_React$Component) {
	  (0, _inherits3.default)(ConfigurationMapDurationValue, _React$Component);
	
	  function ConfigurationMapDurationValue() {
	    (0, _classCallCheck3.default)(this, ConfigurationMapDurationValue);
	    return (0, _possibleConstructorReturn3.default)(this, (ConfigurationMapDurationValue.__proto__ || (0, _getPrototypeOf2.default)(ConfigurationMapDurationValue)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ConfigurationMapDurationValue, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          multiplicants = _props.multiplicants,
	          units = _props.units,
	          value = _props.value;
	
	      // Bail early with default if empty
	
	      if (_ValidatorUtil2.default.isEmpty(value)) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          defaultValue
	        );
	      }
	
	      // Compose value multiplicants
	      var valueInMs = value * multiplicants[units];
	      var components = _DateUtil2.default.msToMultiplicants(valueInMs, multiplicants);
	
	      var hasNoComponents = components.length === 0;
	      var hasOnlyUnitComponent = components.length === 1 && components[0].split(" ")[1] === units;
	
	      // Check if components are redundant
	      if (hasNoComponents || hasOnlyUnitComponent) {
	        return _react2.default.createElement(
	          _ConfigurationMapValue2.default,
	          null,
	          value,
	          " ",
	          units
	        );
	      }
	
	      // Otherwise show the value and it's components
	      return _react2.default.createElement(
	        _ConfigurationMapValue2.default,
	        null,
	        value,
	        " ",
	        units,
	        " (",
	        components.join(", "),
	        ")"
	      );
	    }
	  }]);
	  return ConfigurationMapDurationValue;
	}(_react2.default.Component);
	
	ConfigurationMapDurationValue.defaultProps = {
	  defaultValue: _react2.default.createElement(
	    "em",
	    null,
	    "Not Configured"
	  ),
	  multiplicants: MULTIPLICANTS,
	  units: "ms",
	  value: 0
	};
	
	ConfigurationMapDurationValue.propTypes = {
	  defaultValue: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.node]),
	  multiplicants: _react2.default.PropTypes.object,
	  units: _react2.default.PropTypes.oneOf((0, _keys2.default)(MULTIPLICANTS)),
	  value: _react2.default.PropTypes.number
	};
	
	module.exports = ConfigurationMapDurationValue;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	var _ConfigurationMapDurationValue = __webpack_require__(1780);
	
	var _ConfigurationMapDurationValue2 = _interopRequireDefault(_ConfigurationMapDurationValue);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapValueWithDefault = __webpack_require__(1775);
	
	var _ConfigurationMapValueWithDefault2 = _interopRequireDefault(_ConfigurationMapValueWithDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMMON_COLUMNS = [{
	  heading: "Grace Period",
	  prop: "gracePeriod",
	  render: function render(prop, row) {
	    return _react2.default.createElement(_ConfigurationMapDurationValue2.default, { units: "sec", value: row[prop] });
	  }
	}, {
	  heading: "Interval",
	  prop: "interval",
	  render: function render(prop, row) {
	    return _react2.default.createElement(_ConfigurationMapDurationValue2.default, { units: "sec", value: row[prop] });
	  }
	}, {
	  heading: "Timeout",
	  prop: "timeout",
	  render: function render(prop, row) {
	    return _react2.default.createElement(_ConfigurationMapDurationValue2.default, { units: "sec", value: row[prop] });
	  }
	}, {
	  heading: "Max Failures",
	  prop: "maxFailures"
	}, {
	  heading: "Container",
	  prop: "container"
	}];
	
	var PodHealthChecksConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodHealthChecksConfigSection, _React$Component);
	
	  function PodHealthChecksConfigSection() {
	    (0, _classCallCheck3.default)(this, PodHealthChecksConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodHealthChecksConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodHealthChecksConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodHealthChecksConfigSection, [{
	    key: "getCommandColumns",
	    value: function getCommandColumns() {
	      return [{
	        heading: "Command",
	        prop: "command"
	      }].concat(COMMON_COLUMNS);
	    }
	  }, {
	    key: "getDefaultEndpointsColumns",
	    value: function getDefaultEndpointsColumns() {
	      return {
	        hideIfEmpty: true,
	        render: function render(prop, row) {
	          // We use a default <Value/> renderer in order to render
	          // all elements as <Div/>s. Otherwise the boolean's look
	          // funny.
	          return _react2.default.createElement(_ConfigurationMapValueWithDefault2.default, { value: row[prop] });
	        }
	      };
	    }
	  }, {
	    key: "getEndpointsColumns",
	    value: function getEndpointsColumns() {
	      return [{
	        heading: "Service Endpoint",
	        prop: "endpoint"
	      }, {
	        heading: "Proto",
	        prop: "protocol"
	      }, {
	        heading: "Path",
	        prop: "path"
	      }].concat(COMMON_COLUMNS);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	      var _props$appConfig$cont = this.props.appConfig.containers,
	          containers = _props$appConfig$cont === undefined ? [] : _props$appConfig$cont;
	
	      var healthChecks = containers.reduce(function (memo, container) {
	        var healthCheck = container.healthCheck;
	
	
	        if (!healthCheck) {
	          return memo;
	        }
	
	        var spec = {
	          interval: healthCheck.intervalSeconds,
	          gracePeriod: healthCheck.gracePeriodSeconds,
	          maxFailures: healthCheck.maxConsecutiveFailures,
	          timeout: healthCheck.timeoutSeconds,
	          container: (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(container)
	        };
	
	        if (healthCheck.exec != null) {
	          spec.command = healthCheck.exec.command.shell;
	          if (healthCheck.exec.command.argv) {
	            spec.command = healthCheck.exec.command.argv.join(" ");
	          }
	
	          memo.command.push(spec);
	        }
	
	        if (healthCheck.http != null) {
	          spec.endpoint = healthCheck.http.endpoint;
	          spec.path = healthCheck.http.path;
	          spec.protocol = healthCheck.http.scheme || "http";
	          memo.endpoints.push(spec);
	        }
	
	        if (healthCheck.tcp != null) {
	          spec.endpoint = healthCheck.tcp.endpoint;
	          spec.protocol = "tcp";
	          memo.endpoints.push(spec);
	        }
	
	        return memo;
	      }, { endpoints: [], command: [] });
	
	      if (!healthChecks.endpoints.length && !healthChecks.command.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 1 },
	          "Health Checks"
	        ),
	        healthChecks.endpoints.length !== 0 && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 2 },
	            "Service Endpoint Health Checks"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            { key: "pod-general-section" },
	            _react2.default.createElement(_ConfigurationMapTable2.default, {
	              columnDefaults: this.getDefaultEndpointsColumns(),
	              columns: this.getEndpointsColumns(),
	              data: healthChecks.endpoints,
	              onEditClick: onEditClick,
	              tabViewID: "multihealthChecks"
	            })
	          )
	        ),
	        healthChecks.command.length !== 0 && _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 2 },
	            "Command Health Checks"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            { key: "pod-general-section" },
	            _react2.default.createElement(_ConfigurationMapTable2.default, {
	              columnDefaults: { hideIfEmpty: true },
	              columns: this.getCommandColumns(),
	              data: healthChecks.command,
	              onEditClick: onEditClick,
	              tabViewID: "multihealthChecks"
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return PodHealthChecksConfigSection;
	}(_react2.default.Component);
	
	PodHealthChecksConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	PodHealthChecksConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodHealthChecksConfigSection;

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodLabelsConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodLabelsConfigSection, _React$Component);
	
	  function PodLabelsConfigSection() {
	    (0, _classCallCheck3.default)(this, PodLabelsConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodLabelsConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodLabelsConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodLabelsConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Key",
	        prop: "key"
	      }, {
	        heading: "Value",
	        prop: "value"
	      }, {
	        heading: "Container",
	        prop: "container"
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	      var _props$appConfig = this.props.appConfig,
	          _props$appConfig$labe = _props$appConfig.labels,
	          labels = _props$appConfig$labe === undefined ? {} : _props$appConfig$labe,
	          _props$appConfig$cont = _props$appConfig.containers,
	          containers = _props$appConfig$cont === undefined ? [] : _props$appConfig$cont;
	
	
	      var combinedLabels = [];
	
	      if (labels != null) {
	        combinedLabels = (0, _keys2.default)(labels).reduce(function (memo, key) {
	          memo.push({
	            key: _react2.default.createElement(
	              "code",
	              null,
	              key
	            ),
	            value: labels[key],
	            container: (0, _ServiceConfigDisplayUtil.getSharedIconWithLabel)()
	          });
	
	          return memo;
	        }, []);
	      }
	
	      combinedLabels = containers.reduce(function (memo, container) {
	        var _container$labels = container.labels,
	            labels = _container$labels === undefined ? {} : _container$labels;
	
	
	        if (labels != null) {
	          return (0, _keys2.default)(labels).reduce(function (cvMemo, key) {
	            cvMemo.push({
	              key: _react2.default.createElement(
	                "code",
	                null,
	                key
	              ),
	              value: labels[key],
	              container: (0, _ServiceConfigDisplayUtil.getContainerNameWithIcon)(container)
	            });
	
	            return cvMemo;
	          }, memo);
	        }
	
	        return memo;
	      }, combinedLabels);
	
	      if (!combinedLabels.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 1 },
	          "Labels"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: "pod-general-section" },
	          _react2.default.createElement(_ConfigurationMapTable2.default, {
	            columnDefaults: { hideIfEmpty: true },
	            columns: this.getColumns(),
	            data: combinedLabels,
	            onEditClick: onEditClick,
	            tabViewID: "multienvironment"
	          })
	        )
	      );
	    }
	  }]);
	  return PodLabelsConfigSection;
	}(_react2.default.Component);
	
	PodLabelsConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	PodLabelsConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodLabelsConfigSection;

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigDisplayUtil2 = _interopRequireDefault(_ServiceConfigDisplayUtil);
	
	var _ServiceConfigUtil = __webpack_require__(1752);
	
	var _ServiceConfigUtil2 = _interopRequireDefault(_ServiceConfigUtil);
	
	var _ConfigurationMapValueWithDefault = __webpack_require__(1775);
	
	var _ConfigurationMapValueWithDefault2 = _interopRequireDefault(_ConfigurationMapValueWithDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NETWORK_MODE_NAME = {
	  container: "Container",
	  host: "Host"
	};
	
	function getNetworkTypes(networks) {
	  if (!networks || !networks.length) {
	    return null;
	  }
	
	  return networks.map(function (_ref) {
	    var mode = _ref.mode;
	    return NETWORK_MODE_NAME[mode];
	  }).join(", ");
	}
	
	var PodNetworkConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodNetworkConfigSection, _React$Component);
	
	  function PodNetworkConfigSection() {
	    (0, _classCallCheck3.default)(this, PodNetworkConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodNetworkConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodNetworkConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodNetworkConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Name",
	        prop: "name"
	      }, {
	        heading: "Protocol",
	        prop: "protocol"
	      }, {
	        heading: "Port",
	        prop: "port"
	      }, {
	        heading: "Load Balanced Address",
	        prop: "lbAddress",
	        placeholder: _react2.default.createElement(
	          "em",
	          null,
	          "Not Enabled"
	        )
	      }, {
	        heading: "Container",
	        prop: "container"
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	
	      var appConfig = this.props.appConfig;
	      var _appConfig$containers = appConfig.containers,
	          containers = _appConfig$containers === undefined ? [] : _appConfig$containers;
	
	      var endpoints = containers.reduce(function (memo, container) {
	        var _container$endpoints = container.endpoints,
	            endpoints = _container$endpoints === undefined ? [] : _container$endpoints;
	
	
	        return memo.concat(endpoints.map(function (_ref2) {
	          var containerPort = _ref2.containerPort,
	              _ref2$labels = _ref2.labels,
	              labels = _ref2$labels === undefined ? {} : _ref2$labels,
	              name = _ref2.name,
	              protocol = _ref2.protocol;
	
	          var lbAddress = (0, _keys2.default)(labels).reduce(function (memo, label) {
	            if (_ServiceConfigUtil2.default.matchVIPLabel(label)) {
	              memo.push(_ServiceConfigUtil2.default.buildHostNameFromVipLabel(labels[label]));
	            }
	
	            return memo;
	          }, []);
	
	          return {
	            name: name,
	            protocol: protocol,
	            port: containerPort,
	            lbAddress: lbAddress.join(", "),
	            container: _ServiceConfigDisplayUtil2.default.getContainerNameWithIcon(container)
	          };
	        }));
	      }, []);
	
	      if (!endpoints.length) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 1 },
	          "Network"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: "pod-general-section" },
	          _react2.default.createElement(
	            _ConfigurationMapRow2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapLabel2.default,
	              null,
	              "Network Type"
	            ),
	            _react2.default.createElement(_ConfigurationMapValueWithDefault2.default, {
	              value: getNetworkTypes(appConfig.networks)
	            }),
	            _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	              onEditClick: onEditClick,
	              tabViewID: "networking"
	            })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 3 },
	            "Service Endpoints"
	          ),
	          _react2.default.createElement(_ConfigurationMapTable2.default, {
	            columnDefaults: { hideIfEmpty: true },
	            columns: this.getColumns(),
	            data: endpoints,
	            onEditClick: onEditClick,
	            tabViewID: "networking"
	          })
	        )
	      );
	    }
	  }]);
	  return PodNetworkConfigSection;
	}(_react2.default.Component);
	
	PodNetworkConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	PodNetworkConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodNetworkConfigSection;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	var _PlacementConstraintsUtil2 = _interopRequireDefault(_PlacementConstraintsUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodPlacementConstraintsConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodPlacementConstraintsConfigSection, _React$Component);
	
	  function PodPlacementConstraintsConfigSection() {
	    (0, _classCallCheck3.default)(this, PodPlacementConstraintsConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodPlacementConstraintsConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodPlacementConstraintsConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodPlacementConstraintsConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Field Name",
	        prop: "fieldName"
	      }, {
	        heading: "Operator",
	        prop: "operator"
	      }, {
	        heading: "Value",
	        prop: "value"
	      }];
	    }
	  }, {
	    key: "getConstraints",
	    value: function getConstraints() {
	      var constraints = (0, _Util.findNestedPropertyInObject)(this.props.appConfig, "scheduling.placement.constraints") || [];
	
	      return constraints.map(function (_ref) {
	        var fieldName = _ref.fieldName,
	            operator = _ref.operator,
	            value = _ref.value;
	
	        if (_PlacementConstraintsUtil2.default.requiresEmptyValue(operator)) {
	          value = _react2.default.createElement(
	            "em",
	            null,
	            "Not Applicable"
	          );
	        }
	
	        return { fieldName: fieldName, operator: operator, value: value };
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	
	      var constraints = this.getConstraints();
	      // Since we are stateless component we will need to return something for react
	      // so we are using the `<noscript>` tag as placeholder.
	      if (!constraints.length) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 3 },
	          "Placement Constraints"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          null,
	          _react2.default.createElement(_ConfigurationMapTable2.default, {
	            columns: this.getColumns(),
	            data: constraints,
	            onEditClick: onEditClick,
	            tabViewID: "services"
	          })
	        )
	      );
	    }
	  }]);
	  return PodPlacementConstraintsConfigSection;
	}(_react2.default.Component);
	
	PodPlacementConstraintsConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	PodPlacementConstraintsConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodPlacementConstraintsConfigSection;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigDisplayUtil2 = _interopRequireDefault(_ServiceConfigDisplayUtil);
	
	var _VolumeConstants = __webpack_require__(1756);
	
	var _VolumeConstants2 = _interopRequireDefault(_VolumeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BOOLEAN_OPTIONS = {
	  truthy: "TRUE",
	  falsy: "FALSE"
	};
	
	var PodStorageConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(PodStorageConfigSection, _React$Component);
	
	  function PodStorageConfigSection() {
	    (0, _classCallCheck3.default)(this, PodStorageConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (PodStorageConfigSection.__proto__ || (0, _getPrototypeOf2.default)(PodStorageConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodStorageConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Volume",
	        prop: "volume"
	      }, {
	        heading: "Type",
	        prop: "type"
	      }, {
	        heading: "Size",
	        prop: "size"
	      }, {
	        heading: "Read Only",
	        prop: "readOnly",
	        render: function render(prop, row) {
	          if (row[prop]) {
	            return BOOLEAN_OPTIONS.truthy;
	          }
	
	          return BOOLEAN_OPTIONS.falsy;
	        }
	      }, {
	        heading: "Container Mount Path",
	        prop: "mountPath"
	      }, {
	        heading: "Host Path",
	        prop: "hostPath"
	      }, {
	        heading: "Container",
	        prop: "container"
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	      var _props$appConfig = this.props.appConfig,
	          _props$appConfig$volu = _props$appConfig.volumes,
	          volumes = _props$appConfig$volu === undefined ? [] : _props$appConfig$volu,
	          _props$appConfig$cont = _props$appConfig.containers,
	          containers = _props$appConfig$cont === undefined ? [] : _props$appConfig$cont;
	
	      var volumeSummary = volumes.reduce(function (memo, volume) {
	        var type = _VolumeConstants2.default.type.unknown;
	        if (volume.host != null) {
	          type = _VolumeConstants2.default.type.host;
	        }
	        if ((0, _keys2.default)(volume).length === 1 && volume.name != null) {
	          type = _VolumeConstants2.default.type.ephemeral;
	        }
	
	        var volumeInfo = {
	          type: type,
	          volume: volume.name,
	          hostPath: volume.host
	        };
	
	        // Fetch all mounts for this volume in the containers
	        var containerMounts = containers.reduce(function (cmMemo, container) {
	          var _container$volumeMoun = container.volumeMounts,
	              volumeMounts = _container$volumeMoun === undefined ? [] : _container$volumeMoun;
	
	
	          return cmMemo.concat(volumeMounts.filter(function (volumeMount) {
	            return volumeMount.name === volume.name;
	          }).map(function (volumeMount) {
	            return {
	              container: _ServiceConfigDisplayUtil2.default.getContainerNameWithIcon(container),
	              mountPath: volumeMount.mountPath,
	              readOnly: volumeMount.readOnly || false
	            };
	          }));
	        }, []);
	
	        // If there are no mounts, add only one line without containers
	        if (containerMounts.length === 0) {
	          memo.push(volumeInfo);
	
	          return memo;
	        }
	
	        // Otherwise create one volume entry for each mount
	        return containerMounts.reduce(function (volumesMemo, mountInfo) {
	          return volumesMemo.concat((0, _assign2.default)({}, volumeInfo, mountInfo));
	        }, memo);
	      }, []);
	
	      if (!volumeSummary.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 1 },
	          "Storage"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: "pod-general-section" },
	          _react2.default.createElement(_ConfigurationMapTable2.default, {
	            columnDefaults: { hideIfEmpty: true },
	            columns: this.getColumns(),
	            data: volumeSummary,
	            onEditClick: onEditClick,
	            tabViewID: "multivolumes"
	          })
	        )
	      );
	    }
	  }]);
	  return PodStorageConfigSection;
	}(_react2.default.Component);
	
	PodStorageConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	PodStorageConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = PodStorageConfigSection;

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigDisplayUtil2 = _interopRequireDefault(_ServiceConfigDisplayUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceEnvironmentVariablesConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceEnvironmentVariablesConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceEnvironmentVariablesConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceEnvironmentVariablesConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceEnvironmentVariablesConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceEnvironmentVariablesConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceEnvironmentVariablesConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	    * @override
	    */
	    value: function shouldExcludeItem() {
	      var env = this.props.appConfig.env;
	
	
	      return env == null || (0, _keys2.default)(env).length === 0 || (0, _keys2.default)(env).every(function (key) {
	        return typeof env[key] !== "string";
	      });
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "environment",
	        values: [{
	          key: "env",
	          heading: "Environment Variables",
	          headingLevel: 1
	        }, {
	          key: "env",
	          render: function render(envData) {
	            var columns = [{
	              heading: _ServiceConfigDisplayUtil2.default.getColumnHeadingFn("Key"),
	              prop: "key",
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  "code",
	                  null,
	                  row[prop]
	                );
	              },
	              className: _ServiceConfigDisplayUtil2.default.getColumnClassNameFn("configuration-map-table-label"),
	              sortable: true
	            }, {
	              heading: _ServiceConfigDisplayUtil2.default.getColumnHeadingFn("Value"),
	              prop: "value",
	              render: function render(prop, row) {
	                var value = row[prop];
	
	                return _ServiceConfigDisplayUtil2.default.getDisplayValue(value);
	              },
	              className: _ServiceConfigDisplayUtil2.default.getColumnClassNameFn("configuration-map-table-value"),
	              sortable: true
	            }];
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "environment"
	                  });
	                }
	              });
	            }
	
	            var data = (0, _keys2.default)(envData).map(function (envKey) {
	              return { key: envKey, value: envData[envKey] };
	            }).filter(function (_ref) {
	              var value = _ref.value;
	
	              return typeof value === "string";
	            });
	
	            return _react2.default.createElement(_reactjsComponents.Table, {
	              key: "secrets-table",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: data
	            });
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceEnvironmentVariablesConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceEnvironmentVariablesConfigSection;

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Util = __webpack_require__(982);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceConfigBaseSectionDisplay = function (_React$Component) {
	  (0, _inherits3.default)(ServiceConfigBaseSectionDisplay, _React$Component);
	
	  function ServiceConfigBaseSectionDisplay() {
	    (0, _classCallCheck3.default)(this, ServiceConfigBaseSectionDisplay);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceConfigBaseSectionDisplay.__proto__ || (0, _getPrototypeOf2.default)(ServiceConfigBaseSectionDisplay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceConfigBaseSectionDisplay, [{
	    key: "shouldExcludeItem",
	    value: function shouldExcludeItem() {
	      return false;
	    }
	  }, {
	    key: "getDisplayValue",
	    value: function getDisplayValue(type, value) {
	      // If the row's type is pre, we wrap it in a pre tag.
	      if (type === "pre" && value) {
	        return _react2.default.createElement(
	          "pre",
	          { className: "flush transparent wrap" },
	          value
	        );
	      }
	
	      return (0, _ServiceConfigDisplayUtil.getDisplayValue)(value);
	    }
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      return { values: [] };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          appConfig = _props.appConfig,
	          onEditClick = _props.onEditClick;
	
	      var _getDefinition = this.getDefinition(),
	          values = _getDefinition.values,
	          tabViewID = _getDefinition.tabViewID;
	
	      var configurationMapRows = values.filter(function (row) {
	        // Some rows must be excluded if relevant data is missing.
	        return !_this2.shouldExcludeItem(row);
	      }).map(function (row, rowIndex) {
	        var reactKey = "" + rowIndex;
	        var value = (0, _Util.findNestedPropertyInObject)(appConfig, row.key);
	
	        // If a transformValue was specified on the row, we use it.
	        if (row.transformValue != null) {
	          value = row.transformValue(value, appConfig);
	        }
	
	        if (row.render != null) {
	          // If a custom render method was specified on the row, we use that.
	          return row.render(value, appConfig);
	        } else if (row.heading != null) {
	          // If the row is a heading, we render the heading.
	          return _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { key: reactKey, level: row.headingLevel },
	            row.heading
	          );
	        }
	
	        // Otherwise we treat the row as "label:value" type display.
	        return _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: reactKey },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            row.label
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            _this2.getDisplayValue(row.type, value)
	          ),
	          _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	            onEditClick: onEditClick,
	            tabViewID: tabViewID
	          })
	        );
	      });
	
	      if (configurationMapRows.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        configurationMapRows
	      );
	    }
	  }]);
	  return ServiceConfigBaseSectionDisplay;
	}(_react2.default.Component);
	
	module.exports = ServiceConfigBaseSectionDisplay;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Util = __webpack_require__(982);
	
	var _Units = __webpack_require__(1400);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ContainerConstants = __webpack_require__(1682);
	
	var _ContainerConstants2 = _interopRequireDefault(_ContainerConstants);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ContainerConstants$t = _ContainerConstants2.default.type,
	    DOCKER = _ContainerConstants$t.DOCKER,
	    MESOS = _ContainerConstants$t.MESOS,
	    labelMap = _ContainerConstants2.default.labelMap;
	
	var ServiceGeneralConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceGeneralConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceGeneralConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceGeneralConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceGeneralConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceGeneralConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceGeneralConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	     * @override
	     */
	    value: function shouldExcludeItem(row) {
	      var appConfig = this.props.appConfig;
	
	
	      switch (row.key) {
	        case "fetch":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "fetch.length");
	        case "gpus":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "gpus");
	        case "backoffSeconds":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "backoffSeconds");
	        case "backoffFactor":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "backoffFactor");
	        case "maxLaunchDelaySeconds":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "maxLaunchDelaySeconds");
	        case "minHealthOpacity":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "minHealthOpacity");
	        case "maxOverCapacity":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "maxOverCapacity");
	        case "acceptedResourceRoles":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "acceptedResourceRoles.length");
	        case "dependencies":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "dependencies.length");
	        case "executor":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "executor");
	        case "user":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "user");
	        case "args":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "args.length");
	        case "version":
	          return !(0, _Util.findNestedPropertyInObject)(appConfig, "version");
	        default:
	          return false;
	      }
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "services",
	        values: [{
	          heading: "General",
	          headingLevel: 1
	        }, {
	          key: "id",
	          label: "Service ID"
	        }, {
	          key: "instances",
	          label: "Instances"
	        }, {
	          key: "container.type",
	          label: "Container Runtime",
	          transformValue: function transformValue(runtime) {
	            return labelMap[runtime] || labelMap[MESOS];
	          }
	        }, {
	          key: "cpus",
	          label: "CPU"
	        }, {
	          key: "mem",
	          label: "Memory",
	          transformValue: function transformValue(value) {
	            if (value == null) {
	              return value;
	            }
	
	            return (0, _Units.formatResource)("mem", value);
	          }
	        }, {
	          key: "disk",
	          label: "Disk",
	          transformValue: function transformValue(value) {
	            if (value == null) {
	              return value;
	            }
	
	            return (0, _Units.formatResource)("disk", value);
	          }
	        }, {
	          key: "gpus",
	          label: "GPU"
	        }, {
	          key: "backoffSeconds",
	          label: "Backoff Seconds"
	        }, {
	          key: "backoffFactor",
	          label: "Backoff Factor"
	        }, {
	          key: "maxLaunchDelaySeconds",
	          label: "Backoff Max Launch Delay"
	        }, {
	          key: "minHealthOpacity",
	          label: "Upgrade Min Health Capacity"
	        }, {
	          key: "maxOverCapacity",
	          label: "Upgrade Max Overcapacity"
	        }, {
	          key: "container.docker.image",
	          label: "Container Image",
	          transformValue: function transformValue(value, appConfig) {
	            var runtime = (0, _Util.findNestedPropertyInObject)(appConfig, "container.type");
	
	            // Disabled for MESOS
	            return (0, _ServiceConfigDisplayUtil.getDisplayValue)(value, runtime == null || runtime === MESOS);
	          }
	        }, {
	          key: "container.docker.privileged",
	          label: "Extended Runtime Priv.",
	          transformValue: function transformValue(value, appConfig) {
	            var runtime = (0, _Util.findNestedPropertyInObject)(appConfig, "container.type");
	            // Disabled for DOCKER
	            if (runtime !== DOCKER && value == null) {
	              return (0, _ServiceConfigDisplayUtil.getDisplayValue)(null, true);
	            }
	
	            // Cast boolean as a string.
	            return String(Boolean(value));
	          }
	        }, {
	          key: "container.docker.forcePullImage",
	          label: "Force Pull on Launch",
	          transformValue: function transformValue(value, appConfig) {
	            var runtime = (0, _Util.findNestedPropertyInObject)(appConfig, "container.type");
	            // Disabled for DOCKER
	            if (runtime !== DOCKER && value == null) {
	              return (0, _ServiceConfigDisplayUtil.getDisplayValue)(null, true);
	            }
	
	            // Cast boolean as a string.
	            return String(Boolean(value));
	          }
	        }, {
	          key: "cmd",
	          label: "Command",
	          type: "pre"
	        }, {
	          key: "acceptedResourceRoles",
	          label: "Resource Roles",
	          transformValue: function transformValue() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            return value.join(", ");
	          }
	        }, {
	          key: "dependencies",
	          label: "Dependencies",
	          transformValue: function transformValue() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            return value.join(", ");
	          }
	        }, {
	          key: "executor",
	          label: "Executor"
	        }, {
	          key: "user",
	          label: "User"
	        }, {
	          key: "args",
	          label: "Args",
	          transformValue: function transformValue() {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            if (!value.length) {
	              return (0, _ServiceConfigDisplayUtil.getDisplayValue)(null);
	            }
	
	            var args = value.map(function (arg, index) {
	              return _react2.default.createElement(
	                "pre",
	                { key: index, className: "flush transparent wrap" },
	                arg
	              );
	            });
	
	            return _react2.default.createElement(
	              "div",
	              null,
	              args
	            );
	          }
	        }, {
	          key: "version",
	          label: "Version"
	        }, {
	          key: "fetch",
	          heading: "Container Artifacts",
	          headingLevel: 3
	        }, {
	          key: "fetch",
	          render: function render(data) {
	            var columns = [{
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Artifact Uri"),
	              prop: "uri",
	              render: function render(prop, row) {
	                var value = row[prop];
	
	                return (0, _ServiceConfigDisplayUtil.getDisplayValue)(value);
	              },
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)("configuration-map-table-label"),
	              sortable: true
	            }];
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "services"
	                  });
	                }
	              });
	            }
	
	            return _react2.default.createElement(_reactjsComponents.Table, {
	              key: "artifacts-table",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: data
	            });
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceGeneralConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceGeneralConfigSection;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapDurationValue = __webpack_require__(1780);
	
	var _ConfigurationMapDurationValue2 = _interopRequireDefault(_ConfigurationMapDurationValue);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderDuration(prop, row) {
	  var value = row[prop] || null;
	
	  return _react2.default.createElement(_ConfigurationMapDurationValue2.default, {
	    defaultValue: _react2.default.createElement(
	      "em",
	      null,
	      "Not Configured"
	    ),
	    units: "sec",
	    value: value
	  });
	}
	
	var ServiceHealthChecksConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceHealthChecksConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceHealthChecksConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceHealthChecksConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceHealthChecksConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceHealthChecksConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceHealthChecksConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	     * @override
	     */
	    value: function shouldExcludeItem() {
	      var appConfig = this.props.appConfig;
	
	
	      return !_Util2.default.findNestedPropertyInObject(appConfig, "healthChecks.length");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "healthChecks",
	        values: [{
	          key: "healthChecks",
	          render: function render(healthChecks) {
	            if (healthChecks.length === 0) {
	              return null;
	            }
	
	            return _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              {
	                key: "service-health-checks-heading",
	                level: 1
	              },
	              "Health Checks"
	            );
	          }
	        }, {
	          key: "healthChecks",
	          render: function render(healthChecks) {
	            var serviceEndpointHealthChecks = healthChecks.filter(function (healthCheck) {
	              return [_HealthCheckProtocols.MESOS_HTTP, _HealthCheckProtocols.MESOS_HTTPS].includes(healthCheck.protocol);
	            });
	
	            var columns = [{
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Protocol"),
	              prop: "protocol",
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  _ConfigurationMapValue2.default,
	                  null,
	                  (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop])
	                );
	              },
	
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Path"),
	              prop: "path",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  _ConfigurationMapValue2.default,
	                  null,
	                  (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop])
	                );
	              },
	
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Grace Period"),
	              prop: "gracePeriodSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Interval"),
	              prop: "intervalSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Timeout"),
	              prop: "timeoutSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Max Failures"),
	              prop: "maxConsecutiveFailures",
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  _ConfigurationMapValue2.default,
	                  null,
	                  (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop])
	                );
	              },
	
	              sortable: true
	            }];
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "healthChecks"
	                  });
	                }
	              });
	            }
	
	            if (serviceEndpointHealthChecks.length === 0) {
	              return null;
	            }
	
	            return [_react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              {
	                key: "service-endpoint-health-checks-heading",
	                level: 2
	              },
	              "Service Endpoint Health Checks"
	            ), _react2.default.createElement(_reactjsComponents.Table, {
	              key: "service-endpoint-health-checks",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: serviceEndpointHealthChecks
	            })];
	          }
	        }, {
	          key: "healthChecks",
	          render: function render(healthChecks) {
	            var commandHealthChecks = healthChecks.filter(function (healthCheck) {
	              return healthCheck.protocol === _HealthCheckProtocols.COMMAND;
	            });
	
	            var columns = [{
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Command"),
	              prop: "command",
	              render: function render(prop, row) {
	                var command = row[prop] || {};
	                var value = (0, _ServiceConfigDisplayUtil.getDisplayValue)(command.value);
	                if (!command.value) {
	                  return value;
	                }
	
	                return _react2.default.createElement(
	                  _ConfigurationMapValue2.default,
	                  null,
	                  _react2.default.createElement(
	                    "pre",
	                    { className: "flush transparent wrap" },
	                    value
	                  )
	                );
	              },
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Grace Period"),
	              prop: "gracePeriodSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Interval"),
	              prop: "intervalSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Timeout"),
	              prop: "timeoutSeconds",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: renderDuration,
	              sortable: true
	            }, {
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Max Failures"),
	              prop: "maxConsecutiveFailures",
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  _ConfigurationMapValue2.default,
	                  null,
	                  (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop])
	                );
	              },
	
	              sortable: true
	            }];
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "environment"
	                  });
	                }
	              });
	            }
	
	            if (commandHealthChecks.length === 0) {
	              return null;
	            }
	
	            return [_react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              {
	                key: "command-health-checks-heading",
	                level: 2
	              },
	              "Command Health Checks"
	            ), _react2.default.createElement(_reactjsComponents.Table, {
	              key: "command-health-checks",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: commandHealthChecks
	            })];
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceHealthChecksConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceHealthChecksConfigSection;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigDisplayUtil2 = _interopRequireDefault(_ServiceConfigDisplayUtil);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceLabelsConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceLabelsConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceLabelsConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceLabelsConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceLabelsConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceLabelsConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceLabelsConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	    * @override
	    */
	    value: function shouldExcludeItem() {
	      var labels = this.props.appConfig.labels;
	
	
	      return labels == null || (0, _keys2.default)(labels).length === 0;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "environment",
	        values: [{
	          key: "labels",
	          heading: "Labels",
	          headingLevel: 1
	        }, {
	          key: "labels",
	          render: function render(labelsDataMap) {
	            var columns = [{
	              heading: _ServiceConfigDisplayUtil2.default.getColumnHeadingFn(),
	              prop: "key",
	              render: function render(prop, row) {
	                return _react2.default.createElement(
	                  "code",
	                  null,
	                  row[prop]
	                );
	              },
	              className: _ServiceConfigDisplayUtil2.default.getColumnClassNameFn("configuration-map-table-label"),
	              sortable: true
	            }, {
	              heading: _ServiceConfigDisplayUtil2.default.getColumnHeadingFn(),
	              prop: "value",
	              className: _ServiceConfigDisplayUtil2.default.getColumnClassNameFn("configuration-map-table-value"),
	              sortable: true
	            }];
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "environment"
	                  });
	                }
	              });
	            }
	
	            var data = (0, _keys2.default)(labelsDataMap).reduce(function (memo, labelKey) {
	              var value = _ServiceConfigDisplayUtil2.default.getDisplayValue(labelsDataMap[labelKey]);
	
	              memo.push({ key: labelKey, value: value });
	
	              return memo;
	            }, []);
	
	            return _react2.default.createElement(_reactjsComponents.Table, {
	              key: "labels-table",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: data
	            });
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceLabelsConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceLabelsConfigSection;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _Util = __webpack_require__(982);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ServiceConfigUtil = __webpack_require__(1752);
	
	var _ServiceConfigUtil2 = _interopRequireDefault(_ServiceConfigUtil);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceNetworkingConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceNetworkingConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceNetworkingConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceNetworkingConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceNetworkingConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceNetworkingConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceNetworkingConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	     * @override
	     */
	    value: function shouldExcludeItem(row) {
	      if (row.key !== "networks.0.name") {
	        return false;
	      }
	
	      var appConfig = this.props.appConfig;
	
	      var networkName = (0, _Util.findNestedPropertyInObject)(appConfig, row.key);
	
	      return !networkName;
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "networking",
	        values: [{
	          heading: "Network",
	          headingLevel: 1
	        }, {
	          key: "networks.0.mode",
	          label: "Network Mode"
	        }, {
	          key: "networks.0.name",
	          label: "Network Name"
	        }, {
	          key: "portDefinitions",
	          render: function render(portDefinitions, appDefinition) {
	            var keys = {
	              name: "name",
	              port: "port",
	              protocol: "protocol",
	              labels: "labels",
	              service: "servicePort"
	            };
	
	            var networkType = (0, _Util.findNestedPropertyInObject)(appDefinition, "networks.0.mode");
	
	            var containerPortMappings = (0, _Util.findNestedPropertyInObject)(appDefinition, "container.portMappings");
	
	            if (containerPortMappings != null && containerPortMappings.length !== 0) {
	              portDefinitions = containerPortMappings;
	              keys.port = "hostPort";
	            }
	
	            // Make sure to have something to render, even if there is no data
	            if (!portDefinitions) {
	              portDefinitions = [];
	            }
	
	            var columns = [{
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Name"),
	              prop: keys.name,
	              render: function render(prop, row) {
	                return (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop]);
	              },
	
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Protocol"),
	              prop: keys.protocol,
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: function render(prop, row) {
	                var protocol = row[prop] || "";
	                protocol = protocol.replace(/,\s*/g, ", ");
	
	                return (0, _ServiceConfigDisplayUtil.getDisplayValue)(protocol);
	              },
	
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Host Port"),
	              prop: keys.port,
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: function render(prop, row) {
	                return appDefinition.requirePorts ? (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop]) : "Auto Assigned";
	              },
	
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Load Balanced Address"),
	              prop: "",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              render: function render(prop, row) {
	                var port = row.port,
	                    labels = row.labels;
	
	                var vipLabel = _ServiceConfigUtil2.default.findVIPLabel(labels);
	
	                if (vipLabel) {
	                  return _ServiceConfigUtil2.default.buildHostNameFromVipLabel(labels[vipLabel], port);
	                }
	
	                return _react2.default.createElement(
	                  "em",
	                  null,
	                  "Not Enabled"
	                );
	              },
	
	              sortable: true
	            }];
	
	            // We add the container port column if the network type is anything
	            // but HOST.
	            if (networkType !== _Networking2.default.type.HOST) {
	              var hostPortIndex = columns.findIndex(function (column) {
	                return column.prop === keys.port;
	              });
	
	              columns.splice(hostPortIndex, 0, {
	                heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Container Port"),
	                prop: "containerPort",
	                className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	                render: function render(prop, row) {
	                  return (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop]);
	                },
	
	                sortable: true
	              });
	            }
	
	            var containsServicePorts = portDefinitions.some(function (portDefinition) {
	              return portDefinition.servicePort != null && portDefinition.servicePort !== 0;
	            });
	
	            if (containsServicePorts) {
	              var _hostPortIndex = columns.findIndex(function (column) {
	                return column.prop === keys.port;
	              });
	              var servicePortsPosition = _hostPortIndex + 1;
	
	              columns.splice(servicePortsPosition, 0, {
	                heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Service Port"),
	                prop: keys.service,
	                className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	                render: function render(prop, row) {
	                  return (0, _ServiceConfigDisplayUtil.getDisplayValue)(row[prop]);
	                },
	
	                sortable: true
	              });
	            }
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "networking"
	                  });
	                }
	              });
	            }
	
	            if (_ValidatorUtil2.default.isEmpty(portDefinitions)) {
	              return;
	            }
	
	            return [_react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              {
	                key: "service-endpoints-heading",
	                level: 2
	              },
	              "Service Endpoints"
	            ), _react2.default.createElement(_reactjsComponents.Table, {
	              key: "service-endpoints",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: portDefinitions
	            })];
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceNetworkingConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceNetworkingConfigSection;

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapTable = __webpack_require__(1777);
	
	var _ConfigurationMapTable2 = _interopRequireDefault(_ConfigurationMapTable);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	var _PlacementConstraintsUtil2 = _interopRequireDefault(_PlacementConstraintsUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicePlacementConstraintsConfigSection = function (_React$Component) {
	  (0, _inherits3.default)(ServicePlacementConstraintsConfigSection, _React$Component);
	
	  function ServicePlacementConstraintsConfigSection() {
	    (0, _classCallCheck3.default)(this, ServicePlacementConstraintsConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServicePlacementConstraintsConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServicePlacementConstraintsConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServicePlacementConstraintsConfigSection, [{
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        heading: "Field Name",
	        prop: "fieldName"
	      }, {
	        heading: "Operator",
	        prop: "operator"
	      }, {
	        heading: "Value",
	        prop: "value"
	      }];
	    }
	  }, {
	    key: "getConstraints",
	    value: function getConstraints() {
	      var constraints = this.props.appConfig.constraints || [];
	
	      return constraints.map(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	            fieldName = _ref2[0],
	            operator = _ref2[1],
	            value = _ref2[2];
	
	        if (_PlacementConstraintsUtil2.default.requiresEmptyValue(operator)) {
	          value = _react2.default.createElement(
	            "em",
	            null,
	            "Not Applicable"
	          );
	        }
	
	        return { fieldName: fieldName, operator: operator, value: value };
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onEditClick = this.props.onEditClick;
	
	      var constraints = this.getConstraints();
	
	      // Since we are stateless component we will need to return something for react
	      // so we are using the `<noscript>` tag as placeholder.
	      if (!constraints.length) {
	        return _react2.default.createElement("noscript", null);
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 3 },
	          "Placement Constraints"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          null,
	          _react2.default.createElement(_ConfigurationMapTable2.default, {
	            columns: this.getColumns(),
	            data: constraints,
	            onEditClick: onEditClick,
	            tabViewID: "services"
	          })
	        )
	      );
	    }
	  }]);
	  return ServicePlacementConstraintsConfigSection;
	}(_react2.default.Component);
	
	ServicePlacementConstraintsConfigSection.defaultProps = {
	  appConfig: {}
	};
	
	ServicePlacementConstraintsConfigSection.propTypes = {
	  appConfig: _react2.default.PropTypes.object,
	  onEditClick: _react2.default.PropTypes.func
	};
	
	module.exports = ServicePlacementConstraintsConfigSection;

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Units = __webpack_require__(1400);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _ServiceConfigDisplayUtil = __webpack_require__(1736);
	
	var _ConfigurationMapEditAction = __webpack_require__(1771);
	
	var _ConfigurationMapEditAction2 = _interopRequireDefault(_ConfigurationMapEditAction);
	
	var _ServiceConfigBaseSectionDisplay = __webpack_require__(1787);
	
	var _ServiceConfigBaseSectionDisplay2 = _interopRequireDefault(_ServiceConfigBaseSectionDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceStorageConfigSection = function (_ServiceConfigBaseSec) {
	  (0, _inherits3.default)(ServiceStorageConfigSection, _ServiceConfigBaseSec);
	
	  function ServiceStorageConfigSection() {
	    (0, _classCallCheck3.default)(this, ServiceStorageConfigSection);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceStorageConfigSection.__proto__ || (0, _getPrototypeOf2.default)(ServiceStorageConfigSection)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceStorageConfigSection, [{
	    key: "shouldExcludeItem",
	
	    /**
	     * @override
	     */
	    value: function shouldExcludeItem() {
	      var appConfig = this.props.appConfig;
	
	
	      return !_Util2.default.findNestedPropertyInObject(appConfig, "container.volumes.length");
	    }
	
	    /**
	     * @override
	     */
	
	  }, {
	    key: "getDefinition",
	    value: function getDefinition() {
	      var onEditClick = this.props.onEditClick;
	
	
	      return {
	        tabViewID: "volumes",
	        values: [{
	          key: "container.volumes",
	          heading: "Storage",
	          headingLevel: 1
	        }, {
	          key: "container.volumes",
	          render: function render(volumes) {
	            if (volumes == null) {
	              return null;
	            }
	
	            var columns = [{
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Volume"),
	              prop: "volume",
	              render: function render(prop, row) {
	                var name = "";
	
	                if (row.name != null) {
	                  name = " (" + row.name + ")";
	                }
	
	                return "" + row.type.join(" ") + name;
	              },
	
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Size"),
	              prop: "size",
	              render: function render(prop, row) {
	                var value = row[prop];
	
	                if (value == null) {
	                  return (0, _ServiceConfigDisplayUtil.getDisplayValue)(value, row.isHostVolume);
	                }
	
	                if (row.type.join(" ") === "External" && !row.isHostVolume) {
	                  // External volumes specify size in GiB
	                  value = value * 1024;
	                }
	
	                return (0, _Units.formatResource)("disk", value);
	              },
	
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Mode"),
	              prop: "mode",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }, {
	              heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Container Mount Path"),
	              prop: "containerPath",
	              className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	              sortable: true
	            }];
	
	            var shouldDisplayHostPath = false;
	
	            var volumesData = volumes.map(function (appVolume) {
	              // We don't want to mutate the appVolume value.
	              var volume = {
	                name: null,
	                size: null,
	                type: [],
	                isHostVolume: false
	              };
	
	              volume.containerPath = appVolume.containerPath;
	              volume.mode = appVolume.mode;
	
	              if (appVolume.persistent != null) {
	                volume.size = appVolume.persistent.size;
	                volume.type.push("Persistent", "Local");
	              } else if (appVolume.external != null) {
	                volume.size = appVolume.external.size;
	                volume.type.push("External");
	              } else {
	                volume.isHostVolume = true;
	                volume.type.push("Host", "Volume");
	              }
	
	              if (appVolume.external != null) {
	                volume.name = appVolume.external.name;
	              }
	
	              if (appVolume.hostPath != null) {
	                // Set this flag to true so that we render the hostPath column.
	                shouldDisplayHostPath = true;
	              }
	
	              volume.hostPath = (0, _ServiceConfigDisplayUtil.getDisplayValue)(appVolume.hostPath, !volume.isHostVolume);
	
	              return volume;
	            });
	
	            if (shouldDisplayHostPath) {
	              columns.push({
	                heading: (0, _ServiceConfigDisplayUtil.getColumnHeadingFn)("Host Path"),
	                prop: "hostPath",
	                className: (0, _ServiceConfigDisplayUtil.getColumnClassNameFn)(),
	                sortable: true
	              });
	            }
	
	            if (onEditClick) {
	              columns.push({
	                heading: function heading() {
	                  return null;
	                },
	
	                className: "configuration-map-action",
	                prop: "edit",
	                render: function render() {
	                  return _react2.default.createElement(_ConfigurationMapEditAction2.default, {
	                    onEditClick: onEditClick,
	                    tabViewID: "volumes"
	                  });
	                }
	              });
	            }
	
	            return _react2.default.createElement(_reactjsComponents.Table, {
	              key: "service-volumes",
	              className: "table table-simple table-align-top table-break-word table-fixed-layout flush-bottom",
	              columns: columns,
	              data: volumesData
	            });
	          }
	        }]
	      };
	    }
	  }]);
	  return ServiceStorageConfigSection;
	}(_ServiceConfigBaseSectionDisplay2.default);
	
	module.exports = ServiceStorageConfigSection;

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Constraints = __webpack_require__(1795);
	
	var _Container = __webpack_require__(1689);
	
	var _EnvironmentVariables = __webpack_require__(1797);
	
	var _Artifacts = __webpack_require__(1798);
	
	var _HealthChecks = __webpack_require__(1799);
	
	var _Labels = __webpack_require__(1800);
	
	var _Residency = __webpack_require__(1801);
	
	var _RequirePorts = __webpack_require__(1802);
	
	var _PortDefinitions = __webpack_require__(1803);
	
	var _Networks = __webpack_require__(1805);
	
	module.exports = {
	  id: (0, _ReducerUtil.simpleReducer)("id"),
	  instances: (0, _ReducerUtil.simpleIntReducer)("instances"),
	  container: _Container.JSONReducer,
	  cpus: (0, _ReducerUtil.simpleFloatReducer)("cpus"),
	  mem: (0, _ReducerUtil.simpleIntReducer)("mem"),
	  disk: (0, _ReducerUtil.simpleFloatReducer)("disk"),
	  gpus: (0, _ReducerUtil.simpleFloatReducer)("gpus"),
	  cmd: (0, _ReducerUtil.simpleReducer)("cmd"),
	  constraints: _Constraints.JSONReducer,
	  env: _EnvironmentVariables.JSONReducer,
	  fetch: _Artifacts.JSONReducer,
	  healthChecks: _HealthChecks.JSONReducer,
	  labels: _Labels.JSONReducer,
	  networks: _Networks.JSONReducer,
	  portDefinitions: _PortDefinitions.JSONReducer,
	  requirePorts: _RequirePorts.JSONReducer,
	  residency: _Residency.JSONReducer
	};

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _Util = __webpack_require__(982);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _Constraints = __webpack_require__(1796);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, transaction) {
	    var constraints = _Constraints.JSONReducer.bind(this)(state, transaction);
	
	    return constraints.map(function (_ref) {
	      var fieldName = _ref.fieldName,
	          operator = _ref.operator,
	          value = _ref.value;
	
	      if (!(0, _ValidatorUtil.isEmpty)(value)) {
	        return [fieldName, operator, value];
	      }
	
	      return [fieldName, operator];
	    });
	  },
	  JSONParser: function JSONParser(state) {
	    var constraints = (0, _Util.findNestedPropertyInObject)(state, "constraints") || [];
	
	    if (!Array.isArray(constraints)) {
	      return [];
	    }
	
	    return (0, _Constraints.JSONParser)(constraints.reduce(function (memo, constraint) {
	      if (!Array.isArray(constraint)) {
	        return memo;
	      }
	
	      var _constraint = (0, _slicedToArray3.default)(constraint, 3),
	          fieldName = _constraint[0],
	          operator = _constraint[1],
	          value = _constraint[2];
	
	      memo.push({ fieldName: fieldName, operator: operator, value: value });
	
	      return memo;
	    }, []));
	  }
	};

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _PlacementConstraintsUtil = __webpack_require__(1714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONSTRAINT_FIELDS = ["fieldName", "operator", "value"];
	
	function processTransaction(state, _ref) {
	  var type = _ref.type,
	      path = _ref.path,
	      value = _ref.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 3),
	      fieldName = _path[0],
	      index = _path[1],
	      name = _path[2];
	
	  if (fieldName !== "constraints") {
	    return state;
	  }
	
	  var newState = state.slice();
	
	  if (type === _TransactionTypes.ADD_ITEM) {
	    newState.push({ fieldName: null, operator: null, value: null });
	  }
	  if (type === _TransactionTypes.REMOVE_ITEM) {
	    newState = newState.filter(function (item, index) {
	      return index !== value;
	    });
	  }
	  if (type === _TransactionTypes.SET && CONSTRAINT_FIELDS.includes(name) && !(0, _PlacementConstraintsUtil.requiresEmptyValue)(newState[index].operator)) {
	    newState[index][name] = value;
	  }
	
	  if (name === "operator" && (0, _PlacementConstraintsUtil.requiresEmptyValue)(value)) {
	    newState[index].value = null;
	  }
	
	  return newState;
	}
	
	module.exports = {
	  JSONParser: function JSONParser(constraints) {
	    // Ignore non-array constraints
	    if (!Array.isArray(constraints)) {
	      return [];
	    }
	
	    return constraints.reduce(function (memo, item, index) {
	      if ((typeof item === "undefined" ? "undefined" : (0, _typeof3.default)(item)) !== "object") {
	        return memo;
	      }
	
	      var fieldName = item.fieldName,
	          operator = item.operator,
	          value = item.value;
	
	      memo.push(new _Transaction2.default(["constraints"], null, _TransactionTypes.ADD_ITEM));
	      memo.push(new _Transaction2.default(["constraints", index, "fieldName"], fieldName, _TransactionTypes.SET));
	      memo.push(new _Transaction2.default(["constraints", index, "operator"], operator, _TransactionTypes.SET));
	
	      // Skip if value is not set
	      if (value != null) {
	        memo.push(new _Transaction2.default(["constraints", index, "value"], value, _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  },
	  JSONReducer: function JSONReducer(state, _ref2) {
	    var type = _ref2.type,
	        path = _ref2.path,
	        value = _ref2.value;
	
	    if (path == null) {
	      return state;
	    }
	    if (this.constraints == null) {
	      this.constraints = [];
	    }
	
	    this.constraints = processTransaction(this.constraints, {
	      type: type,
	      path: path,
	      value: value
	    });
	
	    return this.constraints.filter(function () {
	      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return !(0, _ValidatorUtil.isEmpty)(item.fieldName) && !(0, _ValidatorUtil.isEmpty)(item.operator);
	    }).map(function (_ref3) {
	      var fieldName = _ref3.fieldName,
	          operator = _ref3.operator,
	          value = _ref3.value;
	
	      return {
	        fieldName: fieldName,
	        value: value,
	        operator: operator.toUpperCase()
	      };
	    });
	  },
	  FormReducer: function FormReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref4 = arguments[1];
	    var type = _ref4.type,
	        path = _ref4.path,
	        value = _ref4.value;
	
	    if (path == null || !Array.isArray(state)) {
	      return state;
	    }
	
	    return processTransaction(state, { type: type, path: path, value: value });
	  }
	};

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, _ref) {
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.env == null) {
	      // `this` is a context which is given to every reducer so it could
	      // cache information.
	      // In this case we are caching an array structure and although the
	      // output structure is a object. But this enables us to not overwrite
	      // values if there are two values with the same key temporarily.
	      this.env = [];
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("env") !== -1) {
	      if (joinedPath === "env") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            this.env.push({ key: null, value: "" });
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            this.env = this.env.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return this.env.reduce(function (memo, item) {
	          if (item.key != null) {
	            memo[item.key] = item.value;
	          }
	
	          return memo;
	        }, {});
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET && "env." + index + ".key" === joinedPath) {
	        this.env[index].key = value;
	      }
	      if (type === _TransactionTypes.SET && "env." + index + ".value" === joinedPath) {
	        this.env[index].value = value;
	      }
	    }
	
	    return this.env.reduce(function (memo, item) {
	      if (item.key != null) {
	        memo[item.key] = item.value;
	      }
	
	      return memo;
	    }, {});
	  },
	  JSONParser: function JSONParser(state) {
	    if (state.env == null) {
	      return [];
	    }
	
	    return (0, _keys2.default)(state.env).filter(function (key) {
	      return state.env[key] == null || typeof state.env[key] === "string";
	    }).reduce(function (memo, key, index) {
	      /**
	       * For the environment variables which are a key => value based object
	       * we want to create a new item and fill it with the key and the
	       * value. So we need 3 transactions for each key value pair.
	       * 1) Add a new Item to the path with the index equal to index.
	       * 2) Set the key on the path `env.${index}.key`
	       * 3) Set the value on the path `env.${index}.value`
	       */
	      memo.push(new _Transaction2.default(["env"], index, _TransactionTypes.ADD_ITEM));
	      memo.push(new _Transaction2.default(["env", index, "key"], key, _TransactionTypes.SET));
	      if (typeof state.env[key] === "string") {
	        memo.push(new _Transaction2.default(["env", index, "value"], state.env[key], _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getJson(data) {
	  return data.filter(function (_ref) {
	    var uri = _ref.uri;
	    return !(0, _ValidatorUtil.isEmpty)(uri);
	  });
	}
	
	function processTransaction(state, _ref2) {
	  var type = _ref2.type,
	      path = _ref2.path,
	      value = _ref2.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 3),
	      field = _path[0],
	      index = _path[1],
	      name = _path[2];
	
	  if (field !== "fetch") {
	    return state;
	  }
	
	  var newState = state.slice();
	
	  if (type === _TransactionTypes.ADD_ITEM) {
	    newState.push(value || { uri: null });
	  }
	
	  if (type === _TransactionTypes.REMOVE_ITEM) {
	    newState = newState.filter(function (item, index) {
	      return index !== value;
	    });
	  }
	
	  if (type === _TransactionTypes.SET && index != null && name != null) {
	    newState[index][name] = value;
	  }
	
	  return newState;
	}
	
	module.exports = {
	  JSONParser: function JSONParser(state) {
	    if (state.fetch == null) {
	      return [];
	    }
	
	    return state.fetch.reduce(function (memo, item, index) {
	      memo.push(new _Transaction2.default(["fetch"], item, _TransactionTypes.ADD_ITEM));
	      (0, _keys2.default)(item).forEach(function (key) {
	        memo.push(new _Transaction2.default(["fetch", index, key], item[key], _TransactionTypes.SET));
	      });
	
	      return memo;
	    }, []);
	  },
	  JSONReducer: function JSONReducer(state, _ref3) {
	    var type = _ref3.type,
	        path = _ref3.path,
	        value = _ref3.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.fetch == null) {
	      this.fetch = [];
	    }
	
	    this.fetch = processTransaction(this.fetch, { type: type, path: path, value: value });
	
	    return getJson(this.fetch);
	  }
	};

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _HealthCheckProtocols = __webpack_require__(1700);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapHealthChecks(item) {
	  var newItem = _Util2.default.omit(item, ["path", "command", "protocol", "https"]);
	
	  if (item.protocol != null) {
	    newItem.protocol = item.protocol;
	    if (item.protocol.toUpperCase() === _HealthCheckProtocols.COMMAND && item.command != null) {
	      newItem.command = {
	        value: item.command
	      };
	    }
	
	    if (item.protocol.toUpperCase() !== _HealthCheckProtocols.COMMAND) {
	      newItem.path = item.path;
	    }
	  }
	
	  return newItem;
	}
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, _ref) {
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.healthChecks == null) {
	      // `this` is a context which is given to every reducer so it could
	      // cache information.
	      // In this case we are caching an array structure and although the
	      // output structure is a object. But this enables us to not overwrite
	      // values if there are two values with the same key temporarily.
	      this.healthChecks = [];
	    }
	
	    var joinedPath = path.join(".");
	
	    if (type === _TransactionTypes.REMOVE_ITEM && joinedPath === "portDefinitions") {
	      this.healthChecks = this.healthChecks.map(function (item) {
	        if (item.portIndex === value) {
	          return null;
	        }
	
	        if (item.portIndex > value) {
	          item.portIndex--;
	        }
	
	        return item;
	      }).filter(function (item) {
	        return item != null;
	      });
	    }
	
	    if (joinedPath.search("healthChecks") !== -1) {
	      if (joinedPath === "healthChecks") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            this.healthChecks.push(value || {});
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            this.healthChecks = this.healthChecks.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return this.healthChecks.map(mapHealthChecks);
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET) {
	        if ("healthChecks." + index + ".protocol" === joinedPath) {
	          this.healthChecks[index].protocol = value;
	          if (value === _HealthCheckProtocols.MESOS_HTTP && this.healthChecks[index].https) {
	            this.healthChecks[index].protocol = _HealthCheckProtocols.MESOS_HTTPS;
	          }
	        }
	        if ("healthChecks." + index + ".portIndex" === joinedPath) {
	          this.healthChecks[index].portIndex = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".command" === joinedPath) {
	          this.healthChecks[index].command = value;
	        }
	        if ("healthChecks." + index + ".path" === joinedPath) {
	          this.healthChecks[index].path = value;
	        }
	        if ("healthChecks." + index + ".gracePeriodSeconds" === joinedPath) {
	          this.healthChecks[index].gracePeriodSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".intervalSeconds" === joinedPath) {
	          this.healthChecks[index].intervalSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".timeoutSeconds" === joinedPath) {
	          this.healthChecks[index].timeoutSeconds = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".maxConsecutiveFailures" === joinedPath) {
	          this.healthChecks[index].maxConsecutiveFailures = (0, _ReducerUtil.parseIntValue)(value);
	        }
	        if ("healthChecks." + index + ".https" === joinedPath) {
	          this.healthChecks[index].https = value;
	          if (value === true) {
	            this.healthChecks[index].protocol = _HealthCheckProtocols.MESOS_HTTPS;
	          } else {
	            this.healthChecks[index].protocol = _HealthCheckProtocols.MESOS_HTTP;
	          }
	        }
	      }
	    }
	
	    return this.healthChecks.map(mapHealthChecks);
	  },
	  JSONParser: function JSONParser(state) {
	    if (state.healthChecks == null) {
	      return [];
	    }
	
	    return state.healthChecks.reduce(function (memo, item, index) {
	      if (item.protocol == null) {
	        return memo;
	      }
	      memo.push(new _Transaction2.default(["healthChecks"], item, _TransactionTypes.ADD_ITEM));
	      memo.push(new _Transaction2.default(["healthChecks", index, "protocol"], item.protocol.toUpperCase(), _TransactionTypes.SET));
	      if (item.protocol.toUpperCase() === _HealthCheckProtocols.COMMAND) {
	        if (item.command != null && item.command.value != null) {
	          memo.push(new _Transaction2.default(["healthChecks", index, "command"], item.command.value, _TransactionTypes.SET));
	        }
	      }
	      if (item.protocol.toUpperCase().replace(_HealthCheckProtocols.MESOS_HTTPS, _HealthCheckProtocols.MESOS_HTTP) === _HealthCheckProtocols.MESOS_HTTP) {
	        if (item.protocol === _HealthCheckProtocols.MESOS_HTTPS) {
	          memo.push(new _Transaction2.default(["healthChecks", index, "https"], true, _TransactionTypes.SET));
	        }
	      }
	      ["path", "portIndex", "gracePeriodSeconds", "intervalSeconds", "timeoutSeconds", "maxConsecutiveFailures"].forEach(function (key) {
	        if (item[key] != null) {
	          memo.push(new _Transaction2.default(["healthChecks", index, key], item[key], _TransactionTypes.SET));
	        }
	      });
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, _ref) {
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.labels == null) {
	      // `this` is referring to a context which is given to every reducer so
	      // it can cache information.
	      // In this case we are caching an array structure and although the
	      // output structure is a object. But this enables us to not overwrite
	      // values if there are two values with the same key temporarily.
	      this.labels = [];
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("labels") !== -1) {
	      if (joinedPath === "labels") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            this.labels.push({ key: null, value: "" });
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            this.labels = this.labels.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	
	        return this.labels.reduce(function (memo, item) {
	          if (item.key != null) {
	            memo[item.key] = item.value;
	          }
	
	          return memo;
	        }, {});
	      }
	
	      var index = joinedPath.match(/\d+/)[0];
	      if (type === _TransactionTypes.SET && "labels." + index + ".key" === joinedPath) {
	        this.labels[index].key = value;
	      }
	      if (type === _TransactionTypes.SET && "labels." + index + ".value" === joinedPath) {
	        this.labels[index].value = value;
	      }
	    }
	
	    return this.labels.reduce(function (memo, item) {
	      if (item.key != null) {
	        memo[item.key] = item.value;
	      }
	
	      return memo;
	    }, {});
	  },
	  JSONParser: function JSONParser(state) {
	    if (state.labels == null) {
	      return [];
	    }
	
	    return (0, _keys2.default)(state.labels).reduce(function (memo, key, index) {
	      /**
	       * For the labels which are a key => value based object we want to
	       * create a new item and fill it with the key and the value. So we
	       * need 3 transactions for each key value pair.
	       * 1) Add a new Item to the path with the index equal to index.
	       * 2) Set the key on the path `labels.${index}.key`
	       * 3) Set the value on the path `labels.${index}.value`
	       */
	      memo.push(new _Transaction2.default(["labels"], index, _TransactionTypes.ADD_ITEM));
	      memo.push(new _Transaction2.default(["labels", index, "key"], key, _TransactionTypes.SET));
	      memo.push(new _Transaction2.default(["labels", index, "value"], state.labels[key], _TransactionTypes.SET));
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, _ref) {
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.localVolumes == null) {
	      this.localVolumes = [];
	    }
	
	    var joinedPath = path.join(".");
	
	    if (joinedPath.search("localVolumes") !== -1) {
	      if (joinedPath === "localVolumes") {
	        switch (type) {
	          case _TransactionTypes.ADD_ITEM:
	            this.localVolumes.push(false);
	            break;
	          case _TransactionTypes.REMOVE_ITEM:
	            this.localVolumes = this.localVolumes.filter(function (item, index) {
	              return index !== value;
	            });
	            break;
	        }
	      }
	      var index = path[1];
	      if (type === _TransactionTypes.SET && "localVolumes." + index + ".type" === joinedPath) {
	        this.localVolumes[index] = value === "PERSISTENT";
	      }
	
	      var hasLocalVolumes = this.localVolumes.find(function (value) {
	        return value;
	      });
	      if (hasLocalVolumes && this.residency == null) {
	        return {
	          relaunchEscalationTimeoutSeconds: 10,
	          taskLostBehavior: "WAIT_FOREVER"
	        };
	      } else if (!hasLocalVolumes) {
	        return;
	      } else {
	        return this.residency;
	      }
	    }
	    if (type === _TransactionTypes.SET && joinedPath === "residency") {
	      this.residency = value;
	
	      return value;
	    }
	
	    return state;
	  },
	  JSONParser: function JSONParser(state) {
	    if (state.residency == null) {
	      return [];
	    }
	
	    return new _Transaction2.default(["residency"], state.residency);
	  }
	};

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(state, _ref) {
	    var path = _ref.path,
	        type = _ref.type,
	        value = _ref.value;
	
	    var _path = (0, _slicedToArray3.default)(path, 1),
	        base = _path[0];
	
	    if (base === "portsAutoAssign" && type === _TransactionTypes.SET) {
	      return !value;
	    }
	
	    return state;
	  },
	  JSONParser: function JSONParser(state) {
	    return new _Transaction2.default(["portsAutoAssign"], !state.requirePorts);
	  }
	};

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _Util = __webpack_require__(982);
	
	var _PortDefinitionsReducer = __webpack_require__(1804);
	
	var _PortDefinitionsReducer2 = _interopRequireDefault(_PortDefinitionsReducer);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	var _VipLabelUtil = __webpack_require__(1695);
	
	var _VipLabelUtil2 = _interopRequireDefault(_VipLabelUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HOST = _Networking2.default.type.HOST;
	
	
	module.exports = {
	  /**
	   * Creates portDefinitions for the JSON Editor. Only returns definitions for
	   * network type HOST, but will still record changes if network is
	   * something else
	   * @param {Object[]} state Initial state to apply action on
	   * @param {Object} action
	   * @param {(ADD_ITEM|REMOVE_ITEM|SET)} action.type - action to perform
	   * @param {String[]} action.path - location of value
	   * @param {*} action.value - value to perform action with
	   * @return {Object[]} new portDefinitions with action performed on it
	   */
	  JSONReducer: function JSONReducer() {
	    var _this = this;
	
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	    var path = action.path,
	        value = action.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (!this.appState) {
	      this.appState = {
	        id: "",
	        networkType: HOST
	      };
	    }
	
	    var joinedPath = path.join(".");
	    if (joinedPath === "networks.0.network" && value != null) {
	      var _value$split = value.split("."),
	          _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	          mode = _value$split2[0],
	          _name = _value$split2[1];
	
	      this.appState.networkType = mode;
	    }
	    if (joinedPath === "networks.0.mode" && value != null) {
	      this.appState.networkType = value;
	    }
	
	    if (joinedPath === "id" && value != null) {
	      this.appState.id = value;
	    }
	
	    if (joinedPath === "portsAutoAssign" && value != null) {
	      this.appState.portsAutoAssign = value;
	    }
	
	    // Apply PortDefinitionsReducer to retrieve updated local state
	    // Store the change no matter what network type we have
	    this.portDefinitions = (0, _PortDefinitionsReducer2.default)(this.portDefinitions, action);
	
	    // We only want portDefinitions for networks of type HOST
	    if (this.appState.networkType !== HOST) {
	      return null;
	    }
	
	    // Create JSON port definitions from state
	    return this.portDefinitions.map(function (portDefinition, index) {
	      var name = portDefinition.name;
	
	      var vipLabel = "VIP_" + index;
	      var hostPort = portDefinition.hostPort ? Number(portDefinition.hostPort) : 0;
	      var defaultVipPort = hostPort !== 0 ? hostPort : null;
	      var vipPort = portDefinition.vipPort || defaultVipPort;
	
	      var protocol = null;
	      if (portDefinition.protocol) {
	        protocol = _PortDefinitionConstants.PROTOCOLS.filter(function (protocol) {
	          return portDefinition.protocol[protocol];
	        }).join(",");
	      }
	
	      var labels = _VipLabelUtil2.default.generateVipLabel(_this.appState.id, portDefinition, vipLabel, vipPort);
	
	      return {
	        labels: labels,
	        name: name,
	        protocol: protocol,
	        port: hostPort
	      };
	    });
	  },
	
	
	  /**
	   * Parses a configuration and produces necessary Transactions for a Batch
	   * to create an equal JSON configuration
	   * @param {Object[]} state - Initial state to apply action on
	   * @return {Transaction[]} Array of Transactions to produce
	   * given configuration
	   */
	  JSONParser: function JSONParser(state) {
	    if (state.portDefinitions == null) {
	      return [];
	    }
	
	    // Look at portDefinitions and add accepted fields
	    return state.portDefinitions.reduce(function (memo, item, index) {
	      memo.push(new _Transaction2.default(["portDefinitions"], item, _TransactionTypes.ADD_ITEM));
	
	      if (item.name != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "name"], item.name, _TransactionTypes.SET));
	      }
	
	      var port = Number(item.port);
	      if (!isNaN(port)) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "hostPort"], port, _TransactionTypes.SET));
	      }
	
	      if (item.protocol != null) {
	        var protocols = item.protocol.split(",");
	        _PortDefinitionConstants.PROTOCOLS.forEach(function (protocol) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "protocol", protocol], protocols.includes(protocol), _TransactionTypes.SET));
	        });
	      }
	
	      var vip = (0, _Util.findNestedPropertyInObject)(item, "labels.VIP_" + index);
	      if (vip != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "loadBalanced"], true, _TransactionTypes.SET));
	
	        if (!vip.startsWith(state.id + ":")) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "vip"], vip, _TransactionTypes.SET));
	        }
	
	        var vipPortMatch = vip.match(/.+:(\d+)/);
	        if (vipPortMatch) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "vipPort"], vipPortMatch[1], _TransactionTypes.SET));
	        }
	      }
	
	      if (item.labels != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "labels"], item.labels, _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = ["hostPort", "labels", "loadBalanced", "name", "servicePort", "vip", "vipPort"];
	
	function transformPortDefinition(definition) {
	  if (definition != null && definition.protocol != null && typeof definition.protocol === "string") {
	    definition.protocol = {
	      tcp: definition.protocol.search("tcp"),
	      udp: definition.protocol.search("udp")
	    };
	  }
	
	  return definition;
	}
	
	/**
	 * @param {Object[]} state
	 * @param {Object} action
	 * @param {(ADD_ITEM|REMOVE_ITEM|SET)} action.type - action to perform
	 * @param {String[]} action.path - location of value
	 * @param {*} action.value - value to perform action with
	 * @return {Object[]} new portDefinitions with action performed on it
	 */
	function PortDefinitionsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var type = action.type,
	      _action$path = action.path,
	      path = _action$path === undefined ? [] : _action$path,
	      value = action.value;
	
	  var _path = (0, _slicedToArray3.default)(path, 4),
	      base = _path[0],
	      index = _path[1],
	      field = _path[2],
	      subfield = _path[3];
	
	  var joinedPath = path.join(".");
	
	  if (base === "portDefinitions") {
	    if (joinedPath === "portDefinitions") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          var definition = {
	            hostPort: null,
	            labels: null,
	            loadBalanced: false,
	            name: null,
	            protocol: {
	              tcp: false,
	              udp: false
	            },
	            servicePort: null,
	            vip: null,
	            vipPort: null
	          };
	          var defaults = { protocol: { tcp: true } };
	
	          state.push((0, _assign2.default)(definition, transformPortDefinition(value) || defaults));
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          state = state.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	    }
	
	    if (index != null && type === _TransactionTypes.SET) {
	      if (FIELDS.includes(field)) {
	        state[index][field] = value;
	      }
	
	      if (field === "protocol" && _PortDefinitionConstants.PROTOCOLS.includes(subfield)) {
	        if (state[index].protocol == null) {
	          state[index].protocol = {};
	        }
	
	        state[index].protocol[subfield] = value;
	      }
	    }
	  }
	
	  return state;
	}
	
	module.exports = PortDefinitionsReducer;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONTAINER = _Networking2.default.type.CONTAINER;
	
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    if (this.networks == null) {
	      this.networks = [];
	    }
	
	    var _path = (0, _slicedToArray3.default)(path, 3),
	        base = _path[0],
	        index = _path[1],
	        field = _path[2];
	
	    if (base === "networks") {
	      if (type === _TransactionTypes.ADD_ITEM) {
	        this.networks.push(value || {});
	      }
	      if (type === _TransactionTypes.REMOVE_ITEM) {
	        this.networks = this.networks.filter(function (item, index) {
	          return index !== value;
	        });
	      }
	      if (type === _TransactionTypes.SET && field === "network") {
	        var _value$split = value.split("."),
	            _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	            mode = _value$split2[0],
	            name = _value$split2[1];
	
	        this.networks[index] = {};
	        this.networks[index].mode = mode;
	        this.networks[index].name = name;
	      }
	      if (type === _TransactionTypes.SET && field === "name") {
	        this.networks[index].name = value;
	      }
	      if (type === _TransactionTypes.SET && field === "mode") {
	        this.networks[index].mode = value;
	      }
	    }
	
	    return this.networks.map(function (network) {
	      return (0, _assign2.default)({}, network, {
	        mode: _Networking2.default.internalToJson[network.mode]
	      });
	    });
	  },
	  JSONParser: function JSONParser(state) {
	    var transactions = (state.networks || []).reduce(function (memo, network, index) {
	      var name = network.name;
	      var mode = name != null ? CONTAINER : network.mode;
	
	      memo = memo.concat(new _Transaction2.default(["networks"], network, _TransactionTypes.ADD_ITEM));
	
	      if (mode == null && name == null) {
	        return memo;
	      }
	
	      if (name != null) {
	        memo = memo.concat(new _Transaction2.default(["networks", index, "name"], name));
	      }
	      if (mode != null) {
	        var internalMode = _Networking2.default.jsonToInternal[mode.toLowerCase()];
	
	        memo = memo.concat(new _Transaction2.default(["networks", index, "mode"], internalMode));
	      }
	
	      return memo;
	    }, []);
	
	    return transactions;
	  }
	};

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ParserUtil = __webpack_require__(1662);
	
	var _MultiContainerConstraints = __webpack_require__(1807);
	
	var _Artifacts = __webpack_require__(1798);
	
	var _MultiContainerEnvironmentVariables = __webpack_require__(1808);
	
	var _ExternalVolumes = __webpack_require__(1809);
	
	var _HealthChecks = __webpack_require__(1799);
	
	var _LocalVolumes = __webpack_require__(1810);
	
	var _Labels = __webpack_require__(1800);
	
	var _PortDefinitions = __webpack_require__(1803);
	
	var _PortMappings = __webpack_require__(1811);
	
	var _Residency = __webpack_require__(1801);
	
	var _MultiContainerScaling = __webpack_require__(1812);
	
	var _Networks = __webpack_require__(1805);
	
	var _MultiContainerNetwork = __webpack_require__(1751);
	
	var _MultiContainerVolumes = __webpack_require__(1755);
	
	var _Containers = __webpack_require__(1813);
	
	module.exports = [(0, _ParserUtil.simpleParser)(["id"]), (0, _ParserUtil.simpleParser)(["instances"]), (0, _ParserUtil.simpleParser)(["cpus"]), (0, _ParserUtil.simpleParser)(["mem"]), (0, _ParserUtil.simpleParser)(["disk"]), (0, _ParserUtil.simpleParser)(["gpus"]), (0, _ParserUtil.simpleParser)(["cmd"]), _MultiContainerConstraints.JSONParser, _Containers.JSONParser, _MultiContainerEnvironmentVariables.JSONParser, _ExternalVolumes.JSONParser, _Artifacts.JSONParser, _HealthChecks.JSONParser, _Labels.JSONParser, _LocalVolumes.JSONParser, _MultiContainerNetwork.JSONParser, _Networks.JSONParser, _PortDefinitions.JSONParser, _PortMappings.JSONParser, // Note: must come after portDefinitions, as it uses its information!
	_Residency.JSONParser, _MultiContainerScaling.JSONParser, _MultiContainerVolumes.JSONParser];

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Util = __webpack_require__(982);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _Constraints = __webpack_require__(1796);
	
	module.exports = {
	  FormReducer: _Constraints.FormReducer,
	  JSONReducer: function JSONReducer(state, transaction) {
	    var constraints = _Constraints.JSONReducer.bind(this)(state, transaction);
	
	    return constraints.map(function (_ref) {
	      var fieldName = _ref.fieldName,
	          operator = _ref.operator,
	          value = _ref.value;
	
	      if (!(0, _ValidatorUtil.isEmpty)(value)) {
	        return { fieldName: fieldName, operator: operator, value: value };
	      }
	
	      return { fieldName: fieldName, operator: operator };
	    });
	  },
	  JSONParser: function JSONParser(state) {
	    var constraints = (0, _Util.findNestedPropertyInObject)(state, "scheduling.placement.constraints");
	
	    return (0, _Constraints.JSONParser)(constraints);
	  }
	};

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONParser: function JSONParser(state) {
	    if (state.environment == null) {
	      return [];
	    }
	
	    return (0, _keys2.default)(state.environment).filter(function (key) {
	      return state.environment[key] == null || typeof state.environment[key] === "string";
	    }).reduce(function (memo, key, index) {
	      /**
	       * For the environment variables which are a key => value based object
	       * we want to create a new item and fill it with the key and the
	       * value. So we need 3 transactions for each key value pair.
	       * 1) Add a new Item to the path with the index equal to index.
	       * 2) Set the key on the path `env.${index}.key`
	       * 3) Set the value on the path `env.${index}.value`
	       */
	      memo.push(new _Transaction2.default(["env"], index, _TransactionTypes.ADD_ITEM));
	      memo.push(new _Transaction2.default(["env", index, "key"], key, _TransactionTypes.SET));
	      if (typeof state.environment[key] === "string") {
	        memo.push(new _Transaction2.default(["env", index, "value"], state.environment[key], _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONParser: function JSONParser(state) {
	    if (state.container == null || state.container.volumes == null) {
	      return [];
	    }
	
	    return state.container.volumes.filter(function (item) {
	      return item.external != null;
	    }).reduce(function (memo, item, index) {
	      /**
	      * For the externalVolumes we have a special case as all the volumes
	      * are present in the `container.volumes` But in this parser we only
	      * want to parse the external volumes. Which means that we first filter
	      * those and only keep external volumes (decision based on if
	      * external is set). After that we do get all the values even
	      * stuff which we do not handle in the form yet. These steps are:
	      * 1) Add a new Item to the path with the index equal to index.
	      * 2) Set the name from `volume.external.name`on the path
	      *    `externalVolumes.${index}.name`.
	      * 3) Set the containerPath from `volume.containerPath on the path
	      *    `externalVolumes.${index}.containerPath`
	      * 4) Set the provider from `volume.external.provider` on the path
	      *    `externalVolumes.${index}.provider`
	      * 5) Set the options from `volume.external.options` on the path
	      *    `externalVolumes.${index}.options`
	      * 6) Set the mode from `volume.mode` on the path
	      *    `externalVolumes.${index}.mode`
	      */
	      memo.push(new _Transaction2.default(["externalVolumes"], item, _TransactionTypes.ADD_ITEM));
	
	      if (item.external.name != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "name"], item.external.name, _TransactionTypes.SET));
	      }
	
	      if (item.external.size != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "size"], item.external.size, _TransactionTypes.SET));
	      }
	
	      if (item.containerPath != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "containerPath"], item.containerPath, _TransactionTypes.SET));
	      }
	
	      if (item.external.provider != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "provider"], item.external.provider, _TransactionTypes.SET));
	      }
	
	      if (item.external.options != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "options"], item.external.options, _TransactionTypes.SET));
	      }
	      if (item.mode != null) {
	        memo.push(new _Transaction2.default(["externalVolumes", index, "mode"], item.mode, _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONParser: function JSONParser(state) {
	    if (state.container == null || state.container.volumes == null) {
	      return [];
	    }
	
	    return state.container.volumes.filter(function (item) {
	      return item.hostPath != null || item.persistent != null;
	    }).reduce(function (memo, item, index) {
	      /**
	       * For the localVolumes we have a special case as all the volumes
	       * are present in the `container.volumes` But in this parser we only
	       * want to parse the local volumes. which means that we first filter
	       * those and only keep local volumes (decision based on if
	       * persistent or hostPath is set). After that we do get all the values even
	       * stuff which we do not handle in the form yet. These steps are:
	       * 1) Add a new Item to the path with the index equal to index.
	       * 2) Set the size from `volume.persistent.size`on the path
	       *    `localVolumes.${index}.size`.
	       * 3) Set the containerPath from `volume.containerPath on the path
	       *    `localVolumes.${index}.containerPath`
	       * 4) Set the mode from `volume.mode` on the path
	       *    `localVolumes.${index}.mode`
	       */
	      memo.push(new _Transaction2.default(["localVolumes"], item, _TransactionTypes.ADD_ITEM));
	
	      if (item.persistent != null && item.persistent.size != null) {
	        memo.push(new _Transaction2.default(["localVolumes", index, "type"], "PERSISTENT", _TransactionTypes.SET));
	
	        memo.push(new _Transaction2.default(["localVolumes", index, "size"], item.persistent.size, _TransactionTypes.SET));
	      } else {
	        memo.push(new _Transaction2.default(["localVolumes", index, "type"], "HOST", _TransactionTypes.SET));
	
	        memo.push(new _Transaction2.default(["localVolumes", index, "hostPath"], item.hostPath || "", _TransactionTypes.SET));
	      }
	
	      if (item.containerPath != null) {
	        memo.push(new _Transaction2.default(["localVolumes", index, "containerPath"], item.containerPath, _TransactionTypes.SET));
	      }
	
	      if (item.mode != null) {
	        memo.push(new _Transaction2.default(["localVolumes", index, "mode"], item.mode, _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, []);
	  }
	};

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _from = __webpack_require__(1018);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _Util = __webpack_require__(982);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  /**
	   * This parser must take precedence over PortDefinition parser, as it assumes
	   * some data available from it
	   * @param {Object} state current appConfig
	   * @returns {Transaction[]} A list of transactions resulting _portDefinition_
	   * settings. NOT portMappings! The source of truth is portDefinitions, but
	   * portMapping takes precedence.
	   */
	  JSONParser: function JSONParser(state) {
	    var portMappings = (0, _Util.findNestedPropertyInObject)(state, "container.portMappings") || [];
	    var portDefinitionsLength = (0, _Util.findNestedPropertyInObject)(state, "portDefinitions.length") || 0;
	
	    // Add additional fields if we have more definitions in portMappings
	    // than in portDefinitions
	    var length = portMappings.length - portDefinitionsLength;
	    var addTransactions = [];
	    (0, _from2.default)({ length: length }).forEach(function () {
	      addTransactions.push(new _Transaction2.default(["portDefinitions"], null, _TransactionTypes.ADD_ITEM));
	    });
	
	    // Look at portMappings and add accepted fields
	    // but translate them into portDefinitions
	    return portMappings.reduce(function (memo, item, index) {
	      if (item.name != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "name"], item.name, _TransactionTypes.SET));
	      }
	
	      // If port is a number but not zero, we set automaticPort to false
	      // so we can set the port and portMapping to true,
	      // since we have a host port
	      var hostPort = Number(item.hostPort);
	      if (!isNaN(hostPort) && hostPort !== 0) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "automaticPort"], false, _TransactionTypes.SET));
	
	        memo.push(new _Transaction2.default(["portDefinitions", index, "portMapping"], true, _TransactionTypes.SET));
	
	        memo.push(new _Transaction2.default(["portDefinitions", index, "hostPort"], hostPort, _TransactionTypes.SET));
	      }
	
	      // If port is zero, we set automaticPort to true and portMapping to true,
	      // since we have a host port
	      if (!isNaN(hostPort) && hostPort === 0) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "automaticPort"], true, _TransactionTypes.SET));
	
	        memo.push(new _Transaction2.default(["portDefinitions", index, "portMapping"], true, _TransactionTypes.SET));
	      }
	
	      // If port is not set, we set portMapping to false
	      if (isNaN(hostPort)) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "portMapping"], false, _TransactionTypes.SET));
	      }
	
	      var containerPort = Number(item.containerPort);
	      if (!isNaN(containerPort)) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "containerPort"], containerPort, _TransactionTypes.SET));
	      }
	
	      var servicePort = Number(item.servicePort);
	      if (!isNaN(servicePort)) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "servicePort"], servicePort, _TransactionTypes.SET));
	      }
	
	      if (item.protocol != null) {
	        var protocols = item.protocol.split(",");
	        _PortDefinitionConstants.PROTOCOLS.forEach(function (protocol) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "protocol", protocol], protocols.includes(protocol), _TransactionTypes.SET));
	        });
	      }
	
	      var vip = (0, _Util.findNestedPropertyInObject)(item, "labels.VIP_" + index);
	      if (vip != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "loadBalanced"], true, _TransactionTypes.SET));
	
	        if (!vip.startsWith(state.id + ":")) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "vip"], vip, _TransactionTypes.SET));
	        }
	
	        var vipPortMatch = vip.match(/.+:(\d+)/);
	        if (vipPortMatch) {
	          memo.push(new _Transaction2.default(["portDefinitions", index, "vipPort"], vipPortMatch[1], _TransactionTypes.SET));
	        }
	      }
	
	      if (item.labels != null) {
	        memo.push(new _Transaction2.default(["portDefinitions", index, "labels"], item.labels, _TransactionTypes.SET));
	      }
	
	      return memo;
	    }, addTransactions);
	  }
	};

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    if (path == null) {
	      return state;
	    }
	
	    var joinedPath = path.join(".");
	    if (this.internalState == null) {
	      this.internalState = {
	        instances: 1,
	        kind: "fixed"
	      };
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "instances") {
	      this.internalState.instances = parseInt(value, 10);
	      if (!this.internalState.instances) {
	        return null;
	      }
	
	      return this.internalState;
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "scaling.kind") {
	      this.internalState.kind = value;
	      if (!this.internalState.instances) {
	        return null;
	      }
	
	      return this.internalState;
	    }
	
	    return state;
	  },
	  JSONParser: function JSONParser(state) {
	    if (state.scaling == null) {
	      return [];
	    }
	
	    var transactions = [];
	    if (state.scaling.instances) {
	      transactions.push(new _Transaction2.default(["instances"], state.scaling.instances));
	    }
	    if (state.scaling.kind) {
	      transactions.push(new _Transaction2.default(["scaling", "kind"], state.scaling.kind));
	    }
	
	    return transactions;
	  }
	};

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _Util = __webpack_require__(982);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _Networking = __webpack_require__(1690);
	
	var _Networking2 = _interopRequireDefault(_Networking);
	
	var _DefaultPod = __webpack_require__(1683);
	
	var _MultiContainerVolumeMounts = __webpack_require__(1814);
	
	var _Endpoints = __webpack_require__(1815);
	
	var _MultiContainerArtifacts = __webpack_require__(1816);
	
	var _MultiContainerHealthChecks = __webpack_require__(1699);
	
	var _PortDefinitionConstants = __webpack_require__(1692);
	
	var _VipLabelUtil = __webpack_require__(1695);
	
	var _VipLabelUtil2 = _interopRequireDefault(_VipLabelUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Networking$type = _Networking2.default.type,
	    CONTAINER = _Networking$type.CONTAINER,
	    HOST = _Networking$type.HOST;
	
	
	var containerFloatReducer = (0, _ReducerUtil.combineReducers)({
	  cpus: (0, _ReducerUtil.simpleFloatReducer)("resources.cpus"),
	  mem: (0, _ReducerUtil.simpleFloatReducer)("resources.mem"),
	  disk: (0, _ReducerUtil.simpleFloatReducer)("resources.disk")
	});
	
	function mapEndpoints() {
	  var endpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var networkType = arguments[1];
	  var appState = arguments[2];
	
	  return endpoints.map(function (endpoint, index) {
	    var name = endpoint.name,
	        hostPort = endpoint.hostPort,
	        containerPort = endpoint.containerPort,
	        automaticPort = endpoint.automaticPort,
	        protocol = endpoint.protocol,
	        vipPort = endpoint.vipPort,
	        labels = endpoint.labels;
	
	
	    var vipLabel = "VIP_" + index;
	
	    protocol = (0, _keys2.default)(protocol).filter(function (key) {
	      return protocol[key];
	    });
	
	    if (automaticPort) {
	      hostPort = 0;
	    }
	
	    labels = _VipLabelUtil2.default.generateVipLabel(appState.id, endpoint, vipLabel, vipPort || containerPort || hostPort);
	
	    if (networkType === CONTAINER) {
	      return {
	        name: name,
	        containerPort: containerPort,
	        hostPort: hostPort,
	        protocol: protocol,
	        labels: labels
	      };
	    }
	
	    return {
	      name: name,
	      hostPort: hostPort,
	      protocol: protocol,
	      labels: labels
	    };
	  });
	}
	
	function containersParser(state) {
	  if (state == null || state.containers == null) {
	    return [];
	  }
	
	  return state.containers.reduce(function (memo, item, index) {
	    memo.push(new _Transaction2.default(["containers"], item, _TransactionTypes.ADD_ITEM));
	    if (item.name) {
	      memo.push(new _Transaction2.default(["containers", index, "name"], item.name));
	    }
	
	    if (item.image) {
	      memo.push(new _Transaction2.default(["containers", index, "image"], item.image));
	    }
	    if (item.image && item.image.id) {
	      memo.push(new _Transaction2.default(["containers", index, "image", "id"], item.image.id));
	    }
	    if (item.image && item.image.forcePull) {
	      memo.push(new _Transaction2.default(["containers", index, "image", "forcePull"], item.image.forcePull));
	    }
	    if (item.resources != null) {
	      var resources = item.resources;
	
	      if (resources.cpus != null) {
	        memo.push(new _Transaction2.default(["containers", index, "resources", "cpus"], resources.cpus));
	      }
	      if (resources.mem != null) {
	        memo.push(new _Transaction2.default(["containers", index, "resources", "mem"], resources.mem));
	      }
	      if (resources.disk != null) {
	        memo.push(new _Transaction2.default(["containers", index, "resources", "disk"], resources.disk));
	      }
	    }
	
	    if (item.privileged != null) {
	      memo.push(new _Transaction2.default(["containers", index, "privileged"], item.privileged));
	    }
	
	    if (item.healthCheck != null) {
	      memo = memo.concat((0, _MultiContainerHealthChecks.JSONSegmentParser)(item.healthCheck, ["containers", index, "healthCheck"]));
	    }
	
	    if (item.artifacts != null && item.artifacts.length !== 0) {
	      item.artifacts.forEach(function (artifact, artifactIndex) {
	        memo.push(new _Transaction2.default(["containers", index, "artifacts"], artifact, _TransactionTypes.ADD_ITEM));
	        if (artifact == null || (typeof artifact === "undefined" ? "undefined" : (0, _typeof3.default)(artifact)) !== "object") {
	          return;
	        }
	
	        memo = memo.concat((0, _keys2.default)(artifact).map(function (key) {
	          return new _Transaction2.default(["containers", index, "artifacts", artifactIndex, key], artifact[key]);
	        }));
	      });
	    }
	
	    if (item.endpoints != null && item.endpoints.length !== 0) {
	      var networkMode = (0, _Util.findNestedPropertyInObject)(state, "networks.0.mode");
	
	      item.endpoints.forEach(function (_endpoint, endpointIndex) {
	        var endpoint = (0, _assign2.default)({}, _endpoint);
	        // Internal representation of protocols field differs from the JSON
	        // Thus we need to delete the field from the ADD_ITEM value so that
	        // JSONReducer isn't confused by it
	        var endpointProtocol = endpoint.protocol;
	        delete endpoint["protocol"];
	
	        memo = memo.concat([new _Transaction2.default(["containers", index, "endpoints"], endpoint, _TransactionTypes.ADD_ITEM), new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "hostPort"], endpoint.hostPort), new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "automaticPort"], endpoint.hostPort === 0), new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "servicePort"], endpoint.servicePort === 0), new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "name"], endpoint.name)]);
	
	        if (endpoint.labels != null) {
	          memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "labels"], endpoint.labels));
	        }
	
	        if (networkMode === CONTAINER.toLowerCase()) {
	          memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "containerPort"], endpoint.containerPort));
	        }
	
	        var vip = (0, _Util.findNestedPropertyInObject)(endpoint, "labels.VIP_" + endpointIndex);
	
	        if (vip != null) {
	          memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "loadBalanced"], true));
	
	          if (!vip.startsWith(state.id + ":")) {
	            memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "vip"], vip));
	          }
	
	          var vipPortMatch = vip.match(/.+:(\d+)/);
	          if (vipPortMatch) {
	            memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "vipPort"], vipPortMatch[1]));
	          }
	        }
	
	        var protocols = endpointProtocol || [];
	        _PortDefinitionConstants.PROTOCOLS.forEach(function (protocol) {
	          memo.push(new _Transaction2.default(["containers", index, "endpoints", endpointIndex, "protocol", protocol], protocols.includes(protocol), _TransactionTypes.SET));
	        });
	      });
	    }
	
	    if (item.forcePullImage != null) {
	      memo.push(new _Transaction2.default(["containers", index, "forcePullImage"], item.forcePullImage));
	    }
	
	    if (item.exec != null && item.exec.command != null && item.exec.command.shell != null) {
	      memo.push(new _Transaction2.default(["containers", index, "exec", "command", "shell"], item.exec.command.shell));
	    }
	
	    return memo;
	  }, []);
	}
	
	function shouldDeleteContainerImage(image) {
	  return image == null || !image.id;
	}
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var _this = this;
	
	    var _ref = arguments[1];
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	    var containerIndex = arguments[2];
	
	    if (containerIndex === 0) {
	      state = [];
	    }
	
	    var _path = (0, _slicedToArray3.default)(path, 4),
	        base = _path[0],
	        index = _path[1],
	        field = _path[2],
	        subField = _path[3];
	
	    if (this.networkType == null) {
	      this.networkType = HOST;
	    }
	
	    if (this.appState == null) {
	      this.appState = {};
	    }
	
	    if (this.healthCheckState == null) {
	      this.healthCheckState = [];
	    }
	
	    if (base === "id" && type === _TransactionTypes.SET) {
	      this.appState.id = value;
	    }
	
	    if (base === "networks" && parseInt(index, 10) === 0 && type === _TransactionTypes.SET) {
	      var valueSplit = value.split(".");
	
	      this.networkType = valueSplit[0];
	    }
	
	    if (!path.includes("containers") && !path.includes("volumeMounts")) {
	      return state.map(function (container, index) {
	        if (_this.endpoints && _this.endpoints[index] && _this.endpoints[index].length !== 0) {
	          container.endpoints = mapEndpoints(_this.endpoints[index], _this.networkType, _this.appState);
	        }
	
	        return container;
	      });
	    }
	
	    if (this.cache == null) {
	      // This is needed to provide a context for nested reducers.
	      // Containers is an array so we will have multiple items and so that
	      // the reducers are not overwriting each others context we are
	      // providing one object per item in the array.
	      this.cache = [];
	    }
	
	    if (this.images == null) {
	      this.images = {};
	    }
	
	    if (this.endpoints == null) {
	      this.endpoints = [];
	    }
	
	    if (this.volumeMounts == null) {
	      this.volumeMounts = [];
	    }
	    var newState = state.slice();
	    var joinedPath = path.join(".");
	
	    if (joinedPath === "containers") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          var name = "container-" + (newState.length + 1);
	
	          newState.push((0, _assign2.default)({}, _DefaultPod.DEFAULT_POD_CONTAINER, { name: name }));
	          this.cache.push({});
	          this.endpoints.push([]);
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          newState = newState.filter(function (item, index) {
	            return index !== value;
	          });
	          this.cache = this.cache.filter(function (item, index) {
	            return index !== value;
	          });
	          this.endpoints = this.endpoints.filter(function (item, index) {
	            return index !== value;
	          });
	          break;
	      }
	
	      return newState;
	    }
	
	    this.volumeMounts = (0, _MultiContainerVolumeMounts.JSONReducer)(this.volumeMounts, {
	      type: type,
	      path: path,
	      value: value
	    });
	
	    newState = state.map(function (container, index) {
	      if (_this.volumeMounts.length !== 0) {
	        container.volumeMounts = _this.volumeMounts.filter(function (volumeMount) {
	          return volumeMount.name != null && volumeMount.mountPath[index];
	        }).map(function (volumeMount) {
	          return {
	            name: volumeMount.name,
	            mountPath: volumeMount.mountPath[index]
	          };
	        });
	      }
	
	      if (_this.volumeMounts.length === 0 && container.volumeMounts != null) {
	        container.volumeMounts = [];
	      }
	
	      return container;
	    });
	
	    if (field === "endpoints") {
	      if (this.endpoints[index] == null) {
	        this.endpoints[index] = [];
	      }
	
	      this.endpoints = (0, _Endpoints.JSONReducer)(this.endpoints, {
	        type: type,
	        path: path,
	        value: value
	      });
	    }
	    newState = newState.map(function (container, index) {
	      if (_this.endpoints && _this.endpoints[index] && _this.endpoints[index].length !== 0) {
	        container.endpoints = mapEndpoints(_this.endpoints[index], _this.networkType, _this.appState);
	      }
	
	      return container;
	    });
	
	    if (field === "healthCheck") {
	      if (this.healthCheckState[index] == null) {
	        this.healthCheckState[index] = {};
	      }
	
	      newState[index].healthCheck = _MultiContainerHealthChecks.JSONSegmentReducer.call(this.healthCheckState[index], newState[index].healthCheck, { type: type, path: path.slice(3), value: value });
	    }
	
	    if (field === "artifacts") {
	      // Create a local cache of artifacts so we can filter the display values
	      if (this.artifactState == null) {
	        this.artifactState = [];
	      }
	
	      // Filter empty values and assign to state
	      _MultiContainerArtifacts.JSONReducer.call(this.artifactState, null, { type: type, path: path, value: value }).forEach(function (item, index) {
	        newState[index].artifacts = item.filter(function (_ref2) {
	          var uri = _ref2.uri;
	          return !(0, _ValidatorUtil.isEmpty)(uri);
	        });
	      });
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".name") {
	      newState[index].name = value;
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".exec.command.shell") {
	      newState[index].exec = (0, _assign2.default)({}, newState[index].exec, {
	        command: { shell: value }
	      });
	    }
	
	    if (type === _TransactionTypes.SET && field === "resources") {
	      // Parse numbers
	      newState[index].resources = containerFloatReducer.call(this.cache[index], newState[index].resources, { type: type, value: value, path: [field, subField] });
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".image") {
	      newState[index].image = this.images[index] = (0, _assign2.default)({}, newState[index].image, value);
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".image.id") {
	      newState[index].image = this.images[index] = (0, _assign2.default)({}, this.images[index], {
	        id: value,
	        kind: "DOCKER"
	      });
	      if (shouldDeleteContainerImage(newState[index].image)) {
	        delete newState[index].image;
	      }
	    }
	
	    if (type === _TransactionTypes.SET && joinedPath === "containers." + index + ".image.forcePull") {
	      newState[index].image = this.images[index] = (0, _assign2.default)({}, this.images[index], {
	        forcePull: value
	      });
	      if (shouldDeleteContainerImage(newState[index].image)) {
	        delete newState[index].image;
	      }
	    }
	
	    return newState;
	  },
	
	  JSONParser: containersParser
	};

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        path = _ref.path,
	        value = _ref.value;
	
	    var _path = (0, _slicedToArray3.default)(path, 4),
	        base = _path[0],
	        index = _path[1],
	        name = _path[2],
	        secondIndex = _path[3];
	
	    var newState = state.slice();
	
	    if (base === "containers") {
	      switch (type) {
	        case _TransactionTypes.ADD_ITEM:
	          newState = newState.map(function (volumeMount) {
	            volumeMount.mountPath.push("");
	
	            return volumeMount;
	          });
	          break;
	        case _TransactionTypes.REMOVE_ITEM:
	          newState = newState.map(function (volumeMount) {
	            volumeMount.mountPath = volumeMount.mountPath.filter(function (item, index) {
	              return index !== value;
	            });
	
	            return volumeMount;
	          });
	          break;
	      }
	    }
	
	    if (base !== "volumeMounts") {
	      return newState;
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        newState.push({ mountPath: [] });
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState = newState.filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	    }
	
	    if (name === "name") {
	      newState[index].name = String(value);
	    }
	    if (name === "mountPath") {
	      newState[index].mountPath[secondIndex] = String(value);
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _ReducerUtil = __webpack_require__(1665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEndpointsFieldValues = {
	  automaticPort: true,
	  containerPort: null,
	  hostPort: null,
	  labels: null,
	  loadBalanced: false,
	  name: null,
	  protocol: {
	    tcp: true,
	    udp: false
	  },
	  servicePort: null,
	  vip: null,
	  vipPort: null
	};
	
	module.exports = {
	  JSONReducer: function JSONReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var newState = [].concat(state);
	
	    var _path = (0, _slicedToArray3.default)(path, 6),
	        _ = _path[0],
	        index = _path[1],
	        field = _path[2],
	        secondIndex = _path[3],
	        name = _path[4],
	        subField = _path[5];
	
	    if (field !== "endpoints") {
	      return state;
	    }
	
	    if (newState[index] == null) {
	      newState[index] = [];
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        var newEndpoint = value;
	
	        if (value == null) {
	          newEndpoint = (0, _assign2.default)({}, defaultEndpointsFieldValues);
	        }
	
	        newEndpoint.protocol = (0, _assign2.default)({}, newEndpoint.protocol);
	        newState[index].push(newEndpoint);
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        newState[index] = newState[index].filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	    }
	
	    var fieldNames = ["name", "automaticPort", "loadBalanced", "labels", "vip", "vipPort"];
	    var numericalFiledNames = ["containerPort", "hostPort"];
	
	    if (type === _TransactionTypes.SET && name === "protocol") {
	      newState[index][secondIndex].protocol[subField] = value;
	    }
	    if (type === _TransactionTypes.SET && fieldNames.includes(name)) {
	      newState[index][secondIndex][name] = value;
	    }
	    if (type === _TransactionTypes.SET && numericalFiledNames.includes(name)) {
	      newState[index][secondIndex][name] = (0, _ReducerUtil.parseIntValue)(value);
	    }
	
	    return newState;
	  }
	};

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray2 = __webpack_require__(1249);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _TransactionTypes = __webpack_require__(1664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONReducer: function JSONReducer(__, _ref) {
	    var type = _ref.type,
	        _ref$path = _ref.path,
	        path = _ref$path === undefined ? [] : _ref$path,
	        value = _ref.value;
	
	    var _path = (0, _slicedToArray3.default)(path, 6),
	        _ = _path[0],
	        index = _path[1],
	        field = _path[2],
	        secondIndex = _path[3],
	        name = _path[4],
	        _subField = _path[5];
	
	    if (field !== "artifacts") {
	      return;
	    }
	    if (this.artifactState == null) {
	      this.artifactState = [];
	    }
	
	    if (this.artifactState[index] == null) {
	      this.artifactState[index] = [];
	    }
	
	    switch (type) {
	      case _TransactionTypes.ADD_ITEM:
	        this.artifactState[index].push({ uri: null });
	        break;
	      case _TransactionTypes.REMOVE_ITEM:
	        this.artifactState[index] = this.artifactState[index].filter(function (item, index) {
	          return index !== value;
	        });
	        break;
	      case _TransactionTypes.SET:
	        this.artifactState[index][secondIndex][name] = value;
	        break;
	    }
	
	    return this.artifactState;
	  }
	};

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ReducerUtil = __webpack_require__(1665);
	
	var _MultiContainerConstraints = __webpack_require__(1807);
	
	var _Containers = __webpack_require__(1813);
	
	var _EnvironmentVariables = __webpack_require__(1797);
	
	var _Artifacts = __webpack_require__(1798);
	
	var _MultiContainerScaling = __webpack_require__(1812);
	
	var _Labels = __webpack_require__(1800);
	
	var _MultiContainerVolumes = __webpack_require__(1755);
	
	var _MultiContainerNetwork = __webpack_require__(1751);
	
	module.exports = {
	  id: (0, _ReducerUtil.simpleReducer)("id"),
	  containers: _Containers.JSONReducer,
	  environment: _EnvironmentVariables.JSONReducer,
	  scaling: _MultiContainerScaling.JSONReducer,
	  labels: _Labels.JSONReducer,
	  scheduling: function scheduling(state, transaction) {
	    return {
	      placement: {
	        constraints: _MultiContainerConstraints.JSONReducer.bind(this)(state, transaction)
	      }
	    };
	  },
	
	  fetch: _Artifacts.JSONReducer,
	  volumes: _MultiContainerVolumes.JSONReducer,
	  networks: _MultiContainerNetwork.JSONReducer
	};

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ParserUtil = __webpack_require__(1662);
	
	var _Constraints = __webpack_require__(1795);
	
	var _Container = __webpack_require__(1689);
	
	var _EnvironmentVariables = __webpack_require__(1797);
	
	var _ExternalVolumes = __webpack_require__(1809);
	
	var _Artifacts = __webpack_require__(1798);
	
	var _HealthChecks = __webpack_require__(1799);
	
	var _Labels = __webpack_require__(1800);
	
	var _LocalVolumes = __webpack_require__(1810);
	
	var _UnknownVolumes = __webpack_require__(1819);
	
	var _Networks = __webpack_require__(1805);
	
	var _PortDefinitions = __webpack_require__(1803);
	
	var _PortMappings = __webpack_require__(1811);
	
	var _Residency = __webpack_require__(1801);
	
	var _RequirePorts = __webpack_require__(1802);
	
	module.exports = [(0, _ParserUtil.simpleParser)(["id"]), (0, _ParserUtil.simpleParser)(["instances"]), (0, _ParserUtil.simpleParser)(["cpus"]), (0, _ParserUtil.simpleParser)(["mem"]), (0, _ParserUtil.simpleParser)(["disk"]), (0, _ParserUtil.simpleParser)(["gpus"]), (0, _ParserUtil.simpleParser)(["cmd"]), _Constraints.JSONParser, _Container.JSONParser, _EnvironmentVariables.JSONParser, _ExternalVolumes.JSONParser, _Artifacts.JSONParser, _HealthChecks.JSONParser, _Labels.JSONParser, _LocalVolumes.JSONParser, _Networks.JSONParser, _PortDefinitions.JSONParser, _PortMappings.JSONParser, // Note: must come after portDefinitions, as it uses its information!
	_RequirePorts.JSONParser, _Residency.JSONParser, _UnknownVolumes.JSONParser];

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _TransactionTypes = __webpack_require__(1664);
	
	var _Transaction = __webpack_require__(1663);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  JSONParser: function JSONParser(state) {
	    if (state.container == null || state.container.volumes == null) {
	      return [];
	    }
	
	    return state.container.volumes.filter(function (item) {
	      return item.persistent == null && item.external == null && item.hostPath == null;
	    }).reduce(function (memo, item) {
	      return memo.concat(new _Transaction2.default(["unknownVolumes"], item, _TransactionTypes.ADD_ITEM));
	    }, []);
	  }
	};

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _NetworkValidatorUtil = __webpack_require__(1821);
	
	var _NetworkValidatorUtil2 = _interopRequireDefault(_NetworkValidatorUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Networking = __webpack_require__(1690);
	
	var _ServiceConfigUtil = __webpack_require__(1752);
	
	var _ServiceConfigUtil2 = _interopRequireDefault(_ServiceConfigUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkServiceEndpoints(ports, pathPrefix) {
	  return ports.reduce(function (portsMemo, port, index) {
	    var labels = port.labels || {};
	    var vipLabels = (0, _keys2.default)(labels).filter(_ServiceConfigUtil2.default.matchVIPLabel);
	
	    var errors = vipLabels.reduce(function (errorsMemo, label) {
	      var vipLabelMatch = _Networking.VIP_LABEL_VALUE_REGEX.exec(labels[label]);
	
	      if (!vipLabelMatch) {
	        return errorsMemo.concat({
	          path: pathPrefix.concat([index, "labels", label]),
	          message: "VIP label must be in the following format: <ip-addres|name>:<port>"
	        });
	      }
	
	      var vipPort = vipLabelMatch[2];
	
	      if (!_NetworkValidatorUtil2.default.isValidPort(vipPort)) {
	        return errorsMemo.concat({
	          path: pathPrefix.concat([index, "labels", label]),
	          message: "Port should be an integer less than or equal to 65535"
	        });
	      }
	
	      return errorsMemo;
	    }, []);
	
	    return portsMemo.concat(errors);
	  }, []);
	}
	
	var VipLabelsValidators = {
	  mustContainPort: function mustContainPort(app) {
	    // Single container app with HOST network
	    var ports = (0, _Util.findNestedPropertyInObject)(app, "portDefinitions");
	    var pathPrefix = ["portDefinitions"];
	
	    // Single container app with BRIDGE or USER network
	    if ((0, _ValidatorUtil.isEmpty)(ports)) {
	      ports = (0, _Util.findNestedPropertyInObject)(app, "container.portMappings");
	      pathPrefix = ["container", "portMappings"];
	    }
	
	    if (!(0, _ValidatorUtil.isEmpty)(ports)) {
	      return checkServiceEndpoints(ports, pathPrefix);
	    }
	
	    // Multi container app
	    var containers = app.containers || [];
	
	    return containers.reduce(function (memo, _ref, containerIndex) {
	      var _ref$endpoints = _ref.endpoints,
	          endpoints = _ref$endpoints === undefined ? [] : _ref$endpoints;
	
	      pathPrefix = ["containers", containerIndex, "endpoints"];
	
	      return memo.concat(checkServiceEndpoints(endpoints, pathPrefix));
	    }, []);
	  }
	};
	
	module.exports = VipLabelsValidators;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NetworkValidatorUtil = {
	  isValidPort: function isValidPort(value) {
	    return _ValidatorUtil2.default.isInteger(value) && _ValidatorUtil2.default.isNumberInRange(value, { min: 0, max: 65535 });
	  }
	};
	
	module.exports = NetworkValidatorUtil;

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RouterUtil = __webpack_require__(1016);
	
	var _RouterUtil2 = _interopRequireDefault(_RouterUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesPage = _react2.default.createClass({
	  contextTypes: {
	    router: _reactRouter.routerShape
	  },
	
	  mixins: [_TabsMixin2.default, _mesosphereSharedReactjs.StoreMixin],
	
	  displayName: "ServicesPage",
	
	  statics: {
	    routeConfig: {
	      label: "Services",
	      icon: _react2.default.createElement(_Icon2.default, { id: "services-inverse", size: "small", family: "product" }),
	      matches: /^\/services/
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      currentTab: "/services/overview"
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.store_listeners = [{ name: "notification", events: ["change"], suppressUpdate: false }];
	    this.tabs_tabs = {
	      "/services/overview": "Services"
	    };
	    this.updateCurrentTab();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.updateCurrentTab();
	  },
	  updateCurrentTab: function updateCurrentTab() {
	    var currentTab = _RouterUtil2.default.reconstructPathFromRoutes(this.props.routes);
	    // `/services/overview` tab also contains routes for '/services/overview/:id'
	    if (currentTab === "/services/overview/:id" || currentTab == null) {
	      currentTab = "/services/overview";
	    }
	    // Disguise `/services/detail` tab under `/services/overview`
	    // eventhough it is an actual sibling
	    if (currentTab === "/services/detail/:id" || currentTab == null) {
	      currentTab = "/services/overview";
	    }
	
	    if (this.state.currentTab !== currentTab) {
	      this.setState({ currentTab: currentTab });
	    }
	  },
	  getNavigation: function getNavigation() {
	    if (_RouterUtil2.default.shouldHideNavigation(this.props.routes)) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      "ul",
	      { className: "menu-tabbed" },
	      this.tabs_getRoutedTabs()
	    );
	  },
	  render: function render() {
	    return this.props.children;
	  }
	});
	
	module.exports = ServicesPage;

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _TaskDetail = __webpack_require__(1490);
	
	var _TaskDetail2 = _interopRequireDefault(_TaskDetail);
	
	var _ServiceBreadcrumbs = __webpack_require__(1585);
	
	var _ServiceBreadcrumbs2 = _interopRequireDefault(_ServiceBreadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dontScrollRoutes = [/\/files\/view.*$/, /\/logs.*$/];
	
	var ServiceTaskDetailPage = function (_React$Component) {
	  (0, _inherits3.default)(ServiceTaskDetailPage, _React$Component);
	
	  function ServiceTaskDetailPage() {
	    (0, _classCallCheck3.default)(this, ServiceTaskDetailPage);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceTaskDetailPage.__proto__ || (0, _getPrototypeOf2.default)(ServiceTaskDetailPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceTaskDetailPage, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          location = _props.location,
	          params = _props.params,
	          routes = _props.routes;
	      var id = params.id,
	          taskID = params.taskID;
	
	
	      var routePrefix = "/services/detail/" + encodeURIComponent(id) + "/tasks/" + encodeURIComponent(taskID);
	      var tabs = [{ label: "Details", routePath: routePrefix + "/details" }, { label: "Files", routePath: routePrefix + "/files" }, { label: "Logs", routePath: routePrefix + "/logs" }];
	
	      var task = _MesosStateStore2.default.getTaskFromTaskID(taskID);
	      var breadcrumbs = void 0;
	      if (task != null) {
	        breadcrumbs = _react2.default.createElement(_ServiceBreadcrumbs2.default, {
	          serviceID: id,
	          taskID: task.getId(),
	          taskName: task.getName()
	        });
	      } else {
	        breadcrumbs = _react2.default.createElement(_ServiceBreadcrumbs2.default, { serviceID: id });
	      }
	
	      var dontScroll = dontScrollRoutes.some(function (regex) {
	        return regex.test(location.pathname);
	      });
	
	      return _react2.default.createElement(
	        _Page2.default,
	        { dontScroll: dontScroll },
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: breadcrumbs, tabs: tabs, iconID: "services" }),
	        _react2.default.createElement(
	          _TaskDetail2.default,
	          { params: params, routes: routes },
	          this.props.children
	        )
	      );
	    }
	  }]);
	  return ServiceTaskDetailPage;
	}(_react2.default.Component);
	
	ServiceTaskDetailPage.propTypes = {
	  params: _react2.default.PropTypes.object,
	  routes: _react2.default.PropTypes.array
	};
	
	module.exports = ServiceTaskDetailPage;

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EventTypes = __webpack_require__(933);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ServiceItemNotFound = __webpack_require__(1583);
	
	var _ServiceItemNotFound2 = _interopRequireDefault(_ServiceItemNotFound);
	
	var _VolumeDetail = __webpack_require__(1584);
	
	var _VolumeDetail2 = _interopRequireDefault(_VolumeDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onStoreChange"];
	
	var ServiceVolumeContainer = function (_React$Component) {
	  (0, _inherits3.default)(ServiceVolumeContainer, _React$Component);
	
	  function ServiceVolumeContainer() {
	    (0, _classCallCheck3.default)(this, ServiceVolumeContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceVolumeContainer.__proto__ || (0, _getPrototypeOf2.default)(ServiceVolumeContainer)).apply(this, arguments));
	
	    _this.state = {
	      isLoading: !_DCOSStore2.default.serviceDataReceived,
	      lastUpdate: 0
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceVolumeContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _DCOSStore2.default.addChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _DCOSStore2.default.removeChangeListener(_EventTypes.DCOS_CHANGE, this.onStoreChange);
	    }
	  }, {
	    key: "onStoreChange",
	    value: function onStoreChange() {
	      // Throttle updates from DCOSStore
	      if (Date.now() - this.state.lastUpdate > 1000 || _DCOSStore2.default.serviceDataReceived && this.state.isLoading) {
	        this.setState({
	          isLoading: !_DCOSStore2.default.serviceDataReceived,
	          lastUpdate: Date.now()
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$params = this.props.params,
	          id = _props$params.id,
	          volumeID = _props$params.volumeID;
	
	      var serviceId = decodeURIComponent(id);
	      var service = _DCOSStore2.default.serviceTree.findItemById(serviceId);
	      var volumeId = decodeURIComponent(volumeID);
	
	      if (this.state.isLoading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      if (!service) {
	        return _react2.default.createElement(_ServiceItemNotFound2.default, {
	          message: "The service with the ID of \"" + id + "\" could not be found."
	        });
	      }
	
	      var volume = service.getVolumes().findItem(function (volume) {
	        return volume.getId() === volumeId;
	      });
	
	      if (!volume) {
	        return _react2.default.createElement(_ServiceItemNotFound2.default, { message: "Volume '" + volumeId + "' was not found." });
	      }
	
	      return _react2.default.createElement(_VolumeDetail2.default, { service: service, volume: volume });
	    }
	  }]);
	  return ServiceVolumeContainer;
	}(_react2.default.Component);
	
	ServiceVolumeContainer.propTypes = {
	  params: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = ServiceVolumeContainer;

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodConfigurationContainer = __webpack_require__(1826);
	
	var _PodConfigurationContainer2 = _interopRequireDefault(_PodConfigurationContainer);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceConfigurationContainer = __webpack_require__(1827);
	
	var _ServiceConfigurationContainer2 = _interopRequireDefault(_ServiceConfigurationContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HighOrderServiceConfiguration = function HighOrderServiceConfiguration(props) {
	  var errors = props.errors,
	      onEditClick = props.onEditClick,
	      service = props.service;
	
	  if (service instanceof _Pod2.default) {
	    return _react2.default.createElement(_PodConfigurationContainer2.default, { pod: service });
	  }
	
	  return _react2.default.createElement(_ServiceConfigurationContainer2.default, {
	    errors: errors,
	    onEditClick: onEditClick,
	    service: service
	  });
	};
	
	HighOrderServiceConfiguration.propTypes = {
	  errors: _react2.default.PropTypes.array,
	  service: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_Pod2.default), _react2.default.PropTypes.instanceOf(_Service2.default)])
	};
	
	module.exports = HighOrderServiceConfiguration;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _ServiceConfigDisplay = __webpack_require__(1768);
	
	var _ServiceConfigDisplay2 = _interopRequireDefault(_ServiceConfigDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodConfigurationTabView = function (_React$Component) {
	  (0, _inherits3.default)(PodConfigurationTabView, _React$Component);
	
	  function PodConfigurationTabView() {
	    (0, _classCallCheck3.default)(this, PodConfigurationTabView);
	    return (0, _possibleConstructorReturn3.default)(this, (PodConfigurationTabView.__proto__ || (0, _getPrototypeOf2.default)(PodConfigurationTabView)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(PodConfigurationTabView, [{
	    key: "render",
	    value: function render() {
	      var spec = this.props.pod.getSpec();
	      var localeVersion = new Date(spec.getVersion()).toLocaleString();
	
	      // TODO (DCOS_OSS-1037): Implement ability to edit a Pod
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "h3",
	          { className: "flush-top" },
	          "Current Version (",
	          localeVersion,
	          ")"
	        ),
	        _react2.default.createElement(_ServiceConfigDisplay2.default, { appConfig: spec })
	      );
	    }
	  }]);
	  return PodConfigurationTabView;
	}(_react2.default.Component);
	
	PodConfigurationTabView.propTypes = {
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default)
	};
	
	module.exports = PodConfigurationTabView;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceConfiguration = __webpack_require__(1828);
	
	var _ServiceConfiguration2 = _interopRequireDefault(_ServiceConfiguration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceConfigurationContainer = function (_React$Component) {
	  (0, _inherits3.default)(ServiceConfigurationContainer, _React$Component);
	
	  function ServiceConfigurationContainer() {
	    (0, _classCallCheck3.default)(this, ServiceConfigurationContainer);
	    return (0, _possibleConstructorReturn3.default)(this, (ServiceConfigurationContainer.__proto__ || (0, _getPrototypeOf2.default)(ServiceConfigurationContainer)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ServiceConfigurationContainer, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var service = this.props.service;
	
	
	      _DCOSStore2.default.fetchServiceVersions(service.getId());
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var nextService = nextProps.service;
	      var service = this.props.service;
	
	
	      if (service.getVersion() !== nextService.getVersion()) {
	        _DCOSStore2.default.fetchServiceVersions(nextService.getId());
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          errors = _props.errors,
	          onEditClick = _props.onEditClick,
	          service = _props.service;
	
	      // Wait till we've loaded the versions
	
	      if (!service.getVersions().size) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      return _react2.default.createElement(_ServiceConfiguration2.default, {
	        errors: errors,
	        onEditClick: onEditClick,
	        service: service
	      });
	    }
	  }]);
	  return ServiceConfigurationContainer;
	}(_react2.default.Component);
	
	ServiceConfigurationContainer.defaultProps = {
	  errors: []
	};
	
	ServiceConfigurationContainer.propTypes = {
	  onEditClick: _react2.default.PropTypes.func,
	  errors: _react2.default.PropTypes.array,
	  service: _react2.default.PropTypes.instanceOf(_Service2.default)
	};
	
	module.exports = ServiceConfigurationContainer;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _from = __webpack_require__(1018);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _DCOSStore = __webpack_require__(1102);
	
	var _DCOSStore2 = _interopRequireDefault(_DCOSStore);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ServiceUtil = __webpack_require__(1068);
	
	var _ApplicationSpec = __webpack_require__(1078);
	
	var _ApplicationSpec2 = _interopRequireDefault(_ApplicationSpec);
	
	var _ServiceConfigDisplay = __webpack_require__(1768);
	
	var _ServiceConfigDisplay2 = _interopRequireDefault(_ServiceConfigDisplay);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceUtil2 = __webpack_require__(1244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleApplyButtonClick", "handleEditButtonClick", "handleVersionSelection"];
	
	function fetchVersion(service, versionID) {
	  if (service.getVersions().get(versionID) == null) {
	    _DCOSStore2.default.fetchServiceVersion(service.getId(), versionID);
	  }
	}
	
	var ServiceConfiguration = function (_mixin) {
	  (0, _inherits3.default)(ServiceConfiguration, _mixin);
	
	  function ServiceConfiguration() {
	    (0, _classCallCheck3.default)(this, ServiceConfiguration);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceConfiguration.__proto__ || (0, _getPrototypeOf2.default)(ServiceConfiguration)).apply(this, arguments));
	
	    _this.state = {
	      selectedVersionID: null
	    };
	
	    _this.store_listeners = [{ name: "dcos", events: ["change"] }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceConfiguration, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var service = this.props.service;
	
	      var versionID = service.getVersion();
	
	      this.setState({ selectedVersionID: versionID });
	
	      fetchVersion(service, versionID);
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var service = this.props.service;
	      var selectedVersionID = this.state.selectedVersionID;
	
	
	      return nextProps.service.getVersion() !== service.getVersion() || nextProps.service.getVersions() !== service.getVersions() || nextState.selectedVersionID !== selectedVersionID;
	    }
	  }, {
	    key: "handleApplyButtonClick",
	    value: function handleApplyButtonClick() {
	      var _props = this.props,
	          onEditClick = _props.onEditClick,
	          service = _props.service;
	      var selectedVersionID = this.state.selectedVersionID;
	
	
	      var serviceConfiguration = service.getVersions().get(selectedVersionID);
	
	      onEditClick(service, (0, _ServiceUtil2.getDefinitionFromSpec)(new _ApplicationSpec2.default(serviceConfiguration)));
	    }
	  }, {
	    key: "handleEditButtonClick",
	    value: function handleEditButtonClick() {
	      var serviceID = encodeURIComponent(this.props.service.getId());
	      var selectedVersionID = this.state.selectedVersionID;
	
	
	      this.context.router.push("/services/detail/" + serviceID + "/edit/" + selectedVersionID);
	    }
	  }, {
	    key: "handleVersionSelection",
	    value: function handleVersionSelection(versionItem) {
	      fetchVersion(this.props.service, versionItem.id);
	
	      this.setState({ selectedVersionID: versionItem.id });
	    }
	  }, {
	    key: "getVersionsActions",
	    value: function getVersionsActions() {
	      return _react2.default.createElement(
	        "div",
	        { className: "pod flush-top flush-right flush-left" },
	        _react2.default.createElement(
	          "div",
	          { className: "button-collection" },
	          this.getVersionsDropdown(),
	          this.getRollbackButtons()
	        )
	      );
	    }
	  }, {
	    key: "getRollbackButtons",
	    value: function getRollbackButtons() {
	      var _this2 = this;
	
	      var service = this.props.service;
	      var selectedVersionID = this.state.selectedVersionID;
	
	      var applyButton = null;
	
	      if (service.getVersion() !== selectedVersionID) {
	        applyButton = _react2.default.createElement(
	          "button",
	          {
	            className: "button button-primary-link",
	            disabled: (0, _ServiceUtil.isSDKService)(service),
	            key: "version-button-apply",
	            onClick: function onClick() {
	              return _this2.handleApplyButtonClick();
	            }
	          },
	          "Apply"
	        );
	      }
	
	      return [_react2.default.createElement(
	        "button",
	        {
	          className: "button button-primary-link",
	          disabled: (0, _ServiceUtil.isSDKService)(service),
	          key: "version-button-edit",
	          onClick: function onClick() {
	            return _this2.handleEditButtonClick();
	          }
	        },
	        "Edit"
	      ), applyButton];
	    }
	  }, {
	    key: "getVersionsDropdown",
	    value: function getVersionsDropdown() {
	      var service = this.props.service;
	
	      var versions = service.getVersions();
	
	      var versionItems = (0, _from2.default)(versions.keys()).sort(function (a, b) {
	        return new Date(a) - new Date(b);
	      }).map(function (version) {
	        var localeVersion = new Date(version).toLocaleString();
	        var itemCaption = localeVersion;
	        if (version === service.getVersion()) {
	          itemCaption = _react2.default.createElement(
	            "span",
	            { className: "badge-container" },
	            _react2.default.createElement(
	              "span",
	              { className: "badge-container-text" },
	              localeVersion
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "badge" },
	              "Active"
	            )
	          );
	        }
	
	        return {
	          id: version,
	          html: _react2.default.createElement(
	            "div",
	            { className: "button-split-content-wrapper" },
	            _react2.default.createElement(_Icon2.default, {
	              className: "services-version-select-icon services-version-select-icon-selected button-split-content-item",
	              id: "check",
	              size: "mini",
	              color: "neutral"
	            }),
	            _react2.default.createElement(_Icon2.default, {
	              className: "services-version-select-icon button-split-content-item",
	              id: "commit",
	              size: "mini",
	              color: "neutral"
	            }),
	            _react2.default.createElement(
	              "span",
	              {
	                className: "button-split-content-item text-overflow",
	                title: version
	              },
	              itemCaption
	            )
	          )
	        };
	      });
	
	      return _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        {
	          content: "Configuration version",
	          wrapperClassName: "button button-transparent button-flush"
	        },
	        _react2.default.createElement(_reactjsComponents.Dropdown, {
	          buttonClassName: "services-version-select-toggle dropdown-toggle button button-transparent button-split-content flush-left",
	          dropdownMenuClassName: "services-version-select-menu dropdown-menu",
	          dropdownMenuListClassName: "dropdown-menu-list",
	          dropdownMenuListItemClassName: "clickable",
	          items: versionItems,
	          key: "version-dropdown",
	          onItemSelection: this.handleVersionSelection,
	          persistentID: this.state.selectedVersionID,
	          scrollContainer: ".gm-scroll-view",
	          scrollContainerParentSelector: ".gm-prevented",
	          transition: true,
	          transitionName: "dropdown-menu",
	          wrapperClassName: "services-version-select dropdown"
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          errors = _props2.errors,
	          service = _props2.service;
	      var selectedVersionID = this.state.selectedVersionID;
	
	      var config = service.getVersions().get(selectedVersionID);
	
	      if (config == null) {
	        return _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(_Loader2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        this.getVersionsActions(),
	        _react2.default.createElement(_ServiceConfigDisplay2.default, { appConfig: config, errors: errors })
	      );
	    }
	  }]);
	  return ServiceConfiguration;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	ServiceConfiguration.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	ServiceConfiguration.defaultProps = {
	  errors: []
	};
	
	ServiceConfiguration.propTypes = {
	  onEditClick: _react2.default.PropTypes.func.isRequired,
	  errors: _react2.default.PropTypes.array,
	  service: _react2.default.PropTypes.instanceOf(_Service2.default).isRequired
	};
	
	module.exports = ServiceConfiguration;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodDebugContainer = __webpack_require__(1830);
	
	var _PodDebugContainer2 = _interopRequireDefault(_PodDebugContainer);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceDebugContainer = __webpack_require__(1835);
	
	var _ServiceDebugContainer2 = _interopRequireDefault(_ServiceDebugContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HighOrderServiceDebug = function HighOrderServiceDebug(props) {
	  var service = props.service;
	
	  if (service instanceof _Pod2.default) {
	    return _react2.default.createElement(_PodDebugContainer2.default, { pod: service });
	  }
	
	  return _react2.default.createElement(_ServiceDebugContainer2.default, { service: service });
	};
	
	HighOrderServiceDebug.propTypes = {
	  service: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_Pod2.default), _react2.default.PropTypes.instanceOf(_Service2.default)])
	};
	
	module.exports = HighOrderServiceDebug;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Alert = __webpack_require__(1730);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _DeclinedOffersHelpText = __webpack_require__(1831);
	
	var _DeclinedOffersHelpText2 = _interopRequireDefault(_DeclinedOffersHelpText);
	
	var _DeclinedOffersTable = __webpack_require__(1832);
	
	var _DeclinedOffersTable2 = _interopRequireDefault(_DeclinedOffersTable);
	
	var _MarathonStore = __webpack_require__(1221);
	
	var _MarathonStore2 = _interopRequireDefault(_MarathonStore);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodContainerTerminationTable = __webpack_require__(1833);
	
	var _PodContainerTerminationTable2 = _interopRequireDefault(_PodContainerTerminationTable);
	
	var _RecentOffersSummary = __webpack_require__(1834);
	
	var _RecentOffersSummary2 = _interopRequireDefault(_RecentOffersSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleJumpToRecentOffersClick"];
	
	var PodDebugTabView = function (_React$Component) {
	  (0, _inherits3.default)(PodDebugTabView, _React$Component);
	
	  function PodDebugTabView() {
	    (0, _classCallCheck3.default)(this, PodDebugTabView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodDebugTabView.__proto__ || (0, _getPrototypeOf2.default)(PodDebugTabView)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodDebugTabView, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _MarathonStore2.default.setShouldEmbedLastUnusedOffers(true);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _MarathonStore2.default.setShouldEmbedLastUnusedOffers(false);
	    }
	  }, {
	    key: "getDeclinedOffersTable",
	    value: function getDeclinedOffersTable() {
	      var pod = this.props.pod;
	
	      var queue = pod.getQueue();
	
	      if (queue == null || queue.declinedOffers.offers == null) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 2 },
	          "Details"
	        ),
	        _react2.default.createElement(_DeclinedOffersTable2.default, {
	          offers: queue.declinedOffers.offers,
	          service: pod,
	          summary: queue.declinedOffers.summary
	        })
	      );
	    }
	  }, {
	    key: "getTerminationHistory",
	    value: function getTerminationHistory() {
	      var history = this.props.pod.getTerminationHistoryList().getItems();
	      if (!history.length) {
	        return _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            null,
	            "Last Terminations"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "(No data)"
	          )
	        );
	      }
	
	      return history.reduce(function (acc, item, index) {
	        var headline = void 0;
	        var startedAt = item.getStartedAt();
	        var terminatedAt = item.getTerminatedAt();
	
	        if (index === 0) {
	          headline = _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 2 },
	            "Last Termination (",
	            _react2.default.createElement(_TimeAgo2.default, { time: terminatedAt }),
	            ")"
	          );
	        } else {
	          headline = _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 2 },
	            "Terminated at",
	            " ",
	            terminatedAt.toString(),
	            " ",
	            "(",
	            _react2.default.createElement(_TimeAgo2.default, { time: terminatedAt }),
	            ")"
	          );
	        }
	
	        acc.push(_react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: "termination-" + index },
	          headline,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Instance ID"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                item.getId()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Message"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                item.getMessage()
	              )
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapRow2.default,
	              null,
	              _react2.default.createElement(
	                _ConfigurationMapLabel2.default,
	                null,
	                "Started At"
	              ),
	              _react2.default.createElement(
	                _ConfigurationMapValue2.default,
	                null,
	                startedAt.toString(),
	                " (",
	                _react2.default.createElement(_TimeAgo2.default, { time: startedAt }),
	                ")"
	              )
	            )
	          )
	        ), _react2.default.createElement(
	          _ConfigurationMapSection2.default,
	          { key: "container-" + index },
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 3 },
	            "Containers"
	          ),
	          _react2.default.createElement(_PodContainerTerminationTable2.default, { containers: item.getContainers() })
	        ));
	
	        return acc;
	      }, []);
	    }
	  }, {
	    key: "getLastVersionChange",
	    value: function getLastVersionChange() {
	      var pod = this.props.pod;
	
	      var lastUpdated = pod.getLastUpdated();
	
	      // Note to reader: `getLastChanged` refers to the last changes that happened
	      // to the pod (such as state changes or instance changes), but we are
	      // interested in the last configuration update, for which we are using the
	      // `getLastUpdate` function.
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Last Changes"
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Configuration"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            lastUpdated.toString(),
	            " (",
	            _react2.default.createElement(_TimeAgo2.default, { time: lastUpdated }),
	            ")"
	          )
	        )
	      );
	    }
	  }, {
	    key: "getRecentOfferSummary",
	    value: function getRecentOfferSummary() {
	      var _this2 = this;
	
	      var pod = this.props.pod;
	
	      var queue = pod.getQueue();
	      var introText = "Offers will appear here when your service is deploying or waiting for resources.";
	      var mainContent = null;
	      var offerCount = null;
	
	      if (queue != null && queue.declinedOffers.summary != null) {
	        var summary = queue.declinedOffers.summary;
	        var _summary$roles$offers = summary.roles.offers,
	            offers = _summary$roles$offers === undefined ? 0 : _summary$roles$offers;
	
	
	        introText = _DeclinedOffersHelpText2.default.summaryIntro;
	
	        mainContent = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapHeading2.default,
	            { level: 2 },
	            "Summary"
	          ),
	          _react2.default.createElement(_RecentOffersSummary2.default, { data: summary })
	        );
	
	        offerCount = " (" + offers + ")";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          ref: function ref(_ref) {
	            _this2.offerSummaryRef = _ref;
	          }
	        },
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Recent Resource Offers",
	          offerCount
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          introText
	        ),
	        mainContent
	      );
	    }
	  }, {
	    key: "getWaitingForResourcesNotice",
	    value: function getWaitingForResourcesNotice() {
	      var queue = this.props.pod.getQueue();
	
	      if (queue == null || queue.since == null) {
	        return null;
	      }
	
	      var waitingSince = _DateUtil2.default.strToMs(queue.since);
	      var timeWaiting = Date.now() - waitingSince;
	
	      // If the service has been waiting for less than five minutes, we don't
	      // display the warning.
	      if (timeWaiting < 1000 * 60 * 5) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Alert2.default,
	        null,
	        "DC/OS has been waiting for resources and is unable to complete this deployment for ",
	        _DateUtil2.default.getDuration(timeWaiting, null),
	        ". ",
	        _react2.default.createElement(
	          "a",
	          { className: "clickable", onClick: this.handleJumpToRecentOffersClick },
	          "See recent resource offers"
	        ),
	        "."
	      );
	    }
	  }, {
	    key: "handleJumpToRecentOffersClick",
	    value: function handleJumpToRecentOffersClick() {
	      if (this.offerSummaryRef) {
	        this.offerSummaryRef.scrollIntoView();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        this.getWaitingForResourcesNotice(),
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          this.getLastVersionChange(),
	          this.getTerminationHistory(),
	          this.getRecentOfferSummary(),
	          this.getDeclinedOffersTable()
	        )
	      );
	    }
	  }]);
	  return PodDebugTabView;
	}(_react2.default.Component);
	
	PodDebugTabView.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	PodDebugTabView.propTypes = {
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default)
	};
	
	module.exports = PodDebugTabView;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryDocsURL = _MetadataStore2.default.buildDocsURI("/overview/concepts/#mesos-resource-offer");
	
	module.exports = {
	  summaryIntro: _react2.default.createElement(
	    "span",
	    null,
	    "When you attempt to deploy a service, DC/OS waits for offers to match the resources your service requires. If the offer does not satisfy the requirement, it is declined and DC/OS retries. ",
	    _react2.default.createElement(
	      "a",
	      { href: summaryDocsURL, target: "_blank" },
	      "Learn more"
	    ),
	    "."
	  )
	};

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(785);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _DeclinedOffersReasons = __webpack_require__(1209);
	
	var _DeclinedOffersReasons2 = _interopRequireDefault(_DeclinedOffersReasons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeclinedOffersTable = function (_React$Component) {
	  (0, _inherits3.default)(DeclinedOffersTable, _React$Component);
	
	  function DeclinedOffersTable() {
	    (0, _classCallCheck3.default)(this, DeclinedOffersTable);
	    return (0, _possibleConstructorReturn3.default)(this, (DeclinedOffersTable.__proto__ || (0, _getPrototypeOf2.default)(DeclinedOffersTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DeclinedOffersTable, [{
	    key: "areResourcesUnmatched",
	    value: function areResourcesUnmatched(requestedResource, receivedResource) {
	      if (Array.isArray(receivedResource)) {
	        return receivedResource.includes(requestedResource);
	      }
	
	      return receivedResource >= requestedResource;
	    }
	  }, {
	    key: "getColumnClassNameFn",
	    value: function getColumnClassNameFn(classes) {
	      return function (prop, sortBy) {
	        return (0, _classnames2.default)(classes, {
	          active: prop === sortBy.prop
	        });
	      };
	    }
	  }, {
	    key: "getColumnHeadingFn",
	    value: function getColumnHeadingFn(defaultHeading, abbreviation) {
	      return function (prop, order, sortBy) {
	        var _classNames;
	
	        var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", sortBy.prop === prop), _classNames));
	
	        var columnHeading = defaultHeading || prop;
	
	        if (abbreviation != null) {
	          columnHeading = [_react2.default.createElement(
	            "span",
	            { className: "hidden-medium-down", key: "full-text" },
	            columnHeading
	          ), _react2.default.createElement(
	            "span",
	            { className: "hidden-large-up", key: "abbreviation" },
	            abbreviation
	          )];
	        }
	
	        return _react2.default.createElement(
	          "span",
	          null,
	          columnHeading,
	          _react2.default.createElement("span", { className: caretClassNames })
	        );
	      };
	    }
	  }, {
	    key: "getMatchedResourcesSortFn",
	    value: function getMatchedResourcesSortFn(resource) {
	      return function (item, prop) {
	        // It's possible that prop is one of the resources, or timestamp for a
	        // tiebreaker. Return the timestamp in ms if it's the current prop.
	        if (prop === "timestamp") {
	          return _DateUtil2.default.strToMs(item[prop]);
	        }
	
	        var _item$unmatchedResour = item.unmatchedResource,
	            unmatchedResource = _item$unmatchedResour === undefined ? [] : _item$unmatchedResour;
	
	
	        if (unmatchedResource.includes(resource)) {
	          return 1;
	        }
	
	        return 0;
	      };
	    }
	  }, {
	    key: "getMatchedOfferRenderFn",
	    value: function getMatchedOfferRenderFn(resource) {
	      var _this2 = this;
	
	      var summary = this.props.summary;
	
	
	      return function (prop, row) {
	        var _row$unmatchedResourc = row.unmatchedResource,
	            unmatchedResource = _row$unmatchedResourc === undefined ? [] : _row$unmatchedResourc;
	
	        var isResourceUnmatched = unmatchedResource.includes(resource);
	        var receivedResourceClasses = (0, _classnames2.default)({
	          "text-danger": isResourceUnmatched
	        });
	
	        var requestedResource = summary[prop].requested;
	        var receivedResource = row.offered[prop];
	
	        var requestedResourceSuffix = "";
	        var receivedResourceSuffix = "";
	        var icon = null;
	
	        if (isResourceUnmatched) {
	          icon = _react2.default.createElement(_Icon2.default, { color: "red", id: "close", size: "mini" });
	
	          if (unmatchedResource.includes(_DeclinedOffersReasons2.default.UNFULFILLED_ROLE) && _this2.areResourcesUnmatched(requestedResource, receivedResource)) {
	            requestedResourceSuffix = "(Role: " + summary.roles.requested + ")";
	            receivedResourceSuffix = "(Role: " + row.offered.roles + ")";
	          }
	        } else {
	          icon = _react2.default.createElement(_Icon2.default, { color: "green", id: "check", size: "mini" });
	        }
	
	        if (Array.isArray(receivedResource)) {
	          receivedResource = receivedResource.join(", ");
	        }
	
	        if (Array.isArray(requestedResource)) {
	          requestedResource = requestedResource.join(", ");
	        }
	
	        if (["cpus", "mem", "disk"].includes(prop)) {
	          requestedResource = _Units2.default.formatResource(prop, requestedResource);
	          receivedResource = _Units2.default.formatResource(prop, receivedResource);
	        } else {
	          if (!requestedResource) {
	            requestedResource = "N/A";
	          }
	
	          if (!receivedResource) {
	            receivedResource = "N/A";
	          }
	        }
	
	        var tooltipContent = _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Requested"
	            ),
	            ": ",
	            requestedResource,
	            " " + requestedResourceSuffix
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Received"
	            ),
	            ": ",
	            _react2.default.createElement(
	              "span",
	              { className: receivedResourceClasses },
	              receivedResource
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "text-nowrap" },
	              " " + receivedResourceSuffix
	            )
	          )
	        );
	
	        return _react2.default.createElement(
	          _reactjsComponents.Tooltip,
	          { content: tooltipContent, maxWidth: 400, wrapText: true },
	          icon
	        );
	      };
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { className: "hidden-large-up", style: { width: "30%" } }),
	        _react2.default.createElement("col", { className: "hidden-medium-down", style: { width: "10%" } }),
	        _react2.default.createElement("col", { className: "hidden-medium-down", style: { width: "10%" } }),
	        _react2.default.createElement("col", { className: "hidden-medium-down", style: { width: "10%" } }),
	        _react2.default.createElement("col", { style: { width: "10%" } }),
	        _react2.default.createElement("col", { className: "hidden-small-down" })
	      );
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var _this3 = this;
	
	      return [{
	        heading: this.getColumnHeadingFn("Host"),
	        prop: "hostname",
	        className: this.getColumnClassNameFn(),
	        render: function render(prop, row) {
	          var hostname = row[prop];
	          var node = _MesosStateStore2.default.getNodeFromHostname(hostname);
	
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { className: "table-cell-link-primary", to: "/nodes/" + node.id },
	            hostname
	          );
	        },
	        sortable: true
	      }, {
	        heading: this.getColumnHeadingFn("Role", "RLE"),
	        prop: "roles",
	        className: this.getColumnClassNameFn("text-align-center"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.UNFULFILLED_ROLE),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.UNFULFILLED_ROLE))
	      }, {
	        heading: this.getColumnHeadingFn("Constraint", "CSTR"),
	        prop: "constraints",
	        className: this.getColumnClassNameFn("text-align-center"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.UNFULFILLED_CONSTRAINT),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.UNFULFILLED_CONSTRAINT))
	      }, {
	        heading: this.getColumnHeadingFn("CPU/MEM/DSK"),
	        prop: "cpus",
	        className: this.getColumnClassNameFn("text-align-center hidden-large-up"),
	        render: function render(prop, row) {
	          return _react2.default.createElement(
	            "div",
	            { className: "flex flex-justify-items-space-around" },
	            _this3.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_CPU)(prop, row),
	            _this3.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_MEM)(prop, row),
	            _this3.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_DISK)(prop, row)
	          );
	        },
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.INSUFFICIENT_CPU))
	      }, {
	        heading: this.getColumnHeadingFn("CPU"),
	        prop: "cpus",
	        className: this.getColumnClassNameFn("text-align-center hidden-medium-down"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_CPU),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.INSUFFICIENT_CPU))
	      }, {
	        heading: this.getColumnHeadingFn("Mem"),
	        prop: "mem",
	        className: this.getColumnClassNameFn("text-align-center hidden-medium-down"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_MEM),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.INSUFFICIENT_MEM))
	      }, {
	        heading: this.getColumnHeadingFn("Disk", "DSK"),
	        prop: "disk",
	        className: this.getColumnClassNameFn("text-align-center hidden-medium-down"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_DISK),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.INSUFFICIENT_DISK))
	      }, {
	        heading: this.getColumnHeadingFn("Port", "PRT"),
	        prop: "ports",
	        className: this.getColumnClassNameFn("text-align-center"),
	        render: this.getMatchedOfferRenderFn(_DeclinedOffersReasons2.default.INSUFFICIENT_PORTS),
	        sortable: true,
	        sortFunction: _TableUtil2.default.getSortFunction("timestamp", this.getMatchedResourcesSortFn(_DeclinedOffersReasons2.default.INSUFFICIENT_PORTS))
	      }, {
	        heading: this.getColumnHeadingFn("Received"),
	        prop: "timestamp",
	        className: this.getColumnClassNameFn("text-align-right hidden-small-down"),
	        render: function render(prop, row) {
	          return _react2.default.createElement(_TimeAgo2.default, { time: _DateUtil2.default.strToMs(row[prop]) });
	        },
	        sortable: true
	      }];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var offers = this.props.offers;
	
	
	      return _react2.default.createElement(
	        _foundationUi.MountService.Mount,
	        { type: "DeclinedOffersTable" },
	        _react2.default.createElement(_reactjsComponents.Table, {
	          className: "table table-simple table-header-nowrap table-break-word table-hover flush-bottom",
	          colGroup: this.getColGroup(),
	          columns: this.getColumns(),
	          data: offers,
	          sortBy: { prop: "hostname", order: "asc" }
	        })
	      );
	    }
	  }]);
	  return DeclinedOffersTable;
	}(_react2.default.Component);
	
	module.exports = DeclinedOffersTable;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getColumnHeading", "renderColumnID", "renderColumnState", "renderColumnTerminationCode", "renderColumnTerminationMessage"];
	
	var PodContainerTerminationTable = function (_React$Component) {
	  (0, _inherits3.default)(PodContainerTerminationTable, _React$Component);
	
	  function PodContainerTerminationTable() {
	    (0, _classCallCheck3.default)(this, PodContainerTerminationTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodContainerTerminationTable.__proto__ || (0, _getPrototypeOf2.default)(PodContainerTerminationTable)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodContainerTerminationTable, [{
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = _ResourceTableUtil2.default.getClassName;
	
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "Container ID",
	        heading: this.getColumnHeading,
	        render: this.renderColumnID
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "Last State",
	        heading: this.getColumnHeading,
	        render: this.renderColumnState
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "Code",
	        heading: this.getColumnHeading,
	        render: this.renderColumnTerminationCode
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        prop: "Message",
	        heading: this.getColumnHeading,
	        render: this.renderColumnTerminationMessage
	      }];
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "160px" } }),
	        _react2.default.createElement("col", { style: { width: "80px" } }),
	        _react2.default.createElement("col", { style: { width: "160px" } })
	      );
	    }
	  }, {
	    key: "getColumnHeading",
	    value: function getColumnHeading(prop, order, sortBy) {
	      var _classNames;
	
	      var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", prop === sortBy.prop), _classNames));
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        prop,
	        _react2.default.createElement("span", { className: caretClassNames })
	      );
	    }
	  }, {
	    key: "renderColumnID",
	    value: function renderColumnID(prop, row) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        row.getId()
	      );
	    }
	  }, {
	    key: "renderColumnState",
	    value: function renderColumnState(prop, row) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        row.getLastKnownState()
	      );
	    }
	  }, {
	    key: "renderColumnTerminationCode",
	    value: function renderColumnTerminationCode(prop, row) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        row.getTermination().exitCode || 0
	      );
	    }
	  }, {
	    key: "renderColumnTerminationMessage",
	    value: function renderColumnTerminationMessage(prop, row) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        row.getTermination().message || "-"
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: this.props.className,
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        data: this.props.containers,
	        itemHeight: _TableUtil2.default.getRowHeight(),
	        sortBy: { prop: "ID", order: "desc" }
	      });
	    }
	  }]);
	  return PodContainerTerminationTable;
	}(_react2.default.Component);
	
	PodContainerTerminationTable.defaultProps = {
	  className: "table table-borderless-outer table-borderless-inner-columns flush-bottom",
	  containers: []
	};
	
	PodContainerTerminationTable.propTypes = {
	  className: _react2.default.PropTypes.string,
	  containers: _react2.default.PropTypes.array.isRequired
	};
	
	module.exports = PodContainerTerminationTable;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var displayedResourceValues = {
	  roles: "Role",
	  constraints: "Constraints",
	  cpus: "CPU",
	  mem: "Memory",
	  disk: "Disk",
	  ports: "Ports"
	};
	
	var MAX_BAR_HEIGHT = 200;
	
	function getGraphBar(resource, data, index) {
	  var resourceOfferSummary = data[resource];
	  var matchedOffers = resourceOfferSummary.matched;
	  var offeredCount = resourceOfferSummary.offers;
	  var percentageMatched = null;
	  var percentageOffered = null;
	
	  // Avoid NaN and infinite values from division by zero.
	  if (offeredCount === 0) {
	    percentageMatched = 0;
	  } else {
	    percentageMatched = matchedOffers / offeredCount;
	  }
	
	  if (data.roles.offers === 0 || offeredCount === 0) {
	    percentageOffered = 0;
	  } else {
	    percentageOffered = offeredCount / data.roles.offers;
	  }
	
	  var barGraphMatchedClasses = (0, _classnames2.default)("funnel-graph-item-bar-matched", {
	    "funnel-graph-item-bar-matched-border-top": percentageMatched > 0 && percentageMatched < 1
	  });
	
	  var offeredHeight = Math.ceil(MAX_BAR_HEIGHT * percentageOffered);
	  var matchedHeight = Math.ceil(offeredHeight * percentageMatched);
	
	  return _react2.default.createElement(
	    _reactjsComponents.Tooltip,
	    {
	      content: getResourceTooltipContent(resource, data),
	      interactive: true,
	      key: index,
	      width: 200,
	      wrapText: true,
	      wrapperClassName: "funnel-graph-item"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "funnel-graph-item-bar" },
	      _react2.default.createElement(
	        "div",
	        { className: "funnel-graph-item-percentage" },
	        Math.ceil(percentageMatched * 100),
	        "%"
	      ),
	      _react2.default.createElement(
	        "div",
	        {
	          className: "funnel-graph-item-bar-offered",
	          style: { flexBasis: offeredHeight + "px" }
	        },
	        _react2.default.createElement("div", {
	          className: barGraphMatchedClasses,
	          style: { flexBasis: matchedHeight + "px" }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "funnel-graph-item-label" },
	      _react2.default.createElement(
	        "div",
	        { className: "funnel-graph-item-label-primary" },
	        displayedResourceValues[resource]
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "funnel-graph-item-label-secondary small flush-bottom" },
	        _Units2.default.contractNumber(resourceOfferSummary.matched),
	        "/",
	        _Units2.default.contractNumber(resourceOfferSummary.offers)
	      )
	    )
	  );
	}
	
	function getGraphSpacer(_ref) {
	  var key = _ref.key,
	      _ref$showIcon = _ref.showIcon,
	      showIcon = _ref$showIcon === undefined ? true : _ref$showIcon;
	
	  var icon = null;
	
	  if (showIcon) {
	    icon = _react2.default.createElement(_Icon2.default, { id: "caret-right", size: "small", color: "light-grey" });
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "funnel-graph-item-spacer", key: key },
	    icon,
	    _react2.default.createElement("div", { className: "funnel-graph-item-label" })
	  );
	}
	
	function getResourceTooltipContent(resource, data) {
	  var _data$resource = data[resource],
	      matched = _data$resource.matched,
	      offers = _data$resource.offers,
	      requestedValue = _data$resource.requested;
	
	  var docsURI = null;
	  var explanatoryText = null;
	
	  if (matched === 0) {
	    explanatoryText = "did not match";
	  } else if (matched >= offers) {
	    explanatoryText = "matched";
	  } else {
	    explanatoryText = "partially matched";
	  }
	
	  if (resource === "roles") {
	    docsURI = _Config2.default.mesosDocsURI + "roles/";
	    explanatoryText = "The resource offer " + explanatoryText + " your service's role (" + requestedValue + ").";
	  }
	
	  if (resource === "constraints") {
	    docsURI = _Config2.default.marathonDocsURI + "constraints.html";
	    explanatoryText = "The resource offer " + explanatoryText + " your service's requirements (" + requestedValue + ").";
	  }
	
	  if (resource === "cpus") {
	    docsURI = _Config2.default.mesosDocsURI + "attributes-resources/";
	    explanatoryText = "The CPUs offered " + explanatoryText + " your service's requirements (" + requestedValue + ").";
	  }
	
	  if (resource === "mem") {
	    requestedValue = _Units2.default.formatResource(resource, requestedValue);
	    docsURI = _Config2.default.mesosDocsURI + "attributes-resources/";
	    explanatoryText = "The memory offered " + explanatoryText + " your service's requirements (" + requestedValue + ").";
	  }
	
	  if (resource === "disk") {
	    requestedValue = _Units2.default.formatResource(resource, requestedValue);
	    explanatoryText = "The disk space offered " + explanatoryText + " your service's requirements (" + requestedValue + ").";
	    docsURI = _Config2.default.mesosDocsURI + "attributes-resources/";
	  }
	
	  if (resource === "ports") {
	    explanatoryText = "The port offered " + explanatoryText + " your service's requirements (" + requestedValue + ").";
	    docsURI = _Config2.default.mesosDocsURI + "attributes-resources/";
	  }
	
	  return _react2.default.createElement(
	    "span",
	    null,
	    explanatoryText,
	    " ",
	    _react2.default.createElement(
	      "a",
	      { href: docsURI, target: "_blank" },
	      "Learn more"
	    ),
	    "."
	  );
	}
	
	function RecentOffersSummary(_ref2) {
	  var data = _ref2.data;
	
	  var funnelItems = ["roles", "constraints", "cpus", "mem", "disk", "ports"];
	  var funnelGraphItems = funnelItems.reduce(function (accumulator, item, index) {
	    accumulator.push(getGraphBar(item, data, index));
	
	    if (index < funnelItems.length - 1) {
	      accumulator.push(getGraphSpacer({ key: "spacer-" + index }));
	    }
	
	    return accumulator;
	  }, []);
	
	  funnelGraphItems.unshift(getGraphSpacer({ key: "graph-start", showIcon: false }));
	
	  funnelGraphItems.push(getGraphSpacer({ key: "graph-end", showIcon: false }));
	
	  return _react2.default.createElement(
	    "div",
	    { className: "funnel-graph pod flush-horizontal" },
	    _react2.default.createElement(
	      "div",
	      { className: "funnel-graph-bars" },
	      funnelGraphItems
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "funnel-graph-key" },
	      _react2.default.createElement(
	        "div",
	        { className: "funnel-graph-key-item" },
	        _react2.default.createElement("span", { className: "funnel-graph-key-dot funnel-graph-key-dot-matched dot" }),
	        "Matched"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "funnel-graph-key-item" },
	        _react2.default.createElement("span", { className: "funnel-graph-key-dot funnel-graph-key-dot-declined dot" }),
	        "Declined"
	      )
	    )
	  );
	}
	
	module.exports = RecentOffersSummary;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _Alert = __webpack_require__(1730);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _DeclinedOffersHelpText = __webpack_require__(1831);
	
	var _DeclinedOffersHelpText2 = _interopRequireDefault(_DeclinedOffersHelpText);
	
	var _DeclinedOffersTable = __webpack_require__(1832);
	
	var _DeclinedOffersTable2 = _interopRequireDefault(_DeclinedOffersTable);
	
	var _MarathonStore = __webpack_require__(1221);
	
	var _MarathonStore2 = _interopRequireDefault(_MarathonStore);
	
	var _RecentOffersSummary = __webpack_require__(1834);
	
	var _RecentOffersSummary2 = _interopRequireDefault(_RecentOffersSummary);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _Framework = __webpack_require__(1060);
	
	var _Framework2 = _interopRequireDefault(_Framework);
	
	var _TaskStatsTable = __webpack_require__(1836);
	
	var _TaskStatsTable2 = _interopRequireDefault(_TaskStatsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleJumpToRecentOffersClick"];
	
	var ServiceDebugContainer = function (_React$Component) {
	  (0, _inherits3.default)(ServiceDebugContainer, _React$Component);
	
	  function ServiceDebugContainer() {
	    (0, _classCallCheck3.default)(this, ServiceDebugContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceDebugContainer.__proto__ || (0, _getPrototypeOf2.default)(ServiceDebugContainer)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceDebugContainer, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _MarathonStore2.default.setShouldEmbedLastUnusedOffers(true);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _MarathonStore2.default.setShouldEmbedLastUnusedOffers(false);
	    }
	  }, {
	    key: "getDeclinedOffersTable",
	    value: function getDeclinedOffersTable() {
	      var service = this.props.service;
	
	
	      if (!this.shouldShowDeclinedOfferTable()) {
	        return null;
	      }
	
	      var queue = service.getQueue();
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 2 },
	          "Details"
	        ),
	        _react2.default.createElement(_DeclinedOffersTable2.default, {
	          offers: queue.declinedOffers.offers,
	          service: service,
	          summary: queue.declinedOffers.summary
	        })
	      );
	    }
	  }, {
	    key: "getLastTaskFailureInfo",
	    value: function getLastTaskFailureInfo() {
	      var lastTaskFailure = this.props.service.getLastTaskFailure();
	      if (lastTaskFailure == null) {
	        return _react2.default.createElement(
	          "p",
	          null,
	          "This app does not have failed tasks"
	        );
	      }
	
	      var version = lastTaskFailure.version,
	          timestamp = lastTaskFailure.timestamp,
	          taskId = lastTaskFailure.taskId,
	          state = lastTaskFailure.state,
	          message = lastTaskFailure.message,
	          host = lastTaskFailure.host;
	
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Task ID"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getValueText(taskId)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "State"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getValueText(state)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Message"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getValueText(message)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Host"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            this.getValueText(host)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Timestamp"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            timestamp,
	            " (",
	            _react2.default.createElement(_TimeAgo2.default, { time: new Date(timestamp) }),
	            ")"
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Version"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            version,
	            " (",
	            _react2.default.createElement(_TimeAgo2.default, { time: new Date(version) }),
	            ")"
	          )
	        )
	      );
	    }
	  }, {
	    key: "getLastVersionChange",
	    value: function getLastVersionChange() {
	      var versionInfo = this.props.service.getVersionInfo();
	      if (versionInfo == null) {
	        return _react2.default.createElement(
	          "p",
	          null,
	          "This app does not have version change information"
	        );
	      }
	
	      var lastScalingAt = versionInfo.lastScalingAt,
	          lastConfigChangeAt = versionInfo.lastConfigChangeAt;
	
	      var lastScaling = "No operation since last config change";
	      if (lastScalingAt !== lastConfigChangeAt) {
	        lastScaling = _react2.default.createElement(
	          "span",
	          null,
	          lastScalingAt,
	          " (",
	          _react2.default.createElement(_TimeAgo2.default, { time: new Date(lastScalingAt) }),
	          ")"
	        );
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Scale or Restart"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            lastScaling
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Configuration"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            lastConfigChangeAt + " ",
	            "(",
	            _react2.default.createElement(_TimeAgo2.default, { time: new Date(lastConfigChangeAt) }),
	            ")"
	          )
	        )
	      );
	    }
	  }, {
	    key: "getRecentOfferSummaryContent",
	    value: function getRecentOfferSummaryContent() {
	      var service = this.props.service;
	
	
	      if (!this.shouldShowDeclinedOfferSummary()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          { level: 2 },
	          "Summary"
	        ),
	        _react2.default.createElement(_RecentOffersSummary2.default, { data: service.getQueue().declinedOffers.summary })
	      );
	    }
	  }, {
	    key: "getRecentOfferSummaryCount",
	    value: function getRecentOfferSummaryCount() {
	      var service = this.props.service;
	
	
	      if (!this.shouldShowDeclinedOfferSummary()) {
	        return null;
	      }
	
	      var queue = service.getQueue();
	      var summary = queue.declinedOffers.summary;
	      var _summary$roles$offers = summary.roles.offers,
	          offers = _summary$roles$offers === undefined ? 0 : _summary$roles$offers;
	
	
	      return " (" + offers + ")";
	    }
	  }, {
	    key: "getRecentOfferSummaryDisabledText",
	    value: function getRecentOfferSummaryDisabledText(frameworkName) {
	      if (frameworkName != null) {
	        return "Rejected offer analysis is not currently supported for " + frameworkName + ".";
	      }
	
	      return "Rejected offer analysis is not currently supported.";
	    }
	  }, {
	    key: "getRecentOfferSummaryIntroText",
	    value: function getRecentOfferSummaryIntroText() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Framework2.default) {
	        var frameworkName = service.getPackageName();
	
	        return this.getRecentOfferSummaryDisabledText(frameworkName);
	      }
	
	      if (this.shouldShowDeclinedOfferSummary()) {
	        return _DeclinedOffersHelpText2.default.summaryIntro;
	      }
	
	      return "Offers will appear here when your service is deploying or waiting for resources.";
	    }
	  }, {
	    key: "getRecentOfferSummary",
	    value: function getRecentOfferSummary() {
	      var _this2 = this;
	
	      var introText = this.getRecentOfferSummaryIntroText();
	      var mainContent = this.getRecentOfferSummaryContent();
	      var offerCount = this.getRecentOfferSummaryCount();
	
	      return _react2.default.createElement(
	        "div",
	        {
	          ref: function ref(_ref) {
	            _this2.offerSummaryRef = _ref;
	          }
	        },
	        _react2.default.createElement(
	          _ConfigurationMapHeading2.default,
	          null,
	          "Recent Resource Offers",
	          offerCount
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          introText
	        ),
	        mainContent
	      );
	    }
	  }, {
	    key: "getTaskStats",
	    value: function getTaskStats() {
	      var taskStats = this.props.service.getTaskStats();
	
	      if (taskStats.getList().getItems().length === 0) {
	        return _react2.default.createElement(
	          "p",
	          null,
	          "This app does not have task statistics"
	        );
	      }
	
	      return _react2.default.createElement(_TaskStatsTable2.default, { taskStats: taskStats });
	    }
	  }, {
	    key: "getValueText",
	    value: function getValueText(value) {
	      if (value == null || value === "") {
	        return _react2.default.createElement(
	          "p",
	          null,
	          "Unspecified"
	        );
	      }
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        value
	      );
	    }
	  }, {
	    key: "getWaitingForResourcesNotice",
	    value: function getWaitingForResourcesNotice() {
	      var service = this.props.service;
	
	
	      if (service instanceof _Framework2.default) {
	        return null;
	      }
	
	      var queue = service.getQueue();
	
	      if (queue == null || queue.since == null) {
	        return null;
	      }
	
	      var waitingSince = _DateUtil2.default.strToMs(queue.since);
	      var timeWaiting = Date.now() - waitingSince;
	
	      // If the service has been waiting for less than five minutes, we don't
	      // display the warning.
	      if (timeWaiting < 1000 * 60 * 5) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Alert2.default,
	        null,
	        "DC/OS has been waiting for resources and is unable to complete this deployment for ",
	        _DateUtil2.default.getDuration(timeWaiting, null),
	        ". ",
	        _react2.default.createElement(
	          "a",
	          { className: "clickable", onClick: this.handleJumpToRecentOffersClick },
	          "See recent resource offers"
	        ),
	        "."
	      );
	    }
	  }, {
	    key: "handleJumpToRecentOffersClick",
	    value: function handleJumpToRecentOffersClick() {
	      if (this.offerSummaryRef) {
	        this.offerSummaryRef.scrollIntoView();
	      }
	    }
	  }, {
	    key: "shouldShowDeclinedOfferSummary",
	    value: function shouldShowDeclinedOfferSummary() {
	      var service = this.props.service;
	
	
	      return !this.shouldSuppressDeclinedOfferDetails() && service.getQueue().declinedOffers.summary != null;
	    }
	  }, {
	    key: "shouldShowDeclinedOfferTable",
	    value: function shouldShowDeclinedOfferTable() {
	      var service = this.props.service;
	
	
	      return !this.shouldSuppressDeclinedOfferDetails() && service.getQueue().declinedOffers.offers != null;
	    }
	  }, {
	    key: "shouldSuppressDeclinedOfferDetails",
	    value: function shouldSuppressDeclinedOfferDetails() {
	      var service = this.props.service;
	
	      var queue = service.getQueue();
	
	      return queue == null || service instanceof _Framework2.default;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        this.getWaitingForResourcesNotice(),
	        _react2.default.createElement(
	          _ConfigurationMap2.default,
	          null,
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Last Changes"
	            ),
	            this.getLastVersionChange()
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Last Task Failure"
	            ),
	            this.getLastTaskFailureInfo()
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapSection2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              null,
	              "Task Statistics"
	            ),
	            this.getTaskStats()
	          ),
	          this.getRecentOfferSummary(),
	          this.getDeclinedOffersTable()
	        )
	      );
	    }
	  }]);
	  return ServiceDebugContainer;
	}(_react2.default.Component);
	
	ServiceDebugContainer.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	ServiceDebugContainer.propTypes = {
	  service: _react2.default.PropTypes.instanceOf(_Service2.default)
	};
	
	module.exports = ServiceDebugContainer;

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _DateUtil = __webpack_require__(1105);
	
	var _DateUtil2 = _interopRequireDefault(_DateUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var taskStatus = ["getRunningTaskCount", "getHealthyTaskCount", "getUnhealthyTaskCount", "getStagedTaskCount"];
	var nameMapping = {
	  startedAfterLastScaling: "Started After Last Scaling",
	  withLatestConfig: "With Latest Config",
	  withOutdatedConfig: "With Outdated Config",
	  totalSummary: "Total Summary"
	};
	var headerMapping = {
	  getRunningTaskCount: "RUNNING",
	  getHealthyTaskCount: "HEALTHY",
	  getUnhealthyTaskCount: "UNHEALTHY",
	  getStagedTaskCount: "STAGED",
	  getMedianLifeTime: "MEDIAN LIFETIME"
	};
	
	var TaskStatsTable = function (_React$Component) {
	  (0, _inherits3.default)(TaskStatsTable, _React$Component);
	
	  function TaskStatsTable() {
	    (0, _classCallCheck3.default)(this, TaskStatsTable);
	    return (0, _possibleConstructorReturn3.default)(this, (TaskStatsTable.__proto__ || (0, _getPrototypeOf2.default)(TaskStatsTable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TaskStatsTable, [{
	    key: "getClassName",
	    value: function getClassName(prop, sortBy) {
	      var shouldAlignRight = taskStatus.includes(prop) || prop === "getMedianLifeTime";
	
	      return (0, _classnames2.default)({
	        active: prop === sortBy.prop,
	        "text-align-right": shouldAlignRight,
	        "hidden-small-down": taskStatus.includes(prop)
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var getClassName = this.getClassName;
	      var heading = this.renderHeading;
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getName",
	        render: function render(prop, taskStats) {
	          return nameMapping[taskStats.getName()];
	        },
	
	        sortable: false
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getRunningTaskCount",
	        render: this.getStatus,
	        sortable: false
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getHealthyTaskCount",
	        render: this.getStatus,
	        sortable: false
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getUnhealthyTaskCount",
	        render: this.getStatus,
	        sortable: false
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getStagedTaskCount",
	        render: this.getStatus,
	        sortable: false
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "getMedianLifeTime",
	        render: this.renderTime,
	        sortable: false
	      }];
	    }
	  }, {
	    key: "renderHeading",
	    value: function renderHeading(prop) {
	      return _react2.default.createElement(
	        "span",
	        { className: "table-header-title" },
	        headerMapping[prop]
	      );
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "20%" } }),
	        _react2.default.createElement("col", { style: { width: "95px" }, className: "hidden-small-down" }),
	        _react2.default.createElement("col", { style: { width: "90px" }, className: "hidden-small-down" }),
	        _react2.default.createElement("col", { style: { width: "105px" }, className: "hidden-small-down" }),
	        _react2.default.createElement("col", { style: { width: "90px" }, className: "hidden-small-down" }),
	        _react2.default.createElement("col", null)
	      );
	    }
	  }, {
	    key: "getStatus",
	    value: function getStatus(prop, taskStats) {
	      return taskStats[prop]();
	    }
	  }, {
	    key: "renderTime",
	    value: function renderTime(prop, taskStats) {
	      var label = "seconds";
	      var lifeTimeSeconds = taskStats[prop]();
	      var timeValue = lifeTimeSeconds;
	
	      if (lifeTimeSeconds > 3600) {
	        label = "minutes";
	        timeValue = timeValue / 60;
	      }
	
	      timeValue = new Number(parseFloat(timeValue).toFixed()).toLocaleString();
	
	      var humanReadable = _DateUtil2.default.getDuration(parseInt(lifeTimeSeconds, 10));
	
	      return timeValue + " " + label + " (" + humanReadable + ")";
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_reactjsComponents.Table, {
	        className: "table table-simple table-borderless-outer table-borderless-inner-columns table-hover flush-bottom",
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        data: this.props.taskStats.getList().getItems()
	      });
	    }
	  }]);
	  return TaskStatsTable;
	}(_react2.default.Component);
	
	module.exports = TaskStatsTable;

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodInstancesContainer = __webpack_require__(1838);
	
	var _PodInstancesContainer2 = _interopRequireDefault(_PodInstancesContainer);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _ServiceInstancesContainer = __webpack_require__(1844);
	
	var _ServiceInstancesContainer2 = _interopRequireDefault(_ServiceInstancesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HighOrderServiceInstances = function HighOrderServiceInstances(props) {
	  var service = props.service,
	      params = props.params;
	
	  if (service instanceof _Pod2.default) {
	    return _react2.default.createElement(_PodInstancesContainer2.default, { pod: service });
	  }
	
	  return _react2.default.createElement(_ServiceInstancesContainer2.default, { service: service, params: params });
	};
	
	HighOrderServiceInstances.propTypes = {
	  params: _react2.default.PropTypes.object.isRequired,
	  service: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_Pod2.default), _react2.default.PropTypes.instanceOf(_Service2.default)])
	};
	
	module.exports = HighOrderServiceInstances;

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _ContainerUtil = __webpack_require__(1553);
	
	var _ContainerUtil2 = _interopRequireDefault(_ContainerUtil);
	
	var _EventTypes = __webpack_require__(933);
	
	var _EventTypes2 = _interopRequireDefault(_EventTypes);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _ActionKeys = __webpack_require__(1554);
	
	var _ActionKeys2 = _interopRequireDefault(_ActionKeys);
	
	var _MarathonActions = __webpack_require__(1224);
	
	var _MarathonActions2 = _interopRequireDefault(_MarathonActions);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodInstancesView = __webpack_require__(1839);
	
	var _PodInstancesView2 = _interopRequireDefault(_PodInstancesView);
	
	var _PodUtil = __webpack_require__(1842);
	
	var _PodUtil2 = _interopRequireDefault(_PodUtil);
	
	var _ServiceActionItem = __webpack_require__(1555);
	
	var _ServiceActionItem2 = _interopRequireDefault(_ServiceActionItem);
	
	var _TaskModals = __webpack_require__(1556);
	
	var _TaskModals2 = _interopRequireDefault(_TaskModals);
	
	var _ActionTypes = __webpack_require__(1223);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleMesosStateChange", "handleServerAction", "handleModalClose", "clearActionError", "killPodInstances"];
	
	var PodInstancesContainer = function (_React$Component) {
	  (0, _inherits3.default)(PodInstancesContainer, _React$Component);
	
	  function PodInstancesContainer() {
	    (0, _classCallCheck3.default)(this, PodInstancesContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodInstancesContainer.__proto__ || (0, _getPrototypeOf2.default)(PodInstancesContainer)).apply(this, arguments));
	
	    _this.state = {
	      actionErrors: {},
	      lastUpdate: 0,
	      pendingActions: {}
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodInstancesContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _MesosStateStore2.default.addChangeListener(_EventTypes2.default.MESOS_STATE_CHANGE, this.handleMesosStateChange);
	      // Listen for server actions so we can update state immediately
	      // on the completion of an API request.
	      this.dispatcher = _AppDispatcher2.default.register(this.handleServerAction);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _MesosStateStore2.default.removeChangeListener(_EventTypes2.default.MESOS_STATE_CHANGE, this.handleMesosStateChange);
	
	      _AppDispatcher2.default.unregister(this.dispatcher);
	    }
	  }, {
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        modalHandlers: this.getModalHandlers()
	      };
	    }
	  }, {
	    key: "killPodInstances",
	    value: function killPodInstances() {
	      this.setPendingAction(_ActionKeys2.default.POD_INSTANCES_KILL);
	
	      return _MarathonActions2.default.killPodInstances.apply(_MarathonActions2.default, arguments);
	    }
	  }, {
	    key: "handleMesosStateChange",
	    value: function handleMesosStateChange() {
	      this.setState({
	        lastUpdate: Date.now()
	      });
	    }
	  }, {
	    key: "handleServerAction",
	    value: function handleServerAction(payload) {
	      var action = payload.action;
	
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_MARATHON_POD_INSTANCE_KILL_ERROR:
	          this.unsetPendingAction(_ActionKeys2.default.POD_INSTANCES_KILL, action.data);
	          break;
	        case _ActionTypes.REQUEST_MARATHON_POD_INSTANCE_KILL_SUCCESS:
	          this.unsetPendingAction(_ActionKeys2.default.POD_INSTANCES_KILL);
	          break;
	      }
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose(key) {
	      if (key) {
	        this.clearActionError(key);
	      }
	      this.setState({ modal: {} });
	    }
	  }, {
	    key: "fetchData",
	    value: function fetchData() {}
	    // Re-fetch data - this will end up being a single Relay request
	
	    /**
	     * Sets the actionType to pending in state which will in turn be pushed
	     * to children components as a prop. Also clears any existing error for
	     * the actionType
	     * @param {String} actionType
	     */
	
	  }, {
	    key: "setPendingAction",
	    value: function setPendingAction(actionType) {
	      var _state = this.state,
	          actionErrors = _state.actionErrors,
	          pendingActions = _state.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, true)
	      });
	    }
	    /**
	     * Sets the pending actionType to false in state which will in turn be
	     * pushed down to children via props. Can optional set an error for the
	     * actionType
	     * @param  {String} actionType
	     * @param  {Any} error
	     */
	
	  }, {
	    key: "unsetPendingAction",
	    value: function unsetPendingAction(actionType) {
	      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var _state2 = this.state,
	          actionErrors = _state2.actionErrors,
	          pendingActions = _state2.pendingActions;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, error),
	        pendingActions: _ContainerUtil2.default.adjustPendingActions(pendingActions, actionType, false)
	      });
	
	      // Fetch new data if action was successful
	      if (!error) {
	        this.fetchData();
	      }
	    }
	  }, {
	    key: "clearActionError",
	    value: function clearActionError(actionType) {
	      var actionErrors = this.state.actionErrors;
	
	
	      this.setState({
	        actionErrors: _ContainerUtil2.default.adjustActionErrors(actionErrors, actionType, null)
	      });
	    }
	  }, {
	    key: "getModalHandlers",
	    value: function getModalHandlers() {
	      var _this2 = this;
	
	      var set = function set(id, props) {
	        // Set props to be passed into modal
	        _this2.setState({
	          modal: (0, _assign2.default)({}, props, { id: id })
	        });
	      };
	
	      return {
	        killPodInstances: function killPodInstances(props) {
	          return set(_ServiceActionItem2.default.KILL_POD_INSTANCES, props);
	        }
	      };
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      return {
	        killPodInstances: this.killPodInstances
	      };
	    }
	  }, {
	    key: "getModals",
	    value: function getModals() {
	      var pod = this.props.pod;
	
	      var modalProps = (0, _assign2.default)({ pod: pod }, this.state.modal);
	
	      return _react2.default.createElement(_TaskModals2.default, {
	        actions: this.getActions(),
	        actionErrors: this.state.actionErrors,
	        clearError: this.clearActionError,
	        onClose: this.handleModalClose,
	        pendingActions: this.state.pendingActions,
	        modalProps: modalProps
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var pod = this.props.pod;
	
	
	      var historicalInstances = _MesosStateStore2.default.getPodHistoricalInstances(pod);
	      var instances = _PodUtil2.default.mergeHistoricalInstanceList(pod.getInstanceList(), historicalInstances);
	
	      instances = instances.mapItems(function (instance) {
	        instance.agent = _MesosStateStore2.default.getNodeFromHostname(instance.getAgentAddress());
	
	        return instance;
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_PodInstancesView2.default, { instances: instances, pod: pod }),
	        this.getModals()
	      );
	    }
	  }]);
	  return PodInstancesContainer;
	}(_react2.default.Component);
	
	// Make these modal handlers available via context
	// so any child can trigger the opening of modals
	
	
	PodInstancesContainer.childContextTypes = {
	  modalHandlers: _react.PropTypes.shape({
	    killPodInstances: _react.PropTypes.func
	  })
	};
	
	PodInstancesContainer.propTypes = {
	  pod: _react.PropTypes.instanceOf(_Pod2.default)
	};
	
	module.exports = PodInstancesContainer;

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _FilterHeadline = __webpack_require__(1321);
	
	var _FilterHeadline2 = _interopRequireDefault(_FilterHeadline);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodInstanceList = __webpack_require__(1228);
	
	var _PodInstanceList2 = _interopRequireDefault(_PodInstanceList);
	
	var _PodInstancesTable = __webpack_require__(1840);
	
	var _PodInstancesTable2 = _interopRequireDefault(_PodInstancesTable);
	
	var _PodInstanceStatus = __webpack_require__(1233);
	
	var _PodInstanceStatus2 = _interopRequireDefault(_PodInstanceStatus);
	
	var _PodUtil = __webpack_require__(1842);
	
	var _PodUtil2 = _interopRequireDefault(_PodUtil);
	
	var _PodViewFilter = __webpack_require__(1843);
	
	var _PodViewFilter2 = _interopRequireDefault(_PodViewFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleFilterChange", "handleFilterReset", "handleKillClick", "handleKillAndScaleClick", "handleSelectionChange"];
	
	var PodInstancesView = function (_React$Component) {
	  (0, _inherits3.default)(PodInstancesView, _React$Component);
	
	  function PodInstancesView() {
	    (0, _classCallCheck3.default)(this, PodInstancesView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodInstancesView.__proto__ || (0, _getPrototypeOf2.default)(PodInstancesView)).apply(this, arguments));
	
	    _this.state = {
	      filter: {
	        text: "",
	        status: "active"
	      },
	      selectedItems: []
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodInstancesView, [{
	    key: "getInstanceFilterStatus",
	    value: function getInstanceFilterStatus(instance) {
	      var status = instance.getInstanceStatus();
	      switch (status) {
	        case _PodInstanceStatus2.default.STAGED:
	          return "staged";
	
	        case _PodInstanceStatus2.default.HEALTHY:
	        case _PodInstanceStatus2.default.UNHEALTHY:
	        case _PodInstanceStatus2.default.RUNNING:
	          return "active";
	
	        case _PodInstanceStatus2.default.KILLED:
	          return "completed";
	
	        default:
	          return "";
	      }
	    }
	  }, {
	    key: "getKillButtons",
	    value: function getKillButtons() {
	      if (!this.state.selectedItems.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection flush-bottom" },
	        _react2.default.createElement(
	          "div",
	          { className: "button button-link", onClick: this.handleKillClick },
	          _react2.default.createElement(_Icon2.default, { id: "repeat", size: "mini" }),
	          _react2.default.createElement(
	            "span",
	            null,
	            "Restart"
	          )
	        )
	      );
	    }
	  }, {
	    key: "handleFilterChange",
	    value: function handleFilterChange(filter) {
	      this.setState({ filter: filter });
	    }
	  }, {
	    key: "handleFilterReset",
	    value: function handleFilterReset() {
	      this.setState({
	        filter: {
	          text: "",
	          status: "all"
	        }
	      });
	    }
	  }, {
	    key: "handleKillClick",
	    value: function handleKillClick() {
	      var selectedItems = this.state.selectedItems;
	
	
	      if (!selectedItems.length) {
	        return;
	      }
	
	      this.context.modalHandlers.killPodInstances({
	        action: "restart",
	        selectedItems: selectedItems
	      });
	    }
	  }, {
	    key: "handleKillAndScaleClick",
	    value: function handleKillAndScaleClick() {
	      var selectedItems = this.state.selectedItems;
	
	
	      if (!selectedItems.length) {
	        return;
	      }
	
	      this.context.modalHandlers.killPodInstances({
	        action: "stop",
	        selectedItems: selectedItems
	      });
	    }
	  }, {
	    key: "handleSelectionChange",
	    value: function handleSelectionChange(selectedItems) {
	      this.setState({ selectedItems: selectedItems });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var filter = this.state.filter;
	      var instances = this.props.instances;
	
	
	      var filteredTextItems = instances;
	      var filteredItems = instances;
	
	      if (filter.text) {
	        filteredTextItems = instances.filterItems(function (instance) {
	          return _PodUtil2.default.isInstanceOrChildrenMatchingText(instance, filter.text);
	        });
	        filteredItems = filteredTextItems;
	      }
	
	      if (filter.status && filter.status !== "all") {
	        filteredItems = filteredTextItems.filterItems(function (instance) {
	          return _this2.getInstanceFilterStatus(instance) === filter.status;
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_FilterHeadline2.default, {
	          currentLength: filteredItems.getItems().length,
	          isFiltering: filter.text || filter.status !== "all",
	          name: "Instance",
	          onReset: this.handleFilterReset,
	          totalLength: instances.getItems().length
	        }),
	        _react2.default.createElement(
	          _PodViewFilter2.default,
	          {
	            filter: filter,
	            items: filteredTextItems.getItems(),
	            onFilterChange: this.handleFilterChange,
	            statusChoices: ["all", "active", "completed"],
	            statusMapper: this.getInstanceFilterStatus
	          },
	          this.getKillButtons()
	        ),
	        _react2.default.createElement(_PodInstancesTable2.default, {
	          filterText: filter.text,
	          instances: filteredItems,
	          onSelectionChange: this.handleSelectionChange,
	          pod: this.props.pod
	        })
	      );
	    }
	  }]);
	  return PodInstancesView;
	}(_react2.default.Component);
	
	PodInstancesView.contextTypes = {
	  modalHandlers: _react2.default.PropTypes.shape({
	    killPodInstances: _react2.default.PropTypes.func.isRequired
	  }).isRequired,
	  router: _reactRouter.routerShape
	};
	
	PodInstancesView.propTypes = {
	  instances: _react2.default.PropTypes.instanceOf(_PodInstanceList2.default).isRequired,
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default).isRequired
	};
	
	module.exports = PodInstancesView;

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(929);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _deepEqual = __webpack_require__(802);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(785);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _CheckboxTable = __webpack_require__(1475);
	
	var _CheckboxTable2 = _interopRequireDefault(_CheckboxTable);
	
	var _CollapsingString = __webpack_require__(1474);
	
	var _CollapsingString2 = _interopRequireDefault(_CollapsingString);
	
	var _ExpandingTable = __webpack_require__(1476);
	
	var _ExpandingTable2 = _interopRequireDefault(_ExpandingTable);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TimeAgo = __webpack_require__(1343);
	
	var _TimeAgo2 = _interopRequireDefault(_TimeAgo);
	
	var _Units = __webpack_require__(1400);
	
	var _Units2 = _interopRequireDefault(_Units);
	
	var _Pod = __webpack_require__(1227);
	
	var _Pod2 = _interopRequireDefault(_Pod);
	
	var _PodInstanceList = __webpack_require__(1228);
	
	var _PodInstanceList2 = _interopRequireDefault(_PodInstanceList);
	
	var _PodInstanceStatus = __webpack_require__(1233);
	
	var _PodInstanceStatus2 = _interopRequireDefault(_PodInstanceStatus);
	
	var _PodTableHeaderLabels = __webpack_require__(1841);
	
	var _PodTableHeaderLabels2 = _interopRequireDefault(_PodTableHeaderLabels);
	
	var _PodUtil = __webpack_require__(1842);
	
	var _PodUtil2 = _interopRequireDefault(_PodUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tableColumnClasses = {
	  checkbox: "task-table-column-checkbox",
	  name: "task-table-column-primary",
	  address: "task-table-column-host-address",
	  status: "task-table-column-status",
	  health: "task-table-column-health",
	  logs: "task-table-column-logs",
	  cpus: "task-table-column-cpus",
	  mem: "task-table-column-mem",
	  updated: "task-table-column-updated",
	  version: "task-table-column-version"
	};
	
	var METHODS_TO_BIND = ["getColGroup", "handleItemCheck", "renderColumnAddress", "renderColumnID", "renderColumnLogs", "renderColumnResource", "renderColumnStatus", "renderColumnHealth", "renderColumnUpdated", "renderColumnVersion"];
	
	var PodInstancesTable = function (_React$Component) {
	  (0, _inherits3.default)(PodInstancesTable, _React$Component);
	
	  function PodInstancesTable() {
	    (0, _classCallCheck3.default)(this, PodInstancesTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodInstancesTable.__proto__ || (0, _getPrototypeOf2.default)(PodInstancesTable)).apply(this, arguments));
	
	    _this.state = {
	      checkedItems: {}
	    };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodInstancesTable, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var checkedItems = this.state.checkedItems;
	
	      var prevInstances = this.props.instances.getItems();
	      var nextInstances = nextProps.instances.getItems();
	
	      // When the `instances` property is changed and we have selected
	      // items, re-trigger selection change in order to remove checked
	      // entries that are no longer present.
	
	      if ((0, _keys2.default)(checkedItems).length && !(0, _deepEqual2.default)(prevInstances, nextInstances)) {
	        this.triggerSelectionChange(checkedItems, nextProps.instances);
	      }
	    }
	  }, {
	    key: "triggerSelectionChange",
	    value: function triggerSelectionChange(checkedItems, instances) {
	      var checkedItemInstances = instances.getItems().filter(function (item) {
	        return checkedItems[item.getId()];
	      });
	      this.props.onSelectionChange(checkedItemInstances);
	    }
	  }, {
	    key: "handleItemCheck",
	    value: function handleItemCheck(idsChecked) {
	      var checkedItems = {};
	
	      idsChecked.forEach(function (id) {
	        checkedItems[id] = true;
	      });
	      this.setState({ checkedItems: checkedItems });
	
	      this.triggerSelectionChange(checkedItems, this.props.instances);
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { className: tableColumnClasses.checkbox }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { className: tableColumnClasses.address }),
	        _react2.default.createElement("col", { className: tableColumnClasses.status }),
	        _react2.default.createElement("col", { className: tableColumnClasses.health }),
	        _react2.default.createElement("col", { className: tableColumnClasses.logs }),
	        _react2.default.createElement("col", { className: tableColumnClasses.cpus }),
	        _react2.default.createElement("col", { className: tableColumnClasses.mem }),
	        _react2.default.createElement("col", { className: tableColumnClasses.updated }),
	        _react2.default.createElement("col", { className: tableColumnClasses.version })
	      );
	    }
	  }, {
	    key: "getColumnHeading",
	    value: function getColumnHeading(prop, order, sortBy) {
	      var _classNames;
	
	      var caretClassNames = (0, _classnames2.default)("caret", (_classNames = {}, (0, _defineProperty3.default)(_classNames, "caret--" + order, order != null), (0, _defineProperty3.default)(_classNames, "caret--visible", prop === sortBy.prop), _classNames));
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        _PodTableHeaderLabels2.default[prop],
	        _react2.default.createElement("span", { className: caretClassNames })
	      );
	    }
	  }, {
	    key: "getColumnClassName",
	    value: function getColumnClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)(tableColumnClasses[prop], {
	        highlight: prop === sortBy.prop,
	        clickable: row == null
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      return [{
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "name",
	        render: this.renderColumnID,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "address",
	        render: this.renderColumnAddress,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "status",
	        render: this.renderColumnStatus,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "health",
	        render: this.renderColumnHealth,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "logs",
	        render: this.renderColumnLogs,
	        sortable: false
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "cpus",
	        render: this.renderColumnResource,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "mem",
	        render: this.renderColumnResource,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "updated",
	        render: this.renderColumnUpdated,
	        sortable: true
	      }, {
	        className: this.getColumnClassName,
	        heading: this.getColumnHeading,
	        prop: "version",
	        render: this.renderColumnVersion,
	        sortable: true
	      }];
	    }
	  }, {
	    key: "getContainersWithResources",
	    value: function getContainersWithResources(podSpec, containers, agentAddress) {
	      var children = containers.map(function (container) {
	        var containerResources = container.getResources();
	
	        // TODO: Remove the following 4 lines when DCOS-10098 is addressed
	        var containerSpecResources = containerResources;
	        var containerSpec = podSpec.getContainerSpec(container.name);
	        if (containerSpec) {
	          containerSpecResources = containerSpec.resources;
	        }
	
	        var addressComponents = container.getEndpoints().map(function (endpoint, i) {
	          return _react2.default.createElement(
	            "a",
	            {
	              className: "text-muted",
	              href: "http://" + agentAddress + ":" + endpoint.allocatedHostPort,
	              key: i,
	              target: "_blank",
	              title: "Open in a new window"
	            },
	            endpoint.allocatedHostPort
	          );
	        });
	
	        return {
	          id: container.getId(),
	          name: container.getName(),
	          status: container.getContainerStatus(),
	          address: addressComponents,
	          cpus: containerResources.cpus,
	          mem: containerResources.mem,
	          updated: container.getLastUpdated(),
	          version: "",
	          containerSpecResources: containerSpecResources,
	          isHistoricalInstance: container.isHistoricalInstance
	        };
	      });
	
	      return children;
	    }
	  }, {
	    key: "getDisabledItemsMap",
	    value: function getDisabledItemsMap(instanceList) {
	      return instanceList.reduceItems(function (memo, instance) {
	        if (!instance.isRunning()) {
	          memo[instance.getId()] = true;
	        }
	
	        return memo;
	      }, {});
	    }
	  }, {
	    key: "getTableDataFor",
	    value: function getTableDataFor(instances, filterText) {
	      var _this2 = this;
	
	      var podSpec = this.props.pod.getSpec();
	
	      return instances.getItems().map(function (instance) {
	        var containers = instance.getContainers().filter(function (container) {
	          return _PodUtil2.default.isContainerMatchingText(container, filterText);
	        });
	        var children = _this2.getContainersWithResources(podSpec, containers, instance.getAgentAddress());
	
	        var _instance$getResource = instance.getResources(),
	            cpus = _instance$getResource.cpus,
	            mem = _instance$getResource.mem;
	
	        return {
	          id: instance.getId(),
	          name: instance.getName(),
	          address: instance.getAgentAddress(),
	          agent: instance.agent,
	          cpus: cpus,
	          mem: mem,
	          updated: instance.getLastUpdated(),
	          status: instance.getInstanceStatus(),
	          version: podSpec.getVersion(),
	          children: children,
	          podSpec: podSpec
	        };
	      });
	    }
	  }, {
	    key: "getInstanceFilterStatus",
	    value: function getInstanceFilterStatus(instance) {
	      var status = instance.getInstanceStatus();
	      switch (status) {
	        case _PodInstanceStatus2.default.STAGED:
	          return "staged";
	
	        case _PodInstanceStatus2.default.HEALTHY:
	        case _PodInstanceStatus2.default.UNHEALTHY:
	        case _PodInstanceStatus2.default.RUNNING:
	          return "active";
	
	        case _PodInstanceStatus2.default.KILLED:
	          return "completed";
	
	        default:
	          return "";
	      }
	    }
	  }, {
	    key: "renderWithClickHandler",
	    value: function renderWithClickHandler(rowOptions, content, className) {
	      return _react2.default.createElement(
	        "div",
	        { onClick: rowOptions.clickHandler, className: className },
	        content
	      );
	    }
	  }, {
	    key: "renderColumnID",
	    value: function renderColumnID(prop, col) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var taskID = col.id,
	          taskName = col.name;
	
	      if (!rowOptions.isParent) {
	        var id = encodeURIComponent(this.props.pod.getId());
	
	        return _react2.default.createElement(
	          "div",
	          { className: "expanding-table-primary-cell-heading text-overflow" },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: "table-cell-link-secondary text-overflow",
	              to: "/services/detail/" + id + "/tasks/" + taskID,
	              title: taskName
	            },
	            _react2.default.createElement(_CollapsingString2.default, { string: taskName })
	          )
	        );
	      }
	
	      var classes = (0, _classnames2.default)("expanding-table-primary-cell is-expandable", {
	        "is-expanded": rowOptions.isExpanded
	      });
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(_CollapsingString2.default, { string: taskID }), classes);
	    }
	  }, {
	    key: "renderColumnLogs",
	    value: function renderColumnLogs(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (rowOptions.isParent) {
	        // Because elements are just stacked we need a spacer
	        return _react2.default.createElement(
	          "span",
	          null,
	          "\xA0"
	        );
	      }
	
	      var id = encodeURIComponent(this.props.pod.getId());
	      var taskID = row.id;
	
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/services/detail/" + id + "/tasks/" + taskID + "/logs", title: row.name },
	        _react2.default.createElement(_Icon2.default, { color: "grey", id: "page-document", size: "mini" })
	      );
	    }
	  }, {
	    key: "renderColumnAddress",
	    value: function renderColumnAddress(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var address = row.address;
	
	
	      if (rowOptions.isParent) {
	        var agent = row.agent;
	
	
	        if (!agent) {
	          return this.renderWithClickHandler(rowOptions, _react2.default.createElement(_CollapsingString2.default, { string: address }));
	        }
	
	        return this.renderWithClickHandler(rowOptions, _react2.default.createElement(
	          _reactRouter.Link,
	          {
	            className: "table-cell-link-secondary text-overflow",
	            to: "/nodes/" + agent.id,
	            title: address
	          },
	          _react2.default.createElement(_CollapsingString2.default, { string: address })
	        ));
	      }
	
	      return this.renderWithClickHandler(rowOptions, address);
	    }
	  }, {
	    key: "renderColumnStatus",
	    value: function renderColumnStatus(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var status = row.status;
	
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(
	        "span",
	        { className: "status-text " + status.textClassName },
	        status.displayName
	      ));
	    }
	  }, {
	    key: "renderColumnHealth",
	    value: function renderColumnHealth(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var status = row.status;
	      var healthStatus = status.healthStatus;
	
	      var tooltipContent = "Healthy";
	
	      if (healthStatus === "UNHEALTHY") {
	        tooltipContent = "Unhealthy";
	      }
	
	      if (healthStatus === "NA") {
	        tooltipContent = "No health checks available";
	      }
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(
	        "div",
	        { className: "flex-box flex-box-align-vertical-center table-cell-flex-box flex-align-items-center flex-direction-top-to-bottom" },
	        _react2.default.createElement(
	          "div",
	          { className: "table-cell-icon" },
	          _react2.default.createElement(
	            _reactjsComponents.Tooltip,
	            { anchor: "center", content: tooltipContent },
	            _react2.default.createElement("span", { className: (0, _classnames2.default)("flush", status.dotClassName) })
	          )
	        )
	      ));
	    }
	  }, {
	    key: "renderColumnResource",
	    value: function renderColumnResource(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var tooltipContent = void 0;
	      if (rowOptions.hasChildren) {
	        var executorResource = row.podSpec && row.podSpec.executorResources ? row.podSpec.executorResources[prop] || 0 : 0;
	        var childResources = row.children.filter(function (child) {
	          return !child.isHistoricalInstance;
	        }).reduce(function (sum, current) {
	          return sum + (current[prop] || 0);
	        }, 0);
	        tooltipContent = "Containers: " + _Units2.default.formatResource(prop, childResources) + ", Executor: " + _Units2.default.formatResource(prop, executorResource);
	      } else {
	        var activeResource = row.isHistoricalInstance ? 0 : row[prop] || 0;
	        var totalResource = row.containerSpecResources[prop] || 0;
	        tooltipContent = "Using " + activeResource + "/" + _Units2.default.formatResource(prop, totalResource);
	      }
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(
	        _reactjsComponents.Tooltip,
	        { anchor: "center", content: tooltipContent },
	        _react2.default.createElement(
	          "span",
	          null,
	          _Units2.default.formatResource(prop, row.containerSpecResources ? row.containerSpecResources[prop] || 0 : row[prop])
	        )
	      ));
	    }
	  }, {
	    key: "renderColumnUpdated",
	    value: function renderColumnUpdated(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(_TimeAgo2.default, { time: row.updated }));
	    }
	  }, {
	    key: "renderColumnVersion",
	    value: function renderColumnVersion(prop, row) {
	      var rowOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      if (!row.version) {
	        return null;
	      }
	
	      var localeVersion = new Date(row.version).toLocaleString();
	
	      return this.renderWithClickHandler(rowOptions, _react2.default.createElement(
	        "span",
	        null,
	        localeVersion
	      ));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          instances = _props.instances,
	          pod = _props.pod,
	          filterText = _props.filterText;
	      var checkedItems = this.state.checkedItems;
	
	      // If custom list of instances is not provided, use the default instances
	      // from the pod
	
	      if (instances == null) {
	        instances = pod.getInstanceList();
	      }
	      var disabledItems = this.getDisabledItemsMap(instances);
	
	      return _react2.default.createElement(_ExpandingTable2.default, {
	        allowMultipleSelect: true,
	        className: "task-table expanding-table table table-hover table-borderless-outer table-borderless-inner-columns flush-bottom",
	        childRowClassName: "expanding-table-child",
	        checkedItemsMap: checkedItems,
	        columns: this.getColumns(),
	        colGroup: this.getColGroup(),
	        data: this.getTableDataFor(instances, filterText),
	        disabledItemsMap: disabledItems,
	        inactiveItemsMap: disabledItems,
	        expandAll: !!filterText,
	        getColGroup: this.getColGroup,
	        onCheckboxChange: this.handleItemCheck,
	        sortBy: { prop: "name", order: "asc" },
	        tableComponent: _CheckboxTable2.default,
	        uniqueProperty: "id"
	      });
	    }
	  }]);
	  return PodInstancesTable;
	}(_react2.default.Component);
	
	PodInstancesTable.defaultProps = {
	  filterText: "",
	  instances: null,
	  inverseStyle: false,
	  onSelectionChange: function onSelectionChange() {},
	
	  pod: null
	};
	
	PodInstancesTable.propTypes = {
	  filterText: _react2.default.PropTypes.string,
	  instances: _react2.default.PropTypes.instanceOf(_PodInstanceList2.default),
	  inverseStyle: _react2.default.PropTypes.bool,
	  onSelectionChange: _react2.default.PropTypes.func,
	  pod: _react2.default.PropTypes.instanceOf(_Pod2.default).isRequired
	};
	
	module.exports = PodInstancesTable;

/***/ },
/* 1841 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  name: "NAME",
	  address: "HOST/PORT",
	  status: "STATUS",
	  health: "HEALTH",
	  cpus: "CPU",
	  mem: "MEM",
	  updated: "UPDATED",
	  version: "VERSION"
	};

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _values = __webpack_require__(959);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _map = __webpack_require__(1071);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _PodInstance = __webpack_require__(1229);
	
	var _PodInstance2 = _interopRequireDefault(_PodInstance);
	
	var _PodInstanceList = __webpack_require__(1228);
	
	var _PodInstanceList2 = _interopRequireDefault(_PodInstanceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PodUtil = {
	  /**
	   * Returns true if the container given matches
	   * the free-text given.
	   *
	   * @param {PodContainer} container - The Container to test
	   * @param {string} text - The text to test against
	   * @returns {boolean} - Returns true if the test passes
	   */
	  isContainerMatchingText: function isContainerMatchingText(container, text) {
	    if (!text) {
	      return true;
	    }
	
	    return container.getName().indexOf(text) >= 0;
	  },
	
	
	  /**
	   * Returns true if the container instance matches
	   * the free-text given.
	   *
	   * @param {PodInstance} instance - The instance to test
	   * @param {string} text - The text to test against
	   * @returns {boolean} - Returns true if the test passes
	   */
	  isInstanceOrChildrenMatchingText: function isInstanceOrChildrenMatchingText(instance, text) {
	    if (!text) {
	      return true;
	    }
	
	    if (instance.getName().indexOf(text) >= 0) {
	      return true;
	    }
	
	    return instance.getContainers().some(function (container) {
	      return PodUtil.isContainerMatchingText(container, text);
	    });
	  },
	
	
	  /**
	   * This function merges the output of MesosStateUtil.getPodHistoricalInstances
	   * with the array of currently known instances returned from the
	   * Pod.getInstances() function.
	   *
	   * NOTE: podInstances is an array of PodInstance objects, but the
	   *       historicalInstances is an array of plain objects, with a structure
	   *       that can be used to construct a PodInstance!
	   *
	   * @param {PodInstanceList} podInstances - An array of PodInstance objects
	   * @param {Array} historicalInstances - The output of
	   *  getPodHistoricalInstances
	   * @returns {PodInstanceList} The new array of PodInstance objects
	   */
	  mergeHistoricalInstanceList: function mergeHistoricalInstanceList(podInstances, historicalInstances) {
	    if (!historicalInstances) {
	      return podInstances;
	    }
	
	    // De-compose PodInstances into plain objects, so we always operate
	    // with plain objects
	    var podInstancesMap = podInstances.reduceItems(function (memo, podInstance) {
	      memo[podInstance.getId()] = podInstance.get();
	
	      return memo;
	    }, {});
	
	    // Then merge historical instance information in the pod instance map
	    var combinedInstanceMap = historicalInstances.reduce(function (memo, historicalInstance) {
	      var podInstance = memo[historicalInstance.id];
	      if (podInstance === undefined) {
	        memo[historicalInstance.id] = historicalInstance;
	
	        return memo;
	      }
	
	      var combinedContainers = [].concat(podInstance.containers, historicalInstance.containers.map(function (container) {
	        return (0, _assign2.default)({}, container, { isHistoricalInstance: true });
	      }));
	
	      // Filter combined container list to remove potential duplicates
	      var containerIds = new _map2.default();
	      combinedContainers = combinedContainers.filter(function (_ref) {
	        var containerId = _ref.containerId;
	
	        if (containerId != null && !containerIds.has(containerId)) {
	          containerIds.set(containerId);
	
	          return true;
	        }
	
	        return false;
	      });
	
	      podInstance.containers = combinedContainers;
	
	      return memo;
	    }, podInstancesMap);
	
	    // Re-compose PodInstances from plain objects
	    var instances = (0, _values2.default)(combinedInstanceMap).map(function (instance) {
	      return new _PodInstance2.default(instance);
	    });
	
	    return new _PodInstanceList2.default({ items: instances });
	  }
	};
	
	module.exports = PodUtil;

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _assign = __webpack_require__(865);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterButtons = __webpack_require__(1383);
	
	var _FilterButtons2 = _interopRequireDefault(_FilterButtons);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["getFilterButtonContent", "handleStatusFilterChange", "handleSearchStringChange"];
	
	var PodViewFilter = function (_React$Component) {
	  (0, _inherits3.default)(PodViewFilter, _React$Component);
	
	  function PodViewFilter() {
	    (0, _classCallCheck3.default)(this, PodViewFilter);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PodViewFilter.__proto__ || (0, _getPrototypeOf2.default)(PodViewFilter)).apply(this, arguments));
	
	    METHODS_TO_BIND.forEach(function (method) {
	      this[method] = this[method].bind(this);
	    }, _this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(PodViewFilter, [{
	    key: "handleStatusFilterChange",
	    value: function handleStatusFilterChange(filterByStatus) {
	      this.props.onFilterChange((0, _assign2.default)({}, this.props.filter, {
	        status: filterByStatus
	      }));
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.props.onFilterChange((0, _assign2.default)({}, this.props.filter, {
	        text: searchString
	      }));
	    }
	  }, {
	    key: "getFilterButtonContent",
	    value: function getFilterButtonContent(filterName, count) {
	      return _react2.default.createElement(
	        "span",
	        { className: "button-align-content badge-container" },
	        _react2.default.createElement(
	          "span",
	          { className: "badge-container-text label flush" },
	          _StringUtil2.default.capitalize(filterName)
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "badge badge-rounded" },
	          count || 0
	        )
	      );
	    }
	  }, {
	    key: "getFilterButtons",
	    value: function getFilterButtons() {
	      var _props = this.props,
	          filter = _props.filter,
	          items = _props.items,
	          inverseStyle = _props.inverseStyle,
	          statusMapper = _props.statusMapper,
	          statusChoices = _props.statusChoices;
	
	      if (!statusChoices.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(_FilterButtons2.default, {
	        renderButtonContent: this.getFilterButtonContent,
	        filters: statusChoices,
	        onFilterChange: this.handleStatusFilterChange,
	        inverseStyle: inverseStyle,
	        itemList: items.map(statusMapper),
	        selectedFilter: filter.status
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          filter = _props2.filter,
	          inverseStyle = _props2.inverseStyle;
	
	      var childrenCount = _react2.default.Children.count(children);
	
	      return _react2.default.createElement(
	        _FilterBar2.default,
	        { rightAlignLastNChildren: childrenCount },
	        _react2.default.createElement(_FilterInputText2.default, {
	          className: "flush-bottom",
	          searchString: filter.text,
	          handleFilterChange: this.handleSearchStringChange,
	          inverseStyle: inverseStyle
	        }),
	        this.getFilterButtons(),
	        children
	      );
	    }
	  }]);
	  return PodViewFilter;
	}(_react2.default.Component);
	
	PodViewFilter.defaultProps = {
	  filter: {
	    text: "",
	    status: ""
	  },
	  items: [],
	  inverseStyle: false,
	  onFilterChange: function onFilterChange() {},
	  statusMapper: function statusMapper() {
	    return "";
	  },
	
	  statusChoices: []
	};
	
	PodViewFilter.propTypes = {
	  filter: _react2.default.PropTypes.shape({
	    text: _react2.default.PropTypes.string,
	    status: _react2.default.PropTypes.string
	  }),
	  items: _react2.default.PropTypes.array,
	  inverseStyle: _react2.default.PropTypes.bool,
	  onFilterChange: _react2.default.PropTypes.func,
	  statusMapper: _react2.default.PropTypes.func,
	  statusChoices: _react2.default.PropTypes.array
	};
	
	module.exports = PodViewFilter;

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _Service = __webpack_require__(1090);
	
	var _Service2 = _interopRequireDefault(_Service);
	
	var _TasksContainer = __webpack_require__(1552);
	
	var _TasksContainer2 = _interopRequireDefault(_TasksContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["onStateStoreSuccess", "onStateStoreError"];
	
	var ServiceInstancesContainer = function (_mixin) {
	  (0, _inherits3.default)(ServiceInstancesContainer, _mixin);
	
	  function ServiceInstancesContainer() {
	    (0, _classCallCheck3.default)(this, ServiceInstancesContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceInstancesContainer.__proto__ || (0, _getPrototypeOf2.default)(ServiceInstancesContainer)).apply(this, arguments));
	
	    _this.state = {
	      lastUpdate: 0,
	      mesosStateErrorCount: 0
	    };
	
	    _this.store_listeners = [{ name: "state", events: ["success", "error"], suppressUpdate: true }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ServiceInstancesContainer, [{
	    key: "onStateStoreSuccess",
	    value: function onStateStoreSuccess() {
	      // Throttle updates
	      if (Date.now() - this.state.lastUpdate > 1000 || this.state.mesosStateErrorCount !== 0) {
	        this.setState({
	          lastUpdate: Date.now(),
	          mesosStateErrorCount: 0
	        });
	      }
	    }
	  }, {
	    key: "onStateStoreError",
	    value: function onStateStoreError() {
	      this.setState({
	        mesosStateErrorCount: this.state.mesosStateErrorCount + 1
	      });
	    }
	  }, {
	    key: "getContents",
	    value: function getContents() {
	      var isLoading = (0, _keys2.default)(_MesosStateStore2.default.get("lastMesosState")).length === 0;
	
	      var hasError = this.state.mesosStateErrorCount > 3;
	
	      if (isLoading) {
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      // General Error
	      if (hasError) {
	        return _react2.default.createElement(_RequestErrorMsg2.default, null);
	      }
	
	      var service = this.props.service;
	
	      var tasks = _MesosStateStore2.default.getTasksByService(service);
	
	      return _react2.default.createElement(_TasksContainer2.default, { params: this.props.params, tasks: tasks });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _foundationUi.MountService.Mount,
	        { type: "ServiceInstancesContainer:TasksContainer" },
	        this.getContents()
	      );
	    }
	  }]);
	  return ServiceInstancesContainer;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	ServiceInstancesContainer.propTypes = {
	  service: _react2.default.PropTypes.instanceOf(_Service2.default),
	  params: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = ServiceInstancesContainer;

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _RepositoriesTab = __webpack_require__(1846);
	
	var _RepositoriesTab2 = _interopRequireDefault(_RepositoriesTab);
	
	var _SettingsPage = __webpack_require__(1856);
	
	var _SettingsPage2 = _interopRequireDefault(_SettingsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsRoutes = [{
	  type: _reactRouter.Redirect,
	  from: "/settings",
	  to: "/settings/repositories"
	}, {
	  type: _reactRouter.Route,
	  path: "settings",
	  component: _SettingsPage2.default,
	  category: "system",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.Route,
	    path: "repositories",
	    component: _RepositoriesTab2.default,
	    isInSidebar: true
	  }]
	}];
	
	module.exports = settingsRoutes;

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AddRepositoryFormModal = __webpack_require__(1847);
	
	var _AddRepositoryFormModal2 = _interopRequireDefault(_AddRepositoryFormModal);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _FilterBar = __webpack_require__(1317);
	
	var _FilterBar2 = _interopRequireDefault(_FilterBar);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RepositoriesTable = __webpack_require__(1854);
	
	var _RepositoriesTable2 = _interopRequireDefault(_RepositoriesTable);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var RepositoriesBreadcrumbs = function RepositoriesBreadcrumbs(addButton) {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: -1, title: "Repositories" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/settings/repositories" },
	        "Package Repositories"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, {
	    iconID: "gear",
	    breadcrumbs: crumbs,
	    addButton: addButton
	  });
	};
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleSearchStringChange", "handleCloseAddRepository", "handleOpenAddRepository"];
	
	var RepositoriesTab = function (_mixin) {
	  (0, _inherits3.default)(RepositoriesTab, _mixin);
	
	  function RepositoriesTab() {
	    (0, _classCallCheck3.default)(this, RepositoriesTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RepositoriesTab.__proto__ || (0, _getPrototypeOf2.default)(RepositoriesTab)).call(this));
	
	    _this.state = {
	      addRepositoryModalOpen: false,
	      hasError: false,
	      isLoading: true,
	      searchString: ""
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["repositoriesSuccess", "repositoriesError"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(RepositoriesTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(RepositoriesTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(RepositoriesTab.prototype), "componentDidMount", this).apply(this, arguments);
	      _CosmosPackagesStore2.default.fetchRepositories();
	    }
	  }, {
	    key: "handleCloseAddRepository",
	    value: function handleCloseAddRepository() {
	      this.setState({ addRepositoryModalOpen: false });
	    }
	  }, {
	    key: "handleOpenAddRepository",
	    value: function handleOpenAddRepository() {
	      this.setState({ addRepositoryModalOpen: true });
	    }
	  }, {
	    key: "onCosmosPackagesStoreRepositoriesError",
	    value: function onCosmosPackagesStoreRepositoriesError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "onCosmosPackagesStoreRepositoriesSuccess",
	    value: function onCosmosPackagesStoreRepositoriesSuccess() {
	      this.setState({ hasError: false, isLoading: false });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getContent",
	    value: function getContent() {
	      var _state = this.state,
	          addRepositoryModalOpen = _state.addRepositoryModalOpen,
	          hasError = _state.hasError,
	          isLoading = _state.isLoading,
	          searchString = _state.searchString;
	
	
	      if (hasError) {
	        return this.getErrorScreen();
	      }
	
	      if (isLoading) {
	        return this.getLoadingScreen();
	      }
	
	      var repositories = _CosmosPackagesStore2.default.getRepositories().filterItemsByText(searchString);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _FilterBar2.default,
	          null,
	          _react2.default.createElement(_FilterInputText2.default, {
	            className: "flush-bottom",
	            placeholder: "Search",
	            searchString: searchString,
	            handleFilterChange: this.handleSearchStringChange
	          })
	        ),
	        _react2.default.createElement(_RepositoriesTable2.default, { repositories: repositories, filter: searchString }),
	        _react2.default.createElement(_AddRepositoryFormModal2.default, {
	          numberOfRepositories: repositories.getItems().length,
	          open: addRepositoryModalOpen,
	          onClose: this.handleCloseAddRepository
	        })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          addButton: {
	            onItemSelect: this.handleOpenAddRepository,
	            label: "Add Repository"
	          },
	          breadcrumbs: _react2.default.createElement(RepositoriesBreadcrumbs, null)
	        }),
	        this.getContent()
	      );
	    }
	  }]);
	  return RepositoriesTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	RepositoriesTab.routeConfig = {
	  label: "Package Repositories",
	  matches: /^\/settings\/repositories/
	};
	
	module.exports = RepositoriesTab;

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _FormModal = __webpack_require__(1350);
	
	var _FormModal2 = _interopRequireDefault(_FormModal);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	var _ValidatorUtil2 = _interopRequireDefault(_ValidatorUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var METHODS_TO_BIND = ["handleAddRepository", "onCosmosPackagesStoreRepositoryAddError", "onCosmosPackagesStoreRepositoryAddSuccess", "resetState"];
	/* eslint-enable no-unused-vars */
	
	var AddRepositoryFormModal = function (_mixin) {
	  (0, _inherits3.default)(AddRepositoryFormModal, _mixin);
	
	  function AddRepositoryFormModal() {
	    (0, _classCallCheck3.default)(this, AddRepositoryFormModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AddRepositoryFormModal.__proto__ || (0, _getPrototypeOf2.default)(AddRepositoryFormModal)).call(this));
	
	    _this.state = {
	      disableButtons: false,
	      errorMsg: null
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["repositoryAddSuccess", "repositoryAddError"]
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(AddRepositoryFormModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var props = this.props;
	
	      if (props.open && !nextProps.open) {
	        // Closes, reset state
	        this.resetState();
	      }
	    }
	  }, {
	    key: "onCosmosPackagesStoreRepositoryAddError",
	    value: function onCosmosPackagesStoreRepositoryAddError(errorMsg) {
	      this.setState({ disableButtons: false, errorMsg: errorMsg });
	    }
	  }, {
	    key: "onCosmosPackagesStoreRepositoryAddSuccess",
	    value: function onCosmosPackagesStoreRepositoryAddSuccess() {
	      _CosmosPackagesStore2.default.fetchRepositories();
	      this.props.onClose();
	    }
	  }, {
	    key: "handleAddRepository",
	    value: function handleAddRepository(model) {
	      _CosmosPackagesStore2.default.addRepository(model.name, model.uri, model.priority);
	      this.resetState();
	    }
	  }, {
	    key: "getAddRepositoryFormDefinition",
	    value: function getAddRepositoryFormDefinition() {
	      var numberOfRepositories = this.props.numberOfRepositories;
	
	
	      return [{
	        fieldType: "text",
	        name: "name",
	        placeholder: "Repository Name",
	        required: true,
	        showError: false,
	        showLabel: false,
	        writeType: "input",
	        validation: function validation() {
	          return true;
	        },
	
	        value: ""
	      }, {
	        fieldType: "text",
	        name: "uri",
	        placeholder: "URL",
	        required: true,
	        showError: false,
	        showLabel: false,
	        writeType: "input",
	        validation: function validation() {
	          return true;
	        },
	
	        value: ""
	      }, {
	        fieldType: "number",
	        name: "priority",
	        placeholder: "Priority",
	        required: false,
	        min: "0",
	        max: "" + numberOfRepositories,
	        step: "1",
	        validationErrorText: "Must be a positive integer between 0 and " + numberOfRepositories + " representing its priority. 0 is the highest and " + numberOfRepositories + " denotes the lowest priority.",
	        showLabel: false,
	        writeType: "input",
	        validation: function validation(value) {
	          return _ValidatorUtil2.default.isDefined(value) && _ValidatorUtil2.default.isNumberInRange(value, { max: numberOfRepositories });
	        },
	
	        value: ""
	      }];
	    }
	  }, {
	    key: "getButtonDefinition",
	    value: function getButtonDefinition() {
	      return [{
	        text: "Close",
	        className: "button button-medium",
	        isClose: true
	      }, {
	        text: "Add",
	        className: "button button-success button-medium",
	        isSubmit: true
	      }];
	    }
	  }, {
	    key: "getErrorMessage",
	    value: function getErrorMessage() {
	      var errorMsg = this.state.errorMsg;
	
	      if (!errorMsg) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "h4",
	        { className: "text-align-center text-danger flush-top" },
	        errorMsg
	      );
	    }
	  }, {
	    key: "resetState",
	    value: function resetState() {
	      this.setState({ errorMsg: null, disableButtons: false });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          state = this.state;
	
	
	      return _react2.default.createElement(
	        _FormModal2.default,
	        {
	          definition: this.getAddRepositoryFormDefinition(),
	          disabled: state.disableButtons,
	          buttonDefinition: this.getButtonDefinition(),
	          modalProps: {
	            header: _react2.default.createElement(
	              _ModalHeading2.default,
	              null,
	              "Add Repository"
	            ),
	            showHeader: true
	          },
	          onChange: this.resetState,
	          onClose: props.onClose,
	          onSubmit: this.handleAddRepository,
	          open: props.open
	        },
	        this.getErrorMessage()
	      );
	    }
	  }]);
	  return AddRepositoryFormModal;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	AddRepositoryFormModal.propTypes = {
	  numberOfRepositories: _react2.default.PropTypes.number.isRequired,
	  open: _react2.default.PropTypes.bool
	};
	
	module.exports = AddRepositoryFormModal;

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _PluginSDK2 = _interopRequireDefault(_PluginSDK);
	
	var _GetSetBaseStore2 = __webpack_require__(1007);
	
	var _GetSetBaseStore3 = _interopRequireDefault(_GetSetBaseStore2);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _CosmosPackagesActions = __webpack_require__(1849);
	
	var _CosmosPackagesActions2 = _interopRequireDefault(_CosmosPackagesActions);
	
	var _EventTypes = __webpack_require__(933);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _RepositoryList = __webpack_require__(1850);
	
	var _RepositoryList2 = _interopRequireDefault(_RepositoryList);
	
	var _UniverseInstalledPackagesList = __webpack_require__(1851);
	
	var _UniverseInstalledPackagesList2 = _interopRequireDefault(_UniverseInstalledPackagesList);
	
	var _UniversePackage = __webpack_require__(1852);
	
	var _UniversePackage2 = _interopRequireDefault(_UniversePackage);
	
	var _UniversePackagesList = __webpack_require__(1853);
	
	var _UniversePackagesList2 = _interopRequireDefault(_UniversePackagesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CosmosPackagesStore = function (_GetSetBaseStore) {
	  (0, _inherits3.default)(CosmosPackagesStore, _GetSetBaseStore);
	
	  function CosmosPackagesStore() {
	    (0, _classCallCheck3.default)(this, CosmosPackagesStore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CosmosPackagesStore.__proto__ || (0, _getPrototypeOf2.default)(CosmosPackagesStore)).apply(this, arguments));
	
	    _this.getSet_data = {
	      availablePackages: [],
	      packageDetails: null,
	      installedPackages: [],
	      repositories: []
	    };
	
	    _PluginSDK2.default.addStoreConfig({
	      store: _this,
	      storeID: _this.storeID,
	      events: {
	        availableError: _EventTypes.COSMOS_SEARCH_ERROR,
	        availableSuccess: _EventTypes.COSMOS_SEARCH_CHANGE,
	        descriptionSuccess: _EventTypes.COSMOS_DESCRIBE_CHANGE,
	        descriptionError: _EventTypes.COSMOS_DESCRIBE_ERROR,
	        installedSuccess: _EventTypes.COSMOS_LIST_CHANGE,
	        installedError: _EventTypes.COSMOS_LIST_ERROR,
	
	        installError: _EventTypes.COSMOS_INSTALL_ERROR,
	        installSuccess: _EventTypes.COSMOS_INSTALL_SUCCESS,
	        uninstallError: _EventTypes.COSMOS_UNINSTALL_ERROR,
	        uninstallSuccess: _EventTypes.COSMOS_UNINSTALL_SUCCESS,
	
	        repositoriesSuccess: _EventTypes.COSMOS_REPOSITORIES_SUCCESS,
	        repositoriesError: _EventTypes.COSMOS_REPOSITORIES_ERROR,
	        repositoryAddSuccess: _EventTypes.COSMOS_REPOSITORY_ADD_SUCCESS,
	        repositoryAddError: _EventTypes.COSMOS_REPOSITORY_ADD_ERROR,
	        repositoryDeleteSuccess: _EventTypes.COSMOS_REPOSITORY_DELETE_SUCCESS,
	        repositoryDeleteError: _EventTypes.COSMOS_REPOSITORY_DELETE_ERROR
	      },
	      unmountWhen: function unmountWhen(store, event) {
	        return event === "availableSuccess";
	      },
	
	      listenAlways: false
	    });
	
	    _this.dispatcherIndex = _AppDispatcher2.default.register(function (payload) {
	      var source = payload.source;
	      if (source !== _ActionTypes.SERVER_ACTION) {
	        return false;
	      }
	
	      var action = payload.action;
	      var data = action.data;
	
	      switch (action.type) {
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_DESCRIBE_SUCCESS:
	          _this.processPackageDescriptionSuccess(data, action.packageName, action.packageVersion);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_DESCRIBE_ERROR:
	          _this.processPackageDescriptionError(data, action.packageName, action.packageVersion);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGES_LIST_SUCCESS:
	          _this.processInstalledPackagesSuccess(data, action.packageName, action.appId);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGES_LIST_ERROR:
	          _this.processInstalledPackagesError(data, action.packageName, action.appId);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGES_SEARCH_SUCCESS:
	          _this.processAvailablePackagesSuccess(data, action.query);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGES_SEARCH_ERROR:
	          _this.processAvailablePackagesError(data, action.query);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_INSTALL_SUCCESS:
	          _this.emit(_EventTypes.COSMOS_INSTALL_SUCCESS, action.packageName, action.packageVersion, data.appId);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_INSTALL_ERROR:
	          _this.emit(_EventTypes.COSMOS_INSTALL_ERROR, data, action.packageName, action.packageVersion);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_UNINSTALL_SUCCESS:
	          _this.emit(_EventTypes.COSMOS_UNINSTALL_SUCCESS, action.packageName, action.packageVersion, action.appId);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_PACKAGE_UNINSTALL_ERROR:
	          _this.emit(_EventTypes.COSMOS_UNINSTALL_ERROR, data, action.packageName, action.packageVersion, action.appId);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORIES_LIST_SUCCESS:
	          _this.processRepositoriesSuccess(data);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORIES_LIST_ERROR:
	          _this.emit(_EventTypes.COSMOS_REPOSITORIES_ERROR, data);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORY_ADD_SUCCESS:
	          _this.emit(_EventTypes.COSMOS_REPOSITORY_ADD_SUCCESS, data, action.name, action.uri);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORY_ADD_ERROR:
	          _this.emit(_EventTypes.COSMOS_REPOSITORY_ADD_ERROR, data, action.name, action.uri);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORY_DELETE_SUCCESS:
	          _this.emit(_EventTypes.COSMOS_REPOSITORY_DELETE_SUCCESS, data, action.name, action.uri);
	          break;
	        case _ActionTypes.REQUEST_COSMOS_REPOSITORY_DELETE_ERROR:
	          _this.emit(_EventTypes.COSMOS_REPOSITORY_DELETE_ERROR, data, action.name, action.uri);
	          break;
	      }
	
	      return true;
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(CosmosPackagesStore, [{
	    key: "addChangeListener",
	    value: function addChangeListener(eventName, callback) {
	      this.on(eventName, callback);
	    }
	  }, {
	    key: "removeChangeListener",
	    value: function removeChangeListener(eventName, callback) {
	      this.removeListener(eventName, callback);
	    }
	
	    /* API */
	
	  }, {
	    key: "fetchAvailablePackages",
	    value: function fetchAvailablePackages() {
	      return _CosmosPackagesActions2.default.fetchAvailablePackages.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "fetchInstalledPackages",
	    value: function fetchInstalledPackages() {
	      return _CosmosPackagesActions2.default.fetchInstalledPackages.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "fetchPackageDescription",
	    value: function fetchPackageDescription() {
	      return _CosmosPackagesActions2.default.fetchPackageDescription.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "installPackage",
	    value: function installPackage() {
	      return _CosmosPackagesActions2.default.installPackage.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "uninstallPackage",
	    value: function uninstallPackage() {
	      return _CosmosPackagesActions2.default.uninstallPackage.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "fetchRepositories",
	    value: function fetchRepositories() {
	      return _CosmosPackagesActions2.default.fetchRepositories.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "addRepository",
	    value: function addRepository() {
	      return _CosmosPackagesActions2.default.addRepository.apply(_CosmosPackagesActions2.default, arguments);
	    }
	  }, {
	    key: "deleteRepository",
	    value: function deleteRepository() {
	      return _CosmosPackagesActions2.default.deleteRepository.apply(_CosmosPackagesActions2.default, arguments);
	    }
	
	    /* Reducers */
	
	  }, {
	    key: "getAvailablePackages",
	    value: function getAvailablePackages() {
	      return new _UniversePackagesList2.default({ items: this.get("availablePackages") });
	    }
	  }, {
	    key: "getInstalledPackages",
	    value: function getInstalledPackages() {
	      return new _UniverseInstalledPackagesList2.default({
	        items: this.get("installedPackages")
	      });
	    }
	  }, {
	    key: "getPackageDetails",
	    value: function getPackageDetails() {
	      var packageDetails = this.get("packageDetails");
	      if (packageDetails) {
	        return new _UniversePackage2.default(packageDetails);
	      }
	
	      return null;
	    }
	  }, {
	    key: "getRepositories",
	    value: function getRepositories() {
	      return new _RepositoryList2.default({ items: this.get("repositories") });
	    }
	  }, {
	    key: "processAvailablePackagesSuccess",
	    value: function processAvailablePackagesSuccess(packages, query) {
	      this.set({ availablePackages: packages });
	
	      this.emit(_EventTypes.COSMOS_SEARCH_CHANGE, query);
	    }
	  }, {
	    key: "processAvailablePackagesError",
	    value: function processAvailablePackagesError(error, query) {
	      this.emit(_EventTypes.COSMOS_SEARCH_ERROR, error, query);
	    }
	  }, {
	    key: "processInstalledPackagesSuccess",
	    value: function processInstalledPackagesSuccess(packages, name, appId) {
	      this.set({ installedPackages: packages });
	
	      this.emit(_EventTypes.COSMOS_LIST_CHANGE, name, appId);
	    }
	  }, {
	    key: "processInstalledPackagesError",
	    value: function processInstalledPackagesError(error, name, appId) {
	      this.emit(_EventTypes.COSMOS_LIST_ERROR, error, name, appId);
	    }
	  }, {
	    key: "processPackageDescriptionSuccess",
	    value: function processPackageDescriptionSuccess(cosmosPackage, name, version) {
	      this.set({ packageDetails: cosmosPackage });
	
	      this.emit(_EventTypes.COSMOS_DESCRIBE_CHANGE, name, version);
	    }
	  }, {
	    key: "processPackageDescriptionError",
	    value: function processPackageDescriptionError(error, name, version) {
	      this.set({ packageDetails: null });
	
	      this.emit(_EventTypes.COSMOS_DESCRIBE_ERROR, error, name, version);
	    }
	  }, {
	    key: "processRepositoriesSuccess",
	    value: function processRepositoriesSuccess(repositories) {
	      this.set({ repositories: repositories });
	
	      this.emit(_EventTypes.COSMOS_REPOSITORIES_SUCCESS);
	    }
	  }, {
	    key: "storeID",
	    get: function get() {
	      return "cosmosPackages";
	    }
	  }]);
	  return CosmosPackagesStore;
	}(_GetSetBaseStore3.default);
	
	module.exports = new CosmosPackagesStore();

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _ActionTypes = __webpack_require__(999);
	
	var _AppDispatcher = __webpack_require__(1000);
	
	var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContentType(action, actionType) {
	  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "v2";
	
	  return "application/vnd.dcos.package." + action + "-" + actionType + "+json;charset=utf-8;version=" + version;
	}
	
	var CosmosPackagesActions = {
	  fetchAvailablePackages: function fetchAvailablePackages(query) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("search", "request", "v1"),
	      headers: { Accept: getContentType("search", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/search",
	      data: (0, _stringify2.default)({ query: query }),
	      success: function success(response) {
	        var packages = response.packages || [];
	        var data = packages.map(function (cosmosPackage) {
	          if (!cosmosPackage.resource) {
	            cosmosPackage.resource = {};
	          }
	
	          if (cosmosPackage.images) {
	            cosmosPackage.resource.images = cosmosPackage.images;
	            delete cosmosPackage.images;
	          }
	
	          return cosmosPackage;
	        });
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGES_SEARCH_SUCCESS,
	          data: data,
	          query: query
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGES_SEARCH_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          query: query,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchInstalledPackages: function fetchInstalledPackages(packageName, appId) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("list", "request", "v1"),
	      headers: { Accept: getContentType("list", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/list",
	      data: (0, _stringify2.default)({ packageName: packageName, appId: appId }),
	      success: function success(response) {
	        var packages = response.packages || [];
	        // Map list data to match other endpoint structures
	        var data = packages.map(function (item) {
	          var cosmosPackage = _Util2.default.findNestedPropertyInObject(item, "packageInformation.packageDefinition") || {};
	          cosmosPackage.appId = item.appId;
	          cosmosPackage.resource = _Util2.default.findNestedPropertyInObject(item, "packageInformation.resourceDefinition") || {};
	
	          if (cosmosPackage.images) {
	            cosmosPackage.resource.images = cosmosPackage.images;
	            delete cosmosPackage.images;
	          }
	
	          if (!cosmosPackage.currentVersion && cosmosPackage.version) {
	            cosmosPackage.currentVersion = cosmosPackage.version;
	            delete cosmosPackage.version;
	          }
	
	          return cosmosPackage;
	        });
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGES_LIST_SUCCESS,
	          data: data,
	          packageName: packageName,
	          appId: appId
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGES_LIST_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          packageName: packageName,
	          appId: appId,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchPackageDescription: function fetchPackageDescription(packageName, packageVersion) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("describe", "request", "v1"),
	      headers: { Accept: getContentType("describe", "response", "v3") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/describe",
	      data: (0, _stringify2.default)({ packageName: packageName, packageVersion: packageVersion }),
	      success: function success(response) {
	        var cosmosPackage = response.package;
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_DESCRIBE_SUCCESS,
	          data: cosmosPackage,
	          packageName: packageName,
	          packageVersion: packageVersion
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_DESCRIBE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          packageName: packageName,
	          packageVersion: packageVersion,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchPackageVersions: function fetchPackageVersions(packageName) {
	    // necessary for the backend
	    // even though it's not in use
	    var includePackageVersions = false;
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("list-versions", "request", "v1"),
	      headers: { Accept: getContentType("list-versions", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/list-versions",
	      data: (0, _stringify2.default)({ packageName: packageName, includePackageVersions: includePackageVersions }),
	      success: function success(response) {
	        var packageVersions = response.results;
	
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_LIST_VERSIONS_SUCCESS,
	          data: packageVersions
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_LIST_VERSIONS_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  installPackage: function installPackage(packageName, packageVersion) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("install", "request", "v1"),
	      headers: { Accept: getContentType("install", "response") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/install",
	      data: (0, _stringify2.default)({ packageName: packageName, packageVersion: packageVersion, options: options }),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_INSTALL_SUCCESS,
	          data: response,
	          packageName: packageName,
	          packageVersion: packageVersion
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_INSTALL_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          packageName: packageName,
	          packageVersion: packageVersion,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  uninstallPackage: function uninstallPackage(packageName, packageVersion, appId) {
	    var all = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("uninstall", "request", "v1"),
	      headers: { Accept: getContentType("uninstall", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/uninstall",
	      data: (0, _stringify2.default)({ packageName: packageName, packageVersion: packageVersion, appId: appId, all: all }),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_UNINSTALL_SUCCESS,
	          data: response,
	          packageName: packageName,
	          packageVersion: packageVersion,
	          appId: appId
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_PACKAGE_UNINSTALL_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.parseResponseBody(xhr),
	          packageName: packageName,
	          packageVersion: packageVersion,
	          appId: appId,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  fetchRepositories: function fetchRepositories(type) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("repository.list", "request", "v1"),
	      headers: { Accept: getContentType("repository.list", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/repository/list",
	      data: (0, _stringify2.default)({ type: type }),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORIES_LIST_SUCCESS,
	          data: response.repositories
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORIES_LIST_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          xhr: xhr
	        });
	      }
	    });
	  },
	  addRepository: function addRepository(name, uri, index) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("repository.add", "request", "v1"),
	      headers: { Accept: getContentType("repository.add", "response", "v1") },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/repository/add",
	      data: (0, _stringify2.default)({ name: name, uri: uri, index: index }),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORY_ADD_SUCCESS,
	          data: response,
	          name: name,
	          uri: uri
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORY_ADD_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          name: name,
	          uri: uri,
	          xhr: xhr
	        });
	      }
	    });
	  },
	  deleteRepository: function deleteRepository(name, uri) {
	    _mesosphereSharedReactjs.RequestUtil.json({
	      contentType: getContentType("repository.delete", "request", "v1"),
	      headers: {
	        Accept: getContentType("repository.delete", "response", "v1")
	      },
	      method: "POST",
	      url: "" + _Config2.default.rootUrl + _Config2.default.cosmosAPIPrefix + "/repository/delete",
	      data: (0, _stringify2.default)({ name: name, uri: uri }),
	      success: function success(response) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORY_DELETE_SUCCESS,
	          data: response,
	          name: name,
	          uri: uri
	        });
	      },
	      error: function error(xhr) {
	        _AppDispatcher2.default.handleServerAction({
	          type: _ActionTypes.REQUEST_COSMOS_REPOSITORY_DELETE_ERROR,
	          data: _mesosphereSharedReactjs.RequestUtil.getErrorFromXHR(xhr),
	          name: name,
	          uri: uri,
	          xhr: xhr
	        });
	      }
	    });
	  }
	};
	
	if (_Config2.default.useFixtures) {
	  var packageDescribeFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/cosmos/package-describe.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var packagesListFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/cosmos/packages-list.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var packagesSearchFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/cosmos/packages-search.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var packagesRepositoriesFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/cosmos/packages-repositories.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	  var packageListVersionsFixture = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../tests/_fixtures/cosmos/package-list-versions.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	  if (!global.actionTypes) {
	    global.actionTypes = {};
	  }
	
	  global.actionTypes.CosmosPackagesActions = {
	    fetchPackageDescription: {
	      event: "success",
	      success: { response: packageDescribeFixture }
	    },
	    fetchPackageVersions: {
	      event: "success",
	      success: { response: packageListVersionsFixture }
	    },
	    fetchInstalledPackages: {
	      event: "success",
	      success: { response: packagesListFixture }
	    },
	    fetchAvailablePackages: {
	      event: "success",
	      success: { response: packagesSearchFixture }
	    },
	    installPackage: { event: "success" },
	    uninstallPackage: { event: "success" },
	    fetchRepositories: {
	      event: "success",
	      success: { response: packagesRepositoriesFixture }
	    },
	    addRepository: { event: "success" },
	    deleteRepository: { event: "success" }
	  };
	
	  (0, _keys2.default)(global.actionTypes.CosmosPackagesActions).forEach(function (method) {
	    CosmosPackagesActions[method] = _mesosphereSharedReactjs.RequestUtil.stubRequest(CosmosPackagesActions, "CosmosPackagesActions", method);
	  });
	}
	
	module.exports = CosmosPackagesActions;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _Item = __webpack_require__(950);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RepositoryList = function (_List) {
	  (0, _inherits3.default)(RepositoryList, _List);
	
	  function RepositoryList() {
	    var _ref;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, RepositoryList);
	
	    // Specify filter properties if not specified
	    if (!options.filterProperties) {
	      // Use default getters
	      options.filterProperties = { name: null, uri: null };
	    }
	
	    // Pass in overloaded options and the rest of the arguments
	    return (0, _possibleConstructorReturn3.default)(this, (_ref = RepositoryList.__proto__ || (0, _getPrototypeOf2.default)(RepositoryList)).call.apply(_ref, [this, options].concat((0, _toConsumableArray3.default)(Array.prototype.slice(arguments, 1)))));
	  }
	
	  (0, _createClass3.default)(RepositoryList, [{
	    key: "getPriority",
	    value: function getPriority(repository) {
	      return this.getItems().indexOf(repository);
	    }
	  }]);
	  return RepositoryList;
	}(_List3.default);
	
	RepositoryList.type = _Item2.default;
	
	module.exports = RepositoryList;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _UniversePackage = __webpack_require__(1852);
	
	var _UniversePackage2 = _interopRequireDefault(_UniversePackage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UniverseInstalledPackagesList = function (_List) {
	  (0, _inherits3.default)(UniverseInstalledPackagesList, _List);
	
	  function UniverseInstalledPackagesList() {
	    var _ref;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, UniverseInstalledPackagesList);
	
	    // Specify filter properties if not specified
	    if (!options.filterProperties) {
	      options.filterProperties = {
	        appId: function appId(item) {
	          return item.getAppId();
	        },
	        description: function description(item) {
	          return item.getDescription();
	        },
	        name: function name(item) {
	          return item.getName();
	        },
	        tags: function tags(item) {
	          return item.getTags().join(" ");
	        }
	      };
	    }
	
	    // Pass in overloaded options and the rest of the arguments
	
	    // Replace list items instances of UniversePackage.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = UniverseInstalledPackagesList.__proto__ || (0, _getPrototypeOf2.default)(UniverseInstalledPackagesList)).call.apply(_ref, [this, options].concat((0, _toConsumableArray3.default)(Array.prototype.slice(arguments, 1)))));
	
	    _this.list = _this.list.map(function (item) {
	      if (item instanceof _UniversePackage2.default) {
	        return item;
	      } else {
	        return new _UniversePackage2.default(item);
	      }
	    });
	    return _this;
	  }
	
	  return UniverseInstalledPackagesList;
	}(_List3.default);
	
	module.exports = UniverseInstalledPackagesList;

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Item2 = __webpack_require__(950);
	
	var _Item3 = _interopRequireDefault(_Item2);
	
	var _FrameworkUtil = __webpack_require__(1080);
	
	var _FrameworkUtil2 = _interopRequireDefault(_FrameworkUtil);
	
	var _Util = __webpack_require__(982);
	
	var _Util2 = _interopRequireDefault(_Util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UniversePackage = function (_Item) {
	  (0, _inherits3.default)(UniversePackage, _Item);
	
	  function UniversePackage() {
	    (0, _classCallCheck3.default)(this, UniversePackage);
	    return (0, _possibleConstructorReturn3.default)(this, (UniversePackage.__proto__ || (0, _getPrototypeOf2.default)(UniversePackage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(UniversePackage, [{
	    key: "getActiveBlock",
	    value: function getActiveBlock() {
	      return Math.floor(Math.random() * 10) + 1;
	    }
	  }, {
	    key: "getActiveDecisionPoint",
	    value: function getActiveDecisionPoint() {
	      return this.getActiveBlock();
	    }
	  }, {
	    key: "getAppId",
	    value: function getAppId() {
	      return this.get("appId");
	    }
	  }, {
	    key: "getAppIdName",
	    value: function getAppIdName() {
	      var appId = this.getAppId();
	      // Remove initial slash if present
	      if (appId.charAt(0) === "/") {
	        appId = appId.slice(1);
	      }
	
	      return appId;
	    }
	  }, {
	    key: "getBlockCount",
	    value: function getBlockCount() {
	      return this.getActiveBlock() + 10;
	    }
	  }, {
	    key: "getConfig",
	    value: function getConfig() {
	      return this.get("config");
	    }
	  }, {
	    key: "getDescription",
	    value: function getDescription() {
	      return this.get("description");
	    }
	  }, {
	    key: "getDecisionPointCount",
	    value: function getDecisionPointCount() {
	      return this.getActiveBlock() + 10;
	    }
	  }, {
	    key: "getIcons",
	    value: function getIcons() {
	      return _FrameworkUtil2.default.getServiceImages(_Util2.default.findNestedPropertyInObject(this.get("resource"), "images"));
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      return this.get("name");
	    }
	  }, {
	    key: "getScreenshots",
	    value: function getScreenshots() {
	      return _Util2.default.findNestedPropertyInObject(this.get("resource"), "images.screenshots");
	    }
	  }, {
	    key: "getLicenses",
	    value: function getLicenses() {
	      return this.get("licenses") || [];
	    }
	  }, {
	    key: "getMaintainer",
	    value: function getMaintainer() {
	      return this.get("maintainer");
	    }
	  }, {
	    key: "getPreInstallNotes",
	    value: function getPreInstallNotes() {
	      return this.get("preInstallNotes");
	    }
	  }, {
	    key: "getPostInstallNotes",
	    value: function getPostInstallNotes() {
	      return this.get("postInstallNotes");
	    }
	  }, {
	    key: "getPostUninstallNotes",
	    value: function getPostUninstallNotes() {
	      return this.get("postUninstallNotes");
	    }
	  }, {
	    key: "getSCM",
	    value: function getSCM() {
	      return this.get("scm");
	    }
	  }, {
	    key: "getVersion",
	    value: function getVersion() {
	      return this.get("version");
	    }
	  }, {
	    key: "getTags",
	    value: function getTags() {
	      return this.get("tags") || [];
	    }
	  }, {
	    key: "isCLIOnly",
	    value: function isCLIOnly() {
	      return !_Util2.default.findNestedPropertyInObject(this.get("marathon"), "v2AppMustacheTemplate");
	    }
	  }, {
	    key: "isCertified",
	    value: function isCertified() {
	      return this.get("selected");
	    }
	  }]);
	  return UniversePackage;
	}(_Item3.default);
	
	module.exports = UniversePackage;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _toConsumableArray2 = __webpack_require__(1017);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _List2 = __webpack_require__(947);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _UniversePackage = __webpack_require__(1852);
	
	var _UniversePackage2 = _interopRequireDefault(_UniversePackage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UniversePackagesList = function (_List) {
	  (0, _inherits3.default)(UniversePackagesList, _List);
	
	  function UniversePackagesList() {
	    var _ref;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, UniversePackagesList);
	
	    // Specify filter properties if not specified
	    if (!options.filterProperties) {
	      options.filterProperties = {
	        description: null, // use default getter
	        name: null, // use default getter
	        tags: function tags(item) {
	          var tags = item.get("tags") || [];
	
	          return tags.join(" ");
	        }
	      };
	    }
	
	    // Pass in overloaded options and the rest of the arguments
	    return (0, _possibleConstructorReturn3.default)(this, (_ref = UniversePackagesList.__proto__ || (0, _getPrototypeOf2.default)(UniversePackagesList)).call.apply(_ref, [this, options].concat((0, _toConsumableArray3.default)(Array.prototype.slice(arguments, 1)))));
	  }
	
	  (0, _createClass3.default)(UniversePackagesList, [{
	    key: "getSelectedAndNonSelectedPackages",
	    value: function getSelectedAndNonSelectedPackages() {
	      var selectedPackages = [];
	      var nonSelectedPackages = [];
	
	      this.getItems().forEach(function (universePackage) {
	        if (universePackage.isCertified()) {
	          selectedPackages.push(universePackage);
	        } else {
	          nonSelectedPackages.push(universePackage);
	        }
	      });
	
	      return {
	        selectedPackages: new this.constructor({ items: selectedPackages }),
	        nonSelectedPackages: new this.constructor({ items: nonSelectedPackages })
	      };
	    }
	  }]);
	  return UniversePackagesList;
	}(_List3.default);
	
	UniversePackagesList.type = _UniversePackage2.default;
	
	module.exports = UniversePackagesList;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CollapsingString = __webpack_require__(1474);
	
	var _CollapsingString2 = _interopRequireDefault(_CollapsingString);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _List = __webpack_require__(947);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ModalHeading = __webpack_require__(1346);
	
	var _ModalHeading2 = _interopRequireDefault(_ModalHeading);
	
	var _ResourceTableUtil = __webpack_require__(1342);
	
	var _ResourceTableUtil2 = _interopRequireDefault(_ResourceTableUtil);
	
	var _RepositoriesTableHeaderLabels = __webpack_require__(1855);
	
	var _RepositoriesTableHeaderLabels2 = _interopRequireDefault(_RepositoriesTableHeaderLabels);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TableUtil = __webpack_require__(1057);
	
	var _TableUtil2 = _interopRequireDefault(_TableUtil);
	
	var _UserActions = __webpack_require__(1316);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var METHODS_TO_BIND = ["getHeadline", "getPriority", "getRemoveButton", "handleDeleteCancel", "handleDeleteRepository", "handleOpenConfirm"];
	/* eslint-enable no-unused-vars */
	
	var RepositoriesTable = function (_mixin) {
	  (0, _inherits3.default)(RepositoriesTable, _mixin);
	
	  function RepositoriesTable() {
	    (0, _classCallCheck3.default)(this, RepositoriesTable);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RepositoriesTable.__proto__ || (0, _getPrototypeOf2.default)(RepositoriesTable)).call(this));
	
	    _this.state = {
	      repositoryToRemove: null,
	      repositoryRemoveError: null,
	      pendingRequest: false
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["repositoryDeleteError", "repositoryDeleteSuccess"],
	      listenAlways: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(RepositoriesTable, [{
	    key: "onCosmosPackagesStoreRepositoryDeleteError",
	    value: function onCosmosPackagesStoreRepositoryDeleteError(error) {
	      this.setState({ repositoryRemoveError: error, pendingRequest: false });
	    }
	  }, {
	    key: "onCosmosPackagesStoreRepositoryDeleteSuccess",
	    value: function onCosmosPackagesStoreRepositoryDeleteSuccess() {
	      this.setState({
	        repositoryToRemove: null,
	        repositoryRemoveError: null,
	        pendingRequest: false
	      });
	      _CosmosPackagesStore2.default.fetchRepositories();
	    }
	  }, {
	    key: "handleOpenConfirm",
	    value: function handleOpenConfirm(repositoryToRemove) {
	      this.setState({ repositoryToRemove: repositoryToRemove });
	    }
	  }, {
	    key: "handleDeleteCancel",
	    value: function handleDeleteCancel() {
	      this.setState({ repositoryToRemove: null });
	    }
	  }, {
	    key: "handleDeleteRepository",
	    value: function handleDeleteRepository() {
	      var repositoryToRemove = this.state.repositoryToRemove;
	
	      _CosmosPackagesStore2.default.deleteRepository(repositoryToRemove.get("name"), repositoryToRemove.get("url"));
	
	      this.setState({ pendingRequest: true });
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(prop, sortBy, row) {
	      return (0, _classnames2.default)({
	        active: prop === sortBy.prop,
	        clickable: row == null, // this is a header
	        "text-align-right": prop === "priority"
	      });
	    }
	  }, {
	    key: "getColumns",
	    value: function getColumns() {
	      var repositories = this.props.repositories;
	
	      var getClassName = this.getClassName;
	      var heading = _ResourceTableUtil2.default.renderHeading(_RepositoriesTableHeaderLabels2.default);
	      var sortFunction = _TableUtil2.default.getSortFunction("uri", function (item, prop) {
	        if (prop === "priority") {
	          return repositories.getPriority(item);
	        }
	
	        return item.get(prop);
	      });
	
	      return [{
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "name",
	        render: this.getHeadline,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "uri",
	        render: this.getUri,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: heading,
	        prop: "priority",
	        render: this.getPriority,
	        sortable: true,
	        sortFunction: sortFunction
	      }, {
	        className: getClassName,
	        headerClassName: getClassName,
	        heading: function heading() {},
	
	        prop: "removed",
	        render: this.getRemoveButton,
	        sortable: false
	      }];
	    }
	  }, {
	    key: "getColGroup",
	    value: function getColGroup() {
	      return _react2.default.createElement(
	        "colgroup",
	        null,
	        _react2.default.createElement("col", { style: { width: "30%" } }),
	        _react2.default.createElement("col", null),
	        _react2.default.createElement("col", { style: { width: "112px" } }),
	        _react2.default.createElement("col", { style: { width: "85px" } })
	      );
	    }
	  }, {
	    key: "getUri",
	    value: function getUri(prop, repository) {
	      return _react2.default.createElement(_CollapsingString2.default, { string: repository.get("uri") });
	    }
	  }, {
	    key: "getHeadline",
	    value: function getHeadline(prop, repository) {
	      return _react2.default.createElement(
	        "div",
	        { className: "table-cell-emphasized text-overflow" },
	        repository.get("name")
	      );
	    }
	  }, {
	    key: "getPriority",
	    value: function getPriority(prop, repository) {
	      return this.props.repositories.getPriority(repository);
	    }
	  }, {
	    key: "getRemoveButton",
	    value: function getRemoveButton(prop, repositoryToRemove) {
	      return _react2.default.createElement(
	        "div",
	        { className: "flex-align-right" },
	        _react2.default.createElement(
	          "a",
	          {
	            className: "button button-link button-danger table-display-on-row-hover",
	            onClick: this.handleOpenConfirm.bind(this, repositoryToRemove)
	          },
	          _StringUtil2.default.capitalize(_UserActions2.default.DELETE)
	        )
	      );
	    }
	  }, {
	    key: "getRemoveModalContent",
	    value: function getRemoveModalContent() {
	      var _state = this.state,
	          repositoryRemoveError = _state.repositoryRemoveError,
	          repositoryToRemove = _state.repositoryToRemove;
	
	      var repositoryLabel = "This repository";
	      if (repositoryToRemove && repositoryToRemove.get("name")) {
	        repositoryLabel = repositoryToRemove.get("name");
	      }
	
	      var error = null;
	
	      if (repositoryRemoveError != null) {
	        error = _react2.default.createElement(
	          "p",
	          { className: "text-error-state" },
	          repositoryRemoveError
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "text-align-center" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Repository (" + repositoryLabel + ") will be " + _UserActions2.default.DELETED + " from " + _Config2.default.productName + ". You will not be able to install any packages belonging to that repository anymore."
	        ),
	        error
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          state = this.state;
	
	      var heading = _react2.default.createElement(
	        _ModalHeading2.default,
	        null,
	        "Are you sure?"
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactjsComponents.Table, {
	          className: "table table-borderless-outer table-borderless-inner-columns flush-bottom table-hover",
	          columns: this.getColumns(),
	          colGroup: this.getColGroup(),
	          data: props.repositories.getItems().slice(),
	          sortBy: { prop: "priority", order: "asc" }
	        }),
	        _react2.default.createElement(
	          _reactjsComponents.Confirm,
	          {
	            closeByBackdropClick: true,
	            disabled: state.pendingRequest,
	            header: heading,
	            open: !!state.repositoryToRemove,
	            onClose: this.handleDeleteCancel,
	            leftButtonCallback: this.handleDeleteCancel,
	            rightButtonCallback: this.handleDeleteRepository,
	            rightButtonClassName: "button button-danger",
	            rightButtonText: _StringUtil2.default.capitalize(_UserActions2.default.DELETE) + " Repository",
	            showHeader: true
	          },
	          this.getRemoveModalContent()
	        )
	      );
	    }
	  }]);
	  return RepositoriesTable;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	RepositoriesTable.defaultProps = {
	  repositories: new _List2.default()
	};
	
	RepositoriesTable.propTypes = {
	  repositories: _react2.default.PropTypes.object.isRequired
	};
	
	module.exports = RepositoriesTable;

/***/ },
/* 1855 */
/***/ function(module, exports) {

	"use strict";
	
	var RepositoriesTableHeaderLabels = {
	  name: "REPOSITORY NAME",
	  priority: "PRIORITY",
	  uri: "URL"
	};
	
	module.exports = RepositoriesTableHeaderLabels;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingsPage = function (_React$Component) {
	  (0, _inherits3.default)(SettingsPage, _React$Component);
	
	  function SettingsPage() {
	    (0, _classCallCheck3.default)(this, SettingsPage);
	    return (0, _possibleConstructorReturn3.default)(this, (SettingsPage.__proto__ || (0, _getPrototypeOf2.default)(SettingsPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SettingsPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return SettingsPage;
	}(_react2.default.Component);
	
	SettingsPage.routeConfig = {
	  label: "Settings",
	  icon: _react2.default.createElement(_Icon2.default, { id: "gear-inverse", size: "small", family: "product" }),
	  matches: /^\/settings/
	};
	
	module.exports = SettingsPage;

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _SystemOverviewPage = __webpack_require__(1858);
	
	var _SystemOverviewPage2 = _interopRequireDefault(_SystemOverviewPage);
	
	var _OverviewDetailTab = __webpack_require__(1859);
	
	var _OverviewDetailTab2 = _interopRequireDefault(_OverviewDetailTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemOverviewRoutes = {
	  type: _reactRouter.Route,
	  path: "overview",
	  component: _SystemOverviewPage2.default,
	  category: "system",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.IndexRoute,
	    component: _OverviewDetailTab2.default
	  }]
	};
	
	module.exports = systemOverviewRoutes;

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SystemOverviewPage = function (_React$Component) {
	  (0, _inherits3.default)(SystemOverviewPage, _React$Component);
	
	  function SystemOverviewPage() {
	    (0, _classCallCheck3.default)(this, SystemOverviewPage);
	    return (0, _possibleConstructorReturn3.default)(this, (SystemOverviewPage.__proto__ || (0, _getPrototypeOf2.default)(SystemOverviewPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SystemOverviewPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return SystemOverviewPage;
	}(_react2.default.Component);
	
	SystemOverviewPage.routeConfig = {
	  label: "Overview",
	  icon: _react2.default.createElement(_Icon2.default, { id: "cluster-inverse", size: "small", family: "product" }),
	  matches: /^\/overview/
	};
	
	module.exports = SystemOverviewPage;

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _keys = __webpack_require__(925);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _reactIntl = __webpack_require__(753);
	
	var _moment = __webpack_require__(1106);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _ConfigStore = __webpack_require__(1268);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _ConfigurationMapHeading = __webpack_require__(1377);
	
	var _ConfigurationMapHeading2 = _interopRequireDefault(_ConfigurationMapHeading);
	
	var _ConfigurationMapLabel = __webpack_require__(1435);
	
	var _ConfigurationMapLabel2 = _interopRequireDefault(_ConfigurationMapLabel);
	
	var _ConfigurationMapRow = __webpack_require__(1379);
	
	var _ConfigurationMapRow2 = _interopRequireDefault(_ConfigurationMapRow);
	
	var _ConfigurationMapSection = __webpack_require__(1380);
	
	var _ConfigurationMapSection2 = _interopRequireDefault(_ConfigurationMapSection);
	
	var _ConfigurationMapValue = __webpack_require__(1436);
	
	var _ConfigurationMapValue2 = _interopRequireDefault(_ConfigurationMapValue);
	
	var _Util = __webpack_require__(982);
	
	var _HashMapDisplay = __webpack_require__(1437);
	
	var _HashMapDisplay2 = _interopRequireDefault(_HashMapDisplay);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MarathonStore = __webpack_require__(1221);
	
	var _MarathonStore2 = _interopRequireDefault(_MarathonStore);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _MesosStateStore = __webpack_require__(1100);
	
	var _MesosStateStore2 = _interopRequireDefault(_MesosStateStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _VersionsModal = __webpack_require__(1413);
	
	var _VersionsModal2 = _interopRequireDefault(_VersionsModal);
	
	var _ValidatorUtil = __webpack_require__(983);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable no-unused-vars */
	var METHODS_TO_BIND = ["handleClusterConfigModalClose", "handleClusterConfigModalOpen"];
	/* eslint-disable no-unused-vars */
	
	
	var SystemOverviewBreadcrumbs = function SystemOverviewBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Cluster" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/overview" },
	        "Overview"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "cluster", breadcrumbs: crumbs });
	};
	
	var OverviewDetailTab = function (_mixin) {
	  (0, _inherits3.default)(OverviewDetailTab, _mixin);
	
	  function OverviewDetailTab() {
	    (0, _classCallCheck3.default)(this, OverviewDetailTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OverviewDetailTab.__proto__ || (0, _getPrototypeOf2.default)(OverviewDetailTab)).apply(this, arguments));
	
	    _this.state = {
	      isClusterBuildInfoOpen: false
	    };
	
	    _this.store_listeners = [{
	      name: "config",
	      events: ["ccidSuccess"]
	    }, {
	      name: "marathon",
	      events: ["instanceInfoSuccess"]
	    }, {
	      name: "metadata",
	      events: ["dcosBuildInfoChange", "dcosSuccess", "success"]
	    }, {
	      name: "state",
	      events: ["success"],
	      listenAlways: false
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(OverviewDetailTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(OverviewDetailTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(OverviewDetailTab.prototype), "componentDidMount", this).apply(this, arguments);
	
	      _ConfigStore2.default.fetchCCID();
	      _MarathonStore2.default.fetchMarathonInstanceInfo();
	      _MetadataStore2.default.fetchDCOSBuildInfo();
	    }
	  }, {
	    key: "handleClusterConfigModalOpen",
	    value: function handleClusterConfigModalOpen() {
	      this.setState({ isClusterBuildInfoOpen: true });
	    }
	  }, {
	    key: "handleClusterConfigModalClose",
	    value: function handleClusterConfigModalClose() {
	      this.setState({ isClusterBuildInfoOpen: false });
	    }
	  }, {
	    key: "getLoading",
	    value: function getLoading() {
	      return _react2.default.createElement(_Loader2.default, { size: "small", type: "ballBeat" });
	    }
	  }, {
	    key: "getClusterDetails",
	    value: function getClusterDetails() {
	      var ccid = _ConfigStore2.default.get("ccid");
	      var publicIP = this.getPublicIP();
	      var productVersion = _MetadataStore2.default.version;
	
	      if ((0, _keys2.default)(ccid).length) {
	        ccid = ccid.zbase32_public_key;
	      } else {
	        ccid = this.getLoading();
	      }
	
	      if (productVersion == null) {
	        productVersion = this.getLoading();
	      }
	
	      if (publicIP == null) {
	        publicIP = this.getLoading();
	      }
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "version" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _Config2.default.productName,
	            " Version"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            productVersion
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "ccid" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Cryptographic Cluster ID"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            ccid
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "publicIP" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            "Public IP"
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            publicIP
	          )
	        )
	      );
	    }
	  }, {
	    key: "getMarathonDetailsHash",
	    value: function getMarathonDetailsHash() {
	      var marathonDetails = _MarathonStore2.default.getInstanceInfo();
	
	      if (!(0, _keys2.default)(marathonDetails).length) {
	        return null;
	      }
	
	      return {
	        "Marathon Details": {
	          Version: marathonDetails.version,
	          "Framework ID": marathonDetails.frameworkId,
	          Leader: marathonDetails.leader,
	          "Marathon Config": marathonDetails.marathon_config,
	          "ZooKeeper Config": marathonDetails.zookeeper_config
	        }
	      };
	    }
	  }, {
	    key: "getPageHeaderActions",
	    value: function getPageHeaderActions() {
	      return [{
	        label: "View Cluster Configuration",
	        onItemSelect: this.handleClusterConfigModalOpen
	      }];
	    }
	  }, {
	    key: "getPublicIP",
	    value: function getPublicIP() {
	      var publicIP = (0, _Util.findNestedPropertyInObject)(_MetadataStore2.default.get("metadata"), "PUBLIC_IPV4");
	
	      if (!publicIP) {
	        return null;
	      }
	
	      return publicIP;
	    }
	
	    /**
	     * Get user if existent otherwise
	     * return null
	     *
	     * @param {String} mesosBuildUser
	     * @returns {Component|Null} User string or null
	     *
	     * @memberOf OverviewDetailTab
	     */
	
	  }, {
	    key: "getMesosBuildUser",
	    value: function getMesosBuildUser(mesosBuildUser) {
	      if ((0, _ValidatorUtil.isEmpty)(mesosBuildUser)) {
	        return null;
	      } else {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: "COMMON.BY_NAME",
	          values: {
	            name: mesosBuildUser
	          }
	        });
	      }
	    }
	
	    /**
	     * Build Mesos details
	     *
	     * @returns {Component} Mesos details component
	     *
	     * @memberOf OverviewDetailTab
	     */
	
	  }, {
	    key: "getMesosDetails",
	    value: function getMesosDetails() {
	      var mesosConfig = _MesosStateStore2.default.get("lastMesosState");
	      var mesosCluster = mesosConfig.cluster || this.getLoading();
	      var mesosLeaderInfo = mesosConfig.leader_info || this.getLoading();
	      var mesosVersion = mesosConfig.version || this.getLoading();
	      var mesosBuilt = mesosConfig.build_time || this.getLoading();
	      var mesosStarted = mesosConfig.start_time || this.getLoading();
	      var mesosElected = mesosConfig.elected_time || this.getLoading();
	      var mesosBuildUser = mesosConfig.build_user;
	
	      return _react2.default.createElement(
	        _ConfigurationMapSection2.default,
	        null,
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "cluster" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.CLUSTER" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            mesosCluster
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "leader" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.LEADER" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            mesosLeaderInfo.hostname,
	            ":",
	            mesosLeaderInfo.port
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "version" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.VERSION" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            mesosVersion
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "built" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.BUILT" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            (0, _moment2.default)(mesosBuilt * 1000).fromNow(),
	            " ",
	            this.getMesosBuildUser(mesosBuildUser)
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "started" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.STARTED" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            (0, _moment2.default)(mesosStarted * 1000).fromNow()
	          )
	        ),
	        _react2.default.createElement(
	          _ConfigurationMapRow2.default,
	          { key: "elected" },
	          _react2.default.createElement(
	            _ConfigurationMapLabel2.default,
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.ELECTED" })
	          ),
	          _react2.default.createElement(
	            _ConfigurationMapValue2.default,
	            null,
	            (0, _moment2.default)(mesosElected * 1000).fromNow()
	          )
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var buildInfo = _MetadataStore2.default.get("dcosBuildInfo");
	      var marathonHash = this.getMarathonDetailsHash();
	      var marathonDetails = null;
	      var versionsModal = null;
	
	      if (marathonHash) {
	        marathonDetails = _react2.default.createElement(_HashMapDisplay2.default, { hash: marathonHash });
	      }
	
	      if (buildInfo != null) {
	        versionsModal = _react2.default.createElement(_VersionsModal2.default, {
	          onClose: this.handleClusterConfigModalClose,
	          open: this.state.isClusterBuildInfoOpen,
	          versionDump: buildInfo
	        });
	      }
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          actions: this.getPageHeaderActions(),
	          breadcrumbs: _react2.default.createElement(SystemOverviewBreadcrumbs, null)
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            _ConfigurationMap2.default,
	            null,
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              { className: "flush-top" },
	              "Cluster ",
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.DETAILS" })
	            ),
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              { level: 2 },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.GENERAL" })
	            ),
	            this.getClusterDetails(),
	            _react2.default.createElement(
	              _ConfigurationMapHeading2.default,
	              { level: 2 },
	              "Mesos ",
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: "COMMON.DETAILS" })
	            ),
	            this.getMesosDetails(),
	            marathonDetails,
	            _react2.default.createElement(_foundationUi.MountService.Mount, { type: "OverviewDetailTab:AdditionalClusterDetails" })
	          )
	        ),
	        versionsModal
	      );
	    }
	  }]);
	  return OverviewDetailTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	OverviewDetailTab.routeConfig = {
	  label: "Overview",
	  matches: /^\/overview\/details/
	};
	
	module.exports = OverviewDetailTab;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouter = __webpack_require__(785);
	
	var _PackageDetailTab = __webpack_require__(1861);
	
	var _PackageDetailTab2 = _interopRequireDefault(_PackageDetailTab);
	
	var _PackagesTab = __webpack_require__(1869);
	
	var _PackagesTab2 = _interopRequireDefault(_PackagesTab);
	
	var _CatalogPage = __webpack_require__(1873);
	
	var _CatalogPage2 = _interopRequireDefault(_CatalogPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var universeRoutes = [{
	  // Keep this around for any old links pointing to /universe
	  type: _reactRouter.Redirect,
	  from: "/universe",
	  to: "/catalog"
	}, {
	  type: _reactRouter.Redirect,
	  from: "/catalog",
	  to: "/catalog/packages"
	}, {
	  type: _reactRouter.Route,
	  path: "catalog",
	  component: _CatalogPage2.default,
	  category: "root",
	  isInSidebar: true,
	  children: [{
	    type: _reactRouter.Route,
	    path: "packages",
	    component: _PackagesTab2.default,
	    hideHeaderNavigation: true
	  }, {
	    type: _reactRouter.Route,
	    path: "packages/:packageName",
	    component: _PackageDetailTab2.default,
	    hideHeaderNavigation: true
	  }]
	}];
	
	module.exports = universeRoutes;

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _reactRouter = __webpack_require__(785);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _iconServiceDefaultLarge2x = __webpack_require__(1084);
	
	var _iconServiceDefaultLarge2x2 = _interopRequireDefault(_iconServiceDefaultLarge2x);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageViewer = __webpack_require__(1862);
	
	var _ImageViewer2 = _interopRequireDefault(_ImageViewer);
	
	var _InstallPackageModal = __webpack_require__(1864);
	
	var _InstallPackageModal2 = _interopRequireDefault(_InstallPackageModal);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MetadataStore = __webpack_require__(1044);
	
	var _MetadataStore2 = _interopRequireDefault(_MetadataStore);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _RequestErrorMsg = __webpack_require__(1353);
	
	var _RequestErrorMsg2 = _interopRequireDefault(_RequestErrorMsg);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var PackageDetailBreadcrumbs = function PackageDetailBreadcrumbs(_ref) {
	  var cosmosPackage = _ref.cosmosPackage;
	
	  var name = cosmosPackage.getName();
	  var version = cosmosPackage.getVersion();
	
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Catalog" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/catalog/packages" },
	        "Catalog"
	      )
	    )
	  ), _react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 1, title: name },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/catalog/packages/" + name, query: { version: version }, key: 0 },
	        name
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "packages", breadcrumbs: crumbs });
	};
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleInstallModalClose", "handleInstallModalOpen"];
	
	var PackageDetailTab = function (_mixin) {
	  (0, _inherits3.default)(PackageDetailTab, _mixin);
	
	  function PackageDetailTab() {
	    (0, _classCallCheck3.default)(this, PackageDetailTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PackageDetailTab.__proto__ || (0, _getPrototypeOf2.default)(PackageDetailTab)).call(this));
	
	    _this.state = {
	      hasError: 0,
	      openInstallModal: false,
	      isLoading: true
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["descriptionError", "descriptionSuccess"],
	      unmountWhen: function unmountWhen(store, event) {
	        if (event === "descriptionSuccess") {
	          return !!_CosmosPackagesStore2.default.get("packageDetails");
	        }
	      },
	
	      listenAlways: false,
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PackageDetailTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(PackageDetailTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(PackageDetailTab.prototype), "componentDidMount", this).apply(this, arguments);
	
	      var packageName = this.props.params.packageName;
	      var version = this.props.location.query.version;
	      // Fetch package description
	
	      _CosmosPackagesStore2.default.fetchPackageDescription(packageName, version);
	    }
	  }, {
	    key: "onCosmosPackagesStoreDescriptionError",
	    value: function onCosmosPackagesStoreDescriptionError() {
	      this.setState({ hasError: true });
	    }
	  }, {
	    key: "onCosmosPackagesStoreDescriptionSuccess",
	    value: function onCosmosPackagesStoreDescriptionSuccess() {
	      this.setState({ hasError: false, isLoading: false });
	    }
	  }, {
	    key: "handleInstallModalClose",
	    value: function handleInstallModalClose() {
	      this.setState({ openInstallModal: false });
	    }
	  }, {
	    key: "handleInstallModalOpen",
	    value: function handleInstallModalOpen() {
	      this.setState({ openInstallModal: true });
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      return _react2.default.createElement(_RequestErrorMsg2.default, null);
	    }
	  }, {
	    key: "getItems",
	    value: function getItems(definition, renderItem) {
	      var _this2 = this;
	
	      var items = [];
	      definition.forEach(function (item, index) {
	        var label = item.label,
	            type = item.type,
	            value = item.value;
	
	        // When there is no content to render, discard it all together
	
	        if (!value || Array.isArray(value) && !value.length) {
	          return null;
	        }
	
	        // If not specific type assume value is renderable
	        var content = value;
	
	        // Render sub items
	        if (type === "subItems") {
	          content = _this2.getItems(value, _this2.getSubItem);
	        }
	
	        items.push(renderItem(label, content, index));
	      });
	
	      return items;
	    }
	  }, {
	    key: "getItem",
	    value: function getItem(label, value, key) {
	      if (!label || !value) {
	        return null;
	      }
	
	      if (typeof value === "string") {
	        value = _react2.default.createElement(
	          "p",
	          { className: "flush" },
	          value
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "pod pod-shorter flush-top flush-right flush-left",
	          key: key
	        },
	        _react2.default.createElement(
	          "h5",
	          { className: "short-bottom" },
	          label
	        ),
	        value
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getSubItem",
	    value: function getSubItem(label, value, key) {
	      var content = value;
	
	      if (_StringUtil2.default.isEmail(value)) {
	        content = _react2.default.createElement(
	          "a",
	          { key: key, href: "mailto:" + value },
	          value
	        );
	      }
	
	      if (_StringUtil2.default.isUrl(value)) {
	        content = _react2.default.createElement(
	          "a",
	          { key: key, href: value, target: "_blank" },
	          value
	        );
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { key: key, className: "short" },
	        label + ": ",
	        content
	      );
	    }
	  }, {
	    key: "mapLicenses",
	    value: function mapLicenses(licenses) {
	      return licenses.map(function (license) {
	        var item = {
	          label: license.name,
	          value: license.url
	        };
	
	        return item;
	      });
	    }
	  }, {
	    key: "getPackageBadge",
	    value: function getPackageBadge(cosmosPackage, version) {
	      var isCertified = cosmosPackage.isCertified();
	      var badgeCopy = isCertified ? "Certified" : "Community";
	      var badgeClasses = (0, _classnames2.default)("badge badge-large badge-rounded", {
	        "badge--primary": isCertified
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: "badge-container selected-badge" },
	        _react2.default.createElement(
	          "span",
	          { className: badgeClasses },
	          badgeCopy
	        ),
	        _react2.default.createElement(
	          "small",
	          null,
	          version
	        )
	      );
	    }
	  }, {
	    key: "getInstallButtons",
	    value: function getInstallButtons(cosmosPackage) {
	      if (cosmosPackage.isCLIOnly()) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "CLI Only Package"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "This package can only be installed using the CLI. See the ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: _MetadataStore2.default.buildDocsURI("/usage/managing-services/install/#installing-a-service-using-the-cli"),
	                target: "_blank"
	              },
	              "documentation"
	            ),
	            "."
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "button-collection" },
	        _react2.default.createElement(
	          "button",
	          {
	            className: "button button-primary",
	            onClick: this.handleInstallModalOpen
	          },
	          "Review & Run"
	        )
	      );
	    }
	  }, {
	    key: "getTermsConditionUrl",
	    value: function getTermsConditionUrl() {
	      var cosmosPackage = _CosmosPackagesStore2.default.getPackageDetails();
	
	      if (cosmosPackage.isCertified()) {
	        return "https://mesosphere.com/catalog-terms-conditions/#certified-services";
	      } else {
	        return "https://mesosphere.com/catalog-terms-conditions/#community-services";
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          state = this.state;
	
	
	      if (state.hasError || !props.params.packageName) {
	        return this.getErrorScreen();
	      }
	
	      var cosmosPackage = _CosmosPackagesStore2.default.getPackageDetails();
	      if (state.isLoading || !cosmosPackage) {
	        return this.getLoadingScreen();
	      }
	
	      var name = cosmosPackage.getName();
	      var version = cosmosPackage.getVersion();
	      var description = cosmosPackage.getDescription();
	      var preInstallNotes = cosmosPackage.getPreInstallNotes();
	
	      var definition = [{
	        label: "Description",
	        value: description && _react2.default.createElement("div", {
	          dangerouslySetInnerHTML: _StringUtil2.default.parseMarkdown(description)
	        })
	      }, {
	        label: "Pre-Install Notes",
	        value: preInstallNotes && _react2.default.createElement("div", {
	          dangerouslySetInnerHTML: _StringUtil2.default.parseMarkdown(preInstallNotes)
	        })
	      }, {
	        label: "Information",
	        type: "subItems",
	        value: [{ label: "SCM", value: cosmosPackage.getSCM() }, { label: "Maintainer", value: cosmosPackage.getMaintainer() }]
	      }, {
	        label: "Licenses",
	        type: "subItems",
	        value: this.mapLicenses(cosmosPackage.getLicenses())
	      }];
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, {
	          breadcrumbs: _react2.default.createElement(PackageDetailBreadcrumbs, { cosmosPackage: cosmosPackage })
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object-spacing-wrapper media-object-spacing-wide media-object-offset" },
	            _react2.default.createElement(
	              "div",
	              { className: "media-object media-object-align-top media-object-wrap" },
	              _react2.default.createElement(
	                "div",
	                { className: "media-object-item" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "icon icon-huge icon-image-container icon-app-container icon-app-container--borderless icon-default-white" },
	                  _react2.default.createElement(_Image2.default, {
	                    fallbackSrc: _iconServiceDefaultLarge2x2.default,
	                    src: cosmosPackage.getIcons()["icon-large"]
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "media-object-item media-object-item-grow" },
	                _react2.default.createElement(
	                  "h1",
	                  { className: "short flush-top" },
	                  name
	                ),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  this.getPackageBadge(cosmosPackage, version)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "media-object-item package-action-buttons" },
	                this.getInstallButtons(cosmosPackage),
	                _react2.default.createElement(
	                  "small",
	                  null,
	                  "By deploying you agree to the ",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: this.getTermsConditionUrl(),
	                      target: "_blank",
	                      title: "Terms and Conditions"
	                    },
	                    "terms and conditions"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "pod flush-horizontal flush-bottom" },
	            this.getItems(definition, this.getItem),
	            _react2.default.createElement(_ImageViewer2.default, { images: cosmosPackage.getScreenshots() })
	          )
	        ),
	        _react2.default.createElement(_InstallPackageModal2.default, {
	          open: state.openInstallModal,
	          cosmosPackage: cosmosPackage,
	          onClose: this.handleInstallModalClose
	        })
	      );
	    }
	  }]);
	  return PackageDetailTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	module.exports = PackageDetailTab;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ImageViewerModal = __webpack_require__(1863);
	
	var _ImageViewerModal2 = _interopRequireDefault(_ImageViewerModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleImageViewerModalClose", "handleImageViewerLeftClick", "handleImageViewerRightClick"];
	
	var ImageViewer = function (_React$Component) {
	  (0, _inherits3.default)(ImageViewer, _React$Component);
	
	  function ImageViewer() {
	    (0, _classCallCheck3.default)(this, ImageViewer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageViewer.__proto__ || (0, _getPrototypeOf2.default)(ImageViewer)).apply(this, arguments));
	
	    _this.state = { selectedImage: null };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(ImageViewer, [{
	    key: "handleImageViewerModalClose",
	    value: function handleImageViewerModalClose() {
	      this.setState({ selectedImage: null });
	    }
	  }, {
	    key: "handleImageViewerModalOpen",
	    value: function handleImageViewerModalOpen(selectedImage) {
	      this.setState({ selectedImage: selectedImage });
	    }
	  }, {
	    key: "handleImageViewerLeftClick",
	    value: function handleImageViewerLeftClick() {
	      var selectedImage = this.state.selectedImage;
	      var images = this.props.images;
	
	      if (--selectedImage < 0) {
	        selectedImage = images.length - 1;
	      }
	      this.setState({ selectedImage: selectedImage });
	    }
	  }, {
	    key: "handleImageViewerRightClick",
	    value: function handleImageViewerRightClick() {
	      var selectedImage = this.state.selectedImage;
	      var images = this.props.images;
	      // Add before the modulus operator and use modulus as a circular buffer
	
	      this.setState({ selectedImage: ++selectedImage % images.length });
	    }
	  }, {
	    key: "getImages",
	    value: function getImages(images) {
	      var _this2 = this;
	
	      return images.map(function (imageUrl, index) {
	        return _react2.default.createElement(
	          "div",
	          { className: "media-object-item media-object-item-fill", key: index },
	          _react2.default.createElement("div", {
	            className: "media-object-item-fill-image image-rounded-corners clickable",
	            onClick: _this2.handleImageViewerModalOpen.bind(_this2, index),
	            style: { backgroundImage: "url(" + imageUrl + ")" }
	          })
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var images = this.props.images;
	      var selectedImage = this.state.selectedImage;
	
	
	      if (!images || !images.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pod pod-short flush-top flush-right flush-left" },
	        _react2.default.createElement(
	          "h5",
	          { className: "flush-top" },
	          "Media"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "media-object-spacing-wrapper media-object-offset" },
	          _react2.default.createElement(
	            "div",
	            { className: "media-object flex-box flex-box-wrap" },
	            this.getImages(images)
	          )
	        ),
	        _react2.default.createElement(_ImageViewerModal2.default, {
	          onLeftClick: this.handleImageViewerLeftClick,
	          onRightClick: this.handleImageViewerRightClick,
	          images: images,
	          open: selectedImage != null,
	          onClose: this.handleImageViewerModalClose,
	          selectedImage: selectedImage
	        })
	      );
	    }
	  }]);
	  return ImageViewer;
	}(_react2.default.Component);
	
	ImageViewer.defaultProps = {
	  images: []
	};
	
	ImageViewer.propTypes = {
	  images: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)
	};
	
	module.exports = ImageViewer;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _KeyboardUtil = __webpack_require__(1416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METHODS_TO_BIND = ["handleClick", "handleKeyPress"];
	
	var ImageViewerModal = function (_React$Component) {
	  (0, _inherits3.default)(ImageViewerModal, _React$Component);
	
	  function ImageViewerModal() {
	    (0, _classCallCheck3.default)(this, ImageViewerModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageViewerModal.__proto__ || (0, _getPrototypeOf2.default)(ImageViewerModal)).apply(this, arguments));
	
	    _this.state = { isLoadingImage: false };
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	
	    if (_this.props.open) {
	      global.addEventListener("keydown", _this.handleKeyPress, true);
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(ImageViewerModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var props = this.props;
	
	      if (props.open && !nextProps.open) {
	        // Closes
	        global.removeEventListener("keydown", this.handleKeyPress, true);
	      }
	
	      if (!props.open && nextProps.open) {
	        // Opens
	        global.addEventListener("keydown", this.handleKeyPress, true);
	      }
	    }
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(event) {
	      var images = this.props.images;
	      // Should do nothing if the key event was already consumed, or there is only
	      // one or no images
	
	      if (event.defaultPrevented || !images || images.length < 2) {
	        return;
	      }
	
	      if (event.keyCode === _KeyboardUtil.keyCodes.leftArrow) {
	        this.handleClick("left");
	      }
	
	      if (event.keyCode === _KeyboardUtil.keyCodes.rightArrow) {
	        this.handleClick("right");
	      }
	
	      // Consume the event for suppressing "double action".
	      event.preventDefault();
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(direction) {
	      if (direction === "left") {
	        this.props.onLeftClick();
	      }
	
	      if (direction === "right") {
	        this.props.onRightClick();
	      }
	
	      this.handleLoadingImageChange(true);
	    }
	  }, {
	    key: "handleLoadingImageChange",
	    value: function handleLoadingImageChange(isLoadingImage) {
	      this.setState({ isLoadingImage: isLoadingImage });
	    }
	  }, {
	    key: "getSelectedImage",
	    value: function getSelectedImage() {
	      var props = this.props;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "fill-image-container" },
	        _react2.default.createElement("img", {
	          className: "fill-image",
	          onLoad: this.handleLoadingImageChange.bind(this, false),
	          key: props.selectedImage,
	          src: props.images[props.selectedImage]
	        })
	      );
	    }
	  }, {
	    key: "getFooter",
	    value: function getFooter() {
	      return _react2.default.createElement(
	        "div",
	        { onKeyPress: this.handleKeyPress },
	        _react2.default.createElement(
	          "span",
	          {
	            onClick: this.handleClick.bind(this, "left"),
	            className: "modal-image-viewer-arrow-container clickable backward"
	          },
	          _react2.default.createElement(_Icon2.default, { className: "arrow", color: "white", id: "caret-left", size: "small" })
	        ),
	        _react2.default.createElement(
	          "span",
	          {
	            className: "modal-image-viewer-arrow-container clickable forward",
	            onClick: this.handleClick.bind(this, "left")
	          },
	          _react2.default.createElement(_Icon2.default, { className: "arrow", color: "white", id: "caret-right", size: "small" })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          state = this.state;
	
	      var closeIcon = _react2.default.createElement(_Icon2.default, { id: "close", size: "mini" });
	      var modalClasses = (0, _classnames2.default)("modal modal-image-viewer", {
	        hidden: state.isLoadingImage
	      });
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          footer: this.getFooter(),
	          modalClass: modalClasses,
	          onClose: props.onClose,
	          open: props.open,
	          scrollContainerClass: "",
	          closeButton: closeIcon,
	          showFooter: props.images && props.images.length > 1,
	          showHeader: false,
	          useGemini: false
	        },
	        this.getSelectedImage()
	      );
	    }
	  }]);
	  return ImageViewerModal;
	}(_react2.default.Component);
	
	ImageViewerModal.defaultProps = {
	  images: []
	};
	
	ImageViewerModal.propTypes = {
	  images: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  onLeftClick: _react2.default.PropTypes.func.isRequired,
	  onRightClick: _react2.default.PropTypes.func.isRequired,
	  onClose: _react2.default.PropTypes.func.isRequired
	};
	
	module.exports = ImageViewerModal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsComponents = __webpack_require__(1277);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _CosmosErrorHeader = __webpack_require__(1865);
	
	var _CosmosErrorHeader2 = _interopRequireDefault(_CosmosErrorHeader);
	
	var _CosmosErrorMessage = __webpack_require__(1866);
	
	var _CosmosErrorMessage2 = _interopRequireDefault(_CosmosErrorMessage);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _iconServiceDefaultLarge2x = __webpack_require__(1084);
	
	var _iconServiceDefaultLarge2x2 = _interopRequireDefault(_iconServiceDefaultLarge2x);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _InternalStorageMixin = __webpack_require__(1324);
	
	var _InternalStorageMixin2 = _interopRequireDefault(_InternalStorageMixin);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ReviewConfig = __webpack_require__(1868);
	
	var _ReviewConfig2 = _interopRequireDefault(_ReviewConfig);
	
	var _SchemaForm = __webpack_require__(1456);
	
	var _SchemaForm2 = _interopRequireDefault(_SchemaForm);
	
	var _SchemaUtil = __webpack_require__(1460);
	
	var _SchemaUtil2 = _interopRequireDefault(_SchemaUtil);
	
	var _SchemaFormUtil = __webpack_require__(1458);
	
	var _SchemaFormUtil2 = _interopRequireDefault(_SchemaFormUtil);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _TabsMixin = __webpack_require__(1481);
	
	var _TabsMixin2 = _interopRequireDefault(_TabsMixin);
	
	var _UniversePackage = __webpack_require__(1852);
	
	var _UniversePackage2 = _interopRequireDefault(_UniversePackage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PREINSTALL_NOTES_CHAR_LIMIT = 140;
	
	var METHODS_TO_BIND = ["getAdvancedSubmit", "handleChangeTab", "handleInstallPackage", "handleAdvancedFormChange", "handleModalClose", "handlePreinstallNotesToggle"];
	
	var InstallPackageModal = function (_mixin) {
	  (0, _inherits3.default)(InstallPackageModal, _mixin);
	
	  function InstallPackageModal() {
	    (0, _classCallCheck3.default)(this, InstallPackageModal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InstallPackageModal.__proto__ || (0, _getPrototypeOf2.default)(InstallPackageModal)).apply(this, arguments));
	
	    _this.tabs_tabs = {
	      installError: "InstallError",
	      advancedInstall: "AdvancedInstall",
	      reviewAdvancedConfig: "ReviewAdvancedConfig",
	      packageInstalled: "PackageInstalled"
	    };
	
	    _this.internalStorage_set({
	      descriptionError: null,
	      hasFormErrors: false,
	      installError: null,
	      pendingRequest: false
	    });
	
	    _this.state = {
	      currentTab: "reviewAdvancedConfig",
	      schemaIncorrect: false,
	      truncatedPreInstallNotes: true
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["descriptionError", "descriptionSuccess", "installError", "installSuccess"]
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(InstallPackageModal, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      (0, _get3.default)(InstallPackageModal.prototype.__proto__ || (0, _getPrototypeOf2.default)(InstallPackageModal.prototype), "componentWillReceiveProps", this).apply(this, arguments);
	      var props = this.props;
	
	      // Return early if open prop did not change
	
	      if (props.open === nextProps.open) {
	        return;
	      }
	
	      // If closing
	      if (props.open && !nextProps.open) {
	        this.internalStorage_set({
	          descriptionError: null,
	          installError: null,
	          pendingRequest: false
	        });
	        // Reset our trigger submit for advanced install
	        this.triggerAdvancedSubmit = undefined;
	        this.setState({
	          currentTab: "reviewAdvancedConfig",
	          truncatedPreInstallNotes: true
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.triggerAdvancedSubmit) {
	        // Trigger submit upfront to validate fields and potentially disable buttons
	        var _triggerAdvancedSubmi = this.triggerAdvancedSubmit(),
	            isValidated = _triggerAdvancedSubmi.isValidated;
	
	        this.internalStorage_update({ hasFormErrors: !isValidated });
	      }
	    }
	  }, {
	    key: "onCosmosPackagesStoreDescriptionError",
	    value: function onCosmosPackagesStoreDescriptionError(descriptionError) {
	      this.internalStorage_update({ descriptionError: descriptionError });
	      this.forceUpdate();
	    }
	  }, {
	    key: "onCosmosPackagesStoreDescriptionSuccess",
	    value: function onCosmosPackagesStoreDescriptionSuccess() {
	      var cosmosPackage = this.props.cosmosPackage;
	
	      var schemaIncorrect = !_SchemaUtil2.default.validateSchema(cosmosPackage.getConfig());
	
	      this.internalStorage_update({
	        hasError: schemaIncorrect
	      });
	
	      this.setState({ schemaIncorrect: schemaIncorrect });
	    }
	  }, {
	    key: "onCosmosPackagesStoreInstallError",
	    value: function onCosmosPackagesStoreInstallError(installError) {
	      this.internalStorage_update({
	        installError: installError,
	        pendingRequest: false
	      });
	      this.setState({ currentTab: "installError" });
	    }
	  }, {
	    key: "onCosmosPackagesStoreInstallSuccess",
	    value: function onCosmosPackagesStoreInstallSuccess(name, version, appId) {
	      this.internalStorage_update({
	        installError: null,
	        pendingRequest: false,
	        appId: appId
	      });
	      this.setState({ currentTab: "packageInstalled" });
	    }
	  }, {
	    key: "handleAdvancedFormChange",
	    value: function handleAdvancedFormChange(formObject) {
	      this.internalStorage_update({ hasFormErrors: !formObject.isValidated });
	      this.forceUpdate();
	    }
	  }, {
	    key: "handleChangeTab",
	    value: function handleChangeTab(currentTab) {
	      var newState = { installError: null };
	      if (currentTab === "advancedInstall") {
	        // Change back to previous state and clean up stored config
	        newState.advancedConfiguration = null;
	      }
	
	      if (currentTab === "reviewAdvancedConfig") {
	        var _triggerAdvancedSubmi2 = this.triggerAdvancedSubmit(),
	            isValidated = _triggerAdvancedSubmi2.isValidated,
	            model = _triggerAdvancedSubmi2.model;
	
	        // Change state if form fields are validated and store configuration
	        // for submission
	
	
	        if (isValidated) {
	          newState.advancedConfiguration = model;
	        }
	      }
	
	      this.internalStorage_update(newState);
	      this.tabs_handleTabClick(currentTab);
	    }
	  }, {
	    key: "handleInstallPackage",
	    value: function handleInstallPackage() {
	      var cosmosPackage = this.props.cosmosPackage;
	
	      var name = cosmosPackage.getName();
	      var version = cosmosPackage.getVersion();
	      var configuration = this.getPackageConfiguration();
	
	      _CosmosPackagesStore2.default.installPackage(name, version, configuration);
	      this.internalStorage_update({ pendingRequest: true });
	      this.forceUpdate();
	    }
	  }, {
	    key: "handleModalClose",
	    value: function handleModalClose() {
	      this.setState({ schemaIncorrect: false });
	      this.props.onClose();
	    }
	  }, {
	    key: "handlePreinstallNotesToggle",
	    value: function handlePreinstallNotesToggle() {
	      var truncatedPreInstallNotes = !this.state.truncatedPreInstallNotes;
	      this.setState({ truncatedPreInstallNotes: truncatedPreInstallNotes });
	    }
	  }, {
	    key: "getAdvancedSubmit",
	    value: function getAdvancedSubmit(triggerSubmit) {
	      this.triggerAdvancedSubmit = triggerSubmit;
	    }
	  }, {
	    key: "getPackageConfiguration",
	    value: function getPackageConfiguration() {
	      var _internalStorage_get = this.internalStorage_get(),
	          advancedConfiguration = _internalStorage_get.advancedConfiguration;
	
	      var cosmosPackage = this.props.cosmosPackage;
	
	
	      if (advancedConfiguration) {
	        return advancedConfiguration;
	      }
	
	      var definitions = _SchemaUtil2.default.schemaToMultipleDefinition({
	        schema: cosmosPackage.getConfig()
	      });
	
	      return _SchemaFormUtil2.default.processFormModel(_SchemaUtil2.default.definitionToJSONDocument(definitions), definitions);
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(
	        "div",
	        { className: "modal-content-loading-indicator vertical-center" },
	        _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: "getInstallErrorScreen",
	    value: function getInstallErrorScreen() {
	      var _internalStorage_get2 = this.internalStorage_get(),
	          pendingRequest = _internalStorage_get2.pendingRequest,
	          installError = _internalStorage_get2.installError;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "modal-body" },
	          _react2.default.createElement(
	            _CosmosErrorHeader2.default,
	            null,
	            "An Error Occurred"
	          ),
	          _react2.default.createElement(_CosmosErrorMessage2.default, { error: installError, flushBottom: true })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-footer" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-collection button-collection-stacked" },
	            _react2.default.createElement(
	              "button",
	              {
	                disabled: pendingRequest,
	                className: "button button-block",
	                onClick: this.handleChangeTab.bind(this, "advancedInstall")
	              },
	              "Edit Configuration"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getPreInstallNotes",
	    value: function getPreInstallNotes(notes, truncated) {
	      if (!notes) {
	        return null;
	      }
	
	      if (truncated) {
	        notes = notes.slice(0, PREINSTALL_NOTES_CHAR_LIMIT);
	      }
	
	      return _react2.default.createElement(
	        "p",
	        { className: "small text-align-left flush-bottom" },
	        notes,
	        this.getPreInstallNotesToggle(truncated, notes)
	      );
	    }
	  }, {
	    key: "getPreInstallNotesToggle",
	    value: function getPreInstallNotesToggle(truncated, notes) {
	      if (notes.length < PREINSTALL_NOTES_CHAR_LIMIT) {
	        return null;
	      }
	
	      var ellipses = "";
	      var textTruncationToggleWord = "collapse";
	
	      if (truncated) {
	        ellipses = "...";
	        textTruncationToggleWord = "expand";
	      }
	
	      var text = _react2.default.createElement(
	        "span",
	        { className: "clickable", onClick: this.handlePreinstallNotesToggle },
	        _react2.default.createElement(
	          "u",
	          null,
	          textTruncationToggleWord
	        )
	      );
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        ellipses,
	        " ",
	        text
	      );
	    }
	  }, {
	    key: "renderInstallErrorTabView",
	    value: function renderInstallErrorTabView() {
	      var _internalStorage_get3 = this.internalStorage_get(),
	          descriptionError = _internalStorage_get3.descriptionError,
	          installError = _internalStorage_get3.installError;
	
	      var cosmosPackage = this.props.cosmosPackage;
	
	      var preInstallNotes = cosmosPackage.getPreInstallNotes();
	      var name = cosmosPackage.getName();
	      var version = cosmosPackage.getVersion();
	      var truncated = this.state.truncatedPreInstallNotes;
	      var packageVersionClasses = (0, _classnames2.default)({
	        "flush-bottom": !preInstallNotes
	      });
	
	      if (installError) {
	        return this.getInstallErrorScreen();
	      }
	
	      var error = void 0;
	      if (descriptionError) {
	        error = _react2.default.createElement(
	          "p",
	          { className: "text-danger small text-align-center" },
	          descriptionError
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "modal-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "text-align-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "icon icon-jumbo icon-image-container icon-app-container icon-app-container--borderless" },
	              _react2.default.createElement(_Image2.default, {
	                fallbackSrc: _iconServiceDefaultLarge2x2.default,
	                src: cosmosPackage.getIcons()["icon-large"]
	              })
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "h2 short-top short-bottom" },
	              name
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: packageVersionClasses },
	              version
	            ),
	            this.getPreInstallNotes(preInstallNotes, truncated),
	            error
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-footer" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-collection button-collection-stacked horizontal-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "button button-success button-block",
	                onClick: this.props.onClose
	              },
	              "OK"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderAdvancedInstallTabView",
	    value: function renderAdvancedInstallTabView() {
	      var _internalStorage_get4 = this.internalStorage_get(),
	          pendingRequest = _internalStorage_get4.pendingRequest,
	          hasFormErrors = _internalStorage_get4.hasFormErrors;
	      // Only return footer, we always render SchemaForm, but just change
	      // the hidden class in render
	
	      return _react2.default.createElement(
	        "div",
	        { className: "modal-footer" },
	        _react2.default.createElement(
	          "div",
	          { className: "button-collection flush-bottom" },
	          _react2.default.createElement(
	            "button",
	            { className: "button", onClick: this.handleModalClose },
	            "Cancel"
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: pendingRequest || hasFormErrors,
	              className: "button button-primary",
	              onClick: this.handleChangeTab.bind(this, "reviewAdvancedConfig")
	            },
	            "Review & Run"
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderReviewAdvancedConfigTabView",
	    value: function renderReviewAdvancedConfigTabView() {
	      var _internalStorage_get5 = this.internalStorage_get(),
	          pendingRequest = _internalStorage_get5.pendingRequest;
	
	      var cosmosPackage = this.props.cosmosPackage;
	
	      var name = cosmosPackage.getName();
	      var version = cosmosPackage.getVersion();
	      var buttonText = "Run Service";
	
	      if (pendingRequest) {
	        buttonText = "Deploying...";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "modal--install-package__review__wrapper" },
	        _react2.default.createElement(_ReviewConfig2.default, {
	          packageIcon: cosmosPackage.getIcons()["icon-small"],
	          packageName: name,
	          packageVersion: version,
	          configuration: this.getPackageConfiguration()
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-footer" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-collection flush-bottom" },
	            _react2.default.createElement(
	              "button",
	              { className: "button", onClick: this.handleModalClose },
	              "Cancel"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "button-collection flush" },
	              _react2.default.createElement(
	                "button",
	                {
	                  className: "button button-outline",
	                  onClick: this.handleChangeTab.bind(this, "advancedInstall")
	                },
	                "Edit"
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: pendingRequest,
	                  className: "button button-primary",
	                  onClick: this.handleInstallPackage
	                },
	                buttonText
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "renderPackageInstalledTabView",
	    value: function renderPackageInstalledTabView() {
	      var _internalStorage_get6 = this.internalStorage_get(),
	          appId = _internalStorage_get6.appId;
	
	      var cosmosPackage = this.props.cosmosPackage;
	
	
	      var notes = cosmosPackage.getPostInstallNotes();
	
	      var parsedNotes = _StringUtil2.default.parseMarkdown(notes);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "modal-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "horizontal-center" },
	            _react2.default.createElement(
	              "span",
	              { className: "text-success" },
	              _react2.default.createElement(_Icon2.default, { id: "circle-check", size: "large", color: "green" })
	            ),
	            _react2.default.createElement(
	              "h2",
	              { className: "short-top short-bottom" },
	              "Success!"
	            ),
	            _react2.default.createElement("div", {
	              className: "install-package-modal-package-notes text-overflow-break-word",
	              dangerouslySetInnerHTML: parsedNotes
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-footer" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-collection button-collection-stacked horizontal-center" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "button button-success button-block",
	                href: "#/services/detail/" + encodeURIComponent(appId)
	              },
	              "Go To Service"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getIncorrectSchemaWarning",
	    value: function getIncorrectSchemaWarning(cosmosPackage) {
	      var errorText = "The schema for this package is not properly configured. " + "If you are the package owner, please check your configuration.";
	
	      var maintainer = cosmosPackage.getMaintainer();
	      if (maintainer) {
	        errorText = _react2.default.createElement(
	          "span",
	          null,
	          errorText + " Or you may contact the maintainer: ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:" + maintainer },
	            maintainer
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "modal-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "horizontal-center" },
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Invalid Configuration"
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "text-danger text-align-center" },
	              errorText
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "modal-footer" },
	          _react2.default.createElement(
	            "div",
	            { className: "button-collection button-collection-stacked horizontal-center" },
	            _react2.default.createElement(
	              "button",
	              {
	                className: "button button-wide button-block",
	                onClick: this.handleModalClose
	              },
	              "Close"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getModalContents",
	    value: function getModalContents() {
	      var _state = this.state,
	          currentTab = _state.currentTab,
	          schemaIncorrect = _state.schemaIncorrect;
	      var cosmosPackage = this.props.cosmosPackage;
	
	
	      if (schemaIncorrect) {
	        return this.getIncorrectSchemaWarning(cosmosPackage);
	      }
	
	      var schema = cosmosPackage.getConfig();
	      var name = cosmosPackage.getName();
	      var version = cosmosPackage.getVersion();
	      var advancedConfigClasses = (0, _classnames2.default)("modal-install-package-body-and-header", {
	        hidden: currentTab !== "advancedInstall"
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { className: "modal-install-package-tab-form-wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: advancedConfigClasses },
	          _react2.default.createElement(_SchemaForm2.default, {
	            packageIcon: cosmosPackage.getIcons()["icon-small"],
	            packageName: name,
	            packageVersion: version,
	            schema: schema,
	            onChange: this.handleAdvancedFormChange,
	            getTriggerSubmit: this.getAdvancedSubmit
	          })
	        ),
	        this.tabs_getTabView()
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	          state = this.state;
	      var currentTab = state.currentTab;
	
	
	      var isAdvanced = currentTab === "advancedInstall" || currentTab === "reviewAdvancedConfig";
	
	      var backdropClasses = (0, _classnames2.default)({
	        "modal-backdrop": true,
	        "default-cursor": isAdvanced
	      });
	
	      var modalClasses = (0, _classnames2.default)("modal modal-install-package", {
	        "modal-large modal-install-package-advanced-view": isAdvanced,
	        "modal-small": !isAdvanced
	      });
	
	      var modalWrapperClasses = (0, _classnames2.default)({
	        "multiple-form-modal modal-form": isAdvanced
	      });
	
	      return _react2.default.createElement(
	        _reactjsComponents.Modal,
	        {
	          backdropClass: backdropClasses,
	          closeByBackdropClick: !isAdvanced,
	          modalClass: modalClasses,
	          modalWrapperClass: modalWrapperClasses,
	          onClose: this.handleModalClose,
	          open: props.open,
	          scrollContainerClass: "multiple-form-modal-body",
	          showFooter: false,
	          useGemini: false
	        },
	        this.getModalContents()
	      );
	    }
	  }]);
	  return InstallPackageModal;
	}((0, _reactjsMixin2.default)(_InternalStorageMixin2.default, _TabsMixin2.default, _mesosphereSharedReactjs.StoreMixin));
	
	InstallPackageModal.defaultProps = {
	  onClose: function onClose() {},
	
	  open: false
	};
	
	InstallPackageModal.propTypes = {
	  cosmosPackage: _react2.default.PropTypes.instanceOf(_UniversePackage2.default).isRequired,
	  open: _react2.default.PropTypes.bool,
	  onClose: _react2.default.PropTypes.func
	};
	
	module.exports = InstallPackageModal;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CosmosErrorHeader = function CosmosErrorHeader(props) {
	  return _react2.default.createElement(
	    "h3",
	    { className: "text-align-center flush-top" },
	    props.children
	  );
	};
	
	CosmosErrorHeader.propTypes = {
	  children: _react2.default.PropTypes.node
	};
	
	module.exports = CosmosErrorHeader;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof2 = __webpack_require__(937);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Alert = __webpack_require__(1730);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ErrorPaths = __webpack_require__(1867);
	
	var _ErrorPaths2 = _interopRequireDefault(_ErrorPaths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REPOSITORY_ERRORS = ["EmptyPackageImport", "IndexNotFound", "InvalidRepositoryUri", "PackageFileMissing", "PackageFileNotJson", "RepositoryNotPresent", "RepositoryUriConnection", "RepositoryUriSyntax"];
	
	var CosmosErrorMessage = function (_React$Component) {
	  (0, _inherits3.default)(CosmosErrorMessage, _React$Component);
	
	  function CosmosErrorMessage() {
	    (0, _classCallCheck3.default)(this, CosmosErrorMessage);
	    return (0, _possibleConstructorReturn3.default)(this, (CosmosErrorMessage.__proto__ || (0, _getPrototypeOf2.default)(CosmosErrorMessage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CosmosErrorMessage, [{
	    key: "getMessage",
	    value: function getMessage() {
	      var error = this.props.error;
	
	      if (!error) {
	        return "An unknown error occurred";
	      }
	
	      // Append reference to repository page, since repository related errors
	      // can occur at any request to Cosmos
	      var type = error.type,
	          message = error.message;
	
	
	      if (REPOSITORY_ERRORS.includes(type)) {
	        return this.appendRepositoryLink(message);
	      }
	
	      return message;
	    }
	  }, {
	    key: "getDetails",
	    value: function getDetails() {
	      var error = this.props.error;
	
	      if (!error) {
	        return null;
	      }
	
	      // Return early if we have some well-known or an unknown type
	      if (typeof error === "string") {
	        return [error];
	      }
	      if ((typeof error === "undefined" ? "undefined" : (0, _typeof3.default)(error)) !== "object") {
	        return null;
	      }
	
	      // Return early if important fields are missing, or they are not
	      // in the expected format
	      if (!error.data || !error.data.errors) {
	        return null;
	      }
	      if (!Array.isArray(error.data.errors)) {
	        return [String(error.data.errors)];
	      }
	
	      // Get an array of array of errors for every individual path
	      var errorsDetails = error.data.errors.map(function (errorDetail) {
	        // Return early on unexpected error object format
	        if (!errorDetail) {
	          return [];
	        }
	        if ((typeof errorDetail === "undefined" ? "undefined" : (0, _typeof3.default)(errorDetail)) !== "object") {
	          return [String(errorDetail)];
	        }
	
	        // Extract details
	        var _errorDetail$path = errorDetail.path,
	            path = _errorDetail$path === undefined ? "/" : _errorDetail$path,
	            _errorDetail$errors = errorDetail.errors,
	            errors = _errorDetail$errors === undefined ? [] : _errorDetail$errors;
	
	        if (!errors || !Array.isArray(errors)) {
	          return [];
	        }
	
	        return errors.map(function (error) {
	          return (_ErrorPaths2.default[path] || path) + "." + error;
	        });
	      });
	
	      // Flatten elements in array and return
	      return errorsDetails.reduce(function (a, b) {
	        return a.concat(b);
	      });
	    }
	  }, {
	    key: "appendRepositoryLink",
	    value: function appendRepositoryLink(message) {
	      return _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          message + ". "
	        ),
	        _react2.default.createElement("br", null),
	        "You can go to the ",
	        _react2.default.createElement(
	          "a",
	          { href: "/#/settings/repositories/" },
	          "Repositories Settings"
	        ),
	        " page to change installed repositories."
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Alert2.default,
	        { flushBottom: this.props.flushBottom },
	        this.getMessage(),
	        _react2.default.createElement(
	          "div",
	          { className: "pod pod-narrower-left pod-shorter-top flush-bottom" },
	          _react2.default.createElement(
	            "ul",
	            { className: "short flush-bottom" },
	            this.getDetails()
	          )
	        )
	      );
	    }
	  }]);
	  return CosmosErrorMessage;
	}(_react2.default.Component);
	
	CosmosErrorMessage.defaultProps = {
	  error: { message: "Please try again." },
	  flushBottom: false
	};
	
	CosmosErrorMessage.propTypes = {
	  error: _react2.default.PropTypes.shape({
	    message: _react2.default.PropTypes.node,
	    type: _react2.default.PropTypes.string,
	    data: _react2.default.PropTypes.object
	  }),
	  flushBottom: _react2.default.PropTypes.bool
	};
	
	module.exports = CosmosErrorMessage;

/***/ },
/* 1867 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Human-readable resolution of error paths commonly found
	 * in various places.
	 */
	var ErrorPaths = {
	  id: "appId",
	  "/id": "appId",
	  apps: "appId",
	  "/": "general"
	};
	
	module.exports = ErrorPaths;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _stringify = __webpack_require__(1245);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reactGeminiScrollbar = __webpack_require__(1281);
	
	var _reactGeminiScrollbar2 = _interopRequireDefault(_reactGeminiScrollbar);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConfigurationMap = __webpack_require__(1376);
	
	var _ConfigurationMap2 = _interopRequireDefault(_ConfigurationMap);
	
	var _iconServiceDefaultSmall2x = __webpack_require__(1082);
	
	var _iconServiceDefaultSmall2x2 = _interopRequireDefault(_iconServiceDefaultSmall2x);
	
	var _HashMapDisplay = __webpack_require__(1437);
	
	var _HashMapDisplay2 = _interopRequireDefault(_HashMapDisplay);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ScrollbarUtil = __webpack_require__(1340);
	
	var _ScrollbarUtil2 = _interopRequireDefault(_ScrollbarUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReviewConfig = function (_React$Component) {
	  (0, _inherits3.default)(ReviewConfig, _React$Component);
	
	  function ReviewConfig() {
	    (0, _classCallCheck3.default)(this, ReviewConfig);
	    return (0, _possibleConstructorReturn3.default)(this, (ReviewConfig.__proto__ || (0, _getPrototypeOf2.default)(ReviewConfig)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ReviewConfig, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Timeout necessary due to modal content height updates on did mount
	      setTimeout(function () {
	        _ScrollbarUtil2.default.updateWithRef(_this2.refs.gemini);
	      });
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      var _props = this.props,
	          configuration = _props.configuration,
	          packageIcon = _props.packageIcon,
	          packageName = _props.packageName,
	          packageVersion = _props.packageVersion;
	
	      var fileName = "config.json";
	      var configString = (0, _stringify2.default)(configuration, null, 2);
	      var ieDownloadConfig = function ieDownloadConfig() {
	        // Download if on IE
	        if (global.navigator.msSaveOrOpenBlob) {
	          var blob = new Blob([configString], { type: "application/json" });
	          global.navigator.msSaveOrOpenBlob(blob, fileName);
	        }
	      };
	
	      return _react2.default.createElement(
	        "div",
	        { className: "modal-header flex-item-shrink-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "column-4" },
	            _react2.default.createElement(
	              "div",
	              { className: "media-object-spacing-wrapper media-object-spacing-narrow media-object-offset" },
	              _react2.default.createElement(
	                "div",
	                { className: "media-object media-object-align-middle" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "media-object-item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "icon icon-medium icon-image-container icon-app-container icon-default-white" },
	                    _react2.default.createElement(_Image2.default, {
	                      fallbackSrc: _iconServiceDefaultSmall2x2.default,
	                      src: packageIcon
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "media-object-item" },
	                  _react2.default.createElement(
	                    "h4",
	                    { className: "flush-top flush-bottom text-color-neutral" },
	                    packageName
	                  ),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "side-panel-resource-label" },
	                    packageVersion
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "column-8 text-align-right" },
	            _react2.default.createElement(
	              "a",
	              {
	                className: "button button-small button-stroke button-rounded",
	                onClick: ieDownloadConfig,
	                download: fileName,
	                href: "data:attachment/json;content-disposition=attachment;filename=" + fileName + ";charset=utf-8," + encodeURIComponent(configString)
	              },
	              _react2.default.createElement(_Icon2.default, { id: "download", size: "mini" }),
	              " Download config.json"
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: "getDefinitionReview",
	    value: function getDefinitionReview() {
	      return _react2.default.createElement(
	        _ConfigurationMap2.default,
	        null,
	        _react2.default.createElement(_HashMapDisplay2.default, { hash: this.props.configuration })
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: this.props.className },
	        this.getHeader(),
	        _react2.default.createElement(
	          _reactGeminiScrollbar2.default,
	          { autoshow: true, className: "review-config", ref: "gemini" },
	          _react2.default.createElement(
	            "div",
	            { className: "modal-body flush-top flush-bottom" },
	            this.getDefinitionReview()
	          )
	        )
	      );
	    }
	  }]);
	  return ReviewConfig;
	}(_react2.default.Component);
	
	ReviewConfig.defaultProps = {
	  className: "modal-install-package-body-and-header"
	};
	
	ReviewConfig.propTypes = {
	  className: _react2.default.PropTypes.string,
	  configuration: _react2.default.PropTypes.object.isRequired,
	  packageIcon: _react2.default.PropTypes.string,
	  packageName: _react2.default.PropTypes.string,
	  packageVersion: _react2.default.PropTypes.string
	};
	
	module.exports = ReviewConfig;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1061);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(981);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactjsMixin = __webpack_require__(1271);
	
	var _reactjsMixin2 = _interopRequireDefault(_reactjsMixin);
	
	var _PluginSDK = __webpack_require__(864);
	
	var _reactRouter = __webpack_require__(785);
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mesosphereSharedReactjs = __webpack_require__(776);
	
	var _AlertPanel = __webpack_require__(1040);
	
	var _AlertPanel2 = _interopRequireDefault(_AlertPanel);
	
	var _AlertPanelHeader = __webpack_require__(1043);
	
	var _AlertPanelHeader2 = _interopRequireDefault(_AlertPanelHeader);
	
	var _Breadcrumb = __webpack_require__(1273);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbTextContent = __webpack_require__(1274);
	
	var _BreadcrumbTextContent2 = _interopRequireDefault(_BreadcrumbTextContent);
	
	var _CosmosErrorMessage = __webpack_require__(1866);
	
	var _CosmosErrorMessage2 = _interopRequireDefault(_CosmosErrorMessage);
	
	var _CosmosPackagesStore = __webpack_require__(1848);
	
	var _CosmosPackagesStore2 = _interopRequireDefault(_CosmosPackagesStore);
	
	var _CreateServiceModalCatalogPanelOption = __webpack_require__(1870);
	
	var _CreateServiceModalCatalogPanelOption2 = _interopRequireDefault(_CreateServiceModalCatalogPanelOption);
	
	var _iconServiceDefaultMedium2x = __webpack_require__(1083);
	
	var _iconServiceDefaultMedium2x2 = _interopRequireDefault(_iconServiceDefaultMedium2x);
	
	var _FilterInputText = __webpack_require__(1322);
	
	var _FilterInputText2 = _interopRequireDefault(_FilterInputText);
	
	var _Image = __webpack_require__(1457);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Loader = __webpack_require__(1275);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Page = __webpack_require__(1325);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _StringUtil = __webpack_require__(952);
	
	var _StringUtil2 = _interopRequireDefault(_StringUtil);
	
	var _CatalogPackageOption = __webpack_require__(1872);
	
	var _CatalogPackageOption2 = _interopRequireDefault(_CatalogPackageOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-unused-vars */
	var PackagesBreadcrumbs = function PackagesBreadcrumbs() {
	  var crumbs = [_react2.default.createElement(
	    _Breadcrumb2.default,
	    { key: 0, title: "Catalog" },
	    _react2.default.createElement(
	      _BreadcrumbTextContent2.default,
	      null,
	      _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/catalog/packages" },
	        "Catalog"
	      )
	    )
	  )];
	
	  return _react2.default.createElement(_Page2.default.Header.Breadcrumbs, { iconID: "packages", breadcrumbs: crumbs });
	};
	/* eslint-enable no-unused-vars */
	
	
	var METHODS_TO_BIND = ["handleSearchStringChange", "clearInput"];
	
	var shouldRenderCatalogOption = _PluginSDK.Hooks.applyFilter("hasCapability", true, "packageAPI");
	
	if (shouldRenderCatalogOption) {
	  _foundationUi.MountService.MountService.registerComponent(_CreateServiceModalCatalogPanelOption2.default, "CreateService:ServicePicker:GridOptions", 0);
	}
	
	var PackagesTab = function (_mixin) {
	  (0, _inherits3.default)(PackagesTab, _mixin);
	
	  function PackagesTab() {
	    (0, _classCallCheck3.default)(this, PackagesTab);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PackagesTab.__proto__ || (0, _getPrototypeOf2.default)(PackagesTab)).call(this));
	
	    _this.state = {
	      errorMessage: false,
	      installModalPackage: null,
	      isLoading: true,
	      searchString: ""
	    };
	
	    _this.store_listeners = [{
	      name: "cosmosPackages",
	      events: ["availableError", "availableSuccess"],
	      suppressUpdate: true
	    }];
	
	    METHODS_TO_BIND.forEach(function (method) {
	      _this[method] = _this[method].bind(_this);
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(PackagesTab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _get3.default)(PackagesTab.prototype.__proto__ || (0, _getPrototypeOf2.default)(PackagesTab.prototype), "componentDidMount", this).apply(this, arguments);
	      _CosmosPackagesStore2.default.fetchAvailablePackages();
	    }
	  }, {
	    key: "onCosmosPackagesStoreAvailableError",
	    value: function onCosmosPackagesStoreAvailableError(errorMessage) {
	      this.setState({ errorMessage: errorMessage });
	    }
	  }, {
	    key: "onCosmosPackagesStoreAvailableSuccess",
	    value: function onCosmosPackagesStoreAvailableSuccess() {
	      this.setState({ errorMessage: false, isLoading: false });
	    }
	  }, {
	    key: "handleDetailOpen",
	    value: function handleDetailOpen(cosmosPackage, event) {
	      event.stopPropagation();
	      this.context.router.push({
	        pathname: "/catalog/packages/" + cosmosPackage.getName(),
	        query: {
	          version: cosmosPackage.getVersion()
	        }
	      });
	    }
	  }, {
	    key: "handleSearchStringChange",
	    value: function handleSearchStringChange() {
	      var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      this.setState({ searchString: searchString });
	    }
	  }, {
	    key: "clearInput",
	    value: function clearInput() {
	      this.handleSearchStringChange("");
	    }
	  }, {
	    key: "getErrorScreen",
	    value: function getErrorScreen() {
	      var errorMessage = this.state.errorMessage;
	
	
	      return _react2.default.createElement(
	        _AlertPanel2.default,
	        null,
	        _react2.default.createElement(
	          _AlertPanelHeader2.default,
	          null,
	          "An Error Occurred"
	        ),
	        _react2.default.createElement(_CosmosErrorMessage2.default, { error: errorMessage, flushBottom: true })
	      );
	    }
	  }, {
	    key: "getIcon",
	    value: function getIcon(cosmosPackage) {
	      return _react2.default.createElement(
	        "div",
	        { className: "icon icon-jumbo icon-image-container icon-app-container icon-app-container--borderless icon-default-white" },
	        _react2.default.createElement(_Image2.default, {
	          fallbackSrc: _iconServiceDefaultMedium2x2.default,
	          src: cosmosPackage.getIcons()["icon-medium"]
	        })
	      );
	    }
	  }, {
	    key: "getLoadingScreen",
	    value: function getLoadingScreen() {
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }, {
	    key: "getPackageGrid",
	    value: function getPackageGrid(packages) {
	      var _this2 = this;
	
	      return packages.getItems().map(function (cosmosPackage, index) {
	        return _react2.default.createElement(
	          _CatalogPackageOption2.default,
	          {
	            image: _this2.getIcon(cosmosPackage),
	            key: index,
	            label: _this2.getPackageOptionBadge(cosmosPackage),
	            onOptionSelect: _this2.handleDetailOpen.bind(_this2, cosmosPackage)
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "h6 flush-top short" },
	            cosmosPackage.getName()
	          ),
	          _react2.default.createElement(
	            "small",
	            { className: "flush" },
	            cosmosPackage.getVersion()
	          )
	        );
	      });
	    }
	  }, {
	    key: "getPackageOptionBadge",
	    value: function getPackageOptionBadge(cosmosPackage) {
	      var isCertified = cosmosPackage.isCertified();
	      var copy = isCertified ? "Certified" : "Community";
	      var classes = (0, _classnames2.default)("badge badge-rounded", {
	        "badge--primary": isCertified
	      });
	
	      return _react2.default.createElement(
	        "span",
	        { className: classes },
	        copy
	      );
	    }
	  }, {
	    key: "getCertifiedPackagesGrid",
	    value: function getCertifiedPackagesGrid(packages) {
	      if (this.state.searchString || packages.getItems().length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "pod flush-top flush-horizontal clearfix" },
	        _react2.default.createElement(
	          "h4",
	          { className: "short flush-top" },
	          "Certified"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "tall flush-top" },
	          "Certified packages are verified by Mesosphere for interoperability with DC/OS."
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "panel-grid row" },
	          this.getPackageGrid(packages)
	        )
	      );
	    }
	  }, {
	    key: "getCommunityPackagesGrid",
	    value: function getCommunityPackagesGrid(packages) {
	      var isSearchActive = this.state.searchString !== "";
	      if (!isSearchActive && packages.getItems().length === 0) {
	        return null;
	      }
	
	      var subtitle = _react2.default.createElement(
	        "p",
	        { className: "tall flush-top" },
	        "Community packages are unverified and unreviewed content from the community."
	      );
	      var title = "Community";
	      var titleClasses = (0, _classnames2.default)("flush-top", {
	        short: !isSearchActive,
	        tall: isSearchActive
	      });
	
	      if (isSearchActive) {
	        var foundPackagesLength = packages.getItems().length;
	        if (foundPackagesLength < 1) {
	          var noResults = "No results were found for your search: \"" + this.state.searchString + "\" ";
	
	          return _react2.default.createElement(
	            "div",
	            { className: "clearfix" },
	            noResults,
	            "(",
	            _react2.default.createElement(
	              "a",
	              { className: "clickable", onClick: this.clearInput },
	              "view all"
	            ),
	            ")"
	          );
	        }
	
	        var packagesWord = _StringUtil2.default.pluralize("service", foundPackagesLength);
	        subtitle = null;
	        title = packages.getItems().length + " " + packagesWord + " found";
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "clearfix" },
	        _react2.default.createElement(
	          "h1",
	          { className: titleClasses },
	          title
	        ),
	        subtitle,
	        _react2.default.createElement(
	          "div",
	          { className: "panel-grid row" },
	          this.getPackageGrid(packages)
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var state = this.state;
	
	      var content = void 0;
	
	      if (state.errorMessage) {
	        content = this.getErrorScreen();
	      } else if (state.isLoading) {
	        content = this.getLoadingScreen();
	      } else {
	        var packages = _CosmosPackagesStore2.default.getAvailablePackages();
	        var splitPackages = packages.getSelectedAndNonSelectedPackages();
	
	        var communityPackages = splitPackages.nonSelectedPackages;
	        var selectedPackages = splitPackages.selectedPackages;
	
	        if (state.searchString) {
	          communityPackages = packages.filterItemsByText(state.searchString);
	        }
	
	        content = _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "pod flush-horizontal flush-top" },
	            _react2.default.createElement(_FilterInputText2.default, {
	              className: "flex-grow",
	              placeholder: "Search catalog",
	              searchString: state.searchString,
	              handleFilterChange: this.handleSearchStringChange
	            })
	          ),
	          this.getCertifiedPackagesGrid(selectedPackages),
	          this.getCommunityPackagesGrid(communityPackages)
	        );
	      }
	
	      return _react2.default.createElement(
	        _Page2.default,
	        null,
	        _react2.default.createElement(_Page2.default.Header, { breadcrumbs: _react2.default.createElement(PackagesBreadcrumbs, null) }),
	        content
	      );
	    }
	  }]);
	  return PackagesTab;
	}((0, _reactjsMixin2.default)(_mesosphereSharedReactjs.StoreMixin));
	
	PackagesTab.contextTypes = {
	  router: _reactRouter.routerShape
	};
	
	module.exports = PackagesTab;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _serviceImagePackageLarge2x = __webpack_require__(1871);
	
	var _serviceImagePackageLarge2x2 = _interopRequireDefault(_serviceImagePackageLarge2x);
	
	var _CreateServiceModalServicePickerOption = __webpack_require__(1717);
	
	var _CreateServiceModalServicePickerOption2 = _interopRequireDefault(_CreateServiceModalServicePickerOption);
	
	var _CreateServiceModalServicePickerOptionContent = __webpack_require__(1718);
	
	var _CreateServiceModalServicePickerOptionContent2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionContent);
	
	var _CreateServiceModalServicePickerOptionImage = __webpack_require__(1719);
	
	var _CreateServiceModalServicePickerOptionImage2 = _interopRequireDefault(_CreateServiceModalServicePickerOptionImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CreateServicePickerCatalogOption = function (_React$Component) {
	  (0, _inherits3.default)(CreateServicePickerCatalogOption, _React$Component);
	
	  function CreateServicePickerCatalogOption() {
	    (0, _classCallCheck3.default)(this, CreateServicePickerCatalogOption);
	    return (0, _possibleConstructorReturn3.default)(this, (CreateServicePickerCatalogOption.__proto__ || (0, _getPrototypeOf2.default)(CreateServicePickerCatalogOption)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CreateServicePickerCatalogOption, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          columnClasses = _props.columnClasses,
	          onOptionSelect = _props.onOptionSelect;
	
	
	      return _react2.default.createElement(
	        _CreateServiceModalServicePickerOption2.default,
	        {
	          columnClasses: columnClasses,
	          onOptionSelect: onOptionSelect.bind(null, {
	            route: "/catalog",
	            type: "redirect"
	          })
	        },
	        _react2.default.createElement(_CreateServiceModalServicePickerOptionImage2.default, { src: _serviceImagePackageLarge2x2.default }),
	        _react2.default.createElement(
	          _CreateServiceModalServicePickerOptionContent2.default,
	          null,
	          "Install a Package"
	        )
	      );
	    }
	  }]);
	  return CreateServicePickerCatalogOption;
	}(_react2.default.Component);
	
	CreateServicePickerCatalogOption.propTypes = {
	  columnClasses: _react2.default.PropTypes.string,
	  onOptionSelect: _react2.default.PropTypes.func
	};
	
	module.exports = CreateServicePickerCatalogOption;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./a7c768a3b085fb2cd8e0bcfb4da5cf26-service-image-package-large@2x.png";

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Panel = __webpack_require__(1042);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CatalogPackageOption(props) {
	  var children = props.children,
	      image = props.image,
	      label = props.label,
	      onOptionSelect = props.onOptionSelect;
	
	  var contentClasses = ["panel-cell horizontal-center text-align-center", {
	    "panel-cell-shorter": false
	  }];
	  var headingClasses = ["panel-cell panel-cell-borderless horizontal-center flush-bottom", {
	    "panel-cell-light": false,
	    "panel-cell-shorter": false
	  }];
	  var footerClasses = ["panel-cell horizontal-center flush-top", {
	    "panel-cell-short": false,
	    "panel-cell-shorter": false
	  }];
	
	  return _react2.default.createElement(
	    "div",
	    { className: "panel-grid-item column-6 column-small-4 column-large-3" },
	    _react2.default.createElement(
	      _Panel2.default,
	      {
	        className: "panel-interactive clickable",
	        contentClass: contentClasses,
	        footer: label,
	        footerClass: footerClasses,
	        heading: image,
	        headingClass: headingClasses,
	        onClick: onOptionSelect
	      },
	      children
	    )
	  );
	}
	
	module.exports = CatalogPackageOption;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(971);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(948);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(949);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(974);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(975);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(969);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogPage = function (_React$Component) {
	  (0, _inherits3.default)(CatalogPage, _React$Component);
	
	  function CatalogPage() {
	    (0, _classCallCheck3.default)(this, CatalogPage);
	    return (0, _possibleConstructorReturn3.default)(this, (CatalogPage.__proto__ || (0, _getPrototypeOf2.default)(CatalogPage)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CatalogPage, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CatalogPage;
	}(_react2.default.Component);
	
	CatalogPage.routeConfig = {
	  label: "Catalog",
	  icon: _react2.default.createElement(_Icon2.default, { id: "packages-inverse", size: "small", family: "product" }),
	  matches: /^\/catalog/
	};
	
	module.exports = CatalogPage;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _foundationUi = __webpack_require__(1024);
	
	var _react = __webpack_require__(588);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Config = __webpack_require__(955);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationServiceUtil = {
	  /**
	   * registerRoutesInNavigation - declares Navigation Elements based on routes using
	   * NavigationService API
	   *
	   * @param  {Array} routes Application routes
	   * @return {undefined}
	   */
	  registerRoutesInNavigation: function registerRoutesInNavigation(routes) {
	    if (_Config2.default.environment === "development") {
	      console.warn("DEPRECATED: All navigation elements should register " + "with the NavigationService");
	    }
	
	    var indexRoute = routes.find(function (route) {
	      return route.id === "index";
	    });
	
	    if (!indexRoute) {
	      return;
	    }
	
	    indexRoute.childRoutes.filter(function (_ref) {
	      var isInSidebar = _ref.isInSidebar;
	      return isInSidebar;
	    }).forEach(function (route) {
	      var path = route.path,
	          category = route.category,
	          _route$childRoutes = route.childRoutes,
	          childRoutes = _route$childRoutes === undefined ? [] : _route$childRoutes;
	
	      var primaryPath = "/" + path;
	
	      _foundationUi.navigation.NavigationService.registerCategory(category);
	
	      var icon = _react2.default.cloneElement(route.component.routeConfig.icon, {
	        className: "sidebar-menu-item-icon icon icon-small"
	      });
	
	      _foundationUi.navigation.NavigationService.registerPrimary(primaryPath, route.component.routeConfig.label, { category: category, icon: icon });
	      childRoutes.filter(function (_ref2) {
	        var isInSidebar = _ref2.isInSidebar;
	        return isInSidebar;
	      }).forEach(function (childRoute) {
	        _foundationUi.navigation.NavigationService.registerSecondary(primaryPath, childRoute.path, childRoute.component.routeConfig.label, { isActiveRegex: childRoute.sidebarActiveRegex });
	      });
	    });
	  }
	};
	
	exports.default = NavigationServiceUtil;

/***/ },
/* 1875 */
/***/ function(module, exports) {

	module.exports = {
		"BUTTON.CLOSE": "Close",
		"CLIPBOARD.COPY": "Copy",
		"CLIPBOARD.COPIED": "Copied",
		"COMMON.GENERAL": "General",
		"COMMON.DETAILS": "Details",
		"COMMON.CLUSTER": "Cluster",
		"COMMON.LEADER": "Leader",
		"COMMON.VERSION": "Version",
		"COMMON.BUILT": "Built",
		"COMMON.STARTED": "Started",
		"COMMON.ELECTED": "Elected",
		"COMMON.BY_NAME": "by {name}",
		"COMMON.DOCUMENTATION": "documentation",
		"COMMON.DOCUMENTATION_TITLE": "go to documentation guide",
		"COMMON.DISMISS": "Dismiss",
		"DASHBOARD.VIEW_ALL": "View all {servicesCount} Services",
		"DASHBOARD.PANEL_HEADING.CPU": "CPU Allocation",
		"DASHBOARD.PANEL_HEADING.MEMORY": "Memory Allocation",
		"DASHBOARD.PANEL_HEADING.DISK": "Disk Allocation",
		"DASHBOARD.PANEL_HEADING.SERVICES_HEALTH": "Services Health",
		"DASHBOARD.PANEL_HEADING.TASKS": "Tasks",
		"DASHBOARD.PANEL_HEADING.COMPONENT_HEALTH": "Component Health",
		"DASHBOARD.PANEL_HEADING.NODES": "Nodes",
		"DOCS.MORE_INFORMATION": "More information",
		"DOCS.DOCUMENTATION": "documentation",
		"SERVICE_ACTIONS.EDIT": "Edit",
		"SERVICE_ACTIONS.DELETE": "Delete",
		"SERVICE_ACTIONS.RESTART": "Restart",
		"SERVICE_ACTIONS.RESUME": "Resume",
		"SERVICE_ACTIONS.OPEN_SERVICE": "Open Service",
		"SERVICE_ACTIONS.SCALE": "Scale",
		"SERVICE_ACTIONS.SCALE_BY": "Scale By",
		"SERVICE_ACTIONS.SUSPEND": "Suspend",
		"SERVICE_ACTIONS.SDK_GROUP_DELETE_1": "Copy and paste this command into the CLI",
		"SERVICE_ACTIONS.SDK_GROUP_DELETE_4": "Then",
		"SERVICE_ACTIONS.SDK_GROUP_DELETE_5": "the group",
		"SERVICE_ACTIONS.SDK_GROUP_DELETE_6": "Copy the command below into the DC/OS CLI",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_1": "your group by",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_2": "from the DC/OS CLI",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_3": "For",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_4": "Create",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_5": "files for each service. Here is a sample options file",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_6": "Then, use this command to update each service",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_7": "For",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_8": "Copy the JSON below into a file called",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_9": "Then, copy the command below into the DC/OS CLI",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_SUSPEND": "scaling each service to 0 instances",
		"SERVICE_ACTIONS.SDK_GROUP_UPDATE_SCALE": "updating the number of instances of each service",
		"SERVICE_ACTIONS.SDK_SERVICE_RESTART": "Restart your service from the DC/OS CLI.",
		"SERVICE_ACTIONS.SDK_SERVICE_SUSPEND": "Suspend your service by scaling to 0 instances from the DC/OS CLI using an `options.json` file.",
		"SERVICE_ACTIONS.SDK_SERVICE_RESUME": "Resume your service by scaling to 1 or more instances from the DC/OS CLI using an `options.json` file.",
		"SERVICE_ACTIONS.SDK_SERVICE_SCALE": "Update the number of instances in your service's target configuration using an `options.json` file.",
		"SERVICE_ACTIONS.SDK_SERVICE_SCALE_NOTE": "Scaling to fewer instances is not supported.",
		"SERVICE_ACTIONS.SDK_SERVICE_DELETE_PART_1": "You must delete",
		"SERVICE_ACTIONS.SDK_SERVICE_DELETE_PART_2": "via the DC/OS CLI. Copy and paste this command into the CLI. See the",
		"SERVICE_ACTIONS.SDK_SERVICE_UPDATE_PART_1": "To update this service's configuration, please update",
		"SERVICE_ACTIONS.SDK_SERVICE_UPDATE_PART_2": "Run the following CLI command:",
		"SERVICES.DEPLOYMENT_COUNT": "{deploymentsCount} {deploymentsCount, plural, =1 {deployment} other {deployments}}",
		"SERVICES.DEPLOYMENT_MODAL_HEADING": "{deploymentsCount} Active {deploymentsCount, plural, =1 {Deployment} other {Deployments}}",
		"SERVICE_ACTIONS.DELETE_SERVICE_FRAMEWORK": "You must use the DC/OS CLI to delete this service. Refer to the ",
		"SERVICE_ACTIONS.DELETE_SERVICE_FRAMEWORK_2": " for complete instructions or copy and paste this command into your CLI."
	};

/***/ }
]);


// WEBPACK FOOTER //
// index.319e9788a25893f6c883.js